module.exports = { 
    village: {
    3950: [
      { id: 525164, name: "Aamali" },
      { id: 525193, name: "Akkalkuwa" },
      { id: 525167, name: "Alivihir" },
      { id: 525162, name: "Amalibari" },
      { id: 525155, name: "Amaliphali" },
      { id: 525101, name: "Ambabari" },
      { id: 525060, name: "Ambaribar" },
      { id: 525011, name: "Arethi" },
      { id: 525026, name: "Bagda" },
      { id: 525019, name: "Balaghat" },
      { id: 525156, name: "Bamangaon" },
      { id: 525006, name: "Bamani" },
      { id: 525020, name: "Bardi" },
      { id: 525014, name: "Barisurgas" },
      { id: 525053, name: "Bedakund" },
      { id: 525084, name: "Beti" },
      { id: 525181, name: "Bhabalpur" },
      { id: 525038, name: "Bhagdari" },
      { id: 525047, name: "Bhangrapani" },
      { id: 525098, name: "Bharadipadar" },
      { id: 525054, name: "Bharkund" },
      { id: 525132, name: "Bhoyra" },
      { id: 525040, name: "Bijaligavhan" },
      { id: 525042, name: "Bijaripati" },
      { id: 525052, name: "Bokhadi" },
      { id: 525179, name: "Boripada" },
      { id: 525134, name: "Bri.Ankushvihir" },
      { id: 525148, name: "Chandpur" },
      { id: 525036, name: "Chanwai" },
      { id: 525023, name: "Chapadi" },
      { id: 525191, name: "Chhoti Rajmohi" },
      { id: 525080, name: "Chikhali" },
      { id: 525004, name: "Chimalkhedi" },
      { id: 525059, name: "Chivalutar" },
      { id: 525093, name: "Dab" },
      { id: 525077, name: "Dahel" },
      { id: 525007, name: "Danel" },
      { id: 525099, name: "Dasarapadar" },
      { id: 525029, name: "Debramal" },
      { id: 525168, name: "Devmogaranagar" },
      { id: 525003, name: "Dhankhedi" },
      { id: 525137, name: "Digiamba" },
      { id: 525120, name: "Dodawa" },
      { id: 525145, name: "Dogripada" },
      { id: 525057, name: "Gadwani" },
      { id: 525175, name: "Galotha Bk" },
      { id: 525177, name: "Galotha Kh" },
      { id: 525009, name: "Gaman" },
      { id: 525171, name: "Gangapur" },
      { id: 525119, name: "Gavhali" },
      { id: 525169, name: "Ghantani" },
      { id: 525112, name: "Ghunshi" },
      { id: 525142, name: "Gotpada" },
      { id: 525160, name: "Guliamba" },
      { id: 525144, name: "Guliumbar" },
      { id: 525083, name: "Horafali" },
      { id: 525070, name: "Hunakhamb" },
      { id: 525051, name: "Jamali" },
      { id: 525153, name: "Jamali (Umarkuwa)" },
      { id: 525062, name: "Jamana" },
      { id: 525109, name: "Jambhapani" },
      { id: 525010, name: "Jangathi" },
      { id: 525184, name: "Janiamba" },
      { id: 525018, name: "Jugalkhet" },
      { id: 525138, name: "Junanagarmutha" },
      { id: 525073, name: "Junwani" },
      { id: 525157, name: "Kadwa Mahu" },
      { id: 525115, name: "Kakadkhunt" },
      { id: 525176, name: "Kakarpada" },
      { id: 525118, name: "Kakdiamba" },
      { id: 525033, name: "Kanjala" },
      { id: 525041, name: "Kanjani" },
      { id: 525163, name: "Kankala" },
      { id: 525097, name: "Kankalamal" },
      { id: 525170, name: "Kankali" },
      { id: 525090, name: "Kataskhai" },
      { id: 525046, name: "Kathi" },
      { id: 525154, name: "Kauli" },
      { id: 525158, name: "Kawaligavhan" },
      { id: 525013, name: "Kewadi" },
      { id: 525087, name: "Khadakapani" },
      { id: 525140, name: "Khadake" },
      { id: 525117, name: "Khadkuna" },
      { id: 525094, name: "Khai" },
      { id: 525192, name: "Khapar" },
      { id: 525161, name: "Khapran" },
      { id: 525133, name: "Khatkuwa" },
      { id: 525135, name: "Khatwani" },
      { id: 525017, name: "Khodasbara" },
      { id: 525071, name: "Khodi" },
      { id: 525061, name: "Khuntagavhan" },
      { id: 525068, name: "Khurchimal" },
      { id: 525128, name: "Kolavi" },
      { id: 525096, name: "Kolavimal" },
      { id: 525150, name: "Korai" },
      { id: 525089, name: "Kothali" },
      { id: 525129, name: "Koyalivihir" },
      { id: 525012, name: "Kukadipadar" },
      { id: 525141, name: "Kumbharkhan" },
      { id: 944576, name: "Kundi" },
      { id: 525095, name: "Kuwa" },
      { id: 525114, name: "Lalpur" },
      { id: 525037, name: "Mahalpada" },
      { id: 525108, name: "Mahukhadi" },
      { id: 525116, name: "Mahupada" },
      { id: 525194, name: "Makranifali" },
      { id: 525069, name: "Mal" },
      { id: 525127, name: "Mandara" },
      { id: 525183, name: "Mandaviamba" },
      { id: 525032, name: "Mandawa" },
      { id: 525002, name: "Manibeli" },
      { id: 525136, name: "Me.Ankushvihir" },
      { id: 525188, name: "Mithyafali" },
      { id: 525078, name: "Mogra" },
      { id: 525021, name: "Mokas" },
      { id: 525043, name: "Molgi" },
      { id: 525104, name: "Moramba" },
      { id: 525027, name: "Morhi" },
      { id: 525085, name: "Morkhi" },
      { id: 525025, name: "Movan" },
      { id: 525008, name: "Mukhadi" },
      { id: 525152, name: "Nainshewadi" },
      { id: 525173, name: "Nala" },
      { id: 525139, name: "Nawa Nangarmutha" },
      { id: 525126, name: "Nawagaon" },
      { id: 525121, name: "Nawapada" },
      { id: 525067, name: "Nendwan Budruk" },
      { id: 525066, name: "Nendwan Khurd" },
      { id: 525082, name: "Nimbapati" },
      { id: 525088, name: "Odhi" },
      { id: 525079, name: "Oghani" },
      { id: 525091, name: "Ohwa" },
      { id: 525039, name: "Olpada" },
      { id: 525031, name: "Palaskhobra" },
      { id: 525022, name: "Pandhramati" },
      { id: 525063, name: "Patbara" },
      { id: 525123, name: "Pechari Deo" },
      { id: 525049, name: "Pimati" },
      { id: 525159, name: "Pimpalgaon" },
      { id: 525015, name: "Pimpalkhunta" },
      { id: 525048, name: "Pimprapani" },
      { id: 525189, name: "Pimpripada" },
      { id: 525125, name: "Porambi" },
      { id: 525190, name: "Rajmohi (Mothi)" },
      { id: 525105, name: "Rampur" },
      { id: 525110, name: "Ranzani" },
      { id: 525102, name: "Ratanbara" },
      { id: 525111, name: "Raysingpur" },
      { id: 525146, name: "Rethi" },
      { id: 525103, name: "Rojkund" },
      { id: 525074, name: "Sakliumar" },
      { id: 525055, name: "Sallibar" },
      { id: 525030, name: "Sambar" },
      { id: 525072, name: "Sari" },
      { id: 525147, name: "Sheltapani" },
      { id: 525106, name: "Shendvan" },
      { id: 525005, name: "Sinduri" },
      { id: 525182, name: "Singpur Budruk" },
      { id: 525165, name: "Singpur Kh" },
      { id: 525166, name: "Sojdan" },
      { id: 525131, name: "Sonapati" },
      { id: 525045, name: "Sorachapada" },
      { id: 525187, name: "Sorapada" },
      { id: 525016, name: "Surgas" },
      { id: 525107, name: "Talamba" },
      { id: 525124, name: "Tawali" },
      { id: 525086, name: "Thana" },
      { id: 525172, name: "Thanavihir" },
      { id: 525178, name: "Timakmauli" },
      { id: 525092, name: "Todikund" },
      { id: 525143, name: "Udepur(Chota)" },
      { id: 525149, name: "Udepur(Motha)" },
      { id: 525044, name: "Ukhalipada" },
      { id: 525100, name: "Ukhalsag" },
      { id: 525064, name: "Umargavhan" },
      { id: 525122, name: "Umarkuva" },
      { id: 525050, name: "Umati" },
      { id: 525058, name: "Urmilamal" },
      { id: 525113, name: "Vadali" },
      { id: 525130, name: "Vakadhaman" },
      { id: 525185, name: "Vanyavihir Bk" },
      { id: 525186, name: "Vanyavihir Kh" },
      { id: 525028, name: "Vehgi" },
      { id: 525056, name: "Veli" },
      { id: 525034, name: "Velkhedi" },
      { id: 525035, name: "Veri" },
      { id: 525174, name: "Virpur" },
      { id: 525024, name: "Wadfali" },
      { id: 525180, name: "Wadfali (Na)" },
      { id: 525075, name: "Wadibar" },
      { id: 525076, name: "Walamba (K)" },
      { id: 525081, name: "Walamba (R)" },
      { id: 525151, name: "Ziri Sawar" },
    ],
    3951: [
      { id: 525242, name: "Aambari" },
      { id: 947289, name: "Aatti" },
      { id: 525207, name: "Achapa" },
      { id: 525208, name: "Amala" },
      { id: 525274, name: "Asali" },
      { id: 525283, name: "Astamba Forest" },
      { id: 525282, name: "Astamba(Re)" },
      { id: 947272, name: "Bhabari" },
      { id: 525330, name: "Bhadal" },
      { id: 947282, name: "Bhamne" },
      { id: 525202, name: "Bhanoli" },
      { id: 525225, name: "Bhogawade Bk" },
      { id: 525234, name: "Bhogawade Kh" },
      { id: 525228, name: "Bhujgaon" },
      { id: 947267, name: "Bhusha" },
      { id: 525336, name: "Bilbarpada" },
      { id: 947273, name: "Bilgaon" },
      { id: 947298, name: "Bodala" },
      { id: 525199, name: "Borsisa" },
      { id: 525236, name: "Borwan" },
      { id: 947274, name: "Chandsaili" },
      { id: 525204, name: "Chhapari" },
      { id: 525197, name: "Chickhedi" },
      { id: 947283, name: "Chikhali" },
      { id: 947275, name: "Chinchkathi" },
      { id: 525257, name: "Chippal" },
      { id: 525278, name: "Chittar Forest" },
      { id: 525277, name: "Chittar(Re)" },
      { id: 525238, name: "Chondwade Bk" },
      { id: 525240, name: "Chondwade Kh" },
      { id: 525271, name: "Chulwad" },
      { id: 525237, name: "Dhadgaon" },
      { id: 525235, name: "Dhanaje Bk" },
      { id: 525239, name: "Dhanaje Kh" },
      { id: 525198, name: "Duttal" },
      { id: 947292, name: "Gaourya" },
      { id: 525252, name: "Ghatli" },
      { id: 525248, name: "Goraamba" },
      { id: 525232, name: "Harankhuri" },
      { id: 525221, name: "Hatdhui" },
      { id: 525203, name: "Jalola" },
      { id: 525209, name: "Jamanvahi" },
      { id: 947276, name: "Jarali" },
      { id: 947284, name: "Jhummat" },
      { id: 525249, name: "Jugani" },
      { id: 525251, name: "Kakadada" },
      { id: 525272, name: "Kakarpati" },
      { id: 525273, name: "Kalibel" },
      { id: 947277, name: "Kamod Khurd" },
      { id: 525253, name: "Kamod Vasahat" },
      { id: 947299, name: "Katra" },
      { id: 525213, name: "Katri (Re)" },
      { id: 525214, name: "Katri Forest" },
      { id: 525269, name: "Kela Bk" },
      { id: 525264, name: "Kela Kh" },
      { id: 525346, name: "Kelapani" },
      { id: 947278, name: "Khadkala Budruk" },
      { id: 947285, name: "Khadkala Khurd" },
      { id: 947293, name: "Khadki" },
      { id: 525212, name: "Khadkya" },
      { id: 525250, name: "Khamala" },
      { id: 525217, name: "Khanbara" },
      { id: 525223, name: "Kharda" },
      { id: 947286, name: "Khardi Khurd" },
      { id: 525243, name: "Kharwad" },
      { id: 525215, name: "Khuntamodi" },
      { id: 525255, name: "Khushgavhan" },
      { id: 525306, name: "Khutwada" },
      { id: 947300, name: "Kuklat" },
      { id: 525298, name: "Kuktar" },
      { id: 947287, name: "Kumbhari" },
      { id: 525216, name: "Kundal" },
      { id: 525244, name: "Kundya" },
      { id: 525258, name: "Kusumveri" },
      { id: 947271, name: "Kuvarkhet" },
      { id: 947268, name: "Lekhda" },
      { id: 525294, name: "Makadkund" },
      { id: 947294, name: "Maktarzhira" },
      { id: 525280, name: "Mal" },
      { id: 947288, name: "Mandvi Khurd" },
      { id: 525261, name: "Mankhedi Bk" },
      { id: 525263, name: "Manwani Bk" },
      { id: 525256, name: "Manwani Kh" },
      { id: 525218, name: "Mojara" },
      { id: 525254, name: "Mokh Bk" },
      { id: 525265, name: "Mokh Kh" },
      { id: 525246, name: "Mundalgaon" },
      { id: 525231, name: "Mundalwad" },
      { id: 525201, name: "Nal Gavhan" },
      { id: 525205, name: "Nandalwad" },
      { id: 525260, name: "Nawagaon" },
      { id: 947281, name: "Nigadi" },
      { id: 525291, name: "Nimgavhan" },
      { id: 525224, name: "Nimkhedi" },
      { id: 525276, name: "Padali" },
      { id: 525268, name: "Padamund" },
      { id: 525259, name: "Palkha" },
      { id: 525266, name: "Panbari" },
      { id: 525284, name: "Paula" },
      { id: 947295, name: "Pimpalbari" },
      { id: 525206, name: "Pimpari" },
      { id: 525262, name: "Radikalam" },
      { id: 947296, name: "Rajbardi" },
      { id: 525275, name: "Ramsala" },
      { id: 525233, name: "Roshamal Bk" },
      { id: 947297, name: "Sadari" },
      { id: 947291, name: "Sawrya" },
      { id: 947290, name: "Sawrya Digar" },
      { id: 947279, name: "Shelda" },
      { id: 947280, name: "Shelkui" },
      { id: 947269, name: "Shindidigar" },
      { id: 947270, name: "Shirsani" },
      { id: 525270, name: "Sisa" },
      { id: 525230, name: "Somane" },
      { id: 525211, name: "Son Bk" },
      { id: 525210, name: "Son Kh" },
      { id: 525195, name: "Surung" },
      { id: 525229, name: "Surwani" },
      { id: 525267, name: "Talai" },
      { id: 947264, name: "Telkhedi" },
      { id: 525222, name: "Tembhala" },
      { id: 947263, name: "Tembhurni" },
      { id: 947262, name: "Thuvani" },
      { id: 525196, name: "Tinasmal" },
      { id: 525345, name: "Toranmal (June)" },
      { id: 525247, name: "Toranmal (New)" },
      { id: 947261, name: "Trishul" },
      { id: 525329, name: "Udadya" },
      { id: 525279, name: "Ukhaliamba" },
      { id: 525226, name: "Umarani Bk" },
      { id: 525227, name: "Umarani Kh" },
      { id: 525357, name: "Vadfalya" },
      { id: 525281, name: "Valiamba" },
      { id: 525219, name: "Varkhedi Bk" },
      { id: 525220, name: "Varkhedi Kh" },
      { id: 947260, name: "Vavi" },
      { id: 525245, name: "Velkhedi" },
      { id: 947259, name: "Walaval" },
      { id: 947258, name: "Warvali" },
      { id: 525335, name: "Zhapi" },
    ],
    3952: [
      { id: 525416, name: "Aamlad" },
      { id: 525399, name: "Alwan" },
      { id: 525368, name: "Amalpada" },
      { id: 525408, name: "Amoni" },
      { id: 525434, name: "Ashte Tarfe Borad" },
      { id: 525418, name: "Ban" },
      { id: 525427, name: "Bandhare" },
      { id: 525380, name: "Belipada" },
      { id: 525414, name: "Bhavar" },
      { id: 525361, name: "Biyamal" },
      { id: 525431, name: "Borad" },
      { id: 525384, name: "Budhaval" },
      { id: 525382, name: "Budhavali" },
      { id: 525441, name: "Chaugaon Bk" },
      { id: 525395, name: "Chaugaon Kh" },
      { id: 525432, name: "Chhotadhanpur" },
      { id: 525412, name: "Chinode" },
      { id: 525411, name: "Dalelpur" },
      { id: 525447, name: "Daswad" },
      { id: 525366, name: "Dekati" },
      { id: 525448, name: "Dhanore" },
      { id: 525425, name: "Dhanpur" },
      { id: 914325, name: "Dhavlivihir" },
      { id: 525362, name: "Ekdhad" },
      { id: 525400, name: "Gadhavali" },
      { id: 525393, name: "Gaulanpada" },
      { id: 525404, name: "Gopalpur" },
      { id: 525443, name: "Gunjali" },
      { id: 525410, name: "Halalpur" },
      { id: 525358, name: "Ichhagavhan" },
      { id: 525419, name: "Juwani (F)" },
      { id: 525423, name: "Juwani(R)" },
      { id: 525446, name: "Kadhel" },
      { id: 525387, name: "Kakalpur" },
      { id: 525435, name: "Kalamsare" },
      { id: 525422, name: "Karde" },
      { id: 525413, name: "Kazipur Talawadi" },
      { id: 525401, name: "Khardi Bk" },
      { id: 525402, name: "Khardi Kh" },
      { id: 525445, name: "Kharwad" },
      { id: 525449, name: "Khedale" },
      { id: 525378, name: "Khusgavhan" },
      { id: 525398, name: "Kothar" },
      { id: 525360, name: "Kundave" },
      { id: 525424, name: "Lakhapur (Rev)" },
      { id: 525417, name: "Lakhapur(F)" },
      { id: 525397, name: "Lakkadkot" },
      { id: 525383, name: "Lobhani" },
      { id: 525394, name: "Mal Kh" },
      { id: 525420, name: "Malde" },
      { id: 525392, name: "Mendhwad" },
      { id: 525444, name: "Mod" },
      { id: 525390, name: "Modalpada" },
      { id: 525436, name: "Mohida" },
      { id: 525440, name: "Morwad" },
      { id: 525385, name: "Nalgavhan" },
      { id: 525365, name: "Narmadanagar" },
      { id: 525438, name: "Navagaon" },
      { id: 525430, name: "Nyuban" },
      { id: 525403, name: "Padalpur" },
      { id: 525376, name: "Padhadi" },
      { id: 525369, name: "Pimparpada" },
      { id: 525433, name: "Pratappur" },
      { id: 525381, name: "Rajvihir" },
      { id: 525389, name: "Rampur" },
      { id: 525374, name: "Ranapur" },
      { id: 525428, name: "Ranipur" },
      { id: 525405, name: "Ranzani" },
      { id: 525396, name: "Rapapur" },
      { id: 525371, name: "Ratanpada" },
      { id: 525406, name: "Razave Nave Gaon" },
      { id: 525370, name: "Retpada" },
      { id: 525409, name: "Revanagar" },
      { id: 525407, name: "Rozave" },
      { id: 525437, name: "Salsadi" },
      { id: 525367, name: "Sardarnagar" },
      { id: 525391, name: "Satone" },
      { id: 525359, name: "Sawar" },
      { id: 525426, name: "Sawarpada" },
      { id: 525388, name: "Shelwai" },
      { id: 525375, name: "Shirve" },
      { id: 525429, name: "Silingpur" },
      { id: 525421, name: "Singaspur" },
      { id: 525364, name: "Sojarbarapura" },
      { id: 525377, name: "Somawal Bk" },
      { id: 525379, name: "Somawal Kh" },
      { id: 525373, name: "Sorapada" },
      { id: 525415, name: "Taloda" },
      { id: 525439, name: "Talve" },
      { id: 525450, name: "Tarhavad" },
      { id: 525372, name: "Umarkuwa" },
      { id: 525442, name: "Umri" },
      { id: 525363, name: "Walheri" },
      { id: 525386, name: "Ziri" },
    ],
    3953: [
      { id: 525618, name: "Abhanpur" },
      { id: 525491, name: "Adgaon" },
      { id: 525460, name: "Akaspur" },
      { id: 525484, name: "Alkhed" },
      { id: 525486, name: "Ambapur" },
      { id: 525465, name: "Amode" },
      { id: 525479, name: "Anakwade" },
      { id: 525601, name: "Anarad" },
      { id: 525534, name: "Asalod" },
      { id: 525512, name: "Asus" },
      { id: 525564, name: "Aurangpur" },
      { id: 525502, name: "Awage" },
      { id: 525494, name: "Bahirpur" },
      { id: 525603, name: "Bamkheda T.Sa" },
      { id: 525630, name: "Bamkheda T.T" },
      { id: 525576, name: "Bhade" },
      { id: 525628, name: "Bhadgaon" },
      { id: 525507, name: "Bhagapur" },
      { id: 525540, name: "Bhongra" },
      { id: 525517, name: "Bhortek" },
      { id: 525544, name: "Bhulane" },
      { id: 525470, name: "Bhute" },
      { id: 525495, name: "Biladi-T-Haveli" },
      { id: 525602, name: "Biladi.Ta.Sa" },
      { id: 525626, name: "Borale" },
      { id: 525499, name: "Bramhanpuri" },
      { id: 525481, name: "Budigavhan" },
      { id: 525580, name: "Bupkari" },
      { id: 525505, name: "Chandsaili" },
      { id: 525539, name: "Chandsaili (Fo)" },
      { id: 525482, name: "Chikhali Bk" },
      { id: 525526, name: "Chikhali Kh." },
      { id: 525455, name: "Chirde" },
      { id: 525611, name: "Chirkhan" },
      { id: 525527, name: "Damalde" },
      { id: 525581, name: "Damarkheda" },
      { id: 525457, name: "Dara" },
      { id: 525609, name: "Deur" },
      { id: 525568, name: "Dhamlad" },
      { id: 525614, name: "Dhandre Bk" },
      { id: 525577, name: "Dhurkheda" },
      { id: 525632, name: "Dondwade" },
      { id: 525553, name: "Dongargaon" },
      { id: 525541, name: "Dudhkheda" },
      { id: 525466, name: "Fattepur" },
      { id: 525631, name: "Fes" },
      { id: 525492, name: "Ganor" },
      { id: 525500, name: "Godipur" },
      { id: 525530, name: "Gogapur" },
      { id: 525634, name: "Hingani" },
      { id: 525546, name: "Hol" },
      { id: 525513, name: "Holgujari" },
      { id: 525487, name: "Islampur" },
      { id: 525623, name: "Jainagar" },
      { id: 525520, name: "Jam" },
      { id: 525473, name: "Javade.Ta.Bo" },
      { id: 525521, name: "Javade.Ta.Ha" },
      { id: 525508, name: "Javkheda" },
      { id: 525503, name: "Junavane" },
      { id: 525613, name: "Kahatul" },
      { id: 525620, name: "Kakarde Di" },
      { id: 525619, name: "Kakarde Kh" },
      { id: 525599, name: "Kalambu" },
      { id: 525528, name: "Kalmad.Ta.Ha" },
      { id: 525560, name: "Kalmadi.Ta.Bo" },
      { id: 525567, name: "Kalsadi" },
      { id: 525551, name: "Kamaravad" },
      { id: 525608, name: "Kamkheda" },
      { id: 525587, name: "Kanadi Kh" },
      { id: 525477, name: "Kanadi.Ta.Ha" },
      { id: 525469, name: "Kansai" },
      { id: 525582, name: "Karajai" },
      { id: 525571, name: "Karankheda" },
      { id: 525532, name: "Karjot" },
      { id: 525617, name: "Katghar" },
      { id: 525574, name: "Katharde Digar" },
      { id: 525575, name: "Katharde Kh" },
      { id: 525510, name: "Kavalith" },
      { id: 525596, name: "Kavthal T.Sha." },
      { id: 525604, name: "Kavthal.T.Sa" },
      { id: 525629, name: "Khairve" },
      { id: 525621, name: "Khaparkheda" },
      { id: 525493, name: "Khargaon" },
      { id: 525496, name: "Kheddigar" },
      { id: 525514, name: "Kochare" },
      { id: 525622, name: "Kondhaval" },
      { id: 525451, name: "Kotbandhani" },
      { id: 525563, name: "Kothali Ta.Ha" },
      { id: 525598, name: "Kothali.Ta.Sa." },
      { id: 525475, name: "Kudhavad" },
      { id: 525597, name: "Kukaval" },
      { id: 525557, name: "Kukdel" },
      { id: 525515, name: "Kurangi" },
      { id: 525605, name: "Kurhavad.Ta.Sa" },
      { id: 525468, name: "Kusumwade" },
      { id: 525476, name: "Lachore" },
      { id: 525485, name: "Lakkadkot" },
      { id: 525583, name: "Lambole" },
      { id: 525537, name: "Langadibhavani" },
      { id: 525531, name: "Lohare" },
      { id: 525612, name: "Londhare" },
      { id: 525548, name: "Lonkheda" },
      { id: 525456, name: "Madkani" },
      { id: 525538, name: "Malgaon" },
      { id: 525554, name: "Maloni" },
      { id: 525584, name: "Manarad" },
      { id: 525535, name: "Mandane" },
      { id: 525543, name: "Manmodya" },
      { id: 525625, name: "Matkut" },
      { id: 525480, name: "Mhasavad" },
      { id: 525545, name: "Mohide.Ta.Ha" },
      { id: 525559, name: "Mohide.Ta.Sha" },
      { id: 525490, name: "Mubarakpur" },
      { id: 525453, name: "Nagziri" },
      { id: 525572, name: "Nandarde" },
      { id: 525591, name: "Nandarkheda" },
      { id: 525462, name: "Nandya" },
      { id: 525504, name: "Navalpur" },
      { id: 525522, name: "Navanagar" },
      { id: 525542, name: "New Aslod" },
      { id: 525624, name: "Nimbhore" },
      { id: 525519, name: "Ozarte" },
      { id: 525483, name: "Padalde Budruk" },
      { id: 525506, name: "Padalde Khurd" },
      { id: 525592, name: "Palasvade" },
      { id: 525565, name: "Pari" },
      { id: 525533, name: "Pimparde" },
      { id: 525474, name: "Pimplod" },
      { id: 525454, name: "Pimprani" },
      { id: 525501, name: "Pimpri" },
      { id: 525578, name: "Pingane" },
      { id: 525579, name: "Prakasha" },
      { id: 525549, name: "Purushottamnagar" },
      { id: 525600, name: "Pusanad" },
      { id: 525497, name: "Raikhed" },
      { id: 525463, name: "Rampur" },
      { id: 525452, name: "Ranipur" },
      { id: 525606, name: "Sarangkheda" },
      { id: 525594, name: "Sasade" },
      { id: 525550, name: "Sawakheda" },
      { id: 525586, name: "Sawalde" },
      { id: 525558, name: "Shahada" },
      { id: 525536, name: "Shahane" },
      { id: 525593, name: "Shelti" },
      { id: 525585, name: "Shirud Digar" },
      { id: 525467, name: "Shirud.Ta.Ha" },
      { id: 525516, name: "Shrikhed" },
      { id: 525595, name: "Sonvad.Ta.Sha" },
      { id: 525570, name: "Sonval.Ta.Bo" },
      { id: 525511, name: "Sonval.Ta.Ha" },
      { id: 525498, name: "Sultanpur" },
      { id: 525489, name: "Sulwade" },
      { id: 525464, name: "Talavadi" },
      { id: 525562, name: "Tarhadi.Ta.Bo" },
      { id: 525488, name: "Tawalai" },
      { id: 525547, name: "Tembhali" },
      { id: 525607, name: "Tembhe Bk" },
      { id: 525589, name: "Tembhe.Ta.Sha." },
      { id: 525561, name: "Thengche" },
      { id: 525529, name: "Tidhare" },
      { id: 525556, name: "Tikhore" },
      { id: 525524, name: "Titari" },
      { id: 525633, name: "Torkheda" },
      { id: 525509, name: "Tuki" },
      { id: 525610, name: "Udhalod" },
      { id: 525518, name: "Ukhalshem" },
      { id: 525478, name: "Umarti" },
      { id: 525555, name: "Untavad" },
      { id: 525627, name: "Vadali" },
      { id: 525552, name: "Vadchhil" },
      { id: 525523, name: "Vadgaon" },
      { id: 525573, name: "Vaijali" },
      { id: 525566, name: "Varde" },
      { id: 525590, name: "Vardhe" },
      { id: 525588, name: "Varul.T.Sha" },
      { id: 525458, name: "Virpur" },
      { id: 525472, name: "Wadi" },
      { id: 525525, name: "Wagharde" },
      { id: 525569, name: "Waghode" },
      { id: 525471, name: "Welavad" },
    ],
    3954: [
      { id: 525665, name: "Adachhi" },
      { id: 525784, name: "Ajepur" },
      { id: 525725, name: "Akhatwade" },
      { id: 525749, name: "Akrale" },
      { id: 525781, name: "Ambapur" },
      { id: 525692, name: "Amlathe" },
      { id: 525666, name: "Amrave" },
      { id: 525694, name: "Arale" },
      { id: 525656, name: "Arditara" },
      { id: 525721, name: "Asane" },
      { id: 525782, name: "Ashte" },
      { id: 525696, name: "Bahyane" },
      { id: 525770, name: "Bal Amrai" },
      { id: 525717, name: "Baldane" },
      { id: 525727, name: "Balwand" },
      { id: 525688, name: "Bamdod" },
      { id: 525716, name: "Bhadwad" },
      { id: 525680, name: "Bhagsari" },
      { id: 525704, name: "Bhaler" },
      { id: 525654, name: "Bhangda" },
      { id: 525651, name: "Bhavanipada" },
      { id: 525753, name: "Bhone" },
      { id: 525766, name: "Biladi" },
      { id: 525675, name: "Borale" },
      { id: 525751, name: "Chakle" },
      { id: 525747, name: "Chaupale" },
      { id: 525743, name: "Dahindule Bk." },
      { id: 525744, name: "Dahindule Kh" },
      { id: 525657, name: "Devpur" },
      { id: 525668, name: "Dhamdai" },
      { id: 525709, name: "Dhamdod" },
      { id: 525710, name: "Dhandhane" },
      { id: 525638, name: "Dhanora" },
      { id: 525769, name: "Dhekwad" },
      { id: 525763, name: "Dhirajgaon" },
      { id: 525643, name: "Dhulwad" },
      { id: 525755, name: "Dudhale" },
      { id: 525735, name: "Fulsare" },
      { id: 525786, name: "Gangapur" },
      { id: 525785, name: "Ghogalgaon" },
      { id: 525719, name: "Ghotane" },
      { id: 525683, name: "Ghuli" },
      { id: 525645, name: "Gujar Jamboli" },
      { id: 525644, name: "Gujarbhavali" },
      { id: 525777, name: "Haripur" },
      { id: 525691, name: "Hatmohide" },
      { id: 525687, name: "Hol Tarfe Haveli" },
      { id: 525699, name: "Hol Tarfe Ranale" },
      { id: 525726, name: "Indrihatti" },
      { id: 525636, name: "Isainagar" },
      { id: 525762, name: "Jalkhe" },
      { id: 525700, name: "Junmohide" },
      { id: 525701, name: "Kakarde" },
      { id: 525771, name: "Kalamba" },
      { id: 525707, name: "Kalmadi" },
      { id: 944568, name: "Kaltolami" },
      { id: 525706, name: "Kanalde" },
      { id: 525714, name: "Kandhre" },
      { id: 525639, name: "Karanjwe" },
      { id: 525737, name: "Karankheda" },
      { id: 525741, name: "Karjkupe" },
      { id: 525715, name: "Karli" },
      { id: 525746, name: "Kathore" },
      { id: 525772, name: "Khairale" },
      { id: 525765, name: "Khamgaon" },
      { id: 525677, name: "Khaparkheda" },
      { id: 525730, name: "Kharde Kh." },
      { id: 525670, name: "Khodasgaon" },
      { id: 525720, name: "Khokrale" },
      { id: 525689, name: "Khondamali" },
      { id: 525659, name: "Kodhali Kh." },
      { id: 525681, name: "Kolde" },
      { id: 525698, name: "Koparli" },
      { id: 525673, name: "Korit" },
      { id: 525663, name: "Kothade" },
      { id: 525679, name: "L.Shahade" },
      { id: 942965, name: "Lahan Umaj" },
      { id: 525740, name: "Lonkheda" },
      { id: 525648, name: "Loy" },
      { id: 525733, name: "Malkhand" },
      { id: 525652, name: "Malpur" },
      { id: 525724, name: "Mandal" },
      { id: 525653, name: "Mangrul" },
      { id: 525697, name: "Manjre" },
      { id: 525759, name: "Mothe Umaj" },
      { id: 525732, name: "Moyane" },
      { id: 525702, name: "Nagaon" },
      { id: 525774, name: "Nagsar" },
      { id: 525739, name: "Nalve Bk." },
      { id: 525742, name: "Nalve Kh." },
      { id: 525756, name: "Nandarkhe" },
      { id: 525637, name: "Nandpur" },
      { id: 525754, name: "Nandurbar" },
      { id: 525736, name: "Narayanpur" },
      { id: 525676, name: "Nashinde" },
      { id: 525658, name: "Natawad" },
      { id: 525773, name: "Navagaon" },
      { id: 525713, name: "Nimbhel" },
      { id: 525660, name: "Nimboni Bk." },
      { id: 525718, name: "Nyahali" },
      { id: 525693, name: "Osarli" },
      { id: 525780, name: "Ozarde" },
      { id: 525764, name: "Pachorabari" },
      { id: 525682, name: "Palashi" },
      { id: 525667, name: "Patharai" },
      { id: 525686, name: "Patonda" },
      { id: 525664, name: "Pawle" },
      { id: 525757, name: "Pimpari" },
      { id: 525649, name: "Pimplod" },
      { id: 525722, name: "Rajale" },
      { id: 525646, name: "Rajapur" },
      { id: 525684, name: "Rakaswade" },
      { id: 525712, name: "Ranale" },
      { id: 525761, name: "Ranale Kh" },
      { id: 525728, name: "Saitane" },
      { id: 525678, name: "Samsherpur" },
      { id: 525695, name: "Saturkhe" },
      { id: 525672, name: "Sawalde" },
      { id: 525640, name: "Shejve" },
      { id: 525671, name: "Shinde" },
      { id: 525705, name: "Shindgavhan" },
      { id: 525760, name: "Shirwade" },
      { id: 525641, name: "Shivpur" },
      { id: 525778, name: "Shrirampur" },
      { id: 525775, name: "Songir" },
      { id: 525674, name: "Sujalpur" },
      { id: 525738, name: "Sundarde" },
      { id: 525783, name: "Sutare" },
      { id: 525729, name: "Talwade Bk" },
      { id: 912926, name: "Talwade Kh" },
      { id: 525635, name: "Tarapur" },
      { id: 525787, name: "Thanepada" },
      { id: 525723, name: "Tilali" },
      { id: 525703, name: "Tisi" },
      { id: 525767, name: "Tokartale" },
      { id: 525734, name: "Umarde Bk" },
      { id: 525745, name: "Umarde Kh" },
      { id: 525650, name: "Umargaon" },
      { id: 525750, name: "Vadbare" },
      { id: 525731, name: "Vaindane" },
      { id: 525752, name: "Vasadare" },
      { id: 525748, name: "Vawad" },
      { id: 525647, name: "Velawad" },
      { id: 525690, name: "Vikharan" },
      { id: 525768, name: "Virchak" },
      { id: 525642, name: "Vyahur" },
      { id: 525776, name: "Wadgaon" },
      { id: 525708, name: "Wadwad" },
      { id: 525758, name: "Wadzhakan" },
      { id: 525779, name: "Waghale" },
      { id: 525685, name: "Waghode" },
      { id: 525662, name: "Wagshepa" },
      { id: 525711, name: "Wankute" },
      { id: 525669, name: "Warul" },
      { id: 525655, name: "Waslai" },
    ],
    3955: [
      { id: 525802, name: "Amlan" },
      { id: 525890, name: "Amsarpada" },
      { id: 525838, name: "Anjane" },
      { id: 525928, name: "Anthipada" },
      { id: 525920, name: "Balaamrai" },
      { id: 525833, name: "Bandhare" },
      { id: 525798, name: "Bandharfali" },
      { id: 525915, name: "Bandharpada" },
      { id: 525878, name: "Bardipada" },
      { id: 525817, name: "Bari" },
      { id: 525940, name: "Bedki" },
      { id: 525795, name: "Bedkipada" },
      { id: 525863, name: "Bhadwad" },
      { id: 525849, name: "Bhangarpada" },
      { id: 525909, name: "Bhardu" },
      { id: 525810, name: "Bhavare" },
      { id: 525862, name: "Bijadevi" },
      { id: 525880, name: "Bijgaon" },
      { id: 525840, name: "Bilbare" },
      { id: 525897, name: "Bilda" },
      { id: 525851, name: "Bilgavhan" },
      { id: 525846, name: "Bilipada" },
      { id: 525809, name: "Bilmanjre" },
      { id: 525816, name: "Bokalzar" },
      { id: 525866, name: "Borchak" },
      { id: 525942, name: "Borpada" },
      { id: 525830, name: "Borzar" },
      { id: 525845, name: "Cheda" },
      { id: 525834, name: "Chikhali" },
      { id: 525933, name: "Chinchpada" },
      { id: 525914, name: "Chitavi" },
      { id: 525903, name: "Chorvihir" },
      { id: 525822, name: "Chouki" },
      { id: 944546, name: "Daliamba" },
      { id: 525943, name: "Dapur" },
      { id: 525841, name: "Deolipada(Navagaon M)" },
      { id: 525912, name: "Deolipada(Visarwadi M)" },
      { id: 525854, name: "Deomogara" },
      { id: 525815, name: "Dhanrat" },
      { id: 525882, name: "Dhavalipada" },
      { id: 525887, name: "Dhong" },
      { id: 942960, name: "Dhorpada" },
      { id: 525814, name: "Dhulipada" },
      { id: 525871, name: "Dogegaon" },
      { id: 945058, name: "Dokare" },
      { id: 525835, name: "Dudhave" },
      { id: 525797, name: "Gadad" },
      { id: 942958, name: "Gadadani" },
      { id: 525918, name: "Gangapur" },
      { id: 942959, name: "Gatadi" },
      { id: 525807, name: "Ghodajamane" },
      { id: 525879, name: "Ghogalpada" },
      { id: 525927, name: "Haldani" },
      { id: 525837, name: "Jamade" },
      { id: 525812, name: "Jamtalav" },
      { id: 525932, name: "June Sawarat" },
      { id: 525904, name: "Kadwan" },
      { id: 525946, name: "Kamod" },
      { id: 944547, name: "Kanhala" },
      { id: 525857, name: "Karanjali" },
      { id: 525939, name: "Karanji Bk" },
      { id: 525808, name: "Karanji Kh" },
      { id: 525831, name: "Karanjvel" },
      { id: 525791, name: "Kareghat" },
      { id: 525872, name: "Kasare" },
      { id: 525910, name: "Keli" },
      { id: 525908, name: "Kelpada" },
      { id: 525902, name: "Khadki" },
      { id: 944575, name: "Khadkipada" },
      { id: 525859, name: "Khairve" },
      { id: 525826, name: "Khalibardi" },
      { id: 525929, name: "Khanapur" },
      { id: 525949, name: "Khandbara" },
      { id: 525850, name: "Kharje" },
      { id: 525900, name: "Khatgaon" },
      { id: 525792, name: "Khekada" },
      { id: 525790, name: "Khokarwada" },
      { id: 525948, name: "Khokase" },
      { id: 525891, name: "Kholghar" },
      { id: 525892, name: "Kholvihir" },
      { id: 525839, name: "Kokanipada" },
      { id: 525936, name: "Kolada" },
      { id: 525801, name: "Kothada" },
      { id: 525947, name: "Kotkhamb" },
      { id: 525945, name: "Kukaran" },
      { id: 525788, name: "Lakkad Kot" },
      { id: 525906, name: "Mahalkadu" },
      { id: 525883, name: "Malvan" },
      { id: 525870, name: "Marod" },
      { id: 944574, name: "Maslipada" },
      { id: 525877, name: "Mendipada" },
      { id: 525852, name: "Mentalav" },
      { id: 525881, name: "Mogarani" },
      { id: 944548, name: "Mohanpada" },
      { id: 525930, name: "Morkaranja" },
      { id: 525821, name: "Morthuwa" },
      { id: 525905, name: "Mothe Kadwan" },
      { id: 525873, name: "Moulipada" },
      { id: 525874, name: "Nagare" },
      { id: 525828, name: "Nagzari" },
      { id: 525926, name: "Nanagipada" },
      { id: 525805, name: "Nandvan" },
      { id: 525832, name: "Navagaon" },
      { id: 525889, name: "Navali" },
      { id: 945059, name: "Navapur" },
      { id: 525931, name: "Navi Sawarat" },
      { id: 525916, name: "Nawapada (Navapur M)" },
      { id: 525813, name: "Nawapada(Visarwadi M)" },
      { id: 525868, name: "Nijampur" },
      { id: 525876, name: "Nimboni" },
      { id: 525922, name: "Nimdarda" },
      { id: 525842, name: "Pachamba" },
      { id: 525867, name: "Palipada" },
      { id: 525888, name: "Palshi" },
      { id: 525884, name: "Palsun" },
      { id: 945060, name: "Panbara" },
      { id: 525803, name: "Pangaran" },
      { id: 525941, name: "Pati" },
      { id: 525811, name: "Payarvihir" },
      { id: 525893, name: "Pimpale" },
      { id: 525944, name: "Pimpran" },
      { id: 525823, name: "Pratappur" },
      { id: 525804, name: "Raingan" },
      { id: 525820, name: "Raipur" },
      { id: 525885, name: "Sagali" },
      { id: 525829, name: "Sari" },
      { id: 525865, name: "Shegave" },
      { id: 525869, name: "Shehi" },
      { id: 525847, name: "Shetgaon" },
      { id: 945061, name: "Shirve" },
      { id: 525875, name: "Shrawani" },
      { id: 525907, name: "Sonare Digar" },
      { id: 525938, name: "Sonkhadake" },
      { id: 525855, name: "Sonpada" },
      { id: 942962, name: "Sukvel" },
      { id: 525937, name: "Suli" },
      { id: 525858, name: "Talavipada" },
      { id: 525898, name: "Tarapur" },
      { id: 525848, name: "Tarpada" },
      { id: 525796, name: "Thuwa" },
      { id: 525921, name: "Tilsar" },
      { id: 525934, name: "Tinmauli" },
      { id: 525925, name: "Uchishevdi" },
      { id: 945064, name: "Ukalapani" },
      { id: 525844, name: "Umaran" },
      { id: 945062, name: "Umbhardi" },
      { id: 525886, name: "Vadade" },
      { id: 525827, name: "Vadkalambi" },
      { id: 525935, name: "Vadkhut" },
      { id: 525899, name: "Vadphali" },
      { id: 525856, name: "Vagade" },
      { id: 525853, name: "Vavadi" },
      { id: 945063, name: "Vhande(Vasade)" },
      { id: 525806, name: "Vijapur" },
      { id: 525919, name: "Visarwadi" },
      { id: 525917, name: "Vrhadipada" },
      { id: 525911, name: "Wadsatra" },
      { id: 525913, name: "Wagadi" },
      { id: 525800, name: "Wakipada" },
      { id: 525896, name: "Wanzale" },
      { id: 525864, name: "Watvi (Khandbara Man)" },
      { id: 525843, name: "Watvi (Navagav Man)" },
      { id: 525794, name: "Zamanzar" },
      { id: 525860, name: "Zamatyawad" },
      { id: 525861, name: "Zaripada" },
    ],
    3956: [
      { id: 526022, name: "Abhanpur Kh." },
      { id: 526069, name: "Adhe" },
      { id: 526072, name: "Ahilyapur" },
      { id: 526084, name: "Ajanad" },
      { id: 526089, name: "Ajande Bk" },
      { id: 526053, name: "Ajande Kh." },
      { id: 947339, name: "Ajnad Bangla" },
      { id: 526002, name: "Ambe" },
      { id: 526054, name: "Amode" },
      { id: 525999, name: "Anjanpada" },
      { id: 526035, name: "Anturli" },
      { id: 526038, name: "Arthe Bk." },
      { id: 526039, name: "Arthe Kh." },
      { id: 526071, name: "Asali" },
      { id: 526083, name: "Babhalaj" },
      { id: 526065, name: "Babhulde" },
      { id: 526057, name: "Balade" },
      { id: 525979, name: "Balkuwe" },
      { id: 526043, name: "Bharvade" },
      { id: 526029, name: "Bhatane" },
      { id: 526086, name: "Bhatpure" },
      { id: 526087, name: "Bhaver" },
      { id: 525993, name: "Bhilardevpada" },
      { id: 526017, name: "Bhoiti" },
      { id: 526075, name: "Bhorkheda" },
      { id: 526092, name: "Bhortek" },
      { id: 525968, name: "Boradi" },
      { id: 526048, name: "Borgaon" },
      { id: 526003, name: "Bormali" },
      { id: 525959, name: "Borpani" },
      { id: 525969, name: "Budki" },
      { id: 525958, name: "Chakadu" },
      { id: 525976, name: "Chandase" },
      { id: 525970, name: "Chandpuri" },
      { id: 526018, name: "Chilare" },
      { id: 526020, name: "Dahivad" },
      { id: 943959, name: "Devisinggaon" },
      { id: 526004, name: "Dhavalivihir" },
      { id: 525954, name: "Durbadya" },
      { id: 525960, name: "Fattepur Knagai" },
      { id: 943960, name: "Fattepurforest" },
      { id: 525951, name: "Gadhaddeo" },
      { id: 526059, name: "Gartad" },
      { id: 526096, name: "Ghodasgaon" },
      { id: 526062, name: "Gidhade" },
      { id: 526076, name: "Godi" },
      { id: 525952, name: "Gurhadpani" },
      { id: 525998, name: "Hadakhed" },
      { id: 525986, name: "Hated" },
      { id: 525984, name: "Hedryapada" },
      { id: 526015, name: "Higaon" },
      { id: 526049, name: "Hingoni Bk" },
      { id: 526007, name: "Hingonipada" },
      { id: 526081, name: "Hisale" },
      { id: 526016, name: "Hivarkheda" },
      { id: 526090, name: "Hol" },
      { id: 526073, name: "Jaitpur" },
      { id: 526024, name: "Jalod" },
      { id: 525992, name: "Jamnyapada" },
      { id: 526094, name: "Japore" },
      { id: 526047, name: "Jatode" },
      { id: 526036, name: "Javkheda" },
      { id: 525990, name: "Joyada" },
      { id: 526030, name: "June Bhampur" },
      { id: 525953, name: "Kakadmal" },
      { id: 526052, name: "Kalmasare" },
      { id: 526019, name: "Karvand" },
      { id: 525991, name: "Khairkhuti" },
      { id: 525994, name: "Khambale" },
      { id: 526014, name: "Khamkheda Pr. Ambe" },
      { id: 526042, name: "Khankheda Pr. Thalner" },
      { id: 526055, name: "Kharde Bk" },
      { id: 526064, name: "Kharde Kh." },
      { id: 525957, name: "Kodid" },
      { id: 526067, name: "Kurkhali" },
      { id: 525980, name: "Kuwe" },
      { id: 526005, name: "Lakadya Hanuman" },
      { id: 526006, name: "Lauki" },
      { id: 526037, name: "Lodhare" },
      { id: 526051, name: "Madal" },
      { id: 526078, name: "Mahadeo Dondwad" },
      { id: 526079, name: "Malkatar" },
      { id: 526028, name: "Mamane" },
      { id: 526093, name: "Manjrod" },
      { id: 525965, name: "Mohida" },
      { id: 526025, name: "Mukhed" },
      { id: 525974, name: "Nandarde" },
      { id: 526091, name: "Nanthe" },
      { id: 526010, name: "Natwade" },
      { id: 943967, name: "Navebhampur" },
      { id: 525971, name: "New Boradi" },
      { id: 526009, name: "Nimzari" },
      { id: 525983, name: "Palasner" },
      { id: 525985, name: "Panakhed" },
      { id: 526063, name: "Patharde" },
      { id: 526095, name: "Pilode" },
      { id: 526088, name: "Pimpale" },
      { id: 526068, name: "Pimpri" },
      { id: 526013, name: "Rohini" },
      { id: 526045, name: "Rudawali" },
      { id: 526058, name: "Sakvad" },
      { id: 525989, name: "Sangavi" },
      { id: 526066, name: "Savalade" },
      { id: 526085, name: "Saver" },
      { id: 525966, name: "Shemlya" },
      { id: 526050, name: "Shingave" },
      { id: 943969, name: "Shirpur Budruk" },
      { id: 943971, name: "Shirpur Khurd" },
      { id: 525982, name: "Subhash Nagar" },
      { id: 526011, name: "Sule" },
      { id: 526060, name: "Tajpuri" },
      { id: 526070, name: "Tande" },
      { id: 526082, name: "Tardi" },
      { id: 526023, name: "Tarhad (Kasbe)" },
      { id: 526027, name: "Tarhadi T.T." },
      { id: 526041, name: "Tekwade" },
      { id: 526044, name: "Tembhe Bk." },
      { id: 525973, name: "Tembhepada" },
      { id: 526077, name: "Thalner" },
      { id: 526080, name: "Tode" },
      { id: 526026, name: "Ukhalwadi" },
      { id: 525956, name: "Umarda" },
      { id: 526056, name: "Untawad" },
      { id: 526061, name: "Uparpid" },
      { id: 526001, name: "Vadle Kh" },
      { id: 525955, name: "Vakwad" },
      { id: 526046, name: "Vanaval" },
      { id: 526034, name: "Varul" },
      { id: 526008, name: "Varzadi" },
      { id: 526031, name: "Vikharan Bk." },
      { id: 526032, name: "Vikharan Kh." },
      { id: 525977, name: "Wadi Bk" },
      { id: 525978, name: "Wadi Kh." },
      { id: 525981, name: "Waghadi" },
      { id: 525961, name: "Wakapada" },
      { id: 944988, name: "Warvade" },
      { id: 525975, name: "Wasardi" },
      { id: 526074, name: "Wathode" },
      { id: 525964, name: "Zende-Anjan" },
    ],
    3957: [
      { id: 526140, name: "Achhi" },
      { id: 526202, name: "Ajande Bk" },
      { id: 526174, name: "Ajande Kh" },
      { id: 526112, name: "Akkadse" },
      { id: 526151, name: "Akkalkos" },
      { id: 526205, name: "Alane" },
      { id: 526141, name: "Amalathe" },
      { id: 526232, name: "Amarale" },
      { id: 526129, name: "Anjanvihire" },
      { id: 526225, name: "Arave" },
      { id: 526192, name: "Babhalde" },
      { id: 526208, name: "Babhale" },
      { id: 526119, name: "Bamhane" },
      { id: 526201, name: "Betawad" },
      { id: 526159, name: "Bhadane" },
      { id: 526199, name: "Bhilane Digar" },
      { id: 526213, name: "Chandgad" },
      { id: 526147, name: "Chaugaon Bk" },
      { id: 526146, name: "Chaugaon Kh." },
      { id: 526099, name: "Chawalde" },
      { id: 526143, name: "Chilane" },
      { id: 526222, name: "Chimthane" },
      { id: 526237, name: "Chimthaval" },
      { id: 526206, name: "Chirne" },
      { id: 526111, name: "Chudane" },
      { id: 526165, name: "Dabhashi" },
      { id: 526177, name: "Dabli" },
      { id: 526144, name: "Dalwade Pra.N." },
      { id: 526223, name: "Dalwade Pra.S." },
      { id: 526216, name: "Dangurne" },
      { id: 526233, name: "Darana" },
      { id: 526209, name: "Darkheda" },
      { id: 526173, name: "Daswel" },
      { id: 526172, name: "Dattane" },
      { id: 526116, name: "Daul" },
      { id: 526221, name: "Degaon" },
      { id: 526120, name: "Dhamane" },
      { id: 526176, name: "Dhandarne" },
      { id: 526108, name: "Dhawde" },
      { id: 526227, name: "Divi" },
      { id: 943961, name: "Dondaicha" },
      { id: 526194, name: "Dongargaon" },
      { id: 526171, name: "Gavhane" },
      { id: 526157, name: "Ghusre" },
      { id: 526189, name: "Gorane" },
      { id: 526162, name: "Hatnur" },
      { id: 526139, name: "Hispur" },
      { id: 526175, name: "Hol Pra.Be." },
      { id: 526180, name: "Humbarde" },
      { id: 526231, name: "Jakhane" },
      { id: 526138, name: "Jasane" },
      { id: 526187, name: "Jatode" },
      { id: 526145, name: "Jogshelu" },
      { id: 526207, name: "Kadane" },
      { id: 526136, name: "Kalgaon" },
      { id: 526191, name: "Kalmadi" },
      { id: 526113, name: "Kalwade" },
      { id: 526179, name: "Kamkhede" },
      { id: 526126, name: "Kampur" },
      { id: 526193, name: "Kanchanpur" },
      { id: 526115, name: "Karle" },
      { id: 526212, name: "Khalane" },
      { id: 526128, name: "Kharde Bk." },
      { id: 526131, name: "Kodade" },
      { id: 526135, name: "Kumbhare" },
      { id: 526160, name: "Kumrej" },
      { id: 526121, name: "Kurukwade" },
      { id: 526132, name: "Langhane" },
      { id: 526134, name: "Lohgaon" },
      { id: 526117, name: "Madane" },
      { id: 526210, name: "Mahalpur" },
      { id: 526188, name: "Malich" },
      { id: 526109, name: "Malpur" },
      { id: 526196, name: "Malsar" },
      { id: 526124, name: "Mandal" },
      { id: 526186, name: "Melane" },
      { id: 526127, name: "Methi" },
      { id: 526198, name: "Mudawad" },
      { id: 526236, name: "Mukati" },
      { id: 526184, name: "Nardane" },
      { id: 526149, name: "Newade" },
      { id: 526104, name: "Nimgul" },
      { id: 526167, name: "Nirgudi" },
      { id: 526211, name: "Nishane" },
      { id: 526200, name: "Padhawad" },
      { id: 526161, name: "Parsamal" },
      { id: 526114, name: "Parsole" },
      { id: 526182, name: "Pashte" },
      { id: 526154, name: "Patan" },
      { id: 526106, name: "Pathare" },
      { id: 526190, name: "Pimparkheda" },
      { id: 526183, name: "Pimprad" },
      { id: 526224, name: "Pipari" },
      { id: 526123, name: "Rahimpur" },
      { id: 526107, name: "Rami" },
      { id: 526137, name: "Ranjane" },
      { id: 526228, name: "Rewadi" },
      { id: 526234, name: "Rohane" },
      { id: 526230, name: "Rudane" },
      { id: 526102, name: "Sahur" },
      { id: 526163, name: "Salve" },
      { id: 526215, name: "Sarve" },
      { id: 526220, name: "Satare" },
      { id: 526101, name: "Shendwade" },
      { id: 526226, name: "Shewade" },
      { id: 526155, name: "Shindkheda" },
      { id: 526170, name: "Shirale" },
      { id: 526217, name: "Sondale" },
      { id: 526150, name: "Sonewadi" },
      { id: 526158, name: "Sonshelu" },
      { id: 526164, name: "Sukwad" },
      { id: 526153, name: "Sulwade" },
      { id: 526110, name: "Suray" },
      { id: 526097, name: "Takarkhede" },
      { id: 526235, name: "Tamthre" },
      { id: 526100, name: "Tavkheda Pra.N." },
      { id: 526166, name: "Tavkhede Pra.Be." },
      { id: 526168, name: "Temlay" },
      { id: 526181, name: "Vadali" },
      { id: 526197, name: "Vadode" },
      { id: 526214, name: "Vaipur" },
      { id: 526204, name: "Valkheda" },
      { id: 526148, name: "Varpade" },
      { id: 526169, name: "Varshi" },
      { id: 526152, name: "Varsus" },
      { id: 526156, name: "Varul" },
      { id: 526130, name: "Varzadi" },
      { id: 526133, name: "Vasamane" },
      { id: 526125, name: "Vikharan" },
      { id: 526122, name: "Vikhurle" },
      { id: 526195, name: "Viklel" },
      { id: 526142, name: "Virdel" },
      { id: 526178, name: "Vitai" },
      { id: 526098, name: "Wadade" },
      { id: 526229, name: "Wadi" },
      { id: 526219, name: "Waghadi Bk" },
      { id: 526218, name: "Waghadi Kh" },
      { id: 526203, name: "Waghode" },
      { id: 526118, name: "Wani" },
      { id: 526185, name: "Warud" },
      { id: 943962, name: "Warvade" },
      { id: 526105, name: "Zirve" },
      { id: 526103, name: "Zotwade" },
    ],
    3958: [
      { id: 945413, name: "Aagarpada" },
      { id: 526360, name: "Aamode" },
      { id: 526297, name: "Aechale" },
      { id: 526313, name: "Aine" },
      { id: 526280, name: "Akhade" },
      { id: 526331, name: "Akkalpada" },
      { id: 526335, name: "Amali" },
      { id: 526319, name: "Ambapur" },
      { id: 526256, name: "Amkhel" },
      { id: 526306, name: "Amode" },
      { id: 526316, name: "Ashtane" },
      { id: 526274, name: "Babhulade" },
      { id: 526372, name: "Bagulnagar" },
      { id: 526431, name: "Balhane" },
      { id: 526300, name: "Balsane" },
      { id: 945412, name: "Baripada" },
      { id: 526257, name: "Basar" },
      { id: 526385, name: "Basarawal" },
      { id: 526453, name: "Behed" },
      { id: 526323, name: "Bhadane" },
      { id: 526461, name: "Bhadgaon (Ma)" },
      { id: 526295, name: "Bhadgaon (V)" },
      { id: 526282, name: "Bhagapur" },
      { id: 526288, name: "Bhamer" },
      { id: 526356, name: "Bhongaon" },
      { id: 526266, name: "Bhortek" },
      { id: 526339, name: "Bodakikhadi" },
      { id: 526358, name: "Bodgaon" },
      { id: 947335, name: "Bodhripada" },
      { id: 526413, name: "Bopkhel" },
      { id: 526265, name: "Bramhanwel" },
      { id: 526260, name: "Burudkhe" },
      { id: 526367, name: "Charanmal" },
      { id: 526346, name: "Chaupale" },
      { id: 947334, name: "Chavadipada" },
      { id: 526254, name: "Chhadwel (Korde)" },
      { id: 526315, name: "Chhadwel (P)" },
      { id: 526450, name: "Chhail" },
      { id: 526305, name: "Chhavadi" },
      { id: 526423, name: "Chikase" },
      { id: 526458, name: "Chinchkhede" },
      { id: 526400, name: "Chinchpada" },
      { id: 526268, name: "Chipalipada" },
      { id: 526407, name: "Chorwad" },
      { id: 526355, name: "Dahiwel" },
      { id: 526403, name: "Dangshirwade" },
      { id: 526378, name: "Dapur" },
      { id: 526402, name: "Daregaon" },
      { id: 526452, name: "Darkhel" },
      { id: 526327, name: "Datarti" },
      { id: 526418, name: "Degaon" },
      { id: 526426, name: "Deshshirwade" },
      { id: 526263, name: "Devjipada" },
      { id: 526370, name: "Devli Pada" },
      { id: 526440, name: "Dhadane" },
      { id: 526437, name: "Dhamandhar" },
      { id: 526333, name: "Dhamnar" },
      { id: 526336, name: "Dhaner" },
      { id: 526377, name: "Dhangai" },
      { id: 526364, name: "Dhavali Vihir" },
      { id: 526253, name: "Dhavali Vihir (New)" },
      { id: 526363, name: "Dholipada" },
      { id: 526430, name: "Dhongade Digar" },
      { id: 526447, name: "Dighawe" },
      { id: 526286, name: "Domkani" },
      { id: 526390, name: "Dongarpada" },
      { id: 526301, name: "Dusane" },
      { id: 526310, name: "Fofare" },
      { id: 526446, name: "Ganeshpur" },
      { id: 526328, name: "Gangapur" },
      { id: 526345, name: "Gartad" },
      { id: 526417, name: "Gavhanipada" },
      { id: 526308, name: "Ghanegaon" },
      { id: 526361, name: "Ghodade" },
      { id: 526324, name: "Gondas" },
      { id: 526272, name: "Gultare" },
      { id: 947340, name: "Hanumant Nagar" },
      { id: 526348, name: "Hanumantpada" },
      { id: 947336, name: "Harpada" },
      { id: 526309, name: "Hatti Bk." },
      { id: 526298, name: "Hatti Kh." },
      { id: 526293, name: "Hodadane" },
      { id: 947337, name: "Holyahchapada" },
      { id: 526330, name: "Ichchapur" },
      { id: 526299, name: "Indawe" },
      { id: 526246, name: "Isarde" },
      { id: 526284, name: "Jaitane" },
      { id: 526249, name: "Jamade" },
      { id: 526273, name: "Jambhore" },
      { id: 526352, name: "Jamkhel" },
      { id: 526275, name: "Jamki" },
      { id: 526381, name: "Jayramnagar" },
      { id: 526379, name: "Jebapur" },
      { id: 526424, name: "Jirapur" },
      { id: 526303, name: "Kadhre" },
      { id: 526368, name: "Kadupada" },
      { id: 526427, name: "Kadyale" },
      { id: 526382, name: "Kailasnagar" },
      { id: 526460, name: "Kakani" },
      { id: 526349, name: "Kakarde" },
      { id: 526396, name: "Kaksewad" },
      { id: 526388, name: "Kalambe" },
      { id: 526320, name: "Kalambhir" },
      { id: 947338, name: "Kaldar" },
      { id: 526456, name: "Kalgaon" },
      { id: 947333, name: "Kalikhet" },
      { id: 526244, name: "Kaltek" },
      { id: 526369, name: "Karanjati" },
      { id: 526444, name: "Kasare" },
      { id: 526317, name: "Kawathe" },
      { id: 526387, name: "Khairkhunda" },
      { id: 526341, name: "Khandbara" },
      { id: 526338, name: "Kharadbari" },
      { id: 526404, name: "Khargaon" },
      { id: 526415, name: "Khatyal" },
      { id: 526250, name: "Khori" },
      { id: 526285, name: "Khudane" },
      { id: 526357, name: "Kirwade" },
      { id: 526325, name: "Kokale" },
      { id: 526435, name: "Kokangaon" },
      { id: 526255, name: "Korde" },
      { id: 526392, name: "Kudashi" },
      { id: 526350, name: "Kuher" },
      { id: 526343, name: "Kuruswade" },
      { id: 526374, name: "Kuttarkhamb" },
      { id: 526252, name: "Kuttarmare" },
      { id: 526262, name: "Lagadwal" },
      { id: 526406, name: "Lakhale" },
      { id: 526347, name: "Lavhardodi" },
      { id: 526304, name: "Lonkhede" },
      { id: 526342, name: "Machmal" },
      { id: 526321, name: "Mahir" },
      { id: 526394, name: "Mahuband" },
      { id: 526359, name: "Maindane" },
      { id: 526340, name: "Malangaon" },
      { id: 526419, name: "Malanjan" },
      { id: 526389, name: "Malgaon Pr.Warsa" },
      { id: 526314, name: "Malkhede" },
      { id: 526442, name: "Malpur" },
      { id: 526401, name: "Malyachapada" },
      { id: 526438, name: "Mandane" },
      { id: 526411, name: "Manjari" },
      { id: 526412, name: "Mapalgaon" },
      { id: 526259, name: "Mavajipada" },
      { id: 947332, name: "Mhalyachapada" },
      { id: 526307, name: "Mhasale" },
      { id: 526459, name: "Mhasdi Pr.Ner" },
      { id: 526422, name: "Mhasdi Pr.Pimpalner" },
      { id: 526409, name: "Mohagaon" },
      { id: 526376, name: "Mohane" },
      { id: 526451, name: "Nadse" },
      { id: 526270, name: "Nagaziri" },
      { id: 526443, name: "Nagpur (Ko)" },
      { id: 526311, name: "Nagpur (V)" },
      { id: 526384, name: "Nandarakhi" },
      { id: 526326, name: "Nandwan" },
      { id: 945068, name: "Navapur" },
      { id: 526441, name: "Nawadane" },
      { id: 526264, name: "Nawapada" },
      { id: 526380, name: "Nawenagar" },
      { id: 526463, name: "Nijampur" },
      { id: 526454, name: "Nilgavhan" },
      { id: 526395, name: "Ozarade" },
      { id: 526243, name: "Pachale" },
      { id: 526238, name: "Pachmouli" },
      { id: 526240, name: "Pangan" },
      { id: 526247, name: "Panhalipada" },
      { id: 526399, name: "Pankhede" },
      { id: 526432, name: "Pargaon" },
      { id: 526318, name: "Perejpur" },
      { id: 526248, name: "Petale" },
      { id: 526281, name: "Phophade" },
      { id: 526383, name: "Pimpalgaon Budruk" },
      { id: 526408, name: "Pimpalgaon Khurd" },
      { id: 526425, name: "Pimpalner" },
      { id: 526239, name: "Pinjar Zadi" },
      { id: 945067, name: "Pobare" },
      { id: 526449, name: "Pratappur" },
      { id: 526375, name: "Punajinagar" },
      { id: 526261, name: "Raikot" },
      { id: 947331, name: "Rainpada" },
      { id: 526290, name: "Raipur" },
      { id: 526271, name: "Raitel" },
      { id: 526258, name: "Ranjangaon" },
      { id: 526365, name: "Rohan" },
      { id: 526351, name: "Rohod" },
      { id: 526291, name: "Rojgaon" },
      { id: 526278, name: "Runmali" },
      { id: 526464, name: "Sakri" },
      { id: 526287, name: "Saltek" },
      { id: 526421, name: "Samode" },
      { id: 526354, name: "Satarpada" },
      { id: 526302, name: "Satmane" },
      { id: 526391, name: "Savarimal" },
      { id: 526445, name: "Sayane" },
      { id: 526332, name: "Sayyadnagar" },
      { id: 526429, name: "Shelbari" },
      { id: 526410, name: "Shendwad" },
      { id: 526439, name: "Shenpur" },
      { id: 526428, name: "Shewadipada" },
      { id: 526433, name: "Shewage" },
      { id: 526322, name: "Shewali (Da. )" },
      { id: 526462, name: "Shewali (Ma. )" },
      { id: 526353, name: "Shirsole" },
      { id: 526414, name: "Shiv" },
      { id: 526371, name: "Shivajinagar" },
      { id: 526289, name: "Shivajinagar Na.Ga." },
      { id: 526334, name: "Shivarimal" },
      { id: 526245, name: "Sinband" },
      { id: 526434, name: "Sitarampur" },
      { id: 526398, name: "Sukapur" },
      { id: 526362, name: "Surpan" },
      { id: 526344, name: "Sutare" },
      { id: 526329, name: "Tamaswadi" },
      { id: 945065, name: "Tembhe Pra.Bhamer" },
      { id: 945066, name: "Tembhe Pra.Varsa" },
      { id: 526251, name: "Titane" },
      { id: 526337, name: "Torankudi" },
      { id: 526312, name: "Ubhand" },
      { id: 526283, name: "Ubharandi" },
      { id: 526386, name: "Umarpata" },
      { id: 910827, name: "Umbarkhandwa" },
      { id: 526420, name: "Umbhare" },
      { id: 526448, name: "Umbharti" },
      { id: 526279, name: "Vajadare" },
      { id: 526241, name: "Valwhe" },
      { id: 526294, name: "Vardharne" },
      { id: 526277, name: "Varsus" },
      { id: 526416, name: "Varzadi" },
      { id: 526276, name: "Vaskhedi" },
      { id: 526457, name: "Vasmar" },
      { id: 526292, name: "Vehergaon" },
      { id: 526269, name: "Vihirgaon" },
      { id: 526436, name: "Virkhel" },
      { id: 526455, name: "Vitai" },
      { id: 526242, name: "Vitawe" },
      { id: 526397, name: "Waki" },
      { id: 526405, name: "Warsa" },
      { id: 526366, name: "Zanzale" },
      { id: 526267, name: "Zirani" },
    ],
    3959: [
      { id: 526541, name: "Achade" },
      { id: 526531, name: "Ajang" },
      { id: 526588, name: "Ajnale" },
      { id: 526575, name: "Aklad" },
      { id: 526527, name: "Ambode" },
      { id: 526533, name: "Amdad" },
      { id: 526598, name: "Anakwadi" },
      { id: 526540, name: "Anchade Tanda" },
      { id: 526516, name: "Arni" },
      { id: 526600, name: "Arvi" },
      { id: 526632, name: "Awadhan" },
      { id: 526523, name: "Babhulwadi" },
      { id: 526614, name: "Babre" },
      { id: 526518, name: "Balapur" },
      { id: 526590, name: "Balhane" },
      { id: 526469, name: "Bamburle.Pr.Ner." },
      { id: 526466, name: "Behed" },
      { id: 526607, name: "Bendrepada" },
      { id: 526570, name: "Bhadane" },
      { id: 526536, name: "Bhirdai" },
      { id: 526534, name: "Bhirdane" },
      { id: 526551, name: "Bhokar" },
      { id: 526501, name: "Biladi" },
      { id: 526613, name: "Bodgaon" },
      { id: 526468, name: "Boris" },
      { id: 526620, name: "Borkund" },
      { id: 526475, name: "Borsule" },
      { id: 526543, name: "Borvihir" },
      { id: 526471, name: "Burzad" },
      { id: 526627, name: "Chande" },
      { id: 526579, name: "Chaugaon" },
      { id: 526539, name: "Chinchkhede" },
      { id: 526478, name: "Chinchwar" },
      { id: 526559, name: "Chitod" },
      { id: 526591, name: "Dahyane" },
      { id: 526484, name: "Dapura" },
      { id: 526485, name: "Dapuri" },
      { id: 526490, name: "Deobhane" },
      { id: 943957, name: "Deopur" },
      { id: 526583, name: "Deur Bk." },
      { id: 526582, name: "Deur Kh." },
      { id: 526605, name: "Dhadre" },
      { id: 526497, name: "Dhadri" },
      { id: 526494, name: "Dhamane" },
      { id: 526612, name: "Dhamangaon" },
      { id: 526495, name: "Dhamani" },
      { id: 945120, name: "Dhandane" },
      { id: 526487, name: "Dhanur" },
      { id: 526496, name: "Dhodi" },
      { id: 943958, name: "Dhule" },
      { id: 526593, name: "Diwanmala" },
      { id: 526619, name: "Dondwad" },
      { id: 526519, name: "Fagne" },
      { id: 526525, name: "Gadutar" },
      { id: 526550, name: "Gondur" },
      { id: 526578, name: "Gotane" },
      { id: 526544, name: "Hadsuni" },
      { id: 526602, name: "Hendrun" },
      { id: 526597, name: "Henkalwadi" },
      { id: 526505, name: "Henkalwadi-1" },
      { id: 526587, name: "Hingane" },
      { id: 526622, name: "Horpada" },
      { id: 526610, name: "Isarne" },
      { id: 526502, name: "Japi" },
      { id: 526592, name: "Junher" },
      { id: 526609, name: "Junwane" },
      { id: 526532, name: "Kalkheda" },
      { id: 526491, name: "Kapadne" },
      { id: 526530, name: "Kasvihir" },
      { id: 526492, name: "Kauthal" },
      { id: 526482, name: "Kawathi" },
      { id: 526564, name: "Khandlay Budruk" },
      { id: 526565, name: "Khandlay Kh." },
      { id: 526554, name: "Khede" },
      { id: 526617, name: "Khordad" },
      { id: 526608, name: "Kulthe" },
      { id: 526546, name: "Kundane (Velhane)" },
      { id: 526557, name: "Kundane (War)" },
      { id: 526504, name: "Kundane (Warkhede)" },
      { id: 526577, name: "Kusumbe" },
      { id: 526594, name: "Laling" },
      { id: 526465, name: "Lamkani" },
      { id: 526580, name: "Lohgad" },
      { id: 526581, name: "Lonkhedi" },
      { id: 526488, name: "Lonkute" },
      { id: 526566, name: "M.Nurnagar" },
      { id: 526569, name: "Mahal Kali" },
      { id: 526567, name: "Mahal Kandamana" },
      { id: 526573, name: "Mahal Kasad" },
      { id: 526572, name: "Mahal Lodha" },
      { id: 526574, name: "Mahal Mali" },
      { id: 526571, name: "Mahal Pandhari" },
      { id: 526631, name: "Mahindale" },
      { id: 526526, name: "Malane" },
      { id: 526603, name: "Mandal" },
      { id: 526481, name: "Mehergaon" },
      { id: 526601, name: "Moghan" },
      { id: 526506, name: "Mohadi Pr.Dan." },
      { id: 943963, name: "Mohadi.Pra.La" },
      { id: 526558, name: "Morane Pr. La." },
      { id: 526576, name: "Morane Pr.Ner" },
      { id: 526628, name: "Mordad" },
      { id: 526629, name: "Mordad Tanda" },
      { id: 526595, name: "Morshevadi" },
      { id: 526535, name: "Mukati" },
      { id: 526500, name: "Nagaon Bk." },
      { id: 526528, name: "Nagaon Kh." },
      { id: 526552, name: "Nakane" },
      { id: 526623, name: "Nandale Bk." },
      { id: 526529, name: "Nandale Kh." },
      { id: 526472, name: "Nandane" },
      { id: 526584, name: "Nandre" },
      { id: 526624, name: "Nane" },
      { id: 526524, name: "Narvhal" },
      { id: 526476, name: "Navekothare" },
      { id: 526480, name: "Navlane" },
      { id: 526514, name: "Nawalnagar" },
      { id: 526510, name: "Nawra" },
      { id: 526511, name: "Nawri" },
      { id: 526474, name: "Nikumbhe" },
      { id: 526549, name: "Nimdale" },
      { id: 526615, name: "Nimgul" },
      { id: 526503, name: "Nimkhedi" },
      { id: 526493, name: "Nyahalod" },
      { id: 526589, name: "Padalde" },
      { id: 526586, name: "Pimparkhede" },
      { id: 526520, name: "Pimpri" },
      { id: 526606, name: "Purmepada" },
      { id: 526467, name: "Rami" },
      { id: 526562, name: "Ranmala" },
      { id: 526560, name: "Raver" },
      { id: 526621, name: "Raywat" },
      { id: 526596, name: "Sadgaon" },
      { id: 526477, name: "Saitale" },
      { id: 526556, name: "Sanjori" },
      { id: 526489, name: "Sarvad" },
      { id: 526509, name: "Satarne" },
      { id: 526522, name: "Saundane" },
      { id: 526537, name: "Savali" },
      { id: 526561, name: "Sawalde" },
      { id: 526538, name: "Sawali Tanda" },
      { id: 526473, name: "Sayane" },
      { id: 526512, name: "Shirdane Pr.Da." },
      { id: 526479, name: "Shirdhane Pr.Ner" },
      { id: 526611, name: "Shirud" },
      { id: 526625, name: "Sitane" },
      { id: 526599, name: "Sonewadi" },
      { id: 526483, name: "Songir" },
      { id: 526507, name: "Sukawad Pra.Da." },
      { id: 526548, name: "Sutare Pada" },
      { id: 526486, name: "Tamaswadi" },
      { id: 526547, name: "Tanda (Kundane Pra.Ve)" },
      { id: 526626, name: "Tarwade" },
      { id: 526563, name: "Tikhi" },
      { id: 526498, name: "Tisgaon" },
      { id: 526585, name: "Ubhand" },
      { id: 526555, name: "Udane" },
      { id: 526521, name: "Vadjai" },
      { id: 526542, name: "Vajirkhede" },
      { id: 526515, name: "Vani Bk" },
      { id: 526616, name: "Vani Kh" },
      { id: 526517, name: "Varkhede" },
      { id: 526545, name: "Velhane Bk." },
      { id: 526618, name: "Vinchur" },
      { id: 526508, name: "Vishwanath" },
      { id: 526499, name: "Wadel" },
      { id: 526513, name: "Wadgaon" },
      { id: 526470, name: "Wadne" },
      { id: 526630, name: "Walwadi" },
      { id: 526553, name: "War" },
    ],
    3960: [
      { id: 526729, name: "Adawad" },
      { id: 526680, name: "Adgaon" },
      { id: 526688, name: "Ajanti Sim" },
      { id: 526685, name: "Akhatwade" },
      { id: 526683, name: "Akulkhede" },
      { id: 526634, name: "Amalwadi" },
      { id: 526667, name: "Ambade" },
      { id: 526691, name: "Anwarde Bk." },
      { id: 526698, name: "Anwarde Kh." },
      { id: 526734, name: "Badhai" },
      { id: 526733, name: "Badhawani" },
      { id: 526702, name: "Bhardu" },
      { id: 526648, name: "Bhawade" },
      { id: 526724, name: "Bhokari" },
      { id: 526737, name: "Bidgaon" },
      { id: 526679, name: "Bor Ajanti" },
      { id: 526670, name: "Borkheda" },
      { id: 526662, name: "Bormali" },
      { id: 526697, name: "Budhgaon" },
      { id: 526703, name: "Chahardi" },
      { id: 526744, name: "Chandsani" },
      { id: 526640, name: "Chaugaon" },
      { id: 944347, name: "Chopda" },
      { id: 526644, name: "Chunchale" },
      { id: 526690, name: "Dagadi Bk" },
      { id: 526742, name: "Deogaon" },
      { id: 526661, name: "Deojhiri" },
      { id: 526660, name: "Devhari" },
      { id: 526741, name: "Dhanore Pr.Ad." },
      { id: 526649, name: "Dhanore Pr.Cho." },
      { id: 526714, name: "Dhanwadi" },
      { id: 526706, name: "Dhupe Bk." },
      { id: 526705, name: "Dhupe Kh." },
      { id: 526708, name: "Dondwade" },
      { id: 526650, name: "Galangi" },
      { id: 526700, name: "Galwade" },
      { id: 526647, name: "Ganpur" },
      { id: 526687, name: "Garatad" },
      { id: 526707, name: "Ghadwel" },
      { id: 526652, name: "Ghodgaon" },
      { id: 526715, name: "Ghumawal Bk." },
      { id: 526751, name: "Ghumawal Kh." },
      { id: 526717, name: "Gorgawale Bk." },
      { id: 526723, name: "Gorgawale Kh." },
      { id: 526701, name: "Hated Bk." },
      { id: 526699, name: "Hated Kh." },
      { id: 526732, name: "Ichhapur" },
      { id: 526747, name: "Kamalgaon" },
      { id: 526658, name: "Karjana" },
      { id: 526641, name: "Karjane(Ma)" },
      { id: 526721, name: "Kathora" },
      { id: 526682, name: "Kazipura" },
      { id: 526711, name: "Khachane" },
      { id: 526716, name: "Khadgaon" },
      { id: 526736, name: "Khandane" },
      { id: 526668, name: "Kharad" },
      { id: 526731, name: "Khardi" },
      { id: 526654, name: "Kharya Padav" },
      { id: 526725, name: "Khedi Bk." },
      { id: 526719, name: "Kolamba" },
      { id: 526643, name: "Krishnapur (Angurne)" },
      { id: 526713, name: "Kurvel" },
      { id: 526653, name: "Kusumba" },
      { id: 526639, name: "Lasur" },
      { id: 526730, name: "Loni" },
      { id: 526673, name: "Machale" },
      { id: 526646, name: "Majare Hingone" },
      { id: 526686, name: "Majre Hol" },
      { id: 526663, name: "Malapur" },
      { id: 526696, name: "Malkheda" },
      { id: 526642, name: "Mamlade" },
      { id: 526675, name: "Mangrul" },
      { id: 526645, name: "Mauje Hingone" },
      { id: 526659, name: "Melane" },
      { id: 526749, name: "Mitawali" },
      { id: 526738, name: "Moharad" },
      { id: 526689, name: "Mohide" },
      { id: 526633, name: "Morchida" },
      { id: 526656, name: "Mulyavtar" },
      { id: 526677, name: "Nagalwadi" },
      { id: 526669, name: "Narod" },
      { id: 526681, name: "Narwade" },
      { id: 526710, name: "Nimgavhan" },
      { id: 944936, name: "Panchak" },
      { id: 526743, name: "Pargaon" },
      { id: 526748, name: "Pimpri" },
      { id: 526750, name: "Pungaon" },
      { id: 526745, name: "Rukhankheda Pr.A." },
      { id: 526672, name: "Rukhankheda Pr.Cho." },
      { id: 526720, name: "Sanpule" },
      { id: 526636, name: "Satrasen" },
      { id: 526694, name: "Shendani" },
      { id: 526657, name: "Shenpani" },
      { id: 526638, name: "Shikawal" },
      { id: 526726, name: "Sutkar" },
      { id: 526709, name: "Tandalwadi" },
      { id: 526712, name: "Tawase Bk." },
      { id: 526674, name: "Tawase Kh." },
      { id: 526635, name: "Umarti" },
      { id: 526666, name: "Vadati" },
      { id: 526728, name: "Vadgaon Bk." },
      { id: 526722, name: "Vadgaon Kh." },
      { id: 526718, name: "Vadgaon Sim" },
      { id: 526692, name: "Vadhoda" },
      { id: 526655, name: "Vaijapur" },
      { id: 526676, name: "Varad" },
      { id: 526671, name: "Vardi" },
      { id: 526739, name: "Vargavhan" },
      { id: 526727, name: "Vatar" },
      { id: 526684, name: "Vele" },
      { id: 526704, name: "Vichakhede" },
      { id: 526664, name: "Virwade" },
      { id: 526665, name: "Vishnapur" },
      { id: 526693, name: "Vitner" },
      { id: 526695, name: "Walaki" },
      { id: 526651, name: "Welode" },
    ],
    3961: [
      { id: 526761, name: "Adgaon" },
      { id: 526829, name: "Aklud" },
      { id: 526838, name: "Amode" },
      { id: 526814, name: "Anjale" },
      { id: 526799, name: "Atrawal" },
      { id: 526822, name: "Bamnod" },
      { id: 526821, name: "Bhalod" },
      { id: 526802, name: "Bhalshiv" },
      { id: 526828, name: "Bhortek" },
      { id: 526783, name: "Borale" },
      { id: 526811, name: "Borawal Bk" },
      { id: 526803, name: "Borawal Kh" },
      { id: 526835, name: "Borkhede Bk" },
      { id: 526819, name: "Borkhede Kh" },
      { id: 526807, name: "Chikhali Bk" },
      { id: 526806, name: "Chikhali Kh" },
      { id: 526767, name: "Chincholi" },
      { id: 526798, name: "Chitode" },
      { id: 526784, name: "Chunchale" },
      { id: 526790, name: "Dagadi" },
      { id: 526779, name: "Dahigaon" },
      { id: 526771, name: "Dambhurni" },
      { id: 526769, name: "Dongaon" },
      { id: 526818, name: "Dongar Kathora" },
      { id: 526832, name: "Duskheda" },
      { id: 526839, name: "Faizpur" },
      { id: 526754, name: "Gadrya" },
      { id: 526770, name: "Giradgaon" },
      { id: 526837, name: "Hambardi" },
      { id: 526776, name: "Haripura" },
      { id: 526833, name: "Hingone" },
      { id: 526760, name: "Ichkheda" },
      { id: 526755, name: "Jamnya" },
      { id: 526825, name: "Karanji" },
      { id: 526762, name: "Kasarkheda" },
      { id: 526831, name: "Kasve" },
      { id: 526830, name: "Kathora Pr. Savada" },
      { id: 526765, name: "Kingaon Bk" },
      { id: 526766, name: "Kingaon Kh" },
      { id: 526796, name: "Kolwad" },
      { id: 526780, name: "Korpawli" },
      { id: 526827, name: "Kosgaon" },
      { id: 526781, name: "Mahelkhedi" },
      { id: 526763, name: "Malod" },
      { id: 526791, name: "Manwel" },
      { id: 526834, name: "Marul" },
      { id: 526808, name: "Mhaiswadi" },
      { id: 526777, name: "Mohrale" },
      { id: 526764, name: "Naigaon" },
      { id: 526782, name: "Navare" },
      { id: 526836, name: "Nhavi Pr. Ya." },
      { id: 526772, name: "Nhavi.Pr. Adawad" },
      { id: 526810, name: "Nimgaon" },
      { id: 526823, name: "Padalse" },
      { id: 526795, name: "Parsade Bk" },
      { id: 526774, name: "Pathrale" },
      { id: 526815, name: "Pilode Bk" },
      { id: 526792, name: "Pilode Kh" },
      { id: 526801, name: "Pimpri" },
      { id: 526840, name: "Pimprud" },
      { id: 526809, name: "Rajore" },
      { id: 526826, name: "Ridhuri" },
      { id: 526786, name: "Sakali" },
      { id: 526820, name: "Sangvi Bk" },
      { id: 526805, name: "Sangvi Kh" },
      { id: 526797, name: "Satod" },
      { id: 526778, name: "Savkhede Sim" },
      { id: 526773, name: "Shiragad" },
      { id: 526789, name: "Shirsad" },
      { id: 526812, name: "Takarkheda" },
      { id: 526804, name: "Tembhi Kh" },
      { id: 526793, name: "Thorgavhan" },
      { id: 526768, name: "Untawad" },
      { id: 526753, name: "Usmali" },
      { id: 526787, name: "Vadhode Pr Ya." },
      { id: 526842, name: "Vadhode Pr. Sa." },
      { id: 526794, name: "Vadri Kh" },
      { id: 526756, name: "Vaghazira" },
      { id: 526824, name: "Vanoli" },
      { id: 526788, name: "Viravali Bk" },
      { id: 526841, name: "Viroda" },
      { id: 526813, name: "Waghlud" },
      { id: 526785, name: "Waghode" },
      { id: 526800, name: "Yawal" },
    ],
    3962: [
      { id: 526857, name: "Aabhoda Bk." },
      { id: 526858, name: "Aabhoda Kh." },
      { id: 526875, name: "Ahirwadi" },
      { id: 526942, name: "Ainpur" },
      { id: 526882, name: "Ajanad" },
      { id: 526869, name: "Ajande" },
      { id: 526920, name: "Andalwadi" },
      { id: 526851, name: "Andharmali" },
      { id: 526890, name: "Atwade" },
      { id: 526953, name: "Balwadi" },
      { id: 526952, name: "Bhamalwadi" },
      { id: 526865, name: "Bhatkhede" },
      { id: 526885, name: "Bhokari" },
      { id: 526867, name: "Bhor" },
      { id: 526895, name: "Boharde" },
      { id: 526887, name: "Borkhede" },
      { id: 526915, name: "Borkhede Sim" },
      { id: 526909, name: "Chinawal" },
      { id: 526900, name: "Chinchati" },
      { id: 526881, name: "Chorwad" },
      { id: 526929, name: "Chunwade" },
      { id: 526918, name: "Dasanur" },
      { id: 526947, name: "Dhamodi" },
      { id: 526897, name: "Dhurkhede" },
      { id: 526891, name: "Dodhe" },
      { id: 526933, name: "Gahukhede" },
      { id: 526852, name: "Garbardi" },
      { id: 526849, name: "Garkhede" },
      { id: 526927, name: "Gate" },
      { id: 526902, name: "Gaulkheda" },
      { id: 526958, name: "Golwade" },
      { id: 526845, name: "Gulabwadi" },
      { id: 944349, name: "Hol" },
      { id: 526899, name: "Janori" },
      { id: 526847, name: "Jinsi" },
      { id: 526876, name: "Junone" },
      { id: 526907, name: "Kalmode" },
      { id: 526950, name: "Kandwel" },
      { id: 526879, name: "Karjod" },
      { id: 526878, name: "Kerhale Bk." },
      { id: 526877, name: "Kerhale Kh." },
      { id: 526880, name: "Khanapur" },
      { id: 526945, name: "Khirdi Bk." },
      { id: 526944, name: "Khirdi Kh." },
      { id: 526906, name: "Khirode Pr. Yawal" },
      { id: 526860, name: "Khirode Pr.Raver" },
      { id: 526893, name: "Khirwad" },
      { id: 526916, name: "Kochur Bk." },
      { id: 526914, name: "Kochur Kh." },
      { id: 526949, name: "Kolode" },
      { id: 526903, name: "Kumbharkhede" },
      { id: 526863, name: "Kusumbe Bk." },
      { id: 526862, name: "Kusumbe Kh." },
      { id: 526856, name: "Lalmati" },
      { id: 526901, name: "Lohare" },
      { id: 526938, name: "Lumkheda" },
      { id: 526956, name: "Mangalwadi" },
      { id: 526930, name: "Mangi" },
      { id: 526959, name: "Manglur" },
      { id: 526925, name: "Maskawad Bk." },
      { id: 526921, name: "Maskawad Kh." },
      { id: 526922, name: "Maskawad Sim" },
      { id: 526871, name: "Mohagan Bk." },
      { id: 526853, name: "Mohamandali (New)" },
      { id: 526855, name: "Mohamandali (Old)" },
      { id: 526883, name: "Morgaon" },
      { id: 526889, name: "Morgaon Kh." },
      { id: 526846, name: "Morwhal" },
      { id: 526861, name: "Munjalwadi" },
      { id: 526868, name: "Nandurkhede" },
      { id: 526892, name: "Nehete" },
      { id: 526913, name: "Nimbhora Bk." },
      { id: 526898, name: "Nimbhore Sim" },
      { id: 526939, name: "Nimbol" },
      { id: 526850, name: "Nimdya" },
      { id: 526874, name: "Nirul" },
      { id: 526873, name: "Padale Bk." },
      { id: 526872, name: "Padale Kh" },
      { id: 526844, name: "Pal" },
      { id: 526894, name: "Patondi" },
      { id: 526870, name: "Pimpri" },
      { id: 526888, name: "Punkhede" },
      { id: 526957, name: "Puri" },
      { id: 526932, name: "Raipur" },
      { id: 526934, name: "Rangaon" },
      { id: 526859, name: "Rasalpur" },
      { id: 526866, name: "Raver" },
      { id: 526943, name: "Rembhote" },
      { id: 526908, name: "Rojhoda" },
      { id: 526848, name: "Sahastraling" },
      { id: 526940, name: "Sangve" },
      { id: 526923, name: "Savda" },
      { id: 526905, name: "Savkhede Bk." },
      { id: 526904, name: "Savkhede Kh." },
      { id: 526951, name: "Shingadi" },
      { id: 526919, name: "Singanur" },
      { id: 526954, name: "Singat" },
      { id: 526931, name: "Sudgaon" },
      { id: 526948, name: "Sulwadi" },
      { id: 526926, name: "Sunode" },
      { id: 526886, name: "Tamaswadi" },
      { id: 526955, name: "Tandalwadi" },
      { id: 526935, name: "Taskhede" },
      { id: 526896, name: "Therole" },
      { id: 526928, name: "Thorgavhan" },
      { id: 526854, name: "Tidya" },
      { id: 526937, name: "Udali Budruk" },
      { id: 526936, name: "Udhali Kh" },
      { id: 526864, name: "Utkhede" },
      { id: 526941, name: "Vitwe" },
      { id: 526912, name: "Vivare Bk." },
      { id: 526911, name: "Vivare Kh" },
      { id: 526910, name: "Wadgaon" },
      { id: 526946, name: "Waghadi" },
      { id: 526884, name: "Waghod" },
      { id: 526917, name: "Waghode Bk." },
      { id: 526924, name: "Waghode Kh" },
    ],
    3963: [
      { id: 526961, name: "Anturli" },
      { id: 526966, name: "Belaswadi" },
      { id: 526965, name: "Belkhede" },
      { id: 527037, name: "Bhandgure" },
      { id: 526963, name: "Bhokari" },
      { id: 527016, name: "Bhote" },
      { id: 527010, name: "Bodwad" },
      { id: 527003, name: "Borkhede" },
      { id: 527024, name: "Changdeo" },
      { id: 526991, name: "Charthane" },
      { id: 527036, name: "Chikhali" },
      { id: 527006, name: "Chinchkhede Bk." },
      { id: 527014, name: "Chinchkhede Kh" },
      { id: 527022, name: "Chinchol" },
      { id: 526974, name: "Dhabe" },
      { id: 526964, name: "Dhamande" },
      { id: 527004, name: "Dhamangaon" },
      { id: 527039, name: "Dhormal" },
      { id: 527000, name: "Dhule" },
      { id: 526987, name: "Dolarkhede" },
      { id: 526984, name: "Dui" },
      { id: 527030, name: "Ghodasgaon" },
      { id: 526998, name: "Halkhede" },
      { id: 527034, name: "Hartale" },
      { id: 527002, name: "Hivare" },
      { id: 527009, name: "Ichhapur" },
      { id: 526996, name: "Jondhan Khede" },
      { id: 527011, name: "Kakode" },
      { id: 526970, name: "Karkee" },
      { id: 527025, name: "Kasarkhede" },
      { id: 526983, name: "Khamkhede" },
      { id: 527020, name: "Korhale" },
      { id: 527027, name: "Kothali" },
      { id: 526969, name: "Kothe" },
      { id: 527029, name: "Kund" },
      { id: 527017, name: "Kurhe" },
      { id: 526971, name: "Loharkhede" },
      { id: 526992, name: "Madhapuri" },
      { id: 527007, name: "Mahalkhede" },
      { id: 527042, name: "Malegaon" },
      { id: 527026, name: "Manegaon" },
      { id: 527043, name: "Manyarkhede" },
      { id: 527023, name: "Mehun" },
      { id: 526981, name: "Mel Sangave" },
      { id: 526975, name: "Mendhode" },
      { id: 526979, name: "Mondhalde" },
      { id: 526993, name: "Morzira" },
      { id: 527028, name: "Muktainagar" },
      { id: 526968, name: "Naigaon" },
      { id: 526989, name: "Nandwel" },
      { id: 526962, name: "Narvel" },
      { id: 527008, name: "Nimkhedi Bk." },
      { id: 527040, name: "Nimkhedi Kh" },
      { id: 526980, name: "Panchane" },
      { id: 527012, name: "Parambi" },
      { id: 526960, name: "Patondi" },
      { id: 527031, name: "Pimpri Akaraut" },
      { id: 526972, name: "Pimpri Bhojana" },
      { id: 526967, name: "Pimpri Nandu" },
      { id: 526976, name: "Pipripancham" },
      { id: 527019, name: "Primpale" },
      { id: 526977, name: "Purnad" },
      { id: 526995, name: "Rajure" },
      { id: 526973, name: "Ramgad" },
      { id: 527021, name: "Rigaon" },
      { id: 527044, name: "Ruikhede" },
      { id: 527032, name: "Salbardi" },
      { id: 527041, name: "Sarola" },
      { id: 527035, name: "Satod" },
      { id: 526978, name: "Shemalde" },
      { id: 526985, name: "Sukali" },
      { id: 527015, name: "Sule" },
      { id: 527005, name: "Takali" },
      { id: 527013, name: "Talkhede" },
      { id: 527038, name: "Tarode" },
      { id: 527018, name: "Therole" },
      { id: 526982, name: "Uchande" },
      { id: 527001, name: "Umare" },
      { id: 527033, name: "Vadhave" },
      { id: 526990, name: "Vayala" },
      { id: 526999, name: "Wadhode" },
    ],
    3964: [
      { id: 527062, name: "Amadgaon" },
      { id: 527052, name: "Bhankhede Pr.Bo" },
      { id: 527082, name: "Bodwad" },
      { id: 527056, name: "Borgaon" },
      { id: 527077, name: "Chikhali Bk." },
      { id: 527078, name: "Chinchakhede Pr. Bo" },
      { id: 527065, name: "Chinchkhede Seem" },
      { id: 527046, name: "Dhanori" },
      { id: 527093, name: "Dhodkheda" },
      { id: 527061, name: "Farkande" },
      { id: 527097, name: "Ghankhed" },
      { id: 527048, name: "Golegaon Bk" },
      { id: 527047, name: "Golegaon Kh" },
      { id: 527096, name: "Harankhed" },
      { id: 527063, name: "Hingane" },
      { id: 527081, name: "Jalchakra Bk." },
      { id: 527083, name: "Jalchakra Kh." },
      { id: 527091, name: "Jamathi" },
      { id: 527050, name: "Junone" },
      { id: 527051, name: "Karanji" },
      { id: 527066, name: "Kolhadi" },
      { id: 527090, name: "Kurhe Hardo" },
      { id: 527092, name: "Lonwadi" },
      { id: 527054, name: "Manmodi" },
      { id: 527088, name: "Manur Bk." },
      { id: 527089, name: "Manur Kh." },
      { id: 527057, name: "Muktal" },
      { id: 527068, name: "Nadgaon" },
      { id: 527069, name: "Nandgaon" },
      { id: 527072, name: "Nimkhed" },
      { id: 527049, name: "Pachadevali" },
      { id: 527060, name: "Palaskhede Bk." },
      { id: 527070, name: "Palaskhede Kh." },
      { id: 527075, name: "Rajur" },
      { id: 527086, name: "Revati" },
      { id: 527080, name: "Salshingi" },
      { id: 527085, name: "Shelwad" },
      { id: 527076, name: "Shevage Bk." },
      { id: 527094, name: "Shevage Kh." },
      { id: 527064, name: "Shirsale" },
      { id: 527067, name: "Sonoti" },
      { id: 527053, name: "Surwade Bk." },
      { id: 527055, name: "Surwade Kh." },
      { id: 527095, name: "Vadji" },
      { id: 527084, name: "Vaki" },
      { id: 527059, name: "Varad Bk." },
      { id: 527058, name: "Varad Kh." },
      { id: 527074, name: "Varkhed Bk." },
      { id: 527071, name: "Varkhed Kh." },
      { id: 527045, name: "Vichave" },
      { id: 527073, name: "Yengaon" },
      { id: 527087, name: "Yevati" },
    ],
    3965: [
      { id: 527145, name: "Achegaon" },
      { id: 527128, name: "Anjansonde" },
      { id: 527147, name: "Belkhede" },
      { id: 527112, name: "Belvhal" },
      { id: 527098, name: "Bhankhede Pr. Edlabad" },
      { id: 527116, name: "Bhilmali" },
      { id: 527118, name: "Bhusawal" },
      { id: 527136, name: "Bohardi Bk" },
      { id: 527135, name: "Bohardi Kh" },
      { id: 527108, name: "Chorwad" },
      { id: 527133, name: "Daryapur" },
      { id: 527119, name: "Fekari" },
      { id: 527129, name: "Fulgaon" },
      { id: 527109, name: "Gojore" },
      { id: 527110, name: "Gombhi" },
      { id: 527125, name: "Hatnur" },
      { id: 527130, name: "Jadgaon" },
      { id: 527099, name: "Jogalkhede" },
      { id: 527115, name: "Jogalkhori" },
      { id: 527134, name: "Kahurkhede" },
      { id: 527149, name: "Kandari" },
      { id: 527104, name: "Kanhale Bk." },
      { id: 527107, name: "Kanhale Kh." },
      { id: 527121, name: "Kathore Bk." },
      { id: 527122, name: "Kathore Kh." },
      { id: 527105, name: "Khadake" },
      { id: 527140, name: "Khandale" },
      { id: 527103, name: "Khedi Bk." },
      { id: 527139, name: "Kinhi" },
      { id: 527114, name: "Kurhe Pr. Nashirabad" },
      { id: 527117, name: "Mandavedigar" },
      { id: 527127, name: "Manpur" },
      { id: 527131, name: "Manyarkhede" },
      { id: 527102, name: "Mirgavhan" },
      { id: 527141, name: "Mondhale" },
      { id: 527148, name: "Nimbhore Budruk" },
      { id: 527123, name: "Nimbhore Kh." },
      { id: 527138, name: "Ojharkhede" },
      { id: 527146, name: "Pimpalgaon Bk." },
      { id: 527144, name: "Pimpalgaon Kh." },
      { id: 527120, name: "Pimprisekam." },
      { id: 527106, name: "Sakari" },
      { id: 527100, name: "Sakegaon" },
      { id: 943289, name: "Satare" },
      { id: 527124, name: "Savtar" },
      { id: 527142, name: "Shindi" },
      { id: 527111, name: "Sunasgaon" },
      { id: 527143, name: "Susari" },
      { id: 527126, name: "Tahakali" },
      { id: 527137, name: "Talwel" },
      { id: 527101, name: "Vanjole" },
      { id: 527113, name: "Varad Seem" },
      { id: 527150, name: "Varangaon" },
      { id: 527132, name: "Velhale" },
    ],
    3966: [
      { id: 527154, name: "Amode Bk." },
      { id: 527170, name: "Amode Kh" },
      { id: 527192, name: "Asoda" },
      { id: 527191, name: "Avhane" },
      { id: 527174, name: "Awar" },
      { id: 527201, name: "Beli" },
      { id: 527187, name: "Bhadli Bk" },
      { id: 527157, name: "Bhadli Kh" },
      { id: 527203, name: "Bhagpur" },
      { id: 527151, name: "Bhokar" },
      { id: 527183, name: "Bholane" },
      { id: 527225, name: "Bilkhede" },
      { id: 527226, name: "Bilwadi" },
      { id: 527228, name: "Bornar" },
      { id: 527204, name: "Chincholi" },
      { id: 527216, name: "Dapore" },
      { id: 527156, name: "Deogoan" },
      { id: 527182, name: "Deulwade" },
      { id: 527208, name: "Devhari" },
      { id: 527176, name: "Dhamangaon" },
      { id: 527211, name: "Dhanore Bk." },
      { id: 527166, name: "Dhanore Kh" },
      { id: 527206, name: "Dhanwad" },
      { id: 527172, name: "Diksai" },
      { id: 527230, name: "Domgaon" },
      { id: 527164, name: "Fesardi" },
      { id: 527179, name: "Fupanagari" },
      { id: 527155, name: "Gadhode" },
      { id: 527167, name: "Ghardi" },
      { id: 527196, name: "Jalgaon Kh." },
      { id: 943257, name: "Jalgaon Shahar" },
      { id: 527224, name: "Jalke" },
      { id: 527153, name: "Jamod" },
      { id: 527232, name: "Jawkhede" },
      { id: 527186, name: "Kadgaon" },
      { id: 527178, name: "Kanalda" },
      { id: 527184, name: "Kanaswade" },
      { id: 527209, name: "Kandari" },
      { id: 527163, name: "Karanj" },
      { id: 527159, name: "Kathora" },
      { id: 527177, name: "Khaparkhede" },
      { id: 943258, name: "Khedi Bk." },
      { id: 527190, name: "Khedi Kh" },
      { id: 527195, name: "Khirdi" },
      { id: 527160, name: "Kinod" },
      { id: 527218, name: "Kurhadade" },
      { id: 527200, name: "Kusumbe Kh" },
      { id: 527169, name: "Kuwarkhede" },
      { id: 527217, name: "Lamanjan" },
      { id: 527237, name: "Lonwadi Bk" },
      { id: 527236, name: "Lonwadi Kh" },
      { id: 527188, name: "Mamurabad" },
      { id: 527199, name: "Manyarkheda" },
      { id: 943264, name: "Mehrun" },
      { id: 527227, name: "Mhasawad" },
      { id: 527213, name: "Mohadi" },
      { id: 527212, name: "Nagziri" },
      { id: 527161, name: "Nandgaon" },
      { id: 527168, name: "Nandre Bk" },
      { id: 527180, name: "Nandre Kh" },
      { id: 527197, name: "Nashirabad" },
      { id: 527202, name: "Nimgaon Bk" },
      { id: 943259, name: "Nimkhedi" },
      { id: 527152, name: "Palsod" },
      { id: 527229, name: "Pathari" },
      { id: 527158, name: "Phupani" },
      { id: 527165, name: "Pilkhede" },
      { id: 527205, name: "Pimpale" },
      { id: 943260, name: "Pimprala" },
      { id: 527210, name: "Raipur" },
      { id: 527221, name: "Ramdeowadi" },
      { id: 527171, name: "Ridhur" },
      { id: 527193, name: "Savkheda Bk." },
      { id: 527162, name: "Savkheda Kh." },
      { id: 527185, name: "Shelgaon" },
      { id: 527214, name: "Shirsoli P.B." },
      { id: 527215, name: "Shirsoli P.N." },
      { id: 527235, name: "Subhashwadi" },
      { id: 527181, name: "Sujde" },
      { id: 527198, name: "Tarsod" },
      { id: 527194, name: "Tighre" },
      { id: 527175, name: "Turkheda" },
      { id: 527207, name: "Umale" },
      { id: 527231, name: "Vadali" },
      { id: 527189, name: "Vadnagari" },
      { id: 527233, name: "Varad Bk." },
      { id: 527234, name: "Varad Kh." },
      { id: 527222, name: "Vasantwadi" },
      { id: 944865, name: "Vavadade" },
      { id: 527173, name: "Vidgaon" },
      { id: 527223, name: "Vitner" },
      { id: 527219, name: "Wakadi" },
    ],
    3967: [
      { id: 527300, name: "Adgaon" },
      { id: 527298, name: "Ambe" },
      { id: 527293, name: "Anandnagar" },
      { id: 527290, name: "Anturli" },
      { id: 527284, name: "Bambhori Kh." },
      { id: 527297, name: "Bamhne" },
      { id: 527248, name: "Bhalgaon Bk." },
      { id: 527275, name: "Bhatkhede" },
      { id: 527245, name: "Chortakki" },
      { id: 527265, name: "Dapori" },
      { id: 527251, name: "Dharagir" },
      { id: 943292, name: "Erandol" },
      { id: 527285, name: "Farkande" },
      { id: 527292, name: "Galapur" },
      { id: 527252, name: "Ganeshnagar" },
      { id: 527277, name: "Hanmantkhade Majre" },
      { id: 527276, name: "Hanmantkhede Bk." },
      { id: 527296, name: "Hanmantkhede Sim" },
      { id: 527281, name: "Jalu" },
      { id: 527286, name: "Janfal" },
      { id: 527240, name: "Javkhede Bk." },
      { id: 527239, name: "Javkhede Kh." },
      { id: 527291, name: "Javkhede Sim" },
      { id: 527259, name: "Kadholi" },
      { id: 527289, name: "Kasoda" },
      { id: 527268, name: "Khadke Bk." },
      { id: 527253, name: "Khadke Kh." },
      { id: 527254, name: "Khadke Sim" },
      { id: 527262, name: "Kharchi Bk." },
      { id: 527267, name: "Kharchi Kh." },
      { id: 527279, name: "Khedgaon" },
      { id: 527264, name: "Khedi Kh." },
      { id: 527287, name: "Malkhede Bk." },
      { id: 527271, name: "Mukhpat" },
      { id: 527272, name: "Nagduli" },
      { id: 527247, name: "Nandgaon Bk." },
      { id: 527282, name: "Nandkhurde Bk." },
      { id: 527283, name: "Nandkhurde Kh." },
      { id: 527294, name: "Nipane" },
      { id: 527250, name: "Palasdal" },
      { id: 527249, name: "Patarkhede" },
      { id: 527243, name: "Pimpalkhotha Bk." },
      { id: 527244, name: "Pimpalkothe Kh." },
      { id: 527260, name: "Pimpalkothe Pr. Chandsar" },
      { id: 527242, name: "Pimpri Bk." },
      { id: 527274, name: "Pimpri Sim" },
      { id: 527241, name: "Pimpri-Pr-Chandsar" },
      { id: 527266, name: "Ravanje Bk." },
      { id: 527263, name: "Ravanje Kh." },
      { id: 527261, name: "Ringangaon" },
      { id: 527256, name: "Sawade Pr. Chandsar" },
      { id: 527278, name: "Sonbardi" },
      { id: 527295, name: "Tade" },
      { id: 527257, name: "Takarkhede" },
      { id: 527299, name: "Talai" },
      { id: 527238, name: "Toli Kh." },
      { id: 527270, name: "Umarde" },
      { id: 527288, name: "Umare" },
      { id: 527301, name: "Utran Ahir Hadd" },
      { id: 527302, name: "Utran Gujar Hadd" },
      { id: 527258, name: "Vaijanath" },
      { id: 527280, name: "Vankothe" },
      { id: 527269, name: "Varkhedi" },
      { id: 527246, name: "Vikharan" },
      { id: 527273, name: "Waghlud Sim" },
    ],
    3968: [
      { id: 527326, name: "Ahire Bk." },
      { id: 527327, name: "Ahire Kh." },
      { id: 527323, name: "Anjan Vihire" },
      { id: 527386, name: "Anore" },
      { id: 527346, name: "Avhani" },
      { id: 527383, name: "Babhale Bk." },
      { id: 527318, name: "Babhulgaon" },
      { id: 527387, name: "Bambhori Bk." },
      { id: 527354, name: "Bambhori Pra.Cha" },
      { id: 527306, name: "Bhamardi" },
      { id: 527390, name: "Bhavarkhede" },
      { id: 527370, name: "Bhod Bk." },
      { id: 527369, name: "Bhod Kh." },
      { id: 527347, name: "Bhokani" },
      { id: 527376, name: "Bhone Bk." },
      { id: 527377, name: "Bilkhede" },
      { id: 527388, name: "Borgaon Bk." },
      { id: 527391, name: "Borgaon Kh." },
      { id: 527361, name: "Borkhede" },
      { id: 527319, name: "Chamgaon" },
      { id: 527339, name: "Chandsar Bk." },
      { id: 527368, name: "Chavalkhede" },
      { id: 527366, name: "Chinchpure Bk." },
      { id: 527337, name: "Chorgaon" },
      { id: 527320, name: "Dahidule" },
      { id: 527385, name: "Dhanore" },
      { id: 527342, name: "Dhar" },
      { id: 527381, name: "Dharangaon" },
      { id: 945547, name: "Doc. Hedgevarnagar" },
      { id: 527344, name: "Dongaon Bk." },
      { id: 527345, name: "Dongaon Kh." },
      { id: 527352, name: "Eklagna Bk." },
      { id: 527349, name: "Fulpat" },
      { id: 527384, name: "Gangapuri Bk." },
      { id: 527382, name: "Garkhede" },
      { id: 527310, name: "Gondegaon" },
      { id: 527336, name: "Hanmantkhede Kh." },
      { id: 527375, name: "Hingone Bk." },
      { id: 527374, name: "Hingone Kh." },
      { id: 527380, name: "Jambhore" },
      { id: 527372, name: "Kalyane Bk." },
      { id: 527373, name: "Kalyane Hol" },
      { id: 527371, name: "Kalyane Kh." },
      { id: 527316, name: "Kandari Bk." },
      { id: 527338, name: "Kavthal" },
      { id: 527322, name: "Khamkhede" },
      { id: 527359, name: "Khapat" },
      { id: 527305, name: "Kharde Bk." },
      { id: 527340, name: "Ladli" },
      { id: 527317, name: "Mahankale" },
      { id: 527362, name: "Musai Bk." },
      { id: 527365, name: "Musai Kh." },
      { id: 527303, name: "Nanded" },
      { id: 527304, name: "Narne" },
      { id: 527321, name: "Nimbhore" },
      { id: 527334, name: "Nimkhede" },
      { id: 527313, name: "Nishane Bk." },
      { id: 527312, name: "Nishane Kh." },
      { id: 527355, name: "Paldhi Bk." },
      { id: 527353, name: "Paldhi Kh." },
      { id: 527329, name: "Pashtane Bk." },
      { id: 527328, name: "Pashtane Kh." },
      { id: 527350, name: "Patharad Bk." },
      { id: 527351, name: "Patharad Kh." },
      { id: 527315, name: "Pimpale Bk." },
      { id: 527314, name: "Pimpale Kh." },
      { id: 527335, name: "Pimpale Sim" },
      { id: 527367, name: "Pimpri Kh." },
      { id: 527356, name: "Pokhari" },
      { id: 527341, name: "Rel" },
      { id: 527309, name: "Rotwad" },
      { id: 527311, name: "Sakre" },
      { id: 527308, name: "Salve" },
      { id: 527379, name: "Sarve Kh." },
      { id: 527332, name: "Satkhede" },
      { id: 527378, name: "Shamkhede" },
      { id: 527343, name: "Sheri" },
      { id: 527325, name: "Sonwad Bk." },
      { id: 527331, name: "Sonwad Kh." },
      { id: 527348, name: "Tahakali" },
      { id: 527330, name: "Tarde Kh." },
      { id: 527307, name: "Ukhalwadi" },
      { id: 527360, name: "Vanjari Bk." },
      { id: 527363, name: "Varad Bk." },
      { id: 527364, name: "Varad Kh." },
      { id: 527389, name: "Vivare" },
      { id: 527358, name: "Waghlud Bk." },
      { id: 527357, name: "Waghlud Kh." },
      { id: 527324, name: "Waktuki" },
      { id: 527333, name: "Zurkheda" },
    ],
    3969: [
      { id: 527425, name: "Amalgaon" },
      { id: 527504, name: "Amalner" },
      { id: 527489, name: "Ambare" },
      { id: 527498, name: "Ambasan" },
      { id: 527456, name: "Amode" },
      { id: 527530, name: "Anchalwadi" },
      { id: 527526, name: "Anore" },
      { id: 527491, name: "Anturli" },
      { id: 527527, name: "Ardi" },
      { id: 527528, name: "Atale" },
      { id: 527482, name: "Bahadarwadi" },
      { id: 527407, name: "Bamhane" },
      { id: 527507, name: "Bharvas" },
      { id: 527406, name: "Bhilali" },
      { id: 527511, name: "Bhortek" },
      { id: 527537, name: "Bilkhede" },
      { id: 527505, name: "Bodarde" },
      { id: 527401, name: "Bohare" },
      { id: 527417, name: "Borgaon" },
      { id: 527484, name: "Chakave" },
      { id: 527510, name: "Chaubari" },
      { id: 527500, name: "Chimanpuri" },
      { id: 527544, name: "Chopdai" },
      { id: 527448, name: "Dahiwad Bk" },
      { id: 527450, name: "Dahiwad Kh." },
      { id: 527543, name: "Dangar Bk." },
      { id: 527443, name: "Dapori Bk." },
      { id: 527446, name: "Dapori Kh" },
      { id: 527454, name: "Daregaon" },
      { id: 527464, name: "Devali" },
      { id: 527465, name: "Devgav" },
      { id: 527512, name: "Dhanore" },
      { id: 527494, name: "Dhar" },
      { id: 527393, name: "Dhavade" },
      { id: 527477, name: "Dheku Bk." },
      { id: 527523, name: "Dheku Charam" },
      { id: 527476, name: "Dheku Kh." },
      { id: 527497, name: "Dheku Sim" },
      { id: 527437, name: "Dhupi" },
      { id: 527394, name: "Dhurkheda" },
      { id: 527421, name: "Dodhawad" },
      { id: 527409, name: "Eklahare" },
      { id: 527478, name: "Ekrukhi" },
      { id: 527410, name: "Ektas" },
      { id: 527539, name: "Fapore Bk." },
      { id: 944933, name: "Fapore Bk.(Van)" },
      { id: 527538, name: "Fapore Kh." },
      { id: 527460, name: "Gadkhamb" },
      { id: 527495, name: "Galwade Bk." },
      { id: 527496, name: "Galwade Kh." },
      { id: 527435, name: "Gandhali" },
      { id: 527438, name: "Gangapuri" },
      { id: 527415, name: "Govardhan" },
      { id: 527473, name: "Hedave" },
      { id: 527434, name: "Hingone Bk." },
      { id: 527536, name: "Hingone Kh Pr. A" },
      { id: 527420, name: "Hingone Kh.Pr.Jalod" },
      { id: 527422, name: "Hingone Sim Pra.Jalod" },
      { id: 527541, name: "Indrapimpri" },
      { id: 527513, name: "Jaitpir" },
      { id: 527423, name: "Jalod" },
      { id: 527542, name: "Janave" },
      { id: 527524, name: "Javakhede" },
      { id: 527469, name: "Junone" },
      { id: 527461, name: "Kachare" },
      { id: 527419, name: "Kalali" },
      { id: 527408, name: "Kalambe" },
      { id: 527403, name: "Kalamsare" },
      { id: 527395, name: "Kamatwadi" },
      { id: 527397, name: "Kandari Kh." },
      { id: 527485, name: "Kanhere" },
      { id: 527488, name: "Karan Khede" },
      { id: 527540, name: "Kavpimpri" },
      { id: 527501, name: "Khadke" },
      { id: 527490, name: "Khaparkheda Pr.Dangri" },
      { id: 527439, name: "Khaparkheda Pr.Jalod" },
      { id: 527412, name: "Kharde" },
      { id: 527428, name: "Khaushi Bk." },
      { id: 527414, name: "Khedi Bk. Pr. Dangri" },
      { id: 527453, name: "Khedi Kh.Pr. Amalner" },
      { id: 527426, name: "Khedi Kh.Pr.Ja." },
      { id: 527427, name: "Khedi Sim Pr. J." },
      { id: 527483, name: "Khokarpat" },
      { id: 527545, name: "Kodaval" },
      { id: 527466, name: "Kurhe Bk." },
      { id: 527452, name: "Kurhe Kh." },
      { id: 527467, name: "Kurhe Sim" },
      { id: 527457, name: "Ladgaon" },
      { id: 527520, name: "Lon Bk." },
      { id: 527516, name: "Lon Charam" },
      { id: 527515, name: "Lon Kh." },
      { id: 527517, name: "Lon Sim" },
      { id: 527534, name: "Londhave" },
      { id: 527398, name: "Lone" },
      { id: 527508, name: "Lonpancham" },
      { id: 527493, name: "Malpur" },
      { id: 527518, name: "Mandal" },
      { id: 527503, name: "Mangrul" },
      { id: 527459, name: "Manjardi" },
      { id: 527416, name: "Marwad" },
      { id: 527441, name: "Mathagavhan" },
      { id: 527431, name: "Mehargaon" },
      { id: 527396, name: "Mhasale" },
      { id: 527506, name: "Mudi Pr Dangri" },
      { id: 527433, name: "Mudi.Pr.Amalner" },
      { id: 527444, name: "Mungase" },
      { id: 527463, name: "Nagaon Bk." },
      { id: 527462, name: "Nagaon Kh." },
      { id: 527440, name: "Nalkhede" },
      { id: 527458, name: "Nandgaon" },
      { id: 527429, name: "Nandri" },
      { id: 527399, name: "Nimb" },
      { id: 527424, name: "Nimbhore" },
      { id: 527449, name: "Nimzari" },
      { id: 527533, name: "Nisardi" },
      { id: 527400, name: "Padalsare." },
      { id: 527411, name: "Padase" },
      { id: 527472, name: "Palasdal" },
      { id: 527445, name: "Patonda" },
      { id: 527436, name: "Pilode" },
      { id: 527499, name: "Pimpale Bk." },
      { id: 527529, name: "Pimpale Kh." },
      { id: 527430, name: "Pimpli Pr.Jalod" },
      { id: 527432, name: "Pingalwade" },
      { id: 527402, name: "Pragane Dangari" },
      { id: 527480, name: "Radhavan" },
      { id: 527479, name: "Rajore" },
      { id: 527470, name: "Rameshwar Bk." },
      { id: 527471, name: "Rameshwar Kh." },
      { id: 527531, name: "Ranaiche Bk." },
      { id: 527532, name: "Ranaiche Kh." },
      { id: 527492, name: "Ranjane" },
      { id: 527442, name: "Rundhati" },
      { id: 527509, name: "Sabgavhan" },
      { id: 527487, name: "Sadawan Bk." },
      { id: 527486, name: "Sadawan Kh." },
      { id: 527475, name: "Sarbete Bk." },
      { id: 527474, name: "Sarbete Kh." },
      { id: 527418, name: "Satri" },
      { id: 527392, name: "Savkheda" },
      { id: 527405, name: "Shahapur" },
      { id: 527521, name: "Shirsale Bk." },
      { id: 527522, name: "Shirsale Kh." },
      { id: 527535, name: "Shirud" },
      { id: 527447, name: "Sonkhedi" },
      { id: 527481, name: "Sundarpatti" },
      { id: 527451, name: "Takarkheda" },
      { id: 527525, name: "Talwade" },
      { id: 527404, name: "Tandali" },
      { id: 527455, name: "Taskheda." },
      { id: 527502, name: "Vaghoda" },
      { id: 527413, name: "Vasare" },
      { id: 527468, name: "Vyavhardal" },
      { id: 527519, name: "Wavade" },
      { id: 527514, name: "Zadi" },
    ],
    3970: [
      { id: 527654, name: "Adgaon" },
      { id: 527553, name: "Ambapimpri" },
      { id: 527596, name: "Babhale Nag" },
      { id: 527557, name: "Bahadarpur" },
      { id: 527605, name: "Bahute" },
      { id: 527659, name: "Bhatpuri" },
      { id: 527567, name: "Bhilali" },
      { id: 527581, name: "Bhokarbari" },
      { id: 527546, name: "Bholane" },
      { id: 527612, name: "Bhondandigar" },
      { id: 527582, name: "Bodarde" },
      { id: 527647, name: "Bole" },
      { id: 527635, name: "Chahutre" },
      { id: 527574, name: "Chikhalod Bk." },
      { id: 527573, name: "Chikhalod Kh." },
      { id: 527614, name: "Chorwad" },
      { id: 527569, name: "Dabapimpri" },
      { id: 527588, name: "Dagadi Pr. Amalner" },
      { id: 527577, name: "Dahigaon" },
      { id: 527561, name: "Dalwel" },
      { id: 527644, name: "Deogaon" },
      { id: 527585, name: "Dhabe" },
      { id: 527648, name: "Dholi" },
      { id: 527636, name: "Dhulpimpri" },
      { id: 527653, name: "Gadgaon" },
      { id: 527643, name: "Hanmant Khede" },
      { id: 527586, name: "Hirapur" },
      { id: 527554, name: "Hiwarkhede Bk." },
      { id: 527563, name: "Hiwarkhede Kh." },
      { id: 527570, name: "Holpimpri" },
      { id: 527549, name: "Indhave" },
      { id: 527592, name: "Itave" },
      { id: 527593, name: "Itner" },
      { id: 527559, name: "Jamde" },
      { id: 527550, name: "Jirali" },
      { id: 527642, name: "Jogal Kheda" },
      { id: 527631, name: "Kamatwadi" },
      { id: 527601, name: "Kanhere" },
      { id: 527555, name: "Kankraj" },
      { id: 527637, name: "Karadi" },
      { id: 527620, name: "Karanji Bk" },
      { id: 527657, name: "Karmad Bk." },
      { id: 527656, name: "Karmad Kh." },
      { id: 527575, name: "Khedi Dhok" },
      { id: 527632, name: "Kholsar" },
      { id: 527568, name: "Kolpimpri" },
      { id: 527603, name: "Loni Bk" },
      { id: 527602, name: "Loni Kh" },
      { id: 527604, name: "Loni Seem" },
      { id: 527556, name: "Mahalpur" },
      { id: 527634, name: "Mangrul" },
      { id: 527629, name: "Mehu" },
      { id: 527623, name: "Mhasve" },
      { id: 527619, name: "Modhale Pr. A." },
      { id: 527578, name: "Mohadi" },
      { id: 527641, name: "Mondhale Pr. U." },
      { id: 527608, name: "Morfal" },
      { id: 527633, name: "Morfali" },
      { id: 527625, name: "Mundane Pr.Amalner" },
      { id: 527652, name: "Mundane Pr.Utran" },
      { id: 527606, name: "Nagaon" },
      { id: 527572, name: "Nerpat" },
      { id: 527590, name: "Palaskhede Bk." },
      { id: 527591, name: "Palaskhede Kh." },
      { id: 527607, name: "Palaskhede Seem" },
      { id: 527622, name: "Parola" },
      { id: 527650, name: "Patar Khede" },
      { id: 527564, name: "Pimpal Bhairao" },
      { id: 527548, name: "Pimpalkothe" },
      { id: 527640, name: "Pimpri Pr.Utran" },
      { id: 527611, name: "Popatnagar" },
      { id: 527565, name: "Pungaon" },
      { id: 527576, name: "Rajawad" },
      { id: 527597, name: "Ramnagar" },
      { id: 527658, name: "Ratale" },
      { id: 527571, name: "Ratnapimpri" },
      { id: 527589, name: "Sab Gavhan Pr. Amalner" },
      { id: 527594, name: "Sangvi" },
      { id: 527595, name: "Sarve Bk" },
      { id: 527598, name: "Savakhede Turk" },
      { id: 527655, name: "Saval Khede" },
      { id: 527600, name: "Savkhede Hol" },
      { id: 527599, name: "Savkhede Marath" },
      { id: 527580, name: "Shelave Bk." },
      { id: 527579, name: "Shelave Kh." },
      { id: 527566, name: "Shevage Bk." },
      { id: 527639, name: "Shevage Pr.Ba." },
      { id: 527615, name: "Shirasmani" },
      { id: 527558, name: "Shirsode" },
      { id: 527660, name: "Shivare Digar" },
      { id: 527626, name: "Soke" },
      { id: 527560, name: "Sub Gavhan Kh" },
      { id: 527616, name: "Sudhakarnagar" },
      { id: 527551, name: "Sumthane" },
      { id: 527651, name: "Tamaswadi" },
      { id: 527587, name: "Tambole" },
      { id: 527645, name: "Tardi" },
      { id: 527661, name: "Tarwade Kh." },
      { id: 527630, name: "Tehu" },
      { id: 527617, name: "Titavi" },
      { id: 527646, name: "Toli" },
      { id: 527627, name: "Udanidigar" },
      { id: 527628, name: "Undanikhalsa" },
      { id: 527624, name: "Undirkhede" },
      { id: 527584, name: "Utrad" },
      { id: 527552, name: "Vadgaon Pr. Amalner" },
      { id: 527613, name: "Vadgaon Pr.Erandol" },
      { id: 527583, name: "Vanjari Kh." },
      { id: 527547, name: "Vasant Nagar" },
      { id: 527638, name: "Vasant Wadi" },
      { id: 527649, name: "Velhane Kh." },
      { id: 527621, name: "Vichkhede" },
      { id: 527609, name: "Waghare" },
      { id: 527610, name: "Waghari" },
    ],
    3971: [
      { id: 527678, name: "Aanchalgaon" },
      { id: 527662, name: "Adalase" },
      { id: 527688, name: "Amadade" },
      { id: 527682, name: "Anjan Vihire" },
      { id: 527684, name: "Anturli Bk." },
      { id: 527714, name: "Babrud Pr. Bahal" },
      { id: 527690, name: "Babrud Pr. Utran" },
      { id: 527708, name: "Balad Kh." },
      { id: 527674, name: "Batsar" },
      { id: 943279, name: "Bhadgaon" },
      { id: 527683, name: "Bhatkhande Bk." },
      { id: 527691, name: "Bhattagaon" },
      { id: 527718, name: "Bhortek Bk" },
      { id: 527705, name: "Bodarde" },
      { id: 527704, name: "Bornar" },
      { id: 527702, name: "Dalwade" },
      { id: 527710, name: "Devhari" },
      { id: 527679, name: "Dhotre" },
      { id: 527703, name: "Ghusardi Kh." },
      { id: 527685, name: "Girad" },
      { id: 527713, name: "Godgaon" },
      { id: 527671, name: "Gudhe" },
      { id: 527663, name: "Juwardi" },
      { id: 527719, name: "Kajgaon" },
      { id: 527711, name: "Kanashi" },
      { id: 943275, name: "Karab" },
      { id: 527693, name: "Khedgaon Kh." },
      { id: 527670, name: "Kolgaon" },
      { id: 527707, name: "Kothali" },
      { id: 527712, name: "Lon Pr. Bhadgaon" },
      { id: 527686, name: "Lon Pr. Utran" },
      { id: 527666, name: "Mahindale" },
      { id: 527715, name: "Malgaon" },
      { id: 527692, name: "Mandki" },
      { id: 527701, name: "Navare" },
      { id: 527706, name: "Nimbhora" },
      { id: 527668, name: "Palaskhede" },
      { id: 527676, name: "Pandhrad" },
      { id: 527720, name: "Pasardi" },
      { id: 527664, name: "Pathrad" },
      { id: 527665, name: "Pendgaon" },
      { id: 527675, name: "Picharde" },
      { id: 527689, name: "Pimpalgaon Bk." },
      { id: 527681, name: "Pimparkhed" },
      { id: 527673, name: "Pimprihat" },
      { id: 527667, name: "Rupnagar" },
      { id: 527672, name: "Sawade" },
      { id: 527669, name: "Shindi" },
      { id: 527694, name: "Shivani" },
      { id: 527680, name: "Talband" },
      { id: 527716, name: "Tandulwadi" },
      { id: 943272, name: "Tongaon" },
      { id: 527717, name: "Umarkhed" },
      { id: 527677, name: "Vasantwadi" },
      { id: 943287, name: "Wadadhe" },
      { id: 527698, name: "Wadajee" },
      { id: 527700, name: "Wade" },
      { id: 527709, name: "Wadgaon Bk." },
      { id: 527695, name: "Wadgaon Nalbandi" },
      { id: 527699, name: "Wak" },
      { id: 527697, name: "Walwadi Bk." },
      { id: 527696, name: "Walwadi Kh." },
      { id: 527687, name: "Warkhed" },
    ],
    3972: [
      { id: 527744, name: "Abhone" },
      { id: 527797, name: "Adgaon" },
      { id: 527826, name: "Alwadi" },
      { id: 527785, name: "Ambehol" },
      { id: 527836, name: "Andhari" },
      { id: 527755, name: "Bahal" },
      { id: 527779, name: "Bangaon" },
      { id: 527812, name: "Beldarwadi" },
      { id: 527769, name: "Bhamare Bk" },
      { id: 527770, name: "Bhamare Kh" },
      { id: 527752, name: "Bhaur" },
      { id: 527754, name: "Bhawali" },
      { id: 527799, name: "Bhoras Bk." },
      { id: 527800, name: "Bhoras Kh" },
      { id: 527803, name: "Bilakhed" },
      { id: 527788, name: "Bodhare" },
      { id: 527742, name: "Borkhede Bk" },
      { id: 527766, name: "Borkhede Kh." },
      { id: 527807, name: "Bramhan Shewage" },
      { id: 939710, name: "Chaitanya Tanda No.4" },
      { id: 943255, name: "Chalisgaon" },
      { id: 527772, name: "Chambhardi Bk." },
      { id: 527773, name: "Chambhardi Kh." },
      { id: 527858, name: "Chandikawadi" },
      { id: 527847, name: "Chaturbhuj" },
      { id: 527729, name: "Chinchgavhan" },
      { id: 527798, name: "Chinchkhede" },
      { id: 527840, name: "Chitegaon" },
      { id: 527726, name: "Dahiwad" },
      { id: 527761, name: "Damrun" },
      { id: 527723, name: "Daregaon" },
      { id: 527739, name: "Dasegaon Bk" },
      { id: 527750, name: "Daskebardi" },
      { id: 527805, name: "Deoli" },
      { id: 527825, name: "Deshmukhwadi" },
      { id: 527727, name: "Dhamangaon" },
      { id: 527758, name: "Dhomane" },
      { id: 527804, name: "Don Digar" },
      { id: 527771, name: "Eklahare" },
      { id: 527846, name: "Ganeshpur" },
      { id: 527841, name: "Ganpur" },
      { id: 527853, name: "Ghodegaon" },
      { id: 527862, name: "Gujardari" },
      { id: 947122, name: "Harinagar" },
      { id: 527778, name: "Hatale" },
      { id: 527835, name: "Hatgaon" },
      { id: 527763, name: "Hingone Kh." },
      { id: 527764, name: "Hingone Seem" },
      { id: 527838, name: "Hirapur" },
      { id: 939707, name: "Ichhapur Tanda No.1" },
      { id: 939708, name: "Ichhapur Tanda No.2" },
      { id: 939709, name: "Ichhapur Tanda No.3" },
      { id: 527753, name: "Jamada" },
      { id: 527774, name: "Jamadi Pr. Bahal" },
      { id: 527775, name: "Jawale" },
      { id: 527789, name: "Junone" },
      { id: 527733, name: "Kadhare" },
      { id: 527830, name: "Kakadane" },
      { id: 527745, name: "Kalamadu" },
      { id: 527850, name: "Karanjgaon" },
      { id: 527802, name: "Kargaon" },
      { id: 527809, name: "Khadaki Bk." },
      { id: 527728, name: "Khadaki Seem" },
      { id: 527854, name: "Kharadi" },
      { id: 527790, name: "Kharjai" },
      { id: 527748, name: "Khedgaon" },
      { id: 527749, name: "Khedi Kh" },
      { id: 527782, name: "Kherde" },
      { id: 527811, name: "Kodgaon" },
      { id: 527776, name: "Konganagar" },
      { id: 527730, name: "Krishnapuri" },
      { id: 527849, name: "Krushnanagar" },
      { id: 527743, name: "Kunjhar" },
      { id: 527724, name: "Londhe" },
      { id: 527784, name: "Lonje" },
      { id: 527832, name: "Malshevage" },
      { id: 527823, name: "Mandurne" },
      { id: 527734, name: "Mehunbare" },
      { id: 527768, name: "Mundkhede Bk." },
      { id: 527767, name: "Mundkhede Kh." },
      { id: 527829, name: "Nandre" },
      { id: 527759, name: "Nhave" },
      { id: 527815, name: "Nimkhedi" },
      { id: 527856, name: "Odhare" },
      { id: 527792, name: "Ozar" },
      { id: 527732, name: "Palasare" },
      { id: 527738, name: "Parasharam Nagar" },
      { id: 527810, name: "Pat Khadki" },
      { id: 527857, name: "Patana" },
      { id: 527786, name: "Pathraje" },
      { id: 527791, name: "Patonda" },
      { id: 527822, name: "Pilkhod" },
      { id: 527852, name: "Pimpalgaon" },
      { id: 527820, name: "Pimpalwad Mhalsa" },
      { id: 527833, name: "Pimpalwad Nikumbh" },
      { id: 527842, name: "Pimparkhede" },
      { id: 527806, name: "Pimpri Bk. Pr. De" },
      { id: 527839, name: "Pimpri Bk. Pr.Cha." },
      { id: 527737, name: "Pimpri Kh." },
      { id: 527747, name: "Pohare" },
      { id: 527741, name: "Rahipuri" },
      { id: 527859, name: "Rajdehare" },
      { id: 527746, name: "Rajmane" },
      { id: 527721, name: "Ramnagar" },
      { id: 527780, name: "Ranjangaon" },
      { id: 527851, name: "Rohini" },
      { id: 527796, name: "Rokade" },
      { id: 527781, name: "Sangavi" },
      { id: 527824, name: "Sayagaon" },
      { id: 527816, name: "Sevanagar" },
      { id: 527808, name: "Shewari" },
      { id: 527751, name: "Shidwadi" },
      { id: 527848, name: "Shindi" },
      { id: 527827, name: "Shirasgaon" },
      { id: 527844, name: "Shivapur" },
      { id: 527783, name: "Songaon" },
      { id: 527725, name: "Sundarnagar" },
      { id: 527863, name: "Takali Pr. Cha." },
      { id: 527821, name: "Takali Pr. Dehere" },
      { id: 527837, name: "Talegaon" },
      { id: 527787, name: "Talode Pr. Chalisgaon" },
      { id: 527828, name: "Talonde Pr. Dehere" },
      { id: 527818, name: "Tamaswadi" },
      { id: 527813, name: "Tambole Bk." },
      { id: 527814, name: "Tambole Kh." },
      { id: 527834, name: "Tamgavhan" },
      { id: 527760, name: "Tarwade" },
      { id: 527757, name: "Tekwade Bk." },
      { id: 527756, name: "Tekwade Kh." },
      { id: 527735, name: "Tirpole" },
      { id: 527736, name: "Umbarkhede" },
      { id: 527817, name: "Upkhede" },
      { id: 527762, name: "Vadale Vadali" },
      { id: 527740, name: "Vadgaon Lambe" },
      { id: 527845, name: "Valthan" },
      { id: 527731, name: "Varkhede Bk." },
      { id: 527819, name: "Varkhede Kh." },
      { id: 527722, name: "Visapur" },
      { id: 527855, name: "Vishnunagar" },
      { id: 527793, name: "Waghadu" },
      { id: 527777, name: "Waghale" },
      { id: 527765, name: "Waghali" },
      { id: 527794, name: "Wakadi" },
    ],
    3973: [
      { id: 527930, name: "Akhatwade" },
      { id: 527915, name: "Anturli Bk.Pr.Pa." },
      { id: 527914, name: "Anturli Kh.Pr.Lo." },
      { id: 527909, name: "Anturli Kh.Pr.Pa." },
      { id: 527888, name: "Arve" },
      { id: 527872, name: "Asankhede Bk." },
      { id: 527873, name: "Asankhede Kh." },
      { id: 527979, name: "Atalgavhan" },
      { id: 527938, name: "Badarkhe" },
      { id: 527904, name: "Bahuleshwar" },
      { id: 527942, name: "Balad Bk." },
      { id: 527912, name: "Bambarud Kh. Pr.Pa." },
      { id: 527871, name: "Bambarud Pr. Bo." },
      { id: 527935, name: "Bhadali" },
      { id: 527908, name: "Bhatkhande Kh." },
      { id: 527964, name: "Bhoje" },
      { id: 527967, name: "Bhokari" },
      { id: 527926, name: "Bhortek Kh.Pr.Bh" },
      { id: 527889, name: "Bildi Bk." },
      { id: 527948, name: "Chinchkhede Bk." },
      { id: 527916, name: "Chinchkhede Kh." },
      { id: 527971, name: "Chinchpure" },
      { id: 527920, name: "Chunchale." },
      { id: 527864, name: "Dahigaon" },
      { id: 527972, name: "Dambhurni" },
      { id: 527940, name: "Dighi" },
      { id: 527865, name: "Dokalkheda" },
      { id: 527954, name: "Dongargaon" },
      { id: 527906, name: "Duskhede" },
      { id: 527988, name: "Gahule" },
      { id: 527947, name: "Galan Bk." },
      { id: 527946, name: "Galan Kh." },
      { id: 527925, name: "Ghusardi Bk." },
      { id: 527886, name: "Goradkheda Bk." },
      { id: 527887, name: "Goradkheda Kh." },
      { id: 527875, name: "Hadsan" },
      { id: 527944, name: "Hanumanwadi" },
      { id: 527924, name: "Hol" },
      { id: 527893, name: "Jamane" },
      { id: 527911, name: "Jargaon" },
      { id: 527982, name: "Jawakhedi Digar" },
      { id: 527903, name: "Kalamsara" },
      { id: 527901, name: "Kasampura" },
      { id: 527951, name: "Khadakdeola Bk." },
      { id: 527953, name: "Khadakdeola Kh." },
      { id: 527931, name: "Khajola" },
      { id: 527885, name: "Khedgaon (Nandiche)" },
      { id: 527976, name: "Kokadi" },
      { id: 527978, name: "Kolhe" },
      { id: 944348, name: "Krushnapuri" },
      { id: 527869, name: "Kurangi" },
      { id: 527896, name: "Kurhad Bk." },
      { id: 527895, name: "Kurhad Kh." },
      { id: 527897, name: "Lakh ." },
      { id: 527870, name: "Lasgaon" },
      { id: 527958, name: "Lasure" },
      { id: 527900, name: "Lohara" },
      { id: 527965, name: "Lohari Bk." },
      { id: 527957, name: "Lohari Kh." },
      { id: 527913, name: "Lohatar" },
      { id: 527868, name: "Mahiji" },
      { id: 527881, name: "Mandaki" },
      { id: 527899, name: "Mhasas" },
      { id: 527877, name: "Mohadi" },
      { id: 527939, name: "Mohalai" },
      { id: 527955, name: "Mondhala" },
      { id: 527943, name: "Nachankheda" },
      { id: 527922, name: "Nagardeola Bk." },
      { id: 527928, name: "Nagardeola Sim." },
      { id: 527892, name: "Naiknagar" },
      { id: 527874, name: "Nandra" },
      { id: 527936, name: "Neri" },
      { id: 527960, name: "Nimbhori Bk." },
      { id: 527956, name: "Nimbhori Kh." },
      { id: 527929, name: "Nipane" },
      { id: 527910, name: "Ozar" },
      { id: 527991, name: "Pachora" },
      { id: 527876, name: "Pahan" },
      { id: 527907, name: "Pardhade" },
      { id: 527981, name: "Pimpalgaon Bk." },
      { id: 527921, name: "Pimpalgaon Kh. Pr. Bha." },
      { id: 527932, name: "Pimpri Bk. Pr.Bha." },
      { id: 527980, name: "Pimpri Bk.Pr.Pa." },
      { id: 527985, name: "Pimpri Kh.Pr.Pa." },
      { id: 527882, name: "Pungaon" },
      { id: 527961, name: "Rajuri Bk." },
      { id: 527963, name: "Rajuri Kh." },
      { id: 527898, name: "Rameshwar" },
      { id: 527890, name: "Sajgaon" },
      { id: 527867, name: "Samner" },
      { id: 527923, name: "Sangameshwar" },
      { id: 527891, name: "Sangavi Pr.Lo." },
      { id: 527919, name: "Sangvi Pr.Bha." },
      { id: 527917, name: "Sarola Bk" },
      { id: 527918, name: "Sarola Kh" },
      { id: 527933, name: "Sarve Bk.Pr.Bha." },
      { id: 527894, name: "Sarve Bk.Pr.Lo." },
      { id: 527986, name: "Sarve Bk.Pr.Pa." },
      { id: 527934, name: "Sarve Kh.Pr.Bha." },
      { id: 527987, name: "Satgaon" },
      { id: 527969, name: "Sawkheda Bk." },
      { id: 527970, name: "Sawkheda Kh." },
      { id: 527902, name: "Shahapure" },
      { id: 527984, name: "Shewale" },
      { id: 527983, name: "Shindad" },
      { id: 527927, name: "Takali Bk." },
      { id: 527949, name: "Tarkheda Bk." },
      { id: 527950, name: "Tarkheda Khurd" },
      { id: 527975, name: "Vadgaon Ambe" },
      { id: 527973, name: "Vadgaon Ambe Bk." },
      { id: 527974, name: "Vadgaon Ambe Kh." },
      { id: 527879, name: "Vadgaon Aseri" },
      { id: 527880, name: "Vadgaon Bk.Pr.Pa." },
      { id: 527977, name: "Vadgaon Joge" },
      { id: 527989, name: "Vadgaon Kade" },
      { id: 527941, name: "Vadgaon Kh.Pr.Bha." },
      { id: 527905, name: "Vadgaon Kh.Pr.Pa." },
      { id: 527937, name: "Vadgaon Mulane" },
      { id: 527878, name: "Vadgaon Tek" },
      { id: 527866, name: "Varasade Pr.Bo." },
      { id: 527990, name: "Varasade.Bk Pr.Pa." },
      { id: 527966, name: "Varkhedi Bk." },
      { id: 527968, name: "Varkhedi Kh." },
      { id: 527884, name: "Veruli Bk." },
      { id: 527883, name: "Veruli Kh." },
      { id: 527945, name: "Vishnunagar" },
      { id: 527962, name: "Wadi" },
      { id: 527952, name: "Waghulkheda" },
      { id: 527959, name: "Wanegaon" },
    ],
    3974: [
      { id: 528071, name: "Ambadi" },
      { id: 528013, name: "Ambilhol" },
      { id: 528012, name: "Ambilhol Devi" },
      { id: 528130, name: "Amkhede" },
      { id: 528031, name: "Betawad Bk" },
      { id: 528024, name: "Betawad Kh" },
      { id: 528104, name: "Bhagdare" },
      { id: 528050, name: "Bharadi" },
      { id: 528122, name: "Bharudkhede" },
      { id: 528051, name: "Bhilkheda" },
      { id: 528079, name: "Bilwadi" },
      { id: 528017, name: "Borgaon" },
      { id: 528061, name: "Chilgaon" },
      { id: 528040, name: "Chinchakhede Bk" },
      { id: 528081, name: "Chinchkhede Digar" },
      { id: 528094, name: "Chinchkhede Tawa" },
      { id: 528133, name: "Chincholi Pimpri" },
      { id: 528145, name: "Deulgaon" },
      { id: 527995, name: "Dev Pimpri" },
      { id: 528030, name: "Devalasgaon" },
      { id: 528120, name: "Dhalgaon" },
      { id: 528126, name: "Dhalsingi" },
      { id: 528006, name: "Dohari" },
      { id: 528060, name: "Dondwade" },
      { id: 528057, name: "Ekulti Bk." },
      { id: 528058, name: "Ekulti Kh" },
      { id: 527998, name: "Gadegaon Pn Nashirabad" },
      { id: 528075, name: "Ganeshpur" },
      { id: 528002, name: "Gangapuri" },
      { id: 528005, name: "Garkhede Bk" },
      { id: 528004, name: "Garkhede Kh" },
      { id: 528147, name: "Godri" },
      { id: 528074, name: "Gondegaon" },
      { id: 528039, name: "Gondkhed" },
      { id: 528117, name: "Gorad Khede" },
      { id: 528033, name: "Gornale" },
      { id: 528097, name: "Harinagar" },
      { id: 527999, name: "Hingane Bk" },
      { id: 528100, name: "Hingane N.Kasab" },
      { id: 528139, name: "Hingane Pimpri" },
      { id: 528009, name: "Hivar Khede Bk." },
      { id: 528084, name: "Hivari Digar" },
      { id: 528085, name: "Hivarkhede Digar" },
      { id: 528095, name: "Hivarkhede Tawa" },
      { id: 528015, name: "Holhaveli" },
      { id: 528109, name: "Jalandri Bk." },
      { id: 528132, name: "Jalandri Kh." },
      { id: 528091, name: "Jambhol" },
      { id: 943267, name: "Jamner" },
      { id: 528073, name: "Jangipura" },
      { id: 528056, name: "Jogal Khede" },
      { id: 528137, name: "Junone" },
      { id: 528026, name: "Kalkhede" },
      { id: 528135, name: "Kapuswadi" },
      { id: 527992, name: "Karmad" },
      { id: 528093, name: "Karnafata" },
      { id: 528108, name: "Kasali" },
      { id: 528140, name: "Kasba Pimpri" },
      { id: 528041, name: "Kekat Nimbora" },
      { id: 528000, name: "Khadgaon" },
      { id: 528016, name: "Khadki" },
      { id: 528119, name: "Khandave" },
      { id: 528059, name: "Kharchane" },
      { id: 528148, name: "Kinhi" },
      { id: 528045, name: "Kodoli ." },
      { id: 528123, name: "Kumbari Kh" },
      { id: 528124, name: "Kumbhari Bk." },
      { id: 528035, name: "Kumbhari Sim" },
      { id: 528098, name: "Lahasar" },
      { id: 528055, name: "Lakholi" },
      { id: 528083, name: "Lihe" },
      { id: 528070, name: "Londhri Bk." },
      { id: 528069, name: "Londhri Kh." },
      { id: 528114, name: "Loni" },
      { id: 528116, name: "Madani" },
      { id: 528014, name: "Mahukhede" },
      { id: 528020, name: "Maldhabadi" },
      { id: 528072, name: "Malkheda" },
      { id: 527996, name: "Malpimpri" },
      { id: 528118, name: "Mandave Bk." },
      { id: 528121, name: "Mandave Kh." },
      { id: 528111, name: "Mehegaon" },
      { id: 528080, name: "Mengaon" },
      { id: 528034, name: "Mohadi" },
      { id: 528077, name: "Morad Digar" },
      { id: 528067, name: "Moygaon Bk" },
      { id: 528029, name: "Moykhede Digar" },
      { id: 528003, name: "Mundkhede" },
      { id: 528054, name: "Nachan Khede" },
      { id: 528127, name: "Nagan Kh ." },
      { id: 528134, name: "Nandre Haveli" },
      { id: 528053, name: "Nandre Pr.Lohare" },
      { id: 528018, name: "Navidabhadi" },
      { id: 527997, name: "Neri Bk." },
      { id: 527994, name: "Neri Digar" },
      { id: 528110, name: "Nimkhedi Pimpri" },
      { id: 528102, name: "Ozar Bk." },
      { id: 528101, name: "Ozar Kh." },
      { id: 528064, name: "Pahur" },
      { id: 528010, name: "Palas Khede Bk." },
      { id: 528136, name: "Palas Khede Kakar" },
      { id: 527993, name: "Palasakhede.Pr.Na" },
      { id: 528038, name: "Paldhi" },
      { id: 528146, name: "Pathad Tanda" },
      { id: 528023, name: "Patkheda" },
      { id: 528141, name: "Phattepur" },
      { id: 528086, name: "Pimpalgaon Bk." },
      { id: 528066, name: "Pimpalgaon Golait" },
      { id: 528087, name: "Pimpalgaon Kamani" },
      { id: 528088, name: "Pimpalgaon Kh." },
      { id: 528142, name: "Pimpalgaon Pimpri" },
      { id: 528046, name: "Pimpar Khede" },
      { id: 528112, name: "Rahere" },
      { id: 528032, name: "Rajani" },
      { id: 528007, name: "Rampur" },
      { id: 528099, name: "Rampura" },
      { id: 528047, name: "Rotwad" },
      { id: 528129, name: "Samrod" },
      { id: 528062, name: "Sangavi" },
      { id: 528025, name: "Sargaon" },
      { id: 528052, name: "Sarve Pr.Lohare" },
      { id: 528131, name: "Savarle" },
      { id: 528049, name: "Savatkhede" },
      { id: 528105, name: "Shahapur" },
      { id: 528128, name: "Shankarpura" },
      { id: 528106, name: "Shelgaon" },
      { id: 528076, name: "Shendurni" },
      { id: 528092, name: "Shengola" },
      { id: 528068, name: "Sheri" },
      { id: 528138, name: "Shevage Pimpri" },
      { id: 528001, name: "Shingaiet" },
      { id: 528065, name: "Sonale" },
      { id: 528021, name: "Sonari" },
      { id: 528036, name: "Sunasgaon Bk." },
      { id: 528037, name: "Sunasgaon Kh." },
      { id: 528043, name: "Takali Bk." },
      { id: 528044, name: "Takali Kh." },
      { id: 528115, name: "Takali Pimpri" },
      { id: 528103, name: "Takarkhede" },
      { id: 528107, name: "Talegaon" },
      { id: 528082, name: "Tarangwadi" },
      { id: 528027, name: "Tighre Wadgaon" },
      { id: 528125, name: "Tondapur" },
      { id: 528143, name: "Tornale" },
      { id: 528144, name: "Vasantnagar" },
      { id: 528096, name: "Wadali" },
      { id: 528089, name: "Wadgaon Bk." },
      { id: 528150, name: "Wadgaon Nimb" },
      { id: 528149, name: "Wadgaon Saddo" },
      { id: 528028, name: "Wadgaon Tighre" },
      { id: 528019, name: "Wadi" },
      { id: 528022, name: "Waghari" },
      { id: 528113, name: "Wakadi" },
      { id: 528011, name: "Waki Bk." },
      { id: 528042, name: "Waki Kh." },
      { id: 528090, name: "Wakod" },
    ],
    3975: [
      { id: 528251, name: "Adol Bk." },
      { id: 528250, name: "Adol Kh." },
      { id: 528200, name: "Ahmadpur" },
      { id: 528243, name: "Akola Kh." },
      { id: 528206, name: "Asalgaon Bhag 1" },
      { id: 944989, name: "Asalgaon Bhag 2" },
      { id: 528237, name: "Bhendwad Bk." },
      { id: 528235, name: "Bhendwad Kh." },
      { id: 528157, name: "Bhingara Khurd" },
      { id: 528240, name: "Bhurkhed" },
      { id: 528215, name: "Borala Bk." },
      { id: 528213, name: "Borala Kh." },
      { id: 528177, name: "Chalthana Bk." },
      { id: 528171, name: "Chalthana Kh." },
      { id: 528172, name: "Chalthana Siyam" },
      { id: 528232, name: "Chawara" },
      { id: 528209, name: "Chinchkhed Kh." },
      { id: 528255, name: "Dadulgaon" },
      { id: 528193, name: "Dautpur" },
      { id: 528214, name: "Devhari Budruk" },
      { id: 528192, name: "Dhanora" },
      { id: 528234, name: "Gadegaon Bk." },
      { id: 528227, name: "Gadegaon Kh." },
      { id: 528161, name: "Garpeth" },
      { id: 528254, name: "Gaulkhed" },
      { id: 528259, name: "Golegaon Bk." },
      { id: 528261, name: "Golegaon Kh." },
      { id: 528202, name: "Gorada Pra.Jalgaon" },
      { id: 528169, name: "Gorada Pra.Jamod" },
      { id: 528163, name: "Hanwatkhed" },
      { id: 528190, name: "Hashampur" },
      { id: 528256, name: "Hingna Balapur" },
      { id: 528233, name: "Ilora" },
      { id: 528201, name: "Islampur" },
      { id: 945181, name: "Jalgaon Khurd" },
      { id: 528168, name: "Kahupatta" },
      { id: 528223, name: "Kajegaon" },
      { id: 528238, name: "Karanwadi" },
      { id: 528167, name: "Khamkhed" },
      { id: 528242, name: "Khandvi" },
      { id: 528272, name: "Khel Amanat" },
      { id: 528266, name: "Khel Bari Jalgaon" },
      { id: 528270, name: "Khel Chatari Bk." },
      { id: 528271, name: "Khel Chatari Kh." },
      { id: 528265, name: "Khel Gobji Jalgaon" },
      { id: 528173, name: "Khel Lon Jamod" },
      { id: 944296, name: "Khel Mali Jalgaon" },
      { id: 528269, name: "Khel Murtijapur" },
      { id: 528176, name: "Khel Paraskar (Jamod)" },
      { id: 528273, name: "Khel Sonji" },
      { id: 528274, name: "Khelfut" },
      { id: 528268, name: "Khelkhasa Bk." },
      { id: 528267, name: "Khelkhasa Kh." },
      { id: 528175, name: "Khelmali (Jamod)" },
      { id: 528174, name: "Khelshivapur (Jamod)" },
      { id: 528181, name: "Khelwardhe (Jamod)" },
      { id: 528188, name: "Kherda Bk." },
      { id: 528186, name: "Kherda Kh." },
      { id: 528198, name: "Kolkhed Pr.Jalgaon" },
      { id: 528197, name: "Kolkhed Pr.Jamod" },
      { id: 528229, name: "Kurangad Bk." },
      { id: 528226, name: "Kurangad Kh." },
      { id: 528156, name: "Kuvardev" },
      { id: 528231, name: "Madakhed Bk." },
      { id: 528230, name: "Madakhed Kh." },
      { id: 528264, name: "Mahuli" },
      { id: 528248, name: "Mandava" },
      { id: 528257, name: "Manegaon" },
      { id: 528195, name: "Mohamadpur" },
      { id: 528239, name: "Mohidepur" },
      { id: 528212, name: "Muradabad" },
      { id: 528203, name: "Nav Kh." },
      { id: 528187, name: "Nimbhora Bk." },
      { id: 528236, name: "Nimbhora Kh." },
      { id: 528249, name: "Nimkarad" },
      { id: 528224, name: "Palaskhed" },
      { id: 528246, name: "Palshi Ghat" },
      { id: 528204, name: "Palshi Supo" },
      { id: 528245, name: "Palshi Vaidya" },
      { id: 528217, name: "Parasharampur" },
      { id: 528218, name: "Patan" },
      { id: 528244, name: "Pimpalgaon Kale Bhag 1" },
      { id: 944990, name: "Pimpalgaon Kale Bhag 2" },
      { id: 528241, name: "Pimpri Khodri" },
      { id: 528162, name: "Raipur" },
      { id: 528165, name: "Rajura Bk." },
      { id: 528164, name: "Rajura Kh." },
      { id: 528194, name: "Rasulpur" },
      { id: 528185, name: "Sajanpuri" },
      { id: 528260, name: "Satli" },
      { id: 528247, name: "Sawadan" },
      { id: 528220, name: "Sawargaon" },
      { id: 528155, name: "Sonbardi" },
      { id: 528228, name: "Sukli" },
      { id: 528205, name: "Sulaj" },
      { id: 528252, name: "Sultanpur" },
      { id: 528170, name: "Sungaon Bhag 1" },
      { id: 944991, name: "Sungaon Bhag 2" },
      { id: 528262, name: "Takli Khasa" },
      { id: 528219, name: "Takli Khati" },
      { id: 528263, name: "Takli Paraskar" },
      { id: 528225, name: "Taroda Bk." },
      { id: 528221, name: "Taroda Kh." },
      { id: 528183, name: "Taroda Pra. Jamod" },
      { id: 528184, name: "Taroda Tulja" },
      { id: 528196, name: "Tatarpur" },
      { id: 528253, name: "Tivadi Ajampur" },
      { id: 528160, name: "Umapur" },
      { id: 528180, name: "Usara Bk." },
      { id: 528179, name: "Usara Kh." },
      { id: 528211, name: "Uti Bk" },
      { id: 528210, name: "Uti Kh." },
      { id: 528208, name: "Wadgaon Patan" },
      { id: 528191, name: "Wadgaongad" },
      { id: 528199, name: "Wadi Bk." },
      { id: 528207, name: "Wadi Kh." },
      { id: 528216, name: "Wadshingi" },
      { id: 528182, name: "Wanur" },
      { id: 528178, name: "Wawadi Hardo" },
      { id: 528166, name: "Wayal" },
      { id: 528222, name: "Yengaon" },
      { id: 528258, name: "Zadegaon" },
    ],
    3976: [
      { id: 528396, name: "Aanswad" },
      { id: 528348, name: "Akoli Bk." },
      { id: 528349, name: "Akoli Kh." },
      { id: 528299, name: "Alewadi" },
      { id: 528284, name: "Ambabarvha" },
      { id: 528370, name: "Atkal" },
      { id: 528375, name: "Awar" },
      { id: 528324, name: "Balhadi" },
      { id: 528328, name: "Banoda Bk." },
      { id: 528329, name: "Bawanbir" },
      { id: 528358, name: "Bhilkhed" },
      { id: 528387, name: "Bhon" },
      { id: 528344, name: "Bhuikhed" },
      { id: 528356, name: "Bodkha" },
      { id: 528319, name: "Borkhed" },
      { id: 528350, name: "Changefal Bk." },
      { id: 528351, name: "Changefal Kh." },
      { id: 528300, name: "Chichari" },
      { id: 528361, name: "Chondhi" },
      { id: 528275, name: "Chunkhedi" },
      { id: 528323, name: "Danapur" },
      { id: 528392, name: "Deulgaon" },
      { id: 528334, name: "Dhamangaon" },
      { id: 528280, name: "Durgadaitya" },
      { id: 528337, name: "Eklara(Banoda)" },
      { id: 528314, name: "Gopalkhed" },
      { id: 528302, name: "Hadiyamahal" },
      { id: 528381, name: "Hingana Kavthal" },
      { id: 528385, name: "Itkhed" },
      { id: 528373, name: "Jastgaon" },
      { id: 528338, name: "Kakanwada Bk." },
      { id: 528342, name: "Kakanwada Kh." },
      { id: 528362, name: "Kakoda" },
      { id: 528371, name: "Kalamkhed" },
      { id: 528295, name: "Kamod" },
      { id: 528304, name: "Karmoda" },
      { id: 528339, name: "Katel" },
      { id: 528355, name: "Kathargaon" },
      { id: 945033, name: "Kavathal Bhag 2" },
      { id: 528383, name: "Kavthal Bhag 1" },
      { id: 528326, name: "Khalad Bk." },
      { id: 528325, name: "Khalad Kh." },
      { id: 528391, name: "Khel Bhongal Paturda" },
      { id: 528390, name: "Khel Dalavi Paturda" },
      { id: 528393, name: "Khel Mali Paturda" },
      { id: 528379, name: "Khel Thorat Paturda" },
      { id: 528389, name: "Khiroda" },
      { id: 528377, name: "Kodri" },
      { id: 528341, name: "Kolad" },
      { id: 528382, name: "Kumbharkhed" },
      { id: 528395, name: "Kundegaon" },
      { id: 528312, name: "Ladnapur Bhag 1" },
      { id: 945034, name: "Ladnapur Bhag 2" },
      { id: 528311, name: "Lohagaon Bk." },
      { id: 528310, name: "Lohagaon Kh." },
      { id: 528307, name: "Malthana Bk." },
      { id: 528306, name: "Malthana Kh." },
      { id: 528364, name: "Manardi" },
      { id: 528309, name: "Marod" },
      { id: 528345, name: "Mominabad" },
      { id: 528374, name: "Neknampur" },
      { id: 528332, name: "Nimkhed" },
      { id: 528357, name: "Nirod" },
      { id: 528352, name: "Niwana" },
      { id: 528335, name: "Palashi Zashi" },
      { id: 528327, name: "Palsoda" },
      { id: 528316, name: "Panchala Pr.Bawanbir" },
      { id: 528315, name: "Panchala Pr.Jamod" },
      { id: 528378, name: "Paturda Kh." },
      { id: 528386, name: "Pesoda" },
      { id: 528346, name: "Pimpari Adgaon" },
      { id: 528365, name: "Pimpri Kavthal" },
      { id: 528297, name: "Pingli Bk." },
      { id: 528296, name: "Pingli Jahangir" },
      { id: 528347, name: "Rajpur" },
      { id: 528366, name: "Ringanwadi" },
      { id: 528293, name: "Rohinkhidaki" },
      { id: 528360, name: "Rudhana" },
      { id: 528343, name: "Salabad" },
      { id: 528294, name: "Salwan" },
      { id: 528353, name: "Sangrampur" },
      { id: 528320, name: "Sangrampur Pr.Sonala" },
      { id: 528333, name: "Sawala" },
      { id: 528388, name: "Sawali" },
      { id: 528298, name: "Saykhed" },
      { id: 528308, name: "Shewaga Bk" },
      { id: 528305, name: "Shewaga Kh." },
      { id: 528303, name: "Shivani" },
      { id: 528322, name: "Sogoda" },
      { id: 528318, name: "Sonala Bhag 1" },
      { id: 945035, name: "Sonala Bhag 2" },
      { id: 528394, name: "Takali Panchgavhan" },
      { id: 528369, name: "Takleshwar" },
      { id: 528354, name: "Tamgaon" },
      { id: 528317, name: "Tunki Bk." },
      { id: 528313, name: "Tunki Kh." },
      { id: 528363, name: "Ukadgaon" },
      { id: 528376, name: "Ukali Bk." },
      { id: 528330, name: "Umara" },
      { id: 528340, name: "Wadgaon (Wan)" },
      { id: 528359, name: "Wakana" },
      { id: 528368, name: "Wankhed Bhag 1" },
      { id: 945036, name: "Wankhed Bhag 2" },
      { id: 528321, name: "Warkhed" },
      { id: 528336, name: "Warwat Bakal" },
      { id: 528380, name: "Warwat Khanderao" },
      { id: 528301, name: "Wasali" },
      { id: 528372, name: "Wastagaon" },
      { id: 528331, name: "Zashi" },
    ],
    3977: [
      { id: 528423, name: "Adsul" },
      { id: 528447, name: "Alasana" },
      { id: 528410, name: "Belura" },
      { id: 528399, name: "Bhastan" },
      { id: 528401, name: "Bhongaon" },
      { id: 528402, name: "Bondgaon" },
      { id: 528408, name: "Bramhanwada" },
      { id: 528403, name: "Chinchkhed" },
      { id: 528433, name: "Chincholi Karfarma" },
      { id: 528404, name: "Dolarkhed" },
      { id: 528417, name: "Dongarkhed" },
      { id: 528448, name: "Ekphal" },
      { id: 528434, name: "Gaigaon Bk." },
      { id: 528460, name: "Gaigaon Kh." },
      { id: 528451, name: "Gaulkhed" },
      { id: 528467, name: "Gavhan" },
      { id: 528428, name: "Ghui" },
      { id: 528419, name: "Golegaon Bk." },
      { id: 528420, name: "Golegaon Kh." },
      { id: 528429, name: "Hingna Vaijinath" },
      { id: 528459, name: "Irkhed" },
      { id: 528449, name: "Jalamb Bhag 1" },
      { id: 945037, name: "Jalamb Bhag 2" },
      { id: 528442, name: "Janori" },
      { id: 528439, name: "Jawala Bk." },
      { id: 528435, name: "Jawala Palaskhed" },
      { id: 528422, name: "Kalkhed" },
      { id: 528397, name: "Kalwad" },
      { id: 528458, name: "Kanarkhed" },
      { id: 528398, name: "Kathora" },
      { id: 528415, name: "Khatkhed" },
      { id: 528450, name: "Kherda" },
      { id: 528413, name: "Kurkhed" },
      { id: 528456, name: "Lasura Bk." },
      { id: 528455, name: "Lasura Kh." },
      { id: 528457, name: "Lontek" },
      { id: 528407, name: "Machhindrakhed" },
      { id: 528440, name: "Mahagaon" },
      { id: 528466, name: "Majalapur (Ujad)" },
      { id: 528438, name: "Manarkhed Kh" },
      { id: 528418, name: "Manasgaon" },
      { id: 528426, name: "Manegaon" },
      { id: 528406, name: "Matargaon Bk. Bhag 1" },
      { id: 945038, name: "Matargaon Bk.Bhag 2" },
      { id: 528409, name: "Matargaon Kh." },
      { id: 528427, name: "Mehen (Ujad)" },
      { id: 528412, name: "Morgaon Digras" },
      { id: 528411, name: "Nimbi" },
      { id: 528421, name: "Padsul" },
      { id: 528464, name: "Pahurjira Bhag 1" },
      { id: 945039, name: "Pahurjira Bhag 2" },
      { id: 528416, name: "Pahurpurna" },
      { id: 528424, name: "Palodi" },
      { id: 528400, name: "Sagoda" },
      { id: 528446, name: "Sangwa" },
      { id: 528452, name: "Sawarna" },
      { id: 528432, name: "Shegaon Bhag 1" },
      { id: 945040, name: "Shegaon Bhag 2" },
      { id: 945044, name: "Shegaon Bhag 3" },
      { id: 945046, name: "Shegaon Bhag 4" },
      { id: 945047, name: "Shegaon Bhag 5" },
      { id: 528463, name: "Shelgaon Ujad" },
      { id: 528461, name: "Shirasgaon Nile" },
      { id: 528430, name: "Shrikshetra Nagzari" },
      { id: 528443, name: "Takali Dharav" },
      { id: 528454, name: "Takali Hat" },
      { id: 528437, name: "Takali Nagzari" },
      { id: 528453, name: "Takali Viro" },
      { id: 528469, name: "Taroda Kasaba" },
      { id: 528414, name: "Taroda Tarodi" },
      { id: 528465, name: "Tintrav" },
      { id: 528445, name: "Tivhan Bk." },
      { id: 528444, name: "Tivhan Kh." },
      { id: 528431, name: "Unhalkhed" },
      { id: 528405, name: "Waradh" },
      { id: 528436, name: "Warkhed Bk." },
      { id: 528462, name: "Warkhed Kh." },
      { id: 528468, name: "Warud" },
      { id: 528441, name: "Yeulkhed" },
      { id: 528425, name: "Zadegaon" },
    ],
    3978: [
      { id: 528512, name: "Ahmadpur" },
      { id: 528501, name: "Alampur" },
      { id: 528477, name: "Amboda" },
      { id: 528543, name: "Aurangapur" },
      { id: 528510, name: "Avdha Bk." },
      { id: 528506, name: "Avdha Kh." },
      { id: 528565, name: "Barafgaon" },
      { id: 528498, name: "Belad Pr.Jalgaon" },
      { id: 528570, name: "Belura" },
      { id: 528523, name: "Bhilvadi" },
      { id: 528545, name: "Bhogalwadi" },
      { id: 528567, name: "Bhorwand" },
      { id: 528471, name: "Bhota" },
      { id: 528511, name: "Bhuising" },
      { id: 528530, name: "Burti Pr.Chandur" },
      { id: 528544, name: "Burti Pr.Wadner" },
      { id: 528495, name: "Chandur Biswa" },
      { id: 528550, name: "Chinchkhed Pr.Malkapur" },
      { id: 528473, name: "Dadgaon" },
      { id: 528528, name: "Dahigaon" },
      { id: 528537, name: "Dahivadi" },
      { id: 528525, name: "Dhadi" },
      { id: 528558, name: "Dhanora Bk." },
      { id: 528559, name: "Dhanora Kh." },
      { id: 528533, name: "Dhanora Pr.Chandur" },
      { id: 528522, name: "Dighi" },
      { id: 528571, name: "Dolkhed" },
      { id: 528573, name: "Fuli" },
      { id: 528526, name: "Ghordhadi" },
      { id: 528540, name: "Gondhankhed" },
      { id: 528580, name: "Gosing" },
      { id: 528493, name: "Hingana Ujad" },
      { id: 528488, name: "Hingane Gavhad" },
      { id: 528472, name: "Hingna Bhota" },
      { id: 528475, name: "Hingne Dadgaon" },
      { id: 528474, name: "Hingne Isapur" },
      { id: 528529, name: "Isabpur" },
      { id: 528476, name: "Isapur" },
      { id: 528480, name: "Isarkheda" },
      { id: 528569, name: "Jawala Bazar" },
      { id: 528483, name: "Jigaon" },
      { id: 528575, name: "Kandari Bk." },
      { id: 528576, name: "Kandari Kh." },
      { id: 528535, name: "Kati" },
      { id: 528538, name: "Kedar" },
      { id: 528563, name: "Khadadgaon" },
      { id: 528574, name: "Khaira" },
      { id: 528554, name: "Khandala" },
      { id: 528497, name: "Kharkundi" },
      { id: 528519, name: "Khatkhed" },
      { id: 528481, name: "Khedgaon" },
      { id: 528494, name: "Kherda" },
      { id: 528503, name: "Khudavantpur" },
      { id: 528527, name: "Khumgaon" },
      { id: 528485, name: "Kodarkhed" },
      { id: 528546, name: "Kokalwadi" },
      { id: 528541, name: "Kolasar" },
      { id: 528556, name: "Lonwadi Pr.Nandura" },
      { id: 528564, name: "Mahalungi Pr.Wadner" },
      { id: 528508, name: "Mahamdpur" },
      { id: 528557, name: "Malegaon Pr.P.Raja" },
      { id: 528487, name: "Mamulwadi" },
      { id: 528539, name: "Matoda" },
      { id: 528551, name: "Mendhali" },
      { id: 528500, name: "Modha" },
      { id: 528489, name: "Mominabad" },
      { id: 528566, name: "Muramba" },
      { id: 528536, name: "Naigaon" },
      { id: 528581, name: "Nandura Bk." },
      { id: 528513, name: "Nandura Kh." },
      { id: 528505, name: "Narakhed" },
      { id: 528509, name: "Narayanpur" },
      { id: 528504, name: "Nimgaon" },
      { id: 528484, name: "Palsoda" },
      { id: 528486, name: "Patonda" },
      { id: 528516, name: "Pimpalkhuta Dhande" },
      { id: 528549, name: "Pimpalkhuta Kh." },
      { id: 528547, name: "Pimpri Adhav" },
      { id: 528479, name: "Pimprikoli" },
      { id: 528552, name: "Pota" },
      { id: 528548, name: "Potali" },
      { id: 528507, name: "Rampur" },
      { id: 528534, name: "Rasulpur" },
      { id: 528517, name: "Rasulpur Pr.Raja" },
      { id: 528470, name: "Roti" },
      { id: 528515, name: "Sangawa" },
      { id: 528531, name: "Sanpudi" },
      { id: 528491, name: "Sawargaon Chahu" },
      { id: 528490, name: "Sawargaon Nehu" },
      { id: 528555, name: "Shelgaon Mukund" },
      { id: 528577, name: "Shemba Bk." },
      { id: 528578, name: "Shemba Kh." },
      { id: 528496, name: "Sirsodi" },
      { id: 528524, name: "Taka" },
      { id: 528572, name: "Takarkhed" },
      { id: 528482, name: "Takli (Watpal)" },
      { id: 528579, name: "Tandulwadi Pr.Rajur" },
      { id: 528568, name: "Tarwadi" },
      { id: 528542, name: "Tikodi" },
      { id: 528502, name: "Udaypur" },
      { id: 528521, name: "Vitali" },
      { id: 528518, name: "Wadali" },
      { id: 528492, name: "Wadgaon Dighi" },
      { id: 528520, name: "Wadgaon Pr.Raja" },
      { id: 528553, name: "Wadi Pr.Malkapur" },
      { id: 528514, name: "Wadi Pr.Wadner" },
      { id: 528532, name: "Wadner Bhag 1" },
      { id: 945032, name: "Wadner Bhag 2" },
      { id: 528562, name: "Walti Bk." },
      { id: 528561, name: "Walti Kh." },
      { id: 528560, name: "Wasadi Bk." },
      { id: 528478, name: "Wasadi Kh." },
      { id: 528499, name: "Yerali" },
    ],
    3979: [
      { id: 528636, name: "Aland" },
      { id: 528608, name: "Anurabad" },
      { id: 528621, name: "Bahapura" },
      { id: 528639, name: "Belad" },
      { id: 528649, name: "Bhadgani" },
      { id: 528625, name: "Bhalegaon" },
      { id: 528592, name: "Bhangura" },
      { id: 528590, name: "Chikhali" },
      { id: 528633, name: "Chinchkhed Bk." },
      { id: 528585, name: "Chinchol" },
      { id: 528596, name: "Dasarkhed" },
      { id: 528644, name: "Datala Bhag 1" },
      { id: 945006, name: "Datala Bhag 2" },
      { id: 528623, name: "Deodhaba" },
      { id: 528607, name: "Dharangaon" },
      { id: 528637, name: "Dudhalgaon Bk." },
      { id: 528583, name: "Dudhalgaon Kh." },
      { id: 528619, name: "Gadegaon" },
      { id: 528642, name: "Gahukhed" },
      { id: 528632, name: "Gaulkhed" },
      { id: 528641, name: "Ghirni Bhag 1" },
      { id: 945007, name: "Ghirni Bhag 2" },
      { id: 528603, name: "Ghodi" },
      { id: 528622, name: "Gorad" },
      { id: 528634, name: "Harankhed" },
      { id: 528601, name: "Harsoda" },
      { id: 528626, name: "Hingana Kazi" },
      { id: 528587, name: "Hingana Nagapur" },
      { id: 528604, name: "Hingane Dharangaon" },
      { id: 528614, name: "Jalalabad" },
      { id: 528631, name: "Jambhuldhaba" },
      { id: 528582, name: "Kalegaon" },
      { id: 528624, name: "Kamrdipur" },
      { id: 528627, name: "Khadki" },
      { id: 528629, name: "Khamkhed" },
      { id: 528620, name: "Khaparkhed" },
      { id: 528615, name: "Khokodi" },
      { id: 528586, name: "Korwad" },
      { id: 528611, name: "Kund Bk." },
      { id: 528612, name: "Kund Kh." },
      { id: 528606, name: "Lahe Kh." },
      { id: 528652, name: "Lasura" },
      { id: 528638, name: "Lonwadi" },
      { id: 528643, name: "Makner" },
      { id: 528613, name: "Malkapur Bhag 1" },
      { id: 945008, name: "Malkapur Bhag 2" },
      { id: 945009, name: "Malkapur Bhag 3" },
      { id: 528589, name: "Mhaiswadi" },
      { id: 528647, name: "Morkhed Bk." },
      { id: 528646, name: "Morkhed Kh." },
      { id: 528588, name: "Narwel Bhag 1" },
      { id: 945010, name: "Narwel Bhag 2" },
      { id: 528617, name: "Nimbari" },
      { id: 528605, name: "Nimboli" },
      { id: 528650, name: "Nimkhed Pr.Vadner" },
      { id: 528610, name: "Panhera" },
      { id: 528628, name: "Pimpalkhunta Mahadev" },
      { id: 528651, name: "Pimpalkhuta Pr.Vadner" },
      { id: 528594, name: "Rangaon" },
      { id: 528591, name: "Rantham" },
      { id: 528616, name: "Rastapur" },
      { id: 528654, name: "Sawali" },
      { id: 528645, name: "Shiradhon" },
      { id: 528602, name: "Shivni" },
      { id: 528597, name: "Talaswada" },
      { id: 528598, name: "Tandulwadi" },
      { id: 528599, name: "Telkhed" },
      { id: 528593, name: "Tighra" },
      { id: 528648, name: "Umali" },
      { id: 528635, name: "Wadji" },
      { id: 528609, name: "Wadoda" },
      { id: 528584, name: "Waghola" },
      { id: 528640, name: "Waghud" },
      { id: 528630, name: "Wajirabad" },
      { id: 528618, name: "Wakodi" },
      { id: 528653, name: "Warkhed" },
      { id: 528595, name: "Wiwara" },
      { id: 528600, name: "Zodga" },
    ],
    3980: [
      { id: 528753, name: "Advihir" },
      { id: 528735, name: "Ajadarad" },
      { id: 528736, name: "Antri" },
      { id: 528683, name: "Avhayunuspur" },
      { id: 528666, name: "Behardad" },
      { id: 528731, name: "Bhortek" },
      { id: 528737, name: "Borakhedi" },
      { id: 528668, name: "Bramhanda" },
      { id: 528693, name: "Chawarda" },
      { id: 528674, name: "Chinchkhed Kh." },
      { id: 528773, name: "Chinchkhed Nath" },
      { id: 528732, name: "Chinchpur" },
      { id: 528667, name: "Chunpimpri" },
      { id: 528718, name: "Dabha" },
      { id: 528679, name: "Dabhadi" },
      { id: 528684, name: "Dahigaon" },
      { id: 528665, name: "Dhamangaon Badhe Bhag 1" },
      { id: 945028, name: "Dhamangaon Badhe Bhag 2" },
      { id: 528770, name: "Dhamangaon Deshmukh" },
      { id: 528697, name: "Dhonkhed" },
      { id: 528751, name: "Didola Bk" },
      { id: 528750, name: "Didola Kh." },
      { id: 528702, name: "Dudhamal" },
      { id: 528704, name: "Fardapur" },
      { id: 528725, name: "Ghusar Bk." },
      { id: 528726, name: "Ghusar Kh." },
      { id: 528775, name: "Giroli" },
      { id: 528715, name: "Gotmara" },
      { id: 528660, name: "Gugali" },
      { id: 528710, name: "Gulbheli" },
      { id: 528701, name: "Hanwatkhed Gotmara" },
      { id: 528716, name: "Hanwatkhed Sarolapir" },
      { id: 528743, name: "Harmod" },
      { id: 528761, name: "Ibrahimpur" },
      { id: 528774, name: "Isalwadi" },
      { id: 528681, name: "Jahagirpur" },
      { id: 528758, name: "Jaipur" },
      { id: 528713, name: "Jamalpur" },
      { id: 528763, name: "Jamathi" },
      { id: 528759, name: "Januna" },
      { id: 528730, name: "Kabarkhed" },
      { id: 528767, name: "Kajampur" },
      { id: 528705, name: "Kalegaon" },
      { id: 528746, name: "Khadki" },
      { id: 528765, name: "Khairkhed" },
      { id: 528745, name: "Khamkhed" },
      { id: 528671, name: "Khandwa Bhag 1" },
      { id: 945029, name: "Khandwa Bhag 2" },
      { id: 528755, name: "Kharbadi" },
      { id: 528672, name: "Khedi" },
      { id: 528669, name: "Kinhola" },
      { id: 528689, name: "Kolhi Gawali" },
      { id: 528688, name: "Kolhi Golar" },
      { id: 528673, name: "Korhala" },
      { id: 528769, name: "Kothali" },
      { id: 528714, name: "Kurha" },
      { id: 528659, name: "Lapali" },
      { id: 528686, name: "Liha Bk." },
      { id: 528768, name: "Longhat" },
      { id: 528749, name: "Mahalpimpri" },
      { id: 528655, name: "Mahalungi Jahagir" },
      { id: 528691, name: "Makodi" },
      { id: 528675, name: "Malegaon" },
      { id: 528747, name: "Mohegaon" },
      { id: 528754, name: "Motala" },
      { id: 528740, name: "Murti" },
      { id: 943440, name: "Naik Nagar" },
      { id: 528717, name: "Nalkund" },
      { id: 528722, name: "Nhavi" },
      { id: 528662, name: "Nimkhalli" },
      { id: 528776, name: "Nimkhed" },
      { id: 528676, name: "Nipana" },
      { id: 528664, name: "Pangarkhed" },
      { id: 528670, name: "Panhera Khedi" },
      { id: 528738, name: "Parda" },
      { id: 528657, name: "Pimpalgaon Devi Bhag 1" },
      { id: 945030, name: "Pimpalgaon Devi Bhag 2" },
      { id: 528772, name: "Pimpalgaon Nath" },
      { id: 528728, name: "Pimpalpati" },
      { id: 528692, name: "Pimpri Gawali" },
      { id: 528698, name: "Pokhari" },
      { id: 528695, name: "Pophali" },
      { id: 528734, name: "Punhai" },
      { id: 528720, name: "Rahera" },
      { id: 528744, name: "Rajur" },
      { id: 528771, name: "Ramgaon" },
      { id: 943439, name: "Ridhora Jahagir" },
      { id: 528661, name: "Ridhora Khandopant" },
      { id: 528708, name: "Rohinkhed" },
      { id: 528764, name: "Sahastramuli" },
      { id: 528729, name: "Sanglad Pr.Rajur" },
      { id: 528699, name: "Sarola Maroti" },
      { id: 528700, name: "Sarola Pir" },
      { id: 528677, name: "Sawargaon Jahagir" },
      { id: 528709, name: "Shahapur" },
      { id: 528727, name: "Shelapur Bk." },
      { id: 528724, name: "Shelapur Kh" },
      { id: 528680, name: "Shelgaon Bajar" },
      { id: 528762, name: "Shirwa" },
      { id: 528658, name: "Sindkhed Lapali" },
      { id: 528687, name: "Sirmil" },
      { id: 528663, name: "Sonbarad Pr.Malkapur" },
      { id: 528711, name: "Sonbarad Pr.Rohinkhed" },
      { id: 528760, name: "Sultanpur" },
      { id: 528690, name: "Takli Pr.Malkapur" },
      { id: 528739, name: "Takli Pr.Rajur" },
      { id: 528748, name: "Talkhed" },
      { id: 528723, name: "Talni" },
      { id: 528706, name: "Tapowan" },
      { id: 528766, name: "Taroda" },
      { id: 528682, name: "Tembhi" },
      { id: 528707, name: "Thad" },
      { id: 528752, name: "Tighra" },
      { id: 528712, name: "Ubalkhed" },
      { id: 528685, name: "Urha" },
      { id: 528694, name: "Wadgaon Jamalpur" },
      { id: 528656, name: "Wadgaon Mahalungi" },
      { id: 528703, name: "Wadgaon Pr.Rohinkhed" },
      { id: 528696, name: "Wadi" },
      { id: 528741, name: "Waghjal" },
      { id: 528757, name: "Warud" },
      { id: 528742, name: "Waruli" },
      { id: 528678, name: "Yakatpur" },
    ],
    3981: [
      { id: 528921, name: "Aasa" },
      { id: 528896, name: "Adgaon" },
      { id: 528908, name: "Akoli" },
      { id: 528920, name: "Ambetakali" },
      { id: 528884, name: "Ambikapur" },
      { id: 528781, name: "Amsari" },
      { id: 528855, name: "Antraj Bhag 1" },
      { id: 944993, name: "Antraj Bhag 2" },
      { id: 528894, name: "Atali Bhag 1" },
      { id: 944994, name: "Atali Bhag 2" },
      { id: 528877, name: "Awar" },
      { id: 528846, name: "Belkhed" },
      { id: 528805, name: "Belura" },
      { id: 528827, name: "Bhalegaon" },
      { id: 528793, name: "Bhandari" },
      { id: 528839, name: "Bhendi" },
      { id: 528895, name: "Bori" },
      { id: 528791, name: "Borjawala" },
      { id: 528897, name: "Bothakaji" },
      { id: 528849, name: "Bothakoli" },
      { id: 528785, name: "Chikhali Bk." },
      { id: 528784, name: "Chikhali Kh." },
      { id: 528848, name: "Chinchkhed Band" },
      { id: 528914, name: "Chinchpur Bhag 1" },
      { id: 945175, name: "Chinchpur Bhag 2" },
      { id: 528883, name: "Chitoda" },
      { id: 528916, name: "Dadham" },
      { id: 528898, name: "Dastapur" },
      { id: 528901, name: "Deulkhed" },
      { id: 528832, name: "Dhapati" },
      { id: 528836, name: "Dhorapgaon" },
      { id: 528856, name: "Dhotra" },
      { id: 528842, name: "Divthana" },
      { id: 528778, name: "Dondwada" },
      { id: 528922, name: "Dudha" },
      { id: 528799, name: "Dyangangapur" },
      { id: 528915, name: "Fattepur" },
      { id: 528871, name: "Ganeshpur (Maharkhed)" },
      { id: 528818, name: "Garadgaon" },
      { id: 528919, name: "Gawandhala" },
      { id: 528861, name: "Geru" },
      { id: 528863, name: "Gerumatargaon" },
      { id: 528800, name: "Ghanegaon" },
      { id: 528909, name: "Gharod Bhag 1" },
      { id: 944995, name: "Gharod Bhag 2" },
      { id: 528814, name: "Ghatpuri" },
      { id: 528817, name: "Gondhanapur" },
      { id: 528786, name: "Hingana Umara" },
      { id: 528885, name: "Hingna Karegaon" },
      { id: 528859, name: "Hiwarkhed" },
      { id: 528831, name: "Hiwra Bk." },
      { id: 528796, name: "Hiwra Kh." },
      { id: 528795, name: "Iwara" },
      { id: 528810, name: "Jaipur Lande" },
      { id: 528806, name: "Jalaka Bhadang" },
      { id: 528857, name: "Jalka Teli" },
      { id: 528822, name: "Januna" },
      { id: 528925, name: "Jayramgad" },
      { id: 528891, name: "Kadamapur" },
      { id: 528841, name: "Kalegaon" },
      { id: 528904, name: "Kanchanpur" },
      { id: 528854, name: "Kanzara" },
      { id: 528881, name: "Karegaon Bk." },
      { id: 528892, name: "Karegaon Kh." },
      { id: 528825, name: "Kasarkhed" },
      { id: 528847, name: "Kawadgaon" },
      { id: 528866, name: "Khamgaon" },
      { id: 645605, name: "Khamgaon Gramin" },
      { id: 528906, name: "Kherdi" },
      { id: 528851, name: "Kherdi Ujad" },
      { id: 528779, name: "Kholkhed" },
      { id: 528815, name: "Khutpuri" },
      { id: 528858, name: "Kinhi Mahadeo" },
      { id: 528809, name: "Kokta" },
      { id: 528875, name: "Kolori" },
      { id: 528853, name: "Konti" },
      { id: 528826, name: "Kumbhephal" },
      { id: 528802, name: "Kurha" },
      { id: 528918, name: "Lakhanwada Bk." },
      { id: 528917, name: "Lakhanwada Kh." },
      { id: 528780, name: "Lanjud Bhag 1" },
      { id: 944996, name: "Lanjud Bhag 2" },
      { id: 528790, name: "Lasura Jahangir" },
      { id: 528873, name: "Lokhanda" },
      { id: 528899, name: "Loni Gurav" },
      { id: 528808, name: "Makta" },
      { id: 528816, name: "Mandaka" },
      { id: 528850, name: "Mandni" },
      { id: 528819, name: "Mathani" },
      { id: 528878, name: "Nagapur" },
      { id: 528869, name: "Nagzari Bk." },
      { id: 528870, name: "Nagzari Kh." },
      { id: 528844, name: "Nandri" },
      { id: 528905, name: "Naydevi" },
      { id: 528880, name: "Nilegaon" },
      { id: 528834, name: "Nimkawala" },
      { id: 528912, name: "Nimkhed" },
      { id: 528797, name: "Nipana" },
      { id: 528910, name: "Nirod" },
      { id: 528872, name: "Pala" },
      { id: 528889, name: "Palshi Bk" },
      { id: 528890, name: "Palshi Kh." },
      { id: 528803, name: "Parkhed Bhag 1" },
      { id: 944997, name: "Parkhed Bhag 2" },
      { id: 528886, name: "Patonda" },
      { id: 528888, name: "Pedka" },
      { id: 528838, name: "Pimpalchoch" },
      { id: 528798, name: "Pimpalgaon Raja Bhag 1" },
      { id: 945176, name: "Pimpalgaon Raja Bhag 2" },
      { id: 528874, name: "Pimprala" },
      { id: 528783, name: "Pimpri Deshmukh" },
      { id: 528924, name: "Pimpri Dhangar" },
      { id: 528876, name: "Pimpri Gawli" },
      { id: 528913, name: "Pimpri Korde" },
      { id: 528893, name: "Pimpri Mohadar" },
      { id: 528835, name: "Poraj" },
      { id: 528804, name: "Rahud" },
      { id: 528887, name: "Ramnagar" },
      { id: 528833, name: "Rohana" },
      { id: 528821, name: "Sajanpuri" },
      { id: 528788, name: "Sambhapur" },
      { id: 528852, name: "Sarola" },
      { id: 528813, name: "Sarola Ujad" },
      { id: 528828, name: "Sawargaon Bk." },
      { id: 528829, name: "Sawargaon Kh." },
      { id: 528903, name: "Sawarkhed" },
      { id: 528900, name: "Shahapur" },
      { id: 528824, name: "Shelodi" },
      { id: 528845, name: "Shendri" },
      { id: 528787, name: "Shendri (Sambhapur)" },
      { id: 528911, name: "Shirala" },
      { id: 528923, name: "Shirla Nemane" },
      { id: 528867, name: "Shridhar Nagar" },
      { id: 528820, name: "Sirasgaon Deshmukh" },
      { id: 528782, name: "Sujatpur" },
      { id: 528807, name: "Sutala Bk." },
      { id: 528812, name: "Sutala Kh." },
      { id: 528837, name: "Takli" },
      { id: 528830, name: "Tandulwadi" },
      { id: 528794, name: "Tarodanath" },
      { id: 528823, name: "Tembhurna" },
      { id: 528789, name: "Umara Lasura" },
      { id: 528792, name: "Umra" },
      { id: 528907, name: "Umra Atali" },
      { id: 528879, name: "Vihigaon Bhag 1" },
      { id: 528811, name: "Vihigaon Bhag 2" },
      { id: 528840, name: "Wadji" },
      { id: 528902, name: "Wahala Kh." },
      { id: 528862, name: "Waki" },
      { id: 528801, name: "Wakud" },
      { id: 528882, name: "Warkhed" },
      { id: 528843, name: "Warna" },
      { id: 528860, name: "Wazar" },
      { id: 528868, name: "Zodga" },
    ],
    3982: [
      { id: 529034, name: "Akola Thakare" },
      { id: 529025, name: "Andhrud" },
      { id: 529026, name: "Andhrudi" },
      { id: 529044, name: "Anjani Bk.Bhag 1" },
      { id: 945019, name: "Anjani Bu.Bhag 2" },
      { id: 529082, name: "Antri Deshmukh" },
      { id: 529031, name: "Aregaon" },
      { id: 529067, name: "Babhulkhed" },
      { id: 529069, name: "Badnapur" },
      { id: 528996, name: "Barda" },
      { id: 528977, name: "Bardapur" },
      { id: 529059, name: "Barhai" },
      { id: 529075, name: "Bartala" },
      { id: 529022, name: "Belgaon" },
      { id: 529060, name: "Bhalegaon" },
      { id: 529003, name: "Bhiwapur" },
      { id: 529002, name: "Bhosa" },
      { id: 529049, name: "Bhumra" },
      { id: 529057, name: "Bori" },
      { id: 528993, name: "Botha" },
      { id: 528936, name: "Brahmapuri" },
      { id: 529068, name: "Chaygaon" },
      { id: 529014, name: "Chinchala" },
      { id: 529079, name: "Chincholi Bore" },
      { id: 529072, name: "Chondi" },
      { id: 529080, name: "Dadulgavhan" },
      { id: 529021, name: "Degaon" },
      { id: 528962, name: "Delap" },
      { id: 528945, name: "Deulgaon Mali" },
      { id: 528984, name: "Deulgaon Sakarasha" },
      { id: 528953, name: "Dipkhed" },
      { id: 529029, name: "Dongaon Bhag 1" },
      { id: 945020, name: "Dongaon Bhag 2" },
      { id: 945021, name: "Dongaon Bhag 3" },
      { id: 945022, name: "Dongaon Bhag 4" },
      { id: 528994, name: "Drugbori" },
      { id: 528934, name: "Dudha" },
      { id: 529066, name: "Erandoli" },
      { id: 529076, name: "Faijalapur" },
      { id: 528939, name: "Gajarkhed" },
      { id: 529081, name: "Ganpur" },
      { id: 529000, name: "Garkhed" },
      { id: 529038, name: "Gawandhala" },
      { id: 529010, name: "Ghatbori" },
      { id: 528989, name: "Ghatnandra" },
      { id: 528978, name: "Ghonsar" },
      { id: 529052, name: "Ghordada" },
      { id: 528963, name: "Ghuti" },
      { id: 529028, name: "Gohogaon" },
      { id: 528998, name: "Gomedhar" },
      { id: 529007, name: "Hanwatkhed" },
      { id: 528942, name: "Hiwara Bk." },
      { id: 528960, name: "Hiwara Kh. Bhag 1" },
      { id: 945023, name: "Hiwara Khurd Bhag 2" },
      { id: 529033, name: "Hiwara Sable" },
      { id: 528926, name: "Hiwarkhed" },
      { id: 529078, name: "Jaitala" },
      { id: 529001, name: "Jambharun" },
      { id: 529050, name: "Jamgaon" },
      { id: 528967, name: "Janefal Bhag 1" },
      { id: 945024, name: "Janefal Bhag 2" },
      { id: 529015, name: "Januna" },
      { id: 528970, name: "Januna N.Shendla" },
      { id: 529032, name: "Jawala" },
      { id: 529039, name: "Kabra" },
      { id: 528959, name: "Kalambeshwar" },
      { id: 529071, name: "Kalapvihir" },
      { id: 529064, name: "Kalyana" },
      { id: 529065, name: "Kambarkhed" },
      { id: 529016, name: "Kanaka Bk." },
      { id: 529012, name: "Kanaka Kh." },
      { id: 529027, name: "Karhadwadi" },
      { id: 528955, name: "Kasarkhed" },
      { id: 529051, name: "Khamkhed" },
      { id: 529047, name: "Khanapur" },
      { id: 529046, name: "Khandala" },
      { id: 528957, name: "Khudnapur" },
      { id: 528952, name: "Koyali" },
      { id: 528931, name: "Lavhala" },
      { id: 529017, name: "Lawana" },
      { id: 528928, name: "Loni" },
      { id: 529018, name: "Loni Gavali Bhag 1" },
      { id: 945025, name: "Loni Gawali Bhag 2" },
      { id: 528997, name: "Loni Kale" },
      { id: 529030, name: "Madani" },
      { id: 528969, name: "Malegaon" },
      { id: 529084, name: "Malkhed" },
      { id: 528927, name: "Malkhed Ujad" },
      { id: 528979, name: "Mandwa S.Dongar" },
      { id: 528968, name: "Marotipeth" },
      { id: 943682, name: "Mehkar Bhag 1" },
      { id: 944294, name: "Mehkar Bhag 2" },
      { id: 528995, name: "Mel Janori" },
      { id: 528971, name: "Miskinwadi" },
      { id: 528946, name: "Mohadari" },
      { id: 528981, name: "Mohana Bk." },
      { id: 528975, name: "Mohana Kh." },
      { id: 528930, name: "Mohkhed" },
      { id: 529041, name: "Mola" },
      { id: 529042, name: "Moli" },
      { id: 528972, name: "Mosabewadi" },
      { id: 528964, name: "Mundefal" },
      { id: 529045, name: "Nagapur" },
      { id: 529005, name: "Nageshwadi" },
      { id: 528943, name: "Nagzari Bk." },
      { id: 528944, name: "Nagzari Kh." },
      { id: 528974, name: "Naigaon Dattapur" },
      { id: 528985, name: "Naigaon Deshmukh" },
      { id: 529037, name: "Nanaj" },
      { id: 529063, name: "Nandra N.Bhalegaon" },
      { id: 529070, name: "Nandra N.Chaygaon" },
      { id: 528999, name: "Nimba" },
      { id: 529058, name: "Pachala" },
      { id: 528988, name: "Pachdeval" },
      { id: 529062, name: "Palaskhed" },
      { id: 529035, name: "Palshi" },
      { id: 529023, name: "Pangarkhed" },
      { id: 528961, name: "Paradi" },
      { id: 529073, name: "Parda" },
      { id: 528983, name: "Parkhed" },
      { id: 529053, name: "Partapur" },
      { id: 528987, name: "Pathardi Ujad" },
      { id: 528933, name: "Pentakali" },
      { id: 528932, name: "Pimpalgaon Unda" },
      { id: 529040, name: "Pimpri Mali" },
      { id: 528938, name: "Pokhari" },
      { id: 528935, name: "Raipur" },
      { id: 529008, name: "Rajgad" },
      { id: 529004, name: "Ratnapur" },
      { id: 529036, name: "Ratnapur Bhosa" },
      { id: 529048, name: "Sabra" },
      { id: 529077, name: "Sarangpur" },
      { id: 528956, name: "Sarshiv" },
      { id: 528948, name: "Sawangi Mali" },
      { id: 528947, name: "Sawangiwir" },
      { id: 528973, name: "Sawatra" },
      { id: 529043, name: "Shahapur" },
      { id: 529019, name: "Shelgaon Deshmukh Bhag 1" },
      { id: 945026, name: "Shelgaon Deshmukh Bhag 2" },
      { id: 528941, name: "Shelgaon Kakde" },
      { id: 528976, name: "Shendla" },
      { id: 528940, name: "Shivaji Nagar" },
      { id: 529074, name: "Shivpuri" },
      { id: 528966, name: "Sonargavhan" },
      { id: 529056, name: "Sonati" },
      { id: 528951, name: "Subhanpur" },
      { id: 529055, name: "Sukali" },
      { id: 528965, name: "Sula" },
      { id: 529085, name: "Suryapur" },
      { id: 529061, name: "Takarkhed" },
      { id: 529006, name: "Tembhurkhed" },
      { id: 528958, name: "Thar Bardapur" },
      { id: 529083, name: "Turkhed" },
      { id: 529020, name: "Uddhava Vithalwadi" },
      { id: 529054, name: "Ukali" },
      { id: 529024, name: "Umara" },
      { id: 528954, name: "Usaran" },
      { id: 528991, name: "Uti" },
      { id: 529013, name: "Vishvi" },
      { id: 528937, name: "Vivekanand Nagar" },
      { id: 528990, name: "Wadali" },
      { id: 528949, name: "Wadgaon Mali" },
      { id: 528986, name: "Wagdeo" },
      { id: 528929, name: "Wardada" },
      { id: 528950, name: "Wardadi" },
      { id: 529011, name: "Warud" },
      { id: 528992, name: "Warwand" },
      { id: 529009, name: "Witkhed" },
    ],
    3983: [
      { id: 529118, name: "Ainkhed" },
      { id: 529203, name: "Ambashi Bhag 1" },
      { id: 944957, name: "Ambashi Bhag 2" },
      { id: 529119, name: "Amdapur Bhag 1" },
      { id: 944958, name: "Amdapur Bhag 2" },
      { id: 944959, name: "Amdapur Bhag 3" },
      { id: 529202, name: "Amkhed" },
      { id: 529215, name: "Amona" },
      { id: 529220, name: "Ancharwadi Bhag 1" },
      { id: 945053, name: "Ancharwadi Bhag 2" },
      { id: 529088, name: "Andhai" },
      { id: 529225, name: "Antri Khedekar" },
      { id: 529185, name: "Antri Koli" },
      { id: 529143, name: "Anwi" },
      { id: 529105, name: "Asola Naik" },
      { id: 529223, name: "Asola Pr.Kherda" },
      { id: 529124, name: "Babhulgaon" },
      { id: 529168, name: "Beldari" },
      { id: 529157, name: "Belkhed" },
      { id: 529198, name: "Berala" },
      { id: 529199, name: "Bhalgaon" },
      { id: 529195, name: "Bhankhed." },
      { id: 529222, name: "Bharosa Bhag 1" },
      { id: 945054, name: "Bharosa Bhag 2" },
      { id: 529189, name: "Bhogawati" },
      { id: 529191, name: "Bhokar" },
      { id: 529149, name: "Bhorsa" },
      { id: 529148, name: "Bhorsi" },
      { id: 529139, name: "Borakhedi" },
      { id: 529187, name: "Borala" },
      { id: 529087, name: "Borala Pra. Amdapur" },
      { id: 529141, name: "Borgaon Kakade Bhag 1" },
      { id: 944964, name: "Borgaon Kakade Bhag 2" },
      { id: 529170, name: "Borgaon Wasu" },
      { id: 529177, name: "Bramhapuri" },
      { id: 529206, name: "Chandanpur" },
      { id: 529160, name: "Chandhai" },
      { id: 529193, name: "Chandhai Pr.Chikhali" },
      { id: 645606, name: "Chikhali Bhag 1" },
      { id: 945055, name: "Chikhali Bhag 2" },
      { id: 529137, name: "Dahigaon" },
      { id: 529095, name: "Dasala" },
      { id: 529213, name: "Deulgaon Dhangar" },
      { id: 529151, name: "Dewadari" },
      { id: 529131, name: "Dhanori" },
      { id: 529159, name: "Dhodap" },
      { id: 529135, name: "Dhotra Bhangoji Bhag 1" },
      { id: 945056, name: "Dhotra Bhangoji Bhag 2" },
      { id: 529107, name: "Dhotra Naik" },
      { id: 529120, name: "Dhuma" },
      { id: 529167, name: "Diwathana" },
      { id: 529086, name: "Dongar Shewali" },
      { id: 529155, name: "Dongargaon" },
      { id: 529146, name: "Eklara" },
      { id: 529204, name: "Gangalgaon" },
      { id: 529117, name: "Ghanmod" },
      { id: 529162, name: "Girola" },
      { id: 529174, name: "Godri" },
      { id: 529111, name: "Gondhankhed" },
      { id: 529127, name: "Gondhankhed Pr. Amdapur" },
      { id: 529227, name: "Gunjala" },
      { id: 529121, name: "Haralkhed" },
      { id: 529092, name: "Harni" },
      { id: 529181, name: "Hatni" },
      { id: 529108, name: "Hiwara Naik" },
      { id: 529130, name: "Isoli Bhag 1" },
      { id: 944960, name: "Isoli Bhag 2" },
      { id: 529217, name: "Isrul" },
      { id: 529196, name: "Jambhora" },
      { id: 529150, name: "Jambhrun" },
      { id: 529102, name: "Jamdara" },
      { id: 529134, name: "Karankhed" },
      { id: 529116, name: "Karatwadi" },
      { id: 529122, name: "Karkheda" },
      { id: 529090, name: "Karwand Bhag 1" },
      { id: 945057, name: "Karwand Bhag 2" },
      { id: 529207, name: "Katoda" },
      { id: 529094, name: "Kavhala" },
      { id: 529205, name: "Kawathal" },
      { id: 529178, name: "Kelwad" },
      { id: 529201, name: "Khairav" },
      { id: 529110, name: "Khamkhed" },
      { id: 529172, name: "Khandala Makardhwaj" },
      { id: 529173, name: "Khor" },
      { id: 529109, name: "Kinhi Naik" },
      { id: 529098, name: "Kinhi Sawadad" },
      { id: 529176, name: "Kinhola" },
      { id: 529200, name: "Kolara Bhag 1" },
      { id: 944961, name: "Kolara Bhag 2" },
      { id: 529175, name: "Kolari" },
      { id: 529214, name: "Konad" },
      { id: 529156, name: "Kotkhed" },
      { id: 529099, name: "Kusumba" },
      { id: 529100, name: "Kusumbi" },
      { id: 529112, name: "Mahattamkhed" },
      { id: 529115, name: "Mahimal" },
      { id: 529209, name: "Malagi" },
      { id: 529182, name: "Malgani" },
      { id: 529186, name: "Malshemba" },
      { id: 529216, name: "Mangrul Pr Kherda" },
      { id: 529125, name: "Mangrur Nawghare" },
      { id: 529138, name: "Manmod" },
      { id: 529229, name: "Manubai" },
      { id: 529104, name: "Medsing" },
      { id: 529226, name: "Mera Bk. Bhag 1" },
      { id: 945174, name: "Mera Bk.Bhag 2" },
      { id: 529224, name: "Mera Kh." },
      { id: 529219, name: "Misalwadi Bhag 1" },
      { id: 944962, name: "Misalwali Bhag 2" },
      { id: 529103, name: "Mohadari" },
      { id: 529145, name: "Mungasari" },
      { id: 529132, name: "Mungi" },
      { id: 529210, name: "Muradpur" },
      { id: 529153, name: "Naigaon Bk." },
      { id: 529154, name: "Naigaon Kh." },
      { id: 529192, name: "Palaskhed Daulat" },
      { id: 529164, name: "Palaskhed Jayanti" },
      { id: 529158, name: "Palaskhed Sapkal" },
      { id: 529194, name: "Pambulwadi" },
      { id: 529140, name: "Pandhardeo" },
      { id: 529147, name: "Patoda" },
      { id: 529169, name: "Peth" },
      { id: 529228, name: "Pimpalwadi" },
      { id: 529123, name: "Pimparkhed" },
      { id: 529212, name: "Ramnagar" },
      { id: 529208, name: "Ranantri" },
      { id: 529211, name: "Rohada" },
      { id: 529188, name: "Sakegaon" },
      { id: 529180, name: "Satgaon Bhusari" },
      { id: 944963, name: "Sawana Bhag 2" },
      { id: 529152, name: "Sawangi Gawali Bhag 1" },
      { id: 944965, name: "Sawangi Gawali Bhag 2" },
      { id: 529183, name: "Sawargaon Dukare" },
      { id: 529128, name: "Sawarkhed Bk." },
      { id: 529129, name: "Sawarkhed Kh." },
      { id: 529113, name: "Sawarkhed Najik" },
      { id: 529161, name: "Sawna Bhag 1" },
      { id: 529218, name: "Shelgaon Atol" },
      { id: 529144, name: "Shelgaon Jahangir" },
      { id: 529133, name: "Shelodi" },
      { id: 529089, name: "Shelsur" },
      { id: 529165, name: "Shelud" },
      { id: 529171, name: "Shindi Harali" },
      { id: 529166, name: "Somthana" },
      { id: 529179, name: "Sonewadi" },
      { id: 529093, name: "Takarkhed Helga" },
      { id: 529114, name: "Takarkhed Musalman" },
      { id: 529190, name: "Tambulwadi" },
      { id: 529142, name: "Telhara" },
      { id: 529101, name: "Toranwada" },
      { id: 529096, name: "Udaynagar" },
      { id: 529136, name: "Utrada" },
      { id: 529097, name: "Vairagad" },
      { id: 529106, name: "Vardada" },
      { id: 529221, name: "Vasantnagar" },
      { id: 529184, name: "Waghapur" },
      { id: 529163, name: "Walti" },
      { id: 529126, name: "Warkhed" },
      { id: 529197, name: "Yewata" },
    ],
    3984: [
      { id: 529243, name: "Afjalpur" },
      { id: 529269, name: "Ajispur" },
      { id: 529250, name: "Ambhoda" },
      { id: 529280, name: "Antriteli" },
      { id: 529290, name: "Atakal" },
      { id: 529294, name: "Awalkhed" },
      { id: 529315, name: "Bhadgaon" },
      { id: 529266, name: "Bhadola" },
      { id: 529244, name: "Birsingpur" },
      { id: 529323, name: "Bodegaon" },
      { id: 529261, name: "Borkhed" },
      { id: 529306, name: "Borkhed (Dhad)" },
      { id: 529258, name: "Buldana" },
      { id: 529325, name: "Chandol Bhag 1" },
      { id: 944952, name: "Chandol Bhag 2" },
      { id: 529248, name: "Chautha" },
      { id: 529293, name: "Chikhala" },
      { id: 529247, name: "Dahid Bk." },
      { id: 529291, name: "Dahid Kh." },
      { id: 529305, name: "Dalsawangi" },
      { id: 529308, name: "Dasalwadi" },
      { id: 529242, name: "Dattapur" },
      { id: 529245, name: "Deulghat" },
      { id: 529230, name: "Devhari" },
      { id: 529292, name: "Devpur" },
      { id: 529304, name: "Dhad Bhag 1" },
      { id: 944956, name: "Dhad Bhag 2" },
      { id: 529302, name: "Dhamangaon" },
      { id: 529324, name: "Dhangarpur" },
      { id: 529309, name: "Domrul" },
      { id: 529277, name: "Dongar Khandala" },
      { id: 529297, name: "Dudha" },
      { id: 529307, name: "Ghatnandra" },
      { id: 529237, name: "Girda" },
      { id: 529264, name: "Gondankhed" },
      { id: 529235, name: "Gondhankhed Chautha" },
      { id: 529232, name: "Gummi" },
      { id: 529260, name: "Hanwatkhed" },
      { id: 529254, name: "Hatedi Bk." },
      { id: 529253, name: "Hatedi Kh." },
      { id: 529236, name: "Ijalapur" },
      { id: 529326, name: "Irala" },
      { id: 529252, name: "Ismailpur" },
      { id: 529298, name: "Jamathi" },
      { id: 529322, name: "Jamb" },
      { id: 529255, name: "Jambharun" },
      { id: 529233, name: "Januna" },
      { id: 529312, name: "Kardi" },
      { id: 529295, name: "Kesapur" },
      { id: 529275, name: "Kherdi" },
      { id: 529274, name: "Khupgaon" },
      { id: 529256, name: "Kolwad" },
      { id: 529320, name: "Kulamkhed" },
      { id: 529311, name: "Kumbefal" },
      { id: 529234, name: "Madh" },
      { id: 529267, name: "Malvihir" },
      { id: 529296, name: "Malwandi" },
      { id: 529301, name: "Masrul" },
      { id: 529284, name: "Matala" },
      { id: 529321, name: "Maundhala" },
      { id: 529238, name: "Merkhed" },
      { id: 529318, name: "Mhasla Bk." },
      { id: 529317, name: "Mhasla Kh." },
      { id: 529314, name: "Mohoj" },
      { id: 529268, name: "Nandrakoli" },
      { id: 529239, name: "Padli" },
      { id: 529287, name: "Palaskhed Bhat" },
      { id: 529241, name: "Palaskhed Nago" },
      { id: 529240, name: "Palaskhed Naik" },
      { id: 529263, name: "Paldhag" },
      { id: 944953, name: "Pangari Bhag 2" },
      { id: 529299, name: "Pangarkhed" },
      { id: 529282, name: "Pangri Bhag 1" },
      { id: 529286, name: "Pimpalgaon Sarai" },
      { id: 529265, name: "Pimparkhed" },
      { id: 529272, name: "Pokhari" },
      { id: 529288, name: "Raypur Bhag 1" },
      { id: 944954, name: "Raypur Bhag 2" },
      { id: 529316, name: "Ruikhed Mayamba" },
      { id: 529273, name: "Ruikhed Tekale" },
      { id: 529257, name: "Sagwan" },
      { id: 529279, name: "Sakhali Bk. Bhag 1" },
      { id: 944955, name: "Sakhali Bu.Bhag 2" },
      { id: 529278, name: "Sakhali Kh." },
      { id: 529319, name: "Satgaon (Mahsala)" },
      { id: 529271, name: "Sav" },
      { id: 529259, name: "Sawala" },
      { id: 529313, name: "Sawali" },
      { id: 529289, name: "Shekapur" },
      { id: 529281, name: "Shirpur" },
      { id: 529285, name: "Sindkhed" },
      { id: 529300, name: "Soyagaon" },
      { id: 529327, name: "Sundarkhed" },
      { id: 529310, name: "Takli" },
      { id: 529251, name: "Tandulwadi" },
      { id: 529231, name: "Taradkhed" },
      { id: 529262, name: "Tarapur" },
      { id: 529246, name: "Umala" },
      { id: 529283, name: "Umarkhed" },
      { id: 529303, name: "Warud" },
      { id: 529276, name: "Warwand" },
      { id: 529270, name: "Yelgaon" },
      { id: 529249, name: "Zari" },
    ],
    3985: [
      { id: 529364, name: "Aland" },
      { id: 529375, name: "Ambhora" },
      { id: 529329, name: "Andhera Bhag 1" },
      { id: 944985, name: "Andhera Bhag 2" },
      { id: 529365, name: "Asola Jahagir" },
      { id: 529330, name: "Baigaon Bk." },
      { id: 529337, name: "Baigaon Khurd" },
      { id: 529367, name: "Bamkhed" },
      { id: 529384, name: "Bhivgaon Bk." },
      { id: 529385, name: "Bhivgaon Kh." },
      { id: 529378, name: "Borakhedi Bawara" },
      { id: 529352, name: "Chinchkhed" },
      { id: 529368, name: "Chincholi Burkul" },
      { id: 529363, name: "Dagadwadi" },
      { id: 529343, name: "Deulgaon Mahi Bhag 1" },
      { id: 944987, name: "Deulgaon Mahi Bhag 2" },
      { id: 529381, name: "Deulgaon Raja" },
      { id: 529344, name: "Dhotra Nandai" },
      { id: 529349, name: "Digras Bk." },
      { id: 529350, name: "Digras Kh." },
      { id: 529338, name: "Dodra" },
      { id: 529357, name: "Doiphodewadi" },
      { id: 529359, name: "Gargundi" },
      { id: 529342, name: "Garkhed" },
      { id: 529386, name: "Giroli Bk." },
      { id: 529387, name: "Giroli Kh." },
      { id: 529389, name: "Golegaon" },
      { id: 529369, name: "Gondhankhed" },
      { id: 529379, name: "Jambhora" },
      { id: 529377, name: "Jawalkhed" },
      { id: 529383, name: "Jumda" },
      { id: 529331, name: "Khadka" },
      { id: 529353, name: "Khalyal Gavhan" },
      { id: 529356, name: "Kinhi Pawar" },
      { id: 529374, name: "Kumbhari" },
      { id: 529336, name: "Mandapgaon" },
      { id: 529360, name: "Mehuna Raja" },
      { id: 529332, name: "Mendgaon" },
      { id: 529346, name: "Nagangaon" },
      { id: 529348, name: "Narayankhed" },
      { id: 529371, name: "Nimgaon Guru" },
      { id: 529388, name: "Nimkhed" },
      { id: 529334, name: "Padali Shinde" },
      { id: 529391, name: "Palaskhed Malakdeo" },
      { id: 529366, name: "Palaskhed Zalta" },
      { id: 529358, name: "Pangri" },
      { id: 529370, name: "Pimpalgaon Bk." },
      { id: 529373, name: "Pimpalgaon Chilmkha" },
      { id: 529380, name: "Pimpalner" },
      { id: 529339, name: "Pimpri Andhale" },
      { id: 529362, name: "Rohana" },
      { id: 529382, name: "Saokhed Bhoi" },
      { id: 529347, name: "Saramba" },
      { id: 529372, name: "Savangi Tekade" },
      { id: 529335, name: "Sawkhed Nagre" },
      { id: 529328, name: "Sevanagar" },
      { id: 529333, name: "Shiwani Armal" },
      { id: 529355, name: "Singaon (Jahagir) Bhag 1" },
      { id: 944986, name: "Singaon (Jahangir) Bhag 2" },
      { id: 529354, name: "Sultanpur" },
      { id: 529345, name: "Sura" },
      { id: 529361, name: "Takarkhed Bhagile" },
      { id: 529351, name: "Takarkhed Vayal" },
      { id: 529390, name: "Tuljapur" },
      { id: 529376, name: "Umbarkhed" },
      { id: 529340, name: "Waki Bk." },
      { id: 529341, name: "Waki Kh." },
    ],
    3986: [
      { id: 529429, name: "Aagefal" },
      { id: 529473, name: "Adgaon Raja" },
      { id: 529421, name: "Ambewadi" },
      { id: 529492, name: "Anchali" },
      { id: 529418, name: "Balsamudra" },
      { id: 529424, name: "Barlinga" },
      { id: 529430, name: "Bhandari" },
      { id: 529501, name: "Bhosa" },
      { id: 529458, name: "Borakhedi Bk." },
      { id: 529483, name: "Borkhedi Jalal" },
      { id: 529477, name: "Borkhedi Kh." },
      { id: 529455, name: "Butta" },
      { id: 529453, name: "Changefal" },
      { id: 529499, name: "Chincholi Jahagir" },
      { id: 529404, name: "Daregaon" },
      { id: 529489, name: "Daregaon Shendurjan" },
      { id: 529494, name: "Dattapur" },
      { id: 529503, name: "Dawargaon" },
      { id: 529432, name: "Deulgaon Kol" },
      { id: 529448, name: "Devkhed" },
      { id: 529502, name: "Dhandarwadi" },
      { id: 529457, name: "Dhanora" },
      { id: 529423, name: "Dhoravi" },
      { id: 529442, name: "Dusarbid" },
      { id: 529399, name: "Ekamba" },
      { id: 529475, name: "Garkhed" },
      { id: 529407, name: "Goregaon" },
      { id: 529396, name: "Gunj" },
      { id: 529395, name: "Gunj Matha" },
      { id: 529415, name: "Hanwatkhed" },
      { id: 529482, name: "Hanwatkhed Malkapur Pangra" },
      { id: 529414, name: "Hiwara Gadling" },
      { id: 529439, name: "Hiwarkhed" },
      { id: 529420, name: "Jagdari" },
      { id: 529462, name: "Jalgaon" },
      { id: 529449, name: "Jambhora" },
      { id: 529443, name: "Jaulka" },
      { id: 529471, name: "Jaypur" },
      { id: 529431, name: "Kandari" },
      { id: 529425, name: "Keshav Shivani" },
      { id: 529435, name: "Khairav" },
      { id: 529454, name: "Khairkhed" },
      { id: 529495, name: "Khamgaon" },
      { id: 529467, name: "Kingaon Raja" },
      { id: 529434, name: "Konati" },
      { id: 529433, name: "Kumbefal" },
      { id: 529410, name: "Linga Bhag 1" },
      { id: 529447, name: "Linga Bhag 2" },
      { id: 529484, name: "Maharkhed" },
      { id: 529427, name: "Malkapur Pangra" },
      { id: 945050, name: "Malkapur Pangra Bhag 2" },
      { id: 529393, name: "Mohadi" },
      { id: 529405, name: "Nagzari" },
      { id: 529493, name: "Naiknagar" },
      { id: 529490, name: "Nasirabad" },
      { id: 529438, name: "Nimgaon Wayal" },
      { id: 529488, name: "Nimkhed" },
      { id: 529456, name: "Nimkhed Kasaba" },
      { id: 529464, name: "Palaskhed Chakka" },
      { id: 529486, name: "Pangarkhed" },
      { id: 529409, name: "Pangri Kate" },
      { id: 529468, name: "Pangri Ugale" },
      { id: 529446, name: "Pimpalgaon Kuda" },
      { id: 529465, name: "Pimpalgaon Lendi" },
      { id: 529403, name: "Pimpalgaon Sonara" },
      { id: 529463, name: "Pimpalkhuta" },
      { id: 529472, name: "Pimparkhed Bk." },
      { id: 529498, name: "Pimparkhed Kh." },
      { id: 529422, name: "Pophal Shivani" },
      { id: 529444, name: "Raheri Bk." },
      { id: 529440, name: "Raheri Kh." },
      { id: 529412, name: "Rajegaon" },
      { id: 529392, name: "Ratali" },
      { id: 529451, name: "Rumhana" },
      { id: 529401, name: "Sakharkherda" },
      { id: 945051, name: "Sakharkherda Bhag 2" },
      { id: 529469, name: "Sarkhed" },
      { id: 529459, name: "Sathegaon" },
      { id: 529394, name: "Sawadad" },
      { id: 529400, name: "Sawangi Bhagat" },
      { id: 529491, name: "Sawargaon Mal" },
      { id: 529481, name: "Sawkhed Tejan" },
      { id: 529411, name: "Sayala" },
      { id: 529466, name: "Shelgaon Raut" },
      { id: 529500, name: "Shelu" },
      { id: 529416, name: "Shendurjan" },
      { id: 945052, name: "Shendurjan Bhag 2" },
      { id: 529398, name: "Shevaga Jahagir" },
      { id: 529402, name: "Shindi" },
      { id: 529476, name: "Shirner" },
      { id: 529419, name: "Shivni Kankal" },
      { id: 529487, name: "Shivni Taka" },
      { id: 944219, name: "Sindkhed Raja Bhag 2" },
      { id: 944218, name: "Sindkhedraja" },
      { id: 529478, name: "Sonoshi" },
      { id: 529450, name: "Soyandeo" },
      { id: 529497, name: "Sulajgaon" },
      { id: 529441, name: "Tadhegaon" },
      { id: 529445, name: "Tadshivani" },
      { id: 529406, name: "Tandulwadi Khamgaon" },
      { id: 529452, name: "Tandulwadi Rumhana" },
      { id: 529485, name: "Tandulwadi Sakharkherda" },
      { id: 529480, name: "Ugala" },
      { id: 529408, name: "Umangaon" },
      { id: 529470, name: "Umrad" },
      { id: 529504, name: "Vasant Nagar" },
      { id: 529460, name: "Vizora" },
      { id: 529474, name: "Wadali" },
      { id: 529413, name: "Waghala" },
      { id: 529461, name: "Waghjai" },
      { id: 529496, name: "Waghora" },
      { id: 529436, name: "Waghrul" },
      { id: 529437, name: "Wakad Jahagir" },
      { id: 529479, name: "Wardadi Bk." },
      { id: 529426, name: "Wardadi Kh." },
      { id: 529397, name: "Warudi" },
      { id: 529428, name: "Zotinga" },
    ],
    3987: [
      { id: 529574, name: "Ajispur" },
      { id: 529569, name: "Ambhora" },
      { id: 529538, name: "Anjani Khurd" },
      { id: 529579, name: "Ardav" },
      { id: 529553, name: "Bagulkhed" },
      { id: 529534, name: "Banda" },
      { id: 529533, name: "Bhanapur" },
      { id: 529586, name: "Bhiwapur" },
      { id: 529525, name: "Bhumrala" },
      { id: 529506, name: "Bibi" },
      { id: 529526, name: "Bibkhed" },
      { id: 529545, name: "Borkhedi" },
      { id: 529508, name: "Bramhan Chikna" },
      { id: 529517, name: "Chikhala" },
      { id: 529565, name: "Chincholi Sangle" },
      { id: 529519, name: "Chorpangra" },
      { id: 529580, name: "Dabha" },
      { id: 529564, name: "Deulgaon Kundpal" },
      { id: 529577, name: "Deulgaon Waisa" },
      { id: 529522, name: "Devanagar" },
      { id: 529589, name: "Dhad" },
      { id: 529531, name: "Dhanora" },
      { id: 529566, name: "Dhayfal" },
      { id: 529592, name: "Gandhari" },
      { id: 529559, name: "Gaykhed" },
      { id: 529576, name: "Gotra" },
      { id: 529520, name: "Govardhan Nagar" },
      { id: 529552, name: "Gundha" },
      { id: 529529, name: "Gunjapur" },
      { id: 529554, name: "Gunjkhed" },
      { id: 529516, name: "Hatta" },
      { id: 529572, name: "Hirdav" },
      { id: 529515, name: "Hiwara Khand" },
      { id: 529573, name: "Jafrabad" },
      { id: 529578, name: "Jambul" },
      { id: 529550, name: "Kamaljapur" },
      { id: 529512, name: "Karegaon" },
      { id: 529527, name: "Kasari" },
      { id: 529581, name: "Kaulkhed" },
      { id: 529511, name: "Khalegaon" },
      { id: 529518, name: "Khandala" },
      { id: 529509, name: "Khaparkhed" },
      { id: 529588, name: "Khurampur" },
      { id: 529521, name: "Kingaon Jattu" },
      { id: 529563, name: "Kinhi" },
      { id: 529556, name: "Koyali" },
      { id: 529570, name: "Kundlas" },
      { id: 944211, name: "Lonar Bhag 1" },
      { id: 944212, name: "Lonar Bhag 2" },
      { id: 529594, name: "Madhi" },
      { id: 529510, name: "Maharchikna" },
      { id: 529505, name: "Mandwa" },
      { id: 529546, name: "Matarkhed" },
      { id: 529561, name: "Matmal" },
      { id: 529547, name: "Mohotkhed" },
      { id: 529591, name: "Nandra" },
      { id: 529535, name: "Narsapur" },
      { id: 529548, name: "Nijampur" },
      { id: 529555, name: "Pahur" },
      { id: 529551, name: "Palaskhed" },
      { id: 529575, name: "Pangra Dole" },
      { id: 529568, name: "Parda Pr.Lonar" },
      { id: 529544, name: "Pardi Pr.Lonar" },
      { id: 529543, name: "Pardi Pr.Mehkar" },
      { id: 529585, name: "Pathra" },
      { id: 529557, name: "Pimpalkhuta" },
      { id: 529571, name: "Pimpalner" },
      { id: 529507, name: "Pimpri Khandare" },
      { id: 529590, name: "Raigaon" },
      { id: 529532, name: "Rajni" },
      { id: 529560, name: "Sarasawati" },
      { id: 529593, name: "Sawargaon Mundhe" },
      { id: 529524, name: "Sawargaon Teli" },
      { id: 529558, name: "Shara" },
      { id: 529514, name: "Shindi" },
      { id: 529530, name: "Shivani Pisa" },
      { id: 529584, name: "Shivni Jat" },
      { id: 529513, name: "Somthana" },
      { id: 529583, name: "Sonuna" },
      { id: 529536, name: "Sultanpur" },
      { id: 529562, name: "Tambola" },
      { id: 529542, name: "Tandulwadi" },
      { id: 529587, name: "Titavi" },
      { id: 529540, name: "Udanapur" },
      { id: 529523, name: "Vasantnagar" },
      { id: 529541, name: "Wadgaon Tejan" },
      { id: 529582, name: "Wadhav" },
      { id: 529539, name: "Walhur" },
      { id: 529528, name: "Wazar" },
      { id: 529549, name: "Weni Bhag 1" },
      { id: 945003, name: "Weni Bhag 2" },
      { id: 529537, name: "Yesapur" },
      { id: 529567, name: "Yevti" },
    ],
    3988: [
      { id: 529631, name: "Adgaon Budruk" },
      { id: 529687, name: "Adsul" },
      { id: 529636, name: "Akoli Ruprao" },
      { id: 529643, name: "Atkali" },
      { id: 529682, name: "Babhulgaon" },
      { id: 529605, name: "Badkhed" },
      { id: 529688, name: "Bambarda Khurd" },
      { id: 531592, name: "Barukheda" },
      { id: 529648, name: "Belkhed" },
      { id: 529659, name: "Bhamberi" },
      { id: 529619, name: "Bhili" },
      { id: 529639, name: "Bhokar" },
      { id: 529624, name: "Borvha" },
      { id: 529618, name: "Chandanpur" },
      { id: 529645, name: "Changalwadi" },
      { id: 529641, name: "Chapaner" },
      { id: 529601, name: "Chichari" },
      { id: 529621, name: "Chipi" },
      { id: 529626, name: "Chitalwadi" },
      { id: 529671, name: "Dahigaon" },
      { id: 529616, name: "Danapur" },
      { id: 529673, name: "Dapura" },
      { id: 529686, name: "Davala" },
      { id: 529620, name: "Dhonda Akhar" },
      { id: 529600, name: "Diwanzari" },
      { id: 529656, name: "Gadegaon" },
      { id: 529650, name: "Ghodegaon" },
      { id: 529613, name: "Gordha" },
      { id: 529617, name: "Hayatpur" },
      { id: 529614, name: "Hingani Budruk" },
      { id: 529615, name: "Hingani Khurd" },
      { id: 529603, name: "Hiwarkhed Bhag 1" },
      { id: 944402, name: "Hiwarkhed Bhag 2" },
      { id: 529664, name: "Isapur" },
      { id: 529666, name: "Jafrapur" },
      { id: 529658, name: "Jastagaon" },
      { id: 529611, name: "Kalamkhed" },
      { id: 529637, name: "Kalegaon" },
      { id: 529622, name: "Karhi Pr. Adgaon" },
      { id: 529623, name: "Karhi Rupagad" },
      { id: 529604, name: "Karla Budruk" },
      { id: 529691, name: "Khakata" },
      { id: 529625, name: "Khandala" },
      { id: 529660, name: "Khaparkhed" },
      { id: 529675, name: "Khel Mukardam" },
      { id: 529677, name: "Kheldeshpande" },
      { id: 529674, name: "Khelkrushnaji" },
      { id: 529689, name: "Khelsatwaji" },
      { id: 529647, name: "Kotha" },
      { id: 529633, name: "Malegaon" },
      { id: 529652, name: "Malegaon Bazar" },
      { id: 529635, name: "Malpura" },
      { id: 529630, name: "Malthana Budruk" },
      { id: 529629, name: "Malthana Khurd" },
      { id: 943520, name: "Mamdabad" },
      { id: 529672, name: "Manabda" },
      { id: 529679, name: "Manatri Budruk" },
      { id: 529678, name: "Manatri Khurd" },
      { id: 529628, name: "Mehkhed" },
      { id: 529602, name: "Moradi" },
      { id: 529597, name: "Moypani" },
      { id: 529690, name: "Narsipur" },
      { id: 529693, name: "Ner" },
      { id: 529680, name: "Nimbhora Budruk" },
      { id: 529669, name: "Nimbhora Khurd" },
      { id: 529644, name: "Nimboli" },
      { id: 943517, name: "Nurabad" },
      { id: 529609, name: "Parasharampur." },
      { id: 529640, name: "Pathardi Bhag 1" },
      { id: 944404, name: "Pathardi Bhag 2" },
      { id: 529596, name: "Pimparkhed" },
      { id: 529681, name: "Piwandal Budruk" },
      { id: 529694, name: "Piwandal Khurd" },
      { id: 529646, name: "Raikhed" },
      { id: 529657, name: "Ranegaon" },
      { id: 529627, name: "Sadarpur" },
      { id: 529695, name: "Sangavi" },
      { id: 943514, name: "Satkabad" },
      { id: 529607, name: "Saundala" },
      { id: 529651, name: "Sheri Budruk" },
      { id: 529653, name: "Sheri Khurd" },
      { id: 529654, name: "Sheri Pra.Wadner" },
      { id: 529632, name: "Shivaji Nagar" },
      { id: 529638, name: "Sirsoli" },
      { id: 529655, name: "Sonkel" },
      { id: 529608, name: "Sonwadi" },
      { id: 529642, name: "Takali" },
      { id: 529612, name: "Talegaon Budruk" },
      { id: 529610, name: "Talegaon Khurd" },
      { id: 529684, name: "Talegaon Paturda" },
      { id: 529685, name: "Talegaon Pr.Wadner" },
      { id: 943523, name: "Telhara Budruk" },
      { id: 943522, name: "Telhara Khurd" },
      { id: 529661, name: "Thar" },
      { id: 529662, name: "Tudgaon" },
      { id: 529676, name: "Ubarkhed" },
      { id: 529667, name: "Ukali Bajar" },
      { id: 529598, name: "Umarshevadi" },
      { id: 529692, name: "Umri" },
      { id: 529670, name: "Wadgaon Rothe" },
      { id: 529665, name: "Wadi Adampur" },
      { id: 529683, name: "Wagargaon" },
      { id: 529663, name: "Wakodi" },
      { id: 529595, name: "Wari Bhairavgad" },
      { id: 529606, name: "Warkhed" },
      { id: 529649, name: "Warud Bk." },
      { id: 529634, name: "Warud Kh." },
      { id: 529668, name: "Warud Wadner" },
      { id: 529599, name: "Zari Bazar" },
    ],
    3989: [
      { id: 529734, name: "Adgaon Kh." },
      { id: 529863, name: "Agaskhed" },
      { id: 529764, name: "Akoli Jahangir" },
      { id: 529765, name: "Akolkhed" },
      { id: 943494, name: "Akot Bhag 1" },
      { id: 944361, name: "Akot Bhag 2" },
      { id: 529707, name: "Alampur" },
      { id: 529813, name: "Alegaon" },
      { id: 529826, name: "Alewadi" },
      { id: 529812, name: "Alyarpur" },
      { id: 529757, name: "Ambadi" },
      { id: 529711, name: "Amboda" },
      { id: 529740, name: "Aminapur" },
      { id: 921273, name: "Amona" },
      { id: 529832, name: "Andh" },
      { id: 529794, name: "Asegaon Bajar" },
      { id: 529706, name: "Aurangabad" },
      { id: 529785, name: "Aurangabad Pr. Akot" },
      { id: 529814, name: "Balegaon" },
      { id: 529820, name: "Bambarda Bu." },
      { id: 529742, name: "Bandhara" },
      { id: 529721, name: "Belura" },
      { id: 529755, name: "Bhilkhed" },
      { id: 529868, name: "Bhod" },
      { id: 529762, name: "Bochara" },
      { id: 529713, name: "Bordi" },
      { id: 529875, name: "Bori" },
      { id: 529753, name: "Chandanpur Tirwari" },
      { id: 529772, name: "Chandikapur" },
      { id: 529787, name: "Chapaner" },
      { id: 529747, name: "Chichpani" },
      { id: 529725, name: "Chinchkhed Bu." },
      { id: 529738, name: "Chinchkhed Khurd" },
      { id: 529771, name: "Chinchkheda Kh." },
      { id: 529862, name: "Chohotta" },
      { id: 529719, name: "Chorwad Bk" },
      { id: 529716, name: "Chorwad Kh" },
      { id: 529700, name: "Dahikhel Futkar" },
      { id: 529748, name: "Dangarkhed" },
      { id: 529844, name: "Danori" },
      { id: 529728, name: "Dautpur" },
      { id: 529825, name: "Deori" },
      { id: 529833, name: "Deulgaon" },
      { id: 529776, name: "Devulgaon" },
      { id: 529845, name: "Dewarda" },
      { id: 529779, name: "Dhaga" },
      { id: 529852, name: "Dhamana Bk" },
      { id: 529774, name: "Dhamangaon" },
      { id: 529791, name: "Dhangarwadi" },
      { id: 917393, name: "Dharagad" },
      { id: 529859, name: "Dharel" },
      { id: 529828, name: "Dinoda" },
      { id: 529769, name: "Diwthana" },
      { id: 529717, name: "Edlapur" },
      { id: 529809, name: "Fattepur" },
      { id: 529744, name: "Gajipur" },
      { id: 529838, name: "Garsoli" },
      { id: 529763, name: "Gaulkhed" },
      { id: 529857, name: "Girjapur" },
      { id: 529720, name: "Gokhi" },
      { id: 917331, name: "Gullarghat" },
      { id: 529729, name: "Gyajuddin Nagar" },
      { id: 529847, name: "Hanwadi" },
      { id: 529839, name: "Hilalabad" },
      { id: 529831, name: "Isapur" },
      { id: 529727, name: "Jainpur Pimpri" },
      { id: 529732, name: "Jalgaon Nahate" },
      { id: 529746, name: "Januna" },
      { id: 529745, name: "Januna Bk" },
      { id: 529823, name: "Jaulka" },
      { id: 529871, name: "Jaulkhed Bk." },
      { id: 529855, name: "Jaulkhed Kh." },
      { id: 529704, name: "Jitapur Pr. Adgaon" },
      { id: 529705, name: "Jitapur Pr. Rupagad" },
      { id: 529786, name: "Jogban" },
      { id: 529799, name: "Kalwadi" },
      { id: 529789, name: "Kanheri" },
      { id: 529759, name: "Kapashi" },
      { id: 529798, name: "Karatwadi Aa." },
      { id: 529861, name: "Karatwadi Railway" },
      { id: 529860, name: "Karodi" },
      { id: 529708, name: "Kasod Shivpur" },
      { id: 529730, name: "Katkhed" },
      { id: 529795, name: "Kavatha Budruk" },
      { id: 529796, name: "Kavatha Khurd" },
      { id: 529836, name: "Kawasa Budruk" },
      { id: 529835, name: "Kawasa Khurd" },
      { id: 529870, name: "Keliweli" },
      { id: 531587, name: "Kelpani" },
      { id: 931658, name: "Kelpani Budruk" },
      { id: 943498, name: "Kemlapur" },
      { id: 529800, name: "Kesori" },
      { id: 529718, name: "Khairkhed" },
      { id: 529856, name: "Khanapur Budruk" },
      { id: 529788, name: "Khanapur Tryambakpur" },
      { id: 529815, name: "Khaparwadi Budruk" },
      { id: 529822, name: "Khaparwadi Khurd" },
      { id: 529701, name: "Khasbag" },
      { id: 529801, name: "Kherda" },
      { id: 529750, name: "Khirkund Budruk" },
      { id: 529749, name: "Khirkund Khurd" },
      { id: 529783, name: "Khudawantpur" },
      { id: 529869, name: "Kinkhed" },
      { id: 529874, name: "Koha" },
      { id: 529726, name: "Kolwihir" },
      { id: 529873, name: "Kund" },
      { id: 529837, name: "Kutasa Bhag 1" },
      { id: 944363, name: "Kutasa Bhag 2" },
      { id: 529723, name: "Ladegaon" },
      { id: 529784, name: "Lakhamapur" },
      { id: 529810, name: "Lamkani" },
      { id: 529739, name: "Lohari Budruk" },
      { id: 529741, name: "Lohari Kh." },
      { id: 529829, name: "Lotkhed" },
      { id: 529760, name: "Mahagaon" },
      { id: 529858, name: "Mahalaxmi" },
      { id: 529714, name: "Makrampur" },
      { id: 529697, name: "Malakapur Gound" },
      { id: 529698, name: "Malkapur Bhil" },
      { id: 529733, name: "Malkapur Pra.Adgaon" },
      { id: 529780, name: "Manchanpur" },
      { id: 529754, name: "Mankari" },
      { id: 529751, name: "Mardi Pr. Chinchona" },
      { id: 529752, name: "Mardi Pr. Khatkali" },
      { id: 529827, name: "Maroda" },
      { id: 529781, name: "Mirzapur" },
      { id: 529790, name: "Miyache Khede" },
      { id: 529782, name: "Mohala" },
      { id: 529819, name: "Mohammadpur" },
      { id: 529806, name: "Mundgaon" },
      { id: 529867, name: "Nakhegaon" },
      { id: 529865, name: "Nandkhed" },
      { id: 529766, name: "Narsingpur" },
      { id: 529807, name: "Naynapur" },
      { id: 529736, name: "Nevhori Bk." },
      { id: 529737, name: "Nevhori Kh." },
      { id: 529851, name: "Nijampur" },
      { id: 529842, name: "Palsod" },
      { id: 529768, name: "Panaj" },
      { id: 529843, name: "Panori" },
      { id: 529846, name: "Parala" },
      { id: 529854, name: "Patonda" },
      { id: 529841, name: "Patsul" },
      { id: 529866, name: "Pilakwadi" },
      { id: 529824, name: "Pimpri Dikkar" },
      { id: 529715, name: "Pimpri Kh." },
      { id: 529699, name: "Popatkhed" },
      { id: 529818, name: "Punda" },
      { id: 529702, name: "Rahnapur" },
      { id: 529735, name: "Rajegaon" },
      { id: 529758, name: "Rajura" },
      { id: 529849, name: "Rajurwadi" },
      { id: 529709, name: "Ramapur Dharur" },
      { id: 529793, name: "Rambhapur" },
      { id: 943501, name: "Ramtek" },
      { id: 529840, name: "Raundala" },
      { id: 529853, name: "Rel" },
      { id: 529830, name: "Rohankhed" },
      { id: 529756, name: "Rudhadi Pr. Chinchona" },
      { id: 529743, name: "Rudhadi Pr. Khatkali" },
      { id: 529761, name: "Ruikhed" },
      { id: 529864, name: "Salkhed" },
      { id: 529710, name: "Sarfabad" },
      { id: 529792, name: "Sawara" },
      { id: 529816, name: "Sawargaon" },
      { id: 529797, name: "Sawarkhed" },
      { id: 529696, name: "Shahanur" },
      { id: 943506, name: "Shahapur" },
      { id: 529811, name: "Shahapur Pr. Akot" },
      { id: 529767, name: "Shahapur Pr. Karla" },
      { id: 529703, name: "Shahapur Pr.Rupagad" },
      { id: 531590, name: "Somthana Budruk" },
      { id: 529802, name: "Sonbardi" },
      { id: 529712, name: "Sukali" },
      { id: 529808, name: "Sultanpur" },
      { id: 529777, name: "Tajnapur" },
      { id: 529848, name: "Takali Budruk" },
      { id: 529850, name: "Takali Kh." },
      { id: 529803, name: "Tandulwadi" },
      { id: 529834, name: "Taroda" },
      { id: 529872, name: "Thokbardi" },
      { id: 529722, name: "Umara" },
      { id: 529817, name: "Vitali" },
      { id: 529775, name: "Wadali Deshmukh" },
      { id: 529731, name: "Wadali Satwai" },
      { id: 529778, name: "Wadgaon Mendhe" },
      { id: 529773, name: "Waghoda" },
      { id: 529770, name: "Wai" },
      { id: 529805, name: "Wani" },
      { id: 529804, name: "Warula" },
      { id: 529821, name: "Warur" },
      { id: 529724, name: "Wasali Nagapur" },
    ],
    3990: [
      { id: 529923, name: "Adoshi" },
      { id: 529890, name: "Andura Bhag 1" },
      { id: 944367, name: "Andura Bhag 2" },
      { id: 529901, name: "Antri Malkapur" },
      { id: 943524, name: "Babhulkhed" },
      { id: 529897, name: "Bahadura" },
      { id: 529968, name: "Balhali" },
      { id: 529939, name: "Barlinga" },
      { id: 529959, name: "Batwadi Bk." },
      { id: 529958, name: "Batwadi Kh." },
      { id: 529973, name: "Bharatpur" },
      { id: 529950, name: "Bhikundkhed" },
      { id: 529895, name: "Bhortek" },
      { id: 529927, name: "Borala" },
      { id: 529892, name: "Borgaon Vairale" },
      { id: 529928, name: "Borwakadi" },
      { id: 529970, name: "Chincholi Ganu" },
      { id: 529938, name: "Dadham Bk." },
      { id: 529881, name: "Dagadkhed" },
      { id: 529947, name: "Dawalpur" },
      { id: 529962, name: "Degaon" },
      { id: 529969, name: "Dhadi" },
      { id: 529964, name: "Dhanegaon" },
      { id: 529926, name: "Dhanora" },
      { id: 529900, name: "Dongargaon" },
      { id: 529956, name: "Gademod" },
      { id: 943525, name: "Gajipur" },
      { id: 529931, name: "Gaygaon 1" },
      { id: 944374, name: "Gaygaon 2" },
      { id: 529921, name: "Hasnapur" },
      { id: 529889, name: "Hata 1" },
      { id: 944365, name: "Hata 2" },
      { id: 529906, name: "Hatrun" },
      { id: 529884, name: "Hingana Adsul" },
      { id: 529886, name: "Hingana Nimba" },
      { id: 529953, name: "Hingana Shelad" },
      { id: 529877, name: "Hingana Shikari" },
      { id: 529879, name: "Janorimael" },
      { id: 529943, name: "Jogalkhed" },
      { id: 529922, name: "Kadoshi" },
      { id: 529876, name: "Kajikhed" },
      { id: 529916, name: "Kalamba Budruk" },
      { id: 529914, name: "Kalamba Khurd" },
      { id: 529915, name: "Kalambi Mahagaon" },
      { id: 943526, name: "Kalbai" },
      { id: 529934, name: "Kanheri (Sarap)" },
      { id: 529894, name: "Karanja Ramjanpur" },
      { id: 943528, name: "Kasarkhed" },
      { id: 529949, name: "Kastkhed" },
      { id: 529918, name: "Kasura" },
      { id: 529898, name: "Kawatha" },
      { id: 529960, name: "Khamkhed" },
      { id: 529909, name: "Khandala" },
      { id: 529919, name: "Kharbi" },
      { id: 529940, name: "Khirpuri Bk." },
      { id: 529937, name: "Khirpuri Kh." },
      { id: 529945, name: "Kolasa" },
      { id: 529929, name: "Kumbhari" },
      { id: 529957, name: "Kupata" },
      { id: 529899, name: "Lohara 1" },
      { id: 944369, name: "Lohara 2" },
      { id: 944370, name: "Lohara 3" },
      { id: 529887, name: "Malkhed" },
      { id: 529907, name: "Malwada" },
      { id: 529961, name: "Manaki" },
      { id: 529930, name: "Manali" },
      { id: 529942, name: "Manarkhed" },
      { id: 529954, name: "Mandawa Bk." },
      { id: 529955, name: "Mandawa Kh." },
      { id: 529948, name: "Mandoli" },
      { id: 529908, name: "Manjari" },
      { id: 943527, name: "Modhapur" },
      { id: 529880, name: "Mokha" },
      { id: 529910, name: "Morgaon Sadijan" },
      { id: 529905, name: "Morzadi" },
      { id: 529882, name: "Nagad" },
      { id: 529972, name: "Nakashi" },
      { id: 529936, name: "Nandkhed" },
      { id: 529893, name: "Naya Andura" },
      { id: 529888, name: "Nimba" },
      { id: 529896, name: "Nimbi" },
      { id: 529925, name: "Nimkarda" },
      { id: 529941, name: "Onkarkhed" },
      { id: 529944, name: "Paras 1" },
      { id: 944378, name: "Paras 2" },
      { id: 529966, name: "Pimpalgaon" },
      { id: 529932, name: "Ridhora" },
      { id: 529883, name: "Sagad" },
      { id: 529963, name: "Sangwi Jomdeo" },
      { id: 529946, name: "Satargaon" },
      { id: 529913, name: "Sawarpati" },
      { id: 529951, name: "Shelad" },
      { id: 529902, name: "Shingoli" },
      { id: 529891, name: "Sonala" },
      { id: 529917, name: "Songiri" },
      { id: 529878, name: "Swarupkhed" },
      { id: 529952, name: "Takali Gademod" },
      { id: 529920, name: "Takali Khojbad" },
      { id: 529935, name: "Takali Kureshi" },
      { id: 529924, name: "Takali Nimkarda 1" },
      { id: 944372, name: "Takali Nimkarda 2" },
      { id: 529965, name: "Tamshi" },
      { id: 529967, name: "Tandali Tarfe Tulanga" },
      { id: 529904, name: "Ural Bk." },
      { id: 529903, name: "Ural Kh." },
      { id: 529933, name: "Vyala 1" },
      { id: 944376, name: "Vyala 2" },
      { id: 529971, name: "Wadegaon 1" },
      { id: 944380, name: "Wadegaon 2" },
      { id: 944381, name: "Wadegaon 3" },
      { id: 529885, name: "Wazegaon" },
      { id: 529911, name: "Zural Bk." },
      { id: 529912, name: "Zural Kh." },
    ],
    3991: [
      { id: 529995, name: "Agar Bhag 1" },
      { id: 944354, name: "Agar Bhag 2" },
      { id: 530046, name: "Akhatwada" },
      { id: 530136, name: "Akkalkot" },
      { id: 530142, name: "Akola" },
      { id: 530145, name: "Akoli Budruk" },
      { id: 530146, name: "Akoli Khurd" },
      { id: 530050, name: "Aliyabad" },
      { id: 530009, name: "Amanatpur" },
      { id: 530031, name: "Ambikapur" },
      { id: 530047, name: "Anakwadi" },
      { id: 530114, name: "Anvi" },
      { id: 530034, name: "Apatapa" },
      { id: 530042, name: "Apoti Budruk" },
      { id: 530035, name: "Apoti Khurd" },
      { id: 530111, name: "Babhulgaon" },
      { id: 529998, name: "Badlapur" },
      { id: 530070, name: "Bahadarpur" },
      { id: 530059, name: "Bahirkhed" },
      { id: 530010, name: "Bakharabad" },
      { id: 530126, name: "Bhaurad" },
      { id: 529999, name: "Bhod" },
      { id: 530074, name: "Birsingpur" },
      { id: 530110, name: "Bondarkhed Sisa" },
      { id: 530152, name: "Bondarkhed Ujad" },
      { id: 530100, name: "Borgaon Kh." },
      { id: 530113, name: "Borgaon Manju Bhag 1" },
      { id: 944358, name: "Borgaon Manju Bhag 2" },
      { id: 944359, name: "Borgaon Manju Bhag 3" },
      { id: 944360, name: "Borgaon Manju Bhag 4" },
      { id: 530017, name: "Bramhapuri" },
      { id: 530132, name: "Chachondi" },
      { id: 530099, name: "Chandaki" },
      { id: 529990, name: "Chandpur" },
      { id: 530150, name: "Chandur" },
      { id: 530151, name: "Changefal" },
      { id: 530163, name: "Chikhalgaon Bhag 1" },
      { id: 944351, name: "Chikhalgaon Bhag 2" },
      { id: 530125, name: "Dabaki" },
      { id: 530066, name: "Dahigaon Gavande" },
      { id: 530022, name: "Dahihanda" },
      { id: 530090, name: "Dalambi" },
      { id: 530101, name: "Dapaki Jahangir" },
      { id: 530032, name: "Dapura" },
      { id: 530095, name: "Devali" },
      { id: 530082, name: "Dhaga" },
      { id: 529974, name: "Dhamana" },
      { id: 530162, name: "Dhapshi" },
      { id: 530058, name: "Dhotardi" },
      { id: 530092, name: "Dodaki" },
      { id: 530116, name: "Dongargaon" },
      { id: 530027, name: "Donwada" },
      { id: 529985, name: "Dudhala" },
      { id: 530102, name: "Dudhalam" },
      { id: 530026, name: "Eklara" },
      { id: 529981, name: "Faramardabad" },
      { id: 529978, name: "Gandhigram" },
      { id: 530019, name: "Ganori" },
      { id: 530106, name: "Ghonga" },
      { id: 530049, name: "Ghusar Bhag 1" },
      { id: 944356, name: "Ghusar Bhag 2" },
      { id: 530039, name: "Ghusarwadi" },
      { id: 530033, name: "Gonapur" },
      { id: 530062, name: "Gondapur" },
      { id: 529977, name: "Gopalkhed" },
      { id: 530157, name: "Goregaon Bu." },
      { id: 530156, name: "Goregaon Khu." },
      { id: 529982, name: "Gotra" },
      { id: 530134, name: "Gudadhi" },
      { id: 529987, name: "Hatla" },
      { id: 530154, name: "Hingna Barlinga" },
      { id: 530079, name: "Hingna Jahangir" },
      { id: 530118, name: "Hingna Kumbhari" },
      { id: 530140, name: "Hingna Mhaispur" },
      { id: 530012, name: "Hingna Tamaswadi" },
      { id: 530021, name: "Hingni Bu." },
      { id: 530053, name: "Jalalabad" },
      { id: 530067, name: "Jalalpur" },
      { id: 530093, name: "Jawala Bu." },
      { id: 530098, name: "Jawala Khu." },
      { id: 530149, name: "Kalambeshwar" },
      { id: 530006, name: "Kanadi" },
      { id: 529996, name: "Kanchanpur" },
      { id: 530096, name: "Kanshiwani" },
      { id: 530161, name: "Kapashi Road" },
      { id: 530159, name: "Kapashi Talav" },
      { id: 530025, name: "Kapileshwar" },
      { id: 530029, name: "Kasali Bu." },
      { id: 530028, name: "Kasali Khu." },
      { id: 530068, name: "Kasampur" },
      { id: 530014, name: "Kati" },
      { id: 530023, name: "Katyar" },
      { id: 530030, name: "Kaulkhed" },
      { id: 530063, name: "Kaulkhed Gomase" },
      { id: 944352, name: "Kaulkhed Jahangir" },
      { id: 530071, name: "Khadka" },
      { id: 530169, name: "Khadki Bu." },
      { id: 530003, name: "Khadki Takali" },
      { id: 529983, name: "Khambora" },
      { id: 530020, name: "Khanapur" },
      { id: 530001, name: "Khanapur Ujad" },
      { id: 530130, name: "Kharap Bu." },
      { id: 530148, name: "Kharap Khu." },
      { id: 529993, name: "Khekadi" },
      { id: 530041, name: "Khobarkhed" },
      { id: 530089, name: "Kolambi" },
      { id: 530085, name: "Kothari" },
      { id: 530143, name: "Kumbhari" },
      { id: 530078, name: "Kurankhed" },
      { id: 530160, name: "Lakhanwada" },
      { id: 530040, name: "Lakhonda Bk." },
      { id: 530037, name: "Lakhonda Kh." },
      { id: 529986, name: "Lonagra" },
      { id: 530147, name: "Loni" },
      { id: 530065, name: "Mahadalpur" },
      { id: 530052, name: "Majalapur" },
      { id: 530168, name: "Malkapur" },
      { id: 529984, name: "Mandala" },
      { id: 530036, name: "Marodi" },
      { id: 530120, name: "Masa" },
      { id: 530158, name: "Mazod" },
      { id: 530051, name: "Mhaisang" },
      { id: 530153, name: "Mhaispur" },
      { id: 530038, name: "Mhatodi" },
      { id: 530080, name: "Mirzapur" },
      { id: 530115, name: "Mirzapur Anvi" },
      { id: 530011, name: "Morgaon Bhakare" },
      { id: 530061, name: "Mujare Mohamadpur" },
      { id: 530091, name: "Mustafapur" },
      { id: 530128, name: "Naigaon" },
      { id: 530094, name: "Nandapur" },
      { id: 529997, name: "Navathal" },
      { id: 530045, name: "Navkheda" },
      { id: 530013, name: "Nimbhora" },
      { id: 530155, name: "Nimbi Malokar" },
      { id: 530084, name: "Nipana" },
      { id: 529975, name: "Nirat" },
      { id: 530048, name: "Nirmalkhed" },
      { id: 530139, name: "Nizampur" },
      { id: 530131, name: "Pach Pimpal" },
      { id: 530081, name: "Pahadpur" },
      { id: 530077, name: "Pailpada" },
      { id: 530064, name: "Palaso Bk." },
      { id: 530072, name: "Palaso Kh." },
      { id: 529988, name: "Palodi" },
      { id: 529994, name: "Paritwada" },
      { id: 530015, name: "Pati" },
      { id: 530105, name: "Patur Nandapur" },
      { id: 530076, name: "Rajapur" },
      { id: 530075, name: "Rambhapur" },
      { id: 530060, name: "Ramgaon" },
      { id: 530016, name: "Rohana" },
      { id: 530056, name: "Sangalud Bk." },
      { id: 530057, name: "Sangalud Kh." },
      { id: 529989, name: "Sangavi Bu." },
      { id: 529980, name: "Sangavi Khu." },
      { id: 530002, name: "Sangavi Mohadi" },
      { id: 530103, name: "Santoshpur" },
      { id: 530069, name: "Shahapur" },
      { id: 530000, name: "Shahapur Ujad" },
      { id: 530135, name: "Shahnavajpur" },
      { id: 530043, name: "Shamabad" },
      { id: 530088, name: "Shekapur" },
      { id: 530104, name: "Shikhatkhed" },
      { id: 530007, name: "Shiloda" },
      { id: 530167, name: "Shivani" },
      { id: 530144, name: "Shivapur" },
      { id: 530166, name: "Shivar" },
      { id: 530109, name: "Sisa" },
      { id: 530117, name: "Sisa Udegaon" },
      { id: 530141, name: "Somthana" },
      { id: 530121, name: "Sonala" },
      { id: 530107, name: "Sonkhas" },
      { id: 530123, name: "Sukali" },
      { id: 530137, name: "Sukapur" },
      { id: 530005, name: "Sukoda" },
      { id: 530044, name: "Sultan Ajampur" },
      { id: 530008, name: "Takali Jalam" },
      { id: 530097, name: "Takli Pote" },
      { id: 530004, name: "Takoda" },
      { id: 530086, name: "Tamashi" },
      { id: 530073, name: "Tankhed" },
      { id: 530138, name: "Tapalabad" },
      { id: 529991, name: "Tarapur" },
      { id: 530108, name: "Telkhed" },
      { id: 529992, name: "Ugwa" },
      { id: 530122, name: "Ukli" },
      { id: 530164, name: "Umari Pragane Akola" },
      { id: 530129, name: "Umarkhed" },
      { id: 530165, name: "Umri Pragane Balapur" },
      { id: 530055, name: "Varodi" },
      { id: 530018, name: "Wadad Bk." },
      { id: 530024, name: "Wadad Kh." },
      { id: 529976, name: "Wairat Rajapur" },
      { id: 530127, name: "Wakapur" },
      { id: 530054, name: "Waki" },
      { id: 530087, name: "Walki" },
      { id: 529979, name: "Wallabh Nagar" },
      { id: 530083, name: "Wani" },
      { id: 530112, name: "Washimba" },
      { id: 530133, name: "Yawalkhed" },
      { id: 530124, name: "Yelwan" },
      { id: 530119, name: "Yeota" },
    ],
    3992: [
      { id: 530289, name: "Akoli Jahangir" },
      { id: 530269, name: "Aladatpur" },
      { id: 530260, name: "Allapur" },
      { id: 530209, name: "Amatwada" },
      { id: 530224, name: "Anbhora" },
      { id: 530302, name: "Arkhed" },
      { id: 530197, name: "Atkali." },
      { id: 530270, name: "Aurangpur" },
      { id: 530245, name: "Bahadarpur" },
      { id: 530314, name: "Balapur" },
      { id: 530237, name: "Ballarkhed" },
      { id: 530271, name: "Bapori" },
      { id: 530226, name: "Bhagora" },
      { id: 530176, name: "Bhatori" },
      { id: 530324, name: "Bidgaon" },
      { id: 530296, name: "Borgaon" },
      { id: 530235, name: "Borta" },
      { id: 530256, name: "Bramhi (Bai)" },
      { id: 530252, name: "Bramhi Budruk" },
      { id: 530255, name: "Bramhi Khurd" },
      { id: 530214, name: "Chikhali" },
      { id: 530244, name: "Chinchkhed" },
      { id: 530304, name: "Dahatonda" },
      { id: 530183, name: "Dapura" },
      { id: 530190, name: "Datala" },
      { id: 530178, name: "Datwi" },
      { id: 530205, name: "Deoran" },
      { id: 530291, name: "Dhamori Budruk" },
      { id: 530290, name: "Dhamori Khurd" },
      { id: 530306, name: "Dhanora Budruk" },
      { id: 530307, name: "Dhanora Khurd" },
      { id: 530329, name: "Dhanora Patekar" },
      { id: 530227, name: "Dhanora Waidya" },
      { id: 530316, name: "Dhotra Shinde" },
      { id: 530180, name: "Durgwada" },
      { id: 530299, name: "Fani" },
      { id: 530210, name: "Gajipur" },
      { id: 530288, name: "Ganeshpur" },
      { id: 530310, name: "Gaulkhed" },
      { id: 530268, name: "Gaulkhedi" },
      { id: 530173, name: "Ghungashi" },
      { id: 530247, name: "Girdharpur" },
      { id: 530332, name: "Gopalpur" },
      { id: 530212, name: "Goregaon" },
      { id: 530234, name: "Gunjwada" },
      { id: 530294, name: "Hamidpur" },
      { id: 530172, name: "Hasanapur" },
      { id: 530218, name: "Hatgaon" },
      { id: 530279, name: "Hayatpur" },
      { id: 530219, name: "Hendaj" },
      { id: 530201, name: "Hirpur" },
      { id: 530238, name: "Hiwara Korde" },
      { id: 530259, name: "Isafpur" },
      { id: 530192, name: "Jambha Budruk" },
      { id: 530194, name: "Jambha Khurd" },
      { id: 530285, name: "Jamthi Budruk" },
      { id: 530282, name: "Jamthi Khurd Aarkhed" },
      { id: 530303, name: "Jamthi Khurd Vadgaon" },
      { id: 530278, name: "Jethapur" },
      { id: 530258, name: "Jitapur" },
      { id: 530198, name: "Jitapur Nakat" },
      { id: 530213, name: "Kadwi" },
      { id: 530320, name: "Kamal Khed" },
      { id: 530321, name: "Kamalani" },
      { id: 530313, name: "Kamatha" },
      { id: 530319, name: "Kanadi" },
      { id: 530300, name: "Kanzara" },
      { id: 530292, name: "Karali" },
      { id: 530266, name: "Kasarkhed" },
      { id: 530215, name: "Kasawi" },
      { id: 530284, name: "Kautha Sopinath" },
      { id: 530231, name: "Kavatha Kholapur" },
      { id: 530318, name: "Kawhala" },
      { id: 530328, name: "Khandala" },
      { id: 530182, name: "Khaparwada" },
      { id: 530206, name: "Kharab Dhore" },
      { id: 530204, name: "Kharab Navale" },
      { id: 530203, name: "Kharbadi" },
      { id: 530274, name: "Khodad" },
      { id: 530187, name: "Khudavantpur" },
      { id: 530297, name: "Kinhi" },
      { id: 530323, name: "Kinkhed" },
      { id: 530233, name: "Kolsara" },
      { id: 530277, name: "Kurum 1" },
      { id: 944391, name: "Kurum 2" },
      { id: 530177, name: "Lait" },
      { id: 530179, name: "Lakhpuri" },
      { id: 530249, name: "Langhapur" },
      { id: 530312, name: "Lasnapur" },
      { id: 530301, name: "Lodhipur" },
      { id: 530232, name: "Lonsana" },
      { id: 530275, name: "Madhapuri" },
      { id: 530262, name: "Malakapur" },
      { id: 530248, name: "Mana" },
      { id: 530273, name: "Mandura" },
      { id: 530188, name: "Mangrul Kambe" },
      { id: 530202, name: "Matoda (Hendaj)" },
      { id: 530281, name: "Matoda (Vadgaon)" },
      { id: 530331, name: "Mirapur" },
      { id: 530257, name: "Mohabatpur" },
      { id: 530315, name: "Mohakhed" },
      { id: 530325, name: "Mozar" },
      { id: 530171, name: "Mungshi" },
      { id: 530305, name: "Muramba" },
      { id: 943529, name: "Murtijapur" },
      { id: 530264, name: "Nagoli" },
      { id: 530265, name: "Nagthana" },
      { id: 530243, name: "Nawasal" },
      { id: 530322, name: "Nimbha" },
      { id: 530220, name: "Palsoda" },
      { id: 530175, name: "Parad" },
      { id: 530326, name: "Pimpal Shenda" },
      { id: 530229, name: "Pingala" },
      { id: 530241, name: "Piwashi" },
      { id: 530239, name: "Pohi" },
      { id: 530240, name: "Pota" },
      { id: 530283, name: "Rajnapur Khinkhini" },
      { id: 530327, name: "Rajura Ghate" },
      { id: 530286, name: "Rajura Sarode" },
      { id: 530263, name: "Rambhapur" },
      { id: 530222, name: "Ramkhed" },
      { id: 530242, name: "Ramtek" },
      { id: 530261, name: "Rasulapur (Repadkhed)" },
      { id: 530186, name: "Rasulpur (Jamthi Bu)" },
      { id: 530195, name: "Repadkhed" },
      { id: 530236, name: "Rohana" },
      { id: 530250, name: "Sahadatpur" },
      { id: 530287, name: "Saidapur" },
      { id: 530185, name: "Sakhari" },
      { id: 530207, name: "Salatwada" },
      { id: 530208, name: "Samsherpur" },
      { id: 530174, name: "Sangwa" },
      { id: 530181, name: "Sangwi" },
      { id: 530225, name: "Sanjapur (Goregaon)" },
      { id: 530200, name: "Sanjapur (Hirpur)" },
      { id: 530230, name: "Shelu Bajar" },
      { id: 530189, name: "Shelu Najik" },
      { id: 530217, name: "Shelu Wetal" },
      { id: 530317, name: "Shend" },
      { id: 530298, name: "Sheni" },
      { id: 530223, name: "Sherwadi" },
      { id: 530308, name: "Shivan Kh." },
      { id: 530246, name: "Sikandarpur" },
      { id: 530199, name: "Siraso 1" },
      { id: 944389, name: "Siraso 2" },
      { id: 530251, name: "Sirtala" },
      { id: 530221, name: "Sonala" },
      { id: 530216, name: "Sonori" },
      { id: 530272, name: "Sonori (Bapori)" },
      { id: 530276, name: "Sultanpur (Karali)" },
      { id: 530293, name: "Sultanpur (Mana)" },
      { id: 530211, name: "Takli Gajipur" },
      { id: 530184, name: "Takwada." },
      { id: 530254, name: "Tipatala" },
      { id: 530311, name: "Turkhed" },
      { id: 530196, name: "Umai" },
      { id: 530309, name: "Umari" },
      { id: 530267, name: "Unkhed" },
      { id: 530170, name: "Virwada" },
      { id: 530280, name: "Wadgaon Kurum" },
      { id: 530253, name: "Waghajali" },
      { id: 530191, name: "Wahitpur" },
      { id: 530295, name: "Wai Mana" },
      { id: 530330, name: "Wirahit" },
      { id: 530193, name: "Yashwantpur" },
      { id: 530228, name: "Yendali" },
    ],
    3993: [
      { id: 530347, name: "Adgaon Khurd" },
      { id: 530406, name: "Agikhed" },
      { id: 530373, name: "Alegaon" },
      { id: 530364, name: "Ambashi" },
      { id: 530387, name: "Andhar Sangvi" },
      { id: 530367, name: "Asola" },
      { id: 530416, name: "Astul" },
      { id: 530400, name: "Babhali" },
      { id: 530399, name: "Babhulgaon" },
      { id: 530410, name: "Bagayat Patur" },
      { id: 530365, name: "Beltala" },
      { id: 530389, name: "Belura Budruk" },
      { id: 530390, name: "Belura Khurd" },
      { id: 530395, name: "Bhandaraj Budruk" },
      { id: 530397, name: "Bhandaraj Khurd" },
      { id: 530411, name: "Bhanos" },
      { id: 530422, name: "Bodkha" },
      { id: 530345, name: "Changefal" },
      { id: 530349, name: "Channi" },
      { id: 530363, name: "Charangaon" },
      { id: 530386, name: "Charmoli" },
      { id: 530344, name: "Chatari" },
      { id: 530379, name: "Chikhalwad" },
      { id: 530424, name: "Chinchkhed (Patur)" },
      { id: 530372, name: "Chinchkhed Pimpalkhuta" },
      { id: 530388, name: "Chinchkhed Sasti" },
      { id: 530385, name: "Chondhi" },
      { id: 530383, name: "Dadham" },
      { id: 530398, name: "Dadulgaon" },
      { id: 530402, name: "Deulgaon" },
      { id: 530342, name: "Digras Budruk" },
      { id: 530392, name: "Digras Kh." },
      { id: 530359, name: "Dolarkhed" },
      { id: 530370, name: "Gawandgaon" },
      { id: 530369, name: "Golegaon" },
      { id: 530426, name: "Gondhalwadi" },
      { id: 530391, name: "Hingana Wadegaon" },
      { id: 530351, name: "Hiwara" },
      { id: 530377, name: "Jamb" },
      { id: 530401, name: "Jambharun" },
      { id: 530403, name: "Jirayat Patur 1" },
      { id: 944399, name: "Jirayat Patur 2" },
      { id: 944400, name: "Jirayat Patur 3" },
      { id: 530407, name: "Joga Talav" },
      { id: 530420, name: "Kakadadari" },
      { id: 530368, name: "Karla" },
      { id: 530405, name: "Khamkhed" },
      { id: 530413, name: "Khanapur" },
      { id: 530374, name: "Khaparkhed" },
      { id: 530335, name: "Khetri" },
      { id: 530419, name: "Kosgaon" },
      { id: 530417, name: "Kothari Budruk" },
      { id: 530415, name: "Kothari Khurd" },
      { id: 530337, name: "Lavkhed" },
      { id: 530412, name: "Malakapur" },
      { id: 530425, name: "Malrajura" },
      { id: 530358, name: "Malsur" },
      { id: 530408, name: "Mauje Shiv" },
      { id: 530404, name: "Nandkhed" },
      { id: 530384, name: "Navegaon" },
      { id: 530340, name: "Nimkhed" },
      { id: 530376, name: "Pacharan" },
      { id: 530371, name: "Padsingi" },
      { id: 530366, name: "Palaskhed" },
      { id: 530382, name: "Pandhurna" },
      { id: 530357, name: "Pangara" },
      { id: 530354, name: "Pangartati" },
      { id: 530414, name: "Pardi" },
      { id: 530418, name: "Pastul" },
      { id: 530421, name: "Patti Amarai Patur" },
      { id: 530378, name: "Pimpaldoli" },
      { id: 530346, name: "Pimpalkhuta 1" },
      { id: 944397, name: "Pimpalkhuta 2" },
      { id: 530348, name: "Raher" },
      { id: 530338, name: "Sangola" },
      { id: 530343, name: "Sasti 1" },
      { id: 944395, name: "Sasti 2" },
      { id: 530353, name: "Sawargaon 1" },
      { id: 944393, name: "Sawargaon 2" },
      { id: 530427, name: "Sawarkhed" },
      { id: 530350, name: "Sayvani" },
      { id: 530375, name: "Shekapur" },
      { id: 530396, name: "Shirla" },
      { id: 530334, name: "Shirpur" },
      { id: 530381, name: "Sonuna" },
      { id: 530409, name: "Sotalwan" },
      { id: 530361, name: "Sukli" },
      { id: 530336, name: "Takali Khetri" },
      { id: 530393, name: "Tandali Budruk" },
      { id: 530394, name: "Tandali Kh." },
      { id: 530341, name: "Tulanga Budruk" },
      { id: 530339, name: "Tulanga Kh." },
      { id: 530352, name: "Umara" },
      { id: 530380, name: "Umarwadi" },
      { id: 530360, name: "Varangaon" },
      { id: 530356, name: "Vasali" },
      { id: 530362, name: "Vivara" },
      { id: 530333, name: "Wahala Budruk" },
      { id: 530355, name: "Zarandi" },
    ],
    3994: [
      { id: 530482, name: "Ajani Budruk" },
      { id: 530490, name: "Ajani Khurd" },
      { id: 530489, name: "Ajani Mahala" },
      { id: 530473, name: "Alanda" },
      { id: 530558, name: "Asartek" },
      { id: 530474, name: "Ashkaripur" },
      { id: 530480, name: "Ashrafpur" },
      { id: 530536, name: "Atkali Dhaba Mandal" },
      { id: 530497, name: "Atkali Kherda Mandal" },
      { id: 530477, name: "Bagayat Barshitakli" },
      { id: 530575, name: "Bahirkhed" },
      { id: 530430, name: "Bakharapur" },
      { id: 530476, name: "Barshitakali 1" },
      { id: 944385, name: "Barshitakali 2" },
      { id: 530448, name: "Belkhed" },
      { id: 530556, name: "Bhambora" },
      { id: 530479, name: "Bharatpur" },
      { id: 530513, name: "Bhedikaji" },
      { id: 530515, name: "Bhendgaon" },
      { id: 530517, name: "Bhendi Sutrak" },
      { id: 530516, name: "Bhendimahal" },
      { id: 530451, name: "Bormali" },
      { id: 530470, name: "Bramhandari" },
      { id: 530449, name: "Chelaka" },
      { id: 530521, name: "Chinchkhed" },
      { id: 530581, name: "Chinchkhed Bk." },
      { id: 530544, name: "Chincholi Devdari" },
      { id: 530438, name: "Chincholi Rudrayani" },
      { id: 530461, name: "Chohogaav" },
      { id: 530500, name: "Dagadparwa" },
      { id: 530509, name: "Dauchaka" },
      { id: 530547, name: "Devdari" },
      { id: 530454, name: "Dhaba" },
      { id: 530582, name: "Dhakali" },
      { id: 530459, name: "Dhamandari" },
      { id: 530548, name: "Dhanora" },
      { id: 530572, name: "Dharagiri" },
      { id: 530549, name: "Dhotarkhed" },
      { id: 530502, name: "Donad Budruk" },
      { id: 530504, name: "Donad Khurd" },
      { id: 530550, name: "Fetra" },
      { id: 530570, name: "Ghota" },
      { id: 530468, name: "Gorwha" },
      { id: 530527, name: "Haldoli" },
      { id: 530537, name: "Hatola" },
      { id: 530538, name: "Hirkani" },
      { id: 530487, name: "Isapur" },
      { id: 530534, name: "Jaanuna" },
      { id: 530435, name: "Jalalabad" },
      { id: 530457, name: "Jam Vasu" },
      { id: 530528, name: "Jambharun" },
      { id: 530583, name: "Jamkeshwar" },
      { id: 530445, name: "Januna" },
      { id: 530498, name: "Jogalkhed" },
      { id: 530506, name: "Kajaleshwar" },
      { id: 530463, name: "Kanheri Sarap" },
      { id: 530567, name: "Kardu" },
      { id: 530579, name: "Kasarkhed" },
      { id: 530552, name: "Kasmar" },
      { id: 530465, name: "Katkheda" },
      { id: 530456, name: "Khadaki" },
      { id: 530486, name: "Khambora" },
      { id: 530512, name: "Kherda Budruk" },
      { id: 530573, name: "Kherda Kh." },
      { id: 530554, name: "Khopadi" },
      { id: 530478, name: "Khori Khudavantpur" },
      { id: 530546, name: "Kinkhed" },
      { id: 530541, name: "Kothali Bk." },
      { id: 530462, name: "Kothali Kh." },
      { id: 530576, name: "Lakhamapur" },
      { id: 530453, name: "Lohgad" },
      { id: 530452, name: "Lohgad Tanda" },
      { id: 530495, name: "Mahagaon Dhaba Mandal" },
      { id: 530533, name: "Mahagaon Mahan Mandal" },
      { id: 530530, name: "Mahan" },
      { id: 530458, name: "Mandoli" },
      { id: 530441, name: "Mangrul" },
      { id: 530514, name: "Manmatkhed" },
      { id: 530496, name: "Mirzapur" },
      { id: 530557, name: "Morgaon Kakad" },
      { id: 530580, name: "Morhal" },
      { id: 530562, name: "Mozari Budruk" },
      { id: 530569, name: "Mozari Khurd" },
      { id: 942975, name: "Mungsaji Nagar" },
      { id: 530483, name: "Nasirabad" },
      { id: 530577, name: "Nihida" },
      { id: 530508, name: "Nimbhora" },
      { id: 530455, name: "Nimbi" },
      { id: 530565, name: "Nimbi Budruk" },
      { id: 530564, name: "Nimbi Khurd" },
      { id: 530443, name: "Padmin" },
      { id: 530571, name: "Parabhawani" },
      { id: 530469, name: "Paranda" },
      { id: 530559, name: "Pardi" },
      { id: 530439, name: "Patkhed" },
      { id: 530578, name: "Pimpalgaon Chambhare" },
      { id: 530586, name: "Pimpalgaon Hande" },
      { id: 530471, name: "Pimpalkhuta" },
      { id: 530493, name: "Pimpalshenda" },
      { id: 530568, name: "Pinjar 1" },
      { id: 944387, name: "Pinjar 2" },
      { id: 530442, name: "Punoti Bk." },
      { id: 530499, name: "Punoti Kh." },
      { id: 530488, name: "Rahit" },
      { id: 530434, name: "Rajanda 1" },
      { id: 944383, name: "Rajanda 2" },
      { id: 530440, name: "Rajankhed" },
      { id: 530446, name: "Rajankhed Tanda" },
      { id: 530531, name: "Ramgaon" },
      { id: 530491, name: "Redwa" },
      { id: 530472, name: "Rustamabad" },
      { id: 530561, name: "Sadalapur" },
      { id: 530475, name: "Safepur" },
      { id: 530485, name: "Sahit" },
      { id: 530444, name: "Sakani" },
      { id: 530545, name: "Sakharvira" },
      { id: 530518, name: "Salpi" },
      { id: 530464, name: "Sarav" },
      { id: 530555, name: "Sarkinhi" },
      { id: 530529, name: "Satali" },
      { id: 530585, name: "Sawarkhed" },
      { id: 530460, name: "Saykhed" },
      { id: 530525, name: "Sayyadpur" },
      { id: 530450, name: "Sevanagar" },
      { id: 530432, name: "Shahapur" },
      { id: 530484, name: "Shelapur" },
      { id: 530447, name: "Shelgaon" },
      { id: 530510, name: "Shelu Budruk" },
      { id: 530511, name: "Shelu Khurd" },
      { id: 530431, name: "Shindkhed" },
      { id: 530526, name: "Shiwapur" },
      { id: 530433, name: "Songiri" },
      { id: 530429, name: "Sukli" },
      { id: 530563, name: "Sultanpur" },
      { id: 530560, name: "Takali Chhabile" },
      { id: 530520, name: "Takarkhed" },
      { id: 530503, name: "Tamsi" },
      { id: 530481, name: "Tawakalpur" },
      { id: 530532, name: "Tembhi" },
      { id: 530584, name: "Titawa" },
      { id: 530524, name: "Titawan" },
      { id: 530522, name: "Tiwasa Budruk" },
      { id: 530523, name: "Tiwasa Khurd" },
      { id: 530507, name: "Ujaleshwar" },
      { id: 530574, name: "Umardari" },
      { id: 530566, name: "Vadgaon" },
      { id: 530437, name: "Vaghjali" },
      { id: 530539, name: "Vastapur" },
      { id: 530466, name: "Vizora" },
      { id: 530492, name: "Wadala" },
      { id: 530535, name: "Wadalaa" },
      { id: 530542, name: "Wagha Budruk" },
      { id: 530551, name: "Wagha Khurd" },
      { id: 530540, name: "Wai" },
      { id: 530519, name: "Walpi" },
      { id: 530494, name: "Wankhedpur" },
      { id: 530428, name: "Warkhed" },
      { id: 530436, name: "Warkhed (Wagh)" },
      { id: 530501, name: "Warkhed Budruk" },
      { id: 530543, name: "Warkhed Khurd" },
      { id: 530505, name: "Yawalkhed" },
      { id: 530467, name: "Yeranda" },
      { id: 530553, name: "Zodga" },
    ],
    3995: [
      { id: 530641, name: "Aamkheda" },
      { id: 530609, name: "Amana" },
      { id: 530648, name: "Amani" },
      { id: 530604, name: "Ansing" },
      { id: 530590, name: "Bhamatwadi" },
      { id: 530661, name: "Bhaurad" },
      { id: 530647, name: "Bhera" },
      { id: 530660, name: "Bhildurga" },
      { id: 530645, name: "Bolhi" },
      { id: 530624, name: "Borala" },
      { id: 530704, name: "Borala Jahagir" },
      { id: 530637, name: "Bordi" },
      { id: 530643, name: "Borgaon" },
      { id: 530658, name: "Bramhanwada Bk." },
      { id: 530657, name: "Bramhanwada Kh." },
      { id: 530600, name: "Bramhanwada N. Marsul" },
      { id: 530708, name: "Chandas" },
      { id: 530659, name: "Chiwara" },
      { id: 530699, name: "Dapuri Kalwe" },
      { id: 530700, name: "Dapuri Kh." },
      { id: 530635, name: "Davha" },
      { id: 530665, name: "Davhi" },
      { id: 530589, name: "Deothana Khamb" },
      { id: 530616, name: "Dhamdhami" },
      { id: 530611, name: "Dharamwadi" },
      { id: 530694, name: "Dharkaranji" },
      { id: 530679, name: "Dharpimpri" },
      { id: 530601, name: "Dholi" },
      { id: 530703, name: "Dhorkheda" },
      { id: 530674, name: "Dongarkinhi" },
      { id: 530631, name: "Dubalwel" },
      { id: 530690, name: "Dudhala" },
      { id: 530677, name: "Ekamba" },
      { id: 530625, name: "Eranda" },
      { id: 530593, name: "Gangalwadi" },
      { id: 530681, name: "Ghata" },
      { id: 530626, name: "Givha" },
      { id: 530608, name: "Goksavangi" },
      { id: 530632, name: "Gunj" },
      { id: 530640, name: "Hanwatkheda" },
      { id: 530664, name: "Irala" },
      { id: 530653, name: "Jambhrunwadi" },
      { id: 530630, name: "Jamkhed" },
      { id: 530685, name: "Jamthi" },
      { id: 530629, name: "Jaulka" },
      { id: 530633, name: "Jodgavhan" },
      { id: 530597, name: "Kalakamatha" },
      { id: 530666, name: "Kalambeshwar" },
      { id: 530656, name: "Karanji" },
      { id: 530619, name: "Kawardari" },
      { id: 530682, name: "Keli" },
      { id: 530652, name: "Khadaki Izara" },
      { id: 530592, name: "Khairkheda" },
      { id: 530701, name: "Khandala Shinde" },
      { id: 530670, name: "Kharodi" },
      { id: 530667, name: "Kherdi" },
      { id: 530638, name: "Khirda" },
      { id: 530686, name: "Kinhi Ghodmod" },
      { id: 530620, name: "Kinhiraja" },
      { id: 530596, name: "Koldara" },
      { id: 530672, name: "Kolgaon Bk." },
      { id: 530673, name: "Kolgaon Kh." },
      { id: 530644, name: "Kolhi" },
      { id: 530702, name: "Kotha" },
      { id: 530605, name: "Kurala" },
      { id: 530614, name: "Kuttardoh" },
      { id: 530623, name: "Mairaldoh" },
      { id: 530646, name: "Malegaon" },
      { id: 530610, name: "Malegaon N. Kinhi" },
      { id: 530678, name: "Manka" },
      { id: 530594, name: "Marsul Bhag 1" },
      { id: 944833, name: "Marsul Bhag 2" },
      { id: 530650, name: "Masala Kh." },
      { id: 944835, name: "Medashi Bhag 2" },
      { id: 530599, name: "Medshi Bhag 1" },
      { id: 530684, name: "Mirzapur" },
      { id: 530662, name: "Mungala Bhag 1" },
      { id: 944834, name: "Mungala Bhag 2" },
      { id: 530615, name: "Musalwadi" },
      { id: 530698, name: "Mutha" },
      { id: 530636, name: "Nagardas" },
      { id: 530680, name: "Pangarkheda." },
      { id: 530587, name: "Pangrabandi" },
      { id: 530651, name: "Pangri Dhankute" },
      { id: 530675, name: "Pangri Kute" },
      { id: 530649, name: "Pangri Nawaghare" },
      { id: 530612, name: "Pimpal Shenda" },
      { id: 530591, name: "Pimpalwadi" },
      { id: 530639, name: "Pimpla" },
      { id: 530602, name: "Rajura" },
      { id: 530634, name: "Ramnagar" },
      { id: 530668, name: "Regaon" },
      { id: 530607, name: "Ridhora" },
      { id: 530687, name: "Sakrapur" },
      { id: 530669, name: "Sawalad" },
      { id: 530693, name: "Shelgaon Bagade" },
      { id: 530695, name: "Shelgaon Bondade" },
      { id: 530692, name: "Shelgaon Khavane" },
      { id: 530683, name: "Shirpur Bhag 1" },
      { id: 944836, name: "Shirpur Bhag 2" },
      { id: 944837, name: "Shirpur Bhag 3" },
      { id: 530707, name: "Shirsala" },
      { id: 530706, name: "Somthana" },
      { id: 530622, name: "Sonala" },
      { id: 530588, name: "Sonkhas" },
      { id: 530603, name: "Sudi" },
      { id: 530606, name: "Sukanda" },
      { id: 530705, name: "Taktoda" },
      { id: 530642, name: "Tapowan" },
      { id: 530671, name: "Tarodi" },
      { id: 530688, name: "Tiwali" },
      { id: 530617, name: "Udi" },
      { id: 530627, name: "Umardari" },
      { id: 530598, name: "Umarwadi" },
      { id: 530676, name: "Wadap" },
      { id: 530613, name: "Wadi Ramrao" },
      { id: 530697, name: "Waghalud" },
      { id: 530691, name: "Waghi Bk." },
      { id: 530696, name: "Wakad" },
      { id: 530595, name: "Wakalwadi" },
      { id: 530621, name: "Wakapur" },
      { id: 530663, name: "Warangi" },
      { id: 530628, name: "Wardari Bk." },
      { id: 530618, name: "Wardari Kh." },
      { id: 530689, name: "Wasari" },
      { id: 530654, name: "Zodaga Bk." },
      { id: 530655, name: "Zodaga Kh." },
    ],
    3996: [
      { id: 530780, name: "Ajgaon" },
      { id: 530805, name: "Ambapur" },
      { id: 530746, name: "Amgavhan" },
      { id: 530800, name: "Arak" },
      { id: 530838, name: "Asegaon" },
      { id: 530742, name: "Bahadarpur" },
      { id: 530783, name: "Baldeo" },
      { id: 530766, name: "Belkhed" },
      { id: 530835, name: "Bhadkumbha" },
      { id: 530808, name: "Bhamrun" },
      { id: 530720, name: "Bhur" },
      { id: 530829, name: "Bitoda Bhoyar" },
      { id: 530753, name: "Borwha Bk." },
      { id: 530776, name: "Borwha Kh." },
      { id: 530743, name: "Chakwa" },
      { id: 530778, name: "Chambhai" },
      { id: 530812, name: "Chandai" },
      { id: 530790, name: "Chehel" },
      { id: 530821, name: "Chikhalgad" },
      { id: 530731, name: "Chikhali" },
      { id: 530831, name: "Chinchakheda" },
      { id: 530799, name: "Chinchala" },
      { id: 530834, name: "Chincholi" },
      { id: 530724, name: "Chorad" },
      { id: 530844, name: "Chukamba" },
      { id: 530810, name: "Dabha" },
      { id: 530837, name: "Dabhadi" },
      { id: 530806, name: "Dastapur" },
      { id: 530751, name: "Dawakha" },
      { id: 530789, name: "Dhanora Bk." },
      { id: 530816, name: "Dhanora Kh." },
      { id: 530774, name: "Dharmapur" },
      { id: 530763, name: "Dhotra" },
      { id: 530768, name: "Dilawalpur" },
      { id: 530752, name: "Ekamba" },
      { id: 530826, name: "Falegaon" },
      { id: 530757, name: "Ganeshpur" },
      { id: 530756, name: "Ghota" },
      { id: 530772, name: "Gimbha" },
      { id: 530735, name: "Gogri" },
      { id: 530802, name: "Golwadi" },
      { id: 530732, name: "Hirangi" },
      { id: 530779, name: "Hisai" },
      { id: 530729, name: "Icha" },
      { id: 530828, name: "Ichori" },
      { id: 530765, name: "Ismailpur" },
      { id: 530781, name: "Jamb" },
      { id: 530771, name: "Januna Bk." },
      { id: 530723, name: "Januna Kh." },
      { id: 530819, name: "Jogaldari" },
      { id: 530820, name: "Junanpani" },
      { id: 530817, name: "Kalamba Bodakhe" },
      { id: 530736, name: "Kanzara" },
      { id: 530827, name: "Kasola" },
      { id: 530773, name: "Kawathal" },
      { id: 530750, name: "Khadi" },
      { id: 530824, name: "Khapardari" },
      { id: 530759, name: "Kharbi" },
      { id: 530733, name: "Kherda Bk." },
      { id: 530734, name: "Kherda Kh." },
      { id: 530818, name: "Kolambi" },
      { id: 530775, name: "Kothari" },
      { id: 530841, name: "Kumbhi" },
      { id: 530842, name: "Lahi" },
      { id: 530745, name: "Lakhamapur" },
      { id: 530726, name: "Lathi" },
      { id: 530811, name: "Lawana" },
      { id: 530718, name: "Majlapur" },
      { id: 530711, name: "Malshelu" },
      { id: 530786, name: "Mangalsa" },
      { id: 943449, name: "Mangrulpir" },
      { id: 530801, name: "Manoli" },
      { id: 530714, name: "Masola Bk." },
      { id: 530807, name: "Masola Kh." },
      { id: 530770, name: "Mohari" },
      { id: 530782, name: "Mohogavan" },
      { id: 530814, name: "Motsawanga" },
      { id: 530762, name: "Mozari" },
      { id: 530785, name: "Murtijapur" },
      { id: 530728, name: "Nagi" },
      { id: 530833, name: "Nandgaon" },
      { id: 530712, name: "Nandkheda" },
      { id: 530749, name: "Nawkhi" },
      { id: 530739, name: "Nimbi" },
      { id: 530709, name: "Pangri" },
      { id: 530730, name: "Pardi Tad" },
      { id: 530754, name: "Parwa" },
      { id: 530713, name: "Pedgaon" },
      { id: 530795, name: "Peth Khudawatpur" },
      { id: 530839, name: "Pimpalgaon" },
      { id: 530787, name: "Pimpalgaon Ujad" },
      { id: 530777, name: "Pimpalkhuta" },
      { id: 530747, name: "Pimpalshenda" },
      { id: 530738, name: "Pimpri Awagan" },
      { id: 530760, name: "Pimpri Bk." },
      { id: 530737, name: "Pimpri Kh." },
      { id: 530740, name: "Poghat" },
      { id: 530764, name: "Poti" },
      { id: 530721, name: "Pur" },
      { id: 530791, name: "Rahit" },
      { id: 530758, name: "Raipur" },
      { id: 530840, name: "Ramgadh" },
      { id: 530813, name: "Ramgaon" },
      { id: 530793, name: "Renkapur" },
      { id: 530722, name: "Rui" },
      { id: 530822, name: "Salambi" },
      { id: 530825, name: "Sangaon" },
      { id: 530744, name: "Sanlapur" },
      { id: 530830, name: "Sarsi" },
      { id: 530748, name: "Sattarsawangi" },
      { id: 530792, name: "Sawalapur" },
      { id: 530823, name: "Sawargaon" },
      { id: 530815, name: "Saykheda" },
      { id: 530769, name: "Shahapur Bk." },
      { id: 530784, name: "Shahapur Kh." },
      { id: 530836, name: "Shegi" },
      { id: 530797, name: "Shelgaon" },
      { id: 530727, name: "Shelu Kh." },
      { id: 530717, name: "Shendurjana More" },
      { id: 530832, name: "Shivani D" },
      { id: 530755, name: "Shivni Road" },
      { id: 530798, name: "Sonkhas" },
      { id: 530788, name: "Swasin" },
      { id: 530710, name: "Tandali" },
      { id: 530716, name: "Tapovan" },
      { id: 530715, name: "Tarhala" },
      { id: 530796, name: "Tuljapur" },
      { id: 530741, name: "Umardoh" },
      { id: 530794, name: "Umari Bk" },
      { id: 530843, name: "Vasantwadi" },
      { id: 530761, name: "Wadha" },
      { id: 530719, name: "Wanoja 1" },
      { id: 944838, name: "Wanoja 2" },
      { id: 530809, name: "Warud Bk." },
      { id: 530804, name: "Warud Kh." },
      { id: 530803, name: "Yedalpur" },
      { id: 530725, name: "Yedshi" },
      { id: 530767, name: "Zadgaon" },
    ],
    3997: [
      { id: 530976, name: "Aajampur" },
      { id: 530905, name: "Ajampur" },
      { id: 530943, name: "Akhatwada" },
      { id: 530993, name: "Alalpur" },
      { id: 530977, name: "Alamgirpur" },
      { id: 530941, name: "Alimardapur" },
      { id: 530917, name: "Amboda" },
      { id: 530956, name: "Anai" },
      { id: 530897, name: "Antarkhed" },
      { id: 530890, name: "Aurangapur" },
      { id: 530881, name: "Babapur" },
      { id: 530960, name: "Bagapur" },
      { id: 530973, name: "Bagayat" },
      { id: 530869, name: "Baggi" },
      { id: 530848, name: "Bahadarpur" },
      { id: 530899, name: "Bambarda" },
      { id: 530874, name: "Belkhed" },
      { id: 530862, name: "Belmandal" },
      { id: 530870, name: "Bembla" },
      { id: 530851, name: "Bhadshivni" },
      { id: 530926, name: "Bhambdevi" },
      { id: 530972, name: "Bhilkheda" },
      { id: 530921, name: "Bhiwari" },
      { id: 530893, name: "Bhuloda" },
      { id: 530924, name: "Bondewadi" },
      { id: 531006, name: "Bramhankhed" },
      { id: 530891, name: "Bramhanwada" },
      { id: 530863, name: "Chadai" },
      { id: 531002, name: "Dadgaon" },
      { id: 530984, name: "Deochandi" },
      { id: 530998, name: "Dhamni Khadi" },
      { id: 530919, name: "Dhanaj Budruk" },
      { id: 530906, name: "Dhanaj Khurd" },
      { id: 530907, name: "Dhangarkhed" },
      { id: 530942, name: "Dhanora Tathod" },
      { id: 530928, name: "Dhotra (Deshmukh)" },
      { id: 530914, name: "Dhotra (Jahangir)" },
      { id: 530965, name: "Dighi" },
      { id: 530937, name: "Donad Bk." },
      { id: 530915, name: "Dongargaon" },
      { id: 530949, name: "Dughora" },
      { id: 531010, name: "Eklara" },
      { id: 530988, name: "Gaiwal" },
      { id: 530945, name: "Ganeshpur" },
      { id: 530957, name: "Gangapur" },
      { id: 531001, name: "Girda" },
      { id: 530883, name: "Haibatpur" },
      { id: 530884, name: "Hasanapur" },
      { id: 530910, name: "Higanwadi" },
      { id: 530927, name: "Hiwara (Lahe)" },
      { id: 531005, name: "Imampur" },
      { id: 530877, name: "Ingalkhed" },
      { id: 530955, name: "Inza" },
      { id: 530882, name: "Isafpur" },
      { id: 530967, name: "Isafpur H.75" },
      { id: 530904, name: "Jaipur" },
      { id: 530886, name: "Jalalpur" },
      { id: 530954, name: "Jamb" },
      { id: 530898, name: "Jamthi Kh." },
      { id: 530855, name: "Janori" },
      { id: 530964, name: "Januna" },
      { id: 530854, name: "Kajaleshwar" },
      { id: 530861, name: "Kakadshivni" },
      { id: 531007, name: "Kali Karanja" },
      { id: 530888, name: "Kamargaon" },
      { id: 530875, name: "Kamatha" },
      { id: 530958, name: "Kamathwada" },
      { id: 530940, name: "Karli" },
      { id: 530847, name: "Khanapur" },
      { id: 530866, name: "Khatnapur" },
      { id: 530849, name: "Kherda Bk." },
      { id: 530944, name: "Kherda Karanja" },
      { id: 530850, name: "Kherda Kh." },
      { id: 530991, name: "Kinhi Rokade" },
      { id: 530982, name: "Kinkhed" },
      { id: 530981, name: "Kisan Nagar" },
      { id: 530978, name: "Koli" },
      { id: 530901, name: "Kupati" },
      { id: 530879, name: "Kurhad" },
      { id: 530878, name: "Ladegaon" },
      { id: 530857, name: "Lohagaon" },
      { id: 530968, name: "Lohara" },
      { id: 530935, name: "Loni (Arab)" },
      { id: 530856, name: "Mahagaon" },
      { id: 530846, name: "Majalapur" },
      { id: 530912, name: "Malegaon Dhanaj" },
      { id: 531003, name: "Malegaon Yevata" },
      { id: 530990, name: "Malkapur" },
      { id: 531008, name: "Mamdabad (Dhoni)" },
      { id: 943460, name: "Mamdapur" },
      { id: 944832, name: "Manabha 2" },
      { id: 530948, name: "Manbha" },
      { id: 530983, name: "Mandwa" },
      { id: 530925, name: "Meha" },
      { id: 530873, name: "Mhasala" },
      { id: 530994, name: "Mirzapur" },
      { id: 530932, name: "Mohgavhan" },
      { id: 530867, name: "Mokhad" },
      { id: 531004, name: "Morhal" },
      { id: 530913, name: "Morpur" },
      { id: 530930, name: "Mugutpur" },
      { id: 530980, name: "Murambi" },
      { id: 530889, name: "Murtijapur" },
      { id: 530923, name: "Nagalwadi" },
      { id: 530974, name: "Nagapur" },
      { id: 530931, name: "Naregaon" },
      { id: 530936, name: "Nimbha Jahangir" },
      { id: 530852, name: "Palana" },
      { id: 530858, name: "Pangavhan" },
      { id: 530992, name: "Panvihir" },
      { id: 530860, name: "Parwa Kohar" },
      { id: 530995, name: "Pasrani" },
      { id: 530918, name: "Pendha" },
      { id: 530951, name: "Pilkheda" },
      { id: 530876, name: "Pimpalgaon Bk." },
      { id: 531009, name: "Pimpalgaon Kh." },
      { id: 531011, name: "Pimpri (Forest)" },
      { id: 530922, name: "Pimpri (Modak)" },
      { id: 530868, name: "Pimpri Mokhad" },
      { id: 530947, name: "Pimpri Warghat" },
      { id: 530969, name: "Poha" },
      { id: 530911, name: "Rahati" },
      { id: 530963, name: "Ramnagar" },
      { id: 530909, name: "Ramtek" },
      { id: 530961, name: "Raperi" },
      { id: 530908, name: "Sahadatpur" },
      { id: 530865, name: "Shaha" },
      { id: 530894, name: "Shahapur" },
      { id: 530987, name: "Shelu Bu." },
      { id: 530892, name: "Shemlai" },
      { id: 530975, name: "Sherpur" },
      { id: 530985, name: "Shevti" },
      { id: 530903, name: "Shinganapur" },
      { id: 530916, name: "Shirsoli" },
      { id: 530845, name: "Shivan Bk." },
      { id: 530970, name: "Shivnagar" },
      { id: 530989, name: "Sohal" },
      { id: 530959, name: "Somthana" },
      { id: 530950, name: "Sukali" },
      { id: 530871, name: "Sukali (Karanja)" },
      { id: 530872, name: "Takali Bk." },
      { id: 530880, name: "Takali Kh" },
      { id: 530920, name: "Tamaswadi" },
      { id: 530902, name: "Tandali" },
      { id: 530979, name: "Tapowan" },
      { id: 530929, name: "Tarkheda" },
      { id: 530971, name: "Tuljapur" },
      { id: 530853, name: "Ujaleshwar" },
      { id: 530859, name: "Ukarda" },
      { id: 530952, name: "Umbarda Bajar" },
      { id: 530895, name: "Undri" },
      { id: 530896, name: "Vilegaon" },
      { id: 530934, name: "Virgavhan" },
      { id: 530885, name: "Wadgaon" },
      { id: 530997, name: "Wadgaon Ijara" },
      { id: 530938, name: "Wadgaon Range" },
      { id: 530966, name: "Wadhavi" },
      { id: 530999, name: "Waghola" },
      { id: 530953, name: "Wahitkhed" },
      { id: 530986, name: "Wai" },
      { id: 531000, name: "Waki" },
      { id: 530864, name: "Walhai" },
      { id: 530900, name: "Wapti" },
      { id: 530939, name: "Yawardi" },
      { id: 530996, name: "Yesapur" },
      { id: 530946, name: "Yevta" },
      { id: 530933, name: "Zodaga" },
      { id: 530962, name: "Zolgaon" },
    ],
    3998: [
      { id: 531061, name: "Abhaikheda" },
      { id: 531014, name: "Ajani" },
      { id: 531137, name: "Amdari" },
      { id: 531065, name: "Amgavhan" },
      { id: 531112, name: "Amkinhi" },
      { id: 531057, name: "Asola Bk." },
      { id: 531080, name: "Asola Kh." },
      { id: 531110, name: "Balajinagar" },
      { id: 531015, name: "Bhandegaon" },
      { id: 531132, name: "Bhildongar" },
      { id: 531034, name: "Bhoyani" },
      { id: 531091, name: "Bhuli" },
      { id: 531016, name: "Bidgaon" },
      { id: 531071, name: "Borwha" },
      { id: 531090, name: "Chakur" },
      { id: 531023, name: "Chausala" },
      { id: 531084, name: "Chikhali" },
      { id: 531069, name: "Chistala" },
      { id: 531042, name: "Chondhi" },
      { id: 531024, name: "Dahithana" },
      { id: 531025, name: "Dapura Bk." },
      { id: 531029, name: "Dapura Kh." },
      { id: 531030, name: "Dara" },
      { id: 531043, name: "Derdi" },
      { id: 531087, name: "Deurwadi" },
      { id: 531067, name: "Devthana" },
      { id: 531064, name: "Dhamani (Manora)" },
      { id: 531027, name: "Dhanora Bhuse" },
      { id: 531085, name: "Dhanora Bk." },
      { id: 531052, name: "Dhanora Kh." },
      { id: 531103, name: "Dhawanda" },
      { id: 531136, name: "Dhoni" },
      { id: 531066, name: "Dongargaon" },
      { id: 531056, name: "Eklara" },
      { id: 531140, name: "Fulumari Bhag 1" },
      { id: 944839, name: "Fulumari Bhag 2" },
      { id: 531095, name: "Gadegaon" },
      { id: 531089, name: "Galamgaon" },
      { id: 531031, name: "Gartek" },
      { id: 531081, name: "Gavha" },
      { id: 531020, name: "Ghoti" },
      { id: 531126, name: "Girat" },
      { id: 531124, name: "Girda" },
      { id: 531127, name: "Giroli Bhag 1" },
      { id: 944840, name: "Giroli Bhag 2" },
      { id: 531105, name: "Gogjai" },
      { id: 531108, name: "Gondegaon." },
      { id: 531145, name: "Gosta" },
      { id: 531063, name: "Gundi" },
      { id: 531120, name: "Halda" },
      { id: 531093, name: "Hatana" },
      { id: 531138, name: "Hatoli" },
      { id: 531047, name: "Hatti" },
      { id: 531058, name: "Hiwara Bk." },
      { id: 531131, name: "Hiwara Kh." },
      { id: 531134, name: "Ingalwadi" },
      { id: 531018, name: "Inzori" },
      { id: 531121, name: "Jagdambanagar" },
      { id: 531037, name: "Jamdara (Ghoti)" },
      { id: 531019, name: "Jamdara (Kavathal)" },
      { id: 531026, name: "Jamni" },
      { id: 531032, name: "Januna Khurd" },
      { id: 531059, name: "Jawala Bk." },
      { id: 531060, name: "Jawala Khurd" },
      { id: 531111, name: "Jotibanagar" },
      { id: 531104, name: "Kakad Chikhali" },
      { id: 531051, name: "Kamlapur" },
      { id: 531083, name: "Karkheda" },
      { id: 531072, name: "Karli" },
      { id: 531129, name: "Karpa" },
      { id: 531133, name: "Khambala" },
      { id: 531036, name: "Khandala" },
      { id: 531123, name: "Khapardari" },
      { id: 531041, name: "Khapri" },
      { id: 531125, name: "Kherda" },
      { id: 531119, name: "Kolar" },
      { id: 531062, name: "Kondoli" },
      { id: 531045, name: "Kupta" },
      { id: 531054, name: "Lohara" },
      { id: 531028, name: "M. Shahapur" },
      { id: 531092, name: "Mahuli" },
      { id: 531077, name: "Manora" },
      { id: 531146, name: "Mendra" },
      { id: 531022, name: "Mhasni" },
      { id: 531038, name: "Mohgavhan" },
      { id: 531050, name: "Mundala" },
      { id: 531098, name: "Naigaon Bandi" },
      { id: 531033, name: "Nayani" },
      { id: 531143, name: "Palodi" },
      { id: 531094, name: "Panchala" },
      { id: 531048, name: "Parawa" },
      { id: 531099, name: "Pimpalshenda" },
      { id: 531128, name: "Pimpri" },
      { id: 531100, name: "Poharadevi" },
      { id: 531076, name: "Ramtirth" },
      { id: 531142, name: "Ranjitnagar" },
      { id: 531139, name: "Ratanwadi" },
      { id: 531012, name: "Renukapur" },
      { id: 531117, name: "Rohana" },
      { id: 531035, name: "Rudrala" },
      { id: 531148, name: "Rui" },
      { id: 531118, name: "Sakhardoh" },
      { id: 531102, name: "Sawali" },
      { id: 531053, name: "Sawargaon" },
      { id: 531013, name: "Sayyadpur" },
      { id: 531073, name: "Sewadasnagar" },
      { id: 531114, name: "Shendona" },
      { id: 531135, name: "Shendurjana Adhav" },
      { id: 531116, name: "Singanapur" },
      { id: 531115, name: "Singdoh" },
      { id: 531086, name: "Soijana" },
      { id: 531141, name: "Someshwarnagar" },
      { id: 531078, name: "Somnathnagar" },
      { id: 531079, name: "Somthana" },
      { id: 531070, name: "Talap Bk." },
      { id: 531046, name: "Tembhala" },
      { id: 531039, name: "Terka" },
      { id: 531021, name: "Tornala" },
      { id: 531144, name: "Ujwalnagar" },
      { id: 531055, name: "Umardari" },
      { id: 531106, name: "Umari Bk." },
      { id: 531107, name: "Umari Kh." },
      { id: 531017, name: "Umbarda" },
      { id: 531101, name: "Vasantnagar" },
      { id: 531113, name: "Vasantnagar (Poharadevi)" },
      { id: 531147, name: "Vatphal" },
      { id: 531130, name: "Vilegaon" },
      { id: 531082, name: "Vitholi" },
      { id: 531109, name: "Wadgaon" },
      { id: 531088, name: "Wadgaon Ujad" },
      { id: 531040, name: "Waghdari" },
      { id: 531096, name: "Waigaul" },
      { id: 531044, name: "Wanjarkhed" },
      { id: 531049, name: "Wapta" },
      { id: 531122, name: "Warda" },
      { id: 531074, name: "Waroli" },
      { id: 531068, name: "Watod" },
      { id: 531075, name: "Yeshawantnagar" },
    ],
    3999: [
      { id: 531182, name: "Adgaon Kata" },
      { id: 531247, name: "Adgaon Kh." },
      { id: 531168, name: "Adoli" },
      { id: 531196, name: "Anjankheda" },
      { id: 531257, name: "Ansing" },
      { id: 531187, name: "Asola Jahagir" },
      { id: 531170, name: "Atkali" },
      { id: 531226, name: "Babhulgaon" },
      { id: 531209, name: "Bhatumra" },
      { id: 531198, name: "Bhoyata" },
      { id: 531213, name: "Bitoda Teli" },
      { id: 531222, name: "Bori Bk." },
      { id: 531248, name: "Borkhedi" },
      { id: 531261, name: "Bramha" },
      { id: 531189, name: "Bramhanwada" },
      { id: 531220, name: "Chendkapur" },
      { id: 531183, name: "Chikhali Bk." },
      { id: 531185, name: "Chikhali Kh." },
      { id: 531223, name: "Degaon" },
      { id: 531244, name: "Deothana Bk." },
      { id: 531250, name: "Depul" },
      { id: 531162, name: "Dhanora Bk." },
      { id: 531219, name: "Dhanora Kh." },
      { id: 531163, name: "Dharagiri" },
      { id: 531150, name: "Dharkata" },
      { id: 531275, name: "Dhilli" },
      { id: 531231, name: "Dhumka" },
      { id: 531155, name: "Dodki" },
      { id: 531200, name: "Dudhkheda" },
      { id: 531255, name: "Ekamba" },
      { id: 531228, name: "Falegaon Thet" },
      { id: 531216, name: "Fulsakra" },
      { id: 531249, name: "Ganeshpur" },
      { id: 943459, name: "Ghodbabhulgaon" },
      { id: 531267, name: "Ghota" },
      { id: 531156, name: "Giwha" },
      { id: 531188, name: "Gondegaon" },
      { id: 943457, name: "Gondeshwar" },
      { id: 531191, name: "Gonhi" },
      { id: 531232, name: "Hisse Borala" },
      { id: 531184, name: "Hisse Chikhali" },
      { id: 531157, name: "Hiwara Rohila" },
      { id: 531256, name: "Ilakhi" },
      { id: 531276, name: "Jaipur" },
      { id: 531154, name: "Jambharun Dharmaji" },
      { id: 531227, name: "Jambharun Jahagir" },
      { id: 531195, name: "Jambhrun Bhite" },
      { id: 531212, name: "Jambhrun Mahali" },
      { id: 531194, name: "Jambhrun Naoji" },
      { id: 531151, name: "Jambhrun Parande" },
      { id: 531254, name: "Jawala" },
      { id: 531171, name: "Jumda" },
      { id: 531214, name: "Kajlamba" },
      { id: 531190, name: "Kakaddati" },
      { id: 531210, name: "Kalamba Mahali" },
      { id: 531178, name: "Kamathwada" },
      { id: 531217, name: "Kanadi" },
      { id: 531237, name: "Kapasi" },
      { id: 531175, name: "Karli" },
      { id: 531180, name: "Kata" },
      { id: 531233, name: "Kekat Umra" },
      { id: 531258, name: "Khadsing" },
      { id: 531166, name: "Khandala Kh." },
      { id: 531215, name: "Kharola" },
      { id: 531202, name: "Kinkheda" },
      { id: 531245, name: "Kokalgaon" },
      { id: 531201, name: "Kondala Mahali" },
      { id: 531179, name: "Kondala Zamre" },
      { id: 531239, name: "Krishna" },
      { id: 531173, name: "Kumbharkhed" },
      { id: 531208, name: "Malegaon Najik Bhatumara" },
      { id: 531221, name: "Masala Bk." },
      { id: 531165, name: "Mohaja" },
      { id: 531253, name: "Mohgawhan Dak" },
      { id: 531230, name: "Mohgawhan Dube" },
      { id: 531164, name: "Nagthana" },
      { id: 531274, name: "Nimbalwadi" },
      { id: 531229, name: "Panchala" },
      { id: 531207, name: "Pandaw Umra" },
      { id: 531240, name: "Pangarkhed" },
      { id: 531225, name: "Pardi Asara" },
      { id: 531167, name: "Pardi Ekburji" },
      { id: 531206, name: "Pardi Takmor" },
      { id: 531259, name: "Pimpalgaon" },
      { id: 531243, name: "Rajgaon" },
      { id: 531211, name: "Sakra" },
      { id: 531263, name: "Sapli" },
      { id: 531270, name: "Sawali" },
      { id: 531203, name: "Sawanga Jahagir" },
      { id: 531149, name: "Sawargaon Barde" },
      { id: 531169, name: "Sawargaon Jire" },
      { id: 531236, name: "Saykheda" },
      { id: 531260, name: "Shelgaon" },
      { id: 531265, name: "Shelu Bk." },
      { id: 531262, name: "Shelu Kh." },
      { id: 531238, name: "Shirputi" },
      { id: 531159, name: "Shrigiri" },
      { id: 531266, name: "Sonda" },
      { id: 531272, name: "Songavhan" },
      { id: 531153, name: "Sonkhas" },
      { id: 531205, name: "Sonwal" },
      { id: 531199, name: "Soyata" },
      { id: 531242, name: "Sukali" },
      { id: 531218, name: "Supkhel" },
      { id: 531177, name: "Surala" },
      { id: 531193, name: "Surkandi" },
      { id: 531152, name: "Tamasi" },
      { id: 531197, name: "Tamsala" },
      { id: 531158, name: "Tandali Bk." },
      { id: 531204, name: "Tandali Shewai" },
      { id: 531273, name: "Tanka" },
      { id: 531172, name: "Toe" },
      { id: 531235, name: "Tondgaon" },
      { id: 531176, name: "Tornala" },
      { id: 531241, name: "Ukalipen" },
      { id: 531252, name: "Umra Kapse" },
      { id: 531224, name: "Umra Shamshoddin" },
      { id: 531264, name: "Umrala" },
      { id: 531192, name: "Umramaind" },
      { id: 531234, name: "Vilegaon" },
      { id: 531186, name: "Waghjali" },
      { id: 531174, name: "Wagholi Bk." },
      { id: 531246, name: "Wagholi Kh." },
      { id: 531269, name: "Wai" },
      { id: 531160, name: "Walki Jahagir" },
      { id: 531161, name: "Wangi" },
      { id: 531251, name: "Wara Jahangir" },
      { id: 531268, name: "Warla" },
      { id: 943453, name: "Washim 1" },
      { id: 943455, name: "Washim 2" },
      { id: 943456, name: "Washim 3" },
      { id: 531181, name: "Zakalwadi" },
      { id: 531271, name: "Zodga" },
    ],
    4000: [
      { id: 531369, name: "Agarwadi" },
      { id: 531309, name: "Anchal" },
      { id: 531333, name: "Asegaon Pen" },
      { id: 531365, name: "Asola" },
      { id: 531287, name: "Balkhed" },
      { id: 531329, name: "Belkheda" },
      { id: 531285, name: "Bhapur" },
      { id: 531368, name: "Bhar Jahagir" },
      { id: 531348, name: "Bhokarkhed" },
      { id: 531299, name: "Bibkhed" },
      { id: 531293, name: "Borkhedi" },
      { id: 531366, name: "Chakoli" },
      { id: 531371, name: "Chichamba Bhar" },
      { id: 531324, name: "Chichamba Pen" },
      { id: 531345, name: "Chikhali" },
      { id: 531323, name: "Dapuri Kh" },
      { id: 531341, name: "Degaon" },
      { id: 531331, name: "Deulgaon Banda" },
      { id: 531286, name: "Dhodap Bk." },
      { id: 531317, name: "Dhodap Kh." },
      { id: 531355, name: "Ekalaspur" },
      { id: 531306, name: "Ganeshpur" },
      { id: 531357, name: "Ganeshpur Risod" },
      { id: 531279, name: "Gaundhala" },
      { id: 531353, name: "Ghonsar" },
      { id: 531339, name: "Ghota" },
      { id: 531283, name: "Gobhani." },
      { id: 531289, name: "Gohagaon" },
      { id: 531314, name: "Gowardhan Bhag 1" },
      { id: 944842, name: "Gowardhan Bhag 2" },
      { id: 531352, name: "Haral" },
      { id: 531330, name: "Hiwar Pen" },
      { id: 531311, name: "Jaikhed" },
      { id: 531305, name: "Jamb Adhav" },
      { id: 531372, name: "Jawala" },
      { id: 531307, name: "Jogeshwari" },
      { id: 531303, name: "Kalamgavhan" },
      { id: 531361, name: "Kanheri" },
      { id: 531370, name: "Kankarwadi" },
      { id: 531280, name: "Karanji" },
      { id: 531298, name: "Karda" },
      { id: 531346, name: "Kawatha Kh." },
      { id: 531302, name: "Kenwad" },
      { id: 531321, name: "Keshavnagar" },
      { id: 531327, name: "Khadki Dhangare" },
      { id: 531340, name: "Khadki Sadar" },
      { id: 531343, name: "Kinkhed" },
      { id: 531336, name: "Koyali Bk." },
      { id: 531312, name: "Koyali Bk.(Rithad)" },
      { id: 531313, name: "Koyali Kh." },
      { id: 531337, name: "Koyali Kh.(Rithad)" },
      { id: 531301, name: "Kuksa" },
      { id: 531373, name: "Kurha" },
      { id: 531281, name: "Lehani" },
      { id: 531342, name: "Lingakotwal" },
      { id: 531363, name: "Loni Bk." },
      { id: 531364, name: "Loni Kh." },
      { id: 531288, name: "Mahagaon" },
      { id: 531374, name: "Mandwa" },
      { id: 531316, name: "Mangulzanak" },
      { id: 531358, name: "Mangwadi" },
      { id: 531320, name: "Masalapen" },
      { id: 531350, name: "Mohaja Ingole" },
      { id: 531375, name: "Mohjabandi" },
      { id: 531362, name: "Mop" },
      { id: 531367, name: "Morgavhan" },
      { id: 531297, name: "Mothegaon" },
      { id: 531277, name: "Nagzari" },
      { id: 531304, name: "Nandhana" },
      { id: 531315, name: "Nawali" },
      { id: 531359, name: "Ner" },
      { id: 531310, name: "Netansa" },
      { id: 531354, name: "Nijampur" },
      { id: 531356, name: "Pachamba" },
      { id: 531349, name: "Palaskhed" },
      { id: 531290, name: "Pantapur" },
      { id: 531326, name: "Pardi Tikhe" },
      { id: 531291, name: "Patwad" },
      { id: 531344, name: "Pedgaon" },
      { id: 531318, name: "Pen Bori" },
      { id: 531294, name: "Pimparkhed" },
      { id: 531300, name: "Pimpri Sarhad" },
      { id: 943445, name: "Risod Bhag 2" },
      { id: 943470, name: "Risod Bhag 3" },
      { id: 943444, name: "Risod Bhag1" },
      { id: 531328, name: "Rithad" },
      { id: 531296, name: "Sarapkhed" },
      { id: 531351, name: "Sawad" },
      { id: 531319, name: "Shelgaon Rajgure" },
      { id: 531360, name: "Shelu Khadse" },
      { id: 531284, name: "Tandulwadi" },
      { id: 531308, name: "Tapowan" },
      { id: 531278, name: "Ukirkhed" },
      { id: 531338, name: "Vyad Bhag 1" },
      { id: 944841, name: "Vyad Bhag 2" },
      { id: 531347, name: "Wadiraytal" },
      { id: 531292, name: "Wadiwakad" },
      { id: 531282, name: "Wadji" },
      { id: 531322, name: "Waghi Kh." },
      { id: 531295, name: "Wakad Bhag 1" },
      { id: 944843, name: "Wakad Bhag 2" },
      { id: 531332, name: "Wanoja" },
      { id: 531335, name: "Warudtopha" },
      { id: 531325, name: "Yevta" },
      { id: 531334, name: "Yevti" },
    ],
    4001: [
      { id: 531456, name: "Aki" },
      { id: 531429, name: "Ambadi" },
      { id: 531420, name: "Babanda" },
      { id: 531473, name: "Bairagad" },
      { id: 531515, name: "Bajardhana" },
      { id: 531405, name: "Baratanda" },
      { id: 531452, name: "Baru" },
      { id: 531446, name: "Baspani" },
      { id: 531451, name: "Berdabarda" },
      { id: 531415, name: "Berdabhuru" },
      { id: 531392, name: "Bhanwar" },
      { id: 531426, name: "Bhokarbardi" },
      { id: 531486, name: "Bhondilawa" },
      { id: 531522, name: "Bhulori" },
      { id: 531382, name: "Bibamal" },
      { id: 531458, name: "Bijudhawdi" },
      { id: 531407, name: "Biroti" },
      { id: 531380, name: "Bobado" },
      { id: 531520, name: "Bod" },
      { id: 531501, name: "Bori" },
      { id: 531525, name: "Bothara" },
      { id: 531484, name: "Bulumgavhan" },
      { id: 531508, name: "Chakarda" },
      { id: 531487, name: "Chatwabod" },
      { id: 531495, name: "Chaurakund" },
      { id: 531410, name: "Chendo" },
      { id: 531489, name: "Chethar" },
      { id: 531417, name: "Chichghat" },
      { id: 531504, name: "Chipoli" },
      { id: 531517, name: "Chitri" },
      { id: 531480, name: "Chopan" },
      { id: 531453, name: "Chutiya" },
      { id: 531400, name: "Dabaka" },
      { id: 531406, name: "Dabhayakheda" },
      { id: 531433, name: "Dabida" },
      { id: 531394, name: "Dadra" },
      { id: 531440, name: "Dahenda" },
      { id: 531491, name: "Dhakarmal" },
      { id: 531464, name: "Dharakot" },
      { id: 531490, name: "Dharanmahu" },
      { id: 531532, name: "Dharni" },
      { id: 531468, name: "Dhodra" },
      { id: 531482, name: "Dhokda" },
      { id: 531387, name: "Dhomanadhana" },
      { id: 531425, name: "Dhulghat Gadga" },
      { id: 531411, name: "Dhulghat Railway" },
      { id: 531521, name: "Didamda" },
      { id: 531445, name: "Diya" },
      { id: 531516, name: "Duni" },
      { id: 531499, name: "Faildhana" },
      { id: 531460, name: "Gadgamalur" },
      { id: 531427, name: "Gambheri" },
      { id: 531386, name: "Gaulandoh" },
      { id: 531424, name: "Gaulkheda" },
      { id: 531523, name: "Ghota" },
      { id: 531455, name: "Ghuti" },
      { id: 531396, name: "Golai" },
      { id: 531507, name: "Gombarkahu" },
      { id: 531418, name: "Gondwadi" },
      { id: 531475, name: "Harda" },
      { id: 531511, name: "Hardoli" },
      { id: 531500, name: "Harisal" },
      { id: 531459, name: "Hatida" },
      { id: 531492, name: "Hatnada" },
      { id: 531393, name: "Hirabambai" },
      { id: 531526, name: "Jambu" },
      { id: 531408, name: "Jampani" },
      { id: 531449, name: "Jutpani" },
      { id: 531513, name: "Kadhav" },
      { id: 531505, name: "Kakarmal" },
      { id: 531419, name: "Kalamkhar" },
      { id: 531441, name: "Kalpi" },
      { id: 531397, name: "Kanjoli" },
      { id: 531528, name: "Kara" },
      { id: 531506, name: "Karada" },
      { id: 531471, name: "Kasaikheda" },
      { id: 531469, name: "Kasmar" },
      { id: 531485, name: "Katkumbha" },
      { id: 531470, name: "Kawadaziri" },
      { id: 531488, name: "Kekada" },
      { id: 531481, name: "Khamda" },
      { id: 531434, name: "Khaparkheda" },
      { id: 531436, name: "Khari" },
      { id: 531438, name: "Kharya Tembru" },
      { id: 531395, name: "Khidki" },
      { id: 531403, name: "Khidki Kalam" },
      { id: 531479, name: "Khokmar" },
      { id: 531401, name: "Koldadhana" },
      { id: 531530, name: "Kot" },
      { id: 531527, name: "Kotha" },
      { id: 531478, name: "Kund" },
      { id: 531421, name: "Kusumkot Bk." },
      { id: 531422, name: "Kusumkot Kh." },
      { id: 531476, name: "Kutanga" },
      { id: 531383, name: "Laktu" },
      { id: 531518, name: "Lawada" },
      { id: 531496, name: "Malur (Fo)" },
      { id: 531381, name: "Mandu" },
      { id: 531447, name: "Mandwa" },
      { id: 531497, name: "Mangiya" },
      { id: 531457, name: "Mansudhawadi" },
      { id: 531463, name: "Mogarda" },
      { id: 531416, name: "Mokha" },
      { id: 944450, name: "Mothakheda" },
      { id: 531389, name: "Nagazira" },
      { id: 531435, name: "Nagudhana" },
      { id: 531529, name: "Nanduri" },
      { id: 531390, name: "Nardu" },
      { id: 531423, name: "Narwati" },
      { id: 531509, name: "Nirgudi" },
      { id: 531472, name: "Padidam" },
      { id: 531412, name: "Palaskundi" },
      { id: 531428, name: "Pankhalya" },
      { id: 531378, name: "Patharpur" },
      { id: 531493, name: "Patiya" },
      { id: 531514, name: "Pohara" },
      { id: 531503, name: "Potilawa" },
      { id: 531466, name: "Rabang" },
      { id: 531385, name: "Rajpur" },
      { id: 944931, name: "Ranamalur" },
      { id: 531384, name: "Ranapisa" },
      { id: 531477, name: "Rangubeli" },
      { id: 531398, name: "Ranigaon" },
      { id: 531431, name: "Ranitamboli" },
      { id: 531414, name: "Ratnapur" },
      { id: 531391, name: "Rehatya" },
      { id: 531432, name: "Rohinikheda" },
      { id: 531498, name: "Rora" },
      { id: 531377, name: "Sadrabadi" },
      { id: 531379, name: "Salai" },
      { id: 531402, name: "Sawalikheda" },
      { id: 531474, name: "Sawalkheda" },
      { id: 531467, name: "Sawarya" },
      { id: 531430, name: "Shirpur" },
      { id: 531399, name: "Shiwaziri" },
      { id: 531439, name: "Sonabardi" },
      { id: 531388, name: "Susarda" },
      { id: 531444, name: "Takarkheda" },
      { id: 531443, name: "Talai" },
      { id: 531413, name: "Talai Railway" },
      { id: 531494, name: "Tangda" },
      { id: 531462, name: "Tatra" },
      { id: 531448, name: "Tembli" },
      { id: 531404, name: "Tembrukheda" },
      { id: 531442, name: "Tingrya" },
      { id: 531465, name: "Titamba" },
      { id: 531454, name: "Toli" },
      { id: 531510, name: "Ukupati" },
      { id: 531512, name: "Utawali" },
      { id: 531450, name: "Zapal" },
      { id: 531461, name: "Zilangpati" },
      { id: 531376, name: "Zilpi" },
    ],
    4002: [
      { id: 531555, name: "Adhav" },
      { id: 531675, name: "Adnadi" },
      { id: 531582, name: "Ahad" },
      { id: 531718, name: "Aki" },
      { id: 531678, name: "Aladoh" },
      { id: 531703, name: "Ambapati" },
      { id: 531597, name: "Amona" },
      { id: 531661, name: "Amzari" },
      { id: 531629, name: "Awagad" },
      { id: 531695, name: "Badnapur" },
      { id: 531649, name: "Bagdari" },
      { id: 531684, name: "Baglinga" },
      { id: 531717, name: "Bahadarpur" },
      { id: 531648, name: "Bamdehi" },
      { id: 531617, name: "Barugavhan" },
      { id: 944943, name: "Barukheda" },
      { id: 531668, name: "Bela" },
      { id: 531632, name: "Bhandora" },
      { id: 531674, name: "Bhandri" },
      { id: 531559, name: "Bhandum (Dhakana)" },
      { id: 531599, name: "Bhandum (Hatru)" },
      { id: 531542, name: "Bhawai" },
      { id: 531692, name: "Bhilkheda" },
      { id: 531566, name: "Bhilkheda (Borala)" },
      { id: 531548, name: "Bhiroja" },
      { id: 531655, name: "Bhulori" },
      { id: 531534, name: "Bhutrum" },
      { id: 531618, name: "Biba" },
      { id: 531670, name: "Bihali" },
      { id: 531621, name: "Bodu" },
      { id: 944938, name: "Boori." },
      { id: 531724, name: "Borala" },
      { id: 531536, name: "Boratyakheda" },
      { id: 531602, name: "Borda" },
      { id: 531659, name: "Bori" },
      { id: 531633, name: "Butida" },
      { id: 531709, name: "Chandpur" },
      { id: 531720, name: "Chauramal" },
      { id: 531687, name: "Chichati" },
      { id: 531701, name: "Chichkheda" },
      { id: 531550, name: "Chikhali" },
      { id: 531613, name: "Chilhati" },
      { id: 531619, name: "Chobita" },
      { id: 531627, name: "Chunkhadi" },
      { id: 531636, name: "Churani" },
      { id: 531664, name: "Churni" },
      { id: 531558, name: "Dabiya" },
      { id: 531634, name: "Dahendri" },
      { id: 531560, name: "Dhakna" },
      { id: 531716, name: "Dharamdoh 1" },
      { id: 531586, name: "Dhargad" },
      { id: 531673, name: "Dhomanipatha" },
      { id: 531593, name: "Dolar" },
      { id: 531650, name: "Doma" },
      { id: 531611, name: "Domi" },
      { id: 531601, name: "Ektai" },
      { id: 531557, name: "Gadgabhandum" },
      { id: 531723, name: "Gangadhari" },
      { id: 531642, name: "Gangarkheda" },
      { id: 531568, name: "Garajdari" },
      { id: 531569, name: "Gaulkheda" },
      { id: 531711, name: "Gaulkheda Bazar" },
      { id: 531639, name: "Ghana" },
      { id: 531654, name: "Ghatang" },
      { id: 531704, name: "Girguti" },
      { id: 531584, name: "Gullarghat" },
      { id: 531614, name: "Hatru" },
      { id: 531671, name: "Hattighat" },
      { id: 531606, name: "Hilda" },
      { id: 531693, name: "Hiradamal" },
      { id: 531690, name: "Jaitadehi" },
      { id: 944301, name: "Jamali R" },
      { id: 531667, name: "Jamlivan" },
      { id: 531658, name: "Jamun Nala" },
      { id: 531631, name: "Jarida" },
      { id: 531651, name: "Kajaldoh" },
      { id: 531565, name: "Kakadari" },
      { id: 531694, name: "Kalapani" },
      { id: 531666, name: "Kamapur" },
      { id: 531623, name: "Kamida" },
      { id: 531647, name: "Kanheri" },
      { id: 531637, name: "Karada" },
      { id: 531608, name: "Karanjkheda" },
      { id: 531645, name: "Katkumbh" },
      { id: 531547, name: "Keli" },
      { id: 944942, name: "Kelpani" },
      { id: 531549, name: "Kesharpur" },
      { id: 531624, name: "Khadimal" },
      { id: 531628, name: "Khandukheda" },
      { id: 531605, name: "Khari" },
      { id: 531578, name: "Khatkali" },
      { id: 531662, name: "Khatkali (Dha)" },
      { id: 531571, name: "Khirapani" },
      { id: 531705, name: "Khongada" },
      { id: 531672, name: "Kohana" },
      { id: 531641, name: "Korda" },
      { id: 531643, name: "Kotmi" },
      { id: 531646, name: "Koylari" },
      { id: 531533, name: "Kuhi" },
      { id: 531700, name: "Kulangana Bk." },
      { id: 531699, name: "Kulangana Kh." },
      { id: 531682, name: "Kundi" },
      { id: 531620, name: "Lakhewada" },
      { id: 531656, name: "Lawada" },
      { id: 531679, name: "Lawada Van" },
      { id: 531652, name: "Lonazari" },
      { id: 531615, name: "Madizadap" },
      { id: 531676, name: "Madki" },
      { id: 531539, name: "Makhala" },
      { id: 531697, name: "Malkapur" },
      { id: 531691, name: "Manbhang" },
      { id: 531712, name: "Manjarkapdi" },
      { id: 531616, name: "Marita" },
      { id: 531653, name: "Masondi" },
      { id: 531630, name: "Mehriaam" },
      { id: 531663, name: "Memna" },
      { id: 531580, name: "Menghat" },
      { id: 531721, name: "Morgad" },
      { id: 531677, name: "Motha" },
      { id: 531683, name: "Mozari" },
      { id: 531713, name: "Nagapur" },
      { id: 944940, name: "Nagartas" },
      { id: 944941, name: "Odapati" },
      { id: 531640, name: "Pachdongri" },
      { id: 531635, name: "Palshya" },
      { id: 531579, name: "Pandhra Khadak" },
      { id: 531680, name: "Pastalai" },
      { id: 531551, name: "Patkahu" },
      { id: 531544, name: "Pili" },
      { id: 531564, name: "Pipadari" },
      { id: 531604, name: "Piplya" },
      { id: 531607, name: "Rahu" },
      { id: 531537, name: "Raipur" },
      { id: 531553, name: "Raksha" },
      { id: 531696, name: "Ramtek" },
      { id: 531612, name: "Ruipathar" },
      { id: 531707, name: "Sakhari Chikhalpati" },
      { id: 531600, name: "Salita" },
      { id: 531657, name: "Salona" },
      { id: 531541, name: "Sarwarkheda" },
      { id: 531719, name: "Sattiruipatha" },
      { id: 531570, name: "Sawarpani" },
      { id: 531556, name: "Sawarya" },
      { id: 531545, name: "Semadoh" },
      { id: 531665, name: "Shahapur" },
      { id: 531609, name: "Simori" },
      { id: 944937, name: "Somthana Bu." },
      { id: 531589, name: "Somthana Kh." },
      { id: 531710, name: "Somwarkheda" },
      { id: 531722, name: "Sonapur" },
      { id: 531610, name: "Sumita" },
      { id: 531554, name: "Tarubanda" },
      { id: 531706, name: "Tekda Nagzira" },
      { id: 531715, name: "Telkhar" },
      { id: 531603, name: "Tembru" },
      { id: 531708, name: "Tembrusonda" },
      { id: 531660, name: "Tetu" },
      { id: 531644, name: "Toranwadi" },
      { id: 531681, name: "Vairat" },
      { id: 531698, name: "Vastapur" },
      { id: 531581, name: "Zingapur" },
    ],
    4003: [
      { id: 531787, name: "Adgaon Ade" },
      { id: 531738, name: "Adgaon Khade" },
      { id: 531794, name: "Ahamadpur" },
      { id: 531782, name: "Aiwajpur" },
      { id: 531774, name: "Ajitpur" },
      { id: 531733, name: "Alampur" },
      { id: 531766, name: "Allipur" },
      { id: 531816, name: "Aurangpur" },
      { id: 531736, name: "Bhandaraj" },
      { id: 531744, name: "Bhokari" },
      { id: 531749, name: "Bhuraskhed" },
      { id: 531797, name: "Borala" },
      { id: 531812, name: "Borgaon Ambada" },
      { id: 531846, name: "Bramhanwada" },
      { id: 531778, name: "Chausala" },
      { id: 531830, name: "Chincholi Bk." },
      { id: 531822, name: "Chincholi Kh." },
      { id: 531824, name: "Chincholi Shingne" },
      { id: 531727, name: "Chinchona" },
      { id: 531761, name: "Dahigaon Bk." },
      { id: 531760, name: "Dahigaon Kh." },
      { id: 531757, name: "Deogaon" },
      { id: 531847, name: "Deulgaon" },
      { id: 531755, name: "Dhadi" },
      { id: 531798, name: "Dhanegaon" },
      { id: 531741, name: "Dhanwadi" },
      { id: 531850, name: "Dombala" },
      { id: 531726, name: "Dongargaon" },
      { id: 531831, name: "Ekalara" },
      { id: 531848, name: "Fajalpur" },
      { id: 531762, name: "Fattepur" },
      { id: 531770, name: "Ganeshpur" },
      { id: 531840, name: "Ganeshpur (Pandhari)" },
      { id: 531728, name: "Gaurkheda" },
      { id: 531754, name: "Gavandgaon Bk" },
      { id: 531753, name: "Gavandgaon Kh" },
      { id: 531818, name: "Ghodasgaon" },
      { id: 531785, name: "Hantoda" },
      { id: 531739, name: "Hasanapur Pardi" },
      { id: 531844, name: "Hayapur" },
      { id: 531752, name: "Hingani" },
      { id: 531730, name: "Hirapur" },
      { id: 531748, name: "Husenpur Dhudki" },
      { id: 531767, name: "Husenpur Khodgaon" },
      { id: 531813, name: "Jawala Bk." },
      { id: 531814, name: "Jawala Kh" },
      { id: 531743, name: "Jawardi" },
      { id: 531765, name: "Jethamalpur" },
      { id: 531750, name: "Kalgavhan" },
      { id: 531791, name: "Kalwada" },
      { id: 531820, name: "Kamalpur" },
      { id: 944405, name: "Kapustalani 2" },
      { id: 531811, name: "Kapustalni" },
      { id: 531735, name: "Karala" },
      { id: 531817, name: "Kasbegavhan" },
      { id: 531751, name: "Katwel" },
      { id: 531768, name: "Khanampur" },
      { id: 531833, name: "Khaspur" },
      { id: 531771, name: "Khel Babuji" },
      { id: 531792, name: "Khel Gangaji" },
      { id: 531772, name: "Khel Hadole" },
      { id: 531796, name: "Khel Hagone" },
      { id: 531793, name: "Khel Hiraji" },
      { id: 531781, name: "Khel Khadase" },
      { id: 531773, name: "Khel Kokat" },
      { id: 531780, name: "Khel Krushnaji" },
      { id: 531731, name: "Khirada" },
      { id: 531826, name: "Khirgavhan" },
      { id: 531790, name: "Khudawanpur" },
      { id: 531849, name: "Kokarda" },
      { id: 531832, name: "Kotegaon" },
      { id: 531843, name: "Kotha" },
      { id: 531836, name: "Kumbhargaon Bk." },
      { id: 531837, name: "Kumbhargaon Kh." },
      { id: 531776, name: "Lakhad" },
      { id: 531851, name: "Lakhanwadi" },
      { id: 531806, name: "Loharajpur" },
      { id: 531756, name: "Madarpur" },
      { id: 531786, name: "Malkapur Bk." },
      { id: 531841, name: "Malkapur Kh." },
      { id: 531769, name: "Mamrabad" },
      { id: 531737, name: "Masamapur" },
      { id: 531784, name: "Mohabatpur" },
      { id: 531805, name: "Murha Bk." },
      { id: 531808, name: "Murha Kh." },
      { id: 531745, name: "Murtijapur Ghogarda" },
      { id: 531740, name: "Nabapur" },
      { id: 531801, name: "Narayanpur Bk." },
      { id: 531852, name: "Narayanpur Kh." },
      { id: 531835, name: "Nimbhari" },
      { id: 531742, name: "Nimkhed Ade" },
      { id: 531732, name: "Nimkhed Bazar" },
      { id: 531729, name: "Palaskheda" },
      { id: 531839, name: "Pardi" },
      { id: 531828, name: "Pimpalgavhan" },
      { id: 531802, name: "Pohi" },
      { id: 531823, name: "Rahimapur" },
      { id: 531747, name: "Rajapur" },
      { id: 531763, name: "Ramgaon" },
      { id: 531842, name: "Rampura" },
      { id: 531764, name: "Rashidpur" },
      { id: 531829, name: "Ratanpur Jogarda" },
      { id: 531800, name: "Ratnapur" },
      { id: 531803, name: "Ratnapur Bk." },
      { id: 531799, name: "Raundalpur" },
      { id: 531827, name: "Saidapur" },
      { id: 531815, name: "Saidapur (Borgaon Ambada)" },
      { id: 531821, name: "Sakhari" },
      { id: 531825, name: "Samsherpur" },
      { id: 531810, name: "Saray" },
      { id: 531845, name: "Sarfabad" },
      { id: 531777, name: "Sarfabad (Lakhad)" },
      { id: 531746, name: "Sategaon" },
      { id: 531834, name: "Sayyadgaon" },
      { id: 531775, name: "Shahapur" },
      { id: 531804, name: "Shekapur" },
      { id: 531759, name: "Shelgaon" },
      { id: 531783, name: "Shirasgaon" },
      { id: 531809, name: "Songaon" },
      { id: 531779, name: "Surji" },
      { id: 531795, name: "Takarkheda More" },
      { id: 531819, name: "Taroda" },
      { id: 531734, name: "Turkhed" },
      { id: 531788, name: "Vihigaon Bk." },
      { id: 531789, name: "Vihigaon Kh." },
      { id: 531758, name: "Wadali" },
      { id: 531838, name: "Wanoja" },
      { id: 531807, name: "Warud Kh." },
    ],
    4004: [
      { id: 531898, name: "Ajitpur" },
      { id: 531905, name: "Ambada Kandari" },
      { id: 531985, name: "Ambuj" },
      { id: 531904, name: "Antargaon" },
      { id: 531896, name: "Aregaon" },
      { id: 532021, name: "Asadpur" },
      { id: 531888, name: "Aurangpur Najik Paratwada" },
      { id: 531961, name: "Aurangpur Najik Tawlar" },
      { id: 531906, name: "Bag Ambada" },
      { id: 532019, name: "Bajitpur" },
      { id: 531936, name: "Balegaon" },
      { id: 943702, name: "Begampura" },
      { id: 531864, name: "Belkheda" },
      { id: 531892, name: "Beni" },
      { id: 943703, name: "Bhande Bhonde" },
      { id: 531965, name: "Bhilona" },
      { id: 531916, name: "Bhitkheda" },
      { id: 531853, name: "Bhopapur" },
      { id: 531925, name: "Bhugaon" },
      { id: 531928, name: "Bopapur" },
      { id: 531938, name: "Bordi" },
      { id: 531939, name: "Borgaon Dori" },
      { id: 531940, name: "Borgaon Peth" },
      { id: 531941, name: "Borgaon Talni" },
      { id: 531860, name: "Buradghat" },
      { id: 531935, name: "Chachondi" },
      { id: 531931, name: "Chamak Budruk" },
      { id: 531930, name: "Chamak Khurd" },
      { id: 531876, name: "Chandura Jahagir" },
      { id: 531937, name: "Chausala" },
      { id: 531909, name: "Chikhali" },
      { id: 531900, name: "Darapur" },
      { id: 531873, name: "Daryabad" },
      { id: 531878, name: "Datura" },
      { id: 531854, name: "Devgaon" },
      { id: 531914, name: "Dewari" },
      { id: 531856, name: "Dhamangaon Gadhi Bhag 1" },
      { id: 944465, name: "Dhamangaon Gadhi Bhag 2" },
      { id: 531957, name: "Dharampur" },
      { id: 531880, name: "Dhotarkheda" },
      { id: 532004, name: "Donoda" },
      { id: 531871, name: "Ekalaspur" },
      { id: 531868, name: "Gaurkheda" },
      { id: 531907, name: "Ghodgaon" },
      { id: 531862, name: "Gondvihir" },
      { id: 531946, name: "Gondwagholi" },
      { id: 531872, name: "Hanawatkheda" },
      { id: 531899, name: "Haram" },
      { id: 532006, name: "Hiwara" },
      { id: 531999, name: "Isapur" },
      { id: 531989, name: "Isegaon" },
      { id: 531956, name: "Jahanpur" },
      { id: 531875, name: "Jalalpur" },
      { id: 531894, name: "Jambhala" },
      { id: 531983, name: "Janori" },
      { id: 531954, name: "Januna" },
      { id: 531973, name: "Jatanpur" },
      { id: 531972, name: "Jawalapur" },
      { id: 531922, name: "Jawardi" },
      { id: 531987, name: "Kakda" },
      { id: 531861, name: "Kalwit" },
      { id: 531980, name: "Kamatwada" },
      { id: 531887, name: "Kandali" },
      { id: 531958, name: "Kasampur" },
      { id: 532023, name: "Kawitha Bk." },
      { id: 531975, name: "Kawitha Kh" },
      { id: 532007, name: "Khairi" },
      { id: 531933, name: "Khambora" },
      { id: 532015, name: "Khanapur" },
      { id: 532008, name: "Khanapur Chichkheda" },
      { id: 531903, name: "Khanapur N. Bhitkheda" },
      { id: 531918, name: "Khanapur N.Rahimapur" },
      { id: 531963, name: "Khanjamanagar" },
      { id: 531998, name: "Khanjanabad" },
      { id: 531901, name: "Khanjirpur" },
      { id: 532031, name: "Kharpi" },
      { id: 531948, name: "Khatijapur" },
      { id: 943694, name: "Khel Gujar" },
      { id: 943697, name: "Khelbagad" },
      { id: 943698, name: "Khelbari" },
      { id: 943700, name: "Khelbhaleray" },
      { id: 943699, name: "Khelbocha" },
      { id: 531912, name: "Kheldeomali" },
      { id: 943695, name: "Khelghumat" },
      { id: 531920, name: "Kheltapmali" },
      { id: 943696, name: "Kheltekad" },
      { id: 908937, name: "Kheltrimbaknarayan" },
      { id: 531919, name: "Khonjampur" },
      { id: 531890, name: "Khudanpur" },
      { id: 531991, name: "Khushalpur Najik Mukindpur" },
      { id: 531910, name: "Khushalpur Najik Narayanpur" },
      { id: 532001, name: "Kolha" },
      { id: 531964, name: "Kopra" },
      { id: 531883, name: "Kothara" },
      { id: 531881, name: "Kumbhi" },
      { id: 531951, name: "Kumbhi Wagholi" },
      { id: 531977, name: "Kushta Bk." },
      { id: 531978, name: "Kushta Kh." },
      { id: 531982, name: "Mahamadpur" },
      { id: 531870, name: "Malhara" },
      { id: 531952, name: "Malkapur Kh." },
      { id: 531942, name: "Meghnathpur" },
      { id: 531863, name: "Mhasona" },
      { id: 531990, name: "Mukindpur" },
      { id: 531891, name: "Muradpur" },
      { id: 531924, name: "Nabapur" },
      { id: 531884, name: "Nagarwadi" },
      { id: 531929, name: "Naigaon" },
      { id: 531908, name: "Narayanpur" },
      { id: 531889, name: "Narsala" },
      { id: 531869, name: "Narsari" },
      { id: 532010, name: "Narsingpur" },
      { id: 531911, name: "Naubag" },
      { id: 531927, name: "Nijampur" },
      { id: 532020, name: "Nimbhari" },
      { id: 531874, name: "Nimdari" },
      { id: 531867, name: "Nimkheda" },
      { id: 531859, name: "Nimkund" },
      { id: 531960, name: "Pachamba Khurd" },
      { id: 531865, name: "Pandhari" },
      { id: 531949, name: "Parasapur" },
      { id: 943701, name: "Paratwada" },
      { id: 531968, name: "Pardi" },
      { id: 531971, name: "Pathrot Bhag 1" },
      { id: 944464, name: "Pathrot Bhag 2" },
      { id: 531945, name: "Payvihir" },
      { id: 531947, name: "Pchamba Budruk" },
      { id: 531855, name: "Pimpalkhuta" },
      { id: 531976, name: "Pohi" },
      { id: 531915, name: "Rahimapur N. Khanapur" },
      { id: 531953, name: "Raipur" },
      { id: 531981, name: "Raipur (Va)" },
      { id: 532011, name: "Raipur Jahagir" },
      { id: 531913, name: "Raipura" },
      { id: 531950, name: "Rajjakpur" },
      { id: 531885, name: "Rajura" },
      { id: 531923, name: "Ramapur Belaj" },
      { id: 531969, name: "Ramapur Bk." },
      { id: 531895, name: "Ramapur Jambhala" },
      { id: 531970, name: "Ramapur Kh" },
      { id: 943704, name: "Ramgaon" },
      { id: 532012, name: "Rangarwasni" },
      { id: 531988, name: "Rasegaon" },
      { id: 531943, name: "Ratnapur" },
      { id: 531995, name: "Rawalgaon" },
      { id: 531974, name: "Rayani" },
      { id: 531897, name: "Sahapur N Wadgaon" },
      { id: 531984, name: "Salabatpur" },
      { id: 531902, name: "Salebad" },
      { id: 531866, name: "Salepur" },
      { id: 532005, name: "Sangnvi N Khairi" },
      { id: 531926, name: "Sangvi Na.Nijampur" },
      { id: 532018, name: "Sawalapur" },
      { id: 532002, name: "Sawali Bk." },
      { id: 532003, name: "Sawali Kh" },
      { id: 531879, name: "Sawali Na. Datura" },
      { id: 532022, name: "Shahapur (Inamgaon)" },
      { id: 532000, name: "Shampur" },
      { id: 531996, name: "Shankarpur" },
      { id: 531921, name: "Shekapur" },
      { id: 531979, name: "Shindi Bk." },
      { id: 531932, name: "Surwada" },
      { id: 531962, name: "Tawalar" },
      { id: 532009, name: "Tirmalpur" },
      { id: 532017, name: "Tonglabad" },
      { id: 531934, name: "Tuljapur Jahagir" },
      { id: 531944, name: "Upatkheda" },
      { id: 531917, name: "Virkheda" },
      { id: 943705, name: "Virpur" },
      { id: 531886, name: "Vitthalpur" },
      { id: 531893, name: "Wadgaon Fattepur" },
      { id: 532013, name: "Wadgaon Kh" },
      { id: 531994, name: "Wadhona Jahagir" },
      { id: 531986, name: "Wadner Bhujang" },
      { id: 531882, name: "Wadura" },
      { id: 531955, name: "Wagdoh" },
      { id: 531959, name: "Walmikpur" },
      { id: 531967, name: "Walni Bk." },
      { id: 531966, name: "Walni Kh" },
      { id: 531992, name: "Wasani Bk." },
      { id: 531993, name: "Wasani Kh." },
      { id: 531858, name: "Wazzar" },
      { id: 532016, name: "Yelki" },
      { id: 531877, name: "Yeni" },
      { id: 532014, name: "Yesurna" },
      { id: 531997, name: "Yevata" },
    ],
    4005: [
      { id: 532101, name: "Abadalpur" },
      { id: 532116, name: "Abdullapur" },
      { id: 532163, name: "Akhatwada" },
      { id: 532034, name: "Alampur" },
      { id: 532092, name: "Alipur" },
      { id: 532107, name: "Amrullapur" },
      { id: 532167, name: "Anandwadi" },
      { id: 532079, name: "Angadpur" },
      { id: 532152, name: "Asegaon" },
      { id: 532141, name: "Bahadarpur" },
      { id: 532181, name: "Barhanpur" },
      { id: 532131, name: "Belaj" },
      { id: 532072, name: "Belkheda" },
      { id: 532064, name: "Belmandali" },
      { id: 532186, name: "Belora Bhag 1" },
      { id: 532128, name: "Belura Gadhi" },
      { id: 532166, name: "Beskheda" },
      { id: 532041, name: "Bhalewadi" },
      { id: 532170, name: "Bhangaon" },
      { id: 532029, name: "Bodad" },
      { id: 532157, name: "Boraj" },
      { id: 532184, name: "Borala" },
      { id: 532130, name: "Borgaon Mohna" },
      { id: 532084, name: "Bramhanwada Pathak" },
      { id: 532077, name: "Bramhanwada Thadi" },
      { id: 944299, name: "Chandur Bajar" },
      { id: 532055, name: "Chinchkumbh" },
      { id: 532068, name: "Chincholi Bk." },
      { id: 532192, name: "Chincholi Kale" },
      { id: 532148, name: "Chincholi Purna" },
      { id: 532143, name: "Dahigaon" },
      { id: 532162, name: "Dattapur" },
      { id: 532081, name: "Deurwada" },
      { id: 532095, name: "Dewapur" },
      { id: 532144, name: "Dhanora" },
      { id: 532082, name: "Dhoktirth" },
      { id: 532098, name: "Dilalpur" },
      { id: 532176, name: "Durgwada" },
      { id: 532108, name: "Fajalapur" },
      { id: 532126, name: "Fubgaon" },
      { id: 532086, name: "Ganoja" },
      { id: 532069, name: "Gaurkheda" },
      { id: 532063, name: "Ghat Ladki" },
      { id: 532105, name: "Gopalpur" },
      { id: 532032, name: "Govindpur" },
      { id: 532153, name: "Govindpur (Asegaon)" },
      { id: 532124, name: "Haidatpur" },
      { id: 532087, name: "Hashampur" },
      { id: 532096, name: "Hilalabad" },
      { id: 532099, name: "Hirapur" },
      { id: 532134, name: "Hirur" },
      { id: 532058, name: "Hiwradevi" },
      { id: 532171, name: "Hushangabad" },
      { id: 532102, name: "Imampur" },
      { id: 532083, name: "Inapur" },
      { id: 532053, name: "Inayatpur" },
      { id: 532172, name: "Jadhavpur" },
      { id: 532147, name: "Jagannathpur" },
      { id: 532137, name: "Jainpur" },
      { id: 532090, name: "Jalnapur" },
      { id: 532054, name: "Jamapati" },
      { id: 532160, name: "Jamapur" },
      { id: 532169, name: "Jasapur" },
      { id: 532118, name: "Jasapur (Belora Bhag 2)" },
      { id: 532067, name: "Jawara" },
      { id: 532180, name: "Jawla" },
      { id: 532094, name: "Kajali" },
      { id: 532035, name: "Kalhodi" },
      { id: 532024, name: "Karanja Bahiram" },
      { id: 532168, name: "Khanjirpur" },
      { id: 532177, name: "Kharala" },
      { id: 532178, name: "Kharwadi" },
      { id: 532040, name: "Khel Chaudhar (Karajgaon)" },
      { id: 532049, name: "Khel Januji (Choudhar Kurha)" },
      { id: 532039, name: "Khel Januji (Deshmukh Kurha)" },
      { id: 532048, name: "Khel Khushal ( Deshmukh Kurha)" },
      { id: 532033, name: "Khel Mhal (Karajgaon)" },
      { id: 532038, name: "Khel Sakharam (Deshmukh Kurha)" },
      { id: 532061, name: "Khinkhini" },
      { id: 532097, name: "Kodori" },
      { id: 532052, name: "Kondwardha" },
      { id: 532139, name: "Kotgawandi" },
      { id: 532155, name: "Krishnapur" },
      { id: 532123, name: "Krushnapur (Kural)" },
      { id: 532125, name: "Kural" },
      { id: 532074, name: "Kurankhed" },
      { id: 532047, name: "Lakhanwadi" },
      { id: 532093, name: "Madhan" },
      { id: 532120, name: "Mahamadpur" },
      { id: 532044, name: "Makrampur" },
      { id: 532146, name: "Malkapur" },
      { id: 532078, name: "Markanda" },
      { id: 532112, name: "Masod" },
      { id: 532104, name: "Mirajapur" },
      { id: 532111, name: "Mochkheda" },
      { id: 532161, name: "Mohangaon" },
      { id: 532187, name: "Mubarakgaon" },
      { id: 532173, name: "Muradpur" },
      { id: 532059, name: "Nagarwadi" },
      { id: 532103, name: "Najarpur Khu." },
      { id: 532100, name: "Nanori" },
      { id: 532145, name: "Narayanpur" },
      { id: 532117, name: "Nimbhora" },
      { id: 532075, name: "Nimkheda" },
      { id: 532025, name: "Pala" },
      { id: 532046, name: "Palaswada" },
      { id: 532037, name: "Pandhari" },
      { id: 532165, name: "Parsoda" },
      { id: 532060, name: "Parsoda (Khinkhini)" },
      { id: 532122, name: "Pimpalkhuta" },
      { id: 532110, name: "Pimpri Talegaon" },
      { id: 532114, name: "Pimpri Thugaon" },
      { id: 532057, name: "Pithonda" },
      { id: 532158, name: "Pralhadpur" },
      { id: 532164, name: "Rahatgaon" },
      { id: 532132, name: "Rajna" },
      { id: 532188, name: "Rajura (Lahan)" },
      { id: 532190, name: "Ramdalpur" },
      { id: 532119, name: "Rasidpur" },
      { id: 532156, name: "Rasullapur" },
      { id: 532027, name: "Ratanpur" },
      { id: 532056, name: "Redwa" },
      { id: 532115, name: "Rodori" },
      { id: 532129, name: "Saidapur" },
      { id: 532028, name: "Saikheda" },
      { id: 532062, name: "Sambhora" },
      { id: 532051, name: "Sanjapur" },
      { id: 532135, name: "Sarfabad" },
      { id: 532036, name: "Sarfapur" },
      { id: 532127, name: "Sayyadpur" },
      { id: 532088, name: "Shahapur" },
      { id: 532138, name: "Shahapur Hirur" },
      { id: 532179, name: "Shahapur N.Jawla" },
      { id: 532174, name: "Sharyatpur" },
      { id: 532043, name: "Shindi Kh." },
      { id: 944431, name: "Shirajgaon Kasaba 2" },
      { id: 944433, name: "Shirajgaon Kasaba 3" },
      { id: 532026, name: "Shirajgaon Kasba 1" },
      { id: 532175, name: "Shivpur" },
      { id: 532185, name: "Shiwanga" },
      { id: 532089, name: "Silimpur" },
      { id: 532136, name: "Sirajgaon Ardak" },
      { id: 532159, name: "Sirajgaon Band" },
      { id: 532045, name: "Somthana" },
      { id: 532085, name: "Sonori" },
      { id: 532030, name: "Subhanpur" },
      { id: 532154, name: "Sultanpur" },
      { id: 532091, name: "Sultanpur (Sonori)" },
      { id: 532140, name: "Sundarpur" },
      { id: 532076, name: "Surali" },
      { id: 532150, name: "Takarkheda" },
      { id: 532109, name: "Talegaon Mohna" },
      { id: 532149, name: "Talni Purna" },
      { id: 532182, name: "Talvel" },
      { id: 532142, name: "Tamaswadi" },
      { id: 532050, name: "Thugaon Pimpri" },
      { id: 532106, name: "Tondgaon" },
      { id: 532113, name: "Tonglapur" },
      { id: 532189, name: "Trimalpur" },
      { id: 532133, name: "Tuljapur Gadhi" },
      { id: 532066, name: "Udapur" },
      { id: 532042, name: "Umari" },
      { id: 532151, name: "Virul" },
      { id: 532065, name: "Vishroli" },
      { id: 532070, name: "Vithalapur" },
      { id: 532121, name: "Wadala" },
      { id: 532183, name: "Wadura" },
      { id: 532080, name: "Wadura ( Kajali)" },
      { id: 532071, name: "Wani" },
      { id: 532073, name: "Waroli" },
      { id: 532191, name: "Wathonda" },
    ],
    4006: [
      { id: 532331, name: "Adgaon" },
      { id: 532281, name: "Ahmadabad" },
      { id: 532251, name: "Ahmadpur" },
      { id: 532329, name: "Ajampur" },
      { id: 532306, name: "Akhatwada" },
      { id: 532201, name: "Ambada" },
      { id: 532225, name: "Ambhori" },
      { id: 532212, name: "Ashtagaon" },
      { id: 532344, name: "Ashtoli" },
      { id: 532289, name: "Asona" },
      { id: 532349, name: "Bahadurnagar" },
      { id: 532317, name: "Bahirampur" },
      { id: 532305, name: "Barhanpur" },
      { id: 532355, name: "Barhanpur (Dabheri)" },
      { id: 532242, name: "Belkheda" },
      { id: 532256, name: "Belona" },
      { id: 532263, name: "Bhaipur" },
      { id: 532205, name: "Bhalond" },
      { id: 532298, name: "Bhambora" },
      { id: 532197, name: "Bhangara" },
      { id: 532321, name: "Bhawsingpur" },
      { id: 532341, name: "Bhilapur" },
      { id: 532226, name: "Bhiwkundi" },
      { id: 532218, name: "Bodna" },
      { id: 532236, name: "Bopalawadi" },
      { id: 532352, name: "Bramhanwada" },
      { id: 532198, name: "Charud" },
      { id: 532243, name: "Chikhal Sawangi" },
      { id: 532241, name: "Chincholi Gavali" },
      { id: 532240, name: "Chinchpur" },
      { id: 532357, name: "Dabheri" },
      { id: 532193, name: "Dahsur" },
      { id: 532254, name: "Dapori" },
      { id: 532294, name: "Daryapur" },
      { id: 532227, name: "Deothan" },
      { id: 532323, name: "Dhamangaon" },
      { id: 532249, name: "Dhanora" },
      { id: 532343, name: "Domak" },
      { id: 532237, name: "Dongar Yawali" },
      { id: 532259, name: "Dorali" },
      { id: 532274, name: "Durgwada" },
      { id: 532194, name: "Ganeshpur" },
      { id: 532231, name: "Ghoddeo Bk." },
      { id: 532230, name: "Ghoddeo Kh." },
      { id: 532338, name: "Ghodgavhan" },
      { id: 532209, name: "Gokalapur" },
      { id: 532340, name: "Gorala" },
      { id: 532213, name: "Gujarmali" },
      { id: 532297, name: "Hashampur" },
      { id: 532211, name: "Hasnapur" },
      { id: 532202, name: "Hirapur" },
      { id: 532235, name: "Hiwarkhed" },
      { id: 532288, name: "Inapur" },
      { id: 532210, name: "Indur" },
      { id: 532200, name: "Irur" },
      { id: 532335, name: "Isabpur" },
      { id: 532356, name: "Ismailpur" },
      { id: 532255, name: "Ismailpur (Dabheri)" },
      { id: 532229, name: "Jamathi" },
      { id: 532224, name: "Januna" },
      { id: 532308, name: "Jayatapur" },
      { id: 532222, name: "Jaymalpur" },
      { id: 532314, name: "Kamalapur" },
      { id: 532264, name: "Karajgaon" },
      { id: 532336, name: "Kasampur" },
      { id: 532219, name: "Kashimpur ( La)" },
      { id: 532326, name: "Katpur" },
      { id: 532333, name: "Katsur" },
      { id: 532309, name: "Kawathal" },
      { id: 532269, name: "Khanapur" },
      { id: 532293, name: "Khanpur" },
      { id: 532208, name: "Khed Bhag 1." },
      { id: 944448, name: "Khed Bhag 2" },
      { id: 532313, name: "Khedi Krishnapur" },
      { id: 532220, name: "Khopada" },
      { id: 532345, name: "Kolvihir" },
      { id: 532273, name: "Kopara" },
      { id: 532223, name: "Ladki Bk" },
      { id: 532234, name: "Lakhara" },
      { id: 532320, name: "Lashkarpur" },
      { id: 532304, name: "Lehegaon" },
      { id: 532301, name: "Lihida" },
      { id: 532285, name: "Mahmadabad" },
      { id: 532199, name: "Malkapur" },
      { id: 532204, name: "Mamadapur" },
      { id: 532322, name: "Mamdapur (Katpur)" },
      { id: 532337, name: "Mangrul" },
      { id: 532195, name: "Maniardhi" },
      { id: 532272, name: "Manimpur" },
      { id: 532253, name: "Maywadi" },
      { id: 532262, name: "Mengwadi" },
      { id: 532232, name: "Molvan" },
      { id: 944302, name: "Morshi Rural" },
      { id: 532295, name: "Munaimpur" },
      { id: 532358, name: "Nabipur" },
      { id: 532214, name: "Nagarwadi" },
      { id: 532348, name: "Najarpur" },
      { id: 532279, name: "Nashirpur" },
      { id: 532296, name: "Naya Wathoda" },
      { id: 532307, name: "Nerpingalai Bhag 1." },
      { id: 944449, name: "Nerpinglai Bhag 2" },
      { id: 532312, name: "Nimbharni" },
      { id: 532287, name: "Nimbhi" },
      { id: 532238, name: "Pala" },
      { id: 532280, name: "Pardi" },
      { id: 532332, name: "Patur" },
      { id: 532290, name: "Pimpalkhuta Lahan" },
      { id: 532284, name: "Pimpalkhuta Motha" },
      { id: 532196, name: "Pimpri" },
      { id: 532319, name: "Porgavhan" },
      { id: 532300, name: "Pusala" },
      { id: 532206, name: "Raipur" },
      { id: 532310, name: "Rajurwadi" },
      { id: 532247, name: "Rasulpur Belkheda" },
      { id: 532246, name: "Rasulpur Kopra" },
      { id: 532245, name: "Rasulpur Yerla" },
      { id: 532350, name: "Ridhapur" },
      { id: 532328, name: "Rohankhed" },
      { id: 532283, name: "Rohnala" },
      { id: 532244, name: "Sadatpur" },
      { id: 532354, name: "Sahadapur" },
      { id: 532228, name: "Salbardi" },
      { id: 532316, name: "Salepur" },
      { id: 532286, name: "Sambhapur" },
      { id: 532339, name: "Sawarkhed" },
      { id: 532250, name: "Sawarkhed (Chin)" },
      { id: 532203, name: "Saywada" },
      { id: 532302, name: "Shahanawajpur" },
      { id: 532342, name: "Shirajgaon" },
      { id: 532315, name: "Shiralas" },
      { id: 532303, name: "Shirkhed" },
      { id: 532270, name: "Shivpuri" },
      { id: 532311, name: "Shiwara" },
      { id: 532291, name: "Simbhora" },
      { id: 532217, name: "Sinora" },
      { id: 532221, name: "Songaon" },
      { id: 532324, name: "Sultanpur" },
      { id: 532252, name: "Supala" },
      { id: 532257, name: "Surwadi Bk." },
      { id: 532325, name: "Talegaon" },
      { id: 532282, name: "Talni" },
      { id: 532248, name: "Taroda (Chin)" },
      { id: 532207, name: "Taroda (Khe)" },
      { id: 532239, name: "Tembhi" },
      { id: 532261, name: "Thani" },
      { id: 532260, name: "Thuni" },
      { id: 532351, name: "Trimalpur" },
      { id: 532299, name: "Tuljapur" },
      { id: 532347, name: "Tuljapur (Kavathal)" },
      { id: 532265, name: "Tuljapur (Ritpur)" },
      { id: 532215, name: "Udkhed" },
      { id: 532233, name: "Umarkhed" },
      { id: 532330, name: "Vichori" },
      { id: 532318, name: "Vishnora" },
      { id: 532334, name: "Vitthalpur" },
      { id: 532327, name: "Wagholi" },
      { id: 532216, name: "Warha" },
      { id: 532346, name: "Yadavpur" },
      { id: 532353, name: "Yashwantpur" },
      { id: 532271, name: "Yerla" },
      { id: 532292, name: "Yevti" },
    ],
    4007: [
      { id: 532422, name: "Aampend" },
      { id: 532470, name: "Ajitpur-Bhapki" },
      { id: 532464, name: "Aloda" },
      { id: 532471, name: "Ambafata" },
      { id: 532445, name: "Amdapur" },
      { id: 532437, name: "Amner" },
      { id: 532396, name: "Antarkhop" },
      { id: 532491, name: "Asona" },
      { id: 532434, name: "Babhulkheda" },
      { id: 532369, name: "Bahada" },
      { id: 532482, name: "Bargaon" },
      { id: 532427, name: "Belkheda" },
      { id: 532465, name: "Belora" },
      { id: 532477, name: "Benoda" },
      { id: 532425, name: "Beskheda" },
      { id: 532407, name: "Bhalapur" },
      { id: 532412, name: "Bhandoli Bk" },
      { id: 532364, name: "Bhemdi Mothi" },
      { id: 532440, name: "Chainpur" },
      { id: 532419, name: "Chandas" },
      { id: 532447, name: "Chinchargavhan" },
      { id: 532411, name: "Dabhi" },
      { id: 532444, name: "Dawargaon" },
      { id: 532366, name: "Daywadi" },
      { id: 532441, name: "Deutwada" },
      { id: 532428, name: "Dhaga" },
      { id: 532475, name: "Dhamandhas" },
      { id: 532399, name: "Dhanodi" },
      { id: 532405, name: "Ekalvihir" },
      { id: 532424, name: "Ekdara" },
      { id: 532493, name: "Esapur" },
      { id: 532417, name: "Fattepur" },
      { id: 532461, name: "Gadegaon" },
      { id: 532438, name: "Gaulkhed" },
      { id: 532463, name: "Gaulkheda" },
      { id: 532365, name: "Gavhankund" },
      { id: 532432, name: "Ghorad" },
      { id: 532483, name: "Goregaon" },
      { id: 532443, name: "Hanumantkhed" },
      { id: 532469, name: "Haturna" },
      { id: 532389, name: "Humanpeth" },
      { id: 532370, name: "Isambari" },
      { id: 532448, name: "Isapur" },
      { id: 532433, name: "Ismailpur" },
      { id: 532497, name: "Ittamgaon" },
      { id: 532496, name: "Jamalpur" },
      { id: 532479, name: "Jamgaon Khadka" },
      { id: 532378, name: "Jamgaon Mahendri" },
      { id: 532388, name: "Jamtal" },
      { id: 532406, name: "Jamthi Ganeshpur" },
      { id: 532373, name: "Jarud Bhag 1" },
      { id: 944444, name: "Jarud Bhag 2" },
      { id: 532455, name: "Kachurna" },
      { id: 532485, name: "Karajgaon" },
      { id: 532377, name: "Karli" },
      { id: 532380, name: "Karwar" },
      { id: 532488, name: "Kasari" },
      { id: 532456, name: "Kati" },
      { id: 532408, name: "Kekatwada" },
      { id: 532480, name: "Khadka" },
      { id: 532449, name: "Khanapur" },
      { id: 532384, name: "Khaperkheda" },
      { id: 532409, name: "Kharad" },
      { id: 532392, name: "Khedi" },
      { id: 532401, name: "Kumbhikheda" },
      { id: 532473, name: "Kumdara" },
      { id: 532415, name: "Kurali" },
      { id: 532404, name: "Linga" },
      { id: 532492, name: "Loni" },
      { id: 532371, name: "Mahapur" },
      { id: 532381, name: "Mahendri" },
      { id: 532393, name: "Malkapur" },
      { id: 532397, name: "Malkhed" },
      { id: 532490, name: "Mamdapur" },
      { id: 532368, name: "Mangona" },
      { id: 532452, name: "Mangruli" },
      { id: 532474, name: "Manikpur" },
      { id: 532431, name: "Mendhi" },
      { id: 532374, name: "Milanpur" },
      { id: 532391, name: "Molvihir" },
      { id: 532451, name: "Morangana" },
      { id: 532450, name: "Morchund" },
      { id: 532436, name: "Morshi Kh" },
      { id: 532420, name: "Musalkheda" },
      { id: 532478, name: "Nagziri" },
      { id: 532454, name: "Namapur" },
      { id: 532467, name: "Nandgaon" },
      { id: 532494, name: "Natala" },
      { id: 532429, name: "Naygaon" },
      { id: 532466, name: "Palaswada" },
      { id: 532476, name: "Palsona" },
      { id: 532472, name: "Pandharghati" },
      { id: 532382, name: "Pandhari" },
      { id: 532398, name: "Pardi" },
      { id: 532459, name: "Pawani" },
      { id: 532453, name: "Pethmangruli" },
      { id: 532379, name: "Pimpalgad" },
      { id: 532376, name: "Pimpalkhuta" },
      { id: 532484, name: "Pimpalkhuta Khurd" },
      { id: 532363, name: "Pimpalshenda" },
      { id: 532423, name: "Pimpalvihir" },
      { id: 532426, name: "Porgavhan" },
      { id: 532390, name: "Pusla" },
      { id: 532386, name: "Pusli" },
      { id: 532446, name: "Rajura Bajar" },
      { id: 532383, name: "Ramapur" },
      { id: 532439, name: "Rasulpur" },
      { id: 532361, name: "Rawala" },
      { id: 532414, name: "Roshankhed" },
      { id: 532375, name: "Saidapur" },
      { id: 532387, name: "Satnoor" },
      { id: 532486, name: "Sawanga" },
      { id: 532410, name: "Sawangi" },
      { id: 532372, name: "Shahapur" },
      { id: 532418, name: "Shekapur" },
      { id: 532359, name: "Shekdari" },
      { id: 532394, name: "Shendurjana Ghat" },
      { id: 532495, name: "Shingori" },
      { id: 532413, name: "Shirpur" },
      { id: 532416, name: "Surli" },
      { id: 532400, name: "Suryakheda" },
      { id: 532403, name: "Tarodi" },
      { id: 532462, name: "Tembhani" },
      { id: 532367, name: "Tembhurkheda" },
      { id: 532362, name: "Tiwsa Ghat" },
      { id: 532430, name: "Udapur" },
      { id: 532402, name: "Urad" },
      { id: 532458, name: "Wadala" },
      { id: 532457, name: "Wadegaon" },
      { id: 532487, name: "Wadhona" },
      { id: 532468, name: "Waghal" },
      { id: 532395, name: "Wai Bk." },
      { id: 532385, name: "Wai Kh" },
      { id: 532460, name: "Wandli" },
      { id: 944303, name: "Warud Bhag1" },
      { id: 944304, name: "Warud Bhag2" },
      { id: 532421, name: "Wathoda" },
      { id: 532442, name: "Wawruli" },
      { id: 532435, name: "Wedhapur" },
      { id: 532481, name: "Yerandwadi" },
      { id: 532360, name: "Zatamziri" },
      { id: 532489, name: "Zolamba" },
    ],
    4008: [
      { id: 532571, name: "Adampur" },
      { id: 532545, name: "Akhatwada" },
      { id: 532510, name: "Alipur Ujad" },
      { id: 532581, name: "Alwada" },
      { id: 532554, name: "Ambikapur Ujad" },
      { id: 532542, name: "Amdabad" },
      { id: 532507, name: "Ankwadi" },
      { id: 532589, name: "Balapur Ujad" },
      { id: 532540, name: "Bansapur Ujad" },
      { id: 532541, name: "Bhambora" },
      { id: 532543, name: "Bharaswadi" },
      { id: 532534, name: "Bharwadi" },
      { id: 532590, name: "Bhiwapur" },
      { id: 532577, name: "Borda" },
      { id: 532567, name: "Chakatapur Ujad" },
      { id: 532532, name: "Chandur Dhore" },
      { id: 532559, name: "Chenushtha" },
      { id: 532569, name: "Chikhali" },
      { id: 532516, name: "Dadurni Ujad" },
      { id: 532563, name: "Dahigaon Dhanora Ujad" },
      { id: 532514, name: "Dapori Kh." },
      { id: 532576, name: "Degaon Ujad" },
      { id: 532539, name: "Dehani" },
      { id: 532544, name: "Dhamantri" },
      { id: 532579, name: "Dharwada" },
      { id: 532564, name: "Dhotra" },
      { id: 532570, name: "Diwankhed" },
      { id: 532580, name: "Durgwada" },
      { id: 532521, name: "Fattepur Ja" },
      { id: 532503, name: "Fattepur Shi" },
      { id: 532587, name: "Gavha Balapur" },
      { id: 532573, name: "Ghota" },
      { id: 532522, name: "Godri" },
      { id: 532499, name: "Gurudeo Nagar" },
      { id: 532558, name: "Husenpur" },
      { id: 532524, name: "Isapur" },
      { id: 532582, name: "Jagdishpur" },
      { id: 532557, name: "Jahagirpur" },
      { id: 532551, name: "Jaitapur Ujad" },
      { id: 532572, name: "Jamthi Ujad" },
      { id: 532515, name: "Jawara" },
      { id: 532588, name: "Jawara Ujad" },
      { id: 532520, name: "Karajgaon" },
      { id: 532546, name: "Karimabad Ujad" },
      { id: 532523, name: "Katsur" },
      { id: 532555, name: "Kaudanyapur" },
      { id: 532550, name: "Kawadgavhan" },
      { id: 532518, name: "Kolwan" },
      { id: 532505, name: "Kolwan Ujad" },
      { id: 532583, name: "Kurha Bhag 1" },
      { id: 944866, name: "Kurha Bhag 2" },
      { id: 532509, name: "Maldhur" },
      { id: 532565, name: "Malegaon" },
      { id: 532525, name: "Mamdapur" },
      { id: 532560, name: "Marda" },
      { id: 532568, name: "Mardi" },
      { id: 532584, name: "Masadi" },
      { id: 532501, name: "Mozari" },
      { id: 532552, name: "Murtijapur" },
      { id: 532538, name: "Nimbhora De" },
      { id: 532549, name: "Palwadi" },
      { id: 532508, name: "Raghunathpur" },
      { id: 532585, name: "Rahimabad" },
      { id: 532561, name: "Ranbajpur Ujad" },
      { id: 532511, name: "Salora Bk." },
      { id: 532592, name: "Sarsi" },
      { id: 532519, name: "Satargaon" },
      { id: 532512, name: "Shendola Bk." },
      { id: 532502, name: "Shendola Kh." },
      { id: 532500, name: "Shendurjana Bk." },
      { id: 532548, name: "Shendurjana Kh" },
      { id: 532578, name: "Shindwadi" },
      { id: 532506, name: "Shirajgaon Mozari" },
      { id: 532504, name: "Shiwangaon" },
      { id: 532513, name: "Sujatpur Ujad" },
      { id: 532526, name: "Sultanpur" },
      { id: 532530, name: "Surwadi Bk." },
      { id: 532531, name: "Surwadi Kh." },
      { id: 532529, name: "Talegaon Thakur" },
      { id: 532537, name: "Tarkhed" },
      { id: 532553, name: "Taroda" },
      { id: 532533, name: "Thanathuni" },
      { id: 532528, name: "Tiosa Bhag 1" },
      { id: 944445, name: "Tiosa Bhag 2" },
      { id: 944446, name: "Tiosa Bhag 3" },
      { id: 944447, name: "Tiosa Bhag 4" },
      { id: 532536, name: "Umbarkhed" },
      { id: 532498, name: "Vinchori Ujad" },
      { id: 532566, name: "Virgavhan" },
      { id: 532574, name: "Vishnora Ujad" },
      { id: 532575, name: "Wadura" },
      { id: 532586, name: "Wagda Ujad" },
      { id: 532556, name: "Wandali" },
      { id: 532591, name: "Wandhona" },
      { id: 532527, name: "Wani" },
      { id: 532562, name: "Warha" },
      { id: 532535, name: "Warkhed" },
      { id: 532517, name: "Waruda" },
      { id: 532547, name: "Wathoda Kh" },
    ],
    4009: [
      { id: 943706, name: "Akoli" },
      { id: 532706, name: "Aliyabad" },
      { id: 532643, name: "Amannapur" },
      { id: 532712, name: "Amdapur" },
      { id: 532665, name: "Amla" },
      { id: 532645, name: "Angola" },
      { id: 532717, name: "Anjangaon Bari" },
      { id: 532595, name: "Antora" },
      { id: 532718, name: "Arhad" },
      { id: 532597, name: "Aurangpur" },
      { id: 943714, name: "Badnera" },
      { id: 532704, name: "Bahilolpur" },
      { id: 943715, name: "Benoda" },
      { id: 532622, name: "Bhagvanpur" },
      { id: 532707, name: "Bhankheda Bk." },
      { id: 532708, name: "Bhankheda Kh." },
      { id: 532623, name: "Bharatpur" },
      { id: 532689, name: "Bodna" },
      { id: 532681, name: "Borgaon" },
      { id: 532612, name: "Brahmanwada Govindpur" },
      { id: 532594, name: "Bramhanwada Bhagat" },
      { id: 532700, name: "Chandur" },
      { id: 532677, name: "Changapur" },
      { id: 532615, name: "Chinchkhed" },
      { id: 532611, name: "Dastapur" },
      { id: 532617, name: "Davargaon" },
      { id: 532650, name: "Degaon" },
      { id: 532619, name: "Devapur" },
      { id: 532600, name: "Devra" },
      { id: 532599, name: "Devri" },
      { id: 532636, name: "Dhamana" },
      { id: 532609, name: "Dhanora Kokate" },
      { id: 532628, name: "Digargavhan" },
      { id: 532605, name: "Donad" },
      { id: 532601, name: "Fazalapur" },
      { id: 943708, name: "Gambhirpur" },
      { id: 532714, name: "Gangapur" },
      { id: 532690, name: "Ghatkheda" },
      { id: 532664, name: "Gopalpur" },
      { id: 532715, name: "Govindpur" },
      { id: 532710, name: "Hatla" },
      { id: 532674, name: "Hirapur" },
      { id: 943707, name: "Ilahabad" },
      { id: 532691, name: "Indala" },
      { id: 532657, name: "Jalaka" },
      { id: 532610, name: "Jamdol" },
      { id: 532654, name: "Jamthi" },
      { id: 943709, name: "Jewad" },
      { id: 532669, name: "Kamunja" },
      { id: 532629, name: "Kapustalani" },
      { id: 532614, name: "Karajgaon" },
      { id: 532709, name: "Kastura" },
      { id: 532703, name: "Kat Aamla" },
      { id: 532675, name: "Kathora Bk." },
      { id: 532632, name: "Kathora Kh" },
      { id: 532616, name: "Kekatpur" },
      { id: 532662, name: "Khanapur" },
      { id: 532633, name: "Krushnapur" },
      { id: 532670, name: "Kund Sarjapur" },
      { id: 532713, name: "Kurhad" },
      { id: 532699, name: "Lontek" },
      { id: 532634, name: "Mahadapur" },
      { id: 943716, name: "Mahajanpur" },
      { id: 532626, name: "Mahuli Jahangir" },
      { id: 532630, name: "Malegaon" },
      { id: 532693, name: "Malegaon Ma." },
      { id: 532698, name: "Malkapur" },
      { id: 532646, name: "Malkapur (55)" },
      { id: 532685, name: "Masod" },
      { id: 532716, name: "Mhasala Bhag 1" },
      { id: 944466, name: "Mhasala Bhag 2" },
      { id: 532711, name: "Mogra" },
      { id: 532697, name: "Morangana" },
      { id: 532680, name: "Nagapur" },
      { id: 532653, name: "Nandgaon Peth Bhag 1" },
      { id: 944472, name: "Nandgaon Peth Bhag 2" },
      { id: 532659, name: "Nandura Bk." },
      { id: 532620, name: "Nandura Lashkarpur" },
      { id: 532607, name: "Nandura Pingalai" },
      { id: 532642, name: "Narayanpur" },
      { id: 532618, name: "Narsingpur" },
      { id: 943711, name: "Navsari" },
      { id: 532658, name: "Naya Akola" },
      { id: 532652, name: "Nemtapur" },
      { id: 943712, name: "Nimbhorakhurd" },
      { id: 532667, name: "Ozarkheda" },
      { id: 532639, name: "Pandharpur" },
      { id: 532719, name: "Pardi" },
      { id: 532686, name: "Parsoda" },
      { id: 532602, name: "Parwatpur" },
      { id: 943713, name: "Pethamrawati" },
      { id: 532688, name: "Pimpalkhuta" },
      { id: 532640, name: "Pimpalvihir" },
      { id: 532701, name: "Pimpri" },
      { id: 532647, name: "Pimpri (56)" },
      { id: 532692, name: "Pohara" },
      { id: 532603, name: "Pusada" },
      { id: 944469, name: "Pusada Bhag 2" },
      { id: 943717, name: "Rahatgaon" },
      { id: 532696, name: "Raipur" },
      { id: 943718, name: "Rajapeth" },
      { id: 532684, name: "Rajura" },
      { id: 532676, name: "Ramgaon" },
      { id: 532606, name: "Rasulpur" },
      { id: 532679, name: "Rasulpur 88" },
      { id: 532673, name: "Revsa" },
      { id: 532604, name: "Rohankheda" },
      { id: 532651, name: "Rustampur" },
      { id: 532663, name: "Salora Bk." },
      { id: 532625, name: "Salora Kh" },
      { id: 532621, name: "Saramastabad" },
      { id: 943722, name: "Saturna" },
      { id: 532596, name: "Savanga" },
      { id: 532641, name: "Sawardi" },
      { id: 532656, name: "Shahapur" },
      { id: 943721, name: "Shegaon" },
      { id: 532655, name: "Shevati Jahangir" },
      { id: 532593, name: "Shirala Bhag 1" },
      { id: 944467, name: "Shirala Bhag 2" },
      { id: 944470, name: "Shirala Bhag 3" },
      { id: 532678, name: "Sukali" },
      { id: 532672, name: "Sultanpur" },
      { id: 532687, name: "Sultanpur (96)" },
      { id: 532648, name: "Takli Jaha" },
      { id: 532702, name: "Takli Kh." },
      { id: 532637, name: "Talkhanda" },
      { id: 943710, name: "Tarkheda" },
      { id: 532661, name: "Tembha" },
      { id: 532660, name: "Thugaon" },
      { id: 532631, name: "Tukapur" },
      { id: 532638, name: "Tuljapur" },
      { id: 532720, name: "Udkhed" },
      { id: 532635, name: "Ukali" },
      { id: 532644, name: "Vitthalapur" },
      { id: 532624, name: "Vitthalpur" },
      { id: 532705, name: "Wadad" },
      { id: 943719, name: "Wadali" },
      { id: 532721, name: "Wadgaon Jire" },
      { id: 532683, name: "Wadgaon Mahore" },
      { id: 532682, name: "Wadura" },
      { id: 532627, name: "Wagholi" },
      { id: 532649, name: "Walaki" },
      { id: 532666, name: "Walgaon" },
      { id: 944473, name: "Walgaon Bhag 2" },
      { id: 532671, name: "Wanarshi" },
      { id: 532613, name: "Wardhi" },
      { id: 943720, name: "Waruda" },
      { id: 532668, name: "Warwad" },
      { id: 532598, name: "Yawali" },
    ],
    4010: [
      { id: 532733, name: "Abitpur" },
      { id: 532785, name: "Advi" },
      { id: 532728, name: "Afjalpur" },
      { id: 532835, name: "Alangaon" },
      { id: 944816, name: "Anakwadi" },
      { id: 532746, name: "Anchalwadi" },
      { id: 532800, name: "Antapur" },
      { id: 532815, name: "Asara Bhag 1" },
      { id: 944406, name: "Asara Bhag 2" },
      { id: 532755, name: "Ashti" },
      { id: 532820, name: "Bahadrpur" },
      { id: 532769, name: "Bailmarkheda" },
      { id: 532768, name: "Balegaon" },
      { id: 532792, name: "Ballarkheda" },
      { id: 532766, name: "Bhalsi" },
      { id: 532801, name: "Bhatkuli Bhag 1" },
      { id: 944427, name: "Bhatkuli Bhag 2" },
      { id: 532763, name: "Bokurkheda" },
      { id: 532838, name: "Bondewadi" },
      { id: 532851, name: "Borgaon" },
      { id: 532786, name: "Borkhadi Bk" },
      { id: 532780, name: "Borkhadi Kh" },
      { id: 532803, name: "Chakur" },
      { id: 532776, name: "Chandpur" },
      { id: 532834, name: "Checharwadi" },
      { id: 532842, name: "Chunki" },
      { id: 532818, name: "Dadhi" },
      { id: 532762, name: "Dagdagad" },
      { id: 532807, name: "Dahatonda" },
      { id: 532833, name: "Dararkheda" },
      { id: 532737, name: "Daryabad" },
      { id: 532734, name: "Dastarapur" },
      { id: 532805, name: "Dautpur" },
      { id: 532797, name: "Degurkheda" },
      { id: 532828, name: "Degurkheda (Nimbha)" },
      { id: 532740, name: "Deori" },
      { id: 532774, name: "Dhamori" },
      { id: 532765, name: "Dhangarkheda" },
      { id: 532831, name: "Dholewadi" },
      { id: 532829, name: "Gaiwadi" },
      { id: 532789, name: "Gajagad" },
      { id: 532817, name: "Ganojadevi" },
      { id: 532854, name: "Ganori" },
      { id: 532813, name: "Ghatkheda" },
      { id: 532837, name: "Gopgavhan" },
      { id: 532848, name: "Gourkheda" },
      { id: 532790, name: "Govindpur" },
      { id: 532794, name: "Hartala" },
      { id: 532787, name: "Hartoti" },
      { id: 532778, name: "Hasanapur" },
      { id: 532759, name: "Hatkheda" },
      { id: 532836, name: "Haturna" },
      { id: 532751, name: "Himantpur" },
      { id: 532739, name: "Hirapur" },
      { id: 532821, name: "Ibrahimpur" },
      { id: 532816, name: "Indapur" },
      { id: 532742, name: "Ismailpur" },
      { id: 532791, name: "Jalatapur" },
      { id: 532736, name: "Jalka" },
      { id: 532840, name: "Janewadi" },
      { id: 532809, name: "Jasapur" },
      { id: 532756, name: "Jawara" },
      { id: 532738, name: "Jayatapur" },
      { id: 532784, name: "Kakarkheda" },
      { id: 532724, name: "Kalamgavhan" },
      { id: 532802, name: "Kaliche Khede" },
      { id: 532757, name: "Kamnapur" },
      { id: 532804, name: "Kanfodi" },
      { id: 532808, name: "Kasampur" },
      { id: 532849, name: "Kawtha" },
      { id: 532795, name: "Khalkhoni" },
      { id: 532855, name: "Khallar Ba." },
      { id: 532832, name: "Khanapur" },
      { id: 532822, name: "Kharbi" },
      { id: 532775, name: "Khartalegaon Bhag 1" },
      { id: 944409, name: "Khartalegaon Bhag 2" },
      { id: 532796, name: "Khatijapur" },
      { id: 532783, name: "Kholapur Bhag 1" },
      { id: 944411, name: "Kholapurbhag 2" },
      { id: 532793, name: "Koltek" },
      { id: 532845, name: "Krishnapur" },
      { id: 532830, name: "Kumagad" },
      { id: 532827, name: "Kund Khurd" },
      { id: 532753, name: "Makrampur" },
      { id: 532743, name: "Makrandabad" },
      { id: 532741, name: "Malapur" },
      { id: 532773, name: "Malkapur" },
      { id: 532754, name: "Malpur" },
      { id: 532814, name: "Mankheda" },
      { id: 532752, name: "Marki" },
      { id: 532781, name: "Mhaispur" },
      { id: 532811, name: "Nanded Kh" },
      { id: 532847, name: "Narayanpur" },
      { id: 532727, name: "Narayanpur (Nimbha)" },
      { id: 532782, name: "Nawed" },
      { id: 532779, name: "Nawthal Bk" },
      { id: 532788, name: "Nawthal Khu.(Bhatukali)" },
      { id: 532846, name: "Nimbha" },
      { id: 532850, name: "Nimbhora Bk" },
      { id: 532758, name: "Nimkheda" },
      { id: 532770, name: "Nindodi" },
      { id: 532747, name: "Nirul Gangamai" },
      { id: 532852, name: "Parlam" },
      { id: 532819, name: "Pedhi" },
      { id: 532730, name: "Pohara" },
      { id: 532731, name: "Purnanagar" },
      { id: 532748, name: "Raipur" },
      { id: 532722, name: "Rajegaon" },
      { id: 532732, name: "Rama" },
      { id: 532726, name: "Rasulpur" },
      { id: 532812, name: "Runmochan" },
      { id: 532729, name: "Rustampur" },
      { id: 532723, name: "Sambhegaon" },
      { id: 532839, name: "Sarbalampur" },
      { id: 532799, name: "Sarmaspur" },
      { id: 532725, name: "Saur" },
      { id: 532826, name: "Sawarkheda" },
      { id: 532806, name: "Sayat" },
      { id: 532853, name: "Sherpur" },
      { id: 532823, name: "Shipgaon" },
      { id: 532857, name: "Shivni Bk" },
      { id: 532858, name: "Shivni Kd" },
      { id: 532844, name: "Shiwapur" },
      { id: 532771, name: "Sonarkheda" },
      { id: 532735, name: "Takarkheda Shambhu" },
      { id: 532825, name: "Tatarpur" },
      { id: 532841, name: "Thetkheda" },
      { id: 532824, name: "Tuljapur" },
      { id: 532764, name: "Udapur" },
      { id: 532750, name: "Umarapur" },
      { id: 532744, name: "Umartek" },
      { id: 532856, name: "Uttamsara" },
      { id: 532760, name: "Virshi" },
      { id: 532810, name: "Wadala" },
      { id: 532798, name: "Waghoda" },
      { id: 532761, name: "Waigaon" },
      { id: 532749, name: "Waki" },
      { id: 532767, name: "Wandli" },
      { id: 532843, name: "Wasewadi" },
      { id: 532772, name: "Wathoda Shukleshwar" },
      { id: 532745, name: "Watonda" },
      { id: 532777, name: "Zanji" },
    ],
    4011: [
      { id: 532883, name: "Adula" },
      { id: 532991, name: "Ahmadpur" },
      { id: 532992, name: "Ajitpur" },
      { id: 532977, name: "Alampur" },
      { id: 533005, name: "Amla" },
      { id: 532870, name: "Antargaon" },
      { id: 532880, name: "Antargaon Shivaji" },
      { id: 532990, name: "Arala" },
      { id: 532927, name: "Babhali" },
      { id: 532893, name: "Bahadarpur" },
      { id: 532930, name: "Banosa" },
      { id: 532967, name: "Belora" },
      { id: 532955, name: "Bembala Budruk" },
      { id: 532958, name: "Bembala Kh." },
      { id: 532997, name: "Bhambora" },
      { id: 532897, name: "Bhamod" },
      { id: 532912, name: "Bhuikheda" },
      { id: 532943, name: "Bhujwada" },
      { id: 532874, name: "Bhuras Ramagad" },
      { id: 532989, name: "Borala" },
      { id: 532965, name: "Chandai" },
      { id: 532985, name: "Chandikapur" },
      { id: 532899, name: "Chandkhed" },
      { id: 532910, name: "Chandola" },
      { id: 532963, name: "Chandpur" },
      { id: 532929, name: "Chandur" },
      { id: 532987, name: "Darapur" },
      { id: 532942, name: "Darkheda" },
      { id: 532931, name: "Daryapur" },
      { id: 532905, name: "Dhamana Kh." },
      { id: 532902, name: "Dhamodi" },
      { id: 532998, name: "Dhanora Jahagir" },
      { id: 532951, name: "Dighi" },
      { id: 532982, name: "Dongargaon" },
      { id: 532908, name: "Eklara Bhamod" },
      { id: 533002, name: "Elichpur" },
      { id: 532949, name: "Elori Mirzapur" },
      { id: 532918, name: "Gajipur" },
      { id: 532889, name: "Ganeshapur" },
      { id: 532962, name: "Gaurkheda" },
      { id: 532936, name: "Gaywadi." },
      { id: 532953, name: "Ghada" },
      { id: 532876, name: "Ghodchandi" },
      { id: 533004, name: "Ghuikhed" },
      { id: 532891, name: "Golegaon" },
      { id: 532981, name: "Haibatpur" },
      { id: 532922, name: "Hasanpur" },
      { id: 532903, name: "Hingani Mirzapur" },
      { id: 532975, name: "Husenpur" },
      { id: 532944, name: "Ichora" },
      { id: 532938, name: "Indalwadi" },
      { id: 532871, name: "Itki" },
      { id: 532877, name: "Jagarwadi" },
      { id: 532950, name: "Jahanpur" },
      { id: 532924, name: "Jahanpur Khurd" },
      { id: 532882, name: "Jainpur" },
      { id: 532940, name: "Jaitapur" },
      { id: 532995, name: "Jasapur" },
      { id: 532996, name: "Jitapur" },
      { id: 533001, name: "Kalamgavhan" },
      { id: 532933, name: "Kalashi" },
      { id: 532974, name: "Kanholi" },
      { id: 532925, name: "Kapshi" },
      { id: 532913, name: "Karatkhed" },
      { id: 532886, name: "Kasampur" },
      { id: 532863, name: "Katkheda" },
      { id: 533008, name: "Khairi" },
      { id: 532993, name: "Khalilpur" },
      { id: 532956, name: "Khallar." },
      { id: 532971, name: "Khanpur" },
      { id: 532873, name: "Kharsanglood" },
      { id: 532986, name: "Khel Nagawe" },
      { id: 532964, name: "Khirgavhan" },
      { id: 532916, name: "Khurmabad" },
      { id: 532920, name: "Khursanpur" },
      { id: 532973, name: "Kolambi" },
      { id: 532866, name: "Kuberi" },
      { id: 532945, name: "Kukasa" },
      { id: 532959, name: "Landi" },
      { id: 532906, name: "Lasur" },
      { id: 532921, name: "Lehegaon" },
      { id: 532928, name: "Lodhipur" },
      { id: 532915, name: "Lohitkhed" },
      { id: 532898, name: "Lotwada" },
      { id: 532904, name: "Mahamadpur Atkali" },
      { id: 532948, name: "Mahimapur" },
      { id: 532979, name: "Mahuli Dhande" },
      { id: 532966, name: "Malkapur Bk." },
      { id: 532961, name: "Markanda" },
      { id: 532984, name: "Matargaon" },
      { id: 532968, name: "Mhaispur" },
      { id: 532896, name: "Mhaispur Mocharda." },
      { id: 532969, name: "Mulpatabad" },
      { id: 532888, name: "Mustafapur" },
      { id: 532917, name: "Nachona" },
      { id: 532999, name: "Naigaon" },
      { id: 532970, name: "Nalwada" },
      { id: 532994, name: "Nanded Bk." },
      { id: 532894, name: "Nandrun" },
      { id: 532980, name: "Nandura" },
      { id: 532976, name: "Nardoda" },
      { id: 533003, name: "Narsingpur" },
      { id: 532939, name: "Panora" },
      { id: 532895, name: "Patharvira" },
      { id: 532926, name: "Peth Itbarpur" },
      { id: 532875, name: "Pimpalkhuta" },
      { id: 532881, name: "Pimplod Bhag 1" },
      { id: 944475, name: "Pimplod Bhag 2" },
      { id: 532957, name: "Pralhadpur" },
      { id: 532860, name: "Rajkheda" },
      { id: 532900, name: "Ramagad" },
      { id: 532972, name: "Ramgaon" },
      { id: 532907, name: "Ramtirtha" },
      { id: 532914, name: "Rustampur" },
      { id: 532878, name: "Sagarwadi" },
      { id: 532887, name: "Samada" },
      { id: 532947, name: "Sangawa Bk." },
      { id: 532946, name: "Sangawa Kh." },
      { id: 532872, name: "Sanglood." },
      { id: 532884, name: "Sasan Bk." },
      { id: 532885, name: "Sasan Ramapur" },
      { id: 532923, name: "Shahapur" },
      { id: 532935, name: "Shinganwadi" },
      { id: 532988, name: "Shingnapur" },
      { id: 533007, name: "Shirajda" },
      { id: 532937, name: "Shivar Bk." },
      { id: 532954, name: "Shivarkheda" },
      { id: 532890, name: "Shiwar Kh." },
      { id: 532978, name: "Sikandarpur" },
      { id: 532919, name: "Sonkhas" },
      { id: 532911, name: "Sonkheda" },
      { id: 532892, name: "Soundli Hirapur" },
      { id: 532934, name: "Sujapur" },
      { id: 532909, name: "Sukali" },
      { id: 532941, name: "Takali" },
      { id: 532983, name: "Takarkheda Kaware" },
      { id: 532869, name: "Tamaswadi" },
      { id: 532864, name: "Telkheda" },
      { id: 532932, name: "Thilori" },
      { id: 944869, name: "Thilori 1" },
      { id: 532901, name: "Tonglabad." },
      { id: 532867, name: "Umari Itbarpur" },
      { id: 533000, name: "Umari Kurankhed" },
      { id: 532865, name: "Umari Mamdabad" },
      { id: 532960, name: "Uprai." },
      { id: 532868, name: "Vdhal Gavhan" },
      { id: 532859, name: "Wadner Gangai 1" },
      { id: 944483, name: "Wadner Gangai 2" },
      { id: 944485, name: "Wadner Gangai 3" },
      { id: 532952, name: "Wadura" },
      { id: 532861, name: "Warud Bk." },
      { id: 532862, name: "Yeoda 1" },
      { id: 944478, name: "Yeoda 3" },
      { id: 532879, name: "Yerandgaon" },
      { id: 944451, name: "Yevda 2" },
      { id: 533006, name: "Zingala" },
    ],
    4012: [
      { id: 533042, name: "Adgaon Bk." },
      { id: 533018, name: "Adgaon Kh." },
      { id: 533122, name: "Aditapur" },
      { id: 533010, name: "Ajani" },
      { id: 533094, name: "Ajmatpur" },
      { id: 533160, name: "Amdapur" },
      { id: 533161, name: "Arjunpur" },
      { id: 533078, name: "Bachharapur" },
      { id: 533146, name: "Bakhalapur" },
      { id: 533167, name: "Belora" },
      { id: 533019, name: "Belora Hirapur" },
      { id: 533054, name: "Bhagura" },
      { id: 533024, name: "Bopnemtabad" },
      { id: 533111, name: "Borgaon" },
      { id: 533033, name: "Chakora" },
      { id: 533053, name: "Chandsura" },
      { id: 533164, name: "Chikhali Vaidya" },
      { id: 533089, name: "Chincholi" },
      { id: 533016, name: "Dabha" },
      { id: 533044, name: "Dadapur" },
      { id: 533021, name: "Dahigaon" },
      { id: 533147, name: "Deulgavhan" },
      { id: 533168, name: "Dhamak" },
      { id: 533056, name: "Dhanora Fasi" },
      { id: 533067, name: "Dhanora Gurav." },
      { id: 533035, name: "Dhanora Jog." },
      { id: 533166, name: "Dhanora Sikra" },
      { id: 533090, name: "Dharwadi" },
      { id: 533119, name: "Dhawalsar" },
      { id: 533026, name: "Dhawalsari" },
      { id: 533153, name: "Dhengala" },
      { id: 533014, name: "Durgapur" },
      { id: 533061, name: "Eklarbid" },
      { id: 533137, name: "Eklaspur" },
      { id: 533046, name: "Erandgaon" },
      { id: 533083, name: "Fatepur" },
      { id: 533009, name: "Fulamala" },
      { id: 533130, name: "Ganeshpur" },
      { id: 533144, name: "Gangapur" },
      { id: 533081, name: "Gaurkheda" },
      { id: 533163, name: "Gavner Talegaon" },
      { id: 533027, name: "Gharfal" },
      { id: 533095, name: "Ghol" },
      { id: 533155, name: "Golegaon" },
      { id: 533159, name: "Harni" },
      { id: 533133, name: "Hasapur" },
      { id: 533022, name: "Hiwara Bk" },
      { id: 533117, name: "Hiwara Murade" },
      { id: 533152, name: "Inzala" },
      { id: 533123, name: "Itapur" },
      { id: 533154, name: "Jagatpur" },
      { id: 533034, name: "Jaisinga" },
      { id: 533036, name: "Jalu" },
      { id: 533050, name: "Jamathi" },
      { id: 533051, name: "Jamgaon" },
      { id: 533037, name: "Januna" },
      { id: 533052, name: "Jasapur" },
      { id: 533038, name: "Jawara" },
      { id: 533088, name: "Jawara Molvan" },
      { id: 533115, name: "Kajana" },
      { id: 533075, name: "Kanas" },
      { id: 533135, name: "Kani Mirzapur." },
      { id: 533063, name: "Kanzara" },
      { id: 533104, name: "Kekatpur" },
      { id: 533157, name: "Khanapur" },
      { id: 533132, name: "Khandala Kh ." },
      { id: 533124, name: "Kharabi" },
      { id: 533165, name: "Kharbi Gund" },
      { id: 533148, name: "Khed Pimpri." },
      { id: 533040, name: "Khirsana" },
      { id: 533108, name: "Kodori" },
      { id: 533102, name: "Kohala Jateshwar" },
      { id: 533058, name: "Kothoda" },
      { id: 533131, name: "Lohogaon" },
      { id: 533020, name: "Loni" },
      { id: 533085, name: "Mahimapur" },
      { id: 533059, name: "Maholi Chor" },
      { id: 533150, name: "Malegaon" },
      { id: 533156, name: "Malkapur" },
      { id: 533142, name: "Mangrul Chavhala." },
      { id: 533049, name: "Manjari" },
      { id: 533047, name: "Mhasala" },
      { id: 533064, name: "Mirzapur" },
      { id: 533120, name: "Mirzapur 1" },
      { id: 533065, name: "Mokhad" },
      { id: 533025, name: "Morgaon" },
      { id: 533077, name: "Mund Dhan" },
      { id: 533091, name: "Mund Gurao" },
      { id: 533080, name: "Mund Hindurao" },
      { id: 533079, name: "Mund Mali" },
      { id: 533092, name: "Mund Narayan" },
      { id: 533086, name: "Mund Wada" },
      { id: 533071, name: "Mund Zunjarrao" },
      { id: 533073, name: "Mundbari" },
      { id: 533070, name: "Mundnishankrao" },
      { id: 533023, name: "Nagzari" },
      { id: 533082, name: "Nandsawangi" },
      { id: 533028, name: "Nandura Khurd" },
      { id: 533098, name: "Nandurabad" },
      { id: 533100, name: "Nimaswada" },
      { id: 533017, name: "Nimbhora Lahe" },
      { id: 533162, name: "Nimgavhan" },
      { id: 533041, name: "Nirsana" },
      { id: 533072, name: "Omkarkheda" },
      { id: 533141, name: "Pachod" },
      { id: 533136, name: "Pahur" },
      { id: 533015, name: "Pala" },
      { id: 533121, name: "Palas Mandal" },
      { id: 533116, name: "Papal" },
      { id: 533093, name: "Phubgaon" },
      { id: 533105, name: "Pimpalgaon (Bainai)" },
      { id: 533149, name: "Pimpalgaon Nipani" },
      { id: 533043, name: "Pimpri" },
      { id: 533118, name: "Pimpri Gavanda" },
      { id: 533112, name: "Pimpri Nipani" },
      { id: 533125, name: "Pimpri Pochchha" },
      { id: 533109, name: "Pusner" },
      { id: 533048, name: "Rahimapur" },
      { id: 533114, name: "Rajana" },
      { id: 533127, name: "Rampur" },
      { id: 533140, name: "Rasulpur" },
      { id: 533087, name: "Rohana" },
      { id: 533101, name: "Sakhra" },
      { id: 533145, name: "Salod" },
      { id: 533138, name: "Sangrampur" },
      { id: 533055, name: "Sarsi" },
      { id: 533062, name: "Satargaon" },
      { id: 533060, name: "Sawaner" },
      { id: 533068, name: "Sawanga Gurav" },
      { id: 533074, name: "Shahapur" },
      { id: 533143, name: "Shahapur Khekadi" },
      { id: 533096, name: "Shelu Natwa" },
      { id: 533030, name: "Shelugund" },
      { id: 533012, name: "Shendani" },
      { id: 533106, name: "Shingoli" },
      { id: 533069, name: "Shirpur" },
      { id: 533151, name: "Shivra" },
      { id: 533139, name: "Shiwani" },
      { id: 533032, name: "Siddhanathpur" },
      { id: 533066, name: "Siloda" },
      { id: 533113, name: "Sukhli Gurav" },
      { id: 533099, name: "Sultanpur (Pimpri)" },
      { id: 533110, name: "Sultanpur (Shelu)" },
      { id: 533011, name: "Takli Bk." },
      { id: 533103, name: "Takli Gilba" },
      { id: 533057, name: "Takli Kanada" },
      { id: 533128, name: "Tighara" },
      { id: 533039, name: "Timtala" },
      { id: 533158, name: "Tuljapur" },
      { id: 533126, name: "Undir Kheda" },
      { id: 533134, name: "Veni Ganeshpur" },
      { id: 533084, name: "Wadala" },
      { id: 533129, name: "Wadhona Ramnath" },
      { id: 533031, name: "Wadura" },
      { id: 533097, name: "Waghoda" },
      { id: 533107, name: "Wagholi" },
      { id: 533045, name: "Wakpur" },
      { id: 533013, name: "Walki" },
      { id: 533029, name: "Watpur" },
      { id: 533076, name: "Yenas" },
      { id: 533169, name: "Yeoti" },
    ],
    4013: [
      { id: 533204, name: "Ajitpur (U)" },
      { id: 533207, name: "Ambapur" },
      { id: 533180, name: "Amdori" },
      { id: 533176, name: "Amla Vishveshwar" },
      { id: 533232, name: "Ashrafpur" },
      { id: 533212, name: "Bagapur" },
      { id: 533239, name: "Baggi" },
      { id: 533187, name: "Baslapur" },
      { id: 533229, name: "Bhiltek" },
      { id: 533246, name: "Bori" },
      { id: 533249, name: "Botha (U)" },
      { id: 533183, name: "Bramhi" },
      { id: 533203, name: "Budhali" },
      { id: 944439, name: "Chandur Railway Bhag 1" },
      { id: 944442, name: "Chandur Railway Bhag 2" },
      { id: 533257, name: "Chandurkheda" },
      { id: 533171, name: "Chirodi" },
      { id: 533200, name: "Dahigaon" },
      { id: 533243, name: "Danapur" },
      { id: 533192, name: "Dhanapur" },
      { id: 533216, name: "Dhanodi" },
      { id: 533206, name: "Dhanora Mhali" },
      { id: 533227, name: "Dhanora Mogal" },
      { id: 533252, name: "Dhotra" },
      { id: 533223, name: "Dighi Kolhe" },
      { id: 533193, name: "Dilawarpur" },
      { id: 533256, name: "Eklara" },
      { id: 533236, name: "Ekpala" },
      { id: 533172, name: "Gaurkheda" },
      { id: 533255, name: "Ghuikhed" },
      { id: 533222, name: "Hadpa" },
      { id: 533240, name: "Ibrahimpur" },
      { id: 533213, name: "Ismailpur" },
      { id: 533233, name: "Jahagirpur" },
      { id: 533178, name: "Jalka Jagtap" },
      { id: 533245, name: "Jawala" },
      { id: 533241, name: "Jawra" },
      { id: 533218, name: "Kalamgaon" },
      { id: 533219, name: "Kalamjapur" },
      { id: 533173, name: "Karala" },
      { id: 533221, name: "Kawtha Kadu" },
      { id: 533250, name: "Khambala" },
      { id: 533225, name: "Khanapur" },
      { id: 533259, name: "Kharbi Mandavgad" },
      { id: 533205, name: "Khudavantpur" },
      { id: 533251, name: "Kirjawala" },
      { id: 533226, name: "Kodori Harak" },
      { id: 533224, name: "Kohla" },
      { id: 533185, name: "Lalkhed" },
      { id: 533190, name: "Lasnapur" },
      { id: 533201, name: "Malkhed" },
      { id: 533191, name: "Mandwa" },
      { id: 533199, name: "Manjarkhed (Kasaba)" },
      { id: 533244, name: "Manjarkhed Danapur" },
      { id: 533253, name: "Mogra" },
      { id: 533186, name: "Mota (U)" },
      { id: 533234, name: "Murtizapur" },
      { id: 944826, name: "Naya Sawanga" },
      { id: 533210, name: "Neknanpur" },
      { id: 533238, name: "Nimbha" },
      { id: 533242, name: "Nimgavhan" },
      { id: 533181, name: "Nimla" },
      { id: 533220, name: "Palaskhed" },
      { id: 533175, name: "Pathargaon" },
      { id: 533197, name: "Rajana" },
      { id: 533237, name: "Rajura" },
      { id: 533211, name: "Sagulwada" },
      { id: 533177, name: "Salora Kh." },
      { id: 533217, name: "Satefal" },
      { id: 944443, name: "Satefal Bhag 2" },
      { id: 533260, name: "Sawanga Bk." },
      { id: 533184, name: "Sawanga Vithoba" },
      { id: 533182, name: "Sawangi Magrapur" },
      { id: 533228, name: "Sawangi Sangam" },
      { id: 533194, name: "Shirajgaon Korde" },
      { id: 533208, name: "Shivni" },
      { id: 533209, name: "Songaon" },
      { id: 533231, name: "Sonora Bk." },
      { id: 533230, name: "Sonora Kh." },
      { id: 533214, name: "Supalwada" },
      { id: 533202, name: "Takli" },
      { id: 533188, name: "Taroda" },
      { id: 533189, name: "Tembhurni" },
      { id: 533174, name: "Thugaon" },
      { id: 533254, name: "Titwa" },
      { id: 533235, name: "Tongalabad" },
      { id: 533195, name: "Tuljapur" },
      { id: 533179, name: "Umarpur" },
      { id: 533215, name: "Wadgaon Bhatt (U)" },
      { id: 533248, name: "Wai" },
      { id: 533196, name: "Wai Both" },
      { id: 533247, name: "Wajradevi" },
      { id: 533261, name: "Yerad" },
      { id: 533258, name: "Zibla" },
    ],
    4014: [
      { id: 533321, name: "Aajangaon" },
      { id: 533325, name: "Amadabad" },
      { id: 533264, name: "Anjansingi" },
      { id: 533263, name: "Anjanwati" },
      { id: 533354, name: "Asegaon" },
      { id: 533269, name: "Ashok Nagar" },
      { id: 533330, name: "Ashta" },
      { id: 533324, name: "Bahirampur" },
      { id: 533278, name: "Barhanpur" },
      { id: 533342, name: "Bhatkuli" },
      { id: 533316, name: "Bhilli" },
      { id: 533337, name: "Borgaon Dhande" },
      { id: 533299, name: "Borgaon Nistane" },
      { id: 533343, name: "Borwaghal" },
      { id: 533331, name: "Chincholi" },
      { id: 533277, name: "Chinchpur" },
      { id: 533273, name: "Dabhada" },
      { id: 533315, name: "Dattapur" },
      { id: 533365, name: "Daulatabad" },
      { id: 533364, name: "Devgaon." },
      { id: 533266, name: "Dhakulgaon" },
      { id: 533294, name: "Dighi Mahalle" },
      { id: 533345, name: "Dipori" },
      { id: 533372, name: "Edalabad" },
      { id: 533358, name: "Ganeshpur" },
      { id: 533308, name: "Gangajali" },
      { id: 533268, name: "Gavha Farkade" },
      { id: 533270, name: "Gavha Nipani" },
      { id: 533350, name: "Ghusali" },
      { id: 533335, name: "Giroli" },
      { id: 533300, name: "Gokulsara" },
      { id: 533305, name: "Gunji" },
      { id: 533292, name: "Haibatpur" },
      { id: 533370, name: "Haibatpur 1" },
      { id: 533317, name: "Hingangaon" },
      { id: 533297, name: "Hirapur" },
      { id: 533307, name: "Hirapur 1" },
      { id: 533323, name: "Hirpur" },
      { id: 533339, name: "Isapur" },
      { id: 533310, name: "Jalgaon Arvi" },
      { id: 533290, name: "Jalgaon Mangrul" },
      { id: 533362, name: "Jalka Patache" },
      { id: 533288, name: "Janhapur" },
      { id: 533341, name: "Jodhapur" },
      { id: 533312, name: "Juna Dhamangaon" },
      { id: 533319, name: "Kalashi" },
      { id: 533356, name: "Kamnapur" },
      { id: 533326, name: "Kasarkheda" },
      { id: 533351, name: "Kashikhed" },
      { id: 533272, name: "Kawali" },
      { id: 533366, name: "Khanapur" },
      { id: 533298, name: "Khanapur (Talegaon)" },
      { id: 533340, name: "Kharda" },
      { id: 533360, name: "Mahimapur" },
      { id: 533361, name: "Malatpur" },
      { id: 533349, name: "Mambapur" },
      { id: 533262, name: "Mirpur" },
      { id: 533311, name: "Mirzapur" },
      { id: 533367, name: "Mubarakpur" },
      { id: 533295, name: "Mulfatpur" },
      { id: 533287, name: "Mund Anant Vyankatesh" },
      { id: 533284, name: "Mund Daf Ambapur" },
      { id: 533285, name: "Mund Dattaji Tryambak" },
      { id: 533289, name: "Mund Kadtaram Damodhar" },
      { id: 533283, name: "Mund Khushal Raghunath" },
      { id: 533293, name: "Mund Malhar Koner" },
      { id: 533291, name: "Mund Nilkanth Sakharam" },
      { id: 533286, name: "Mund Vyankatesh Bhashkar" },
      { id: 533363, name: "Nagapur" },
      { id: 533352, name: "Nargawandi" },
      { id: 533282, name: "Naygaon" },
      { id: 533373, name: "Nimbapur" },
      { id: 533320, name: "Nimbhora Bodkha" },
      { id: 533318, name: "Nimbhora Raj" },
      { id: 533328, name: "Nimboli" },
      { id: 533314, name: "Parsodi" },
      { id: 533359, name: "Pathanpur" },
      { id: 533296, name: "Peth Raghunathpur" },
      { id: 533265, name: "Pimpalkhuta" },
      { id: 533338, name: "Raipur" },
      { id: 533309, name: "Ramgaon" },
      { id: 533271, name: "Rasulpur" },
      { id: 533301, name: "Salabadpur" },
      { id: 533322, name: "Salimpur" },
      { id: 533369, name: "Samsherpur Bk." },
      { id: 533371, name: "Samsherpur Kh." },
      { id: 533353, name: "Sawla" },
      { id: 533267, name: "Sayadpur" },
      { id: 533306, name: "Shahapur" },
      { id: 944874, name: "Shendurjana (Khu) Bhag 2" },
      { id: 533357, name: "Shendurjana Khurd Bhag 1" },
      { id: 533279, name: "Shidodi" },
      { id: 533333, name: "Sonegaon" },
      { id: 533302, name: "Sonora Kakde" },
      { id: 533327, name: "Talani" },
      { id: 944872, name: "Talegaon Bhag 2" },
      { id: 944873, name: "Talegaon Bhag 3" },
      { id: 533368, name: "Talegaon Bhag. 1" },
      { id: 533304, name: "Taroda" },
      { id: 533348, name: "Tiwra" },
      { id: 533276, name: "Tuljapur" },
      { id: 533344, name: "Usalgavhan" },
      { id: 533334, name: "Vaknath" },
      { id: 533275, name: "Vasad" },
      { id: 533303, name: "Virul Ronghe" },
      { id: 533336, name: "Vitala" },
      { id: 533347, name: "Wadgaon Bajdi" },
      { id: 533346, name: "Wadgaon Rajdi" },
      { id: 533355, name: "Wadhona" },
      { id: 533313, name: "Wagholi" },
      { id: 533281, name: "Warud Bagaji" },
      { id: 533274, name: "Wathoda Bk." },
      { id: 533280, name: "Yerli" },
      { id: 533329, name: "Zada" },
      { id: 533332, name: "Zadgaon" },
    ],
    4015: [
      { id: 533450, name: "Abadkinhi" },
      { id: 533508, name: "Abdalpur" },
      { id: 533519, name: "Afzalpur" },
      { id: 533420, name: "Ahmadpur" },
      { id: 533506, name: "Ajitpur" },
      { id: 533402, name: "Ajitpur (Saza Nandora)" },
      { id: 533417, name: "Allipur" },
      { id: 533511, name: "Aloda" },
      { id: 533430, name: "Ambikapur" },
      { id: 533507, name: "Anandwadi" },
      { id: 533527, name: "Antapur" },
      { id: 533431, name: "Antora" },
      { id: 533465, name: "Ashti" },
      { id: 533514, name: "Bahadarpur" },
      { id: 533485, name: "Bambarda" },
      { id: 533422, name: "Belora Bk" },
      { id: 533530, name: "Belora Kh" },
      { id: 533396, name: "Bhadkumbh" },
      { id: 533495, name: "Bharaswada" },
      { id: 533503, name: "Bhishnur" },
      { id: 533518, name: "Bondnapur" },
      { id: 533383, name: "Borgaon" },
      { id: 533405, name: "Borkhedi" },
      { id: 533455, name: "Borkhedi(Saza Sahur)" },
      { id: 533477, name: "Bramhanwada" },
      { id: 533453, name: "Chamala" },
      { id: 533448, name: "Check Kinhi" },
      { id: 533462, name: "Chekbandi" },
      { id: 533499, name: "Chinchkumbha" },
      { id: 533408, name: "Chinchkumbha( Saza Narsingpur)" },
      { id: 533460, name: "Chincholi" },
      { id: 533517, name: "Chistur" },
      { id: 533473, name: "Dalapatpur" },
      { id: 533502, name: "Daulatpur" },
      { id: 533525, name: "Dautpur" },
      { id: 533428, name: "Delwadi" },
      { id: 533501, name: "Deogaon" },
      { id: 533412, name: "Dhadi" },
      { id: 533469, name: "Dongargaon" },
      { id: 533385, name: "Dugrawada" },
      { id: 533513, name: "Durgapur" },
      { id: 533401, name: "Gavala" },
      { id: 533415, name: "Ghatsur" },
      { id: 533493, name: "Godavari" },
      { id: 533528, name: "Harishwada" },
      { id: 533418, name: "Husenabad" },
      { id: 533419, name: "Husnabad" },
      { id: 533510, name: "Indarmari" },
      { id: 533443, name: "Isapur" },
      { id: 533492, name: "Ismailpur" },
      { id: 533437, name: "Jaitapur" },
      { id: 533490, name: "Jamalpur" },
      { id: 533434, name: "Jamaratpur" },
      { id: 533406, name: "Jamgaon" },
      { id: 533463, name: "Jatashankar" },
      { id: 533424, name: "Jolwadi" },
      { id: 533509, name: "Junona" },
      { id: 533523, name: "Kakad Dara (Saza Dhadi)" },
      { id: 533444, name: "Kakaddara" },
      { id: 533456, name: "Karola" },
      { id: 533421, name: "Kashimpur" },
      { id: 533531, name: "Khadaka" },
      { id: 533478, name: "Khadki" },
      { id: 533429, name: "Khambit" },
      { id: 533400, name: "Khanapur" },
      { id: 533461, name: "Kinhala" },
      { id: 533445, name: "Kolhakali" },
      { id: 533374, name: "Kopra" },
      { id: 533436, name: "Lahan Arvi" },
      { id: 533411, name: "Lakhanwada" },
      { id: 533435, name: "Lingapur" },
      { id: 533529, name: "Mahadapur" },
      { id: 533441, name: "Malkapur" },
      { id: 533500, name: "Mamdapur" },
      { id: 533410, name: "Manikwada" },
      { id: 533391, name: "Milanpur" },
      { id: 533459, name: "Mirzapur" },
      { id: 533457, name: "Moi" },
      { id: 533468, name: "Mominabad" },
      { id: 533470, name: "Mubarakpur" },
      { id: 533458, name: "Mubarakpur( Saza Parsoda)" },
      { id: 533474, name: "Munimpur" },
      { id: 533504, name: "Nababpur" },
      { id: 533395, name: "Nagazari" },
      { id: 533484, name: "Nagazari( Saza Borgaon)" },
      { id: 533416, name: "Nandora" },
      { id: 533497, name: "Narayanpur" },
      { id: 533491, name: "Narsapur" },
      { id: 533482, name: "Narsingpur" },
      { id: 533432, name: "Navin Antora" },
      { id: 533466, name: "Navin Ashti" },
      { id: 533522, name: "Navin Ramdara" },
      { id: 533376, name: "Pagapur" },
      { id: 533451, name: "Palsona" },
      { id: 533413, name: "Panchala" },
      { id: 533442, name: "Pandhurna" },
      { id: 533480, name: "Parsoda" },
      { id: 533407, name: "Peth" },
      { id: 533464, name: "Peth Ahmadpur" },
      { id: 533426, name: "Pilapur" },
      { id: 533375, name: "Pimpla" },
      { id: 533414, name: "Porgavhan" },
      { id: 533423, name: "Raipur" },
      { id: 533403, name: "Rajapur" },
      { id: 533382, name: "Rambhapur" },
      { id: 533521, name: "Ramdara" },
      { id: 533488, name: "Ramgaon" },
      { id: 533496, name: "Rampuri" },
      { id: 533526, name: "Ranwadi" },
      { id: 533398, name: "Rashidpur" },
      { id: 533467, name: "Rasulpur" },
      { id: 533381, name: "Rohna" },
      { id: 533389, name: "Rudrapur" },
      { id: 533487, name: "Sabapur" },
      { id: 533390, name: "Sahur" },
      { id: 533520, name: "Sakindapur" },
      { id: 533386, name: "Salora" },
      { id: 533393, name: "Satnur" },
      { id: 533394, name: "Sattarpur" },
      { id: 533377, name: "Sawanga" },
      { id: 533516, name: "Sayadpur" },
      { id: 533384, name: "Shahapur" },
      { id: 533486, name: "Shekapur" },
      { id: 533479, name: "Sherpur" },
      { id: 533387, name: "Shiwapur" },
      { id: 533483, name: "Sindivihira" },
      { id: 533498, name: "Sirkutni" },
      { id: 533399, name: "Sirri" },
      { id: 533475, name: "Sirsoli" },
      { id: 533505, name: "Sonapur" },
      { id: 533425, name: "Subda" },
      { id: 533489, name: "Sujatpur" },
      { id: 533438, name: "Sujatpur(Narsingpur)" },
      { id: 533471, name: "Sundarpur" },
      { id: 533512, name: "Talegaon" },
      { id: 533388, name: "Tarasawanga" },
      { id: 533494, name: "Tekoda" },
      { id: 533515, name: "Tembha" },
      { id: 533378, name: "Thadi" },
      { id: 533452, name: "Thar" },
      { id: 533449, name: "Theka Kinhi" },
      { id: 533446, name: "Thekakolha" },
      { id: 533447, name: "Thekamoi" },
      { id: 533392, name: "Tumni" },
      { id: 533397, name: "Umarkheda" },
      { id: 533481, name: "Vishwanagar" },
      { id: 533439, name: "Vithalapur" },
      { id: 533379, name: "Wadala" },
      { id: 533409, name: "Wadegaon" },
      { id: 533454, name: "Wadi" },
      { id: 533476, name: "Wagholi" },
      { id: 533380, name: "Wardhapur" },
      { id: 533472, name: "Yashwantpur" },
      { id: 533440, name: "Yenada" },
      { id: 533427, name: "Yenada ( Saza Lahanarvi)" },
      { id: 533404, name: "Zadgaon" },
    ],
    4016: [
      { id: 533615, name: "Agargaon" },
      { id: 533577, name: "Ajanadevi" },
      { id: 533613, name: "Ajandoh" },
      { id: 533628, name: "Ambhora" },
      { id: 533627, name: "Bangadapur" },
      { id: 533533, name: "Belgaon" },
      { id: 533551, name: "Bhalewadi" },
      { id: 533604, name: "Bhalu" },
      { id: 533625, name: "Bhiwapur" },
      { id: 533575, name: "Bihadi" },
      { id: 533553, name: "Bondar Thana" },
      { id: 533549, name: "Borgaon (Dhole)" },
      { id: 533595, name: "Borgaon Check No.1" },
      { id: 533596, name: "Borgaon Check No.2" },
      { id: 533652, name: "Borgaon Go." },
      { id: 533607, name: "Bori" },
      { id: 533540, name: "Botona" },
      { id: 533637, name: "Brahmanwada" },
      { id: 533629, name: "Budhalagad" },
      { id: 533581, name: "Chandewani" },
      { id: 533564, name: "Chincholi" },
      { id: 533640, name: "Chopan" },
      { id: 533586, name: "Dabha" },
      { id: 533643, name: "Danapur" },
      { id: 533636, name: "Dhaga" },
      { id: 533566, name: "Dhamkund" },
      { id: 533630, name: "Dhanoli" },
      { id: 533536, name: "Dhanora" },
      { id: 533605, name: "Dharti" },
      { id: 533588, name: "Dhawadi Bk" },
      { id: 533589, name: "Dhawadi Kh" },
      { id: 533593, name: "Dhawasa (Heti)" },
      { id: 533594, name: "Dhawasa Bk" },
      { id: 533592, name: "Dhawasa Kh" },
      { id: 533620, name: "Dongargaon" },
      { id: 533541, name: "Ekamba" },
      { id: 533554, name: "Ekarjun" },
      { id: 533634, name: "Enidodka" },
      { id: 533641, name: "Fefarwada" },
      { id: 533602, name: "Garpit" },
      { id: 533590, name: "Gawandi" },
      { id: 533645, name: "Ghughus" },
      { id: 533579, name: "Godhani" },
      { id: 533642, name: "Gundmund" },
      { id: 533609, name: "Heti Kundi" },
      { id: 533610, name: "Jamani" },
      { id: 533555, name: "Jasapur" },
      { id: 533614, name: "Jaurkheda" },
      { id: 533603, name: "Jaurwada Kh." },
      { id: 533616, name: "Joga" },
      { id: 533552, name: "Junapani" },
      { id: 533543, name: "Junona" },
      { id: 533617, name: "Kajali" },
      { id: 533570, name: "Kakada" },
      { id: 533622, name: "Kannamwargram" },
      { id: 533623, name: "Kannamwargram Heti" },
      { id: 533580, name: "Karanja Gha" },
      { id: 533572, name: "Khairi" },
      { id: 533646, name: "Khairwada" },
      { id: 533567, name: "Khapari" },
      { id: 533591, name: "Kharaskhanda" },
      { id: 533556, name: "Kinhala" },
      { id: 533611, name: "Kundi" },
      { id: 533631, name: "Kurha" },
      { id: 533648, name: "Ladgad" },
      { id: 533599, name: "Linga Mandavi" },
      { id: 533574, name: "Madani" },
      { id: 533644, name: "Mahadapur" },
      { id: 533559, name: "Malegaon Theka" },
      { id: 533558, name: "Malegaon(Kali)" },
      { id: 533650, name: "Maraksur" },
      { id: 533647, name: "Masod" },
      { id: 533537, name: "Mendhagad" },
      { id: 533632, name: "Methiraji" },
      { id: 533585, name: "Morshi" },
      { id: 533582, name: "Nagalwadi" },
      { id: 533618, name: "Nagazari" },
      { id: 533621, name: "Nandora" },
      { id: 533578, name: "Nara" },
      { id: 533561, name: "Narsingpur" },
      { id: 533546, name: "Palora" },
      { id: 533560, name: "Panjara Bangla" },
      { id: 533639, name: "Panjara Go." },
      { id: 533539, name: "Pardi" },
      { id: 533538, name: "Pardi Heti" },
      { id: 533571, name: "Parsodi" },
      { id: 533601, name: "Pilapur" },
      { id: 533600, name: "Pipari" },
      { id: 533563, name: "Ragadgaon" },
      { id: 533619, name: "Rahati" },
      { id: 533624, name: "Raipur" },
      { id: 533548, name: "Rajani" },
      { id: 533562, name: "Ranwadi" },
      { id: 533535, name: "Ridhapur" },
      { id: 533584, name: "Sarashi" },
      { id: 533545, name: "Sarwadi" },
      { id: 533612, name: "Sawal" },
      { id: 533547, name: "Sawali Bk." },
      { id: 533608, name: "Sawali Kh" },
      { id: 533534, name: "Sawardoh" },
      { id: 533573, name: "Selgaon L." },
      { id: 533565, name: "Selgaon U." },
      { id: 533587, name: "Shekapur" },
      { id: 533635, name: "Sindi Vihiri" },
      { id: 533606, name: "Sonegaon (Masod)" },
      { id: 533649, name: "Sonegaon (Musth.)" },
      { id: 533550, name: "Sonegaon(Dharti)" },
      { id: 533557, name: "Sonegaon(Junapani)" },
      { id: 533651, name: "Susund" },
      { id: 533532, name: "Susundra" },
      { id: 533544, name: "Taroda" },
      { id: 533569, name: "Taroda(Botona)" },
      { id: 533583, name: "Thanegaon" },
      { id: 533568, name: "Tonglapur" },
      { id: 533626, name: "Tulana" },
      { id: 533633, name: "Umar Vihiri" },
      { id: 533597, name: "Umari" },
      { id: 533576, name: "Waghoda" },
      { id: 533542, name: "Waghoda Saza Botona" },
      { id: 533638, name: "Yelhati" },
      { id: 533598, name: "Yengaon" },
    ],
    4017: [
      { id: 533680, name: "Adegaon" },
      { id: 533734, name: "Agapur" },
      { id: 533748, name: "Ahirwada" },
      { id: 944977, name: "Ahirwada(Punarvasan)" },
      { id: 533732, name: "Ahmadabad" },
      { id: 533682, name: "Ahmadnagar" },
      { id: 533813, name: "Ajangaon" },
      { id: 533694, name: "Ajdapur" },
      { id: 533751, name: "Allipur" },
      { id: 533834, name: "Ambapur" },
      { id: 533708, name: "Ambazari" },
      { id: 533747, name: "Ambikapur" },
      { id: 533773, name: "Antardoh" },
      { id: 942998, name: "Arvi" },
      { id: 533684, name: "Ashta" },
      { id: 533823, name: "Babapur" },
      { id: 533743, name: "Bahadarpur (Dhanodi)" },
      { id: 533824, name: "Bahadarpur (Khubgaon)" },
      { id: 533713, name: "Bajarwada" },
      { id: 533801, name: "Balai(Majara)" },
      { id: 533870, name: "Barhasonegaon" },
      { id: 533702, name: "Bedhona" },
      { id: 533675, name: "Belhara" },
      { id: 944978, name: "Belhara Tanda" },
      { id: 533687, name: "Benoda" },
      { id: 533805, name: "Bhadod ( Bor)" },
      { id: 533772, name: "Bhadod (Panwadi)" },
      { id: 533691, name: "Bhaipur" },
      { id: 533856, name: "Bid-Nagzari" },
      { id: 533821, name: "Bodad" },
      { id: 533655, name: "Bodala" },
      { id: 533667, name: "Borgaon" },
      { id: 533769, name: "Borgaon Hatla" },
      { id: 533858, name: "Bori" },
      { id: 533799, name: "Borkhedi (Madana)" },
      { id: 533705, name: "Borkhedi (Wadhona)" },
      { id: 533808, name: "Bothali (Kasarkheda )" },
      { id: 533789, name: "Bothali(Kinhala)" },
      { id: 533783, name: "Brahmanwada" },
      { id: 533686, name: "Chandani" },
      { id: 533776, name: "Chandani (Bothli)" },
      { id: 533670, name: "Chincholi Dange" },
      { id: 533681, name: "Chinchthana" },
      { id: 533820, name: "Chor Amba" },
      { id: 533786, name: "Dahegaon Gondi" },
      { id: 533716, name: "Dahegaon Mustafa" },
      { id: 944966, name: "Dahegaon Tanda" },
      { id: 533836, name: "Dahyapur" },
      { id: 533845, name: "Daryapur" },
      { id: 533843, name: "Dattapur" },
      { id: 533689, name: "Daulatpur" },
      { id: 943000, name: "Dautpur" },
      { id: 533729, name: "Deurwada" },
      { id: 533660, name: "Devhada" },
      { id: 533825, name: "Dhanodi Baha" },
      { id: 533726, name: "Dhanodi Kh" },
      { id: 533807, name: "Dighi (Honade)" },
      { id: 533827, name: "Dighi Panwadi" },
      { id: 533837, name: "Dongargaon" },
      { id: 533811, name: "Dudhbardi" },
      { id: 533721, name: "Eklara" },
      { id: 533659, name: "Gangapur" },
      { id: 533819, name: "Gaurkheda" },
      { id: 533757, name: "Gavhankhedi" },
      { id: 533841, name: "Gazipur" },
      { id: 533662, name: "Goiwada" },
      { id: 533774, name: "Gumgaon" },
      { id: 533741, name: "Haibatpur" },
      { id: 917333, name: "Haibatpur(Punarvasan)" },
      { id: 533840, name: "Hamdapur" },
      { id: 533673, name: "Harashi" },
      { id: 533714, name: "Hardoli" },
      { id: 533767, name: "Hariswada" },
      { id: 533745, name: "Hashimpur" },
      { id: 533768, name: "Hatla" },
      { id: 533822, name: "Hivara Rith" },
      { id: 533677, name: "Hivaratanda" },
      { id: 533674, name: "Hiwara" },
      { id: 533859, name: "Husenpur" },
      { id: 533860, name: "Husenpur (Virul)" },
      { id: 533696, name: "Irgavhan" },
      { id: 533693, name: "Isakpur" },
      { id: 533712, name: "Ismailpur" },
      { id: 944967, name: "Ithlapur(Punarvasan)" },
      { id: 533736, name: "Itlapur" },
      { id: 533657, name: "Jalgaon" },
      { id: 917332, name: "Jam Punarvasan" },
      { id: 533739, name: "Jamalpur" },
      { id: 533683, name: "Jamb" },
      { id: 533678, name: "Jamkhuta" },
      { id: 533654, name: "Jamner" },
      { id: 533715, name: "Jamthi" },
      { id: 533704, name: "Jiwapur" },
      { id: 533777, name: "Kachnur" },
      { id: 533818, name: "Kakaddara" },
      { id: 533869, name: "Kanchanpur" },
      { id: 533724, name: "Karmabad" },
      { id: 533802, name: "Kasarkheda" },
      { id: 533750, name: "Kashimpur" },
      { id: 533756, name: "Kawadi" },
      { id: 533720, name: "Khadaki" },
      { id: 533839, name: "Khairi" },
      { id: 533847, name: "Khanapur" },
      { id: 533664, name: "Khanwadi" },
      { id: 533791, name: "Khapari (Dahegaon Gondi)" },
      { id: 533782, name: "Khapari (Pimalkhuta)" },
      { id: 533787, name: "Kharangana" },
      { id: 533653, name: "Kharashi" },
      { id: 533742, name: "Khubgaon" },
      { id: 533792, name: "Kinhala" },
      { id: 908939, name: "Kopra" },
      { id: 533848, name: "Krishnapur" },
      { id: 533722, name: "Ladegaon" },
      { id: 533700, name: "Ladnapur" },
      { id: 533701, name: "Lahadevi" },
      { id: 533830, name: "Laxmipur" },
      { id: 533798, name: "Madana" },
      { id: 533778, name: "Mahakal" },
      { id: 533692, name: "Mahamadpur" },
      { id: 533766, name: "Mahamadpur (Arvi )" },
      { id: 533762, name: "Mahimapur" },
      { id: 533697, name: "Maiwadi" },
      { id: 533832, name: "Malatpur" },
      { id: 533784, name: "Malegaon(Kali)" },
      { id: 533785, name: "Malegaon(Theka)" },
      { id: 944968, name: "Mandala(Punarvasan)" },
      { id: 533666, name: "Mandla" },
      { id: 533663, name: "Maneri" },
      { id: 533857, name: "Mankapur" },
      { id: 533740, name: "Manulapur" },
      { id: 533844, name: "Marda" },
      { id: 533685, name: "Matoda" },
      { id: 533711, name: "Mirapur" },
      { id: 533759, name: "Mirzapur (Borgaon Hatla)" },
      { id: 533752, name: "Mirzapur (Neri)" },
      { id: 944969, name: "Mirzapur(Punarvasan)" },
      { id: 533796, name: "Morangana" },
      { id: 533771, name: "Mubarakpur" },
      { id: 533842, name: "Mudhapur" },
      { id: 533695, name: "Mund Arvi" },
      { id: 533698, name: "Mund Maywadi" },
      { id: 533760, name: "Murtizapur" },
      { id: 533730, name: "Nababpur" },
      { id: 533763, name: "Nababpur (Deurwada)" },
      { id: 533829, name: "Nagapur" },
      { id: 533707, name: "Nagazari" },
      { id: 533855, name: "Nagazari (Virul)" },
      { id: 533754, name: "Nandora" },
      { id: 944970, name: "Nandora(Punarvasan)" },
      { id: 533725, name: "Nandpur" },
      { id: 533788, name: "Nanhi" },
      { id: 533809, name: "Natala" },
      { id: 944971, name: "Natala(Bothali)" },
      { id: 533761, name: "Neri" },
      { id: 944972, name: "Neri(Punarvasan)" },
      { id: 533862, name: "Nijampur" },
      { id: 533764, name: "Nimboli" },
      { id: 533744, name: "Pachegaon" },
      { id: 533671, name: "Pachod" },
      { id: 533849, name: "Pachod Tha." },
      { id: 533709, name: "Panjara" },
      { id: 533817, name: "Panjara Bothali" },
      { id: 533804, name: "Panwadi" },
      { id: 533758, name: "Pargothan" },
      { id: 533850, name: "Parsodi" },
      { id: 533658, name: "Partoda" },
      { id: 533803, name: "Patan" },
      { id: 533812, name: "Pimpalgaon (Ajangaon)" },
      { id: 533863, name: "Pimpalgaon (Sorta)" },
      { id: 533775, name: "Pimpalkhuta" },
      { id: 533770, name: "Pipari" },
      { id: 944973, name: "Pipari(Punarvasan)" },
      { id: 533723, name: "Rahimabad" },
      { id: 533672, name: "Rajani" },
      { id: 533735, name: "Rajapur" },
      { id: 533851, name: "Rampur" },
      { id: 533871, name: "Rasulabad" },
      { id: 533806, name: "Ratnapur" },
      { id: 533868, name: "Renkapur" },
      { id: 533755, name: "Revti" },
      { id: 533835, name: "Rohana" },
      { id: 533753, name: "Roshanpur" },
      { id: 533727, name: "Rudrapur" },
      { id: 533728, name: "Saheb-Daulatpur" },
      { id: 533781, name: "Saheli" },
      { id: 533828, name: "Saikheda" },
      { id: 533833, name: "Saldara" },
      { id: 533853, name: "Salfal" },
      { id: 533668, name: "Sarangpuri" },
      { id: 533738, name: "Sarkaspur" },
      { id: 944974, name: "Sarkaspur(Puarvasan)" },
      { id: 533699, name: "Savlapur" },
      { id: 533800, name: "Sawad" },
      { id: 533816, name: "Sawangi" },
      { id: 533854, name: "Sawarkheda" },
      { id: 533710, name: "Shahabajpur" },
      { id: 533731, name: "Shahamahamadpur" },
      { id: 533690, name: "Shahapur (Dautpur)" },
      { id: 533866, name: "Shahapur (Sorta)" },
      { id: 533688, name: "Singona" },
      { id: 533872, name: "Sirda" },
      { id: 533719, name: "Sirpur (Saza Rohana)" },
      { id: 533831, name: "Sirpur(Saza)" },
      { id: 533865, name: "Sorta" },
      { id: 533846, name: "Sukali (Kasarkheda)" },
      { id: 533794, name: "Sukli (Sa.Bothali)" },
      { id: 533810, name: "Sukli (Sa.Virul)" },
      { id: 533718, name: "Takarkheda" },
      { id: 533861, name: "Takli" },
      { id: 533795, name: "Talegaon" },
      { id: 533790, name: "Taroda" },
      { id: 533814, name: "Tembhari" },
      { id: 533676, name: "Thar" },
      { id: 533717, name: "Theka Ambazari" },
      { id: 533797, name: "Theka Sawad" },
      { id: 533669, name: "Thekasarangpuri" },
      { id: 533679, name: "Titona" },
      { id: 533661, name: "Tokiwada" },
      { id: 533737, name: "Tona" },
      { id: 533706, name: "Tuljapur" },
      { id: 533867, name: "Umarda" },
      { id: 533793, name: "Umari (Aajangaon)" },
      { id: 533815, name: "Umari( Bothali)" },
      { id: 533852, name: "Virul" },
      { id: 533780, name: "Vithpur Dabali" },
      { id: 533864, name: "Wadala" },
      { id: 533826, name: "Wadgaon" },
      { id: 533703, name: "Wadhona" },
      { id: 533765, name: "Wadhona Tha." },
      { id: 533733, name: "Wagda" },
      { id: 944975, name: "Wagda(Punarvasan)" },
      { id: 533838, name: "Wai" },
      { id: 533749, name: "Wallipur" },
      { id: 533779, name: "Wanarkund" },
      { id: 533656, name: "Wardh" },
      { id: 533746, name: "Wathoda" },
      { id: 944976, name: "Wathoda(Punarvasan)" },
      { id: 533665, name: "Yerzad" },
    ],
    4018: [
      { id: 534009, name: "Ajangaon" },
      { id: 533925, name: "Akoli" },
      { id: 533888, name: "Akoli (Hingani)" },
      { id: 534038, name: "Algaon" },
      { id: 908890, name: "Ambhora" },
      { id: 533923, name: "Amgaon" },
      { id: 533980, name: "Amgaon (Khurd)" },
      { id: 533883, name: "Amgaon (Madani)" },
      { id: 533954, name: "Antargaon" },
      { id: 533997, name: "Arvi (Lahan)" },
      { id: 533945, name: "Babapur" },
      { id: 533960, name: "Babhulgaon" },
      { id: 534021, name: "Bakhalapur" },
      { id: 533972, name: "Belgaon" },
      { id: 534013, name: "Belodi" },
      { id: 533905, name: "Bibi" },
      { id: 533917, name: "Bid Borkhedi" },
      { id: 533940, name: "Bid-Sukli" },
      { id: 534035, name: "Bondsula" },
      { id: 534014, name: "Borgaon" },
      { id: 533877, name: "Bori" },
      { id: 533918, name: "Borkhedi (Gawande)" },
      { id: 533930, name: "Borkhedi (Kala)" },
      { id: 533919, name: "Bothali" },
      { id: 533896, name: "Bramhani" },
      { id: 534024, name: "Chanki" },
      { id: 533929, name: "Chargaon" },
      { id: 534006, name: "Charmandal" },
      { id: 533996, name: "Chichghat" },
      { id: 534036, name: "Chincholi (Hamdapur)" },
      { id: 533912, name: "Chincholi (Jungad)" },
      { id: 533926, name: "Chincholi (Zadshi)" },
      { id: 534022, name: "Dabalapur" },
      { id: 534010, name: "Dahegaon (Gosavi)" },
      { id: 533949, name: "Daulatpur" },
      { id: 533988, name: "Daulatpur (Sukali)" },
      { id: 534033, name: "Deulgaon" },
      { id: 533890, name: "Dhamangaon" },
      { id: 533895, name: "Dhanoli (Gawande)" },
      { id: 533986, name: "Dhanoli (Meghe)" },
      { id: 534008, name: "Dhapki" },
      { id: 533979, name: "Dhondgaon" },
      { id: 534042, name: "Digraj" },
      { id: 534030, name: "Dindoda" },
      { id: 533882, name: "Dodaki" },
      { id: 533891, name: "Dongargaon" },
      { id: 534016, name: "Dorli (Helodi)" },
      { id: 533911, name: "Dorli (Moi)" },
      { id: 533913, name: "Gaimukh" },
      { id: 533948, name: "Ganeshpur" },
      { id: 534012, name: "Ganeshpur (Helodi)" },
      { id: 533992, name: "Gangapur" },
      { id: 533874, name: "Garamsur" },
      { id: 908941, name: "Ghodeghat" },
      { id: 533909, name: "Ghorad" },
      { id: 533938, name: "Girnala" },
      { id: 533932, name: "Giroli" },
      { id: 533878, name: "Gohda (Kala)" },
      { id: 533885, name: "Gohda (Kh)" },
      { id: 533965, name: "Gondapur" },
      { id: 534034, name: "Hamdapur" },
      { id: 534019, name: "Helodi" },
      { id: 533889, name: "Hingni" },
      { id: 533952, name: "Hiwara (Chanki)" },
      { id: 534032, name: "Hiwara (Helodi)" },
      { id: 534015, name: "Hiwara (Wadgaon-Kala)" },
      { id: 533958, name: "Inchora" },
      { id: 533984, name: "Indapur" },
      { id: 533944, name: "Itaki" },
      { id: 533995, name: "Itala" },
      { id: 534003, name: "Jaipur" },
      { id: 533908, name: "Jakhala" },
      { id: 533935, name: "Jamani" },
      { id: 533982, name: "Janglapur" },
      { id: 533876, name: "Joga" },
      { id: 534005, name: "Jogapur" },
      { id: 533886, name: "Junewani" },
      { id: 533902, name: "Jungad" },
      { id: 534023, name: "Junona" },
      { id: 533893, name: "Juwadi" },
      { id: 533959, name: "Kamthi" },
      { id: 533966, name: "Kanhapur" },
      { id: 533950, name: "Kashimpur (Wadgaon)" },
      { id: 533963, name: "Kashimpur (Zadashi)" },
      { id: 533941, name: "Keli" },
      { id: 533981, name: "Kelzar" },
      { id: 534001, name: "Kesalapur" },
      { id: 533985, name: "Khadaki (Amgaon)" },
      { id: 534004, name: "Khadka" },
      { id: 533978, name: "Khadki (Belgaon)" },
      { id: 533922, name: "Khairi" },
      { id: 533928, name: "Khairi (Borkhedi Kala)" },
      { id: 533892, name: "Khairi (Juwadi)" },
      { id: 534011, name: "Khapari (Dhone)" },
      { id: 533903, name: "Khapari (Mungapur)" },
      { id: 533939, name: "Kherda" },
      { id: 533994, name: "Kinhala" },
      { id: 533906, name: "Kinhi" },
      { id: 533974, name: "Kolgaon" },
      { id: 533983, name: "Kolhi" },
      { id: 534025, name: "Kopra" },
      { id: 533991, name: "Kotamba" },
      { id: 533933, name: "Krishnapur" },
      { id: 533947, name: "Kshirsamudra" },
      { id: 533951, name: "Kurha" },
      { id: 533968, name: "Lehaki Kh." },
      { id: 533973, name: "Londhapur" },
      { id: 534007, name: "Madka" },
      { id: 533921, name: "Madni" },
      { id: 533993, name: "Mahabala" },
      { id: 533875, name: "Manoli" },
      { id: 533924, name: "Masala" },
      { id: 533961, name: "Mohadara" },
      { id: 533970, name: "Mohanapur (Selu)" },
      { id: 533967, name: "Mohanapur (Surgaon)" },
      { id: 533901, name: "Mohgaon" },
      { id: 533898, name: "Moi" },
      { id: 533998, name: "Morchapur" },
      { id: 534026, name: "Mukindpur" },
      { id: 533904, name: "Mungapur" },
      { id: 533964, name: "Nagtekdi" },
      { id: 533884, name: "Nanbardi" },
      { id: 533969, name: "Nawabpur" },
      { id: 533873, name: "Nawargaon" },
      { id: 533897, name: "Nimboli" },
      { id: 534040, name: "Pahelanpur" },
      { id: 534041, name: "Palasgaon (Bai)" },
      { id: 908942, name: "Pardi" },
      { id: 534017, name: "Parsodi" },
      { id: 533907, name: "Pimpal Khuta" },
      { id: 533894, name: "Pimpal Shenda" },
      { id: 534031, name: "Pimpalgaon" },
      { id: 534018, name: "Pimpara" },
      { id: 533914, name: "Raipur (Heti)" },
      { id: 533916, name: "Raipur (Jangli)" },
      { id: 533957, name: "Rehaki (Kala)" },
      { id: 533915, name: "Ridhora" },
      { id: 533910, name: "Ringani" },
      { id: 533881, name: "Salai (Kala)" },
      { id: 533879, name: "Salai (Pevath)" },
      { id: 533977, name: "Seldoh" },
      { id: 533971, name: "Seloo" },
      { id: 533990, name: "Shahapur" },
      { id: 533900, name: "Shiwangaon" },
      { id: 534039, name: "Shiwangaon (Jungad)" },
      { id: 943004, name: "Sindi R" },
      { id: 533934, name: "Singoda" },
      { id: 533976, name: "Somalgad" },
      { id: 533880, name: "Sondi" },
      { id: 533899, name: "Sonegaon" },
      { id: 533989, name: "Sukali (Station)" },
      { id: 908891, name: "Sukli" },
      { id: 533937, name: "Sukli (Bai)" },
      { id: 533962, name: "Surgaon" },
      { id: 534029, name: "Takali (Kite)" },
      { id: 533927, name: "Takali (Zadashi)" },
      { id: 534002, name: "Talodi" },
      { id: 533920, name: "Tamaswada" },
      { id: 533946, name: "Tirmalpur" },
      { id: 534027, name: "Tuljapur" },
      { id: 534020, name: "Tuljapur (Station)" },
      { id: 533953, name: "Umargaon" },
      { id: 534037, name: "Uttampur" },
      { id: 533975, name: "Wadgaon (Jangli)" },
      { id: 533956, name: "Wadgaon (Kala)" },
      { id: 533936, name: "Wadgaon (Madani)" },
      { id: 533955, name: "Wadgaon Kh." },
      { id: 534028, name: "Waghala" },
      { id: 534000, name: "Waghapur" },
      { id: 533999, name: "Wahitpur" },
      { id: 533887, name: "Wanarvihira" },
      { id: 533943, name: "Wanoda" },
      { id: 533987, name: "Yankapur (Ramana)" },
      { id: 533942, name: "Yeli" },
      { id: 533931, name: "Zadshi" },
    ],
    4019: [
      { id: 534126, name: "Abdullapur" },
      { id: 534184, name: "Afzalpur" },
      { id: 534146, name: "Ajagaon" },
      { id: 534167, name: "Ajansara" },
      { id: 534085, name: "Alodi" },
      { id: 534045, name: "Amaji Majara" },
      { id: 534153, name: "Ambapur" },
      { id: 534177, name: "Amboda" },
      { id: 534141, name: "Aminpur" },
      { id: 534069, name: "Amla" },
      { id: 534052, name: "Anji (Mothi)" },
      { id: 534145, name: "Asala" },
      { id: 534096, name: "Ashrafpur" },
      { id: 534124, name: "Ashta" },
      { id: 534187, name: "Balapur (Sa.Selsura)" },
      { id: 534115, name: "Balapur(Saza Dhanora)" },
      { id: 534095, name: "Banpur" },
      { id: 534100, name: "Barbadi" },
      { id: 534063, name: "Belgaon" },
      { id: 534088, name: "Bhaiyapur" },
      { id: 534122, name: "Bhankheda" },
      { id: 534154, name: "Bhawanpur" },
      { id: 534083, name: "Bhiwapur" },
      { id: 534155, name: "Bhiwapur(Saza Mirapur)" },
      { id: 534111, name: "Bhugaon" },
      { id: 534171, name: "Bodad" },
      { id: 534119, name: "Bondapur" },
      { id: 534196, name: "Borgaon (Meghe)" },
      { id: 534060, name: "Borgaon (Nandora)" },
      { id: 534057, name: "Borgaon (Savali)" },
      { id: 534047, name: "Chaka" },
      { id: 534048, name: "Chendakapur" },
      { id: 534182, name: "Chikni" },
      { id: 534098, name: "Chinchala" },
      { id: 534099, name: "Chitoda" },
      { id: 534140, name: "Chunhala" },
      { id: 534071, name: "Dahegaon (Mi.)" },
      { id: 943003, name: "Dahegaon(Station)" },
      { id: 534158, name: "Dapuri" },
      { id: 534134, name: "Dattapur" },
      { id: 534161, name: "Dattapur (Mirapur)" },
      { id: 534082, name: "Dattapur(Saza Nalwadi)" },
      { id: 534152, name: "Dewangan" },
      { id: 534067, name: "Dhamangaon (63)" },
      { id: 534113, name: "Dhanora" },
      { id: 534169, name: "Dhodari" },
      { id: 534164, name: "Dhotra (Ka)" },
      { id: 534178, name: "Dhotra (Rly)" },
      { id: 534059, name: "Dhulwa" },
      { id: 534061, name: "Digras (61)" },
      { id: 534066, name: "Dorli (48)" },
      { id: 534058, name: "Dorli (Saza Anji)" },
      { id: 534168, name: "Ekurli" },
      { id: 534147, name: "Fattepur" },
      { id: 534073, name: "Ganeshpur" },
      { id: 534135, name: "Goji" },
      { id: 534127, name: "Gondapur" },
      { id: 534185, name: "Hirapur" },
      { id: 534137, name: "Inzapur" },
      { id: 534151, name: "Itala" },
      { id: 534117, name: "Itlapur" },
      { id: 534150, name: "Jamnala" },
      { id: 534094, name: "Jamtha" },
      { id: 534112, name: "Jaulgaon" },
      { id: 534081, name: "Kamathwada" },
      { id: 534046, name: "Kamthi" },
      { id: 534103, name: "Karanji (Bhoge)" },
      { id: 534106, name: "Karanji (Kanji)" },
      { id: 534075, name: "Karla" },
      { id: 534076, name: "Kartada" },
      { id: 534080, name: "Kedarwadi" },
      { id: 534174, name: "Kelapur" },
      { id: 534139, name: "Kesalapur" },
      { id: 534050, name: "Khanapur" },
      { id: 534105, name: "Kharangana (Gode)" },
      { id: 534170, name: "Kurzadi (Fort)" },
      { id: 534097, name: "Kurzadi (Ja)" },
      { id: 534104, name: "Kutki" },
      { id: 534065, name: "Lonsawali" },
      { id: 534118, name: "Madni" },
      { id: 534077, name: "Mahakal" },
      { id: 534092, name: "Malegaon" },
      { id: 534110, name: "Mandavgad" },
      { id: 534054, name: "Mandawa" },
      { id: 534194, name: "Masala" },
      { id: 534186, name: "Meghapur" },
      { id: 534159, name: "Mirapur" },
      { id: 534043, name: "Morangana" },
      { id: 534078, name: "Mudhapur (Rith)" },
      { id: 534128, name: "Mudhapur(Saza Madani)" },
      { id: 534108, name: "Nagapur(Sewagram)" },
      { id: 534180, name: "Nagthana" },
      { id: 534195, name: "Nalwadi" },
      { id: 534109, name: "Nandora" },
      { id: 534189, name: "Narayanpur (72)" },
      { id: 534183, name: "Narayanpur (Chikni)" },
      { id: 534114, name: "Narayanpur (Dhanora)" },
      { id: 534053, name: "Narsula" },
      { id: 945404, name: "Natala(Punarvasan)" },
      { id: 534157, name: "Neri" },
      { id: 534176, name: "Neri(Saza.Nimgaon)" },
      { id: 534175, name: "Nimgaon" },
      { id: 534181, name: "Padhegaon" },
      { id: 534089, name: "Padhegaon (Saza Salod Hi)" },
      { id: 534087, name: "Palakwadi Urf Wardha" },
      { id: 534093, name: "Paloti" },
      { id: 534074, name: "Pandharkawda" },
      { id: 534079, name: "Pavnar" },
      { id: 534044, name: "Pavni" },
      { id: 534051, name: "Pavnur" },
      { id: 534056, name: "Peth" },
      { id: 534191, name: "Pipri (Meghe)" },
      { id: 534120, name: "Pujai" },
      { id: 534055, name: "Pulai" },
      { id: 534123, name: "Raghunathpur" },
      { id: 534136, name: "Raifuli" },
      { id: 534156, name: "Rampur" },
      { id: 534179, name: "Rotha" },
      { id: 534129, name: "Sakhara" },
      { id: 534091, name: "Salod (Hirapur)" },
      { id: 534084, name: "Satoda" },
      { id: 534131, name: "Sawali" },
      { id: 534197, name: "Sawangi Meghe" },
      { id: 534188, name: "Selsura" },
      { id: 534138, name: "Selukate" },
      { id: 534101, name: "Sevagram" },
      { id: 534049, name: "Sewa" },
      { id: 534090, name: "Shampur" },
      { id: 534102, name: "Shirpur" },
      { id: 534160, name: "Shivapur" },
      { id: 908943, name: "Sindhi Meghe" },
      { id: 534070, name: "Sindi Kh.(Rith) 142" },
      { id: 534149, name: "Sirasgaon (Dh)" },
      { id: 534107, name: "Sondlapur" },
      { id: 534163, name: "Sonegaon (Sta.)" },
      { id: 534166, name: "Sonpeth" },
      { id: 534162, name: "Sultanpur" },
      { id: 534143, name: "Taharpur" },
      { id: 534121, name: "Talegaon (Rith)" },
      { id: 534165, name: "Talegaon (Ta)" },
      { id: 534133, name: "Tanapur" },
      { id: 534130, name: "Taroda" },
      { id: 534072, name: "Tigaon (54)" },
      { id: 534086, name: "Umari(Meghe)" },
      { id: 534148, name: "Wadadha" },
      { id: 534064, name: "Wagdara (129)" },
      { id: 534172, name: "Waifad" },
      { id: 534144, name: "Waigaon(Nipani)" },
      { id: 534116, name: "Waigaon(Rith)" },
      { id: 534142, name: "Walhapur" },
      { id: 534193, name: "Warud" },
      { id: 534068, name: "Wathoda (128)" },
      { id: 534190, name: "Yangaddeo" },
      { id: 534132, name: "Yerangaon" },
      { id: 534125, name: "Yesamba" },
      { id: 534062, name: "Zadgaon" },
    ],
    4020: [
      { id: 534331, name: "Adegaon" },
      { id: 534243, name: "Agargaon" },
      { id: 534315, name: "Ajanavati" },
      { id: 534239, name: "Akapur" },
      { id: 534247, name: "Akoli" },
      { id: 534325, name: "Aloda" },
      { id: 534343, name: "Amboda" },
      { id: 534310, name: "Aminabad" },
      { id: 534305, name: "Andori" },
      { id: 534311, name: "Anji( B)" },
      { id: 534216, name: "Apti" },
      { id: 534323, name: "Babapur" },
      { id: 534267, name: "Babapur (Rith)" },
      { id: 534235, name: "Babhulgaon(Bo)" },
      { id: 534293, name: "Babhulgaon(Kho)" },
      { id: 534212, name: "Bachchharajpur" },
      { id: 534312, name: "Bahaddarpur" },
      { id: 534307, name: "Barhanpur" },
      { id: 534281, name: "Belgaon" },
      { id: 534214, name: "Bhagwanpur" },
      { id: 534259, name: "Bhidi" },
      { id: 534322, name: "Bhojankheda" },
      { id: 534304, name: "Bopapur" },
      { id: 534317, name: "Bopapur Mauja No.96" },
      { id: 534326, name: "Borgaon Aa" },
      { id: 534302, name: "Chandrapur" },
      { id: 534332, name: "Chikhali" },
      { id: 534329, name: "Chinchala" },
      { id: 534206, name: "Chitaki" },
      { id: 534251, name: "Chondhi" },
      { id: 534283, name: "Dagapur" },
      { id: 534228, name: "Dahegaon (Dhande)" },
      { id: 534339, name: "Dapori" },
      { id: 534219, name: "Dattapur" },
      { id: 534284, name: "Deoli (Rural)" },
      { id: 534242, name: "Dhonapur" },
      { id: 534282, name: "Digdoh." },
      { id: 534316, name: "Dighi" },
      { id: 534313, name: "Dilavarpur" },
      { id: 534249, name: "Durgada" },
      { id: 534225, name: "Ekamba" },
      { id: 534207, name: "Eklaspur" },
      { id: 534289, name: "Ekpala" },
      { id: 534248, name: "Fattepur" },
      { id: 534231, name: "Gagapur Mauja N.41" },
      { id: 534263, name: "Ganeshpur" },
      { id: 534306, name: "Gangapur Mauja N.5" },
      { id: 534336, name: "Gaul" },
      { id: 534233, name: "Ghodegaon" },
      { id: 534344, name: "Giroli" },
      { id: 534342, name: "Gopalpur" },
      { id: 534314, name: "Govindpur" },
      { id: 534198, name: "Gunjkheda" },
      { id: 534215, name: "Hamdapur" },
      { id: 534213, name: "Haralpur" },
      { id: 534245, name: "Hirapur" },
      { id: 534268, name: "Hiwara (Kavare)" },
      { id: 534199, name: "Hiwara Sa.Gunjkheda" },
      { id: 534258, name: "Hurdanpur" },
      { id: 534218, name: "Husnapur" },
      { id: 534265, name: "Husnapur (Bhidi)" },
      { id: 534241, name: "Inzala" },
      { id: 534340, name: "Inzapur" },
      { id: 534252, name: "Irapur" },
      { id: 534288, name: "Isapur" },
      { id: 534299, name: "Jafrabad" },
      { id: 534320, name: "Jaitapur" },
      { id: 534276, name: "Jamani" },
      { id: 534291, name: "Kajalsara" },
      { id: 534237, name: "Kandegaon" },
      { id: 534271, name: "Kangokul" },
      { id: 534227, name: "Kapurwadi" },
      { id: 534262, name: "Karmalapur" },
      { id: 534264, name: "Kashimpur" },
      { id: 534236, name: "Kavitgaon" },
      { id: 534201, name: "Kavtha" },
      { id: 534202, name: "Kavtha (Zopadi)" },
      { id: 534279, name: "Khadki" },
      { id: 534298, name: "Khanapur" },
      { id: 534273, name: "Kharda" },
      { id: 534222, name: "Khatkheda" },
      { id: 534266, name: "Kolhapur(Rao)" },
      { id: 534296, name: "Kolhapur(Si)" },
      { id: 534334, name: "Kolona (Chore)" },
      { id: 534230, name: "Kolona (Gho)" },
      { id: 534338, name: "Krishnapur" },
      { id: 534210, name: "Kurla" },
      { id: 534200, name: "Laxminarayanpur" },
      { id: 534224, name: "Loni" },
      { id: 534300, name: "Mahamadpur" },
      { id: 534269, name: "Malatpur" },
      { id: 534274, name: "Malkapur" },
      { id: 534328, name: "Mamdapur Mauja No.104" },
      { id: 534294, name: "Mirzapur" },
      { id: 534301, name: "Mohanapur" },
      { id: 534303, name: "Mominpur" },
      { id: 534324, name: "Mund" },
      { id: 534278, name: "Muradgaon (Be)" },
      { id: 534286, name: "Muradgaon (Kho)" },
      { id: 534308, name: "Muradpur" },
      { id: 534335, name: "Musalabad" },
      { id: 534209, name: "Nachangaon" },
      { id: 534280, name: "Nagzari" },
      { id: 534253, name: "Nandgaon" },
      { id: 534285, name: "Nandora(D)" },
      { id: 534204, name: "Nandpur" },
      { id: 534226, name: "Narayanpur" },
      { id: 534337, name: "Nashirpur" },
      { id: 534229, name: "Nimgavhan" },
      { id: 534346, name: "Nimsada" },
      { id: 534244, name: "Palasgaon" },
      { id: 534345, name: "Pathari" },
      { id: 534341, name: "Pimpalgaon" },
      { id: 534211, name: "Pimpri" },
      { id: 534257, name: "Raghala" },
      { id: 534221, name: "Raghunathpur" },
      { id: 534330, name: "Raipur" },
      { id: 534297, name: "Raipur Khurd" },
      { id: 534208, name: "Rangnathpur" },
      { id: 534292, name: "Ratnapur" },
      { id: 534270, name: "Rohani" },
      { id: 534309, name: "Rudrapur" },
      { id: 534261, name: "Saidapur" },
      { id: 534327, name: "Sarul" },
      { id: 534223, name: "Sawala" },
      { id: 534254, name: "Sawangi" },
      { id: 534321, name: "Sekapur" },
      { id: 534205, name: "Sekapur(Zopadi)" },
      { id: 534238, name: "Sendari" },
      { id: 534220, name: "Shahapur" },
      { id: 534203, name: "Shekapur" },
      { id: 534272, name: "Shirpur (Hore)" },
      { id: 534295, name: "Singarwadi" },
      { id: 534277, name: "Sonegaon (Aa)" },
      { id: 534318, name: "Sonegaon(Bai)" },
      { id: 534234, name: "Sonora(Dhok)" },
      { id: 534319, name: "Takali (Chana)" },
      { id: 534347, name: "Takali Darne" },
      { id: 534333, name: "Takli (Kho)" },
      { id: 534240, name: "Talni (Bha)" },
      { id: 534250, name: "Talni(Kha)" },
      { id: 534255, name: "Tamba" },
      { id: 534246, name: "Timapur" },
      { id: 534232, name: "Trimbakpur" },
      { id: 534256, name: "Vijaygopal" },
      { id: 534260, name: "Wabgaon" },
      { id: 534217, name: "Wagholi" },
      { id: 534287, name: "Wai" },
      { id: 534290, name: "Watkheda" },
      { id: 534275, name: "Yesgaon" },
    ],
    4021: [
      { id: 534362, name: "Agaskand" },
      { id: 534430, name: "Ajamanpur" },
      { id: 534403, name: "Ajangaon" },
      { id: 534485, name: "Ajansara" },
      { id: 534434, name: "Ajanti" },
      { id: 534419, name: "Ajmatpur" },
      { id: 534358, name: "Alamdoh" },
      { id: 534385, name: "Allipur" },
      { id: 534529, name: "Antapur" },
      { id: 534401, name: "Arvi (Chhoti)" },
      { id: 534453, name: "Ashti" },
      { id: 534375, name: "Babapur" },
      { id: 534365, name: "Babapur (Sa. Khangaon)" },
      { id: 534360, name: "Balapur" },
      { id: 534502, name: "Bambarda" },
      { id: 534396, name: "Bhagawa" },
      { id: 534363, name: "Bhaiyyapur" },
      { id: 534492, name: "Bhardi" },
      { id: 534508, name: "Bhiwapur" },
      { id: 534405, name: "Bid Ajangaon (Rith)" },
      { id: 534389, name: "Bid Sirud" },
      { id: 534407, name: "Bid Sonegaon (Rith)" },
      { id: 534444, name: "Biddabha" },
      { id: 534477, name: "Bidladki" },
      { id: 534404, name: "Bondurni" },
      { id: 534510, name: "Bopapur" },
      { id: 534456, name: "Borgaon (Na)" },
      { id: 534435, name: "Borgaon Datar" },
      { id: 534519, name: "Bori" },
      { id: 534443, name: "Borkhedi" },
      { id: 534424, name: "Brahmanwada" },
      { id: 534495, name: "Burkoni" },
      { id: 534370, name: "Chanki" },
      { id: 534476, name: "Chichaghat 2" },
      { id: 534458, name: "Chichghat (Rithi)" },
      { id: 534497, name: "Chikmoh" },
      { id: 534494, name: "Chincholi (Bu)" },
      { id: 534381, name: "Chincholi(1)" },
      { id: 534445, name: "Dabha" },
      { id: 534439, name: "Dag" },
      { id: 534422, name: "Daigavhan" },
      { id: 534417, name: "Dalalpur" },
      { id: 534491, name: "Daroda" },
      { id: 534368, name: "Dawlapur" },
      { id: 534471, name: "Dhamangaon" },
      { id: 534520, name: "Dhanora" },
      { id: 534423, name: "Dharmapur" },
      { id: 534533, name: "Dhiwri(Pipari)" },
      { id: 534526, name: "Dhochi" },
      { id: 534505, name: "Donduda" },
      { id: 534525, name: "Dorla" },
      { id: 534449, name: "Fattepur" },
      { id: 534487, name: "Fukta" },
      { id: 534359, name: "Gadegaon" },
      { id: 534393, name: "Gadegaon (Rith)" },
      { id: 534438, name: "Ganeshpur" },
      { id: 534503, name: "Gangapur" },
      { id: 534378, name: "Gangapur (1)" },
      { id: 534431, name: "Gangapur (Mauja No. 49)" },
      { id: 534402, name: "Gaul" },
      { id: 534382, name: "Gaznapur" },
      { id: 534410, name: "Ghatsavli" },
      { id: 534507, name: "Ghogapur (Rith)" },
      { id: 534426, name: "Gondapur" },
      { id: 534420, name: "Gopalpur" },
      { id: 534415, name: "Govindpur" },
      { id: 534527, name: "Hadsti" },
      { id: 534351, name: "Harnapur" },
      { id: 943006, name: "Hinganghat" },
      { id: 534388, name: "Hirapur (Rith)" },
      { id: 534511, name: "Hivara" },
      { id: 534387, name: "Inzala" },
      { id: 534383, name: "Isapur" },
      { id: 534455, name: "Itlapur" },
      { id: 534479, name: "Jaitapur" },
      { id: 534416, name: "Jamani" },
      { id: 534418, name: "Jamgaon" },
      { id: 534514, name: "Jangona" },
      { id: 534436, name: "Junona" },
      { id: 534400, name: "Kachangaon" },
      { id: 534462, name: "Kadajana" },
      { id: 534481, name: "Kajalsara" },
      { id: 534361, name: "Kangaon" },
      { id: 534373, name: "Kanholi" },
      { id: 534384, name: "Kapsi" },
      { id: 534501, name: "Kasapur" },
      { id: 534428, name: "Kasarkheda" },
      { id: 534442, name: "Kashimpur" },
      { id: 534374, name: "Katri" },
      { id: 534450, name: "Kawadghat" },
      { id: 534472, name: "Kekatvihira" },
      { id: 534440, name: "Khairati" },
      { id: 534364, name: "Khangaon" },
      { id: 534504, name: "Khapri (1)" },
      { id: 534391, name: "Khapri (Rith)" },
      { id: 534493, name: "Khardi" },
      { id: 534531, name: "Khekdi" },
      { id: 534354, name: "Kholapur" },
      { id: 534429, name: "Kingaon" },
      { id: 534433, name: "Kolhi Sa. Borgaon (Da)" },
      { id: 534530, name: "Kolhi Sa. Dhivari Pipri" },
      { id: 534432, name: "Kopra" },
      { id: 534369, name: "Kosurla Khurd" },
      { id: 534376, name: "Kosurla Mo. 1" },
      { id: 534461, name: "Kukabardi" },
      { id: 534464, name: "Kumbhi" },
      { id: 534460, name: "Kund" },
      { id: 534524, name: "Kuran (Rith)" },
      { id: 534408, name: "Kutki" },
      { id: 534475, name: "Ladki" },
      { id: 534377, name: "Madhwapur" },
      { id: 534448, name: "Mahadapur" },
      { id: 534488, name: "Mankapur" },
      { id: 534478, name: "Manora" },
      { id: 534371, name: "Mansaoli" },
      { id: 534356, name: "Mendukdoh" },
      { id: 534379, name: "Mozari" },
      { id: 534412, name: "Mubarakpur" },
      { id: 534470, name: "Murpad" },
      { id: 534441, name: "Naigaon" },
      { id: 534454, name: "Nandgaon (Bo)" },
      { id: 534355, name: "Nandgaon (Ka)" },
      { id: 534532, name: "Nandra" },
      { id: 534350, name: "Narayanpur" },
      { id: 534483, name: "Narsala" },
      { id: 534446, name: "Narsingpur" },
      { id: 534398, name: "Nidha" },
      { id: 534414, name: "Nurapur" },
      { id: 534496, name: "Pardi" },
      { id: 534506, name: "Parsoda" },
      { id: 534515, name: "Parsoda (Rith)" },
      { id: 534394, name: "Pawani" },
      { id: 534463, name: "Pimpalgaon (Ma)" },
      { id: 534386, name: "Pimpalgaon(Ha)" },
      { id: 534509, name: "Pipri" },
      { id: 534427, name: "Pirapur" },
      { id: 534512, name: "Pohana" },
      { id: 534366, name: "Poti" },
      { id: 534411, name: "Radhapur" },
      { id: 534353, name: "Rangna" },
      { id: 534457, name: "Rimdoh" },
      { id: 534357, name: "Rohankheda" },
      { id: 534421, name: "Sakidapur" },
      { id: 534352, name: "Salimpur" },
      { id: 534413, name: "Sastabad" },
      { id: 534522, name: "Sasti" },
      { id: 534474, name: "Satefal" },
      { id: 534348, name: "Sati" },
      { id: 534500, name: "Sawangi (Heti)" },
      { id: 534484, name: "Sawangi (Rith)" },
      { id: 534534, name: "Sawangi (Sangam)" },
      { id: 534468, name: "Sawli (Wagh)" },
      { id: 534518, name: "Sekapur (Bai)" },
      { id: 534521, name: "Selu" },
      { id: 534469, name: "Selu (Mu)" },
      { id: 534437, name: "Shahalangadi" },
      { id: 534459, name: "Shegaon (Kund)" },
      { id: 534367, name: "Shekapur(Mozari)" },
      { id: 534498, name: "Sindbahar" },
      { id: 534528, name: "Sindola Rith" },
      { id: 534397, name: "Sirasgaon" },
      { id: 534390, name: "Sirud" },
      { id: 534395, name: "Sonegaon (Dho)" },
      { id: 534486, name: "Sonegaon Khunkar" },
      { id: 534406, name: "Sonegaon(Ra)" },
      { id: 534516, name: "Sukali" },
      { id: 534467, name: "Sultanpur" },
      { id: 534372, name: "Takli" },
      { id: 534452, name: "Tambhari" },
      { id: 534499, name: "Tembha" },
      { id: 534399, name: "Tivsadi" },
      { id: 534466, name: "Umari" },
      { id: 534482, name: "Vaijapur" },
      { id: 534513, name: "Veni" },
      { id: 534490, name: "Wadner" },
      { id: 534425, name: "Wagholi" },
      { id: 534465, name: "Waldhur" },
      { id: 534451, name: "Wani" },
      { id: 534480, name: "Warkhed" },
      { id: 534349, name: "Warud" },
      { id: 534447, name: "Wela" },
      { id: 534473, name: "Yenora" },
      { id: 534392, name: "Yerandwadi" },
      { id: 534489, name: "Yerangaon" },
      { id: 534523, name: "Yerla" },
      { id: 534517, name: "Yerli" },
      { id: 534409, name: "Yetala (Rith)" },
      { id: 534380, name: "Zagdi" },
    ],
    4022: [
      { id: 534663, name: "Aajda" },
      { id: 534642, name: "Aashta" },
      { id: 534726, name: "Akola (Rith)" },
      { id: 534749, name: "Aloni" },
      { id: 534594, name: "Antargaon" },
      { id: 534690, name: "Arambha" },
      { id: 534589, name: "Arvi" },
      { id: 534748, name: "Asola" },
      { id: 534647, name: "Aurangapur (Sa)" },
      { id: 534708, name: "Aurangapur (Shi)" },
      { id: 534679, name: "Aurangpur (Ubada)" },
      { id: 534644, name: "Babapur" },
      { id: 534705, name: "Ballarpur" },
      { id: 534717, name: "Bandar (Rith)" },
      { id: 534551, name: "Barbadi" },
      { id: 534637, name: "Barfa" },
      { id: 534691, name: "Belghat" },
      { id: 534669, name: "Bhanapur" },
      { id: 534582, name: "Bhangapur (Rith)" },
      { id: 534611, name: "Bhawanpur" },
      { id: 534542, name: "Bhosa" },
      { id: 534627, name: "Bodkha Aa." },
      { id: 534636, name: "Bodkha Rith" },
      { id: 534753, name: "Bori" },
      { id: 534570, name: "Bothali" },
      { id: 534666, name: "Bothuda" },
      { id: 534646, name: "Chakur" },
      { id: 534754, name: "Chapapur" },
      { id: 534731, name: "Chikhali" },
      { id: 534630, name: "Chikhalkot" },
      { id: 534709, name: "Chincholi" },
      { id: 534673, name: "Chincholi(M)" },
      { id: 534730, name: "Chopan" },
      { id: 534581, name: "Chorvihira" },
      { id: 534678, name: "Dahegaon" },
      { id: 534549, name: "Dalpatpur" },
      { id: 534719, name: "Dasoda" },
      { id: 534576, name: "Davalatpur" },
      { id: 534653, name: "Derda" },
      { id: 534689, name: "Dhagadban" },
      { id: 534572, name: "Dhamangaon" },
      { id: 534720, name: "Dhamangaon (Gathe)" },
      { id: 534654, name: "Dhanoli" },
      { id: 534614, name: "Dhondgaon" },
      { id: 534568, name: "Dhumankheda." },
      { id: 534574, name: "Dongargaon" },
      { id: 534707, name: "Dongargaon (E)" },
      { id: 534588, name: "Faridpur" },
      { id: 534723, name: "Gadamodi" },
      { id: 534712, name: "Gadhavdev" },
      { id: 534578, name: "Ganeshpur (M)" },
      { id: 534703, name: "Ganeshpur (Na)" },
      { id: 534722, name: "Ganeshpur (U)" },
      { id: 534677, name: "Ganeshpur(Dha)" },
      { id: 534744, name: "Gangapur" },
      { id: 534541, name: "Gaul" },
      { id: 534674, name: "Gavha" },
      { id: 534592, name: "Ghorpad" },
      { id: 534742, name: "Ghui" },
      { id: 534586, name: "Girad" },
      { id: 534752, name: "Girgaon" },
      { id: 534702, name: "Govindpur" },
      { id: 534567, name: "Govindpur(Kh)" },
      { id: 534746, name: "Guljarpur" },
      { id: 534662, name: "Haladgaon" },
      { id: 534564, name: "Harankhuri" },
      { id: 534631, name: "Hirdi" },
      { id: 534610, name: "Hiwara" },
      { id: 534613, name: "Husenpur" },
      { id: 534547, name: "Isapur" },
      { id: 534618, name: "Italapur" },
      { id: 534621, name: "Jamb" },
      { id: 534643, name: "Jejori" },
      { id: 534559, name: "Jira" },
      { id: 534599, name: "Jogingumpha" },
      { id: 534736, name: "Kakaddhara" },
      { id: 534539, name: "Kalamana" },
      { id: 534550, name: "Kandhali" },
      { id: 534660, name: "Kanhapur" },
      { id: 534556, name: "Kankati" },
      { id: 534675, name: "Karda" },
      { id: 534751, name: "Karur (P)" },
      { id: 534699, name: "Karur(E)" },
      { id: 534715, name: "Kasarpeth" },
      { id: 534694, name: "Kavtha" },
      { id: 534573, name: "Kawadapur" },
      { id: 534604, name: "Keslapar" },
      { id: 534701, name: "Keslapur" },
      { id: 534615, name: "Khairgaon" },
      { id: 534566, name: "Khandala" },
      { id: 534667, name: "Khanjirpur" },
      { id: 534593, name: "Khapri (Kora)" },
      { id: 534756, name: "Khapri (Nimbha)" },
      { id: 534641, name: "Khapri(E)" },
      { id: 534737, name: "Khek" },
      { id: 534652, name: "Khuni" },
      { id: 534755, name: "Khursapar" },
      { id: 534575, name: "Khursapar(Dha)" },
      { id: 534685, name: "Kinhala" },
      { id: 534695, name: "Kinhi" },
      { id: 534733, name: "Kora" },
      { id: 534555, name: "Kori" },
      { id: 534734, name: "Krishnapeth" },
      { id: 534536, name: "Krishnapur" },
      { id: 534560, name: "Kurla" },
      { id: 534605, name: "Lahori" },
      { id: 534616, name: "Lasanpur" },
      { id: 534597, name: "Lokhandi" },
      { id: 534634, name: "Lonar" },
      { id: 534553, name: "Mahagaon" },
      { id: 534735, name: "Maharmajra" },
      { id: 534665, name: "Mandgaon" },
      { id: 534683, name: "Mangali" },
      { id: 534672, name: "Mangaon" },
      { id: 534718, name: "Mangrul" },
      { id: 534540, name: "Marda" },
      { id: 534700, name: "Mendula (M. No. 154)" },
      { id: 534676, name: "Menkhat" },
      { id: 534606, name: "Mira" },
      { id: 534693, name: "Mirzapur" },
      { id: 534600, name: "Mohgaon" },
      { id: 534622, name: "Muradpur" },
      { id: 534671, name: "Nagapur" },
      { id: 534692, name: "Nandori" },
      { id: 534645, name: "Nandpur" },
      { id: 534655, name: "Nandra" },
      { id: 534583, name: "Nanhi" },
      { id: 534732, name: "Narayanpur" },
      { id: 534706, name: "Narayanpur 1" },
      { id: 534538, name: "Narayanpur 4" },
      { id: 534565, name: "Narayanpur Kh." },
      { id: 534639, name: "Nimbha" },
      { id: 534557, name: "Nirgudi" },
      { id: 534585, name: "Pahad Farid" },
      { id: 534625, name: "Paikmari" },
      { id: 534680, name: "Panchgavhan" },
      { id: 534688, name: "Parda" },
      { id: 534546, name: "Pardi" },
      { id: 534571, name: "Parodhi" },
      { id: 534544, name: "Parsoda" },
      { id: 534562, name: "Parsodi" },
      { id: 534725, name: "Patalkot" },
      { id: 534687, name: "Pathar" },
      { id: 534750, name: "Pawangaon" },
      { id: 534587, name: "Peth" },
      { id: 534739, name: "Pilapur" },
      { id: 534598, name: "Pimpalgaon" },
      { id: 534603, name: "Pipri" },
      { id: 534704, name: "Pothara" },
      { id: 534545, name: "Rajjakpur" },
      { id: 534617, name: "Rajurwadi" },
      { id: 534607, name: "Ralegaon" },
      { id: 534558, name: "Ramnagar" },
      { id: 534670, name: "Rampur (H)" },
      { id: 534661, name: "Rampur(1)" },
      { id: 534563, name: "Ranumari" },
      { id: 534602, name: "Rasa" },
      { id: 534684, name: "Rengapur" },
      { id: 534620, name: "Renkapur" },
      { id: 534640, name: "Runka" },
      { id: 534596, name: "Saigavhan" },
      { id: 534710, name: "Sakhara" },
      { id: 534656, name: "Sakurli" },
      { id: 534535, name: "Salapur" },
      { id: 534619, name: "Samudrapur" },
      { id: 534579, name: "Sandas" },
      { id: 534738, name: "Satghari" },
      { id: 534657, name: "Savangi De." },
      { id: 534595, name: "Savangi M." },
      { id: 534697, name: "Sawangi (Za.)" },
      { id: 534728, name: "Sawari" },
      { id: 534609, name: "Sawarkhada" },
      { id: 534650, name: "Sewa" },
      { id: 534664, name: "Shedgaon" },
      { id: 534698, name: "Shegaon (Go)" },
      { id: 534612, name: "Shirpur" },
      { id: 534590, name: "Shivanfal" },
      { id: 534659, name: "Shivani" },
      { id: 534721, name: "Silli" },
      { id: 534682, name: "Sirsi" },
      { id: 534741, name: "Sonapur" },
      { id: 534624, name: "Sonegaon (Bo)" },
      { id: 534668, name: "Sonegaon (Pa)" },
      { id: 534629, name: "Sonegaon Ta." },
      { id: 534658, name: "Sujatpur" },
      { id: 534577, name: "Sukali(Mau N.211)" },
      { id: 534638, name: "Sukali(Nibha)" },
      { id: 534649, name: "Sultanpur" },
      { id: 534716, name: "Tadgaon" },
      { id: 534711, name: "Talodi" },
      { id: 534648, name: "Tambhari" },
      { id: 534633, name: "Tas" },
      { id: 534601, name: "Tawi" },
      { id: 534569, name: "Tekadi" },
      { id: 534747, name: "Tirmalpur" },
      { id: 534686, name: "Tuljapur" },
      { id: 534580, name: "Turimajra" },
      { id: 534681, name: "Ubda" },
      { id: 534548, name: "Umra" },
      { id: 534552, name: "Umri" },
      { id: 534727, name: "Umri (Kora)" },
      { id: 534591, name: "Undirgaon" },
      { id: 534608, name: "Undirkheda" },
      { id: 534724, name: "Usegaon" },
      { id: 534537, name: "Vikhani" },
      { id: 534632, name: "Wadgaon" },
      { id: 534626, name: "Wadgaon(Saza Nimbha)" },
      { id: 534714, name: "Wagdari" },
      { id: 534628, name: "Wagheda" },
      { id: 534635, name: "Wagheda (Dhok)" },
      { id: 534543, name: "Waigaon (Be)" },
      { id: 534561, name: "Waigaon (Gond)" },
      { id: 534554, name: "Waksur" },
      { id: 534740, name: "Wanarchuha" },
      { id: 534713, name: "Wanarchuha 1" },
      { id: 534651, name: "Wandhali" },
      { id: 534729, name: "Wasi" },
      { id: 534623, name: "Waygaon (H)" },
      { id: 534584, name: "Yedalabad" },
      { id: 534743, name: "Yekodi" },
      { id: 534745, name: "Yesapur" },
      { id: 534696, name: "Zunka" },
    ],
    4023: [
      { id: 534910, name: "Agra" },
      { id: 534826, name: "Ambada (Deshmukh)" },
      { id: 534895, name: "Ambada(Rithi)" },
      { id: 534758, name: "Ambada(Saywada)" },
      { id: 534863, name: "Ambola" },
      { id: 534812, name: "Arambhi" },
      { id: 534883, name: "Babulkheda(Rithi)" },
      { id: 534827, name: "Banor(Chandra)" },
      { id: 534790, name: "Banor(Pithori)" },
      { id: 534787, name: "Baradpavni" },
      { id: 534816, name: "Belona" },
      { id: 534830, name: "Bhaiwadi" },
      { id: 534800, name: "Bharsingi" },
      { id: 534784, name: "Bhayyapur(Rithi)" },
      { id: 534878, name: "Bhishnur" },
      { id: 534776, name: "Bopapur" },
      { id: 534867, name: "Borkhedi (Theke)" },
      { id: 534870, name: "Borkhedi(Mal)" },
      { id: 534822, name: "Bramhani(Rithi)" },
      { id: 534807, name: "Chichkumbha(Rithi)" },
      { id: 534854, name: "Chorkhairi" },
      { id: 534796, name: "Datewadi" },
      { id: 534792, name: "Dawasa" },
      { id: 534772, name: "Devgram" },
      { id: 534837, name: "Dewali" },
      { id: 534843, name: "Dhotra" },
      { id: 534774, name: "Dindargaon" },
      { id: 534815, name: "Gaimukh" },
      { id: 534832, name: "Gangaldoh" },
      { id: 534767, name: "Gaulkheda" },
      { id: 534900, name: "Ghogra" },
      { id: 534819, name: "Gondegaon" },
      { id: 534833, name: "Gondhani" },
      { id: 534908, name: "Gumgaon" },
      { id: 534813, name: "Hiwara" },
      { id: 534889, name: "Indarwada" },
      { id: 534831, name: "Indora" },
      { id: 534769, name: "Jalalkheda" },
      { id: 534893, name: "Jamgaon Bk" },
      { id: 534892, name: "Jamgaon Kh" },
      { id: 534906, name: "Jatlapur" },
      { id: 534801, name: "Jolwadi" },
      { id: 534901, name: "Junewani" },
      { id: 534860, name: "Junona (Fuke)" },
      { id: 534838, name: "Junona (Gharad)" },
      { id: 534897, name: "Kakaddara(Rithi)" },
      { id: 534802, name: "Karanjoli" },
      { id: 534781, name: "Karimabad(Rithi)" },
      { id: 534797, name: "Khadki" },
      { id: 534836, name: "Khairgaon" },
      { id: 534809, name: "Khalangondri" },
      { id: 534864, name: "Khandala[Bk]" },
      { id: 534899, name: "Khapa(Ghudan)" },
      { id: 534857, name: "Khapri(Gosavi)" },
      { id: 534896, name: "Khaprikene" },
      { id: 534905, name: "Kharala" },
      { id: 534907, name: "Kharashi" },
      { id: 534762, name: "Kharbadi" },
      { id: 534757, name: "Khargad" },
      { id: 534841, name: "Kharsoli" },
      { id: 534852, name: "Khedi Gowargondi" },
      { id: 534761, name: "Khedi Kh" },
      { id: 534844, name: "Khedikaryat" },
      { id: 534882, name: "Khushalpur" },
      { id: 534871, name: "Khutkheri" },
      { id: 534848, name: "Koni" },
      { id: 534898, name: "Kukadi(Rithi)" },
      { id: 534903, name: "Lohara" },
      { id: 534904, name: "Lohari (Sawanga)" },
      { id: 534868, name: "Lohgad (Theke) Rithi" },
      { id: 534869, name: "Lohgad(Mal) Rithi" },
      { id: 534771, name: "Madna" },
      { id: 534785, name: "Mahajanpur(Rithi)" },
      { id: 534763, name: "Mahendri" },
      { id: 534891, name: "Maiwadi" },
      { id: 534866, name: "Malapur" },
      { id: 534786, name: "Mamdapur(Rithi)" },
      { id: 534818, name: "Manikwada" },
      { id: 534853, name: "Mannathkhedi" },
      { id: 534814, name: "Math(Rithi)" },
      { id: 534794, name: "Mendhala" },
      { id: 534851, name: "Mhasora" },
      { id: 534777, name: "Milanpur(Rithi)" },
      { id: 534765, name: "Mirjapur" },
      { id: 534847, name: "Mogra" },
      { id: 534821, name: "Mohadi (Dalvi)" },
      { id: 534845, name: "Mohadi (Dhotra)" },
      { id: 534778, name: "Mohanpur(Rithi)" },
      { id: 534873, name: "Mohgaon (Bhadade)" },
      { id: 534773, name: "Mohgaon(Rithi)" },
      { id: 943139, name: "Movad" },
      { id: 534768, name: "Mundmalipura" },
      { id: 534880, name: "Nababpur(Rithi)" },
      { id: 534887, name: "Naigaon (Dhote)" },
      { id: 534780, name: "Naigaon (Thakre)" },
      { id: 534850, name: "Nanda (Shinde)" },
      { id: 534764, name: "Nandni" },
      { id: 534840, name: "Nandori(Rithi)" },
      { id: 534886, name: "Narayanpur(Rithi)" },
      { id: 534829, name: "Narkhed" },
      { id: 534779, name: "Narsingi" },
      { id: 534835, name: "Nasirpur(Rithi)" },
      { id: 534820, name: "Navegaon(Rithi)" },
      { id: 534823, name: "Palasgaon(Rithi)" },
      { id: 534890, name: "Panwadi" },
      { id: 534842, name: "Pardi(Rithi)" },
      { id: 534879, name: "Parsodi [Dixit]" },
      { id: 534839, name: "Parsodi(Raut)" },
      { id: 534782, name: "Peth Ismailpur" },
      { id: 534817, name: "Pilapur" },
      { id: 534791, name: "Pimpaldhara" },
      { id: 534828, name: "Pimpalgaon (Wakhaji)" },
      { id: 534877, name: "Pimpalgaon Raut" },
      { id: 534872, name: "Pipla (Kewalram)" },
      { id: 534855, name: "Pipla (Kh)" },
      { id: 534825, name: "Pithori" },
      { id: 534770, name: "Ramgaon(Rithi)" },
      { id: 534798, name: "Rampur(Rithi)" },
      { id: 534811, name: "Rampuri Rayyat (Rithi)" },
      { id: 534810, name: "Rampuri(Mal)" },
      { id: 534806, name: "Ramthi" },
      { id: 534894, name: "Ranwadi" },
      { id: 534888, name: "Rohana" },
      { id: 534799, name: "Sahajapur" },
      { id: 534759, name: "Saiwada" },
      { id: 534793, name: "Sakharkheda" },
      { id: 534909, name: "Salai (Rithi)" },
      { id: 534824, name: "Sardi" },
      { id: 534861, name: "Sawargaon" },
      { id: 534766, name: "Shabaspur" },
      { id: 534856, name: "Shemda" },
      { id: 534859, name: "Sindi" },
      { id: 534865, name: "Singarkheda" },
      { id: 534783, name: "Sinjar" },
      { id: 534862, name: "Sipikhapa(Rithi)" },
      { id: 534902, name: "Sonegaon(Rithi)" },
      { id: 534775, name: "Sonpur(Rithi)" },
      { id: 534804, name: "Talegaon(Rithi)" },
      { id: 534789, name: "Tara" },
      { id: 534760, name: "Thadipavni" },
      { id: 534884, name: "Thaturwada" },
      { id: 534874, name: "Thugaon (Nipani)" },
      { id: 534875, name: "Tinkheda" },
      { id: 534846, name: "Toyapar" },
      { id: 534808, name: "Udapur" },
      { id: 534858, name: "Umari" },
      { id: 534803, name: "Umatha" },
      { id: 534788, name: "Utara" },
      { id: 534876, name: "Wadgaon (Umari)" },
      { id: 534805, name: "Wadhona" },
      { id: 534795, name: "Wadvihara" },
      { id: 534885, name: "Warjali(Rithi)" },
      { id: 534881, name: "Wiwara" },
      { id: 534849, name: "Yeni" },
      { id: 534834, name: "Yerla(Indora)" },
    ],
    4024: [
      { id: 535050, name: "Ahmednagar" },
      { id: 534962, name: "Ajangaon" },
      { id: 535068, name: "Akewada" },
      { id: 534986, name: "Alagondi" },
      { id: 535015, name: "Ambada (So)" },
      { id: 535005, name: "Amnergondi (Rithi)" },
      { id: 534930, name: "Babulkheda" },
      { id: 535000, name: "Bhajipani" },
      { id: 535030, name: "Bhorgad" },
      { id: 534981, name: "Bhudakmadka" },
      { id: 534918, name: "Bid Jatamzari" },
      { id: 535063, name: "Bihalgondi" },
      { id: 535045, name: "Bilavargondi" },
      { id: 535092, name: "Bopapur" },
      { id: 535023, name: "Boragaon (Rithi)" },
      { id: 535002, name: "Bordoh" },
      { id: 535078, name: "Borgaon" },
      { id: 535004, name: "Borgondi" },
      { id: 534924, name: "Bori" },
      { id: 535040, name: "Borkhedi(Rithi)" },
      { id: 534961, name: "Bramhapuri(Rithi)" },
      { id: 535066, name: "Chakdoh" },
      { id: 535049, name: "Chandanpardi" },
      { id: 534964, name: "Chargaon" },
      { id: 534987, name: "Chaukigad" },
      { id: 535012, name: "Chaurepathar" },
      { id: 534955, name: "Chendkapur" },
      { id: 534997, name: "Chichala" },
      { id: 535051, name: "Chicholi" },
      { id: 534948, name: "Chikhali (Maina.)" },
      { id: 534983, name: "Chikhali (Malode)" },
      { id: 535090, name: "Chikhali (Masod)" },
      { id: 535034, name: "Chikhlagad" },
      { id: 534941, name: "Delwadi(Rithi)" },
      { id: 535076, name: "Dhamangaon" },
      { id: 534992, name: "Dhankundav" },
      { id: 534960, name: "Dhawalapur" },
      { id: 535006, name: "Dhiwarwadi" },
      { id: 535095, name: "Dhotiwada" },
      { id: 535079, name: "Dhurkheda" },
      { id: 534938, name: "Digras" },
      { id: 535081, name: "Dodki" },
      { id: 534999, name: "Dongargaon" },
      { id: 534928, name: "Dorli" },
      { id: 534966, name: "Dorli (Bk)" },
      { id: 534965, name: "Dorli (Kh)" },
      { id: 535062, name: "Dudhala" },
      { id: 535067, name: "Elkapar" },
      { id: 535007, name: "Fetri" },
      { id: 535061, name: "Ganeshpur" },
      { id: 534952, name: "Gangaldoh" },
      { id: 534990, name: "Garamsur" },
      { id: 535024, name: "Gharatwada" },
      { id: 534979, name: "Ghorpad" },
      { id: 535085, name: "Ghubadi" },
      { id: 534916, name: "Gollarkhapa" },
      { id: 534927, name: "Gondidigras" },
      { id: 534922, name: "Gondikhapa" },
      { id: 534921, name: "Gondimohgaon" },
      { id: 534947, name: "Gonhi" },
      { id: 535025, name: "Gujarkhedi" },
      { id: 534939, name: "Harankhuri" },
      { id: 535069, name: "Hardoli" },
      { id: 534971, name: "Hatla" },
      { id: 534951, name: "Isapur (Kh)" },
      { id: 534949, name: "Isapur(Bk)" },
      { id: 534936, name: "Isasani" },
      { id: 535074, name: "Jamgad" },
      { id: 535014, name: "Jatamkohala" },
      { id: 534919, name: "Jatamzari" },
      { id: 535089, name: "Jatlapur" },
      { id: 535053, name: "Junapani" },
      { id: 535009, name: "Junewani" },
      { id: 535059, name: "Kachari Savanga" },
      { id: 534932, name: "Kalambha" },
      { id: 535042, name: "Kalkuhi" },
      { id: 534988, name: "Kalmunda" },
      { id: 535093, name: "Kamthi" },
      { id: 534945, name: "Karla" },
      { id: 534991, name: "Katlabodi" },
      { id: 943595, name: "Katol" },
      { id: 535086, name: "Kawdimet" },
      { id: 535037, name: "Kedarpur" },
      { id: 535058, name: "Kelapur" },
      { id: 535013, name: "Khadki" },
      { id: 535077, name: "Khairi (Kh)" },
      { id: 534950, name: "Khairi (Navghare)" },
      { id: 534913, name: "Khamli" },
      { id: 535016, name: "Khandala (Kh)" },
      { id: 534996, name: "Khangaon" },
      { id: 534943, name: "Khanwadi" },
      { id: 535047, name: "Khapa" },
      { id: 535096, name: "Khapa (Bk)" },
      { id: 535075, name: "Khapari (Barokar)" },
      { id: 534972, name: "Khapari (Kh)" },
      { id: 535054, name: "Khursapur" },
      { id: 535038, name: "Khutamba" },
      { id: 535087, name: "Kinki Dhoda" },
      { id: 534959, name: "Kohala" },
      { id: 535039, name: "Kokarda(Rithi)" },
      { id: 535008, name: "Kolambi" },
      { id: 535032, name: "Kolhu" },
      { id: 535071, name: "Kondhali" },
      { id: 534973, name: "Kondhasaoli" },
      { id: 534978, name: "Kotwalbardi" },
      { id: 535020, name: "Kukadi Panjra" },
      { id: 535064, name: "Kundi" },
      { id: 535027, name: "Ladgaon" },
      { id: 534958, name: "Lakholi" },
      { id: 534995, name: "Lamdham" },
      { id: 535019, name: "Linga" },
      { id: 534954, name: "Malegaon" },
      { id: 535084, name: "Malkapur" },
      { id: 534993, name: "Mandala" },
      { id: 534982, name: "Maragsur" },
      { id: 534929, name: "Masli" },
      { id: 535091, name: "Masod" },
      { id: 534970, name: "Mendhepathar" },
      { id: 535043, name: "Mendhepathar (Jangli)" },
      { id: 534925, name: "Mendki" },
      { id: 534969, name: "Metpanjara" },
      { id: 535082, name: "Mhasala" },
      { id: 534953, name: "Mhaskhapra" },
      { id: 535083, name: "Miniwada" },
      { id: 534963, name: "Mohagaon (Rithi)" },
      { id: 535031, name: "Mohgaon (Dhole)" },
      { id: 535011, name: "Mohgaon (Jangli)" },
      { id: 534933, name: "Mohkhedi" },
      { id: 534911, name: "Mukani" },
      { id: 534980, name: "Murli" },
      { id: 535048, name: "Murti" },
      { id: 534998, name: "Naigaon" },
      { id: 534914, name: "Nanda (Rithi)" },
      { id: 535046, name: "Nandora" },
      { id: 535029, name: "Palgondi" },
      { id: 535041, name: "Panchdhar" },
      { id: 535010, name: "Pandhardhakani" },
      { id: 534920, name: "Panjara (Rithi)" },
      { id: 535070, name: "Panjra (Kate)" },
      { id: 534940, name: "Panwadi" },
      { id: 534994, name: "Paradsinga" },
      { id: 535003, name: "Pardi (Gotmare)" },
      { id: 534926, name: "Pardi(Rithi)" },
      { id: 535028, name: "Parsodi" },
      { id: 535001, name: "Pathar" },
      { id: 944881, name: "Pethbudhawar" },
      { id: 535094, name: "Pratapgad" },
      { id: 535088, name: "Pusagondi" },
      { id: 534912, name: "Rajni" },
      { id: 534956, name: "Ranghoda (Rithi)" },
      { id: 534977, name: "Raulgaon" },
      { id: 535022, name: "Ridhora" },
      { id: 535065, name: "Ringanabodi" },
      { id: 535044, name: "Sabkund" },
      { id: 534946, name: "Salai (Bk)" },
      { id: 535055, name: "Salai (Kh)" },
      { id: 535057, name: "Salai (Rithi)" },
      { id: 943596, name: "Sangama" },
      { id: 535033, name: "Saoli" },
      { id: 535021, name: "Saoli (Bk)" },
      { id: 535018, name: "Saoli (Kh)" },
      { id: 534989, name: "Shekapur" },
      { id: 535072, name: "Shirmi" },
      { id: 535052, name: "Shivkamath (Rithi)" },
      { id: 534942, name: "Sirsawadi" },
      { id: 535056, name: "Sonegaon" },
      { id: 534957, name: "Sonkhamb" },
      { id: 534974, name: "Sonmoh" },
      { id: 534915, name: "Sonoli" },
      { id: 535060, name: "Sonpur" },
      { id: 535036, name: "Tandulwani" },
      { id: 534917, name: "Tapani" },
      { id: 534968, name: "Tarabodi" },
      { id: 535073, name: "Taroda" },
      { id: 534967, name: "Ubagi(Rithi)" },
      { id: 535080, name: "Vasantnagar" },
      { id: 534944, name: "Wadhona" },
      { id: 534937, name: "Wadvihara" },
      { id: 535026, name: "Waghoda" },
      { id: 534985, name: "Wai (Bk)" },
      { id: 534984, name: "Wai (Kh)" },
      { id: 534975, name: "Wajbodi" },
      { id: 535035, name: "Walni" },
      { id: 534931, name: "Wandli (Bu)" },
      { id: 535017, name: "Wandli (Kh)" },
      { id: 534976, name: "Yenvihira" },
      { id: 534934, name: "Yenwa" },
      { id: 534935, name: "Yerla (Dhote)" },
      { id: 534923, name: "Zilpa" },
    ],
    4025: [
      { id: 535199, name: "Aalesur" },
      { id: 535189, name: "Aashtikala" },
      { id: 535139, name: "Adasa" },
      { id: 535167, name: "Belori Bk." },
      { id: 535154, name: "Bhadangi" },
      { id: 535132, name: "Bordoh (Rithi)" },
      { id: 535138, name: "Borgaon Bk." },
      { id: 535152, name: "Borgaon Kh." },
      { id: 535202, name: "Bramhni" },
      { id: 535106, name: "Budhla" },
      { id: 535120, name: "Chakdoh" },
      { id: 535201, name: "Chichbhuwan" },
      { id: 535098, name: "Dadhera" },
      { id: 535185, name: "Dahegaon" },
      { id: 535097, name: "Deoli (Rithi)" },
      { id: 535141, name: "Dhapewada Bk." },
      { id: 535156, name: "Dhapewada Kh." },
      { id: 535151, name: "Dhurkheda" },
      { id: 535164, name: "Dorli (Bhadoji)" },
      { id: 535153, name: "Dorli (Mani)" },
      { id: 535186, name: "Dorli Gangaji" },
      { id: 535111, name: "Dudhbardi (Rithi)" },
      { id: 535192, name: "Gadaga" },
      { id: 535173, name: "Ghogali" },
      { id: 535172, name: "Ghorad" },
      { id: 535200, name: "Gondkhairi" },
      { id: 535169, name: "Gowari" },
      { id: 535180, name: "Gumthala" },
      { id: 535149, name: "Hardoli" },
      { id: 535109, name: "Jirola (Rithi)" },
      { id: 535187, name: "Kalambi" },
      { id: 943594, name: "Kalmeshwar(Mcl)" },
      { id: 535142, name: "Kanyadol" },
      { id: 535196, name: "Karli (Waneri)" },
      { id: 535188, name: "Ketapar" },
      { id: 535122, name: "Khairi (Deshmukh)" },
      { id: 535175, name: "Khairi (Harji)" },
      { id: 535170, name: "Khairi (Lakhama)" },
      { id: 535150, name: "Khangaon" },
      { id: 535160, name: "Khapari (Kothe)" },
      { id: 535195, name: "Khapari (Uma)" },
      { id: 535116, name: "Khumari" },
      { id: 535118, name: "Khursapar (Rithi)" },
      { id: 535126, name: "Kohali" },
      { id: 535115, name: "Kokarda" },
      { id: 535135, name: "Koreghat (Rithi)" },
      { id: 535177, name: "Ladai (Jangli)" },
      { id: 535178, name: "Ladai (Maalgujari)" },
      { id: 535134, name: "Linga" },
      { id: 535105, name: "Lohgad" },
      { id: 535179, name: "Lonara" },
      { id: 535148, name: "Madhasawangi" },
      { id: 535108, name: "Mandvi" },
      { id: 535117, name: "Mhasepathar" },
      { id: 535145, name: "Mohagaon" },
      { id: 535130, name: "Mohali" },
      { id: 944875, name: "Mohpa(Mci)" },
      { id: 535197, name: "Nanda (Rithi)" },
      { id: 535101, name: "Nandikheda" },
      { id: 535137, name: "Nilgaon" },
      { id: 535176, name: "Nimboli" },
      { id: 535194, name: "Nimji" },
      { id: 535112, name: "Panjra (Rithi)" },
      { id: 535114, name: "Panubali" },
      { id: 535121, name: "Pardi (Desh)" },
      { id: 535113, name: "Parsodi (Rithi)" },
      { id: 535171, name: "Parsodi (Wakil)" },
      { id: 535161, name: "Peth Ubali" },
      { id: 535107, name: "Pilkapar" },
      { id: 535190, name: "Pilkapar(Rithi)" },
      { id: 535144, name: "Pipla (Kinkheda)" },
      { id: 535184, name: "Pipla (Rithi)" },
      { id: 535131, name: "Pohi (Gondkhairi)" },
      { id: 535119, name: "Ramgiri" },
      { id: 535193, name: "Rohana (Rithi)" },
      { id: 535198, name: "Sahuli" },
      { id: 535166, name: "Sawali Bk." },
      { id: 535158, name: "Sawali Kh." },
      { id: 535124, name: "Sawandri" },
      { id: 535146, name: "Sawangi (Tomar)" },
      { id: 535181, name: "Sawangi (Vyavhare)" },
      { id: 535182, name: "Selu" },
      { id: 535183, name: "Shahajapur (Rithi)" },
      { id: 535191, name: "Shahapur" },
      { id: 535162, name: "Sindi" },
      { id: 535143, name: "Sindi (Rithi)" },
      { id: 535155, name: "Sonapar" },
      { id: 535133, name: "Sonegoan" },
      { id: 535127, name: "Sonoli (Naik)" },
      { id: 535110, name: "Sonoli (Rithi)" },
      { id: 535140, name: "Sonpur" },
      { id: 535123, name: "Susundri" },
      { id: 535100, name: "Telgaon" },
      { id: 535136, name: "Telkamthi" },
      { id: 535099, name: "Tidangi" },
      { id: 535103, name: "Tishti Bk." },
      { id: 535102, name: "Tishti Kh." },
      { id: 535168, name: "Tondakhairi" },
      { id: 535129, name: "Ubagi" },
      { id: 535159, name: "Ubali" },
      { id: 535174, name: "Uparwahi" },
      { id: 535157, name: "Wadhona Bk." },
      { id: 535147, name: "Wadhona Kh." },
      { id: 535165, name: "Waroda" },
      { id: 535128, name: "Wathoda" },
      { id: 535125, name: "Yelkapar (Rithi)" },
      { id: 535104, name: "Zilpi" },
      { id: 535163, name: "Zunki" },
    ],
    4026: [
      { id: 535296, name: "Ajani" },
      { id: 535300, name: "Angewada" },
      { id: 535227, name: "Ashti Bk." },
      { id: 535211, name: "Ashti Kh." },
      { id: 535265, name: "Badegaon" },
      { id: 535279, name: "Bawangaon" },
      { id: 535321, name: "Belori Kh." },
      { id: 535241, name: "Bhagimahari" },
      { id: 535331, name: "Bhanegaon" },
      { id: 535311, name: "Bhendala" },
      { id: 535237, name: "Bhojapur" },
      { id: 535253, name: "Bhondetal" },
      { id: 535255, name: "Bichawa" },
      { id: 535206, name: "Bid Jatamkhora" },
      { id: 535314, name: "Bidachichghat" },
      { id: 535325, name: "Bidkawadas" },
      { id: 535215, name: "Borgaon Jangli" },
      { id: 535297, name: "Borujwada" },
      { id: 535307, name: "Bramhpuri" },
      { id: 535323, name: "Champa" },
      { id: 535335, name: "Chankapur" },
      { id: 535263, name: "Chargaon" },
      { id: 535216, name: "Chhatrapur" },
      { id: 535313, name: "Chichghat(Rithi)" },
      { id: 535336, name: "Chicholi" },
      { id: 535258, name: "Chorkhairi" },
      { id: 535329, name: "Dahegaon(Rangari)" },
      { id: 535277, name: "Dhakara" },
      { id: 535290, name: "Dohanghat" },
      { id: 535231, name: "Dudhbardi(Rithi)" },
      { id: 535306, name: "Erangaon" },
      { id: 535274, name: "Gadami" },
      { id: 535233, name: "Gadegaon" },
      { id: 535315, name: "Gosewadi" },
      { id: 535298, name: "Gujarkhedi" },
      { id: 535288, name: "Gumgaon" },
      { id: 535210, name: "Hattisarra" },
      { id: 535273, name: "Hetikheda" },
      { id: 535242, name: "Hetisurla" },
      { id: 535269, name: "Hingna" },
      { id: 535319, name: "Isapur" },
      { id: 535322, name: "Itangoti" },
      { id: 535207, name: "Jaitgad" },
      { id: 535217, name: "Jaitpur" },
      { id: 535225, name: "Jakhewada(Rithi)" },
      { id: 535214, name: "Jalalkheda" },
      { id: 535205, name: "Jatamkhora" },
      { id: 535218, name: "Joga" },
      { id: 535245, name: "Junewani (Panyakhali)" },
      { id: 535230, name: "Karajghat" },
      { id: 535320, name: "Kawadas" },
      { id: 535208, name: "Kawatha" },
      { id: 535212, name: "Kelwad" },
      { id: 535209, name: "Khairi (Dhalgaon)" },
      { id: 535280, name: "Khairi (Panjabrao)" },
      { id: 535293, name: "Khangaon" },
      { id: 535220, name: "Khapa (Janabai)" },
      { id: 535239, name: "Khapa (Narsala)" },
      { id: 943604, name: "Khapapeth" },
      { id: 535266, name: "Kharduka" },
      { id: 535285, name: "Khedi" },
      { id: 535270, name: "Khubala" },
      { id: 535294, name: "Khurajgaon" },
      { id: 535203, name: "Khursapar" },
      { id: 535282, name: "Kirnapur" },
      { id: 535268, name: "Kocchi" },
      { id: 535316, name: "Kodadongri" },
      { id: 535286, name: "Kodegaon" },
      { id: 535250, name: "Kormeta" },
      { id: 535281, name: "Kothulana" },
      { id: 535305, name: "Kotodi" },
      { id: 535309, name: "Kusumbi" },
      { id: 535275, name: "Kusumbi (Nimtalai)" },
      { id: 535261, name: "Maharkund" },
      { id: 535219, name: "Malegaon(Joga)" },
      { id: 535302, name: "Malegaon(Town)" },
      { id: 535303, name: "Manegaon" },
      { id: 535235, name: "Mangsa" },
      { id: 535271, name: "Mohagaon (Jangali)" },
      { id: 535252, name: "Nagalwadi" },
      { id: 535221, name: "Nanda Gomukh" },
      { id: 535234, name: "Nandakhurd (Rithi)" },
      { id: 535229, name: "Nandapur" },
      { id: 535228, name: "Nandori" },
      { id: 535238, name: "Narsala" },
      { id: 535276, name: "Nimtalai" },
      { id: 535304, name: "Pandharakhedi" },
      { id: 535224, name: "Pandhari (J)" },
      { id: 535295, name: "Pardi (Rithi)" },
      { id: 535292, name: "Parsodi" },
      { id: 535301, name: "Patakakhedi" },
      { id: 535317, name: "Patansavangi" },
      { id: 535272, name: "Pendhari" },
      { id: 535240, name: "Pipala (Bhadi)" },
      { id: 535326, name: "Pipla (Da-B)" },
      { id: 535267, name: "Pipla (Rithi)" },
      { id: 535236, name: "Pohana(Rithi)" },
      { id: 535330, name: "Pota" },
      { id: 535213, name: "Raibasa" },
      { id: 535257, name: "Raiwadi" },
      { id: 535284, name: "Rajana (Halad)" },
      { id: 535256, name: "Rajegaon (Panyakhali)" },
      { id: 535283, name: "Ramdongari" },
      { id: 535226, name: "Rampuri" },
      { id: 535327, name: "Ranala" },
      { id: 535264, name: "Risala" },
      { id: 535328, name: "Rohana" },
      { id: 535222, name: "Salai" },
      { id: 535251, name: "Sarra" },
      { id: 943162, name: "Savner" },
      { id: 535204, name: "Sawali (Mohatkar)" },
      { id: 535243, name: "Sawangi" },
      { id: 535324, name: "Sawarmendha" },
      { id: 535232, name: "Sherdi" },
      { id: 535334, name: "Sillewada" },
      { id: 535308, name: "Sillori" },
      { id: 535247, name: "Sindewani Bk." },
      { id: 535246, name: "Sindewani Kh." },
      { id: 535254, name: "Sironji" },
      { id: 535259, name: "Sonpur" },
      { id: 535260, name: "Surewani" },
      { id: 535310, name: "Takali (Bhansali)" },
      { id: 535248, name: "Tekadi" },
      { id: 535244, name: "Telangkhedi" },
      { id: 535262, name: "Tembhurdoh" },
      { id: 535287, name: "Tigai" },
      { id: 535223, name: "Umari (Bharatpur)" },
      { id: 535278, name: "Umari Jambhalpani" },
      { id: 535299, name: "Umari(Rithi)" },
      { id: 535318, name: "Veltur" },
      { id: 535332, name: "Waghoda" },
      { id: 535291, name: "Wagholi" },
      { id: 535312, name: "Waki" },
      { id: 535289, name: "Wakodi" },
      { id: 535333, name: "Walani" },
      { id: 535249, name: "Warpani" },
    ],
    4027: [
      { id: 535407, name: "Aamdi" },
      { id: 535357, name: "Aawaleghat" },
      { id: 535349, name: "Ambazari" },
      { id: 535383, name: "Amgaon" },
      { id: 535392, name: "Baburwada" },
      { id: 535363, name: "Bachhera" },
      { id: 943154, name: "Bajarkund" },
      { id: 535418, name: "Bakhari" },
      { id: 535344, name: "Banera" },
      { id: 535432, name: "Banpuri" },
      { id: 535403, name: "Bansingi" },
      { id: 535430, name: "Beldongari" },
      { id: 535431, name: "Bhagi (Ri)" },
      { id: 535386, name: "Bhagimahari" },
      { id: 535359, name: "Bhivagad" },
      { id: 535375, name: "Bhulewadi" },
      { id: 535376, name: "Bitoli" },
      { id: 535440, name: "Borada (Ganeshi)" },
      { id: 535439, name: "Bori (Rani)" },
      { id: 535449, name: "Bori (Singori)" },
      { id: 535354, name: "Borvan" },
      { id: 535435, name: "Champa (Ri)" },
      { id: 535358, name: "Chargaon" },
      { id: 535397, name: "Chichbhuwan" },
      { id: 535389, name: "Chicholi" },
      { id: 535398, name: "Dahegaon (Joshi)" },
      { id: 943153, name: "Deoli" },
      { id: 535345, name: "Dhawalapur" },
      { id: 535402, name: "Digalwadi" },
      { id: 535428, name: "Dorli" },
      { id: 535409, name: "Dumari Kala" },
      { id: 535419, name: "Dumari Kh." },
      { id: 535393, name: "Dundakhairi(Rithi)" },
      { id: 535424, name: "Garanda" },
      { id: 535350, name: "Gargoti(Rithi)" },
      { id: 535417, name: "Gawana" },
      { id: 535361, name: "Ghat Khairi" },
      { id: 535442, name: "Ghat Rohana" },
      { id: 535337, name: "Ghatkukada" },
      { id: 535338, name: "Ghatpendhari" },
      { id: 535380, name: "Ghukashi" },
      { id: 535444, name: "Gondegaon" },
      { id: 943152, name: "Gorakhpur" },
      { id: 535396, name: "Gundhari (Pande)" },
      { id: 535414, name: "Gundhari (Wandhe)" },
      { id: 535425, name: "Hingana (Ba)" },
      { id: 535445, name: "Hiwara (Gahu)" },
      { id: 535408, name: "Hiwari" },
      { id: 535401, name: "Itgaon" },
      { id: 535443, name: "Juni Kamptee" },
      { id: 535394, name: "Kalapatha" },
      { id: 535385, name: "Kalbhairao" },
      { id: 535360, name: "Kamptee(Padit)" },
      { id: 535453, name: "Kandri" },
      { id: 535372, name: "Kanhadevi" },
      { id: 535452, name: "Kanhan (Pipri)" },
      { id: 535391, name: "Karmbhad" },
      { id: 535434, name: "Keradi" },
      { id: 535410, name: "Khandala (Du)" },
      { id: 535447, name: "Khandala (Ghatate)" },
      { id: 535399, name: "Khandala (M]" },
      { id: 535438, name: "Khedi" },
      { id: 535340, name: "Kirangisarra(Rithi)" },
      { id: 535339, name: "Kolitmara" },
      { id: 535366, name: "Kondasawari" },
      { id: 535353, name: "Kukada (Rithi)" },
      { id: 535373, name: "Kusumdhara" },
      { id: 535379, name: "Lohara (Ri)" },
      { id: 535390, name: "Mahadula" },
      { id: 535395, name: "Mahuli" },
      { id: 535355, name: "Makardhokada" },
      { id: 535342, name: "Mehakepar(Rithi)" },
      { id: 535411, name: "Mehandi" },
      { id: 535369, name: "Mogra" },
      { id: 535420, name: "Nandgaon" },
      { id: 535343, name: "Narhar(Rithi)" },
      { id: 535362, name: "Navegaon(Khairi)" },
      { id: 535406, name: "Nayakund" },
      { id: 535377, name: "Neurwada" },
      { id: 944910, name: "New Gondegaon" },
      { id: 535448, name: "Nilaj" },
      { id: 535388, name: "Nimba" },
      { id: 535437, name: "Nimkheda" },
      { id: 535365, name: "Palasavali" },
      { id: 535378, name: "Pali" },
      { id: 535405, name: "Palora" },
      { id: 535436, name: "Panjara (Ri)" },
      { id: 535400, name: "Pardi" },
      { id: 535351, name: "Pardi(Rithi)" },
      { id: 944909, name: "Parseoni Bareja" },
      { id: 535404, name: "Parsioni" },
      { id: 535413, name: "Parsodi" },
      { id: 535374, name: "Parsodi (Peth)" },
      { id: 535348, name: "Pathar(Rithi)" },
      { id: 535387, name: "Pendhari" },
      { id: 535412, name: "Pipla" },
      { id: 535364, name: "Rangari(Rithi)" },
      { id: 535371, name: "Sakarla" },
      { id: 535368, name: "Salai (Tekadi)" },
      { id: 535382, name: "Salai(Mahuli)" },
      { id: 535347, name: "Saleghat" },
      { id: 535429, name: "Satak" },
      { id: 535346, name: "Sawangi" },
      { id: 535370, name: "Sawli" },
      { id: 535352, name: "Shiladevi" },
      { id: 535446, name: "Sihora" },
      { id: 535450, name: "Singardip" },
      { id: 535426, name: "Singori" },
      { id: 535427, name: "Soholi" },
      { id: 535416, name: "Sonegaon" },
      { id: 535384, name: "Suganabodi" },
      { id: 535341, name: "Surera" },
      { id: 535356, name: "Suwardhara" },
      { id: 535415, name: "Tamaswadi" },
      { id: 535451, name: "Tekadi Ko.Kh.T.Sa.Kr.14" },
      { id: 535367, name: "Tekadi(Kanha)" },
      { id: 535433, name: "Telang Khedi" },
      { id: 535381, name: "Umari" },
      { id: 535423, name: "Waghoda" },
      { id: 535421, name: "Wagholi" },
      { id: 535441, name: "Warada" },
      { id: 535422, name: "Yesamba" },
    ],
    4028: [
      { id: 535596, name: "Ajani" },
      { id: 535497, name: "Akola" },
      { id: 535524, name: "Ambazari" },
      { id: 535557, name: "Amgaon" },
      { id: 535607, name: "Asoli" },
      { id: 535469, name: "Bakhari(R)" },
      { id: 535466, name: "Bandra" },
      { id: 535478, name: "Belda" },
      { id: 535586, name: "Bhandar Bodi" },
      { id: 535545, name: "Bhilewada" },
      { id: 535571, name: "Bhojapur" },
      { id: 535537, name: "Bhondewada" },
      { id: 535569, name: "Bijewada" },
      { id: 943600, name: "Bodalzira(Panyakhali)" },
      { id: 535542, name: "Bondri" },
      { id: 535539, name: "Borda" },
      { id: 535590, name: "Bori" },
      { id: 535503, name: "Bothiya(Palora)" },
      { id: 535577, name: "Chakorda (Rithi)" },
      { id: 535563, name: "Chargaon" },
      { id: 535505, name: "Chargaon(Maudi)" },
      { id: 535548, name: "Chaugan" },
      { id: 535459, name: "Chawari" },
      { id: 535541, name: "Chhatrapur" },
      { id: 535594, name: "Chichala" },
      { id: 944912, name: "Chichda(Juna)" },
      { id: 535528, name: "Chichda(Navin)" },
      { id: 535517, name: "Chiknapur(Panyakhali)" },
      { id: 535603, name: "Chokhala" },
      { id: 535536, name: "Chorbahuli (Mogra)" },
      { id: 535526, name: "Chorbahuli(Van)" },
      { id: 535535, name: "Chorkhumari" },
      { id: 535522, name: "Dahoda" },
      { id: 535483, name: "Deolapar" },
      { id: 535543, name: "Deoli" },
      { id: 535593, name: "Devhala (Rithi)" },
      { id: 535472, name: "Dongartal" },
      { id: 535534, name: "Dongri" },
      { id: 535573, name: "Dudhala (R)" },
      { id: 535458, name: "Dulara" },
      { id: 535498, name: "Fulzari" },
      { id: 535486, name: "Fulzari (Forest)" },
      { id: 535455, name: "Garra" },
      { id: 535488, name: "Ghoti" },
      { id: 535606, name: "Ghoti(Dahoda)" },
      { id: 535514, name: "Ghoti(Ramjan)" },
      { id: 535464, name: "Goreghat" },
      { id: 535552, name: "Gudegaon" },
      { id: 535555, name: "Guguldoh" },
      { id: 535597, name: "Hamlapuri" },
      { id: 535587, name: "Hansapur" },
      { id: 535598, name: "Hatodi" },
      { id: 535544, name: "Hiwara (Bende)" },
      { id: 535568, name: "Hiwara(Pathrai)" },
      { id: 535499, name: "Hiwarabazar" },
      { id: 535504, name: "Hiwra (Hiwri)" },
      { id: 535521, name: "Jamuniya" },
      { id: 535476, name: "Junewani" },
      { id: 535600, name: "Kachurwahi" },
      { id: 535471, name: "Kadbikheda" },
      { id: 535473, name: "Kamthi" },
      { id: 535610, name: "Kandri" },
      { id: 535479, name: "Karajghat" },
      { id: 535457, name: "Karwahi" },
      { id: 535492, name: "Katta" },
      { id: 535561, name: "Kawadak" },
      { id: 535572, name: "Kawalapur" },
      { id: 535559, name: "Kelapur (R)" },
      { id: 535564, name: "Khairi" },
      { id: 535591, name: "Khandala (Kh)" },
      { id: 535495, name: "Khanora" },
      { id: 535485, name: "Khapa" },
      { id: 535510, name: "Kharpada" },
      { id: 535494, name: "Khidki" },
      { id: 535582, name: "Khindsi (R)" },
      { id: 535477, name: "Khirsali(Rithi)" },
      { id: 535601, name: "Khodegaon" },
      { id: 535538, name: "Khumari" },
      { id: 535454, name: "Khursapar" },
      { id: 535602, name: "Kirnapur(Khodgaon)" },
      { id: 535609, name: "Kirnapur(Shivani)" },
      { id: 535496, name: "Lakhapur" },
      { id: 535460, name: "Lodha" },
      { id: 535599, name: "Lohadongari" },
      { id: 535589, name: "Lohara" },
      { id: 535585, name: "Mahadula" },
      { id: 535531, name: "Maharajpur" },
      { id: 535527, name: "Maharapeth (R)" },
      { id: 535575, name: "Manapur" },
      { id: 535556, name: "Mandri" },
      { id: 535456, name: "Manegaon Tek" },
      { id: 535512, name: "Manegaon(Kala)" },
      { id: 535554, name: "Manegaon(Rithi)" },
      { id: 535551, name: "Mangli" },
      { id: 943602, name: "Maniktal Bareja" },
      { id: 535565, name: "Mansar" },
      { id: 944913, name: "Mansar Bareja" },
      { id: 535605, name: "Masala" },
      { id: 943601, name: "Mathurasagar Bareja" },
      { id: 535592, name: "Minsi (Rithi)" },
      { id: 535487, name: "Mohagaon(Rithi)" },
      { id: 535506, name: "Moudi" },
      { id: 535533, name: "Mukanapur" },
      { id: 535529, name: "Murda" },
      { id: 535480, name: "Murzad(Panyakhali)" },
      { id: 535553, name: "Musewadi" },
      { id: 535595, name: "Nagardhan" },
      { id: 535532, name: "Nahabi" },
      { id: 535578, name: "Navegaon (R) Soneghat" },
      { id: 535547, name: "Navegaon(Belda)" },
      { id: 535465, name: "Navegaon(Sangrampur)" },
      { id: 535580, name: "Nawargaon" },
      { id: 535463, name: "Nawegaon 2" },
      { id: 535576, name: "Pachpaoli(Rithi)" },
      { id: 535584, name: "Panchala (Bk)" },
      { id: 535583, name: "Panchala (Kh)" },
      { id: 535570, name: "Parsoda" },
      { id: 535566, name: "Patgowari" },
      { id: 535525, name: "Pathrai" },
      { id: 535508, name: "Pawni" },
      { id: 535502, name: "Pendhari" },
      { id: 535462, name: "Pindkapar(Lodha)" },
      { id: 535549, name: "Pindkapur(Sonpur)" },
      { id: 535490, name: "Pipriya" },
      { id: 535558, name: "Pipriyapeth" },
      { id: 929108, name: "Pusda Punarvasan No. 1" },
      { id: 929109, name: "Pusda Punarvasan No. 2" },
      { id: 535518, name: "Pusda(Panyakhali)" },
      { id: 535515, name: "Ramjan" },
      { id: 535560, name: "Rampuri" },
      { id: 943603, name: "Ramtek" },
      { id: 535579, name: "Sagrampur" },
      { id: 535489, name: "Salai" },
      { id: 535513, name: "Salai(Hiwrabajar)" },
      { id: 535588, name: "Salaimeta" },
      { id: 535540, name: "Sarakha" },
      { id: 535519, name: "Sarra (Panyakhali)" },
      { id: 535501, name: "Sawadani" },
      { id: 535511, name: "Sawangi" },
      { id: 535467, name: "Sawara" },
      { id: 535523, name: "Shahapur" },
      { id: 535608, name: "Shivani (Bhodaki)" },
      { id: 535574, name: "Shivani (Rithi)" },
      { id: 535491, name: "Sillari" },
      { id: 535493, name: "Sindewani" },
      { id: 535581, name: "Sirpur" },
      { id: 535562, name: "Sitalwadi" },
      { id: 535507, name: "Sitapar" },
      { id: 535461, name: "Sitapur" },
      { id: 535546, name: "Soneghat" },
      { id: 535550, name: "Sonpur" },
      { id: 944911, name: "Tangala-Chikanapur (Punarvasit)" },
      { id: 535516, name: "Tangla" },
      { id: 535481, name: "Tuyapar(Belda)" },
      { id: 535520, name: "Tuyapar(Dahoda)" },
      { id: 535530, name: "Umri" },
      { id: 535482, name: "Umri(Junewani)" },
      { id: 535468, name: "Usripar" },
      { id: 535474, name: "Wadamba (Malgujari)" },
      { id: 535475, name: "Wadamba (Rayatwari)" },
      { id: 535604, name: "Wadegaon" },
      { id: 535509, name: "Wanpauni" },
      { id: 535500, name: "Warghat" },
      { id: 535484, name: "Zinzeriya" },
    ],
    4029: [
      { id: 535686, name: "Adasa" },
      { id: 535648, name: "Adegaon" },
      { id: 535699, name: "Ajangaon" },
      { id: 535616, name: "Aroli" },
      { id: 535627, name: "Ashti (Barshi)" },
      { id: 535682, name: "Asthi (Dahegaon)" },
      { id: 535697, name: "Babadeo" },
      { id: 535638, name: "Banor" },
      { id: 535626, name: "Barshi" },
      { id: 535645, name: "Berdepar" },
      { id: 535718, name: "Bhamewada(Rithi)" },
      { id: 535652, name: "Bhandewadi" },
      { id: 535641, name: "Bhendala" },
      { id: 535680, name: "Bhokara (Sundargaon)" },
      { id: 535690, name: "Bhowari" },
      { id: 535720, name: "Borgaon" },
      { id: 535732, name: "Borgaon(Rithi)" },
      { id: 535654, name: "Borighivari" },
      { id: 535628, name: "Chacher" },
      { id: 535679, name: "Charbha" },
      { id: 535713, name: "Chehadi" },
      { id: 943178, name: "Chichghat(Punarvasit)" },
      { id: 535689, name: "Chicholi" },
      { id: 535691, name: "Chikhalabodi" },
      { id: 535723, name: "Chirwha" },
      { id: 535714, name: "Dahali" },
      { id: 535688, name: "Dahegaon" },
      { id: 535676, name: "Deomundhari" },
      { id: 535703, name: "Dhamangaon" },
      { id: 535639, name: "Dhani" },
      { id: 535701, name: "Dhanla" },
      { id: 535655, name: "Dhanoli" },
      { id: 535671, name: "Dharmapuri" },
      { id: 535683, name: "Dholmara" },
      { id: 535613, name: "Dudhala" },
      { id: 535633, name: "Gangner" },
      { id: 535684, name: "Ghotmundhari" },
      { id: 535731, name: "Gowari" },
      { id: 535625, name: "Hingana" },
      { id: 535635, name: "Hiwara (Balhe)" },
      { id: 535692, name: "Hiwara (Dharaskar)" },
      { id: 535669, name: "Ijani" },
      { id: 535659, name: "Indora" },
      { id: 535661, name: "Indori (Rithi)" },
      { id: 535698, name: "Isapur" },
      { id: 535617, name: "Kargaon(Rithi)" },
      { id: 535649, name: "Kathalabodi" },
      { id: 535644, name: "Khandala ( Pipari)" },
      { id: 535634, name: "Khandala (Gangner)" },
      { id: 535678, name: "Khandala (Gujar)" },
      { id: 535618, name: "Khaparkheda ( Teli)" },
      { id: 535647, name: "Khaparkheda (Jangali)" },
      { id: 535624, name: "Khaparkheda (Kirad)" },
      { id: 943177, name: "Kharada (Punarvasit)" },
      { id: 535619, name: "Kharda" },
      { id: 535675, name: "Khat" },
      { id: 535656, name: "Khidki" },
      { id: 535630, name: "Khopadi" },
      { id: 535710, name: "Kirnapur" },
      { id: 535653, name: "Kodamendhi" },
      { id: 535709, name: "Kopara" },
      { id: 535716, name: "Korad" },
      { id: 535733, name: "Kotgaon" },
      { id: 535708, name: "Kumbhapur" },
      { id: 535704, name: "Kumbhari" },
      { id: 535715, name: "Lapaka" },
      { id: 535721, name: "Mahadula" },
      { id: 535674, name: "Mahalgaon" },
      { id: 535707, name: "Mangli (Chande)" },
      { id: 535640, name: "Mangli(Gosai)" },
      { id: 535700, name: "Mangli(Teli)" },
      { id: 535717, name: "Marodi" },
      { id: 535725, name: "Mathani" },
      { id: 535646, name: "Metashivadouli" },
      { id: 535722, name: "Mohadi" },
      { id: 535727, name: "Mohkhedi" },
      { id: 535672, name: "Morgaon" },
      { id: 535734, name: "Mouda" },
      { id: 535665, name: "Murmadi" },
      { id: 535706, name: "Nanadevi" },
      { id: 535611, name: "Nandapuri" },
      { id: 535729, name: "Nandgaon (Kirad)" },
      { id: 535660, name: "Nandgaon(Chirwha)" },
      { id: 535695, name: "Narsala" },
      { id: 535677, name: "Nawargaon" },
      { id: 535636, name: "Nawegaon (Gangner)" },
      { id: 535702, name: "Nawegaon (Korad)" },
      { id: 535612, name: "Nerla" },
      { id: 535693, name: "Niharwani" },
      { id: 535623, name: "Nimkheda" },
      { id: 535629, name: "Nisatkheda" },
      { id: 535687, name: "Panjara" },
      { id: 535730, name: "Panmara" },
      { id: 535621, name: "Pardi Khurd" },
      { id: 535622, name: "Pardikala" },
      { id: 535724, name: "Pawaddauna" },
      { id: 535666, name: "Pimpalgaon" },
      { id: 535681, name: "Pipari" },
      { id: 535705, name: "Rahadi" },
      { id: 535620, name: "Rajoli" },
      { id: 535643, name: "Rewaral" },
      { id: 535632, name: "Salva" },
      { id: 535651, name: "Sawangi" },
      { id: 535696, name: "Sawargaon" },
      { id: 535685, name: "Shiwani" },
      { id: 535668, name: "Shrikhanda" },
      { id: 535694, name: "Singori (Bori)" },
      { id: 535719, name: "Singori (Marodi)" },
      { id: 535667, name: "Sirsoli" },
      { id: 535711, name: "Sukali (Dev)" },
      { id: 535663, name: "Sukli (Dukare)" },
      { id: 535673, name: "Tanda" },
      { id: 535615, name: "Tarodi" },
      { id: 535637, name: "Tarsa" },
      { id: 535657, name: "Tondli (Burj)" },
      { id: 535658, name: "Tondli Rithi" },
      { id: 535614, name: "Tuman" },
      { id: 535642, name: "Virsi" },
      { id: 535728, name: "Wadhana" },
      { id: 535650, name: "Waghbodi" },
      { id: 535670, name: "Wagholi (Rithi)" },
      { id: 535662, name: "Wakeshwar" },
      { id: 535726, name: "Wanjra" },
      { id: 535664, name: "Waygaon" },
      { id: 535631, name: "Yesmba" },
      { id: 535712, name: "Zullar" },
    ],
    4030: [
      { id: 535791, name: "Aadka" },
      { id: 535761, name: "Aawandhi" },
      { id: 535755, name: "Ajani" },
      { id: 535776, name: "Ambadi" },
      { id: 535775, name: "Asalwada" },
      { id: 535769, name: "Asoli" },
      { id: 535736, name: "Babulkheda" },
      { id: 535774, name: "Bhamewada" },
      { id: 535752, name: "Bhilgaon" },
      { id: 535760, name: "Bhowari" },
      { id: 535801, name: "Bhugaon" },
      { id: 535746, name: "Bidbina" },
      { id: 535783, name: "Bidgaon" },
      { id: 535745, name: "Bina" },
      { id: 535798, name: "Borgaon" },
      { id: 535737, name: "Chicholi" },
      { id: 535803, name: "Chikhali" },
      { id: 535797, name: "Chikna" },
      { id: 535767, name: "Dhargaon" },
      { id: 535781, name: "Dighori" },
      { id: 535756, name: "Gada" },
      { id: 535780, name: "Garla" },
      { id: 535754, name: "Ghorpad" },
      { id: 535772, name: "Gumthala" },
      { id: 535739, name: "Gumthi" },
      { id: 535796, name: "Jakhegaon" },
      { id: 535770, name: "Kadholi" },
      { id: 535766, name: "Kapsi Bk" },
      { id: 535748, name: "Kawtha" },
      { id: 535792, name: "Kem" },
      { id: 535795, name: "Kesori" },
      { id: 535751, name: "Khairy" },
      { id: 535738, name: "Khapa" },
      { id: 535742, name: "Khaparkheda" },
      { id: 535749, name: "Khasala" },
      { id: 535786, name: "Khedi" },
      { id: 535810, name: "Koradi" },
      { id: 535789, name: "Kusumbi" },
      { id: 535762, name: "Lihigaon" },
      { id: 535740, name: "Lonkhairi" },
      { id: 535809, name: "Mahadula" },
      { id: 535768, name: "Mahalgaon" },
      { id: 535800, name: "Mangali" },
      { id: 535750, name: "Mhasala" },
      { id: 535741, name: "Nanda" },
      { id: 535808, name: "Nanha" },
      { id: 535807, name: "Nerala" },
      { id: 535757, name: "Neri" },
      { id: 535793, name: "Nimba" },
      { id: 535802, name: "Ninhali (Rithi)" },
      { id: 535779, name: "Palsad" },
      { id: 535788, name: "Pandherkawada" },
      { id: 535785, name: "Pandhurna" },
      { id: 535743, name: "Panjara" },
      { id: 535787, name: "Parsodi" },
      { id: 535764, name: "Pawangaon" },
      { id: 535765, name: "Powari" },
      { id: 535753, name: "Ranala" },
      { id: 535799, name: "Ranmangali" },
      { id: 535771, name: "Sawali" },
      { id: 535794, name: "Selu" },
      { id: 535763, name: "Shirpur" },
      { id: 535804, name: "Shivani" },
      { id: 535759, name: "Sonegaon" },
      { id: 535744, name: "Suradevi" },
      { id: 535735, name: "Tandulwani" },
      { id: 535782, name: "Tarodi Bk." },
      { id: 535784, name: "Tarodi(Kh)" },
      { id: 535790, name: "Temsana" },
      { id: 535778, name: "Umari" },
      { id: 535758, name: "Ungaon" },
      { id: 535773, name: "Wadoda" },
      { id: 535806, name: "Warambha" },
      { id: 535747, name: "Waregaon" },
      { id: 535777, name: "Yekardi" },
      { id: 535811, name: "Yerkheda" },
      { id: 535805, name: "Zharap" },
    ],
    4031: [
      { id: 535871, name: "Adyali" },
      { id: 535945, name: "Alagondi" },
      { id: 535817, name: "Amgaon" },
      { id: 535964, name: "Ashta" },
      { id: 535846, name: "Ashti" },
      { id: 535863, name: "Bahadura" },
      { id: 535838, name: "Bailwada" },
      { id: 535819, name: "Bajargaon" },
      { id: 535812, name: "Bandhara (Rithi)" },
      { id: 535900, name: "Banwadi" },
      { id: 535867, name: "Beltarodi" },
      { id: 535866, name: "Besa" },
      { id: 535843, name: "Bhartwada" },
      { id: 535965, name: "Bhokara" },
      { id: 535815, name: "Bhuyari" },
      { id: 535855, name: "Bodhala" },
      { id: 535847, name: "Borgaon" },
      { id: 535969, name: "Bori" },
      { id: 535968, name: "Borkhedi" },
      { id: 535937, name: "Borkhedi (Railway)" },
      { id: 535909, name: "Bothali" },
      { id: 535837, name: "Brahmanwada" },
      { id: 535946, name: "Bramhani" },
      { id: 535842, name: "Chakkikhapa" },
      { id: 535834, name: "Chandrapur(Rithi)" },
      { id: 535958, name: "Chichkotha" },
      { id: 535951, name: "Chicholi (Rithi) P.C. No. 84" },
      { id: 535854, name: "Chicholi P.C. No. 4" },
      { id: 535888, name: "Chikana" },
      { id: 535952, name: "Chimanzari" },
      { id: 535882, name: "Dahegaon" },
      { id: 535956, name: "Daheli" },
      { id: 535971, name: "Davlameti" },
      { id: 535915, name: "Deoli (Gujar)" },
      { id: 535818, name: "Dhaga(Rithi)" },
      { id: 535831, name: "Dhamna (Linga) (Rithi)" },
      { id: 535874, name: "Dhamna 36 A" },
      { id: 535935, name: "Dhawalpeth" },
      { id: 535922, name: "Dhudhala (Rithi)" },
      { id: 535897, name: "Dongargaon" },
      { id: 535927, name: "Dongargaon (Bori) 76" },
      { id: 535858, name: "Drugdhamna" },
      { id: 535947, name: "Dudha" },
      { id: 535851, name: "Fetari" },
      { id: 535895, name: "Gawasi Manapur" },
      { id: 535868, name: "Ghogali (Gra)" },
      { id: 535840, name: "Ghoghali" },
      { id: 535921, name: "Ghoti" },
      { id: 535905, name: "Ghuti" },
      { id: 535850, name: "Godhani (Railway)" },
      { id: 535852, name: "Gonhi (Khurd)" },
      { id: 535862, name: "Gonhi (Sim)" },
      { id: 535928, name: "Gopalpur (Rithi)" },
      { id: 535877, name: "Gotal Pajri" },
      { id: 535839, name: "Gumthala" },
      { id: 535967, name: "Hudkeshwar Bk." },
      { id: 535870, name: "Hudkeshwar Kh." },
      { id: 535930, name: "Jaipur(Rithi)" },
      { id: 535896, name: "Jamtha" },
      { id: 535934, name: "Jangeshwar" },
      { id: 535963, name: "Jasapur" },
      { id: 535913, name: "Junapani" },
      { id: 535872, name: "Kalamana" },
      { id: 535901, name: "Kaldongri" },
      { id: 535880, name: "Kalkuhi" },
      { id: 535931, name: "Kanhalgaon (Rithi) P.C. No. 82" },
      { id: 535876, name: "Kanhalgaon P.C. No. 38" },
      { id: 535860, name: "Kapsi Kh" },
      { id: 535813, name: "Kavdimet(Rithi)" },
      { id: 535950, name: "Kawtha" },
      { id: 535857, name: "Khadgaon" },
      { id: 535816, name: "Khairi" },
      { id: 535844, name: "Khandala" },
      { id: 535932, name: "Khapari Subhedar" },
      { id: 535879, name: "Khapari(Railway)" },
      { id: 535820, name: "Khapri Khurd (Rithi)" },
      { id: 535861, name: "Kharabi" },
      { id: 535957, name: "Kharda" },
      { id: 535886, name: "Kharsoli" },
      { id: 535903, name: "Khasarmari" },
      { id: 535898, name: "Khatmari" },
      { id: 535940, name: "Kinhalmakadi" },
      { id: 535875, name: "Kirnapur (Rithi) P.C. No. 75" },
      { id: 535919, name: "Kirnapur P.C. No. 38" },
      { id: 535920, name: "Kolar" },
      { id: 535856, name: "Lava" },
      { id: 535832, name: "Linga" },
      { id: 535841, name: "Lonare" },
      { id: 535848, name: "Mahurzari" },
      { id: 535827, name: "Malegaon (Bk) (Rithi)" },
      { id: 535826, name: "Malegaon (Kh) (Rithi)" },
      { id: 535949, name: "Mangli" },
      { id: 535907, name: "Mangrul" },
      { id: 535929, name: "Mhasala" },
      { id: 535829, name: "Mohgaon Bk. (Rithi)" },
      { id: 535830, name: "Mohgaon Kh" },
      { id: 535908, name: "Mohgaon P. C. No. 74" },
      { id: 535959, name: "Mohgaon P. C. No. 86" },
      { id: 535926, name: "Murarpur (Rithi)" },
      { id: 535966, name: "Narsala" },
      { id: 535902, name: "Nawarmari" },
      { id: 535890, name: "Nawegaon" },
      { id: 535948, name: "Nawegaon (P.C. No. 40)" },
      { id: 535889, name: "Nimbha" },
      { id: 535824, name: "Pachanvari" },
      { id: 535828, name: "Padri Khapa" },
      { id: 535823, name: "Panjara" },
      { id: 535884, name: "Panjari (Brk) P.C. No. 42 A" },
      { id: 535904, name: "Panjari Lodhi" },
      { id: 535845, name: "Pardi" },
      { id: 535916, name: "Parsodi" },
      { id: 535883, name: "Parsodi (Gra)" },
      { id: 535833, name: "Pethkaldongari" },
      { id: 535892, name: "Pewatha" },
      { id: 535887, name: "Pilkapar" },
      { id: 535938, name: "Pipardol (Rithi)" },
      { id: 535869, name: "Pipla" },
      { id: 535849, name: "Pithesur (Rithi)" },
      { id: 535954, name: "Pohi" },
      { id: 535941, name: "Rahimabad (Rithi)" },
      { id: 535943, name: "Rahimapur (Rithi)" },
      { id: 535944, name: "Rama" },
      { id: 535923, name: "Rampur (Rithi)" },
      { id: 535918, name: "Rengapar (Rithi)" },
      { id: 535942, name: "Ridhora (Bk) (Rithi)" },
      { id: 535894, name: "Rui" },
      { id: 535925, name: "Rui Khairi" },
      { id: 535891, name: "Salai (Godhani)" },
      { id: 535825, name: "Satnavari" },
      { id: 535822, name: "Sawanga" },
      { id: 535878, name: "Shankarpur" },
      { id: 535821, name: "Shiwa" },
      { id: 535914, name: "Sindivihiri" },
      { id: 535814, name: "Sirpur" },
      { id: 535939, name: "Sonegaon (Bori)" },
      { id: 535960, name: "Sonegaon (Lodhi)" },
      { id: 535972, name: "Sonegaon (Nipani)" },
      { id: 535924, name: "Sonurli" },
      { id: 535906, name: "Sukli" },
      { id: 535859, name: "Surabardi" },
      { id: 535873, name: "Takli" },
      { id: 535962, name: "Tamaswadi" },
      { id: 535936, name: "Tarsi" },
      { id: 535881, name: "Telhara" },
      { id: 535953, name: "Tembhari" },
      { id: 535912, name: "Tumdi" },
      { id: 535865, name: "Umergaon" },
      { id: 535933, name: "Vathoda" },
      { id: 535864, name: "Vihirgaon" },
      { id: 535835, name: "Vyahad" },
      { id: 535917, name: "Vyahadghat (Rithi)" },
      { id: 535955, name: "Wadgaon (Kh) (Rithi)" },
      { id: 535970, name: "Wadi" },
      { id: 535961, name: "Wadmajara (Rithi)" },
      { id: 535910, name: "Wakeshwar" },
      { id: 535836, name: "Walani" },
      { id: 535893, name: "Warada" },
      { id: 535911, name: "Waranga" },
      { id: 535885, name: "Wela Harichandra" },
      { id: 535853, name: "Yerla" },
      { id: 535899, name: "Zari (Rithi)" },
    ],
    4032: [
      { id: 943067, name: "Ajni" },
      { id: 943068, name: "Ambazari" },
      { id: 943097, name: "Babulkheda" },
      { id: 943103, name: "Bhamti" },
      { id: 943104, name: "Bhandewadi" },
      { id: 943102, name: "Bhankheda" },
      { id: 943101, name: "Bharatwada" },
      { id: 943098, name: "Bidipeth" },
      { id: 943099, name: "Binakhi" },
      { id: 943100, name: "Borgaon" },
      { id: 943077, name: "Chichbhuwan" },
      { id: 943076, name: "Chikhali(De)" },
      { id: 943075, name: "Chikhali(Khu)" },
      { id: 943084, name: "Dabha" },
      { id: 943087, name: "Dhantoli" },
      { id: 943086, name: "Dharampeth" },
      { id: 943085, name: "Dighori" },
      { id: 943096, name: "Futala" },
      { id: 943073, name: "Gadga" },
      { id: 943074, name: "Gorewada" },
      { id: 943135, name: "Hajaripahad" },
      { id: 943138, name: "Hansapuri" },
      { id: 943136, name: "Harpur" },
      { id: 943137, name: "Hiwari" },
      { id: 943069, name: "Indora" },
      { id: 943079, name: "Jaripatka" },
      { id: 943080, name: "Jattarodi" },
      { id: 943078, name: "Jaytala" },
      { id: 943070, name: "Kachchimet" },
      { id: 943071, name: "Kalamna" },
      { id: 943072, name: "Khamla" },
      { id: 943107, name: "Lendhara" },
      { id: 943106, name: "Manewada" },
      { id: 943105, name: "Mankapur" },
      { id: 943088, name: "Nagpur(Khas)" },
      { id: 943089, name: "Nara" },
      { id: 943090, name: "Nari" },
      { id: 943093, name: "Pandharabodi" },
      { id: 943092, name: "Pardi" },
      { id: 943091, name: "Parsodi" },
      { id: 943095, name: "Police Line" },
      { id: 943094, name: "Punapur" },
      { id: 943131, name: "Sakkardara" },
      { id: 943130, name: "Shivangaon" },
      { id: 943132, name: "Sitabardi" },
      { id: 943134, name: "Somalwada" },
      { id: 943133, name: "Sonegaon" },
      { id: 943082, name: "Takli(Sim)" },
      { id: 943081, name: "Takli(Zingabai)" },
      { id: 943083, name: "Telangkhedi" },
      { id: 943108, name: "Wadpakad" },
      { id: 943110, name: "Wanjara" },
      { id: 943129, name: "Wanjari" },
      { id: 943109, name: "Wathoda" },
    ],
    4033: [
      { id: 535988, name: "Adegaon" },
      { id: 535977, name: "Agargaon" },
      { id: 536029, name: "Ajangaon" },
      { id: 536023, name: "Alesur" },
      { id: 535980, name: "Ambazari" },
      { id: 536109, name: "Amgaon" },
      { id: 536080, name: "Amgaon (Devali)" },
      { id: 535985, name: "Amgaon (Rithi)" },
      { id: 536119, name: "Asola" },
      { id: 536011, name: "Bhansoli (Kinhi)" },
      { id: 536121, name: "Bhansuli" },
      { id: 536059, name: "Bhivkund" },
      { id: 536016, name: "Bibi" },
      { id: 535997, name: "Bid Nilazidi" },
      { id: 536028, name: "Bid-Ajangaon" },
      { id: 536078, name: "Bid-Borgaon" },
      { id: 536114, name: "Bid-Ganeshpur" },
      { id: 536046, name: "Bid-Mhasala" },
      { id: 536021, name: "Borgaon" },
      { id: 536112, name: "Bothali" },
      { id: 536015, name: "Chauki" },
      { id: 536032, name: "Chicholi (Pathar)" },
      { id: 536094, name: "Chinchghat" },
      { id: 535978, name: "Dabha" },
      { id: 536093, name: "Datala" },
      { id: 536060, name: "Degma Kh" },
      { id: 535998, name: "Degma(Bu)" },
      { id: 536005, name: "Devali" },
      { id: 535974, name: "Devali (Kalbande)" },
      { id: 536111, name: "Devali (Nistane)" },
      { id: 536077, name: "Devali (Sawangi)" },
      { id: 536095, name: "Devalipeth" },
      { id: 536113, name: "Dewapur" },
      { id: 536052, name: "Dhanoli" },
      { id: 536083, name: "Dhanoli (Gumgaon)" },
      { id: 535991, name: "Dhanoli (Kavdas)" },
      { id: 536024, name: "Dhokarda" },
      { id: 535975, name: "Digdoh (Pande)" },
      { id: 536124, name: "Digdoh Devi" },
      { id: 536018, name: "Dongargaon (Rithi)" },
      { id: 536108, name: "Gangapur" },
      { id: 535986, name: "Gaurala" },
      { id: 536027, name: "Ghodeghat" },
      { id: 536122, name: "Ghogali" },
      { id: 535983, name: "Gidamgad" },
      { id: 536043, name: "Girola" },
      { id: 536082, name: "Godhani (Rithi)" },
      { id: 535987, name: "Gothangaon" },
      { id: 536076, name: "Gumgaon" },
      { id: 536031, name: "Haladgaon" },
      { id: 536055, name: "Hingna" },
      { id: 536128, name: "Isasani" },
      { id: 536002, name: "Itewahi" },
      { id: 536118, name: "Junapani" },
      { id: 536061, name: "Junewani" },
      { id: 536003, name: "Kajali" },
      { id: 536085, name: "Kanholi" },
      { id: 536086, name: "Kanholi (Rithi)" },
      { id: 536013, name: "Kanholibara" },
      { id: 536090, name: "Katangdhara" },
      { id: 535990, name: "Kavdas" },
      { id: 535993, name: "Keragondi" },
      { id: 536067, name: "Khadka" },
      { id: 536012, name: "Khadki" },
      { id: 535973, name: "Khairi" },
      { id: 536042, name: "Khairi (Sita)" },
      { id: 536026, name: "Khairi Khurd" },
      { id: 536062, name: "Khairi Khurd(Pradhan)" },
      { id: 536106, name: "Khapa" },
      { id: 535984, name: "Khapa Kh" },
      { id: 535982, name: "Khapa Nipani" },
      { id: 536020, name: "Khapari (Gandhi)" },
      { id: 535992, name: "Khapri (Karlekar)" },
      { id: 536116, name: "Khapri (Moreshwar)" },
      { id: 535994, name: "Khori Khapa" },
      { id: 536025, name: "Kinhala" },
      { id: 536104, name: "Kinhi" },
      { id: 536056, name: "Kinhi (Bhansoli)" },
      { id: 536009, name: "Kinhi (Dhanoli)" },
      { id: 536035, name: "Kinhi (Mandalekar)" },
      { id: 536006, name: "Kinhi (Rithi)" },
      { id: 536071, name: "Kirmati" },
      { id: 536101, name: "Kirmiti (Bharkas)" },
      { id: 536117, name: "Kohala" },
      { id: 535996, name: "Kokardi" },
      { id: 536074, name: "Kotewada" },
      { id: 536081, name: "Ladgaon" },
      { id: 536008, name: "Lakhamapur" },
      { id: 536058, name: "Mandavghorad" },
      { id: 535999, name: "Mandawa (Mahara)" },
      { id: 536010, name: "Mandawa (Marwadi)" },
      { id: 536051, name: "Mangli" },
      { id: 536037, name: "Mangrul" },
      { id: 536001, name: "Mathani" },
      { id: 536014, name: "Mauda (Rithi)" },
      { id: 536088, name: "Menkhat" },
      { id: 536044, name: "Metaumari" },
      { id: 536045, name: "Mhasala" },
      { id: 536050, name: "Mohgaon" },
      { id: 535989, name: "Mohgaon (Dhole)" },
      { id: 536064, name: "Mondha" },
      { id: 536115, name: "Murzari" },
      { id: 536127, name: "Nagalwadi" },
      { id: 536057, name: "Nanda Kh" },
      { id: 535979, name: "Nandera" },
      { id: 536000, name: "Nanhi" },
      { id: 535995, name: "Nawegaon Khurd" },
      { id: 536034, name: "Neri (Mankar)" },
      { id: 536123, name: "Nildoh" },
      { id: 536036, name: "Nildoh (Pannase)" },
      { id: 536070, name: "Panjari" },
      { id: 536039, name: "Pendhari" },
      { id: 536004, name: "Pendhari(Devli)" },
      { id: 536091, name: "Pipaldhara" },
      { id: 536110, name: "Pipri" },
      { id: 536079, name: "Pitesur" },
      { id: 536097, name: "Pohi" },
      { id: 536053, name: "Raipur" },
      { id: 536096, name: "Salaidabha" },
      { id: 536068, name: "Salaimendha" },
      { id: 536041, name: "Sangam" },
      { id: 536017, name: "Sawali" },
      { id: 536120, name: "Sawangi" },
      { id: 536069, name: "Sawangi (Devali)" },
      { id: 536040, name: "Sawardhota" },
      { id: 536072, name: "Shivmadka" },
      { id: 536007, name: "Singardip" },
      { id: 536038, name: "Sinka" },
      { id: 536098, name: "Sirul" },
      { id: 536075, name: "Sondapar" },
      { id: 536065, name: "Sukali" },
      { id: 536105, name: "Sukali (Beldar)" },
      { id: 536092, name: "Sukali (Gharpure)" },
      { id: 536047, name: "Sukali (Kalar)" },
      { id: 536073, name: "Sumthana" },
      { id: 536129, name: "Takalghat" },
      { id: 536066, name: "Takali" },
      { id: 536103, name: "Tembhari" },
      { id: 536033, name: "Turagondi" },
      { id: 536100, name: "Turkmari" },
      { id: 536063, name: "Ukhali" },
      { id: 536107, name: "Umari" },
      { id: 536048, name: "Umari (Wagh)" },
      { id: 536126, name: "Waddhamana" },
      { id: 536087, name: "Wadgaon (Bakshi)" },
      { id: 536030, name: "Wadgaon (Gujar)" },
      { id: 536084, name: "Wagdara (Gumgaon)" },
      { id: 536054, name: "Wagdara (I.Rithi)" },
      { id: 535976, name: "Walani" },
      { id: 536125, name: "Wanadongari" },
      { id: 536019, name: "Wanadongri (Rithi)" },
      { id: 536022, name: "Waranga" },
      { id: 536102, name: "Wateghat" },
      { id: 536089, name: "Wayfal" },
      { id: 535981, name: "Yerangaon" },
      { id: 536049, name: "Zilpi" },
    ],
    4034: [
      { id: 536146, name: "Akola" },
      { id: 536295, name: "Alagondi (Forest Village)" },
      { id: 536190, name: "Amboli" },
      { id: 536246, name: "Amgaon (De)" },
      { id: 536303, name: "Amghat" },
      { id: 536184, name: "Aptur" },
      { id: 536204, name: "Bareja (Ri)" },
      { id: 536143, name: "Barvha" },
      { id: 536262, name: "Bela" },
      { id: 536216, name: "Belgaon" },
      { id: 536267, name: "Belpeth" },
      { id: 536232, name: "Bendoli" },
      { id: 536213, name: "Bhapsi" },
      { id: 536255, name: "Bhivgad" },
      { id: 536150, name: "Bhiwapur" },
      { id: 536300, name: "Bidmohna (Ri)" },
      { id: 536176, name: "Bopeshwar (Ri)" },
      { id: 536266, name: "Borgaon" },
      { id: 536141, name: "Borgaon (K)" },
      { id: 536251, name: "Borgaon (Kazi) (Rithi)" },
      { id: 536263, name: "Borgaon (La)" },
      { id: 536222, name: "Borgaon (Rithi)" },
      { id: 536302, name: "Bori Majara" },
      { id: 536217, name: "Boribhatari (Ri)" },
      { id: 536319, name: "Bothali (Ki)" },
      { id: 536234, name: "Bothali (Thana)" },
      { id: 536187, name: "Bramhi (Ri)" },
      { id: 536189, name: "Bramhni" },
      { id: 536152, name: "Champa" },
      { id: 536309, name: "Chanoda" },
      { id: 536249, name: "Chargaon" },
      { id: 536225, name: "Chicholi(Rithi)" },
      { id: 536301, name: "Chikhaldhokda" },
      { id: 536154, name: "Chimanazari" },
      { id: 536173, name: "Dahegaon" },
      { id: 536172, name: "Davha" },
      { id: 536135, name: "Dawalimet(Rithi)" },
      { id: 536209, name: "Deni" },
      { id: 536229, name: "Dewli" },
      { id: 536287, name: "Dhamangaon (Ri)" },
      { id: 536221, name: "Dhurkheda" },
      { id: 536299, name: "Dighori" },
      { id: 536294, name: "Dongargaon" },
      { id: 536163, name: "Dudha" },
      { id: 536220, name: "Fattepur(Rithi)" },
      { id: 536169, name: "Fukeshwar" },
      { id: 536273, name: "Ganeshpur(Rithi)" },
      { id: 536203, name: "Gangapur" },
      { id: 536197, name: "Ganpawli (Ri)" },
      { id: 536183, name: "Gaosut" },
      { id: 536241, name: "Garamsur (Ri)" },
      { id: 536195, name: "Ghoturli" },
      { id: 536291, name: "Godhani" },
      { id: 536274, name: "Gowari(Rithi)" },
      { id: 536320, name: "Gulalpur (Ri)" },
      { id: 536159, name: "Haladgaon" },
      { id: 536194, name: "Hatkawada (Ri)" },
      { id: 536179, name: "Heoti" },
      { id: 536308, name: "Hiwara" },
      { id: 536310, name: "Ibrahimpur (Ri)" },
      { id: 536281, name: "Jaitapur" },
      { id: 536240, name: "Jambhalapani" },
      { id: 536238, name: "Jamgad" },
      { id: 536293, name: "Junoni" },
      { id: 536312, name: "Kachalkuhi(Rithi)" },
      { id: 536157, name: "Kachchimet" },
      { id: 536275, name: "Kalamana (Be)" },
      { id: 536288, name: "Kalamana (Go)" },
      { id: 536139, name: "Kalandri" },
      { id: 536200, name: "Kanwha" },
      { id: 536211, name: "Karhandala" },
      { id: 536198, name: "Katara(Rithi)" },
      { id: 536258, name: "Kawadapur" },
      { id: 536317, name: "Keslapur" },
      { id: 536248, name: "Khairi (Buti)" },
      { id: 536231, name: "Khairi (Ka)" },
      { id: 536140, name: "Khairi(Na)" },
      { id: 536171, name: "Khapri" },
      { id: 536138, name: "Khapri (Ku)" },
      { id: 536193, name: "Khapri (Ri)" },
      { id: 536132, name: "Khapri Raja" },
      { id: 536214, name: "Khedi(Rithi)" },
      { id: 536286, name: "Khursapar" },
      { id: 536259, name: "Khursapar(Bela)" },
      { id: 536235, name: "Kinhala (De) (Rithi)" },
      { id: 536261, name: "Kinhala (V)" },
      { id: 536318, name: "Kinhala(Bo)" },
      { id: 536264, name: "Kohla" },
      { id: 536149, name: "Kolarmet" },
      { id: 536192, name: "Kotgaon" },
      { id: 536188, name: "Kumbhapur (Ri)" },
      { id: 536218, name: "Kumbhari" },
      { id: 536228, name: "Lohara" },
      { id: 536136, name: "Majri(Rithi)" },
      { id: 536175, name: "Makardhokada" },
      { id: 536137, name: "Mangli" },
      { id: 536316, name: "Manori" },
      { id: 536230, name: "Marajghat (Rithi)" },
      { id: 536236, name: "Maramzari (Ri)" },
      { id: 536304, name: "Masala(Ch)" },
      { id: 536165, name: "Masalkund" },
      { id: 536156, name: "Matkazari" },
      { id: 536256, name: "Mendhepathar" },
      { id: 536279, name: "Menkhat (Ri)" },
      { id: 536298, name: "Metmangrud (Ri)" },
      { id: 536297, name: "Mhasala(Go)" },
      { id: 536162, name: "Mhasepathar (R)" },
      { id: 536219, name: "Mohpa" },
      { id: 536254, name: "Muradpur" },
      { id: 536247, name: "Murzadi" },
      { id: 536305, name: "Nandra" },
      { id: 536201, name: "Narsala (Ri)" },
      { id: 536226, name: "Nawegaon (S)" },
      { id: 536142, name: "Nirvha" },
      { id: 536257, name: "Nishanghat" },
      { id: 536131, name: "Pachgaon" },
      { id: 536290, name: "Pandharabodi (Rithi)" },
      { id: 536285, name: "Pandhartal(Rithi)" },
      { id: 536282, name: "Panjrepar ( Dewli) (Rithi)" },
      { id: 536224, name: "Panjrepar(Rithi)" },
      { id: 536166, name: "Paradgaon" },
      { id: 536215, name: "Parsodi(Um)" },
      { id: 536164, name: "Parsodi(Uti)" },
      { id: 536208, name: "Pauni(Rithi)" },
      { id: 536278, name: "Pavani" },
      { id: 536158, name: "Pendhari" },
      { id: 536271, name: "Pendkapur" },
      { id: 536280, name: "Pethmahmadpur (Ri)" },
      { id: 536207, name: "Pimpalkhut (Ri)" },
      { id: 536283, name: "Pipardol" },
      { id: 536144, name: "Pipla" },
      { id: 536315, name: "Pipra" },
      { id: 536191, name: "Piraya" },
      { id: 536237, name: "Piti Chuwha" },
      { id: 536148, name: "Pusagondi" },
      { id: 536181, name: "Rajulwadi" },
      { id: 536265, name: "Rakhi(Rithi)" },
      { id: 536250, name: "Ridhora(Rithi)" },
      { id: 536167, name: "Saiki" },
      { id: 536185, name: "Salai" },
      { id: 536276, name: "Salai Bk. (Ri)" },
      { id: 536277, name: "Salai Kh." },
      { id: 536289, name: "Salaimahalgaon(Rithi)" },
      { id: 536130, name: "Salaimendha" },
      { id: 536253, name: "Salairani" },
      { id: 536311, name: "Sandigondi" },
      { id: 536270, name: "Sawangi (Bk)" },
      { id: 536269, name: "Sawangi (Kh)" },
      { id: 536268, name: "Sayeshwar" },
      { id: 536307, name: "Seloti(Rithi)" },
      { id: 536206, name: "Seo" },
      { id: 536313, name: "Shedeshwar" },
      { id: 536199, name: "Shirpur" },
      { id: 536239, name: "Sindi Vihari" },
      { id: 536272, name: "Singapur (Ri)" },
      { id: 536314, name: "Singori" },
      { id: 536321, name: "Sirsi (R)" },
      { id: 536202, name: "Sonegaon(Rithi)" },
      { id: 536186, name: "Sonpuri" },
      { id: 536306, name: "Sukali Junoni" },
      { id: 536296, name: "Sukli (Di) (Rithi)" },
      { id: 536153, name: "Sukli (Pe)" },
      { id: 536174, name: "Sukli (Ri)" },
      { id: 536252, name: "Surabardi" },
      { id: 536244, name: "Surajpur (Ri)" },
      { id: 536133, name: "Surgaon" },
      { id: 536245, name: "Tambekhani (M)" },
      { id: 536243, name: "Tambekhani (Ri)" },
      { id: 536292, name: "Telkawadsi" },
      { id: 536227, name: "Thana" },
      { id: 536233, name: "Thana (Padri)" },
      { id: 536170, name: "Thara" },
      { id: 536182, name: "Thombara" },
      { id: 536160, name: "Tikhadi" },
      { id: 536212, name: "Tirkhura" },
      { id: 536180, name: "Udasa" },
      { id: 536177, name: "Ukadwadi" },
      { id: 536161, name: "Umra" },
      { id: 536205, name: "Umred (Rural)" },
      { id: 536242, name: "Umri (Ri)" },
      { id: 536134, name: "Undari" },
      { id: 536151, name: "Uti" },
      { id: 536147, name: "Virli" },
      { id: 536155, name: "Wadadh" },
      { id: 536223, name: "Wadandra" },
      { id: 536145, name: "Wadegaon" },
      { id: 536260, name: "Wadgaon" },
      { id: 536168, name: "Wagholi (Davha) (Rithi)" },
      { id: 536284, name: "Wagholi(Rithi)" },
      { id: 536210, name: "Wanoda" },
      { id: 536196, name: "Wayagaon (Rt)" },
      { id: 536178, name: "Welsakhara" },
    ],
    4035: [
      { id: 536338, name: "Aajni T.S.Kr.1" },
      { id: 536352, name: "Aajni T.S.Kr.7" },
      { id: 536410, name: "Adam" },
      { id: 536430, name: "Adegaon" },
      { id: 536368, name: "Agargaon" },
      { id: 536329, name: "Akoli" },
      { id: 536379, name: "Ambadi" },
      { id: 536432, name: "Ambhora Kh." },
      { id: 944904, name: "Ambhora Khurd-Ambhora Kala-Gadpayli (Punarvasit)" },
      { id: 536426, name: "Ambhorakala" },
      { id: 536384, name: "Amti" },
      { id: 536415, name: "Awarmara" },
      { id: 536451, name: "Balapur (Rithi)" },
      { id: 536465, name: "Bamhani" },
      { id: 943606, name: "Bamhani(Punarvasit)" },
      { id: 536427, name: "Bandarchuha (Rithi)" },
      { id: 536362, name: "Banor" },
      { id: 536327, name: "Bhamewada" },
      { id: 536404, name: "Bhandarbora" },
      { id: 536408, name: "Bhatara" },
      { id: 536458, name: "Bhiwapur" },
      { id: 944901, name: "Bhiwapur-Fegad (Punarvasit)" },
      { id: 536387, name: "Bhiwkund" },
      { id: 536349, name: "Bhojapur" },
      { id: 536378, name: "Bhowardeo" },
      { id: 536400, name: "Bidbothli" },
      { id: 536389, name: "Bodkhipeth" },
      { id: 536506, name: "Borada(Rithi)" },
      { id: 536475, name: "Bori" },
      { id: 536422, name: "Bori (Naik)" },
      { id: 536439, name: "Bothli" },
      { id: 536496, name: "Bramhani" },
      { id: 536499, name: "Buti Tola Alias Kosari" },
      { id: 536364, name: "Chada" },
      { id: 536497, name: "Chandala(Rithi)" },
      { id: 536437, name: "Channa" },
      { id: 536328, name: "Chanoda" },
      { id: 536375, name: "Chapegadi" },
      { id: 536374, name: "Chapeghat(Rithi)" },
      { id: 536438, name: "Chichal" },
      { id: 536366, name: "Chichghat T.S.Kr.58" },
      { id: 536417, name: "Chichghat T.S.Kr.62" },
      { id: 536399, name: "Chikhalabodi" },
      { id: 536440, name: "Chikhali" },
      { id: 536490, name: "Chikna Tukum" },
      { id: 536407, name: "Chipdi" },
      { id: 536333, name: "Chitapur" },
      { id: 536493, name: "Dahegaon" },
      { id: 536401, name: "Dalpatpur(Rithi)" },
      { id: 536402, name: "Dawdipar" },
      { id: 536383, name: "Deoli Kh." },
      { id: 536396, name: "Deolikala" },
      { id: 536498, name: "Dhamna" },
      { id: 536424, name: "Dhamni" },
      { id: 536449, name: "Dhanla" },
      { id: 536334, name: "Dhanoli" },
      { id: 536335, name: "Dipala" },
      { id: 536342, name: "Dodma" },
      { id: 536339, name: "Dongargaon" },
      { id: 536480, name: "Dongarmauda" },
      { id: 536455, name: "Fegad" },
      { id: 536425, name: "Gadpayli" },
      { id: 536418, name: "Gondpipri" },
      { id: 536441, name: "Gonha" },
      { id: 944897, name: "Gonha - Chikhli ( Punarvasit)" },
      { id: 536494, name: "Gothangaon" },
      { id: 944899, name: "Gothangaon-Pandhargota-Rajoli (Punarvasit)" },
      { id: 536481, name: "Hardoli" },
      { id: 536423, name: "Hardoli (Naik)" },
      { id: 944902, name: "Hardoli(Punarvasit)" },
      { id: 536341, name: "Hetameti(Rith)" },
      { id: 536355, name: "Heti(Rith)" },
      { id: 536398, name: "Hudpa" },
      { id: 536354, name: "Isapur (Navegaon)" },
      { id: 536461, name: "Jiwanapur" },
      { id: 943615, name: "Jiwanapur(Punarvasit)" },
      { id: 536371, name: "Kanheri Dongarmoh" },
      { id: 536369, name: "Kanheri Kh.(Rith)" },
      { id: 536477, name: "Karhandla" },
      { id: 536414, name: "Katara" },
      { id: 536446, name: "Kesori" },
      { id: 536447, name: "Khairlanji" },
      { id: 536323, name: "Khalasana" },
      { id: 944894, name: "Kharada" },
      { id: 536376, name: "Kharbi" },
      { id: 536397, name: "Khenda" },
      { id: 536358, name: "Khetapur" },
      { id: 536381, name: "Khobna" },
      { id: 536450, name: "Khokarla" },
      { id: 536392, name: "Khopadi(Rith)" },
      { id: 536385, name: "Khursapar" },
      { id: 536467, name: "Kinhi" },
      { id: 536500, name: "Kitadi(Rith)" },
      { id: 536325, name: "Kuchadi" },
      { id: 536403, name: "Kuhi" },
      { id: 536503, name: "Kujba" },
      { id: 536462, name: "Kukkadumri" },
      { id: 536336, name: "Lanjala" },
      { id: 536409, name: "Lohara" },
      { id: 536468, name: "Madnapur" },
      { id: 536411, name: "Majri" },
      { id: 536361, name: "Malchi" },
      { id: 536330, name: "Malni" },
      { id: 536433, name: "Maloda" },
      { id: 536470, name: "Mandhal" },
      { id: 536331, name: "Mangli" },
      { id: 536344, name: "Mendha(Rithi)" },
      { id: 536434, name: "Mendhe Kh." },
      { id: 536346, name: "Mendhegaon" },
      { id: 536431, name: "Mendhekala" },
      { id: 536421, name: "Mhasli" },
      { id: 943617, name: "Mhasli(Punarvasit)" },
      { id: 536351, name: "Mohadara" },
      { id: 536324, name: "Mohadi" },
      { id: 536365, name: "Mohgaon" },
      { id: 536363, name: "Murbi" },
      { id: 536405, name: "Musalgaon" },
      { id: 536413, name: "Navegaon (Devi)" },
      { id: 944895, name: "Navegaon (Sirsi) Sonarwahi-Umri(Punarvasit)" },
      { id: 536453, name: "Navegaon T. Sa.Kr.61" },
      { id: 536416, name: "Navegaon T.Sa.Kr.65" },
      { id: 536380, name: "Navegaon(Rithi)" },
      { id: 944903, name: "Navegaon-(Chichghat) (Punarvasit)" },
      { id: 536343, name: "Nawargaon" },
      { id: 536395, name: "Newri" },
      { id: 536476, name: "Pachkhedi T.Sa.Kr.49" },
      { id: 536484, name: "Pachkhedi T.Sa.Kr.72" },
      { id: 536373, name: "Palegaon(Rithi)" },
      { id: 536394, name: "Pandegaon" },
      { id: 536457, name: "Pandhargota" },
      { id: 536502, name: "Paoni" },
      { id: 536473, name: "Pardi" },
      { id: 536479, name: "Parsodi (Raja)" },
      { id: 536353, name: "Parsodi(Rithi) T.Sa.Kr.6" },
      { id: 536485, name: "Parsodi(Rithi)T.Sa.Kr.50" },
      { id: 944905, name: "Pauni(Punarvasit)" },
      { id: 536419, name: "Pavani" },
      { id: 536393, name: "Pilkapar(Rithi)" },
      { id: 944896, name: "Pimpari Munje - Gondpimpri - Dhamni (Punarvasit)" },
      { id: 536469, name: "Pipalgaon(Rithi)" },
      { id: 536322, name: "Pipari Munje" },
      { id: 536442, name: "Pipri" },
      { id: 536507, name: "Pohara" },
      { id: 536488, name: "Polsa" },
      { id: 536347, name: "Powari(Rithi)" },
      { id: 536429, name: "Pratappur(Rithi)" },
      { id: 536370, name: "Rajola" },
      { id: 536495, name: "Rajoli" },
      { id: 536390, name: "Rampuri(Rithi)" },
      { id: 536501, name: "Ranbodi" },
      { id: 536444, name: "Ratnapur" },
      { id: 536478, name: "Rengatur" },
      { id: 536360, name: "Ridhora" },
      { id: 536505, name: "Ruyal T.Sa.Kr.51" },
      { id: 536471, name: "Ruyal T.Sa.Kr.60" },
      { id: 536356, name: "Sagundhara(Rithi)" },
      { id: 536486, name: "Salai(Rithi)" },
      { id: 536382, name: "Salwa" },
      { id: 536345, name: "Sasegaon" },
      { id: 536464, name: "Satara" },
      { id: 536456, name: "Sawangi T.Sa.Kr.66" },
      { id: 536367, name: "Sawangi Tsa.Kr.58" },
      { id: 920753, name: "Sawangi(Punarvasit)" },
      { id: 536388, name: "Sawargaon" },
      { id: 536372, name: "Sawarkheda" },
      { id: 536391, name: "Sawli" },
      { id: 536445, name: "Shikarpur" },
      { id: 536340, name: "Shivani" },
      { id: 536412, name: "Shiwani(Rithi)" },
      { id: 536350, name: "Silli" },
      { id: 536472, name: "Siroli(Rithi)" },
      { id: 536452, name: "Sirsi" },
      { id: 943954, name: "Sirsi(Punarvasit)" },
      { id: 536454, name: "Sonarwahi" },
      { id: 536406, name: "Sonegaon T. Sa.Kr.52" },
      { id: 536359, name: "Sonegaon T.Sa.Kr.3 A" },
      { id: 536463, name: "Sonegaon T.Sa.Kr.65" },
      { id: 943952, name: "Sonegaon(Kukkadumari)" },
      { id: 536436, name: "Sonpuri" },
      { id: 536357, name: "Takli T. Sa.Kr.9" },
      { id: 536386, name: "Takli T.Sa.Kr.57 A" },
      { id: 536459, name: "Tamaswadi(Rithi)" },
      { id: 536483, name: "Tarna" },
      { id: 536332, name: "Tarni" },
      { id: 536448, name: "Taroli" },
      { id: 536504, name: "Tekepar" },
      { id: 536348, name: "Tembhari" },
      { id: 536491, name: "Thana" },
      { id: 536326, name: "Titur" },
      { id: 943635, name: "Tudaka(Punarvasit)" },
      { id: 536443, name: "Tudka" },
      { id: 536487, name: "Udeshwar(Rithi)" },
      { id: 536420, name: "Umari" },
      { id: 536377, name: "Umarpeth(Rithi)" },
      { id: 536482, name: "Virkhandi" },
      { id: 536466, name: "Wadegaon" },
      { id: 536337, name: "Wadegaon (Kale)" },
      { id: 536474, name: "Wag" },
      { id: 536489, name: "Wagdhara(Rithi)" },
      { id: 536492, name: "Welgaon" },
      { id: 536435, name: "Weltur" },
      { id: 536428, name: "Yedmepar (Rithi)" },
    ],
    4036: [
      { id: 536613, name: "Adyal" },
      { id: 944924, name: "Adyal(Punarvasit)" },
      { id: 536562, name: "Akalabodi" },
      { id: 536548, name: "Alesur" },
      { id: 536546, name: "Bellarpar" },
      { id: 536522, name: "Besur" },
      { id: 536623, name: "Bhagebori" },
      { id: 536540, name: "Bhagwanpur" },
      { id: 536530, name: "Bhivi" },
      { id: 536621, name: "Bhiwapur" },
      { id: 536600, name: "Bhowari" },
      { id: 536581, name: "Bhowari Rithi" },
      { id: 536627, name: "Bhumkolargata Rithi" },
      { id: 536573, name: "Bopeshwar Rithi" },
      { id: 536637, name: "Bordkala" },
      { id: 536638, name: "Bordkhurd Rithi" },
      { id: 536633, name: "Borgaon Rithi" },
      { id: 536513, name: "Botezari" },
      { id: 536551, name: "Chargaon" },
      { id: 536515, name: "Chargaon (Gotadi)" },
      { id: 536566, name: "Chichala" },
      { id: 536524, name: "Chikhalapar" },
      { id: 536629, name: "Chikhali" },
      { id: 536569, name: "Chikhali Rithi" },
      { id: 536579, name: "Chorvihira" },
      { id: 536547, name: "Dhamangaon (Gawali)" },
      { id: 536643, name: "Dhamangaon V." },
      { id: 536514, name: "Dhanjimet (Rithi)" },
      { id: 536606, name: "Dhaparla" },
      { id: 536582, name: "Dhaparla (Doye)" },
      { id: 536532, name: "Dharmapar Rithi" },
      { id: 536620, name: "Dongargaon" },
      { id: 536593, name: "Gadeghat" },
      { id: 944928, name: "Gadeghat-Ghatumari (Punarvasit)" },
      { id: 536564, name: "Gardapar" },
      { id: 536594, name: "Ghatumari" },
      { id: 536590, name: "Gohalli" },
      { id: 944927, name: "Gohdali-Nandikheda (Punarvasit)" },
      { id: 536605, name: "Gondbori" },
      { id: 536601, name: "Hatimunda Rithi" },
      { id: 536640, name: "Hattibodi" },
      { id: 536509, name: "Indapur" },
      { id: 536619, name: "Jambhurda" },
      { id: 536550, name: "Jamgaon Rithi" },
      { id: 536576, name: "Jawali" },
      { id: 536608, name: "Jawrabodi" },
      { id: 536554, name: "Kalandri Rithi" },
      { id: 536624, name: "Kanhalgaon Rithi" },
      { id: 536560, name: "Kargaon" },
      { id: 536552, name: "Kawadshi" },
      { id: 536511, name: "Keslapar" },
      { id: 536561, name: "Khairgaon" },
      { id: 536634, name: "Khairi" },
      { id: 536512, name: "Khandalzari" },
      { id: 536542, name: "Khapari" },
      { id: 536543, name: "Kharkada" },
      { id: 536529, name: "Kharkada (Rithi)" },
      { id: 536526, name: "Khatkheda" },
      { id: 536549, name: "Kholdoda" },
      { id: 536538, name: "Khursapar Rithi" },
      { id: 536607, name: "Kinhala" },
      { id: 536614, name: "Kinhikala" },
      { id: 536615, name: "Kinhikhurda" },
      { id: 536587, name: "Kitadi" },
      { id: 536585, name: "Kitadi Rithi" },
      { id: 944920, name: "Kitadi(Punarvasit)" },
      { id: 536612, name: "Kolari" },
      { id: 536518, name: "Kondapur Rithi" },
      { id: 536545, name: "Lonara" },
      { id: 536575, name: "Mahadapur" },
      { id: 536527, name: "Mahalgaon" },
      { id: 536517, name: "Malewada" },
      { id: 536508, name: "Mandwa" },
      { id: 536567, name: "Mandwa(Labhan)" },
      { id: 536625, name: "Mangli" },
      { id: 536553, name: "Mangrud" },
      { id: 536534, name: "Mankapur (Rithi)" },
      { id: 536557, name: "Manora" },
      { id: 536588, name: "Marupar" },
      { id: 944923, name: "Marupar(Punarvasit)" },
      { id: 536635, name: "Medha" },
      { id: 536610, name: "Mhashadongri" },
      { id: 536622, name: "Mokhala" },
      { id: 536598, name: "Mokhebardi" },
      { id: 944921, name: "Mokhebardi-Kinhikala-Kinhikhurd (Punarvasit)" },
      { id: 536642, name: "Murharpur" },
      { id: 536523, name: "Nad" },
      { id: 944926, name: "Nagataroli(Punarvasit)" },
      { id: 536617, name: "Nagtaroli" },
      { id: 536626, name: "Nakshi" },
      { id: 536535, name: "Nand" },
      { id: 536592, name: "Nandikheda" },
      { id: 536559, name: "Navegaon (Deshmukh)" },
      { id: 536618, name: "Neri" },
      { id: 944922, name: "Neri-Savargaon (Punarvasit)" },
      { id: 536565, name: "Pahami" },
      { id: 536641, name: "Pandharwani" },
      { id: 536533, name: "Panjarepar" },
      { id: 536591, name: "Panjarepar (Panyakhali)" },
      { id: 944918, name: "Panjarepar(Punarvasit)" },
      { id: 536628, name: "Parsodi" },
      { id: 536602, name: "Pawargaondi" },
      { id: 536556, name: "Pendharabodi" },
      { id: 536604, name: "Pendhari" },
      { id: 536611, name: "Pimpalgaon Rithi" },
      { id: 536570, name: "Piparda Rithi" },
      { id: 536521, name: "Pirawa" },
      { id: 536520, name: "Polgaon" },
      { id: 536586, name: "Pullar" },
      { id: 536584, name: "Ranmangli" },
      { id: 536631, name: "Rohana" },
      { id: 536541, name: "Sakara Rithi" },
      { id: 536589, name: "Salebhatti (Chor)" },
      { id: 536525, name: "Salebhatti (Dande)" },
      { id: 536580, name: "Salebhatti (Panyakhali)" },
      { id: 536597, name: "Saleshahari (Panyakhali)" },
      { id: 917394, name: "Saleshahari Salebhatti Pu" },
      { id: 536563, name: "Sarandi" },
      { id: 536616, name: "Sawargaon" },
      { id: 536537, name: "Saygaon" },
      { id: 536644, name: "Saygaon Rithi" },
      { id: 536571, name: "Seloti" },
      { id: 944919, name: "Shegaon(So)(Punarvasit)" },
      { id: 536510, name: "Shivanfal" },
      { id: 536555, name: "Shiwapur" },
      { id: 536568, name: "Somanala" },
      { id: 536599, name: "Somanala (Pullar)" },
      { id: 536630, name: "Sonegaon Rithi" },
      { id: 536577, name: "Sonepada Rithi" },
      { id: 536536, name: "Sukali" },
      { id: 536519, name: "Sukali(Rithi)" },
      { id: 536583, name: "Taka" },
      { id: 536609, name: "Tas" },
      { id: 536636, name: "Tatoli" },
      { id: 536596, name: "Thutanbori" },
      { id: 944925, name: "Thutanbori(Punarvasit)" },
      { id: 536539, name: "Tidkepar" },
      { id: 536595, name: "Tukumbori Rithi" },
      { id: 536578, name: "Ukhali" },
      { id: 536528, name: "Urkudapar" },
      { id: 536603, name: "Virkhandi" },
      { id: 536632, name: "Wadadha" },
      { id: 536574, name: "Wakeshwar" },
      { id: 536544, name: "Wani" },
      { id: 536572, name: "Wasi" },
      { id: 536558, name: "Welwa" },
      { id: 536516, name: "Yedsambha Rithi" },
      { id: 536531, name: "Zamkoli" },
      { id: 536639, name: "Zilbodi" },
    ],
    4037: [
      { id: 536765, name: "Agri" },
      { id: 536675, name: "Alesur" },
      { id: 536744, name: "Ambagad" },
      { id: 536688, name: "Asalpani" },
      { id: 536656, name: "Ashti" },
      { id: 536687, name: "Bagheda" },
      { id: 536653, name: "Bajartola" },
      { id: 536671, name: "Balapur (Hamesha)" },
      { id: 536779, name: "Bamhani" },
      { id: 536705, name: "Bapera" },
      { id: 536745, name: "Bapera (Ambagad)" },
      { id: 536751, name: "Bhondki" },
      { id: 536707, name: "Binakhi" },
      { id: 536717, name: "Borgaon" },
      { id: 536777, name: "Bori" },
      { id: 536708, name: "Brahmantola" },
      { id: 536654, name: "Chandmara" },
      { id: 536699, name: "Chandpur" },
      { id: 536786, name: "Chargaon" },
      { id: 536750, name: "Chicholi" },
      { id: 536793, name: "Chikhala" },
      { id: 536649, name: "Chikhali" },
      { id: 536715, name: "Chulardoh" },
      { id: 536720, name: "Chulhad" },
      { id: 536747, name: "Dawezari(Mitewani)" },
      { id: 536721, name: "Dawezari(Sihora)" },
      { id: 536651, name: "Deonara" },
      { id: 536714, name: "Deorideo" },
      { id: 536704, name: "Deosarra" },
      { id: 536784, name: "Dewhadi" },
      { id: 536694, name: "Dhamlewada" },
      { id: 536719, name: "Dhanegaon" },
      { id: 536787, name: "Dhorwada" },
      { id: 536659, name: "Dhutera" },
      { id: 536652, name: "Dongari Bu" },
      { id: 536774, name: "Dongarla" },
      { id: 536741, name: "Gaimukh" },
      { id: 536689, name: "Garakabhonga" },
      { id: 536686, name: "Garra" },
      { id: 536692, name: "Gobarwahi" },
      { id: 536712, name: "Gondekhari" },
      { id: 536682, name: "Gonditola" },
      { id: 536706, name: "Gonditola(Binakhi)" },
      { id: 536735, name: "Gowaritola" },
      { id: 536650, name: "Gowaritola(Dewanara)" },
      { id: 536695, name: "Gudhari Kh" },
      { id: 536746, name: "Hardoli (Ambagad)" },
      { id: 536767, name: "Hardoli (Sihora)" },
      { id: 536757, name: "Hasara" },
      { id: 536734, name: "Hattipangadi" },
      { id: 536754, name: "Hingana" },
      { id: 536665, name: "Hirapur Hamesha" },
      { id: 536691, name: "Jogiwada" },
      { id: 536645, name: "Kamkasur" },
      { id: 536768, name: "Karkapur" },
      { id: 536749, name: "Karli" },
      { id: 536660, name: "Kawalewada" },
      { id: 536773, name: "Khairlanji" },
      { id: 536696, name: "Khandad" },
      { id: 536709, name: "Khapa (Mohadi)" },
      { id: 536755, name: "Khapa (Tumsar)" },
      { id: 536676, name: "Khapa(Khurd)" },
      { id: 536792, name: "Kharabi" },
      { id: 536778, name: "Koshti" },
      { id: 536672, name: "Kurmuda" },
      { id: 536739, name: "Lanzera" },
      { id: 536678, name: "Lawada" },
      { id: 536673, name: "Laxmipur (Hamesha)" },
      { id: 536681, name: "Lendezari" },
      { id: 536655, name: "Lobhi" },
      { id: 536740, name: "Lohara" },
      { id: 536724, name: "Machchhera" },
      { id: 536785, name: "Madagi (Dewhadi)" },
      { id: 536703, name: "Mahalgaon" },
      { id: 536648, name: "Mandavi(Dhabale)" },
      { id: 536733, name: "Mandekasa" },
      { id: 536732, name: "Mandekasa (Hamesha)" },
      { id: 536789, name: "Mandhal" },
      { id: 536729, name: "Mandvi" },
      { id: 536756, name: "Mangali" },
      { id: 536711, name: "Mangali (Tudaka)" },
      { id: 536679, name: "Mangarli" },
      { id: 536758, name: "Mehegaon" },
      { id: 536664, name: "Mendipur" },
      { id: 536753, name: "Mitewani" },
      { id: 536701, name: "Mohadi Khapa" },
      { id: 536766, name: "Mohagaon (Khadan)" },
      { id: 536661, name: "Mohagaon Khurd" },
      { id: 536690, name: "Mothagaon" },
      { id: 536710, name: "Murali" },
      { id: 536657, name: "Nakadongari" },
      { id: 536775, name: "Navargaon" },
      { id: 536764, name: "Nawegaon" },
      { id: 536685, name: "Nilagondi(Hamesha)" },
      { id: 536763, name: "Pachara" },
      { id: 536684, name: "Pangadi" },
      { id: 536683, name: "Pangadi Hamesha" },
      { id: 536770, name: "Panjara" },
      { id: 536791, name: "Panjara(Devhadi)" },
      { id: 536730, name: "Paraswada(Devadi)" },
      { id: 536790, name: "Paraswada(Sihora)" },
      { id: 536658, name: "Pathari" },
      { id: 536670, name: "Paunarkhari" },
      { id: 536667, name: "Paunarkhari H." },
      { id: 536748, name: "Pawanara" },
      { id: 536727, name: "Pipari Chunni" },
      { id: 536736, name: "Pipariya" },
      { id: 536759, name: "Pipra" },
      { id: 536737, name: "Pitesur" },
      { id: 536666, name: "Rajapur" },
      { id: 536743, name: "Rampur Hamesha" },
      { id: 536731, name: "Ranera" },
      { id: 536769, name: "Rengepar" },
      { id: 536680, name: "Rongha" },
      { id: 536677, name: "Rongha Hamesha" },
      { id: 536722, name: "Rupera" },
      { id: 536752, name: "Sakhali" },
      { id: 536662, name: "Sakkardara" },
      { id: 536780, name: "Shiwani" },
      { id: 536723, name: "Sihora" },
      { id: 536725, name: "Silegaon" },
      { id: 536716, name: "Sindpuri" },
      { id: 536663, name: "Sirpur Hamesha" },
      { id: 536693, name: "Sitasawangi" },
      { id: 536647, name: "Sitekasa" },
      { id: 536772, name: "Sitepar" },
      { id: 536697, name: "Sodipur" },
      { id: 536698, name: "Sondya" },
      { id: 536718, name: "Sonegaon" },
      { id: 536742, name: "Sonpuri" },
      { id: 536738, name: "Sorna" },
      { id: 536782, name: "Stationtoli" },
      { id: 536788, name: "Sukali" },
      { id: 536713, name: "Sukali Nakul" },
      { id: 536668, name: "Sundartola" },
      { id: 536646, name: "Susurdoh" },
      { id: 944320, name: "Susurdoh(Pu)" },
      { id: 536771, name: "Tamaswadi" },
      { id: 536781, name: "Tamaswadi (Tudka)" },
      { id: 536700, name: "Temani" },
      { id: 536783, name: "Tudka" },
      { id: 943017, name: "Tumsar" },
      { id: 536776, name: "Umarwada" },
      { id: 536674, name: "Vitpur" },
      { id: 536726, name: "Wahani" },
      { id: 536728, name: "Wangi" },
      { id: 536702, name: "Warpindakepar" },
      { id: 536669, name: "Yedarbuchi" },
      { id: 536761, name: "Yerli" },
      { id: 536762, name: "Zanzeriya" },
      { id: 536760, name: "Zarli" },
    ],
    4038: [
      { id: 536818, name: "Akola" },
      { id: 536817, name: "Andhalgaon" },
      { id: 536796, name: "Bacchera" },
      { id: 536855, name: "Betala" },
      { id: 536830, name: "Bhikarkheda" },
      { id: 536864, name: "Bhosa" },
      { id: 536870, name: "Bidsitepar" },
      { id: 536800, name: "Bitekhari" },
      { id: 536900, name: "Bonde" },
      { id: 536810, name: "Bondri" },
      { id: 536896, name: "Borgaon" },
      { id: 536888, name: "Bori" },
      { id: 536859, name: "Boteshwar" },
      { id: 536867, name: "Bothali" },
      { id: 536798, name: "Bothali (Ritthi)" },
      { id: 536850, name: "Chichkheda" },
      { id: 536819, name: "Chicholi" },
      { id: 536861, name: "Chorkhamari" },
      { id: 536853, name: "Dahegaon" },
      { id: 536883, name: "Dawadipar (Kardi)" },
      { id: 536799, name: "Deulgaon" },
      { id: 536876, name: "Dewhada Buj." },
      { id: 536874, name: "Dewhada Kh." },
      { id: 536831, name: "Dharmapuri" },
      { id: 536897, name: "Dhiwarwada" },
      { id: 536806, name: "Dhop" },
      { id: 536812, name: "Dhusala" },
      { id: 536858, name: "Dokepar ( Ritthi )" },
      { id: 536898, name: "Dongardeo" },
      { id: 536832, name: "Dongargaon" },
      { id: 536869, name: "Ekalari" },
      { id: 536892, name: "Ekalzari (Ritthi)" },
      { id: 536838, name: "Eklara (Ritthi)" },
      { id: 536797, name: "Futala" },
      { id: 536854, name: "Ghatkuroda" },
      { id: 536811, name: "Ghorpad" },
      { id: 536846, name: "Hardoli" },
      { id: 536795, name: "Hivra" },
      { id: 536807, name: "Jamb" },
      { id: 536878, name: "Jambhalapani" },
      { id: 536889, name: "Jambhora" },
      { id: 536840, name: "Kalamna" },
      { id: 536808, name: "Kandri" },
      { id: 536843, name: "Kanhalgaon" },
      { id: 536887, name: "Kanhalgaon (Khadki)" },
      { id: 536884, name: "Kardi" },
      { id: 536826, name: "Kate Bamhani" },
      { id: 536822, name: "Kati" },
      { id: 536893, name: "Kesalwada" },
      { id: 536899, name: "Khadki" },
      { id: 536813, name: "Khairlanji" },
      { id: 536862, name: "Khamari Bk" },
      { id: 536852, name: "Khodgaon" },
      { id: 536848, name: "Khutsawari" },
      { id: 536890, name: "Kisanpur" },
      { id: 536836, name: "Kushari" },
      { id: 536891, name: "Lendezari" },
      { id: 536834, name: "Mahalgaon" },
      { id: 536816, name: "Malida" },
      { id: 536849, name: "Mandesar" },
      { id: 536872, name: "Mehuni (Ritthi)" },
      { id: 536839, name: "Mohadi" },
      { id: 536857, name: "Mohagaon (Devi)" },
      { id: 536880, name: "Mohgaon ( Buj )" },
      { id: 536842, name: "Morgaon" },
      { id: 536886, name: "Mundhari Buj" },
      { id: 536885, name: "Mundhari Kh" },
      { id: 536875, name: "Narsinhatola" },
      { id: 536794, name: "Navegaon (Dhu)" },
      { id: 536879, name: "Navegaon (Ritthi)" },
      { id: 536814, name: "Navegaon Bu." },
      { id: 536865, name: "Neri" },
      { id: 536805, name: "Nerla Ritthi" },
      { id: 536877, name: "Nilaj Bk" },
      { id: 536881, name: "Nilaj Kh" },
      { id: 536866, name: "Pachgaon" },
      { id: 536873, name: "Pahuni" },
      { id: 536804, name: "Paldongari" },
      { id: 536894, name: "Palora(Jambhora)" },
      { id: 536823, name: "Pandharabodi" },
      { id: 536809, name: "Panjara (Bori)" },
      { id: 536895, name: "Panjara (Bothali)" },
      { id: 536868, name: "Panjara (Gramdan)" },
      { id: 536841, name: "Pardi" },
      { id: 536833, name: "Pimpalgaon (Ka)" },
      { id: 536860, name: "Pimpalgaon(Zanzad)" },
      { id: 536851, name: "Rampur" },
      { id: 536837, name: "Roha" },
      { id: 536856, name: "Rohna" },
      { id: 536815, name: "Sakarla" },
      { id: 536827, name: "Salai Buj" },
      { id: 536803, name: "Salai Kh." },
      { id: 536821, name: "Salebardi" },
      { id: 536871, name: "Satona" },
      { id: 536820, name: "Shioni" },
      { id: 536802, name: "Sihari" },
      { id: 536844, name: "Sirsoli" },
      { id: 536847, name: "Sitepar" },
      { id: 536801, name: "Tadgaon" },
      { id: 536824, name: "Takala" },
      { id: 536863, name: "Takali" },
      { id: 536828, name: "Tanga" },
      { id: 536882, name: "Usaripar" },
      { id: 536825, name: "Usarra" },
      { id: 536845, name: "Vadegaon (Mo)" },
      { id: 536829, name: "Vihirgaon" },
      { id: 536835, name: "Wadegaon ( Si )" },
      { id: 536901, name: "Warthi" },
    ],
    4039: [
      { id: 536985, name: "Ajani Hamesha" },
      { id: 536960, name: "Ajimabad" },
      { id: 536964, name: "Ambadi" },
      { id: 537052, name: "Ambadi (R)" },
      { id: 536997, name: "Amgaon" },
      { id: 536986, name: "Anjani (R)" },
      { id: 537036, name: "Arjuni" },
      { id: 944316, name: "Arjuni(Pu)" },
      { id: 536917, name: "Ashoknagar" },
      { id: 537031, name: "Basora" },
      { id: 537070, name: "Bela" },
      { id: 536966, name: "Belgaon" },
      { id: 537009, name: "Belgaon (R)" },
      { id: 536992, name: "Berodi" },
      { id: 944312, name: "Berodi(Pu)" },
      { id: 943062, name: "Bhandara(N.P.)" },
      { id: 943063, name: "Bhandara(Nazul)" },
      { id: 536994, name: "Bhilewada" },
      { id: 536950, name: "Bhojapur" },
      { id: 537034, name: "Borgaon Bk." },
      { id: 917389, name: "Borgaon Bu Pun" },
      { id: 537045, name: "Borgaon Kh." },
      { id: 537026, name: "Chandori" },
      { id: 536972, name: "Chandrapur" },
      { id: 536928, name: "Chicholi" },
      { id: 537053, name: "Chikhal Pahela" },
      { id: 537018, name: "Chikhalabodi" },
      { id: 536902, name: "Chikhali" },
      { id: 537017, name: "Chikhali Hamesha" },
      { id: 537003, name: "Chintapur" },
      { id: 537041, name: "Chowa" },
      { id: 536945, name: "Dabha" },
      { id: 536919, name: "Dawadipar" },
      { id: 537022, name: "Dawadipar Bajar" },
      { id: 537007, name: "Dawwa" },
      { id: 537006, name: "Dhargaon" },
      { id: 537004, name: "Dighori" },
      { id: 536988, name: "Dodmazari" },
      { id: 537062, name: "Dongargaon" },
      { id: 536973, name: "Dudhara" },
      { id: 537071, name: "Ganeshpur" },
      { id: 537008, name: "Ganglewada" },
      { id: 537033, name: "Garada Bk." },
      { id: 537001, name: "Garada Jangli" },
      { id: 537021, name: "Garada Kh." },
      { id: 536954, name: "Girola" },
      { id: 537063, name: "Golewadi" },
      { id: 536904, name: "Gopiwada" },
      { id: 536912, name: "Gunjepar" },
      { id: 537015, name: "Gunthara" },
      { id: 536962, name: "Hansapur" },
      { id: 536906, name: "Hattidohi" },
      { id: 536941, name: "Indurkha" },
      { id: 536975, name: "Injewada" },
      { id: 537058, name: "Itgaon" },
      { id: 944309, name: "Itgaon(Pu)" },
      { id: 537037, name: "Jakh" },
      { id: 536914, name: "Jakh Saja Kr. 9" },
      { id: 537056, name: "Jamgaon" },
      { id: 944318, name: "Jamgaon Wadad(Pu)" },
      { id: 536946, name: "Jamni" },
      { id: 917390, name: "Juni Takli Punar" },
      { id: 537000, name: "Kakada Gondi" },
      { id: 537010, name: "Kanhalmoh" },
      { id: 536993, name: "Karachkheda" },
      { id: 536953, name: "Kardha" },
      { id: 536920, name: "Kawadshi" },
      { id: 537002, name: "Kawalewada" },
      { id: 536948, name: "Kesalwada" },
      { id: 536942, name: "Khairi" },
      { id: 536932, name: "Khairi (D)" },
      { id: 944317, name: "Khairi(Pu)" },
      { id: 536936, name: "Khairlanji" },
      { id: 536979, name: "Khamari" },
      { id: 536944, name: "Khambata" },
      { id: 536957, name: "Khapa" },
      { id: 537030, name: "Khapa (Jangal)" },
      { id: 536923, name: "Kharadi" },
      { id: 536903, name: "Kharbi" },
      { id: 912364, name: "Khokarla" },
      { id: 537039, name: "Kholapur" },
      { id: 537014, name: "Khurshipar" },
      { id: 536909, name: "Khurshipar (Tave)" },
      { id: 943030, name: "Khutsavari" },
      { id: 536968, name: "Kitadi" },
      { id: 537059, name: "Kitali (Mandavi)" },
      { id: 537047, name: "Kodamendhi (R)" },
      { id: 537011, name: "Kodamoh" },
      { id: 536999, name: "Kodurli" },
      { id: 536970, name: "Koka" },
      { id: 537027, name: "Koknagad" },
      { id: 536925, name: "Kondhi" },
      { id: 536958, name: "Korambhi" },
      { id: 536943, name: "Kothurna" },
      { id: 536940, name: "Laweshwar" },
      { id: 537061, name: "Lendezari (R)" },
      { id: 536927, name: "Lohara" },
      { id: 537051, name: "Madgi" },
      { id: 537028, name: "Mahaka" },
      { id: 537019, name: "Makar-Dhokda" },
      { id: 917391, name: "Makardhokda Pu" },
      { id: 537029, name: "Malipar" },
      { id: 536977, name: "Mandangaon" },
      { id: 536967, name: "Mandwi" },
      { id: 537020, name: "Manegaon Ba" },
      { id: 536915, name: "Maregaon" },
      { id: 537025, name: "Mathadi" },
      { id: 536998, name: "Matimeta" },
      { id: 536981, name: "Matora" },
      { id: 537038, name: "Maudi" },
      { id: 944319, name: "Maudi(Pu)" },
      { id: 537032, name: "Mendha" },
      { id: 536908, name: "Mohadura" },
      { id: 536916, name: "Mujabi" },
      { id: 536921, name: "Nandora" },
      { id: 536969, name: "Navegaon" },
      { id: 536913, name: "Navegaon (Koka)" },
      { id: 537013, name: "Navegaon (R)" },
      { id: 537040, name: "Nawargaon" },
      { id: 536991, name: "Nerodi" },
      { id: 537055, name: "Nimgaon" },
      { id: 537023, name: "Pachkhedi" },
      { id: 537060, name: "Pagora" },
      { id: 537054, name: "Pahela" },
      { id: 536995, name: "Paladi" },
      { id: 537024, name: "Palgaon" },
      { id: 536931, name: "Pandhi" },
      { id: 536935, name: "Pandrabodi" },
      { id: 536922, name: "Parsodi" },
      { id: 536926, name: "Pevtha" },
      { id: 537050, name: "Pimpalgaon" },
      { id: 536952, name: "Pindkepar" },
      { id: 536951, name: "Pindkepar(Rithi)" },
      { id: 943031, name: "Pingalai" },
      { id: 536934, name: "Pipari" },
      { id: 944310, name: "Pipari(Pu)" },
      { id: 537067, name: "Purkabodi" },
      { id: 536910, name: "Raini (R)" },
      { id: 536987, name: "Rajdoh" },
      { id: 536924, name: "Rajedahegaon" },
      { id: 537016, name: "Rajegaon" },
      { id: 537046, name: "Rawanwadi" },
      { id: 536907, name: "Rohana Kh." },
      { id: 536929, name: "Sahuli" },
      { id: 536955, name: "Salebardi" },
      { id: 536930, name: "Salebardi T. Sa. Kr. 17" },
      { id: 536982, name: "Salehatti" },
      { id: 536983, name: "Salehetti (Hamesha)" },
      { id: 536933, name: "Sangam" },
      { id: 944311, name: "Sangam(Pu)" },
      { id: 536974, name: "Sarpewada" },
      { id: 536938, name: "Sawargaon (R)" },
      { id: 537049, name: "Sawari" },
      { id: 537069, name: "Shahapur" },
      { id: 537064, name: "Shingori (R)" },
      { id: 536937, name: "Shirsi" },
      { id: 537043, name: "Shrinagar" },
      { id: 536963, name: "Silli" },
      { id: 537005, name: "Singori" },
      { id: 536956, name: "Sirasghat" },
      { id: 920755, name: "Sirasghat(Punarvasit)" },
      { id: 536905, name: "Sitepar" },
      { id: 536976, name: "Sitepar Saja Kr.19" },
      { id: 537065, name: "Sonegaon" },
      { id: 536971, name: "Sonkund" },
      { id: 536939, name: "Sonuli" },
      { id: 536980, name: "Surewada" },
      { id: 944313, name: "Surewada(Pu)" },
      { id: 536947, name: "Takali" },
      { id: 536911, name: "Tawepar" },
      { id: 537048, name: "Tekepar (Hamesha)" },
      { id: 536989, name: "Tekepar (Ko)" },
      { id: 536996, name: "Tekepar Dodamazari" },
      { id: 536959, name: "Tekepar T.Saa.Kr.27" },
      { id: 944314, name: "Tekepar(Ko.Pu.)" },
      { id: 537068, name: "Thana" },
      { id: 537035, name: "Tiddi" },
      { id: 536918, name: "Umari" },
      { id: 536990, name: "Usaragondi" },
      { id: 537042, name: "Usaripar" },
      { id: 537057, name: "Wadad" },
      { id: 536965, name: "Wadegaon R" },
      { id: 536978, name: "Wadipar" },
      { id: 537012, name: "Waghbodi" },
      { id: 537044, name: "Wakeshwar" },
      { id: 536984, name: "Yetewahi" },
      { id: 537066, name: "Yetewahi(Rithi)" },
      { id: 536961, name: "Zabada" },
    ],
    4040: [
      { id: 537110, name: "Alebedar" },
      { id: 537090, name: "Amgaon Bk." },
      { id: 537091, name: "Amgaon Kh." },
      { id: 537082, name: "Ategaon" },
      { id: 537126, name: "Bamhani" },
      { id: 537089, name: "Bampewada" },
      { id: 537138, name: "Baradkinhi" },
      { id: 537106, name: "Bodra" },
      { id: 537155, name: "Bolde" },
      { id: 537140, name: "Bonde" },
      { id: 537100, name: "Borgaon" },
      { id: 537073, name: "Bundalghat Vi." },
      { id: 537083, name: "Chandori" },
      { id: 537132, name: "Chargaon" },
      { id: 537115, name: "Chichgaon" },
      { id: 537124, name: "Dharmapuri" },
      { id: 537092, name: "Dongargaon Ri." },
      { id: 537123, name: "Gadkumbhali" },
      { id: 537080, name: "Ghanod" },
      { id: 537079, name: "Gidalpar" },
      { id: 537139, name: "Girola" },
      { id: 537081, name: "Girola Ri." },
      { id: 537145, name: "Gondumari" },
      { id: 537104, name: "Gudhari" },
      { id: 537118, name: "Jamanapur" },
      { id: 537108, name: "Jambhali" },
      { id: 537077, name: "Jambhali S." },
      { id: 537161, name: "Katangdhara" },
      { id: 537158, name: "Kesalwada" },
      { id: 537099, name: "Khairi" },
      { id: 537117, name: "Khairlanji" },
      { id: 537093, name: "Khamba" },
      { id: 537148, name: "Khandala" },
      { id: 537103, name: "Kinhi" },
      { id: 537112, name: "Kinhi 1" },
      { id: 537137, name: "Kitadi" },
      { id: 537129, name: "Kumbhali" },
      { id: 537130, name: "Lawari" },
      { id: 537143, name: "Mahalgaon" },
      { id: 537107, name: "Makardhokada Ri." },
      { id: 537086, name: "Makkitola" },
      { id: 537094, name: "Malutola" },
      { id: 537125, name: "Mohgata" },
      { id: 537128, name: "Mohghata (Raiyyatwari)" },
      { id: 537114, name: "Mokhe" },
      { id: 537127, name: "Mundipar S." },
      { id: 537074, name: "Navegaon Ri." },
      { id: 537144, name: "Nilaj" },
      { id: 537088, name: "Nipiyartola Ri." },
      { id: 537150, name: "Nyaharwani" },
      { id: 537146, name: "Palasgaon" },
      { id: 537087, name: "Palaspani" },
      { id: 537076, name: "Pangadi Vi." },
      { id: 537156, name: "Papada Bk." },
      { id: 537153, name: "Papada Kh." },
      { id: 537101, name: "Parastola" },
      { id: 537134, name: "Parsodi" },
      { id: 537119, name: "Pathari" },
      { id: 537109, name: "Pindkepar" },
      { id: 537078, name: "Pitezari" },
      { id: 537095, name: "Rengepar" },
      { id: 537147, name: "Sakara" },
      { id: 537168, name: "Sakoli" },
      { id: 537157, name: "Salai Bk." },
      { id: 537159, name: "Salai(Kh)" },
      { id: 537164, name: "Salebardi" },
      { id: 537166, name: "Sangadi(Krushik)" },
      { id: 537160, name: "Sangaon" },
      { id: 537116, name: "Sarati" },
      { id: 537162, name: "Sasara" },
      { id: 537096, name: "Satalwada" },
      { id: 537136, name: "Sawarbandh" },
      { id: 537131, name: "Sawargaon Ri." },
      { id: 537122, name: "Sendurwafa" },
      { id: 537167, name: "Siregaontola" },
      { id: 537113, name: "Sitepar" },
      { id: 537151, name: "Sivanibandh" },
      { id: 537084, name: "Sonegaon" },
      { id: 537105, name: "Sonpuri" },
      { id: 537142, name: "Sukali" },
      { id: 537133, name: "Sundari" },
      { id: 537111, name: "Tudmapuri" },
      { id: 537121, name: "Ukara" },
      { id: 537135, name: "Umari" },
      { id: 537075, name: "Umarzari" },
      { id: 537085, name: "Usgaon" },
      { id: 537163, name: "Vihirgaon Bu." },
      { id: 537141, name: "Wadad" },
      { id: 537097, name: "Wadegaon" },
      { id: 537098, name: "Walmazari" },
      { id: 537154, name: "Wangi" },
      { id: 537149, name: "Watetekar" },
      { id: 537120, name: "Wirshi" },
      { id: 537165, name: "Yedgaon" },
      { id: 537102, name: "Yekodi" },
      { id: 537152, name: "Zadgaon" },
    ],
    4041: [
      { id: 537188, name: "Alesur (Bandrazari)" },
      { id: 537237, name: "Alesur (Lakhori)" },
      { id: 537245, name: "Bandrazari" },
      { id: 537230, name: "Bhugaon" },
      { id: 537178, name: "Borgaon" },
      { id: 537196, name: "Channa" },
      { id: 537212, name: "Chichtola" },
      { id: 537174, name: "Chikhalbodi" },
      { id: 537175, name: "Daitmangli" },
      { id: 537256, name: "Deori (Hemesha)" },
      { id: 537258, name: "Devhadi" },
      { id: 537217, name: "Dhabetekadi" },
      { id: 537199, name: "Dhanala" },
      { id: 537260, name: "Dhwarkheda" },
      { id: 537225, name: "Dighori (Nanhori )" },
      { id: 537228, name: "Dongargaon (Sa)" },
      { id: 537223, name: "Dongargaon(Nya)" },
      { id: 537192, name: "Gadegaon" },
      { id: 537215, name: "Gadpendhari" },
      { id: 537194, name: "Garada" },
      { id: 537251, name: "Ghodezari" },
      { id: 537241, name: "Gondegaon" },
      { id: 537262, name: "Gondi" },
      { id: 537173, name: "Gondsawari" },
      { id: 537242, name: "Gurdha" },
      { id: 537240, name: "Isapur" },
      { id: 537249, name: "Jewanala" },
      { id: 537224, name: "Kaneri" },
      { id: 537226, name: "Kanhalgaon" },
      { id: 537253, name: "Kawadsi" },
      { id: 537264, name: "Kawalewada" },
      { id: 537171, name: "Kesalwada (Pawar)" },
      { id: 537239, name: "Kesalwada (Ra)" },
      { id: 537193, name: "Kesalwada (Wagh )" },
      { id: 537209, name: "Khairi (Bamhani )" },
      { id: 537252, name: "Khairi (Kawdasi )" },
      { id: 537266, name: "Kharashi" },
      { id: 537181, name: "Khedepar" },
      { id: 537267, name: "Khunari" },
      { id: 537202, name: "Khurshipar (Kesalwada )" },
      { id: 537170, name: "Khurshipar (Malkazari )" },
      { id: 537184, name: "Kinhi (Gadegaon)" },
      { id: 537257, name: "Kitadi" },
      { id: 537234, name: "Kolara" },
      { id: 537233, name: "Kolari" },
      { id: 537190, name: "Lakhani" },
      { id: 537187, name: "Lakhori" },
      { id: 537268, name: "Lohara" },
      { id: 537243, name: "Macharna" },
      { id: 537200, name: "Malkazari" },
      { id: 537189, name: "Manegaon" },
      { id: 537244, name: "Mangali" },
      { id: 537271, name: "Maregaon" },
      { id: 537179, name: "Masalmeta" },
      { id: 537231, name: "Mendha ( Bhugaon)" },
      { id: 537198, name: "Mendha (Pohara)" },
      { id: 537182, name: "Mendha (Somalwada)" },
      { id: 537263, name: "Mengapur" },
      { id: 537219, name: "Miregaon" },
      { id: 537222, name: "Mogara" },
      { id: 537206, name: "Morgaon" },
      { id: 537204, name: "Mundipar" },
      { id: 537247, name: "Murmadi" },
      { id: 537248, name: "Murmadi (Hamesha)" },
      { id: 537272, name: "Murmadi (Sawari)" },
      { id: 537227, name: "Murmadi (Tup)" },
      { id: 537221, name: "Nanhori" },
      { id: 537269, name: "Narva" },
      { id: 537205, name: "Nilagondi" },
      { id: 537250, name: "Nimgaon" },
      { id: 537254, name: "Pahadi" },
      { id: 537265, name: "Palandur (Chou )" },
      { id: 537236, name: "Palasgaon" },
      { id: 537218, name: "Pardi" },
      { id: 537172, name: "Parsodi" },
      { id: 537270, name: "Pathari" },
      { id: 537169, name: "Pauldawana" },
      { id: 537214, name: "Pendhari" },
      { id: 537210, name: "Pimpalgaon" },
      { id: 537213, name: "Pohara" },
      { id: 537201, name: "Purkabodi" },
      { id: 537207, name: "Rajegaon" },
      { id: 537261, name: "Rajoli" },
      { id: 537220, name: "Rampuri" },
      { id: 537211, name: "Rengepar (Kohali)" },
      { id: 537176, name: "Rengepar (Kotha)" },
      { id: 537238, name: "Rengola" },
      { id: 537246, name: "Saigaon" },
      { id: 537177, name: "Salebhata" },
      { id: 537208, name: "Samewada" },
      { id: 537255, name: "Sangaon" },
      { id: 537191, name: "Sawari" },
      { id: 537197, name: "Seloti" },
      { id: 537216, name: "Shiwani" },
      { id: 537203, name: "Sindipar" },
      { id: 537180, name: "Singori" },
      { id: 537195, name: "Sipewada" },
      { id: 537185, name: "Somalwada" },
      { id: 537183, name: "Sonekhari" },
      { id: 537229, name: "Sonmala" },
      { id: 537235, name: "Vihirgaon" },
      { id: 537259, name: "Wakal" },
      { id: 537186, name: "Yetewahi" },
      { id: 537232, name: "Zarap" },
    ],
    4042: [
      { id: 537376, name: "Aawalgaon" },
      { id: 537285, name: "Adyal" },
      { id: 537312, name: "Akot" },
      { id: 537333, name: "Ambadi" },
      { id: 537402, name: "Amgaon (Adarsh)" },
      { id: 537407, name: "Asgaon" },
      { id: 537344, name: "Asgaon(Rithi)" },
      { id: 537320, name: "Atri" },
      { id: 537348, name: "Bachewadi" },
      { id: 537380, name: "Belghata" },
      { id: 537379, name: "Betala" },
      { id: 537322, name: "Bhawad" },
      { id: 537339, name: "Bhendara" },
      { id: 537277, name: "Bhikarminsi" },
      { id: 537303, name: "Bhivkhidki" },
      { id: 537415, name: "Bhojapur" },
      { id: 537406, name: "Bhuyar" },
      { id: 537352, name: "Borgaon" },
      { id: 537319, name: "Borgaon (Khambadi)" },
      { id: 537328, name: "Brahmani" },
      { id: 537347, name: "Brahmi" },
      { id: 537296, name: "Chakara" },
      { id: 537381, name: "Chandakapur" },
      { id: 537427, name: "Chandi" },
      { id: 537428, name: "Channewada" },
      { id: 537295, name: "Chichal" },
      { id: 537297, name: "Chichbodi" },
      { id: 537368, name: "Chichgaon" },
      { id: 537372, name: "Chichkheda" },
      { id: 944327, name: "Chichkheda(Pu)" },
      { id: 912539, name: "Chikhali" },
      { id: 537398, name: "Dhakundi" },
      { id: 537375, name: "Dhamangaon" },
      { id: 537349, name: "Dhamani" },
      { id: 537413, name: "Dhanori" },
      { id: 537321, name: "Fanoli" },
      { id: 537369, name: "Gaidongari" },
      { id: 537387, name: "Garadapur" },
      { id: 537292, name: "Gose Bk." },
      { id: 537293, name: "Gose Kh." },
      { id: 537416, name: "Gudegaon" },
      { id: 537356, name: "Isapur" },
      { id: 537327, name: "Itgaon" },
      { id: 537394, name: "Jogikheda" },
      { id: 537374, name: "Jogikheda (Hamesha)" },
      { id: 537342, name: "Junona" },
      { id: 537386, name: "Kachekhani" },
      { id: 537399, name: "Kakepar" },
      { id: 537275, name: "Kalewada" },
      { id: 537284, name: "Kamkazari" },
      { id: 537423, name: "Kanhalgaon" },
      { id: 537309, name: "Katurli" },
      { id: 537370, name: "Kawadsi (Parsodi)" },
      { id: 537305, name: "Kesalapuri" },
      { id: 537302, name: "Kesalwada" },
      { id: 537341, name: "Khairi (Diwan)" },
      { id: 537332, name: "Khairi (Telota)" },
      { id: 537283, name: "Khairi (Tirri)" },
      { id: 537365, name: "Khaksi" },
      { id: 537317, name: "Khambadi" },
      { id: 537403, name: "Khapari (Bhuyar)" },
      { id: 537361, name: "Khapari (Korambhi)" },
      { id: 537288, name: "Khapari (Saundad)" },
      { id: 537417, name: "Khatkheda" },
      { id: 537422, name: "Khokari Dhorap" },
      { id: 537425, name: "Kisanpur (Hamesha)" },
      { id: 537318, name: "Kodurli" },
      { id: 537382, name: "Kodurli(Khambadi)" },
      { id: 537324, name: "Kondha" },
      { id: 537364, name: "Korambhi" },
      { id: 537367, name: "Kosambodi" },
      { id: 537314, name: "Kosara" },
      { id: 537393, name: "Kotalpar" },
      { id: 537326, name: "Kurza" },
      { id: 537351, name: "Lawadi" },
      { id: 537389, name: "Lohara" },
      { id: 537325, name: "Lonhara" },
      { id: 537360, name: "Mahalgaon" },
      { id: 537291, name: "Malchi" },
      { id: 944322, name: "Malchi(Pu)" },
      { id: 537412, name: "Mandavgota" },
      { id: 537355, name: "Mangali" },
      { id: 537294, name: "Mendha" },
      { id: 944325, name: "Mendha(Pu)" },
      { id: 537400, name: "Mendhegaon" },
      { id: 537278, name: "Minsi" },
      { id: 537350, name: "Mohari" },
      { id: 537340, name: "Mokhara" },
      { id: 537362, name: "Mujbi" },
      { id: 537371, name: "Murmadi" },
      { id: 537366, name: "Nagangaon" },
      { id: 537378, name: "Naigaon" },
      { id: 537420, name: "Nandikheda" },
      { id: 537334, name: "Navegaon (Brahmi)" },
      { id: 537274, name: "Nerala" },
      { id: 537298, name: "Nevegaon Alias Palepar" },
      { id: 537346, name: "Nighavi" },
      { id: 537396, name: "Nilaj (Amgaon)" },
      { id: 537377, name: "Nimgaon" },
      { id: 537313, name: "Nirgudi" },
      { id: 537391, name: "Nishti" },
      { id: 537373, name: "Pahungaon" },
      { id: 537329, name: "Palora (Chauras)" },
      { id: 537401, name: "Panjarepar" },
      { id: 537276, name: "Pannasi" },
      { id: 537359, name: "Parsodi" },
      { id: 537289, name: "Pathari" },
      { id: 944323, name: "Pathari(Pu)" },
      { id: 537358, name: "Pauna Bk." },
      { id: 537354, name: "Pauna Kh." },
      { id: 943021, name: "Pauni(M.Ci.)" },
      { id: 537290, name: "Pendhari" },
      { id: 537310, name: "Pilandri" },
      { id: 537316, name: "Pimpalgaon" },
      { id: 537424, name: "Pradhan (Dhorap)" },
      { id: 537390, name: "Rajkota" },
      { id: 537345, name: "Ranala" },
      { id: 537395, name: "Ranala Alias Annapurna" },
      { id: 537281, name: "Rengepar (Rithi)" },
      { id: 537383, name: "Rewani" },
      { id: 537410, name: "Rohana" },
      { id: 537335, name: "Ruyad" },
      { id: 537392, name: "Salebhatti" },
      { id: 537301, name: "Salewada" },
      { id: 912537, name: "Saundad" },
      { id: 944329, name: "Saundad Khapari(Pu)" },
      { id: 537419, name: "Savarla" },
      { id: 537273, name: "Sawargaon" },
      { id: 537384, name: "Selari" },
      { id: 537330, name: "Sendri Bk." },
      { id: 537323, name: "Sendri Kh." },
      { id: 537280, name: "Shegaon" },
      { id: 537421, name: "Sheli Somnala" },
      { id: 537343, name: "Shivnala" },
      { id: 537426, name: "Shivnala (Gondi)" },
      { id: 537414, name: "Sindhi" },
      { id: 537336, name: "Sindpuri" },
      { id: 537408, name: "Singori (Hamesha)" },
      { id: 537409, name: "Singori (Wahi)" },
      { id: 537411, name: "Sirsala" },
      { id: 537315, name: "Somanala Bk." },
      { id: 537308, name: "Somanala Kh." },
      { id: 912538, name: "Sonegaon" },
      { id: 537286, name: "Surbodi" },
      { id: 537282, name: "Tambekhani" },
      { id: 537397, name: "Tekadi" },
      { id: 537304, name: "Telpendhari" },
      { id: 537363, name: "Thana" },
      { id: 537331, name: "Thana(Navegav)" },
      { id: 537404, name: "Thanegaon" },
      { id: 537279, name: "Tirri" },
      { id: 537357, name: "Umari" },
      { id: 537306, name: "Umari (Adyal)" },
      { id: 537418, name: "Vilam" },
      { id: 537307, name: "Virali (Khandar)" },
      { id: 537338, name: "Wadegaon" },
      { id: 537388, name: "Wahi" },
      { id: 537405, name: "Waigaon" },
      { id: 537353, name: "Walani" },
      { id: 537311, name: "Wasela" },
      { id: 537385, name: "Welwa" },
      { id: 537337, name: "Yenoda" },
    ],
    4043: [
      { id: 537492, name: "Antargaon (Raiyyat Wari)" },
      { id: 537494, name: "Antergaon" },
      { id: 537504, name: "Asola" },
      { id: 537496, name: "Athali" },
      { id: 537514, name: "Awali" },
      { id: 537475, name: "Barwha" },
      { id: 537437, name: "Belati" },
      { id: 537490, name: "Bhagadi" },
      { id: 537478, name: "Borgaon" },
      { id: 537442, name: "Bothali" },
      { id: 537509, name: "Chaprad" },
      { id: 537476, name: "Chichal" },
      { id: 537499, name: "Chichgaon" },
      { id: 537491, name: "Chicholi" },
      { id: 537469, name: "Chikna" },
      { id: 537486, name: "Dahegaon" },
      { id: 537489, name: "Dandegaon" },
      { id: 537477, name: "Dharmapuri" },
      { id: 537448, name: "Dholsar" },
      { id: 537472, name: "Dighori (Mothi)" },
      { id: 537457, name: "Dokesarandi" },
      { id: 537463, name: "Donad" },
      { id: 537466, name: "Gawarala" },
      { id: 537447, name: "Ghartoda" },
      { id: 537434, name: "Ghodezari" },
      { id: 537443, name: "Gunjepar" },
      { id: 537432, name: "Hardoli" },
      { id: 537510, name: "Indora" },
      { id: 537455, name: "Itan" },
      { id: 537468, name: "Jaitpur" },
      { id: 537501, name: "Kanhalgaon" },
      { id: 537456, name: "Karandla" },
      { id: 537512, name: "Keshori (Raiyyatwari)" },
      { id: 537511, name: "Keshori Kh." },
      { id: 537445, name: "Khairi (Ghar)" },
      { id: 537507, name: "Khairi (Pat)" },
      { id: 537479, name: "Khairi (Raiyyatwari)" },
      { id: 537464, name: "Khairna" },
      { id: 537467, name: "Kholmara" },
      { id: 537503, name: "Kinhala" },
      { id: 537444, name: "Kinhi" },
      { id: 537461, name: "Kirmati" },
      { id: 537488, name: "Kocchi" },
      { id: 537480, name: "Kodamedi (Rai)" },
      { id: 537474, name: "Kodamedi(Kha)" },
      { id: 537436, name: "Kondhala" },
      { id: 537459, name: "Kudegaon" },
      { id: 537497, name: "Lakhandur" },
      { id: 537502, name: "Madeghat" },
      { id: 537473, name: "Malada" },
      { id: 537505, name: "Manded" },
      { id: 537450, name: "Mandhal" },
      { id: 537487, name: "Manegaon" },
      { id: 537446, name: "Masal" },
      { id: 537508, name: "Mendha" },
      { id: 537465, name: "Moharna" },
      { id: 537484, name: "Murmadi" },
      { id: 537483, name: "Murza" },
      { id: 537462, name: "Nanded" },
      { id: 537451, name: "Opara" },
      { id: 537435, name: "Pachgaon" },
      { id: 537458, name: "Pahungaon" },
      { id: 537429, name: "Palependhari" },
      { id: 537481, name: "Pardi" },
      { id: 537441, name: "Parsodi" },
      { id: 537495, name: "Parsodi(Nag)" },
      { id: 537438, name: "Pauldawana" },
      { id: 537431, name: "Pendhari" },
      { id: 537498, name: "Pimpalgaon[Ko]" },
      { id: 537485, name: "Piparwani" },
      { id: 537500, name: "Puyar" },
      { id: 537452, name: "Rajani" },
      { id: 537460, name: "Rohani" },
      { id: 537471, name: "Sakhara" },
      { id: 537449, name: "Sarandi (Bu)" },
      { id: 537506, name: "Sawargaon" },
      { id: 537493, name: "Silli" },
      { id: 537433, name: "Sonegaon" },
      { id: 537513, name: "Soni" },
      { id: 537440, name: "Tai Kh." },
      { id: 537439, name: "Tai[Buj]" },
      { id: 537470, name: "Tawasi" },
      { id: 537516, name: "Tembhari" },
      { id: 537430, name: "Tirkhuri" },
      { id: 537515, name: "Vihirgaon" },
      { id: 943026, name: "Virali(Dambi)" },
      { id: 537453, name: "Virali[Buj]" },
      { id: 537454, name: "Virali[Khurd]" },
      { id: 537482, name: "Zari" },
    ],
    4044: [
      { id: 537624, name: "Alezari" },
      { id: 537640, name: "Arabkasa" },
      { id: 537520, name: "Arjuni" },
      { id: 537523, name: "Atri" },
      { id: 537530, name: "Bagholi" },
      { id: 537622, name: "Balapur" },
      { id: 537554, name: "Barbaspura" },
      { id: 537589, name: "Baywada" },
      { id: 537547, name: "Belati Bk" },
      { id: 944829, name: "Belati Khurd" },
      { id: 537625, name: "Berdipar" },
      { id: 537542, name: "Berdipar(Kache)" },
      { id: 537630, name: "Bhajepar" },
      { id: 537578, name: "Bhambodi" },
      { id: 537560, name: "Bhiwapur" },
      { id: 537540, name: "Bhuratola" },
      { id: 537528, name: "Bihiriya" },
      { id: 537570, name: "Biroli" },
      { id: 537611, name: "Birsi" },
      { id: 537533, name: "Boda" },
      { id: 537619, name: "Bodalkasa" },
      { id: 537521, name: "Bondarani" },
      { id: 537612, name: "Bopesar" },
      { id: 537531, name: "Bora" },
      { id: 537628, name: "Borgaon" },
      { id: 537604, name: "Budhewada" },
      { id: 537579, name: "Chandori Bk" },
      { id: 537527, name: "Chandori Kh." },
      { id: 537559, name: "Chikhali" },
      { id: 537550, name: "Chirekhani" },
      { id: 537638, name: "Chorkhamara" },
      { id: 537556, name: "Churadi" },
      { id: 537536, name: "Dabbetola" },
      { id: 537572, name: "Dhadari" },
      { id: 537564, name: "Dhadhari" },
      { id: 537616, name: "Dongargaon" },
      { id: 537588, name: "Gangla" },
      { id: 537557, name: "Garada" },
      { id: 537580, name: "Ghatkuroda" },
      { id: 537582, name: "Ghogara" },
      { id: 537568, name: "Ghoti" },
      { id: 537524, name: "Gond Mohadi" },
      { id: 537566, name: "Govindtola" },
      { id: 537553, name: "Gumadhawada" },
      { id: 537529, name: "Indora Br." },
      { id: 537561, name: "Indora Kh" },
      { id: 537585, name: "Isapur" },
      { id: 537541, name: "Jamuniya" },
      { id: 537636, name: "Kachekhani" },
      { id: 537543, name: "Kachewani" },
      { id: 537637, name: "Kamakazari" },
      { id: 537537, name: "Karti Bk." },
      { id: 537538, name: "Karti Kh." },
      { id: 537546, name: "Kawalewada" },
      { id: 537594, name: "Kesalwada" },
      { id: 537618, name: "Khadaki" },
      { id: 537551, name: "Khairbodi" },
      { id: 537601, name: "Khairi" },
      { id: 537526, name: "Khairlanji" },
      { id: 537617, name: "Khamari" },
      { id: 537606, name: "Khedepar" },
      { id: 537586, name: "Khodgaon" },
      { id: 537590, name: "Khopada" },
      { id: 537576, name: "Khurkhudi" },
      { id: 537626, name: "Khurshipar" },
      { id: 537522, name: "Kindgipar" },
      { id: 537633, name: "Kodelohara" },
      { id: 537569, name: "Kodobari" },
      { id: 537623, name: "Kovesar" },
      { id: 537634, name: "Koylari" },
      { id: 537608, name: "Kulpa" },
      { id: 537613, name: "Lakhegaon" },
      { id: 537595, name: "Ledada" },
      { id: 537610, name: "Lonara" },
      { id: 537639, name: "Malakazari" },
      { id: 537597, name: "Malhi" },
      { id: 537558, name: "Malpuri" },
      { id: 537549, name: "Mandawi" },
      { id: 537567, name: "Mangezari" },
      { id: 537593, name: "Manora" },
      { id: 537544, name: "Marartola" },
      { id: 537609, name: "Mardagondi" },
      { id: 537631, name: "Maregaon" },
      { id: 537614, name: "Mendha" },
      { id: 537555, name: "Mendipur" },
      { id: 537583, name: "Mundikota" },
      { id: 537548, name: "Mundipar" },
      { id: 537602, name: "Murmadi" },
      { id: 537599, name: "Murpar" },
      { id: 537535, name: "Nahartola" },
      { id: 537635, name: "Nandalpar" },
      { id: 537552, name: "Nandnagar" },
      { id: 537587, name: "Nawargaon" },
      { id: 537592, name: "Nawegaon Kh" },
      { id: 537603, name: "Nawezari" },
      { id: 537598, name: "Nilagondi" },
      { id: 537563, name: "Nimgaon" },
      { id: 537539, name: "Paldongari" },
      { id: 537584, name: "Panjara" },
      { id: 537525, name: "Paraswada" },
      { id: 537581, name: "Patiltola" },
      { id: 537620, name: "Pindkepar" },
      { id: 537518, name: "Pipariya" },
      { id: 537545, name: "Pujaritola" },
      { id: 537565, name: "Rustampur" },
      { id: 537571, name: "Salebardi" },
      { id: 537575, name: "Sarandi" },
      { id: 537632, name: "Sarra" },
      { id: 537627, name: "Satona" },
      { id: 537519, name: "Sawara" },
      { id: 537534, name: "Sejagaon" },
      { id: 537600, name: "Selotpar" },
      { id: 537596, name: "Silli" },
      { id: 537607, name: "Sitepar" },
      { id: 537532, name: "Sonegaon" },
      { id: 537605, name: "Sonekhari" },
      { id: 537577, name: "Sonoli" },
      { id: 537621, name: "Sukali" },
      { id: 537615, name: "Thanegaon" },
      { id: 943065, name: "Tiroda" },
      { id: 537573, name: "Umari" },
      { id: 537574, name: "Vihirgaon" },
      { id: 537629, name: "Wadegaon" },
      { id: 537562, name: "Wadhona" },
      { id: 537591, name: "Yedamakot" },
    ],
    4045: [
      { id: 537714, name: "Akotola" },
      { id: 537688, name: "Alebedar" },
      { id: 537696, name: "Ambetalao" },
      { id: 537668, name: "Asalpani" },
      { id: 537694, name: "Babai" },
      { id: 537667, name: "Bagadbandh" },
      { id: 537664, name: "Bagholi" },
      { id: 537716, name: "Bajartola" },
      { id: 537717, name: "Bamhani" },
      { id: 537692, name: "Bhadanga" },
      { id: 537687, name: "Bolunda" },
      { id: 537658, name: "Borgaon" },
      { id: 537677, name: "Bote" },
      { id: 537698, name: "Chanditola" },
      { id: 537725, name: "Changotola" },
      { id: 537661, name: "Chichgaon" },
      { id: 537660, name: "Chichgaontola" },
      { id: 537733, name: "Chichtola" },
      { id: 537695, name: "Chilhati" },
      { id: 537720, name: "Chopa" },
      { id: 537647, name: "Dawdipar" },
      { id: 537643, name: "Dawwa" },
      { id: 537691, name: "Deutola" },
      { id: 537654, name: "Dhanutola" },
      { id: 537659, name: "Dongarutola" },
      { id: 537680, name: "Gahelatola" },
      { id: 537650, name: "Gankhaira" },
      { id: 537708, name: "Garada" },
      { id: 537681, name: "Ghoti" },
      { id: 537713, name: "Ghumarra" },
      { id: 537701, name: "Gidhadi" },
      { id: 537656, name: "Girola(Rithi)" },
      { id: 537642, name: "Gondekhari" },
      { id: 537675, name: "Goregaon" },
      { id: 537731, name: "Gowaritola" },
      { id: 537728, name: "Halbitola Tedha" },
      { id: 537736, name: "Halbitola(Nimba)" },
      { id: 537726, name: "Hausitola" },
      { id: 537686, name: "Hirapur" },
      { id: 537699, name: "Hiratola" },
      { id: 537649, name: "Hirdamali" },
      { id: 537653, name: "Isatola" },
      { id: 537711, name: "Jambhulpani" },
      { id: 537697, name: "Kalimati" },
      { id: 537705, name: "Kalpathari" },
      { id: 537693, name: "Kamargaon" },
      { id: 537715, name: "Kanhartola Chopa" },
      { id: 537719, name: "Kanhartola(Chango)" },
      { id: 537673, name: "Katangi" },
      { id: 537702, name: "Kawaditola" },
      { id: 537652, name: "Kawalewada" },
      { id: 537671, name: "Khadipar" },
      { id: 537670, name: "Khadipartola" },
      { id: 537700, name: "Khosetola" },
      { id: 537672, name: "Kurhadi" },
      { id: 537641, name: "Lendezari" },
      { id: 537684, name: "Malpuri" },
      { id: 537674, name: "Menghatola" },
      { id: 537689, name: "Mhasgaon" },
      { id: 537703, name: "Mohadi" },
      { id: 537645, name: "Mohgaon Bk.(Dhundatola)" },
      { id: 537724, name: "Mohgaon(Tilli)" },
      { id: 537704, name: "Mundharitola" },
      { id: 537707, name: "Mundipar" },
      { id: 537712, name: "Murdoli" },
      { id: 537666, name: "Nawargaon" },
      { id: 537735, name: "Nimba" },
      { id: 537679, name: "Nonitola" },
      { id: 537706, name: "Palewada" },
      { id: 537721, name: "Palkheda" },
      { id: 537738, name: "Pangadi(Rithi)" },
      { id: 537734, name: "Pathantola" },
      { id: 537682, name: "Pathari" },
      { id: 537709, name: "Pindkepar" },
      { id: 537732, name: "Pipartola" },
      { id: 537662, name: "Purgaon" },
      { id: 537685, name: "Ramatola" },
      { id: 537739, name: "Rengepar(Rithi)" },
      { id: 537683, name: "Saitola" },
      { id: 537690, name: "Salangtola" },
      { id: 537648, name: "Sarvatola" },
      { id: 537651, name: "Satwa" },
      { id: 537655, name: "Shaharwani" },
      { id: 537663, name: "Silegaon" },
      { id: 537710, name: "Sodalagondi" },
      { id: 537723, name: "Sonartola" },
      { id: 537657, name: "Sonegaon" },
      { id: 537678, name: "Soni" },
      { id: 537665, name: "Sukhpur" },
      { id: 537727, name: "Tedha" },
      { id: 537722, name: "Telankhedi" },
      { id: 537730, name: "Tilli" },
      { id: 537669, name: "Timezari" },
      { id: 537644, name: "Tumkheda Bk." },
      { id: 537718, name: "Tumsar" },
      { id: 537737, name: "Zaliya(Rithi)" },
      { id: 537676, name: "Zanjiya" },
    ],
    4046: [
      { id: 537855, name: "Adasi" },
      { id: 537814, name: "Ambhora" },
      { id: 537832, name: "Arjuni" },
      { id: 537835, name: "Asoli" },
      { id: 537796, name: "Bagholi" },
      { id: 537752, name: "Bajartola" },
      { id: 537770, name: "Balamatola" },
      { id: 537791, name: "Banathar" },
      { id: 537816, name: "Barbaspura" },
      { id: 537833, name: "Batana" },
      { id: 537831, name: "Bhadutola" },
      { id: 537749, name: "Bhadyatola" },
      { id: 537785, name: "Bhagwattola" },
      { id: 537865, name: "Bhanpur" },
      { id: 537742, name: "Bijaitola" },
      { id: 537768, name: "Birsi -12" },
      { id: 537829, name: "Birsi -37" },
      { id: 537748, name: "Birsola" },
      { id: 537756, name: "Brahmantola" },
      { id: 537811, name: "Chandanitola" },
      { id: 537790, name: "Changera" },
      { id: 537802, name: "Chargaon" },
      { id: 537823, name: "Chhipiya" },
      { id: 537822, name: "Chiramantola" },
      { id: 537818, name: "Chulod" },
      { id: 537842, name: "Chutiya" },
      { id: 537744, name: "Dagotola" },
      { id: 537878, name: "Dandegaon" },
      { id: 537758, name: "Dangorli" },
      { id: 537761, name: "Dasgaon Bk." },
      { id: 537760, name: "Dasgaon Kh." },
      { id: 537852, name: "Datora" },
      { id: 537861, name: "Dawaniwada" },
      { id: 537772, name: "Deori" },
      { id: 537741, name: "Deutola" },
      { id: 537840, name: "Dhakni" },
      { id: 537877, name: "Dhamanewada" },
      { id: 537789, name: "Dhamangaon" },
      { id: 537860, name: "Dhapewada" },
      { id: 537869, name: "Dongargaon" },
      { id: 537875, name: "Ekodi" },
      { id: 537868, name: "Fattepur" },
      { id: 537889, name: "Fulchur" },
      { id: 537884, name: "Gangazari" },
      { id: 537798, name: "Garra Bk." },
      { id: 537799, name: "Garra Kh." },
      { id: 537806, name: "Ghiwari" },
      { id: 537766, name: "Girola" },
      { id: 944827, name: "Gondia(Buj)" },
      { id: 944828, name: "Gondia(Khurd)" },
      { id: 537800, name: "Gonditola -21" },
      { id: 537807, name: "Gonditola -23" },
      { id: 537854, name: "Gudama" },
      { id: 537813, name: "Halbitola - 22" },
      { id: 537851, name: "Halbitola -31" },
      { id: 537784, name: "Hiwara" },
      { id: 537837, name: "Irri" },
      { id: 537781, name: "Jabbar Tola" },
      { id: 537788, name: "Jagantola" },
      { id: 537863, name: "Jartal" },
      { id: 537750, name: "Jirutola" },
      { id: 537886, name: "Junewani" },
      { id: 537797, name: "Kalar Tola" },
      { id: 537828, name: "Kamtha" },
      { id: 537778, name: "Kanhartola -10" },
      { id: 537754, name: "Kanhartola -16" },
      { id: 537849, name: "Karanja" },
      { id: 537743, name: "Karutola" },
      { id: 537747, name: "Kasa" },
      { id: 537888, name: "Katangi Kala" },
      { id: 537810, name: "Katangtola -24" },
      { id: 537824, name: "Katangtola -39" },
      { id: 537753, name: "Kati" },
      { id: 537873, name: "Khalbanda" },
      { id: 537890, name: "Khamari" },
      { id: 537882, name: "Kharra" },
      { id: 537871, name: "Khatitola" },
      { id: 537830, name: "Khatiya" },
      { id: 537881, name: "Kidangipar" },
      { id: 537759, name: "Kinhi" },
      { id: 537793, name: "Kochewahi" },
      { id: 537864, name: "Kohka" },
      { id: 537786, name: "Korani" },
      { id: 537887, name: "Kudwa" },
      { id: 537779, name: "Lahitola" },
      { id: 537826, name: "Lambatola" },
      { id: 537841, name: "Lodhitola -07" },
      { id: 537804, name: "Lodhitola -22" },
      { id: 537805, name: "Lodhitola -23" },
      { id: 537859, name: "Lodhitola -27" },
      { id: 537777, name: "Lohara" },
      { id: 537858, name: "Mahalgaon" },
      { id: 537880, name: "Majitpur" },
      { id: 537762, name: "Makadi" },
      { id: 537755, name: "Marartola -16" },
      { id: 537794, name: "Marartola -19" },
      { id: 537820, name: "Mogarra" },
      { id: 537853, name: "Morwahi" },
      { id: 537867, name: "Mundipar -08" },
      { id: 537834, name: "Mundipar -36" },
      { id: 537857, name: "Murdada" },
      { id: 537801, name: "Murpar" },
      { id: 537815, name: "Nagra" },
      { id: 537839, name: "Nangpura Murri" },
      { id: 537836, name: "Navargaon Kala" },
      { id: 537808, name: "Nawa Tola" },
      { id: 537838, name: "Nawargaon Kh." },
      { id: 537773, name: "Nawegaon -11" },
      { id: 537809, name: "Nawegaon -23" },
      { id: 537776, name: "Nila Gondi" },
      { id: 537765, name: "Nilaj" },
      { id: 537780, name: "Pandharabodi" },
      { id: 537843, name: "Pangadi" },
      { id: 537827, name: "Panjara" },
      { id: 537821, name: "Paraswada" },
      { id: 537870, name: "Pardibandh" },
      { id: 537846, name: "Pindkepar" },
      { id: 537740, name: "Pipartola -07" },
      { id: 537767, name: "Pipartola -14" },
      { id: 537774, name: "Polatola" },
      { id: 537745, name: "Powaritola" },
      { id: 537746, name: "Pujaritola" },
      { id: 537769, name: "Raipur" },
      { id: 537795, name: "Rajegaon" },
      { id: 537876, name: "Rampuri" },
      { id: 537844, name: "Rapewada" },
      { id: 537782, name: "Ratnara" },
      { id: 537803, name: "Rawanwadi" },
      { id: 537874, name: "Sahespur" },
      { id: 537783, name: "Sai Tola" },
      { id: 537885, name: "Sangrampur" },
      { id: 537787, name: "Satona" },
      { id: 537812, name: "Sawari" },
      { id: 537866, name: "Sejgaon" },
      { id: 537764, name: "Seoni" },
      { id: 537751, name: "Serkatola" },
      { id: 537819, name: "Sirpur" },
      { id: 537771, name: "Sonbihri" },
      { id: 537775, name: "Sonpuri" },
      { id: 537856, name: "Tanda" },
      { id: 537757, name: "Tedwa" },
      { id: 537817, name: "Temni" },
      { id: 537879, name: "Tikayatpur" },
      { id: 537850, name: "Tumkheda Kh." },
      { id: 537763, name: "Umari" },
      { id: 537792, name: "Wadegaon" },
      { id: 537862, name: "Walad" },
      { id: 537872, name: "Zadutola" },
      { id: 537825, name: "Zilmili" },
    ],
    4047: [
      { id: 537972, name: "Amgaon" },
      { id: 537961, name: "Anjora" },
      { id: 537953, name: "Asoli" },
      { id: 537967, name: "Bagheda" },
      { id: 537947, name: "Bamhani" },
      { id: 537933, name: "Bangaon" },
      { id: 537893, name: "Baniyatola" },
      { id: 537907, name: "Banjaritola" },
      { id: 537916, name: "Basipar" },
      { id: 537922, name: "Bhajiyapar" },
      { id: 537960, name: "Bhalitola" },
      { id: 537898, name: "Bhosa" },
      { id: 537941, name: "Birsi" },
      { id: 537896, name: "Boda" },
      { id: 537959, name: "Borkanhar" },
      { id: 537931, name: "Bothali" },
      { id: 537891, name: "Buraditola" },
      { id: 537945, name: "Chichtola" },
      { id: 537966, name: "Chimantola" },
      { id: 537917, name: "Chirchalbandh" },
      { id: 537927, name: "Dahegaon" },
      { id: 537918, name: "Dhamangaon" },
      { id: 537938, name: "Dhawaditola" },
      { id: 537950, name: "Dhobitola" },
      { id: 537915, name: "Dongargaon" },
      { id: 537954, name: "Fukkimeta" },
      { id: 537894, name: "Ghattemani" },
      { id: 537895, name: "Girola" },
      { id: 537937, name: "Gortha" },
      { id: 537913, name: "Gosaitola" },
      { id: 537955, name: "Jambhurtola" },
      { id: 537939, name: "Jamkhari" },
      { id: 537925, name: "Jawari" },
      { id: 537906, name: "Kalimati" },
      { id: 537897, name: "Karanji" },
      { id: 537968, name: "Katangtola" },
      { id: 537914, name: "Kattipar" },
      { id: 537903, name: "Katurli" },
      { id: 537970, name: "Kawadi" },
      { id: 537926, name: "Khurshipar" },
      { id: 537892, name: "Khurshipartola" },
      { id: 537921, name: "Kikaripar" },
      { id: 537932, name: "Kindgipar." },
      { id: 537965, name: "Kopitola" },
      { id: 537952, name: "Kosamtola" },
      { id: 537942, name: "Kumbhartoli" },
      { id: 537935, name: "Maharitola" },
      { id: 537951, name: "Makkitola" },
      { id: 537936, name: "Malhi" },
      { id: 537928, name: "Manegaon" },
      { id: 537901, name: "Manekasa" },
      { id: 537912, name: "Marartola" },
      { id: 537902, name: "Mohgaon" },
      { id: 537909, name: "Mundipar" },
      { id: 537940, name: "Nagtola" },
      { id: 537908, name: "Nangpura" },
      { id: 537910, name: "Nansari" },
      { id: 537920, name: "Navegaon" },
      { id: 537943, name: "Padampur" },
      { id: 537971, name: "Pangaon" },
      { id: 537948, name: "Pauldawana" },
      { id: 537957, name: "Pipartola Sa No 17 Asoli" },
      { id: 537946, name: "Pipartola Sa No 21sawangi" },
      { id: 537962, name: "Ramatola" },
      { id: 537919, name: "Ramjitola" },
      { id: 537973, name: "Risama" },
      { id: 537934, name: "Sambhutola" },
      { id: 537911, name: "Sarkartola" },
      { id: 537944, name: "Sawangi" },
      { id: 537924, name: "Shioni" },
      { id: 537923, name: "Shiontola" },
      { id: 537904, name: "Sitepar" },
      { id: 537963, name: "Sonekhari" },
      { id: 537905, name: "Suplipar" },
      { id: 537949, name: "Surkuda" },
      { id: 537899, name: "Takari" },
      { id: 537900, name: "Tekari" },
      { id: 537930, name: "Thana" },
      { id: 537929, name: "Thanatola" },
      { id: 537956, name: "Tigaon" },
      { id: 537958, name: "Waghdongari" },
      { id: 537969, name: "Walad" },
      { id: 537964, name: "Yermada" },
    ],
    4048: [
      { id: 538065, name: "Amgaon Kh." },
      { id: 537987, name: "Asaitola" },
      { id: 538006, name: "Bakalsarra" },
      { id: 537994, name: "Bamhani" },
      { id: 538039, name: "Banjari" },
      { id: 538046, name: "Bhadipar" },
      { id: 538027, name: "Bhajepar" },
      { id: 537977, name: "Bhajiyadand" },
      { id: 538026, name: "Bhansula" },
      { id: 538060, name: "Bijepar" },
      { id: 538010, name: "Binzali" },
      { id: 538028, name: "Bodalbodi" },
      { id: 538009, name: "Bramhantola" },
      { id: 538052, name: "Chandsuraj" },
      { id: 538035, name: "Daldalkuhi" },
      { id: 538018, name: "Dandhari" },
      { id: 538013, name: "Darbada" },
      { id: 538040, name: "Darrekasa" },
      { id: 538041, name: "Dhanegaon" },
      { id: 538012, name: "Dhanoli" },
      { id: 538033, name: "Dhansuwa" },
      { id: 538037, name: "Diwatisur" },
      { id: 538062, name: "Domatola" },
      { id: 537978, name: "Durgutola" },
      { id: 538005, name: "Gallatola" },
      { id: 537976, name: "Gandhitola" },
      { id: 538021, name: "Gendurzariya" },
      { id: 538011, name: "Ghonsi" },
      { id: 538029, name: "Girola" },
      { id: 537983, name: "Gonditola" },
      { id: 538044, name: "Gorre" },
      { id: 538032, name: "Halbitola T Sa Kr.10" },
      { id: 538059, name: "Halbitola T Sa Kr.14" },
      { id: 538049, name: "Hetitola" },
      { id: 538031, name: "Isanatola" },
      { id: 538042, name: "Jamakudo" },
      { id: 538023, name: "Jambhali" },
      { id: 538036, name: "Kachargad" },
      { id: 537981, name: "Kadotitola" },
      { id: 538007, name: "Kahali" },
      { id: 538017, name: "Kamakazari" },
      { id: 538048, name: "Karutola" },
      { id: 537999, name: "Kawarabandh" },
      { id: 537991, name: "Khedepar" },
      { id: 538014, name: "Kholgad" },
      { id: 538054, name: "Kopalgad" },
      { id: 538043, name: "Kosamtarra" },
      { id: 537986, name: "Kotjambhora" },
      { id: 538058, name: "Kotra" },
      { id: 538064, name: "Kularbhatti" },
      { id: 537990, name: "Kumbhartola" },
      { id: 537996, name: "Kunbitola" },
      { id: 538050, name: "Labhandharni" },
      { id: 537995, name: "Latori" },
      { id: 538056, name: "Lohara" },
      { id: 537980, name: "Makkatola" },
      { id: 538055, name: "Managad" },
      { id: 538063, name: "Maramjob" },
      { id: 538051, name: "Markakhanda" },
      { id: 537998, name: "Mohatola" },
      { id: 537984, name: "Mokasitola" },
      { id: 538000, name: "Mundipar" },
      { id: 538019, name: "Murkudoh" },
      { id: 538025, name: "Nanwha" },
      { id: 537988, name: "Navegaon" },
      { id: 538034, name: "Nawatola" },
      { id: 538016, name: "Nimba" },
      { id: 537992, name: "Pandhari" },
      { id: 538061, name: "Pandharwani" },
      { id: 538008, name: "Pangaon" },
      { id: 537989, name: "Pathantola" },
      { id: 537993, name: "Pathari" },
      { id: 538002, name: "Pauldauna" },
      { id: 538004, name: "Pipariya" },
      { id: 537985, name: "Powaritola" },
      { id: 538003, name: "Ramatola" },
      { id: 538015, name: "Rondha" },
      { id: 537982, name: "Sakaritola" },
      { id: 537974, name: "Sakharitola" },
      { id: 537975, name: "Salaitola" },
      { id: 538047, name: "Salangtola" },
      { id: 538024, name: "Salekasa" },
      { id: 537979, name: "Satgaon" },
      { id: 538057, name: "Sherpar" },
      { id: 538022, name: "Sirmalkasa" },
      { id: 538030, name: "Sonartola" },
      { id: 538001, name: "Sonpuri" },
      { id: 538020, name: "Tahkazari" },
      { id: 538045, name: "Tirkhedi" },
      { id: 538038, name: "Toyagondi" },
      { id: 538053, name: "Vicharpur" },
      { id: 537997, name: "Zaliya" },
    ],
    4049: [
      { id: 538154, name: "Baki" },
      { id: 538156, name: "Bamhani" },
      { id: 538095, name: "Bamhani (Sawangi)" },
      { id: 538123, name: "Baudhnagar" },
      { id: 538097, name: "Bhadutola" },
      { id: 538106, name: "Bhusaritola" },
      { id: 538088, name: "Birhi" },
      { id: 538070, name: "Bolunda" },
      { id: 538092, name: "Bopabodi" },
      { id: 538121, name: "Bothali" },
      { id: 538074, name: "Chichtola" },
      { id: 538153, name: "Chikhali" },
      { id: 538169, name: "Chingi" },
      { id: 538118, name: "Chirchadi" },
      { id: 538144, name: "Dalli" },
      { id: 538116, name: "Dawwa" },
      { id: 538149, name: "Dewapayli" },
      { id: 538071, name: "Dhanori" },
      { id: 538108, name: "Dodke" },
      { id: 538157, name: "Dongargaon" },
      { id: 538126, name: "Dongargaon (Khajari)" },
      { id: 538142, name: "Duggipar" },
      { id: 538113, name: "Dunda" },
      { id: 538093, name: "Futala" },
      { id: 538091, name: "Ghatbori (Ko)" },
      { id: 538124, name: "Ghatbori (Te.)" },
      { id: 538076, name: "Ghategaon" },
      { id: 538081, name: "Ghoti" },
      { id: 538084, name: "Girola" },
      { id: 538104, name: "Gongle" },
      { id: 538110, name: "Gopaltoli" },
      { id: 538102, name: "Halbitola" },
      { id: 538079, name: "Heti" },
      { id: 538109, name: "Jambhali" },
      { id: 538166, name: "Kaneri" },
      { id: 538133, name: "Kanharpayli" },
      { id: 538134, name: "Katalwahi(Rithi)" },
      { id: 538171, name: "Kawalewada" },
      { id: 538131, name: "Kesalwada" },
      { id: 538105, name: "Khadipar" },
      { id: 538160, name: "Khadki" },
      { id: 538085, name: "Khairi" },
      { id: 538083, name: "Khairi Hamesha" },
      { id: 538120, name: "Khajari" },
      { id: 538168, name: "Khoba" },
      { id: 538086, name: "Khodshivani" },
      { id: 538158, name: "Khurshipar" },
      { id: 538128, name: "Kodamedi" },
      { id: 538136, name: "Kohalipar" },
      { id: 538152, name: "Kohalitola" },
      { id: 538119, name: "Kohalitola (Aadarsh)" },
      { id: 538141, name: "Kohmara" },
      { id: 538170, name: "Kokana Gosai" },
      { id: 538167, name: "Kokana J." },
      { id: 538151, name: "Kolargaon" },
      { id: 538150, name: "Kosabi" },
      { id: 538164, name: "Kosamghat" },
      { id: 538073, name: "Kosamtondi" },
      { id: 538145, name: "Koylari" },
      { id: 538067, name: "Lendezari" },
      { id: 538089, name: "Mahuli" },
      { id: 538072, name: "Malijunga" },
      { id: 538161, name: "Manditola" },
      { id: 538165, name: "Maneri" },
      { id: 538066, name: "Mangezari(Rithi)" },
      { id: 538117, name: "Maramjob(Rithi)" },
      { id: 538163, name: "Mendki" },
      { id: 538122, name: "Mhaswani" },
      { id: 538155, name: "Mogarra" },
      { id: 538138, name: "Mohgata" },
      { id: 538075, name: "Mundipar (Ishwar)" },
      { id: 538087, name: "Mundipar (Sindipar)" },
      { id: 538068, name: "Murpar (Le)" },
      { id: 538112, name: "Murpar (Ram)" },
      { id: 538143, name: "Nainpur" },
      { id: 538173, name: "Nishani (Rithi)" },
      { id: 538111, name: "Palasgaon" },
      { id: 538096, name: "Palasgaon(Raka)" },
      { id: 538103, name: "Pandhari" },
      { id: 538135, name: "Pandharwani" },
      { id: 538140, name: "Pandharwani (Shenda)" },
      { id: 538125, name: "Parsodi" },
      { id: 538107, name: "Patekurra" },
      { id: 538082, name: "Pindakepar Rithi" },
      { id: 538100, name: "Pipri" },
      { id: 538146, name: "Pradhantola" },
      { id: 538078, name: "Purkabodi(Rithi)" },
      { id: 538147, name: "Putli" },
      { id: 538162, name: "Rajguda" },
      { id: 538099, name: "Raka" },
      { id: 538101, name: "Rengepar" },
      { id: 538132, name: "Rengepar (Dalli)" },
      { id: 538130, name: "Sadakarjuni" },
      { id: 538159, name: "Sahakepar" },
      { id: 538148, name: "Saledharani" },
      { id: 538098, name: "Saundad" },
      { id: 538094, name: "Sawangi" },
      { id: 538137, name: "Shenda" },
      { id: 538114, name: "Shivantola" },
      { id: 538090, name: "Sindipar" },
      { id: 538115, name: "Sitepar" },
      { id: 538077, name: "Temani" },
      { id: 538069, name: "Thadezari" },
      { id: 538080, name: "Thadezari (Rithi)" },
      { id: 538129, name: "Tidka" },
      { id: 538139, name: "Ushikheda" },
      { id: 538127, name: "Wadegaon" },
      { id: 538172, name: "Zankar Gondi" },
    ],
    4050: [
      { id: 538255, name: "Ambhora" },
      { id: 538284, name: "Arattondi T.Sa. Kra. 10" },
      { id: 538321, name: "Arattondi T.Sa. Kra.20" },
      { id: 538257, name: "Arattondi T.Sa. Kra.24" },
      { id: 538290, name: "Arjuni" },
      { id: 538324, name: "Arunnagar" },
      { id: 538323, name: "Asoli" },
      { id: 538179, name: "Bakati" },
      { id: 538199, name: "Barabhati" },
      { id: 538190, name: "Bhagi (Rithi)" },
      { id: 538266, name: "Bharnoli" },
      { id: 538181, name: "Bhiwakhidki" },
      { id: 538188, name: "Bhursitola" },
      { id: 538189, name: "Bidtola" },
      { id: 538294, name: "Bodade" },
      { id: 538282, name: "Bodra" },
      { id: 538201, name: "Bolade" },
      { id: 538273, name: "Bondgaon Devi" },
      { id: 538234, name: "Bondgaon Sur" },
      { id: 538330, name: "Bori" },
      { id: 538203, name: "Bortekadi (Rithi)" },
      { id: 538191, name: "Bortola" },
      { id: 538301, name: "Budhewada" },
      { id: 538231, name: "Butai (Rithi )" },
      { id: 538178, name: "Channa" },
      { id: 538276, name: "Chapti" },
      { id: 538240, name: "Chicholi" },
      { id: 538208, name: "Chutiya" },
      { id: 538285, name: "Dabhana" },
      { id: 538281, name: "Deulgaon T.Sa. Kra. 12" },
      { id: 538195, name: "Dewalgaon T.Sa. Kra.6" },
      { id: 538295, name: "Dhabetekadi Aadarsh" },
      { id: 538215, name: "Dhabetekadi T.Sa. Kra. 27" },
      { id: 538256, name: "Dhamditola" },
      { id: 538239, name: "Dinkarnagar" },
      { id: 538299, name: "Doma (Rithi)" },
      { id: 538304, name: "Dongargaon ( Rithi )" },
      { id: 538268, name: "Dongargaon T.Sa. Kra.13" },
      { id: 538244, name: "Dongargaon T.Sa. Kra.32" },
      { id: 538197, name: "Dongargaon T.Sa. Kra.6" },
      { id: 538235, name: "Gandhari" },
      { id: 538180, name: "Gangezari" },
      { id: 538252, name: "Gardanpur" },
      { id: 538253, name: "Gawarra" },
      { id: 538311, name: "Ghatipalasagaon" },
      { id: 538269, name: "Ghusobatola" },
      { id: 538228, name: "Gothangaon" },
      { id: 538325, name: "Gournagar" },
      { id: 538174, name: "Gudhari" },
      { id: 538261, name: "Ilda" },
      { id: 538274, name: "Inzori" },
      { id: 538312, name: "Isapur" },
      { id: 538308, name: "Itakheda" },
      { id: 538219, name: "Jabbarkheda" },
      { id: 538236, name: "Jambhali T.Sa. Kra.26" },
      { id: 538207, name: "Jambhali T.Sa. Kra.27" },
      { id: 538260, name: "Jambhali T.Sa. Kra.33" },
      { id: 538319, name: "Janawa" },
      { id: 538238, name: "Jarugata" },
      { id: 538259, name: "Junevani" },
      { id: 538233, name: "Kadholi" },
      { id: 538204, name: "Kalimati(Rithi)" },
      { id: 538247, name: "Kaneri" },
      { id: 538302, name: "Kanhalgaon (Rithi)" },
      { id: 538309, name: "Kanhalgaon T.Sa. Kra.17" },
      { id: 538262, name: "Kanhalgaon T.Sa. Kra.34" },
      { id: 538218, name: "Kanholi" },
      { id: 538293, name: "Karadgaon" },
      { id: 538242, name: "Karandali" },
      { id: 538331, name: "Katgaon (Rithi)" },
      { id: 538202, name: "Kawatha" },
      { id: 538246, name: "Kelwad" },
      { id: 538251, name: "Keshori" },
      { id: 538265, name: "Khadki" },
      { id: 538287, name: "Khairi" },
      { id: 538275, name: "Khambi" },
      { id: 538313, name: "Khamkhura" },
      { id: 538241, name: "Khokari" },
      { id: 538332, name: "Kholda" },
      { id: 538186, name: "Kholi" },
      { id: 538182, name: "Kodka (Channa)" },
      { id: 538216, name: "Kohalgaon" },
      { id: 538320, name: "Korambhi" },
      { id: 538326, name: "Korambhitola" },
      { id: 538200, name: "Kumbhitola" },
      { id: 538317, name: "Mahagaon" },
      { id: 538303, name: "Mahalgaon" },
      { id: 538222, name: "Mahuli" },
      { id: 538307, name: "Mahurkuda" },
      { id: 538305, name: "Malkanpur" },
      { id: 538209, name: "Malkazari" },
      { id: 538322, name: "Mandokhal (Rithi)" },
      { id: 538329, name: "Mandokhal T.Sa. Kra.20" },
      { id: 538289, name: "Morgaon" },
      { id: 538194, name: "Mungali" },
      { id: 538187, name: "Navegaon Bandh" },
      { id: 538315, name: "Navnitpur" },
      { id: 538298, name: "Nilaj" },
      { id: 538232, name: "Nimgaon (Rithi )" },
      { id: 538279, name: "Nimgaon T.Sa. Kra.10" },
      { id: 538185, name: "Pandharwani(Mal)" },
      { id: 538184, name: "Pandharwani(Rai)" },
      { id: 538258, name: "Parastola" },
      { id: 538183, name: "Parsodi(Rai)" },
      { id: 538288, name: "Pathari (Rithi)" },
      { id: 538214, name: "Pauni (Dhabe)" },
      { id: 538278, name: "Pimpalgaon" },
      { id: 538230, name: "Pratapgad" },
      { id: 538248, name: "Pushpanagar (A)" },
      { id: 538249, name: "Pushpanagar (B)" },
      { id: 538264, name: "Rajoli" },
      { id: 538300, name: "Ramghat (Rithi)" },
      { id: 538229, name: "Ramnagar" },
      { id: 538205, name: "Rampuri" },
      { id: 538217, name: "Ranjitola T.Sa. Kra.29" },
      { id: 538263, name: "Saigaon" },
      { id: 538227, name: "Sanjaynagar" },
      { id: 538272, name: "Sarandi (Rithi)" },
      { id: 538328, name: "Sawari" },
      { id: 538193, name: "Sawartola" },
      { id: 538270, name: "Silezari" },
      { id: 538280, name: "Silli (Rithi)" },
      { id: 538327, name: "Sindhmarhan(Rithi)" },
      { id: 538175, name: "Siregaon" },
      { id: 538314, name: "Siroli" },
      { id: 538176, name: "Somalpur" },
      { id: 538196, name: "Somalpur(Rithi)" },
      { id: 538283, name: "Sonegaon" },
      { id: 538286, name: "Sukali" },
      { id: 538237, name: "Surban" },
      { id: 538277, name: "Surgaon" },
      { id: 538291, name: "Tadgaon" },
      { id: 538297, name: "Tavashi Khurd" },
      { id: 538213, name: "Tidka T.Sa. Kra.14" },
      { id: 538292, name: "Tidka T.Sa. Kra.15" },
      { id: 538267, name: "Tirkhuri" },
      { id: 538245, name: "Tukum Narayan" },
      { id: 538210, name: "Tumdimendha ( Rithi ) T.Sa. Kra.18" },
      { id: 538306, name: "Tumdimendha T.Sa. Kra.14" },
      { id: 538192, name: "Umari" },
      { id: 538243, name: "Umarpayali" },
      { id: 538254, name: "Varvhi" },
      { id: 538271, name: "Vihirgaon Baradya" },
      { id: 538310, name: "Wadegaon" },
      { id: 538250, name: "Wadegaon Bandhya" },
      { id: 538318, name: "Yegaon" },
      { id: 538206, name: "Yelodi" },
      { id: 538177, name: "Yerandi T.Sa. Kra.2" },
      { id: 538316, name: "Yerandi T.Sa. Kra.21" },
      { id: 538221, name: "Yerandi T.Sa. Kra.29" },
      { id: 538198, name: "Yerandi T.Sa. Kra.6" },
      { id: 538296, name: "Zarpada" },
      { id: 538212, name: "Zashinagar" },
    ],
    4051: [
      { id: 944159, name: "Aakta" },
      { id: 538333, name: "Alebedar" },
      { id: 538407, name: "Alewada" },
      { id: 538344, name: "Alezari (Riti)" },
      { id: 538415, name: "Ambhora" },
      { id: 538364, name: "Amgaon" },
      { id: 538452, name: "Balapur" },
      { id: 538409, name: "Belgaon" },
      { id: 538422, name: "Bhagi (7)" },
      { id: 538369, name: "Bhagi(13)" },
      { id: 538456, name: "Bhandari" },
      { id: 538375, name: "Bharregaon" },
      { id: 538382, name: "Bilargondi" },
      { id: 538400, name: "Bodaldand" },
      { id: 538417, name: "Bonde" },
      { id: 538389, name: "Borgaon Ba." },
      { id: 538360, name: "Borgaon Saza Kra. 3" },
      { id: 538390, name: "Charbhata (10)" },
      { id: 538345, name: "Charbhata (4)" },
      { id: 538355, name: "Chhattartola" },
      { id: 538383, name: "Chichewada" },
      { id: 538433, name: "Chichgad" },
      { id: 538427, name: "Chilhati" },
      { id: 538444, name: "Chipota" },
      { id: 538453, name: "Chumali" },
      { id: 538366, name: "Dawaki" },
      { id: 538467, name: "Deori" },
      { id: 538420, name: "Dewalgaon" },
      { id: 538337, name: "Dewatola" },
      { id: 538463, name: "Dhamditola Saza Kra. 33" },
      { id: 538335, name: "Dhamditola Saza Kra.30" },
      { id: 538411, name: "Dhanori" },
      { id: 538441, name: "Dhawalkhedi" },
      { id: 538334, name: "Dhiwarintola" },
      { id: 538370, name: "Dhobisarad" },
      { id: 538437, name: "Dhodhara" },
      { id: 538454, name: "Dongargaon (33)" },
      { id: 538343, name: "Dongargaon Saza Kra. 5" },
      { id: 538439, name: "Dongargaon(18)" },
      { id: 538462, name: "Elamagondi" },
      { id: 538358, name: "Fukkimeta" },
      { id: 538397, name: "Futana" },
      { id: 538402, name: "Gadegaon" },
      { id: 538451, name: "Garartola" },
      { id: 538461, name: "Gawrala" },
      { id: 538457, name: "Ghogara" },
      { id: 538418, name: "Ghonadi" },
      { id: 538365, name: "Gotabodi" },
      { id: 538398, name: "Haldi" },
      { id: 538340, name: "Hardoli" },
      { id: 538464, name: "Istari" },
      { id: 538362, name: "Jamanapur" },
      { id: 538394, name: "Jethabhawda" },
      { id: 538446, name: "Kadikasa" },
      { id: 538426, name: "Kakodi" },
      { id: 538387, name: "Kalchua" },
      { id: 538385, name: "Kanhalgaon" },
      { id: 538405, name: "Kawalewada" },
      { id: 538423, name: "Kesori" },
      { id: 538412, name: "Khamkhurra" },
      { id: 538353, name: "Khamtalav" },
      { id: 538416, name: "Kosabi(Kh)" },
      { id: 538410, name: "Kosbi(Bk)" },
      { id: 538419, name: "Kotjambhora" },
      { id: 538442, name: "Kunabitola" },
      { id: 538391, name: "Lendijob" },
      { id: 538347, name: "Lohara" },
      { id: 538466, name: "Mahaka" },
      { id: 538368, name: "Makardhokada" },
      { id: 538374, name: "Malharbodi" },
      { id: 538458, name: "Malkazari" },
      { id: 538459, name: "Mangardoh" },
      { id: 538373, name: "Maramjob" },
      { id: 538384, name: "Masulkasa" },
      { id: 538395, name: "Masurbhawda" },
      { id: 538429, name: "Mehatakheda" },
      { id: 538403, name: "Mhaisuli" },
      { id: 538465, name: "Mispiri" },
      { id: 538438, name: "Mohandi" },
      { id: 538350, name: "Mohantola" },
      { id: 538408, name: "Mohgaon" },
      { id: 944831, name: "Mohgaon Saza Kramank(12)" },
      { id: 538351, name: "Mulla" },
      { id: 538372, name: "Mundipar" },
      { id: 538371, name: "Murdoli" },
      { id: 538425, name: "Murmadi" },
      { id: 538414, name: "Murmadi(Rithi)" },
      { id: 538393, name: "Murpar Rithi" },
      { id: 538377, name: "Murpar Saza Kra.6" },
      { id: 538348, name: "Murpar Saza Kra.9" },
      { id: 538388, name: "Nakati" },
      { id: 538413, name: "Nilaj" },
      { id: 538338, name: "Owara" },
      { id: 538399, name: "Padampur" },
      { id: 538367, name: "Padampur Saza Kra.11" },
      { id: 538450, name: "Paladur" },
      { id: 538401, name: "Palangaon" },
      { id: 538336, name: "Palasgaon" },
      { id: 538341, name: "Pandharpur" },
      { id: 538386, name: "Pandharwani" },
      { id: 538404, name: "Parsodi" },
      { id: 538339, name: "Pauddauna" },
      { id: 538430, name: "Paulzola" },
      { id: 538406, name: "Pindakepar" },
      { id: 538361, name: "Pindakepar Saza Kra.12" },
      { id: 538460, name: "Piparkhari" },
      { id: 538447, name: "Pouni (Rithi)" },
      { id: 538349, name: "Purada" },
      { id: 538379, name: "Rajamdongari" },
      { id: 538431, name: "Rehadi" },
      { id: 538436, name: "Ropa" },
      { id: 538380, name: "Salai" },
      { id: 538354, name: "Salegaon" },
      { id: 538342, name: "Saoli" },
      { id: 538435, name: "Sarregaon" },
      { id: 538392, name: "Serpar" },
      { id: 538381, name: "Shedepar" },
      { id: 538359, name: "Shilapur" },
      { id: 538396, name: "Sindibirri" },
      { id: 538434, name: "Singandoh" },
      { id: 538421, name: "Sirpur Bandh" },
      { id: 538376, name: "Sirpur Saza Kra.13" },
      { id: 538352, name: "Subraytola" },
      { id: 538449, name: "Sukali" },
      { id: 538440, name: "Sundari" },
      { id: 538346, name: "Surtoli" },
      { id: 538356, name: "Tekabedar" },
      { id: 538378, name: "Toyagondi" },
      { id: 538424, name: "Tumadikasa" },
      { id: 538443, name: "Uchepur" },
      { id: 538357, name: "Wadegaon" },
      { id: 538428, name: "Wadekasa" },
      { id: 538432, name: "Wandhara" },
      { id: 538448, name: "Wasani" },
      { id: 538363, name: "Zuzaritola" },
    ],
    4052: [
      { id: 538470, name: "Amgaon" },
      { id: 538498, name: "Arattondi" },
      { id: 538474, name: "Bodadha Gaoganna" },
      { id: 538475, name: "Bodadha Tukum" },
      { id: 538502, name: "Chikhali Rith" },
      { id: 538503, name: "Chikhali Tukum" },
      { id: 538481, name: "Chop" },
      { id: 538480, name: "Dongar Mendha" },
      { id: 538500, name: "Dongargaon Halbi" },
      { id: 538472, name: "Ekalpur" },
      { id: 538496, name: "Fari" },
      { id: 538468, name: "Gandhi Nagar" },
      { id: 538482, name: "Kalamgaon" },
      { id: 538477, name: "Kasari Gaoganna" },
      { id: 538478, name: "Kasari Tukum" },
      { id: 538499, name: "Kinhala" },
      { id: 538491, name: "Kokadi" },
      { id: 538494, name: "Kondhala" },
      { id: 538473, name: "Koregaon" },
      { id: 538493, name: "Kurud" },
      { id: 942966, name: "Nainpur" },
      { id: 538479, name: "Penda" },
      { id: 538488, name: "Pimpalgaon" },
      { id: 538489, name: "Potgaon" },
      { id: 538471, name: "Rampur Tukum" },
      { id: 538476, name: "Ravanwadi" },
      { id: 538469, name: "Sawangi" },
      { id: 538485, name: "Shankarpur" },
      { id: 538487, name: "Shelda Lambe" },
      { id: 538486, name: "Shelda Tukum" },
      { id: 538495, name: "Shivrajpur Chak" },
      { id: 538484, name: "Tulshi" },
      { id: 538497, name: "Usegaon" },
      { id: 538501, name: "Vihirgaon" },
      { id: 942968, name: "Virshi Tukum" },
      { id: 538483, name: "Visora" },
      { id: 538490, name: "Vitthalgaon" },
      { id: 538492, name: "Wadegaon" },
      { id: 942970, name: "Wadsa" },
    ],
    4053: [
      { id: 538587, name: "Akapur Chak" },
      { id: 538518, name: "Armori" },
      { id: 538516, name: "Arsoda" },
      { id: 538512, name: "Ashta" },
      { id: 538564, name: "Bhakrondi" },
      { id: 538565, name: "Bhansi" },
      { id: 538596, name: "Bodadha Chak" },
      { id: 538595, name: "Bori Chak" },
      { id: 538591, name: "Borkanhar Patch" },
      { id: 538529, name: "Chamorshi (M.)" },
      { id: 538530, name: "Chamorshi Chak" },
      { id: 538535, name: "Chavela" },
      { id: 538606, name: "Chicholi" },
      { id: 538605, name: "Chicholi Chak" },
      { id: 538589, name: "Churmura" },
      { id: 538593, name: "Darli" },
      { id: 538562, name: "Davandi" },
      { id: 538544, name: "Delanwadi" },
      { id: 538597, name: "Deloda Bk" },
      { id: 538598, name: "Deloda Kh" },
      { id: 538601, name: "Deshapur" },
      { id: 538602, name: "Deshpur Chak" },
      { id: 538574, name: "Deulgaon Butti" },
      { id: 538600, name: "Devipur Camp" },
      { id: 538549, name: "Dongar Tamasi" },
      { id: 538547, name: "Dongar Tamasi Patch" },
      { id: 538525, name: "Dongargaon (Bhusari)" },
      { id: 538573, name: "Dongarsawangi" },
      { id: 538585, name: "Ganeshpur Chak" },
      { id: 538552, name: "Hirapur Rith" },
      { id: 538575, name: "Injewari" },
      { id: 538567, name: "Jambhali" },
      { id: 538511, name: "Jogisakhara" },
      { id: 538520, name: "Kaneri" },
      { id: 538578, name: "Karpada Chak" },
      { id: 538505, name: "Kasavi" },
      { id: 538563, name: "Khadki" },
      { id: 538604, name: "Khairi Rith" },
      { id: 538568, name: "Khardi" },
      { id: 538588, name: "Kitali" },
      { id: 538577, name: "Kojabi" },
      { id: 538570, name: "Koregaon" },
      { id: 538541, name: "Kosari" },
      { id: 538538, name: "Kulkuli" },
      { id: 538555, name: "Kurandi Chak" },
      { id: 538556, name: "Kurandi Mal" },
      { id: 538599, name: "Kurunza" },
      { id: 538583, name: "Lohara" },
      { id: 538542, name: "Manapur" },
      { id: 538540, name: "Mangda" },
      { id: 538508, name: "Manjewada" },
      { id: 538566, name: "Mendha ( Wadegaon)" },
      { id: 538553, name: "Mendha (Bhakrondi)" },
      { id: 538550, name: "Mendhebodi Chak" },
      { id: 538582, name: "Mohatola Alies Kukadi" },
      { id: 538534, name: "Mohazari Alias Sukarbodi" },
      { id: 538548, name: "Mohzari" },
      { id: 538515, name: "Mulur Chak" },
      { id: 538514, name: "Mulur Rith" },
      { id: 538543, name: "Nagarwahi Chak" },
      { id: 538545, name: "Nagarwahi Mal" },
      { id: 538572, name: "Narchuli" },
      { id: 538580, name: "Naroti Chak" },
      { id: 538592, name: "Naroti Mal" },
      { id: 538507, name: "Nawargaon" },
      { id: 538537, name: "Nawargaon (Maktta)" },
      { id: 538536, name: "Nawargaon Alias Ramtola" },
      { id: 538506, name: "Palasgaon" },
      { id: 538519, name: "Palora" },
      { id: 538561, name: "Paraswadi" },
      { id: 538531, name: "Patanwada" },
      { id: 538510, name: "Pathargota" },
      { id: 538586, name: "Peth Tukum" },
      { id: 538576, name: "Pewati Alies Nawegaon" },
      { id: 538560, name: "Pisewadadha" },
      { id: 538533, name: "Purana Wairagad" },
      { id: 538513, name: "Rampur Chak" },
      { id: 538504, name: "Ravi" },
      { id: 538523, name: "Saigaon" },
      { id: 538521, name: "Salmara" },
      { id: 538509, name: "Shankarnagar" },
      { id: 538522, name: "Shegaon" },
      { id: 538524, name: "Shioni Bk" },
      { id: 538546, name: "Shioni Kh" },
      { id: 538584, name: "Sirsi" },
      { id: 538579, name: "Sonpur Chak" },
      { id: 538532, name: "Sukala" },
      { id: 538590, name: "Suryadongari" },
      { id: 538603, name: "Tembha Chak" },
      { id: 538526, name: "Thanegaon" },
      { id: 538558, name: "Thotebodi" },
      { id: 538539, name: "Tultuli" },
      { id: 538557, name: "Umari" },
      { id: 538551, name: "Vairagad" },
      { id: 538581, name: "Vihirgaon" },
      { id: 538594, name: "Wadadha" },
      { id: 538554, name: "Wadegaon" },
      { id: 538517, name: "Waghala" },
      { id: 538571, name: "Wanarchuwa" },
      { id: 538569, name: "Wankheda" },
      { id: 538528, name: "Wankhi" },
      { id: 538527, name: "Wasala" },
      { id: 538559, name: "Yengada" },
    ],
    4054: [
      { id: 538693, name: "Ambezari" },
      { id: 538625, name: "Andhali" },
      { id: 538692, name: "Andhali ( Sonpur )" },
      { id: 538724, name: "Angara" },
      { id: 538608, name: "Anjantola" },
      { id: 538669, name: "Antargaon" },
      { id: 538635, name: "Arattondi" },
      { id: 538655, name: "Bamhani" },
      { id: 538708, name: "Bandhgaon" },
      { id: 538633, name: "Belgaon" },
      { id: 538643, name: "Bhagawanpur" },
      { id: 538695, name: "Bhandari (Masahat)" },
      { id: 538682, name: "Bhategaon" },
      { id: 538621, name: "Bhimanpayli" },
      { id: 538664, name: "Bijapur" },
      { id: 538709, name: "Bortola" },
      { id: 538689, name: "Chandagad" },
      { id: 538691, name: "Chandona" },
      { id: 538663, name: "Charbhatti" },
      { id: 538641, name: "Chargaon" },
      { id: 538729, name: "Charvidand" },
      { id: 538701, name: "Chichewada" },
      { id: 538617, name: "Chichtola" },
      { id: 538674, name: "Chikhaldhokada" },
      { id: 538614, name: "Chikhali" },
      { id: 538646, name: "Chinegaon" },
      { id: 538694, name: "Chipari" },
      { id: 538681, name: "Chirchadi" },
      { id: 538683, name: "Dadapur" },
      { id: 538698, name: "Dalli" },
      { id: 538712, name: "Dameshwar" },
      { id: 538638, name: "Deulgaon" },
      { id: 538612, name: "Dhamaditola" },
      { id: 538718, name: "Dhanegaon" },
      { id: 538609, name: "Dhanori" },
      { id: 538720, name: "Dholdongri" },
      { id: 538702, name: "Dhusi Masahat" },
      { id: 538667, name: "Dongargaon" },
      { id: 538703, name: "Dongargaon(Chan)" },
      { id: 538727, name: "Fari" },
      { id: 538645, name: "Gangoli" },
      { id: 538733, name: "Gangsaitola" },
      { id: 538671, name: "Gargada" },
      { id: 538616, name: "Gewardha" },
      { id: 538640, name: "Ghati" },
      { id: 538631, name: "Gothangaon" },
      { id: 538626, name: "Gurnoli" },
      { id: 538657, name: "Hadkikanhar" },
      { id: 538675, name: "Hetinagar" },
      { id: 538730, name: "Huryaldand" },
      { id: 538651, name: "Jambhali" },
      { id: 538677, name: "Jamtola" },
      { id: 538622, name: "Janbhur Kheda" },
      { id: 538636, name: "Jayatpur (Rith)" },
      { id: 538660, name: "Joshitola" },
      { id: 538648, name: "Kadholi" },
      { id: 538650, name: "Karadi" },
      { id: 538716, name: "Kasarbodi" },
      { id: 538719, name: "Kasari" },
      { id: 538697, name: "Katalwada" },
      { id: 538670, name: "Katangtola" },
      { id: 538723, name: "Khadki" },
      { id: 538632, name: "Khairi" },
      { id: 538642, name: "Kharkada" },
      { id: 538637, name: "Kharmaltola" },
      { id: 538615, name: "Khedegaon" },
      { id: 538673, name: "Khedegaon(Khe)" },
      { id: 538713, name: "Khobramendha" },
      { id: 538704, name: "Kosi" },
      { id: 538658, name: "Kotaldoha" },
      { id: 538731, name: "Kumalpar (Rith)" },
      { id: 538623, name: "Kumbhitola" },
      { id: 538696, name: "Kurandi (Rith)" },
      { id: 538734, name: "Kurkheda" },
      { id: 538665, name: "Lawari" },
      { id: 538680, name: "Laxmipur" },
      { id: 538620, name: "Lendhari" },
      { id: 538629, name: "Maldugi" },
      { id: 538728, name: "Malewada" },
      { id: 538668, name: "Marartola" },
      { id: 538672, name: "Maushi" },
      { id: 538618, name: "Mendha" },
      { id: 538706, name: "Mendha(Ku)" },
      { id: 538705, name: "Mohagaon" },
      { id: 538619, name: "Mohagaon Alias Wakadi" },
      { id: 538699, name: "Nalikasa" },
      { id: 538613, name: "Nanhi" },
      { id: 538726, name: "Navezari" },
      { id: 538628, name: "Nawargaon" },
      { id: 538711, name: "Neharpayli" },
      { id: 538715, name: "Palapundi" },
      { id: 538661, name: "Palasgad" },
      { id: 538647, name: "Palasgaon" },
      { id: 538721, name: "Palasgoan ( An)" },
      { id: 538656, name: "Pitesur" },
      { id: 538676, name: "Purada" },
      { id: 538679, name: "Ramgad" },
      { id: 538717, name: "Ranwahi" },
      { id: 538610, name: "Sadhutola" },
      { id: 538690, name: "Salai Tola" },
      { id: 538662, name: "Salangtola" },
      { id: 538725, name: "Satitola" },
      { id: 538649, name: "Sawalkheda" },
      { id: 538710, name: "Sawargaon" },
      { id: 538722, name: "Sawatala" },
      { id: 538634, name: "Saytola" },
      { id: 538639, name: "Shirpur" },
      { id: 538688, name: "Shivni" },
      { id: 538659, name: "Sindesur" },
      { id: 538684, name: "Sitashivani" },
      { id: 538652, name: "Sonerangi" },
      { id: 538687, name: "Sonpur" },
      { id: 538707, name: "Sonsari" },
      { id: 538611, name: "Talegaon" },
      { id: 538627, name: "Umarzari" },
      { id: 538654, name: "Uradi" },
      { id: 538607, name: "Wadegaon" },
      { id: 538644, name: "Wadhona" },
      { id: 538678, name: "Wagdara Alias Gowarhudki" },
      { id: 538624, name: "Wagheda" },
      { id: 538685, name: "Warvi" },
      { id: 538653, name: "Wasi" },
      { id: 538686, name: "Yedapur" },
      { id: 538714, name: "Yedaskuhi" },
      { id: 538732, name: "Yedaskuhi Masehat" },
      { id: 538700, name: "Yengalkheda" },
      { id: 538630, name: "Yerandi" },
      { id: 538666, name: "Yerkadi" },
    ],
    4055: [
      { id: 538789, name: "Allitola" },
      { id: 538855, name: "Alondi" },
      { id: 538760, name: "Ambekhari" },
      { id: 538822, name: "Ambekhari(Temli)" },
      { id: 538835, name: "Antargaon" },
      { id: 538843, name: "Armurakasa" },
      { id: 538775, name: "Aswalhudki" },
      { id: 538833, name: "Badimadhe" },
      { id: 538829, name: "Banjari(Rith)" },
      { id: 538815, name: "Bedgaon" },
      { id: 538751, name: "Belar Gondi" },
      { id: 538811, name: "Belgaon" },
      { id: 538795, name: "Betakathi" },
      { id: 538773, name: "Bharitola" },
      { id: 538838, name: "Bhatgaon" },
      { id: 538861, name: "Bhimankhoji" },
      { id: 538787, name: "Bhimpur" },
      { id: 538782, name: "Bhuryaldand" },
      { id: 538788, name: "Bihate Kala" },
      { id: 538771, name: "Bihate Kh" },
      { id: 538737, name: "Bijapar" },
      { id: 538736, name: "Bodaldand" },
      { id: 538743, name: "Bogatola" },
      { id: 538761, name: "Bonde" },
      { id: 538764, name: "Bondena" },
      { id: 538808, name: "Bori" },
      { id: 538770, name: "Botekasa" },
      { id: 538863, name: "Botezari" },
      { id: 538797, name: "Chandagota" },
      { id: 538754, name: "Charvidand" },
      { id: 538818, name: "Chilamtola" },
      { id: 538832, name: "Chotimade" },
      { id: 538752, name: "Dabari" },
      { id: 538819, name: "Dawandi" },
      { id: 538830, name: "Deogad (Rith)" },
      { id: 538845, name: "Deulbhatti" },
      { id: 538839, name: "Dholdongri" },
      { id: 538776, name: "Dodke" },
      { id: 538777, name: "Fulgondi" },
      { id: 538825, name: "Gadheli (Masahat)" },
      { id: 538806, name: "Gahanegata" },
      { id: 538840, name: "Gajegaon" },
      { id: 538769, name: "Ghugawa" },
      { id: 538849, name: "Godari" },
      { id: 538853, name: "Gotatola" },
      { id: 538800, name: "Gutekasa" },
      { id: 538867, name: "Gyarapatti" },
      { id: 538748, name: "Hetalkasa" },
      { id: 538741, name: "Hitapadi" },
      { id: 538746, name: "Hitkasa" },
      { id: 538807, name: "Hudukduma" },
      { id: 538780, name: "Jambhali" },
      { id: 538805, name: "Jamnara" },
      { id: 538763, name: "Jamnara(Maseli)" },
      { id: 538813, name: "Jodtarai" },
      { id: 538739, name: "Kaimul" },
      { id: 538793, name: "Kale" },
      { id: 538854, name: "Kameli" },
      { id: 538844, name: "Kaparith" },
      { id: 538848, name: "Khasoda" },
      { id: 538767, name: "Khirutola" },
      { id: 538783, name: "Khunara" },
      { id: 538747, name: "Khurshipar" },
      { id: 538802, name: "Kochinara" },
      { id: 538809, name: "Kohaka" },
      { id: 538827, name: "Kohaka Masahat" },
      { id: 538856, name: "Kohakabodi" },
      { id: 538847, name: "Kohakamokasa" },
      { id: 538745, name: "Kolupadi Kasa" },
      { id: 538785, name: "Korchi" },
      { id: 538834, name: "Kosami (Antargaon)" },
      { id: 538814, name: "Kosmi" },
      { id: 538742, name: "Kotara" },
      { id: 538846, name: "Kotgul" },
      { id: 538820, name: "Kukdel" },
      { id: 538798, name: "Kumkot" },
      { id: 538778, name: "Laxmipur Turf Tadakadand" },
      { id: 538758, name: "Lekurbodi" },
      { id: 538790, name: "Majumkhadka" },
      { id: 538850, name: "Makr Dhokada" },
      { id: 538766, name: "Markekasa" },
      { id: 538750, name: "Maseli" },
      { id: 538755, name: "Mayalghat" },
      { id: 538801, name: "Mohagaon" },
      { id: 538865, name: "Mothazeliya" },
      { id: 538744, name: "Muletipadi Kasa" },
      { id: 538792, name: "Mundipar" },
      { id: 538756, name: "Murkuti" },
      { id: 538826, name: "Nadekal Alias Belkathi" },
      { id: 538749, name: "Nandali" },
      { id: 538842, name: "Nangpur" },
      { id: 538864, name: "Narkasa" },
      { id: 538759, name: "Navezari" },
      { id: 538786, name: "Nawargaon (Ghat)" },
      { id: 538866, name: "Nyahakal" },
      { id: 538753, name: "Padiyal Jog" },
      { id: 538803, name: "Pandharapani" },
      { id: 538799, name: "Pandharigota" },
      { id: 538851, name: "Paurzora" },
      { id: 538757, name: "Pendakodo" },
      { id: 538784, name: "Phakanabhatti" },
      { id: 538812, name: "Piparzora" },
      { id: 538857, name: "Pitesur" },
      { id: 538735, name: "Pranpur Rith" },
      { id: 538828, name: "Pratapgad" },
      { id: 538858, name: "Putargondi" },
      { id: 538762, name: "Rajatola" },
      { id: 538817, name: "Rajatola(Belgaon)" },
      { id: 538768, name: "Ramsaytola" },
      { id: 538862, name: "Rankatta" },
      { id: 538774, name: "Salhe" },
      { id: 538837, name: "Salhe(Bhatgaon)" },
      { id: 538779, name: "Sanpur" },
      { id: 538804, name: "Satputi" },
      { id: 538738, name: "Sawali" },
      { id: 538740, name: "Shikaritola" },
      { id: 538841, name: "Shiwarajpur" },
      { id: 538772, name: "Sohale" },
      { id: 538852, name: "Sonpur" },
      { id: 538781, name: "Surwahi" },
      { id: 538821, name: "Tahakatola" },
      { id: 538859, name: "Talwargad" },
      { id: 538791, name: "Tekabedad" },
      { id: 538860, name: "Tekameta" },
      { id: 538824, name: "Temli" },
      { id: 538823, name: "Tutekanhar" },
      { id: 538810, name: "Wadgaon Alias Ganeshpur" },
      { id: 538836, name: "Wako" },
      { id: 538831, name: "Yedjal Masahat" },
      { id: 538796, name: "Zagadwahi" },
      { id: 538816, name: "Zankargondi" },
      { id: 538794, name: "Zaparagad" },
      { id: 538765, name: "Zendepar" },
    ],
    4056: [
      { id: 538892, name: "Ambezari" },
      { id: 538926, name: "Ampayli" },
      { id: 538940, name: "Arjuni" },
      { id: 538936, name: "Aswalpar" },
      { id: 538868, name: "Bandhona" },
      { id: 538901, name: "Bandhur" },
      { id: 538906, name: "Batmarhan" },
      { id: 539043, name: "Begadi" },
      { id: 538924, name: "Belgaon" },
      { id: 539083, name: "Bhapada" },
      { id: 539094, name: "Bhendi Kanhar" },
      { id: 539090, name: "Bhimpur" },
      { id: 538972, name: "Bhurantola" },
      { id: 538969, name: "Bhusamkudo" },
      { id: 538920, name: "Bodhankheda" },
      { id: 539007, name: "Bodin" },
      { id: 538953, name: "Bori" },
      { id: 539060, name: "Botehur" },
      { id: 538921, name: "Charvidand" },
      { id: 538903, name: "Charwahi" },
      { id: 539012, name: "Chatgaon" },
      { id: 538990, name: "Chavela" },
      { id: 538968, name: "Chicholi" },
      { id: 539027, name: "Chimrikal" },
      { id: 538948, name: "Chingali" },
      { id: 538942, name: "Chudiyal" },
      { id: 539074, name: "Cichoda" },
      { id: 538963, name: "Dabba" },
      { id: 538905, name: "Darachi(Khanmabal)" },
      { id: 538964, name: "Darchi(Dabba)" },
      { id: 538976, name: "Deulgaon" },
      { id: 538877, name: "Devsara" },
      { id: 538896, name: "Devsur" },
      { id: 538987, name: "Dhanora" },
      { id: 538965, name: "Dhawali" },
      { id: 539068, name: "Dhorgatta" },
      { id: 538941, name: "Dongarhur" },
      { id: 538979, name: "Dudhamala" },
      { id: 539065, name: "Durgapur" },
      { id: 539078, name: "Fulbodi" },
      { id: 539048, name: "Gaidongari" },
      { id: 538918, name: "Gajamendhi" },
      { id: 538928, name: "Gatanyeli" },
      { id: 539076, name: "Gatta" },
      { id: 539009, name: "Gattepayli" },
      { id: 539040, name: "Ghodezari" },
      { id: 539015, name: "Ghotevihir" },
      { id: 539002, name: "Girola" },
      { id: 539023, name: "Godalwahi" },
      { id: 539053, name: "Gota" },
      { id: 538912, name: "Gotatola" },
      { id: 538977, name: "Gujanwadi" },
      { id: 539051, name: "Gumadi" },
      { id: 538902, name: "Gurekasa" },
      { id: 539056, name: "Hadapeth" },
      { id: 539032, name: "Halkanhar" },
      { id: 539081, name: "Hanpayli" },
      { id: 539063, name: "Hatanjur" },
      { id: 538986, name: "Heti" },
      { id: 539024, name: "Hipaner" },
      { id: 538914, name: "Hirange" },
      { id: 539020, name: "Horakasa" },
      { id: 539021, name: "Hulondi" },
      { id: 538995, name: "Irpundi" },
      { id: 538888, name: "Irupdhodari" },
      { id: 538885, name: "Iruptola" },
      { id: 538878, name: "Jaisingtola" },
      { id: 539016, name: "Jambhali" },
      { id: 539085, name: "Jambhalizora" },
      { id: 538946, name: "Jangada Bk" },
      { id: 539095, name: "Jappi" },
      { id: 538943, name: "Japtalai" },
      { id: 538959, name: "Jewalwahi" },
      { id: 539039, name: "Kachakal" },
      { id: 539003, name: "Kakadyeli" },
      { id: 539028, name: "Kamangad" },
      { id: 539035, name: "Kamthala" },
      { id: 538991, name: "Kandali" },
      { id: 539031, name: "Kaneli" },
      { id: 538916, name: "Kangadi" },
      { id: 539004, name: "Kanhalgaon(Chingali)" },
      { id: 539080, name: "Kanhalgaon(Karwafa)" },
      { id: 538950, name: "Kanhalgaon(Rith)" },
      { id: 538985, name: "Kanharltola" },
      { id: 538961, name: "Karemarka" },
      { id: 539047, name: "Karwafa" },
      { id: 539013, name: "Katezari" },
      { id: 538894, name: "Katezari(Murumgaon)" },
      { id: 538907, name: "Kawadikasa" },
      { id: 538934, name: "Kehakawahi S" },
      { id: 538933, name: "Kehakawahimal" },
      { id: 538889, name: "Kermarhan" },
      { id: 538875, name: "Khambala" },
      { id: 538881, name: "Khamtala" },
      { id: 539067, name: "Khargi" },
      { id: 538992, name: "Kharkadi" },
      { id: 538925, name: "Khedegaon" },
      { id: 538951, name: "Khedi" },
      { id: 538909, name: "Khedimowad" },
      { id: 539014, name: "Khutgaon" },
      { id: 538898, name: "Kisneli" },
      { id: 539036, name: "Kisner" },
      { id: 539073, name: "Kodekal" },
      { id: 539086, name: "Kokadkasa" },
      { id: 538886, name: "Kolharbodi" },
      { id: 539050, name: "Kondawahi" },
      { id: 538899, name: "Kosami" },
      { id: 538999, name: "Kudakwahi" },
      { id: 538915, name: "Kulbhatti" },
      { id: 539041, name: "Kupaner" },
      { id: 539044, name: "Kuthegaon" },
      { id: 538895, name: "Lahanzeliya" },
      { id: 539077, name: "Latzora" },
      { id: 538984, name: "Lekha" },
      { id: 539008, name: "Mahawada" },
      { id: 538949, name: "Mahawada(Chingali)" },
      { id: 539042, name: "Makkepayli" },
      { id: 538989, name: "Malanda" },
      { id: 539029, name: "Mangewada(Payadi)" },
      { id: 538891, name: "Mangewada(Yermagad)" },
      { id: 539037, name: "Markagaon (Chichoda)" },
      { id: 538900, name: "Markagaon (Kosami)" },
      { id: 538993, name: "Markegaon" },
      { id: 538893, name: "Marma" },
      { id: 539064, name: "Masanadi" },
      { id: 538955, name: "Masarigata" },
      { id: 538876, name: "Medha (Khambala)" },
      { id: 538983, name: "Mendha" },
      { id: 539019, name: "Mendhatola" },
      { id: 538945, name: "Metejangada" },
      { id: 538975, name: "Michagaon Bk" },
      { id: 538974, name: "Michagaon Kh" },
      { id: 538973, name: "Michagaon Masahat" },
      { id: 539038, name: "Michagaon Zada" },
      { id: 538938, name: "Modebhatti" },
      { id: 539071, name: "Mohagaon" },
      { id: 538947, name: "Moholi" },
      { id: 538919, name: "Morchul (Payadi)" },
      { id: 539030, name: "Morchul(Sa)" },
      { id: 538910, name: "Mujalgondi" },
      { id: 539006, name: "Munganer" },
      { id: 538996, name: "Muranda" },
      { id: 539089, name: "Murgaon" },
      { id: 538884, name: "Murmadi" },
      { id: 538923, name: "Murumgaon" },
      { id: 538904, name: "Murzar" },
      { id: 538872, name: "Muska" },
      { id: 538971, name: "Navargaon" },
      { id: 539046, name: "Navegaon" },
      { id: 538952, name: "Nimanwada" },
      { id: 538954, name: "Nimgaon" },
      { id: 538870, name: "Nimgaon(Muska)" },
      { id: 539025, name: "Padaboriya" },
      { id: 539058, name: "Paidi" },
      { id: 539066, name: "Palasgaon" },
      { id: 539010, name: "Palkheda" },
      { id: 539011, name: "Pandharsada" },
      { id: 538930, name: "Pannemara" },
      { id: 538962, name: "Parasvihir" },
      { id: 538978, name: "Paraswadi" },
      { id: 539054, name: "Pathargota" },
      { id: 539017, name: "Pathargota(Sakhera)" },
      { id: 538967, name: "Pauni" },
      { id: 539026, name: "Paurwel" },
      { id: 539057, name: "Pekin Mudza" },
      { id: 539070, name: "Pendhari" },
      { id: 538911, name: "Phulkodo" },
      { id: 539082, name: "Phustola" },
      { id: 539072, name: "Pulkhal" },
      { id: 538958, name: "Pusawandi" },
      { id: 538982, name: "Rajoli" },
      { id: 539049, name: "Rakhatola" },
      { id: 538957, name: "Rampur Rithi" },
      { id: 538935, name: "Rangi" },
      { id: 538997, name: "Ranwahi" },
      { id: 539069, name: "Reche" },
      { id: 539088, name: "Regadand" },
      { id: 538913, name: "Rengagaon" },
      { id: 538931, name: "Ridwahi" },
      { id: 539087, name: "Rondawahi" },
      { id: 538981, name: "Rotarithi" },
      { id: 539062, name: "Rupingatta" },
      { id: 538873, name: "Saidhakani Rith" },
      { id: 538887, name: "Saigaon" },
      { id: 539018, name: "Sakhera" },
      { id: 538871, name: "Salangtola Chak" },
      { id: 538988, name: "Salebhatti" },
      { id: 538869, name: "Salebhatti (Muska)" },
      { id: 539091, name: "Saranda Bk" },
      { id: 539093, name: "Saranda Kh" },
      { id: 539033, name: "Sawanga Bk" },
      { id: 539034, name: "Sawanga Kh" },
      { id: 538917, name: "Sawargaon" },
      { id: 538956, name: "Shiwagata" },
      { id: 538929, name: "Sindesur (Yerkad)" },
      { id: 538880, name: "Sindewahi" },
      { id: 539000, name: "Singapur" },
      { id: 538908, name: "Sinsur" },
      { id: 539075, name: "Sinsur(Chichoda)" },
      { id: 538937, name: "Sinsur(Mohli)" },
      { id: 538970, name: "Sode" },
      { id: 539059, name: "Somalpur" },
      { id: 538890, name: "Sursundi" },
      { id: 539022, name: "Tahakapar" },
      { id: 538874, name: "Talegaon Chak" },
      { id: 539045, name: "Talodhi" },
      { id: 538998, name: "Todemasahat" },
      { id: 538939, name: "Toyagondi" },
      { id: 538994, name: "Tukum" },
      { id: 539055, name: "Tulmer" },
      { id: 538922, name: "Tumdikasa" },
      { id: 538879, name: "Ubdali" },
      { id: 539001, name: "Udegaon" },
      { id: 538932, name: "Umarpal" },
      { id: 538966, name: "Wadgaon" },
      { id: 538897, name: "Wadgaon(Kosami)" },
      { id: 538960, name: "Waghbhumi" },
      { id: 538883, name: "Waghbhumi (Mangewada)" },
      { id: 538944, name: "Warkekasa" },
      { id: 539052, name: "Yadasagondi" },
      { id: 539092, name: "Yedampayli Buj." },
      { id: 539084, name: "Yedampayli Kh" },
      { id: 539005, name: "Yengaon" },
      { id: 538980, name: "Yerandi" },
      { id: 538927, name: "Yerkadmowad" },
      { id: 538882, name: "Yermagad" },
      { id: 539061, name: "Zadapapda" },
      { id: 539079, name: "Zari" },
    ],
    4057: [
      { id: 539112, name: "Adapalli" },
      { id: 539141, name: "Ambeshivani" },
      { id: 539140, name: "Ambetola" },
      { id: 539130, name: "Amirza" },
      { id: 539152, name: "Bamhani" },
      { id: 539126, name: "Belgaon" },
      { id: 539142, name: "Beltek" },
      { id: 539202, name: "Benoli" },
      { id: 539134, name: "Bhikar Maushi" },
      { id: 539203, name: "Bitantola" },
      { id: 539156, name: "Bodali Alias Madya Tukum" },
      { id: 539154, name: "Bodali Mal" },
      { id: 539157, name: "Bodali Tukum" },
      { id: 539135, name: "Botheda" },
      { id: 539121, name: "Chambharda" },
      { id: 539166, name: "Chandala" },
      { id: 539107, name: "Churchura Chak" },
      { id: 539106, name: "Churchura Mal" },
      { id: 539184, name: "Darshani Chak" },
      { id: 539185, name: "Darshani Mal" },
      { id: 539213, name: "Devapur" },
      { id: 944932, name: "Devapur Rith" },
      { id: 539212, name: "Dewada" },
      { id: 539131, name: "Dhunde Shivni" },
      { id: 539145, name: "Dibhana Chak" },
      { id: 539144, name: "Dibhana Mal" },
      { id: 539180, name: "Dongargaon Bk" },
      { id: 539181, name: "Dongargaon Tukum" },
      { id: 942972, name: "Gadchiroli" },
      { id: 539201, name: "Gajanguda" },
      { id: 539206, name: "Gawalheti" },
      { id: 539136, name: "Gilgaon" },
      { id: 539111, name: "Gogaon" },
      { id: 539183, name: "Govindpur" },
      { id: 539174, name: "Gurwala" },
      { id: 539177, name: "Hirapur" },
      { id: 539115, name: "Indala" },
      { id: 539216, name: "Jadegaon" },
      { id: 539208, name: "Jaller" },
      { id: 539210, name: "Jamgaon" },
      { id: 539146, name: "Jepra" },
      { id: 539148, name: "Jungaon Patch" },
      { id: 539133, name: "Kalamtola" },
      { id: 539215, name: "Kalasi" },
      { id: 539117, name: "Kaneri" },
      { id: 539195, name: "Kanhalgaon" },
      { id: 539194, name: "Karkazora" },
      { id: 539105, name: "Katali" },
      { id: 539104, name: "Katali Chak" },
      { id: 539196, name: "Keligatta" },
      { id: 539214, name: "Kharadguda" },
      { id: 539155, name: "Kharpundi" },
      { id: 539138, name: "Khursa" },
      { id: 539103, name: "Kondhana" },
      { id: 539209, name: "Korkuti" },
      { id: 539187, name: "Kosamghat" },
      { id: 539114, name: "Kotgal" },
      { id: 539163, name: "Krupala" },
      { id: 539169, name: "Kumbhi Mokasa" },
      { id: 539171, name: "Kumbhi Patch" },
      { id: 539108, name: "Kurhadi" },
      { id: 539149, name: "Kurkheda" },
      { id: 942977, name: "Lanzeda" },
      { id: 539170, name: "Mademul" },
      { id: 539113, name: "Madya Tukum" },
      { id: 539110, name: "Mahadwadi Chak" },
      { id: 539207, name: "Marda" },
      { id: 539124, name: "Maregaon" },
      { id: 539123, name: "Maregaon Chak" },
      { id: 539122, name: "Maregaon Patch" },
      { id: 539179, name: "Markbodi" },
      { id: 539186, name: "Maroda" },
      { id: 539129, name: "Maushi Chak" },
      { id: 539125, name: "Maushi Khamb" },
      { id: 539158, name: "Mendha" },
      { id: 539164, name: "Mhasali" },
      { id: 539101, name: "Mohazari Patch" },
      { id: 539160, name: "Mudaza Bk" },
      { id: 539161, name: "Mudaza Tukum" },
      { id: 539118, name: "Murkhala" },
      { id: 539128, name: "Murmadi" },
      { id: 539139, name: "Murumbodi Chak" },
      { id: 539100, name: "Nagri" },
      { id: 539217, name: "Nagweli" },
      { id: 539102, name: "Navargaon" },
      { id: 539119, name: "Navegaon" },
      { id: 539137, name: "Palandur" },
      { id: 539116, name: "Pardi Kupi" },
      { id: 539191, name: "Pekingkasa" },
      { id: 539151, name: "Petedongari" },
      { id: 539099, name: "Porla" },
      { id: 539199, name: "Potegaon" },
      { id: 539159, name: "Pulkhal" },
      { id: 539188, name: "Raipur" },
      { id: 539132, name: "Rajagata Chak" },
      { id: 539143, name: "Rajagata Mal" },
      { id: 539198, name: "Rajoli" },
      { id: 539173, name: "Rakhi" },
      { id: 539205, name: "Ramgad (Rithi)" },
      { id: 942974, name: "Rampur Tukum" },
      { id: 539168, name: "Ranbhumi" },
      { id: 539127, name: "Rankheda" },
      { id: 539167, name: "Ranmul" },
      { id: 539192, name: "Ravanzora" },
      { id: 539109, name: "Sakhara" },
      { id: 539193, name: "Sakhera" },
      { id: 539200, name: "Salaitola" },
      { id: 539150, name: "Sawargaon" },
      { id: 539190, name: "Sawela" },
      { id: 539175, name: "Shirpur Chak" },
      { id: 539176, name: "Shivni" },
      { id: 942981, name: "Sonapur" },
      { id: 539189, name: "Suimara" },
      { id: 539178, name: "Surajpur Chak" },
      { id: 539204, name: "Surya Dongari" },
      { id: 539211, name: "Tadguda" },
      { id: 539120, name: "Tembha" },
      { id: 539197, name: "Tohagaon" },
      { id: 539147, name: "Usegaon" },
      { id: 539172, name: "Vihirgaon Chak" },
      { id: 539165, name: "Vihirgaon Mokasa" },
      { id: 942980, name: "Visapur" },
      { id: 539162, name: "Wakadi" },
      { id: 539098, name: "Wasa" },
      { id: 539096, name: "Wasa Chack N0.1" },
      { id: 539097, name: "Wasa Chak No.2" },
      { id: 539182, name: "Yevli" },
    ],
    4058: [
      { id: 539288, name: "Abapur" },
      { id: 539296, name: "Adyal" },
      { id: 539339, name: "Alapalli Masahat" },
      { id: 539306, name: "Amboli" },
      { id: 539351, name: "Amgaon Chak No.1" },
      { id: 539352, name: "Amgaon Chak No.2" },
      { id: 539348, name: "Amgaon Mahal" },
      { id: 539307, name: "Amrapali" },
      { id: 539419, name: "Anandgram" },
      { id: 539350, name: "Anantpur" },
      { id: 539333, name: "Ankhoda" },
      { id: 539421, name: "Ashti" },
      { id: 539334, name: "Ashti Nokewada" },
      { id: 539411, name: "Bahadupur" },
      { id: 539316, name: "Bamanidev" },
      { id: 539337, name: "Bamhanpeth" },
      { id: 539253, name: "Bandhona" },
      { id: 539293, name: "Bawanchuwa" },
      { id: 539379, name: "Belgatta" },
      { id: 539372, name: "Belgatta Chak" },
      { id: 539355, name: "Bhadbhidi Alias Bilaspur" },
      { id: 539271, name: "Bhadbhidi Mokasa" },
      { id: 539226, name: "Bhendala" },
      { id: 539255, name: "Bhendikanhar" },
      { id: 539246, name: "Bhikshichak" },
      { id: 539245, name: "Bhikshimal" },
      { id: 539281, name: "Bhivapur" },
      { id: 539250, name: "Bhoganbodi" },
      { id: 539332, name: "Bhumaki Rith" },
      { id: 539335, name: "Borghat Rith" },
      { id: 539230, name: "Chakalpeth" },
      { id: 539228, name: "Chamorshi" },
      { id: 539331, name: "Chandankhedi" },
      { id: 539344, name: "Chandankhedi (Vangram)" },
      { id: 539310, name: "Chandeshwar" },
      { id: 539396, name: "Chapalwada" },
      { id: 539390, name: "Chapalwada Chak" },
      { id: 539345, name: "Chaparala" },
      { id: 539346, name: "Chaudampalli" },
      { id: 539257, name: "Chitekanhar" },
      { id: 539298, name: "Chittranjanpur" },
      { id: 539249, name: "Darli Rith" },
      { id: 539389, name: "Darpanguda" },
      { id: 539321, name: "Dharmpur" },
      { id: 539290, name: "Dhekani" },
      { id: 539223, name: "Dotkuli" },
      { id: 539304, name: "Durgapur" },
      { id: 539235, name: "Ekodi" },
      { id: 539220, name: "Farada" },
      { id: 539227, name: "Fokurdi" },
      { id: 539289, name: "Fuser" },
      { id: 539382, name: "Gahubodi" },
      { id: 539410, name: "Gandhinagar" },
      { id: 539301, name: "Ganpur Raiyyatwari" },
      { id: 539285, name: "Gauripur" },
      { id: 539218, name: "Ghargaon" },
      { id: 539387, name: "Ghot" },
      { id: 539254, name: "Gilgaon" },
      { id: 539376, name: "Giripeth" },
      { id: 539418, name: "Gundapalli" },
      { id: 539295, name: "Haladi Chak" },
      { id: 539294, name: "Haladi Mal" },
      { id: 539364, name: "Haladwahi" },
      { id: 539365, name: "Haldawahi Tola (Navgram)" },
      { id: 539269, name: "Hivergaon" },
      { id: 539340, name: "Illur" },
      { id: 539315, name: "Jairampur" },
      { id: 539401, name: "Jambela Rith" },
      { id: 539361, name: "Jamgiri" },
      { id: 539353, name: "Janala Tukum" },
      { id: 539354, name: "Jangam Kurul" },
      { id: 539378, name: "Jawaharnagar" },
      { id: 539242, name: "Jaynagar" },
      { id: 539272, name: "Jogana" },
      { id: 539328, name: "Kadholi" },
      { id: 539236, name: "Kalamgaon" },
      { id: 539322, name: "Kanhalgaon" },
      { id: 539237, name: "Kanholi" },
      { id: 539388, name: "Kardul Tola (Navgram)" },
      { id: 539358, name: "Karkapalli Chak" },
      { id: 539286, name: "Karkapalli Mal" },
      { id: 539224, name: "Khandala" },
      { id: 539330, name: "Khardi Rith" },
      { id: 539268, name: "Khorda Chak" },
      { id: 539299, name: "Kishtapur" },
      { id: 539319, name: "Konsari" },
      { id: 539367, name: "Kothari" },
      { id: 539283, name: "Krishnanagar" },
      { id: 539343, name: "Kunghada Mal" },
      { id: 539252, name: "Kunghada Raiyyatwari" },
      { id: 539266, name: "Kurul" },
      { id: 539258, name: "Kuthegaon" },
      { id: 539244, name: "Lakhamapur Bori" },
      { id: 539303, name: "Laxmanpur" },
      { id: 539275, name: "Lenguda" },
      { id: 539370, name: "Machhalighot" },
      { id: 539394, name: "Made Amgaon" },
      { id: 539405, name: "Made Amgaon Chak No. 2" },
      { id: 539404, name: "Made Amgaon Chak No.1" },
      { id: 539366, name: "Made Mudholi" },
      { id: 539391, name: "Makepalli Chak No.1" },
      { id: 539395, name: "Makepalli Chak No.2" },
      { id: 539393, name: "Makepalli Chak No.3" },
      { id: 539392, name: "Makepalli Chak No.4" },
      { id: 539406, name: "Makepalli Mal" },
      { id: 539261, name: "Maler Chak" },
      { id: 539259, name: "Maler Mal" },
      { id: 539415, name: "Malkapur" },
      { id: 539291, name: "Manger Rith" },
      { id: 539371, name: "Manjigaon" },
      { id: 539338, name: "Markanda Kansoba" },
      { id: 539221, name: "Markandadeo" },
      { id: 539360, name: "Maroda" },
      { id: 539400, name: "Meteguda Rith" },
      { id: 539219, name: "Mohurli Mokasa" },
      { id: 539312, name: "Mudholi Chak No.1" },
      { id: 539311, name: "Mudholi Chak No.2" },
      { id: 539313, name: "Mudholi Rith" },
      { id: 539314, name: "Mudholi Tukum" },
      { id: 539239, name: "Murkhala Chak" },
      { id: 539238, name: "Murkhala Mal" },
      { id: 539273, name: "Murmuri" },
      { id: 539287, name: "Mutnur" },
      { id: 539265, name: "Nachangaon" },
      { id: 539362, name: "Narayanpur Chak No.1" },
      { id: 539357, name: "Narayanpur Chak No.2" },
      { id: 539380, name: "Narayanpurmal" },
      { id: 539416, name: "Narendrapur" },
      { id: 539260, name: "Navargaon" },
      { id: 539398, name: "Navegaon" },
      { id: 539231, name: "Navegaon Mal" },
      { id: 539251, name: "Navegaon Raiyyatwari" },
      { id: 539359, name: "Navgram" },
      { id: 539368, name: "Navnitgram" },
      { id: 539262, name: "Navtala Tukum" },
      { id: 539356, name: "Netajinagar (74)" },
      { id: 944939, name: "Netajinagar (75)" },
      { id: 539399, name: "Nikatwada" },
      { id: 539264, name: "Nimgaon Riyyatwari" },
      { id: 539336, name: "Nokewada Rith" },
      { id: 539409, name: "Palaspur" },
      { id: 539279, name: "Pandhari Bhatal" },
      { id: 539318, name: "Pardi Deo" },
      { id: 539276, name: "Pavi-Muranda" },
      { id: 539278, name: "Pavilasanpeth" },
      { id: 539373, name: "Pettala Chak" },
      { id: 539375, name: "Pettala Mal" },
      { id: 539403, name: "Potepalli Patch" },
      { id: 539402, name: "Potepalli Rayyatwari" },
      { id: 539308, name: "Priyadarshani" },
      { id: 539326, name: "Raipur" },
      { id: 539284, name: "Rajangatta" },
      { id: 539381, name: "Rajgopalpur" },
      { id: 539363, name: "Rajur Bk" },
      { id: 539374, name: "Rajur Kh" },
      { id: 539222, name: "Ramala" },
      { id: 539342, name: "Ramangatta" },
      { id: 539325, name: "Ramkrishnapur" },
      { id: 539324, name: "Rammohanpur" },
      { id: 539267, name: "Rampur" },
      { id: 539327, name: "Rampur (Kadholi)" },
      { id: 539243, name: "Ramsagar" },
      { id: 539384, name: "Rashmipur" },
      { id: 539274, name: "Ravanpalli" },
      { id: 539323, name: "Ravindrapur" },
      { id: 539408, name: "Regadi" },
      { id: 539349, name: "Rekhegaon" },
      { id: 539232, name: "Saganapur" },
      { id: 539297, name: "Saganapur (Bhendala)" },
      { id: 539300, name: "Selur" },
      { id: 539229, name: "Shankarpur" },
      { id: 539377, name: "Shantinagar" },
      { id: 539282, name: "Shrinivaspur" },
      { id: 539385, name: "Shyamanagar" },
      { id: 539369, name: "Simultala" },
      { id: 539347, name: "Singampalli" },
      { id: 539386, name: "Singela Rith" },
      { id: 539320, name: "Somanpalli" },
      { id: 539413, name: "Somanpur" },
      { id: 539248, name: "Sonapur" },
      { id: 539412, name: "Subhashgram" },
      { id: 539263, name: "Talodhi Mokasa" },
      { id: 539341, name: "Thakari" },
      { id: 539414, name: "Thakurnagar" },
      { id: 539256, name: "Thatari" },
      { id: 539417, name: "Tumdi" },
      { id: 539329, name: "Umari" },
      { id: 539420, name: "Vasantpur" },
      { id: 539407, name: "Vikaspalli" },
      { id: 539241, name: "Vikrampur" },
      { id: 539270, name: "Visapur Raiyyatwari" },
      { id: 539383, name: "Vishnupur" },
      { id: 539302, name: "Vittalpur" },
      { id: 539240, name: "Wagdara" },
      { id: 539225, name: "Wagholi" },
      { id: 539309, name: "Waigaon" },
      { id: 539247, name: "Wakadi" },
      { id: 539280, name: "Walsara" },
      { id: 539397, name: "Warur" },
      { id: 539234, name: "Weltur Rith" },
      { id: 539233, name: "Weltur Tukum" },
      { id: 539317, name: "Yadavpalli" },
      { id: 539277, name: "Yedanur" },
      { id: 539305, name: "Yenapur" },
    ],
    4059: [
      { id: 539430, name: "Adangepalli" },
      { id: 539423, name: "Adpalli Chak" },
      { id: 539422, name: "Adpallimal" },
      { id: 539485, name: "Ambatpalli" },
      { id: 539441, name: "Ambela" },
      { id: 539454, name: "Bandukpalli" },
      { id: 539450, name: "Baraswada" },
      { id: 539463, name: "Bhagatnager" },
      { id: 539455, name: "Bhawanipur" },
      { id: 539435, name: "Bolepalli" },
      { id: 539488, name: "Chichela" },
      { id: 539476, name: "Chutugunta Chak" },
      { id: 539479, name: "Dampur" },
      { id: 539439, name: "Deshbandhugram" },
      { id: 539466, name: "Devnagar" },
      { id: 539429, name: "Dewada" },
      { id: 539446, name: "Dhannur" },
      { id: 539465, name: "Fuski Chak" },
      { id: 539464, name: "Fuskimal" },
      { id: 539426, name: "Gandhinagar" },
      { id: 539458, name: "Ganeshnagar" },
      { id: 539449, name: "Gangapur Rith" },
      { id: 539432, name: "Garanji" },
      { id: 539438, name: "Gatta" },
      { id: 539472, name: "Gitali" },
      { id: 539486, name: "Gomani" },
      { id: 539459, name: "Govindpur" },
      { id: 539460, name: "Harinagar" },
      { id: 539436, name: "Hetalkasa" },
      { id: 539425, name: "Kalinagar" },
      { id: 539470, name: "Kanchanpur" },
      { id: 539483, name: "Khudirampalli" },
      { id: 539487, name: "Kodigaon" },
      { id: 539481, name: "Kolpalli" },
      { id: 539444, name: "Kolsapur" },
      { id: 539443, name: "Koparalli Chak" },
      { id: 539442, name: "Koparalli Mal" },
      { id: 539482, name: "Kothari" },
      { id: 539477, name: "Lagam" },
      { id: 539471, name: "Lagamchak" },
      { id: 539469, name: "Lagamheti Pach" },
      { id: 539428, name: "Laxmipur" },
      { id: 539445, name: "Lohara" },
      { id: 539474, name: "Machhigatta" },
      { id: 539447, name: "Mallera" },
      { id: 539489, name: "Marpalli" },
      { id: 539461, name: "Mathuranagar" },
      { id: 539468, name: "Mohurli" },
      { id: 539456, name: "Mukhadi" },
      { id: 539457, name: "Mukhadi Tola" },
      { id: 539451, name: "Mulchera" },
      { id: 539473, name: "Nagulwahi" },
      { id: 944934, name: "Navin Labhantanda" },
      { id: 539434, name: "Pulligudam" },
      { id: 539424, name: "Rengewahi" },
      { id: 539480, name: "Shantigram" },
      { id: 539467, name: "Shrinagar" },
      { id: 539462, name: "Shrirampur" },
      { id: 539484, name: "Sundarnagar" },
      { id: 539433, name: "Surgaon" },
      { id: 539453, name: "Tarunnagar" },
      { id: 539478, name: "Tumargunda" },
      { id: 539448, name: "Udaynagar" },
      { id: 539431, name: "Vengnur" },
      { id: 539427, name: "Vijaynagar" },
      { id: 539440, name: "Vishwanathnagar" },
      { id: 539452, name: "Vivekanandpur" },
      { id: 539475, name: "Yella" },
    ],
    4060: [
      { id: 539683, name: "Abanpalli M" },
      { id: 539611, name: "Adange (M)" },
      { id: 539664, name: "Aldandi (M)" },
      { id: 539663, name: "Aldandi (S)" },
      { id: 539635, name: "Alenga (M)" },
      { id: 539623, name: "Alenga (S)" },
      { id: 539523, name: "Alenga M(Kokobanda)" },
      { id: 539532, name: "Asawandi" },
      { id: 539646, name: "Bande (M)" },
      { id: 539640, name: "Barsewada (M)" },
      { id: 539578, name: "Bater (M)" },
      { id: 539616, name: "Besewada" },
      { id: 539506, name: "Bhapda" },
      { id: 539526, name: "Bhumkan" },
      { id: 539667, name: "Birdi (S)" },
      { id: 539624, name: "Bodmeta" },
      { id: 539569, name: "Burgi (M)" },
      { id: 539674, name: "Burgi (S)" },
      { id: 539629, name: "Chandanweli (S)" },
      { id: 539501, name: "Channabodi" },
      { id: 539547, name: "Chokhewada" },
      { id: 539596, name: "Deopadi" },
      { id: 539580, name: "Dewada M" },
      { id: 539491, name: "Dindvi" },
      { id: 539639, name: "Doddi (M)" },
      { id: 539636, name: "Doddi S" },
      { id: 539586, name: "Dodhur (S)" },
      { id: 539496, name: "Dolanda" },
      { id: 539651, name: "Dumme (S)" },
      { id: 539632, name: "Ekansur (M)" },
      { id: 539631, name: "Ekansur (S)" },
      { id: 539648, name: "Ekara Bk." },
      { id: 539658, name: "Ekara Kh." },
      { id: 539650, name: "Etapalli (S)" },
      { id: 539536, name: "Gadadapalli" },
      { id: 539552, name: "Gaderi" },
      { id: 539597, name: "Gardewada" },
      { id: 539494, name: "Gartawahi" },
      { id: 539615, name: "Gatta (S)" },
      { id: 539614, name: "Gattaguda (S)" },
      { id: 539686, name: "Gattepalli" },
      { id: 539577, name: "Gattepalli (S)" },
      { id: 539630, name: "Geda" },
      { id: 539540, name: "Ghotsur" },
      { id: 539620, name: "Gilanguda" },
      { id: 539607, name: "Godeli (M)" },
      { id: 539626, name: "Gorgutta (M)" },
      { id: 539541, name: "Gudram" },
      { id: 539512, name: "Gumadi M" },
      { id: 539527, name: "Gundam" },
      { id: 539628, name: "Gundjur" },
      { id: 539655, name: "Gurupalli" },
      { id: 539594, name: "Hachbodi" },
      { id: 539575, name: "Halewara" },
      { id: 539514, name: "Hanapaili" },
      { id: 539660, name: "Hedri S" },
      { id: 539584, name: "Hetalkasa" },
      { id: 539592, name: "Hikker (M)" },
      { id: 539590, name: "Hindur (M)" },
      { id: 539509, name: "Irpanpaili" },
      { id: 539608, name: "Itulnar" },
      { id: 539601, name: "Jajawandi" },
      { id: 539613, name: "Jambiya" },
      { id: 539499, name: "Jambulgatta" },
      { id: 539500, name: "Jarawandi" },
      { id: 539621, name: "Jarewada (S)" },
      { id: 539654, name: "Jaweli (M)" },
      { id: 539529, name: "Jaweli Bk (S)" },
      { id: 539565, name: "Jaweli Kh (S)" },
      { id: 539564, name: "Jijawandi" },
      { id: 539643, name: "Jiwangatta" },
      { id: 539571, name: "Kachler" },
      { id: 539560, name: "Kamke Alias Ghotsur" },
      { id: 539508, name: "Kandli" },
      { id: 539684, name: "Kandoli (M)" },
      { id: 539685, name: "Kandoli (S)" },
      { id: 539530, name: "Kanhalgaon (M)" },
      { id: 539645, name: "Karampalli (S)" },
      { id: 539673, name: "Karapanfundi (M)" },
      { id: 539543, name: "Karka Bk." },
      { id: 539531, name: "Karka Kh" },
      { id: 539528, name: "Karrem (M)" },
      { id: 539666, name: "Karrem (Yemli)" },
      { id: 539546, name: "Kasansur" },
      { id: 539517, name: "Kasurwahi" },
      { id: 539518, name: "Kohaka" },
      { id: 539537, name: "Koindul" },
      { id: 539617, name: "Koindwarshi" },
      { id: 539551, name: "Kondawahi" },
      { id: 539677, name: "Kondawahi (M)" },
      { id: 539573, name: "Kornar (M)" },
      { id: 539539, name: "Kothari" },
      { id: 539574, name: "Kothi (M)" },
      { id: 539534, name: "Kotmi" },
      { id: 539544, name: "Kottakonda Bk." },
      { id: 539545, name: "Kottakonda Kh." },
      { id: 539642, name: "Krishnar" },
      { id: 539581, name: "Kudari (S)" },
      { id: 539563, name: "Kukeli (M)" },
      { id: 539568, name: "Kundum" },
      { id: 539627, name: "Kunjemarka (M)" },
      { id: 539495, name: "Kurumwada" },
      { id: 539634, name: "Lanzi (S)" },
      { id: 539591, name: "Macchawancha Chek" },
      { id: 539538, name: "Magdandi" },
      { id: 539641, name: "Makkepalli" },
      { id: 539511, name: "Malangatta" },
      { id: 539605, name: "Mallampad (S)" },
      { id: 539521, name: "Mandoli Rithi" },
      { id: 539542, name: "Manewara" },
      { id: 539661, name: "Mangar (S)" },
      { id: 539682, name: "Mangutha (M)" },
      { id: 539503, name: "Manjigad" },
      { id: 539595, name: "Mardkuhi (S)" },
      { id: 539671, name: "Markal" },
      { id: 539652, name: "Marpalli (S)" },
      { id: 539579, name: "Maveli(M)" },
      { id: 539522, name: "Medhari (Tekka)" },
      { id: 539566, name: "Medhari (Wangeturi)" },
      { id: 539602, name: "Modaske" },
      { id: 539619, name: "Mohandi" },
      { id: 539583, name: "Moharli" },
      { id: 539510, name: "Morawahi" },
      { id: 539497, name: "Mungner" },
      { id: 539593, name: "Murwada" },
      { id: 539554, name: "Musaramguda M." },
      { id: 539553, name: "Musaramguda S." },
      { id: 539582, name: "Nagulwadi (M)" },
      { id: 539535, name: "Nainguda" },
      { id: 539533, name: "Nawegaon" },
      { id: 539604, name: "Nender (M)" },
      { id: 539585, name: "Nendwadi" },
      { id: 539520, name: "Paidi" },
      { id: 539680, name: "Paima (M)" },
      { id: 539681, name: "Paima (S)" },
      { id: 539610, name: "Pamajiguda (S)" },
      { id: 539665, name: "Pandewahi (M)" },
      { id: 539656, name: "Pandewahi (S)" },
      { id: 539662, name: "Parsalgondi (S)" },
      { id: 539525, name: "Pendulwahi" },
      { id: 539559, name: "Petha (Halewara)" },
      { id: 539647, name: "Petha (S)" },
      { id: 539678, name: "Pindigundam(M)" },
      { id: 539557, name: "Punnur (S)" },
      { id: 539609, name: "Pursalgondi" },
      { id: 539603, name: "Puske (M)" },
      { id: 539588, name: "Puskoti (S)" },
      { id: 539622, name: "Pusumpalli (M)" },
      { id: 539572, name: "Ragadandi" },
      { id: 539516, name: "Recha" },
      { id: 539587, name: "Rekabhatal" },
      { id: 539599, name: "Rekameta" },
      { id: 539519, name: "Reknar" },
      { id: 539672, name: "Reknar (S)" },
      { id: 539524, name: "Ropi" },
      { id: 539515, name: "Sarkheda" },
      { id: 539562, name: "Sewari" },
      { id: 539561, name: "Sewari (M)" },
      { id: 539505, name: "Sinbhatti" },
      { id: 539492, name: "Sirpur" },
      { id: 539502, name: "Sohagaon" },
      { id: 539606, name: "Surjagad" },
      { id: 539598, name: "Tadguda" },
      { id: 539633, name: "Tadpalli Alias Naralhur" },
      { id: 539638, name: "Tambada (M)" },
      { id: 539637, name: "Tambada (S)" },
      { id: 539669, name: "Tatigundam (M)" },
      { id: 539668, name: "Tatigundam (S)" },
      { id: 539513, name: "Tekka" },
      { id: 539612, name: "Titoda (S)" },
      { id: 539589, name: "Todgatta (M)" },
      { id: 539644, name: "Todsa (S)" },
      { id: 539657, name: "Tumargunda Bk." },
      { id: 539649, name: "Tumargunda Kh" },
      { id: 539675, name: "Udera (M)" },
      { id: 539670, name: "Udera (S)" },
      { id: 539507, name: "Umargatta" },
      { id: 539618, name: "Wadavi" },
      { id: 539498, name: "Wadsa Kh" },
      { id: 539490, name: "Wadsakala" },
      { id: 539556, name: "Waghezari (M)" },
      { id: 539555, name: "Waghezari (S)" },
      { id: 539504, name: "Wandoli" },
      { id: 539567, name: "Wangeturi" },
      { id: 539653, name: "Wasamundi" },
      { id: 539600, name: "Wateli" },
      { id: 539576, name: "Wattegatta(M)" },
      { id: 539570, name: "Welmagad" },
      { id: 539493, name: "Welmgad" },
      { id: 539558, name: "Wenasar" },
      { id: 539625, name: "Yadasgondi" },
      { id: 539676, name: "Yemali" },
      { id: 539550, name: "Yetawahi" },
      { id: 539659, name: "Zarewada" },
      { id: 539549, name: "Zurri (M)" },
      { id: 539548, name: "Zurri S." },
    ],
    4061: [
      { id: 539741, name: "Arewada" },
      { id: 539695, name: "Badsi (M)" },
      { id: 539765, name: "Bangadi (M)" },
      { id: 539751, name: "Bejur" },
      { id: 539754, name: "Bhamaragad" },
      { id: 539798, name: "Bhatpar" },
      { id: 539769, name: "Bhusewada (M)" },
      { id: 539733, name: "Binagunda (M)" },
      { id: 539785, name: "Bodange" },
      { id: 539783, name: "Boriya" },
      { id: 539723, name: "Botanfundi" },
      { id: 539807, name: "Brahmanpalli" },
      { id: 539777, name: "Chichoda" },
      { id: 539711, name: "Damanmarka" },
      { id: 539784, name: "Darbha" },
      { id: 539757, name: "Dhodraj" },
      { id: 539705, name: "Dirangi (M)" },
      { id: 539715, name: "Dobhur" },
      { id: 539755, name: "Dubbaguda" },
      { id: 539809, name: "Dubbagudam" },
      { id: 539746, name: "Dudepalli" },
      { id: 539708, name: "Fodewada (M)" },
      { id: 539701, name: "Fulcher(M)" },
      { id: 539702, name: "Fulnar" },
      { id: 539722, name: "Fundi (M)" },
      { id: 539795, name: "Gardewada M" },
      { id: 539788, name: "Garewada M" },
      { id: 539812, name: "Ghotpadi" },
      { id: 539772, name: "Golaguda" },
      { id: 539796, name: "Gongwada (M)" },
      { id: 539787, name: "Gongwada (S)" },
      { id: 539731, name: "Gopnar" },
      { id: 539781, name: "Goranur (M)" },
      { id: 539687, name: "Gundapuri" },
      { id: 539737, name: "Gundenhod" },
      { id: 539814, name: "Gundjur" },
      { id: 539704, name: "Gundurwahi" },
      { id: 539712, name: "Halodandi (M)" },
      { id: 539719, name: "Halver" },
      { id: 539752, name: "Hemalkasa" },
      { id: 539794, name: "Hikkameta" },
      { id: 539760, name: "Hindewada (M)" },
      { id: 539730, name: "Hindur" },
      { id: 539799, name: "Hitalwara" },
      { id: 539740, name: "Hitapadi" },
      { id: 539732, name: "Hodari" },
      { id: 539748, name: "Irakdumme(M)" },
      { id: 539770, name: "Irapanar (S)" },
      { id: 539793, name: "Japeli (M)" },
      { id: 539782, name: "Jijgaon" },
      { id: 539806, name: "Jonawahi" },
      { id: 539771, name: "Juvvi" },
      { id: 539742, name: "Karampalli" },
      { id: 539776, name: "Kasansur" },
      { id: 539713, name: "Kathalasur" },
      { id: 539721, name: "Katrangatta" },
      { id: 539813, name: "Kawande" },
      { id: 539778, name: "Kedmarra M" },
      { id: 539779, name: "Kedmarra(S)" },
      { id: 539773, name: "Kehakapari" },
      { id: 539690, name: "Khandinainwadi" },
      { id: 539728, name: "Kiyar (S)" },
      { id: 539726, name: "Kodape" },
      { id: 539789, name: "Kokapadi" },
      { id: 539700, name: "Korparsi" },
      { id: 539745, name: "Kosfundi(M)" },
      { id: 539696, name: "Kothi S" },
      { id: 539767, name: "Kotwara M" },
      { id: 539753, name: "Koyanguda" },
      { id: 539790, name: "Koyar (M)" },
      { id: 539729, name: "Krisnar S" },
      { id: 539691, name: "Kucher" },
      { id: 539768, name: "Kucher (M)" },
      { id: 539747, name: "Kudkeli" },
      { id: 539759, name: "Kukkametha" },
      { id: 539744, name: "Kumarguda" },
      { id: 539694, name: "Kumhur" },
      { id: 539735, name: "Kuwwakodi" },
      { id: 539763, name: "Laheri (M)" },
      { id: 539762, name: "Laheri (S)" },
      { id: 539739, name: "Lashkar (S)" },
      { id: 539802, name: "Madveli" },
      { id: 539811, name: "Malenga" },
      { id: 539761, name: "Mallampodhur" },
      { id: 539805, name: "Manne Rajaram" },
      { id: 539801, name: "Marampalli" },
      { id: 539689, name: "Mardahur" },
      { id: 539703, name: "Markanar" },
      { id: 539756, name: "Medpalli" },
      { id: 539810, name: "Midadapalli" },
      { id: 539717, name: "Mirgulwancha" },
      { id: 539780, name: "Mokela" },
      { id: 539706, name: "Moradpar" },
      { id: 539766, name: "Murangal" },
      { id: 539699, name: "Murumbhusi" },
      { id: 539764, name: "Muspadi" },
      { id: 539693, name: "Muttenkuni" },
      { id: 539718, name: "Nargunda M" },
      { id: 539797, name: "Nelgunda (M)" },
      { id: 539792, name: "Nulwara (M)" },
      { id: 539692, name: "Padhur (S)" },
      { id: 539749, name: "Padtampalli" },
      { id: 539774, name: "Palli (S)" },
      { id: 539786, name: "Parainar" },
      { id: 539804, name: "Parli M" },
      { id: 539710, name: "Permalbhatti" },
      { id: 539716, name: "Pidmili" },
      { id: 539720, name: "Pokur" },
      { id: 539714, name: "Poyarkothi" },
      { id: 539736, name: "Pungasur" },
      { id: 539791, name: "Puswara" },
      { id: 539758, name: "Ranipodur" },
      { id: 539800, name: "Rela" },
      { id: 539803, name: "Sipanpalli" },
      { id: 539750, name: "Tadgaon" },
      { id: 539738, name: "Tadpar (M)" },
      { id: 539727, name: "Tekala" },
      { id: 539707, name: "Timeli" },
      { id: 539743, name: "Tirkameta" },
      { id: 539697, name: "Toynar" },
      { id: 539698, name: "Tumarkodi" },
      { id: 539709, name: "Turremarka M" },
      { id: 539724, name: "Vateli (S)" },
      { id: 539725, name: "Vengdur" },
      { id: 539688, name: "Visamundi" },
      { id: 539734, name: "Wengurwada (M)" },
      { id: 539808, name: "Yechali S" },
      { id: 539775, name: "Zareguda (M)" },
    ],
    4062: [
      { id: 539863, name: "Abanpalli (M)" },
      { id: 539864, name: "Abanpalli (S)" },
      { id: 539998, name: "Aheri" },
      { id: 539884, name: "Aldandi (M)" },
      { id: 539850, name: "Allapalli" },
      { id: 539946, name: "Ambezara" },
      { id: 539832, name: "Appapalli (M)" },
      { id: 539899, name: "Arenda" },
      { id: 539953, name: "Arkapalli" },
      { id: 539924, name: "Asa M" },
      { id: 539976, name: "Asali (M)" },
      { id: 539939, name: "Avalmari" },
      { id: 539927, name: "Bhangarampetha" },
      { id: 539968, name: "Bhaswapur" },
      { id: 539948, name: "Bhimaram M" },
      { id: 539997, name: "Birhadghat" },
      { id: 539994, name: "Bondra M" },
      { id: 539828, name: "Bori" },
      { id: 539833, name: "Botlacheru" },
      { id: 539853, name: "Burukmalampalli" },
      { id: 539901, name: "Chandra M" },
      { id: 539883, name: "Chandra S" },
      { id: 539900, name: "Chaudampalli" },
      { id: 539857, name: "Cherpalli S" },
      { id: 539931, name: "Chhallewada" },
      { id: 539854, name: "Chinchgundi" },
      { id: 539825, name: "Chintalpeth" },
      { id: 539896, name: "Chirepalli" },
      { id: 539929, name: "Chitweli" },
      { id: 539947, name: "Dabbatog M" },
      { id: 539971, name: "Damaram M" },
      { id: 539959, name: "Damaram S" },
      { id: 539926, name: "Damrancha" },
      { id: 539987, name: "Dechali S" },
      { id: 539871, name: "Devalmari M Rithi" },
      { id: 539870, name: "Devalmari S" },
      { id: 539837, name: "Dinacherapalli" },
      { id: 539848, name: "Dodepalli" },
      { id: 539975, name: "Dodger" },
      { id: 539961, name: "Dubbagudam" },
      { id: 539855, name: "Gadaheri" },
      { id: 539856, name: "Gadaheribamni" },
      { id: 539930, name: "Garewada Rithi" },
      { id: 539911, name: "Golakaraji" },
      { id: 539934, name: "Gotelingampalli" },
      { id: 539951, name: "Govindgaon" },
      { id: 539909, name: "Gudigudam" },
      { id: 539952, name: "Gundera" },
      { id: 539879, name: "Gurja Bk" },
      { id: 539905, name: "Gurja Kh" },
      { id: 539866, name: "Indaram (M)" },
      { id: 539865, name: "Indaram S" },
      { id: 539841, name: "Italcheru" },
      { id: 539816, name: "Jamgaon" },
      { id: 539958, name: "Jimmalgatta S" },
      { id: 539967, name: "Joganguda (Dechali)" },
      { id: 539985, name: "Joganguda (Umanur)" },
      { id: 539881, name: "Kachler" },
      { id: 539992, name: "Kalled" },
      { id: 539933, name: "Kamalpur" },
      { id: 539986, name: "Kamasur" },
      { id: 539840, name: "Kannepalli" },
      { id: 539949, name: "Karancha" },
      { id: 539877, name: "Kasampalli M." },
      { id: 539891, name: "Katepalli M" },
      { id: 539890, name: "Katepalli S" },
      { id: 539916, name: "Kavatharam" },
      { id: 539942, name: "Kerneli M" },
      { id: 539943, name: "Kerneli S" },
      { id: 539836, name: "Khamancheru" },
      { id: 539913, name: "Khandala S" },
      { id: 539979, name: "Kishtapur M" },
      { id: 539974, name: "Kishtapur S" },
      { id: 539818, name: "Kishtapur Welgur" },
      { id: 539921, name: "Kodekasa" },
      { id: 539919, name: "Kodsepalli M" },
      { id: 539918, name: "Kodsepalli S" },
      { id: 539935, name: "Kolamarka" },
      { id: 539893, name: "Kolapalli M" },
      { id: 539995, name: "Konjed" },
      { id: 539882, name: "Koreli Bk" },
      { id: 539886, name: "Koreli Kh" },
      { id: 539906, name: "Korepalli" },
      { id: 539847, name: "Krishnapur (Aheri)" },
      { id: 539829, name: "Kultha" },
      { id: 539920, name: "Kurumpalli" },
      { id: 539956, name: "Lakhanguda (M)" },
      { id: 539957, name: "Lakhanguda S" },
      { id: 539944, name: "Lankachen M" },
      { id: 539945, name: "Lankachen S" },
      { id: 539936, name: "Lingampalli" },
      { id: 539993, name: "Lowa S" },
      { id: 539839, name: "Mahagaon Bk" },
      { id: 539838, name: "Mahagaon Kh" },
      { id: 539845, name: "Mahagaon M Rithi" },
      { id: 539819, name: "Mailaram" },
      { id: 539922, name: "Mandra S" },
      { id: 539907, name: "Marneli" },
      { id: 539960, name: "Marpalli" },
      { id: 539972, name: "Medpalli(Jimalgatta)" },
      { id: 539878, name: "Medpalli(Permili)" },
      { id: 539996, name: "Metigudam" },
      { id: 539887, name: "Michaguda" },
      { id: 539888, name: "Mirkal M" },
      { id: 539937, name: "Modumadgu (Kamlapur)" },
      { id: 539842, name: "Modumadgu (Mandra)" },
      { id: 539923, name: "Modumdagu (Ramayyapetha)" },
      { id: 539868, name: "Modumtura M" },
      { id: 539869, name: "Modumtura S" },
      { id: 539889, name: "Mosam (S)" },
      { id: 539962, name: "Motukpalli S" },
      { id: 539963, name: "Mudewahi" },
      { id: 539984, name: "Mukhanpalli" },
      { id: 539852, name: "Nagepalli M" },
      { id: 539849, name: "Nagepalli S Rithi" },
      { id: 539917, name: "Nainer M" },
      { id: 539925, name: "Naingudam" },
      { id: 539892, name: "Nandigaon M" },
      { id: 539823, name: "Nawegaon" },
      { id: 539902, name: "Palle S" },
      { id: 539955, name: "Pattigaon" },
      { id: 539914, name: "Pattigaon M" },
      { id: 539915, name: "Pattigaon S" },
      { id: 539978, name: "Perkabhati S" },
      { id: 539885, name: "Permili" },
      { id: 539990, name: "Peta S" },
      { id: 539860, name: "Pusukpalli" },
      { id: 539912, name: "Rajaram" },
      { id: 539826, name: "Rajpur Patch" },
      { id: 539834, name: "Ramayyapetha" },
      { id: 539830, name: "Rampur Chak" },
      { id: 539843, name: "Rampur M" },
      { id: 539844, name: "Rampur S" },
      { id: 539903, name: "Rapeli" },
      { id: 539980, name: "Raspalli S" },
      { id: 539910, name: "Raygatta" },
      { id: 539964, name: "Regulwahi" },
      { id: 539938, name: "Repanpalli" },
      { id: 539897, name: "Sakangatta" },
      { id: 539867, name: "Sandra S" },
      { id: 539966, name: "Silmpalli" },
      { id: 539983, name: "Sinda M" },
      { id: 539977, name: "Sinda S" },
      { id: 539815, name: "Singanpeth" },
      { id: 539969, name: "Suddagudam" },
      { id: 539898, name: "Tadguda" },
      { id: 539876, name: "Talwada" },
      { id: 539835, name: "Tanbodi" },
      { id: 539932, name: "Tatigudam" },
      { id: 539858, name: "Tekampalli" },
      { id: 539827, name: "Tikepalli" },
      { id: 539965, name: "Timaram (Umanur)" },
      { id: 539895, name: "Timaram M" },
      { id: 539908, name: "Timaram S" },
      { id: 539988, name: "Todka M" },
      { id: 539989, name: "Todka S" },
      { id: 539928, name: "Tonder" },
      { id: 539981, name: "Umanur M" },
      { id: 539982, name: "Umanur S" },
      { id: 539880, name: "Vedampalli" },
      { id: 539862, name: "Vyankatraopeta M" },
      { id: 539861, name: "Vyankatraopeta S" },
      { id: 539940, name: "Vyenkatapur M" },
      { id: 539941, name: "Vyenkatapur S" },
      { id: 539831, name: "Wadla Peth" },
      { id: 539846, name: "Wange Palli" },
      { id: 539873, name: "Watra Bk M" },
      { id: 539872, name: "Watra Bk S" },
      { id: 539874, name: "Watra Kh M" },
      { id: 539875, name: "Watra Kh S" },
      { id: 539817, name: "Welgur M Rithi" },
      { id: 539824, name: "Welgur S" },
      { id: 539822, name: "Welgurtola" },
      { id: 539954, name: "Yedampalli" },
      { id: 539973, name: "Yedranga" },
      { id: 539820, name: "Yelchil" },
      { id: 539991, name: "Yellaram" },
      { id: 539950, name: "Yenkabanda" },
      { id: 539851, name: "Yenkapalli" },
      { id: 539970, name: "Yeragadda" },
      { id: 539904, name: "Yermanar" },
      { id: 539894, name: "Zimela" },
    ],
    4063: [
      { id: 540072, name: "Addimuttapur" },
      { id: 540100, name: "Ahmadali" },
      { id: 540120, name: "Aipeta Ry." },
      { id: 540053, name: "Amravati C.L." },
      { id: 540052, name: "Amravati Mal" },
      { id: 540055, name: "Amravati Patch" },
      { id: 540125, name: "Ankisa Chak" },
      { id: 540140, name: "Ankisa Mal" },
      { id: 540086, name: "Arda(Mal)" },
      { id: 540138, name: "Asaralli" },
      { id: 540139, name: "Balmutyampalli" },
      { id: 540032, name: "Bamni" },
      { id: 540019, name: "Bejurpalli" },
      { id: 540062, name: "Bhogapur Patch" },
      { id: 540063, name: "Bhogapur W.L." },
      { id: 540088, name: "Bodukasa Ry" },
      { id: 540003, name: "Bogatagudam" },
      { id: 540000, name: "Bondra" },
      { id: 540027, name: "Borampalli Mal" },
      { id: 540033, name: "Borampalli Patch" },
      { id: 540084, name: "Bramhanpalli Chek" },
      { id: 540073, name: "Bramhanpalli Ry." },
      { id: 540013, name: "Chandaram Chak" },
      { id: 540006, name: "Chandaram Mal" },
      { id: 540011, name: "Chikyala" },
      { id: 540080, name: "Chintalpalli" },
      { id: 540143, name: "Chintarevala" },
      { id: 540065, name: "Chipurdubba Ry." },
      { id: 540111, name: "Chittur Ry" },
      { id: 540001, name: "Darshewada" },
      { id: 540141, name: "Ganjiramannapeta" },
      { id: 540036, name: "Garkapetha M." },
      { id: 540034, name: "Glassfordpetha" },
      { id: 540126, name: "Golagudam Chak" },
      { id: 540127, name: "Golagudam Mal" },
      { id: 540098, name: "Gontha" },
      { id: 540132, name: "Gumalkonda Patch" },
      { id: 540133, name: "Gumalkonda Ry" },
      { id: 540021, name: "Jafrabad Chak" },
      { id: 540130, name: "Jafrabad Patch" },
      { id: 540129, name: "Jafrabad Ry" },
      { id: 540022, name: "Jafrabad W.L." },
      { id: 540077, name: "Janampalli Chak" },
      { id: 540078, name: "Janampalli W.L." },
      { id: 540018, name: "Jarjpetha" },
      { id: 540094, name: "Jinganur Ch No.1" },
      { id: 540093, name: "Jinganur Ch No.2" },
      { id: 540095, name: "Jinganur Mal" },
      { id: 540029, name: "Kambalpeta Chak" },
      { id: 540028, name: "Kambapeta Ry." },
      { id: 540054, name: "Karaspalli" },
      { id: 540060, name: "Karaspalli Mal" },
      { id: 540089, name: "Karjeli Ry" },
      { id: 540091, name: "Kistyaplli" },
      { id: 540096, name: "Korla Chak" },
      { id: 540097, name: "Korla Mal" },
      { id: 540144, name: "Kotapalli Ry" },
      { id: 540044, name: "Kotha Patch" },
      { id: 540042, name: "Kottamal" },
      { id: 540004, name: "Kottapalli Mal" },
      { id: 540107, name: "Kottur Patch" },
      { id: 540108, name: "Kottur Ry" },
      { id: 540123, name: "Laxmidevi Petha Chak" },
      { id: 540110, name: "Laxmidevi Petha Ry" },
      { id: 540113, name: "Laxmipur Ry" },
      { id: 540020, name: "Madaram Ry" },
      { id: 540082, name: "Maddikuntha" },
      { id: 540081, name: "Mandalapur" },
      { id: 540099, name: "Mangigudam Ry" },
      { id: 540057, name: "Marrigudam" },
      { id: 540059, name: "Medaram Chak" },
      { id: 540061, name: "Medaram Mal" },
      { id: 540025, name: "Mokela" },
      { id: 539999, name: "Moyabinpetha" },
      { id: 540116, name: "Mrudukrishnapur" },
      { id: 540117, name: "Mugapur" },
      { id: 540134, name: "Mukadiguta Ry" },
      { id: 540135, name: "Muttapur Chak" },
      { id: 540136, name: "Muttapur Mal" },
      { id: 540145, name: "Nadikuda" },
      { id: 540069, name: "Nagram" },
      { id: 540074, name: "Nandigaon Chak" },
      { id: 540075, name: "Nandigaon Ry." },
      { id: 540009, name: "Narsayyapalli" },
      { id: 540070, name: "Nasirkhan Palli" },
      { id: 540026, name: "Nemada" },
      { id: 540010, name: "Parsewada" },
      { id: 540104, name: "Patagudam" },
      { id: 540106, name: "Pendalaya" },
      { id: 540118, name: "Pentipaka Chak" },
      { id: 540115, name: "Pentipaka W.L." },
      { id: 540012, name: "Pirmeda" },
      { id: 540122, name: "Pochampalli Ry" },
      { id: 540103, name: "Pulligudam" },
      { id: 540105, name: "Raigudam" },
      { id: 540041, name: "Raipeth Ali Pochampalli" },
      { id: 540049, name: "Raipetha Mal" },
      { id: 540085, name: "Rajanna Palli" },
      { id: 540114, name: "Rajeshwarpalli Chak" },
      { id: 540079, name: "Ramanjpur Chak" },
      { id: 540083, name: "Ramanjpur Tole" },
      { id: 540076, name: "Ramanjpur W.L." },
      { id: 540008, name: "Ramannapetha Ray" },
      { id: 540067, name: "Ramanuja Ganpati" },
      { id: 540090, name: "Rameshgudam" },
      { id: 540068, name: "Ramkrishnapur" },
      { id: 540142, name: "Rangadham Peth M." },
      { id: 540124, name: "Rangadhampetha Chak" },
      { id: 540048, name: "Rangayapalli Patch" },
      { id: 540051, name: "Rangayapalli W. B." },
      { id: 540050, name: "Rangayapalli W.L." },
      { id: 540016, name: "Reguntha Chak" },
      { id: 540015, name: "Reguntha Mal" },
      { id: 540030, name: "Rompalli" },
      { id: 540046, name: "Sirkonda Ch.No.1" },
      { id: 540038, name: "Sirkonda Ch.No.2" },
      { id: 540039, name: "Sirkonda Mal" },
      { id: 540071, name: "Sironcha Mal" },
      { id: 540146, name: "Sironcha Ry." },
      { id: 540109, name: "Somanpalli Mal" },
      { id: 540131, name: "Somnur Mal" },
      { id: 540128, name: "Sunkaralli" },
      { id: 540064, name: "Tamandala Mal" },
      { id: 540137, name: "Tekadamotala" },
      { id: 540024, name: "Tekda Chak" },
      { id: 540023, name: "Tekda Tala" },
      { id: 540056, name: "Tigalgudam" },
      { id: 540112, name: "Tumnur Chak" },
      { id: 540119, name: "Tumnur Mal" },
      { id: 540035, name: "Venkatapur" },
      { id: 540037, name: "Venlaya Mal" },
      { id: 540031, name: "Venlaya Patch" },
      { id: 540005, name: "Vitthalraopeta Chak" },
      { id: 540007, name: "Vitthalraopeta Mal" },
      { id: 540014, name: "Vitthalraopetha W.L." },
      { id: 540043, name: "Viyamapalli" },
      { id: 540121, name: "Waddam" },
      { id: 540092, name: "Waddeli Ry" },
      { id: 540087, name: "Yedsili" },
      { id: 540017, name: "Yellamal" },
      { id: 540066, name: "Yeracheru Mal" },
      { id: 540058, name: "Yerrgunthametham Alias Narayanpur" },
      { id: 540045, name: "Yetakota Ch.No.1" },
      { id: 540040, name: "Yetakota Ch.No.2" },
      { id: 540002, name: "Zenda" },
    ],
    4064: [
      { id: 540230, name: "Aalfar Satara" },
      { id: 540276, name: "Aambhora Rith" },
      { id: 540168, name: "Aashi" },
      { id: 540205, name: "Aashti" },
      { id: 540282, name: "Abamakta" },
      { id: 540239, name: "Ajangaon" },
      { id: 540287, name: "Akola" },
      { id: 540180, name: "Amadi" },
      { id: 540197, name: "Anandvan" },
      { id: 540312, name: "Antapur Rith" },
      { id: 540325, name: "Arjuni" },
      { id: 540326, name: "Arjuni Tukum" },
      { id: 540238, name: "Arvi" },
      { id: 540266, name: "Asala" },
      { id: 540262, name: "Atmurdi" },
      { id: 540173, name: "Bakharda Rith" },
      { id: 540174, name: "Bamarda" },
      { id: 540271, name: "Bandara" },
      { id: 540217, name: "Barvha" },
      { id: 540184, name: "Belgaon" },
      { id: 540306, name: "Belgaon Chak" },
      { id: 908970, name: "Belgoan Bhoyar" },
      { id: 908968, name: "Bembal Rith" },
      { id: 540305, name: "Bembal Tukum" },
      { id: 540328, name: "Bhanusakhindi Rith" },
      { id: 540267, name: "Bhatala" },
      { id: 540311, name: "Bhendala" },
      { id: 540223, name: "Bodakha" },
      { id: 540218, name: "Bopapur" },
      { id: 540202, name: "Borda" },
      { id: 540296, name: "Borgaon Bhosale" },
      { id: 540270, name: "Borgaon Deshpande" },
      { id: 540292, name: "Borgaon Mokasa" },
      { id: 540179, name: "Borgaon Rith" },
      { id: 540245, name: "Borgaon Shiwanfal" },
      { id: 540178, name: "Bori" },
      { id: 540227, name: "Chak Kawadapur" },
      { id: 540224, name: "Chakmaksur" },
      { id: 540303, name: "Chargaon Bk." },
      { id: 540310, name: "Chargaon Kh." },
      { id: 540304, name: "Chargaon Tukum" },
      { id: 540190, name: "Charurkhati" },
      { id: 540253, name: "Chichala" },
      { id: 540257, name: "Chikani" },
      { id: 540196, name: "Chinora" },
      { id: 540322, name: "Dadapur" },
      { id: 540258, name: "Dahala Rith" },
      { id: 540183, name: "Dahegaon" },
      { id: 540324, name: "Dhanoli" },
      { id: 540175, name: "Dindoda" },
      { id: 540274, name: "Dindoda Khurd" },
      { id: 540259, name: "Dongargaon" },
      { id: 540210, name: "Ekarjuma" },
      { id: 540191, name: "Ekona" },
      { id: 540236, name: "Fattapur" },
      { id: 540147, name: "Gaoshet" },
      { id: 540214, name: "Gaul Bk" },
      { id: 540151, name: "Gaul Kh" },
      { id: 540281, name: "Girola" },
      { id: 540165, name: "Girsawali" },
      { id: 540249, name: "Gujgavhan" },
      { id: 540294, name: "Gunjala" },
      { id: 908975, name: "Gurhad Rith" },
      { id: 540235, name: "Hirapur" },
      { id: 540148, name: "Hiwara" },
      { id: 540160, name: "Jalka" },
      { id: 540255, name: "Jamani Bk" },
      { id: 540200, name: "Jamgaon" },
      { id: 540213, name: "Jamgaon Kh" },
      { id: 540150, name: "Jamkhula" },
      { id: 908980, name: "Jamni Rith" },
      { id: 540208, name: "Kalamgavhan" },
      { id: 540207, name: "Karanji" },
      { id: 540228, name: "Kawadapur Mokasa" },
      { id: 540302, name: "Kawadsi" },
      { id: 540298, name: "Kekapur Rith" },
      { id: 540154, name: "Keli" },
      { id: 540248, name: "Kem" },
      { id: 540198, name: "Khairgaon" },
      { id: 540219, name: "Khambada" },
      { id: 540203, name: "Khanji" },
      { id: 540260, name: "Khapari" },
      { id: 540167, name: "Khartangadi Rith" },
      { id: 540159, name: "Kharwad" },
      { id: 540272, name: "Khatoda" },
      { id: 540315, name: "Khekadapur Rith" },
      { id: 540318, name: "Khekadi Rith" },
      { id: 540297, name: "Khemjai" },
      { id: 540177, name: "Kohapara" },
      { id: 540185, name: "Kondala" },
      { id: 540221, name: "Kosarsar" },
      { id: 540250, name: "Kotbala" },
      { id: 540212, name: "Kumbhari Rith" },
      { id: 540157, name: "Kurla Rith" },
      { id: 540284, name: "Lodhi Kheda" },
      { id: 540233, name: "Lonar Dhote" },
      { id: 540170, name: "Longadaga" },
      { id: 540172, name: "Madheli" },
      { id: 540158, name: "Mahadoli" },
      { id: 540319, name: "Mahalgaon Bk." },
      { id: 540229, name: "Mahalgaon Kh" },
      { id: 540187, name: "Majara Rai" },
      { id: 540225, name: "Maksur" },
      { id: 540234, name: "Mandavgurhad" },
      { id: 540243, name: "Mangali Deotale" },
      { id: 540192, name: "Marda" },
      { id: 540316, name: "Mesa" },
      { id: 540240, name: "Mhasala" },
      { id: 540195, name: "Mohabala" },
      { id: 540277, name: "Mokhala" },
      { id: 540265, name: "Mowada" },
      { id: 540215, name: "Muradgaon" },
      { id: 540193, name: "Nagala Rith" },
      { id: 540149, name: "Nagari" },
      { id: 540268, name: "Nagpur Tukum" },
      { id: 540194, name: "Naideo" },
      { id: 540169, name: "Nandara Panzurni Saza" },
      { id: 540295, name: "Nandara Sakhara Saza" },
      { id: 946377, name: "Navin Palasgaon Singru" },
      { id: 540323, name: "Nawargaon Rith" },
      { id: 540181, name: "Niljai" },
      { id: 540289, name: "Nimdhela" },
      { id: 540189, name: "Nimsada" },
      { id: 540251, name: "Pachgaon" },
      { id: 540246, name: "Pandhartala" },
      { id: 540280, name: "Panjarepar Rith" },
      { id: 540182, name: "Panzurni" },
      { id: 540286, name: "Pardi" },
      { id: 540199, name: "Parsoda" },
      { id: 540161, name: "Pauni" },
      { id: 540252, name: "Pijdura" },
      { id: 540264, name: "Pimpalgaon Maroti" },
      { id: 540288, name: "Pimpalgaon Rith" },
      { id: 540237, name: "Pimpalgaon Singaru" },
      { id: 540313, name: "Pohe" },
      { id: 540291, name: "Ralegaon" },
      { id: 540314, name: "Ratnala Rith" },
      { id: 540283, name: "Sakhara (Raja)" },
      { id: 540211, name: "Sakhardoh" },
      { id: 540269, name: "Salori" },
      { id: 540188, name: "Salori Yensa Block" },
      { id: 540321, name: "Shegaon Bk." },
      { id: 540152, name: "Shegaon Khu." },
      { id: 540209, name: "Shembal" },
      { id: 540327, name: "Shiwani Rith" },
      { id: 908972, name: "Sindola" },
      { id: 540285, name: "Singarwadi" },
      { id: 540176, name: "Soit" },
      { id: 540299, name: "Sonegaon" },
      { id: 540232, name: "Sumthana" },
      { id: 540201, name: "Surla" },
      { id: 540275, name: "Susa" },
      { id: 540256, name: "Tadala Bopapur" },
      { id: 540247, name: "Tadgavhan" },
      { id: 540222, name: "Takali" },
      { id: 540261, name: "Takali Vibhutrao" },
      { id: 540254, name: "Talegaon" },
      { id: 540263, name: "Tembhurda" },
      { id: 540206, name: "Tulana" },
      { id: 540241, name: "Tumgaon" },
      { id: 540153, name: "Ukharda" },
      { id: 540293, name: "Umari" },
      { id: 540242, name: "Umari Raiyyatwari" },
      { id: 540244, name: "Wadadha Society" },
      { id: 540300, name: "Wadadha Tukum" },
      { id: 540301, name: "Wadadhamal" },
      { id: 540166, name: "Wadala Rith" },
      { id: 540162, name: "Wadgaon(Madheli Circle)" },
      { id: 540278, name: "Wadgaon(Shegaon Circle)" },
      { id: 540216, name: "Wadgaon(Temurda)" },
      { id: 540156, name: "Waghnakh" },
      { id: 540317, name: "Wagholi" },
      { id: 540308, name: "Waigaon Bhoyar" },
      { id: 540309, name: "Waigaon Khadatkar" },
      { id: 540164, name: "Waldhur Rith" },
      { id: 540273, name: "Wanali Wangram" },
      { id: 540171, name: "Wandhali" },
      { id: 908973, name: "Waneri Rith" },
      { id: 540204, name: "Wanoja" },
      { id: 540231, name: "Warar Makta" },
      { id: 943391, name: "Warora" },
      { id: 943392, name: "Warora(Colary)" },
      { id: 540220, name: "Wathoda" },
      { id: 540186, name: "Yensa" },
      { id: 540279, name: "Yerkheda" },
      { id: 540155, name: "Yewati" },
    ],
    4065: [
      { id: 908995, name: "Aajgaon Rith" },
      { id: 540515, name: "Adegaon (Ko)" },
      { id: 540504, name: "Adegaon Chak Rith" },
      { id: 540571, name: "Adegaon Deshmukh" },
      { id: 540402, name: "Adyali Rith" },
      { id: 540446, name: "Ajgaon" },
      { id: 540350, name: "Amarpuri" },
      { id: 540429, name: "Ambeneri" },
      { id: 540464, name: "Amboli" },
      { id: 540354, name: "Amdi Begde" },
      { id: 540463, name: "Asola" },
      { id: 540384, name: "Balharpur" },
      { id: 540577, name: "Bamhangaon" },
      { id: 540564, name: "Bamhani" },
      { id: 540370, name: "Bandar" },
      { id: 540368, name: "Baradghata" },
      { id: 540531, name: "Belara Rith" },
      { id: 540556, name: "Bhilgaon Rith" },
      { id: 540394, name: "Bhisi" },
      { id: 540329, name: "Bhiwkund" },
      { id: 540494, name: "Bodadha" },
      { id: 540413, name: "Borgaon Buthi" },
      { id: 540561, name: "Borgaon Doye" },
      { id: 540562, name: "Borgaon Rodi" },
      { id: 908982, name: "Borgaon Tukum Rith" },
      { id: 540357, name: "Bothali" },
      { id: 540505, name: "Bothali (Shirpur)" },
      { id: 540452, name: "Bramhni Rith" },
      { id: 540586, name: "Chaiti Rith" },
      { id: 540584, name: "Chaiti Tukum" },
      { id: 540533, name: "Chak Bugizora" },
      { id: 540355, name: "Chak Chichghat" },
      { id: 908988, name: "Chak Chikhali Rith" },
      { id: 909006, name: "Chak Dogargoan Rith" },
      { id: 540517, name: "Chak Gorwat Rith" },
      { id: 540421, name: "Chak Jambhul Vihira" },
      { id: 540479, name: "Chak Jatepur" },
      { id: 540583, name: "Chak Karbada" },
      { id: 540559, name: "Chak Kawadsi Rith" },
      { id: 540472, name: "Chak Lohara" },
      { id: 540437, name: "Chak Vadegaon Rith" },
      { id: 943180, name: "Chak Wagadara Rith" },
      { id: 540383, name: "Chakshivani Majra Rith" },
      { id: 540448, name: "Chichala (Kunabi)" },
      { id: 540461, name: "Chichala (Pardeshi) Rith" },
      { id: 540558, name: "Chichala Manusmari (Rith)" },
      { id: 540398, name: "Chichala Shastri" },
      { id: 540359, name: "Chichghat" },
      { id: 540385, name: "Chicholi" },
      { id: 540552, name: "Chikhalapar" },
      { id: 540508, name: "Chikhali" },
      { id: 943207, name: "Chikhali Mokasa" },
      { id: 540550, name: "Chimur" },
      { id: 540430, name: "Chindhinimbala Rith" },
      { id: 540490, name: "Dabaka Heti" },
      { id: 540471, name: "Dahegaon" },
      { id: 540426, name: "Dahegaon Panjarpar Rith" },
      { id: 540371, name: "Daldali Rith" },
      { id: 540449, name: "Dhanbodi Rith" },
      { id: 540482, name: "Doma" },
      { id: 540480, name: "Dongargaon" },
      { id: 540492, name: "Dongargaon Banji" },
      { id: 540420, name: "Dongargaon Kalu" },
      { id: 540391, name: "Dongarla" },
      { id: 540346, name: "Gadgaon" },
      { id: 540399, name: "Gadpipari" },
      { id: 540547, name: "Gadpipri 2" },
      { id: 540423, name: "Garadapar" },
      { id: 540500, name: "Gaurkheda Rith" },
      { id: 540526, name: "Gondeda" },
      { id: 540537, name: "Gondmohadi" },
      { id: 540514, name: "Gorwat" },
      { id: 540386, name: "Gothangaon" },
      { id: 540333, name: "Gujgavhan" },
      { id: 540521, name: "Harni" },
      { id: 540549, name: "Himatmajara Rith" },
      { id: 540543, name: "Hinganbodi Rith" },
      { id: 540468, name: "Hirapur" },
      { id: 540441, name: "Hiwara" },
      { id: 540458, name: "Irvha" },
      { id: 540587, name: "Jamani" },
      { id: 540338, name: "Jambhulbodi Rith" },
      { id: 540436, name: "Jambhulghat" },
      { id: 540404, name: "Jambhulvihira" },
      { id: 540405, name: "Jamgaon Komti" },
      { id: 540478, name: "Jatepar Rith" },
      { id: 540450, name: "Jawarabodi" },
      { id: 540565, name: "Kag" },
      { id: 540516, name: "Kajalsar" },
      { id: 540419, name: "Kalamgaon" },
      { id: 540553, name: "Kalamgaon 2" },
      { id: 540425, name: "Kanhalgaon" },
      { id: 540396, name: "Kanhalgaon Bramhan Rith" },
      { id: 540400, name: "Kanhalgaon Kunbi Rith" },
      { id: 540416, name: "Kaparla Bujruk" },
      { id: 540415, name: "Kaparla Kh" },
      { id: 540579, name: "Karbada" },
      { id: 540497, name: "Karghata" },
      { id: 540397, name: "Kasaba Pipari Rith" },
      { id: 540336, name: "Kasarbodi" },
      { id: 540489, name: "Kasarbodi Rith" },
      { id: 540554, name: "Katara Rith" },
      { id: 540344, name: "Katebothali Rith" },
      { id: 540433, name: "Kawadsi Dak" },
      { id: 540460, name: "Kawadsi Desh" },
      { id: 540557, name: "Kawadsi Rodi" },
      { id: 540345, name: "Kawathala" },
      { id: 540335, name: "Kesalabodi" },
      { id: 540560, name: "Kesalapur Rith" },
      { id: 540525, name: "Kewada" },
      { id: 540362, name: "Khadsangi" },
      { id: 540445, name: "Khairi" },
      { id: 540512, name: "Khambala" },
      { id: 540337, name: "Khandala" },
      { id: 540470, name: "Khandala Rith" },
      { id: 540334, name: "Khangaon" },
      { id: 540330, name: "Khapari (Ja)" },
      { id: 540387, name: "Khapari (Majara) Rith" },
      { id: 540540, name: "Khapari Dharmu" },
      { id: 540378, name: "Khapari Tekepar" },
      { id: 540434, name: "Khapri (Doma)" },
      { id: 540545, name: "Kharkada" },
      { id: 540532, name: "Khatoda" },
      { id: 540453, name: "Khokarla" },
      { id: 540455, name: "Khursapar Rith" },
      { id: 540358, name: "Khursapur" },
      { id: 540513, name: "Khutala (Mo)" },
      { id: 540393, name: "Kitadi Makta" },
      { id: 540477, name: "Kitadi Rith" },
      { id: 540379, name: "Kitadi Tukum" },
      { id: 540575, name: "Kolara Rith" },
      { id: 540578, name: "Kolara Tukum" },
      { id: 540443, name: "Kolari" },
      { id: 540406, name: "Kolari Khurd Rith" },
      { id: 540573, name: "Kosambi Rith" },
      { id: 540408, name: "Kosekanhal Rith" },
      { id: 540488, name: "Kotgaon" },
      { id: 540366, name: "Kotgaon Rith" },
      { id: 908994, name: "Kothara Rith" },
      { id: 540456, name: "Ladegaon Rith" },
      { id: 540465, name: "Lawari" },
      { id: 540503, name: "Lawari (Maral)" },
      { id: 540493, name: "Lohara (Bu)" },
      { id: 540473, name: "Lohara Kh Rith" },
      { id: 540486, name: "Madnagad Rith" },
      { id: 540581, name: "Madnapur" },
      { id: 540582, name: "Madnapur Tukum" },
      { id: 540524, name: "Mahadwadi" },
      { id: 540422, name: "Mahalgaon (Kalu)" },
      { id: 540485, name: "Mahar Majara (Rith)" },
      { id: 540351, name: "Majara Begde" },
      { id: 943212, name: "Majara Mathade Rith" },
      { id: 540332, name: "Makona" },
      { id: 540495, name: "Malewada" },
      { id: 540572, name: "Manemohadi" },
      { id: 540432, name: "Mangalfusi Rith" },
      { id: 540431, name: "Mangalgaon" },
      { id: 540520, name: "Mangli Rith" },
      { id: 540367, name: "Mangrul" },
      { id: 540388, name: "Maregaon Rith" },
      { id: 540574, name: "Masal Bk" },
      { id: 540376, name: "Masal Kh. Rith" },
      { id: 540570, name: "Masal Tukum" },
      { id: 540563, name: "Mendha Rithi" },
      { id: 540435, name: "Metepar" },
      { id: 540567, name: "Mhasali" },
      { id: 540342, name: "Minghari" },
      { id: 540538, name: "Minzari" },
      { id: 540510, name: "Mokhala" },
      { id: 540519, name: "Motegaon" },
      { id: 540356, name: "Murpar (Shedegaon)" },
      { id: 540349, name: "Murpar Rith" },
      { id: 540348, name: "Murpar Tukum" },
      { id: 540569, name: "Nandara" },
      { id: 540487, name: "Navatala" },
      { id: 540401, name: "Navegaon Brahman" },
      { id: 540454, name: "Navegaon Doye" },
      { id: 540539, name: "Navegaon Peth" },
      { id: 921365, name: "Navin Navegaon" },
      { id: 540509, name: "Neri" },
      { id: 540496, name: "Nimdhela Rith" },
      { id: 540507, name: "Owala Rith" },
      { id: 540457, name: "Pachgaon" },
      { id: 540536, name: "Palasgaon" },
      { id: 540382, name: "Pandharpauni" },
      { id: 540511, name: "Pandharwani" },
      { id: 540444, name: "Panjarepar" },
      { id: 540568, name: "Panjarepar Rith" },
      { id: 540438, name: "Paradpar" },
      { id: 540499, name: "Pardhanheti" },
      { id: 540412, name: "Pardi Butti" },
      { id: 540353, name: "Parsodi" },
      { id: 540372, name: "Pendhari (Bhagade) Rith" },
      { id: 540447, name: "Pendhari (Deshamukh) Rith" },
      { id: 540380, name: "Pendhari (Tukum) Rith" },
      { id: 540339, name: "Pethbhansuli" },
      { id: 540483, name: "Pimpalgaon" },
      { id: 540544, name: "Pimpalneri" },
      { id: 540535, name: "Piparda" },
      { id: 540389, name: "Pitichua" },
      { id: 540347, name: "Pitichuva Rith" },
      { id: 540395, name: "Puyardand" },
      { id: 540501, name: "Rampur Raiyyatwari" },
      { id: 540361, name: "Rengabodi" },
      { id: 540403, name: "Rohana Rith" },
      { id: 540340, name: "Salori (Rith)" },
      { id: 540566, name: "Saradpar" },
      { id: 540576, name: "Satara" },
      { id: 540407, name: "Satara Rith" },
      { id: 540442, name: "Sathgaon" },
      { id: 540476, name: "Sawali Rith" },
      { id: 540498, name: "Sawargaon" },
      { id: 540331, name: "Sawari" },
      { id: 540392, name: "Sawarla" },
      { id: 540462, name: "Shankarpur" },
      { id: 540364, name: "Shedegaon" },
      { id: 540506, name: "Shirpur" },
      { id: 540502, name: "Shivan Payali" },
      { id: 540363, name: "Shivapur" },
      { id: 540411, name: "Shiwara" },
      { id: 540410, name: "Siraspur" },
      { id: 540365, name: "Sonegaon (Be)" },
      { id: 909004, name: "Sonegaon (Van)" },
      { id: 540523, name: "Sonegaon Gawande" },
      { id: 540352, name: "Sonegaon(Siras)" },
      { id: 540451, name: "Susundri Reeth (Kawadsi Desh)" },
      { id: 540469, name: "Susundri Rith (Sathgaon)" },
      { id: 540414, name: "Taki Rith" },
      { id: 540373, name: "Talodhi Gaonganana" },
      { id: 540375, name: "Talodhi Tukum" },
      { id: 540551, name: "Tekadi (Paiku) Rith" },
      { id: 540585, name: "Tekadi Mandavzari Rith" },
      { id: 540580, name: "Tekadi Subhan Rith" },
      { id: 908981, name: "Tekepar Rith" },
      { id: 540374, name: "Tekepar Tukum" },
      { id: 540467, name: "Thana Rith" },
      { id: 540424, name: "Tirkhura" },
      { id: 540428, name: "Titawi" },
      { id: 540542, name: "Umari Butti" },
      { id: 540518, name: "Uparpeth Rith" },
      { id: 540343, name: "Urkudpar" },
      { id: 540522, name: "Usegaon" },
      { id: 540360, name: "Vahangaon" },
      { id: 540440, name: "Vakarla" },
      { id: 540529, name: "Vihirgaon" },
      { id: 540530, name: "Vihirgaon Tukum" },
      { id: 540548, name: "Wadala Pai" },
      { id: 540481, name: "Wadala Rith" },
      { id: 540527, name: "Wadasi" },
      { id: 540541, name: "Wadegaonmal Rith" },
      { id: 540390, name: "Wadhona" },
      { id: 540466, name: "Wagdara Rith" },
      { id: 540484, name: "Waghalpeth Rith" },
      { id: 540528, name: "Wagheda" },
      { id: 540409, name: "Wagholi Rith" },
      { id: 540534, name: "Wasanvihira Rith" },
      { id: 540427, name: "Yerkheda" },
      { id: 540459, name: "Zari 1" },
      { id: 540369, name: "Zari 2" },
    ],
    4066: [
      { id: 540623, name: "Adyal Mendha" },
      { id: 540696, name: "Akapur" },
      { id: 540725, name: "Alewahi" },
      { id: 540691, name: "Balapur Bk" },
      { id: 540638, name: "Balapur Kh." },
      { id: 540694, name: "Balapur Tukum" },
      { id: 540681, name: "Bamhani" },
      { id: 540597, name: "Bamhani (Mo)" },
      { id: 909009, name: "Banvahi Mal" },
      { id: 540591, name: "Banwahi Chak" },
      { id: 540655, name: "Bhikeshwar" },
      { id: 540589, name: "Bikli" },
      { id: 540685, name: "Bond" },
      { id: 540608, name: "Bothali" },
      { id: 540701, name: "Chargaon Chak" },
      { id: 540700, name: "Chargaon Manapur" },
      { id: 540625, name: "Chichala Rith" },
      { id: 540606, name: "Chicholi Khurd" },
      { id: 540643, name: "Chikhal Parsodi" },
      { id: 540718, name: "Chikhalgaon" },
      { id: 540644, name: "Chikmara" },
      { id: 540621, name: "Chindhi Chak" },
      { id: 540616, name: "Chindhimal" },
      { id: 540689, name: "Devpayli" },
      { id: 540645, name: "Devtak" },
      { id: 540708, name: "Dhamagaon Chak" },
      { id: 540707, name: "Dhamangaon Mal" },
      { id: 540635, name: "Dhorpa" },
      { id: 540605, name: "Dongargaon Bk" },
      { id: 540604, name: "Dongargaon Kh" },
      { id: 540695, name: "Dorli (Rith)" },
      { id: 540683, name: "Gaimukh" },
      { id: 540723, name: "Gangasagar Heti" },
      { id: 540612, name: "Ghodazari" },
      { id: 540712, name: "Girgaon" },
      { id: 540677, name: "Govindpur" },
      { id: 540671, name: "Gowarpeth" },
      { id: 540618, name: "Huma" },
      { id: 540633, name: "Irvha" },
      { id: 540624, name: "Jankapur" },
      { id: 540724, name: "Jivanapur" },
      { id: 540709, name: "Kachepar" },
      { id: 540675, name: "Kamathchak Rith" },
      { id: 540713, name: "Kanhalgaon (Sonuli)" },
      { id: 540588, name: "Kanpa" },
      { id: 540603, name: "Kasarla" },
      { id: 540646, name: "Khadki" },
      { id: 540617, name: "Khadki Tukum" },
      { id: 540654, name: "Khairi Bk." },
      { id: 540610, name: "Khairi Kh." },
      { id: 540615, name: "Khairichak Parkhi" },
      { id: 540676, name: "Kharbi" },
      { id: 540650, name: "Kirmiti" },
      { id: 540620, name: "Kitali Bormala" },
      { id: 540663, name: "Kitali Mendha" },
      { id: 943535, name: "Kitali Rith" },
      { id: 540661, name: "Kodepar" },
      { id: 540702, name: "Kojbi Chak" },
      { id: 540703, name: "Kojbi Mal" },
      { id: 540602, name: "Korambi" },
      { id: 540652, name: "Kordha" },
      { id: 540666, name: "Kosambi Chak 1" },
      { id: 540667, name: "Kosambi Chak 2" },
      { id: 540669, name: "Kosambi Gaoli" },
      { id: 540692, name: "Kotalpar" },
      { id: 540596, name: "Kotgaon" },
      { id: 540641, name: "Kothulana" },
      { id: 540601, name: "Kunghada (Rith)" },
      { id: 540600, name: "Kunghada Chak" },
      { id: 540682, name: "Lakhamapur Chak" },
      { id: 540593, name: "Mangali (Arab)" },
      { id: 540619, name: "Mangrul" },
      { id: 540699, name: "Mendha Chargaon" },
      { id: 540722, name: "Mendha Dakhali Ushrala" },
      { id: 540649, name: "Mendha Kirmiti" },
      { id: 540639, name: "Mhasali" },
      { id: 540660, name: "Mindala" },
      { id: 540659, name: "Minthur" },
      { id: 540592, name: "Mohadi Mokasa" },
      { id: 540690, name: "Mohdar" },
      { id: 540637, name: "Moushi" },
      { id: 540636, name: "Moushi Chak" },
      { id: 540611, name: "Nagbhid" },
      { id: 540710, name: "Nanded" },
      { id: 540622, name: "Navegaon Mal." },
      { id: 540653, name: "Navegaon Pandav" },
      { id: 540687, name: "Nawanagar" },
      { id: 540670, name: "Nawegaon Hundeshwari" },
      { id: 540607, name: "Nawkhala" },
      { id: 540628, name: "Owala" },
      { id: 540632, name: "Paharni" },
      { id: 540629, name: "Palasgaon Khurd" },
      { id: 540630, name: "Palasgaon Tukum" },
      { id: 540647, name: "Panholi" },
      { id: 540648, name: "Panholi Mendha" },
      { id: 540651, name: "Panjarepar" },
      { id: 540656, name: "Pardi" },
      { id: 540684, name: "Pardi Jatin" },
      { id: 540598, name: "Pendhari Barad" },
      { id: 540686, name: "Rajoli" },
      { id: 540658, name: "Ranparsodi" },
      { id: 540599, name: "Rengatur" },
      { id: 540668, name: "Sakhara Chak" },
      { id: 540657, name: "Sakhara Rith" },
      { id: 540595, name: "Sale Bhatti Chak" },
      { id: 909013, name: "Salebhatti Rith" },
      { id: 540627, name: "Sapepar Chak" },
      { id: 540679, name: "Sapepar Mal" },
      { id: 540673, name: "Sarangad" },
      { id: 540631, name: "Sawangi Badge" },
      { id: 540717, name: "Sawargaon" },
      { id: 540698, name: "Sawarla" },
      { id: 540674, name: "Sonapur" },
      { id: 540719, name: "Sonapur Tukum" },
      { id: 540714, name: "Sonuli (Kanhalgaon)" },
      { id: 540678, name: "Sonuli Bk." },
      { id: 540715, name: "Sonuli Chak" },
      { id: 540688, name: "Sonuli Khurd" },
      { id: 540609, name: "Sulezari" },
      { id: 540680, name: "Talodhi (Balapur)" },
      { id: 540634, name: "Tekari" },
      { id: 540672, name: "Telandongari Chak" },
      { id: 540640, name: "Telimendha" },
      { id: 540614, name: "Tivarla Gaonganna" },
      { id: 540613, name: "Tivarla Tukum" },
      { id: 540720, name: "Umargaon" },
      { id: 540697, name: "Ushrala Rith" },
      { id: 540704, name: "Vaijapur" },
      { id: 540642, name: "Vilam" },
      { id: 540626, name: "Visapur Rith" },
      { id: 540721, name: "Wadhona" },
      { id: 540716, name: "Walni" },
      { id: 540665, name: "Wasala Makta" },
      { id: 540664, name: "Wasala Mendha" },
      { id: 540693, name: "Yenoli" },
      { id: 540705, name: "Yenoli Chak" },
      { id: 540706, name: "Yenoli Mal" },
      { id: 540711, name: "Zadbori" },
    ],
    4067: [
      { id: 540763, name: "Adyal Gaonganna" },
      { id: 540764, name: "Adyal Tukum" },
      { id: 540736, name: "Ahernavargaon" },
      { id: 540802, name: "Akapur Aliase Rupala" },
      { id: 540834, name: "Aksapur" },
      { id: 540846, name: "Amla Rith" },
      { id: 540845, name: "Arjuni Rith" },
      { id: 540840, name: "Awalgaon" },
      { id: 540856, name: "Balhapur Chak" },
      { id: 540855, name: "Ballarpur Mal" },
      { id: 540831, name: "Baradkinhi" },
      { id: 540768, name: "Beldati" },
      { id: 540727, name: "Belgaon Jani" },
      { id: 540836, name: "Belgaon Kh" },
      { id: 540808, name: "Belpatali" },
      { id: 540775, name: "Betala" },
      { id: 540785, name: "Bhagawanpur" },
      { id: 540735, name: "Bhaleshwar" },
      { id: 540823, name: "Bhanapur Tukum Rith" },
      { id: 540842, name: "Bhuj Tukum" },
      { id: 540858, name: "Bodadha" },
      { id: 540861, name: "Bodhegaon" },
      { id: 540776, name: "Bodhegaon(Ranmochan)" },
      { id: 540852, name: "Bodra" },
      { id: 944979, name: "Bondegaon" },
      { id: 540771, name: "Borgaon" },
      { id: 943265, name: "Bramhpuri" },
      { id: 540812, name: "Budhewada" },
      { id: 540847, name: "Chak Kitali" },
      { id: 540791, name: "Chakbothali" },
      { id: 540752, name: "Chandali" },
      { id: 540784, name: "Chandgaon" },
      { id: 540781, name: "Chaugaon" },
      { id: 540832, name: "Chichgaon" },
      { id: 540827, name: "Chichkheda" },
      { id: 540739, name: "Chikhalgaon" },
      { id: 540741, name: "Chincholi Buj" },
      { id: 540848, name: "Chitak Bodra Navegaon" },
      { id: 540786, name: "Chorti" },
      { id: 943262, name: "Delanwadi" },
      { id: 540729, name: "Deulgaon" },
      { id: 540790, name: "Dhamngaon" },
      { id: 540782, name: "Dhanoli Pohachak" },
      { id: 540767, name: "Dhanoli Rith" },
      { id: 540783, name: "Dhanoli Tukum" },
      { id: 540732, name: "Dighori" },
      { id: 540766, name: "Dudhawahi Chak" },
      { id: 540844, name: "Ekara" },
      { id: 540799, name: "Gaidongari Rith" },
      { id: 540798, name: "Gaidongari Tukum" },
      { id: 540826, name: "Ganeshpur" },
      { id: 540810, name: "Gangalwadi" },
      { id: 540803, name: "Gawarla Chak" },
      { id: 540830, name: "Gogaon" },
      { id: 540857, name: "Halda" },
      { id: 540740, name: "Hardoli" },
      { id: 540765, name: "Hattilendha" },
      { id: 540801, name: "Jawarabodi Mendha" },
      { id: 540779, name: "Jugnala" },
      { id: 540751, name: "Kahali" },
      { id: 540828, name: "Kalamgaon" },
      { id: 540753, name: "Kaleta" },
      { id: 540749, name: "Kanhalgaon" },
      { id: 540800, name: "Katali Chak" },
      { id: 540815, name: "Khambada Rith" },
      { id: 540748, name: "Khamtalodhi" },
      { id: 540750, name: "Khandala" },
      { id: 540759, name: "Kharbi Makta" },
      { id: 540778, name: "Kharkada" },
      { id: 540843, name: "Khatgaon" },
      { id: 540758, name: "Khedmakta" },
      { id: 540780, name: "Kinhi" },
      { id: 540851, name: "Kitadi" },
      { id: 540726, name: "Kolari" },
      { id: 540822, name: "Koregaon Rith" },
      { id: 540839, name: "Kosambi Chak" },
      { id: 540838, name: "Kosambi Khadasmara" },
      { id: 540747, name: "Kothulna" },
      { id: 540859, name: "Kudesawali" },
      { id: 943261, name: "Kurza" },
      { id: 540738, name: "Ladaj" },
      { id: 540756, name: "Lakhapur" },
      { id: 540850, name: "Lohar Dongari" },
      { id: 540769, name: "Maldongri" },
      { id: 540804, name: "Mangli" },
      { id: 540816, name: "Manikpur Rith" },
      { id: 540757, name: "Marar Mendha" },
      { id: 540760, name: "Mayar" },
      { id: 540821, name: "Mendaki" },
      { id: 540860, name: "Mudaza" },
      { id: 540809, name: "Mui" },
      { id: 540837, name: "Murpar" },
      { id: 540734, name: "Nandgaon Jani" },
      { id: 540733, name: "Nanhori" },
      { id: 540746, name: "Navegaon (Makta)" },
      { id: 540824, name: "Navegaon Kh" },
      { id: 540806, name: "Nilaj" },
      { id: 540793, name: "Nimgaon Aliase Bothali" },
      { id: 540854, name: "Padmapur Chak" },
      { id: 540841, name: "Padmapur Tukum" },
      { id: 540849, name: "Palasgaon Makta" },
      { id: 540807, name: "Panchagaon" },
      { id: 540774, name: "Paradgaon" },
      { id: 540817, name: "Parsodi" },
      { id: 540773, name: "Parsodi Jani" },
      { id: 540737, name: "Pimpalgaon" },
      { id: 540835, name: "Powanpar" },
      { id: 540820, name: "Rampuri" },
      { id: 540792, name: "Ranbothali" },
      { id: 540777, name: "Ranmochan" },
      { id: 540814, name: "Ratnapur Rith" },
      { id: 540825, name: "Rudrapur Rith" },
      { id: 540805, name: "Rui" },
      { id: 540829, name: "Saigaon Tukum" },
      { id: 540762, name: "Saigata" },
      { id: 540742, name: "Sawalgaon" },
      { id: 540794, name: "Sawardand Chak" },
      { id: 540853, name: "Selada" },
      { id: 540818, name: "Shivsagar Gaonganna" },
      { id: 540819, name: "Shivsagar Tukum" },
      { id: 540745, name: "Sondri" },
      { id: 540743, name: "Sonegaon" },
      { id: 540797, name: "Surabderi Rith" },
      { id: 540744, name: "Surbodi" },
      { id: 540811, name: "Talodi Kh" },
      { id: 540728, name: "Tapal" },
      { id: 540813, name: "Tekari Rith" },
      { id: 540788, name: "Telandongari" },
      { id: 540730, name: "Torgaon Bujruk" },
      { id: 540731, name: "Torgaon Kh." },
      { id: 540795, name: "Tulan Chak" },
      { id: 540789, name: "Tulan Mal" },
      { id: 540796, name: "Tulan Mendha" },
      { id: 540761, name: "Tumdi Mendha" },
      { id: 540754, name: "Uchali" },
      { id: 540755, name: "Uchali Chak" },
      { id: 540770, name: "Udapur" },
      { id: 540833, name: "Wandra" },
      { id: 540787, name: "Waygaon" },
      { id: 540772, name: "Zilbodi" },
    ],
    4068: [
      { id: 540865, name: "Akapur" },
      { id: 540950, name: "Akapur Alias Bijapur" },
      { id: 540920, name: "Ambora" },
      { id: 540885, name: "Antargaon" },
      { id: 540887, name: "Antargaontola" },
      { id: 540892, name: "Asola Chak" },
      { id: 540883, name: "Barsagad" },
      { id: 540910, name: "Belgaon" },
      { id: 540893, name: "Bhanapur" },
      { id: 540940, name: "Bhansi" },
      { id: 540901, name: "Bharpayali" },
      { id: 540945, name: "Bhattijamb" },
      { id: 540880, name: "Bormala" },
      { id: 540926, name: "Bothali" },
      { id: 540899, name: "Chak Mankapur" },
      { id: 540931, name: "Chak Piranji" },
      { id: 540961, name: "Chak Upri Alias Madhe Bhansi" },
      { id: 540890, name: "Chak Virkhal Tola" },
      { id: 540951, name: "Chandli Bk." },
      { id: 540928, name: "Chargaon" },
      { id: 540913, name: "Chichbodi" },
      { id: 540882, name: "Chikhali" },
      { id: 909027, name: "Chorkhal Rith" },
      { id: 540908, name: "Dabgaon" },
      { id: 540964, name: "Donala Chak." },
      { id: 540965, name: "Donala Mal" },
      { id: 540881, name: "Dongargaon Maske" },
      { id: 540891, name: "Gaidongari" },
      { id: 540875, name: "Geora Bk." },
      { id: 540876, name: "Geora Chak" },
      { id: 540877, name: "Geora Kh." },
      { id: 540932, name: "Ghodewahi" },
      { id: 540972, name: "Haramba" },
      { id: 540925, name: "Hirapur" },
      { id: 540943, name: "Jam Keroda Ryt" },
      { id: 540944, name: "Jamb Bk." },
      { id: 540862, name: "Jankapur Rith" },
      { id: 540863, name: "Jankapur Tukum" },
      { id: 540957, name: "Jibgaon" },
      { id: 540967, name: "Kadholi" },
      { id: 540966, name: "Kajalwahi Chak." },
      { id: 540937, name: "Kapsi" },
      { id: 540906, name: "Kargaon Chak" },
      { id: 540866, name: "Karoli" },
      { id: 540878, name: "Kasargaon" },
      { id: 540954, name: "Kawathi" },
      { id: 540934, name: "Keroda" },
      { id: 540924, name: "Kesarwahi" },
      { id: 540864, name: "Khanabad Chak" },
      { id: 540948, name: "Khedi" },
      { id: 540923, name: "Kisannagar" },
      { id: 540933, name: "Kondekhal Alias Ghodewahi Chak" },
      { id: 540935, name: "Kondekhal Mal" },
      { id: 540949, name: "Kukud Chimadha" },
      { id: 540971, name: "Londholi" },
      { id: 540873, name: "Mangar Medha" },
      { id: 540900, name: "Mankapur" },
      { id: 540884, name: "Meha Bk." },
      { id: 540872, name: "Meha Kh." },
      { id: 540897, name: "Metegaon" },
      { id: 540915, name: "Mokhala" },
      { id: 909022, name: "Mowad Chak" },
      { id: 540905, name: "Mundala" },
      { id: 540911, name: "Navegaon Tukum" },
      { id: 540886, name: "Nifandra" },
      { id: 540939, name: "Nilsani Pethgaon" },
      { id: 540889, name: "Nimgaon" },
      { id: 540868, name: "Palebarsa" },
      { id: 540903, name: "Pandhar Sarad Chak" },
      { id: 540902, name: "Pandharsarad Mal" },
      { id: 540953, name: "Pardi" },
      { id: 540894, name: "Pathari" },
      { id: 540898, name: "Pendhari Chak" },
      { id: 540904, name: "Pendhari Makta" },
      { id: 540942, name: "Pethgaon Mal" },
      { id: 540958, name: "Pethgaon Ryt" },
      { id: 540927, name: "Piranjimal" },
      { id: 540912, name: "Rajoli Chak" },
      { id: 540955, name: "Rudrapur" },
      { id: 540929, name: "Sadagad" },
      { id: 540867, name: "Saikheda" },
      { id: 540895, name: "Saimara Chak" },
      { id: 540896, name: "Saimara Tu." },
      { id: 540970, name: "Sakhari" },
      { id: 540969, name: "Sakhari Chak." },
      { id: 540917, name: "Samada Bk." },
      { id: 540930, name: "Sawali" },
      { id: 540947, name: "Sawali Tukum" },
      { id: 540869, name: "Sawangi Dixit" },
      { id: 540874, name: "Sawatla Rith" },
      { id: 540946, name: "Sindola" },
      { id: 540952, name: "Singapur" },
      { id: 540960, name: "Sirsi Chak" },
      { id: 540959, name: "Sirsi Malgujari" },
      { id: 540938, name: "Sonapur" },
      { id: 540909, name: "Thergaon" },
      { id: 540968, name: "Umri" },
      { id: 540941, name: "Upri" },
      { id: 540870, name: "Usarpar Chak" },
      { id: 540871, name: "Usarpar Tukum" },
      { id: 540956, name: "Usegaon" },
      { id: 540914, name: "Vichora" },
      { id: 540879, name: "Vihirgaon" },
      { id: 540907, name: "Virkhal Chak" },
      { id: 540918, name: "Vyahad Bk." },
      { id: 540922, name: "Vyahad Chak No.1" },
      { id: 540921, name: "Vyahad Chak.No.2" },
      { id: 540919, name: "Vyahad Kh." },
      { id: 540963, name: "Wadholi Chak." },
      { id: 540962, name: "Wadholi Gandli" },
      { id: 540916, name: "Wagholi" },
    ],
    4069: [
      { id: 540979, name: "Alesur" },
      { id: 540978, name: "Alesur Chak" },
      { id: 541048, name: "Amboli" },
      { id: 540996, name: "Antargaon" },
      { id: 541075, name: "Bamani Chak" },
      { id: 541077, name: "Bamhani Mal" },
      { id: 541034, name: "Bhendala" },
      { id: 541020, name: "Chak Sakharampur" },
      { id: 541033, name: "Chargaonbadge" },
      { id: 540984, name: "Chikhal Minghari" },
      { id: 541085, name: "Chikmara" },
      { id: 541070, name: "Chitki" },
      { id: 540982, name: "Delanwadi" },
      { id: 540998, name: "Dewada" },
      { id: 541062, name: "Dhanora" },
      { id: 540981, name: "Dhumankheda" },
      { id: 541030, name: "Dongargaon Salodkar" },
      { id: 541005, name: "Gadbori" },
      { id: 541046, name: "Gadmaushi Chak" },
      { id: 541059, name: "Ghot" },
      { id: 541071, name: "Govindpur Chak" },
      { id: 541057, name: "Gunjewahi Kotha" },
      { id: 541056, name: "Gunjewahi Mal.N.1" },
      { id: 541055, name: "Gunjewahi Mal.N.2" },
      { id: 541032, name: "Hajari Chak" },
      { id: 541050, name: "Indiranagar" },
      { id: 541076, name: "Itoli" },
      { id: 541016, name: "Jamsala" },
      { id: 541051, name: "Jatlapur" },
      { id: 541052, name: "Jatlapur Tukum" },
      { id: 541031, name: "Kachhepar" },
      { id: 541023, name: "Kalamgaon Ganna" },
      { id: 541022, name: "Kalamgaon Tukum" },
      { id: 541042, name: "Kanhalgaon" },
      { id: 541039, name: "Kargata" },
      { id: 541013, name: "Karwa" },
      { id: 541009, name: "Katangdhar" },
      { id: 541054, name: "Khairi Chak" },
      { id: 540990, name: "Khandala" },
      { id: 541058, name: "Khari Golkar" },
      { id: 541078, name: "Khatera Chak" },
      { id: 541079, name: "Khatera Mal" },
      { id: 541035, name: "Khatgaon" },
      { id: 541064, name: "Kinhi" },
      { id: 540973, name: "Kokewada" },
      { id: 540993, name: "Kukasi Rith" },
      { id: 541026, name: "Kukudheti Chak" },
      { id: 541024, name: "Kukudtheti" },
      { id: 541036, name: "Ladbori" },
      { id: 541010, name: "Lalchichbodi" },
      { id: 541081, name: "Lonkhairi Panbuda" },
      { id: 541084, name: "Lonkhairi Tukum" },
      { id: 541047, name: "Lonwahi" },
      { id: 541086, name: "Mangli Chak" },
      { id: 541060, name: "Maregaon Chak" },
      { id: 541061, name: "Maregaon Tukum" },
      { id: 541038, name: "Mendha Chak" },
      { id: 541037, name: "Mendhamal" },
      { id: 541015, name: "Mhasmohan Rith" },
      { id: 540997, name: "Minghari" },
      { id: 541025, name: "Mohabodi" },
      { id: 541019, name: "Mohali" },
      { id: 541065, name: "Murmadi" },
      { id: 540975, name: "Murpar Deshpande" },
      { id: 541069, name: "Murpar Gaonganna" },
      { id: 540976, name: "Murpar Gujar" },
      { id: 541068, name: "Murpar Tukum" },
      { id: 540986, name: "Nachanbhatti" },
      { id: 541021, name: "Naleshwar" },
      { id: 540983, name: "Nandgaon" },
      { id: 540980, name: "Navargaon" },
      { id: 541072, name: "Navegaon Chak" },
      { id: 541082, name: "Navegaon Lon" },
      { id: 541083, name: "Navegaon Tola" },
      { id: 541028, name: "Palasgaon Jat" },
      { id: 541012, name: "Pandharwani" },
      { id: 541027, name: "Pangadi" },
      { id: 540991, name: "Parna" },
      { id: 541045, name: "Pawana Chak" },
      { id: 541044, name: "Pawanpar" },
      { id: 540974, name: "Pendhari" },
      { id: 541080, name: "Petgaon" },
      { id: 541067, name: "Pimpaldand Chak" },
      { id: 541014, name: "Piparheti" },
      { id: 540999, name: "Powan Bori" },
      { id: 540988, name: "Purkepar" },
      { id: 541006, name: "Ramala" },
      { id: 540987, name: "Ratnapur" },
      { id: 541041, name: "Samda Kh." },
      { id: 541066, name: "Saradpar" },
      { id: 541073, name: "Saradpar Chak" },
      { id: 541043, name: "Saradpar Rith" },
      { id: 540989, name: "Sarandi" },
      { id: 541053, name: "Sawargata Chak" },
      { id: 541000, name: "Shankarpur Rith" },
      { id: 541003, name: "Shivni" },
      { id: 541049, name: "Sindewahi" },
      { id: 541011, name: "Singadzari" },
      { id: 540992, name: "Sirkada" },
      { id: 541087, name: "Tambegadi Mendha" },
      { id: 541063, name: "Tayagondi" },
      { id: 540985, name: "Tekari Alias Antargaon" },
      { id: 541018, name: "Tekari Alias Waneri" },
      { id: 541040, name: "Tekari Tukum" },
      { id: 541008, name: "Tembharun Bodi" },
      { id: 541001, name: "Umarwahi" },
      { id: 540994, name: "Uti Najik Ratnapur" },
      { id: 540995, name: "Utichak" },
      { id: 541002, name: "Utimal" },
      { id: 541074, name: "Virwha" },
      { id: 540977, name: "Wagholi Rith" },
      { id: 541017, name: "Wakal" },
      { id: 541007, name: "Waneri" },
      { id: 541004, name: "Wasera" },
      { id: 541029, name: "Yergaon" },
    ],
    4070: [
      { id: 541206, name: "Aambezari Rith" },
      { id: 541216, name: "Aawand Rith" },
      { id: 541160, name: "Agara" },
      { id: 541140, name: "Ashta" },
      { id: 541192, name: "Ashti Kakade" },
      { id: 541102, name: "Ashti Rith" },
      { id: 541191, name: "Ashti Tukum" },
      { id: 541127, name: "Barang Mokasa" },
      { id: 541135, name: "Belagaon Deshpande" },
      { id: 541163, name: "Belgaon Bhusari" },
      { id: 541109, name: "Belora" },
      { id: 943319, name: "Bhadravati" },
      { id: 541202, name: "Bhamdeli (Ma)" },
      { id: 541185, name: "Bhamdeli Raiyyatwari" },
      { id: 541097, name: "Bhatali" },
      { id: 541095, name: "Bhuyari Rt." },
      { id: 541156, name: "Bijoni Raiyyatwari" },
      { id: 541125, name: "Bonthala Ryt" },
      { id: 541155, name: "Borgaon Dhande" },
      { id: 541240, name: "Borgaon Rt." },
      { id: 541208, name: "Botezari" },
      { id: 943394, name: "Chak Khapari" },
      { id: 541218, name: "Chak Tirawanja" },
      { id: 541121, name: "Chalbardi" },
      { id: 541214, name: "Chalbardi Rai." },
      { id: 541161, name: "Chandankheda" },
      { id: 541153, name: "Chandankheda Makta" },
      { id: 541213, name: "Chaparala Rai" },
      { id: 541229, name: "Chargaon" },
      { id: 541154, name: "Charur Gharapuri" },
      { id: 541211, name: "Chek Baranj" },
      { id: 541177, name: "Chichala Makta" },
      { id: 541106, name: "Chichala Raiyyavari" },
      { id: 541105, name: "Chichala Rith" },
      { id: 541167, name: "Chichghat Rith" },
      { id: 541197, name: "Chicholi" },
      { id: 943304, name: "Chichordi" },
      { id: 541233, name: "Chiradevi" },
      { id: 541098, name: "Chopan Rith" },
      { id: 541196, name: "Chora" },
      { id: 541131, name: "Deulwada" },
      { id: 541207, name: "Dewada" },
      { id: 541158, name: "Dhamani" },
      { id: 541094, name: "Dhanoli" },
      { id: 541232, name: "Dhorwasa" },
      { id: 541096, name: "Dongargaon Khadi" },
      { id: 943283, name: "Gavrala" },
      { id: 541181, name: "Ghodabadeo Rt." },
      { id: 541200, name: "Ghode Minwat" },
      { id: 541222, name: "Ghodpeth" },
      { id: 541239, name: "Ghonad" },
      { id: 541165, name: "Ghosari" },
      { id: 541212, name: "Ghotnimbala" },
      { id: 943291, name: "Ghutkala Rai" },
      { id: 541235, name: "Gorja" },
      { id: 541101, name: "Gotala Rith" },
      { id: 541108, name: "Govardip Rith" },
      { id: 541188, name: "Gulgaon Mal" },
      { id: 541189, name: "Gulgaon Tukum" },
      { id: 541221, name: "Gunjala" },
      { id: 541122, name: "Hardala Rith" },
      { id: 541107, name: "Jena Niwali" },
      { id: 541204, name: "Junona" },
      { id: 541215, name: "Kachrala" },
      { id: 541128, name: "Kadholi" },
      { id: 541104, name: "Kansa Shirpur" },
      { id: 541142, name: "Karegaon" },
      { id: 943271, name: "Karli Sonegaon" },
      { id: 541138, name: "Katezari Rith" },
      { id: 541146, name: "Katwal Bhagat" },
      { id: 541151, name: "Katwal Raiyyatwari" },
      { id: 541149, name: "Katwal Tukum" },
      { id: 541133, name: "Kawadi" },
      { id: 541210, name: "Kesurli" },
      { id: 541111, name: "Khandala Rith" },
      { id: 943278, name: "Khapari(Rai)" },
      { id: 541164, name: "Khokari" },
      { id: 541091, name: "Khutala (Bhake)" },
      { id: 541170, name: "Khutwanda (Marar)" },
      { id: 541169, name: "Khutwanda Dixit" },
      { id: 541171, name: "Khutwanda Raiyyatwari" },
      { id: 541166, name: "Khutwanda Tukum" },
      { id: 541123, name: "Kiloni" },
      { id: 541141, name: "Kinhala" },
      { id: 541236, name: "Kochi" },
      { id: 541147, name: "Kokewada (Mankar)" },
      { id: 541134, name: "Kokewada Tukum" },
      { id: 541183, name: "Kondegaon (Mal)" },
      { id: 541182, name: "Kondegaon Tu." },
      { id: 541129, name: "Kondha" },
      { id: 541113, name: "Kuchana" },
      { id: 541234, name: "Kudrara Raiyyatwari" },
      { id: 541230, name: "Kunada" },
      { id: 541231, name: "Kunada Tola" },
      { id: 541130, name: "Kuroda" },
      { id: 541228, name: "Lonara Rt." },
      { id: 943332, name: "Mahadapur Rith" },
      { id: 541132, name: "Majari" },
      { id: 541115, name: "Mangaon" },
      { id: 541195, name: "Mangli Raiyyatwari" },
      { id: 541143, name: "Manora (Singru)" },
      { id: 541193, name: "Masal Visapur" },
      { id: 541199, name: "Minwat Kali" },
      { id: 541198, name: "Minwat Tukum" },
      { id: 541224, name: "Mohabala" },
      { id: 541157, name: "Morwa" },
      { id: 541172, name: "Mudholi" },
      { id: 541241, name: "Mursa" },
      { id: 541119, name: "Naglon" },
      { id: 541150, name: "Nagpur Rith" },
      { id: 541100, name: "Nandori Bk." },
      { id: 541099, name: "Nandori Kh." },
      { id: 541090, name: "Nandra Makta" },
      { id: 541126, name: "Nawargaon Rith" },
      { id: 541223, name: "Nunhara Raiyyatwari" },
      { id: 541186, name: "Pachagaon (Musalman)" },
      { id: 541180, name: "Pachagaon Tukum" },
      { id: 541120, name: "Palasgaon" },
      { id: 541168, name: "Palasgaon Singru" },
      { id: 541103, name: "Panwadala" },
      { id: 541205, name: "Pardi Rith" },
      { id: 541145, name: "Parodhi" },
      { id: 541117, name: "Patala" },
      { id: 541089, name: "Pawana Rt." },
      { id: 541088, name: "Pewara Tukum" },
      { id: 541238, name: "Pipri" },
      { id: 541093, name: "Pirli" },
      { id: 541118, name: "Ralegaon (Tola)" },
      { id: 541116, name: "Ralegaon Rith" },
      { id: 541225, name: "Rampuri Rith" },
      { id: 541209, name: "Ranatalodhi" },
      { id: 541178, name: "Ratnapur Rith" },
      { id: 541227, name: "Ruyal Rith" },
      { id: 541159, name: "Sagara" },
      { id: 541220, name: "Saiwan" },
      { id: 541201, name: "Sawri" },
      { id: 541144, name: "Shegaon Kh." },
      { id: 541092, name: "Sheloti Wagheda" },
      { id: 541242, name: "Shivajinagar" },
      { id: 541173, name: "Sindgavhan Rith" },
      { id: 541184, name: "Sitaram Peth" },
      { id: 541124, name: "Somnala Rith" },
      { id: 541136, name: "Sonegaon Tukum" },
      { id: 943337, name: "Sumthana" },
      { id: 541110, name: "Takli" },
      { id: 943313, name: "Tamsi Rith" },
      { id: 541174, name: "Tekadi (Dixit)" },
      { id: 541237, name: "Telawasa" },
      { id: 541203, name: "Thanegaon (Rith)" },
      { id: 541190, name: "Thetegaon (Rith)" },
      { id: 541114, name: "Thorana" },
      { id: 541217, name: "Tirawanja Mokasa" },
      { id: 541219, name: "Tirur Rith" },
      { id: 944980, name: "Vijasan" },
      { id: 541152, name: "Viloda" },
      { id: 541179, name: "Visapur Raiyyatwari" },
      { id: 541112, name: "Vislon" },
      { id: 541226, name: "Wadala (Rith)" },
      { id: 541139, name: "Wadala Tukum" },
      { id: 541187, name: "Wadegaon Alias Sawarla Shirpur" },
      { id: 541176, name: "Waigaon Raiyyatwari" },
      { id: 541175, name: "Waigaon Tukum" },
    ],
    4071: [
      { id: 541246, name: "Adegaon" },
      { id: 541245, name: "Agarzari" },
      { id: 541274, name: "Ajayapur Raiyyatwari" },
      { id: 541279, name: "Ambhora" },
      { id: 541319, name: "Anturla" },
      { id: 541332, name: "Arwat" },
      { id: 541315, name: "Belsani" },
      { id: 541295, name: "Bor Rith" },
      { id: 541276, name: "Borda Indarpawar" },
      { id: 541275, name: "Chak Borda" },
      { id: 541264, name: "Chak Nimbala" },
      { id: 541270, name: "Chak Pimpal Khut" },
      { id: 541268, name: "Chak Waigaon No.1" },
      { id: 541277, name: "Chak Waigaon No.2." },
      { id: 541286, name: "Chak Walni" },
      { id: 943250, name: "Chanda Raiyyatwari" },
      { id: 541278, name: "Chandsurla" },
      { id: 541316, name: "Chandur" },
      { id: 541300, name: "Chargaon" },
      { id: 541312, name: "Chichala" },
      { id: 541288, name: "Chichpali" },
      { id: 541252, name: "Chincholi" },
      { id: 541324, name: "Chorala" },
      { id: 541248, name: "Chorgaon" },
      { id: 541310, name: "Datala" },
      { id: 943634, name: "Devai Govindpur Raiyyatwari" },
      { id: 943251, name: "Devai Govindpur Tukum" },
      { id: 541323, name: "Dewada" },
      { id: 541328, name: "Dhanora" },
      { id: 541259, name: "Doni" },
      { id: 541335, name: "Durgapur" },
      { id: 541305, name: "Gawarala Rith" },
      { id: 541285, name: "Ghanta Chauki" },
      { id: 541339, name: "Ghugus" },
      { id: 541273, name: "Gondsawari Rayyatwari" },
      { id: 943217, name: "Govindpur Rith" },
      { id: 541263, name: "Haldi" },
      { id: 541331, name: "Hingnala" },
      { id: 541294, name: "Jambharala" },
      { id: 541296, name: "Junona Rayyatwari" },
      { id: 541297, name: "Karwa" },
      { id: 541247, name: "Khandala Rith" },
      { id: 541308, name: "Khutala" },
      { id: 541250, name: "Kitali" },
      { id: 541258, name: "Kolasa" },
      { id: 541280, name: "Kondi Chak" },
      { id: 541334, name: "Kondimal" },
      { id: 541309, name: "Kosara" },
      { id: 541282, name: "Lakhamapur" },
      { id: 541284, name: "Lohara" },
      { id: 541272, name: "Mahadwadi" },
      { id: 541320, name: "Mahakurla" },
      { id: 541266, name: "Mamala" },
      { id: 541330, name: "Marada" },
      { id: 541293, name: "Marar Sawali" },
      { id: 541290, name: "Marar Sawali Chak" },
      { id: 541249, name: "Mhasala Rith" },
      { id: 541255, name: "Mhasala Tukum" },
      { id: 541317, name: "Mhatardevi" },
      { id: 541253, name: "Mingaon" },
      { id: 541243, name: "Mohurli" },
      { id: 541304, name: "Morwa" },
      { id: 541291, name: "Nagala (M)" },
      { id: 541313, name: "Nagala (Si)" },
      { id: 541301, name: "Nagpur (Chota)" },
      { id: 541340, name: "Nakoda" },
      { id: 541271, name: "Nandgur" },
      { id: 541281, name: "Neri" },
      { id: 541292, name: "Niljai" },
      { id: 541265, name: "Nimbala" },
      { id: 541254, name: "Padamapur" },
      { id: 541338, name: "Padoli" },
      { id: 541261, name: "Pahami" },
      { id: 541325, name: "Pandharkawada" },
      { id: 541251, name: "Payali Bhatali" },
      { id: 541262, name: "Peth" },
      { id: 541269, name: "Pimpal Khunt" },
      { id: 541329, name: "Pipri" },
      { id: 541283, name: "Ranvendali" },
      { id: 541298, name: "Sakharwahi" },
      { id: 541318, name: "Shengaon" },
      { id: 541333, name: "Shivinichor" },
      { id: 541321, name: "Sidur" },
      { id: 541257, name: "Sinala" },
      { id: 541314, name: "Sonegaon" },
      { id: 541311, name: "Sonurli" },
      { id: 541337, name: "Tadali" },
      { id: 541289, name: "Temta" },
      { id: 541299, name: "Umrilalman" },
      { id: 541336, name: "Urjanagar" },
      { id: 541326, name: "Usgaon" },
      { id: 541322, name: "Vendali" },
      { id: 541303, name: "Vichoda Bk." },
      { id: 541302, name: "Vichoda Raiyyatwari" },
      { id: 943252, name: "Wadgaon" },
      { id: 541327, name: "Wadha" },
      { id: 541244, name: "Wadholi" },
      { id: 541267, name: "Waigaon Mokasa" },
      { id: 541287, name: "Walni" },
      { id: 541307, name: "Wandhari" },
      { id: 541256, name: "Warwat" },
      { id: 541306, name: "Yerur" },
      { id: 541260, name: "Zari" },
    ],
    4072: [
      { id: 541383, name: "Agdi" },
      { id: 541373, name: "Akapur" },
      { id: 541415, name: "Akapur Indapwar" },
      { id: 541348, name: "Alewahi Alias Nawegaon" },
      { id: 943347, name: "Antargaon Paradwahi" },
      { id: 541437, name: "Babrala" },
      { id: 541361, name: "Belgata Mal" },
      { id: 541362, name: "Belghat Number 1" },
      { id: 541363, name: "Belghat Number 2" },
      { id: 541438, name: "Bembal" },
      { id: 541341, name: "Bendewahi Rith" },
      { id: 541356, name: "Bhadurni" },
      { id: 541394, name: "Bhagwanpur (Punarwasan)" },
      { id: 541419, name: "Bhawarala" },
      { id: 541424, name: "Bhejgaon" },
      { id: 541443, name: "Bondala Bk." },
      { id: 541444, name: "Bondala Kh." },
      { id: 541417, name: "Borchandli" },
      { id: 541442, name: "Borghat Chak" },
      { id: 541441, name: "Borghatmal" },
      { id: 541411, name: "Chak Akapur" },
      { id: 541436, name: "Chak Bembal" },
      { id: 541398, name: "Chak Chiroli" },
      { id: 541385, name: "Chak Dagadtala" },
      { id: 541409, name: "Chak Dahegaon" },
      { id: 541429, name: "Chak Dugala" },
      { id: 541435, name: "Chak Ghosari" },
      { id: 541358, name: "Chak Kanhalgaon" },
      { id: 541378, name: "Chak Katwan" },
      { id: 541391, name: "Chak Kawadpeth" },
      { id: 541395, name: "Chak Sarajkheda" },
      { id: 541420, name: "Chandapur" },
      { id: 541388, name: "Chichala (Mo)" },
      { id: 541376, name: "Chicholi" },
      { id: 541360, name: "Chikhali Chak No. 1" },
      { id: 541359, name: "Chikhali Chak No. 2" },
      { id: 541357, name: "Chikhali Mal" },
      { id: 541372, name: "Chimadha" },
      { id: 541399, name: "Chiroli" },
      { id: 541369, name: "Chitegaon" },
      { id: 541427, name: "Churul Tukum" },
      { id: 541412, name: "Dabgaon Makta" },
      { id: 541414, name: "Dabgaon Tukum" },
      { id: 541402, name: "Dahegaon Mal" },
      { id: 541346, name: "Dongargaon" },
      { id: 909067, name: "Dugala Mal" },
      { id: 541422, name: "Fiskuti" },
      { id: 541380, name: "Fulzari" },
      { id: 541426, name: "Gadisurla" },
      { id: 541352, name: "Gangalwadi" },
      { id: 541349, name: "Golabhuj" },
      { id: 944983, name: "Gondi Vihirgaon" },
      { id: 541389, name: "Gothangaon Rith" },
      { id: 541446, name: "Gowardhan" },
      { id: 541401, name: "Haldi Gaonganna" },
      { id: 541390, name: "Haldi Tukum" },
      { id: 541381, name: "Janala" },
      { id: 541421, name: "Junasurla" },
      { id: 541413, name: "Kanhalgaon" },
      { id: 541384, name: "Kantapeth Ryt." },
      { id: 541377, name: "Karwan" },
      { id: 541379, name: "Katwan Mal" },
      { id: 541392, name: "Kawadpeth Mal" },
      { id: 541406, name: "Kelzar" },
      { id: 541404, name: "Khalwaspeth" },
      { id: 541433, name: "Khandala Ryt." },
      { id: 541347, name: "Kombadwahi Rith" },
      { id: 541440, name: "Korambi" },
      { id: 541374, name: "Kosambi" },
      { id: 541375, name: "Kosambi Chak" },
      { id: 541396, name: "Manda Tukum" },
      { id: 541403, name: "Mankapur" },
      { id: 541371, name: "Marhegaon" },
      { id: 541366, name: "Maroda" },
      { id: 541382, name: "Mhasbodan Rith" },
      { id: 541368, name: "Morwahi Chak" },
      { id: 541367, name: "Morwahi Mal" },
      { id: 943353, name: "Mul" },
      { id: 541350, name: "Murmadi" },
      { id: 541416, name: "Naleshawar Chak" },
      { id: 541410, name: "Naleshwar Mokasa" },
      { id: 541445, name: "Nandgaon" },
      { id: 541439, name: "Nawegaon Bhujala" },
      { id: 541354, name: "Padzari Chak" },
      { id: 541355, name: "Padzari Rith" },
      { id: 541434, name: "Pipari Dixit" },
      { id: 541418, name: "Rajgad" },
      { id: 541342, name: "Rajoli" },
      { id: 943361, name: "Rampur Tukum" },
      { id: 541345, name: "Ratnapur" },
      { id: 541397, name: "Sandala" },
      { id: 541405, name: "Sarajkheda Mal" },
      { id: 541343, name: "Shivapur Gaonganna" },
      { id: 541344, name: "Shivapur Tukum" },
      { id: 541353, name: "Shiwapur Chak" },
      { id: 541430, name: "Sintala" },
      { id: 541365, name: "Somnath Prakalp" },
      { id: 541432, name: "Sukali Rith" },
      { id: 541407, name: "Sushi Dabgaon" },
      { id: 541387, name: "Tadala Rith" },
      { id: 541386, name: "Tadala Tukum" },
      { id: 541351, name: "Tadbhuj" },
      { id: 541370, name: "Tekadi" },
      { id: 541393, name: "Tolewahi" },
      { id: 541364, name: "Ushrala Chak" },
      { id: 541408, name: "Uthal Peth" },
      { id: 944984, name: "Vihirgaon Tukum" },
      { id: 541423, name: "Virai" },
      { id: 541400, name: "Wedi Rith" },
      { id: 541425, name: "Yejgaon" },
      { id: 541431, name: "Yergaon Alias Belgaon" },
    ],
    4073: [
      { id: 541487, name: "Ambai Tukum" },
      { id: 541488, name: "Ambe Dhanora Rith" },
      { id: 541504, name: "Ashta" },
      { id: 541501, name: "Bhatari" },
      { id: 541514, name: "Bhimani" },
      { id: 541497, name: "Borda Borkar" },
      { id: 541496, name: "Borda Dixit" },
      { id: 541486, name: "Borda Zulurwar" },
      { id: 541489, name: "Borgaon Rith" },
      { id: 541490, name: "Chak Aambedhanora" },
      { id: 541505, name: "Chak Ashta" },
      { id: 541510, name: "Chak Ballarpur" },
      { id: 541517, name: "Chak Bamhni" },
      { id: 541506, name: "Chak Chintaldhaba No.1" },
      { id: 541507, name: "Chak Chintaldhaba No.2" },
      { id: 541463, name: "Chak Futana" },
      { id: 541494, name: "Chak Ghanoti No.1" },
      { id: 541493, name: "Chak Ghanoti No.2" },
      { id: 541485, name: "Chak Hattibodi Rai." },
      { id: 541513, name: "Chak Khapari" },
      { id: 541503, name: "Chak Pombhurna" },
      { id: 541467, name: "Chak Thana" },
      { id: 541475, name: "Chakthane Wasana" },
      { id: 541469, name: "Dewada Bk." },
      { id: 541460, name: "Dewada Kh" },
      { id: 541500, name: "Dewai" },
      { id: 541466, name: "Dighori" },
      { id: 541451, name: "Dongar Haldi Mal" },
      { id: 541450, name: "Dongar Haldi No. 2" },
      { id: 541454, name: "Dongar Haldi Tukum" },
      { id: 541453, name: "Dongarhaldi No. 1" },
      { id: 541452, name: "Dongarhaldi No.3" },
      { id: 541464, name: "Futana Mokasa" },
      { id: 541473, name: "Gangapur Chek" },
      { id: 541495, name: "Ghanoti Tukum" },
      { id: 541516, name: "Ghatkul" },
      { id: 541465, name: "Ghosari" },
      { id: 541457, name: "Jam Kh." },
      { id: 541456, name: "Jam Tukum" },
      { id: 541458, name: "Jam Tukum Ryt." },
      { id: 541470, name: "Jungaon" },
      { id: 541472, name: "Juni Ladholi" },
      { id: 541498, name: "Kasargatta" },
      { id: 541499, name: "Kawit Bodi Rith" },
      { id: 541502, name: "Kemara" },
      { id: 541512, name: "Khapari Rith" },
      { id: 541462, name: "Kosambi Chak" },
      { id: 541484, name: "Kosambi Rith" },
      { id: 541478, name: "Loni Rith" },
      { id: 541511, name: "Mohala Rai." },
      { id: 541471, name: "Navi Ladoli" },
      { id: 541477, name: "Nawegaon Chak" },
      { id: 541476, name: "Nawegaon More" },
      { id: 541468, name: "Pipari Deshpande" },
      { id: 541483, name: "Pombhurna" },
      { id: 541459, name: "Rampur Dixit" },
      { id: 541455, name: "Rampur Zadikar" },
      { id: 541448, name: "Satara Bhosale" },
      { id: 541449, name: "Satara Komti" },
      { id: 541447, name: "Satara Tukum" },
      { id: 541479, name: "Selur Chak" },
      { id: 541482, name: "Selur Nagreddi" },
      { id: 541508, name: "Sonapur" },
      { id: 541509, name: "Sonapur Rith" },
      { id: 541474, name: "Thanewasana Mal" },
      { id: 541461, name: "Thergaon Ryt." },
      { id: 541515, name: "Tok" },
      { id: 541491, name: "Umari Potdar" },
      { id: 541492, name: "Umari Tukum" },
      { id: 541480, name: "Welwa Chak" },
      { id: 541481, name: "Welwa Mal" },
    ],
    4074: [
      { id: 541533, name: "Amdi" },
      { id: 541540, name: "Asegaon" },
      { id: 541527, name: "Ashti" },
      { id: 943253, name: "Ballarpur" },
      { id: 541524, name: "Bamhani" },
      { id: 541521, name: "Bhivkund" },
      { id: 541518, name: "Charwat" },
      { id: 541526, name: "Daheli" },
      { id: 541520, name: "Dharmashala Tukum" },
      { id: 541525, name: "Dudholi" },
      { id: 541541, name: "Gilbili" },
      { id: 541519, name: "Hadasti" },
      { id: 541545, name: "Haranpayali Rithi" },
      { id: 541538, name: "Itoli Chak No.1" },
      { id: 541542, name: "Itoli Chak No.2." },
      { id: 541529, name: "Jogapur" },
      { id: 541532, name: "Kalamna" },
      { id: 541547, name: "Katwali" },
      { id: 541544, name: "Kawadjai" },
      { id: 541523, name: "Kem Rith" },
      { id: 541522, name: "Kem Tukum" },
      { id: 541548, name: "Khamturla (Rithi)" },
      { id: 541535, name: "Kinhi" },
      { id: 541530, name: "Korti Makta" },
      { id: 541531, name: "Korti Tukum" },
      { id: 541546, name: "Kothari" },
      { id: 541528, name: "Lawari" },
      { id: 943254, name: "Mana" },
      { id: 541543, name: "Manora" },
      { id: 541539, name: "Mohali Tukum" },
      { id: 541549, name: "Nandgaon Pode" },
      { id: 541537, name: "Nimgata Chak" },
      { id: 541536, name: "Nimgata Makta" },
      { id: 541534, name: "Palasgaon" },
      { id: 541550, name: "Visapur" },
    ],
    4075: [
      { id: 541558, name: "Akola" },
      { id: 541596, name: "Antargaon Bk." },
      { id: 541647, name: "Asan Bk." },
      { id: 541649, name: "Asan Kh." },
      { id: 541661, name: "Awalpur" },
      { id: 541643, name: "Bakhardi" },
      { id: 541615, name: "Belgaon" },
      { id: 541625, name: "Bharosa" },
      { id: 541626, name: "Bhoyegaon" },
      { id: 541651, name: "Bibi" },
      { id: 541622, name: "Borgaon" },
      { id: 541582, name: "Borgaon Bk." },
      { id: 541580, name: "Borgaon Kh." },
      { id: 541598, name: "Bori Navegaon" },
      { id: 541565, name: "Chanai Bk." },
      { id: 541577, name: "Chanai Kh." },
      { id: 541599, name: "Chich Navegaon" },
      { id: 541613, name: "Chichkhod" },
      { id: 541614, name: "Chincholi" },
      { id: 541566, name: "Chopan" },
      { id: 541605, name: "Dahegaon" },
      { id: 541632, name: "Danoda Rith" },
      { id: 541610, name: "Devghat" },
      { id: 541655, name: "Dhamangaon" },
      { id: 541612, name: "Dhanoli" },
      { id: 541603, name: "Dhoptala" },
      { id: 541645, name: "Dhunki" },
      { id: 541569, name: "Durgadi" },
      { id: 541631, name: "Ekodi" },
      { id: 541623, name: "Erai" },
      { id: 909167, name: "Gadchandur" },
      { id: 541633, name: "Gadegaon" },
      { id: 541587, name: "Gandhinagar" },
      { id: 541604, name: "Ganeshmod Rith" },
      { id: 541554, name: "Govindpur" },
      { id: 541579, name: "Hatloni" },
      { id: 541590, name: "Heti" },
      { id: 541634, name: "Hirapur" },
      { id: 541658, name: "Injapur" },
      { id: 541628, name: "Jaitapur" },
      { id: 541574, name: "Jamuldhara" },
      { id: 541559, name: "Jewara" },
      { id: 541627, name: "Jewara Rith" },
      { id: 541597, name: "Kadholi Kh." },
      { id: 541564, name: "Kanhalgaon" },
      { id: 541653, name: "Karawa" },
      { id: 541617, name: "Kargaon Bk." },
      { id: 541620, name: "Karwahi" },
      { id: 541561, name: "Katlabodi" },
      { id: 541635, name: "Kavithgaon(Rith)" },
      { id: 541637, name: "Kawathala" },
      { id: 541581, name: "Kerambodi" },
      { id: 541567, name: "Khadki" },
      { id: 541607, name: "Khairgaon ( Wansadi )" },
      { id: 541578, name: "Khairgaon (Korpana)" },
      { id: 541636, name: "Khairgaon 2" },
      { id: 541650, name: "Khirdi" },
      { id: 541586, name: "Kodsi Bk." },
      { id: 541588, name: "Kodsi Kh." },
      { id: 541639, name: "Koradi" },
      { id: 541560, name: "Korpana" },
      { id: 541555, name: "Kothoda Bk." },
      { id: 541553, name: "Kothoda Kh." },
      { id: 541654, name: "Kukadsath" },
      { id: 541563, name: "Kukalbodi" },
      { id: 541562, name: "Kusal" },
      { id: 541652, name: "Lakhamapur" },
      { id: 541601, name: "Loni" },
      { id: 541583, name: "Mandawa" },
      { id: 541571, name: "Mangulhira" },
      { id: 541602, name: "Matha" },
      { id: 541556, name: "Mehandi" },
      { id: 541662, name: "Nanda" },
      { id: 541630, name: "Nandgaon" },
      { id: 541600, name: "Naranda" },
      { id: 541638, name: "Navegaon" },
      { id: 541644, name: "Nimani" },
      { id: 541642, name: "Nokari" },
      { id: 541648, name: "Palezari" },
      { id: 541641, name: "Palgaon" },
      { id: 541609, name: "Paramba" },
      { id: 541557, name: "Pardi" },
      { id: 541551, name: "Parsoda" },
      { id: 541646, name: "Pipalgaon" },
      { id: 541616, name: "Piparda" },
      { id: 541592, name: "Pipri" },
      { id: 541552, name: "Raipur" },
      { id: 541568, name: "Rupapeth" },
      { id: 541619, name: "Sangoda" },
      { id: 541576, name: "Sawalhira" },
      { id: 541589, name: "Seraj Kh." },
      { id: 541591, name: "Sheraj Bk" },
      { id: 541570, name: "Shivapur" },
      { id: 541595, name: "Shivnaranda" },
      { id: 541621, name: "Sonurli (Virur Gadegaon)" },
      { id: 541606, name: "Sonurli (Wansadi)" },
      { id: 541640, name: "Talodhi" },
      { id: 541585, name: "Tambadi" },
      { id: 541624, name: "Tamsi" },
      { id: 541611, name: "Tanda" },
      { id: 541575, name: "Tangala" },
      { id: 541572, name: "Thippa" },
      { id: 541659, name: "Thutra" },
      { id: 541584, name: "Tulsi" },
      { id: 541573, name: "Umarhira" },
      { id: 541660, name: "Upparwahi" },
      { id: 541629, name: "Virur" },
      { id: 541656, name: "Wadgaon" },
      { id: 541594, name: "Wanoja" },
      { id: 541608, name: "Wansadi" },
      { id: 541618, name: "Yergavhan" },
      { id: 541593, name: "Zoting" },
      { id: 541657, name: "Zulbardi" },
    ],
    4076: [
      { id: 541721, name: "Ambezari" },
      { id: 541743, name: "Antapur" },
      { id: 541685, name: "Asapur" },
      { id: 541738, name: "Babapur" },
      { id: 541727, name: "Belgaon" },
      { id: 541717, name: "Bhaipathar" },
      { id: 541736, name: "Bhari" },
      { id: 541731, name: "Bhokasapur" },
      { id: 541703, name: "Chikali Kh." },
      { id: 541707, name: "Chikhali Buj" },
      { id: 909199, name: "Dampur Mohada" },
      { id: 541696, name: "Dewalaguda" },
      { id: 541689, name: "Dhanakdevi" },
      { id: 541730, name: "Dharmaram" },
      { id: 541670, name: "Dharpana" },
      { id: 541700, name: "Dhonda Arjuni" },
      { id: 541699, name: "Dhonda Mandwa" },
      { id: 541729, name: "Dongargaon" },
      { id: 541710, name: "Gadhpandharwani" },
      { id: 541718, name: "Ganeri" },
      { id: 541735, name: "Govindpur" },
      { id: 541673, name: "Gudsela" },
      { id: 541680, name: "Hatkarguda" },
      { id: 541725, name: "Himayatnagar" },
      { id: 541688, name: "Jabhuldhara" },
      { id: 541713, name: "Jankapur" },
      { id: 541694, name: "Jiwati" },
      { id: 541711, name: "Kakaban" },
      { id: 541671, name: "Kamalpur" },
      { id: 541669, name: "Karankondi" },
      { id: 541687, name: "Kargaon Kh." },
      { id: 541674, name: "Kekezari" },
      { id: 541719, name: "Khadki Hirapur" },
      { id: 541708, name: "Khadki Jamni" },
      { id: 541668, name: "Kodepur" },
      { id: 541741, name: "Kotha Bu" },
      { id: 541684, name: "Kumbhezari" },
      { id: 541712, name: "Kusumbi" },
      { id: 909200, name: "Labhanguda" },
      { id: 541666, name: "Lambori" },
      { id: 541746, name: "Lendiguda" },
      { id: 541695, name: "Loldoh" },
      { id: 541740, name: "Maharajguda" },
      { id: 541681, name: "Manguda" },
      { id: 541705, name: "Maraipatann" },
      { id: 541726, name: "Markagondi" },
      { id: 541686, name: "Markagondi 1" },
      { id: 541693, name: "Markalmetta" },
      { id: 541742, name: "Mukadamguda" },
      { id: 541697, name: "Nagapur" },
      { id: 541709, name: "Nagrala" },
      { id: 541728, name: "Nandappa" },
      { id: 541667, name: "Narpathar" },
      { id: 541679, name: "Nokewada" },
      { id: 541744, name: "Palasguda" },
      { id: 541704, name: "Paldoh" },
      { id: 541722, name: "Pallezari" },
      { id: 541691, name: "Pandharwani" },
      { id: 541739, name: "Parmdoli" },
      { id: 541702, name: "Pataguda" },
      { id: 541714, name: "Patan" },
      { id: 541733, name: "Pitiguda No.1" },
      { id: 541734, name: "Pitiguda No.2" },
      { id: 541677, name: "Pudiyal Mohada" },
      { id: 541716, name: "Punaguda" },
      { id: 541706, name: "Rahpalli Bk." },
      { id: 541724, name: "Rahpalli Kh" },
      { id: 541692, name: "Sarangpur" },
      { id: 541678, name: "Sevadasnagar" },
      { id: 541737, name: "Shedwahi 2" },
      { id: 541672, name: "Shedwahi-1" },
      { id: 541723, name: "Shengaon" },
      { id: 541664, name: "Singarpathar" },
      { id: 541732, name: "Sorakasa" },
      { id: 541715, name: "Tatakohad" },
      { id: 541701, name: "Teka Mandwa" },
      { id: 541698, name: "Tekaarjuni" },
      { id: 541720, name: "Titvi" },
      { id: 541683, name: "Wani (Kh.)" },
      { id: 541682, name: "Wani Bk" },
      { id: 541665, name: "Yellapur" },
      { id: 541690, name: "Yerami Isapur" },
      { id: 541745, name: "Yessapur" },
    ],
    4077: [
      { id: 541787, name: "Aheri" },
      { id: 541834, name: "Annur" },
      { id: 541833, name: "Antargaon" },
      { id: 541768, name: "Antargaon Kh." },
      { id: 541775, name: "Arvi" },
      { id: 541758, name: "Babapur" },
      { id: 541771, name: "Bamanwada" },
      { id: 541851, name: "Bambezari" },
      { id: 541848, name: "Belampur" },
      { id: 541817, name: "Berdi" },
      { id: 541763, name: "Bhadangpur Rith" },
      { id: 541811, name: "Bhedoda" },
      { id: 541816, name: "Bhendala" },
      { id: 541840, name: "Bhendvi" },
      { id: 541843, name: "Bhurkunda Bk" },
      { id: 541841, name: "Bhurkunda Kh." },
      { id: 541789, name: "Botgaon" },
      { id: 541799, name: "Chanakha" },
      { id: 541779, name: "Chandanwahi" },
      { id: 541751, name: "Charli" },
      { id: 541827, name: "Chinchala" },
      { id: 541809, name: "Chinchbodi" },
      { id: 541832, name: "Chincholi Bk." },
      { id: 541762, name: "Chincholi Kh." },
      { id: 541808, name: "Chirud Rith" },
      { id: 541770, name: "Chunala" },
      { id: 541853, name: "Dewada" },
      { id: 541820, name: "Dhanora" },
      { id: 541749, name: "Dhidsi" },
      { id: 541856, name: "Dhopatala" },
      { id: 541828, name: "Dongargaon" },
      { id: 541825, name: "Ghotta" },
      { id: 541794, name: "Goraj(Rith)" },
      { id: 541761, name: "Gowari" },
      { id: 541777, name: "Goyegaon" },
      { id: 541781, name: "Hardona Bk." },
      { id: 541782, name: "Hardona Kh." },
      { id: 541838, name: "Hirapur" },
      { id: 541764, name: "Hirapur Chincholi" },
      { id: 541837, name: "Isapur" },
      { id: 541836, name: "Jamani" },
      { id: 541797, name: "Jogapur" },
      { id: 541750, name: "Kadholi Bk." },
      { id: 541845, name: "Kakadghat" },
      { id: 541766, name: "Kalamana" },
      { id: 541774, name: "Kapangaon" },
      { id: 541847, name: "Kawadgondi" },
      { id: 541813, name: "Kawathala (Rithi)" },
      { id: 541831, name: "Kawitpeth" },
      { id: 541822, name: "Kelzar" },
      { id: 541776, name: "Khairgaon (Rithi)" },
      { id: 541806, name: "Khambada" },
      { id: 541778, name: "Khamona" },
      { id: 541854, name: "Khirdi" },
      { id: 541754, name: "Kinebodi" },
      { id: 541792, name: "Kochi" },
      { id: 541802, name: "Kohapara" },
      { id: 541759, name: "Kolgaon" },
      { id: 541826, name: "Kostala" },
      { id: 541747, name: "Kurli" },
      { id: 541824, name: "Lakkadkot" },
      { id: 541801, name: "Mangaon" },
      { id: 541783, name: "Mangi Bk" },
      { id: 541784, name: "Mangi Kh." },
      { id: 541760, name: "Manoli Bk." },
      { id: 541835, name: "Manoli Kh." },
      { id: 541748, name: "Marda" },
      { id: 541769, name: "Mathara" },
      { id: 541804, name: "Murti" },
      { id: 541767, name: "Muthara" },
      { id: 541805, name: "Nalphadi" },
      { id: 541818, name: "Navegaon" },
      { id: 541765, name: "Nimbala" },
      { id: 541752, name: "Nirli" },
      { id: 541850, name: "Nokari Bk." },
      { id: 541849, name: "Nokari Kh." },
      { id: 541842, name: "Pachgaon" },
      { id: 541800, name: "Panchala" },
      { id: 541785, name: "Pandharpauni" },
      { id: 541757, name: "Pauni" },
      { id: 541753, name: "Pellora" },
      { id: 541773, name: "Pendhari (Rith)" },
      { id: 943367, name: "Rajura" },
      { id: 541772, name: "Rampur" },
      { id: 541793, name: "Ranvelli" },
      { id: 541788, name: "Ruyad Rith" },
      { id: 541756, name: "Sakhari" },
      { id: 541791, name: "Sakharwahi" },
      { id: 541855, name: "Sasti" },
      { id: 541798, name: "Satri" },
      { id: 541807, name: "Shirsi" },
      { id: 541823, name: "Siddheshwar" },
      { id: 541819, name: "Sindi" },
      { id: 541812, name: "Sindola (Rithi)" },
      { id: 541839, name: "Sonapur" },
      { id: 541814, name: "Sondo" },
      { id: 541815, name: "Sonurli" },
      { id: 541829, name: "Subai" },
      { id: 541844, name: "Sukadpalli" },
      { id: 541790, name: "Sumthana" },
      { id: 541810, name: "Tembhurwahi" },
      { id: 541796, name: "Tulana" },
      { id: 541830, name: "Tummaguda" },
      { id: 541852, name: "Umarzara" },
      { id: 541803, name: "Vihirgaon" },
      { id: 541780, name: "Vihirgaon Rith" },
      { id: 541821, name: "Virur Station" },
      { id: 541786, name: "Wangi (Rith)" },
      { id: 541755, name: "Waroda" },
      { id: 541795, name: "Warurroad" },
      { id: 541846, name: "Yergavhan" },
    ],
    4078: [
      { id: 541930, name: "Adegaon" },
      { id: 541858, name: "Aksapur" },
      { id: 541925, name: "Arvi" },
      { id: 541871, name: "Bhanar Heti" },
      { id: 541912, name: "Bhangarpeth" },
      { id: 541911, name: "Bhangram Talodhi" },
      { id: 541874, name: "Borgaon" },
      { id: 541943, name: "Chak Bapur" },
      { id: 541873, name: "Chak Borgaon" },
      { id: 541919, name: "Chak Dongargaon" },
      { id: 541906, name: "Chak Dubarpeth" },
      { id: 541885, name: "Chak Ghadoli" },
      { id: 541907, name: "Chak Gojoli" },
      { id: 541940, name: "Chak Nandgaon" },
      { id: 943175, name: "Chak Patalwada" },
      { id: 541908, name: "Chak Talodhi" },
      { id: 541868, name: "Chak Tarada" },
      { id: 541891, name: "Chak Vihirgaon" },
      { id: 541910, name: "Chak Vithalwada" },
      { id: 541929, name: "Chakdarur" },
      { id: 541863, name: "Chaklikhitwada" },
      { id: 541936, name: "Chaknavegaon" },
      { id: 541916, name: "Chakpargaon" },
      { id: 541896, name: "Chakpipari" },
      { id: 541899, name: "Chaksukwasi" },
      { id: 541859, name: "Chek Beradi" },
      { id: 541887, name: "Chek Vyankatpur" },
      { id: 541862, name: "Chek Wedgaon" },
      { id: 541875, name: "Chekpellur" },
      { id: 541921, name: "Cheksomanpalli" },
      { id: 909212, name: "Chekwadkuli" },
      { id: 541904, name: "Chiwandha" },
      { id: 541935, name: "Darur" },
      { id: 541927, name: "Dhaba" },
      { id: 541915, name: "Dhamangaon" },
      { id: 541890, name: "Dhamanpeth" },
      { id: 541877, name: "Dhanapur" },
      { id: 541928, name: "Dongargaon Makta" },
      { id: 541909, name: "Fulora" },
      { id: 541870, name: "Furdi Heti" },
      { id: 541897, name: "Ganeshpipari" },
      { id: 541857, name: "Ganpur" },
      { id: 541880, name: "Ghadoli" },
      { id: 541905, name: "Gojoli Makta" },
      { id: 541954, name: "Gondpipri" },
      { id: 541944, name: "Gujari" },
      { id: 541939, name: "Heti Nandgaon" },
      { id: 541938, name: "Hiwara" },
      { id: 541901, name: "Kanhalgaon" },
      { id: 541876, name: "Karanji" },
      { id: 541872, name: "Kharalpeth" },
      { id: 541937, name: "Kirmiri" },
      { id: 541922, name: "Kondhana" },
      { id: 541893, name: "Korambi" },
      { id: 541900, name: "Kudesavali" },
      { id: 541869, name: "Kultha" },
      { id: 541941, name: "Kunde Nandgaon" },
      { id: 541946, name: "Lathi" },
      { id: 541865, name: "Likhitwada Rith" },
      { id: 541923, name: "Mangal Peth" },
      { id: 541881, name: "Nandgaon" },
      { id: 541934, name: "Nandwardhan" },
      { id: 541884, name: "Nawegaon Waghade" },
      { id: 541903, name: "Pachgaon" },
      { id: 541932, name: "Panora" },
      { id: 541947, name: "Pardi" },
      { id: 541902, name: "Parsodi" },
      { id: 541879, name: "Patalwada Rith" },
      { id: 541892, name: "Piparitukum" },
      { id: 541953, name: "Podsa" },
      { id: 541913, name: "Ralapeth" },
      { id: 541942, name: "Sakmur" },
      { id: 541914, name: "Salezari" },
      { id: 541945, name: "Sarandi" },
      { id: 541933, name: "Shivani Deshpande" },
      { id: 541861, name: "Sirsi Deulwar" },
      { id: 541920, name: "Somanpalli Makta" },
      { id: 541952, name: "Sonapur Deshpande" },
      { id: 541931, name: "Supgaon" },
      { id: 541886, name: "Surgaon" },
      { id: 541867, name: "Tarda" },
      { id: 541895, name: "Tarsa Bk." },
      { id: 541894, name: "Tarsa Kh." },
      { id: 541864, name: "Tekoda" },
      { id: 541924, name: "Tohogaon" },
      { id: 541949, name: "Tomta" },
      { id: 541918, name: "Undirgaon Kantepeth" },
      { id: 541917, name: "Undirgaon Ryt." },
      { id: 541889, name: "Vihirgaon" },
      { id: 541883, name: "Vithalwada" },
      { id: 541888, name: "Vyankatpur" },
      { id: 541866, name: "Wadholi" },
      { id: 541860, name: "Wadkuli" },
      { id: 541948, name: "Wamanpalli" },
      { id: 541898, name: "Watrana" },
      { id: 541950, name: "Wedgaon" },
      { id: 541926, name: "Wejgaon" },
      { id: 541882, name: "Yen Bothala" },
    ],
    4079: [
      { id: 541978, name: "Adgaon" },
      { id: 541967, name: "Ajani" },
      { id: 541991, name: "Ajanti" },
      { id: 542001, name: "Ajaypur" },
      { id: 542046, name: "Balapur" },
      { id: 541989, name: "Balegaon" },
      { id: 542011, name: "Bangaon" },
      { id: 542066, name: "Bavhala" },
      { id: 541980, name: "Bhalki" },
      { id: 542036, name: "Bharad" },
      { id: 542003, name: "Bhawarkhed" },
      { id: 541996, name: "Borgaon" },
      { id: 542068, name: "Borgaon Ujad" },
      { id: 542041, name: "Bramhanwada (East)" },
      { id: 542063, name: "Bramhanwada (Ujad)" },
      { id: 541961, name: "Bramhanwada West" },
      { id: 945011, name: "Bramhapuri" },
      { id: 541973, name: "Chikani" },
      { id: 542029, name: "Chikhali Kanhoba" },
      { id: 542010, name: "Chinchgaon" },
      { id: 541983, name: "Dagaddhanora" },
      { id: 542061, name: "Dahifal" },
      { id: 541997, name: "Dawargaon" },
      { id: 542033, name: "Dhanaj" },
      { id: 542015, name: "Dodki" },
      { id: 541974, name: "Domga" },
      { id: 541955, name: "Donad" },
      { id: 542044, name: "Fattapur" },
      { id: 541998, name: "Fattepur" },
      { id: 542026, name: "Gaulan" },
      { id: 541982, name: "Gharefal" },
      { id: 542069, name: "Ghui" },
      { id: 542007, name: "Gondgavhan" },
      { id: 542035, name: "Hirapur" },
      { id: 542055, name: "Indira Nagar" },
      { id: 542045, name: "Indrathana" },
      { id: 542008, name: "Injapur" },
      { id: 542062, name: "Jawalgaon" },
      { id: 542070, name: "Kamandev" },
      { id: 541958, name: "Kanhergaon" },
      { id: 542065, name: "Kapshi" },
      { id: 541979, name: "Karkheda" },
      { id: 541959, name: "Khalana" },
      { id: 541960, name: "Khanapur" },
      { id: 542016, name: "Khandala" },
      { id: 541957, name: "Kharadgaon" },
      { id: 542013, name: "Kharbi" },
      { id: 541976, name: "Kholapuri" },
      { id: 542043, name: "Khutafali" },
      { id: 541984, name: "Kohala" },
      { id: 542006, name: "Kolura" },
      { id: 945015, name: "Krushnapur" },
      { id: 542027, name: "Kuregaon" },
      { id: 541995, name: "Lankanath" },
      { id: 542067, name: "Linga" },
      { id: 541970, name: "Lohatwadi" },
      { id: 542004, name: "Lonadi" },
      { id: 541988, name: "Loni" },
      { id: 945014, name: "Magladevi Khad 2" },
      { id: 541966, name: "Mahajanpur" },
      { id: 542030, name: "Makrampur" },
      { id: 541987, name: "Malkapur" },
      { id: 542049, name: "Malkhed Bk." },
      { id: 542050, name: "Malkhed Kh." },
      { id: 541986, name: "Mandawgad" },
      { id: 542032, name: "Mangladevi Khand1" },
      { id: 542038, name: "Mangrul" },
      { id: 542037, name: "Manikwada" },
      { id: 542019, name: "Marwadi" },
      { id: 541972, name: "Mirapur" },
      { id: 541969, name: "Mozar" },
      { id: 542009, name: "Mukindpur" },
      { id: 542025, name: "Muktyarpur" },
      { id: 945013, name: "Nababpur" },
      { id: 542024, name: "Nathrad" },
      { id: 912937, name: "Ner" },
      { id: 542056, name: "Pachwad" },
      { id: 541963, name: "Pandhari" },
      { id: 541965, name: "Parjana" },
      { id: 542034, name: "Pathrad Gole" },
      { id: 542057, name: "Pendhara" },
      { id: 542005, name: "Pimpalgaon Dubba" },
      { id: 541990, name: "Pimpalgaon Kala" },
      { id: 945012, name: "Pimplad" },
      { id: 542047, name: "Pimpri Ijara" },
      { id: 542018, name: "Pimprikalga" },
      { id: 541992, name: "Raipur" },
      { id: 541956, name: "Ramgaon" },
      { id: 541971, name: "Ratnapur" },
      { id: 541994, name: "Renukapur" },
      { id: 542053, name: "Sankhas Heti" },
      { id: 542064, name: "Sarangpur" },
      { id: 542028, name: "Sarata" },
      { id: 541981, name: "Satefal" },
      { id: 542002, name: "Sawanga" },
      { id: 541962, name: "Sawargaon" },
      { id: 541993, name: "Shabaspur" },
      { id: 542058, name: "Shahapur" },
      { id: 542060, name: "Shendri Kh." },
      { id: 541999, name: "Sidhakpur" },
      { id: 542042, name: "Sindkhed" },
      { id: 541964, name: "Sirajgaon" },
      { id: 542054, name: "Sonkhas" },
      { id: 542051, name: "Sonwadhona" },
      { id: 542059, name: "Takali Kh." },
      { id: 542040, name: "Takali Salami" },
      { id: 541975, name: "Tembhi" },
      { id: 542031, name: "Tembhi Ujad" },
      { id: 542014, name: "Udapur" },
      { id: 541977, name: "Umartha" },
      { id: 542039, name: "Umarvihir" },
      { id: 542052, name: "Uttarwadhona" },
      { id: 542023, name: "Vijvihir" },
      { id: 541968, name: "Vyahali" },
      { id: 542000, name: "Wai (Ijara)" },
      { id: 542012, name: "Wai (Paras)" },
      { id: 542020, name: "Walki" },
      { id: 542017, name: "Wanarkhed" },
      { id: 542021, name: "Watfala" },
      { id: 542022, name: "Watfali" },
      { id: 542048, name: "Wirgavhan" },
      { id: 541985, name: "Zombadi" },
    ],
    4080: [
      { id: 542189, name: "Alegaon" },
      { id: 542075, name: "Alipur" },
      { id: 542176, name: "Allipur Ujad" },
      { id: 542153, name: "Amravati" },
      { id: 542196, name: "Anjangaon" },
      { id: 542166, name: "Antargaon" },
      { id: 542200, name: "Asegaondevi" },
      { id: 542115, name: "Ashtarampur" },
      { id: 542156, name: "Aurangpur" },
      { id: 542160, name: "Babhulgaon" },
      { id: 542204, name: "Bagapur" },
      { id: 542106, name: "Bagwadi" },
      { id: 542085, name: "Barad" },
      { id: 542122, name: "Barad (Pu.)" },
      { id: 542146, name: "Bhaiyapur" },
      { id: 542096, name: "Bhatmarg" },
      { id: 542208, name: "Bhatmarg (Pu)" },
      { id: 542202, name: "Bhiluksa" },
      { id: 542198, name: "Borgaon" },
      { id: 542161, name: "Chandapur" },
      { id: 542191, name: "Chendkapur" },
      { id: 542195, name: "Chimnapur" },
      { id: 542206, name: "Chondhi" },
      { id: 542087, name: "Dabha Khand 1" },
      { id: 944908, name: "Dabha Khand 2" },
      { id: 542099, name: "Dehani" },
      { id: 542168, name: "Deogaon" },
      { id: 542089, name: "Dighi" },
      { id: 542207, name: "Dighi .2" },
      { id: 542164, name: "Dighi 1 (Punrvasan)" },
      { id: 542123, name: "Falegaon" },
      { id: 542133, name: "Fatiyabad" },
      { id: 542083, name: "Fattepur (Pu.)" },
      { id: 542072, name: "Fattepur (Ujad)" },
      { id: 542203, name: "Galwha" },
      { id: 542098, name: "Galwhi" },
      { id: 542167, name: "Ganori" },
      { id: 542125, name: "Gawandi" },
      { id: 542109, name: "Gharfal" },
      { id: 542163, name: "Gimona" },
      { id: 542127, name: "Gondhali" },
      { id: 542162, name: "Haibatpur" },
      { id: 542143, name: "Hastapur" },
      { id: 542150, name: "Hatgaon" },
      { id: 542186, name: "Indira Nagar" },
      { id: 542144, name: "Isapur" },
      { id: 542197, name: "Kamaljapur" },
      { id: 542140, name: "Kangokul" },
      { id: 542209, name: "Karalgaon" },
      { id: 542094, name: "Khadaksawanga" },
      { id: 542093, name: "Khadaksawanga (Pu)" },
      { id: 542119, name: "Kharda" },
      { id: 542126, name: "Kinhi" },
      { id: 542084, name: "Kolhi 1" },
      { id: 542121, name: "Kolhi 2" },
      { id: 542145, name: "Kondha" },
      { id: 542082, name: "Kopara 1 (Pu.)" },
      { id: 542139, name: "Kopara 2" },
      { id: 542086, name: "Kopara Ba." },
      { id: 542137, name: "Kopra Ja." },
      { id: 542185, name: "Kotamba" },
      { id: 542079, name: "Kotha (Ujad)" },
      { id: 542076, name: "Kotha Alipur (Punarvasit)" },
      { id: 542184, name: "Krishnapur" },
      { id: 542073, name: "Lakhamapur" },
      { id: 542173, name: "Loni" },
      { id: 542182, name: "Madani" },
      { id: 542155, name: "Mahamadpur" },
      { id: 542107, name: "Mahamadpur (Sarul)" },
      { id: 542100, name: "Mahuli" },
      { id: 542097, name: "Malapur" },
      { id: 542165, name: "Malapur (Pu.)" },
      { id: 542136, name: "Mangarul" },
      { id: 542141, name: "Mangsawangi" },
      { id: 542169, name: "Mankapur" },
      { id: 542175, name: "Maralpur" },
      { id: 542170, name: "Mirjapur" },
      { id: 542124, name: "Mitanapur" },
      { id: 542142, name: "Mitanapur (Fale)" },
      { id: 542091, name: "Mitanapur (Pu.)" },
      { id: 542180, name: "Mouja Wai" },
      { id: 542149, name: "Mubarakpur" },
      { id: 542134, name: "Muradabad" },
      { id: 542131, name: "Mustabad" },
      { id: 542151, name: "Nadesawangi" },
      { id: 542101, name: "Nagargaon" },
      { id: 542147, name: "Nagargaon Khurd" },
      { id: 542193, name: "Nagari (Pu.)" },
      { id: 542102, name: "Nagri" },
      { id: 542158, name: "Naigaon" },
      { id: 542138, name: "Nandura Bk." },
      { id: 542187, name: "Nandura Kh" },
      { id: 542074, name: "Narapur" },
      { id: 542116, name: "Pachkhed" },
      { id: 542088, name: "Pahur I" },
      { id: 542174, name: "Pahur Khand 1" },
      { id: 944992, name: "Pahur Khand 2" },
      { id: 542135, name: "Paloti" },
      { id: 542104, name: "Panas" },
      { id: 542179, name: "Panchgavhan" },
      { id: 542108, name: "Parsodi" },
      { id: 542095, name: "Pimpalgaon" },
      { id: 542199, name: "Pimpalgaon (Ujad)" },
      { id: 542081, name: "Pimpalkhuta" },
      { id: 542080, name: "Pimpalkhuta (Pu.)" },
      { id: 542092, name: "Pratappur (Pu)" },
      { id: 542194, name: "Rani Amravati" },
      { id: 542103, name: "Rasulpur" },
      { id: 542148, name: "Raut Sawangi" },
      { id: 542111, name: "Renukapur" },
      { id: 542078, name: "Rustampur" },
      { id: 542118, name: "Sarfali" },
      { id: 542120, name: "Sarul" },
      { id: 542114, name: "Saujana" },
      { id: 542201, name: "Sawar" },
      { id: 542077, name: "Shekapur" },
      { id: 542110, name: "Shindi" },
      { id: 542177, name: "Subhanpur" },
      { id: 542159, name: "Suhagpur" },
      { id: 542211, name: "Sukali" },
      { id: 542105, name: "Takalgaon" },
      { id: 542152, name: "Tamba" },
      { id: 542172, name: "Tanapur" },
      { id: 542210, name: "Taroda" },
      { id: 542090, name: "Thalegaon" },
      { id: 542171, name: "Tukapur" },
      { id: 542178, name: "Umarda" },
      { id: 542205, name: "Umari" },
      { id: 542192, name: "Vaijapur" },
      { id: 542188, name: "Vani" },
      { id: 542154, name: "Veni" },
      { id: 542132, name: "Virkhed" },
      { id: 542128, name: "Wadgaon" },
      { id: 542157, name: "Waghapur" },
      { id: 542112, name: "Walidadpur" },
      { id: 542113, name: "Warud" },
      { id: 542129, name: "Watkhed Bk." },
      { id: 542130, name: "Watkhed Kh" },
      { id: 542117, name: "Yarandgaon" },
      { id: 542190, name: "Yawali" },
      { id: 542183, name: "Zapat Khed" },
      { id: 542181, name: "Zola" },
    ],
    4081: [
      { id: 542321, name: "Ajani (U)" },
      { id: 542248, name: "Aloda" },
      { id: 542294, name: "Amala" },
      { id: 542297, name: "Andhbori" },
      { id: 542341, name: "Antargaon" },
      { id: 542223, name: "Ashti" },
      { id: 542252, name: "Aurangpur" },
      { id: 542212, name: "Barhanpur" },
      { id: 542232, name: "Belona" },
      { id: 542328, name: "Belori" },
      { id: 542225, name: "Bhavanpur" },
      { id: 542239, name: "Borimahal" },
      { id: 542292, name: "Borjai" },
      { id: 542231, name: "Chaparda" },
      { id: 542262, name: "Chincholi" },
      { id: 542289, name: "Dahegaon" },
      { id: 542244, name: "Dattapur" },
      { id: 542273, name: "Daulatpur" },
      { id: 542318, name: "Deonala" },
      { id: 542229, name: "Dhamni" },
      { id: 542226, name: "Dhanodi" },
      { id: 542299, name: "Dhotra" },
      { id: 542291, name: "Dodapur" },
      { id: 542335, name: "Dongarkharda" },
      { id: 542275, name: "Donoda" },
      { id: 542245, name: "Durg" },
      { id: 542281, name: "Eklaspur" },
      { id: 542303, name: "Gandha" },
      { id: 542329, name: "Gandhinagar" },
      { id: 542319, name: "Ganeshwadi" },
      { id: 542272, name: "Gangadevi" },
      { id: 542267, name: "Gangapur" },
      { id: 542233, name: "Ghoti" },
      { id: 542255, name: "Glamgaon" },
      { id: 542259, name: "Haibatpur" },
      { id: 542304, name: "Hiradi" },
      { id: 542253, name: "Hirapur" },
      { id: 542214, name: "Hiwara" },
      { id: 542316, name: "Hiwari" },
      { id: 542213, name: "Husnapur" },
      { id: 945001, name: "Ichora" },
      { id: 542322, name: "Jodmoha" },
      { id: 542243, name: "Jondhalni" },
      { id: 542352, name: "Kailaspur" },
      { id: 542234, name: "Kalamb Khand 1" },
      { id: 944876, name: "Kalambkhand 2" },
      { id: 542249, name: "Kalaspur" },
      { id: 542280, name: "Kamathwada" },
      { id: 542240, name: "Kanholi" },
      { id: 542241, name: "Karak" },
      { id: 542284, name: "Kasampur" },
      { id: 542296, name: "Katri" },
      { id: 542307, name: "Khadki" },
      { id: 542301, name: "Khairi" },
      { id: 542323, name: "Khateshwar" },
      { id: 542278, name: "Khatkheda" },
      { id: 542310, name: "Khorad Bk." },
      { id: 542325, name: "Khorad Kh" },
      { id: 542247, name: "Khudawantpur" },
      { id: 542274, name: "Khutala" },
      { id: 542349, name: "Kinhala" },
      { id: 542342, name: "Kinwat" },
      { id: 542288, name: "Kodori" },
      { id: 542354, name: "Kolazari" },
      { id: 542219, name: "Kotha" },
      { id: 542333, name: "Kusal" },
      { id: 542256, name: "Mahitapur" },
      { id: 542236, name: "Malkapur" },
      { id: 542258, name: "Mangrul (K.S)" },
      { id: 542222, name: "Mangrul (Sa.S)" },
      { id: 542285, name: "Manjarwaghal" },
      { id: 542254, name: "Mankapur" },
      { id: 542343, name: "Maregaon" },
      { id: 542350, name: "Markanda" },
      { id: 542266, name: "Mategaon" },
      { id: 542283, name: "Mawalni" },
      { id: 542230, name: "Mendhala" },
      { id: 542346, name: "Metikheda" },
      { id: 542238, name: "Mhasola" },
      { id: 542314, name: "Mohdari" },
      { id: 542269, name: "Mubarkpur" },
      { id: 542250, name: "Muradpur" },
      { id: 542334, name: "Musal" },
      { id: 542345, name: "Nagthana" },
      { id: 542340, name: "Nakti (Pardi)" },
      { id: 542311, name: "Nanza" },
      { id: 542227, name: "Narsapur" },
      { id: 542279, name: "Nilaj" },
      { id: 542286, name: "Nimbhora" },
      { id: 542309, name: "Nimgavhan" },
      { id: 542351, name: "Pahur I" },
      { id: 542344, name: "Paloti" },
      { id: 542353, name: "Pangadi" },
      { id: 542216, name: "Pardi" },
      { id: 542290, name: "Parsodi Bk." },
      { id: 542260, name: "Parsodi Kh." },
      { id: 542295, name: "Pathrad" },
      { id: 542312, name: "Pidha" },
      { id: 542348, name: "Pilkhana" },
      { id: 542276, name: "Pimpalgaon (Ho)" },
      { id: 542287, name: "Pimpalgaon (R)" },
      { id: 542264, name: "Pimpalkhuti (Jo)" },
      { id: 542306, name: "Pimpalkhuti (Sa)" },
      { id: 542336, name: "Pimpalshenda" },
      { id: 542302, name: "Pophalani" },
      { id: 542308, name: "Potgavhan" },
      { id: 542339, name: "Pradhanbori" },
      { id: 542300, name: "Rajur" },
      { id: 542242, name: "Rasa" },
      { id: 542218, name: "Rasulpur" },
      { id: 542332, name: "Rudha" },
      { id: 542263, name: "Sarapdhari" },
      { id: 542338, name: "Sarati" },
      { id: 542251, name: "Satephal" },
      { id: 542217, name: "Sawalapur" },
      { id: 542261, name: "Sawangi (Daf)" },
      { id: 542265, name: "Sawargaon" },
      { id: 542228, name: "Shankarpur" },
      { id: 542315, name: "Sharad" },
      { id: 542324, name: "Sheli" },
      { id: 542347, name: "Shivpuri" },
      { id: 542305, name: "Shiwani Kh." },
      { id: 542282, name: "Singnapur" },
      { id: 542270, name: "Sonegaon" },
      { id: 542330, name: "Sonkhas (Jo.S)" },
      { id: 542271, name: "Sonkhas (Sa.S)" },
      { id: 542215, name: "Sukali" },
      { id: 945002, name: "Talegaon" },
      { id: 542277, name: "Taroda" },
      { id: 542317, name: "Taslot" },
      { id: 542235, name: "Thalegaon Punarvasan" },
      { id: 542298, name: "Tirzada" },
      { id: 542221, name: "Tuljapur (K)" },
      { id: 542268, name: "Tuljapur (Sa)" },
      { id: 542320, name: "Umargaon (Wadi)" },
      { id: 542293, name: "Umari" },
      { id: 542237, name: "Wadgaon" },
      { id: 542313, name: "Wadhona Kh." },
      { id: 542257, name: "Wandli" },
      { id: 542327, name: "Watbori" },
      { id: 542220, name: "Yashwantpur" },
      { id: 542337, name: "Zadkinhi" },
    ],
    4082: [
      { id: 542454, name: "Akola Bajar" },
      { id: 542489, name: "Akpuri" },
      { id: 542359, name: "Anandnagar" },
      { id: 542355, name: "Asola" },
      { id: 542482, name: "Balajinagar" },
      { id: 542458, name: "Barad" },
      { id: 542455, name: "Baradtada" },
      { id: 542402, name: "Barbada" },
      { id: 542425, name: "Bechkheda" },
      { id: 542427, name: "Belora" },
      { id: 542424, name: "Bhamb(Raja)" },
      { id: 542380, name: "Bhari" },
      { id: 542364, name: "Bhisani" },
      { id: 542459, name: "Bhosa" },
      { id: 542377, name: "Bhosa(Tanda)" },
      { id: 542391, name: "Bhoyar" },
      { id: 542387, name: "Bodgavhan" },
      { id: 542373, name: "Borgaon" },
      { id: 542421, name: "Bori (Gosavi)" },
      { id: 542457, name: "Borisinh" },
      { id: 542397, name: "Borjai" },
      { id: 542398, name: "Bothbodan" },
      { id: 542419, name: "Chandapur" },
      { id: 542470, name: "Chapdoh" },
      { id: 542403, name: "Chaudhara" },
      { id: 542371, name: "Chinchbardi" },
      { id: 542468, name: "Chinchghat" },
      { id: 542492, name: "Daheli" },
      { id: 542432, name: "Dhamani" },
      { id: 542485, name: "Dhanora" },
      { id: 542386, name: "Dhanora(Vadgaon Po.Ste)" },
      { id: 542477, name: "Dharamgaon" },
      { id: 542406, name: "Dighori" },
      { id: 542378, name: "Dolamba" },
      { id: 542375, name: "Dorli" },
      { id: 542494, name: "Dudhana" },
      { id: 542392, name: "Echori" },
      { id: 542393, name: "Gahuli Hetti" },
      { id: 542490, name: "Ganeshpur" },
      { id: 542441, name: "Ghatana" },
      { id: 542467, name: "Ghoddara" },
      { id: 542435, name: "Ghodkhindi" },
      { id: 542388, name: "Godhani" },
      { id: 542399, name: "Harjuna" },
      { id: 542448, name: "Hatgaon" },
      { id: 542360, name: "Hatola" },
      { id: 542416, name: "Hiwari" },
      { id: 542401, name: "Jamb" },
      { id: 542361, name: "Jambhulani" },
      { id: 542465, name: "Jamdoh" },
      { id: 542395, name: "Jamwadi" },
      { id: 542442, name: "Jawala" },
      { id: 542418, name: "Kajani" },
      { id: 542461, name: "Kamathawada" },
      { id: 542363, name: "Kapra" },
      { id: 542487, name: "Karegaon(Murzhadi Lal)" },
      { id: 542383, name: "Karli" },
      { id: 542453, name: "Khairgaon" },
      { id: 542464, name: "Khangaon" },
      { id: 542411, name: "Kharad Bk.(Nakapardi)" },
      { id: 542417, name: "Kharola" },
      { id: 542437, name: "Kharola Kh." },
      { id: 542400, name: "Kinhi" },
      { id: 542366, name: "Kita" },
      { id: 542439, name: "Kolambi" },
      { id: 542446, name: "Krishnapur" },
      { id: 542368, name: "Lasina" },
      { id: 542503, name: "Lohara" },
      { id: 542440, name: "Loni (Rohana)" },
      { id: 542381, name: "Madkona" },
      { id: 542426, name: "Mangrul" },
      { id: 542460, name: "Manjarda" },
      { id: 542405, name: "Manpur" },
      { id: 542404, name: "Mhasola" },
      { id: 542372, name: "Moha" },
      { id: 542374, name: "Murzadi" },
      { id: 542469, name: "Murzadi (Chinch)" },
      { id: 542488, name: "Murzadi (Lal)" },
      { id: 945018, name: "Nakapardi" },
      { id: 542396, name: "Narkund" },
      { id: 542389, name: "Nilona" },
      { id: 542436, name: "Pandhari" },
      { id: 542356, name: "Pandhurna" },
      { id: 542376, name: "Pangari" },
      { id: 542379, name: "Parawa" },
      { id: 542462, name: "Paunmari" },
      { id: 542500, name: "Pimpalgaon" },
      { id: 542357, name: "Pimpri" },
      { id: 542369, name: "Pimpri (I)" },
      { id: 542449, name: "Pimpri Buti" },
      { id: 542496, name: "Ramgaon" },
      { id: 542430, name: "Ramnagar" },
      { id: 542422, name: "Ramnagar(Rui)" },
      { id: 542471, name: "Ramnagar(Yawali)" },
      { id: 542476, name: "Ramwakdi(Yelbara)" },
      { id: 542434, name: "Ratchandana" },
      { id: 542438, name: "Rauldari" },
      { id: 542495, name: "Rohatek" },
      { id: 542429, name: "Rui" },
      { id: 542480, name: "Saikheda Bandi" },
      { id: 542493, name: "Saikheda Bk." },
      { id: 542456, name: "Saikheda Kh." },
      { id: 542423, name: "Sakur" },
      { id: 542447, name: "Salod" },
      { id: 542431, name: "Sawargad" },
      { id: 542433, name: "Shiwani" },
      { id: 542491, name: "Sukali" },
      { id: 542365, name: "Takali" },
      { id: 542384, name: "Talegaon(Bhari)" },
      { id: 542367, name: "Tekadi" },
      { id: 542362, name: "Tembhurni" },
      { id: 542394, name: "Tiwasa" },
      { id: 542382, name: "Umari(Ujad)" },
      { id: 542504, name: "Umarsara" },
      { id: 542390, name: "Umartha" },
      { id: 542407, name: "Varud(Yewati)" },
      { id: 542420, name: "Vasantnagar(N.V)" },
      { id: 542478, name: "Vithalwadi" },
      { id: 542486, name: "Wadgaon (Po.Ste)" },
      { id: 542505, name: "Wadgaon Road" },
      { id: 542475, name: "Wadner" },
      { id: 542481, name: "Wagada" },
      { id: 542370, name: "Waghapur(Lasina)" },
      { id: 542502, name: "Waghapur(Lohara)" },
      { id: 542428, name: "Wai (Hatola)" },
      { id: 542358, name: "Wai (Rui)" },
      { id: 542499, name: "Waki (Dudhana)" },
      { id: 542385, name: "Waki (Parawa)" },
      { id: 542450, name: "Warud (Ijara)" },
      { id: 542452, name: "Warzadi" },
      { id: 542415, name: "Watkheda" },
      { id: 542501, name: "Yavatmal" },
      { id: 542472, name: "Yawali" },
      { id: 542483, name: "Yelabara" },
      { id: 542466, name: "Yerad" },
      { id: 542451, name: "Yevati" },
      { id: 542414, name: "Zola" },
      { id: 542463, name: "Zuli" },
    ],
    4083: [
      { id: 542637, name: "Amshet" },
      { id: 542600, name: "Antargaon" },
      { id: 542609, name: "Aurangpur" },
      { id: 542584, name: "Bagapur" },
      { id: 542578, name: "Bagwadi" },
      { id: 542620, name: "Banayat" },
      { id: 542512, name: "Barbadi" },
      { id: 542556, name: "Bhandegaon" },
      { id: 542607, name: "Bhileshwar" },
      { id: 542579, name: "Bhopapur" },
      { id: 542560, name: "Bhulai" },
      { id: 542564, name: "Bijora" },
      { id: 542515, name: "Bodegaon" },
      { id: 542636, name: "Bodgavhan" },
      { id: 542555, name: "Borgaon" },
      { id: 542572, name: "Bori Bk." },
      { id: 542612, name: "Bori Kh" },
      { id: 542565, name: "Both" },
      { id: 542537, name: "Bramhanath" },
      { id: 542615, name: "Bramhi" },
      { id: 542624, name: "Chani" },
      { id: 542625, name: "Chikani" },
      { id: 542550, name: "Chikhali" },
      { id: 542534, name: "Chopadi" },
      { id: 542559, name: "Chorkhopadi" },
      { id: 542545, name: "Chorodi" },
      { id: 542589, name: "Daheli" },
      { id: 944844, name: "Darvha Khand 1" },
      { id: 944845, name: "Darvha Khand 2" },
      { id: 542592, name: "Daryapur" },
      { id: 542651, name: "Deogiri" },
      { id: 542581, name: "Deulgaon" },
      { id: 542649, name: "Deurwadi" },
      { id: 542521, name: "Dhamangaon Bk." },
      { id: 542522, name: "Dhamangaon Kh." },
      { id: 542619, name: "Dhawalsar" },
      { id: 542562, name: "Dhulapur" },
      { id: 542543, name: "Dolhari" },
      { id: 542535, name: "Dolhari (Sindhi)" },
      { id: 542602, name: "Domb Khand 1" },
      { id: 944846, name: "Domb Khand 2" },
      { id: 542629, name: "Dudhgaon" },
      { id: 542541, name: "Fubgaon" },
      { id: 542648, name: "Gajipur" },
      { id: 542626, name: "Ganeshpur" },
      { id: 542547, name: "Ganeshpur Bk." },
      { id: 945115, name: "Ganeshpur Tanda" },
      { id: 542570, name: "Gaulpend" },
      { id: 542542, name: "Ghanapur" },
      { id: 542552, name: "Ghatkinhi" },
      { id: 542585, name: "Gondegaon" },
      { id: 542524, name: "Goregaon" },
      { id: 542553, name: "Hanuman Nagar" },
      { id: 542587, name: "Haru" },
      { id: 542608, name: "Hatgaon" },
      { id: 542568, name: "Hatni" },
      { id: 542508, name: "Hatola" },
      { id: 542580, name: "Husanapur" },
      { id: 542538, name: "Imampur" },
      { id: 542554, name: "Irthal" },
      { id: 542539, name: "Ishrampur" },
      { id: 542618, name: "Jambhora" },
      { id: 542536, name: "Jawala" },
      { id: 542622, name: "Kamthwada" },
      { id: 542613, name: "Kanzara Bk" },
      { id: 542611, name: "Kanzara Kh" },
      { id: 542519, name: "Karjagaon" },
      { id: 542644, name: "Karmala" },
      { id: 542597, name: "Khed" },
      { id: 542533, name: "Khopdi Bk." },
      { id: 542606, name: "Khopdi Kh" },
      { id: 542575, name: "Kinhiwalgi" },
      { id: 542520, name: "Kohala" },
      { id: 542551, name: "Kolwai" },
      { id: 542567, name: "Kumbharkinhi" },
      { id: 542557, name: "Kund" },
      { id: 542530, name: "Kurhad Bk." },
      { id: 542523, name: "Kurhad Kh." },
      { id: 542617, name: "Ladkhed" },
      { id: 542598, name: "Lakhkhind" },
      { id: 542540, name: "Lalapur" },
      { id: 542591, name: "Lingbori" },
      { id: 542509, name: "Lohi" },
      { id: 944847, name: "Mahagaon Kasaba Khand 2" },
      { id: 542650, name: "Mahagaon Kasba Khand 1" },
      { id: 542605, name: "Mahatoli" },
      { id: 542616, name: "Mahmadpur" },
      { id: 542561, name: "Mahuli" },
      { id: 542532, name: "Malegaon" },
      { id: 542604, name: "Mangala (I)" },
      { id: 542566, name: "Mangkinhi" },
      { id: 542549, name: "Manki" },
      { id: 542514, name: "Mankopra" },
      { id: 542634, name: "Morgavhan" },
      { id: 542640, name: "Mozar" },
      { id: 542571, name: "Mundhal" },
      { id: 542603, name: "Naigaon" },
      { id: 542511, name: "Nakhegaon" },
      { id: 542621, name: "Nandgavhan" },
      { id: 542529, name: "Nandgavhan Lad" },
      { id: 542531, name: "Nilona" },
      { id: 542643, name: "Nimbala" },
      { id: 542590, name: "Nimbha (I)" },
      { id: 542599, name: "Palashi" },
      { id: 542546, name: "Palodi" },
      { id: 542633, name: "Pandhurna" },
      { id: 542638, name: "Pathraddevi" },
      { id: 542569, name: "Pekarda" },
      { id: 542518, name: "Pimpalgaon" },
      { id: 542614, name: "Pimpalgaon Budruk" },
      { id: 542526, name: "Pimpalkhuta" },
      { id: 542647, name: "Pimpari Bk" },
      { id: 542588, name: "Pimpri Kh." },
      { id: 542528, name: "Rajivnagar" },
      { id: 542563, name: "Rajura" },
      { id: 542595, name: "Ramgaon (Ra.)" },
      { id: 542516, name: "Ramgaon Haru" },
      { id: 542610, name: "Saidani" },
      { id: 542577, name: "Saikhed" },
      { id: 542576, name: "Sajegaon" },
      { id: 542513, name: "Sangalwadi" },
      { id: 542507, name: "Sangvi Railway" },
      { id: 542639, name: "Sawala" },
      { id: 542628, name: "Sawali" },
      { id: 542642, name: "Sawangi" },
      { id: 542594, name: "Sewadasnagar" },
      { id: 542574, name: "Shelodi" },
      { id: 542544, name: "Shendri Bk." },
      { id: 542601, name: "Shindi" },
      { id: 542586, name: "Takali Bk." },
      { id: 542548, name: "Talegaon" },
      { id: 542627, name: "Tapona" },
      { id: 542510, name: "Tarnoli" },
      { id: 542583, name: "Taroda" },
      { id: 542582, name: "Teldhari" },
      { id: 542558, name: "Telgavhan" },
      { id: 542525, name: "Tornala" },
      { id: 542593, name: "Uchegaon" },
      { id: 542632, name: "Ujona" },
      { id: 542596, name: "Umari I." },
      { id: 542645, name: "Wadgaon Andha" },
      { id: 542641, name: "Wadgaon Gadhve" },
      { id: 542635, name: "Wadul" },
      { id: 542527, name: "Wagad Bk." },
      { id: 542646, name: "Wagad Kh." },
      { id: 542573, name: "Waghal" },
      { id: 542630, name: "Waghol" },
      { id: 542631, name: "Waki" },
      { id: 542623, name: "Warjai" },
      { id: 542517, name: "Warud" },
    ],
    4084: [
      { id: 542660, name: "Amala Budruk" },
      { id: 542668, name: "Amala Kh." },
      { id: 542669, name: "Arambhi" },
      { id: 542721, name: "Ashta" },
      { id: 542703, name: "Belora" },
      { id: 542675, name: "Bori" },
      { id: 542680, name: "Chicholi Kh." },
      { id: 542714, name: "Chinchapatra" },
      { id: 542679, name: "Chincholi Budruk" },
      { id: 542699, name: "Chirkuta" },
      { id: 542671, name: "Dabha" },
      { id: 542727, name: "Dehani" },
      { id: 944879, name: "Deurwada" },
      { id: 542697, name: "Deurwada (Punarwasan)" },
      { id: 542704, name: "Deurwadi U." },
      { id: 542729, name: "Dhanora (Tada)" },
      { id: 542682, name: "Dhanora Bk." },
      { id: 542672, name: "Dhanora Kh." },
      { id: 944877, name: "Digras" },
      { id: 542725, name: "Dolaba" },
      { id: 542726, name: "Dolambawadi" },
      { id: 542723, name: "Dolhari" },
      { id: 542653, name: "Donad" },
      { id: 542663, name: "Dorli (U)" },
      { id: 542716, name: "Fetri" },
      { id: 542700, name: "Fulwadi" },
      { id: 542664, name: "Gandhinagar" },
      { id: 542652, name: "Harsul Khand 1" },
      { id: 944878, name: "Harsul Khand 2" },
      { id: 542685, name: "Isapur" },
      { id: 542706, name: "Jawala U." },
      { id: 542701, name: "Jogaldari" },
      { id: 542713, name: "Kalgaon" },
      { id: 542678, name: "Kalsa" },
      { id: 542728, name: "Kandali" },
      { id: 542684, name: "Kati" },
      { id: 542673, name: "Khandapur" },
      { id: 542655, name: "Khekadi" },
      { id: 542692, name: "Kolura" },
      { id: 542708, name: "Lakh (Rayachi)" },
      { id: 542666, name: "Laygavhan" },
      { id: 542656, name: "Ligi (Wai)" },
      { id: 542709, name: "Loni" },
      { id: 542712, name: "Mahagaon" },
      { id: 542731, name: "Malhiwara" },
      { id: 542674, name: "Mallapur" },
      { id: 542676, name: "Mandwa" },
      { id: 542691, name: "Marsul" },
      { id: 542710, name: "Mendhi" },
      { id: 542667, name: "Mokh" },
      { id: 945853, name: "Mokh No1" },
      { id: 542665, name: "Morkhed" },
      { id: 542688, name: "Nandgavhan" },
      { id: 542705, name: "Nimbha" },
      { id: 542686, name: "Pelu" },
      { id: 542724, name: "Pimpri" },
      { id: 542687, name: "Rahati" },
      { id: 542662, name: "Ramgaon" },
      { id: 542683, name: "Ramnagar" },
      { id: 542677, name: "Rohanadevi" },
      { id: 542693, name: "Rui Mo." },
      { id: 542690, name: "Rui Talav" },
      { id: 542654, name: "Sakara" },
      { id: 542717, name: "Sakari" },
      { id: 542698, name: "Sawanga Bk." },
      { id: 542702, name: "Sawanga Kh." },
      { id: 542730, name: "Sevadas Nagar" },
      { id: 542689, name: "Sevanagar" },
      { id: 542658, name: "Shiwani" },
      { id: 542695, name: "Singad" },
      { id: 542661, name: "Tiwari" },
      { id: 542707, name: "Tuptakali" },
      { id: 542681, name: "Ukali" },
      { id: 542659, name: "Vadgaon" },
      { id: 542719, name: "Vasantnagar" },
      { id: 542694, name: "Vasantpur Kharda" },
      { id: 542718, name: "Vithala" },
      { id: 542715, name: "Vitholi" },
      { id: 542722, name: "Wadgaon" },
      { id: 542711, name: "Wai" },
      { id: 542657, name: "Wai Mendhi" },
      { id: 542720, name: "Warandali" },
      { id: 542670, name: "Zirpurwadi" },
    ],
    4085: [
      { id: 542864, name: "Adgaon" },
      { id: 542871, name: "Amati" },
      { id: 542909, name: "Amdari" },
      { id: 542861, name: "Amrutnagar" },
      { id: 542895, name: "Ansing" },
      { id: 542789, name: "Aregaon Bk." },
      { id: 542790, name: "Aregaon Kh." },
      { id: 542781, name: "Asarpend" },
      { id: 542785, name: "Ashwinpur" },
      { id: 542835, name: "Asoli" },
      { id: 542755, name: "Bajrangnagar" },
      { id: 542915, name: "Balawadi" },
      { id: 542754, name: "Bansi" },
      { id: 542775, name: "Belgavhan" },
      { id: 542856, name: "Belura Bk." },
      { id: 542855, name: "Belura Kh." },
      { id: 542743, name: "Bhandari" },
      { id: 542796, name: "Bhatamba" },
      { id: 542765, name: "Bhojala" },
      { id: 542913, name: "Bibi" },
      { id: 542801, name: "Borgadi" },
      { id: 542807, name: "Bori Kh." },
      { id: 542808, name: "Bori Ma." },
      { id: 542818, name: "Bornagar" },
      { id: 542747, name: "Brahmangaon" },
      { id: 542893, name: "Buti Ijara" },
      { id: 542739, name: "Chichghat" },
      { id: 542813, name: "Chikani" },
      { id: 542840, name: "Chikhali" },
      { id: 542800, name: "Chilwadi" },
      { id: 542917, name: "Chirangwadi" },
      { id: 542740, name: "Chondhi" },
      { id: 542907, name: "Dagad Dhanora" },
      { id: 542826, name: "Dahiwad Bk." },
      { id: 542774, name: "Deogavhan" },
      { id: 542884, name: "Deothana" },
      { id: 542802, name: "Dhankeshwarnagar" },
      { id: 542847, name: "Dhanora Ijara" },
      { id: 542805, name: "Dhansal" },
      { id: 542829, name: "Dhansing Nagar" },
      { id: 542912, name: "Dharamwadi" },
      { id: 542883, name: "Dudhagiri" },
      { id: 542873, name: "Fetra" },
      { id: 542891, name: "Fulwadi" },
      { id: 542886, name: "Gadi (U.)" },
      { id: 542738, name: "Gahuli" },
      { id: 542792, name: "Gaimukh Nagar" },
      { id: 542763, name: "Gajipur" },
      { id: 542769, name: "Ganeshpur" },
      { id: 542905, name: "Gaul Bk." },
      { id: 542914, name: "Gaul Kh." },
      { id: 542896, name: "Gaul Manjari" },
      { id: 542779, name: "Ghatodi" },
      { id: 542894, name: "Gopwadi" },
      { id: 542870, name: "Hanuman Nagar" },
      { id: 542851, name: "Hanwat Kheda" },
      { id: 542834, name: "Harshi" },
      { id: 542799, name: "Hegadi" },
      { id: 542860, name: "Hiwalani Kh." },
      { id: 542908, name: "Hiwalani Palampat" },
      { id: 542865, name: "Hiwalni T" },
      { id: 542876, name: "Horkad" },
      { id: 542745, name: "Housapur" },
      { id: 542798, name: "Hudi Bk." },
      { id: 542812, name: "Hudi Kh." },
      { id: 542910, name: "Inapur" },
      { id: 542795, name: "Indira Nagar" },
      { id: 542901, name: "Isapur" },
      { id: 542791, name: "Itawa" },
      { id: 542906, name: "Jagapur" },
      { id: 542776, name: "Jamani Dhundi" },
      { id: 542762, name: "Jamb Bajar" },
      { id: 542887, name: "Jamnaik (1)" },
      { id: 542888, name: "Jamnaik (2)" },
      { id: 542760, name: "Jamshetpur" },
      { id: 542849, name: "Januna" },
      { id: 542777, name: "Jawahar Nagar" },
      { id: 542863, name: "Jawali" },
      { id: 542885, name: "Jawla" },
      { id: 542780, name: "Jyoti Nagar" },
      { id: 542878, name: "Kadoli" },
      { id: 542803, name: "Kakaddati" },
      { id: 542854, name: "Kanherwadi" },
      { id: 542737, name: "Karhol" },
      { id: 542819, name: "Karla" },
      { id: 945016, name: "Karladev" },
      { id: 542794, name: "Katkheda Bk." },
      { id: 542797, name: "Katkheda Kh." },
      { id: 542773, name: "Kawadipur" },
      { id: 542832, name: "Khadakdari" },
      { id: 542874, name: "Khairkheda" },
      { id: 542862, name: "Khandala" },
      { id: 542833, name: "Kharshi" },
      { id: 542843, name: "Khatkala" },
      { id: 542904, name: "Kolha (Pa)" },
      { id: 542815, name: "Kondhai" },
      { id: 542810, name: "Kopra Bk." },
      { id: 542758, name: "Kopra Kh." },
      { id: 542816, name: "Krushna Nagar" },
      { id: 542869, name: "Kumbhari" },
      { id: 542761, name: "Kurhadi" },
      { id: 542732, name: "Lakhi" },
      { id: 542736, name: "Lobhivantnagar" },
      { id: 542889, name: "Lohara Ijara" },
      { id: 542890, name: "Lohara Kh." },
      { id: 542831, name: "Londari" },
      { id: 542788, name: "Loni" },
      { id: 542787, name: "Madhukarnagar" },
      { id: 542911, name: "Malasoli" },
      { id: 542823, name: "Mandwa" },
      { id: 542822, name: "Manikdoh" },
      { id: 542845, name: "Manjarjawala Budruk" },
      { id: 542852, name: "Manjarjawala Kh." },
      { id: 542804, name: "Mansal" },
      { id: 542749, name: "Marsul" },
      { id: 542859, name: "Marwadi Bk." },
      { id: 542846, name: "Marwadi Kh." },
      { id: 542836, name: "Mhaismal" },
      { id: 542784, name: "Moha Ijara" },
      { id: 542741, name: "Mokhad" },
      { id: 542877, name: "Mop" },
      { id: 542753, name: "Mungshi" },
      { id: 542750, name: "Naik Nagar" },
      { id: 542879, name: "Nanand Ijara" },
      { id: 542880, name: "Nanand Kh." },
      { id: 542778, name: "Nandipur" },
      { id: 542850, name: "Nandura Ijara" },
      { id: 542772, name: "Nimbi" },
      { id: 542793, name: "Palodi" },
      { id: 542825, name: "Paluwadi" },
      { id: 542868, name: "Pandhurna Bk." },
      { id: 542842, name: "Pandhurna Kh." },
      { id: 542844, name: "Panhala" },
      { id: 542735, name: "Paradh" },
      { id: 542768, name: "Pardi" },
      { id: 542838, name: "Parwa Budruk" },
      { id: 542839, name: "Parwa Kh." },
      { id: 542759, name: "Pimpalgaon" },
      { id: 542734, name: "Pimpalgaon (Mungshi)" },
      { id: 542872, name: "Pimpalgaon Ijara" },
      { id: 542756, name: "Pimpalkhuta" },
      { id: 542828, name: "Pimparwadi" },
      { id: 542811, name: "Pokhari" },
      { id: 944880, name: "Pusad Khand 1" },
      { id: 944882, name: "Pusad Khand 2" },
      { id: 542733, name: "Rajana" },
      { id: 542752, name: "Rambha" },
      { id: 542858, name: "Ramnagar" },
      { id: 542783, name: "Ramnagar Bk." },
      { id: 542837, name: "Rampur" },
      { id: 542882, name: "Rampur Nagar" },
      { id: 542867, name: "Rohada" },
      { id: 542830, name: "Sandwa" },
      { id: 542857, name: "Satarmal" },
      { id: 542899, name: "Satefal" },
      { id: 542766, name: "Sawangi" },
      { id: 542881, name: "Sawargaon (Gore)" },
      { id: 542892, name: "Sawargaon B." },
      { id: 542771, name: "Sevadas Nagar" },
      { id: 542903, name: "Shambal Pimpri" },
      { id: 542744, name: "Shampur" },
      { id: 542809, name: "Shelu Bk." },
      { id: 542764, name: "Shelu Kh." },
      { id: 542918, name: "Shilona" },
      { id: 542782, name: "Shivaji Nagar" },
      { id: 542916, name: "Shivanagar" },
      { id: 542875, name: "Shiwani" },
      { id: 542919, name: "Shrirampur" },
      { id: 542848, name: "Singarwadi" },
      { id: 542897, name: "Sukali U" },
      { id: 542746, name: "Udadi" },
      { id: 542821, name: "Upavanwadi" },
      { id: 542900, name: "Uti" },
      { id: 542817, name: "Vasantpur" },
      { id: 542866, name: "Vasantwadi" },
      { id: 542841, name: "Wadgaon" },
      { id: 542806, name: "Wadsad" },
      { id: 542853, name: "Waghjali" },
      { id: 542767, name: "Waltur Railway" },
      { id: 542748, name: "Waltur Tambe" },
      { id: 542742, name: "Wamanwadi" },
      { id: 542751, name: "Wanwarla" },
      { id: 542786, name: "Warud" },
      { id: 542824, name: "Warwat" },
      { id: 542827, name: "Weni Kh." },
      { id: 542814, name: "Yehala" },
      { id: 542770, name: "Yeldari" },
      { id: 542757, name: "Yeranda" },
    ],
    4086: [
      { id: 542920, name: "Adad" },
      { id: 543041, name: "Akoli" },
      { id: 542957, name: "Amala" },
      { id: 542975, name: "Amanpur" },
      { id: 542944, name: "Ambali" },
      { id: 543015, name: "Ambavan" },
      { id: 542969, name: "Amdapur" },
      { id: 542946, name: "Amdari" },
      { id: 542967, name: "Amgavhan" },
      { id: 542978, name: "Baldi" },
      { id: 542951, name: "Bara" },
      { id: 542952, name: "Belkhed" },
      { id: 542936, name: "Bhambarkheda" },
      { id: 543022, name: "Bhawani" },
      { id: 543061, name: "Bhojnagar" },
      { id: 542960, name: "Bitargaon" },
      { id: 543058, name: "Bitargaon Bk." },
      { id: 543017, name: "Borgaon" },
      { id: 543070, name: "Bori (Cha)" },
      { id: 543011, name: "Bori (Van)" },
      { id: 542945, name: "Botha" },
      { id: 543007, name: "Brahmangaon" },
      { id: 542981, name: "Chalgani" },
      { id: 943774, name: "Chatari Khand 1" },
      { id: 943775, name: "Chatari Khand 2" },
      { id: 543039, name: "Chikhali" },
      { id: 542974, name: "Chilli" },
      { id: 542999, name: "Chincholi Dhanki" },
      { id: 542962, name: "Chincholi Sangam" },
      { id: 542971, name: "Churmura" },
      { id: 542954, name: "Dahagaon" },
      { id: 543038, name: "Darati" },
      { id: 542987, name: "Deosari" },
      { id: 542921, name: "Dhanaj" },
      { id: 944202, name: "Dhanaki Khand 1" },
      { id: 944204, name: "Dhanaki Khand 2" },
      { id: 543003, name: "Dhanora Sa." },
      { id: 542990, name: "Dharchatari" },
      { id: 542988, name: "Dighadi" },
      { id: 542976, name: "Dindala" },
      { id: 543016, name: "Dongargaon" },
      { id: 542925, name: "Dorli" },
      { id: 543056, name: "Ekamba" },
      { id: 543054, name: "Gadi" },
      { id: 542930, name: "Gaganmal" },
      { id: 543005, name: "Ganjegaon" },
      { id: 543024, name: "Ghadoli" },
      { id: 543018, name: "Ghamapur" },
      { id: 542994, name: "Govindpur" },
      { id: 542980, name: "Gurphali" },
      { id: 543002, name: "Hardada" },
      { id: 542940, name: "Hatala" },
      { id: 543012, name: "Isapur" },
      { id: 543020, name: "Jamb" },
      { id: 542931, name: "Januna" },
      { id: 543048, name: "Javarala" },
      { id: 543057, name: "Jewali" },
      { id: 542953, name: "Kailasnagar" },
      { id: 542933, name: "Kalambula" },
      { id: 542961, name: "Kaleshwar" },
      { id: 543059, name: "Karanji" },
      { id: 542986, name: "Karkhed" },
      { id: 542959, name: "Karodi" },
      { id: 542924, name: "Keli" },
      { id: 543036, name: "Kharbi" },
      { id: 542984, name: "Kharus Bk." },
      { id: 543001, name: "Kharus Kh." },
      { id: 542998, name: "Khopra Kh." },
      { id: 543009, name: "Kopra Bk." },
      { id: 543028, name: "Korta" },
      { id: 542996, name: "Krishanpur" },
      { id: 542949, name: "Kupti" },
      { id: 543019, name: "Kurali" },
      { id: 542964, name: "Limgavhan" },
      { id: 543075, name: "Lingi" },
      { id: 542985, name: "Lohara" },
      { id: 543008, name: "Mankeshwar" },
      { id: 543042, name: "Manyali" },
      { id: 542963, name: "Marlegaon" },
      { id: 542947, name: "Marsul" },
      { id: 543066, name: "Mathuranagar" },
      { id: 542997, name: "Met" },
      { id: 542922, name: "Mohdari" },
      { id: 543045, name: "Morchandi" },
      { id: 542934, name: "Mulawa" },
      { id: 543076, name: "Murli" },
      { id: 542941, name: "Nagapur" },
      { id: 542968, name: "Nagapur (U)" },
      { id: 542955, name: "Nageshwadi" },
      { id: 542939, name: "Nandala" },
      { id: 543014, name: "Narali" },
      { id: 944206, name: "Ningnur Khand 1" },
      { id: 944207, name: "Ningnur Khand 2" },
      { id: 542923, name: "Pahunmari" },
      { id: 542950, name: "Palshi" },
      { id: 542928, name: "Pardi (Bangala)" },
      { id: 542977, name: "Pardi (Chu)" },
      { id: 542983, name: "Parjana" },
      { id: 543044, name: "Paroti (Van)" },
      { id: 543065, name: "Pendha" },
      { id: 542926, name: "Pimpaldri" },
      { id: 543064, name: "Pimpalgaon" },
      { id: 542942, name: "Pimpri Diwat" },
      { id: 542995, name: "Piranji" },
      { id: 542943, name: "Pophali" },
      { id: 542956, name: "Rajapur" },
      { id: 543021, name: "Rampur" },
      { id: 542958, name: "Rangoli" },
      { id: 543062, name: "Ratan Naik Nagar" },
      { id: 542982, name: "Sakhara" },
      { id: 543060, name: "Sawaleshwar" },
      { id: 543073, name: "Sawargaon" },
      { id: 543035, name: "Sewalal Nagar" },
      { id: 543037, name: "Shivaji Nagar" },
      { id: 542948, name: "Shri Dattanagar" },
      { id: 543006, name: "Sindgi" },
      { id: 543023, name: "Soit" },
      { id: 543004, name: "Soit (M)" },
      { id: 543055, name: "Sondabhi" },
      { id: 542973, name: "Sukali (Jahagir )" },
      { id: 542935, name: "Sukali (Navin)" },
      { id: 542966, name: "Takali" },
      { id: 543013, name: "Takali (Ra)" },
      { id: 543034, name: "Takali Bandi" },
      { id: 542929, name: "Taroda" },
      { id: 542993, name: "Tembhurdara" },
      { id: 543069, name: "Therdi" },
      { id: 543049, name: "Tivadi" },
      { id: 542938, name: "Tiwarang" },
      { id: 543074, name: "Udapur" },
      { id: 944193, name: "Umarkhed Khand 1" },
      { id: 944197, name: "Umarkhed Khand 2" },
      { id: 542989, name: "Unchawadad" },
      { id: 542932, name: "Vasantnagar" },
      { id: 943776, name: "Vidul Khand 1" },
      { id: 944199, name: "Vidul Khand 2" },
      { id: 543025, name: "Waltur" },
      { id: 542927, name: "Wanegaon" },
      { id: 542972, name: "Warud Bibi" },
      { id: 542937, name: "Zadgaon" },
      { id: 542970, name: "Zadgaon (U.)" },
    ],
    4087: [
      { id: 543172, name: "Amani Bk." },
      { id: 543171, name: "Amani Kh." },
      { id: 543164, name: "Amboda" },
      { id: 543139, name: "Anatwadi" },
      { id: 543109, name: "Babasaheb Nagar" },
      { id: 543161, name: "Beldari" },
      { id: 543173, name: "Bhamb" },
      { id: 543129, name: "Bhosa" },
      { id: 543184, name: "Bijora" },
      { id: 543110, name: "Bondhara" },
      { id: 543095, name: "Bori Ijara" },
      { id: 543150, name: "Botha" },
      { id: 543096, name: "Brahmi" },
      { id: 543188, name: "Chicholi" },
      { id: 543135, name: "Chilgavhan" },
      { id: 543187, name: "Chilli I" },
      { id: 543080, name: "Chinchpad" },
      { id: 543186, name: "Dagadthar" },
      { id: 543130, name: "Dahisawali" },
      { id: 543106, name: "Dahiwad Kh." },
      { id: 543131, name: "Dhanoda" },
      { id: 543157, name: "Dharegaon" },
      { id: 543145, name: "Dharkanha" },
      { id: 543156, name: "Dharmoha" },
      { id: 543149, name: "Dongargaon" },
      { id: 543189, name: "Fulsawangi" },
      { id: 543111, name: "Fulsing Nagar" },
      { id: 543133, name: "Gaul Kh." },
      { id: 543185, name: "Ghanmukh" },
      { id: 543090, name: "Ghonsara I." },
      { id: 543115, name: "Gunj" },
      { id: 543155, name: "Hingani" },
      { id: 543082, name: "Hiwalani" },
      { id: 543123, name: "Hiwara" },
      { id: 543118, name: "Hiwardari.A" },
      { id: 543144, name: "Hiwardari.Ma" },
      { id: 543103, name: "Hiwari" },
      { id: 543124, name: "Ijani" },
      { id: 543168, name: "Januna" },
      { id: 543169, name: "Kalgaon" },
      { id: 543104, name: "Kali Dou.1" },
      { id: 945005, name: "Kali Dou.Khand 2" },
      { id: 543176, name: "Kali Te." },
      { id: 543094, name: "Kalulal Nagar" },
      { id: 543113, name: "Kanha" },
      { id: 543165, name: "Karajkhed" },
      { id: 543120, name: "Karanji" },
      { id: 543167, name: "Kasarbehel" },
      { id: 543100, name: "Kasola" },
      { id: 543098, name: "Katarwadi" },
      { id: 543102, name: "Kaudgaon" },
      { id: 543163, name: "Kaurwadi E." },
      { id: 543143, name: "Kavurwadi" },
      { id: 945004, name: "Kawatha" },
      { id: 543134, name: "Khadaka" },
      { id: 543097, name: "Khamalwadi" },
      { id: 543084, name: "Kondari (I)" },
      { id: 543160, name: "Kothari" },
      { id: 543122, name: "Leva" },
      { id: 543152, name: "Lohara Kh." },
      { id: 543170, name: "Mahagaon" },
      { id: 543117, name: "Malegaon" },
      { id: 543127, name: "Malkapur" },
      { id: 543116, name: "Malkinhi" },
      { id: 543083, name: "Malvakad" },
      { id: 543093, name: "Manohar Nagar" },
      { id: 543105, name: "Mohadi" },
      { id: 543151, name: "Morath" },
      { id: 543099, name: "Morwadi" },
      { id: 543181, name: "Mudana" },
      { id: 543162, name: "Nadgavhan" },
      { id: 543107, name: "Nagarwadi" },
      { id: 543088, name: "Naiknagar" },
      { id: 543182, name: "Nehrunagar" },
      { id: 543108, name: "Pedhi E." },
      { id: 543177, name: "Pimpalgaon E." },
      { id: 543112, name: "Pimpalgaon Sut" },
      { id: 543179, name: "Pipari E." },
      { id: 543125, name: "Pohandul" },
      { id: 543086, name: "Pokhari (I)" },
      { id: 543190, name: "Rahur" },
      { id: 543183, name: "Rajura" },
      { id: 543132, name: "Rautwadi" },
      { id: 543180, name: "Sadhunagar" },
      { id: 543079, name: "Sai (Ijara)" },
      { id: 543140, name: "Sangam" },
      { id: 543114, name: "Sarkinhi" },
      { id: 543147, name: "Sawana" },
      { id: 543159, name: "Senad" },
      { id: 543078, name: "Sevadas Nagar" },
      { id: 543166, name: "Sevanagar" },
      { id: 543191, name: "Shirfuli" },
      { id: 543192, name: "Shirmal" },
      { id: 543119, name: "Shirpur" },
      { id: 543087, name: "Sudhakar Nagar" },
      { id: 543101, name: "Tarodi" },
      { id: 543175, name: "Tembhi" },
      { id: 543158, name: "Tembhurdara" },
      { id: 543141, name: "Thar Bk." },
      { id: 543142, name: "Thar Kh." },
      { id: 543126, name: "Tiwarang" },
      { id: 543091, name: "Tulshinagar" },
      { id: 543154, name: "Uti" },
      { id: 543121, name: "Vasantnagar" },
      { id: 543077, name: "Wadad Bra" },
      { id: 543178, name: "Wadad Mu" },
      { id: 543136, name: "Waghnath" },
      { id: 543092, name: "Wakad I" },
      { id: 543085, name: "Wakan" },
      { id: 543148, name: "Wakodi" },
      { id: 543081, name: "Wanoli (I)" },
      { id: 543174, name: "Warodi" },
      { id: 543153, name: "Waruna" },
      { id: 543146, name: "Weni Bk." },
    ],
    4088: [
      { id: 543196, name: "Akola" },
      { id: 543237, name: "Amani" },
      { id: 543300, name: "Amboda" },
      { id: 543291, name: "Anjankhed" },
      { id: 543245, name: "Anji Na." },
      { id: 543238, name: "Antargaon" },
      { id: 543235, name: "Arni Khand 1" },
      { id: 945041, name: "Arni Khand 2" },
      { id: 543239, name: "Asara" },
      { id: 543278, name: "Ayata" },
      { id: 543271, name: "Barbhai" },
      { id: 543252, name: "Belora" },
      { id: 543230, name: "Bhandari" },
      { id: 543248, name: "Bhandari (J)" },
      { id: 543285, name: "Bhansara" },
      { id: 543198, name: "Bid" },
      { id: 543219, name: "Borgaon" },
      { id: 543242, name: "Borgaon (Pu)" },
      { id: 543203, name: "Bramhanwada" },
      { id: 543206, name: "Chandani" },
      { id: 543253, name: "Chatari" },
      { id: 543224, name: "Chikani" },
      { id: 543229, name: "Chikhali (Ijara)" },
      { id: 543277, name: "Chimata" },
      { id: 543266, name: "Chinchbardi" },
      { id: 543247, name: "Chincholi" },
      { id: 543220, name: "Dabhadi" },
      { id: 543263, name: "Daheli" },
      { id: 543272, name: "Datodi" },
      { id: 543214, name: "Dattrampur" },
      { id: 543199, name: "Deogaon" },
      { id: 543234, name: "Deurwadi (Bk)" },
      { id: 543232, name: "Deurwadi (Pu)" },
      { id: 543301, name: "Donwada" },
      { id: 543193, name: "Gangaon" },
      { id: 543204, name: "Gawana" },
      { id: 543295, name: "Ghonsara" },
      { id: 543273, name: "Guda" },
      { id: 543264, name: "Ichora" },
      { id: 543296, name: "Iwaleshwar" },
      { id: 543268, name: "Jalandri" },
      { id: 543212, name: "Jamb" },
      { id: 543201, name: "Jawala" },
      { id: 543205, name: "Kakaddara" },
      { id: 543302, name: "Kaotha Bazar" },
      { id: 543276, name: "Kapeshwar" },
      { id: 543246, name: "Karegaon" },
      { id: 543231, name: "Kathoda" },
      { id: 543280, name: "Kawtha Bk." },
      { id: 543286, name: "Kelzara" },
      { id: 945045, name: "Kelzara Khand 1" },
      { id: 543261, name: "Kelzara Khand 2" },
      { id: 543279, name: "Khadaka" },
      { id: 543200, name: "Khandala" },
      { id: 543197, name: "Khed" },
      { id: 543216, name: "Kinhi" },
      { id: 543233, name: "Kolwan" },
      { id: 543228, name: "Kopara" },
      { id: 543297, name: "Kosadani" },
      { id: 543256, name: "Krushnanagar" },
      { id: 543244, name: "Kurha" },
      { id: 543284, name: "Kurha (Du)" },
      { id: 543227, name: "Lingi" },
      { id: 543294, name: "Lonbehal" },
      { id: 543195, name: "Loni" },
      { id: 543225, name: "Mahalungi" },
      { id: 543265, name: "Malegaon" },
      { id: 543289, name: "Mangrul" },
      { id: 543236, name: "Manpur" },
      { id: 543208, name: "Mhasola" },
      { id: 543299, name: "Mukindpur" },
      { id: 543287, name: "Naiknagar" },
      { id: 543215, name: "Navnagar" },
      { id: 543209, name: "Pahur (N.)" },
      { id: 543260, name: "Palashi" },
      { id: 543269, name: "Palodi" },
      { id: 543282, name: "Pandhurna" },
      { id: 543218, name: "Pangari" },
      { id: 543223, name: "Parsoda" },
      { id: 543281, name: "Pimpalner" },
      { id: 543241, name: "Pimpri" },
      { id: 543303, name: "Ranidhonora" },
      { id: 543222, name: "Rudrapur" },
      { id: 543226, name: "Saikheda" },
      { id: 543258, name: "Sakhara (Ujad)" },
      { id: 945042, name: "Sakharatanda" },
      { id: 543298, name: "Sakur" },
      { id: 543213, name: "Satara" },
      { id: 543267, name: "Sawali" },
      { id: 543290, name: "Shari" },
      { id: 543207, name: "Shekalgaon" },
      { id: 543292, name: "Shelu (Bra)" },
      { id: 543202, name: "Shelu (Se)" },
      { id: 543293, name: "Shendursani" },
      { id: 543211, name: "Shirpur" },
      { id: 543249, name: "Shivur" },
      { id: 543262, name: "Subhashnagar" },
      { id: 543259, name: "Sudhakarnagar" },
      { id: 543283, name: "Sukali" },
      { id: 543243, name: "Talni" },
      { id: 543194, name: "Taroda" },
      { id: 543221, name: "Tendoli" },
      { id: 543217, name: "Umari" },
      { id: 543210, name: "Umari Pathar Khand 1" },
      { id: 945043, name: "Umari Pathar Khand 2" },
      { id: 543270, name: "Umri (I.)" },
      { id: 543240, name: "Vitholi" },
      { id: 543254, name: "Warud" },
      { id: 543274, name: "Warud (Tuka)" },
      { id: 543288, name: "Yarmal" },
      { id: 543275, name: "Zaparwadi" },
    ],
    4089: [
      { id: 543354, name: "Ambezari" },
      { id: 543349, name: "Amdi" },
      { id: 543342, name: "Anji N" },
      { id: 543340, name: "Belora" },
      { id: 543315, name: "Bhambora" },
      { id: 543421, name: "Bhim Kund (N)" },
      { id: 945179, name: "Bilayata" },
      { id: 543323, name: "Bodadi" },
      { id: 543306, name: "Chandapur" },
      { id: 543400, name: "Chikhalwardha" },
      { id: 543379, name: "Chincholi (Dangargaon)" },
      { id: 543308, name: "Chincholi(Kopri)" },
      { id: 543351, name: "Choramba" },
      { id: 543338, name: "Chorkund" },
      { id: 543346, name: "Dahegaon" },
      { id: 543305, name: "Dangargaon" },
      { id: 543399, name: "Dattapur (Belora)" },
      { id: 543336, name: "Dattapur(Zatala)" },
      { id: 543377, name: "Devdhari" },
      { id: 543413, name: "Dhunki Badi" },
      { id: 543410, name: "Dongargaon B" },
      { id: 543378, name: "Dorli" },
      { id: 543423, name: "Ganeri" },
      { id: 543374, name: "Gawara Badi" },
      { id: 944998, name: "Ghatanji" },
      { id: 944999, name: "Ghati" },
      { id: 543322, name: "Ghoti" },
      { id: 543402, name: "Govindpur(N)" },
      { id: 543361, name: "Hiwardhara" },
      { id: 543419, name: "Honegaon (Badi)" },
      { id: 543367, name: "Inzala" },
      { id: 543321, name: "Irul" },
      { id: 543408, name: "Jamb" },
      { id: 543357, name: "Jarang" },
      { id: 543362, name: "Jarur" },
      { id: 543348, name: "Junoni" },
      { id: 543406, name: "Kaleshwar" },
      { id: 543316, name: "Kapsi" },
      { id: 543335, name: "Karmana" },
      { id: 543386, name: "Kavtha (Bandi)" },
      { id: 543320, name: "Kawtha Kh." },
      { id: 543352, name: "Khadki" },
      { id: 543412, name: "Khapri" },
      { id: 543341, name: "Khapri Badi" },
      { id: 543381, name: "Kharoni Badi" },
      { id: 543310, name: "Kinhi( Kinara)" },
      { id: 543391, name: "Kinhi(Parava)" },
      { id: 543355, name: "Kochi" },
      { id: 543411, name: "Kochi Badi" },
      { id: 543313, name: "Koli Bk." },
      { id: 543314, name: "Koli Kh." },
      { id: 543334, name: "Kondjai" },
      { id: 543360, name: "Kopra (Van)" },
      { id: 543317, name: "Kopri" },
      { id: 543376, name: "Kopri Khurd" },
      { id: 543343, name: "Kumbhari" },
      { id: 543304, name: "Kurhad" },
      { id: 543404, name: "Kurli" },
      { id: 543337, name: "Lavhana" },
      { id: 543388, name: "Lingapur (N)" },
      { id: 543307, name: "Lingi" },
      { id: 543371, name: "Mandawa" },
      { id: 543416, name: "Mangi (N)" },
      { id: 543369, name: "Mangli Bandi" },
      { id: 543324, name: "Manjari" },
      { id: 543350, name: "Manoli" },
      { id: 543328, name: "Manusdhari" },
      { id: 543339, name: "Maregaon" },
      { id: 543370, name: "Mareweli (U)" },
      { id: 543407, name: "Matani" },
      { id: 543393, name: "Mejda" },
      { id: 543359, name: "Mowada" },
      { id: 543330, name: "Mudhari (Badhi)" },
      { id: 945178, name: "Mudhati Bandi" },
      { id: 543394, name: "Muradgavhan (B)" },
      { id: 944898, name: "Murali Khand 2" },
      { id: 543333, name: "Murali Khand1" },
      { id: 543387, name: "Nagezari" },
      { id: 543309, name: "Nimbarda" },
      { id: 543366, name: "Nukti" },
      { id: 543331, name: "Pandhurna Bk." },
      { id: 543332, name: "Pandhurna Kh." },
      { id: 543382, name: "Pangadi" },
      { id: 543395, name: "Pardi (Jamb)" },
      { id: 543318, name: "Pardi(Naskari)" },
      { id: 543389, name: "Parwa Khand 1" },
      { id: 945000, name: "Parwa Khand 2" },
      { id: 543327, name: "Patapangra" },
      { id: 543380, name: "Pimpalkhuti Badi" },
      { id: 543368, name: "Pimpri" },
      { id: 543384, name: "Rahati" },
      { id: 543373, name: "Rajegaon Budruk" },
      { id: 543409, name: "Rajegaon Khurd" },
      { id: 543414, name: "Rajupeth" },
      { id: 543363, name: "Rajurwadi" },
      { id: 543311, name: "Rampur" },
      { id: 543385, name: "Rasa" },
      { id: 543325, name: "Ratnapur" },
      { id: 543422, name: "Sagada" },
      { id: 543365, name: "Sakhara Kh." },
      { id: 543344, name: "Sasani" },
      { id: 543415, name: "Sawangi" },
      { id: 543417, name: "Sawargaon Magi" },
      { id: 543383, name: "Sayatkharda" },
      { id: 543403, name: "Sayfal" },
      { id: 543358, name: "Sevanagar" },
      { id: 543396, name: "Sharad" },
      { id: 543347, name: "Shiroli Khand 1" },
      { id: 944900, name: "Shiroli Khand 2" },
      { id: 543356, name: "Shivani Khand 1" },
      { id: 944893, name: "Shivani Khand 2" },
      { id: 543390, name: "Sonkhas (N)" },
      { id: 543401, name: "Tadsawali" },
      { id: 543397, name: "Taroda" },
      { id: 543420, name: "Thanegaon" },
      { id: 543418, name: "Tipeshwar" },
      { id: 543372, name: "Titwi" },
      { id: 543345, name: "Tiwsala" },
      { id: 543312, name: "Undarni" },
      { id: 543392, name: "Wadhona" },
      { id: 543405, name: "Waghar Takli" },
      { id: 543364, name: "Wasari" },
      { id: 543319, name: "Yedshi" },
      { id: 543375, name: "Yerandgaon" },
      { id: 543353, name: "Yevti" },
      { id: 543326, name: "Zari (Vidhi)" },
      { id: 543398, name: "Zatala" },
    ],
    4090: [
      { id: 543459, name: "Adni" },
      { id: 543514, name: "Akoli Bk" },
      { id: 543450, name: "Akoli Kh" },
      { id: 543510, name: "Ambhora" },
      { id: 543545, name: "Andharwadi" },
      { id: 543554, name: "Arli" },
      { id: 543425, name: "Asoli" },
      { id: 543515, name: "Baggi" },
      { id: 543522, name: "Bahatter" },
      { id: 543521, name: "Ballarpur" },
      { id: 543512, name: "Belori" },
      { id: 543507, name: "Bhadumari" },
      { id: 543517, name: "Borgaon" },
      { id: 543508, name: "Both" },
      { id: 543511, name: "Chalbardi" },
      { id: 543464, name: "Chanai" },
      { id: 543559, name: "Chanakha" },
      { id: 543428, name: "Chikhaldara" },
      { id: 543500, name: "Chopan" },
      { id: 543436, name: "Dabha" },
      { id: 543502, name: "Daheli" },
      { id: 543552, name: "Daryapur" },
      { id: 543469, name: "Dharna" },
      { id: 543484, name: "Dhoki" },
      { id: 543529, name: "Dhoki (Road)" },
      { id: 543475, name: "Dongargaon" },
      { id: 543483, name: "Ganeshpur" },
      { id: 543476, name: "Ganeshpur (Vai)" },
      { id: 543513, name: "Ghanmod" },
      { id: 543440, name: "Ghoddara" },
      { id: 543496, name: "Ghonsi" },
      { id: 543557, name: "Ghubadi" },
      { id: 543526, name: "Gondwakadi" },
      { id: 543516, name: "Gopalpur" },
      { id: 543555, name: "Hiwari" },
      { id: 543447, name: "Jawaharnagar" },
      { id: 543438, name: "Jira" },
      { id: 543431, name: "Joginkawada" },
      { id: 543458, name: "Karanji" },
      { id: 543446, name: "Karanwadi" },
      { id: 543556, name: "Karegaon (Bandal)" },
      { id: 543427, name: "Karegaon(Rampur)" },
      { id: 543534, name: "Kawatha" },
      { id: 543498, name: "Kegaon" },
      { id: 543495, name: "Kelapur" },
      { id: 543448, name: "Khairgaon (De)" },
      { id: 543533, name: "Khairgaon (Ujad)" },
      { id: 543478, name: "Khairgaon Bk" },
      { id: 543486, name: "Khairgaon Kh" },
      { id: 543550, name: "Khairi" },
      { id: 543462, name: "Khatara" },
      { id: 543453, name: "Kinhala" },
      { id: 543442, name: "Kinhi" },
      { id: 543561, name: "Kodori" },
      { id: 543490, name: "Kondhi" },
      { id: 543479, name: "Konghara" },
      { id: 543535, name: "Kopamandavi" },
      { id: 543466, name: "Kothoda" },
      { id: 543429, name: "Krishnapur" },
      { id: 543499, name: "Kusal" },
      { id: 543444, name: "Lingati" },
      { id: 543506, name: "Lingati (Sa)" },
      { id: 543519, name: "Mahandoli" },
      { id: 543501, name: "Malkapur" },
      { id: 543468, name: "Mangi" },
      { id: 543488, name: "Mangurda" },
      { id: 543528, name: "Marathwakadi" },
      { id: 543473, name: "Maregaon" },
      { id: 543543, name: "Maregaon (Van)" },
      { id: 543437, name: "Meera" },
      { id: 543424, name: "Mohada" },
      { id: 543430, name: "Mohadari" },
      { id: 543449, name: "Morwa" },
      { id: 543487, name: "Muchi" },
      { id: 543460, name: "Munzala" },
      { id: 543525, name: "Nagezari" },
      { id: 543538, name: "Naik Sukali" },
      { id: 543492, name: "Nandgaon" },
      { id: 543441, name: "Nandpur" },
      { id: 543480, name: "Niljai" },
      { id: 543558, name: "Nimdheli" },
      { id: 543482, name: "Padha" },
      { id: 543509, name: "Pahapal" },
      { id: 944892, name: "Pandharkavada" },
      { id: 543489, name: "Pandharwani Bk" },
      { id: 543547, name: "Patanbori" },
      { id: 543435, name: "Pathari" },
      { id: 543504, name: "Patoda" },
      { id: 543523, name: "Pendhari" },
      { id: 543470, name: "Pimpalapur" },
      { id: 543563, name: "Pimpalkhuti" },
      { id: 543426, name: "Pimpalshenda Ga.Na.227" },
      { id: 543553, name: "Pimpalshenda Ga.Na.228" },
      { id: 543477, name: "Pimpari Road" },
      { id: 543562, name: "Pimparibori" },
      { id: 543541, name: "Pitapongari" },
      { id: 543560, name: "Rudha" },
      { id: 543433, name: "Runza" },
      { id: 543443, name: "Saikheda" },
      { id: 543481, name: "Sakhara Bk" },
      { id: 543520, name: "Sakhara Kh" },
      { id: 543454, name: "Sankhi Bk." },
      { id: 543432, name: "Shampur" },
      { id: 543461, name: "Singaldip" },
      { id: 543474, name: "Sonbardi" },
      { id: 543463, name: "Sonurli" },
      { id: 543549, name: "Sukali" },
      { id: 543531, name: "Sunna" },
      { id: 543465, name: "Surdevi" },
      { id: 543524, name: "Susari" },
      { id: 543493, name: "Tadumari" },
      { id: 543494, name: "Tatapur" },
      { id: 543451, name: "Telangtakli" },
      { id: 543530, name: "Tembhi" },
      { id: 543518, name: "Tokwanzari" },
      { id: 543452, name: "Umari" },
      { id: 543472, name: "Vasantnagar" },
      { id: 543434, name: "Vrindavantakli" },
      { id: 543455, name: "Wadhona Bk." },
      { id: 543456, name: "Wadhona Kh." },
      { id: 543503, name: "Wadner" },
      { id: 543551, name: "Wadwat" },
      { id: 543445, name: "Wagada" },
      { id: 543471, name: "Wagholi" },
      { id: 543485, name: "Wai" },
      { id: 543532, name: "Wanjari" },
      { id: 543546, name: "Warha" },
      { id: 543548, name: "Wasari" },
      { id: 543439, name: "Wathoda" },
      { id: 543491, name: "Wedad" },
      { id: 543544, name: "Yedlapur" },
      { id: 543505, name: "Zuli" },
      { id: 543527, name: "Zunzarpur" },
    ],
    4091: [
      { id: 543635, name: "Anji" },
      { id: 543614, name: "Antargaon" },
      { id: 543620, name: "Apati" },
      { id: 543565, name: "Ashta" },
      { id: 543692, name: "Ashtona" },
      { id: 543649, name: "Atmurdi" },
      { id: 543693, name: "Balapur" },
      { id: 543648, name: "Bandar" },
      { id: 543575, name: "Baradgaon" },
      { id: 543622, name: "Bhamb" },
      { id: 543661, name: "Bhimsenpur" },
      { id: 543639, name: "Bhulgad" },
      { id: 543587, name: "Borakhadi" },
      { id: 543643, name: "Borati" },
      { id: 543690, name: "Bori (Ichod)" },
      { id: 543569, name: "Bori Mengapur" },
      { id: 543576, name: "Borjai" },
      { id: 543642, name: "Bukai" },
      { id: 543673, name: "Chahand" },
      { id: 543608, name: "Chikana" },
      { id: 543615, name: "Chikhali (Vanoja)" },
      { id: 543684, name: "Chikhali(Vi)" },
      { id: 543636, name: "Chincholi" },
      { id: 543660, name: "Chondi" },
      { id: 543694, name: "Dahegaon Khand 1" },
      { id: 944884, name: "Dahegaon Khand 2" },
      { id: 543612, name: "Dapori (K)" },
      { id: 543583, name: "Dapori Ka." },
      { id: 543656, name: "Deodhari" },
      { id: 543617, name: "Dhanora" },
      { id: 543610, name: "Dharmapur" },
      { id: 543654, name: "Dhumak Chachora" },
      { id: 543624, name: "Dongargaon" },
      { id: 543592, name: "Ekalara" },
      { id: 543601, name: "Ekburji" },
      { id: 543653, name: "Ekurli" },
      { id: 543689, name: "Gadeghat" },
      { id: 543591, name: "Gopalnagar" },
      { id: 543568, name: "Gujari" },
      { id: 543666, name: "Hirapur" },
      { id: 543590, name: "Hiwari 401" },
      { id: 543603, name: "Hiwari 402" },
      { id: 543574, name: "Hudaki" },
      { id: 543599, name: "Ibrahimpur" },
      { id: 543564, name: "Ichora" },
      { id: 543609, name: "Inzapur" },
      { id: 543611, name: "Jagjai" },
      { id: 944885, name: "Jalaka Khand 2" },
      { id: 543595, name: "Jalka Khand 1" },
      { id: 543584, name: "Kalamner" },
      { id: 543671, name: "Karanji" },
      { id: 543674, name: "Karegaon" },
      { id: 543625, name: "Khadki (Sukali)" },
      { id: 543675, name: "Khadki(Wadki)" },
      { id: 543659, name: "Khairgaon (Ka)" },
      { id: 543651, name: "Khairgaon(J)" },
      { id: 543679, name: "Khairi" },
      { id: 543662, name: "Khemkund" },
      { id: 543655, name: "Kinhi (J)" },
      { id: 543678, name: "Kocchi" },
      { id: 543606, name: "Kolwan" },
      { id: 543600, name: "Kopari" },
      { id: 543672, name: "Ladaki" },
      { id: 543588, name: "Lakhapur" },
      { id: 543593, name: "Lohara" },
      { id: 543647, name: "Loni" },
      { id: 543582, name: "Malki" },
      { id: 543605, name: "Mandawa" },
      { id: 543691, name: "Mangi" },
      { id: 543573, name: "Mengapur" },
      { id: 543623, name: "Mudhapur" },
      { id: 543669, name: "Mudhapur Ujad" },
      { id: 543626, name: "Mukhrampur" },
      { id: 945017, name: "Nagai" },
      { id: 543566, name: "Nagthana" },
      { id: 543572, name: "Narsingpur" },
      { id: 543627, name: "Nidha" },
      { id: 543663, name: "Palas Kund" },
      { id: 543665, name: "Pardi" },
      { id: 543670, name: "Parsoda" },
      { id: 543695, name: "Phepari" },
      { id: 543681, name: "Pimpalapur" },
      { id: 543631, name: "Pimpalgaon" },
      { id: 543602, name: "Pimpalkhuti" },
      { id: 543638, name: "Pimpalshenda" },
      { id: 543688, name: "Pimpari (Sa.)" },
      { id: 543604, name: "Pimpri Durg" },
      { id: 543581, name: "Ralegaon Khand 1" },
      { id: 944883, name: "Ralegaon Khand 2" },
      { id: 543585, name: "Ramtirth" },
      { id: 543630, name: "Ranwad" },
      { id: 543589, name: "Ratnapur" },
      { id: 543597, name: "Raveri" },
      { id: 543683, name: "Ridhora" },
      { id: 543616, name: "Rohini" },
      { id: 543646, name: "Sakhi Kh." },
      { id: 543570, name: "Sangam" },
      { id: 543628, name: "Sarai" },
      { id: 543687, name: "Sarati" },
      { id: 543644, name: "Savitri" },
      { id: 543598, name: "Sawangi (Pe)" },
      { id: 543657, name: "Sawarkheda" },
      { id: 543633, name: "Sawner" },
      { id: 543619, name: "Sheli" },
      { id: 543685, name: "Shindola" },
      { id: 543596, name: "Shrirampur" },
      { id: 543607, name: "Soit Ijara" },
      { id: 543578, name: "Sonurli" },
      { id: 543632, name: "Takali" },
      { id: 543634, name: "Tejani" },
      { id: 543682, name: "Umared" },
      { id: 543664, name: "Umarvihir" },
      { id: 543613, name: "Undari" },
      { id: 543650, name: "Vedshi" },
      { id: 543652, name: "Vihirgaon" },
      { id: 543677, name: "Virul" },
      { id: 543686, name: "Wadgaon" },
      { id: 543637, name: "Wadhona Bajar" },
      { id: 543580, name: "Wadjai" },
      { id: 543680, name: "Wadki" },
      { id: 543567, name: "Wagdara" },
      { id: 543586, name: "Waldhur" },
      { id: 543579, name: "Walinagar" },
      { id: 543618, name: "Wanoja" },
      { id: 543658, name: "Wardh" },
      { id: 543571, name: "Warha" },
      { id: 543594, name: "Warna" },
      { id: 543640, name: "Warud (J)" },
      { id: 543629, name: "Wathoda" },
      { id: 543577, name: "Watkhed" },
      { id: 543667, name: "Yevti" },
      { id: 543621, name: "Zadgaon" },
      { id: 543641, name: "Zargad" },
      { id: 543645, name: "Zotingdhara" },
      { id: 543676, name: "Zullar" },
    ],
    4092: [
      { id: 543774, name: "Akapur" },
      { id: 543719, name: "Ambora (Ujad)" },
      { id: 543758, name: "Apati" },
      { id: 543806, name: "Arjuni" },
      { id: 543810, name: "Asan (Ujad)" },
      { id: 543724, name: "Awalgaon" },
      { id: 543755, name: "Bambarda" },
      { id: 543780, name: "Bhalewadi" },
      { id: 543751, name: "Bodad" },
      { id: 543697, name: "Bori Bk." },
      { id: 543767, name: "Bori Kh" },
      { id: 543721, name: "Buranda(K)" },
      { id: 543741, name: "Chanoda" },
      { id: 543759, name: "Chargaon U" },
      { id: 543720, name: "Chi.Botoni" },
      { id: 543778, name: "Chinchala" },
      { id: 543738, name: "Chinchmandal" },
      { id: 543749, name: "Chopan" },
      { id: 543746, name: "Dandgaon" },
      { id: 543737, name: "Dapora" },
      { id: 543765, name: "Dewala" },
      { id: 543710, name: "Dhamani" },
      { id: 543736, name: "Dhanora (Ujad)" },
      { id: 543773, name: "Dol.Dongargaon" },
      { id: 543764, name: "Dongargaon" },
      { id: 543796, name: "Dorli" },
      { id: 543726, name: "Durgada" },
      { id: 543740, name: "Gadegaon" },
      { id: 543784, name: "Gawarala" },
      { id: 543733, name: "Ghanpur (Ujad)" },
      { id: 543712, name: "Ghoddara" },
      { id: 543715, name: "Ghoguldara" },
      { id: 543807, name: "Godhani" },
      { id: 543709, name: "Gondburanda" },
      { id: 543757, name: "Goraj" },
      { id: 543792, name: "Hatwanjari" },
      { id: 543747, name: "Hiwara Majara" },
      { id: 543801, name: "Hiwari" },
      { id: 543706, name: "Indiragram (Navin)" },
      { id: 543808, name: "Jaglon (Ujad)" },
      { id: 543717, name: "Jalaka" },
      { id: 543748, name: "Kanada" },
      { id: 543787, name: "Kanhalgaon" },
      { id: 543725, name: "Kanhalgaon Ujad" },
      { id: 543769, name: "Kanhalgaon Wai" },
      { id: 543789, name: "Karanwadi" },
      { id: 543800, name: "Kegaon Ga.Na.51" },
      { id: 543739, name: "Kegaon Gav.Na.50" },
      { id: 543772, name: "Khadaki" },
      { id: 543723, name: "Khairgaon (Bhedi)" },
      { id: 543752, name: "Khairgaon Bk" },
      { id: 543730, name: "Khandani" },
      { id: 543790, name: "Khapri" },
      { id: 543713, name: "Khekadwai" },
      { id: 543811, name: "Kilona (Ujad)" },
      { id: 543770, name: "Kinhala" },
      { id: 543797, name: "Kolgaon" },
      { id: 543735, name: "Kosara" },
      { id: 543699, name: "Kothurla" },
      { id: 543698, name: "Krushnapur (Ujad)" },
      { id: 543791, name: "Kumbha Khand 1" },
      { id: 543704, name: "Kumbha Khand 2" },
      { id: 543775, name: "Lakhapur" },
      { id: 543761, name: "Machhindra" },
      { id: 543768, name: "Madanapar (Ujad)" },
      { id: 543708, name: "Mahagaon" },
      { id: 543750, name: "Majara" },
      { id: 543702, name: "Mangali" },
      { id: 543785, name: "Mangarul" },
      { id: 543754, name: "Mardi" },
      { id: 543786, name: "Maregaon" },
      { id: 543729, name: "Mendhani" },
      { id: 543794, name: "Mhaisdodaka" },
      { id: 543745, name: "Mukta" },
      { id: 543711, name: "Narsala" },
      { id: 543795, name: "Nawargaon" },
      { id: 543783, name: "Net" },
      { id: 543766, name: "Pahapal" },
      { id: 543716, name: "Pandawihir" },
      { id: 543777, name: "Pandharkawada" },
      { id: 543742, name: "Pardi" },
      { id: 543779, name: "Pathri" },
      { id: 543804, name: "Pendhari" },
      { id: 543756, name: "Phefarwada" },
      { id: 543776, name: "Pisgaon" },
      { id: 543805, name: "Raipur" },
      { id: 543700, name: "Rameshwar" },
      { id: 543803, name: "Rohpat" },
      { id: 543802, name: "Saganapur" },
      { id: 543707, name: "Sakhara" },
      { id: 543781, name: "Salebhatti" },
      { id: 543722, name: "Sarati" },
      { id: 543734, name: "Sawangi" },
      { id: 543743, name: "Shivani Dhobe" },
      { id: 543714, name: "Shivnala" },
      { id: 543705, name: "Shrirampur (Navin)" },
      { id: 543701, name: "Sindi" },
      { id: 543788, name: "Takarkheda" },
      { id: 543703, name: "Takli" },
      { id: 543753, name: "Tukapur (U)" },
      { id: 543809, name: "Umarghat" },
      { id: 543727, name: "Vasantnagar" },
      { id: 543771, name: "Wadgaon" },
      { id: 543798, name: "Wadgaon (Waghade)" },
      { id: 543728, name: "Wagdara" },
      { id: 543760, name: "Wanoja (Devi)" },
      { id: 543782, name: "Warud" },
      { id: 543799, name: "Wegaon" },
      { id: 543744, name: "Zagada (Ujad)" },
    ],
    4093: [
      { id: 543864, name: "Adakoli" },
      { id: 543894, name: "Adegaon Khand 1" },
      { id: 945027, name: "Adegaon Khand 2" },
      { id: 543922, name: "Aheralli" },
      { id: 543924, name: "Amb" },
      { id: 543814, name: "Ambezari (I)" },
      { id: 543828, name: "Ambezari Bk." },
      { id: 543827, name: "Ambezari Kh." },
      { id: 543882, name: "Ardhawan" },
      { id: 543910, name: "Arjkawada" },
      { id: 543892, name: "Bahilampur" },
      { id: 543856, name: "Balapur" },
      { id: 543885, name: "Bhendala" },
      { id: 543840, name: "Bhimnala" },
      { id: 543926, name: "Birsapeth" },
      { id: 543860, name: "Bopapur" },
      { id: 543815, name: "Borgaon (B)" },
      { id: 543812, name: "Botoni" },
      { id: 543915, name: "Chalbardi" },
      { id: 543908, name: "Chatwan" },
      { id: 543902, name: "Chikhaldoh" },
      { id: 543853, name: "Chinchghat" },
      { id: 543921, name: "Dabha" },
      { id: 543838, name: "Dabhadi" },
      { id: 543857, name: "Dara" },
      { id: 543834, name: "Darara" },
      { id: 543919, name: "Demaddevi" },
      { id: 543939, name: "Dhanora" },
      { id: 543934, name: "Digras" },
      { id: 543869, name: "Dongargaon" },
      { id: 543931, name: "Dorli" },
      { id: 543935, name: "Durbha" },
      { id: 543878, name: "Ganeshpur Bk." },
      { id: 543870, name: "Ganeshpur Kh." },
      { id: 543911, name: "Gawara" },
      { id: 543831, name: "Gopalpur" },
      { id: 543890, name: "Hirapur" },
      { id: 543826, name: "Hiwara Barasa" },
      { id: 543913, name: "Jamani" },
      { id: 543836, name: "Junoni (123)" },
      { id: 543906, name: "Junoni(124)" },
      { id: 543875, name: "Kamalapur" },
      { id: 543930, name: "Kamalweli" },
      { id: 543900, name: "Karegaon" },
      { id: 543824, name: "Katali Borgaon" },
      { id: 543859, name: "Kesalapur" },
      { id: 543851, name: "Khadakdoh" },
      { id: 543879, name: "Khadaki" },
      { id: 543883, name: "Khapari" },
      { id: 543927, name: "Kharbada" },
      { id: 543897, name: "Khatera" },
      { id: 543912, name: "Kodpakhindi" },
      { id: 543877, name: "Kosara" },
      { id: 543841, name: "Kundi" },
      { id: 543852, name: "Ledori" },
      { id: 543937, name: "Lingati" },
      { id: 543855, name: "Loni" },
      { id: 543844, name: "Mahadapur" },
      { id: 543830, name: "Majara" },
      { id: 543846, name: "Mandava" },
      { id: 543907, name: "Mandavi" },
      { id: 543889, name: "Mangali" },
      { id: 543849, name: "Mangurla Bk." },
      { id: 543847, name: "Mangurla Kh." },
      { id: 543872, name: "Marki Bk." },
      { id: 543865, name: "Marki Kh." },
      { id: 543903, name: "Matharjun" },
      { id: 543873, name: "Muchhi" },
      { id: 543917, name: "Mudhati" },
      { id: 543886, name: "Mukutban" },
      { id: 543843, name: "Mulgavhan" },
      { id: 543896, name: "Munjala" },
      { id: 543858, name: "Narsoda" },
      { id: 543832, name: "Nimani" },
      { id: 543901, name: "Nimbadevi" },
      { id: 543813, name: "Pachpohor" },
      { id: 543839, name: "Padharwani" },
      { id: 543825, name: "Palgaon" },
      { id: 543871, name: "Pandharkawada" },
      { id: 543899, name: "Paramba" },
      { id: 543932, name: "Pardi (204)" },
      { id: 543876, name: "Pardi (209)" },
      { id: 543822, name: "Pardi(205)" },
      { id: 543916, name: "Parsodi" },
      { id: 543928, name: "Patan" },
      { id: 543866, name: "Pawanar" },
      { id: 543887, name: "Pimparadwadi" },
      { id: 543893, name: "Pimprad" },
      { id: 543909, name: "Pivardol" },
      { id: 543936, name: "Raipur" },
      { id: 543829, name: "Rajani" },
      { id: 543891, name: "Rajur" },
      { id: 543925, name: "Rampeth" },
      { id: 543823, name: "Rampur" },
      { id: 543880, name: "Ruikot" },
      { id: 543923, name: "Satpalli" },
      { id: 543881, name: "Sawali" },
      { id: 543874, name: "Shekapur" },
      { id: 543821, name: "Shibala" },
      { id: 543848, name: "Shirola" },
      { id: 543868, name: "Sindhi Wadhona" },
      { id: 543929, name: "Surdapur" },
      { id: 543854, name: "Surdevi" },
      { id: 543817, name: "Surla" },
      { id: 543816, name: "Susari" },
      { id: 543920, name: "Takli" },
      { id: 543842, name: "Tembhi" },
      { id: 543918, name: "Umari" },
      { id: 543818, name: "Wadhona Bandi" },
      { id: 543837, name: "Walhasa" },
      { id: 543933, name: "Watholi" },
      { id: 543898, name: "Wedad" },
      { id: 543938, name: "Yedalapur" },
      { id: 543895, name: "Yedasi" },
      { id: 543835, name: "Yesapur" },
      { id: 543884, name: "Yevati" },
      { id: 543833, name: "Zamkola" },
      { id: 543914, name: "Zari" },
    ],
    4094: [
      { id: 543969, name: "Agashi" },
      { id: 543974, name: "Aheri" },
      { id: 544098, name: "Akapur" },
      { id: 544097, name: "Amlon" },
      { id: 544051, name: "Babapur" },
      { id: 543956, name: "Belghat" },
      { id: 544000, name: "Belora" },
      { id: 543985, name: "Besa" },
      { id: 543978, name: "Bhalar" },
      { id: 543944, name: "Bhandewada" },
      { id: 543941, name: "Bhurki" },
      { id: 543953, name: "Bodad Bujurg" },
      { id: 544014, name: "Borda" },
      { id: 543981, name: "Borgaon (Aheri)" },
      { id: 544017, name: "Borgaon(Mendholi)" },
      { id: 544054, name: "Borgoan(Van)" },
      { id: 544089, name: "Bori" },
      { id: 543971, name: "Bramhani" },
      { id: 544071, name: "Chanakha" },
      { id: 543995, name: "Chargaon" },
      { id: 544050, name: "Chendkapur" },
      { id: 543964, name: "Chikhalgaon" },
      { id: 544068, name: "Chikhali" },
      { id: 544081, name: "Chilai" },
      { id: 544011, name: "Chincholi" },
      { id: 543958, name: "Dahegaon (Gho)" },
      { id: 544028, name: "Dahegaon (Vi)" },
      { id: 544091, name: "Deurwada" },
      { id: 544021, name: "Dhabapur" },
      { id: 544090, name: "Dhakori" },
      { id: 543987, name: "Dhandir U" },
      { id: 543977, name: "Dhoptala" },
      { id: 544094, name: "Dhunki" },
      { id: 543957, name: "Dongargaon" },
      { id: 544075, name: "Dorli" },
      { id: 543952, name: "Durgadi" },
      { id: 544025, name: "Fulora" },
      { id: 544099, name: "Gadeghat" },
      { id: 543963, name: "Ganeshpur" },
      { id: 544027, name: "Ghonsa" },
      { id: 544034, name: "Godgaon" },
      { id: 544029, name: "Gondhala (U)" },
      { id: 544057, name: "Gopalpur" },
      { id: 544039, name: "Gopalpur (Banda)" },
      { id: 544073, name: "Gowari (Ka)" },
      { id: 543968, name: "Gowari(Pardi)" },
      { id: 544080, name: "Hiwardhara" },
      { id: 544032, name: "Ijasan" },
      { id: 544093, name: "Jamni(U)" },
      { id: 544064, name: "Jugad" },
      { id: 543982, name: "Junada" },
      { id: 544084, name: "Junoni (U)" },
      { id: 544070, name: "Kalmana (Bk.)" },
      { id: 543965, name: "Kalmana (Kh)" },
      { id: 544009, name: "Kawadshi" },
      { id: 544045, name: "Kayar" },
      { id: 544053, name: "Keshav Nagar" },
      { id: 543986, name: "Kesurli" },
      { id: 544056, name: "Khandla" },
      { id: 544095, name: "Khed (U)" },
      { id: 543991, name: "Khekadi (U)" },
      { id: 543970, name: "Kolera" },
      { id: 544066, name: "Kolgaon" },
      { id: 543967, name: "Kona" },
      { id: 544022, name: "Korambi" },
      { id: 544083, name: "Krishnanpur" },
      { id: 544001, name: "Kumbhari (U)" },
      { id: 544031, name: "Kumbharkhani" },
      { id: 544078, name: "Kundra" },
      { id: 544074, name: "Kurai" },
      { id: 544058, name: "Kurli" },
      { id: 543976, name: "Lalguda" },
      { id: 543984, name: "Lathi" },
      { id: 544042, name: "Mahankalpur" },
      { id: 543946, name: "Majra" },
      { id: 544046, name: "Malegaon(U)" },
      { id: 543993, name: "Mandar" },
      { id: 543990, name: "Manki" },
      { id: 544023, name: "Maregaon(Ko)" },
      { id: 544063, name: "Matholi" },
      { id: 544040, name: "Mendholi" },
      { id: 544082, name: "Modmajara(U)" },
      { id: 544052, name: "Mohada" },
      { id: 544019, name: "Mohorli" },
      { id: 544079, name: "Mundra (Ujad)" },
      { id: 544062, name: "Mungoli" },
      { id: 544020, name: "Murdhoni" },
      { id: 544088, name: "Murti" },
      { id: 543951, name: "Nagala" },
      { id: 544002, name: "Naigaon (Bu)" },
      { id: 543975, name: "Naigaon Kh" },
      { id: 543942, name: "Nandepera" },
      { id: 544086, name: "Nandgaon (U)" },
      { id: 544044, name: "Nawargaon" },
      { id: 544015, name: "Nawegaon (Vi)" },
      { id: 544049, name: "Nerad" },
      { id: 543972, name: "Nilapur" },
      { id: 543999, name: "Niljai" },
      { id: 543954, name: "Nimbala (Road)" },
      { id: 544092, name: "Nimbala Bk" },
      { id: 544085, name: "Nimbala Kh." },
      { id: 544007, name: "Nipani Pimpri (U)" },
      { id: 543997, name: "Niwali" },
      { id: 543962, name: "Palsoda" },
      { id: 543960, name: "Palsoni" },
      { id: 544076, name: "Panchdhar(U)" },
      { id: 544069, name: "Paramdoh" },
      { id: 544008, name: "Pardi (Govari) (Ujad)" },
      { id: 544087, name: "Pardi(Van)" },
      { id: 544033, name: "Parsoda (Ka)" },
      { id: 544048, name: "Patharpur" },
      { id: 544072, name: "Pathri" },
      { id: 543992, name: "Petur" },
      { id: 543980, name: "Pimpalgaon" },
      { id: 543973, name: "Pimpari (Ka)" },
      { id: 544041, name: "Pimpri (Kolera)" },
      { id: 543945, name: "Pohana" },
      { id: 544003, name: "Punvat Khand 1" },
      { id: 944891, name: "Punvat Khand 2" },
      { id: 544004, name: "Purad (Nerad)" },
      { id: 544077, name: "Purad (Punvat)" },
      { id: 544100, name: "Rajur" },
      { id: 543947, name: "Rangana" },
      { id: 544024, name: "Rasa Khand 1" },
      { id: 944886, name: "Rasa Khand 2" },
      { id: 544030, name: "Sakhara (Dara)" },
      { id: 544065, name: "Sakhara (Ko)" },
      { id: 544010, name: "Sawangi" },
      { id: 543966, name: "Sawarla" },
      { id: 543996, name: "Shelu Bk" },
      { id: 543940, name: "Shelu Kh" },
      { id: 544012, name: "Shewala" },
      { id: 544059, name: "Shindola" },
      { id: 544036, name: "Shirgiri" },
      { id: 544006, name: "Shirpur" },
      { id: 544061, name: "Shivni (Jahangir)" },
      { id: 543955, name: "Somnala" },
      { id: 543943, name: "Sonapur" },
      { id: 544026, name: "Sonegaon" },
      { id: 544035, name: "Suknegaon" },
      { id: 944890, name: "Surjapur (U)" },
      { id: 544067, name: "Takli" },
      { id: 543998, name: "Taroda" },
      { id: 544096, name: "Tejapur" },
      { id: 543983, name: "Ukani Khand 1" },
      { id: 944888, name: "Ukani Khand 2" },
      { id: 544037, name: "Umari" },
      { id: 945048, name: "Vangram Dhanuki (Motha Majra)" },
      { id: 544060, name: "Velabai" },
      { id: 544018, name: "Virkund" },
      { id: 544016, name: "Vithalnagar" },
      { id: 543959, name: "Vyankatpur(U)" },
      { id: 543988, name: "Wadgaon (Dhandir)" },
      { id: 543949, name: "Wadgaon Tip" },
      { id: 544047, name: "Wadhona Pilki" },
      { id: 544043, name: "Wadjapur" },
      { id: 543989, name: "Wagdara" },
      { id: 945177, name: "Wangram Dhunki (Motha Bajar)" },
      { id: 944889, name: "Wani" },
      { id: 945049, name: "Wanjari" },
      { id: 543994, name: "Wargaon" },
      { id: 543950, name: "Warzadi" },
      { id: 544055, name: "Welhala" },
      { id: 543979, name: "Yenad" },
      { id: 544013, name: "Yenak" },
      { id: 543961, name: "Zarpat" },
      { id: 543948, name: "Zola" },
    ],
    4095: [
      { id: 544132, name: "Anamal" },
      { id: 544142, name: "Anjani" },
      { id: 544182, name: "Anjankhed" },
      { id: 544119, name: "Ashta" },
      { id: 544177, name: "Asoli" },
      { id: 544117, name: "Banjara Tanda" },
      { id: 544186, name: "Bhagwati" },
      { id: 544191, name: "Bhorad" },
      { id: 544163, name: "Bondgavhan" },
      { id: 544164, name: "Bondgavhan Chauphuli" },
      { id: 544148, name: "Borwadi" },
      { id: 544192, name: "Chorad" },
      { id: 544130, name: "Dattamanjari" },
      { id: 544155, name: "Dhanora (Digdi)" },
      { id: 544135, name: "Digadi (Ku)" },
      { id: 544156, name: "Digdi (Mohpur)" },
      { id: 544112, name: "Gokulnagar" },
      { id: 544115, name: "Gondegaon" },
      { id: 544166, name: "Gondkhedi" },
      { id: 544188, name: "Goundwadsa" },
      { id: 544131, name: "Gundwal" },
      { id: 544101, name: "Hadsani" },
      { id: 544172, name: "Hardap" },
      { id: 544136, name: "Hingani" },
      { id: 544137, name: "Iwleshwar" },
      { id: 945904, name: "Jaggu Naik Tanda" },
      { id: 544193, name: "Junapani" },
      { id: 544114, name: "Karalgaon" },
      { id: 544187, name: "Karanji (Sindkhed)" },
      { id: 544144, name: "Kasarpeth" },
      { id: 544105, name: "Kasbag" },
      { id: 544103, name: "Keroli" },
      { id: 544161, name: "Koli" },
      { id: 544151, name: "Kupti (Mahoor)" },
      { id: 544122, name: "Lakhamapur" },
      { id: 544124, name: "Lakhamapur Tanda" },
      { id: 544106, name: "Lanji" },
      { id: 544181, name: "Lasanwadi" },
      { id: 544108, name: "Limbayat" },
      { id: 544170, name: "Lokarwadi" },
      { id: 544116, name: "Machindra Pardi" },
      { id: 544162, name: "Madnapur" },
      { id: 544138, name: "Mahadapur" },
      { id: 544129, name: "Mahoor" },
      { id: 544190, name: "Malkaguda" },
      { id: 544176, name: "Malkaguda Tanda" },
      { id: 544123, name: "Malwada" },
      { id: 544134, name: "Mamtapur (D)" },
      { id: 544146, name: "Mandva (Mahur)" },
      { id: 544157, name: "Mendki" },
      { id: 544178, name: "Met" },
      { id: 544158, name: "Mungashi" },
      { id: 544121, name: "Murli" },
      { id: 544183, name: "Naik Wadi" },
      { id: 544125, name: "Nakhegaon" },
      { id: 544107, name: "Ner" },
      { id: 544152, name: "Pachunda" },
      { id: 544110, name: "Padsa" },
      { id: 544141, name: "Panola" },
      { id: 544128, name: "Papalwadi" },
      { id: 544150, name: "Pavnala" },
      { id: 544140, name: "Raigad (D)" },
      { id: 544102, name: "Rui" },
      { id: 544189, name: "Rupala Naik Tanda" },
      { id: 544168, name: "Rupanaik Tanda" },
      { id: 544154, name: "Sakur" },
      { id: 544145, name: "Salambi" },
      { id: 544167, name: "Satiguda" },
      { id: 544171, name: "Sawarkhed" },
      { id: 544160, name: "Sayphal" },
      { id: 544184, name: "Selu" },
      { id: 544143, name: "She.Ph Wazra" },
      { id: 544104, name: "Shekapur" },
      { id: 544139, name: "Shivur" },
      { id: 544169, name: "Sindkhed" },
      { id: 544109, name: "Takli" },
      { id: 544133, name: "Tandala" },
      { id: 544180, name: "Tulshi" },
      { id: 544127, name: "Umra" },
      { id: 544165, name: "Vasram Tanda" },
      { id: 544111, name: "Wadsa" },
      { id: 544174, name: "Wai" },
      { id: 544175, name: "Wai Tanda" },
      { id: 544185, name: "Waiphani" },
      { id: 544147, name: "Wanola" },
      { id: 544153, name: "Wanola Tanda" },
    ],
    4096: [
      { id: 544296, name: "Aamdi" },
      { id: 544380, name: "Amalapur" },
      { id: 544257, name: "Ambadi" },
      { id: 544256, name: "Ambadi Tanda" },
      { id: 544309, name: "Andhbori (Chi.)" },
      { id: 544376, name: "Andhbori (E)" },
      { id: 544265, name: "Anji" },
      { id: 544381, name: "Apparaopeth" },
      { id: 544327, name: "Bellori (Dha)" },
      { id: 544267, name: "Bellori (Kinwat)" },
      { id: 544294, name: "Bendi" },
      { id: 544295, name: "Bendi Tanda" },
      { id: 544322, name: "Bhandarwadi" },
      { id: 544226, name: "Bhiku Naik Tanda" },
      { id: 544245, name: "Bhilgaon" },
      { id: 544274, name: "Bhimpur" },
      { id: 544333, name: "Bhisi" },
      { id: 544283, name: "Bhulja" },
      { id: 544302, name: "Bodhadi Bk." },
      { id: 544288, name: "Bodhadi Kh" },
      { id: 544208, name: "Both" },
      { id: 544300, name: "Budhwarpeth" },
      { id: 544317, name: "Burkulwadi" },
      { id: 544344, name: "Chandrapur" },
      { id: 544206, name: "Chapla Naik Tanda" },
      { id: 544299, name: "Chikhali (Bk)" },
      { id: 544371, name: "Chikhali (E)" },
      { id: 544290, name: "Chikhli Tanda" },
      { id: 544203, name: "Chinchkhed" },
      { id: 544297, name: "Choti Chikhali." },
      { id: 544211, name: "Chyas" },
      { id: 544292, name: "Dabhadi" },
      { id: 544235, name: "Dagad Wazra" },
      { id: 544307, name: "Dahegaon" },
      { id: 544219, name: "Daheli" },
      { id: 544225, name: "Darsangavi (Sindkhed)" },
      { id: 544291, name: "Darsangvi (Chikhli)" },
      { id: 544367, name: "Dayal Dhanora" },
      { id: 544312, name: "Devla Tanda" },
      { id: 544255, name: "Dhamandari" },
      { id: 544194, name: "Dhanora (Sindkhed)" },
      { id: 544326, name: "Dhanora Chikhali" },
      { id: 544218, name: "Dhawaji Tanda" },
      { id: 544278, name: "Digadi (Mangabodi)" },
      { id: 544345, name: "Digras" },
      { id: 544373, name: "Dipla Naik Tanda" },
      { id: 544346, name: "Dongargaon (Chikhali)" },
      { id: 544247, name: "Dongargaon (Sindkhed)" },
      { id: 544347, name: "Dongargaon Tanda" },
      { id: 544204, name: "Dundra" },
      { id: 544261, name: "Ganeshpur" },
      { id: 544205, name: "Gaori" },
      { id: 544276, name: "Ghogarwadi" },
      { id: 544272, name: "Ghoti" },
      { id: 544383, name: "Gokunda (Ct)" },
      { id: 544372, name: "Gonde Mahagaon" },
      { id: 544379, name: "Gondjewali" },
      { id: 544368, name: "Gondjewali Tanda" },
      { id: 544200, name: "Hatola" },
      { id: 544301, name: "Hudi (D)" },
      { id: 544336, name: "Hudi (Islapur)" },
      { id: 544316, name: "Injegaon" },
      { id: 544330, name: "Iregaon" },
      { id: 544338, name: "Islapur" },
      { id: 544343, name: "Jaldhara" },
      { id: 544339, name: "Jaldhara Tanda" },
      { id: 544314, name: "Jaroda Tanda" },
      { id: 544242, name: "Jarur" },
      { id: 544243, name: "Jarur Tanda" },
      { id: 544238, name: "Jawarla" },
      { id: 544222, name: "Junoni" },
      { id: 544258, name: "Kamthala" },
      { id: 544263, name: "Kanakwadi" },
      { id: 544370, name: "Kanchali (E)" },
      { id: 544240, name: "Kanki" },
      { id: 544244, name: "Kanki Tanda" },
      { id: 544357, name: "Karanji Islampur" },
      { id: 544289, name: "Karla" },
      { id: 544197, name: "Khambala" },
      { id: 544270, name: "Kherda" },
      { id: 943112, name: "Kinwat" },
      { id: 544349, name: "Kolhari" },
      { id: 544324, name: "Kopara" },
      { id: 544350, name: "Kosmet" },
      { id: 544281, name: "Kothari (Chikhali)" },
      { id: 544229, name: "Kothari Sindkhed" },
      { id: 544355, name: "Kupti Bk" },
      { id: 544356, name: "Kupti Kh" },
      { id: 544308, name: "Lingdhari" },
      { id: 544213, name: "Lingi" },
      { id: 544260, name: "Loni" },
      { id: 544282, name: "Madnapur (Chikhali)" },
      { id: 544378, name: "Malakjam" },
      { id: 544298, name: "Malakwadi" },
      { id: 544264, name: "Malborgaon" },
      { id: 544271, name: "Malkapur" },
      { id: 544342, name: "Malkolhari" },
      { id: 544280, name: "Mandva (Kinwat)" },
      { id: 544227, name: "Mandvi" },
      { id: 544360, name: "Mansing Naik Tanda" },
      { id: 912819, name: "Marakaguda" },
      { id: 544269, name: "Maregaon" },
      { id: 544268, name: "Maregaon (V)" },
      { id: 544375, name: "Marlaguda" },
      { id: 544248, name: "Minki" },
      { id: 544234, name: "Mohada Tanda" },
      { id: 544250, name: "Mohpur" },
      { id: 544334, name: "Mulzara" },
      { id: 544212, name: "Nagapur" },
      { id: 544279, name: "Nagzari" },
      { id: 544354, name: "Nandgaon" },
      { id: 544352, name: "Nandgaon Tanda" },
      { id: 544224, name: "Navargaon" },
      { id: 544252, name: "Nichpur" },
      { id: 544223, name: "Nirala" },
      { id: 544217, name: "Nirala Tanda" },
      { id: 544239, name: "Palshi" },
      { id: 544266, name: "Pandhara" },
      { id: 544377, name: "Pangar Pahad" },
      { id: 544332, name: "Pangri" },
      { id: 544207, name: "Parasram Naik Tanda" },
      { id: 544293, name: "Pardhansawangvi" },
      { id: 544198, name: "Pardi" },
      { id: 544303, name: "Pardi Bk." },
      { id: 544287, name: "Pardi Kh." },
      { id: 544321, name: "Paroti" },
      { id: 544320, name: "Paroti Tanda" },
      { id: 544196, name: "Pathari" },
      { id: 544232, name: "Patoda Bk." },
      { id: 544311, name: "Patoda Chikhali" },
      { id: 544286, name: "Penda" },
      { id: 544382, name: "Phulenagar" },
      { id: 544210, name: "Pimpal Shenda" },
      { id: 544275, name: "Pimpalgaon (Kinwat)" },
      { id: 544246, name: "Pimpalgaon (Sindkhed)" },
      { id: 544305, name: "Pimparphodi" },
      { id: 544323, name: "Pimpri" },
      { id: 544310, name: "Potreddi" },
      { id: 544262, name: "Rajgad" },
      { id: 544253, name: "Rajgad Tanda" },
      { id: 544241, name: "Ramji Naik Tanda" },
      { id: 544195, name: "Rampur" },
      { id: 544237, name: "Raypur Tanda" },
      { id: 544328, name: "Ritha" },
      { id: 544329, name: "Ritha Tanda" },
      { id: 544319, name: "Roda Naik Tanda" },
      { id: 544199, name: "Sakru Na.Tanda" },
      { id: 544221, name: "Salaiguda" },
      { id: 544351, name: "Sangvi" },
      { id: 544220, name: "Sarkhani" },
      { id: 544341, name: "Sawargaon" },
      { id: 544325, name: "Sawari" },
      { id: 544284, name: "Shaniwarpeth" },
      { id: 544348, name: "Shivni Chikhali" },
      { id: 544365, name: "Shivni Islampur" },
      { id: 544306, name: "Sindgi (Chikhali)" },
      { id: 544251, name: "Sindgi Kinvat" },
      { id: 544313, name: "Singarwadi" },
      { id: 544233, name: "Singoda" },
      { id: 544273, name: "Sirmeti" },
      { id: 544228, name: "Sirpur" },
      { id: 544361, name: "Sonwadi" },
      { id: 544340, name: "Sowargaon Tanda" },
      { id: 544315, name: "Sungaguda" },
      { id: 544249, name: "Talaiguda" },
      { id: 544364, name: "Tallari" },
      { id: 544236, name: "Tembhi" },
      { id: 544202, name: "Tembi Tanda" },
      { id: 544304, name: "Thara" },
      { id: 544214, name: "Titvi" },
      { id: 544358, name: "Totamba" },
      { id: 544215, name: "Umri" },
      { id: 544209, name: "Unakdeo" },
      { id: 544374, name: "Vyankatramnaik Tanda" },
      { id: 544254, name: "Wadoli" },
      { id: 544318, name: "Walki Bk" },
      { id: 544337, name: "Walki Kh." },
      { id: 544216, name: "Wazhara (Bk)" },
      { id: 544285, name: "Yenda" },
      { id: 544353, name: "Zalakwadi" },
      { id: 544277, name: "Zendiguda" },
    ],
    4097: [
      { id: 544413, name: "Andhegaon" },
      { id: 544442, name: "Baliram Tanda" },
      { id: 544443, name: "Bhondni Borgoan" },
      { id: 544395, name: "Borgadi" },
      { id: 544391, name: "Borgadi Tanda" },
      { id: 544427, name: "Borgaon (Tamsa)" },
      { id: 544385, name: "Budhali (Ja)" },
      { id: 544410, name: "Chinchordi" },
      { id: 544451, name: "Dabdari" },
      { id: 544456, name: "Daregaon" },
      { id: 544446, name: "Daresarsam" },
      { id: 544394, name: "Dhanora (J)" },
      { id: 544418, name: "Dighi" },
      { id: 544384, name: "Dolhari" },
      { id: 544444, name: "Dudhad" },
      { id: 544388, name: "Ekamba" },
      { id: 544414, name: "Ekdhari" },
      { id: 544420, name: "Gharapur" },
      { id: 544400, name: "Himayatnagar" },
      { id: 544430, name: "Jawalgaon" },
      { id: 544409, name: "Jirona" },
      { id: 544426, name: "Kamari" },
      { id: 544428, name: "Kamarwadi" },
      { id: 544439, name: "Kandli (Bk)" },
      { id: 544438, name: "Kandli (Kh)" },
      { id: 544433, name: "Karanji" },
      { id: 544401, name: "Karla (P)" },
      { id: 544389, name: "Kawtha (J)" },
      { id: 544422, name: "Khadki (Bazar)" },
      { id: 544429, name: "Khairagaon (Ta)" },
      { id: 544403, name: "Khairgaon (Jahagir)" },
      { id: 544424, name: "Kiramgaon" },
      { id: 544397, name: "Linga (Ja)" },
      { id: 544415, name: "Mahadapur" },
      { id: 544393, name: "Mangrul" },
      { id: 544440, name: "Moregaon" },
      { id: 544423, name: "Pahunmari" },
      { id: 544398, name: "Palaspur" },
      { id: 544411, name: "Pardi (J)" },
      { id: 544453, name: "Parwa (Bk)" },
      { id: 544435, name: "Parwa (Kh)" },
      { id: 544445, name: "Pawana" },
      { id: 544448, name: "Pawana Tanda" },
      { id: 544406, name: "Pichondi" },
      { id: 544416, name: "Pimpri" },
      { id: 544441, name: "Pota (Bk)" },
      { id: 544436, name: "Pota (Kh)" },
      { id: 544421, name: "Renapur" },
      { id: 544431, name: "Sarsam (Bk)" },
      { id: 544407, name: "Sawana (J)" },
      { id: 544402, name: "Shibadara (J)" },
      { id: 544387, name: "Siloda" },
      { id: 544396, name: "Siranjani" },
      { id: 544386, name: "Sirpalli" },
      { id: 544434, name: "Sonari" },
      { id: 544454, name: "Takarala (Bk)" },
      { id: 544412, name: "Tembhi" },
      { id: 544419, name: "Tembhurni" },
      { id: 544417, name: "Virsani" },
      { id: 544404, name: "Wadgaon (Ja)" },
      { id: 544452, name: "Wadgaon Kh" },
      { id: 544425, name: "Waghi" },
      { id: 544450, name: "Wai" },
      { id: 544449, name: "Wai Tanda" },
      { id: 544432, name: "Walkyachiwadi" },
      { id: 544392, name: "Warang Takli" },
      { id: 544447, name: "Wasi" },
      { id: 544437, name: "Watphali" },
    ],
    4098: [
      { id: 544480, name: "Ada" },
      { id: 544495, name: "Ambala" },
      { id: 544470, name: "Amgavhan" },
      { id: 946150, name: "Andhawadi" },
      { id: 544600, name: "Ashti" },
      { id: 544491, name: "Babhali" },
      { id: 544528, name: "Bamani" },
      { id: 544529, name: "Bamani Tanda" },
      { id: 544497, name: "Banchincholi" },
      { id: 544517, name: "Baradshewala" },
      { id: 544484, name: "Belgavhan (Hadgaon)" },
      { id: 544572, name: "Belgawhan (D)" },
      { id: 544489, name: "Belmandal" },
      { id: 544483, name: "Bhanegaon" },
      { id: 544493, name: "Bhanegaon Tanda" },
      { id: 544471, name: "Bhategaon" },
      { id: 544511, name: "Borgaon (Hastara)" },
      { id: 544591, name: "Bramhwadi" },
      { id: 544474, name: "Chakri" },
      { id: 544512, name: "Chendkapur" },
      { id: 544575, name: "Chikala" },
      { id: 544530, name: "Chinchgawhan" },
      { id: 544544, name: "Choramba Bk" },
      { id: 544539, name: "Choramba Kh." },
      { id: 544503, name: "Dagadwadi" },
      { id: 544582, name: "Dhakyachiwadi" },
      { id: 544479, name: "Dhanora (Hastara)" },
      { id: 544594, name: "Dhanora (Tamsa)" },
      { id: 544589, name: "Dhotra" },
      { id: 544576, name: "Digras" },
      { id: 544499, name: "Dongargaon" },
      { id: 544555, name: "Dorli" },
      { id: 544571, name: "Ekrala" },
      { id: 946151, name: "Ganeshnagar" },
      { id: 544523, name: "Gargavhan" },
      { id: 544610, name: "Gawatwadi" },
      { id: 544609, name: "Ghogri" },
      { id: 544485, name: "Gojegaon" },
      { id: 544488, name: "Gorlegaon" },
      { id: 544490, name: "Gurfali" },
      { id: 544492, name: "Hadgaon (Rural)" },
      { id: 544500, name: "Hadsani" },
      { id: 544504, name: "Hardaf" },
      { id: 544510, name: "Hastara" },
      { id: 544458, name: "Irapur" },
      { id: 544531, name: "Jagapur" },
      { id: 544537, name: "Jambhal Savali" },
      { id: 544569, name: "Jambhala" },
      { id: 544482, name: "Kaleshwar" },
      { id: 544562, name: "Kanjara (Bk)" },
      { id: 544563, name: "Kanjara (Kh)" },
      { id: 946166, name: "Kankewadi" },
      { id: 544533, name: "Karla (M)" },
      { id: 544526, name: "Karmodi" },
      { id: 544478, name: "Karodi" },
      { id: 544520, name: "Kawana" },
      { id: 544496, name: "Kawtha" },
      { id: 544525, name: "Kedarguda" },
      { id: 544573, name: "Khadki (D)" },
      { id: 544532, name: "Khamgawhan (D)" },
      { id: 544542, name: "Kharbi" },
      { id: 544519, name: "Kinala" },
      { id: 544468, name: "Kohali" },
      { id: 544597, name: "Kolgaon" },
      { id: 544473, name: "Koli" },
      { id: 544579, name: "Kondhur" },
      { id: 544598, name: "Kopra" },
      { id: 544487, name: "Kothala" },
      { id: 544570, name: "Krushnapur" },
      { id: 544540, name: "Kusalwadi" },
      { id: 544592, name: "Lingapur" },
      { id: 544587, name: "Loha" },
      { id: 544588, name: "Loha Tanda" },
      { id: 544502, name: "Lyahari" },
      { id: 544475, name: "Mahatala" },
      { id: 544580, name: "Malegaon" },
      { id: 544534, name: "Malzara" },
      { id: 544535, name: "Manatha" },
      { id: 544586, name: "Mandva" },
      { id: 946152, name: "Mansingnaiktanda" },
      { id: 544464, name: "Manula (Bk)" },
      { id: 544461, name: "Manula (Kh)" },
      { id: 544506, name: "Mardga" },
      { id: 544513, name: "Marlegaon" },
      { id: 544465, name: "Matala" },
      { id: 544558, name: "Morgavhan" },
      { id: 544559, name: "Navha" },
      { id: 544508, name: "Nevri" },
      { id: 544507, name: "Newarwadi" },
      { id: 544522, name: "Nimtok" },
      { id: 544476, name: "Niwgha" },
      { id: 544505, name: "Niwla" },
      { id: 946153, name: "Palaswadi" },
      { id: 544518, name: "Palsa" },
      { id: 544462, name: "Pangra ( D)" },
      { id: 544521, name: "Pangri(Manatha)" },
      { id: 544565, name: "Pangri(Tamsa)" },
      { id: 544561, name: "Patharad" },
      { id: 544466, name: "Peva" },
      { id: 544501, name: "Phali" },
      { id: 544606, name: "Pimpalgaon" },
      { id: 544516, name: "Pimparkhed" },
      { id: 544577, name: "Pimprala" },
      { id: 544524, name: "Pingli" },
      { id: 544607, name: "Rajwadi" },
      { id: 946148, name: "Ramunaiktanda" },
      { id: 544566, name: "Rawangaon (Manatha)" },
      { id: 544590, name: "Rawangaon (Tamasa)" },
      { id: 544494, name: "Rui" },
      { id: 544463, name: "Sapti" },
      { id: 544545, name: "Sawargaon" },
      { id: 544581, name: "Shendan" },
      { id: 946147, name: "Shetmajurwadi" },
      { id: 544527, name: "Shibdara" },
      { id: 544457, name: "Shioor" },
      { id: 544467, name: "Shirad" },
      { id: 544596, name: "Shivani" },
      { id: 544574, name: "Shivpuri" },
      { id: 544556, name: "Takalgaon" },
      { id: 544593, name: "Takarala" },
      { id: 544514, name: "Talang" },
      { id: 544557, name: "Talegaon" },
      { id: 544469, name: "Talni" },
      { id: 544608, name: "Talyachiwadi" },
      { id: 544564, name: "Tamsa" },
      { id: 544538, name: "Taroda" },
      { id: 544554, name: "Umri (Daryabai)" },
      { id: 544601, name: "Umri (Ja)" },
      { id: 544472, name: "Umri Kh" },
      { id: 544515, name: "Unchada" },
      { id: 544459, name: "Unchegaon (Bk)" },
      { id: 544481, name: "Unchegaon(Kh)" },
      { id: 544560, name: "Wadgaon Bk" },
      { id: 544602, name: "Waiphana Bk." },
      { id: 544603, name: "Waiphana Kh." },
      { id: 544460, name: "Waki" },
      { id: 544486, name: "Wakoda" },
      { id: 544599, name: "Walki Bk" },
      { id: 544595, name: "Walki(Kh)" },
      { id: 544509, name: "Warula" },
      { id: 544536, name: "Warwat" },
      { id: 544498, name: "Wategaon" },
      { id: 544477, name: "Yelamb" },
      { id: 544604, name: "Yewli" },
    ],
    4099: [
      { id: 544648, name: "Ahmadpur (D)" },
      { id: 544651, name: "Amarabad Tanda (N.V.)" },
      { id: 544642, name: "Ambegaon" },
      { id: 544656, name: "Amrabad" },
      { id: 544657, name: "Amrapur" },
      { id: 544645, name: "Ardhapur" },
      { id: 544665, name: "Babapur" },
      { id: 544629, name: "Bamni" },
      { id: 544661, name: "Barasgaon" },
      { id: 544654, name: "Belsar" },
      { id: 544614, name: "Bhogaon" },
      { id: 544552, name: "Chabhara" },
      { id: 544551, name: "Chabhara (Tanda)" },
      { id: 544640, name: "Chenapur" },
      { id: 946163, name: "Chenapurtanda" },
      { id: 544646, name: "Chinchban" },
      { id: 544546, name: "Choramba (Nanded)" },
      { id: 544659, name: "Dabhad" },
      { id: 544620, name: "Daur" },
      { id: 544619, name: "Degaon (Kurhada)" },
      { id: 544666, name: "Degaon Bk." },
      { id: 544615, name: "Delub Bk." },
      { id: 544613, name: "Delub Kh." },
      { id: 544541, name: "Deshmukhwadi" },
      { id: 544611, name: "Dhamdari" },
      { id: 544635, name: "Digras" },
      { id: 544622, name: "Ganpur" },
      { id: 544652, name: "Hamrapur" },
      { id: 544623, name: "Isampur" },
      { id: 544658, name: "Jambhrun" },
      { id: 544660, name: "Kaladgaon" },
      { id: 544621, name: "Kamtha Bk." },
      { id: 544637, name: "Karwadi" },
      { id: 544625, name: "Khadki" },
      { id: 544548, name: "Khairgaon (M)" },
      { id: 544663, name: "Khairgaon Bk." },
      { id: 544662, name: "Khairgaon Kh." },
      { id: 544616, name: "Kondha" },
      { id: 544639, name: "Lahan" },
      { id: 944220, name: "Lahan Tanda" },
      { id: 544649, name: "Latifpur (D)" },
      { id: 544644, name: "Loni Bk." },
      { id: 544643, name: "Loni Kh." },
      { id: 544618, name: "Malegaon" },
      { id: 544626, name: "Mendhala Bk." },
      { id: 544627, name: "Mendhala Kh." },
      { id: 544655, name: "Mugatwadi (D)" },
      { id: 544634, name: "Nandla Makta" },
      { id: 544630, name: "Nijampur" },
      { id: 544553, name: "Nilkanthwadi (D)" },
      { id: 544547, name: "Nimgaon" },
      { id: 544638, name: "Pangri Tarf Karwadi" },
      { id: 544636, name: "Pardi Makta" },
      { id: 544641, name: "Patnur" },
      { id: 544633, name: "Pimpalgaon (M)" },
      { id: 544650, name: "Rahimpur Tarf Jambhrun" },
      { id: 544549, name: "Rodgi" },
      { id: 544624, name: "Sanghavi Kh." },
      { id: 544617, name: "Sawargaon" },
      { id: 544543, name: "Sayalwadi" },
      { id: 544653, name: "Shahapur" },
      { id: 544632, name: "Shelgaon Bk." },
      { id: 544631, name: "Shelgaon Kh." },
      { id: 544647, name: "Sheni." },
      { id: 544550, name: "Sonala" },
      { id: 544612, name: "Umari." },
      { id: 544628, name: "Wahedpur" },
      { id: 544664, name: "Yelegaon" },
    ],
    4100: [
      { id: 544667, name: "Alegaon" },
      { id: 943119, name: "Asadullabad" },
      { id: 943120, name: "Asadwan" },
      { id: 943118, name: "Asarjan" },
      { id: 544740, name: "Babhulgaon" },
      { id: 544754, name: "Balirampur" },
      { id: 544674, name: "Bhalki" },
      { id: 544748, name: "Bhanagi" },
      { id: 544690, name: "Bhanpur" },
      { id: 544734, name: "Bhayegaon" },
      { id: 544717, name: "Bondhar Tarf Haveli" },
      { id: 544706, name: "Bondhar Tarf Nerli" },
      { id: 544701, name: "Borgaon Telang" },
      { id: 544720, name: "Brahmanwada" },
      { id: 943127, name: "Bramhapuri" },
      { id: 544676, name: "Chikhali Bk." },
      { id: 544704, name: "Chikhali Kh." },
      { id: 544705, name: "Chimegaon" },
      { id: 544691, name: "Daryapur" },
      { id: 544753, name: "Dhanegaon" },
      { id: 544744, name: "Dhangarwadi" },
      { id: 544686, name: "Dhanora" },
      { id: 544695, name: "Dhoki" },
      { id: 544668, name: "Ekdara" },
      { id: 544725, name: "Elechpur" },
      { id: 943126, name: "Fatehjangpur" },
      { id: 544726, name: "Fattepur" },
      { id: 544716, name: "Gadegaon" },
      { id: 544751, name: "Gangabet" },
      { id: 544739, name: "Gopalchavdi" },
      { id: 544741, name: "Gundegaon" },
      { id: 544675, name: "Hadidadpur" },
      { id: 544711, name: "Hassapur" },
      { id: 544724, name: "Injegaon" },
      { id: 544697, name: "Jaitapur" },
      { id: 943122, name: "Jangamwadi" },
      { id: 544737, name: "Kakandi" },
      { id: 544673, name: "Kakandi Tarf Pasadgaon" },
      { id: 544746, name: "Kalhal" },
      { id: 544712, name: "Kamtha Kh." },
      { id: 544669, name: "Kasarkheda" },
      { id: 544683, name: "Khadki" },
      { id: 544714, name: "Khadkut" },
      { id: 544743, name: "Khupsarwadi" },
      { id: 544671, name: "Khurgaon" },
      { id: 544735, name: "Kikki" },
      { id: 544703, name: "Kottirth" },
      { id: 943121, name: "Koutha" },
      { id: 544685, name: "Limbgaon" },
      { id: 544747, name: "Markand" },
      { id: 544680, name: "Marlak Bk." },
      { id: 544681, name: "Marlak Kh." },
      { id: 943128, name: "Mhalja" },
      { id: 544738, name: "Mujampeth" },
      { id: 544721, name: "Nagapur" },
      { id: 544696, name: "Naleshwar" },
      { id: 943125, name: "Nanded" },
      { id: 544670, name: "Nandusa" },
      { id: 544710, name: "Nasaratpur" },
      { id: 544707, name: "Nerli" },
      { id: 544677, name: "Nila" },
      { id: 544742, name: "Pangri" },
      { id: 544672, name: "Pasadgaon" },
      { id: 544733, name: "Pimpalgaon (Mistri)" },
      { id: 544700, name: "Pimpalgaon Korka" },
      { id: 544749, name: "Pimpalgaon Nimji" },
      { id: 544678, name: "Pimpri Mahipal" },
      { id: 544687, name: "Pokharni" },
      { id: 544729, name: "Punegaon" },
      { id: 544708, name: "Puyni" },
      { id: 544699, name: "Rahati Bk." },
      { id: 544736, name: "Rahegaon" },
      { id: 943140, name: "Rahimpur Kh." },
      { id: 943144, name: "Sangvi" },
      { id: 544722, name: "Sattarpur" },
      { id: 544682, name: "Sayal" },
      { id: 544728, name: "Siddhanath" },
      { id: 544698, name: "Someshwar" },
      { id: 544693, name: "Sugaon Bk." },
      { id: 544692, name: "Sugaon Kh." },
      { id: 544684, name: "Talni" },
      { id: 943124, name: "Taroda Bu" },
      { id: 943123, name: "Taroda Khurd" },
      { id: 544702, name: "Thugaon" },
      { id: 544719, name: "Trikut" },
      { id: 544732, name: "Tuppa" },
      { id: 943142, name: "Vasarni" },
      { id: 544745, name: "Vishnupuri" },
      { id: 544731, name: "Wadgaon" },
      { id: 544709, name: "Wadi Bk." },
      { id: 544713, name: "Wadi Emshet" },
      { id: 544718, name: "Wadi Janji" },
      { id: 544727, name: "Wadi Kardel" },
      { id: 544730, name: "Wadi Puyad" },
      { id: 544715, name: "Wadi Wagji" },
      { id: 544679, name: "Wadwana" },
      { id: 943143, name: "Waghala" },
      { id: 544694, name: "Waghi" },
      { id: 946146, name: "Waghitanda" },
      { id: 544750, name: "Wahegaon" },
      { id: 544752, name: "Wajegaon" },
      { id: 943141, name: "Wajirabad" },
      { id: 544689, name: "Wanegaon" },
      { id: 544723, name: "Wangi" },
      { id: 544688, name: "Warkhed" },
    ],
    4101: [
      { id: 544787, name: "Amdura" },
      { id: 544765, name: "Amrapur (Dudhanwadi)" },
      { id: 544755, name: "Barad" },
      { id: 544766, name: "Borgaon Nandri" },
      { id: 544760, name: "Borgaonsita" },
      { id: 544789, name: "Chikala" },
      { id: 544790, name: "Chikala Tanda" },
      { id: 912820, name: "Chikala Tanda Lahan" },
      { id: 544803, name: "Chilpimpri" },
      { id: 544806, name: "Daregaon" },
      { id: 946164, name: "Daregaontanda" },
      { id: 544807, name: "Daregaonwadi" },
      { id: 544799, name: "Devapur" },
      { id: 544772, name: "Dhanaj" },
      { id: 544782, name: "Dongaon" },
      { id: 544764, name: "Dongargaon" },
      { id: 544783, name: "Hajapur" },
      { id: 544770, name: "Hissa Pathrad" },
      { id: 544785, name: "Ijali" },
      { id: 544774, name: "Jawala Murhar" },
      { id: 544767, name: "Jawala Pathak" },
      { id: 544800, name: "Kamlaj" },
      { id: 544776, name: "Khambala" },
      { id: 544805, name: "Khujda" },
      { id: 544781, name: "Kolha" },
      { id: 544802, name: "Mahati" },
      { id: 544801, name: "Malkautha" },
      { id: 544778, name: "Mendka" },
      { id: 943150, name: "Mudkhed" },
      { id: 544786, name: "Mugat" },
      { id: 544756, name: "Nageli" },
      { id: 544775, name: "Niwgha" },
      { id: 943149, name: "Nyahali" },
      { id: 544758, name: "Padharwadi" },
      { id: 544792, name: "Pangargaon." },
      { id: 544761, name: "Pardi (Vaijapur)" },
      { id: 544771, name: "Pathrad" },
      { id: 544793, name: "Pimpalkautha (Chau)" },
      { id: 544777, name: "Pimpalkoutha Magre" },
      { id: 544762, name: "Rajwadi" },
      { id: 544794, name: "Rohi Pimpalgaon Tanda" },
      { id: 544795, name: "Rohi Pimpalgoan" },
      { id: 544773, name: "Saregaon" },
      { id: 544798, name: "Shankhtirth" },
      { id: 544759, name: "Shemboli" },
      { id: 544804, name: "Takli" },
      { id: 544769, name: "Tarbujapur" },
      { id: 544757, name: "Tirkaswadi" },
      { id: 544763, name: "Vaijapur (Pardi)" },
      { id: 946172, name: "Vasantwadi" },
      { id: 544768, name: "Wadi Kamali" },
      { id: 544788, name: "Wadi Muktaji" },
      { id: 544784, name: "Wadi Muktiyarpur" },
      { id: 544796, name: "Wadi Niyamtullapur" },
      { id: 544780, name: "Wai" },
      { id: 544779, name: "Wardada" },
      { id: 544797, name: "Wasri" },
    ],
    4102: [
      { id: 946173, name: "Aamdaritanda" },
      { id: 544811, name: "Amdari" },
      { id: 544812, name: "Amdariwadi" },
      { id: 544845, name: "Amthana" },
      { id: 946174, name: "Babanwadi" },
      { id: 544881, name: "Ballal" },
      { id: 544830, name: "Battala" },
      { id: 544836, name: "Bembar" },
      { id: 544880, name: "Bendri" },
      { id: 912935, name: "Bhokar" },
      { id: 544809, name: "Bhosi." },
      { id: 544844, name: "Bhurbhushi" },
      { id: 544817, name: "Borgaon" },
      { id: 544821, name: "Borwadi" },
      { id: 544831, name: "Chinchala P.B." },
      { id: 544824, name: "Chitagiri" },
      { id: 544871, name: "Daur" },
      { id: 544857, name: "Devthana." },
      { id: 544819, name: "Dhanora" },
      { id: 544883, name: "Dharjani" },
      { id: 544815, name: "Dhawari Bk" },
      { id: 544814, name: "Dhawari Kh" },
      { id: 544874, name: "Divashi Kh." },
      { id: 946175, name: "Divashi Khu. Tanda" },
      { id: 544853, name: "Diwashi Bk." },
      { id: 544838, name: "Dorli" },
      { id: 544884, name: "Elegaon" },
      { id: 544825, name: "Gargotwadi" },
      { id: 544862, name: "Gargotwadi (Pandurana)" },
      { id: 544888, name: "Hadoli." },
      { id: 544886, name: "Halda" },
      { id: 544835, name: "Hassapur" },
      { id: 544834, name: "Jakapur" },
      { id: 544837, name: "Jambhali" },
      { id: 544868, name: "Jamdari" },
      { id: 544867, name: "Jamdari Tanda" },
      { id: 544889, name: "Kamangaon" },
      { id: 544864, name: "Kandli" },
      { id: 544879, name: "Khadki" },
      { id: 544808, name: "Kharbi" },
      { id: 544829, name: "Kinala" },
      { id: 544854, name: "Kini" },
      { id: 544863, name: "Kolgaon Bk." },
      { id: 544860, name: "Kolgaon Kh." },
      { id: 943147, name: "Konddevnagar" },
      { id: 544875, name: "Laglud" },
      { id: 544887, name: "Lamkani" },
      { id: 544852, name: "Mahagaon" },
      { id: 544843, name: "Maldari" },
      { id: 544842, name: "Maslaga" },
      { id: 544873, name: "Matul" },
      { id: 544851, name: "Mhalsapur (D)" },
      { id: 544885, name: "Moghali" },
      { id: 544847, name: "Mokhandi" },
      { id: 544833, name: "Nagapur" },
      { id: 544882, name: "Nanda Bk." },
      { id: 544861, name: "Nanda Kh." },
      { id: 544877, name: "Nanda P. Mhaisa" },
      { id: 544820, name: "Narvat" },
      { id: 544846, name: "Naslapur" },
      { id: 544848, name: "Nekli" },
      { id: 544855, name: "Paki" },
      { id: 544850, name: "Palaj" },
      { id: 544826, name: "Pandurna" },
      { id: 544872, name: "Pimpaldhav" },
      { id: 544832, name: "Pomnala" },
      { id: 544878, name: "Rahati Bk." },
      { id: 544869, name: "Raikhod" },
      { id: 544849, name: "Ralaj (D)" },
      { id: 946182, name: "Ramunaiktanda" },
      { id: 544876, name: "Rawangaon" },
      { id: 544859, name: "Renapur." },
      { id: 544828, name: "Rittha" },
      { id: 544827, name: "Samandarwadi" },
      { id: 544858, name: "Savargaon (Mal)" },
      { id: 946185, name: "Savargaonmettanda" },
      { id: 544865, name: "Sawargaon Met" },
      { id: 544870, name: "Sayal" },
      { id: 946187, name: "Shivanagartanda" },
      { id: 943148, name: "Siddharthnagarwadi" },
      { id: 946197, name: "Sitaramnaiktanda" },
      { id: 544840, name: "Somthana Patti Bhokar" },
      { id: 544866, name: "Sonari" },
      { id: 544823, name: "Tatkalwadi" },
      { id: 544816, name: "Therban" },
      { id: 544810, name: "Wakad" },
      { id: 946203, name: "Zingarwadi" },
    ],
    4103: [
      { id: 544906, name: "Abdulapur" },
      { id: 544938, name: "Amdapur" },
      { id: 544897, name: "Aswaldari" },
      { id: 544942, name: "Balegaon" },
      { id: 544936, name: "Beldara" },
      { id: 544902, name: "Bhayegaon" },
      { id: 544946, name: "Bijegaon" },
      { id: 544913, name: "Bitnal" },
      { id: 544904, name: "Bolsa (Gangapatti)" },
      { id: 544931, name: "Bolsa Bk" },
      { id: 544930, name: "Bolsa Kh" },
      { id: 544948, name: "Borjuni" },
      { id: 544911, name: "Bothi" },
      { id: 544934, name: "Chinchala Patti Umri" },
      { id: 544929, name: "Dhanora Bk." },
      { id: 544892, name: "Dholumri" },
      { id: 544939, name: "Dilawarpur" },
      { id: 544945, name: "Endala" },
      { id: 544922, name: "Ganipur" },
      { id: 544950, name: "Golegaon" },
      { id: 544919, name: "Gortha" },
      { id: 544900, name: "Hangiraga" },
      { id: 544952, name: "Hassa" },
      { id: 544944, name: "Hatni" },
      { id: 544923, name: "Hiradgaon" },
      { id: 544899, name: "Hunda (Patti Ganga)" },
      { id: 544928, name: "Hunda Patti Umari" },
      { id: 544927, name: "Hunda Tanda" },
      { id: 544941, name: "Ijjatgaon" },
      { id: 544901, name: "Ilegaon P. G." },
      { id: 544918, name: "Jamgaon" },
      { id: 544914, name: "Jirona" },
      { id: 544895, name: "Kalgaon" },
      { id: 544949, name: "Karkala" },
      { id: 544894, name: "Karla" },
      { id: 544947, name: "Kaudgaon" },
      { id: 544954, name: "Kawalguda Bk." },
      { id: 544955, name: "Kawalguda Kh." },
      { id: 544905, name: "Kudla" },
      { id: 544943, name: "Mahati" },
      { id: 544925, name: "Mandala" },
      { id: 544940, name: "Manur" },
      { id: 544937, name: "Miyadadpur" },
      { id: 544909, name: "Mokhandi (Jagir)" },
      { id: 544935, name: "Nagthana Bk." },
      { id: 544933, name: "Nagthana Kh." },
      { id: 544932, name: "Nimtek" },
      { id: 544893, name: "Palasgaon" },
      { id: 544903, name: "Rahati Kh." },
      { id: 544926, name: "Ramkhadak" },
      { id: 544896, name: "Sawargaon (Dakshin)" },
      { id: 544912, name: "Sawargaon (Kala)" },
      { id: 544898, name: "Shelgaon" },
      { id: 544953, name: "Shingnapur" },
      { id: 544908, name: "Shirur" },
      { id: 544891, name: "Shivangaon" },
      { id: 544890, name: "Sindhi" },
      { id: 544921, name: "Somthana P.U." },
      { id: 544907, name: "Talegaon" },
      { id: 544910, name: "Turati" },
      { id: 943111, name: "Umri" },
      { id: 544924, name: "Waghala" },
      { id: 544951, name: "Waghalwada" },
    ],
    4104: [
      { id: 544997, name: "Aloor" },
      { id: 544975, name: "Atala" },
      { id: 544983, name: "Atkur" },
      { id: 544990, name: "Babhali (D)" },
      { id: 544962, name: "Babhulgaon." },
      { id: 544956, name: "Bachegaon" },
      { id: 943116, name: "Balapur" },
      { id: 545007, name: "Bamni" },
      { id: 544981, name: "Bannali" },
      { id: 544971, name: "Belgujari" },
      { id: 544996, name: "Belur Bk." },
      { id: 544994, name: "Belur Kh." },
      { id: 545006, name: "Chenapur (D)" },
      { id: 544969, name: "Chikna" },
      { id: 544995, name: "Chincholi" },
      { id: 544976, name: "Cholakha" },
      { id: 544977, name: "Chondi" },
      { id: 544968, name: "Dhanora Kh." },
      { id: 544979, name: "Digras" },
      { id: 544967, name: "Elegaon" },
      { id: 544982, name: "Gurjawala" },
      { id: 544972, name: "Haregaon" },
      { id: 544960, name: "Hasnali" },
      { id: 544992, name: "Jaflapur" },
      { id: 544978, name: "Jarikot" },
      { id: 544959, name: "Junni" },
      { id: 544973, name: "Karegaon" },
      { id: 544964, name: "Karkheli" },
      { id: 544985, name: "Mangnali" },
      { id: 545008, name: "Manur" },
      { id: 545004, name: "Mashti" },
      { id: 545002, name: "Mokali" },
      { id: 544963, name: "Mutnyal (D)" },
      { id: 544993, name: "Naigaon (D)" },
      { id: 544998, name: "Nerli" },
      { id: 544958, name: "Pangri" },
      { id: 544987, name: "Patoda Bk." },
      { id: 544989, name: "Patoda Kh." },
      { id: 545005, name: "Patoda Thadi" },
      { id: 544966, name: "Pimpalgaon" },
      { id: 544957, name: "Rajapur" },
      { id: 544991, name: "Rameshwar" },
      { id: 545000, name: "Rampur" },
      { id: 943117, name: "Ratnali" },
      { id: 544988, name: "Roshangaon" },
      { id: 544970, name: "Saikhed" },
      { id: 544965, name: "Salegaon (D)" },
      { id: 544984, name: "Samrala" },
      { id: 545009, name: "Sangam" },
      { id: 544986, name: "Sharifabad (D)" },
      { id: 545003, name: "Shelgaon Thadi" },
      { id: 544999, name: "Sirajkhed" },
      { id: 545001, name: "Vilegaon Thadi (Bk)" },
      { id: 544974, name: "Yellapur" },
      { id: 544961, name: "Yeoti" },
      { id: 544980, name: "Yetala" },
    ],
    4105: [
      { id: 545096, name: "Adampur" },
      { id: 545033, name: "Ainapur (D)" },
      { id: 545088, name: "Ajani" },
      { id: 545093, name: "Alandi" },
      { id: 545019, name: "Arali" },
      { id: 545036, name: "Arjapur" },
      { id: 545094, name: "Atkali" },
      { id: 545044, name: "Azizabad (D)" },
      { id: 545055, name: "Babhali (A)" },
      { id: 545053, name: "Badoor" },
      { id: 545087, name: "Bamni Bk." },
      { id: 545057, name: "Bawalgaon" },
      { id: 545027, name: "Belkoni Bk" },
      { id: 545020, name: "Belkoni Kh." },
      { id: 545028, name: "Bhosi" },
      { id: 545084, name: "Bijur" },
      { id: 943146, name: "Billoli" },
      { id: 545063, name: "Bolegaon" },
      { id: 545092, name: "Borgaon Thadi" },
      { id: 545051, name: "Chinchala" },
      { id: 545038, name: "Chirali" },
      { id: 545091, name: "Chitmogra" },
      { id: 545029, name: "Dagdapur" },
      { id: 545066, name: "Daryapur" },
      { id: 545049, name: "Daulapur" },
      { id: 545072, name: "Daulatapur" },
      { id: 545025, name: "Devapur (D)" },
      { id: 545082, name: "Dongaon Bk." },
      { id: 545085, name: "Dongaon Kh" },
      { id: 545032, name: "Dour" },
      { id: 545010, name: "Dugaon" },
      { id: 545021, name: "Gaglegaon" },
      { id: 545098, name: "Galegaon" },
      { id: 545059, name: "Ganjgaon" },
      { id: 545017, name: "Gujari" },
      { id: 545041, name: "Hajjapur" },
      { id: 545012, name: "Harnala" },
      { id: 545047, name: "Harnali" },
      { id: 545065, name: "Hingani" },
      { id: 545077, name: "Hipparga Maal" },
      { id: 545071, name: "Hipparga Thadi" },
      { id: 545045, name: "Hungunda" },
      { id: 545069, name: "Jalalapur (D)" },
      { id: 545079, name: "Jigla" },
      { id: 545090, name: "Kamraspalli" },
      { id: 545016, name: "Kangathi" },
      { id: 545043, name: "Karhal" },
      { id: 545061, name: "Karla Bk." },
      { id: 545056, name: "Karla Kh." },
      { id: 545026, name: "Kasrali" },
      { id: 545018, name: "Kautha" },
      { id: 545089, name: "Kerur" },
      { id: 545074, name: "Kesrali" },
      { id: 545014, name: "Khaprala" },
      { id: 545075, name: "Khatgaon" },
      { id: 545078, name: "Kinhala" },
      { id: 545013, name: "Kolgaon" },
      { id: 545022, name: "Kolheborgaon" },
      { id: 545034, name: "Kondalapur" },
      { id: 545058, name: "Kotgyal" },
      { id: 545015, name: "Kumbhargaon" },
      { id: 943145, name: "Kundalwadi" },
      { id: 545054, name: "Laghul" },
      { id: 545030, name: "Lingapur" },
      { id: 545076, name: "Lohgaon" },
      { id: 545050, name: "Machnur" },
      { id: 545048, name: "Malkapur (D)" },
      { id: 545042, name: "Mamdapur" },
      { id: 545068, name: "Minki" },
      { id: 545024, name: "Mukhed" },
      { id: 545067, name: "Mutnyal" },
      { id: 545046, name: "Nagani" },
      { id: 545035, name: "Nagyapur" },
      { id: 545081, name: "Pachpimpali" },
      { id: 545040, name: "Pimpalgaon (Ku)" },
      { id: 545052, name: "Pokharni" },
      { id: 944223, name: "Pokharni Khu" },
      { id: 545023, name: "Rampur (M)" },
      { id: 545073, name: "Rampur Thadi" },
      { id: 545083, name: "Ramtirth" },
      { id: 545086, name: "Rudrapur" },
      { id: 545064, name: "Sagroli" },
      { id: 545031, name: "Sawali" },
      { id: 545070, name: "Shimpala" },
      { id: 545037, name: "Sultanpur" },
      { id: 545095, name: "Takli Kh" },
      { id: 545039, name: "Takli Thadi" },
      { id: 545080, name: "Talni" },
      { id: 545097, name: "Thadisawali" },
      { id: 545011, name: "Torna" },
      { id: 545060, name: "Vaijiyabad" },
      { id: 545062, name: "Yesgi" },
    ],
    4106: [
      { id: 545181, name: "Aluwadgaon" },
      { id: 545167, name: "Ancholi" },
      { id: 545104, name: "Antargaon" },
      { id: 545138, name: "Awrala" },
      { id: 545118, name: "Babulgaon" },
      { id: 545109, name: "Balegaon" },
      { id: 545103, name: "Barbada" },
      { id: 545154, name: "Bendri" },
      { id: 545150, name: "Betak Biloli" },
      { id: 545163, name: "Bhopala" },
      { id: 545134, name: "Charwadi" },
      { id: 545170, name: "Daregaon" },
      { id: 545148, name: "Degaon" },
      { id: 545127, name: "Dhanaj" },
      { id: 545189, name: "Dhanora T.M." },
      { id: 545162, name: "Dhuppa" },
      { id: 545130, name: "Dongargaon" },
      { id: 545176, name: "Gadga" },
      { id: 545121, name: "Ghungrala" },
      { id: 545168, name: "Godamgaon" },
      { id: 545155, name: "Golegaon" },
      { id: 545137, name: "Hangraga" },
      { id: 545119, name: "Hiparga (Janerao)" },
      { id: 545160, name: "Hotala" },
      { id: 545128, name: "Hussa" },
      { id: 545108, name: "Ijjatgaon (M)" },
      { id: 545106, name: "Ijjatgaon Bk" },
      { id: 545124, name: "Ikalimal" },
      { id: 545140, name: "Iklimore" },
      { id: 545115, name: "Kahala Bk." },
      { id: 545114, name: "Kahala Kh" },
      { id: 545179, name: "Kandala" },
      { id: 545183, name: "Karla T.M." },
      { id: 545174, name: "Kedar Wadgaon" },
      { id: 545158, name: "Khairgaon" },
      { id: 545156, name: "Khandgaon" },
      { id: 545135, name: "Kokalegaon" },
      { id: 545169, name: "Kolambi" },
      { id: 545177, name: "Kopra" },
      { id: 545139, name: "Kouthala" },
      { id: 545161, name: "Kuncholi" },
      { id: 545133, name: "Kuntoor" },
      { id: 545113, name: "Kushanoor" },
      { id: 545153, name: "Lalwandi" },
      { id: 545184, name: "Mahegaon" },
      { id: 545101, name: "Mamnyal" },
      { id: 545116, name: "Mandni" },
      { id: 545171, name: "Manjram" },
      { id: 545105, name: "Manur Tarf Ba" },
      { id: 545180, name: "Marwali" },
      { id: 545178, name: "Marwali Tanda" },
      { id: 545126, name: "Melgaon" },
      { id: 545172, name: "Mokasdara" },
      { id: 545187, name: "Mugaon" },
      { id: 545142, name: "Mustapur" },
      { id: 545151, name: "Naigaon" },
      { id: 545152, name: "Naigaonwadi" },
      { id: 545166, name: "Narangal" },
      { id: 545159, name: "Narsi" },
      { id: 545175, name: "Nawandi" },
      { id: 545120, name: "Nilegavhan" },
      { id: 545147, name: "Palasgaon" },
      { id: 545132, name: "Paradwadi" },
      { id: 545102, name: "Patoda (T.B.)" },
      { id: 545157, name: "Pimpalgaon" },
      { id: 545129, name: "Raher" },
      { id: 545136, name: "Rajgadnagar" },
      { id: 545143, name: "Ransugaon" },
      { id: 545185, name: "Ratoli" },
      { id: 545111, name: "Rui Bk" },
      { id: 545110, name: "Rui Kh" },
      { id: 545107, name: "Sadakpur" },
      { id: 545131, name: "Salegaon" },
      { id: 545125, name: "Sangvi" },
      { id: 545123, name: "Sategaon" },
      { id: 545112, name: "Sawarkhed" },
      { id: 545164, name: "Shelgaon (Gauri)" },
      { id: 545149, name: "Shelgaon Chatri" },
      { id: 545117, name: "Somthana" },
      { id: 545141, name: "Sujlegaon" },
      { id: 545146, name: "Takalgaon" },
      { id: 545145, name: "Takbid" },
      { id: 545165, name: "Takli Bk." },
      { id: 545099, name: "Takli(T.B.)" },
      { id: 545186, name: "Takli(T.M.)" },
      { id: 545144, name: "Talbid" },
      { id: 545182, name: "Tembhurni" },
      { id: 545122, name: "Vanjarwadi" },
      { id: 545100, name: "Vanzirgaon" },
    ],
    4107: [
      { id: 545272, name: "Adgaon" },
      { id: 545213, name: "Ambesangvi" },
      { id: 545312, name: "Andga" },
      { id: 545268, name: "Anteshwar" },
      { id: 545294, name: "Ashtur" },
      { id: 545193, name: "Bamni P.U." },
      { id: 545284, name: "Berali Kh." },
      { id: 545190, name: "Bet Sangvi" },
      { id: 545206, name: "Bhadra" },
      { id: 946157, name: "Bhamlanaiktanda" },
      { id: 545269, name: "Bharaswada" },
      { id: 545201, name: "Bhendegaon" },
      { id: 545271, name: "Borgaon Aknak" },
      { id: 545221, name: "Borgaon Kiwala" },
      { id: 545199, name: "Borgaon Kolha" },
      { id: 545244, name: "Chincholi P.U." },
      { id: 545279, name: "Chitali" },
      { id: 545306, name: "Chondi" },
      { id: 545308, name: "Dagad Sangvi" },
      { id: 545192, name: "Dagadgaon" },
      { id: 545227, name: "Dapshed" },
      { id: 545290, name: "Deola Tanda" },
      { id: 545195, name: "Derla" },
      { id: 545282, name: "Deulgaon" },
      { id: 545219, name: "Dhakni" },
      { id: 545265, name: "Dhanaj Bk." },
      { id: 545266, name: "Dhanaj Kh." },
      { id: 946158, name: "Dhanjitanda" },
      { id: 545275, name: "Dhanora (Makta)" },
      { id: 545234, name: "Dhanora Shelgaon" },
      { id: 545231, name: "Dhavri" },
      { id: 545258, name: "Dolara" },
      { id: 545310, name: "Dongargaon" },
      { id: 545249, name: "Donwada" },
      { id: 545313, name: "Gaundgaon" },
      { id: 545314, name: "Ghotka" },
      { id: 545299, name: "Ghugewadi" },
      { id: 545288, name: "Golegaon P.K." },
      { id: 545262, name: "Golegaon P.U." },
      { id: 946156, name: "Golegaonwadi" },
      { id: 946194, name: "Gondhanitanda" },
      { id: 946209, name: "Govindtanda" },
      { id: 545224, name: "Gundewadi" },
      { id: 545287, name: "Hadoli Jagir" },
      { id: 545278, name: "Haldav" },
      { id: 545298, name: "Haranwadi" },
      { id: 545217, name: "Harbal P.U." },
      { id: 946192, name: "Harishchandratanda" },
      { id: 545214, name: "Harsad" },
      { id: 545248, name: "Hatni" },
      { id: 545259, name: "Hindola" },
      { id: 545281, name: "Hipparga (Chitali)" },
      { id: 545302, name: "Hirabori Tanda" },
      { id: 545211, name: "Hottalwadi" },
      { id: 946159, name: "Hulayewadi" },
      { id: 545240, name: "Jamrun" },
      { id: 545197, name: "Janapuri" },
      { id: 545191, name: "Jawala" },
      { id: 545264, name: "Jomegaon" },
      { id: 545222, name: "Joshi Sangvi" },
      { id: 545309, name: "Kadamachiwadi" },
      { id: 545237, name: "Kalambar Bk." },
      { id: 545238, name: "Kalambar Kh." },
      { id: 545280, name: "Kambegaon" },
      { id: 545245, name: "Kamlaj" },
      { id: 545256, name: "Kanjala" },
      { id: 545257, name: "Kanjalwadi" },
      { id: 545254, name: "Kapshi Bk." },
      { id: 545252, name: "Kapshi Kh." },
      { id: 545215, name: "Karegaon" },
      { id: 545260, name: "Karmala" },
      { id: 545246, name: "Kaudgaon" },
      { id: 946195, name: "Kesutanda" },
      { id: 545208, name: "Khadak Manjari" },
      { id: 545273, name: "Khambegaon" },
      { id: 545194, name: "Kharbi" },
      { id: 545203, name: "Khed Manjara" },
      { id: 545304, name: "Khedkarwadi" },
      { id: 946176, name: "Khirutanda" },
      { id: 545289, name: "Kiroda" },
      { id: 545220, name: "Kiwala" },
      { id: 946211, name: "Koshtwadi" },
      { id: 545251, name: "Kumbhargaon" },
      { id: 946177, name: "Lachchmatanda" },
      { id: 545300, name: "Landgewadi" },
      { id: 545296, name: "Lavhral" },
      { id: 545311, name: "Limboti" },
      { id: 943151, name: "Loha" },
      { id: 545223, name: "Londhe Sangvi" },
      { id: 545212, name: "Madakewadi" },
      { id: 545307, name: "Majare Sangvi" },
      { id: 545301, name: "Malakoli" },
      { id: 545305, name: "Malegaon Yatra" },
      { id: 545233, name: "Malkapur" },
      { id: 946200, name: "Manchutanda" },
      { id: 545285, name: "Mangrul" },
      { id: 545242, name: "Martala" },
      { id: 545283, name: "Maski" },
      { id: 946178, name: "Mokalewadi" },
      { id: 545291, name: "Murambi" },
      { id: 545297, name: "Nagarwadi" },
      { id: 545243, name: "Nandgaon" },
      { id: 946179, name: "Nehrunagar" },
      { id: 545228, name: "Nila" },
      { id: 545200, name: "Palshi" },
      { id: 545205, name: "Pangri" },
      { id: 946201, name: "Parasramtanda" },
      { id: 545277, name: "Pardi" },
      { id: 545270, name: "Penur" },
      { id: 946160, name: "Pethachiwadi" },
      { id: 946196, name: "Phulmalatanda" },
      { id: 545261, name: "Pimpaldari" },
      { id: 545209, name: "Pimpalgaon (Ayab)" },
      { id: 545230, name: "Pimpalgaon Dhage" },
      { id: 545210, name: "Pimpranwadi" },
      { id: 545236, name: "Pokhar Bhoshi" },
      { id: 545235, name: "Pokhari" },
      { id: 545286, name: "Policewadi" },
      { id: 946202, name: "Ramachiwadi" },
      { id: 946212, name: "Ramanaiktanda" },
      { id: 946181, name: "Ramanewadi" },
      { id: 545295, name: "Ramtirth" },
      { id: 545232, name: "Raywadi" },
      { id: 545293, name: "Risangaon" },
      { id: 946183, name: "Rupsingtanda" },
      { id: 946184, name: "Sakrutanda" },
      { id: 545292, name: "Sawargaon Nasarat" },
      { id: 545207, name: "Sayal." },
      { id: 946186, name: "Sevalal Nagar" },
      { id: 545255, name: "Shambhargaon" },
      { id: 545229, name: "Shelgaon" },
      { id: 545202, name: "Shewadi" },
      { id: 946162, name: "Shivajinagartanda" },
      { id: 545204, name: "Shivani Jamga" },
      { id: 545198, name: "Sonkhed" },
      { id: 545274, name: "Sonmanjari" },
      { id: 545267, name: "Sugaon" },
      { id: 545276, name: "Sunegaon" },
      { id: 545239, name: "Takalgaon" },
      { id: 545226, name: "Telki" },
      { id: 946188, name: "Thavaratanda" },
      { id: 545263, name: "Umra" },
      { id: 946189, name: "Vithobatanda" },
      { id: 545218, name: "Wadepuri" },
      { id: 545225, name: "Wadgaon" },
      { id: 545303, name: "Wagdarwadi" },
      { id: 545250, name: "Waka" },
      { id: 545216, name: "Walkewadi" },
      { id: 545241, name: "Walki Bk." },
      { id: 545253, name: "Walki Kh." },
      { id: 946191, name: "Yaldaritanda" },
      { id: 545247, name: "Yeli" },
      { id: 545196, name: "Zari" },
    ],
    4108: [
      { id: 545391, name: "Abulaga" },
      { id: 545364, name: "Alegaon" },
      { id: 545369, name: "Aural" },
      { id: 545327, name: "Babulgaon" },
      { id: 545335, name: "Bachoti" },
      { id: 545320, name: "Bahadarpura" },
      { id: 545324, name: "Balantwadi" },
      { id: 545365, name: "Bamni P.K." },
      { id: 545374, name: "Barul" },
      { id: 545352, name: "Bhandar Kumthyachiwadi" },
      { id: 545437, name: "Bhendewadi" },
      { id: 545372, name: "Bhukmari" },
      { id: 545363, name: "Bhutyachiwadi" },
      { id: 545333, name: "Bijewadi" },
      { id: 545358, name: "Binda" },
      { id: 545432, name: "Bolka" },
      { id: 545388, name: "Bori Bk." },
      { id: 545328, name: "Bori Kh." },
      { id: 545408, name: "Bramhwadi" },
      { id: 545385, name: "Chauki (Mahakaya)" },
      { id: 545337, name: "Chauki Dharnapuri" },
      { id: 545377, name: "Chaukipaya" },
      { id: 545347, name: "Chikhal Bhosi" },
      { id: 545370, name: "Chikhali" },
      { id: 545336, name: "Chincholi P.K." },
      { id: 545357, name: "Dahikalamba" },
      { id: 545422, name: "Daithana" },
      { id: 545362, name: "Datala" },
      { id: 946165, name: "Devla Naik Tanda" },
      { id: 545381, name: "Dhanora (Kavtha)" },
      { id: 545315, name: "Dharmapuri Majare" },
      { id: 545438, name: "Digras Bk." },
      { id: 545439, name: "Digras Kh." },
      { id: 545359, name: "Dinda" },
      { id: 946199, name: "Durgatanda" },
      { id: 946193, name: "Gana Tanda" },
      { id: 545326, name: "Ganganbid" },
      { id: 545344, name: "Gaul" },
      { id: 545417, name: "Ghagardarwadi" },
      { id: 545325, name: "Ghodaj" },
      { id: 545440, name: "Ghubadwadi" },
      { id: 545318, name: "Gogdari" },
      { id: 545404, name: "Gonar" },
      { id: 545321, name: "Gulabwadi" },
      { id: 545361, name: "Gunda" },
      { id: 545441, name: "Guntur" },
      { id: 545415, name: "Guttewadi" },
      { id: 545435, name: "Hadoli Brham" },
      { id: 545371, name: "Halda" },
      { id: 545411, name: "Hanmantwadi" },
      { id: 545418, name: "Harbal P.K." },
      { id: 545430, name: "Hasul" },
      { id: 545428, name: "Hatkayal" },
      { id: 545434, name: "Hiparga Shadivan" },
      { id: 545373, name: "Hisse Aural" },
      { id: 545323, name: "Imamwadi" },
      { id: 545398, name: "Jakapur" },
      { id: 545334, name: "Jangamwadi" },
      { id: 946210, name: "Jayram Tanda" },
      { id: 545394, name: "Kalka" },
      { id: 545406, name: "Kallali" },
      { id: 943113, name: "Kandhar" },
      { id: 545343, name: "Kandharewadi" },
      { id: 545429, name: "Kartala" },
      { id: 545378, name: "Katkalmba" },
      { id: 545384, name: "Kautha" },
      { id: 545380, name: "Kauthawadi" },
      { id: 545403, name: "Khandgaon Hamid" },
      { id: 545351, name: "Khudyachiwadi" },
      { id: 545317, name: "Kot Bazar" },
      { id: 545423, name: "Kurla" },
      { id: 946167, name: "Lachchmatanda" },
      { id: 545360, name: "Ladka" },
      { id: 545322, name: "Lalwadi" },
      { id: 545353, name: "Lath Kh." },
      { id: 545402, name: "Madali" },
      { id: 545431, name: "Mahalingi" },
      { id: 545375, name: "Majare Warwat" },
      { id: 545319, name: "Manaspuri" },
      { id: 545367, name: "Mangal Sangvi" },
      { id: 545395, name: "Mangnali" },
      { id: 545420, name: "Marshivni" },
      { id: 545400, name: "Masalaga" },
      { id: 943114, name: "Matandoh" },
      { id: 545426, name: "Mohija" },
      { id: 545338, name: "Mundewadi Tarf Khandobachiwadi" },
      { id: 545414, name: "Nagalgaon" },
      { id: 946168, name: "Naiknagar" },
      { id: 545433, name: "Nandanshivani" },
      { id: 545368, name: "Nandanwan" },
      { id: 545401, name: "Narnali" },
      { id: 946169, name: "Narpatwadi (Jivlatanda)" },
      { id: 545345, name: "Naugharwadi" },
      { id: 545316, name: "Navrangpura" },
      { id: 545393, name: "Nawandyachiwadi" },
      { id: 946170, name: "Nehrunagar" },
      { id: 545354, name: "Osmannagar" },
      { id: 545346, name: "Panbhoshi" },
      { id: 545350, name: "Pangra" },
      { id: 545342, name: "Panshevadi" },
      { id: 545427, name: "Paranda" },
      { id: 545340, name: "Patalganga" },
      { id: 545396, name: "Pethwadaj" },
      { id: 545339, name: "Phulwal" },
      { id: 545390, name: "Pimpalyachiwadi" },
      { id: 545416, name: "Pokharni" },
      { id: 946171, name: "Pomatanda (Rekhatanda)" },
      { id: 545383, name: "Rahati" },
      { id: 545412, name: "Ramanaik Tanda" },
      { id: 545379, name: "Rautkheda" },
      { id: 545410, name: "Rui" },
      { id: 545330, name: "Sangamwadi" },
      { id: 545349, name: "Sanguchiwadi" },
      { id: 545409, name: "Sawargaon Nipani" },
      { id: 545366, name: "Sawleshwar" },
      { id: 545332, name: "Shekapur" },
      { id: 545392, name: "Shellaliwadi" },
      { id: 545356, name: "Shiradhon" },
      { id: 545397, name: "Shirsi Bk." },
      { id: 545405, name: "Shirsi Kh." },
      { id: 545386, name: "Shirur" },
      { id: 545421, name: "Somthana" },
      { id: 545331, name: "Talyachiwadi" },
      { id: 545382, name: "Telur" },
      { id: 545389, name: "Tokwadi" },
      { id: 946198, name: "Udatanda" },
      { id: 545436, name: "Umarga Khojan" },
      { id: 545329, name: "Umraj." },
      { id: 545425, name: "Wahad" },
      { id: 545387, name: "Wakhrad" },
      { id: 545348, name: "Wanjarwadi" },
      { id: 545376, name: "Warwant" },
      { id: 545399, name: "Yelur" },
    ],
    4109: [
      { id: 545505, name: "Adlur" },
      { id: 545451, name: "Admalwadi" },
      { id: 545472, name: "Akharga" },
      { id: 545522, name: "Ambulga Bk." },
      { id: 545523, name: "Ambulga Kh." },
      { id: 545581, name: "Andegaon" },
      { id: 545519, name: "Aural" },
      { id: 545570, name: "Bamni" },
      { id: 545547, name: "Barhali" },
      { id: 545480, name: "Bawalgaon" },
      { id: 545591, name: "Bennal" },
      { id: 545456, name: "Berli Bk." },
      { id: 545457, name: "Berli Kh." },
      { id: 545496, name: "Betmogra" },
      { id: 545484, name: "Bhagnurwadi" },
      { id: 545573, name: "Bhaswadi" },
      { id: 545521, name: "Bhatapur P.D." },
      { id: 545574, name: "Bhatapur P.Mu." },
      { id: 545532, name: "Bhavani Tanda" },
      { id: 545555, name: "Bhendegaon Bk." },
      { id: 545556, name: "Bhendegaon Kh." },
      { id: 545554, name: "Bhingoli" },
      { id: 545515, name: "Billali" },
      { id: 545454, name: "Bomnali" },
      { id: 545492, name: "Borgaon" },
      { id: 545482, name: "Chandola" },
      { id: 545566, name: "Chinchgaon" },
      { id: 545474, name: "Chivli" },
      { id: 545509, name: "Chondi" },
      { id: 545465, name: "Dabka Raja" },
      { id: 545564, name: "Dapka Gundopant" },
      { id: 545586, name: "Degaon" },
      { id: 545495, name: "Dhamangaon" },
      { id: 545507, name: "Dhanaj" },
      { id: 545479, name: "Dongargaon" },
      { id: 545557, name: "Dornali" },
      { id: 545504, name: "Eklara" },
      { id: 545486, name: "Gadgyalwadi" },
      { id: 545579, name: "Gojegaon" },
      { id: 545577, name: "Gonegaon" },
      { id: 545567, name: "Halni" },
      { id: 545592, name: "Hangarga Kh." },
      { id: 545494, name: "Hangarga P.K." },
      { id: 545510, name: "Hasnal P.D." },
      { id: 545553, name: "Hasnal P.Mu." },
      { id: 545561, name: "Hatral" },
      { id: 545502, name: "Hibbat" },
      { id: 545548, name: "Hippalnari" },
      { id: 545464, name: "Hipparga" },
      { id: 545483, name: "Hokarna" },
      { id: 545445, name: "Hondala" },
      { id: 545487, name: "Honwadaj" },
      { id: 545524, name: "Itgyal P.D." },
      { id: 545582, name: "Itgyal P.Mu." },
      { id: 545516, name: "Jahur" },
      { id: 545442, name: "Jamb Bk." },
      { id: 545444, name: "Jamb Kh." },
      { id: 545489, name: "Jambhali" },
      { id: 545508, name: "Jamkhed" },
      { id: 545540, name: "Jirga" },
      { id: 545470, name: "Junna" },
      { id: 545549, name: "Kabnur" },
      { id: 545562, name: "Kalambar" },
      { id: 545466, name: "Kamjalga" },
      { id: 545471, name: "Kamlewadi" },
      { id: 545453, name: "Kaparwadi" },
      { id: 545481, name: "Karna" },
      { id: 545490, name: "Kerur" },
      { id: 545455, name: "Khairka" },
      { id: 545514, name: "Khapral" },
      { id: 545475, name: "Kharab Khandgaon" },
      { id: 545497, name: "Khatgaon P.D." },
      { id: 545588, name: "Khatgaon P.Mu." },
      { id: 545493, name: "Kolgaon" },
      { id: 545552, name: "Kolnur" },
      { id: 545449, name: "Kotgyal" },
      { id: 545531, name: "Kundral" },
      { id: 545463, name: "Ladga" },
      { id: 545583, name: "Lakhmapur" },
      { id: 545528, name: "Lingapur" },
      { id: 545518, name: "Lonal" },
      { id: 545550, name: "Makni" },
      { id: 545501, name: "Mandlapur" },
      { id: 545467, name: "Mangyal" },
      { id: 545543, name: "Manjari" },
      { id: 545576, name: "Marajwadi" },
      { id: 545499, name: "Mavali" },
      { id: 545513, name: "Methi" },
      { id: 545503, name: "Motarga" },
      { id: 944221, name: "Mukhed" },
      { id: 545572, name: "Mukramabad" },
      { id: 545568, name: "Nagral" },
      { id: 545506, name: "Nandgaon P.D." },
      { id: 545478, name: "Nandgaon P.K." },
      { id: 545559, name: "Nivali" },
      { id: 545443, name: "Pakhandewadi" },
      { id: 545500, name: "Pala" },
      { id: 545452, name: "Pandurni" },
      { id: 545585, name: "Paratpur" },
      { id: 545538, name: "Pimpalkuntha" },
      { id: 545520, name: "Rajura Bk." },
      { id: 545527, name: "Rajura Kh." },
      { id: 545473, name: "Rathodwadi" },
      { id: 545575, name: "Ravangaon" },
      { id: 545565, name: "Ravankola" },
      { id: 545569, name: "Ravi" },
      { id: 545539, name: "Saknur" },
      { id: 545476, name: "Salagara Bk." },
      { id: 545477, name: "Salagara Kh." },
      { id: 545446, name: "Sangvi Benak" },
      { id: 545525, name: "Sangvi Bhadev" },
      { id: 545589, name: "Savarmal" },
      { id: 545590, name: "Sawali" },
      { id: 545462, name: "Sawargaon" },
      { id: 545468, name: "Sawargaonwadi" },
      { id: 545448, name: "Shelkewadi" },
      { id: 545461, name: "Shikara" },
      { id: 545460, name: "Shirur" },
      { id: 545530, name: "Sugaon" },
      { id: 545563, name: "Tagyal" },
      { id: 545488, name: "Tandli" },
      { id: 545533, name: "Tardarwadi" },
      { id: 545526, name: "Thana" },
      { id: 545511, name: "Tupdal Bk." },
      { id: 545512, name: "Tupdal Kh." },
      { id: 545498, name: "Uchchha Bk." },
      { id: 545485, name: "Umardari" },
      { id: 545517, name: "Undri P.D." },
      { id: 545529, name: "Undri P.M." },
      { id: 545558, name: "Wadgaon" },
      { id: 545571, name: "Walanki" },
      { id: 545584, name: "Wandgir" },
      { id: 545447, name: "Wartala" },
      { id: 545551, name: "Wasur" },
      { id: 545537, name: "Yevti" },
    ],
    4110: [
      { id: 545612, name: "Achegaon" },
      { id: 545608, name: "Alapur" },
      { id: 545620, name: "Alur" },
      { id: 545685, name: "Ambulga" },
      { id: 545661, name: "Amdapur" },
      { id: 545602, name: "Antapur" },
      { id: 545594, name: "Apsavargaon" },
      { id: 545644, name: "Balegaon" },
      { id: 545656, name: "Ballur" },
      { id: 545697, name: "Bembra" },
      { id: 545652, name: "Bhaktapur" },
      { id: 545614, name: "Bhayegaon" },
      { id: 545643, name: "Bhokaskheda" },
      { id: 545696, name: "Bhutan Hipparga" },
      { id: 545707, name: "Bijalwadi" },
      { id: 545641, name: "Bomnali" },
      { id: 545663, name: "Borgaon" },
      { id: 545603, name: "Chainpur" },
      { id: 545646, name: "Chakur" },
      { id: 545660, name: "Daregaon" },
      { id: 545678, name: "Davangir" },
      { id: 545610, name: "Degaon Bk." },
      { id: 545605, name: "Degaon Kh" },
      { id: 943115, name: "Deglur" },
      { id: 545668, name: "Devapur" },
      { id: 545645, name: "Dhosni" },
      { id: 545664, name: "Gavandgaon" },
      { id: 545683, name: "Hali" },
      { id: 545694, name: "Hanegaon" },
      { id: 545638, name: "Hanuman Hipparga" },
      { id: 545640, name: "Hawarga" },
      { id: 545654, name: "Hotal" },
      { id: 545600, name: "Ibrahimpur" },
      { id: 545690, name: "Kabirwadi" },
      { id: 545672, name: "Karadkhed" },
      { id: 545625, name: "Kare Malkapur" },
      { id: 545648, name: "Karegaon" },
      { id: 545666, name: "Kathewadi" },
      { id: 545615, name: "Kavalgadda" },
      { id: 545657, name: "Kavalgaon" },
      { id: 545671, name: "Kedarkunta" },
      { id: 545601, name: "Khanapur" },
      { id: 545701, name: "Khutmapur" },
      { id: 545680, name: "Kini" },
      { id: 545702, name: "Kokalgaon" },
      { id: 545619, name: "Kotekallur" },
      { id: 545682, name: "Kshirsamudra" },
      { id: 545692, name: "Kudali" },
      { id: 545706, name: "Kunmarpali" },
      { id: 545635, name: "Kurudgi Bk" },
      { id: 545636, name: "Kurudgi Kh." },
      { id: 545655, name: "Kutub Shahapurwadi" },
      { id: 545596, name: "Lakhkha" },
      { id: 545617, name: "Limba" },
      { id: 545649, name: "Lingankerur" },
      { id: 545687, name: "Loni" },
      { id: 545647, name: "Mailapur (D)" },
      { id: 545681, name: "Malegaon (M)" },
      { id: 545607, name: "Malegoan" },
      { id: 545611, name: "Malkapur" },
      { id: 545633, name: "Mandgi" },
      { id: 545686, name: "Mangajiwadi" },
      { id: 545593, name: "Manshakarga" },
      { id: 545698, name: "Manur Bk." },
      { id: 545674, name: "Markhel" },
      { id: 545684, name: "Martoli" },
      { id: 545630, name: "Mendankallur" },
      { id: 545659, name: "Mengapur (D)" },
      { id: 545604, name: "Munjalga" },
      { id: 545653, name: "Nagral" },
      { id: 545621, name: "Nandur" },
      { id: 545628, name: "Narangal Bk." },
      { id: 545634, name: "Narangal Kh" },
      { id: 545599, name: "Nipani Savargaon" },
      { id: 545670, name: "Pendpalli" },
      { id: 545651, name: "Pimpalgaon" },
      { id: 545677, name: "Pujarwadi" },
      { id: 946180, name: "Punarvasit Vasahat Khanapur" },
      { id: 545618, name: "Rampur P.Shahapur" },
      { id: 944222, name: "Rampur Patti Hottal" },
      { id: 545703, name: "Ramtapur" },
      { id: 545658, name: "Sangvi Karadkhed" },
      { id: 545631, name: "Sangvi Umar" },
      { id: 545626, name: "Shahapur" },
      { id: 545623, name: "Shekhapur" },
      { id: 545624, name: "Shelgaon" },
      { id: 545622, name: "Shevala" },
      { id: 545689, name: "Shilwani" },
      { id: 545613, name: "Shiv Achegaon" },
      { id: 545667, name: "Shivani" },
      { id: 545700, name: "Somur" },
      { id: 545595, name: "Sugaon" },
      { id: 545627, name: "Sujayatpur" },
      { id: 545639, name: "Sundgi Bk." },
      { id: 545642, name: "Sundgi Kh." },
      { id: 545609, name: "Tadkhel" },
      { id: 545676, name: "Takali Jahagir" },
      { id: 545606, name: "Takli Bagam" },
      { id: 545637, name: "Takli Walag" },
      { id: 545629, name: "Tamlur" },
      { id: 545632, name: "Thadi Sawargaon" },
      { id: 545688, name: "Tumbarpalli" },
      { id: 545616, name: "Tupshelgaon" },
      { id: 912812, name: "Wadi Karadkhed" },
      { id: 545673, name: "Walag" },
      { id: 545598, name: "Wannali" },
      { id: 545691, name: "Wazar" },
      { id: 545597, name: "Wazarga" },
      { id: 545705, name: "Yedur" },
      { id: 545669, name: "Yergi" },
      { id: 545675, name: "Zari" },
    ],
    4111: [
      { id: 545837, name: "Adol" },
      { id: 545758, name: "Ajegaon" },
      { id: 545744, name: "Amdari" },
      { id: 545799, name: "Babhulgaon" },
      { id: 545730, name: "Bamani Kh" },
      { id: 545708, name: "Ban" },
      { id: 545711, name: "Barada (Ban)" },
      { id: 545815, name: "Barada (Sengaon)" },
      { id: 545776, name: "Batwadi" },
      { id: 545810, name: "Belala" },
      { id: 545766, name: "Belkheda" },
      { id: 545781, name: "Bhagwati" },
      { id: 545739, name: "Bhandari" },
      { id: 545813, name: "Bhankheda" },
      { id: 545750, name: "Bodkha" },
      { id: 545734, name: "Borkhadi G" },
      { id: 545724, name: "Borkhadi P" },
      { id: 545787, name: "Bramhanwada Pra Washim" },
      { id: 545829, name: "Bramhawadi" },
      { id: 545763, name: "Changephal" },
      { id: 545827, name: "Chikhalagar" },
      { id: 545743, name: "Chinchkheda" },
      { id: 545800, name: "Chondi Bk" },
      { id: 545788, name: "Chondi Kh" },
      { id: 545772, name: "Datada Bk" },
      { id: 545771, name: "Datada Kh" },
      { id: 545765, name: "Deulgaon Jahagir" },
      { id: 545759, name: "Dhangarwadi" },
      { id: 545712, name: "Dhanora Banjara" },
      { id: 545733, name: "Dhotara" },
      { id: 545726, name: "Dongargaon" },
      { id: 545748, name: "Ganeshpur" },
      { id: 545732, name: "Garkheda" },
      { id: 545714, name: "Ghordari" },
      { id: 545833, name: "Gondala" },
      { id: 545795, name: "Gondankheda" },
      { id: 545789, name: "Goregaon" },
      { id: 545780, name: "Gugul Pimpari" },
      { id: 545834, name: "Hanakdari" },
      { id: 545797, name: "Hatala" },
      { id: 545738, name: "Hatta" },
      { id: 545747, name: "Hatta Tanda" },
      { id: 545792, name: "Hiwara Najik Maharkheda" },
      { id: 545723, name: "Hiwarkheda" },
      { id: 545735, name: "Holgira" },
      { id: 545831, name: "Hudi" },
      { id: 545718, name: "Jaipur" },
      { id: 545825, name: "Jambandh" },
      { id: 545832, name: "Jamdaya" },
      { id: 545819, name: "Jamrun Bk" },
      { id: 545798, name: "Jamthi Bk" },
      { id: 545762, name: "Jawala Bk." },
      { id: 545790, name: "Kadoli" },
      { id: 545756, name: "Kahakar Bk" },
      { id: 545721, name: "Kahakar Kh" },
      { id: 545713, name: "Kapadsingi" },
      { id: 545769, name: "Karegaon" },
      { id: 545741, name: "Karla" },
      { id: 545802, name: "Kawardadi" },
      { id: 545803, name: "Kawatha Bk." },
      { id: 545715, name: "Kelsula" },
      { id: 545794, name: "Kendra Bk" },
      { id: 545793, name: "Kendra Kh" },
      { id: 545725, name: "Khadaki" },
      { id: 545740, name: "Khairi (Ghumat)" },
      { id: 545752, name: "Khairkheda" },
      { id: 545835, name: "Khillar" },
      { id: 545823, name: "Khudaj" },
      { id: 545804, name: "Kolsa" },
      { id: 545801, name: "Kondwada" },
      { id: 545745, name: "Limbala Amdari" },
      { id: 545830, name: "Limbala Hudi" },
      { id: 545824, name: "Lingdari" },
      { id: 545840, name: "Lingpimpri" },
      { id: 545812, name: "Mahalsapur" },
      { id: 545778, name: "Maharkheda" },
      { id: 545814, name: "Makodi" },
      { id: 545828, name: "Mangwadi" },
      { id: 545777, name: "Mannas Pimpari" },
      { id: 545791, name: "Mazod" },
      { id: 545754, name: "Mhalshi" },
      { id: 545729, name: "Nansi" },
      { id: 545760, name: "Palshi" },
      { id: 545751, name: "Pankanhergaon" },
      { id: 545818, name: "Pardi" },
      { id: 545737, name: "Patoda" },
      { id: 545779, name: "Pawti" },
      { id: 545710, name: "Pimpri Barda" },
      { id: 545839, name: "Pimpriling" },
      { id: 545822, name: "Pusegaon" },
      { id: 545838, name: "Repa" },
      { id: 545817, name: "Ridhora" },
      { id: 545761, name: "Sabalkheda" },
      { id: 545722, name: "Sakhara" },
      { id: 545727, name: "Salegaon" },
      { id: 545808, name: "Sapatgaon" },
      { id: 545785, name: "Sawana" },
      { id: 545719, name: "Sawarkheda" },
      { id: 545809, name: "Sengaon" },
      { id: 545753, name: "Shegaon" },
      { id: 545720, name: "Shinagi (Khamba)" },
      { id: 545770, name: "Shindephal" },
      { id: 545768, name: "Shivni Bk" },
      { id: 545767, name: "Shivni Kh" },
      { id: 545807, name: "Sinagi Naga" },
      { id: 545731, name: "Sonsawangi" },
      { id: 545806, name: "Sukli Bk" },
      { id: 545805, name: "Sukli Kh" },
      { id: 545764, name: "Suldali Bk." },
      { id: 545773, name: "Suldali Kh" },
      { id: 545784, name: "Surajkheda" },
      { id: 545796, name: "Taktoda" },
      { id: 545816, name: "Talni Pra Narsi" },
      { id: 545749, name: "Tandulwadi" },
      { id: 545782, name: "Tapowan" },
      { id: 545836, name: "Umardari" },
      { id: 545736, name: "Uti Bramhachari" },
      { id: 545728, name: "Uti Purna" },
      { id: 545826, name: "Wad Hiwara" },
      { id: 545717, name: "Wadhona" },
      { id: 545757, name: "Waghjali" },
      { id: 545775, name: "Walana" },
      { id: 545755, name: "Warkheda" },
      { id: 545811, name: "Warud Chakrapan" },
      { id: 545821, name: "Warud Kaji" },
      { id: 545820, name: "Warud Saman" },
      { id: 545774, name: "Watkali" },
      { id: 545786, name: "Waychal Pimpari" },
      { id: 545709, name: "Wazur Kh" },
      { id: 545716, name: "Weltura" },
      { id: 545742, name: "Yeldari" },
    ],
    4112: [
      { id: 545858, name: "Adgaon" },
      { id: 545853, name: "Ambala" },
      { id: 545926, name: "Ambheri" },
      { id: 545981, name: "Amla" },
      { id: 545945, name: "Andharwadi" },
      { id: 545947, name: "Balsond" },
      { id: 545919, name: "Basamba" },
      { id: 545863, name: "Belura" },
      { id: 545951, name: "Belwadi" },
      { id: 545870, name: "Bhandegaon" },
      { id: 545878, name: "Bhatsawangi" },
      { id: 545877, name: "Bhatsawangi Tanda" },
      { id: 545855, name: "Bhingi" },
      { id: 545915, name: "Bhirda" },
      { id: 545921, name: "Bhogaon" },
      { id: 545857, name: "Bhuli" },
      { id: 545860, name: "Bodkhi" },
      { id: 545854, name: "Bondala" },
      { id: 545972, name: "Borala" },
      { id: 545970, name: "Boralwadi" },
      { id: 545932, name: "Bori Shikari" },
      { id: 545895, name: "Borja" },
      { id: 545977, name: "Bramhapuri" },
      { id: 545950, name: "Bukanwadi" },
      { id: 545850, name: "Charthana" },
      { id: 545959, name: "Chikhalwadi" },
      { id: 545862, name: "Chinchala" },
      { id: 545909, name: "Chincholi" },
      { id: 545845, name: "Chinchpuri" },
      { id: 545867, name: "Chorjawala" },
      { id: 545993, name: "Dategaon" },
      { id: 545954, name: "Deulgaon Rama" },
      { id: 545851, name: "Devthana" },
      { id: 545874, name: "Dhanapur" },
      { id: 545955, name: "Dhotarwadi" },
      { id: 545883, name: "Dhotra" },
      { id: 545966, name: "Digras Karhale" },
      { id: 545890, name: "Digraswani" },
      { id: 545906, name: "Dongi" },
      { id: 545911, name: "Dudheri" },
      { id: 545936, name: "Durg Dhamni" },
      { id: 545879, name: "Durgasawangi" },
      { id: 545861, name: "Ekamba" },
      { id: 545897, name: "Gadibori" },
      { id: 545946, name: "Ganeshwadi" },
      { id: 545898, name: "Ghogartala" },
      { id: 545983, name: "Ghota" },
      { id: 545979, name: "Giroli" },
      { id: 545976, name: "Hanwatkheda" },
      { id: 545940, name: "Hingni" },
      { id: 545957, name: "Hingoli" },
      { id: 545886, name: "Hiradi" },
      { id: 545930, name: "Hiwara Bel" },
      { id: 545982, name: "Idoli" },
      { id: 545942, name: "Incha" },
      { id: 545923, name: "Isapur" },
      { id: 545865, name: "Jaipurwadi" },
      { id: 545989, name: "Jamrun Andh" },
      { id: 545975, name: "Jamrun Jahagir" },
      { id: 545941, name: "Jamthi Kh." },
      { id: 545962, name: "Jamwadi" },
      { id: 545900, name: "Jaulka" },
      { id: 545887, name: "Jodtala" },
      { id: 545974, name: "Kadti" },
      { id: 545931, name: "Kalamkonda Bk." },
      { id: 545844, name: "Kalburga" },
      { id: 545872, name: "Kalgaon" },
      { id: 545980, name: "Kalkondi" },
      { id: 545847, name: "Kanadkheda Bk." },
      { id: 545843, name: "Kanadkheda Kh." },
      { id: 545842, name: "Kanhergaon Naka" },
      { id: 545924, name: "Kanka" },
      { id: 545849, name: "Kapurkheda" },
      { id: 545991, name: "Karanjala" },
      { id: 545948, name: "Karwadi" },
      { id: 545984, name: "Kesapur" },
      { id: 545902, name: "Khadkad Bk" },
      { id: 545944, name: "Khambala" },
      { id: 545880, name: "Khanapur" },
      { id: 545929, name: "Khanapur Chita" },
      { id: 545864, name: "Khandala" },
      { id: 545943, name: "Kharbi" },
      { id: 545939, name: "Khed" },
      { id: 545873, name: "Kherda" },
      { id: 545934, name: "Kothalaj" },
      { id: 545917, name: "Koyali" },
      { id: 545925, name: "Lasina" },
      { id: 545968, name: "Limbala Makta" },
      { id: 545856, name: "Limbala Pr. Washim" },
      { id: 545904, name: "Limbi" },
      { id: 545992, name: "Lohagaon" },
      { id: 545903, name: "Lohra" },
      { id: 545938, name: "Maldhamni" },
      { id: 545949, name: "Malharwadi" },
      { id: 545871, name: "Malhiwara" },
      { id: 545866, name: "Malselu" },
      { id: 545958, name: "Malwadi" },
      { id: 545907, name: "Mauja" },
      { id: 545841, name: "Mop" },
      { id: 545973, name: "Nandura" },
      { id: 545908, name: "Nandusa" },
      { id: 545985, name: "Narsi" },
      { id: 545869, name: "Navalgavhan" },
      { id: 545935, name: "Nawkha" },
      { id: 545987, name: "Paheni" },
      { id: 545881, name: "Palsona" },
      { id: 545971, name: "Pangri" },
      { id: 545916, name: "Parda" },
      { id: 545914, name: "Parola" },
      { id: 545927, name: "Patan" },
      { id: 545876, name: "Patonda" },
      { id: 545905, name: "Pedgaon" },
      { id: 545888, name: "Pedgaonwadi" },
      { id: 545852, name: "Phalegaon" },
      { id: 545892, name: "Pimpaldari Tarf Basamba" },
      { id: 545920, name: "Pimparkhed" },
      { id: 545922, name: "Pimplkhuta" },
      { id: 545965, name: "Raholi Bk." },
      { id: 545964, name: "Raholi Kh." },
      { id: 545912, name: "Rajura" },
      { id: 545960, name: "Rajwadi" },
      { id: 545875, name: "Sagad" },
      { id: 545933, name: "Samga" },
      { id: 545893, name: "Sandas Tarf Basamba" },
      { id: 545967, name: "Santuk Pimpari" },
      { id: 545978, name: "Sarkali" },
      { id: 545963, name: "Sasewadi" },
      { id: 545868, name: "Satamba" },
      { id: 545913, name: "Sawa" },
      { id: 545953, name: "Sawad" },
      { id: 545894, name: "Sawargaon" },
      { id: 545928, name: "Sawarkheda" },
      { id: 545910, name: "Sayala" },
      { id: 545961, name: "Singarwadi" },
      { id: 545889, name: "Sirsam Bk." },
      { id: 545884, name: "Sirsam Kh" },
      { id: 545937, name: "Takli Tarf Nandapur" },
      { id: 545901, name: "Tikhadi" },
      { id: 545882, name: "Umarkhoja" },
      { id: 545969, name: "Umra" },
      { id: 545986, name: "Vaijapur" },
      { id: 545859, name: "Wadad" },
      { id: 545846, name: "Wadhona Pr. Washim" },
      { id: 545956, name: "Wanjarwadi" },
      { id: 545848, name: "Wanzola" },
      { id: 545896, name: "Warhadi" },
      { id: 545952, name: "Warud Gawali" },
      { id: 545891, name: "Yehlegaon Hatkar" },
      { id: 545918, name: "Yeli" },
    ],
    4113: [
      { id: 546085, name: "Ajalsonda" },
      { id: 546046, name: "Amdari" },
      { id: 546007, name: "Anjanwada" },
      { id: 546012, name: "Anjanwada Tanda" },
      { id: 546067, name: "Anjanwadi" },
      { id: 546106, name: "Ankhali" },
      { id: 546070, name: "Asola Traf Aundha" },
      { id: 546055, name: "Asola Traf Lakh" },
      { id: 546041, name: "Asonda" },
      { id: 546018, name: "Aundha Nagnath" },
      { id: 546114, name: "Berula" },
      { id: 546099, name: "Bhagwa" },
      { id: 545996, name: "Bhosi" },
      { id: 546035, name: "Borja" },
      { id: 546013, name: "Bramhanwada Pr.Aundha" },
      { id: 546098, name: "Chimegaon" },
      { id: 546110, name: "Chincholi Niloba" },
      { id: 546063, name: "Chondhi Tarf Shahapur" },
      { id: 546054, name: "Daregaon" },
      { id: 546084, name: "Daregavhan" },
      { id: 546104, name: "Daudgaon" },
      { id: 546011, name: "Devala" },
      { id: 546025, name: "Devala Taraf Lakh" },
      { id: 546097, name: "Dhar" },
      { id: 546039, name: "Dharkheda" },
      { id: 545999, name: "Dhegaj" },
      { id: 546037, name: "Dudhala" },
      { id: 545998, name: "Durchuna" },
      { id: 546030, name: "Gadhala" },
      { id: 546017, name: "Galandi" },
      { id: 546006, name: "Gangalwadi" },
      { id: 546062, name: "Gawalewadi" },
      { id: 546096, name: "Gojegaon" },
      { id: 546015, name: "Golegaon" },
      { id: 546027, name: "Gongla" },
      { id: 546023, name: "Hiwara Jatu" },
      { id: 546102, name: "Hiwarkheda" },
      { id: 546034, name: "Jadgaon" },
      { id: 546050, name: "Jalaldhaba" },
      { id: 546112, name: "Jalalpur" },
      { id: 546045, name: "Jamgavhan" },
      { id: 546021, name: "Jamraja" },
      { id: 546080, name: "Jawala Bajar" },
      { id: 546090, name: "Jod Pimpri" },
      { id: 546042, name: "Kakaddhaba" },
      { id: 546089, name: "Kamatha" },
      { id: 546044, name: "Kanjara" },
      { id: 546072, name: "Kathod" },
      { id: 546071, name: "Kathoda Tanda" },
      { id: 546094, name: "Keli" },
      { id: 546093, name: "Keli Tanda" },
      { id: 546069, name: "Kondashi Bk" },
      { id: 546068, name: "Kondashi Kh" },
      { id: 546024, name: "Kundkar Pimpri" },
      { id: 546004, name: "Lad Pimpri" },
      { id: 546026, name: "Lakh" },
      { id: 546111, name: "Landala" },
      { id: 546060, name: "Laxmannaik Tanda" },
      { id: 546058, name: "Lohara Bk" },
      { id: 546057, name: "Lohara Kh" },
      { id: 546033, name: "Mahalajgaon" },
      { id: 546075, name: "Mardi" },
      { id: 546014, name: "Matha" },
      { id: 546032, name: "Metha" },
      { id: 546005, name: "Murtijapur Sawangi" },
      { id: 546064, name: "Nageshwadi" },
      { id: 545994, name: "Nagzari" },
      { id: 546082, name: "Nalegaon" },
      { id: 546000, name: "Nandgaon" },
      { id: 546113, name: "Nandkheda" },
      { id: 546040, name: "Nishana" },
      { id: 546031, name: "Pangra Tarf Lakh" },
      { id: 546095, name: "Pardi (Sawali)" },
      { id: 545995, name: "Pazar Tanda" },
      { id: 546109, name: "Perjabad" },
      { id: 546049, name: "Phuldhaba" },
      { id: 546048, name: "Pimpaldari Tarf Nandapur" },
      { id: 546036, name: "Pimpla" },
      { id: 546043, name: "Poor" },
      { id: 546108, name: "Pota Bk." },
      { id: 546107, name: "Pota Kh." },
      { id: 546079, name: "Purjal" },
      { id: 546022, name: "Rajapur" },
      { id: 546053, name: "Rajdari" },
      { id: 546103, name: "Rameshwar" },
      { id: 546086, name: "Ranjala" },
      { id: 546091, name: "Rupur" },
      { id: 546100, name: "Salna" },
      { id: 546059, name: "Sanghanaik Tanda" },
      { id: 546061, name: "Sarangwadi" },
      { id: 546001, name: "Sawali" },
      { id: 546092, name: "Sawali Kh." },
      { id: 546002, name: "Sawali Tanda" },
      { id: 546056, name: "Sawarkheda" },
      { id: 546074, name: "Sendur Sana" },
      { id: 546073, name: "Shirad Shahapur" },
      { id: 546003, name: "Siddheshwar" },
      { id: 546078, name: "Sirala" },
      { id: 546088, name: "Sirala Tanda" },
      { id: 546052, name: "Sonwadi" },
      { id: 546016, name: "Sukapur" },
      { id: 546010, name: "Suregaon" },
      { id: 546009, name: "Surwadi" },
      { id: 546081, name: "Takalgavhan Tarf Aundha" },
      { id: 546077, name: "Takalgavhan Tarf Shahapur" },
      { id: 546019, name: "Talni Pr. Aundha" },
      { id: 546051, name: "Tamtitanda" },
      { id: 546083, name: "Tapowan" },
      { id: 546047, name: "Tembhurdara" },
      { id: 546008, name: "Turk Pimpari" },
      { id: 546115, name: "Ukhali" },
      { id: 546076, name: "Umra" },
      { id: 546105, name: "Undegaon" },
      { id: 546087, name: "Wadad" },
      { id: 545997, name: "Wadchuna" },
      { id: 546066, name: "Wagarwadi" },
      { id: 546020, name: "Walki" },
      { id: 546065, name: "Wangarwadi Tanda" },
      { id: 546029, name: "Wasai" },
      { id: 546028, name: "Yedud" },
      { id: 546038, name: "Yehalegaon (Solanke)" },
      { id: 546101, name: "Yeli" },
    ],
    4114: [
      { id: 546220, name: "Ada" },
      { id: 546214, name: "Akhada Balapur" },
      { id: 546192, name: "Arati" },
      { id: 546181, name: "Asola" },
      { id: 546130, name: "Asolwadi" },
      { id: 546149, name: "Babhali" },
      { id: 546240, name: "Baur" },
      { id: 546196, name: "Belmanda" },
      { id: 546205, name: "Belthar" },
      { id: 546254, name: "Bhategaon" },
      { id: 546230, name: "Bhosi" },
      { id: 546227, name: "Bhurkyachiwadi" },
      { id: 546144, name: "Bibgavhan" },
      { id: 546209, name: "Bibthar" },
      { id: 546182, name: "Bolda" },
      { id: 546183, name: "Boldawadi" },
      { id: 546243, name: "Bothi" },
      { id: 546155, name: "Chapnath" },
      { id: 546217, name: "Chikhali" },
      { id: 546206, name: "Chinchordi" },
      { id: 546175, name: "Chinchoti" },
      { id: 546251, name: "Chuncha" },
      { id: 546233, name: "Dabhadi" },
      { id: 546245, name: "Dandegaon" },
      { id: 546231, name: "Dati" },
      { id: 546141, name: "Devdari" },
      { id: 546216, name: "Devjana" },
      { id: 546131, name: "Dhanora Jahagir" },
      { id: 546135, name: "Dhanora Sarhadd" },
      { id: 546223, name: "Dhardhawanda" },
      { id: 546133, name: "Dholkyachi Wadi" },
      { id: 546158, name: "Dhumka" },
      { id: 546121, name: "Diggi" },
      { id: 546258, name: "Digras Bk." },
      { id: 546207, name: "Digras Tarf Kondur" },
      { id: 546137, name: "Dongargaon Naka" },
      { id: 546213, name: "Dongargaon Pul" },
      { id: 546264, name: "Dongarkada" },
      { id: 546212, name: "Gangaon" },
      { id: 546146, name: "Gangapur" },
      { id: 546117, name: "Garolyachi Wadi" },
      { id: 546147, name: "Gaul Bajar" },
      { id: 546195, name: "Ghoda" },
      { id: 546157, name: "Gholwa" },
      { id: 546186, name: "Gorlegaon" },
      { id: 546247, name: "Gundalwadi" },
      { id: 546177, name: "Harwadi" },
      { id: 546163, name: "Hatmali" },
      { id: 546266, name: "Hiwara Tarf Jawala" },
      { id: 546189, name: "Jamb Tarf Sindgi" },
      { id: 546248, name: "Jamgavhan" },
      { id: 546165, name: "Jamrun" },
      { id: 546194, name: "Jaroda" },
      { id: 546128, name: "Jatalwadi" },
      { id: 546256, name: "Jawala Panchal" },
      { id: 546134, name: "Kadapdeo" },
      { id: 546166, name: "Kalamkonda Kh." },
      { id: 546142, name: "Kalamnuri" },
      { id: 546228, name: "Kalyachi Wadi" },
      { id: 546202, name: "Kamtha" },
      { id: 546229, name: "Kandli" },
      { id: 546218, name: "Kanhegaon" },
      { id: 546210, name: "Kasbe Dhanwada" },
      { id: 546187, name: "Kawada" },
      { id: 546199, name: "Kawadi" },
      { id: 546116, name: "Khadkad Kh" },
      { id: 546145, name: "Khaparkheda" },
      { id: 546179, name: "Kharvi" },
      { id: 546120, name: "Kharwad" },
      { id: 546224, name: "Killewadgaon" },
      { id: 546208, name: "Kondhur" },
      { id: 546244, name: "Koparwadi" },
      { id: 546263, name: "Krishnapur Tarf Jawala" },
      { id: 546215, name: "Krishnapur Tarf Shewala" },
      { id: 546156, name: "Kumbharwadi" },
      { id: 546234, name: "Kumbharwadi Khandoba" },
      { id: 546221, name: "Kupti" },
      { id: 546235, name: "Kurtadi" },
      { id: 546252, name: "Mahalingi" },
      { id: 546118, name: "Mahari Bk" },
      { id: 546122, name: "Mahari Kh." },
      { id: 546242, name: "Maldhawanda" },
      { id: 546152, name: "Malegaon" },
      { id: 546129, name: "Masod" },
      { id: 546178, name: "Mhaisgavhan" },
      { id: 546123, name: "Morgavhan" },
      { id: 546119, name: "Morwad" },
      { id: 546126, name: "Mundhal" },
      { id: 546176, name: "Nandapur" },
      { id: 546193, name: "Narwadi" },
      { id: 546160, name: "Naukha Tarf Kalamnuri" },
      { id: 546188, name: "Nimtok" },
      { id: 546153, name: "Palodi" },
      { id: 546191, name: "Pardi" },
      { id: 546241, name: "Pawanmari" },
      { id: 546225, name: "Pethvadgaon" },
      { id: 546232, name: "Phutana" },
      { id: 546201, name: "Pimpri Bk." },
      { id: 546219, name: "Pimpri Kh." },
      { id: 546185, name: "Potra" },
      { id: 546167, name: "Puyana" },
      { id: 546148, name: "Rahimapur" },
      { id: 546257, name: "Rameshwar" },
      { id: 546246, name: "Rameshwar Tanda" },
      { id: 546127, name: "Ramwadi" },
      { id: 546260, name: "Redgaon" },
      { id: 546169, name: "Renapur" },
      { id: 546222, name: "Rudrawadi" },
      { id: 546174, name: "Rupur" },
      { id: 546154, name: "Sadas Tarf Nandapur" },
      { id: 546259, name: "Salapur" },
      { id: 546173, name: "Salegaon" },
      { id: 546204, name: "Salva" },
      { id: 546211, name: "Sapali" },
      { id: 546171, name: "Sawangi" },
      { id: 546164, name: "Selsura" },
      { id: 546125, name: "Shenodi" },
      { id: 546200, name: "Shewala" },
      { id: 546150, name: "Shiwani Bk." },
      { id: 546143, name: "Shiwani Kh." },
      { id: 546190, name: "Sindgi" },
      { id: 546172, name: "Sodegaon" },
      { id: 546255, name: "Sukliveer" },
      { id: 546170, name: "Takalgavhan" },
      { id: 546124, name: "Takli Kanhoba" },
      { id: 546139, name: "Taroda" },
      { id: 546184, name: "Telangwadi" },
      { id: 546236, name: "Tondapur" },
      { id: 546226, name: "Tovha" },
      { id: 546159, name: "Tuppa" },
      { id: 546162, name: "Umara" },
      { id: 546237, name: "Umardarawadi" },
      { id: 546261, name: "Wadgaon Tarf Jawala" },
      { id: 546140, name: "Wai" },
      { id: 546138, name: "Wakodi" },
      { id: 546250, name: "Waranga Phata" },
      { id: 546168, name: "Waranga Tarf Nandapur" },
      { id: 546265, name: "Warud" },
      { id: 546161, name: "Waspangara" },
      { id: 546262, name: "Wasphal" },
      { id: 546239, name: "Yedsi" },
      { id: 546238, name: "Yedsi Tanda" },
      { id: 546198, name: "Yegaon" },
      { id: 546197, name: "Yelagaon Tukaram" },
      { id: 546180, name: "Yelegaon Gawali" },
      { id: 546203, name: "Yelki" },
      { id: 546151, name: "Zara" },
      { id: 546253, name: "Zunzunwadi" },
    ],
    4115: [
      { id: 546276, name: "Adgaon" },
      { id: 546378, name: "Agdad" },
      { id: 546306, name: "Akoli" },
      { id: 546349, name: "Amba" },
      { id: 546354, name: "Ambala" },
      { id: 546353, name: "Ambanath" },
      { id: 546278, name: "Aral" },
      { id: 546414, name: "Asegaon" },
      { id: 546412, name: "Babhulgaon" },
      { id: 546383, name: "Bagdad" },
      { id: 546315, name: "Balegaon" },
      { id: 546367, name: "Barepurwadi" },
      { id: 546372, name: "Basmat" },
      { id: 546285, name: "Bhategaon" },
      { id: 546360, name: "Bhendegaon" },
      { id: 546320, name: "Bhogaon" },
      { id: 546411, name: "Bhoripgaon" },
      { id: 546365, name: "Borala" },
      { id: 546396, name: "Borgaon Bk." },
      { id: 546398, name: "Borgaon Kh." },
      { id: 546272, name: "Borisawant" },
      { id: 546289, name: "Brahmangaon Bk." },
      { id: 546290, name: "Brahmangaon Kh." },
      { id: 546404, name: "Chandgavhan" },
      { id: 546286, name: "Chikhali" },
      { id: 546312, name: "Chincholi Tarf Akoli" },
      { id: 546399, name: "Chincholi Tarf Malavta" },
      { id: 546338, name: "Chondhi Tarf Sendursena" },
      { id: 546388, name: "Dabhadi" },
      { id: 546307, name: "Dagadgaon" },
      { id: 546416, name: "Dagadpimpri" },
      { id: 546302, name: "Darephal" },
      { id: 546359, name: "Dhamangaon" },
      { id: 546281, name: "Dhanora Tarf Aral" },
      { id: 546275, name: "Dhaulgaon" },
      { id: 546390, name: "Digras Kh." },
      { id: 546339, name: "Donwada" },
      { id: 546319, name: "Ekrukha" },
      { id: 546374, name: "Ganeshpur" },
      { id: 546391, name: "Girgaon" },
      { id: 546379, name: "Govindpur Tarf Hayatnagar" },
      { id: 546268, name: "Gunda" },
      { id: 546407, name: "Gunj Tarf Asegaon" },
      { id: 546313, name: "Hapsapur" },
      { id: 546287, name: "Hatta" },
      { id: 546325, name: "Hayatnagar" },
      { id: 546296, name: "Hiradgaon" },
      { id: 546283, name: "Hisewadgaon" },
      { id: 546418, name: "Hiwara Kh" },
      { id: 546405, name: "Injangaon" },
      { id: 546327, name: "Jawala Bk." },
      { id: 546328, name: "Jawala Kh." },
      { id: 546380, name: "Jawala Traf Babulgaon" },
      { id: 546350, name: "Jununa" },
      { id: 546376, name: "Kagban" },
      { id: 546271, name: "Kalamba" },
      { id: 546368, name: "Kallavi" },
      { id: 546403, name: "Kanhergaon" },
      { id: 546344, name: "Kanosa" },
      { id: 546267, name: "Karanjala" },
      { id: 546269, name: "Karanji" },
      { id: 546284, name: "Kaudgaon" },
      { id: 546364, name: "Kautha" },
      { id: 546392, name: "Khajamapur" },
      { id: 546334, name: "Khambala" },
      { id: 546381, name: "Khandarban" },
      { id: 546310, name: "Khandegaon" },
      { id: 546333, name: "Khapar Kheda" },
      { id: 546395, name: "Khudnapur" },
      { id: 546394, name: "Kinhola" },
      { id: 546280, name: "Konatha" },
      { id: 546355, name: "Korta" },
      { id: 546342, name: "Kothari" },
      { id: 546341, name: "Kotharwadi" },
      { id: 546301, name: "Kudala" },
      { id: 546332, name: "Kupti" },
      { id: 546345, name: "Kurunda" },
      { id: 546346, name: "Kurundwadi" },
      { id: 546386, name: "Lahan" },
      { id: 546323, name: "Lingi" },
      { id: 546305, name: "Loleshwar" },
      { id: 546385, name: "Lon Bk." },
      { id: 546361, name: "Mahagaon" },
      { id: 546363, name: "Mahmadapurwadi" },
      { id: 546402, name: "Malwata" },
      { id: 546415, name: "Marlapur" },
      { id: 546337, name: "Marsul" },
      { id: 546274, name: "Mategaon" },
      { id: 546366, name: "Mhatargaon" },
      { id: 546369, name: "Mohgaon" },
      { id: 546324, name: "Mudi" },
      { id: 546401, name: "Murumba Bk." },
      { id: 546400, name: "Murumba Kh." },
      { id: 546294, name: "Nagapur" },
      { id: 546295, name: "Nahad" },
      { id: 546373, name: "Nasratpur" },
      { id: 546358, name: "Palasgaon Tarf Dhamangaon" },
      { id: 546406, name: "Palasgaon Tarf Malvata" },
      { id: 546326, name: "Palsi" },
      { id: 546329, name: "Pangra Shinde" },
      { id: 546357, name: "Pangra Tarf Dhamangaon" },
      { id: 546309, name: "Pangrasati" },
      { id: 546397, name: "Parajana" },
      { id: 546389, name: "Pardi Bk." },
      { id: 546343, name: "Pardi Kh" },
      { id: 546273, name: "Parli" },
      { id: 546356, name: "Parwa" },
      { id: 546311, name: "Phata" },
      { id: 546370, name: "Phattepur" },
      { id: 546382, name: "Pimpala Choure" },
      { id: 546292, name: "Pimpalgaon Kute" },
      { id: 546362, name: "Pimprala" },
      { id: 546351, name: "Pimpri" },
      { id: 546371, name: "Polka" },
      { id: 546299, name: "Puyani Bk" },
      { id: 546300, name: "Puyani Kh" },
      { id: 546413, name: "Rajapur" },
      { id: 546335, name: "Rajawadi" },
      { id: 546317, name: "Ranjana" },
      { id: 546321, name: "Raywadi" },
      { id: 546384, name: "Renkapur" },
      { id: 546314, name: "Reulgaon" },
      { id: 546282, name: "Ridhura" },
      { id: 546308, name: "Rodga" },
      { id: 546316, name: "Rukhi" },
      { id: 546408, name: "Runj Tarf Asegaon" },
      { id: 546293, name: "Sangmeshwar" },
      { id: 546270, name: "Sangnapur" },
      { id: 546377, name: "Sarola" },
      { id: 546322, name: "Sategaon" },
      { id: 546318, name: "Satephal Tarf Aral" },
      { id: 546288, name: "Sawangi Bk." },
      { id: 546409, name: "Sawargaon" },
      { id: 546348, name: "Selu" },
      { id: 546298, name: "Shingi" },
      { id: 546330, name: "Sirli" },
      { id: 546393, name: "Somthana" },
      { id: 546291, name: "Sonna Tarf Hatta" },
      { id: 546340, name: "Sukali" },
      { id: 546417, name: "Sunegaon" },
      { id: 546410, name: "Takalgaon" },
      { id: 546279, name: "Telgaon" },
      { id: 546304, name: "Tembhurni" },
      { id: 546375, name: "Thorava" },
      { id: 546277, name: "Wadi Tuljapur" },
      { id: 546297, name: "Waghi" },
      { id: 546352, name: "Wai Tarf Dhamangaon" },
      { id: 546387, name: "Wakhari" },
      { id: 546331, name: "Wapti" },
      { id: 546347, name: "Wartala" },
      { id: 546303, name: "Wiregaon" },
    ],
    4116: [
      { id: 546463, name: "Adgaon (Darade)" },
      { id: 546488, name: "Aher Borgaon" },
      { id: 546471, name: "Ambegaon Diger" },
      { id: 546423, name: "Arsad" },
      { id: 546475, name: "Bhangapur" },
      { id: 546469, name: "Borgaon Jahagir" },
      { id: 546420, name: "Borkini" },
      { id: 546438, name: "Both" },
      { id: 546504, name: "Brahmangaon" },
      { id: 546446, name: "Brahmangaon Paragane Partur" },
      { id: 546444, name: "Brahmawakadi" },
      { id: 546439, name: "Chikhalthana Bk" },
      { id: 546440, name: "Chikhalthana Kh" },
      { id: 546492, name: "Dasala" },
      { id: 546486, name: "Deulgaon Gat" },
      { id: 546431, name: "Devgaon" },
      { id: 546509, name: "Dhanegaon" },
      { id: 546511, name: "Dhengli Pimpalgaon" },
      { id: 546499, name: "Digras Bk" },
      { id: 546510, name: "Digras Jahagir" },
      { id: 546500, name: "Digras Kh" },
      { id: 546505, name: "Dugra" },
      { id: 546422, name: "Ganeshpur" },
      { id: 546474, name: "Gavha" },
      { id: 546430, name: "Girgaon Bk" },
      { id: 546429, name: "Girgaon Kh" },
      { id: 546487, name: "Gohegaon" },
      { id: 546478, name: "Gomewakdi" },
      { id: 546424, name: "Gondage Pimpri Bk" },
      { id: 546497, name: "Gugli Dhamangaon" },
      { id: 546467, name: "Gulkhand" },
      { id: 546482, name: "Hadgaon Kh" },
      { id: 546453, name: "Hatnoor" },
      { id: 546465, name: "Hatta" },
      { id: 546496, name: "Hissi" },
      { id: 546441, name: "Jawala Jivaji" },
      { id: 546501, name: "Kajali Rohina" },
      { id: 546464, name: "Kanhad" },
      { id: 546461, name: "Kanherwadi" },
      { id: 546506, name: "Karadgaon" },
      { id: 546477, name: "Karajkheda" },
      { id: 546507, name: "Kawaddhan" },
      { id: 546454, name: "Kemapur" },
      { id: 546447, name: "Khadgaon" },
      { id: 546434, name: "Khairi" },
      { id: 546494, name: "Khavne Pimpri" },
      { id: 546452, name: "Kherda Dudhana Kinara" },
      { id: 546450, name: "Khupsa" },
      { id: 546457, name: "Kuda" },
      { id: 546432, name: "Kumbhari (Pargane Charthana)" },
      { id: 546485, name: "Kundi" },
      { id: 546468, name: "Kupta" },
      { id: 546493, name: "Ladnandra" },
      { id: 546491, name: "Male Takli" },
      { id: 546458, name: "Mapa" },
      { id: 546484, name: "Mhalasapur" },
      { id: 546445, name: "Moregaon" },
      { id: 546433, name: "Nagthana" },
      { id: 546421, name: "Nandgaon (Deogaon)" },
      { id: 546419, name: "Narsapur" },
      { id: 546427, name: "Nilkanth" },
      { id: 546508, name: "Nipani Takali" },
      { id: 546436, name: "Nirwadi Bk" },
      { id: 546437, name: "Nirwadi Kh" },
      { id: 546459, name: "Pardi Kausadi" },
      { id: 546455, name: "Pimpalgaon (Gosavi)" },
      { id: 546480, name: "Pimprala Kh." },
      { id: 546449, name: "Pimpri Bk" },
      { id: 546448, name: "Pimpri Kh" },
      { id: 546495, name: "Radhedhamangaon" },
      { id: 546435, name: "Raipur" },
      { id: 546502, name: "Raja" },
      { id: 546503, name: "Rajewadi" },
      { id: 546462, name: "Rajura" },
      { id: 546483, name: "Ravalgaon" },
      { id: 546456, name: "Rawha" },
      { id: 546451, name: "Salegaon" },
      { id: 546428, name: "Sawangi P.C." },
      { id: 943628, name: "Selu" },
      { id: 546473, name: "Shelwadi" },
      { id: 546490, name: "Shinde Takli" },
      { id: 546489, name: "Siddhanath Borgaon" },
      { id: 546476, name: "Simangaon" },
      { id: 546425, name: "Singthala" },
      { id: 546479, name: "Sirala" },
      { id: 546472, name: "Sonna" },
      { id: 546443, name: "Sonwati" },
      { id: 546442, name: "Taltumba" },
      { id: 546466, name: "Tandulwadi" },
      { id: 546498, name: "Tidi Pimpalgaon" },
      { id: 546426, name: "Wai" },
      { id: 546481, name: "Waki" },
      { id: 546470, name: "Walangwadi" },
      { id: 546460, name: "Walour" },
      { id: 546512, name: "Zodgaon" },
    ],
    4117: [
      { id: 546628, name: "Aadgaon" },
      { id: 546605, name: "Akoli" },
      { id: 546539, name: "Ambarwadi" },
      { id: 943510, name: "Anandwadi" },
      { id: 546548, name: "Angalgaon" },
      { id: 546652, name: "Asegaon" },
      { id: 546520, name: "Asola" },
      { id: 546535, name: "Badanapur" },
      { id: 546604, name: "Balasa" },
      { id: 546533, name: "Bamani Bk" },
      { id: 546517, name: "Belkheda" },
      { id: 546607, name: "Belkheda Jintur Circle" },
      { id: 546568, name: "Belura" },
      { id: 546574, name: "Bhambri" },
      { id: 546600, name: "Bhilaj" },
      { id: 946057, name: "Bhimanaik Tanda" },
      { id: 546634, name: "Bhogaon" },
      { id: 546557, name: "Bhosi" },
      { id: 546626, name: "Bhusakvadi" },
      { id: 546648, name: "Bordi" },
      { id: 546542, name: "Borgalwadi" },
      { id: 546661, name: "Bori" },
      { id: 546544, name: "Brahmangaon" },
      { id: 546636, name: "Chamani" },
      { id: 546658, name: "Chandaj" },
      { id: 546565, name: "Charthana" },
      { id: 546534, name: "Chaudharni Bk" },
      { id: 546641, name: "Chincholi Darade" },
      { id: 546638, name: "Chincholi Ghute" },
      { id: 546609, name: "Chincholi Kale" },
      { id: 546640, name: "Chitnarwadi" },
      { id: 546621, name: "Dabha" },
      { id: 546569, name: "Dagadchop" },
      { id: 546541, name: "Dahegaon" },
      { id: 546646, name: "Devgaon (Dhanora)" },
      { id: 546639, name: "Devsadi" },
      { id: 546514, name: "Dhamdham" },
      { id: 546522, name: "Dhanora Bk." },
      { id: 546645, name: "Dhanora Devgaon" },
      { id: 546523, name: "Dhanora Kh" },
      { id: 546651, name: "Dhopatwadi" },
      { id: 546620, name: "Digras" },
      { id: 546663, name: "Dohara" },
      { id: 546616, name: "Dongartala" },
      { id: 546606, name: "Donwada" },
      { id: 546682, name: "Dudhagaon" },
      { id: 546672, name: "Dudhangaon" },
      { id: 546622, name: "Gadadgavhan" },
      { id: 546591, name: "Ganeshnagar" },
      { id: 546666, name: "Ganpur" },
      { id: 546556, name: "Garkheda" },
      { id: 546588, name: "Ghadoli" },
      { id: 546527, name: "Ghagara" },
      { id: 546598, name: "Ghewanda" },
      { id: 546668, name: "Gondhala" },
      { id: 945182, name: "Gorwadi Pragane Karvali" },
      { id: 546572, name: "Halvira" },
      { id: 546513, name: "Handi" },
      { id: 546543, name: "Hanwatkheda" },
      { id: 546586, name: "Hiwarkheda" },
      { id: 546618, name: "Itoli" },
      { id: 546581, name: "Jamb Bk" },
      { id: 546579, name: "Jamb Kh" },
      { id: 546552, name: "Jambhrun" },
      { id: 546676, name: "Jawla Kh." },
      { id: 943454, name: "Jintur" },
      { id: 546562, name: "Jogawada" },
      { id: 546633, name: "Jununwadi" },
      { id: 546656, name: "Kadsawangi" },
      { id: 546553, name: "Kanha" },
      { id: 546540, name: "Karanji" },
      { id: 546664, name: "Karvali" },
      { id: 546650, name: "Kasar" },
      { id: 546683, name: "Kaudgaon P.Zari" },
      { id: 546681, name: "Kaudgaon Pr.Aundha" },
      { id: 546669, name: "Kausadi" },
      { id: 546521, name: "Kawada" },
      { id: 546538, name: "Kawatha" },
      { id: 546528, name: "Kawi" },
      { id: 546592, name: "Kehal" },
      { id: 546615, name: "Kharadadi" },
      { id: 546587, name: "Kholgadga" },
      { id: 546583, name: "Kinhi" },
      { id: 546665, name: "Kok" },
      { id: 546532, name: "Kolapa" },
      { id: 546582, name: "Koldandi" },
      { id: 546529, name: "Korwadi" },
      { id: 546550, name: "Kotha" },
      { id: 546531, name: "Kumbephal" },
      { id: 546673, name: "Kumbhari" },
      { id: 546545, name: "Kurhadi" },
      { id: 546642, name: "Limbala" },
      { id: 546678, name: "Mak" },
      { id: 546674, name: "Malegaon (Bori Circle)" },
      { id: 546576, name: "Malegaon (Jintur Circle)" },
      { id: 546617, name: "Mandawa" },
      { id: 546635, name: "Mandhani" },
      { id: 943621, name: "Mangalwadi" },
      { id: 546660, name: "Mangarul" },
      { id: 546573, name: "Mankeshwar" },
      { id: 546594, name: "Mankeshwar Kakde" },
      { id: 546577, name: "Manmodi" },
      { id: 546670, name: "Marwadi" },
      { id: 546603, name: "Mathala" },
      { id: 546551, name: "Mohadi" },
      { id: 546623, name: "Mohkhed" },
      { id: 546624, name: "Mohkhed Tanda" },
      { id: 546570, name: "Mola" },
      { id: 546662, name: "Muda" },
      { id: 546584, name: "Murumkheda" },
      { id: 546647, name: "Nagangaon" },
      { id: 546614, name: "Nagapur" },
      { id: 546667, name: "Nagthana" },
      { id: 546675, name: "Nandgaon (E)" },
      { id: 546526, name: "Navhati Tanda" },
      { id: 546589, name: "Nilaj" },
      { id: 546655, name: "Niwali Bk." },
      { id: 546654, name: "Niwali Kh." },
      { id: 546610, name: "Pachalegaon" },
      { id: 546643, name: "Pachegaon" },
      { id: 546611, name: "Palaskheda" },
      { id: 546561, name: "Pandhargala" },
      { id: 546602, name: "Pangri" },
      { id: 943620, name: "Pathwadi" },
      { id: 546671, name: "Pimpalgaon Gayake" },
      { id: 546547, name: "Pimpalgaon Kajale" },
      { id: 546608, name: "Pimprala" },
      { id: 546571, name: "Pimpri Kh" },
      { id: 546680, name: "Pimpri Rohila" },
      { id: 546630, name: "Pokharni" },
      { id: 546599, name: "Pungala" },
      { id: 946058, name: "Radhanagari Tanda" },
      { id: 546578, name: "Raikheda" },
      { id: 546575, name: "Rajegaon" },
      { id: 946060, name: "Ramnaik Tanda" },
      { id: 546613, name: "Reedaj" },
      { id: 546644, name: "Repa" },
      { id: 546516, name: "Saikheda" },
      { id: 546580, name: "Saikheda Bori" },
      { id: 912649, name: "Sainagar Tanda" },
      { id: 546558, name: "Sakhartala" },
      { id: 546632, name: "Sangalewadi" },
      { id: 546530, name: "Sankrala" },
      { id: 546590, name: "Sawali Bk" },
      { id: 546585, name: "Sawangi (Mhalsa)" },
      { id: 546519, name: "Sawangi Bhamble" },
      { id: 546555, name: "Sawargaon" },
      { id: 546554, name: "Sawargaon Tanda" },
      { id: 546679, name: "Sek" },
      { id: 943623, name: "Shahapurwadi" },
      { id: 546595, name: "Shevadi" },
      { id: 546567, name: "Shivachiwadi" },
      { id: 546653, name: "Sonna" },
      { id: 546625, name: "Sorja" },
      { id: 546564, name: "Sos" },
      { id: 546563, name: "Sostanda" },
      { id: 546601, name: "Sukali" },
      { id: 546627, name: "Takalkhopa" },
      { id: 546612, name: "Tathapur" },
      { id: 546518, name: "Umarad" },
      { id: 546524, name: "Vadi" },
      { id: 946062, name: "Wadachi Wadi" },
      { id: 546560, name: "Wadali" },
      { id: 546629, name: "Waddhuti" },
      { id: 546677, name: "Waghi (Bobde)" },
      { id: 546525, name: "Waghi (Dhanora)" },
      { id: 943622, name: "Waghwadi" },
      { id: 546659, name: "Warna" },
      { id: 546559, name: "Warud" },
      { id: 546649, name: "Wassa" },
      { id: 546515, name: "Wazar Bk" },
      { id: 546596, name: "Yenoli" },
      { id: 546657, name: "Yesegaon" },
    ],
    4118: [
      { id: 546702, name: "Aland" },
      { id: 546740, name: "Alapur Pandhari" },
      { id: 546782, name: "Amadapur" },
      { id: 546797, name: "Ambetakli" },
      { id: 546787, name: "Anandwadi" },
      { id: 546813, name: "Angalgaon" },
      { id: 546694, name: "Arvi" },
      { id: 546759, name: "Asola" },
      { id: 546746, name: "Babhali" },
      { id: 546770, name: "Babhulgaon" },
      { id: 546768, name: "Balsa Kh." },
      { id: 546793, name: "Bharaswad" },
      { id: 546700, name: "Bhogaon" },
      { id: 546790, name: "Borwand Bk." },
      { id: 546784, name: "Borwand Kh." },
      { id: 546765, name: "Bramhangaon" },
      { id: 546766, name: "Bramhapuri Tarf Lohgaon" },
      { id: 546807, name: "Bramhapuri Tarf Pathri" },
      { id: 546698, name: "Bramhapuri Tarf Pedgaon" },
      { id: 546769, name: "Dafwadi" },
      { id: 546809, name: "Daithana" },
      { id: 546803, name: "Dampuri" },
      { id: 546737, name: "Deothana" },
      { id: 546728, name: "Dhar" },
      { id: 546726, name: "Dharangaon" },
      { id: 546761, name: "Dharmapuri" },
      { id: 546812, name: "Dhasadi" },
      { id: 546810, name: "Dhondi" },
      { id: 546688, name: "Digras" },
      { id: 546735, name: "Durdi" },
      { id: 546692, name: "Ekrukha Tarf Pedgaon" },
      { id: 546705, name: "Gavha" },
      { id: 546720, name: "Gokulwadi" },
      { id: 546690, name: "Govindpur" },
      { id: 546706, name: "Hasnapur" },
      { id: 546724, name: "Hingla" },
      { id: 546806, name: "Indewadi" },
      { id: 546693, name: "Ismailpur" },
      { id: 546776, name: "Ithalapur Deshmukh" },
      { id: 546718, name: "Jalalpur" },
      { id: 546763, name: "Jamb" },
      { id: 546799, name: "Jawala" },
      { id: 546713, name: "Jod Parli" },
      { id: 546727, name: "Karadgaon" },
      { id: 546760, name: "Karegaon" },
      { id: 546686, name: "Karla" },
      { id: 546685, name: "Kashtagaon" },
      { id: 546764, name: "Kaudgaon" },
      { id: 944981, name: "Khanapur" },
      { id: 546719, name: "Khanapur Tarf Zari" },
      { id: 546699, name: "Kinhola" },
      { id: 546687, name: "Kumbhari" },
      { id: 546781, name: "Lohagaon" },
      { id: 546811, name: "Malsonna" },
      { id: 546701, name: "Mandakhali" },
      { id: 546708, name: "Mandwa" },
      { id: 546725, name: "Mangangaon" },
      { id: 546731, name: "Matakarala" },
      { id: 546748, name: "Mirkhel" },
      { id: 546710, name: "Mirzapur" },
      { id: 546703, name: "Mohapuri" },
      { id: 546736, name: "Murumba" },
      { id: 546774, name: "Nagapur" },
      { id: 546721, name: "Nandapur" },
      { id: 546739, name: "Nandgaon Bk." },
      { id: 546741, name: "Nandgaon Kh." },
      { id: 546757, name: "Nandkheda" },
      { id: 546773, name: "Narsapur" },
      { id: 546696, name: "Narsapur Tarf Pedgaon" },
      { id: 546754, name: "Pandhari" },
      { id: 546704, name: "Panhera" },
      { id: 546779, name: "Paralgavhan" },
      { id: 546762, name: "Parawa" },
      { id: 943624, name: "Parbhani" },
      { id: 546755, name: "Pathra" },
      { id: 546697, name: "Pedgaon" },
      { id: 546792, name: "Pegargavhan" },
      { id: 546691, name: "Pimpalgaon Sayyadmia" },
      { id: 546785, name: "Pimpalgaon Thombare" },
      { id: 546734, name: "Pimpalgaon Tong" },
      { id: 546745, name: "Pimpari Deshmukh" },
      { id: 546717, name: "Pimpla" },
      { id: 546749, name: "Pingali" },
      { id: 546712, name: "Pingli Kothala" },
      { id: 546796, name: "Pokharni" },
      { id: 546804, name: "Porwad" },
      { id: 546753, name: "Purjawala" },
      { id: 546742, name: "Rahati" },
      { id: 546767, name: "Raipur" },
      { id: 546738, name: "Saba" },
      { id: 546711, name: "Sadegaon" },
      { id: 546798, name: "Sahajpur" },
      { id: 546808, name: "Salapuri" },
      { id: 546732, name: "Sambar" },
      { id: 546729, name: "Samsapur" },
      { id: 546723, name: "Sanpuri" },
      { id: 546689, name: "Sarangapur" },
      { id: 546730, name: "Satla" },
      { id: 546715, name: "Sawangi Kh." },
      { id: 546777, name: "Sayala" },
      { id: 546750, name: "Sendra" },
      { id: 546695, name: "Shahapur" },
      { id: 546783, name: "Singnapur" },
      { id: 546801, name: "Sirsi Bk." },
      { id: 546800, name: "Sirsi Kh." },
      { id: 546771, name: "Sonna" },
      { id: 546733, name: "Sukapurwadi" },
      { id: 546722, name: "Sultanpur" },
      { id: 546789, name: "Surpimpari" },
      { id: 546751, name: "Tadlimbla" },
      { id: 546791, name: "Tadpangari" },
      { id: 546778, name: "Takalgavhan" },
      { id: 546714, name: "Takli Bobade" },
      { id: 546756, name: "Takli Kumbhakarna" },
      { id: 546788, name: "Tamaswadi" },
      { id: 546775, name: "Taroda" },
      { id: 546747, name: "Tattu Jawala" },
      { id: 546802, name: "Thola" },
      { id: 546707, name: "Tuljapur" },
      { id: 546772, name: "Ujalamba" },
      { id: 546744, name: "Ukhalad" },
      { id: 546795, name: "Ukhaladwadi" },
      { id: 546786, name: "Umari" },
      { id: 546752, name: "Varpud" },
      { id: 546794, name: "Wadgaon Tarf Bharaswad" },
      { id: 546684, name: "Wadgaon Tarf Takli" },
      { id: 546716, name: "Wadidamai" },
      { id: 546758, name: "Wangi" },
      { id: 546780, name: "Zadgaon" },
      { id: 546709, name: "Zari" },
    ],
    4119: [
      { id: 546836, name: "Ambegaon Chaharum" },
      { id: 546826, name: "Atola" },
      { id: 546855, name: "Bhosa" },
      { id: 546842, name: "Bondarwadi" },
      { id: 546835, name: "Deulgaon Awachar" },
      { id: 546814, name: "Gogalgaon" },
      { id: 546863, name: "Hamadapur" },
      { id: 546867, name: "Hatkarwadi" },
      { id: 546837, name: "Hattalwadi" },
      { id: 546823, name: "Irlad" },
      { id: 546840, name: "Itali" },
      { id: 546854, name: "Jangamwadi" },
      { id: 546829, name: "Karanji" },
      { id: 546849, name: "Kekar Jawala" },
      { id: 546851, name: "Khadakwadi" },
      { id: 546830, name: "Kharba" },
      { id: 546850, name: "Kinhola Bk" },
      { id: 546825, name: "Kolha" },
      { id: 546833, name: "Kolhawadi" },
      { id: 546821, name: "Kothala" },
      { id: 546860, name: "Kumbhari" },
      { id: 546853, name: "Lohara" },
      { id: 546848, name: "Mandewadgaon" },
      { id: 546856, name: "Mangrul Bk" },
      { id: 546816, name: "Mangrul Palampat" },
      { id: 546828, name: "Manoli" },
      { id: 546831, name: "Manwat" },
      { id: 546841, name: "Nagar Jawala" },
      { id: 546822, name: "Narlad" },
      { id: 546845, name: "Palodi" },
      { id: 546818, name: "Pardi (P.Takli)" },
      { id: 546847, name: "Pimpla" },
      { id: 546852, name: "Pohandul" },
      { id: 546820, name: "Rajura" },
      { id: 546857, name: "Rametakli" },
      { id: 546866, name: "Rampuri Bk" },
      { id: 546838, name: "Ratnapur" },
      { id: 546832, name: "Rudhi" },
      { id: 546865, name: "Sakharewadi" },
      { id: 546864, name: "Sarangapur" },
      { id: 546843, name: "Sawali" },
      { id: 546815, name: "Sawangi Magar" },
      { id: 546844, name: "Sawargaon Kh" },
      { id: 546819, name: "Shevadi Jahagir" },
      { id: 546827, name: "Somthana" },
      { id: 546846, name: "Sonula" },
      { id: 546834, name: "Tad Borgaon" },
      { id: 546817, name: "Takli Nilwarne" },
      { id: 546862, name: "Thar" },
      { id: 546839, name: "Ukkalgaon" },
      { id: 546861, name: "Wangi" },
      { id: 546858, name: "Wazur Bk" },
      { id: 546859, name: "Wazur Kh" },
    ],
    4120: [
      { id: 546923, name: "Anandnagar (Vitatanda)" },
      { id: 546911, name: "Andhapuri" },
      { id: 546908, name: "Babhulgaon" },
      { id: 546897, name: "Babultar" },
      { id: 546893, name: "Bandarwada" },
      { id: 546885, name: "Banegaon" },
      { id: 546874, name: "Borgavhan" },
      { id: 546907, name: "Chate Pimpalgaon" },
      { id: 546915, name: "Dakupimpri" },
      { id: 546871, name: "Devegaon" },
      { id: 546894, name: "Devnandra" },
      { id: 546900, name: "Dhalegaon" },
      { id: 546868, name: "Dongargaon" },
      { id: 546888, name: "Gopegaon" },
      { id: 546910, name: "Goundgaon" },
      { id: 546903, name: "Gunj Kh" },
      { id: 546878, name: "Hadgaon Bk" },
      { id: 546898, name: "Jaitapurwadi" },
      { id: 546882, name: "Jawala Zute" },
      { id: 546913, name: "Kansur" },
      { id: 546881, name: "Kasapuri" },
      { id: 546875, name: "Khedula" },
      { id: 546892, name: "Kherda" },
      { id: 546869, name: "Kinhola Kh" },
      { id: 546917, name: "Limba" },
      { id: 546919, name: "Limba Tanda" },
      { id: 546909, name: "Loni Bk" },
      { id: 943626, name: "Maliwada" },
      { id: 546884, name: "Manjarath" },
      { id: 546886, name: "Mardasgaon" },
      { id: 546901, name: "Masala Tanda" },
      { id: 546902, name: "Masla Kh" },
      { id: 546921, name: "Mudgal" },
      { id: 546883, name: "Nathara" },
      { id: 546890, name: "Niwali" },
      { id: 546887, name: "Pathargavhan Bk" },
      { id: 546880, name: "Pathargavhan Kh" },
      { id: 943625, name: "Pathri" },
      { id: 546889, name: "Patoda Ganga Kinara" },
      { id: 546918, name: "Phularwadi" },
      { id: 546895, name: "Pohetakli" },
      { id: 546891, name: "Rampuri Kh" },
      { id: 546870, name: "Renakhali" },
      { id: 546896, name: "Renapur" },
      { id: 546906, name: "Sarola Bk" },
      { id: 546876, name: "Sarola Kh" },
      { id: 546872, name: "Simurgavhan" },
      { id: 546904, name: "Takalgavhan Tanda" },
      { id: 546916, name: "Tarugavhan" },
      { id: 546899, name: "Tura" },
      { id: 546912, name: "Umara" },
      { id: 546877, name: "Vadi" },
      { id: 546922, name: "Vita Bk" },
      { id: 546920, name: "Waghala" },
      { id: 546879, name: "Warkheda" },
      { id: 546873, name: "Zari" },
    ],
    4121: [
      { id: 546966, name: "Awalgaon" },
      { id: 546959, name: "Bhisegaon" },
      { id: 546968, name: "Bondargaon" },
      { id: 546979, name: "Buktarwadi" },
      { id: 546958, name: "Chukar Pimpri" },
      { id: 943630, name: "Dahikhed" },
      { id: 546954, name: "Devinagar" },
      { id: 546969, name: "Dhamoni" },
      { id: 546947, name: "Dhar Dighol" },
      { id: 546945, name: "Dighol Islampur" },
      { id: 546949, name: "Dobadi Tanda" },
      { id: 546925, name: "Dudhgaon" },
      { id: 546932, name: "Gangapimpri" },
      { id: 546942, name: "Gawali Pimpri" },
      { id: 546933, name: "Golegaon" },
      { id: 546948, name: "Kanhegaon" },
      { id: 546975, name: "Karam" },
      { id: 546950, name: "Khadka" },
      { id: 546943, name: "Khapat Pimpri" },
      { id: 546960, name: "Kortek" },
      { id: 546956, name: "Kothala" },
      { id: 546928, name: "Lasina" },
      { id: 546934, name: "Lohigram" },
      { id: 546974, name: "Margalwadi" },
      { id: 546961, name: "Mohala" },
      { id: 546967, name: "Naikota" },
      { id: 546955, name: "Narwadi" },
      { id: 546971, name: "Nila" },
      { id: 546944, name: "Nimgaon" },
      { id: 546978, name: "Paradhwadi" },
      { id: 546962, name: "Pohandul" },
      { id: 546963, name: "Pohandul Tanda" },
      { id: 546951, name: "Saikheda" },
      { id: 546939, name: "Shelgaon Hatkar" },
      { id: 546941, name: "Shelgaon Maratha" },
      { id: 546938, name: "Sirori" },
      { id: 546936, name: "Sirsi Bk." },
      { id: 944982, name: "Sonkhed" },
      { id: 943629, name: "Sonpeth" },
      { id: 546931, name: "Thadi Pimpalgaon" },
      { id: 546929, name: "Thadiukkadgaon" },
      { id: 546964, name: "Tiwathana" },
      { id: 546977, name: "Ukhali Bk." },
      { id: 546976, name: "Ukkadgaon Makta" },
      { id: 546926, name: "Vita Kh." },
      { id: 546972, name: "Wadgaon" },
      { id: 546970, name: "Wadi Naikata" },
      { id: 546930, name: "Wadi Pimpalgaon" },
      { id: 546927, name: "Waghalgaon (J)" },
      { id: 546973, name: "Waitagwadi" },
      { id: 546965, name: "Wandan" },
      { id: 546924, name: "Wanisangam" },
    ],
    4122: [
      { id: 547026, name: "Akoli" },
      { id: 547001, name: "Anandwadi (Mahatpuri)" },
      { id: 547086, name: "Anandwadi (Pimpaldari)" },
      { id: 547041, name: "Antarweli" },
      { id: 547051, name: "Arbujwadi" },
      { id: 547039, name: "Badwani" },
      { id: 547012, name: "Banpimpla" },
      { id: 547068, name: "Belwadi" },
      { id: 546999, name: "Bhambarwadi" },
      { id: 547025, name: "Bhendewadi" },
      { id: 547081, name: "Borda" },
      { id: 547057, name: "Bothi" },
      { id: 547056, name: "Bothi Tanda" },
      { id: 546987, name: "Brahmanathwadi" },
      { id: 547066, name: "Chilgarwadi" },
      { id: 546990, name: "Chinchtakli" },
      { id: 547013, name: "Dagadwadi" },
      { id: 547078, name: "Dampuri" },
      { id: 547050, name: "Devkatwadi" },
      { id: 547028, name: "Dhangarmoha" },
      { id: 546981, name: "Dharasur" },
      { id: 546998, name: "Dharkhed" },
      { id: 547049, name: "Dhavlkewadi" },
      { id: 547031, name: "Dhebewadi (Thagyachiwadi)" },
      { id: 547032, name: "Dongargaon Shelgaon" },
      { id: 547035, name: "Dongarjawla" },
      { id: 547036, name: "Dongarpimpla" },
      { id: 546991, name: "Dusalgaon" },
      { id: 547003, name: "Gangakhed" },
      { id: 547077, name: "Gaulwadi" },
      { id: 546989, name: "Gaundgaon" },
      { id: 547070, name: "Ghantagra" },
      { id: 547069, name: "Ghatangra Tanda" },
      { id: 547023, name: "Godavari Tanda" },
      { id: 547006, name: "Gopa" },
      { id: 547058, name: "Gunjegaon" },
      { id: 547082, name: "Hanuman Nagar" },
      { id: 547019, name: "Harangul" },
      { id: 547053, name: "Ilegaon" },
      { id: 547004, name: "Iralad" },
      { id: 547048, name: "Isad" },
      { id: 546983, name: "Jawla Rumna" },
      { id: 547045, name: "Kadyachiwadi" },
      { id: 547072, name: "Kanganewadi" },
      { id: 547022, name: "Kasarwadi" },
      { id: 547042, name: "Katkarwadi" },
      { id: 547011, name: "Kaudgaon" },
      { id: 547020, name: "Khadgaon" },
      { id: 546986, name: "Khali" },
      { id: 547052, name: "Khandali" },
      { id: 547063, name: "Khokalewadi" },
      { id: 547037, name: "Kodri" },
      { id: 547079, name: "Kundgirwadi" },
      { id: 547059, name: "Limbewadi" },
      { id: 547060, name: "Limbewadi Tanda" },
      { id: 547000, name: "Mahatpuri" },
      { id: 546988, name: "Mairalsawangi" },
      { id: 547033, name: "Makhani" },
      { id: 547008, name: "Malewadi" },
      { id: 547030, name: "Mankadevi" },
      { id: 547047, name: "Maragalwadi (Wagade)" },
      { id: 547009, name: "Mardasgaon" },
      { id: 547021, name: "Margalwadi" },
      { id: 547054, name: "Masanerwadi" },
      { id: 546994, name: "Masla" },
      { id: 546992, name: "Muli" },
      { id: 546993, name: "Nagthana" },
      { id: 547005, name: "Narlad" },
      { id: 547080, name: "Nilanaik Tanda" },
      { id: 547016, name: "Padegaon" },
      { id: 547061, name: "Pandhargaon" },
      { id: 547073, name: "Pangri" },
      { id: 547076, name: "Phugnarwadi" },
      { id: 547083, name: "Pimpaldari" },
      { id: 546996, name: "Pimpri Zola" },
      { id: 547027, name: "Pokharni Walkya" },
      { id: 546995, name: "Pota" },
      { id: 547071, name: "Ranisawargaon" },
      { id: 546982, name: "Rumna Jawla" },
      { id: 547046, name: "Sanglewadi" },
      { id: 546984, name: "Sayala Sunegaon" },
      { id: 547002, name: "Shankarwadi" },
      { id: 547044, name: "Shelmoha" },
      { id: 547018, name: "Shendga" },
      { id: 547014, name: "Shivajinagar" },
      { id: 547034, name: "Sirsam Shegaon" },
      { id: 546985, name: "Sunegaon Sayala" },
      { id: 547067, name: "Suppa (Jagir)" },
      { id: 547064, name: "Suppa (Khalsa)" },
      { id: 547065, name: "Suppa Tanda" },
      { id: 547015, name: "Suralwadi" },
      { id: 547074, name: "Takalwadi" },
      { id: 547043, name: "Tandulwadi" },
      { id: 547024, name: "Tokwadi" },
      { id: 547029, name: "Ukhali Kh." },
      { id: 547017, name: "Umalanaik Tanda" },
      { id: 547075, name: "Umbarwadi" },
      { id: 547040, name: "Undegaon" },
      { id: 547010, name: "Vitthalwadi" },
      { id: 547062, name: "Wagdara" },
      { id: 547084, name: "Wagdari" },
      { id: 547007, name: "Waghalgaon" },
      { id: 547085, name: "Waghdara Tanda" },
      { id: 547055, name: "Warvanti" },
      { id: 546997, name: "Zola" },
    ],
    4123: [
      { id: 547131, name: "Adgaon" },
      { id: 547116, name: "Ajamabad" },
      { id: 547135, name: "Anandwadi" },
      { id: 547120, name: "Anjanwadi" },
      { id: 547092, name: "Arkhed" },
      { id: 547138, name: "Bandarwadi" },
      { id: 547159, name: "Banwas" },
      { id: 547097, name: "Barbadi" },
      { id: 547146, name: "Bhalkudki" },
      { id: 547100, name: "Bhogaon" },
      { id: 547148, name: "Borgaon Bk." },
      { id: 547155, name: "Borgaon Kh" },
      { id: 547136, name: "Chatori" },
      { id: 547153, name: "Chorwad" },
      { id: 547089, name: "Dhanewadi" },
      { id: 547128, name: "Dhupa" },
      { id: 547096, name: "Digras" },
      { id: 547164, name: "Dongargaon (Palam)" },
      { id: 547102, name: "Dutka" },
      { id: 547161, name: "Fattunaik Tanda" },
      { id: 547117, name: "Ganeshwadi" },
      { id: 547111, name: "Ghoda" },
      { id: 547160, name: "Girdharwadi" },
      { id: 547109, name: "Gulkhand" },
      { id: 547103, name: "Gunj" },
      { id: 547110, name: "Jawla" },
      { id: 547149, name: "Jogalgaon" },
      { id: 547132, name: "Kandalgaon" },
      { id: 547115, name: "Kapsi" },
      { id: 547139, name: "Khadi" },
      { id: 547105, name: "Kharab Dhanora" },
      { id: 547140, name: "Khoras" },
      { id: 547090, name: "Khurlewadi" },
      { id: 547124, name: "Kolwadi" },
      { id: 547147, name: "Konerwadi" },
      { id: 547167, name: "Landakwadi" },
      { id: 547166, name: "Mahadewadi" },
      { id: 547156, name: "Martandwadi" },
      { id: 547158, name: "Mozamabad" },
      { id: 547144, name: "Mutkhed" },
      { id: 547137, name: "Navha" },
      { id: 547133, name: "Navhalgaon" },
      { id: 547119, name: "Palam" },
      { id: 547104, name: "Parwa" },
      { id: 547126, name: "Pendu Bk." },
      { id: 547125, name: "Pendu Kh." },
      { id: 547121, name: "Peth Shivani" },
      { id: 547129, name: "Pethpimpalgaon" },
      { id: 547094, name: "Phala" },
      { id: 547095, name: "Pharkanda" },
      { id: 547099, name: "Pimpalgaon Muruddev" },
      { id: 547154, name: "Pokharni Devi" },
      { id: 547118, name: "Puyani" },
      { id: 547101, name: "Rahati" },
      { id: 547163, name: "Ramapur" },
      { id: 547088, name: "Raorajur" },
      { id: 547114, name: "Rokadewadi" },
      { id: 547168, name: "Sadgirwadi" },
      { id: 547142, name: "Sadlapur" },
      { id: 547127, name: "Sarfrajpur" },
      { id: 547122, name: "Sategaon" },
      { id: 547087, name: "Sawangi Bhujbal" },
      { id: 547098, name: "Sawangi Thadi" },
      { id: 547113, name: "Sayala (Palam)" },
      { id: 547123, name: "Selu" },
      { id: 547106, name: "Sheikhrajura" },
      { id: 547143, name: "Sipegaon" },
      { id: 547112, name: "Sirpur" },
      { id: 547157, name: "Sirsam" },
      { id: 547093, name: "Someshawar" },
      { id: 547141, name: "Tambulgaon" },
      { id: 547165, name: "Tandulwadi" },
      { id: 547130, name: "Teljapur" },
      { id: 547150, name: "Ukkadgaon Jagir" },
      { id: 547091, name: "Umarthadi" },
      { id: 547145, name: "Umra" },
      { id: 547134, name: "Vanbhujwadi" },
      { id: 547108, name: "Wadi (Kh)" },
      { id: 547107, name: "Wadi {Bk}" },
      { id: 547151, name: "Warkhed" },
    ],
    4124: [
      { id: 547225, name: "Adgaon Lasina" },
      { id: 547196, name: "Adgaon Sugaon" },
      { id: 547172, name: "Aherwadi" },
      { id: 547227, name: "Ajdapur" },
      { id: 547203, name: "Alegaon" },
      { id: 547182, name: "Avhai" },
      { id: 547235, name: "Balsa Bk." },
      { id: 547260, name: "Banegaon" },
      { id: 547185, name: "Barbadi" },
      { id: 547226, name: "Bhategaon" },
      { id: 547204, name: "Changephal" },
      { id: 547199, name: "Chudawa" },
      { id: 547252, name: "Dagadwadi" },
      { id: 547242, name: "Dastapur" },
      { id: 547179, name: "Degaon" },
      { id: 547256, name: "Deulgaon Dhudhate" },
      { id: 547255, name: "Devthana" },
      { id: 547233, name: "Dhangar Takli" },
      { id: 547261, name: "Dhanora Kale" },
      { id: 547211, name: "Dhanora Motya" },
      { id: 547192, name: "Dhotra" },
      { id: 547223, name: "Ekrukha" },
      { id: 547218, name: "Ganpur" },
      { id: 547197, name: "Gaur" },
      { id: 547257, name: "Golegaon Palam" },
      { id: 547195, name: "Govindpur" },
      { id: 547250, name: "Hatkarwadi" },
      { id: 547222, name: "Hatkarwadi Khujada" },
      { id: 547190, name: "Hiwara Bk." },
      { id: 547219, name: "Ismailpur" },
      { id: 547243, name: "Ithalapur Mali" },
      { id: 547249, name: "Kalgaon" },
      { id: 547201, name: "Kalmula" },
      { id: 547241, name: "Kamlapur" },
      { id: 547224, name: "Kanadkhed" },
      { id: 547216, name: "Kanhegaon" },
      { id: 547229, name: "Kantheshwar" },
      { id: 547212, name: "Karjanapur" },
      { id: 547173, name: "Katneshwar" },
      { id: 547177, name: "Kaudgaon Tarf Purna" },
      { id: 547208, name: "Kaulgaon Wadi" },
      { id: 547207, name: "Kawalgaon" },
      { id: 547237, name: "Khambegaon" },
      { id: 547251, name: "Khandala" },
      { id: 547253, name: "Kharbada" },
      { id: 547221, name: "Khujada" },
      { id: 547176, name: "Laxmannagar" },
      { id: 547244, name: "Limla" },
      { id: 547189, name: "Lon Kh." },
      { id: 547248, name: "Mahagaon" },
      { id: 547236, name: "Mahatpuri" },
      { id: 547259, name: "Maher" },
      { id: 547245, name: "Majalapur" },
      { id: 547240, name: "Makhani" },
      { id: 547214, name: "Mamdapur" },
      { id: 547184, name: "Marsul Traf Lasina" },
      { id: 547180, name: "Mategaon" },
      { id: 547230, name: "Mithapur" },
      { id: 547258, name: "Mumber" },
      { id: 547198, name: "Narhapur" },
      { id: 547178, name: "Nawaki" },
      { id: 547228, name: "Nila" },
      { id: 547170, name: "Pandhari Tarf Navki" },
      { id: 547187, name: "Pangra Lasina" },
      { id: 547210, name: "Penur" },
      { id: 547217, name: "Phukatgaon" },
      { id: 547246, name: "Phulkalas" },
      { id: 547200, name: "Pimpala Bhatya" },
      { id: 547183, name: "Pimpala Lokhande" },
      { id: 547175, name: "Pimpalgaon Balapur" },
      { id: 547234, name: "Pimpalgaon Likha" },
      { id: 547202, name: "Pimpran" },
      { id: 943627, name: "Purna" },
      { id: 547220, name: "Ramapur" },
      { id: 547191, name: "Regaon" },
      { id: 547206, name: "Runj" },
      { id: 547193, name: "Rupla" },
      { id: 547174, name: "Sandalpur" },
      { id: 547231, name: "Sarangi" },
      { id: 547232, name: "Sategaon" },
      { id: 547209, name: "Satephal" },
      { id: 547238, name: "Sirkalas" },
      { id: 547194, name: "Sonkhed" },
      { id: 547205, name: "Sonna" },
      { id: 547181, name: "Suhagan" },
      { id: 547213, name: "Suki" },
      { id: 547215, name: "Surwadi" },
      { id: 547247, name: "Tadkalas" },
      { id: 547239, name: "Tamkalas" },
      { id: 547186, name: "Tarangal" },
      { id: 547171, name: "Wadgaon Tarf Navki" },
      { id: 547188, name: "Wai Lasina" },
      { id: 547254, name: "Wazur" },
      { id: 547169, name: "Yerndeshwar" },
    ],
    4125: [
      { id: 547274, name: "Adgaon" },
      { id: 547339, name: "Alapur" },
      { id: 547281, name: "Anvapada" },
      { id: 547278, name: "Anwa" },
      { id: 547333, name: "Avhana" },
      { id: 547318, name: "Babhulgaon" },
      { id: 547397, name: "Banegaon" },
      { id: 547323, name: "Baranjala (Lokhande)" },
      { id: 547324, name: "Baranjala (Sabale)" },
      { id: 547359, name: "Belura" },
      { id: 547304, name: "Bhaydi" },
      { id: 547332, name: "Bhivpur" },
      { id: 943390, name: "Bhokardan" },
      { id: 547267, name: "Bhorkheda" },
      { id: 942982, name: "Bismillakha" },
      { id: 547316, name: "Borgaon (Jahagir)" },
      { id: 547369, name: "Borgaon Khadak" },
      { id: 547403, name: "Borgaon Taru" },
      { id: 547415, name: "Chandai Eko" },
      { id: 547414, name: "Chandai Tepli" },
      { id: 547408, name: "Chandai Thombri" },
      { id: 547406, name: "Chincholi" },
      { id: 547356, name: "Chorhala" },
      { id: 547302, name: "Dagadwadi" },
      { id: 547273, name: "Dahigaon" },
      { id: 547301, name: "Danapur" },
      { id: 547319, name: "Dautpur" },
      { id: 547402, name: "Dawargaon" },
      { id: 547300, name: "Dehed" },
      { id: 547371, name: "Deulgaon Kaman" },
      { id: 547407, name: "Deulgaon Tad" },
      { id: 547266, name: "Dhawada" },
      { id: 547277, name: "Dhondkheda" },
      { id: 547383, name: "Ekephal" },
      { id: 547354, name: "Fattepur" },
      { id: 547378, name: "Fulenagar" },
      { id: 547357, name: "Garkheda" },
      { id: 547419, name: "Gavhan Sangameshwar" },
      { id: 547311, name: "Godri" },
      { id: 547334, name: "Gokul" },
      { id: 547361, name: "Goshegaon" },
      { id: 547370, name: "Hasanabad" },
      { id: 547283, name: "Hisoda Bk." },
      { id: 547284, name: "Hisoda Kh." },
      { id: 547346, name: "Ibrahimpur" },
      { id: 547375, name: "Ita" },
      { id: 547264, name: "Jaidevwadi" },
      { id: 547348, name: "Jainpur" },
      { id: 547275, name: "Jalgaon (Sapakal)" },
      { id: 547280, name: "Janephal (Gaikwad)" },
      { id: 547405, name: "Janephal Dabhadi" },
      { id: 547382, name: "Jawkheda Bk." },
      { id: 547381, name: "Jawkheda Kh." },
      { id: 547392, name: "Jawkheda Thombari" },
      { id: 547353, name: "Jomala" },
      { id: 547282, name: "Kalyani" },
      { id: 547292, name: "Karajgaon" },
      { id: 547279, name: "Karlawadi" },
      { id: 547349, name: "Kathora (Jainpur)" },
      { id: 547294, name: "Kathora Bajar" },
      { id: 547399, name: "Kedarkheda" },
      { id: 547377, name: "Khadgaon" },
      { id: 547380, name: "Khadki" },
      { id: 547413, name: "Khamkheda" },
      { id: 547362, name: "Khandala" },
      { id: 547394, name: "Khaparkheda" },
      { id: 547276, name: "Koda" },
      { id: 547321, name: "Kodoli" },
      { id: 547312, name: "Kolegaon" },
      { id: 547360, name: "Koparda" },
      { id: 547308, name: "Kosgaon" },
      { id: 547389, name: "Kota Dabhadi" },
      { id: 547309, name: "Kotha Jahagir" },
      { id: 547291, name: "Kotha Koli" },
      { id: 547351, name: "Kshirsagar" },
      { id: 547293, name: "Kukdi" },
      { id: 547352, name: "Kumbhari" },
      { id: 547379, name: "Latifpur" },
      { id: 547285, name: "Leha" },
      { id: 547322, name: "Lingewadi" },
      { id: 547418, name: "Longaon" },
      { id: 547310, name: "Malegaon" },
      { id: 547336, name: "Malkapur" },
      { id: 547344, name: "Malkheda" },
      { id: 547338, name: "Manapur" },
      { id: 547355, name: "Masanpur" },
      { id: 547262, name: "Mehgaon" },
      { id: 547391, name: "Melkheda" },
      { id: 547299, name: "Mohalai" },
      { id: 547345, name: "Muthad" },
      { id: 547393, name: "Nalni Bk." },
      { id: 547327, name: "Nalni Kh." },
      { id: 547350, name: "Nanja" },
      { id: 547341, name: "Nasirabad" },
      { id: 547315, name: "Nimbola" },
      { id: 547364, name: "Nimgaon" },
      { id: 547287, name: "Padmavati" },
      { id: 547306, name: "Palaskheda Bhokardan" },
      { id: 547386, name: "Palaskheda Dabhadi" },
      { id: 547296, name: "Palaskheda Murtad" },
      { id: 547396, name: "Palaskheda Pimpale" },
      { id: 547409, name: "Palaskheda Thombari" },
      { id: 547366, name: "Pandharpur" },
      { id: 547288, name: "Paradh Bk." },
      { id: 547286, name: "Paradh Kh." },
      { id: 547342, name: "Perjapur" },
      { id: 547290, name: "Pimpalgaon (Renukai)" },
      { id: 547400, name: "Pimpalgaon (Sul)" },
      { id: 547411, name: "Pimpalgaon Barao" },
      { id: 547373, name: "Pimpalgaon Kolte" },
      { id: 547388, name: "Pimpalgaon Sermulki" },
      { id: 547387, name: "Pimpalgaon Sutar" },
      { id: 547395, name: "Pimpalgaon Thot" },
      { id: 547384, name: "Pimpri" },
      { id: 547269, name: "Pokhari" },
      { id: 547335, name: "Pralhadpur" },
      { id: 547365, name: "Rajala" },
      { id: 547337, name: "Rajapur" },
      { id: 547416, name: "Rajur" },
      { id: 547376, name: "Ram Nagar" },
      { id: 547340, name: "Rampur Bechirag" },
      { id: 547298, name: "Relgaon" },
      { id: 547328, name: "Samarth Nagar" },
      { id: 547289, name: "Savangi Aughadrao" },
      { id: 547374, name: "Sawkheda" },
      { id: 547272, name: "Selud" },
      { id: 547317, name: "Sipora Bazar" },
      { id: 547363, name: "Sirasgaon (Mandap)" },
      { id: 547368, name: "Sirasgaon Waghrul" },
      { id: 547358, name: "Soegaon Devi" },
      { id: 547343, name: "Subhanpur" },
      { id: 547295, name: "Surangali" },
      { id: 547326, name: "Tadegaon" },
      { id: 547325, name: "Tadegaonwadi" },
      { id: 547314, name: "Tadkalas" },
      { id: 547367, name: "Takli Bajad" },
      { id: 547320, name: "Takli Bhokardan" },
      { id: 547404, name: "Takli Hivardi" },
      { id: 547305, name: "Talni" },
      { id: 547347, name: "Tandulwadi" },
      { id: 547417, name: "Tapovan" },
      { id: 547410, name: "Thigalkheda" },
      { id: 547412, name: "Umarkheda" },
      { id: 547372, name: "Vazirkheda" },
      { id: 547307, name: "Viregaon" },
      { id: 547265, name: "Vizora" },
      { id: 547268, name: "Wadhod Tangda" },
      { id: 547263, name: "Wadhona" },
      { id: 547331, name: "Wadi Bk." },
      { id: 547330, name: "Wadi Kh" },
      { id: 547303, name: "Wadshed" },
      { id: 547329, name: "Wakdi" },
      { id: 547401, name: "Walsa Dawargaon" },
      { id: 547390, name: "Walsa Khalsa" },
      { id: 547313, name: "Walsa Wadala" },
      { id: 547271, name: "Walsawangi" },
      { id: 547297, name: "Warud Bk" },
    ],
    4126: [
      { id: 547449, name: "Adha" },
      { id: 547513, name: "Akoladev" },
      { id: 547483, name: "Aland" },
      { id: 547510, name: "Ambewadi" },
      { id: 547450, name: "Andhari" },
      { id: 547445, name: "Aradkheda" },
      { id: 547433, name: "Asai" },
      { id: 547422, name: "Belora" },
      { id: 547472, name: "Bharadkhead" },
      { id: 547455, name: "Bharaj Bk." },
      { id: 547454, name: "Bharaj Kh." },
      { id: 547486, name: "Bhatodi" },
      { id: 547436, name: "Bhorkheda" },
      { id: 547423, name: "Borgaon Bk." },
      { id: 547424, name: "Borgaon Math" },
      { id: 547425, name: "Bori Kh." },
      { id: 547476, name: "Borkhedi Chinch" },
      { id: 547447, name: "Borkhedi Gaiki" },
      { id: 547481, name: "Bramhapuri" },
      { id: 547515, name: "Butkheda" },
      { id: 547420, name: "Chapnera" },
      { id: 547428, name: "Chinchkheda" },
      { id: 547506, name: "Dahigaon" },
      { id: 547505, name: "Dawargaon" },
      { id: 547517, name: "Devalegavhan" },
      { id: 547470, name: "Devulgaon Ugle" },
      { id: 547477, name: "Devulzari" },
      { id: 547421, name: "Dhondkheda" },
      { id: 547474, name: "Dolkheda Bk." },
      { id: 547491, name: "Dolkheda Kh." },
      { id: 547518, name: "Dongaon" },
      { id: 547509, name: "Gadegavhan" },
      { id: 547512, name: "Ganeshpur" },
      { id: 547504, name: "Garkheda" },
      { id: 547437, name: "Ghankheda" },
      { id: 547439, name: "Gokulwadi" },
      { id: 547502, name: "Gondhankheda" },
      { id: 547465, name: "Gopi" },
      { id: 547482, name: "Hanumanthkheda" },
      { id: 547440, name: "Harpala" },
      { id: 547484, name: "Hiwara Kabali" },
      { id: 547426, name: "Hiwarabali" },
      { id: 547443, name: "Jafrabad" },
      { id: 547427, name: "Janephal" },
      { id: 547446, name: "Jawakheda Theng" },
      { id: 547494, name: "Kachanera" },
      { id: 547489, name: "Kalegaon" },
      { id: 547501, name: "Khamkheda" },
      { id: 547490, name: "Khanapur" },
      { id: 547458, name: "Khaparkheda" },
      { id: 547466, name: "Khasgaon" },
      { id: 547495, name: "Kinhi" },
      { id: 547461, name: "Kolegaon" },
      { id: 547432, name: "Kolhapur" },
      { id: 547463, name: "Konad" },
      { id: 547471, name: "Kumbhari" },
      { id: 547488, name: "Kumbharzari" },
      { id: 547451, name: "Kusali" },
      { id: 547431, name: "Mahora" },
      { id: 547479, name: "Mangarul" },
      { id: 547467, name: "Merkheda" },
      { id: 547438, name: "Mhasarul" },
      { id: 547485, name: "Nalwihira" },
      { id: 547496, name: "Nandkheda" },
      { id: 547475, name: "Nimkheda Bk." },
      { id: 547507, name: "Nimkheda Kh." },
      { id: 547519, name: "Niwdunga" },
      { id: 547493, name: "Papal" },
      { id: 547448, name: "Pasodi" },
      { id: 547434, name: "Pimpalgaon Kad" },
      { id: 547469, name: "Pimpalkhunta" },
      { id: 547516, name: "Pokhari" },
      { id: 547452, name: "Rastal" },
      { id: 547441, name: "Repala" },
      { id: 547480, name: "Rupkheda Bk." },
      { id: 547442, name: "Rupkheda Kh" },
      { id: 547462, name: "Sanjol" },
      { id: 547498, name: "Satephal" },
      { id: 547503, name: "Sawangi" },
      { id: 547487, name: "Sawargaon" },
      { id: 547444, name: "Sawarkheda" },
      { id: 547473, name: "Sawarkheda Gondhan" },
      { id: 547457, name: "Sawasani" },
      { id: 547497, name: "Shirala" },
      { id: 547456, name: "Sindi" },
      { id: 547478, name: "Sipora" },
      { id: 547459, name: "Songiri" },
      { id: 547464, name: "Sonkheda" },
      { id: 547500, name: "Takli" },
      { id: 547508, name: "Tapovan Gondhan" },
      { id: 547511, name: "Tembhurni" },
      { id: 547520, name: "Tondoli" },
      { id: 547499, name: "Varkheda Viro" },
      { id: 547430, name: "Wadala" },
      { id: 547514, name: "Wadhona" },
      { id: 547453, name: "Wankheda" },
      { id: 547492, name: "Warkheda (Firangi)" },
      { id: 547460, name: "Warud Bk." },
      { id: 547435, name: "Warud Kh." },
      { id: 547468, name: "Weerkheda Bhalki" },
      { id: 547429, name: "Yeota" },
    ],
    4127: [
      { id: 547532, name: "Ahankar Devlgaon" },
      { id: 547525, name: "Ambedkarwadi" },
      { id: 547544, name: "Antarwala (Jalna)" },
      { id: 547587, name: "Antarwala Sindkhed" },
      { id: 547600, name: "Babar Pokhari" },
      { id: 547574, name: "Baji Umrad" },
      { id: 547632, name: "Bapkal" },
      { id: 547548, name: "Bathan Bk." },
      { id: 547650, name: "Bethlam" },
      { id: 547658, name: "Bhatepuri" },
      { id: 547521, name: "Bhatkheda" },
      { id: 547582, name: "Bhilpuri Kh." },
      { id: 547608, name: "Bibi" },
      { id: 547625, name: "Borgaon" },
      { id: 547533, name: "Borkhedi" },
      { id: 547576, name: "Bramhankheda" },
      { id: 547648, name: "Chitli Putli" },
      { id: 547591, name: "Dahifal" },
      { id: 547647, name: "Dambri" },
      { id: 547541, name: "Daregaon (Jalna)" },
      { id: 547624, name: "Daregaon (Ner)" },
      { id: 547535, name: "Deomurti" },
      { id: 547622, name: "Dhagi" },
      { id: 547595, name: "Dhandegaon" },
      { id: 547642, name: "Dhanora" },
      { id: 547605, name: "Dhara" },
      { id: 547566, name: "Dharkalyan" },
      { id: 547558, name: "Dhawedi" },
      { id: 547652, name: "Dudhana Kalegaon" },
      { id: 547612, name: "Erandwadgaon" },
      { id: 547534, name: "Gawali Pokhri" },
      { id: 547524, name: "Ghanewadi" },
      { id: 547649, name: "Ghetuli" },
      { id: 547637, name: "Ghodegaon" },
      { id: 547547, name: "Golapangri" },
      { id: 547546, name: "Golawadi" },
      { id: 547552, name: "Gondegaon" },
      { id: 547528, name: "Gundewadi" },
      { id: 547579, name: "Hadap" },
      { id: 547643, name: "Hastepimpalgaon" },
      { id: 547667, name: "Hatwan" },
      { id: 547664, name: "Hiswan Bk." },
      { id: 547663, name: "Hiswan Kh." },
      { id: 547633, name: "Hiwara Roshangaon" },
      { id: 547636, name: "Hiwardi" },
      { id: 547540, name: "Indewadi" },
      { id: 547660, name: "Islamwadi" },
      { id: 547586, name: "Jaitapur" },
      { id: 547575, name: "Jalgaon" },
      { id: 943632, name: "Jalna" },
      { id: 547529, name: "Jamwadi" },
      { id: 547561, name: "Kadwanchi" },
      { id: 547620, name: "Kakda" },
      { id: 547668, name: "Karla" },
      { id: 547640, name: "Kautha" },
      { id: 547616, name: "Khambewadi" },
      { id: 547657, name: "Khanepuri" },
      { id: 547610, name: "Kharati" },
      { id: 547536, name: "Kharpudi" },
      { id: 547630, name: "Khodepuri" },
      { id: 547623, name: "Kolwadi" },
      { id: 547543, name: "Kumbephal Bk." },
      { id: 547555, name: "Kumbhephal Shindkhed" },
      { id: 547538, name: "Londhyachiwadi" },
      { id: 547569, name: "Majarewadi" },
      { id: 547549, name: "Malegaon Kh." },
      { id: 547665, name: "Mali Pimpalgaon" },
      { id: 547550, name: "Malshendra" },
      { id: 547669, name: "Mamdabad" },
      { id: 547593, name: "Manegaon Jahangir" },
      { id: 547592, name: "Manegaon Khalsa" },
      { id: 547581, name: "Maujpuri" },
      { id: 547617, name: "Mohadi" },
      { id: 547594, name: "Motigavhan" },
      { id: 547615, name: "Nagapur" },
      { id: 943633, name: "Nagewadi" },
      { id: 547560, name: "Nandapur" },
      { id: 547635, name: "Nasadgaon" },
      { id: 547563, name: "Navha" },
      { id: 547601, name: "Ner" },
      { id: 547526, name: "Nidhona" },
      { id: 547629, name: "Nipani Pokhari" },
      { id: 547583, name: "Nirkheda" },
      { id: 547654, name: "Pachanwadgaon" },
      { id: 547589, name: "Pahegaon" },
      { id: 547627, name: "Palaskheda" },
      { id: 547531, name: "Panshendra" },
      { id: 547585, name: "Paregaon" },
      { id: 547606, name: "Pashta" },
      { id: 547564, name: "Patra Tanda" },
      { id: 547598, name: "Patrud" },
      { id: 547609, name: "Pimpalwadi" },
      { id: 547634, name: "Pimpri Dukri" },
      { id: 547567, name: "Pirkalyan" },
      { id: 547522, name: "Pirpimpalgaon" },
      { id: 547653, name: "Pokalwadgaon" },
      { id: 547554, name: "Pokhari Shindkhed" },
      { id: 547646, name: "Pokhari Shingadi" },
      { id: 547661, name: "Punegaon" },
      { id: 547611, name: "Raigavhan" },
      { id: 547577, name: "Ramnagar" },
      { id: 547568, name: "Ranmurti" },
      { id: 909215, name: "Rathodnagar" },
      { id: 547651, name: "Revgaon" },
      { id: 547539, name: "Rohanwadi" },
      { id: 547578, name: "Salegaon (Jalna)" },
      { id: 547590, name: "Salegaon (Ner)" },
      { id: 547545, name: "Samangaon" },
      { id: 547537, name: "Sarwadi (Jalna)" },
      { id: 547645, name: "Sarwadi (Ner)" },
      { id: 547588, name: "Sawangi Talan" },
      { id: 547607, name: "Sawargaon Bhagde" },
      { id: 547580, name: "Sawargaon Hadap" },
      { id: 547614, name: "Sevali" },
      { id: 547621, name: "Shambhu Sawargaon" },
      { id: 547644, name: "Shevga" },
      { id: 547603, name: "Shivnagar" },
      { id: 547602, name: "Shivni" },
      { id: 547530, name: "Shrikrushnagar" },
      { id: 547570, name: "Sindhi Kalegaon" },
      { id: 547542, name: "Siraswadi" },
      { id: 547638, name: "Solgawhan" },
      { id: 547571, name: "Somnath" },
      { id: 547596, name: "Sondeo" },
      { id: 547628, name: "Takarwan" },
      { id: 547662, name: "Tandulwadi Bk." },
      { id: 547527, name: "Tandulwadi Kh." },
      { id: 547523, name: "Tatewadi" },
      { id: 547559, name: "Thar" },
      { id: 547659, name: "Thergaon" },
      { id: 547604, name: "Ukhali" },
      { id: 547597, name: "Umri" },
      { id: 547631, name: "Utavad" },
      { id: 547641, name: "Viregaon" },
      { id: 547565, name: "Wadgaon" },
      { id: 547666, name: "Wadiwadi" },
      { id: 547557, name: "Waghrul (Jahagir)" },
      { id: 547572, name: "Wakhari" },
      { id: 547656, name: "Wanadgaon" },
      { id: 547551, name: "Wanjar Umrad" },
      { id: 547553, name: "Warkheda" },
      { id: 547613, name: "Warkheda Ner" },
      { id: 547562, name: "Warud" },
      { id: 547639, name: "Wazar" },
    ],
    4128: [
      { id: 547730, name: "Akola" },
      { id: 547741, name: "Ambadgaon" },
      { id: 547694, name: "Anwi" },
      { id: 547679, name: "Asarkheda" },
      { id: 547701, name: "Asola" },
      { id: 547736, name: "Badnapur" },
      { id: 547746, name: "Bajar Wahegaon" },
      { id: 547698, name: "Bawane Pangri" },
      { id: 547688, name: "Bhakarwadi" },
      { id: 547706, name: "Bharadkheda" },
      { id: 547684, name: "Bhatkheda" },
      { id: 547749, name: "Bhilpuri Bk." },
      { id: 547756, name: "Butegaon" },
      { id: 547677, name: "Chanegaon" },
      { id: 547676, name: "Chikhali" },
      { id: 547703, name: "Chitoda" },
      { id: 547682, name: "Dabhadi" },
      { id: 547699, name: "Dagadwadi" },
      { id: 547675, name: "Dangargaon Dabhadi" },
      { id: 547714, name: "Dawalwadi" },
      { id: 547691, name: "Dawargaon" },
      { id: 547739, name: "Deogaon" },
      { id: 547750, name: "Deopimpalgaon" },
      { id: 547696, name: "Dhamangaon" },
      { id: 547724, name: "Dhasla" },
      { id: 547748, name: "Dhoksal" },
      { id: 547740, name: "Dhopteshwar" },
      { id: 547755, name: "Dongargaon" },
      { id: 547732, name: "Dudhanwadi" },
      { id: 547733, name: "Georai" },
      { id: 547760, name: "Ghotan" },
      { id: 547731, name: "Gokulwadi" },
      { id: 547716, name: "Haldola" },
      { id: 943420, name: "Hanuman Nagar" },
      { id: 547674, name: "Hivra Dabhadi" },
      { id: 547695, name: "Hiwara Rala" },
      { id: 547715, name: "Jawasgaon" },
      { id: 547735, name: "Kadegaon" },
      { id: 547758, name: "Kajla" },
      { id: 547722, name: "Kandari Bk." },
      { id: 547719, name: "Kandari Kh." },
      { id: 547742, name: "Kasturwadi" },
      { id: 547707, name: "Keligavhan" },
      { id: 547726, name: "Khadakwadi" },
      { id: 547710, name: "Khadgaon" },
      { id: 547685, name: "Khamgaon" },
      { id: 547692, name: "Kinhola" },
      { id: 547754, name: "Kumbhari" },
      { id: 547743, name: "Kusali" },
      { id: 547744, name: "Malegaon Bk." },
      { id: 547725, name: "Malewadi" },
      { id: 547700, name: "Mandeolgaon" },
      { id: 547709, name: "Mandwa" },
      { id: 547751, name: "Manjargaon" },
      { id: 547712, name: "Matarewadi" },
      { id: 547683, name: "Mevhana" },
      { id: 547672, name: "Mhasla" },
      { id: 547708, name: "Najik Pangri" },
      { id: 547670, name: "Nandkheda" },
      { id: 547752, name: "Nanegaon" },
      { id: 547729, name: "Nikalak" },
      { id: 547738, name: "Padali" },
      { id: 547757, name: "Pankheda" },
      { id: 547697, name: "Pathar Deolgaon" },
      { id: 547717, name: "Pirsavangi" },
      { id: 547711, name: "Rajewadi" },
      { id: 547704, name: "Rala" },
      { id: 547737, name: "Ramkheda" },
      { id: 547759, name: "Ranjangaon" },
      { id: 547747, name: "Roshangaon" },
      { id: 547718, name: "Sagarwadi" },
      { id: 547753, name: "Saigaon" },
      { id: 547713, name: "Shelgaon" },
      { id: 547690, name: "Shirasgaon Ghati" },
      { id: 547702, name: "Sindhi Pimpalgaon" },
      { id: 547727, name: "Somthana" },
      { id: 547671, name: "Talni Lodhewadi" },
      { id: 547678, name: "Tupewadi" },
      { id: 547705, name: "Ujjainpuri" },
      { id: 547673, name: "Vilhadi" },
      { id: 547680, name: "Waghrul Dabhadi" },
      { id: 547681, name: "Waghrul Dongargaon" },
      { id: 547745, name: "Wakulni" },
      { id: 547728, name: "Walha" },
      { id: 547693, name: "Wanjarwadi" },
      { id: 547734, name: "Warudi" },
    ],
    4129: [
      { id: 547792, name: "Alamgaon" },
      { id: 943631, name: "Ambad" },
      { id: 547789, name: "Antarwala Awa" },
      { id: 547863, name: "Antarwali Sarathi" },
      { id: 547872, name: "Apegaon" },
      { id: 547790, name: "Awa" },
      { id: 547788, name: "Badapur" },
      { id: 547775, name: "Bakshachiwadi" },
      { id: 547871, name: "Balegaon" },
      { id: 547844, name: "Bangaon" },
      { id: 547821, name: "Bantakli" },
      { id: 547847, name: "Baraswada" },
      { id: 547881, name: "Belgaon" },
      { id: 547867, name: "Bhagawan Nagar" },
      { id: 547839, name: "Bhalgaon" },
      { id: 547859, name: "Bhamberi" },
      { id: 547894, name: "Bhanang Jalgaon" },
      { id: 547886, name: "Bhardi" },
      { id: 547798, name: "Bhathan Kh." },
      { id: 547836, name: "Bhatkheda" },
      { id: 547814, name: "Bhiwandi Bodkha" },
      { id: 547776, name: "Bhokarwadi" },
      { id: 547812, name: "Bori" },
      { id: 547793, name: "Chambharwadi" },
      { id: 547858, name: "Chandanpuri Bk." },
      { id: 547857, name: "Chandanpuri Kh." },
      { id: 547763, name: "Chikangaon" },
      { id: 547786, name: "Chinchkhed" },
      { id: 547869, name: "Churmapuri" },
      { id: 547849, name: "Dadhegaon" },
      { id: 547843, name: "Dahigavhan Kh." },
      { id: 547811, name: "Dahipuri" },
      { id: 547860, name: "Dahyala" },
      { id: 547834, name: "Dawargaon" },
      { id: 547762, name: "Deshgavhan" },
      { id: 547853, name: "Dhakalgaon" },
      { id: 547838, name: "Dhalaskheda" },
      { id: 547805, name: "Dhangar Pimpalgaon" },
      { id: 547802, name: "Dhangar Pimpari" },
      { id: 547846, name: "Dodadgaon" },
      { id: 547873, name: "Domalgaon" },
      { id: 547785, name: "Domegaon" },
      { id: 547808, name: "Dudhpuri" },
      { id: 547845, name: "Dungaon" },
      { id: 547887, name: "Ekalahera" },
      { id: 547868, name: "Gahininath Nagar" },
      { id: 547875, name: "Gandhari" },
      { id: 547897, name: "Ganga Chincholi" },
      { id: 547779, name: "Gangaramwadi" },
      { id: 547888, name: "Ghungarde Hadgaon" },
      { id: 547796, name: "Gola" },
      { id: 547889, name: "Gondi" },
      { id: 547874, name: "Gori" },
      { id: 547818, name: "Govindpur" },
      { id: 547797, name: "Harat Kheda" },
      { id: 547892, name: "Hasanapur" },
      { id: 547803, name: "Hast Pokhari" },
      { id: 547896, name: "Indalgaon" },
      { id: 547826, name: "Ishwarnagar" },
      { id: 547884, name: "Jalura" },
      { id: 547774, name: "Jamkhed" },
      { id: 547773, name: "Jogeshwarwadi" },
      { id: 547783, name: "Kanadgaon" },
      { id: 547885, name: "Karanjala" },
      { id: 547804, name: "Karjat" },
      { id: 547799, name: "Katkheda" },
      { id: 547766, name: "Kauchalwadi" },
      { id: 547832, name: "Kaudgaon" },
      { id: 547840, name: "Khadkeshwar" },
      { id: 547765, name: "Khedgaon" },
      { id: 547771, name: "Kingaon" },
      { id: 547770, name: "Kingaonwadi" },
      { id: 547824, name: "Koli Sirasgaon" },
      { id: 547893, name: "Kothala Kh." },
      { id: 547879, name: "Kukkadgaon" },
      { id: 547891, name: "Kuran" },
      { id: 547878, name: "Lakhmapuri" },
      { id: 547806, name: "Lalwadi" },
      { id: 547823, name: "Lasura" },
      { id: 547769, name: "Lembhewadi" },
      { id: 547764, name: "Lonar Bhaigaon" },
      { id: 547866, name: "Mahakala" },
      { id: 547761, name: "Maherbhaigaon" },
      { id: 547777, name: "Malyachiwadi" },
      { id: 547819, name: "Mardi" },
      { id: 547807, name: "Masai" },
      { id: 547813, name: "Math Jalgaon" },
      { id: 547795, name: "Math Pimpalgaon" },
      { id: 547848, name: "Math Tanda" },
      { id: 547782, name: "Nagonyachiwadi" },
      { id: 547794, name: "Nagzari" },
      { id: 547862, name: "Nalewadi" },
      { id: 547772, name: "Nandi" },
      { id: 547829, name: "Narayangaon" },
      { id: 547768, name: "Nihalsingwadi" },
      { id: 547781, name: "Pagirwadi" },
      { id: 547810, name: "Panegaon" },
      { id: 547841, name: "Pangarkheda" },
      { id: 547833, name: "Pangri" },
      { id: 547837, name: "Parada" },
      { id: 547817, name: "Parner" },
      { id: 547890, name: "Patharwala Bk." },
      { id: 547865, name: "Patharwala Kh." },
      { id: 547780, name: "Pimparkhed Kh." },
      { id: 547851, name: "Pithori Sirasgaon" },
      { id: 547787, name: "Rahuwadi (Sant Sevalalnagar)" },
      { id: 547855, name: "Ramgavhan Bk." },
      { id: 547830, name: "Ramnagar" },
      { id: 547861, name: "Renapuri" },
      { id: 547850, name: "Rewalgaon" },
      { id: 547767, name: "Rohilagad" },
      { id: 547882, name: "Rui" },
      { id: 547895, name: "Sadegaon" },
      { id: 547791, name: "Sadesawangi" },
      { id: 547800, name: "Sarangpur" },
      { id: 547870, name: "Sasht Pimpalgaon" },
      { id: 547876, name: "Shahagad" },
      { id: 547852, name: "Shahapur" },
      { id: 547801, name: "Shevga" },
      { id: 547816, name: "Shiradhon" },
      { id: 547820, name: "Sirner" },
      { id: 547825, name: "Sonak Pimpalgaon" },
      { id: 547854, name: "Soundalgaon Kh." },
      { id: 547880, name: "Sukhapuri" },
      { id: 547842, name: "Tadhadgaon" },
      { id: 547856, name: "Taka" },
      { id: 547827, name: "Vasantnagar" },
      { id: 547778, name: "Vitthalwadi" },
      { id: 547822, name: "Wadi Lasura" },
      { id: 547815, name: "Wadi Siradhon" },
      { id: 547864, name: "Wadigodri" },
      { id: 547883, name: "Wadikalya" },
      { id: 547809, name: "Waghalkheda" },
      { id: 547877, name: "Walkeshwar" },
      { id: 547835, name: "Walkheda" },
      { id: 547831, name: "Zirpi" },
      { id: 547828, name: "Zirpi Tanda" },
      { id: 547784, name: "Zodegaon" },
    ],
    4130: [
      { id: 547933, name: "Antarwala Bk." },
      { id: 547901, name: "Antarwali Rathi" },
      { id: 547991, name: "Antarwali Tembhi" },
      { id: 547920, name: "Antarwalidai" },
      { id: 548004, name: "Argadegavhan" },
      { id: 547916, name: "Awalgaon Bk." },
      { id: 547915, name: "Awalgaon Kh." },
      { id: 547971, name: "Bachegaon" },
      { id: 547964, name: "Bahiregaon" },
      { id: 547992, name: "Banegaon" },
      { id: 547936, name: "Belwadi" },
      { id: 548014, name: "Bhadli Kh." },
      { id: 547962, name: "Bhadregaon" },
      { id: 547979, name: "Bhaigavhan" },
      { id: 547946, name: "Bhendala" },
      { id: 547945, name: "Bhendala Tanda" },
      { id: 547995, name: "Bhoggaon" },
      { id: 547919, name: "Bhutegaon" },
      { id: 547974, name: "Bodkha Bk." },
      { id: 547952, name: "Bolegaon" },
      { id: 547950, name: "Bondhalapuri" },
      { id: 547929, name: "Bor Ranjani" },
      { id: 547958, name: "Borgaon Kh." },
      { id: 547905, name: "Chapadgaon" },
      { id: 547923, name: "Chitravadgaon" },
      { id: 547967, name: "Dahalegaon" },
      { id: 547976, name: "Dahegaon Devi" },
      { id: 547981, name: "Dahigavhan Bk." },
      { id: 547898, name: "Daithana Bk." },
      { id: 547984, name: "Daithana Kh." },
      { id: 547927, name: "Deoli Ambad" },
      { id: 547926, name: "Deoli Partur" },
      { id: 547954, name: "Devdi Hadgaon" },
      { id: 547972, name: "Devhiwra" },
      { id: 547966, name: "Devnagar" },
      { id: 547959, name: "Dhakephal" },
      { id: 547944, name: "Dhanegaon" },
      { id: 547980, name: "Ekrukha" },
      { id: 547900, name: "Gadhe Sawargaon" },
      { id: 547961, name: "Ghansawangi" },
      { id: 547940, name: "Ghonsi Bk." },
      { id: 547968, name: "Ghonsi Kh." },
      { id: 547939, name: "Ghonsi Tanda No.1" },
      { id: 547941, name: "Ghonsi Tanda No.2" },
      { id: 547943, name: "Guna Naik Tanda" },
      { id: 548012, name: "Gunj Bk." },
      { id: 547914, name: "Guru Pimpari" },
      { id: 547937, name: "Hatdi" },
      { id: 547947, name: "Jamb Samarth" },
      { id: 547957, name: "Jiradgaon" },
      { id: 547989, name: "Jogladevi" },
      { id: 547986, name: "Kandari Ambad" },
      { id: 547934, name: "Kandari Partur" },
      { id: 547922, name: "Karadgaon" },
      { id: 547999, name: "Khadka" },
      { id: 547998, name: "Khadkawadi" },
      { id: 547982, name: "Khalapuri" },
      { id: 547978, name: "Khapardev Hiwra" },
      { id: 547942, name: "Kothala Bk." },
      { id: 547993, name: "Kothi" },
      { id: 547904, name: "Krishnanagar" },
      { id: 547921, name: "Krishnapurwadi" },
      { id: 548003, name: "Kumbhar Pimpalgaon" },
      { id: 547956, name: "Lamanwadi" },
      { id: 548007, name: "Limbi" },
      { id: 548000, name: "Limboni" },
      { id: 547969, name: "Machindranath Chincholi" },
      { id: 547955, name: "Maherjavala" },
      { id: 547973, name: "Mandala" },
      { id: 547903, name: "Manepuri" },
      { id: 547996, name: "Mangrul" },
      { id: 547913, name: "Mangu Jalgaon" },
      { id: 547935, name: "Masegaon" },
      { id: 547951, name: "Mohpuri" },
      { id: 547899, name: "Mudhegaon" },
      { id: 547997, name: "Mudregaon" },
      { id: 547985, name: "Murma" },
      { id: 548006, name: "Murti" },
      { id: 548010, name: "Nagobachiwadi" },
      { id: 547911, name: "Nipani Pimpalgaon" },
      { id: 547987, name: "Paduli Bk." },
      { id: 548001, name: "Paduli Kh." },
      { id: 547906, name: "Panewadi" },
      { id: 547931, name: "Pangra" },
      { id: 547932, name: "Pangra Tandi" },
      { id: 547930, name: "Paradgaon" },
      { id: 548002, name: "Pimparkhed Bk." },
      { id: 547960, name: "Pirgaibwadi" },
      { id: 547970, name: "Rahera" },
      { id: 548009, name: "Raja Takli" },
      { id: 547953, name: "Rajegaon" },
      { id: 548005, name: "Rajurkarkotha" },
      { id: 547988, name: "Ramasgaon" },
      { id: 547965, name: "Ramgavhan Kh." },
      { id: 547910, name: "Rani Unchegaon" },
      { id: 547925, name: "Ranjani" },
      { id: 547924, name: "Ranjaniwadi" },
      { id: 547912, name: "Raona" },
      { id: 547938, name: "Sakalgaon" },
      { id: 547908, name: "Sarapgavhan" },
      { id: 547907, name: "Shevgal" },
      { id: 547990, name: "Shevta" },
      { id: 547909, name: "Shindewadgaon" },
      { id: 548013, name: "Shivangaon" },
      { id: 548008, name: "Shripat Dhamangaon" },
      { id: 547977, name: "Sidheshwar Pimpalgaon" },
      { id: 547975, name: "Sindkhed" },
      { id: 547994, name: "Soundalgaon Bk." },
      { id: 547902, name: "Talegaon" },
      { id: 547983, name: "Tirthpuri" },
      { id: 548011, name: "Ukkadgaon" },
      { id: 547948, name: "Viregavhan" },
      { id: 547949, name: "Viregavhan Tanda" },
      { id: 547963, name: "Wadi Ramasgaon" },
      { id: 547918, name: "Yaval Pimpri Tanda" },
      { id: 547917, name: "Yavalpimpri" },
      { id: 547928, name: "Yewala" },
    ],
    4131: [
      { id: 548087, name: "Akoli" },
      { id: 548028, name: "Amba" },
      { id: 548062, name: "Ananadwadi" },
      { id: 548105, name: "Anandgaon" },
      { id: 548056, name: "Angalgaon" },
      { id: 548099, name: "Antarwala" },
      { id: 548082, name: "Asangaon" },
      { id: 548093, name: "Ashti" },
      { id: 548024, name: "Babai" },
      { id: 548023, name: "Babultara" },
      { id: 548061, name: "Bamni" },
      { id: 548102, name: "Banachiwadi" },
      { id: 548086, name: "Bramhanwadi" },
      { id: 548029, name: "Bramhawadgaon" },
      { id: 548109, name: "Changtpuri" },
      { id: 548041, name: "Chincholi" },
      { id: 548021, name: "Dahifal Bhongane" },
      { id: 548075, name: "Daithna Bk." },
      { id: 548071, name: "Daithna Kh." },
      { id: 548049, name: "Davla" },
      { id: 548088, name: "Dhokmal Tanda" },
      { id: 548090, name: "Dhonwadi" },
      { id: 548025, name: "Dolhara" },
      { id: 548034, name: "Eakrukha" },
      { id: 548016, name: "Edlapur" },
      { id: 548044, name: "Firozabad" },
      { id: 548055, name: "Ganeshpur" },
      { id: 548110, name: "Golegaon" },
      { id: 548059, name: "Hanwadi" },
      { id: 548092, name: "Hasturtanda" },
      { id: 548070, name: "Hatdi" },
      { id: 548047, name: "Hondegaon" },
      { id: 548097, name: "Kanakwadi" },
      { id: 548019, name: "Kandari" },
      { id: 548083, name: "Karhala" },
      { id: 548026, name: "Kawjawala" },
      { id: 548020, name: "Khadki" },
      { id: 548065, name: "Khandvi" },
      { id: 548072, name: "Khandviwadi" },
      { id: 548100, name: "Kokate Hadgaon" },
      { id: 548037, name: "Koregaon" },
      { id: 548106, name: "Landakdara" },
      { id: 548085, name: "Likhit Pimpri" },
      { id: 548084, name: "Lingsa" },
      { id: 548104, name: "Loni Kh." },
      { id: 548040, name: "Mapegaon Bk." },
      { id: 548039, name: "Mapegaon Kh." },
      { id: 548027, name: "Masla" },
      { id: 548079, name: "Mav" },
      { id: 548035, name: "Nagapur" },
      { id: 548022, name: "Nandra" },
      { id: 548038, name: "Padali" },
      { id: 548096, name: "Palsi" },
      { id: 548081, name: "Pandepokhari" },
      { id: 548089, name: "Paratwadi" },
      { id: 943155, name: "Partur" },
      { id: 548078, name: "Patoda" },
      { id: 548095, name: "Phulwadi" },
      { id: 548101, name: "Pimpali Dhamangaon" },
      { id: 548018, name: "Pimparkheda (Garad)" },
      { id: 548053, name: "Pimprula" },
      { id: 548094, name: "Raigavhan" },
      { id: 548063, name: "Raipur" },
      { id: 548054, name: "Rangopant Takli" },
      { id: 548048, name: "Raniwahegaon" },
      { id: 548046, name: "Revalgaon" },
      { id: 548032, name: "Rohina Bk." },
      { id: 548033, name: "Rohina Kh." },
      { id: 548045, name: "Salgaon" },
      { id: 548107, name: "Sankanpuri" },
      { id: 548098, name: "Satara Wahegaon" },
      { id: 548051, name: "Satona Bk." },
      { id: 548050, name: "Satona Kh." },
      { id: 548111, name: "Sawangi Gangakinara" },
      { id: 548108, name: "Sawargaon Bk." },
      { id: 548057, name: "Shelgaon" },
      { id: 548068, name: "Shelwada" },
      { id: 548060, name: "Shewga" },
      { id: 548031, name: "Shirdhar Jawala" },
      { id: 548074, name: "Shrishti" },
      { id: 548076, name: "Shrishti Tanda" },
      { id: 548066, name: "Singona" },
      { id: 548064, name: "Sirasgaon" },
      { id: 548067, name: "Soijana" },
      { id: 548080, name: "Surumgaon" },
      { id: 548058, name: "Torna" },
      { id: 548052, name: "Usmanpur" },
      { id: 548103, name: "Wadarwadi" },
      { id: 548030, name: "Wadhona" },
      { id: 548015, name: "Waghadi" },
      { id: 548091, name: "Wahegaon Satara" },
      { id: 548073, name: "Wahegaon Shrishti" },
      { id: 548036, name: "Waijoda" },
      { id: 548069, name: "Walkhed" },
      { id: 548042, name: "Warphal" },
      { id: 548043, name: "Warphalwadi" },
      { id: 548017, name: "Watur" },
      { id: 548077, name: "Yenora" },
    ],
    4132: [
      { id: 548195, name: "Akani" },
      { id: 548174, name: "Ambhoda Kadam" },
      { id: 548146, name: "Ambhor Shelke" },
      { id: 548163, name: "Ambhora Jahagir" },
      { id: 548145, name: "Andhwadi" },
      { id: 548218, name: "Arda Khari" },
      { id: 548181, name: "Arda Tolaji" },
      { id: 548210, name: "Awalgaon" },
      { id: 548196, name: "Barbada" },
      { id: 548122, name: "Belora" },
      { id: 548113, name: "Bhuwan" },
      { id: 548186, name: "Bramhnath Tanda" },
      { id: 548226, name: "Chandeshwar" },
      { id: 548144, name: "Chikhali" },
      { id: 548129, name: "Daha" },
      { id: 548141, name: "Dahifal Khandare" },
      { id: 548160, name: "Deogaon Khawane" },
      { id: 548211, name: "Devthana Mantha" },
      { id: 548135, name: "Devthana Uswad" },
      { id: 548168, name: "Dhoksal" },
      { id: 548184, name: "Dhonde Pimpalgaon" },
      { id: 548132, name: "Dudha" },
      { id: 548126, name: "Erandeshwar" },
      { id: 548167, name: "Ganeshpur" },
      { id: 548143, name: "Garteki Tanda" },
      { id: 548212, name: "Georai" },
      { id: 548222, name: "Gopegaon" },
      { id: 548192, name: "Gulkhand" },
      { id: 548193, name: "Gulkhand Tanda" },
      { id: 548138, name: "Hanwat Kheda" },
      { id: 548220, name: "Hatwan" },
      { id: 548204, name: "Helas" },
      { id: 548205, name: "Helaswadi" },
      { id: 548198, name: "Hiwarkheda" },
      { id: 548118, name: "Incha" },
      { id: 548124, name: "Jaipur" },
      { id: 548130, name: "Jambharun" },
      { id: 548179, name: "Jatkheda" },
      { id: 548134, name: "Kanadi" },
      { id: 548190, name: "Kanphodi" },
      { id: 548214, name: "Karnawal" },
      { id: 548188, name: "Kathala Bk." },
      { id: 548189, name: "Kathala Kh." },
      { id: 548228, name: "Kedarwakadi" },
      { id: 548151, name: "Kehal Wadgaon" },
      { id: 548209, name: "Kendhali" },
      { id: 548213, name: "Khari Arda" },
      { id: 548153, name: "Khorad Sawangi" },
      { id: 548136, name: "Khorwad" },
      { id: 548154, name: "Kinkheda" },
      { id: 548131, name: "Kirla" },
      { id: 548155, name: "Kirtapur" },
      { id: 548127, name: "Kokarasa" },
      { id: 548115, name: "Kokramba" },
      { id: 548182, name: "Lawni" },
      { id: 548216, name: "Limbewadgaon" },
      { id: 548133, name: "Limbkheda" },
      { id: 548197, name: "Limbona" },
      { id: 548150, name: "Mahora" },
      { id: 548140, name: "Malegaon" },
      { id: 548203, name: "Malkini" },
      { id: 548159, name: "Malsawangi" },
      { id: 548171, name: "Maltondi" },
      { id: 548219, name: "Mangrul" },
      { id: 548208, name: "Mantha" },
      { id: 548178, name: "Meskheda" },
      { id: 548147, name: "Mohdari" },
      { id: 548187, name: "Mosa" },
      { id: 548201, name: "Murumkheda" },
      { id: 548152, name: "Naigaon P. Bamhani" },
      { id: 548125, name: "Naigaon P. Sevli" },
      { id: 548221, name: "Nansi" },
      { id: 548157, name: "Padlidudha" },
      { id: 548191, name: "Pakni" },
      { id: 548166, name: "Palaskheda" },
      { id: 548170, name: "Pandhurna" },
      { id: 548158, name: "Pangra Gadade" },
      { id: 548183, name: "Pangri (Gosavi)" },
      { id: 548172, name: "Pangri Bk." },
      { id: 548202, name: "Pangri Kh." },
      { id: 548217, name: "Patoda Bk." },
      { id: 548227, name: "Patoda Kh." },
      { id: 548148, name: "Pewa" },
      { id: 548177, name: "Pimparkheda Kharabe" },
      { id: 548121, name: "Pokhari Kandhali" },
      { id: 548149, name: "Pokhari Takle" },
      { id: 548176, name: "Ramtirth" },
      { id: 548215, name: "Ranmala" },
      { id: 548139, name: "Saskheda" },
      { id: 548180, name: "Sawargaon Wayal" },
      { id: 548123, name: "Shivangiri" },
      { id: 548114, name: "Sirpur" },
      { id: 548173, name: "Sonunkarwadi" },
      { id: 548119, name: "Takalkhopa" },
      { id: 548142, name: "Talegaon" },
      { id: 548117, name: "Talni" },
      { id: 548200, name: "Taltondi" },
      { id: 548207, name: "Thengewadgaon" },
      { id: 548206, name: "Tokwadi" },
      { id: 548128, name: "Tupa" },
      { id: 548199, name: "Umarkheda" },
      { id: 548137, name: "Uswad (Devthana)" },
      { id: 548164, name: "Vaidhywadgaon" },
      { id: 548223, name: "Vidoli Bk." },
      { id: 548224, name: "Vidoli Kh." },
      { id: 548116, name: "Wadgaon Sarhadu" },
      { id: 548169, name: "Wadhegaon (Pandhurna)" },
      { id: 548120, name: "Waghala" },
      { id: 548161, name: "Waghoda" },
      { id: 548185, name: "Wai" },
      { id: 548225, name: "Wanjola" },
      { id: 548165, name: "Warud" },
      { id: 548194, name: "Watur Tanda" },
      { id: 548112, name: "Wazar Sarkate" },
      { id: 548175, name: "Wirgavhan" },
    ],
    4133: [
      { id: 548285, name: "Adgaon (Pishor)" },
      { id: 548343, name: "Adgaon Jehur" },
      { id: 548408, name: "Alapur" },
      { id: 548314, name: "Amba" },
      { id: 548434, name: "Amba Tanda" },
      { id: 548311, name: "Ambala" },
      { id: 548267, name: "Ambegaon Bk." },
      { id: 548266, name: "Ambegaon Kh." },
      { id: 548288, name: "Amdabad" },
      { id: 548332, name: "Andhaner" },
      { id: 548409, name: "Antapur" },
      { id: 548378, name: "Athegaon" },
      { id: 548372, name: "Aurala" },
      { id: 548397, name: "Aurali" },
      { id: 548410, name: "Aurangpur" },
      { id: 548342, name: "Bahirgaon" },
      { id: 548270, name: "Balkheda" },
      { id: 548358, name: "Banshendra" },
      { id: 548274, name: "Barkatpur" },
      { id: 548233, name: "Belkheda" },
      { id: 548394, name: "Bharamba" },
      { id: 548260, name: "Bhildari (Nagad)" },
      { id: 548302, name: "Bhildari (Pishor)" },
      { id: 548382, name: "Bhokangaon" },
      { id: 548234, name: "Bhopewadi" },
      { id: 548365, name: "Bibkheda" },
      { id: 548354, name: "Boltek" },
      { id: 548236, name: "Bormal Tanda" },
      { id: 548402, name: "Borsar Bk." },
      { id: 548415, name: "Borsar Kh." },
      { id: 548319, name: "Bramhani" },
      { id: 548427, name: "Chambharwadi" },
      { id: 548361, name: "Chapaner" },
      { id: 548383, name: "Chikhalthan" },
      { id: 548255, name: "Chimnapur" },
      { id: 548366, name: "Chinchkheda Bk" },
      { id: 548362, name: "Chinchkheda Kh." },
      { id: 548273, name: "Chincholi (L)" },
      { id: 548345, name: "Chivali" },
      { id: 548341, name: "Dabhadi" },
      { id: 548286, name: "Dahigaon" },
      { id: 548417, name: "Debhegaon" },
      { id: 548423, name: "Deogaon (Rangari)" },
      { id: 548419, name: "Deolana" },
      { id: 548424, name: "Deoli" },
      { id: 548429, name: "Deopudi" },
      { id: 548323, name: "Deopul" },
      { id: 548268, name: "Dhamani Kh" },
      { id: 548278, name: "Dhangar Malegaon" },
      { id: 548373, name: "Dhangarwadi" },
      { id: 548422, name: "Dharankheda" },
      { id: 548283, name: "Digaon" },
      { id: 548294, name: "Digar" },
      { id: 548339, name: "Dongaon" },
      { id: 548396, name: "Dongargaon" },
      { id: 548241, name: "Dudhmal" },
      { id: 548279, name: "Ganeshpur (Ganeshpurwadi)" },
      { id: 548435, name: "Garada Tanda" },
      { id: 548303, name: "Gaurpimpri" },
      { id: 548318, name: "Gautala" },
      { id: 548363, name: "Gavhali" },
      { id: 548243, name: "Ghatshendra" },
      { id: 548380, name: "Ghusur" },
      { id: 548433, name: "Ghusur Tanda" },
      { id: 548414, name: "Gondegaon" },
      { id: 548353, name: "Gudma" },
      { id: 548257, name: "Haraswadi" },
      { id: 548259, name: "Hasanabad" },
      { id: 548376, name: "Hasankheda" },
      { id: 548325, name: "Hasta" },
      { id: 548379, name: "Hatnoor" },
      { id: 548329, name: "Hiwarkheda (Gautala)" },
      { id: 548387, name: "Hiwarkheda (Nandgir)" },
      { id: 548404, name: "Jaitapur" },
      { id: 548389, name: "Jaitkheda" },
      { id: 548390, name: "Jaitkheda Tanda" },
      { id: 548405, name: "Jalgaonghat" },
      { id: 548351, name: "Jamdi (Forest)" },
      { id: 548352, name: "Jamdi (Ghat)" },
      { id: 548280, name: "Jamdi (Jahagir)" },
      { id: 548384, name: "Jamdi Kh." },
      { id: 548305, name: "Jawakheda Bk." },
      { id: 548290, name: "Jawakheda Kh." },
      { id: 548375, name: "Jawali Bk." },
      { id: 548377, name: "Jawali Kh." },
      { id: 548347, name: "Jehur" },
      { id: 548418, name: "Kadarpur" },
      { id: 548310, name: "Kalanki" },
      { id: 548371, name: "Kanadgaon (Kannad)" },
      { id: 548425, name: "Kanadgaon Werul" },
      { id: 944715, name: "Kannad" },
      { id: 548269, name: "Karanjkheda Jahagir" },
      { id: 548252, name: "Karanjkheda Khalsa" },
      { id: 548374, name: "Kavitkheda" },
      { id: 548412, name: "Kesapur" },
      { id: 548292, name: "Khadki" },
      { id: 548370, name: "Khamgaon" },
      { id: 548399, name: "Khaparkheda" },
      { id: 548277, name: "Khatkheda" },
      { id: 548360, name: "Kheda" },
      { id: 548284, name: "Khedi" },
      { id: 548256, name: "Kholapur" },
      { id: 548299, name: "Kolambi (Majra)" },
      { id: 548271, name: "Kolambi Makta" },
      { id: 548350, name: "Kolwadi" },
      { id: 548239, name: "Kondbari" },
      { id: 548307, name: "Koparwel" },
      { id: 548385, name: "Kunjkheda" },
      { id: 548421, name: "Lamangaon" },
      { id: 548330, name: "Langada Tanda" },
      { id: 548413, name: "Lavhali" },
      { id: 548245, name: "Lohagaon" },
      { id: 548238, name: "Lonza" },
      { id: 548337, name: "Makranpur" },
      { id: 548392, name: "Malegaon (Lokhandi)" },
      { id: 548395, name: "Malegaon (Thokal)" },
      { id: 548340, name: "Malpur" },
      { id: 548428, name: "Mategaon" },
      { id: 548324, name: "Mehagaon" },
      { id: 548262, name: "Mehun Puranwadi" },
      { id: 548289, name: "Mohadi" },
      { id: 548309, name: "Mohara" },
      { id: 548326, name: "Moharda" },
      { id: 548333, name: "Mundwadi" },
      { id: 548344, name: "Mungsapur" },
      { id: 548287, name: "Nachanwel" },
      { id: 548291, name: "Nadarpur" },
      { id: 548229, name: "Nagad" },
      { id: 548230, name: "Nagad Tanda" },
      { id: 548253, name: "Nagapur" },
      { id: 548386, name: "Nandgirwadi" },
      { id: 548328, name: "Narsingpur" },
      { id: 548250, name: "Newpur Jahangir" },
      { id: 548321, name: "Nimbhora" },
      { id: 548381, name: "Nimdongri" },
      { id: 548367, name: "Nipani" },
      { id: 548357, name: "Palasgaon" },
      { id: 548401, name: "Palaskheda" },
      { id: 548297, name: "Palshi Bk." },
      { id: 548296, name: "Palshi Kh" },
      { id: 548235, name: "Pangra" },
      { id: 548348, name: "Pedakwadi" },
      { id: 548304, name: "Pimparkheda" },
      { id: 548293, name: "Pishor" },
      { id: 548275, name: "Raigaon" },
      { id: 548336, name: "Rail Navadi" },
      { id: 548251, name: "Rewoolgaon" },
      { id: 548327, name: "Rithi" },
      { id: 548368, name: "Rohila Kh." },
      { id: 548272, name: "Rojwepur" },
      { id: 548406, name: "Ruikheda" },
      { id: 548369, name: "Sahangaon" },
      { id: 548258, name: "Saigavhan" },
      { id: 548295, name: "Sakharwel" },
      { id: 548391, name: "Salegaon" },
      { id: 548306, name: "Sarola" },
      { id: 548400, name: "Sasegaon" },
      { id: 548317, name: "Satkund Tanda" },
      { id: 548265, name: "Sawargaon" },
      { id: 548298, name: "Shafepur" },
      { id: 548300, name: "Shafiabad" },
      { id: 548282, name: "Shelgaon (Jahagir)" },
      { id: 548416, name: "Shevata" },
      { id: 548240, name: "Shibghat" },
      { id: 548356, name: "Shirasgaon" },
      { id: 548364, name: "Shirodi" },
      { id: 548430, name: "Shiv Tanda" },
      { id: 548359, name: "Shivrai" },
      { id: 548355, name: "Sirjapur" },
      { id: 548349, name: "Sitanaik Tanda" },
      { id: 548232, name: "Sonwadi" },
      { id: 548420, name: "Tad Pimpalgaon" },
      { id: 548403, name: "Takli (Lavali)" },
      { id: 548246, name: "Takli Antur" },
      { id: 548308, name: "Takli Bk." },
      { id: 548242, name: "Talner" },
      { id: 548346, name: "Tandulwadi" },
      { id: 548407, name: "Tapargaon" },
      { id: 548320, name: "Tapowan" },
      { id: 548331, name: "Telwadi" },
      { id: 548264, name: "Umbarkheda" },
      { id: 548315, name: "Upla" },
      { id: 548411, name: "Vaispur" },
      { id: 548398, name: "Vita" },
      { id: 548426, name: "Vitkheda" },
      { id: 548338, name: "Vitthalpur" },
      { id: 548388, name: "Wadali" },
      { id: 548237, name: "Wadgaon (Jadhav)" },
      { id: 548254, name: "Wadichimnapur" },
      { id: 548312, name: "Wadner" },
      { id: 548313, name: "Wadner Tanda" },
      { id: 548244, name: "Wadod" },
      { id: 548301, name: "Waghulkheda" },
      { id: 548276, name: "Wakad" },
      { id: 548248, name: "Waki Jadid" },
      { id: 548322, name: "Wasadi" },
    ],
    4134: [
      { id: 548489, name: "Amkheda" },
      { id: 548513, name: "Anad" },
      { id: 548455, name: "Anjola" },
      { id: 548477, name: "Bahulkheda" },
      { id: 548457, name: "Banoti" },
      { id: 548458, name: "Banoti Tanda" },
      { id: 548498, name: "Chondeshwar" },
      { id: 548520, name: "Dabha" },
      { id: 548466, name: "Dastapur" },
      { id: 548522, name: "Davhari" },
      { id: 548493, name: "Dhanwat" },
      { id: 548480, name: "Dhingapur" },
      { id: 548497, name: "Fardapur" },
      { id: 548440, name: "Galwada (B)" },
      { id: 548488, name: "Galwada (Soegaon)" },
      { id: 548515, name: "Ghanegaon" },
      { id: 548514, name: "Ghanegaon Tanda" },
      { id: 548453, name: "Ghorkund" },
      { id: 548472, name: "Ghosala" },
      { id: 548446, name: "Gondegaon" },
      { id: 548451, name: "Hanumantkheda" },
      { id: 548503, name: "Hingana" },
      { id: 548517, name: "Hiwari" },
      { id: 548504, name: "Jamthi" },
      { id: 548494, name: "Jangla Tanda" },
      { id: 548469, name: "Jangli Kotha" },
      { id: 548481, name: "Jarandi" },
      { id: 548506, name: "Jawala" },
      { id: 548465, name: "Kaldari" },
      { id: 548484, name: "Kankrala" },
      { id: 548476, name: "Kawali" },
      { id: 548460, name: "Kinhi" },
      { id: 548496, name: "Lenapur" },
      { id: 548518, name: "Mahalbda" },
      { id: 548483, name: "Malegaon" },
      { id: 548501, name: "Malkheda" },
      { id: 548442, name: "Mhashikotha" },
      { id: 548463, name: "Mohalai" },
      { id: 548519, name: "Molkheda" },
      { id: 548452, name: "Mukhed" },
      { id: 548510, name: "Murti" },
      { id: 548511, name: "Nanda" },
      { id: 548512, name: "Nandatanda" },
      { id: 548471, name: "Nandgaon" },
      { id: 946326, name: "Nandgaon Tanda" },
      { id: 548468, name: "Nayagaon" },
      { id: 548479, name: "Nimbayati" },
      { id: 548441, name: "Nimbhora" },
      { id: 548464, name: "Nimkheda" },
      { id: 548473, name: "Nimkhedi" },
      { id: 548459, name: "Palashi" },
      { id: 548492, name: "Palaskheda" },
      { id: 548508, name: "Palaskheda (Sa.)" },
      { id: 548521, name: "Pimpalwadi" },
      { id: 548505, name: "Pimpla" },
      { id: 548482, name: "Pimpri" },
      { id: 548462, name: "Pimpri Antur" },
      { id: 548444, name: "Pohari Bk" },
      { id: 548445, name: "Pohari Kh." },
      { id: 548502, name: "Raksa" },
      { id: 548478, name: "Rampura" },
      { id: 548485, name: "Raveri" },
      { id: 548507, name: "Rawala" },
      { id: 548523, name: "Sawaladbara" },
      { id: 548495, name: "Sawarkheda" },
      { id: 548449, name: "Shindol" },
      { id: 548490, name: "Soegaon" },
      { id: 548487, name: "Sonaswadi" },
      { id: 548500, name: "Thana" },
      { id: 548470, name: "Tidka" },
      { id: 548475, name: "Tikhi" },
      { id: 548509, name: "Titawi" },
      { id: 548447, name: "Titur" },
      { id: 548474, name: "Umarvihire" },
      { id: 548450, name: "Uppalkheda Antur" },
      { id: 548461, name: "Wadgaon (Tigji)" },
      { id: 548467, name: "Wadi Sutonda" },
      { id: 548516, name: "Wakad" },
      { id: 548454, name: "Wakadi" },
      { id: 548443, name: "Wangaon" },
      { id: 548499, name: "Warkhedi Bk." },
      { id: 548491, name: "Warkhedi Kh." },
      { id: 548456, name: "Warthan" },
      { id: 548486, name: "Wetalwadi" },
    ],
    4135: [
      { id: 548527, name: "Adharwadi" },
      { id: 548580, name: "Ajantha" },
      { id: 548559, name: "Ambhai" },
      { id: 548584, name: "Amsari" },
      { id: 548537, name: "Amthana" },
      { id: 548583, name: "Anad" },
      { id: 548646, name: "Andhari" },
      { id: 548582, name: "Andhari (Sillod)" },
      { id: 548632, name: "Anvi" },
      { id: 548634, name: "Asadi" },
      { id: 548648, name: "Babhulgaon Bk." },
      { id: 548575, name: "Bahuli" },
      { id: 548591, name: "Balapur" },
      { id: 548651, name: "Bankinhola" },
      { id: 548652, name: "Bhaigaon" },
      { id: 548610, name: "Bharadi" },
      { id: 548650, name: "Bhawan" },
      { id: 548593, name: "Bodwad" },
      { id: 548565, name: "Bojgaon" },
      { id: 548544, name: "Borgaon Bajar" },
      { id: 548642, name: "Borgaon Kasari" },
      { id: 548548, name: "Borgaon Sarwani" },
      { id: 548545, name: "Borgaonwadi" },
      { id: 548629, name: "Chandapur" },
      { id: 548532, name: "Charner" },
      { id: 548531, name: "Charnerwadi" },
      { id: 548638, name: "Chinchkheda" },
      { id: 548628, name: "Chinchpur" },
      { id: 548536, name: "Chinchwan" },
      { id: 548635, name: "Dahigaon" },
      { id: 548554, name: "Dakala" },
      { id: 548539, name: "Deulgaon Bajar" },
      { id: 548540, name: "Deulgaonwadi" },
      { id: 548605, name: "Dhamni" },
      { id: 548616, name: "Dhanora" },
      { id: 548526, name: "Dharla" },
      { id: 548533, name: "Dhawada" },
      { id: 548619, name: "Dhondkheda" },
      { id: 548599, name: "Dhotra" },
      { id: 548618, name: "Didgaon" },
      { id: 548590, name: "Digras" },
      { id: 548612, name: "Doiphoda" },
      { id: 548636, name: "Dongargaon" },
      { id: 548645, name: "Gavhali" },
      { id: 548647, name: "Georai Shemi" },
      { id: 548552, name: "Ghatambri" },
      { id: 548525, name: "Ghatnandra" },
      { id: 548596, name: "Golegaon Bk." },
      { id: 548597, name: "Golegaon Kh." },
      { id: 548553, name: "Halda" },
      { id: 548567, name: "Hatti" },
      { id: 548556, name: "Jalki (Vasai)" },
      { id: 548601, name: "Jalki Bajar" },
      { id: 548577, name: "Jalki Ghat" },
      { id: 548563, name: "Jambhai" },
      { id: 548561, name: "Janasi" },
      { id: 548551, name: "Janjala" },
      { id: 548654, name: "Kaigaon" },
      { id: 548595, name: "Kajipur" },
      { id: 548604, name: "Kasod" },
      { id: 548529, name: "Kelgaon" },
      { id: 548637, name: "Kerhala" },
      { id: 548570, name: "Khandala" },
      { id: 548620, name: "Khatkheda" },
      { id: 548572, name: "Khedi" },
      { id: 548568, name: "Khullod" },
      { id: 548600, name: "Khupta" },
      { id: 548528, name: "Korhala" },
      { id: 548543, name: "Kotnandra" },
      { id: 548613, name: "Kutubpur" },
      { id: 548571, name: "Leha" },
      { id: 548624, name: "Lonwadi" },
      { id: 548588, name: "Madni" },
      { id: 548625, name: "Mandgaon" },
      { id: 548573, name: "Mandna" },
      { id: 548631, name: "Mangrul" },
      { id: 548623, name: "Mhasla Bk." },
      { id: 548621, name: "Mhasla Kh." },
      { id: 548608, name: "Modha Bk." },
      { id: 548614, name: "Modha Kh." },
      { id: 548574, name: "Mohal" },
      { id: 548579, name: "Mukpath" },
      { id: 548550, name: "Nanegaon" },
      { id: 548586, name: "Natvi" },
      { id: 548649, name: "Nillod" },
      { id: 548630, name: "Palod" },
      { id: 548627, name: "Palshi" },
      { id: 548594, name: "Panas" },
      { id: 548558, name: "Pangri" },
      { id: 548598, name: "Panwadod Bk." },
      { id: 548602, name: "Panwadod Kh." },
      { id: 548538, name: "Pendgaon (Amthana)" },
      { id: 548578, name: "Pimpaldari" },
      { id: 548530, name: "Pimpalgaon Ghat" },
      { id: 548641, name: "Pimpalgaon Peth" },
      { id: 548639, name: "Pimpri" },
      { id: 548611, name: "Pirola" },
      { id: 548633, name: "Rahimabad" },
      { id: 943247, name: "Rajalwadi" },
      { id: 548581, name: "Ranjani" },
      { id: 548564, name: "Relgaon" },
      { id: 548592, name: "Sarati" },
      { id: 548603, name: "Sarola" },
      { id: 548566, name: "Sasurwada" },
      { id: 548542, name: "Sawkheda Bk." },
      { id: 548547, name: "Sawkheda Kh." },
      { id: 548562, name: "Shekhapur" },
      { id: 548535, name: "Shindephal" },
      { id: 548589, name: "Shivna" },
      { id: 943246, name: "Sillod" },
      { id: 548560, name: "Sirsala" },
      { id: 548549, name: "Sirsala Tanda" },
      { id: 548617, name: "Sisarkheda" },
      { id: 548546, name: "Sonappawadi" },
      { id: 548655, name: "Takli Jiwrag" },
      { id: 548622, name: "Takli Kh." },
      { id: 548534, name: "Talni" },
      { id: 548644, name: "Talwada" },
      { id: 548569, name: "Undangaon" },
      { id: 548626, name: "Upli" },
      { id: 548557, name: "Virgaon" },
      { id: 548576, name: "Wadala" },
      { id: 548587, name: "Wadali" },
      { id: 548606, name: "Wadod Chatha" },
      { id: 548585, name: "Waghera" },
      { id: 548609, name: "Wangi Bk." },
      { id: 548607, name: "Wangi Kh." },
      { id: 548615, name: "Wanjola" },
      { id: 548653, name: "Warkhedi" },
      { id: 548640, name: "Warud Kh." },
      { id: 548555, name: "Wasai" },
    ],
    4136: [
      { id: 548693, name: "Adgaon Bk." },
      { id: 548714, name: "Adgaon Kh." },
      { id: 548681, name: "Alad" },
      { id: 548744, name: "Babhulgaon" },
      { id: 548677, name: "Babhulgaon Kh." },
      { id: 548667, name: "Babra" },
      { id: 548706, name: "Bhalgaon" },
      { id: 548711, name: "Bhawadi" },
      { id: 548726, name: "Bhoygaon" },
      { id: 548737, name: "Bilda" },
      { id: 548665, name: "Bodhegaon Bk." },
      { id: 548666, name: "Bodhegaon Kh." },
      { id: 548698, name: "Borgaon Arj" },
      { id: 548668, name: "Chincholi (Nakib)" },
      { id: 548740, name: "Chincholi Bk" },
      { id: 548729, name: "Daregaon" },
      { id: 548741, name: "Dhamangaon" },
      { id: 548658, name: "Dhanora" },
      { id: 548725, name: "Dongargaon Kawad" },
      { id: 548692, name: "Dongargaon Shev" },
      { id: 548730, name: "Fulambri" },
      { id: 548735, name: "Ganori" },
      { id: 548713, name: "Georai Gungi" },
      { id: 548702, name: "Georai Paiga" },
      { id: 548743, name: "Girsawali" },
      { id: 548683, name: "Gumastala" },
      { id: 548662, name: "Hiwara" },
      { id: 548703, name: "Jalgaon Mete" },
      { id: 548689, name: "Janefal" },
      { id: 548742, name: "Jategaon" },
      { id: 548663, name: "Jatwa" },
      { id: 548661, name: "Kanhegaon" },
      { id: 548721, name: "Kanhori" },
      { id: 548707, name: "Kawitkheda" },
      { id: 548679, name: "Khamgaon" },
      { id: 548734, name: "Kingaon" },
      { id: 548722, name: "Lahanyachiwadi" },
      { id: 548672, name: "Lalwan" },
      { id: 548686, name: "Leha Babra" },
      { id: 548746, name: "Lohgad Nandra" },
      { id: 548695, name: "Mahal Kinhola" },
      { id: 548678, name: "Mamnabad" },
      { id: 548747, name: "Marsawali" },
      { id: 548719, name: "Mhasla" },
      { id: 548736, name: "Murshadabadwadi" },
      { id: 548674, name: "Naigaon" },
      { id: 548680, name: "Naigavhan" },
      { id: 548710, name: "Narla" },
      { id: 548675, name: "Nidhona" },
      { id: 548700, name: "Nimkheda" },
      { id: 548701, name: "Padali" },
      { id: 548673, name: "Padali Wawana" },
      { id: 548724, name: "Pal" },
      { id: 548708, name: "Pathri" },
      { id: 548699, name: "Pedgaon Alad" },
      { id: 548727, name: "Pimpalgaon Gangdeo" },
      { id: 548720, name: "Pimpalgaon Walan" },
      { id: 548718, name: "Pimpalgaondeo" },
      { id: 548716, name: "Pirbawada" },
      { id: 548676, name: "Pokhari" },
      { id: 548659, name: "Pophala" },
      { id: 548715, name: "Ranjangaon" },
      { id: 548731, name: "Relgaon" },
      { id: 548656, name: "Ridhora" },
      { id: 548738, name: "Sanjul" },
      { id: 548684, name: "Satal Pimpri" },
      { id: 548682, name: "Satala Bk." },
      { id: 548660, name: "Shahapur" },
      { id: 548690, name: "Shelgaon" },
      { id: 548712, name: "Shelgaon Kh." },
      { id: 548697, name: "Shevta Bk." },
      { id: 548704, name: "Shevta Kh." },
      { id: 548688, name: "Shirodi Bk" },
      { id: 548691, name: "Shirodi Kh" },
      { id: 548669, name: "Sonari Bk." },
      { id: 548670, name: "Sonari Kh." },
      { id: 548728, name: "Sultanwadi" },
      { id: 548657, name: "Takali Kolte" },
      { id: 547385, name: "Talegaon" },
      { id: 548664, name: "Umravati" },
      { id: 548705, name: "Wadod Bajar" },
      { id: 548696, name: "Wadod Kh." },
      { id: 548709, name: "Waghalagaon" },
      { id: 548745, name: "Waghola" },
      { id: 548687, name: "Wahegaon" },
      { id: 548694, name: "Wakod" },
      { id: 548732, name: "Wanegaon Bk" },
      { id: 548717, name: "Wanegaon Kh" },
      { id: 548733, name: "Waregaon" },
      { id: 548671, name: "Wawana" },
      { id: 548685, name: "Wiramgaon" },
    ],
    4137: [
      { id: 548859, name: "Abdimandi" },
      { id: 548852, name: "Adgaon Bk" },
      { id: 548898, name: "Adgaon Kh" },
      { id: 548779, name: "Adgaon Maholi" },
      { id: 548780, name: "Adgaon Sarak" },
      { id: 548794, name: "Alampur" },
      { id: 548912, name: "Ambikapur" },
      { id: 548788, name: "Anjandoh" },
      { id: 548787, name: "Antapur" },
      { id: 548904, name: "Apatgaon" },
      { id: 943218, name: "Asefbagh" },
      { id: 548774, name: "Ashrafpur" },
      { id: 548801, name: "Aurangpur" },
      { id: 548882, name: "Bagtalav" },
      { id: 548778, name: "Bakapur" },
      { id: 548881, name: "Balapur" },
      { id: 943233, name: "Banewadi" },
      { id: 548817, name: "Bangaon" },
      { id: 944705, name: "Banwadi Tanda" },
      { id: 548923, name: "Bebalyachiwadi" },
      { id: 548822, name: "Bendewadi" },
      { id: 548818, name: "Bhabarda" },
      { id: 548888, name: "Bhalgaon" },
      { id: 943234, name: "Bhavsingpura" },
      { id: 548766, name: "Bhikapur" },
      { id: 548884, name: "Bhindon" },
      { id: 548797, name: "Bhogalwadi" },
      { id: 548755, name: "Borwadi" },
      { id: 548756, name: "Borwadi Tanda" },
      { id: 944870, name: "Brijwadi" },
      { id: 548792, name: "Chartha" },
      { id: 548749, name: "Chauka" },
      { id: 943220, name: "Chhatrapati Sambhajinagar" },
      { id: 943226, name: "Chikalthana" },
      { id: 548853, name: "Chincholi" },
      { id: 548907, name: "Chitegaon" },
      { id: 548908, name: "Chitte Pimpalgaon" },
      { id: 548917, name: "Daigavhan" },
      { id: 548897, name: "Darakwadi" },
      { id: 548804, name: "Daregaon" },
      { id: 548858, name: "Daulatabad" },
      { id: 548784, name: "Daulatpur" },
      { id: 548842, name: "Demani" },
      { id: 548880, name: "Devlai" },
      { id: 548866, name: "Dharmapur" },
      { id: 548803, name: "Dhawalapuri" },
      { id: 548757, name: "Dhondkheda" },
      { id: 548768, name: "Dhopateshwar" },
      { id: 548754, name: "Donwada" },
      { id: 548819, name: "Dudhad" },
      { id: 548893, name: "Eklahara" },
      { id: 548905, name: "Ekod" },
      { id: 548814, name: "Fattepur" },
      { id: 548824, name: "Gade Jalgaon" },
      { id: 548928, name: "Gadiwat" },
      { id: 548883, name: "Gandheli" },
      { id: 548815, name: "Gangapur Jahagir" },
      { id: 548874, name: "Gangapur Nehari" },
      { id: 548889, name: "Garkheda" },
      { id: 943248, name: "Garkheda Shahari" },
      { id: 548772, name: "Gavadari Tanda" },
      { id: 548876, name: "Georai" },
      { id: 548806, name: "Georai Kuber" },
      { id: 548875, name: "Georai Tanda" },
      { id: 548929, name: "Ghardon" },
      { id: 548925, name: "Ghardon Tanda" },
      { id: 548916, name: "Gharegaon Ektuni" },
      { id: 548915, name: "Gharegaon Pimpri" },
      { id: 548877, name: "Girnera" },
      { id: 548878, name: "Girnera Tanda" },
      { id: 548844, name: "Golatgaon" },
      { id: 548871, name: "Golwadi" },
      { id: 548783, name: "Gopalpur" },
      { id: 943239, name: "Harsul" },
      { id: 548825, name: "Hasanabadwadi" },
      { id: 548910, name: "Hasanpur" },
      { id: 548790, name: "Hatmali" },
      { id: 944711, name: "Hattesingpura" },
      { id: 943240, name: "Himayatnagar" },
      { id: 548813, name: "Hirapur" },
      { id: 548846, name: "Hivra" },
      { id: 548899, name: "Husenpur" },
      { id: 548909, name: "Ibrahimpur" },
      { id: 548773, name: "Islampurwadi" },
      { id: 943219, name: "Itkeda" },
      { id: 548847, name: "Jadgaon" },
      { id: 943227, name: "Jadhavwadi" },
      { id: 548816, name: "Jaipur" },
      { id: 943225, name: "Jaisingpura" },
      { id: 548903, name: "Jakmatha" },
      { id: 548823, name: "Jalgaon Feran" },
      { id: 943249, name: "Jasvantpura" },
      { id: 548771, name: "Jatwada" },
      { id: 548828, name: "Jawatpur" },
      { id: 548930, name: "Jodwadi" },
      { id: 548770, name: "Jogwada" },
      { id: 548802, name: "Kachanapur" },
      { id: 548810, name: "Kachhighati" },
      { id: 548931, name: "Kachner" },
      { id: 548932, name: "Kachner Tanda" },
      { id: 548921, name: "Kadrabad" },
      { id: 943221, name: "Kanchanwadi" },
      { id: 548777, name: "Kanhapur" },
      { id: 548759, name: "Kankora" },
      { id: 548841, name: "Karajgaon" },
      { id: 548894, name: "Karhol" },
      { id: 548837, name: "Karmad" },
      { id: 548868, name: "Karodi" },
      { id: 548857, name: "Kesapuri" },
      { id: 548862, name: "Kesapuri Tanda" },
      { id: 943223, name: "Kesarsingpura" },
      { id: 548753, name: "Khamkheda" },
      { id: 548924, name: "Khodegaon" },
      { id: 548896, name: "Kodgaon Ambad" },
      { id: 548895, name: "Kodgaon Jalna" },
      { id: 943224, name: "Kokanwadi" },
      { id: 548914, name: "Kolghar" },
      { id: 548763, name: "Kolthan" },
      { id: 548821, name: "Konewadi" },
      { id: 548762, name: "Krishnapurwadi" },
      { id: 548835, name: "Kubhephal" },
      { id: 943222, name: "Kutubpura" },
      { id: 548836, name: "Ladgaon" },
      { id: 548798, name: "Ladsawangi" },
      { id: 548796, name: "Lamkana" },
      { id: 548922, name: "Laygaon" },
      { id: 548758, name: "Lingdari" },
      { id: 548826, name: "Mahalpimpri" },
      { id: 548892, name: "Mahamadpur" },
      { id: 548829, name: "Malharpur" },
      { id: 548863, name: "Maliwada" },
      { id: 548900, name: "Malkapur" },
      { id: 548782, name: "Mandki" },
      { id: 548845, name: "Mangrul" },
      { id: 943237, name: "Masnatpur" },
      { id: 943235, name: "Mitmita" },
      { id: 548752, name: "Morvira" },
      { id: 944714, name: "Mukundwadi" },
      { id: 548827, name: "Murshadkuli" },
      { id: 548795, name: "Murshadpur" },
      { id: 943236, name: "Murtujapur" },
      { id: 548748, name: "Murumkheda" },
      { id: 944871, name: "Musthafabad" },
      { id: 548765, name: "Naigaon" },
      { id: 548789, name: "Naigavhan" },
      { id: 943228, name: "Nakshatrawadi" },
      { id: 548775, name: "Nanakwadi" },
      { id: 943229, name: "Naregaon" },
      { id: 548850, name: "Nipani" },
      { id: 548767, name: "Ohar" },
      { id: 548906, name: "Pachod" },
      { id: 943231, name: "Padampura" },
      { id: 943230, name: "Padegaon" },
      { id: 943232, name: "Pahadsingpura" },
      { id: 548781, name: "Palshi" },
      { id: 548920, name: "Pandhari Pimpalgaon" },
      { id: 548935, name: "Pandharpur" },
      { id: 548854, name: "Pardari" },
      { id: 548855, name: "Pardari Tanda" },
      { id: 548873, name: "Patoda" },
      { id: 548919, name: "Pimpalgaon Pandhari" },
      { id: 548805, name: "Pimpalkhunta" },
      { id: 548901, name: "Pimpri Bk" },
      { id: 548902, name: "Pimpri Kh" },
      { id: 548809, name: "Pirwadi" },
      { id: 548785, name: "Pisadevi" },
      { id: 548776, name: "Pokhari" },
      { id: 548769, name: "Rahalpatti Tanda" },
      { id: 548830, name: "Rampur" },
      { id: 548861, name: "Rampuri" },
      { id: 914295, name: "Raoraspura." },
      { id: 548793, name: "Rustumpur" },
      { id: 548786, name: "Sahajatpur" },
      { id: 548926, name: "Sahastramuli" },
      { id: 548918, name: "Sanjkheda" },
      { id: 548760, name: "Sarola" },
      { id: 548751, name: "Satala" },
      { id: 548838, name: "Satana" },
      { id: 548934, name: "Satara" },
      { id: 548761, name: "Sawangi" },
      { id: 548800, name: "Sayyadpur" },
      { id: 548791, name: "Selud" },
      { id: 548869, name: "Shahajapur" },
      { id: 943238, name: "Shahanurwadi" },
      { id: 548911, name: "Shahapur" },
      { id: 548867, name: "Shekapur" },
      { id: 548840, name: "Shekta" },
      { id: 548833, name: "Shendra Jahagir" },
      { id: 548834, name: "Shendraban" },
      { id: 548865, name: "Shernapur" },
      { id: 548820, name: "Shevga" },
      { id: 548885, name: "Shivgad Tanda" },
      { id: 548886, name: "Sindon" },
      { id: 548860, name: "Sirasmal" },
      { id: 548799, name: "Sultanpur" },
      { id: 548811, name: "Sultanpur (Ladsawangi)" },
      { id: 548831, name: "Sundarwadi" },
      { id: 548832, name: "Takli Shimpi" },
      { id: 548849, name: "Takli Vaidya" },
      { id: 548913, name: "Taklimali" },
      { id: 548870, name: "Tisgaon" },
      { id: 548856, name: "Tohla Naik Tanda" },
      { id: 548848, name: "Tongaon" },
      { id: 548764, name: "Tuljapur" },
      { id: 548891, name: "Uchalti" },
      { id: 548890, name: "Vitthalpur" },
      { id: 548933, name: "Wadgaon Kolhati" },
      { id: 548887, name: "Wadgavhan Kh" },
      { id: 548808, name: "Wadkha" },
      { id: 548843, name: "Wahegaon" },
      { id: 548872, name: "Waladgaon" },
      { id: 548864, name: "Wanjarwadi" },
      { id: 548812, name: "Warud Kaji" },
      { id: 548807, name: "Warzadi" },
      { id: 548851, name: "Zalta" },
    ],
    4138: [
      { id: 548987, name: "Abdullapur" },
      { id: 548946, name: "Akhatwada" },
      { id: 548943, name: "Azampur" },
      { id: 548951, name: "Badlabai" },
      { id: 548979, name: "Bazar Sawangi" },
      { id: 548998, name: "Bhandegaon" },
      { id: 549004, name: "Bhataji" },
      { id: 548970, name: "Bodkha" },
      { id: 549001, name: "Borwadi" },
      { id: 548945, name: "Chincholi" },
      { id: 548967, name: "Daregaon" },
      { id: 548993, name: "Deolana Bk" },
      { id: 548994, name: "Deolana Kh" },
      { id: 548982, name: "Dhamangaon" },
      { id: 548972, name: "Dhamni" },
      { id: 549000, name: "Gadana" },
      { id: 548944, name: "Galleborgaon" },
      { id: 548965, name: "Gandheshwar" },
      { id: 549009, name: "Ghodegaon" },
      { id: 549006, name: "Golegaon" },
      { id: 548974, name: "Indapur" },
      { id: 549007, name: "Jafarwadi" },
      { id: 548962, name: "Kagjipura" },
      { id: 548984, name: "Kanadgaon" },
      { id: 548983, name: "Kanakshil" },
      { id: 548957, name: "Kasabkheda" },
      { id: 548936, name: "Kautgaon" },
      { id: 549008, name: "Khandi Pimpalgaon" },
      { id: 548947, name: "Khaspur" },
      { id: 548992, name: "Khatnapur" },
      { id: 548964, name: "Khirdi" },
      { id: 548954, name: "Khuldabad" },
      { id: 548989, name: "Lamangaon" },
      { id: 548973, name: "Loni" },
      { id: 548985, name: "Mahamadpur" },
      { id: 548959, name: "Malkapur" },
      { id: 548956, name: "Mambapur" },
      { id: 549002, name: "Mamnapur" },
      { id: 548977, name: "Mamurabad." },
      { id: 548995, name: "Matargaon" },
      { id: 548963, name: "Mawsala" },
      { id: 548988, name: "Mhaismal" },
      { id: 548961, name: "Nandrabad" },
      { id: 548941, name: "Nirgudi Bk" },
      { id: 548939, name: "Nirgudi Kh." },
      { id: 548968, name: "Padli" },
      { id: 548940, name: "Palasgaon" },
      { id: 548948, name: "Palaswadi" },
      { id: 548942, name: "Pimpri" },
      { id: 548980, name: "Rail" },
      { id: 549011, name: "Rasulpura" },
      { id: 548953, name: "Salukheda" },
      { id: 549003, name: "Sarai" },
      { id: 548971, name: "Sawkheda" },
      { id: 548958, name: "Shahjatpur" },
      { id: 549010, name: "Shankarpurwadi" },
      { id: 548949, name: "Shekapuri" },
      { id: 548976, name: "Shekhapur" },
      { id: 548975, name: "Sobalgaon" },
      { id: 549005, name: "Sonkheda" },
      { id: 548960, name: "Sulibhanjan" },
      { id: 548981, name: "Sultanabad" },
      { id: 548999, name: "Sultanpur" },
      { id: 548978, name: "Tajnapur" },
      { id: 548990, name: "Takali Rajaray" },
      { id: 548937, name: "Tisgaon" },
      { id: 548950, name: "Verul" },
      { id: 548991, name: "Viramgaon" },
      { id: 548966, name: "Wadgaon" },
      { id: 548996, name: "Wadhod Bk." },
      { id: 548986, name: "Wadhod Kh" },
      { id: 548997, name: "Yesgaon" },
      { id: 548969, name: "Zari" },
    ],
    4139: [
      { id: 549126, name: "Agar Saigaon" },
      { id: 549097, name: "Aghur" },
      { id: 549033, name: "Alapurwadi" },
      { id: 549068, name: "Amanatpurwadi" },
      { id: 549024, name: "Anchalgaon" },
      { id: 549088, name: "Aurangpur" },
      { id: 549172, name: "Awwalgaon" },
      { id: 549056, name: "Babhulgaon Bk." },
      { id: 549154, name: "Babhulgaon Ganga" },
      { id: 549057, name: "Babhulgaon Kh." },
      { id: 549043, name: "Babhulkheda" },
      { id: 549015, name: "Babhultel" },
      { id: 549151, name: "Babtara" },
      { id: 549060, name: "Baigaon" },
      { id: 549175, name: "Bajathan" },
      { id: 549020, name: "Balhegaon" },
      { id: 549131, name: "Ballali Sagaj" },
      { id: 549107, name: "Belgaon" },
      { id: 549090, name: "Bendawadi" },
      { id: 549012, name: "Bhadali" },
      { id: 549106, name: "Bhaggaon" },
      { id: 549135, name: "Bhagur" },
      { id: 549064, name: "Bhaigaon Ganga" },
      { id: 549093, name: "Bhaigaon Vaijapur" },
      { id: 549169, name: "Bhalgaon" },
      { id: 549049, name: "Bhatana" },
      { id: 549146, name: "Bhaur" },
      { id: 549081, name: "Bhingi" },
      { id: 549085, name: "Bhivgaon" },
      { id: 549053, name: "Bhokargaon" },
      { id: 549077, name: "Biloli" },
      { id: 549021, name: "Birola" },
      { id: 549082, name: "Borsar" },
      { id: 549170, name: "Chandegaon" },
      { id: 549099, name: "Chandgaon" },
      { id: 549177, name: "Chenduphal" },
      { id: 549027, name: "Chikatgaon" },
      { id: 549127, name: "Chinchadgaon" },
      { id: 549160, name: "Chorwaghalgaon" },
      { id: 549168, name: "Dagpimpalgaon" },
      { id: 549116, name: "Dahegaon" },
      { id: 549025, name: "Daskul" },
      { id: 549109, name: "Dawala" },
      { id: 549176, name: "Deogaon Shani" },
      { id: 549067, name: "Dhondalgaon" },
      { id: 549152, name: "Dongaon" },
      { id: 549134, name: "Ekodi Sagaj" },
      { id: 549137, name: "Fakirabadwadi" },
      { id: 549173, name: "Gadhe Pimpalgaon" },
      { id: 549054, name: "Garaj" },
      { id: 549105, name: "Ghaigaon" },
      { id: 549115, name: "Golwadi" },
      { id: 549031, name: "Gondgaon" },
      { id: 549145, name: "Goygaon" },
      { id: 549122, name: "Hadas Pimpalgaon" },
      { id: 549037, name: "Hajipurwadi" },
      { id: 549174, name: "Hamrapur" },
      { id: 549159, name: "Hanumantgaon" },
      { id: 549133, name: "Hargovindpur" },
      { id: 549074, name: "Hilalpur" },
      { id: 549042, name: "Hingane Kannad" },
      { id: 549147, name: "Hingoni" },
      { id: 549124, name: "Jalgaon" },
      { id: 549113, name: "Jambargaon" },
      { id: 549058, name: "Jambarkheda" },
      { id: 549075, name: "Janephal" },
      { id: 549094, name: "Jarul" },
      { id: 549164, name: "Jategaon" },
      { id: 549019, name: "Jiri" },
      { id: 549128, name: "Kanak Sagaj" },
      { id: 549148, name: "Kangoni" },
      { id: 549143, name: "Kapus Wadgaon" },
      { id: 549119, name: "Karanjgaon" },
      { id: 549163, name: "Kautgaon" },
      { id: 549017, name: "Kavit Kheda" },
      { id: 549110, name: "Khambala" },
      { id: 549079, name: "Khandala" },
      { id: 549028, name: "Kharaj" },
      { id: 549132, name: "Khirdi" },
      { id: 549044, name: "Khirdi Kannad" },
      { id: 549136, name: "Kiratpur" },
      { id: 549080, name: "Kolhi" },
      { id: 549073, name: "Koradgaon" },
      { id: 549144, name: "Ladgaon" },
      { id: 549078, name: "Lakh Khandala" },
      { id: 549061, name: "Lakhani" },
      { id: 549150, name: "Lakhganga" },
      { id: 549118, name: "Lakhmapurwadi" },
      { id: 549121, name: "Lasurgaon" },
      { id: 549096, name: "Loni Bk." },
      { id: 549026, name: "Loni Kh." },
      { id: 549161, name: "Mahalgaon" },
      { id: 549103, name: "Makarmatpur" },
      { id: 549052, name: "Malegaon Kannad" },
      { id: 549167, name: "Mali Ghogargaon" },
      { id: 549130, name: "Mali Sagaj" },
      { id: 549063, name: "Mandki" },
      { id: 549041, name: "Manegaon" },
      { id: 549040, name: "Manoli" },
      { id: 549046, name: "Manoor" },
      { id: 549139, name: "Mhaski" },
      { id: 549087, name: "Mirakhnagar" },
      { id: 549142, name: "Murshadpur" },
      { id: 549158, name: "Nadi" },
      { id: 549171, name: "Nagamthan" },
      { id: 549111, name: "Nagina Pimpalgaon" },
      { id: 549016, name: "Naigavhan" },
      { id: 549083, name: "Nalegaon" },
      { id: 549100, name: "Nandgaon" },
      { id: 549155, name: "Nandur Dhok" },
      { id: 549076, name: "Narala" },
      { id: 549149, name: "Narayanpur" },
      { id: 549030, name: "Nimgaon" },
      { id: 549125, name: "Palkhed" },
      { id: 549095, name: "Panghavan" },
      { id: 549165, name: "Panvi Bk." },
      { id: 549091, name: "Panvi Kh." },
      { id: 549092, name: "Panvi Khandala" },
      { id: 549071, name: "Parala" },
      { id: 549089, name: "Parsoda" },
      { id: 549066, name: "Pashapur" },
      { id: 549062, name: "Pathri" },
      { id: 549032, name: "Pendephal" },
      { id: 549048, name: "Pimpalgaon Khandala" },
      { id: 549051, name: "Pokhari" },
      { id: 549153, name: "Purangaon" },
      { id: 549038, name: "Raghunathpurwadi" },
      { id: 549069, name: "Rahegaon" },
      { id: 549117, name: "Rahegavhan" },
      { id: 549070, name: "Rajura" },
      { id: 549098, name: "Rotegaon" },
      { id: 549039, name: "Safiyabadwadi" },
      { id: 549047, name: "Sakegaon" },
      { id: 549045, name: "Salegaon" },
      { id: 549084, name: "Sanjarpurwadi" },
      { id: 549112, name: "Satana" },
      { id: 549086, name: "Sawandgaon" },
      { id: 549156, name: "Sawkhed Ganga" },
      { id: 549022, name: "Sawkhed Khandala" },
      { id: 549123, name: "Shahjatpur" },
      { id: 549035, name: "Shioor" },
      { id: 549055, name: "Shivgaon" },
      { id: 549114, name: "Shivrai" },
      { id: 549138, name: "Siddhapur" },
      { id: 549140, name: "Sirasgaon" },
      { id: 549120, name: "Sonwadi" },
      { id: 549108, name: "Surala" },
      { id: 549129, name: "Takli Sagaj" },
      { id: 549013, name: "Talwada" },
      { id: 549036, name: "Tartyachi Wadi" },
      { id: 549162, name: "Tembhi" },
      { id: 549104, name: "Tidhi" },
      { id: 549029, name: "Titarkheda" },
      { id: 549023, name: "Tunki" },
      { id: 549065, name: "Undirwadi" },
      { id: 549101, name: "Vaijapur" },
      { id: 549141, name: "Virgaon" },
      { id: 549072, name: "Wadji" },
      { id: 549050, name: "Waghla" },
      { id: 549014, name: "Wakla" },
      { id: 549166, name: "Wakti" },
      { id: 549018, name: "Walan" },
      { id: 549157, name: "Wanjargaon" },
      { id: 549059, name: "Zolegaon" },
    ],
    4140: [
      { id: 549279, name: "Abdulpur" },
      { id: 549335, name: "Agar Kanadgaon" },
      { id: 549284, name: "Agathan" },
      { id: 549360, name: "Ager Wadgaon" },
      { id: 549314, name: "Akoli Wadgaon" },
      { id: 549327, name: "Alamgirpur" },
      { id: 549356, name: "Amalner" },
      { id: 549231, name: "Ambegaon" },
      { id: 549259, name: "Ambelohal" },
      { id: 943241, name: "Ambewadi" },
      { id: 549315, name: "Aminabad" },
      { id: 549399, name: "Anantpur" },
      { id: 549281, name: "Antapur" },
      { id: 549350, name: "Antapur (Bhendala)" },
      { id: 549196, name: "Apegaon" },
      { id: 549202, name: "Arapur" },
      { id: 549225, name: "Asegaon" },
      { id: 549382, name: "Aurangpur" },
      { id: 549339, name: "Babargaon" },
      { id: 549187, name: "Babhulgaon" },
      { id: 549337, name: "Bagadi" },
      { id: 549341, name: "Balapur" },
      { id: 549229, name: "Bargipur" },
      { id: 549286, name: "Bhagathan" },
      { id: 549321, name: "Bhalgaon" },
      { id: 549347, name: "Bhendala" },
      { id: 549359, name: "Bhivdhanora" },
      { id: 549269, name: "Bhoigaon" },
      { id: 549338, name: "Bolegaon" },
      { id: 549301, name: "Bolthan" },
      { id: 549260, name: "Borgaon" },
      { id: 549392, name: "Borodi" },
      { id: 549210, name: "Butte Wadgaon" },
      { id: 549282, name: "Chandikpur" },
      { id: 549205, name: "Chinchkheda" },
      { id: 549369, name: "Dahegaon" },
      { id: 549190, name: "Daigaon" },
      { id: 549295, name: "Derda" },
      { id: 549181, name: "Derhal" },
      { id: 549207, name: "Devli" },
      { id: 549283, name: "Dhamori Bk." },
      { id: 549191, name: "Dhamori Kh." },
      { id: 549367, name: "Dhoregaon" },
      { id: 549273, name: "Dighi" },
      { id: 549178, name: "Dinwada" },
      { id: 549212, name: "Diwashi" },
      { id: 549261, name: "Domegaon" },
      { id: 549185, name: "Dongaon" },
      { id: 549193, name: "Ekburji Waghalgaon" },
      { id: 549238, name: "Eklahera" },
      { id: 549331, name: "Fajalpur" },
      { id: 549217, name: "Fatiyabad" },
      { id: 549223, name: "Fatulabad" },
      { id: 549254, name: "Fulshevra" },
      { id: 549294, name: "Gajgaon" },
      { id: 549358, name: "Galnimb" },
      { id: 549348, name: "Ganeshwadi" },
      { id: 549351, name: "Gangapur" },
      { id: 549198, name: "Gavli Dhanora" },
      { id: 549252, name: "Gavli Shivra" },
      { id: 549236, name: "Ghanegaon" },
      { id: 549304, name: "Ghodegaon" },
      { id: 549216, name: "Girnera" },
      { id: 549255, name: "Golegaon" },
      { id: 549290, name: "Gopalwadi" },
      { id: 549197, name: "Govindpur" },
      { id: 549370, name: "Guru Dhanora" },
      { id: 549307, name: "Hadiyabad" },
      { id: 549333, name: "Haibatpur" },
      { id: 549227, name: "Haibatpur (Wahegaon)" },
      { id: 549325, name: "Hakikatpur" },
      { id: 549376, name: "Hamjabad" },
      { id: 549345, name: "Hanumantgaon" },
      { id: 549400, name: "Harsul" },
      { id: 549381, name: "Harsuli" },
      { id: 549248, name: "Hirapur" },
      { id: 549234, name: "Ibrahimpur" },
      { id: 549218, name: "Ismailpur" },
      { id: 549237, name: "Itawa" },
      { id: 943242, name: "Jakhmatha" },
      { id: 549215, name: "Jambhala" },
      { id: 549354, name: "Jamgaon" },
      { id: 549274, name: "Jikthan" },
      { id: 549240, name: "Jogeshwari" },
      { id: 549355, name: "Kaigaon" },
      { id: 549272, name: "Kalegaon" },
      { id: 549241, name: "Kamlapur" },
      { id: 549267, name: "Kankori" },
      { id: 549239, name: "Kasoda" },
      { id: 549311, name: "Katepimpalgaon" },
      { id: 549201, name: "Khadak Narala" },
      { id: 549312, name: "Khadak Waghalgaon" },
      { id: 549293, name: "Khadgaon" },
      { id: 549366, name: "Khairgawhan" },
      { id: 549228, name: "Khojewadi" },
      { id: 549300, name: "Khopeshwar" },
      { id: 549182, name: "Kinhal" },
      { id: 549268, name: "Kobapur" },
      { id: 549384, name: "Kodapur" },
      { id: 549305, name: "Kolghar" },
      { id: 549357, name: "Lakhmapur" },
      { id: 549247, name: "Lanzi" },
      { id: 549276, name: "Limbe Jalgaon" },
      { id: 944717, name: "Madalapur" },
      { id: 549396, name: "Mahalaxmi Kheda" },
      { id: 549285, name: "Mahebubkheda" },
      { id: 549250, name: "Mahmadpur" },
      { id: 549208, name: "Mahmadpur (Pimparkheda)" },
      { id: 549324, name: "Maholi" },
      { id: 549180, name: "Maliwadgaon" },
      { id: 549262, name: "Malkapur" },
      { id: 549306, name: "Malunja Bk." },
      { id: 549308, name: "Malunja Kh." },
      { id: 549336, name: "Mamdapur" },
      { id: 549388, name: "Mandava" },
      { id: 549394, name: "Mangegaon" },
      { id: 549329, name: "Manjari" },
      { id: 549206, name: "Manjarpur" },
      { id: 549342, name: "Maujudabad" },
      { id: 549319, name: "Mendhi" },
      { id: 549249, name: "Mendhipur" },
      { id: 549320, name: "Mhasa" },
      { id: 549278, name: "Mirzapur" },
      { id: 549328, name: "Mudhesh Wadgaon" },
      { id: 549368, name: "Murmi" },
      { id: 549377, name: "Murshidabad" },
      { id: 549233, name: "Mustafabad" },
      { id: 549362, name: "Nagapur" },
      { id: 549378, name: "Nagapur (Shendurwada)" },
      { id: 549242, name: "Naigaon" },
      { id: 549235, name: "Nandeda" },
      { id: 549375, name: "Nandrabad" },
      { id: 549270, name: "Narayanpur" },
      { id: 549245, name: "Narayanpur Bk." },
      { id: 549232, name: "Narayanpur Kh." },
      { id: 549363, name: "Narsapur" },
      { id: 549398, name: "Narsingpur" },
      { id: 549353, name: "Nawabpur" },
      { id: 549334, name: "Nevargaon" },
      { id: 549184, name: "Pachapirwadi" },
      { id: 549186, name: "Padalsa" },
      { id: 549271, name: "Padampur" },
      { id: 549195, name: "Pahadpur" },
      { id: 549346, name: "Pakhora" },
      { id: 549296, name: "Palasgaon" },
      { id: 549387, name: "Pandharohal" },
      { id: 549219, name: "Pekalwadi" },
      { id: 549365, name: "Pendapur" },
      { id: 549211, name: "Pimpalgaon" },
      { id: 549343, name: "Pimpalwadi" },
      { id: 549251, name: "Pimparkheda" },
      { id: 549317, name: "Pimpri" },
      { id: 549221, name: "Potul" },
      { id: 549253, name: "Pratappur" },
      { id: 549374, name: "Puri" },
      { id: 549277, name: "Rahimpur" },
      { id: 549183, name: "Raipur" },
      { id: 549199, name: "Rajangaon Pol" },
      { id: 549265, name: "Rajura" },
      { id: 549258, name: "Rampuri" },
      { id: 549244, name: "Ramrai" },
      { id: 549401, name: "Ranjangaon (Shenpunji)" },
      { id: 549316, name: "Ranjangaon Narhari" },
      { id: 549288, name: "Rotasthal" },
      { id: 549349, name: "Saidapur" },
      { id: 549179, name: "Sanav" },
      { id: 549323, name: "Sanjarpur" },
      { id: 549322, name: "Sanjrabad" },
      { id: 549364, name: "Sarangpur" },
      { id: 549397, name: "Savkheda" },
      { id: 549189, name: "Sawangi" },
      { id: 549344, name: "Sayyadpur" },
      { id: 549192, name: "Shah Nawajpur" },
      { id: 549297, name: "Shahapur" },
      { id: 549224, name: "Shahapur Banjar" },
      { id: 549372, name: "Shahapur Kadim" },
      { id: 549287, name: "Shankarpur" },
      { id: 549393, name: "Shankarpur (Mangegaon)" },
      { id: 549310, name: "Sharifpur" },
      { id: 549292, name: "Shekta" },
      { id: 549379, name: "Shendurwada" },
      { id: 549318, name: "Shingi" },
      { id: 549204, name: "Shiregaon" },
      { id: 549263, name: "Shirodi" },
      { id: 549380, name: "Shivpur" },
      { id: 549246, name: "Shivrai" },
      { id: 549298, name: "Siddhanath Wadgaon" },
      { id: 549352, name: "Siddhapur" },
      { id: 549209, name: "Sillegaon" },
      { id: 549222, name: "Sindhi Sirasgaon" },
      { id: 549256, name: "Singpur" },
      { id: 549309, name: "Sirasgaon" },
      { id: 549289, name: "Siresaigaon" },
      { id: 549373, name: "Solegaon" },
      { id: 549203, name: "Sultanabad" },
      { id: 549371, name: "Sultanpur" },
      { id: 943243, name: "Sultanpur Gurudhanora" },
      { id: 943244, name: "Sultanpur Mangegaon" },
      { id: 549340, name: "Surewadi" },
      { id: 549220, name: "Takli" },
      { id: 549214, name: "Takliwadi" },
      { id: 549226, name: "Talesaman" },
      { id: 549386, name: "Talpimpri" },
      { id: 549303, name: "Tandulwadi" },
      { id: 549389, name: "Tandulwadi (Mangegaon)" },
      { id: 549280, name: "Tembhapuri" },
      { id: 549230, name: "Toki" },
      { id: 549361, name: "Trimbalpur" },
      { id: 549264, name: "Turkabad Kharadi" },
      { id: 549194, name: "Umarpur" },
      { id: 549302, name: "Uttarwadi" },
      { id: 549188, name: "Vairagad" },
      { id: 549299, name: "Wadali" },
      { id: 549257, name: "Wadgaon" },
      { id: 549332, name: "Wahegaon" },
      { id: 549291, name: "Wajnapur" },
      { id: 549402, name: "Waluj Bk." },
      { id: 549243, name: "Waluj Kh." },
      { id: 549326, name: "Warkhed" },
      { id: 549213, name: "Warzadi" },
      { id: 549200, name: "Wasusaigaon" },
      { id: 549395, name: "Wazar" },
      { id: 549266, name: "Yesgaon" },
      { id: 549390, name: "Yesgavhan" },
      { id: 549383, name: "Zanzardi" },
      { id: 549313, name: "Zodegaon" },
    ],
    4141: [
      { id: 549504, name: "Abdullapur" },
      { id: 549509, name: "Adgaon" },
      { id: 549505, name: "Adool Bk." },
      { id: 549500, name: "Adool Kh." },
      { id: 549512, name: "Adool Tanda" },
      { id: 549559, name: "Agapur" },
      { id: 946059, name: "Agarnandur" },
      { id: 549574, name: "Akhatwada" },
      { id: 549472, name: "Alipur" },
      { id: 549464, name: "Aliyabad" },
      { id: 549430, name: "Amrapur" },
      { id: 549573, name: "Anandpur" },
      { id: 549510, name: "Antarwali Khandi" },
      { id: 549558, name: "Apegaon" },
      { id: 549405, name: "Aurangpur" },
      { id: 549429, name: "Aurangpur Buttewadi" },
      { id: 549562, name: "Awade Uchegaon" },
      { id: 549436, name: "Babhulgaon" },
      { id: 549477, name: "Balanagar" },
      { id: 549426, name: "Balapur" },
      { id: 549452, name: "Ballalpur" },
      { id: 549456, name: "Bangala Tanda" },
      { id: 549457, name: "Banni Tanda" },
      { id: 549458, name: "Bidkin" },
      { id: 549438, name: "Bokud Jalgaon" },
      { id: 549488, name: "Borgaon" },
      { id: 549555, name: "Bramhagaon" },
      { id: 549420, name: "Bramhagavhan" },
      { id: 549511, name: "Bramhangaon" },
      { id: 549580, name: "Chanakwadi" },
      { id: 549587, name: "Changatpuri" },
      { id: 549415, name: "Chauryahattar Jalgaon" },
      { id: 549552, name: "Chinchala" },
      { id: 549442, name: "Chincholi" },
      { id: 549592, name: "Chitegaon" },
      { id: 549508, name: "Dabhrul" },
      { id: 549542, name: "Dadegaon Bk." },
      { id: 549578, name: "Dadegaon Jahagir" },
      { id: 549541, name: "Dadegaon Kh." },
      { id: 549566, name: "Dalwadi" },
      { id: 549476, name: "Daregaon" },
      { id: 549543, name: "Dawarwadi" },
      { id: 549544, name: "Dera" },
      { id: 549506, name: "Devgaon" },
      { id: 549507, name: "Devgaon Tanda" },
      { id: 549428, name: "Dhakephal" },
      { id: 549486, name: "Dhangaon" },
      { id: 549480, name: "Dhorkin" },
      { id: 549413, name: "Dhupkheda" },
      { id: 549414, name: "Dinnapur" },
      { id: 549492, name: "Diyanatpur" },
      { id: 549474, name: "Dongaon" },
      { id: 549466, name: "Dongri Naik Tanda" },
      { id: 549496, name: "Ektuni" },
      { id: 549445, name: "Farola" },
      { id: 549451, name: "Gadhegaon Gangapur" },
      { id: 549406, name: "Gadhegaon Paithan" },
      { id: 549470, name: "Gazipur" },
      { id: 549473, name: "Georai Bashi" },
      { id: 549502, name: "Georai Bk." },
      { id: 549501, name: "Georai Kh." },
      { id: 549518, name: "Georai Marda" },
      { id: 549495, name: "Gharegaon" },
      { id: 549585, name: "Ghari" },
      { id: 549463, name: "Gidhada" },
      { id: 549432, name: "Hanumantgaon" },
      { id: 549536, name: "Harshi Bk." },
      { id: 549535, name: "Harshi Kh." },
      { id: 549556, name: "Hingani" },
      { id: 549564, name: "Hiradpuri" },
      { id: 549497, name: "Hirapur" },
      { id: 549553, name: "Hiwara Chondhala" },
      { id: 549503, name: "Honobachi Wadi" },
      { id: 549450, name: "Imampur" },
      { id: 549530, name: "Inayatpur" },
      { id: 549557, name: "Indegaon" },
      { id: 549489, name: "Isarwadi" },
      { id: 549455, name: "Islampur" },
      { id: 549586, name: "Ismailpur" },
      { id: 549443, name: "Itawa" },
      { id: 549408, name: "Jainpur" },
      { id: 549447, name: "Jaitpur" },
      { id: 549441, name: "Jambhali" },
      { id: 549423, name: "Jogeshwari" },
      { id: 549520, name: "Kadethan Bk." },
      { id: 549519, name: "Kadethan Kh." },
      { id: 549478, name: "Kapuswadi" },
      { id: 549569, name: "Karanj Kheda" },
      { id: 549479, name: "Karkin" },
      { id: 549483, name: "Kasarpadli" },
      { id: 549568, name: "Katpur" },
      { id: 549410, name: "Kaudgaon" },
      { id: 549546, name: "Kaundar" },
      { id: 549582, name: "Kavsan" },
      { id: 549550, name: "Kekat Jalgaon" },
      { id: 549435, name: "Kesapuri" },
      { id: 549523, name: "Khadgaon" },
      { id: 549417, name: "Khamjalgaon" },
      { id: 549549, name: "Khandala" },
      { id: 549434, name: "Khandewadi" },
      { id: 549532, name: "Kherda" },
      { id: 549539, name: "Koli Bodkha" },
      { id: 559095, name: "Kuranpimpri" },
      { id: 549547, name: "Kutub Kheda" },
      { id: 549471, name: "Lakhegaon" },
      { id: 549422, name: "Lamgavhan" },
      { id: 549528, name: "Limbgaon" },
      { id: 549418, name: "Lohagaon Bk." },
      { id: 549419, name: "Lohagaon Kh." },
      { id: 549584, name: "Mahamadpur" },
      { id: 549427, name: "Mankapur" },
      { id: 549421, name: "Mavasgavhan" },
      { id: 549560, name: "Mayagaon" },
      { id: 549440, name: "Meharban Naik Tanda" },
      { id: 549446, name: "Mharola" },
      { id: 549551, name: "Mirkheda" },
      { id: 549409, name: "Mohalkheda" },
      { id: 549567, name: "Mudhalwadi" },
      { id: 549424, name: "Mulani Wadgaon" },
      { id: 549494, name: "Muradabad" },
      { id: 549538, name: "Murma" },
      { id: 549589, name: "Naigaon" },
      { id: 549433, name: "Naigavhan" },
      { id: 549411, name: "Nandalgaon" },
      { id: 549545, name: "Nandar" },
      { id: 549533, name: "Nanegaon" },
      { id: 549493, name: "Narayangaon" },
      { id: 549561, name: "Navgaon" },
      { id: 549460, name: "Nilajgaon" },
      { id: 549491, name: "Pachalgaon" },
      { id: 549527, name: "Pachod Bk." },
      { id: 549526, name: "Pachod Kh." },
      { id: 549465, name: "Padli" },
      { id: 943245, name: "Paithan" },
      { id: 549448, name: "Paithan Kheda" },
      { id: 549437, name: "Pangra" },
      { id: 549575, name: "Panthewadi" },
      { id: 549513, name: "Parundi" },
      { id: 549516, name: "Parundi Tanda" },
      { id: 549579, name: "Pategaon" },
      { id: 549439, name: "Patode Wadgaon" },
      { id: 549565, name: "Pimpalwadi(Pirachi)" },
      { id: 549469, name: "Porgaon" },
      { id: 549468, name: "Porgaon Tanda" },
      { id: 549534, name: "Pusegaon" },
      { id: 549570, name: "Rahatgaon" },
      { id: 549499, name: "Rajapur" },
      { id: 549524, name: "Ranjangaon Dandga" },
      { id: 549453, name: "Ranjangaon Khuri" },
      { id: 549454, name: "Ranjani" },
      { id: 549588, name: "Saigaon" },
      { id: 549525, name: "Sajegaon" },
      { id: 549548, name: "Salwadgaon" },
      { id: 549416, name: "Shahapur Manegaon" },
      { id: 549485, name: "Shahapur Wahegaon" },
      { id: 549403, name: "Shekta" },
      { id: 549425, name: "Shevata" },
      { id: 549444, name: "Shivnai" },
      { id: 549572, name: "Shringarwadi" },
      { id: 549571, name: "Solanapur" },
      { id: 549462, name: "Sompuri" },
      { id: 549583, name: "Sonwadi (Khadgaon)" },
      { id: 549529, name: "Sonwadi Bk." },
      { id: 549531, name: "Sonwadi Kh" },
      { id: 549517, name: "Sultanpur" },
      { id: 549412, name: "Taherpur" },
      { id: 549563, name: "Takali Ambad" },
      { id: 549487, name: "Takli Paithan" },
      { id: 549522, name: "Tanda Bk." },
      { id: 549521, name: "Tanda Kh." },
      { id: 549431, name: "Taru Pimpalwadi" },
      { id: 549475, name: "Tekadi Tanda" },
      { id: 549581, name: "Telwadi" },
      { id: 549498, name: "Thapati Tanda" },
      { id: 549537, name: "Thergaon" },
      { id: 549407, name: "Tondoli" },
      { id: 549404, name: "Tulapur" },
      { id: 549514, name: "Tupewadi" },
      { id: 549554, name: "Vihamandwa" },
      { id: 549481, name: "Wadala" },
      { id: 549461, name: "Wadgavhan" },
      { id: 549540, name: "Wadji" },
      { id: 549577, name: "Wadwali" },
      { id: 549576, name: "Waghadi" },
      { id: 549490, name: "Wahegaon" },
      { id: 549449, name: "Waki" },
      { id: 549484, name: "Warudi Bk." },
      { id: 549467, name: "Warwandi Kh." },
      { id: 549482, name: "Wawa" },
      { id: 549515, name: "Yasinpur" },
    ],
    4142: [
      { id: 549725, name: "Aamda (Ba)" },
      { id: 549672, name: "Ahmadgavhan" },
      { id: 549665, name: "Alangun" },
      { id: 549770, name: "Alivdand" },
      { id: 549627, name: "Ambatha" },
      { id: 549775, name: "Ambepada" },
      { id: 549751, name: "Ambode" },
      { id: 549764, name: "Ambupada" },
      { id: 549719, name: "Amda Palsan" },
      { id: 549625, name: "Amzar" },
      { id: 549720, name: "Awalpada" },
      { id: 549634, name: "Baflun" },
      { id: 549593, name: "Bardipada" },
      { id: 549769, name: "Barhe" },
      { id: 549750, name: "Bedse" },
      { id: 549721, name: "Bendwal" },
      { id: 549643, name: "Bhadar" },
      { id: 549760, name: "Bhati" },
      { id: 549740, name: "Bhatvihir" },
      { id: 549642, name: "Bhavandagad" },
      { id: 549722, name: "Bhawada" },
      { id: 549771, name: "Bhegu" },
      { id: 549757, name: "Bhenshet" },
      { id: 549709, name: "Bhintghar" },
      { id: 549646, name: "Bhormal" },
      { id: 549743, name: "Bijurpada" },
      { id: 549673, name: "Bival" },
      { id: 549620, name: "Borchond" },
      { id: 549697, name: "Borgaon" },
      { id: 549658, name: "Bubli" },
      { id: 549595, name: "Chandrapur" },
      { id: 549712, name: "Chikadi" },
      { id: 549699, name: "Chikhali" },
      { id: 549594, name: "Chinchale" },
      { id: 549613, name: "Chinchpada" },
      { id: 549656, name: "Chinchpada (Ka)" },
      { id: 549693, name: "Chirai" },
      { id: 549715, name: "Dangrale" },
      { id: 549603, name: "Deogaon" },
      { id: 549681, name: "Deola" },
      { id: 549600, name: "Deshmukh Nagar" },
      { id: 549640, name: "Devaldari" },
      { id: 549632, name: "Dodipada" },
      { id: 549624, name: "Dolhare" },
      { id: 549726, name: "Dudhawal" },
      { id: 549655, name: "Durgapur" },
      { id: 549616, name: "Fanaspada" },
      { id: 549745, name: "Gadga" },
      { id: 549727, name: "Gahale" },
      { id: 549611, name: "Galbari" },
      { id: 549734, name: "Galwad" },
      { id: 549670, name: "Ganeshnagar" },
      { id: 549662, name: "Garmal" },
      { id: 549701, name: "Ghagbari" },
      { id: 549696, name: "Ghodambe" },
      { id: 549597, name: "Gondune" },
      { id: 549630, name: "Gopalnagar" },
      { id: 549747, name: "Gopalpur" },
      { id: 549618, name: "Guhi Jambhulpada" },
      { id: 549748, name: "Gurtembhi" },
      { id: 549596, name: "Hadkaichond" },
      { id: 549671, name: "Hanumantmal" },
      { id: 549705, name: "Harantekadi" },
      { id: 549774, name: "Haste" },
      { id: 549687, name: "Hatgad" },
      { id: 549666, name: "Hatrundi" },
      { id: 549746, name: "Hatti" },
      { id: 549692, name: "Hatti (Ba)" },
      { id: 549779, name: "Hemadpada" },
      { id: 549698, name: "Hiradipada" },
      { id: 549776, name: "Jahule" },
      { id: 549742, name: "Jambhulpada" },
      { id: 549650, name: "Jamunmatha" },
      { id: 549759, name: "Kahandolpada" },
      { id: 549728, name: "Kahandolsa" },
      { id: 549768, name: "Kalmane" },
      { id: 549652, name: "Karanjali" },
      { id: 549724, name: "Karanjul (Pe)" },
      { id: 549637, name: "Karanjul Surgana" },
      { id: 549612, name: "Karanjul(Kelwan)" },
      { id: 549654, name: "Karwande" },
      { id: 549730, name: "Katambi" },
      { id: 549631, name: "Kathipada" },
      { id: 549756, name: "Kelavan" },
      { id: 549680, name: "Khadakmal" },
      { id: 549755, name: "Khadki Digar" },
      { id: 549702, name: "Kharude" },
      { id: 549767, name: "Khiramani" },
      { id: 549761, name: "Khirdi" },
      { id: 549676, name: "Khobala" },
      { id: 549758, name: "Khobale Digar" },
      { id: 549649, name: "Khokari" },
      { id: 549762, name: "Khokarvihir" },
      { id: 549608, name: "Khuntavihir" },
      { id: 549765, name: "Kotamba" },
      { id: 549628, name: "Kothula" },
      { id: 549629, name: "Krishnanagar" },
      { id: 549682, name: "Kukudmunda" },
      { id: 549599, name: "Kukudne" },
      { id: 549657, name: "Ladgaon" },
      { id: 549733, name: "Mahismal" },
      { id: 549710, name: "Malegaon" },
      { id: 549660, name: "Malgavhan" },
      { id: 549607, name: "Malgonde" },
      { id: 549617, name: "Mandha" },
      { id: 549752, name: "Mandve" },
      { id: 549781, name: "Mangdhe" },
      { id: 549675, name: "Mani" },
      { id: 549741, name: "Mankhed" },
      { id: 549780, name: "Mastemani" },
      { id: 549679, name: "Merdand" },
      { id: 549635, name: "Mhaiskhadak" },
      { id: 549766, name: "Modhalpada" },
      { id: 549609, name: "Mohapada (Chi)" },
      { id: 549694, name: "Mohapada (Khu)" },
      { id: 549683, name: "Morchonda" },
      { id: 549686, name: "Mothamal" },
      { id: 549738, name: "Murumdari" },
      { id: 549736, name: "Nadagdari" },
      { id: 549690, name: "Nagshewadi" },
      { id: 549644, name: "Nawapur" },
      { id: 549621, name: "Nimbarpada" },
      { id: 549678, name: "Palashet" },
      { id: 549677, name: "Palsan" },
      { id: 549648, name: "Palvihir" },
      { id: 549604, name: "Pangarne" },
      { id: 549667, name: "Patali (Pa)" },
      { id: 549668, name: "Payarpada" },
      { id: 549713, name: "Pilukpada" },
      { id: 549731, name: "Pimpalchond" },
      { id: 549606, name: "Pimpalsond" },
      { id: 549689, name: "Pohali" },
      { id: 549664, name: "Pratapgad" },
      { id: 549615, name: "Raghatvihir" },
      { id: 549716, name: "Rahude" },
      { id: 549723, name: "Rakshasbhuvan" },
      { id: 549598, name: "Ranjune" },
      { id: 549610, name: "Ranvihir" },
      { id: 549619, name: "Rasha" },
      { id: 549714, name: "Rokadpada" },
      { id: 549735, name: "Ronghane" },
      { id: 549695, name: "Roti" },
      { id: 549708, name: "Sabardara" },
      { id: 549739, name: "Sadudne" },
      { id: 549688, name: "Sajole" },
      { id: 549711, name: "Salbhoye" },
      { id: 549744, name: "Sambarkhal" },
      { id: 549704, name: "Sanjaynagar" },
      { id: 549700, name: "Sarad" },
      { id: 549753, name: "Sarmal" },
      { id: 549626, name: "Satkhamb" },
      { id: 549772, name: "Sayalpada" },
      { id: 549706, name: "Shinde" },
      { id: 549685, name: "Shribhuvan" },
      { id: 549639, name: "Shrirampur" },
      { id: 549601, name: "Songir" },
      { id: 549623, name: "Subhashnagar" },
      { id: 549777, name: "Suktale" },
      { id: 549717, name: "Sule (Va)" },
      { id: 549614, name: "Sundarban" },
      { id: 909115, name: "Surgana" },
      { id: 549663, name: "Suryagad" },
      { id: 549653, name: "Talpada" },
      { id: 549778, name: "Tapupada" },
      { id: 549749, name: "Thangaon" },
      { id: 549633, name: "Torandongri" },
      { id: 549684, name: "Ubarde (Mani)" },
      { id: 549636, name: "Udaldari" },
      { id: 549661, name: "Udaypur" },
      { id: 549602, name: "Udmal" },
      { id: 549659, name: "Umaremal" },
      { id: 549669, name: "Umbarde (Pa)" },
      { id: 549645, name: "Umbarpada (Su)" },
      { id: 549703, name: "Umbarpada Digar" },
      { id: 549622, name: "Umbarthan" },
      { id: 549647, name: "Umbarvihir" },
      { id: 549754, name: "Undohal" },
      { id: 549674, name: "Vadmal" },
      { id: 549732, name: "Vaghanakhi" },
      { id: 549691, name: "Vanjulpada" },
      { id: 549638, name: "Vijaynagar" },
      { id: 549651, name: "Wadpada (Ma)" },
      { id: 549737, name: "Wadpada (Su)" },
      { id: 549729, name: "Waghadi" },
      { id: 549707, name: "Waghdhond" },
      { id: 549641, name: "Walutzira" },
      { id: 549605, name: "Wangan (Ka)" },
      { id: 549718, name: "Wangan Sule" },
      { id: 549773, name: "Wanganpada" },
      { id: 549782, name: "Warambhe" },
      { id: 549763, name: "Zagadpada" },
    ],
    4143: [
      { id: 549878, name: "Abhona" },
      { id: 549802, name: "Ambapur" },
      { id: 549890, name: "Ambika Ozar" },
      { id: 549893, name: "Amburdi Bk." },
      { id: 549892, name: "Amburdi Kh." },
      { id: 549862, name: "Amdar" },
      { id: 549871, name: "Asoli" },
      { id: 549909, name: "Athambe" },
      { id: 549799, name: "Babkhede" },
      { id: 549935, name: "Bagadu" },
      { id: 549807, name: "Balapur" },
      { id: 549870, name: "Barde" },
      { id: 549864, name: "Bedipada" },
      { id: 549811, name: "Belbare" },
      { id: 549844, name: "Bhadvan" },
      { id: 549879, name: "Bhagurdi" },
      { id: 549820, name: "Bhakurde" },
      { id: 549801, name: "Bhandane (Ha.)" },
      { id: 549850, name: "Bhandane Pimpale" },
      { id: 549918, name: "Bhendi" },
      { id: 549921, name: "Bhusani" },
      { id: 944022, name: "Bhutane Digar" },
      { id: 549841, name: "Bijore" },
      { id: 549902, name: "Bilwadi" },
      { id: 549889, name: "Bordaivat" },
      { id: 549843, name: "Chacher" },
      { id: 549867, name: "Chankapur" },
      { id: 549797, name: "Chaphapada" },
      { id: 549899, name: "Chinchore" },
      { id: 549920, name: "Dahyane (Otur)" },
      { id: 549835, name: "Dahyane Di." },
      { id: 549877, name: "Dahyane Pale" },
      { id: 549822, name: "Dalwat" },
      { id: 549840, name: "Darebhanagi" },
      { id: 549824, name: "Daregaon (Ha)" },
      { id: 549905, name: "Daregaon Wani" },
      { id: 549894, name: "Dattanagar" },
      { id: 549865, name: "Desgaon" },
      { id: 549848, name: "Desrane" },
      { id: 549883, name: "Devali Karhad" },
      { id: 549900, name: "Devali Wani" },
      { id: 549839, name: "Dhaner Digar" },
      { id: 549798, name: "Dhanoli" },
      { id: 549852, name: "Dharde Digar" },
      { id: 549810, name: "Dhekale" },
      { id: 549860, name: "Eklahare" },
      { id: 549812, name: "Gangapur" },
      { id: 549845, name: "Gangavan" },
      { id: 549838, name: "Ganore" },
      { id: 549908, name: "Gobapur" },
      { id: 549814, name: "Golakhal" },
      { id: 549808, name: "Gopalkhadi" },
      { id: 549869, name: "Gosrane" },
      { id: 549809, name: "Hingave" },
      { id: 549837, name: "Hundyamokh" },
      { id: 549855, name: "Inshi" },
      { id: 549792, name: "Jaidar" },
      { id: 549868, name: "Jaipur" },
      { id: 549901, name: "Jamale Wani" },
      { id: 549823, name: "Jamle (Ha)" },
      { id: 549806, name: "Jamle Pale" },
      { id: 549898, name: "Jamshet" },
      { id: 549825, name: "Jirwade (Hatgad)" },
      { id: 549912, name: "Jirwade (O)" },
      { id: 549917, name: "Juni Bej" },
      { id: 549846, name: "Kakane" },
      { id: 549875, name: "Kalamthe" },
      { id: 549915, name: "Kalwan Bk." },
      { id: 549913, name: "Kalwan Kh" },
      { id: 549813, name: "Kanashi" },
      { id: 549926, name: "Kanherwadi" },
      { id: 549816, name: "Karambhel (K)" },
      { id: 549818, name: "Karambhel Hatgad" },
      { id: 549804, name: "Karmale" },
      { id: 549907, name: "Katalgaon" },
      { id: 549788, name: "Katharedigar" },
      { id: 549791, name: "Khadaki" },
      { id: 549817, name: "Khadakwan" },
      { id: 549785, name: "Khardedigar" },
      { id: 549857, name: "Khedgaon" },
      { id: 549884, name: "Khirad" },
      { id: 549821, name: "Kosurde" },
      { id: 549790, name: "Koswan" },
      { id: 549800, name: "Kumsadi" },
      { id: 549897, name: "Kundane (Kanashi)" },
      { id: 549927, name: "Kurdane (Otur)" },
      { id: 549794, name: "Lakhani" },
      { id: 549861, name: "Lingame" },
      { id: 549933, name: "Machidhodap" },
      { id: 549829, name: "Malagaon Bk." },
      { id: 549836, name: "Malagaon Kh." },
      { id: 549914, name: "Manur" },
      { id: 549932, name: "Mehadar" },
      { id: 549880, name: "Mohamukh" },
      { id: 549903, name: "Mohandari" },
      { id: 549854, name: "Mohobari" },
      { id: 549888, name: "Mohpada" },
      { id: 549847, name: "Mokbhanagi" },
      { id: 549930, name: "Mulane Wani" },
      { id: 549859, name: "Nakode" },
      { id: 549849, name: "Nalid" },
      { id: 549904, name: "Nanduri" },
      { id: 549929, name: "Narul" },
      { id: 549916, name: "Navi Bej" },
      { id: 549919, name: "Niwane" },
      { id: 549928, name: "Otur" },
      { id: 549891, name: "Ozar" },
      { id: 549851, name: "Padgan" },
      { id: 549887, name: "Palasdar" },
      { id: 549874, name: "Pale Bk." },
      { id: 549873, name: "Pale Kh." },
      { id: 549858, name: "Patvihir" },
      { id: 549934, name: "Pilakos" },
      { id: 549833, name: "Pimple Bk." },
      { id: 549853, name: "Pimple Kh." },
      { id: 549925, name: "Pimpri Markand" },
      { id: 549924, name: "Pimpri Pale" },
      { id: 549789, name: "Pratapnagar" },
      { id: 549784, name: "Punadnagar" },
      { id: 549795, name: "Punegaon" },
      { id: 549856, name: "Ravalji" },
      { id: 549923, name: "Sadadvihir" },
      { id: 549910, name: "Sakore" },
      { id: 549911, name: "Sakorepada" },
      { id: 549866, name: "Sarale Digar" },
      { id: 549896, name: "Savaki Pale" },
      { id: 549834, name: "Savarpada" },
      { id: 549826, name: "Shepupada" },
      { id: 549832, name: "Sheri Digar" },
      { id: 549819, name: "Shingashi" },
      { id: 549922, name: "Shirasamani" },
      { id: 549805, name: "Shivbhandane" },
      { id: 549827, name: "Shrungarwadi" },
      { id: 549830, name: "Sidharthanagar" },
      { id: 549906, name: "Sptashrungi Gad" },
      { id: 549885, name: "Sukapur Hatgad" },
      { id: 549793, name: "Sule" },
      { id: 549787, name: "Supale (Di)" },
      { id: 549828, name: "Tatani" },
      { id: 549882, name: "Tirhal Bk." },
      { id: 549881, name: "Tirhal Kh." },
      { id: 549786, name: "Umbarde" },
      { id: 549895, name: "Vanjari" },
      { id: 549803, name: "Verule" },
      { id: 549796, name: "Virshet" },
      { id: 549842, name: "Visapur" },
      { id: 549876, name: "Vithewadipale" },
      { id: 549863, name: "Wadale Hatgad" },
      { id: 549931, name: "Wadale Wani" },
      { id: 549872, name: "Wadi Bk." },
      { id: 549886, name: "Wadpada" },
      { id: 549815, name: "Warkheda" },
    ],
    4144: [
      { id: 549936, name: "Bhaur" },
      { id: 549981, name: "Bhavade" },
      { id: 549984, name: "Bhilwad" },
      { id: 549959, name: "Chinchave (Ni.)" },
      { id: 549953, name: "Dahiwad" },
      { id: 549965, name: "Deola" },
      { id: 549948, name: "Deopurpada" },
      { id: 549951, name: "Dongargaon" },
      { id: 549943, name: "Fulemalwadi" },
      { id: 549962, name: "Giranare" },
      { id: 549971, name: "Gunjalnagar" },
      { id: 549976, name: "Hanmantpada" },
      { id: 549979, name: "Kanchane" },
      { id: 549978, name: "Kankapur" },
      { id: 549985, name: "Kapashi" },
      { id: 549968, name: "Khadaktale" },
      { id: 549945, name: "Khalap" },
      { id: 549937, name: "Khamkhede" },
      { id: 549974, name: "Kharde (Wa.)" },
      { id: 549961, name: "Kumbharde" },
      { id: 549944, name: "Lohaner" },
      { id: 549954, name: "Ma. Fulenagar" },
      { id: 549949, name: "Mahalpatane" },
      { id: 549942, name: "Malwadi" },
      { id: 549964, name: "Matane" },
      { id: 549952, name: "Meshi" },
      { id: 549950, name: "Nimbole" },
      { id: 549947, name: "Phule Nagar" },
      { id: 549969, name: "Pimpalgaon" },
      { id: 549972, name: "Rameshwar" },
      { id: 549960, name: "Ramnagar" },
      { id: 549958, name: "Sangavi" },
      { id: 549941, name: "Satwaichiwadi" },
      { id: 549938, name: "Savaki Lo" },
      { id: 549977, name: "Sheri(Lo)" },
      { id: 549982, name: "Subhashnagar" },
      { id: 549956, name: "Tisgaon" },
      { id: 549955, name: "Umarane" },
      { id: 549957, name: "Varhale" },
      { id: 549946, name: "Vasol" },
      { id: 549939, name: "Vithewadi" },
      { id: 549980, name: "Wadale (Wa.)" },
      { id: 549973, name: "Wajgaon" },
      { id: 549983, name: "Wakhari" },
      { id: 549975, name: "Warshi" },
      { id: 549963, name: "Warwandi" },
    ],
    4145: [
      { id: 550013, name: "Ajande Digar" },
      { id: 550150, name: "Ajmir Saundane" },
      { id: 550046, name: "Akhatwade" },
      { id: 550011, name: "Aliyabad" },
      { id: 550006, name: "Ambapur" },
      { id: 550069, name: "Ambasan" },
      { id: 550042, name: "Anandpur" },
      { id: 549999, name: "Antapur" },
      { id: 550135, name: "Arai" },
      { id: 550063, name: "Askheda" },
      { id: 550096, name: "Aundane" },
      { id: 550088, name: "Avhati" },
      { id: 550016, name: "Babhulane" },
      { id: 550053, name: "Bahirane" },
      { id: 550036, name: "Bhadane" },
      { id: 550097, name: "Bhakshi" },
      { id: 550111, name: "Bhavnagar" },
      { id: 550104, name: "Bhawade" },
      { id: 550114, name: "Bhildar" },
      { id: 550022, name: "Bhilwad" },
      { id: 550019, name: "Bhimkhet" },
      { id: 549988, name: "Bhimnagar" },
      { id: 550083, name: "Bhuyane" },
      { id: 550067, name: "Bijorase" },
      { id: 550045, name: "Bijote" },
      { id: 550048, name: "Bilpuri" },
      { id: 550049, name: "Bodhari" },
      { id: 550014, name: "Bordaiwat" },
      { id: 549990, name: "Borhate Digar" },
      { id: 550152, name: "Bramhangaon" },
      { id: 550062, name: "Bramhanpade" },
      { id: 550122, name: "Bundhate" },
      { id: 550134, name: "Chaugaon" },
      { id: 550092, name: "Chaundhane" },
      { id: 550050, name: "Chirai" },
      { id: 550003, name: "Dagadpada" },
      { id: 550124, name: "Dahindule" },
      { id: 550123, name: "Dangsaundane" },
      { id: 550027, name: "Daregaon" },
      { id: 550142, name: "Darhane" },
      { id: 550085, name: "Dasane" },
      { id: 550025, name: "Daswel" },
      { id: 550149, name: "Deolane" },
      { id: 550041, name: "Deopur" },
      { id: 550119, name: "Deopur(Chafyachepade)" },
      { id: 549993, name: "Deothan-Digar" },
      { id: 550154, name: "Dhandri" },
      { id: 550084, name: "Dholbare" },
      { id: 550132, name: "Dodheshwar" },
      { id: 550090, name: "Dongrej" },
      { id: 550061, name: "Dyane" },
      { id: 550034, name: "Eklahare" },
      { id: 550065, name: "Fopir" },
      { id: 550099, name: "Gandhinagar" },
      { id: 549992, name: "Ganeshnagar" },
      { id: 550010, name: "Gautamnagar" },
      { id: 549986, name: "Golwad" },
      { id: 550064, name: "Gorane" },
      { id: 550008, name: "Hatnoor" },
      { id: 550059, name: "Ijamane" },
      { id: 550143, name: "Indiranagar" },
      { id: 550009, name: "Jad" },
      { id: 550038, name: "Jaikheda" },
      { id: 550029, name: "Jaipur" },
      { id: 550007, name: "Jaitapur" },
      { id: 550077, name: "Jakhod" },
      { id: 550002, name: "Jamoti" },
      { id: 550118, name: "Joran" },
      { id: 550128, name: "June Nirpur" },
      { id: 550151, name: "Juni Shemali" },
      { id: 550015, name: "Kadyachamala" },
      { id: 550070, name: "Kakadgaon" },
      { id: 550126, name: "Kandhane" },
      { id: 550120, name: "Kapaleshwar" },
      { id: 550082, name: "Karanjad" },
      { id: 550121, name: "Karanjkhed" },
      { id: 550133, name: "Karhe" },
      { id: 550024, name: "Katarwel" },
      { id: 549996, name: "Kathagad" },
      { id: 550094, name: "Kautikpada" },
      { id: 550109, name: "Kelzar" },
      { id: 550086, name: "Kersane" },
      { id: 550060, name: "Khamlon" },
      { id: 550138, name: "Khamtane" },
      { id: 550012, name: "Kharad" },
      { id: 550075, name: "Khirmani" },
      { id: 550116, name: "Kikwari Bk." },
      { id: 550115, name: "Kikwari Kh." },
      { id: 549994, name: "Kodharabad" },
      { id: 550102, name: "Kodmal" },
      { id: 550100, name: "Korobanagar" },
      { id: 550076, name: "Kotbel" },
      { id: 550074, name: "Kupkhede" },
      { id: 550043, name: "Ladud" },
      { id: 550155, name: "Lakhamapur" },
      { id: 550052, name: "Mahad" },
      { id: 549987, name: "Mahatma Phule Nagar" },
      { id: 549991, name: "Mailwade" },
      { id: 550136, name: "Malegaon Tilwan" },
      { id: 550058, name: "Malgaon Bhamer" },
      { id: 550105, name: "Malgaon Kh." },
      { id: 550021, name: "Manur" },
      { id: 549989, name: "Moholangi" },
      { id: 550000, name: "Morane Digar" },
      { id: 550068, name: "Morane Sandas" },
      { id: 550141, name: "More Nagar" },
      { id: 550113, name: "Morkure" },
      { id: 550095, name: "Mulane" },
      { id: 550001, name: "Mulher" },
      { id: 550079, name: "Mungase" },
      { id: 550137, name: "Munjwad" },
      { id: 550071, name: "Nalkas" },
      { id: 550066, name: "Nampur" },
      { id: 550028, name: "Nandin" },
      { id: 550078, name: "Narkol" },
      { id: 550127, name: "Nave Nirpur" },
      { id: 550139, name: "Navegaon" },
      { id: 550145, name: "Navi Shemali" },
      { id: 550125, name: "Nikwel" },
      { id: 550044, name: "Nitane" },
      { id: 550047, name: "Parner" },
      { id: 550017, name: "Parshuramnagar" },
      { id: 550107, name: "Pathave Digar" },
      { id: 550140, name: "Pimpaldar" },
      { id: 550026, name: "Pimpalkothe" },
      { id: 550081, name: "Pingalwade" },
      { id: 550103, name: "Pisore" },
      { id: 550051, name: "Rahud" },
      { id: 550040, name: "Rajpurpande" },
      { id: 550073, name: "Ramtir" },
      { id: 550072, name: "Ratir" },
      { id: 549998, name: "Raver" },
      { id: 550112, name: "Sakode" },
      { id: 550020, name: "Salher" },
      { id: 550101, name: "Salwan" },
      { id: 550146, name: "Sarade" },
      { id: 550108, name: "Sarpargaon" },
      { id: 550130, name: "Sarwar" },
      { id: 944246, name: "Satana 1" },
      { id: 549995, name: "Shevare" },
      { id: 550033, name: "Shripurvade" },
      { id: 550037, name: "Sompur" },
      { id: 944247, name: "Statana 2" },
      { id: 550148, name: "Surane" },
      { id: 549997, name: "Taharabad" },
      { id: 550055, name: "Talwade Bhamer" },
      { id: 550106, name: "Talwade Digar" },
      { id: 550035, name: "Tandulwadi" },
      { id: 550093, name: "Tarsali" },
      { id: 550110, name: "Tatani" },
      { id: 550054, name: "Tembhe (Varche)" },
      { id: 550057, name: "Tembhe Khalche" },
      { id: 550144, name: "Thengoda" },
      { id: 550129, name: "Tilwan" },
      { id: 550031, name: "Tinghari" },
      { id: 550023, name: "Tungan Digar" },
      { id: 550056, name: "Utrane" },
      { id: 550004, name: "Vade Digar" },
      { id: 550032, name: "Vade Kh." },
      { id: 550089, name: "Vanoli" },
      { id: 550091, name: "Vatar" },
      { id: 550098, name: "Vathode" },
      { id: 550147, name: "Vaygaon" },
      { id: 550080, name: "Vijaynagar" },
      { id: 550117, name: "Vinchure" },
      { id: 550087, name: "Virgaon" },
      { id: 550005, name: "Visapur" },
      { id: 550131, name: "Wadi Chaulher" },
      { id: 550030, name: "Wadipisol" },
      { id: 550039, name: "Waghale" },
      { id: 550018, name: "Waghambe" },
      { id: 550153, name: "Yashawantnagar" },
    ],
    4146: [
      { id: 550229, name: "Aghar Bk" },
      { id: 550234, name: "Aghar Kh" },
      { id: 550262, name: "Ajande Bk." },
      { id: 550263, name: "Ajande Kh." },
      { id: 550219, name: "Ajang" },
      { id: 550198, name: "Astane" },
      { id: 550224, name: "Belgaon" },
      { id: 550178, name: "Bharadenagar" },
      { id: 550304, name: "Bhaygaon" },
      { id: 550206, name: "Bhilkot" },
      { id: 550261, name: "Bhuigavhan" },
      { id: 550292, name: "Bodhe" },
      { id: 550258, name: "Chandanpuri" },
      { id: 550275, name: "Chaukatpade" },
      { id: 550211, name: "Chikhalohal" },
      { id: 550296, name: "Chinchagavhan" },
      { id: 550233, name: "Chinchavad" },
      { id: 550158, name: "Chinchave Ga." },
      { id: 550257, name: "Chondhi" },
      { id: 550230, name: "Dabhadi" },
      { id: 550191, name: "Dabli" },
      { id: 550183, name: "Dahidi" },
      { id: 550209, name: "Dahikute" },
      { id: 550291, name: "Dahiwal" },
      { id: 550288, name: "Dapur" },
      { id: 944947, name: "Daregaon" },
      { id: 550194, name: "Dasane" },
      { id: 550287, name: "Deoghat" },
      { id: 550207, name: "Devarpada" },
      { id: 909128, name: "Dhavaeshwar" },
      { id: 550177, name: "Dongrale" },
      { id: 550273, name: "Dubagule" },
      { id: 550217, name: "Dundhe" },
      { id: 550299, name: "Dyane" },
      { id: 550256, name: "Erandgaon" },
      { id: 550160, name: "Galne" },
      { id: 550228, name: "Ganeshnagar (Mitranagar.)" },
      { id: 550168, name: "Garbad" },
      { id: 550164, name: "Garegaon" },
      { id: 550179, name: "Ghanegaon" },
      { id: 550250, name: "Ghodegaon" },
      { id: 550251, name: "Ghodegaon Chouki" },
      { id: 550281, name: "Gigaon" },
      { id: 550269, name: "Gilane" },
      { id: 550204, name: "Gugulwad" },
      { id: 550188, name: "Hatane" },
      { id: 550286, name: "Hiswal Bk" },
      { id: 550223, name: "Jalgaon (Ga.)" },
      { id: 550252, name: "Jalgaon (Ni)" },
      { id: 550201, name: "Jalku" },
      { id: 550276, name: "Jatpade" },
      { id: 550278, name: "Jeur" },
      { id: 550242, name: "Jwardi Bk." },
      { id: 550266, name: "Jwardi Kh" },
      { id: 550156, name: "Kajwade" },
      { id: 550253, name: "Kalewadi" },
      { id: 550290, name: "Kalwadi" },
      { id: 550202, name: "Kandhane" },
      { id: 550184, name: "Kankrale" },
      { id: 550187, name: "Karanjgavhan" },
      { id: 550220, name: "Kashti" },
      { id: 550180, name: "Kaulane (Ga.)" },
      { id: 550240, name: "Kaulane (N)" },
      { id: 550189, name: "Khadaki" },
      { id: 550171, name: "Khakurdi" },
      { id: 550294, name: "Khalane" },
      { id: 550264, name: "Khayade" },
      { id: 550174, name: "Kothare Bk." },
      { id: 550173, name: "Kothare Kh." },
      { id: 550186, name: "Kukane" },
      { id: 550197, name: "Lakhani" },
      { id: 550190, name: "Lendane" },
      { id: 550195, name: "Lonwade" },
      { id: 550161, name: "Lulle" },
      { id: 550270, name: "Malagaon" },
      { id: 944140, name: "Maldhe" },
      { id: 944946, name: "Malegaon" },
      { id: 944141, name: "Malegaon Camp" },
      { id: 550280, name: "Malhanagaon" },
      { id: 550249, name: "Manjare" },
      { id: 550208, name: "Manke" },
      { id: 550265, name: "Mathurpade" },
      { id: 550243, name: "Mehune" },
      { id: 550200, name: "Mohapade" },
      { id: 550170, name: "Mordar" },
      { id: 550232, name: "Mungase" },
      { id: 550241, name: "Nagaon Di." },
      { id: 550159, name: "Nagzari" },
      { id: 550212, name: "Nale" },
      { id: 550238, name: "Nandgaon" },
      { id: 550237, name: "Nandgaon Kh." },
      { id: 550297, name: "Nardane" },
      { id: 550221, name: "Nilgavhan" },
      { id: 550277, name: "Nimbait" },
      { id: 550268, name: "Nimgaon" },
      { id: 550267, name: "Nimgaon Kh" },
      { id: 550272, name: "Nimgule (Lahan)" },
      { id: 944948, name: "Nimgule Mothe" },
      { id: 550167, name: "Nimshevadi" },
      { id: 550283, name: "Padalde" },
      { id: 550205, name: "Palasdare" },
      { id: 550226, name: "Pandharun" },
      { id: 550235, name: "Patane" },
      { id: 550274, name: "Patharde" },
      { id: 550222, name: "Pimpalgaon" },
      { id: 550163, name: "Pohane" },
      { id: 550196, name: "Rajmane" },
      { id: 550157, name: "Rampura" },
      { id: 550218, name: "Ravalgaon" },
      { id: 550295, name: "Ronzane" },
      { id: 550282, name: "Roze" },
      { id: 550213, name: "Sajvahal" },
      { id: 550289, name: "Sakur" },
      { id: 550279, name: "Sakuri(Nimbait)" },
      { id: 944142, name: "Sangameshwar" },
      { id: 550284, name: "Satarpada" },
      { id: 550176, name: "Satmane" },
      { id: 550239, name: "Saundane" },
      { id: 550216, name: "Savandgaon" },
      { id: 550254, name: "Savkarwadi" },
      { id: 550175, name: "Sawatawadi" },
      { id: 550215, name: "Sayane Bk" },
      { id: 550210, name: "Sayane Kh" },
      { id: 550214, name: "Shendurni" },
      { id: 550285, name: "Sherul" },
      { id: 550248, name: "Shirsondi" },
      { id: 550293, name: "Sitane" },
      { id: 550246, name: "Sonaj" },
      { id: 550300, name: "Soyagaon" },
      { id: 550247, name: "Takali" },
      { id: 550225, name: "Talwade" },
      { id: 550231, name: "Tehare" },
      { id: 550182, name: "Tinghari" },
      { id: 550169, name: "Tipe" },
      { id: 550199, name: "Tokade" },
      { id: 550298, name: "Umbardhe" },
      { id: 550185, name: "Vadel" },
      { id: 550193, name: "Vadgaon" },
      { id: 550172, name: "Vadner" },
      { id: 550192, name: "Vajirkhede" },
      { id: 550236, name: "Vake" },
      { id: 550165, name: "Valwade" },
      { id: 550166, name: "Valwadi" },
      { id: 550181, name: "Vanpat" },
      { id: 550244, name: "Varhane" },
      { id: 550245, name: "Varhanepada" },
      { id: 550162, name: "Virane" },
      { id: 550259, name: "Yesgaon Bk" },
      { id: 550260, name: "Yesgaon Kh" },
      { id: 550255, name: "Zadi" },
      { id: 550203, name: "Zodge" },
    ],
    4147: [
      { id: 550365, name: "Amode" },
      { id: 550322, name: "Anakwade" },
      { id: 550315, name: "Astagaon" },
      { id: 550342, name: "Azadnagar" },
      { id: 550378, name: "Babhulwadi" },
      { id: 550349, name: "Bangaon Bk." },
      { id: 550350, name: "Bangaon Kh." },
      { id: 550345, name: "Bejgaon" },
      { id: 550356, name: "Bhalur" },
      { id: 550311, name: "Bhardi" },
      { id: 550359, name: "Bhauri" },
      { id: 550373, name: "Birole" },
      { id: 550403, name: "Bolthan" },
      { id: 550364, name: "Borale" },
      { id: 550305, name: "Boygaon" },
      { id: 550397, name: "Chandanpuri" },
      { id: 550380, name: "Chandore" },
      { id: 550393, name: "Chinchvihir" },
      { id: 550341, name: "Dahegaon" },
      { id: 550306, name: "Darhel" },
      { id: 550310, name: "Dhaner" },
      { id: 550396, name: "Dheku Bk." },
      { id: 550395, name: "Dheku Kh." },
      { id: 550316, name: "Dhotane Bk." },
      { id: 550327, name: "Dhotane Kh." },
      { id: 550379, name: "Doctorwadi" },
      { id: 550319, name: "Ekwai" },
      { id: 550333, name: "Fulenagar" },
      { id: 550388, name: "Ganeshnagar" },
      { id: 550338, name: "Gangadhari" },
      { id: 550325, name: "Ghadeghewadi" },
      { id: 550335, name: "Girnanagar" },
      { id: 550401, name: "Gondegaon" },
      { id: 550382, name: "Hingane Dehere" },
      { id: 550334, name: "Hinganwadi" },
      { id: 550330, name: "Hirenagar" },
      { id: 550329, name: "Hiswal Bk." },
      { id: 550328, name: "Hiswal Kh." },
      { id: 550387, name: "Jalgaon Bk." },
      { id: 550386, name: "Jalgaon Kh." },
      { id: 550368, name: "Jamdari" },
      { id: 550400, name: "Jategaon" },
      { id: 550402, name: "Jawalki" },
      { id: 550362, name: "Kalamdari" },
      { id: 550320, name: "Karhi" },
      { id: 550390, name: "Kasabkhede" },
      { id: 550392, name: "Kasari" },
      { id: 550313, name: "Khadgaon" },
      { id: 550353, name: "Khirdipatode" },
      { id: 550309, name: "Kondhar" },
      { id: 550336, name: "Krantinagar" },
      { id: 550394, name: "Kusumtel" },
      { id: 550347, name: "Laxminagar" },
      { id: 550398, name: "Lodhare" },
      { id: 550357, name: "Lohshingve" },
      { id: 550324, name: "Malegaon Karyat" },
      { id: 550363, name: "Malgaon" },
      { id: 550337, name: "Malharwadi" },
      { id: 550343, name: "Mandwad" },
      { id: 550366, name: "Manglane" },
      { id: 550389, name: "Manikpunj" },
      { id: 944249, name: "Manmad 1" },
      { id: 944250, name: "Manmad 2" },
      { id: 550346, name: "Mohegaon" },
      { id: 550348, name: "Morzar" },
      { id: 550374, name: "Muldongari" },
      { id: 550318, name: "Nagapur" },
      { id: 550331, name: "Nandgaon" },
      { id: 550307, name: "Nandur" },
      { id: 550326, name: "Narayangaon" },
      { id: 550312, name: "Navsari" },
      { id: 550372, name: "Naydongari" },
      { id: 550370, name: "Palashi" },
      { id: 550317, name: "Panewadi" },
      { id: 550314, name: "Panzandev" },
      { id: 550384, name: "Pardhadi" },
      { id: 550308, name: "Parekarwadi" },
      { id: 550385, name: "Pimparkhed" },
      { id: 550361, name: "Pimprale" },
      { id: 550383, name: "Pimpri Haveli" },
      { id: 550391, name: "Pohi" },
      { id: 550339, name: "Pokhari (Pa.)" },
      { id: 550377, name: "Punarvasahat Panjhan (New.Panjhan)" },
      { id: 550381, name: "Rankhede" },
      { id: 550404, name: "Rohile Bk" },
      { id: 550376, name: "Sakora" },
      { id: 550321, name: "Satane" },
      { id: 550371, name: "Sawargaon" },
      { id: 550344, name: "Shashrinagar" },
      { id: 550332, name: "Shriramnagar" },
      { id: 550358, name: "Soygaon" },
      { id: 550351, name: "Takli Bk." },
      { id: 550352, name: "Takli Kh." },
      { id: 550369, name: "Talwade" },
      { id: 550340, name: "Tandulwadi" },
      { id: 550323, name: "Vanjarwadi" },
      { id: 550399, name: "Vasant Nagar" },
      { id: 550367, name: "Vehelgaon" },
      { id: 550355, name: "Wadali Bk." },
      { id: 550354, name: "Wadali Kh." },
      { id: 550360, name: "Wakhari" },
    ],
    4148: [
      { id: 550443, name: "Adgaon" },
      { id: 550479, name: "Ahirkhede" },
      { id: 550442, name: "Asarkhede" },
      { id: 550421, name: "Bahaduri" },
      { id: 550485, name: "Bhadane" },
      { id: 550452, name: "Bharvir" },
      { id: 550449, name: "Bhatgaon" },
      { id: 550424, name: "Bhayale" },
      { id: 550492, name: "Bhoyegaon" },
      { id: 550445, name: "Bhutyane" },
      { id: 550460, name: "Bopane" },
      { id: 550419, name: "Borale" },
      { id: 550516, name: "Chandvad" },
      { id: 550420, name: "Chikhalambe" },
      { id: 550451, name: "Chinchole" },
      { id: 550483, name: "Dahegaon Ma." },
      { id: 550495, name: "Dahiwad" },
      { id: 550415, name: "Dahyane" },
      { id: 550464, name: "Daregaon" },
      { id: 550441, name: "Deogaon" },
      { id: 550507, name: "Devargaon" },
      { id: 550413, name: "Dhodambe" },
      { id: 550429, name: "Dhondgavhan" },
      { id: 550430, name: "Dhotarkhede" },
      { id: 550494, name: "Dighwad" },
      { id: 550470, name: "Dongaon" },
      { id: 550474, name: "Dongargaon" },
      { id: 550417, name: "Dudhkhede" },
      { id: 550473, name: "Dugaon" },
      { id: 550414, name: "Ekrukhe" },
      { id: 550500, name: "Gangave" },
      { id: 550457, name: "Ganur" },
      { id: 550423, name: "Goharan" },
      { id: 550508, name: "Gurhale" },
      { id: 550477, name: "Harnul" },
      { id: 550478, name: "Harsul" },
      { id: 550408, name: "Hatti" },
      { id: 550506, name: "Hirapur" },
      { id: 550461, name: "Hivarkhede" },
      { id: 550406, name: "Indira Nagar" },
      { id: 550439, name: "Indrayanwadi" },
      { id: 550407, name: "Jaitapur" },
      { id: 550422, name: "Jambutke" },
      { id: 550491, name: "Jopul" },
      { id: 550496, name: "Kajisangvi" },
      { id: 550475, name: "Kalamdare" },
      { id: 550514, name: "Kalkhode" },
      { id: 550467, name: "Kanadgaon" },
      { id: 550411, name: "Kanmandale" },
      { id: 550489, name: "Katarwadi" },
      { id: 550431, name: "Khadakjamb" },
      { id: 550490, name: "Khadakozar" },
      { id: 550433, name: "Kheldari" },
      { id: 550472, name: "Kokankhede" },
      { id: 550505, name: "Koltek" },
      { id: 550468, name: "Kundalgaon" },
      { id: 550410, name: "Kundane" },
      { id: 550446, name: "Malsane" },
      { id: 550454, name: "Mangrul" },
      { id: 550471, name: "Mesankhede Bk." },
      { id: 550481, name: "Mesankhede Kh" },
      { id: 550436, name: "Nandurtek" },
      { id: 550448, name: "Narayangaon" },
      { id: 550510, name: "Narayankhede" },
      { id: 550405, name: "Nawapur" },
      { id: 550462, name: "Nhanave" },
      { id: 550501, name: "Nimbale" },
      { id: 550456, name: "Nimgavhan" },
      { id: 550469, name: "Nimon" },
      { id: 550499, name: "Panhale" },
      { id: 550416, name: "Paregaon" },
      { id: 550458, name: "Parsul" },
      { id: 550504, name: "Pate" },
      { id: 550455, name: "Patharshembe" },
      { id: 550480, name: "Pimpalgaon Dhabli" },
      { id: 550428, name: "Pimpalnare" },
      { id: 550509, name: "Pimplad" },
      { id: 550432, name: "Puri" },
      { id: 550437, name: "Rahod" },
      { id: 550435, name: "Rajderwadi" },
      { id: 550488, name: "Rapali" },
      { id: 550486, name: "Raypur" },
      { id: 550503, name: "Redgaon Kh" },
      { id: 550502, name: "Salsane" },
      { id: 550444, name: "Shelu" },
      { id: 550409, name: "Sherisalaiban" },
      { id: 550425, name: "Shinde" },
      { id: 550482, name: "Shingve" },
      { id: 550450, name: "Shirsane" },
      { id: 550434, name: "Shirur" },
      { id: 550440, name: "Shivajinagar" },
      { id: 550418, name: "Shivare" },
      { id: 550447, name: "Sogras" },
      { id: 550497, name: "Soni Sangvi" },
      { id: 550476, name: "Sutarkhede" },
      { id: 550515, name: "Talegaon Rohi" },
      { id: 550453, name: "Talwade" },
      { id: 550459, name: "Tisgaon" },
      { id: 550493, name: "Urdhul" },
      { id: 550463, name: "Uswad" },
      { id: 550466, name: "Vad" },
      { id: 550426, name: "Vadalibhoi" },
      { id: 550438, name: "Vadbare" },
      { id: 550487, name: "Vadgaon Pangu" },
      { id: 550427, name: "Vadner Bhairao" },
      { id: 550511, name: "Vahegaon Sal" },
      { id: 550513, name: "Vaki Bk" },
      { id: 550512, name: "Vaki Kh" },
      { id: 550465, name: "Varadi" },
      { id: 550412, name: "Vijaynagar" },
      { id: 550498, name: "Vitave" },
      { id: 550484, name: "Wakdardi" },
    ],
    4149: [
      { id: 550616, name: "Ahiwantwadi" },
      { id: 550661, name: "Akrale" },
      { id: 550526, name: "Ambad" },
      { id: 550622, name: "Ambaner" },
      { id: 550668, name: "Ambedindori" },
      { id: 550554, name: "Ambegaon" },
      { id: 550637, name: "Ambevani" },
      { id: 550640, name: "Awankhed" },
      { id: 550627, name: "Babapur" },
      { id: 550529, name: "Badagichapada" },
      { id: 550600, name: "Bandharpada" },
      { id: 550573, name: "Bhanwad" },
      { id: 550625, name: "Bhatode" },
      { id: 550644, name: "Bopegaon" },
      { id: 550574, name: "Borvan" },
      { id: 550553, name: "Chachadgaon" },
      { id: 550618, name: "Chamdari" },
      { id: 550624, name: "Chandikapur" },
      { id: 550528, name: "Charose" },
      { id: 550580, name: "Chausale" },
      { id: 550522, name: "Chikadi" },
      { id: 550531, name: "Chilharpada" },
      { id: 550664, name: "Chinchkhed" },
      { id: 550583, name: "Dagadpimpri" },
      { id: 550607, name: "Dahegaon" },
      { id: 550602, name: "Dahivi" },
      { id: 550518, name: "Dehare" },
      { id: 550564, name: "Deherewadi" },
      { id: 550530, name: "Deoghar" },
      { id: 550597, name: "Deolichapada" },
      { id: 550590, name: "Deopada" },
      { id: 550577, name: "Deosane" },
      { id: 550598, name: "Deothan" },
      { id: 550599, name: "Devapur" },
      { id: 550670, name: "Dhakambe" },
      { id: 550654, name: "Dhamanwadi" },
      { id: 550557, name: "Dhaur" },
      { id: 550523, name: "Dhondalpada" },
      { id: 550649, name: "Dindori 1" },
      { id: 944248, name: "Dindori 2" },
      { id: 550588, name: "Eklahare" },
      { id: 550520, name: "Gandole" },
      { id: 944944, name: "Ganeshgaon" },
      { id: 550569, name: "Gawalwadi" },
      { id: 550638, name: "Ghodewadi" },
      { id: 550617, name: "Goldari" },
      { id: 550541, name: "Golshi" },
      { id: 550645, name: "Gondegaon" },
      { id: 550586, name: "Haste Dumala" },
      { id: 550550, name: "Hatnore" },
      { id: 550659, name: "Indore" },
      { id: 550542, name: "Jalkhed" },
      { id: 550551, name: "Jambutake" },
      { id: 550673, name: "Janori" },
      { id: 550674, name: "Jaulakedindori" },
      { id: 550646, name: "Jaulakevani" },
      { id: 550619, name: "Jirwade" },
      { id: 550653, name: "Jopul" },
      { id: 550536, name: "Joran" },
      { id: 550537, name: "Joranpada" },
      { id: 550567, name: "June Dhagur" },
      { id: 550549, name: "Kadawa Mhalungi" },
      { id: 550589, name: "Karanjali" },
      { id: 550579, name: "Karanjkhed" },
      { id: 550609, name: "Karanjwan" },
      { id: 550630, name: "Kasbe Vani" },
      { id: 550532, name: "Kaudasar" },
      { id: 550663, name: "Khadak Sukene" },
      { id: 550669, name: "Khatwad" },
      { id: 550610, name: "Khedale" },
      { id: 550643, name: "Khedgaon" },
      { id: 550587, name: "Khoripada" },
      { id: 550560, name: "Kochargaon" },
      { id: 550543, name: "Kokangaon Bk." },
      { id: 550612, name: "Kokangaon Kh." },
      { id: 550584, name: "Kolher" },
      { id: 550662, name: "Korhate" },
      { id: 550601, name: "Koshimbe" },
      { id: 550631, name: "Krishnagaon" },
      { id: 550665, name: "Kurnoli" },
      { id: 550608, name: "Lakhamapur" },
      { id: 550655, name: "Lokhandewadi" },
      { id: 550658, name: "Madakijamb" },
      { id: 550540, name: "Mahaje" },
      { id: 550585, name: "Maledumala" },
      { id: 550604, name: "Malegaonkazi" },
      { id: 550623, name: "Mandane" },
      { id: 550572, name: "Manori" },
      { id: 550652, name: "Materewadi" },
      { id: 550629, name: "Mavadi" },
      { id: 550548, name: "Mheluske" },
      { id: 550666, name: "Mohadi" },
      { id: 550517, name: "Mokhnal" },
      { id: 550626, name: "Mulane" },
      { id: 550562, name: "Nalegaon" },
      { id: 550614, name: "Nalwadi" },
      { id: 550613, name: "Nalwadpada" },
      { id: 550524, name: "Nanashi" },
      { id: 550568, name: "Nave Dhagur" },
      { id: 550615, name: "Nigdol" },
      { id: 550648, name: "Nilwandi" },
      { id: 550632, name: "Ozarkhed" },
      { id: 550547, name: "Oze" },
      { id: 550647, name: "Pade" },
      { id: 550593, name: "Palasvihir" },
      { id: 550656, name: "Palkhed Bandhara" },
      { id: 550620, name: "Pandane" },
      { id: 550639, name: "Parmori" },
      { id: 550605, name: "Phopshi" },
      { id: 550535, name: "Pimpalgaon Dhum" },
      { id: 550650, name: "Pimpalgaon Ketaki" },
      { id: 550571, name: "Pimpalnare" },
      { id: 550611, name: "Pimparkhed" },
      { id: 550558, name: "Pimpraj" },
      { id: 550582, name: "Pimpri Anchala" },
      { id: 550581, name: "Pingalwadi" },
      { id: 550556, name: "Pophalwade" },
      { id: 550621, name: "Punegaon" },
      { id: 550525, name: "Radtodi" },
      { id: 550651, name: "Rajapur" },
      { id: 550570, name: "Ramshej" },
      { id: 550563, name: "Rashegaon" },
      { id: 550565, name: "Rawalgaon" },
      { id: 550539, name: "Sadrale" },
      { id: 550628, name: "Sangamner" },
      { id: 550578, name: "Sarsale" },
      { id: 936803, name: "Sawarpada" },
      { id: 550576, name: "Shindpada" },
      { id: 550635, name: "Shindwad" },
      { id: 550672, name: "Shivnai" },
      { id: 550533, name: "Shiwarpada" },
      { id: 550544, name: "Shreeramnagar" },
      { id: 909136, name: "Songaon" },
      { id: 550636, name: "Sonjamb" },
      { id: 550660, name: "Talegaon Dindori" },
      { id: 550633, name: "Talegaon Vani" },
      { id: 550591, name: "Talyachapada" },
      { id: 550521, name: "Tetmala" },
      { id: 550538, name: "Thepanwadi" },
      { id: 550566, name: "Tilloli" },
      { id: 550634, name: "Tisgaon" },
      { id: 550596, name: "Titave" },
      { id: 550552, name: "Umrale Bk." },
      { id: 550546, name: "Umrale Kh." },
      { id: 550606, name: "Vaglud" },
      { id: 550641, name: "Valkhed" },
      { id: 550594, name: "Vanare" },
      { id: 550534, name: "Vani Kh." },
      { id: 550595, name: "Vanjule" },
      { id: 550592, name: "Vare" },
      { id: 550642, name: "Varkhede" },
      { id: 550671, name: "Varvandi" },
      { id: 550559, name: "Vilwandi" },
      { id: 550575, name: "Wagdeopada" },
      { id: 550545, name: "Waghad" },
      { id: 550657, name: "Wanarwadi" },
      { id: 550555, name: "Zaralipada" },
    ],
    4150: [
      { id: 550802, name: "Aad Bk." },
      { id: 550779, name: "Aad Kh." },
      { id: 550810, name: "Abheti" },
      { id: 550745, name: "Adgaon" },
      { id: 550751, name: "Ambapani" },
      { id: 550734, name: "Ambapur" },
      { id: 550694, name: "Ambas" },
      { id: 550676, name: "Ambe" },
      { id: 550683, name: "Amdongra" },
      { id: 550811, name: "Amlon" },
      { id: 550742, name: "Andhrute" },
      { id: 550704, name: "Asarbari" },
      { id: 550711, name: "Badagi" },
      { id: 550796, name: "Bardapada" },
      { id: 550744, name: "Belpada" },
      { id: 550697, name: "Bhatvihir" },
      { id: 550801, name: "Bhaygaon" },
      { id: 550740, name: "Bhedamal" },
      { id: 550750, name: "Bhuwan" },
      { id: 550747, name: "Bilkas" },
      { id: 550695, name: "Bordha" },
      { id: 550722, name: "Borichibari" },
      { id: 550763, name: "Borpada" },
      { id: 550737, name: "Borwath" },
      { id: 550752, name: "Chafyachapada" },
      { id: 550792, name: "Chikadi" },
      { id: 550808, name: "Cholmukh" },
      { id: 550692, name: "Dabhadi" },
      { id: 550756, name: "Deogaon" },
      { id: 550721, name: "Derapada" },
      { id: 550790, name: "Devichamal" },
      { id: 550778, name: "Dhabyachapada" },
      { id: 550761, name: "Dhanpada" },
      { id: 550733, name: "Dhondmal" },
      { id: 550817, name: "Dhulghat" },
      { id: 550678, name: "Diksal" },
      { id: 550800, name: "Dolharmal" },
      { id: 550698, name: "Domkhadak" },
      { id: 550783, name: "Dongarshet" },
      { id: 550818, name: "Donwade" },
      { id: 550757, name: "Ekadare" },
      { id: 550815, name: "Fanaspada (Kha)" },
      { id: 550675, name: "Gandole" },
      { id: 550776, name: "Gangodbari" },
      { id: 550743, name: "Garmal" },
      { id: 550797, name: "Gawandh" },
      { id: 550768, name: "Gawandhpada" },
      { id: 550746, name: "Gaydhond" },
      { id: 909141, name: "Ghanshet" },
      { id: 550785, name: "Ghotwihira" },
      { id: 550780, name: "Gonde" },
      { id: 550804, name: "Hanumannagar" },
      { id: 550749, name: "Hanumantpada (Bhu)" },
      { id: 550755, name: "Hanumantpada (U.)" },
      { id: 550703, name: "Harangaon" },
      { id: 550709, name: "Hatrundi" },
      { id: 550794, name: "Homepada" },
      { id: 550769, name: "Inambari" },
      { id: 550713, name: "Jale" },
      { id: 550712, name: "Jamale" },
      { id: 550754, name: "Jambhulmal" },
      { id: 550735, name: "Jambvihir" },
      { id: 550701, name: "Jogmodi" },
      { id: 550714, name: "Junothi" },
      { id: 550758, name: "Kahandolpada" },
      { id: 550690, name: "Kakadpada" },
      { id: 550689, name: "Kalambari" },
      { id: 550727, name: "Kalampada" },
      { id: 550691, name: "Kalune" },
      { id: 550685, name: "Kapurne" },
      { id: 550772, name: "Karanjali" },
      { id: 550682, name: "Karanjkhed" },
      { id: 550753, name: "Kasatvihir" },
      { id: 550716, name: "Kayare" },
      { id: 550723, name: "Kelvihir" },
      { id: 550760, name: "Khadki" },
      { id: 550732, name: "Khambale" },
      { id: 550762, name: "Khamshet" },
      { id: 550786, name: "Kharpadi" },
      { id: 550707, name: "Khirkide" },
      { id: 550729, name: "Khokartale" },
      { id: 550805, name: "Kohor" },
      { id: 550706, name: "Kopurli Bk." },
      { id: 550699, name: "Kopurli Kh." },
      { id: 550738, name: "Kotambi" },
      { id: 550813, name: "Kulwandi" },
      { id: 550720, name: "Kumbhale" },
      { id: 550770, name: "Kumbharbari" },
      { id: 550726, name: "Lavhali" },
      { id: 550803, name: "Lingawane" },
      { id: 550687, name: "Malegaon" },
      { id: 550765, name: "Mangone" },
      { id: 550782, name: "Mankapur" },
      { id: 550686, name: "Mhasgan" },
      { id: 550677, name: "Mohadand" },
      { id: 550708, name: "Mohpada" },
      { id: 550807, name: "Murmuti" },
      { id: 550788, name: "Nachlondhi" },
      { id: 550718, name: "Nalshet" },
      { id: 550773, name: "Nirgude" },
      { id: 550680, name: "Pahuchibari" },
      { id: 550798, name: "Palashi Bk." },
      { id: 550710, name: "Palashi Kh." },
      { id: 550736, name: "Patali" },
      { id: 550816, name: "Pate" },
      { id: 550766, name: "Pawarpada" },
      { id: 550791, name: "Payarpada" },
      { id: 550731, name: "Peint" },
      { id: 550787, name: "Phanaspada (Co)" },
      { id: 550705, name: "Phanaspada(Pate)" },
      { id: 550700, name: "Pimpalpada" },
      { id: 550784, name: "Pimpalwati" },
      { id: 550781, name: "Raitale" },
      { id: 550719, name: "Rajbari" },
      { id: 550728, name: "Ranvihir" },
      { id: 550806, name: "Ruipetha" },
      { id: 550725, name: "Sadadpada (Ra)" },
      { id: 550693, name: "Sadadpada (Su)" },
      { id: 550774, name: "Sambarpada" },
      { id: 550812, name: "Sasune" },
      { id: 550771, name: "Savalghat" },
      { id: 550717, name: "Sawarna" },
      { id: 550795, name: "Shevkhandi" },
      { id: 550777, name: "Shinde" },
      { id: 550799, name: "Shingdari" },
      { id: 550730, name: "Shirale" },
      { id: 550684, name: "Shivshet" },
      { id: 550696, name: "Surgane" },
      { id: 550775, name: "Tilbhat" },
      { id: 550715, name: "Tirdhe" },
      { id: 550741, name: "Tondawal" },
      { id: 550679, name: "Toranmal" },
      { id: 550764, name: "Ubhidhond" },
      { id: 550688, name: "Umarpada (Ma)" },
      { id: 550819, name: "Umbardahad" },
      { id: 550748, name: "Umbarpada Bhuvan" },
      { id: 550767, name: "Umbarpada Karanjali" },
      { id: 550759, name: "Umbrad" },
      { id: 550739, name: "Usthale" },
      { id: 550702, name: "Vadabari" },
      { id: 550793, name: "Wadpada" },
      { id: 550814, name: "Waghyachibari" },
      { id: 550724, name: "Wangani" },
      { id: 550789, name: "Wazvad" },
      { id: 550681, name: "Wirmal" },
    ],
    4151: [
      { id: 550877, name: "Adgaon" },
      { id: 550939, name: "Alwand" },
      { id: 550906, name: "Ambai" },
      { id: 550905, name: "Amboli" },
      { id: 550913, name: "Anjanneri" },
      { id: 550934, name: "Aswali Harsh" },
      { id: 550935, name: "Avhate" },
      { id: 550821, name: "Bafanvihir" },
      { id: 550828, name: "Behedpada" },
      { id: 550845, name: "Belpali" },
      { id: 550855, name: "Berwal" },
      { id: 550911, name: "Beze" },
      { id: 550873, name: "Bhagohol" },
      { id: 550930, name: "Bhilmal" },
      { id: 550865, name: "Bhutmokhada" },
      { id: 550827, name: "Boripada" },
      { id: 550902, name: "Bramhanwade" },
      { id: 550835, name: "Chikhalpada" },
      { id: 550824, name: "Chinchohol" },
      { id: 550843, name: "Chinchwad" },
      { id: 550838, name: "Chirapali" },
      { id: 550912, name: "Chokore" },
      { id: 550862, name: "Chourapada" },
      { id: 550926, name: "Dahalewadi" },
      { id: 550834, name: "Dalpatpur" },
      { id: 550940, name: "Dapure" },
      { id: 550822, name: "Deodongara" },
      { id: 550820, name: "Deodongari" },
      { id: 550938, name: "Deogaon" },
      { id: 550875, name: "Deola" },
      { id: 550928, name: "Dhadoshi" },
      { id: 550858, name: "Dhaytipada" },
      { id: 550903, name: "Dhumodi" },
      { id: 550899, name: "Divyachapada" },
      { id: 550825, name: "Dol Ohol" },
      { id: 550846, name: "Gadadvane" },
      { id: 550900, name: "Ganeshgaon Waghera" },
      { id: 550856, name: "Garmal" },
      { id: 550871, name: "Gavatha" },
      { id: 550886, name: "Ghodhadyachapada" },
      { id: 550851, name: "Goldari" },
      { id: 550894, name: "Gorthan" },
      { id: 550921, name: "Harshawadi" },
      { id: 550836, name: "Harsul" },
      { id: 550849, name: "Hatlondhi" },
      { id: 550833, name: "Hattipada" },
      { id: 550897, name: "Hirdi" },
      { id: 550881, name: "Holdar Nagar" },
      { id: 550841, name: "Jategaon Bk" },
      { id: 550840, name: "Jategaon Kh" },
      { id: 550876, name: "Kacharpada" },
      { id: 550907, name: "Kachurli" },
      { id: 550853, name: "Kadegvhan" },
      { id: 550867, name: "Kalamuste(Tryambak)" },
      { id: 550919, name: "Kalmuste" },
      { id: 550863, name: "Karanjpana" },
      { id: 550823, name: "Kas" },
      { id: 550852, name: "Khadakohol" },
      { id: 550831, name: "Khairaipali" },
      { id: 550922, name: "Khambale" },
      { id: 550932, name: "Kharoli" },
      { id: 550829, name: "Kharshet" },
      { id: 550887, name: "Kharwal" },
      { id: 550842, name: "Khoripada" },
      { id: 550929, name: "Kojoli" },
      { id: 550884, name: "Kone" },
      { id: 550866, name: "Kotambi (Harsul)" },
      { id: 550857, name: "Koulpoda" },
      { id: 550878, name: "Mahadeo Nagar" },
      { id: 550895, name: "Malegaon" },
      { id: 550936, name: "Met Chandrachi" },
      { id: 550937, name: "Met Humbhachi" },
      { id: 550944, name: "Met Yelyachi" },
      { id: 550917, name: "Metghar Killa" },
      { id: 550892, name: "Metkawara" },
      { id: 550924, name: "Mulegaon" },
      { id: 550859, name: "Mulvad" },
      { id: 550872, name: "Murambi" },
      { id: 550890, name: "Nandgaon" },
      { id: 550869, name: "Nandurkipada" },
      { id: 550847, name: "Nirgude (Harsul)" },
      { id: 550854, name: "Ozar Khed" },
      { id: 550931, name: "Pahine" },
      { id: 550915, name: "Pegalwadi (Nashik)" },
      { id: 550914, name: "Pegalwadi (Tryambak)" },
      { id: 550909, name: "Pimplad (Trimbak)" },
      { id: 550898, name: "Pmpri (Trimbak)" },
      { id: 550850, name: "Rajivnagar" },
      { id: 550870, name: "Rautmal" },
      { id: 550864, name: "Rayate" },
      { id: 550896, name: "Rohile" },
      { id: 550933, name: "Samundi" },
      { id: 550837, name: "Sapatpali" },
      { id: 550908, name: "Sapgaon" },
      { id: 550883, name: "Sapte" },
      { id: 550839, name: "Saraste" },
      { id: 550860, name: "Savarvada" },
      { id: 550830, name: "Sawarpada" },
      { id: 550826, name: "Shindpada" },
      { id: 550868, name: "Shirasgaon (Harsul)" },
      { id: 550904, name: "Shirasgaon(Tryambak)" },
      { id: 550880, name: "Shivaji Nagar" },
      { id: 550879, name: "Somnathnagar" },
      { id: 550943, name: "Take Deogaon" },
      { id: 550925, name: "Take Harsha" },
      { id: 550918, name: "Talegaon Trimbak" },
      { id: 550910, name: "Talwade (Trimbak)" },
      { id: 550848, name: "Thanapada" },
      { id: 550891, name: "Torangan(Harsul)" },
      { id: 550832, name: "Torangan(Tryambak)" },
      { id: 550916, name: "Tryambakeshwar" },
      { id: 550920, name: "Umbharande" },
      { id: 550923, name: "Vadholi" },
      { id: 550885, name: "Vaghera" },
      { id: 550889, name: "Varasvihir" },
      { id: 550874, name: "Vatakapada" },
      { id: 550942, name: "Vavi Harsha" },
      { id: 550882, name: "Vele" },
      { id: 550901, name: "Vinayaknagar" },
      { id: 550888, name: "Virnagar" },
      { id: 550861, name: "Walan" },
      { id: 550844, name: "Waygholpada" },
      { id: 550893, name: "Welunje" },
      { id: 550941, name: "Zarwad Bk" },
      { id: 550927, name: "Zarwad Kh" },
    ],
    4152: [
      { id: 944024, name: "Aanandwalli" },
      { id: 944228, name: "Adgaon 1" },
      { id: 944229, name: "Adgaon 2" },
      { id: 944023, name: "Agartakli" },
      { id: 944949, name: "Ambad Khurd" },
      { id: 550991, name: "Ambebahula" },
      { id: 551004, name: "Babhaleshwar" },
      { id: 551011, name: "Belatgavhan" },
      { id: 550981, name: "Belgaon Dhaga" },
      { id: 944045, name: "Bhagur" },
      { id: 944027, name: "Chadegaon" },
      { id: 551006, name: "Chandgiri" },
      { id: 550970, name: "Chandshi" },
      { id: 944029, name: "Chehadi Budruk" },
      { id: 944028, name: "Chunchale" },
      { id: 944031, name: "Dadhegaon" },
      { id: 550989, name: "Dahegaon" },
      { id: 550968, name: "Dari" },
      { id: 944030, name: "Dasak" },
      { id: 944230, name: "Deolali 1" },
      { id: 944231, name: "Deolali 2" },
      { id: 550952, name: "Devargaon" },
      { id: 550953, name: "Dhondegaon" },
      { id: 551012, name: "Donwade" },
      { id: 550978, name: "Dudgaon" },
      { id: 550955, name: "Dugaon" },
      { id: 909142, name: "Eklahare" },
      { id: 909143, name: "Ganeshgaon Nashik" },
      { id: 550964, name: "Ganeshgaon Trambak" },
      { id: 550960, name: "Gangamhalungi" },
      { id: 550999, name: "Gangapadali" },
      { id: 944026, name: "Gangapur" },
      { id: 550977, name: "Gangavarhe" },
      { id: 550990, name: "Gaulane" },
      { id: 550954, name: "Girnare" },
      { id: 550975, name: "Govardhan" },
      { id: 550961, name: "Govindrur" },
      { id: 551001, name: "Hinganwedhe" },
      { id: 550949, name: "Indiranagar" },
      { id: 551002, name: "Jakhori" },
      { id: 550974, name: "Jalalpur" },
      { id: 550984, name: "Jategaon" },
      { id: 551000, name: "Kalavi" },
      { id: 944025, name: "Kamatwade" },
      { id: 551003, name: "Kotamgaon" },
      { id: 550945, name: "Ladchi" },
      { id: 551015, name: "Lahvit" },
      { id: 550998, name: "Lakhalgaon" },
      { id: 551016, name: "Lohshingve" },
      { id: 550995, name: "Madsangavi" },
      { id: 550973, name: "Mahadeopur" },
      { id: 550982, name: "Mahirawani" },
      { id: 944234, name: "Makhamalabad 1" },
      { id: 944235, name: "Makhamalabad 2" },
      { id: 550967, name: "Manoli" },
      { id: 944046, name: "Manur" },
      { id: 550969, name: "Matori" },
      { id: 944047, name: "Mhasrul" },
      { id: 551005, name: "Mohagaon" },
      { id: 550971, name: "Mungsare" },
      { id: 550956, name: "Nagalwadi" },
      { id: 550946, name: "Naikwadi" },
      { id: 944032, name: "Nandur Dasak" },
      { id: 551010, name: "Nanegaon" },
      { id: 944210, name: "Nashik Shahar 1" },
      { id: 944224, name: "Nashik Shahar 2" },
      { id: 944225, name: "Nashik Shahar 3" },
      { id: 944226, name: "Nashik Shahar 4" },
      { id: 944227, name: "Nashikshahar 5" },
      { id: 550997, name: "Odha" },
      { id: 550957, name: "Ozarkhede" },
      { id: 551008, name: "Palse" },
      { id: 944037, name: "Panchak" },
      { id: 944232, name: "Pathardi 1" },
      { id: 944233, name: "Pathardi 2" },
      { id: 944033, name: "Pimpalgaon Bahula" },
      { id: 550963, name: "Pimpalgaon Garudeshwar" },
      { id: 944035, name: "Pimpalgaon Khamb" },
      { id: 550985, name: "Pimplad Nashik" },
      { id: 550992, name: "Pimpri Sayyad" },
      { id: 551013, name: "Rahuri" },
      { id: 550988, name: "Raigadnagar" },
      { id: 550965, name: "Rajewadi" },
      { id: 550987, name: "Rajur Bahula" },
      { id: 909144, name: "Sadgaon" },
      { id: 551018, name: "Samangaon" },
      { id: 551020, name: "Sansari" },
      { id: 550986, name: "Sarul" },
      { id: 944139, name: "Satpur" },
      { id: 550976, name: "Sawargaon" },
      { id: 550959, name: "Shastrinagar" },
      { id: 551009, name: "Shewge Darna" },
      { id: 550996, name: "Shilapur" },
      { id: 551007, name: "Shinde" },
      { id: 944138, name: "Shingvebahula" },
      { id: 550962, name: "Shivangaon" },
      { id: 550958, name: "Subhashnagar" },
      { id: 550994, name: "Sultanpur" },
      { id: 550983, name: "Talegaon Anjaneri" },
      { id: 550980, name: "Tiradshet" },
      { id: 944049, name: "Vadala" },
      { id: 550947, name: "Vadgaon" },
      { id: 944048, name: "Vadner Dumala" },
      { id: 551017, name: "Vanjarwadi" },
      { id: 944050, name: "Vihitgaon" },
      { id: 551019, name: "Vilholi" },
      { id: 550993, name: "Vinchurgavali" },
      { id: 550979, name: "Wasali" },
      { id: 550972, name: "Yashwantnagar" },
    ],
    4153: [
      { id: 551127, name: "Adharwad" },
      { id: 551117, name: "Adsare Bk" },
      { id: 551119, name: "Adsare Kh" },
      { id: 551077, name: "Adwan" },
      { id: 551025, name: "Ahurli" },
      { id: 551106, name: "Ambewadi" },
      { id: 551089, name: "Avachitwadi" },
      { id: 551084, name: "Awal Khed" },
      { id: 551029, name: "Awali Dumala" },
      { id: 551080, name: "Balayduri" },
      { id: 943035, name: "Balwantnagar" },
      { id: 551128, name: "Bambalewadi" },
      { id: 551135, name: "Barshingave" },
      { id: 551048, name: "Belgaon Kurhe" },
      { id: 551121, name: "Belgaon Tarhale" },
      { id: 551116, name: "Bhandardarawadi" },
      { id: 551115, name: "Bharvir Bk" },
      { id: 551114, name: "Bharvir Kh" },
      { id: 551100, name: "Bharwaj" },
      { id: 551035, name: "Bhavli Bk" },
      { id: 551098, name: "Bhavli Kh" },
      { id: 551063, name: "Biturli" },
      { id: 551095, name: "Borli" },
      { id: 551087, name: "Bortembhe" },
      { id: 551083, name: "Chinchale Khaire" },
      { id: 943054, name: "Dahalewadi" },
      { id: 551066, name: "Daundat" },
      { id: 551076, name: "Deole" },
      { id: 551118, name: "Dhamangaon" },
      { id: 551122, name: "Dhamani" },
      { id: 551033, name: "Dhargaon" },
      { id: 551040, name: "Dharnoli" },
      { id: 551094, name: "Fangulgavhan" },
      { id: 551044, name: "Gadgad Sangvi" },
      { id: 551120, name: "Gambhirwadi" },
      { id: 551070, name: "Garudeshwar" },
      { id: 551103, name: "Gavhande" },
      { id: 551129, name: "Ghodewadi" },
      { id: 551139, name: "Ghoti Bk." },
      { id: 551062, name: "Ghoti Kh" },
      { id: 944020, name: "Girnare" },
      { id: 551050, name: "Gondedumala" },
      { id: 944010, name: "Igatpuri Gaon" },
      { id: 944019, name: "Igatpuri Shahar" },
      { id: 551108, name: "Indore" },
      { id: 551104, name: "Jamunde" },
      { id: 551056, name: "Janori" },
      { id: 551099, name: "Kaluste" },
      { id: 551125, name: "Kanad Wadi" },
      { id: 551088, name: "Kanchan Gaon" },
      { id: 551028, name: "Karhole" },
      { id: 551113, name: "Kawaddara" },
      { id: 551036, name: "Kawanai" },
      { id: 551107, name: "Khadked" },
      { id: 551082, name: "Khairgaon" },
      { id: 551065, name: "Khambale" },
      { id: 551126, name: "Khed" },
      { id: 551037, name: "Korapgaon" },
      { id: 551058, name: "Krishnanagar" },
      { id: 551049, name: "Kurhegaon" },
      { id: 551039, name: "Kurnoli" },
      { id: 551105, name: "Kurungwadi" },
      { id: 551041, name: "Kushegaon" },
      { id: 551047, name: "Lahamagewadi" },
      { id: 551057, name: "Laxminagar" },
      { id: 551133, name: "Maidara Dhanoshi" },
      { id: 551071, name: "Malunje" },
      { id: 551053, name: "Manikkhamb" },
      { id: 551101, name: "Manjargaon" },
      { id: 551097, name: "Manwedhe" },
      { id: 551022, name: "Mhasurli" },
      { id: 944945, name: "Modale" },
      { id: 551073, name: "Mogare" },
      { id: 551051, name: "Mukane" },
      { id: 551054, name: "Mundegaon" },
      { id: 551045, name: "Murambi" },
      { id: 551032, name: "Nagosali" },
      { id: 551026, name: "Nandadgaon" },
      { id: 551061, name: "Nandgaon Bk" },
      { id: 551092, name: "Nandgaon Sado" },
      { id: 551059, name: "Nandurvaidya" },
      { id: 551112, name: "Ninavi" },
      { id: 551102, name: "Nirpan" },
      { id: 551031, name: "Ondli" },
      { id: 551055, name: "Padli Deshmukh" },
      { id: 551124, name: "Pardeshwadi" },
      { id: 551079, name: "Pardevi" },
      { id: 551038, name: "Pimpalgaon Bhatata" },
      { id: 551110, name: "Pimpalgaon Dukra" },
      { id: 551111, name: "Pimpalgaon Ghadaga" },
      { id: 551123, name: "Pimpalgaon Mor" },
      { id: 551093, name: "Pimparisaddroddin" },
      { id: 551138, name: "Ramnagar" },
      { id: 551027, name: "Rayambe" },
      { id: 551060, name: "Sakur" },
      { id: 551072, name: "Samnere" },
      { id: 551052, name: "Sanjegaon" },
      { id: 551030, name: "Saturli" },
      { id: 551109, name: "Shenit" },
      { id: 551081, name: "Shenvad Bk" },
      { id: 551069, name: "Shenvad Kh" },
      { id: 551130, name: "Sherewadi" },
      { id: 551023, name: "Shevgedang" },
      { id: 943048, name: "Shidwadi" },
      { id: 551042, name: "Shirsate" },
      { id: 551074, name: "Somaj" },
      { id: 551134, name: "Sonoshi" },
      { id: 551131, name: "Taked Bk" },
      { id: 551132, name: "Taked Kh" },
      { id: 551086, name: "Takeghoti" },
      { id: 944021, name: "Talegaon Budruk" },
      { id: 551090, name: "Talogh" },
      { id: 551091, name: "Taloshi" },
      { id: 943045, name: "Taranganpada" },
      { id: 943049, name: "Thakurwadi" },
      { id: 551085, name: "Titoli" },
      { id: 551078, name: "Tringal Wadi" },
      { id: 551075, name: "Ubhade" },
      { id: 551067, name: "Umbarkon" },
      { id: 551046, name: "Wadivarhe" },
      { id: 909148, name: "Waghachi Wadi" },
      { id: 551068, name: "Waghere" },
      { id: 551064, name: "Waki" },
      { id: 551034, name: "Walvihir" },
      { id: 551024, name: "Wanjole" },
      { id: 551137, name: "Wasali" },
    ],
    4154: [
      { id: 551228, name: "Adwadi" },
      { id: 551212, name: "Agas Khind" },
      { id: 551234, name: "Ashapur" },
      { id: 551220, name: "Atkawade" },
      { id: 551214, name: "Aundhewadi" },
      { id: 551150, name: "Baragaon Pimpri" },
      { id: 551213, name: "Belu" },
      { id: 551180, name: "Bharatpur" },
      { id: 551162, name: "Bhatwadi" },
      { id: 551192, name: "Bhokani" },
      { id: 551211, name: "Borkhind" },
      { id: 551143, name: "Bramhanwade" },
      { id: 551202, name: "Chandrapur" },
      { id: 551231, name: "Chapadgaon" },
      { id: 551239, name: "Chas" },
      { id: 551194, name: "Chincholi" },
      { id: 551165, name: "Chondhi" },
      { id: 551168, name: "Dahiwadi" },
      { id: 551230, name: "Dapur" },
      { id: 551158, name: "Datli" },
      { id: 551225, name: "Dattanagar" },
      { id: 551187, name: "Deopur" },
      { id: 551145, name: "Deshwandi" },
      { id: 551189, name: "Dharangaon" },
      { id: 551215, name: "Dhondbar" },
      { id: 551219, name: "Dhondvirnagar" },
      { id: 551229, name: "Dhulwad" },
      { id: 551262, name: "Dodi Bk." },
      { id: 551264, name: "Dodi Kh." },
      { id: 551221, name: "Dubere" },
      { id: 551251, name: "Dusangwadi" },
      { id: 551176, name: "Eklahare" },
      { id: 551190, name: "Fardapur" },
      { id: 551268, name: "Fattepur" },
      { id: 551257, name: "Fulenagar" },
      { id: 551205, name: "Ghorwad" },
      { id: 551259, name: "Ghotewadi" },
      { id: 551223, name: "Gonde" },
      { id: 551260, name: "Gulapur" },
      { id: 551174, name: "Gulvanch" },
      { id: 551161, name: "Gurewadi" },
      { id: 551207, name: "Harsule" },
      { id: 551233, name: "Hivare" },
      { id: 551147, name: "Hiwargaon" },
      { id: 551199, name: "Jamgaon" },
      { id: 551144, name: "Jaygaon" },
      { id: 551217, name: "Jayprakash Nagar" },
      { id: 551140, name: "Jogaltembhi" },
      { id: 551258, name: "Kahandalwadi" },
      { id: 551266, name: "Kankori" },
      { id: 551183, name: "Karwadi" },
      { id: 551240, name: "Kasarwadi" },
      { id: 551156, name: "Kedarpur" },
      { id: 551149, name: "Keru Patilnagar" },
      { id: 551171, name: "Khadangali" },
      { id: 551193, name: "Khambale" },
      { id: 551206, name: "Khaparale" },
      { id: 551188, name: "Khopadi Bk." },
      { id: 551191, name: "Khopadi Kh." },
      { id: 551175, name: "Kirtangali" },
      { id: 551245, name: "Kolgaonmal" },
      { id: 551148, name: "Komalwadi" },
      { id: 551216, name: "Konambe" },
      { id: 551227, name: "Krishnanagar" },
      { id: 944144, name: "Kundewadi Mouje" },
      { id: 944868, name: "Kundewadimajre" },
      { id: 551181, name: "Laxmanpur" },
      { id: 551169, name: "Mahajanpur" },
      { id: 551250, name: "Maldhon" },
      { id: 551153, name: "Malegaon" },
      { id: 551218, name: "Manegaon" },
      { id: 551265, name: "Manori" },
      { id: 551154, name: "Maparwadi" },
      { id: 551255, name: "Marhal Bk." },
      { id: 551256, name: "Marhal Kh." },
      { id: 551170, name: "Mendhi" },
      { id: 551244, name: "Mirgaon" },
      { id: 551242, name: "Mithsagare" },
      { id: 551196, name: "Mohdari" },
      { id: 551195, name: "Mohu" },
      { id: 551159, name: "Musalgaon" },
      { id: 551141, name: "Naigaon" },
      { id: 551241, name: "Nalwadi" },
      { id: 551269, name: "Nandur Shingote" },
      { id: 551173, name: "Nimgaon Deopur" },
      { id: 551177, name: "Nimgaon Sinnar" },
      { id: 551267, name: "Nirhale" },
      { id: 551236, name: "Padali" },
      { id: 551186, name: "Panchale" },
      { id: 551204, name: "Pandhurli" },
      { id: 551253, name: "Pangari Bk" },
      { id: 551254, name: "Pangari Kh" },
      { id: 551200, name: "Paste" },
      { id: 551246, name: "Pathare Bk." },
      { id: 551247, name: "Pathare Kh." },
      { id: 551222, name: "Patole" },
      { id: 551146, name: "Patpimpri" },
      { id: 551232, name: "Pimpale" },
      { id: 551178, name: "Pimpalgaon" },
      { id: 551243, name: "Pimparwadi" },
      { id: 551226, name: "Ramnagar" },
      { id: 551184, name: "Rampur" },
      { id: 551167, name: "Sangavi" },
      { id: 551201, name: "Saradwadi" },
      { id: 551203, name: "Sawatamalinagar" },
      { id: 551249, name: "Sayale" },
      { id: 551182, name: "Shaha" },
      { id: 551157, name: "Shahapur" },
      { id: 551163, name: "Shastrinagar" },
      { id: 551210, name: "Shivade" },
      { id: 551224, name: "Shivajinagar" },
      { id: 551185, name: "Shrirampur" },
      { id: 944241, name: "Sinnar 1" },
      { id: 944242, name: "Sinnar 2" },
      { id: 944244, name: "Sinnar 3" },
      { id: 944867, name: "Sinnar 4" },
      { id: 551166, name: "Somthane" },
      { id: 551209, name: "Sonambe" },
      { id: 551208, name: "Sonari" },
      { id: 551237, name: "Sonewadi" },
      { id: 551142, name: "Songiri" },
      { id: 551261, name: "Suregaon" },
      { id: 551235, name: "Thangaon" },
      { id: 551179, name: "Ujjani" },
      { id: 551172, name: "Vadangali" },
      { id: 551197, name: "Vadgaon Pingala" },
      { id: 551198, name: "Vinchur Dalvi" },
      { id: 551164, name: "Wadgaon Sinnar" },
      { id: 551152, name: "Wadzire" },
      { id: 551248, name: "Waregaon" },
      { id: 551252, name: "Wavi" },
    ],
    4155: [
      { id: 551290, name: "Ahergaon" },
      { id: 551287, name: "Antarweli" },
      { id: 551395, name: "Aurangpur" },
      { id: 551302, name: "Banganganagar" },
      { id: 551293, name: "Behed" },
      { id: 551347, name: "Bharwas" },
      { id: 551391, name: "Bhendali" },
      { id: 551394, name: "Bhuse" },
      { id: 551343, name: "Bokaddare" },
      { id: 551321, name: "Bramhangaon Vanas" },
      { id: 551333, name: "Bramhangaon Vinchur" },
      { id: 551403, name: "Bramhanwade" },
      { id: 551279, name: "Chandori" },
      { id: 551393, name: "Chapadgaon" },
      { id: 551385, name: "Chatori" },
      { id: 551282, name: "Chehedi Kh." },
      { id: 551281, name: "Chitegaon" },
      { id: 551345, name: "Dahegaon" },
      { id: 551286, name: "Darna Sangvi" },
      { id: 551276, name: "Datyane" },
      { id: 551311, name: "Davachwadi" },
      { id: 551359, name: "Deogaon" },
      { id: 551315, name: "Deopur" },
      { id: 551349, name: "Dhanore" },
      { id: 551351, name: "Dharangaon Khadak" },
      { id: 551350, name: "Dharangaon Veer" },
      { id: 551353, name: "Dindori" },
      { id: 551270, name: "Dixi" },
      { id: 551344, name: "Dongargaon" },
      { id: 551352, name: "Gajarwadi" },
      { id: 551341, name: "Golegaon" },
      { id: 551278, name: "Gondegaon" },
      { id: 551342, name: "Gondegav" },
      { id: 551304, name: "Gorthan" },
      { id: 551340, name: "Hanumannagar" },
      { id: 551373, name: "Jalgaon" },
      { id: 551271, name: "Jivhale" },
      { id: 551357, name: "Kalgaon" },
      { id: 551364, name: "Kanlad" },
      { id: 551392, name: "Karanjgaon" },
      { id: 551402, name: "Karanji Kh." },
      { id: 551295, name: "Karsul" },
      { id: 551273, name: "Kasabe Sukene" },
      { id: 551381, name: "Kathargaon" },
      { id: 551323, name: "Khadak Malegaon" },
      { id: 551326, name: "Khangaon Najik" },
      { id: 551399, name: "Khangaonthadi" },
      { id: 551356, name: "Khedalezunge" },
      { id: 551317, name: "Khede" },
      { id: 551298, name: "Kokangaon" },
      { id: 551325, name: "Kotamgaon" },
      { id: 551371, name: "Kothure" },
      { id: 551312, name: "Kumbhari" },
      { id: 944830, name: "Kundewadi" },
      { id: 551372, name: "Kurudgaon" },
      { id: 551285, name: "Lalpadi" },
      { id: 551405, name: "Lasalgaon" },
      { id: 551310, name: "Lonwadi" },
      { id: 551360, name: "Mahadevnagar" },
      { id: 551390, name: "Mahajanpur" },
      { id: 551398, name: "Majargaon" },
      { id: 551361, name: "Manori Kh." },
      { id: 551339, name: "Maralgoi Bk." },
      { id: 551337, name: "Maralgoi Kh." },
      { id: 551274, name: "Mauje Sukene" },
      { id: 551397, name: "Mhalsakore" },
      { id: 551288, name: "Mukhed" },
      { id: 551280, name: "Nagapur" },
      { id: 551378, name: "Naitale" },
      { id: 551348, name: "Nandgaon" },
      { id: 551306, name: "Nandur Kh." },
      { id: 551354, name: "Nandur Madhyameshwar" },
      { id: 551316, name: "Nandurdi" },
      { id: 551277, name: "Narayangaon" },
      { id: 551294, name: "Narayantembhi" },
      { id: 551332, name: "Nimgaon Wakada" },
      { id: 551368, name: "Niphad" },
      { id: 551275, name: "Oney" },
      { id: 551404, name: "Ozar Gaon" },
      { id: 909222, name: "Ozer Township" },
      { id: 551335, name: "Pachore Bk." },
      { id: 551338, name: "Pachore Kh." },
      { id: 551289, name: "Pachorewani" },
      { id: 551309, name: "Palkhed" },
      { id: 551314, name: "Panchkeshwar" },
      { id: 551370, name: "Pimpalas" },
      { id: 551291, name: "Pimpalgaon Baswant 1" },
      { id: 944238, name: "Pimpalgaon Baswant 3" },
      { id: 551406, name: "Pimpalgaon Najik" },
      { id: 551388, name: "Pimpalgaon Nipani" },
      { id: 944237, name: "Pimpalgaonbaswant 2" },
      { id: 551365, name: "Pimpri" },
      { id: 551387, name: "Ramnagar" },
      { id: 551377, name: "Rampur" },
      { id: 551313, name: "Ranwad" },
      { id: 551369, name: "Rasalpur" },
      { id: 551366, name: "Raulas" },
      { id: 551305, name: "Redgaon" },
      { id: 551358, name: "Rui" },
      { id: 551383, name: "Saikhede" },
      { id: 551299, name: "Sakore" },
      { id: 551320, name: "Sarole Kh." },
      { id: 551355, name: "Sarole Thadi" },
      { id: 551386, name: "Sawali" },
      { id: 551307, name: "Sawargaon" },
      { id: 551284, name: "Shimpi Takali" },
      { id: 551382, name: "Shingave" },
      { id: 551297, name: "Shirasgaon" },
      { id: 551363, name: "Shirwade Wakad" },
      { id: 551303, name: "Shirwadewani" },
      { id: 551319, name: "Shivadi" },
      { id: 551379, name: "Shivare" },
      { id: 551336, name: "Shiwapur" },
      { id: 551374, name: "Shriramnagar" },
      { id: 551396, name: "Shrirampur" },
      { id: 551376, name: "Sonewadi Bk." },
      { id: 551375, name: "Sonewadi Kh." },
      { id: 551384, name: "Songaon" },
      { id: 551329, name: "Subhash Nagar" },
      { id: 551380, name: "Sundarpur" },
      { id: 551324, name: "Takali Vinchur" },
      { id: 551389, name: "Talwade" },
      { id: 551401, name: "Tamaswadi" },
      { id: 551400, name: "Tarukhedle" },
      { id: 551272, name: "Thergaon" },
      { id: 551327, name: "Thetale" },
      { id: 551318, name: "Ugaon" },
      { id: 551292, name: "Umbarkhed" },
      { id: 551296, name: "Vadalinajik" },
      { id: 551322, name: "Vanasgaon" },
      { id: 551283, name: "Varhe Davna" },
      { id: 551331, name: "Vinchur" },
      { id: 551330, name: "Vishnunagar" },
      { id: 551328, name: "Vitthalwadi" },
      { id: 551346, name: "Wahegaon" },
      { id: 551362, name: "Wakad" },
      { id: 551308, name: "Wavi" },
      { id: 551334, name: "Welapur" },
    ],
    4156: [
      { id: 551499, name: "Adgaon Chothava" },
      { id: 551417, name: "Adgaon Repal" },
      { id: 551520, name: "Adsuregaon" },
      { id: 551505, name: "Agulgaon" },
      { id: 551442, name: "Aherwadi" },
      { id: 551407, name: "Ambegaon" },
      { id: 551516, name: "Andarsul" },
      { id: 551483, name: "Angangaon" },
      { id: 551438, name: "Ankai" },
      { id: 551450, name: "Ankute" },
      { id: 551477, name: "Antarveli" },
      { id: 551481, name: "Babhulgaon Bk." },
      { id: 551482, name: "Babhulgaon Kh." },
      { id: 551496, name: "Badapur" },
      { id: 551414, name: "Balapur" },
      { id: 551467, name: "Balhegaon" },
      { id: 551439, name: "Basantnagar" },
      { id: 551509, name: "Bharam" },
      { id: 551479, name: "Bhatgaon" },
      { id: 551522, name: "Bhaykhede" },
      { id: 551489, name: "Bhingare" },
      { id: 551521, name: "Bhulegaon" },
      { id: 551526, name: "Bokate" },
      { id: 551440, name: "Chandgaon" },
      { id: 551493, name: "Chichodi Bk." },
      { id: 551494, name: "Chichodi Kh." },
      { id: 551486, name: "Dahegaon Dhul" },
      { id: 551421, name: "Dahegaon Patoda" },
      { id: 551525, name: "Deolane" },
      { id: 551523, name: "Deothan" },
      { id: 551429, name: "Deshmane Bk." },
      { id: 551430, name: "Deshmane Kh." },
      { id: 551474, name: "Devargaon" },
      { id: 551501, name: "Devdari" },
      { id: 551515, name: "Dhamangaon" },
      { id: 551458, name: "Dhamode" },
      { id: 551470, name: "Dhanakwadi" },
      { id: 551480, name: "Dhanore" },
      { id: 551478, name: "Dhulgaon" },
      { id: 551511, name: "Dongarogaon" },
      { id: 551528, name: "Dugalgaon" },
      { id: 551487, name: "Erandgaon Bk." },
      { id: 551485, name: "Erandgaon Kh." },
      { id: 551460, name: "Ganeshpur" },
      { id: 551514, name: "Garkhede" },
      { id: 551517, name: "Gondgaon" },
      { id: 551476, name: "Gopalwadi" },
      { id: 551413, name: "Gorakhnagar" },
      { id: 551415, name: "Gujarkhede" },
      { id: 551452, name: "Hadap Sawargaon" },
      { id: 551432, name: "Jalgaon Neur" },
      { id: 551428, name: "Jaulke" },
      { id: 551447, name: "Jaydare" },
      { id: 551423, name: "Kanadi" },
      { id: 551471, name: "Kasarkhede" },
      { id: 551411, name: "Katarni" },
      { id: 551513, name: "Kautkhede" },
      { id: 551473, name: "Khairgavhan" },
      { id: 551529, name: "Khamgaon" },
      { id: 551502, name: "Kharvandi" },
      { id: 551454, name: "Khirdisathe" },
      { id: 551508, name: "Kolam Bk." },
      { id: 551504, name: "Kolam Kh." },
      { id: 551456, name: "Kolgaon" },
      { id: 551498, name: "Kotamgaon Bk." },
      { id: 551497, name: "Kotamgaon Kh." },
      { id: 551451, name: "Kusmadi" },
      { id: 551448, name: "Kusur" },
      { id: 551453, name: "Lahit" },
      { id: 551418, name: "Lauki Shiras" },
      { id: 551491, name: "Mahalkhede Chandvad" },
      { id: 551490, name: "Mahalkhede Pa" },
      { id: 551455, name: "Mamdapur" },
      { id: 551431, name: "Manori Bk." },
      { id: 551465, name: "Matulthan" },
      { id: 551436, name: "Mukhed" },
      { id: 551410, name: "Murami" },
      { id: 551457, name: "Nagarsul" },
      { id: 551468, name: "Nagde" },
      { id: 551500, name: "Nandesar" },
      { id: 551459, name: "Nandur" },
      { id: 551441, name: "Naygavhan" },
      { id: 551435, name: "Neurgaon" },
      { id: 551409, name: "Nilkhede" },
      { id: 551492, name: "Nimgaon Madh" },
      { id: 551464, name: "Nyaharkhede Bk." },
      { id: 551463, name: "Nyaharkhede Kh." },
      { id: 551445, name: "Panhalsathe" },
      { id: 551507, name: "Panjarwadi" },
      { id: 551495, name: "Paregaon" },
      { id: 551422, name: "Patoda" },
      { id: 551530, name: "Pimpalgaon Jalal" },
      { id: 551427, name: "Pimpalgaon Lep" },
      { id: 551518, name: "Pimpalkhute Bk." },
      { id: 551519, name: "Pimpalkhute Kh." },
      { id: 551446, name: "Pimpalkhute Tisare" },
      { id: 551425, name: "Pimpri" },
      { id: 551434, name: "Purangaon" },
      { id: 551503, name: "Rahadi" },
      { id: 551444, name: "Rajapur" },
      { id: 551484, name: "Rayate" },
      { id: 551462, name: "Rendale" },
      { id: 551506, name: "Saigaon" },
      { id: 551488, name: "Satali" },
      { id: 551426, name: "Satare" },
      { id: 551437, name: "Satyagaon" },
      { id: 551475, name: "Savargaon" },
      { id: 551449, name: "Savkhede" },
      { id: 551433, name: "Shevage" },
      { id: 551420, name: "Shirasgaon Lauki" },
      { id: 551408, name: "Somthan Desh" },
      { id: 551443, name: "Somthan Josh" },
      { id: 551524, name: "Suregaon Rasta" },
      { id: 551512, name: "Talwade" },
      { id: 551472, name: "Tandulwadi" },
      { id: 551424, name: "Thangaon" },
      { id: 551527, name: "Undirwadi" },
      { id: 551466, name: "Vadgaon Balhe" },
      { id: 551510, name: "Vaghale" },
      { id: 551461, name: "Vaibothi" },
      { id: 551419, name: "Valadgaon" },
      { id: 551416, name: "Vikharni" },
      { id: 551412, name: "Visapur" },
      { id: 944143, name: "Yevla" },
    ],
    4157: [
      { id: 551532, name: "Achchhad" },
      { id: 551540, name: "Amagaon" },
      { id: 551537, name: "Ambeshetgaon" },
      { id: 551549, name: "Anvir" },
      { id: 551565, name: "Awarpada" },
      { id: 551557, name: "Borigaon" },
      { id: 551535, name: "Bormal" },
      { id: 551559, name: "Bramhangaon" },
      { id: 551544, name: "Dolharpada" },
      { id: 551541, name: "Dongari" },
      { id: 551551, name: "Ebhadpada" },
      { id: 551573, name: "Gandhinagar" },
      { id: 551542, name: "Ghimaniya" },
      { id: 551543, name: "Girgaon" },
      { id: 551533, name: "Kajali" },
      { id: 551562, name: "Karajgaon" },
      { id: 551568, name: "Kawada" },
      { id: 551545, name: "Kharadpada" },
      { id: 551538, name: "Kochai" },
      { id: 551574, name: "Kodad" },
      { id: 551572, name: "Kurze" },
      { id: 551563, name: "Manpada" },
      { id: 551536, name: "Masangaon" },
      { id: 551561, name: "Patilpada (Karajgaon)" },
      { id: 551553, name: "Patilpada (Talasari)" },
      { id: 551576, name: "Sagarshet" },
      { id: 551531, name: "Sambha" },
      { id: 551569, name: "Sawane" },
      { id: 551548, name: "Sawroli" },
      { id: 551552, name: "Sutarpada" },
      { id: 551550, name: "Sutrakar" },
      { id: 551566, name: "Talasari" },
      { id: 551567, name: "Thakarpada (Talasari)" },
      { id: 551575, name: "Udhawa" },
      { id: 551534, name: "Upalat" },
      { id: 551570, name: "Vadavali" },
      { id: 551547, name: "Varvada" },
      { id: 551564, name: "Vasa" },
      { id: 551555, name: "Vevaji" },
      { id: 551546, name: "Vilatgaon" },
      { id: 551558, name: "Zai" },
      { id: 551554, name: "Zari" },
    ],
    4158: [
      { id: 945070, name: "Agar Ambemora" },
      { id: 551613, name: "Agwan" },
      { id: 551735, name: "Aine" },
      { id: 551633, name: "Alkapur" },
      { id: 551594, name: "Ambesari" },
      { id: 551588, name: "Ambewadi" },
      { id: 551702, name: "Ambiste" },
      { id: 551721, name: "Ambistewadi" },
      { id: 551706, name: "Ambivali" },
      { id: 909231, name: "Amboli" },
      { id: 551732, name: "Asangaon" },
      { id: 551731, name: "Asangaon Bk" },
      { id: 551607, name: "Asave" },
      { id: 551608, name: "Ashagad" },
      { id: 551657, name: "Ashte" },
      { id: 551580, name: "Aswali" },
      { id: 551683, name: "Awadhani" },
      { id: 551719, name: "Badapokhran" },
      { id: 551643, name: "Bahare" },
      { id: 943964, name: "Bandhan Pada" },
      { id: 551662, name: "Bandhghar" },
      { id: 551666, name: "Bapugaon" },
      { id: 551730, name: "Bavade" },
      { id: 551625, name: "Bendgaon" },
      { id: 551708, name: "Bharad" },
      { id: 551744, name: "Bhavadi" },
      { id: 551697, name: "Bhisenagar" },
      { id: 551647, name: "Bodgaon" },
      { id: 551577, name: "Bordi" },
      { id: 551642, name: "Bramhanwadi" },
      { id: 551660, name: "Chalani" },
      { id: 551720, name: "Chandigaon" },
      { id: 551743, name: "Chandranagar" },
      { id: 551686, name: "Chandwad" },
      { id: 551612, name: "Chari Tarfe Kotabi" },
      { id: 551668, name: "Chari Tarfe Pavan" },
      { id: 551692, name: "Charoti" },
      { id: 551585, name: "Chikhale" },
      { id: 551587, name: "Chimbave" },
      { id: 551652, name: "Chinchale" },
      { id: 551750, name: "Chinchani" },
      { id: 551631, name: "Dabhadi" },
      { id: 551737, name: "Dabhale" },
      { id: 551701, name: "Dabhon" },
      { id: 943956, name: "Dahanu" },
      { id: 551674, name: "Dahigaon" },
      { id: 551679, name: "Dahyale" },
      { id: 551621, name: "Dapchari" },
      { id: 551729, name: "Dedale" },
      { id: 551617, name: "Dehane" },
      { id: 551675, name: "Deur" },
      { id: 551671, name: "Devgaon" },
      { id: 551714, name: "Dhakti Dahanu" },
      { id: 551618, name: "Dhamangaon" },
      { id: 551712, name: "Dhamatane" },
      { id: 551676, name: "Dhaniwari" },
      { id: 551669, name: "Dharampur" },
      { id: 551716, name: "Dhumket" },
      { id: 551640, name: "Dhundalwadi" },
      { id: 551630, name: "Divshi" },
      { id: 551629, name: "Gadchinchale" },
      { id: 551673, name: "Ganeshbag" },
      { id: 551646, name: "Gangangaon" },
      { id: 551661, name: "Gangodi" },
      { id: 551685, name: "Ganjad" },
      { id: 551644, name: "Ghadane" },
      { id: 551709, name: "Ghol" },
      { id: 551583, name: "Gholwad" },
      { id: 551606, name: "Gorwadi" },
      { id: 551736, name: "Govane" },
      { id: 551718, name: "Gungwada" },
      { id: 551639, name: "Haladpada" },
      { id: 551578, name: "Jalwai" },
      { id: 551579, name: "Jambugaon" },
      { id: 551609, name: "Jamshet" },
      { id: 551645, name: "Jitgaon" },
      { id: 551602, name: "Junnarpada" },
      { id: 551593, name: "Kainad" },
      { id: 551626, name: "Kalamdevi" },
      { id: 551678, name: "Kandarwadi" },
      { id: 551600, name: "Kankradi" },
      { id: 551733, name: "Kapshi" },
      { id: 551655, name: "Karanjvira" },
      { id: 551696, name: "Kasa" },
      { id: 551598, name: "Kasara" },
      { id: 551738, name: "Khambale" },
      { id: 551680, name: "Khaniv" },
      { id: 551623, name: "Khubale" },
      { id: 551581, name: "Khunavade" },
      { id: 551632, name: "Kinhvali" },
      { id: 551740, name: "Kolavali" },
      { id: 551711, name: "Kolhan" },
      { id: 551619, name: "Komgaon" },
      { id: 551596, name: "Kosbad" },
      { id: 551745, name: "Kosesari" },
      { id: 551616, name: "Kotabi" },
      { id: 551599, name: "Lashkari" },
      { id: 943970, name: "Lonipada" },
      { id: 943965, name: "Malyan" },
      { id: 943968, name: "Manfod Pada" },
      { id: 551670, name: "Manipur" },
      { id: 943966, name: "Masoli" },
      { id: 551725, name: "Matgaon" },
      { id: 551705, name: "Mhasad" },
      { id: 551638, name: "Modgaon" },
      { id: 551614, name: "Motapada" },
      { id: 551747, name: "Murbad" },
      { id: 551648, name: "Nagzari" },
      { id: 551597, name: "Nandare" },
      { id: 551586, name: "Naraliwadi" },
      { id: 551658, name: "Naroli" },
      { id: 551589, name: "Narpad" },
      { id: 551684, name: "Navnath" },
      { id: 551699, name: "Nikane" },
      { id: 551707, name: "Nikavali" },
      { id: 551663, name: "Nimbapur" },
      { id: 551677, name: "Osarvira" },
      { id: 551727, name: "Osarwadi" },
      { id: 551615, name: "Pale" },
      { id: 551654, name: "Pandhartara" },
      { id: 551604, name: "Paraswadi" },
      { id: 551641, name: "Pardi" },
      { id: 551603, name: "Patilpada" },
      { id: 551628, name: "Patilpada (Saiwan)" },
      { id: 551667, name: "Pavan" },
      { id: 551713, name: "Peth" },
      { id: 551664, name: "Phanaswadi" },
      { id: 551749, name: "Pimpalshet Bk." },
      { id: 551689, name: "Pimpalshet Kh." },
      { id: 551717, name: "Pokharan" },
      { id: 551650, name: "Punjave" },
      { id: 551601, name: "Rai" },
      { id: 551637, name: "Raipur" },
      { id: 551687, name: "Raitali" },
      { id: 551636, name: "Rampur" },
      { id: 551582, name: "Rampur (Bordi)" },
      { id: 551700, name: "Rankol" },
      { id: 551691, name: "Ranshet" },
      { id: 551659, name: "Saiwan" },
      { id: 551734, name: "Sakhare" },
      { id: 551698, name: "Sarani" },
      { id: 551610, name: "Saravali" },
      { id: 551651, name: "Sasvand" },
      { id: 551611, name: "Savata" },
      { id: 551703, name: "Saye" },
      { id: 551688, name: "Shelti" },
      { id: 551665, name: "Shensari" },
      { id: 551627, name: "Shilonda" },
      { id: 551656, name: "Shisane" },
      { id: 551595, name: "Sogave" },
      { id: 551672, name: "Somnath" },
      { id: 551681, name: "Sonale" },
      { id: 551634, name: "Sukhadamba" },
      { id: 551694, name: "Suryanagar" },
      { id: 551715, name: "Tadiyale" },
      { id: 551649, name: "Talothe" },
      { id: 551728, name: "Tanashi" },
      { id: 551710, name: "Tawa" },
      { id: 551590, name: "Thakurwadi" },
      { id: 945069, name: "Torani" },
      { id: 551624, name: "Tornipada" },
      { id: 551704, name: "Urse" },
      { id: 551726, name: "Vadade" },
      { id: 551690, name: "Vadhane" },
      { id: 551722, name: "Vadhvan" },
      { id: 943972, name: "Vadkun" },
      { id: 551742, name: "Vanai" },
      { id: 551739, name: "Vangaon" },
      { id: 551748, name: "Vangarje" },
      { id: 551620, name: "Vankas" },
      { id: 551622, name: "Varkhande" },
      { id: 551723, name: "Varor" },
      { id: 551695, name: "Varoti" },
      { id: 551605, name: "Vasantwadi" },
      { id: 551724, name: "Vasgaon" },
      { id: 551746, name: "Veti" },
      { id: 551584, name: "Vikasnagar" },
      { id: 551741, name: "Vire" },
      { id: 551682, name: "Vivalvedhe" },
      { id: 551635, name: "Vyahali" },
      { id: 551693, name: "Waghadi" },
      { id: 551591, name: "Waki" },
      { id: 551592, name: "Zarali" },
    ],
    4159: [
      { id: 551822, name: "Alonda" },
      { id: 551767, name: "Ambeghar Tarfe Balapur" },
      { id: 551753, name: "Ambeghar Tarfe Dharampur" },
      { id: 551831, name: "Ambivali" },
      { id: 551774, name: "Anantpur" },
      { id: 551798, name: "Andheri" },
      { id: 551784, name: "Apti Bk." },
      { id: 551842, name: "Apti Kh." },
      { id: 551768, name: "Balapur" },
      { id: 551807, name: "Bandhan" },
      { id: 551813, name: "Bangarchole" },
      { id: 551837, name: "Baste" },
      { id: 551836, name: "Bhanapur" },
      { id: 551810, name: "Bhopoli" },
      { id: 551812, name: "Boranda" },
      { id: 551776, name: "Chandranagar" },
      { id: 551763, name: "Charanwadi" },
      { id: 551783, name: "Chari Bk." },
      { id: 551809, name: "Chinchghar" },
      { id: 551772, name: "Dadade" },
      { id: 551805, name: "Deharje" },
      { id: 551773, name: "Devapur" },
      { id: 551754, name: "Dhamani" },
      { id: 551775, name: "Dolhari Bk." },
      { id: 551787, name: "Dolhari Kh." },
      { id: 551789, name: "Gadade" },
      { id: 551782, name: "Ghanede" },
      { id: 551811, name: "Ghaneghar" },
      { id: 551796, name: "Hanumannagar" },
      { id: 551815, name: "Hatane" },
      { id: 551833, name: "Indgaon" },
      { id: 551794, name: "Jambha" },
      { id: 551761, name: "Karhe" },
      { id: 551781, name: "Karsud" },
      { id: 551755, name: "Kasa Bk" },
      { id: 551843, name: "Kashivali" },
      { id: 551752, name: "Kawadas" },
      { id: 551840, name: "Kawale" },
      { id: 551771, name: "Kegawa" },
      { id: 551829, name: "Kev" },
      { id: 551758, name: "Khadaki" },
      { id: 551802, name: "Khand" },
      { id: 551808, name: "Khandeghar" },
      { id: 551821, name: "Khoste" },
      { id: 551795, name: "Khuded" },
      { id: 551778, name: "Kondgaon" },
      { id: 551759, name: "Kunj" },
      { id: 551825, name: "Kurnze" },
      { id: 551762, name: "Madachapada" },
      { id: 551841, name: "Male" },
      { id: 551820, name: "Malwada" },
      { id: 551804, name: "Man" },
      { id: 551769, name: "Medhi" },
      { id: 551826, name: "Mhasaroli" },
      { id: 551824, name: "Moh Bk." },
      { id: 551823, name: "Moh Kh." },
      { id: 551790, name: "Nagzari" },
      { id: 551828, name: "Nalshet" },
      { id: 551803, name: "Onde" },
      { id: 551800, name: "Pochade" },
      { id: 551839, name: "Potkhal" },
      { id: 551819, name: "Rampur" },
      { id: 551818, name: "Sajan" },
      { id: 551797, name: "Sakhare" },
      { id: 551792, name: "Sangamnagar" },
      { id: 551756, name: "Sarshi" },
      { id: 551786, name: "Satkor" },
      { id: 551788, name: "Savade" },
      { id: 551832, name: "Savaroli" },
      { id: 551770, name: "Sawarai" },
      { id: 551838, name: "Shelpada" },
      { id: 551766, name: "Shevate" },
      { id: 551816, name: "Shil (Alonda Najik)" },
      { id: 551814, name: "Shil (Najik Bhopoli)" },
      { id: 551827, name: "Shilshet" },
      { id: 551793, name: "Suksale" },
      { id: 551760, name: "Talavali Tarf Dengachimet" },
      { id: 551779, name: "Talavali Tarf Satkor" },
      { id: 551757, name: "Talwada" },
      { id: 551799, name: "Tembholi" },
      { id: 551806, name: "Tetawali" },
      { id: 551751, name: "Theronda" },
      { id: 551785, name: "Uparale" },
      { id: 551835, name: "Utavali" },
      { id: 551830, name: "Vadapoli" },
      { id: 945134, name: "Varanwadi" },
      { id: 551834, name: "Vasuri" },
      { id: 551780, name: "Vedhe" },
      { id: 551844, name: "Vikramgad" },
      { id: 551777, name: "Vilshet" },
      { id: 551764, name: "Vitthalnagar" },
      { id: 551801, name: "Waki" },
      { id: 551765, name: "Wehelpada" },
      { id: 551791, name: "Yashwantnagar" },
      { id: 551817, name: "Zadapoli" },
    ],
    4160: [
      { id: 551907, name: "Aadkhadak" },
      { id: 551893, name: "Aakare" },
      { id: 551889, name: "Aalemet" },
      { id: 551927, name: "Aaptale" },
      { id: 551894, name: "Aayare" },
      { id: 551951, name: "Aine" },
      { id: 551938, name: "Akhar" },
      { id: 551892, name: "Anantanagar" },
      { id: 551854, name: "Barwadpada" },
      { id: 551848, name: "Behedpada" },
      { id: 551871, name: "Bhagada" },
      { id: 551905, name: "Bharasatmet" },
      { id: 551953, name: "Bhuritek" },
      { id: 551846, name: "Bopdari" },
      { id: 551900, name: "Borale" },
      { id: 551874, name: "Chambharshet" },
      { id: 551891, name: "Chandragaon" },
      { id: 551898, name: "Chandranagar" },
      { id: 551928, name: "Chandrapur" },
      { id: 551948, name: "Chauk" },
      { id: 551852, name: "Dabhalon" },
      { id: 551850, name: "Dabheri" },
      { id: 551880, name: "Dabhose" },
      { id: 551864, name: "Dadarkopara" },
      { id: 551849, name: "Dahul" },
      { id: 551869, name: "Daskod" },
      { id: 551878, name: "Dehare" },
      { id: 551911, name: "Dengachi Met" },
      { id: 551877, name: "Devgaon" },
      { id: 551860, name: "Dhadhari" },
      { id: 551930, name: "Dhanoshi" },
      { id: 551903, name: "Dharampur" },
      { id: 551946, name: "Dongarwadi" },
      { id: 551918, name: "Ganeshnagar" },
      { id: 551929, name: "Gangapur" },
      { id: 551916, name: "Garadwadi" },
      { id: 551886, name: "Ghivanda" },
      { id: 551896, name: "Gorthan" },
      { id: 551908, name: "Hade" },
      { id: 551885, name: "Hateri" },
      { id: 551882, name: "Hiradpada" },
      { id: 551861, name: "Jambhulmatha" },
      { id: 551897, name: "Jamsar" },
      { id: 551917, name: "Jawhar" },
      { id: 551914, name: "Jayeshwar" },
      { id: 551931, name: "Junijawhar" },
      { id: 551936, name: "Kadachimet" },
      { id: 551912, name: "Kalamvira" },
      { id: 551901, name: "Kanadhatti" },
      { id: 551909, name: "Kardhan" },
      { id: 551913, name: "Kasatwadi" },
      { id: 551932, name: "Kashivali" },
      { id: 551939, name: "Kaulale" },
      { id: 551851, name: "Kayari" },
      { id: 551924, name: "Kelghar" },
      { id: 551904, name: "Khadkhad" },
      { id: 551858, name: "Khambala" },
      { id: 551872, name: "Kharonda" },
      { id: 551950, name: "Khidse" },
      { id: 551853, name: "Kirmira" },
      { id: 551890, name: "Kogada" },
      { id: 551868, name: "Kortad" },
      { id: 551906, name: "Kuturvihir" },
      { id: 551863, name: "Malghar" },
      { id: 551952, name: "Manmohadi" },
      { id: 551856, name: "Medha" },
      { id: 551949, name: "Medhe" },
      { id: 551870, name: "Morchachapada" },
      { id: 551942, name: "Nandgaon" },
      { id: 551919, name: "Nandnmal" },
      { id: 551921, name: "Nyahale Bk." },
      { id: 551925, name: "Nyahale Kh" },
      { id: 551855, name: "Ozar" },
      { id: 551876, name: "Palshin" },
      { id: 551947, name: "Pathardi" },
      { id: 551902, name: "Pimpalgaon" },
      { id: 551875, name: "Pimpalshet" },
      { id: 551879, name: "Pimpurna" },
      { id: 551888, name: "Poyshet" },
      { id: 551922, name: "Radhanagari" },
      { id: 551943, name: "Rajewadi" },
      { id: 551915, name: "Ramnagar (Kasatwadi)" },
      { id: 551867, name: "Ramnagar (Savarpada)" },
      { id: 551920, name: "Raytale" },
      { id: 551845, name: "Ruighar" },
      { id: 551859, name: "Sakharshet" },
      { id: 551937, name: "Sakur" },
      { id: 551883, name: "Sarsun" },
      { id: 551866, name: "Savarpada" },
      { id: 551940, name: "Shirasgaon" },
      { id: 551933, name: "Shiroshi" },
      { id: 551895, name: "Shivajinagar (Gorthan)" },
      { id: 551945, name: "Shivajinagar (Zap)" },
      { id: 551926, name: "Shrirampur" },
      { id: 551941, name: "Shrirampur (Kaulale)" },
      { id: 551923, name: "Shrirampur (Nyahale Bk)" },
      { id: 551899, name: "Suryanagar" },
      { id: 551884, name: "Suryanagar (Sarsun)" },
      { id: 551857, name: "Talasari" },
      { id: 551873, name: "Tilonda" },
      { id: 551910, name: "Tuljapur" },
      { id: 551865, name: "Umbarkheda" },
      { id: 551862, name: "Vangani" },
      { id: 551847, name: "Vavar" },
      { id: 551934, name: "Vijaynagar" },
      { id: 551881, name: "Wadoli" },
      { id: 551935, name: "Walwande" },
      { id: 551887, name: "Winwal" },
      { id: 551944, name: "Zap" },
    ],
    4161: [
      { id: 551990, name: "Adoshi" },
      { id: 552004, name: "Amale" },
      { id: 551955, name: "Ase" },
      { id: 551965, name: "Beriste" },
      { id: 551992, name: "Botoshi" },
      { id: 551958, name: "Bramhangaon" },
      { id: 551975, name: "Charangaon" },
      { id: 551966, name: "Chas" },
      { id: 551962, name: "Dandwal" },
      { id: 551954, name: "Dhamani" },
      { id: 551986, name: "Dhamanshet" },
      { id: 551979, name: "Dhondmaryachimet" },
      { id: 551987, name: "Dolhare" },
      { id: 551996, name: "Dudhgaon" },
      { id: 551961, name: "Ghanval" },
      { id: 551967, name: "Ghosali" },
      { id: 551997, name: "Gomghar" },
      { id: 551974, name: "Gonde Bk." },
      { id: 551971, name: "Gonde Kh." },
      { id: 551964, name: "Hirve" },
      { id: 551999, name: "Jogalwadi" },
      { id: 552009, name: "Kaduchiwadi" },
      { id: 551960, name: "Kalamgaon" },
      { id: 552010, name: "Karegaon" },
      { id: 552012, name: "Karol" },
      { id: 552006, name: "Kashti" },
      { id: 551994, name: "Kevanale" },
      { id: 551977, name: "Khoch" },
      { id: 551998, name: "Khodala" },
      { id: 552007, name: "Kiniste" },
      { id: 552008, name: "Kochale" },
      { id: 551985, name: "Koshimshet" },
      { id: 551993, name: "Kurlod" },
      { id: 551973, name: "Laxminagar" },
      { id: 551969, name: "Mokhada" },
      { id: 551968, name: "Morhanda" },
      { id: 551988, name: "Nashera" },
      { id: 551963, name: "Nilmati" },
      { id: 551959, name: "Osarvira" },
      { id: 552011, name: "Pachghar" },
      { id: 551980, name: "Palsunda" },
      { id: 551991, name: "Pathardi" },
      { id: 551983, name: "Pimpalgaon" },
      { id: 551972, name: "Poshera" },
      { id: 551970, name: "Rajivnagar" },
      { id: 551976, name: "Sakhari" },
      { id: 551981, name: "Saturly" },
      { id: 552005, name: "Sawarde" },
      { id: 552000, name: "Sayade" },
      { id: 551957, name: "Shastrinagar" },
      { id: 551989, name: "Shirasgaon" },
      { id: 551978, name: "Shirson" },
      { id: 551984, name: "Shivali" },
      { id: 551995, name: "Suryamal" },
      { id: 551956, name: "Swaminagar" },
      { id: 552002, name: "Udhale" },
      { id: 552003, name: "Vashind" },
      { id: 552001, name: "Wakadpada" },
      { id: 551982, name: "Washala" },
    ],
    4162: [
      { id: 552039, name: "Aapati (Tarfe Kohoj)" },
      { id: 552160, name: "Abitghar" },
      { id: 552047, name: "Abje" },
      { id: 552073, name: "Ainshet" },
      { id: 552118, name: "Akhada" },
      { id: 552079, name: "Alman" },
      { id: 552094, name: "Ambarbhui" },
      { id: 552015, name: "Ambhai" },
      { id: 552046, name: "Ambiste Bk." },
      { id: 552045, name: "Ambiste Kh." },
      { id: 552014, name: "Amgaon" },
      { id: 552053, name: "Asnas" },
      { id: 552042, name: "Avandhe" },
      { id: 552145, name: "Balivali" },
      { id: 552169, name: "Bavali" },
      { id: 552174, name: "Bersheti" },
      { id: 552049, name: "Bhavehar" },
      { id: 552035, name: "Bhopivali" },
      { id: 552089, name: "Bilavali" },
      { id: 552155, name: "Bilghar" },
      { id: 552056, name: "Biloshi" },
      { id: 552044, name: "Borande" },
      { id: 552018, name: "Bramhangaon" },
      { id: 552090, name: "Budhavali" },
      { id: 552111, name: "Chambale" },
      { id: 552179, name: "Chendavali" },
      { id: 552167, name: "Chikhale" },
      { id: 552086, name: "Chinchghar" },
      { id: 552112, name: "Dabhon" },
      { id: 552133, name: "Dahe" },
      { id: 552132, name: "Dahivali Kumbhiste" },
      { id: 552110, name: "Dakivali" },
      { id: 552065, name: "Desai" },
      { id: 552034, name: "Devali Tarf Kohaj" },
      { id: 552130, name: "Devali Tarfe Wada" },
      { id: 552171, name: "Devgaon" },
      { id: 552055, name: "Devghar" },
      { id: 552140, name: "Dhadhare" },
      { id: 552143, name: "Dhapad" },
      { id: 552088, name: "Dongaste" },
      { id: 552066, name: "Gale" },
      { id: 552030, name: "Galtare" },
      { id: 552074, name: "Gandhare" },
      { id: 552122, name: "Gargaon" },
      { id: 552165, name: "Gates Bk." },
      { id: 552166, name: "Gates Kh." },
      { id: 552051, name: "Gaurapur" },
      { id: 552109, name: "Ghonsai" },
      { id: 552168, name: "Goleghar" },
      { id: 552096, name: "Gorad" },
      { id: 552040, name: "Gorhe" },
      { id: 552028, name: "Guhir" },
      { id: 552091, name: "Gunj" },
      { id: 552026, name: "Hamarapur" },
      { id: 552064, name: "Harosale" },
      { id: 552176, name: "Jale" },
      { id: 552082, name: "Jamghar" },
      { id: 552063, name: "Kadivali" },
      { id: 552054, name: "Kalambhai" },
      { id: 552152, name: "Kalambhe" },
      { id: 552144, name: "Kalambholi" },
      { id: 552020, name: "Kalamkhand" },
      { id: 552159, name: "Kambare" },
      { id: 552024, name: "Kanchad" },
      { id: 552149, name: "Kapari" },
      { id: 552062, name: "Karanje" },
      { id: 552027, name: "Karanjpada" },
      { id: 552146, name: "Kasghar" },
      { id: 552092, name: "Kati" },
      { id: 552097, name: "Kelthan" },
      { id: 552177, name: "Khaire Ambivali" },
      { id: 552127, name: "Khaire Tarf Wada" },
      { id: 552050, name: "Khanivali" },
      { id: 552038, name: "Kharivali Tarf Kohoj" },
      { id: 552058, name: "Kharivali Tarf Poulbar" },
      { id: 552138, name: "Khodade" },
      { id: 552085, name: "Khupari" },
      { id: 552013, name: "Khutal" },
      { id: 552075, name: "Kiravali" },
      { id: 552141, name: "Kolim Sarovar" },
      { id: 552104, name: "Kondhale" },
      { id: 552163, name: "Kone" },
      { id: 552081, name: "Konsai" },
      { id: 552181, name: "Kudus" },
      { id: 552016, name: "Kumdal" },
      { id: 552029, name: "Kurle" },
      { id: 944346, name: "Kusavade" },
      { id: 552180, name: "Kuyalu" },
      { id: 552084, name: "Lakhamapur" },
      { id: 552098, name: "Lohape" },
      { id: 552164, name: "Malonda" },
      { id: 552134, name: "Mandava" },
      { id: 552022, name: "Mande" },
      { id: 552102, name: "Mangathane" },
      { id: 552114, name: "Mangrul" },
      { id: 552131, name: "Manivali" },
      { id: 552108, name: "Met" },
      { id: 552173, name: "Mhaswal" },
      { id: 552156, name: "Moj" },
      { id: 552033, name: "Munguste" },
      { id: 552099, name: "Musarne" },
      { id: 552093, name: "Nandani Gaigotha" },
      { id: 552031, name: "Nane" },
      { id: 552107, name: "Nare" },
      { id: 552083, name: "Neharoli" },
      { id: 552048, name: "Nichole" },
      { id: 552095, name: "Nimbavali" },
      { id: 552153, name: "Nishet" },
      { id: 552136, name: "Ogada" },
      { id: 552120, name: "Pachghar" },
      { id: 552059, name: "Pali" },
      { id: 552052, name: "Palsai" },
      { id: 552135, name: "Parali" },
      { id: 552125, name: "Paste" },
      { id: 552068, name: "Pethranjani" },
      { id: 552137, name: "Phanasgaon" },
      { id: 552124, name: "Pik" },
      { id: 552037, name: "Pimpalas" },
      { id: 552070, name: "Pimparoli" },
      { id: 552113, name: "Pinjal" },
      { id: 552021, name: "Posheri" },
      { id: 552017, name: "Raysalgaon" },
      { id: 552041, name: "Sange" },
      { id: 552061, name: "Sapane Bk." },
      { id: 552060, name: "Sapane Kh." },
      { id: 552101, name: "Saparonde" },
      { id: 552078, name: "Sarasohol" },
      { id: 552072, name: "Sarshi" },
      { id: 552126, name: "Sasane" },
      { id: 552119, name: "Satronde" },
      { id: 552161, name: "Savarkhand" },
      { id: 552142, name: "Shele" },
      { id: 552032, name: "Shelte" },
      { id: 552080, name: "Shil" },
      { id: 552123, name: "Shilottar" },
      { id: 552147, name: "Shirsad" },
      { id: 944345, name: "Shivneri" },
      { id: 552154, name: "Sonale Bk." },
      { id: 552151, name: "Sonale Kh." },
      { id: 552067, name: "Sonshiv" },
      { id: 552019, name: "Suponde" },
      { id: 552129, name: "Thunave" },
      { id: 552148, name: "Tilase" },
      { id: 552170, name: "Tilgaon" },
      { id: 552139, name: "Tilmal" },
      { id: 552178, name: "Torane" },
      { id: 552071, name: "Tuse" },
      { id: 552106, name: "Uchat" },
      { id: 552116, name: "Ujjaini" },
      { id: 552128, name: "Umrothe" },
      { id: 552103, name: "Usar" },
      { id: 552117, name: "Vadavali Tarf Gargaon" },
      { id: 552100, name: "Vadavali Tarf Poulbar" },
      { id: 552150, name: "Vadavali Tarf Sonale" },
      { id: 552025, name: "Vaghote" },
      { id: 552036, name: "Vaitarnanagar" },
      { id: 552157, name: "Varai Bk." },
      { id: 552158, name: "Varai Kh." },
      { id: 552076, name: "Varale" },
      { id: 552105, name: "Vardha" },
      { id: 552175, name: "Varnol" },
      { id: 552121, name: "Varsale" },
      { id: 552043, name: "Vasuri Bk" },
      { id: 552057, name: "Vasuri Kh." },
      { id: 552023, name: "Vaveghar" },
      { id: 552087, name: "Vijaygad" },
      { id: 552162, name: "Vijaypur" },
      { id: 552069, name: "Vilkos Tarf Konpati" },
      { id: 552077, name: "Vilkos Tarf Vada" },
      { id: 552115, name: "Virhe" },
      { id: 552182, name: "Wada" },
      { id: 552172, name: "Zadkhaire" },
    ],
    4163: [
      { id: 552342, name: "Aavdhani" },
      { id: 552288, name: "Agarwadi" },
      { id: 552209, name: "Agawan" },
      { id: 552225, name: "Akegavhan" },
      { id: 552193, name: "Akkarpatti" },
      { id: 552231, name: "Akoli" },
      { id: 552207, name: "Alewadi" },
      { id: 943973, name: "Alyali" },
      { id: 552257, name: "Ambadi" },
      { id: 552188, name: "Ambatpada" },
      { id: 552227, name: "Ambedhe" },
      { id: 552345, name: "Ambhan" },
      { id: 552287, name: "Ambodegaon" },
      { id: 552332, name: "Asheri" },
      { id: 552366, name: "Bahadoli" },
      { id: 552320, name: "Bandar" },
      { id: 552264, name: "Bandate" },
      { id: 552346, name: "Bandhan" },
      { id: 552228, name: "Barhanpur" },
      { id: 552244, name: "Betegaon" },
      { id: 552300, name: "Bhadave" },
      { id: 552251, name: "Birwadi" },
      { id: 552387, name: "Boisar" },
      { id: 552238, name: "Borsheti" },
      { id: 552370, name: "Bot" },
      { id: 552275, name: "Chahade" },
      { id: 552335, name: "Chari Khurd" },
      { id: 552299, name: "Chatale" },
      { id: 552337, name: "Chilhar" },
      { id: 552224, name: "Chinchare" },
      { id: 552371, name: "Dahisar Tarfe Manor" },
      { id: 552187, name: "Dahisar Tarfe Tarapur" },
      { id: 552315, name: "Dahiwale" },
      { id: 552340, name: "Damkhind" },
      { id: 552283, name: "Danda (Usarani)" },
      { id: 552199, name: "Dandi" },
      { id: 552389, name: "Dandi (Boisar)" },
      { id: 552213, name: "Dapoli" },
      { id: 552314, name: "Darshet" },
      { id: 552331, name: "Datiware" },
      { id: 552254, name: "Devkhope" },
      { id: 552253, name: "Dhansar" },
      { id: 552380, name: "Dhekale" },
      { id: 552364, name: "Dhuktan" },
      { id: 552312, name: "Dongare" },
      { id: 552355, name: "Durves" },
      { id: 552311, name: "Edwan" },
      { id: 552368, name: "Embur Airambi" },
      { id: 552384, name: "Ganje" },
      { id: 552223, name: "Gargaon" },
      { id: 552316, name: "Ghatim" },
      { id: 552183, name: "Ghivali" },
      { id: 945072, name: "Gholvira" },
      { id: 552383, name: "Girale" },
      { id: 552272, name: "Girnoli" },
      { id: 945073, name: "Gothanpur" },
      { id: 552362, name: "Gowade" },
      { id: 552206, name: "Gundale" },
      { id: 552241, name: "Gundavali" },
      { id: 552374, name: "Gundave" },
      { id: 552367, name: "Haloli" },
      { id: 552221, name: "Hanumannagar" },
      { id: 552260, name: "Haranwadi" },
      { id: 552323, name: "Jalsar" },
      { id: 552268, name: "Jalsarang" },
      { id: 552379, name: "Jansai" },
      { id: 552385, name: "Jayshet" },
      { id: 552249, name: "Kallale" },
      { id: 552259, name: "Kamare" },
      { id: 552243, name: "Kambalgaon" },
      { id: 552185, name: "Kambode" },
      { id: 552317, name: "Kandarwan" },
      { id: 552318, name: "Kandrebhure" },
      { id: 552289, name: "Kapase" },
      { id: 552353, name: "Karalgaon" },
      { id: 552294, name: "Kardal" },
      { id: 552306, name: "Karwale" },
      { id: 552348, name: "Katale" },
      { id: 552386, name: "Katkar" },
      { id: 552267, name: "Kelwa" },
      { id: 552266, name: "Kelwa Road" },
      { id: 552277, name: "Khadkoli" },
      { id: 552333, name: "Khadkona" },
      { id: 552390, name: "Khaira (Boisar)" },
      { id: 552378, name: "Khaire" },
      { id: 552365, name: "Khamloli" },
      { id: 552233, name: "Khanivade" },
      { id: 552322, name: "Khardi" },
      { id: 552214, name: "Kharekuran" },
      { id: 552330, name: "Kharmendri" },
      { id: 552359, name: "Kharshet" },
      { id: 552329, name: "Kharwadashri" },
      { id: 552282, name: "Khatali" },
      { id: 552235, name: "Khutad" },
      { id: 552339, name: "Khutal" },
      { id: 552240, name: "Kirat" },
      { id: 552274, name: "Kokner" },
      { id: 552204, name: "Kolawade" },
      { id: 552212, name: "Kolgaon" },
      { id: 552341, name: "Kondhan" },
      { id: 552321, name: "Kore" },
      { id: 552343, name: "Kosbad" },
      { id: 552186, name: "Kudan" },
      { id: 552369, name: "Kude" },
      { id: 552237, name: "Kukade" },
      { id: 552205, name: "Kumbhavali" },
      { id: 552198, name: "Kurgaon" },
      { id: 552239, name: "Lalonde" },
      { id: 552271, name: "Lalthane" },
      { id: 945071, name: "Lokmanya Nagar" },
      { id: 552347, name: "Loware" },
      { id: 552285, name: "Madhukarnagar" },
      { id: 552242, name: "Mahagaon" },
      { id: 552262, name: "Mahim" },
      { id: 552295, name: "Makane" },
      { id: 552280, name: "Makunsar" },
      { id: 552245, name: "Man" },
      { id: 552310, name: "Mande" },
      { id: 552304, name: "Manjurli" },
      { id: 552392, name: "Manor" },
      { id: 552361, name: "Maswan" },
      { id: 552301, name: "Mathane" },
      { id: 552230, name: "Mendhwan" },
      { id: 552319, name: "Mithagar" },
      { id: 552217, name: "Morekuran" },
      { id: 552189, name: "Mundwali" },
      { id: 552215, name: "Murbe" },
      { id: 552269, name: "Mykhop" },
      { id: 552298, name: "Nagave" },
      { id: 552382, name: "Nagave Tarfe Manor" },
      { id: 552297, name: "Nagavepada" },
      { id: 552247, name: "Nagzari" },
      { id: 552344, name: "Nandgaon Tarfe Manor" },
      { id: 552208, name: "Nandgaon Tarfe Tarapur" },
      { id: 552255, name: "Nandore" },
      { id: 552226, name: "Nanivali" },
      { id: 943975, name: "Navali" },
      { id: 552373, name: "Navaze" },
      { id: 552327, name: "Navghar" },
      { id: 945080, name: "Navi Akkarpatti" },
      { id: 552192, name: "Navi Delwadi" },
      { id: 945081, name: "Navi Popharan" },
      { id: 552201, name: "Nawapur" },
      { id: 552358, name: "Netali" },
      { id: 552219, name: "Newale" },
      { id: 552248, name: "Nihe" },
      { id: 552250, name: "Padghe" },
      { id: 943976, name: "Palghar" },
      { id: 552203, name: "Pam" },
      { id: 552202, name: "Pamtembhi" },
      { id: 552210, name: "Panchali" },
      { id: 552290, name: "Pargaon" },
      { id: 552191, name: "Parnali" },
      { id: 552396, name: "Pasthal" },
      { id: 552196, name: "Pathrali" },
      { id: 552307, name: "Penand" },
      { id: 552363, name: "Pochade" },
      { id: 552338, name: "Pole" },
      { id: 552195, name: "Popharan" },
      { id: 552279, name: "Rambag" },
      { id: 552220, name: "Rani Shigaon" },
      { id: 552232, name: "Ravate" },
      { id: 552270, name: "Rothe" },
      { id: 552273, name: "Sagave" },
      { id: 552372, name: "Sakhare" },
      { id: 552190, name: "Salgaon" },
      { id: 552388, name: "Salwad" },
      { id: 552293, name: "Saphale" },
      { id: 552391, name: "Saravali (Boisar)" },
      { id: 552325, name: "Saravali (Safale)" },
      { id: 552308, name: "Sartodi" },
      { id: 552375, name: "Satiwali" },
      { id: 552252, name: "Satpati" },
      { id: 552184, name: "Sawarai (Tarapur)" },
      { id: 552377, name: "Saware" },
      { id: 552352, name: "Sawarkhand" },
      { id: 552356, name: "Saye" },
      { id: 552256, name: "Shelwali" },
      { id: 552234, name: "Shigaon" },
      { id: 552303, name: "Shilte" },
      { id: 552393, name: "Shirgaon" },
      { id: 552229, name: "Somata" },
      { id: 552291, name: "Sonave" },
      { id: 552222, name: "Sumadipada" },
      { id: 552351, name: "Takwahal" },
      { id: 552357, name: "Tamsai" },
      { id: 552278, name: "Tandulwadi" },
      { id: 552395, name: "Tarapur" },
      { id: 552324, name: "Tembhi Khodave" },
      { id: 943974, name: "Tembhode" },
      { id: 552354, name: "Ten" },
      { id: 552286, name: "Tighare" },
      { id: 552263, name: "Tokarale" },
      { id: 552292, name: "Uchavali" },
      { id: 552200, name: "Uchchheli" },
      { id: 552394, name: "Umbarpada Nandade" },
      { id: 552328, name: "Umbarpada Tarfe Manor" },
      { id: 552211, name: "Umroli" },
      { id: 552194, name: "Unbhat" },
      { id: 552284, name: "Usarani" },
      { id: 552326, name: "Vadhiv" },
      { id: 943978, name: "Vaiti" },
      { id: 552258, name: "Varkhunti" },
      { id: 552276, name: "Vasare" },
      { id: 552349, name: "Vasroli" },
      { id: 552302, name: "Vedhi" },
      { id: 552376, name: "Vehaloli" },
      { id: 552336, name: "Velgaon" },
      { id: 552197, name: "Vengani" },
      { id: 943977, name: "Vevur" },
      { id: 552216, name: "Vikaswadi" },
      { id: 552281, name: "Vilangi" },
      { id: 552313, name: "Virathan Budruk" },
      { id: 552296, name: "Virathan Khurd" },
      { id: 552305, name: "Vitthalwadi" },
      { id: 552334, name: "Wada" },
      { id: 552261, name: "Wadrai" },
      { id: 552350, name: "Wakadi" },
      { id: 552236, name: "Walve" },
      { id: 552360, name: "Wandivali" },
      { id: 552381, name: "Warai" },
      { id: 552246, name: "Warangade" },
      { id: 552218, name: "Wave" },
      { id: 552265, name: "Zanzroli" },
    ],
    4164: [
      { id: 943980, name: "Achole" },
      { id: 552436, name: "Actan" },
      { id: 552422, name: "Adne" },
      { id: 943979, name: "Agashi" },
      { id: 552419, name: "Ambode" },
      { id: 552402, name: "Arnala" },
      { id: 552397, name: "Arnala Killa" },
      { id: 944158, name: "Bapane" },
      { id: 944157, name: "Barampur" },
      { id: 552413, name: "Bhaliwali" },
      { id: 552415, name: "Bhatane" },
      { id: 552408, name: "Bhatpada" },
      { id: 552420, name: "Bhinar" },
      { id: 944168, name: "Bhuigaon Budruk" },
      { id: 944165, name: "Bhuigaon Khurd" },
      { id: 944160, name: "Bilalpada" },
      { id: 944162, name: "Bolinj" },
      { id: 944040, name: "Chandansar" },
      { id: 944017, name: "Chandip" },
      { id: 552447, name: "Chandrapada" },
      { id: 944018, name: "Chikhaldongare" },
      { id: 552410, name: "Chimane" },
      { id: 944034, name: "Chinchoti" },
      { id: 944039, name: "Chobare" },
      { id: 944038, name: "Chulne" },
      { id: 944044, name: "Dahisar" },
      { id: 552430, name: "Depivali" },
      { id: 944145, name: "Devdal" },
      { id: 944146, name: "Dhaniv" },
      { id: 944147, name: "Dhovli" },
      { id: 944036, name: "Diwanman" },
      { id: 552406, name: "Doliv" },
      { id: 944042, name: "Dongre" },
      { id: 944013, name: "Gaas" },
      { id: 944014, name: "Gaaskopari" },
      { id: 944015, name: "Girij" },
      { id: 944016, name: "Gokhivare" },
      { id: 552411, name: "Hedavade" },
      { id: 944041, name: "Juchandra" },
      { id: 552404, name: "Kalamb" },
      { id: 552418, name: "Kalambhon" },
      { id: 944004, name: "Kaman" },
      { id: 943984, name: "Kaner" },
      { id: 945078, name: "Karadi" },
      { id: 552432, name: "Karanjon" },
      { id: 943985, name: "Karmale" },
      { id: 944005, name: "Kashidkopar" },
      { id: 944003, name: "Kasrali" },
      { id: 944012, name: "Kaular Budruk" },
      { id: 944011, name: "Kaular Khurd" },
      { id: 552428, name: "Khairpada" },
      { id: 552412, name: "Khaniwade" },
      { id: 552405, name: "Khardi" },
      { id: 945076, name: "Kharodi" },
      { id: 945075, name: "Khivane" },
      { id: 552438, name: "Khochivade" },
      { id: 944006, name: "Kiravali" },
      { id: 944007, name: "Kofrad" },
      { id: 552399, name: "Kolhapur" },
      { id: 944008, name: "Kolhi" },
      { id: 552407, name: "Kopri" },
      { id: 944009, name: "Koshimbe" },
      { id: 552431, name: "Majivali" },
      { id: 552441, name: "Malaji Pada" },
      { id: 944178, name: "Malonde" },
      { id: 944181, name: "Mandvi" },
      { id: 944173, name: "Manikpur" },
      { id: 945082, name: "Manvel" },
      { id: 944171, name: "Mardes" },
      { id: 552416, name: "Medhe" },
      { id: 945074, name: "More" },
      { id: 552443, name: "Mori" },
      { id: 552401, name: "Mukkam" },
      { id: 944183, name: "Mulgaon" },
      { id: 552446, name: "Nagle" },
      { id: 944150, name: "Naigaon" },
      { id: 944152, name: "Nale" },
      { id: 944151, name: "Naringi" },
      { id: 944149, name: "Navale" },
      { id: 944148, name: "Navghar" },
      { id: 552414, name: "Navsai" },
      { id: 944154, name: "Nilemore" },
      { id: 944153, name: "Nirmal" },
      { id: 552439, name: "Pali" },
      { id: 552440, name: "Panju" },
      { id: 552424, name: "Parol" },
      { id: 552400, name: "Patilgaon" },
      { id: 944156, name: "Pelhar" },
      { id: 552444, name: "Poman" },
      { id: 944186, name: "Rajavali" },
      { id: 944188, name: "Rajodi" },
      { id: 552434, name: "Rangaon" },
      { id: 945077, name: "Ranpada" },
      { id: 552421, name: "Saiwan" },
      { id: 552409, name: "Sakwar" },
      { id: 944205, name: "Saloli" },
      { id: 944200, name: "Samel" },
      { id: 909371, name: "Sandor" },
      { id: 552442, name: "Sarjamori" },
      { id: 944201, name: "Sasunavghar" },
      { id: 944203, name: "Sativali" },
      { id: 552403, name: "Satpale" },
      { id: 552445, name: "Shilottar" },
      { id: 944196, name: "Shirgaon" },
      { id: 944198, name: "Shirsad" },
      { id: 552423, name: "Shirvali" },
      { id: 552426, name: "Shivansai" },
      { id: 944208, name: "Sopara" },
      { id: 552437, name: "Tarkhad" },
      { id: 552398, name: "Tembhi" },
      { id: 552433, name: "Tilher" },
      { id: 552429, name: "Tivari" },
      { id: 552427, name: "Tokare" },
      { id: 944043, name: "Tulinj" },
      { id: 943983, name: "Umela" },
      { id: 943982, name: "Umelman" },
      { id: 943981, name: "Umrale" },
      { id: 552425, name: "Usgaon" },
      { id: 552417, name: "Vadghar" },
      { id: 944190, name: "Vadvali" },
      { id: 552435, name: "Vaslai" },
      { id: 944189, name: "Vatar" },
      { id: 944195, name: "Virar" },
      { id: 944191, name: "Wagholi" },
      { id: 944192, name: "Waliv" },
    ],
    4165: [
      { id: 943723, name: "Aagasan" },
      { id: 943933, name: "Adwali Bhutawali" },
      { id: 943726, name: "Airoli" },
      { id: 945098, name: "Bale" },
      { id: 943886, name: "Balkum" },
      { id: 945091, name: "Bamali" },
      { id: 943890, name: "Betawade" },
      { id: 943906, name: "Bhaindar" },
      { id: 943894, name: "Bhaindarpada" },
      { id: 945093, name: "Bhandarli" },
      { id: 943916, name: "Bonsari" },
      { id: 943896, name: "Boriwade" },
      { id: 943891, name: "Boriwali" },
      { id: 943860, name: "Chauk" },
      { id: 944764, name: "Chendani" },
      { id: 943859, name: "Chene" },
      { id: 943858, name: "Chinchavali" },
      { id: 943934, name: "Chitalsar Manpada" },
      { id: 945089, name: "Dahisar" },
      { id: 943873, name: "Darave" },
      { id: 943872, name: "Datiwali" },
      { id: 943865, name: "Dawale" },
      { id: 943864, name: "Dayghar" },
      { id: 943877, name: "Desai" },
      { id: 943868, name: "Dhokali" },
      { id: 943874, name: "Dighe" },
      { id: 943875, name: "Diva" },
      { id: 943876, name: "Dive" },
      { id: 943866, name: "Domkhar" },
      { id: 943867, name: "Dongari" },
      { id: 943856, name: "Ghansoli" },
      { id: 943857, name: "Ghodbandar" },
      { id: 943855, name: "Goddev" },
      { id: 945101, name: "Goteghar" },
      { id: 943854, name: "Gothivali" },
      { id: 943724, name: "Ilthan" },
      { id: 943861, name: "Juigaon" },
      { id: 943729, name: "Kalva" },
      { id: 943728, name: "Karawe" },
      { id: 943731, name: "Kashi" },
      { id: 943736, name: "Kausa" },
      { id: 943730, name: "Kavesar" },
      { id: 943740, name: "Khairane" },
      { id: 943737, name: "Khari" },
      { id: 943738, name: "Kharigaon" },
      { id: 943739, name: "Khidkali" },
      { id: 943735, name: "Kolshet" },
      { id: 943733, name: "Koparkhairne" },
      { id: 943734, name: "Kopri" },
      { id: 943732, name: "Kukshet" },
      { id: 943907, name: "Mahajanwadi" },
      { id: 943915, name: "Mahape" },
      { id: 943899, name: "Majivade" },
      { id: 943888, name: "Mhatardi" },
      { id: 943908, name: "Mire" },
      { id: 943895, name: "Mogharpada" },
      { id: 945092, name: "Mokashi" },
      { id: 943910, name: "Morwa" },
      { id: 943898, name: "Mumbra" },
      { id: 943909, name: "Murdhe" },
      { id: 945094, name: "Nagaon" },
      { id: 945097, name: "Narivali" },
      { id: 944763, name: "Naupada" },
      { id: 945095, name: "Navali" },
      { id: 943878, name: "Navghar" },
      { id: 943879, name: "Nerul" },
      { id: 945096, name: "Nighu" },
      { id: 943727, name: "Ovale" },
      { id: 943884, name: "Pachpakhadi" },
      { id: 943880, name: "Padle" },
      { id: 943882, name: "Pali" },
      { id: 943881, name: "Parsik" },
      { id: 943883, name: "Pavane" },
      { id: 943885, name: "Penkarpada" },
      { id: 945090, name: "Pimpri" },
      { id: 943892, name: "Rabade" },
      { id: 943911, name: "Rai" },
      { id: 943905, name: "Sabe" },
      { id: 943889, name: "Sangarli" },
      { id: 943897, name: "Sanpada" },
      { id: 943901, name: "Sarsole" },
      { id: 943917, name: "Sawli" },
      { id: 943903, name: "Shahabaj" },
      { id: 943887, name: "Shil" },
      { id: 943900, name: "Shirvane" },
      { id: 943902, name: "Sonkhar" },
      { id: 943935, name: "Sonkhar (Mumbra)" },
      { id: 943869, name: "Talvali" },
      { id: 943870, name: "Tarodi" },
      { id: 943862, name: "Tetavali" },
      { id: 943863, name: "Thane" },
      { id: 943871, name: "Turbhe" },
      { id: 943725, name: "Uttan" },
      { id: 945099, name: "Uttarshiv" },
      { id: 945100, name: "Vakalan" },
      { id: 943904, name: "Wadwali" },
      { id: 943914, name: "Waliwali" },
      { id: 943912, name: "Warsawe" },
      { id: 943893, name: "Washi" },
      { id: 943913, name: "Yeur" },
    ],
    4166: [
      { id: 552609, name: "Aatkoli" },
      { id: 552494, name: "Akaloli" },
      { id: 552674, name: "Alimghar" },
      { id: 552542, name: "Alkhivali" },
      { id: 552629, name: "Amane" },
      { id: 552549, name: "Ambadi" },
      { id: 552539, name: "Angaon" },
      { id: 552621, name: "Anhe" },
      { id: 552672, name: "Anjur" },
      { id: 552610, name: "Arjunali" },
      { id: 552547, name: "Ashivali" },
      { id: 552502, name: "Asnoli Tarf Dugad" },
      { id: 552583, name: "Asnoli Tarf Kunde" },
      { id: 552504, name: "Awale" },
      { id: 552526, name: "Awalwate" },
      { id: 552648, name: "Bapgaon" },
      { id: 552570, name: "Base" },
      { id: 552623, name: "Bhadane" },
      { id: 943927, name: "Bhadwad" },
      { id: 552525, name: "Bhare" },
      { id: 552673, name: "Bharodi" },
      { id: 552644, name: "Bhawale" },
      { id: 552640, name: "Bhinar" },
      { id: 552491, name: "Bhiwali" },
      { id: 945086, name: "Bhiwandi" },
      { id: 552626, name: "Bhoir Gaon" },
      { id: 552599, name: "Bhokari" },
      { id: 552679, name: "Borivali Tarf Rahur" },
      { id: 552605, name: "Borivali Tarf Sonale" },
      { id: 552479, name: "Borpada" },
      { id: 552472, name: "Brahmangaon" },
      { id: 552565, name: "Chane" },
      { id: 552524, name: "Chave" },
      { id: 943921, name: "Chavindre" },
      { id: 552465, name: "Chimbipada" },
      { id: 552611, name: "Chinchavali Tarfe Rahur" },
      { id: 552603, name: "Chinchavali Tarfe Sonale" },
      { id: 552552, name: "Chinchawali Tarfe Kunde" },
      { id: 552630, name: "Chiradpada" },
      { id: 552584, name: "Dabhad" },
      { id: 552480, name: "Dahyale" },
      { id: 552531, name: "Dalepada" },
      { id: 552563, name: "Dalonde" },
      { id: 552666, name: "Dapode" },
      { id: 552536, name: "Davali" },
      { id: 552513, name: "Depoli" },
      { id: 552612, name: "Devali Tarfe Rahur" },
      { id: 552555, name: "Devchole" },
      { id: 552636, name: "Devrung" },
      { id: 552467, name: "Dhamane" },
      { id: 552601, name: "Dhamangaon" },
      { id: 552551, name: "Dighashi" },
      { id: 552671, name: "Dive Anjur" },
      { id: 552487, name: "Dive Kevani" },
      { id: 552613, name: "Dohole" },
      { id: 552558, name: "Dudhani" },
      { id: 552501, name: "Dugad" },
      { id: 552484, name: "Dunge" },
      { id: 552553, name: "Eksal" },
      { id: 552650, name: "Elkunde" },
      { id: 552474, name: "Firangpada" },
      { id: 552475, name: "Gane" },
      { id: 552492, name: "Ganeshpuri" },
      { id: 943920, name: "Gauripada" },
      { id: 552560, name: "Ghadane" },
      { id: 552652, name: "Gholgaon" },
      { id: 552572, name: "Ghotavade" },
      { id: 552497, name: "Ghotgaon" },
      { id: 552580, name: "Gondade" },
      { id: 552566, name: "Gondravali" },
      { id: 552592, name: "Gorad" },
      { id: 552639, name: "Gorsai" },
      { id: 552659, name: "Gove" },
      { id: 552665, name: "Gundavali" },
      { id: 552517, name: "Hiwali" },
      { id: 552635, name: "Itade" },
      { id: 552567, name: "Jambhivali Tarf Khambale" },
      { id: 552577, name: "Jambhivali Tarf Kunde" },
      { id: 552645, name: "Janwal" },
      { id: 552477, name: "Junandurkhi" },
      { id: 552664, name: "Kailasnagar" },
      { id: 552619, name: "Kalambholi" },
      { id: 552686, name: "Kalher" },
      { id: 552485, name: "Kalwar" },
      { id: 943919, name: "Kamatghar" },
      { id: 552680, name: "Kambe" },
      { id: 552571, name: "Kandali Budruk" },
      { id: 552578, name: "Kandali Khurd" },
      { id: 552617, name: "Kandali Tarf Rahur" },
      { id: 943918, name: "Kaneri" },
      { id: 552593, name: "Karanjoti" },
      { id: 552682, name: "Karivali" },
      { id: 552569, name: "Karmale" },
      { id: 552616, name: "Kasane" },
      { id: 552489, name: "Kasheli" },
      { id: 552600, name: "Kashivali" },
      { id: 552681, name: "Katai" },
      { id: 552541, name: "Kawad Budruk" },
      { id: 552544, name: "Kawad Khurd" },
      { id: 552574, name: "Kelhe" },
      { id: 552486, name: "Kewani" },
      { id: 552464, name: "Khadaki Budruk" },
      { id: 552462, name: "Khadaki Khurd" },
      { id: 552534, name: "Khaling Budruk" },
      { id: 552537, name: "Khaling Khurd" },
      { id: 552588, name: "Khambale" },
      { id: 552602, name: "Khandape" },
      { id: 552628, name: "Khandval" },
      { id: 552615, name: "Khanivali" },
      { id: 552683, name: "Kharbav" },
      { id: 552473, name: "Khardi" },
      { id: 552562, name: "Kharivali" },
      { id: 552499, name: "Khativali" },
      { id: 552677, name: "Khoni" },
      { id: 552586, name: "Kiravali Duravali" },
      { id: 552632, name: "Kiravali Tarf Sonale" },
      { id: 552543, name: "Kolivali" },
      { id: 552687, name: "Kon" },
      { id: 552488, name: "Kopar" },
      { id: 552516, name: "Koshimbe" },
      { id: 552618, name: "Koshimbi" },
      { id: 552466, name: "Kuhe" },
      { id: 552625, name: "Kukase" },
      { id: 552597, name: "Kumbharshiv" },
      { id: 552561, name: "Kunde" },
      { id: 552533, name: "Kurund" },
      { id: 552559, name: "Kusapur" },
      { id: 552587, name: "Kushivali" },
      { id: 552468, name: "Lakhivali" },
      { id: 552523, name: "Lamaj" },
      { id: 552528, name: "Lap Budruk" },
      { id: 552527, name: "Lap Khurd" },
      { id: 552529, name: "Lapale Bandhan" },
      { id: 552646, name: "Lonad" },
      { id: 552581, name: "Mahap" },
      { id: 552678, name: "Mahapoli" },
      { id: 552573, name: "Mainde" },
      { id: 552511, name: "Malbidi" },
      { id: 552483, name: "Malodi" },
      { id: 552507, name: "Manivali" },
      { id: 552667, name: "Mankoli" },
      { id: 552496, name: "Mhalunge" },
      { id: 552590, name: "Mohandul" },
      { id: 552509, name: "Mohili" },
      { id: 552510, name: "Mohili Budruk" },
      { id: 552556, name: "Morani" },
      { id: 552535, name: "Murhe" },
      { id: 552647, name: "Muthaval" },
      { id: 943923, name: "Nagaon" },
      { id: 552514, name: "Nandithane" },
      { id: 552637, name: "Nandkar" },
      { id: 943924, name: "Narpoli" },
      { id: 552575, name: "Newade" },
      { id: 552641, name: "Nimbavali" },
      { id: 552518, name: "Nivali" },
      { id: 945087, name: "Nizampura" },
      { id: 552662, name: "Ovali" },
      { id: 552579, name: "Pacchapur" },
      { id: 945084, name: "Pachgaon" },
      { id: 552675, name: "Padagha" },
      { id: 552564, name: "Pahare" },
      { id: 552585, name: "Pali" },
      { id: 552469, name: "Palivali" },
      { id: 552506, name: "Palkhane" },
      { id: 552540, name: "Parivali" },
      { id: 552471, name: "Paye" },
      { id: 552470, name: "Paygaon" },
      { id: 943926, name: "Phene" },
      { id: 552521, name: "Pilanze Budruk" },
      { id: 552520, name: "Pilanze Khurd" },
      { id: 552660, name: "Pimpalas" },
      { id: 552656, name: "Pimpalgaon" },
      { id: 552658, name: "Pimpalghar" },
      { id: 552661, name: "Pimpalner" },
      { id: 552463, name: "Pimpalshet Bhuishet" },
      { id: 552631, name: "Pise" },
      { id: 943925, name: "Pogaon" },
      { id: 552538, name: "Pudas" },
      { id: 552685, name: "Purna" },
      { id: 552684, name: "Rahanal" },
      { id: 552596, name: "Rahur" },
      { id: 552655, name: "Rajnagar" },
      { id: 552657, name: "Ranjnoli" },
      { id: 552550, name: "Ravadi" },
      { id: 552554, name: "Sagaon" },
      { id: 552503, name: "Saigaon" },
      { id: 945085, name: "Saigaon (Temghar)" },
      { id: 552519, name: "Sakharoli" },
      { id: 552633, name: "Sange" },
      { id: 552607, name: "Sape" },
      { id: 552669, name: "Sarang" },
      { id: 552653, name: "Saravali" },
      { id: 552495, name: "Savaroli Tarfe Dugad" },
      { id: 552595, name: "Savaroli Tarfe Rahur" },
      { id: 552634, name: "Sawad" },
      { id: 552638, name: "Sawandhe" },
      { id: 552568, name: "Shedgaon" },
      { id: 552676, name: "Shelar" },
      { id: 552589, name: "Shirgaon" },
      { id: 552582, name: "Shirole" },
      { id: 552478, name: "Shivajinagar" },
      { id: 552649, name: "Shivnagar" },
      { id: 552651, name: "Sonale" },
      { id: 552545, name: "Sontakka" },
      { id: 552620, name: "Sor" },
      { id: 552522, name: "Supegaon" },
      { id: 552670, name: "Surai" },
      { id: 552512, name: "Suryanagar" },
      { id: 552614, name: "Talavali Tarf Rahur" },
      { id: 552608, name: "Talavali Tarf Sonale" },
      { id: 552476, name: "Tembhavali" },
      { id: 943922, name: "Temghar" },
      { id: 552654, name: "Thakurgaon" },
      { id: 552594, name: "Tulshi" },
      { id: 552591, name: "Tungarthan" },
      { id: 552576, name: "Umbarkhand" },
      { id: 552490, name: "Usgaon" },
      { id: 552627, name: "Usroli" },
      { id: 552604, name: "Vadape" },
      { id: 552481, name: "Vadghar" },
      { id: 552515, name: "Vadunavaghar" },
      { id: 552482, name: "Vadvali Tarf Dugad" },
      { id: 552598, name: "Vadvali Tarf Rahur" },
      { id: 552530, name: "Vadvali Tarf Sonale" },
      { id: 552532, name: "Vafale" },
      { id: 552546, name: "Vaghivali" },
      { id: 552606, name: "Vahuli" },
      { id: 552493, name: "Vajreshwari" },
      { id: 552663, name: "Val" },
      { id: 552622, name: "Vandre" },
      { id: 552557, name: "Vape" },
      { id: 552624, name: "Vashere" },
      { id: 552508, name: "Vavali Tarf Dugad" },
      { id: 552498, name: "Vedhe" },
      { id: 552668, name: "Vehele" },
      { id: 552505, name: "Vishwagad" },
      { id: 552643, name: "Walshind" },
      { id: 552500, name: "Waret" },
      { id: 552642, name: "Yewai" },
      { id: 552548, name: "Zidake" },
    ],
    4167: [
      { id: 552727, name: "Aawre" },
      { id: 552807, name: "Adivali" },
      { id: 552690, name: "Aghai" },
      { id: 552746, name: "Ajnup" },
      { id: 552907, name: "Alyani" },
      { id: 552898, name: "Ambarje" },
      { id: 552806, name: "Ambekhor" },
      { id: 943930, name: "Ambivali (So)" },
      { id: 552738, name: "Ambivali (Tarfe Dahigaon)" },
      { id: 552892, name: "Ambivali Tarfe Shere" },
      { id: 552880, name: "Andad" },
      { id: 552810, name: "Apate" },
      { id: 552732, name: "Arjunali" },
      { id: 552918, name: "Asangaon" },
      { id: 552808, name: "Ashte" },
      { id: 552836, name: "Asnoli" },
      { id: 552705, name: "Atgaon" },
      { id: 552719, name: "Avale" },
      { id: 552796, name: "Babare" },
      { id: 552850, name: "Babhale" },
      { id: 552736, name: "Balwandi" },
      { id: 552877, name: "Bamane" },
      { id: 552900, name: "Bavghar" },
      { id: 552833, name: "Bedisgaon" },
      { id: 552735, name: "Belwad" },
      { id: 552846, name: "Belwali" },
      { id: 552805, name: "Belwali (So)" },
      { id: 552742, name: "Bendekon" },
      { id: 552912, name: "Bhagdal" },
      { id: 552855, name: "Bhakari" },
      { id: 552869, name: "Bhatsai" },
      { id: 552693, name: "Bhavse" },
      { id: 552800, name: "Bhinar" },
      { id: 552716, name: "Bhorande" },
      { id: 552700, name: "Birwadi" },
      { id: 552874, name: "Borsheti (Budruk)" },
      { id: 552881, name: "Borsheti (Khurd)" },
      { id: 552764, name: "Chande" },
      { id: 552797, name: "Chandgaon" },
      { id: 552721, name: "Chandroti" },
      { id: 552830, name: "Chariv" },
      { id: 552726, name: "Cherpoli" },
      { id: 552849, name: "Cherwali" },
      { id: 552848, name: "Chikhalgaon" },
      { id: 552793, name: "Chilhar" },
      { id: 552902, name: "Chinchvali" },
      { id: 552784, name: "Chondhe Bk." },
      { id: 552782, name: "Chondhe Kh." },
      { id: 552865, name: "Dahagaon" },
      { id: 552739, name: "Dahigaon" },
      { id: 552909, name: "Dahivali" },
      { id: 552841, name: "Dahivali Tarf Korkada" },
      { id: 552765, name: "Dalkhan" },
      { id: 552753, name: "Dand" },
      { id: 552747, name: "Dapur" },
      { id: 552788, name: "Dehene" },
      { id: 552795, name: "Devgaon" },
      { id: 552811, name: "Dhadhare" },
      { id: 552770, name: "Dhakane" },
      { id: 552760, name: "Dhamani" },
      { id: 552823, name: "Dhasai" },
      { id: 552709, name: "Dimbhe" },
      { id: 552792, name: "Dolkhamb" },
      { id: 552741, name: "Dughar" },
      { id: 552755, name: "Fugale" },
      { id: 552783, name: "Gandulwad" },
      { id: 552905, name: "Gegaon" },
      { id: 552743, name: "Ghanepada" },
      { id: 552897, name: "Ghosai" },
      { id: 552890, name: "Gokulgaon" },
      { id: 552761, name: "Golbhan" },
      { id: 552917, name: "Gotheghar" },
      { id: 552787, name: "Gunde" },
      { id: 552895, name: "Hal" },
      { id: 552791, name: "Hedvali" },
      { id: 552781, name: "Hinglud" },
      { id: 552882, name: "Hiv" },
      { id: 552886, name: "Jambhe" },
      { id: 552778, name: "Jambhulwad" },
      { id: 552759, name: "Jarandi" },
      { id: 552776, name: "Junwani" },
      { id: 552875, name: "Kalambhe" },
      { id: 552697, name: "Kalamgaon" },
      { id: 552772, name: "Kalbhonde" },
      { id: 552908, name: "Kalgaon" },
      { id: 552728, name: "Kambare" },
      { id: 552790, name: "Kambe" },
      { id: 552842, name: "Kanadi" },
      { id: 552838, name: "Kanave" },
      { id: 552703, name: "Kanvinde" },
      { id: 552720, name: "Karade" },
      { id: 552913, name: "Kasara Bk." },
      { id: 552752, name: "Kasara Kh." },
      { id: 552821, name: "Kasgaon" },
      { id: 552766, name: "Kashti" },
      { id: 552864, name: "Katbao" },
      { id: 552729, name: "Kawadas" },
      { id: 552813, name: "Khaire" },
      { id: 552798, name: "Kharade" },
      { id: 552844, name: "Kharangan" },
      { id: 552916, name: "Khardi" },
      { id: 552840, name: "Kharid" },
      { id: 552730, name: "Kharivali (S.)" },
      { id: 552859, name: "Kharivali (So)" },
      { id: 552870, name: "Khativali" },
      { id: 552717, name: "Khor" },
      { id: 552707, name: "Khoste" },
      { id: 552734, name: "Khutadi" },
      { id: 552879, name: "Khutghar" },
      { id: 552706, name: "Kinaishet" },
      { id: 552856, name: "Kinhavali" },
      { id: 552713, name: "Koshimbade" },
      { id: 552771, name: "Kothale" },
      { id: 552775, name: "Kothare" },
      { id: 552826, name: "Kudshet" },
      { id: 552699, name: "Kukambhe" },
      { id: 552817, name: "Kulhe" },
      { id: 552698, name: "Lahe" },
      { id: 552831, name: "Lavale" },
      { id: 552889, name: "Lenad Bk." },
      { id: 552887, name: "Lenad Kh." },
      { id: 552816, name: "Lingayate" },
      { id: 552896, name: "Madh" },
      { id: 552718, name: "Mahuli" },
      { id: 552750, name: "Mal" },
      { id: 552802, name: "Malad" },
      { id: 552828, name: "Malegaon" },
      { id: 552722, name: "Mamnoli" },
      { id: 552809, name: "Manekhind" },
      { id: 552824, name: "Mangaon" },
      { id: 552799, name: "Manjare" },
      { id: 552899, name: "Masavane" },
      { id: 552692, name: "Mohili" },
      { id: 552749, name: "Mokhavane" },
      { id: 552835, name: "Mugaon" },
      { id: 552814, name: "Musai" },
      { id: 552883, name: "Nadgaon (Lenad)" },
      { id: 552861, name: "Nadgaon So" },
      { id: 552695, name: "Nandgaon" },
      { id: 552845, name: "Nandgaon (So)" },
      { id: 552906, name: "Nandval" },
      { id: 552827, name: "Narayangaon" },
      { id: 552885, name: "Nehroli" },
      { id: 552689, name: "Nevare" },
      { id: 552785, name: "Pachghar" },
      { id: 552774, name: "Pachiware" },
      { id: 552773, name: "Palheri" },
      { id: 552867, name: "Pali" },
      { id: 552740, name: "Palshin" },
      { id: 552860, name: "Palsoli (So)" },
      { id: 552837, name: "Partoli" },
      { id: 552872, name: "Pashane" },
      { id: 552767, name: "Patol" },
      { id: 552724, name: "Pendharghol" },
      { id: 552696, name: "Pendhari" },
      { id: 552744, name: "Pimpalpada" },
      { id: 552769, name: "Pingalwadi" },
      { id: 552714, name: "Pivali" },
      { id: 552839, name: "Pofodi" },
      { id: 552725, name: "Pundhe" },
      { id: 552794, name: "Ranvihir" },
      { id: 552891, name: "Ras" },
      { id: 552763, name: "Ratandhale" },
      { id: 552779, name: "Roadvahal" },
      { id: 552701, name: "Sajivali" },
      { id: 552777, name: "Sakadbav" },
      { id: 552704, name: "Sakharoli" },
      { id: 552801, name: "Sakurli" },
      { id: 552868, name: "Sane" },
      { id: 552878, name: "Sapgaon" },
      { id: 552812, name: "Sarangpuri" },
      { id: 552733, name: "Sarlambe" },
      { id: 552866, name: "Sarmal" },
      { id: 552819, name: "Sathgaon" },
      { id: 552723, name: "Savaroli Bk." },
      { id: 552712, name: "Savaroli Kh." },
      { id: 552843, name: "Savaroli So" },
      { id: 552914, name: "Shahapur" },
      { id: 552853, name: "Sheel" },
      { id: 552894, name: "Shei" },
      { id: 552851, name: "Shelwali (Bangar)" },
      { id: 552822, name: "Shelwali (Khandobachi)" },
      { id: 552818, name: "Shenawe" },
      { id: 552702, name: "Shende" },
      { id: 552903, name: "Shendrun Bk." },
      { id: 552888, name: "Shendrun Kh" },
      { id: 552893, name: "Shere" },
      { id: 552820, name: "Shilottar" },
      { id: 552884, name: "Shirgaon" },
      { id: 552748, name: "Shirol" },
      { id: 552858, name: "Shirvanje" },
      { id: 552854, name: "Shivajinagar" },
      { id: 552825, name: "Shivaneri" },
      { id: 552862, name: "Sogaon" },
      { id: 552768, name: "Susarwadi" },
      { id: 552708, name: "Taharpur" },
      { id: 552780, name: "Talwade" },
      { id: 552694, name: "Tanasa" },
      { id: 552910, name: "Tembhare (Khurd)" },
      { id: 552911, name: "Tembhare Bk." },
      { id: 552737, name: "Tembhe" },
      { id: 552803, name: "Tembhurli" },
      { id: 552901, name: "Thile" },
      { id: 552829, name: "Thune Bk." },
      { id: 552832, name: "Thune Kh" },
      { id: 552731, name: "Tute" },
      { id: 552762, name: "Umbarkhand" },
      { id: 552834, name: "Umbhrai" },
      { id: 552754, name: "Umbravane" },
      { id: 552857, name: "Vachkole" },
      { id: 552876, name: "Vafe" },
      { id: 552688, name: "Vaghivali" },
      { id: 552873, name: "Valshet" },
      { id: 552715, name: "Vandre" },
      { id: 552745, name: "Varaskol" },
      { id: 552756, name: "Vashala Bk" },
      { id: 552757, name: "Vashala Kh" },
      { id: 909388, name: "Vashind" },
      { id: 552691, name: "Vaveghar" },
      { id: 552710, name: "Vedvahal" },
      { id: 552711, name: "Vehalonde" },
      { id: 552871, name: "Vehloli" },
      { id: 552815, name: "Vehloli Bk." },
      { id: 552847, name: "Vehloli Kh." },
      { id: 552758, name: "Veluk" },
      { id: 552751, name: "Vihigaon" },
      { id: 552904, name: "Vithobachegaon" },
      { id: 552852, name: "Vittalgaon" },
    ],
    4168: [
      { id: 552935, name: "Aarele" },
      { id: 552948, name: "Adivali" },
      { id: 943662, name: "Ambivali" },
      { id: 552972, name: "Ambivali Tarf Chon" },
      { id: 552938, name: "Ambivali Tarf Vasundri" },
      { id: 552955, name: "Anakhar" },
      { id: 552963, name: "Ane" },
      { id: 552968, name: "Antarde" },
      { id: 553002, name: "Antarli" },
      { id: 552975, name: "Apati Tarf Barhe" },
      { id: 552970, name: "Apati Tarf Chon" },
      { id: 552984, name: "Asade" },
      { id: 943660, name: "Atali" },
      { id: 943661, name: "Ayre" },
      { id: 943685, name: "Balyani" },
      { id: 552956, name: "Bapsai" },
      { id: 943931, name: "Barave" },
      { id: 552920, name: "Behare" },
      { id: 552964, name: "Bhisol" },
      { id: 552986, name: "Bhopar" },
      { id: 552967, name: "Chaure" },
      { id: 943679, name: "Chikanghar" },
      { id: 552931, name: "Chinchavali" },
      { id: 943668, name: "Chole" },
      { id: 552976, name: "Dahagaon" },
      { id: 552947, name: "Dahivali" },
      { id: 552934, name: "Danbav" },
      { id: 552990, name: "Dawadi Tarfe Ambarnath" },
      { id: 552999, name: "Dhamtan" },
      { id: 943681, name: "Dombivali (Juni)" },
      { id: 944811, name: "Dombivali (Navi)" },
      { id: 944812, name: "G. Bha. Patharli" },
      { id: 943674, name: "Galegaon" },
      { id: 943678, name: "Gandhare" },
      { id: 943677, name: "Gauripada" },
      { id: 943676, name: "Gavdevi" },
      { id: 552922, name: "Gerase" },
      { id: 552992, name: "Gharivali" },
      { id: 552995, name: "Ghesar" },
      { id: 552950, name: "Ghotsai" },
      { id: 552983, name: "Golvali" },
      { id: 552953, name: "Goveli" },
      { id: 552945, name: "Guravali" },
      { id: 552998, name: "Hedutane" },
      { id: 552973, name: "Jambhul Mohili" },
      { id: 552927, name: "Ju" },
      { id: 943665, name: "Kachore" },
      { id: 552924, name: "Kakadpada" },
      { id: 943666, name: "Kalyan" },
      { id: 553005, name: "Kamba" },
      { id: 943669, name: "Kanchangaon" },
      { id: 552993, name: "Katai" },
      { id: 943667, name: "Katemanivali" },
      { id: 552960, name: "Kelni" },
      { id: 552928, name: "Khadavali" },
      { id: 943673, name: "Khadegolvali" },
      { id: 553000, name: "Khoni" },
      { id: 552997, name: "Kole" },
      { id: 552957, name: "Kolimb" },
      { id: 943671, name: "Kolivali" },
      { id: 552942, name: "Kondheri" },
      { id: 943670, name: "Kopar" },
      { id: 552921, name: "Kosale" },
      { id: 552958, name: "Kunde" },
      { id: 552959, name: "Mamnoli" },
      { id: 943686, name: "Manda" },
      { id: 552989, name: "Mangaon" },
      { id: 552951, name: "Manivali" },
      { id: 552969, name: "Manjarli Tarfe Barhe" },
      { id: 553006, name: "Mharal Budruk" },
      { id: 552980, name: "Mharal Khurd" },
      { id: 552949, name: "Mhaskal" },
      { id: 943687, name: "Mohane" },
      { id: 943688, name: "Mohili" },
      { id: 552944, name: "Mos" },
      { id: 552932, name: "Nadgaon" },
      { id: 552971, name: "Nalimbi" },
      { id: 552978, name: "Nandap" },
      { id: 552985, name: "Nandiwali Tarf Pachanand" },
      { id: 552981, name: "Nandiwali Tarfe Ambernath" },
      { id: 944813, name: "Navagaon" },
      { id: 552961, name: "Navgaon" },
      { id: 943684, name: "Netivali" },
      { id: 552996, name: "Nilaje" },
      { id: 944810, name: "Nilajepada" },
      { id: 552940, name: "Nimbavli" },
      { id: 552929, name: "Ozarli" },
      { id: 552925, name: "Palsoli" },
      { id: 552937, name: "Phalegaon" },
      { id: 552962, name: "Pimpaloli" },
      { id: 552982, name: "Pisavali" },
      { id: 552933, name: "Pitambare" },
      { id: 552977, name: "Poi" },
      { id: 552952, name: "Rayate" },
      { id: 552930, name: "Raye" },
      { id: 552954, name: "Revati" },
      { id: 552966, name: "Rohan" },
      { id: 552946, name: "Runde" },
      { id: 552988, name: "Sagaon" },
      { id: 552987, name: "Sandap" },
      { id: 552943, name: "Sangode" },
      { id: 943691, name: "Sapad" },
      { id: 943690, name: "Shahad" },
      { id: 553003, name: "Shirdhon" },
      { id: 943932, name: "Shivaji Nagar" },
      { id: 552991, name: "Sonarpada" },
      { id: 943675, name: "Thakurli" },
      { id: 943683, name: "Tisgaon" },
      { id: 943680, name: "Titwala" },
      { id: 943663, name: "Umbarde" },
      { id: 943664, name: "Umbharni" },
      { id: 552994, name: "Usarghar" },
      { id: 552936, name: "Ushid" },
      { id: 552939, name: "Utane" },
      { id: 944809, name: "Vadavali" },
      { id: 553001, name: "Vadavali Budruk" },
      { id: 553004, name: "Vadavali Khurd" },
      { id: 552965, name: "Vaholi" },
      { id: 552919, name: "Valkas" },
      { id: 552979, name: "Varap" },
      { id: 552974, name: "Vasat Shelvali" },
      { id: 552941, name: "Vasundri" },
      { id: 552926, name: "Vaveghar" },
      { id: 552923, name: "Vehale" },
      { id: 943689, name: "Wadeghar" },
    ],
    4169: [
      { id: 945102, name: "Ulhasnagar" },
    ],
    4170: [
      { id: 553032, name: "Adivali Dhokali" },
      { id: 553082, name: "Ambarnath" },
      { id: 553049, name: "Ambeshiv Budruk" },
      { id: 553043, name: "Ambeshiv Khurd" },
      { id: 553021, name: "Ambhe" },
      { id: 553019, name: "Amboshi" },
      { id: 553034, name: "Ashele" },
      { id: 553053, name: "Asnoli" },
      { id: 553027, name: "Asode" },
      { id: 943651, name: "Badlapur" },
      { id: 553031, name: "Bandhanwadi" },
      { id: 943652, name: "Belwali" },
      { id: 553074, name: "Bendshil" },
      { id: 553038, name: "Bhal" },
      { id: 553062, name: "Bhoj" },
      { id: 553012, name: "Bohonoli" },
      { id: 553028, name: "Burdul" },
      { id: 553064, name: "Chamtoli" },
      { id: 553054, name: "Chandap" },
      { id: 553067, name: "Chargaon" },
      { id: 943646, name: "Chikhloli" },
      { id: 553075, name: "Chinchavali (Chamtoli)" },
      { id: 553015, name: "Chinchavali (Hajimlang)" },
      { id: 553033, name: "Chinchpada" },
      { id: 553017, name: "Chirad" },
      { id: 553048, name: "Chon" },
      { id: 553063, name: "Dahivali" },
      { id: 553042, name: "Dapivali" },
      { id: 553071, name: "Devaloli" },
      { id: 553081, name: "Dhavale" },
      { id: 553014, name: "Dhoke (Ambhe)" },
      { id: 553050, name: "Dhoke (Dapivali)" },
      { id: 553080, name: "Done" },
      { id: 553036, name: "Dwarali" },
      { id: 943641, name: "Eranjad" },
      { id: 553077, name: "Goregaon" },
      { id: 553010, name: "Gorpe" },
      { id: 553069, name: "Indgaon" },
      { id: 553065, name: "Jambhale" },
      { id: 553059, name: "Jambhilghar" },
      { id: 943648, name: "Jambhivali" },
      { id: 943647, name: "Javsai" },
      { id: 943649, name: "Joveli" },
      { id: 553008, name: "Kakadwal" },
      { id: 553011, name: "Kakole" },
      { id: 553066, name: "Kanhor" },
      { id: 943643, name: "Kansai" },
      { id: 553045, name: "Karand" },
      { id: 553079, name: "Karav" },
      { id: 553025, name: "Karavale" },
      { id: 553076, name: "Kasgaon" },
      { id: 943642, name: "Katrap" },
      { id: 553020, name: "Kharad" },
      { id: 943645, name: "Kharwai" },
      { id: 553073, name: "Khunteevali" },
      { id: 945083, name: "Kohoj Khuntavali" },
      { id: 553078, name: "Kudsavare" },
      { id: 943644, name: "Kulgaon" },
      { id: 553024, name: "Kumbharli" },
      { id: 553022, name: "Kushivali" },
      { id: 943653, name: "Manakivali" },
      { id: 553035, name: "Manere" },
      { id: 553009, name: "Mangrul" },
      { id: 943654, name: "Manjarli" },
      { id: 943655, name: "Morivali" },
      { id: 553058, name: "Mulgaon" },
      { id: 553026, name: "Narhen" },
      { id: 553007, name: "Nevali" },
      { id: 553044, name: "Pachon" },
      { id: 553046, name: "Padirpada" },
      { id: 943650, name: "Pale" },
      { id: 553016, name: "Pali" },
      { id: 553055, name: "Pimploli" },
      { id: 553018, name: "Posari" },
      { id: 553051, name: "Rahatoli" },
      { id: 553047, name: "Sagaon" },
      { id: 553041, name: "Sai" },
      { id: 553023, name: "Sakharoli" },
      { id: 553040, name: "Sape" },
      { id: 553070, name: "Savare" },
      { id: 553060, name: "Savaroli" },
      { id: 943658, name: "Shelarpada" },
      { id: 553068, name: "Shil" },
      { id: 553013, name: "Shiravali" },
      { id: 943657, name: "Shirgaon" },
      { id: 553057, name: "Sonavale" },
      { id: 943659, name: "Sonivali" },
      { id: 553072, name: "Tan" },
      { id: 553037, name: "Umbroli" },
      { id: 553052, name: "Umbroli (Chon)" },
      { id: 553029, name: "Usatane" },
      { id: 944706, name: "Vadawali" },
      { id: 943656, name: "Valivali" },
      { id: 553083, name: "Vangani" },
      { id: 553061, name: "Varade" },
      { id: 553030, name: "Wadi" },
      { id: 553039, name: "Wasar" },
      { id: 553056, name: "Yeve" },
    ],
    4171: [
      { id: 553289, name: "Agashi" },
      { id: 553189, name: "Alawe" },
      { id: 553173, name: "Alyani" },
      { id: 553270, name: "Ambegaon" },
      { id: 553116, name: "Ambele Bk." },
      { id: 553154, name: "Ambele Kh." },
      { id: 553287, name: "Ambetembhe" },
      { id: 553203, name: "Ambiwali" },
      { id: 553089, name: "Anandgaon" },
      { id: 553198, name: "Anandpur" },
      { id: 553143, name: "Askot" },
      { id: 553092, name: "Asole" },
      { id: 553085, name: "Asose" },
      { id: 553225, name: "Awalegaon" },
      { id: 553216, name: "Balegaon" },
      { id: 553256, name: "Bandhivali" },
      { id: 553141, name: "Bhadane" },
      { id: 553096, name: "Bhaluk" },
      { id: 553233, name: "Bhorande" },
      { id: 553125, name: "Bhuvan" },
      { id: 943928, name: "Birwadi" },
      { id: 553139, name: "Borgaon" },
      { id: 553271, name: "Boriwali" },
      { id: 553101, name: "Brahmangaon" },
      { id: 553190, name: "Bursunge" },
      { id: 553176, name: "Chafe" },
      { id: 553275, name: "Chandrapur" },
      { id: 553212, name: "Chasole" },
      { id: 553088, name: "Chikhale" },
      { id: 553282, name: "Chirad" },
      { id: 553180, name: "Dahigaon" },
      { id: 553131, name: "Dahigaon Shelari" },
      { id: 553164, name: "Dahivali" },
      { id: 553163, name: "Dangurle" },
      { id: 553267, name: "Dehari" },
      { id: 553114, name: "Dehnoli" },
      { id: 553112, name: "Devape" },
      { id: 553111, name: "Devgaon" },
      { id: 553181, name: "Devghar" },
      { id: 553103, name: "Dhanivali" },
      { id: 553147, name: "Dhargaon" },
      { id: 553174, name: "Dhasai" },
      { id: 553206, name: "Dighephal" },
      { id: 553228, name: "Diwanpada" },
      { id: 553288, name: "Dongarnhave" },
      { id: 553250, name: "Dudhanoli" },
      { id: 553248, name: "Durgapur" },
      { id: 553177, name: "Eklahare" },
      { id: 553200, name: "Fangaloshi" },
      { id: 553224, name: "Fangane" },
      { id: 553231, name: "Fangulgavhan" },
      { id: 553121, name: "Fansoli" },
      { id: 553265, name: "Ganeshpur" },
      { id: 553277, name: "Gawali" },
      { id: 553260, name: "Ghagurli" },
      { id: 553107, name: "Ghorale" },
      { id: 553266, name: "Gorakhagad" },
      { id: 553178, name: "Goregaon" },
      { id: 553214, name: "Hedavali" },
      { id: 553084, name: "Hireghar" },
      { id: 553157, name: "Inde" },
      { id: 553202, name: "Jadai" },
      { id: 553249, name: "Jaigaon" },
      { id: 553281, name: "Jambhurde" },
      { id: 553129, name: "Jamghar" },
      { id: 553273, name: "Kachkoli" },
      { id: 553246, name: "Kalambhad (Bho)" },
      { id: 553254, name: "Kalambhad (Mu)" },
      { id: 553253, name: "Kalambhe" },
      { id: 553127, name: "Kalamkhande" },
      { id: 553170, name: "Kandali" },
      { id: 553240, name: "Kanharle" },
      { id: 553272, name: "Kanhol" },
      { id: 553221, name: "Karchonde" },
      { id: 553090, name: "Karvele" },
      { id: 553148, name: "Kasgaon" },
      { id: 553259, name: "Kedurli" },
      { id: 553140, name: "Khandape" },
      { id: 553130, name: "Khandare" },
      { id: 553278, name: "Khanivare" },
      { id: 553213, name: "Khapari" },
      { id: 553199, name: "Kharshetumroli" },
      { id: 553126, name: "Khateghar" },
      { id: 553192, name: "Khed" },
      { id: 553168, name: "Khedale" },
      { id: 553245, name: "Kheware" },
      { id: 553262, name: "Khopivali" },
      { id: 553153, name: "Khutal Bangla" },
      { id: 553211, name: "Khutal Baragaon" },
      { id: 553252, name: "Khutarwadigaon" },
      { id: 553144, name: "Kisal" },
      { id: 553105, name: "Kishor" },
      { id: 553205, name: "Kochare Bk." },
      { id: 553204, name: "Kochare Kh." },
      { id: 553123, name: "Kole" },
      { id: 553251, name: "Koloshi" },
      { id: 553098, name: "Kolthan" },
      { id: 553128, name: "Kondesakhare" },
      { id: 553238, name: "Koravale" },
      { id: 553100, name: "Kudavali" },
      { id: 553222, name: "Kudshet" },
      { id: 553247, name: "Madh" },
      { id: 553244, name: "Mahaj" },
      { id: 553165, name: "Majgaon" },
      { id: 553197, name: "Mal" },
      { id: 553284, name: "Malegaon" },
      { id: 553115, name: "Malhed" },
      { id: 553120, name: "Malinagar" },
      { id: 553191, name: "Mandus" },
      { id: 553243, name: "Mandwat" },
      { id: 553283, name: "Mangaon" },
      { id: 553158, name: "Mangaon (Mulyacha Pada)" },
      { id: 553134, name: "Manivali (Shi)" },
      { id: 553138, name: "Manivali Bk." },
      { id: 553219, name: "Manivali Gho" },
      { id: 553166, name: "Manivali Kh." },
      { id: 553108, name: "Masale" },
      { id: 553207, name: "Merdi" },
      { id: 553257, name: "Mhadas" },
      { id: 553276, name: "Mhasa" },
      { id: 553263, name: "Milhe" },
      { id: 553274, name: "Mohaghar" },
      { id: 553094, name: "Moharai" },
      { id: 553161, name: "Mohop" },
      { id: 553232, name: "Morgaon (Ganeshpur)" },
      { id: 553226, name: "Moroshi" },
      { id: 553290, name: "Murbad" },
      { id: 553118, name: "Nadhai" },
      { id: 553160, name: "Nagaon" },
      { id: 553109, name: "Nandeni" },
      { id: 553159, name: "Nandgaon" },
      { id: 553162, name: "Narayangaon" },
      { id: 553268, name: "Narivali" },
      { id: 553151, name: "Nevalpada" },
      { id: 553136, name: "Nhave" },
      { id: 553210, name: "Nyahadi" },
      { id: 553171, name: "Ojiwale" },
      { id: 553242, name: "Padale" },
      { id: 553182, name: "Palu" },
      { id: 553209, name: "Panshet" },
      { id: 945088, name: "Panshet Molalwadi" },
      { id: 553145, name: "Pargaon" },
      { id: 553169, name: "Parhe" },
      { id: 553208, name: "Paronde" },
      { id: 553110, name: "Pasheni" },
      { id: 553285, name: "Patgaon" },
      { id: 553099, name: "Pawale" },
      { id: 553237, name: "Pendhari" },
      { id: 553095, name: "Pimpalgaon" },
      { id: 553172, name: "Pimpalghar" },
      { id: 553106, name: "Potgaon" },
      { id: 553184, name: "Rampur" },
      { id: 553218, name: "Ranjangaon" },
      { id: 553258, name: "Rao" },
      { id: 553119, name: "Sajai" },
      { id: 553155, name: "Sajgaon" },
      { id: 553146, name: "Sakhare" },
      { id: 553269, name: "Sakurli" },
      { id: 553142, name: "Sangamgaon" },
      { id: 553152, name: "Saralgaon" },
      { id: 553135, name: "Sasane" },
      { id: 553230, name: "Sawarne" },
      { id: 553156, name: "Sayale" },
      { id: 553193, name: "Shai" },
      { id: 553122, name: "Shashtrinagar" },
      { id: 553132, name: "Shelari" },
      { id: 553194, name: "Shelgaon" },
      { id: 553087, name: "Shidgaon" },
      { id: 553093, name: "Shirgaon" },
      { id: 553196, name: "Shiroshi" },
      { id: 553175, name: "Shirpur" },
      { id: 553133, name: "Shirvali" },
      { id: 553117, name: "Shivale" },
      { id: 553280, name: "Sidhdagad" },
      { id: 553187, name: "Singapur" },
      { id: 553183, name: "Sonawale" },
      { id: 553185, name: "Songaon" },
      { id: 553220, name: "Talavali Baragaon" },
      { id: 553201, name: "Talegaon" },
      { id: 553261, name: "Talekhal" },
      { id: 553167, name: "Talwali Tarf Ghorad" },
      { id: 553113, name: "Tembhare Bk." },
      { id: 553102, name: "Temgaon" },
      { id: 553097, name: "Thakarenagar" },
      { id: 553229, name: "Thitabi" },
      { id: 553241, name: "Thune" },
      { id: 553215, name: "Tokawade" },
      { id: 553137, name: "Tondali" },
      { id: 553255, name: "Tulai" },
      { id: 553279, name: "Uchale" },
      { id: 553234, name: "Udaldoh" },
      { id: 553217, name: "Umaroli Bk." },
      { id: 553150, name: "Umbarpada" },
      { id: 553264, name: "Umbroli Kh." },
      { id: 553179, name: "Vadgaon" },
      { id: 553235, name: "Vaishakhare" },
      { id: 553124, name: "Vehare" },
      { id: 553188, name: "Veluk" },
      { id: 553239, name: "Vidhe" },
      { id: 553186, name: "Vidyanagar" },
      { id: 553086, name: "Wadhu" },
      { id: 553149, name: "Wadvali" },
      { id: 553236, name: "Waghgaon" },
      { id: 553091, name: "Waghivali" },
      { id: 553227, name: "Walhivare" },
      { id: 553104, name: "Wanjale" },
      { id: 553195, name: "Wanote" },
      { id: 943929, name: "Washivali Bhakari" },
      { id: 553223, name: "Zadghar" },
    ],
    4172: [
      { id: 553349, name: "Aware" },
      { id: 553336, name: "Bandhpada" },
      { id: 553314, name: "Belondakhar" },
      { id: 553306, name: "Bhendkhal" },
      { id: 553332, name: "Bhom" },
      { id: 553304, name: "Bokadvira" },
      { id: 553327, name: "Bori Bk." },
      { id: 553302, name: "Bori Pakhadi" },
      { id: 553328, name: "Boricha Kotha" },
      { id: 553352, name: "Chanje" },
      { id: 553331, name: "Chikhali Bhom" },
      { id: 553310, name: "Chirle" },
      { id: 553333, name: "Chirner" },
      { id: 553329, name: "Dhasakhosi" },
      { id: 553316, name: "Dhutum" },
      { id: 553320, name: "Dighode" },
      { id: 553299, name: "Dongari" },
      { id: 553305, name: "Funde" },
      { id: 944914, name: "Gaonthan" },
      { id: 553291, name: "Gharapuri" },
      { id: 553341, name: "Govthane" },
      { id: 553300, name: "Hanuman Koliwada" },
      { id: 553326, name: "Harishchandra Pimpale" },
      { id: 943186, name: "Jambhulpada" },
      { id: 553353, name: "Jasai" },
      { id: 553297, name: "Jaskhar" },
      { id: 553330, name: "Jui" },
      { id: 553346, name: "Juipunade" },
      { id: 553348, name: "Kadape" },
      { id: 553303, name: "Kaladhonda" },
      { id: 553334, name: "Kalambusare" },
      { id: 553321, name: "Kanthavali" },
      { id: 553296, name: "Karal" },
      { id: 553311, name: "Kauli Bandhankhar" },
      { id: 553313, name: "Kauli Belodakhar" },
      { id: 553350, name: "Kegaon" },
      { id: 553337, name: "Khopate (Kacherpada)" },
      { id: 553335, name: "Koproli" },
      { id: 553308, name: "Mhatwali" },
      { id: 553317, name: "Muthekhar" },
      { id: 553309, name: "Nagaon" },
      { id: 943185, name: "Navapada" },
      { id: 553351, name: "Navghar" },
      { id: 553307, name: "Navin Sheva" },
      { id: 553295, name: "Pagote" },
      { id: 553342, name: "Pale" },
      { id: 553298, name: "Panje" },
      { id: 553315, name: "Paundkhar" },
      { id: 553339, name: "Pirkone" },
      { id: 553322, name: "Pohi" },
      { id: 553345, name: "Punade" },
      { id: 553323, name: "Ransai" },
      { id: 553301, name: "Ranwad" },
      { id: 553340, name: "Sangpalekhar" },
      { id: 553343, name: "Sarde" },
      { id: 553294, name: "Sawarkhar" },
      { id: 553318, name: "Shematikhar" },
      { id: 553292, name: "Sheva" },
      { id: 553293, name: "Sonari" },
      { id: 553325, name: "Takigaon" },
      { id: 553338, name: "Talbandkhar" },
      { id: 553344, name: "Vasheni" },
      { id: 553312, name: "Veshvi" },
      { id: 553324, name: "Vindhane" },
      { id: 553319, name: "Waltikhar" },
    ],
    4173: [
      { id: 553415, name: "Adai" },
      { id: 553354, name: "Adivali" },
      { id: 553434, name: "Ajivali" },
      { id: 553490, name: "Akulwadi" },
      { id: 553416, name: "Akurli" },
      { id: 553382, name: "Ambe Tarfe Taloje" },
      { id: 553398, name: "Ambe Tarfe Waje" },
      { id: 553409, name: "Ambivali" },
      { id: 553496, name: "Apte" },
      { id: 553466, name: "Ariwali" },
      { id: 553467, name: "Ashte" },
      { id: 909443, name: "Asudgoan" },
      { id: 553451, name: "Bambavi" },
      { id: 553499, name: "Barapada" },
      { id: 553474, name: "Barwai" },
      { id: 553429, name: "Belavali" },
      { id: 553475, name: "Bhatan" },
      { id: 553427, name: "Bherle" },
      { id: 553433, name: "Bhingar" },
      { id: 553436, name: "Bhingarwadi" },
      { id: 553473, name: "Bhokarpada" },
      { id: 945114, name: "Bhokarpada (Chipale)" },
      { id: 553364, name: "Bid" },
      { id: 553406, name: "Bonshet" },
      { id: 553432, name: "Borle" },
      { id: 909442, name: "Chal" },
      { id: 553508, name: "Chawane" },
      { id: 553412, name: "Cheravali" },
      { id: 553426, name: "Chikhale" },
      { id: 553374, name: "Chinchavali Tarfe Taloje" },
      { id: 553390, name: "Chinchavali Tarfe Waje" },
      { id: 553480, name: "Chinchvan" },
      { id: 553380, name: "Chindhran" },
      { id: 553405, name: "Chipale" },
      { id: 553457, name: "Chirvat" },
      { id: 553482, name: "Dahivali" },
      { id: 553487, name: "Dapiwali" },
      { id: 553441, name: "Dapoli" },
      { id: 553396, name: "Dehrang" },
      { id: 553465, name: "Derawali" },
      { id: 553418, name: "Devad" },
      { id: 553378, name: "Devichapada" },
      { id: 553485, name: "Devloli Bk" },
      { id: 553393, name: "Dhamani" },
      { id: 553355, name: "Dhansar" },
      { id: 944434, name: "Dharnacamp" },
      { id: 944435, name: "Dharnagaon" },
      { id: 553395, name: "Dhodani" },
      { id: 944436, name: "Dhongadyacha Pada" },
      { id: 553500, name: "Dighati" },
      { id: 553504, name: "Dolghar" },
      { id: 944432, name: "Dundarai" },
      { id: 553392, name: "Dundre" },
      { id: 553397, name: "Gadhe" },
      { id: 553448, name: "Gavhan" },
      { id: 553511, name: "Gherakilla Manikgad" },
      { id: 553359, name: "Ghot" },
      { id: 553477, name: "Giravale" },
      { id: 553491, name: "Gulsunde" },
      { id: 553403, name: "Harigram" },
      { id: 553387, name: "Hedutane" },
      { id: 553509, name: "Jambhivali" },
      { id: 553483, name: "Jatade" },
      { id: 909440, name: "Kalamboli" },
      { id: 553497, name: "Kalhe" },
      { id: 553507, name: "Kaliwali" },
      { id: 553518, name: "Kalundre" },
      { id: 909441, name: "Kamothe" },
      { id: 553379, name: "Kanpoli" },
      { id: 553493, name: "Karade Budruk" },
      { id: 553492, name: "Karade Khurd" },
      { id: 553372, name: "Karambeli Tarfe Taloje" },
      { id: 553440, name: "Karanjade" },
      { id: 553357, name: "Karavale Bk." },
      { id: 553498, name: "Karnala" },
      { id: 553468, name: "Kasalkhand" },
      { id: 553494, name: "Kasap" },
      { id: 553503, name: "Kasarbhat" },
      { id: 553501, name: "Kelavane" },
      { id: 553388, name: "Kevale" },
      { id: 553383, name: "Khairwadi" },
      { id: 553389, name: "Khanav" },
      { id: 553469, name: "Khanavale" },
      { id: 553513, name: "Kharghar" },
      { id: 553446, name: "Kharkopar" },
      { id: 553377, name: "Kherane Khurd" },
      { id: 944428, name: "Kolakhe Peth" },
      { id: 553463, name: "Kolkhe" },
      { id: 944430, name: "Kolwadi" },
      { id: 553464, name: "Kon" },
      { id: 553385, name: "Kondale" },
      { id: 553370, name: "Kondap" },
      { id: 553439, name: "Kopar" },
      { id: 553404, name: "Koproli" },
      { id: 553505, name: "Koral" },
      { id: 553360, name: "Koyanavele" },
      { id: 553461, name: "Kudave" },
      { id: 553452, name: "Kundevahal" },
      { id: 553495, name: "Ladiwali" },
      { id: 553421, name: "Loniwali" },
      { id: 553431, name: "Machi Prabal" },
      { id: 944438, name: "Madbhuvan" },
      { id: 553381, name: "Mahalungi" },
      { id: 553375, name: "Mahodar" },
      { id: 553394, name: "Maldunge" },
      { id: 553453, name: "Manghar" },
      { id: 553419, name: "Moho" },
      { id: 553471, name: "Mohope" },
      { id: 553386, name: "Morbe" },
      { id: 553454, name: "Mosare" },
      { id: 553358, name: "Nagzari" },
      { id: 553460, name: "Nandgaon" },
      { id: 553456, name: "Nanoshi" },
      { id: 553481, name: "Narpoli" },
      { id: 909438, name: "Navade" },
      { id: 553408, name: "Nere" },
      { id: 943061, name: "Nerepada" },
      { id: 553414, name: "Nevali" },
      { id: 553447, name: "Nhave" },
      { id: 553368, name: "Nitalas" },
      { id: 553369, name: "Nitale" },
      { id: 553365, name: "Owe" },
      { id: 553517, name: "Owle" },
      { id: 553450, name: "Padeghar" },
      { id: 909436, name: "Padghe" },
      { id: 553462, name: "Palaspe" },
      { id: 553367, name: "Pale Budruk" },
      { id: 909435, name: "Palekhurd" },
      { id: 553472, name: "Pali Budruk" },
      { id: 553422, name: "Pali Khurd" },
      { id: 553515, name: "Palidevad" },
      { id: 944321, name: "Panvel" },
      { id: 553442, name: "Pargaon" },
      { id: 553438, name: "Pargaon Dungi" },
      { id: 553455, name: "Patnoli" },
      { id: 909437, name: "Pendhar" },
      { id: 553362, name: "Pisarve" },
      { id: 553486, name: "Posari" },
      { id: 553470, name: "Poyanje" },
      { id: 944437, name: "Poyanje Katkarwadi" },
      { id: 553391, name: "Ritghar" },
      { id: 909434, name: "Rodpali" },
      { id: 553363, name: "Rohinjan" },
      { id: 553502, name: "Sai" },
      { id: 553428, name: "Sangade" },
      { id: 553410, name: "Sangatoli" },
      { id: 553479, name: "Sangurli" },
      { id: 553506, name: "Sarsai" },
      { id: 553484, name: "Savale" },
      { id: 553510, name: "Savane" },
      { id: 553435, name: "Shedung" },
      { id: 553417, name: "Shilottar Raichur" },
      { id: 553373, name: "Shiravali" },
      { id: 553478, name: "Shirdhon" },
      { id: 553399, name: "Shivansai" },
      { id: 553423, name: "Shivkar" },
      { id: 553476, name: "Somtane" },
      { id: 553449, name: "Sonkhar" },
      { id: 553361, name: "Taloje Majkur" },
      { id: 553512, name: "Taloje Panchnad" },
      { id: 553384, name: "Tamsai" },
      { id: 553444, name: "Targhar" },
      { id: 909431, name: "Tembhode" },
      { id: 909433, name: "Tondare" },
      { id: 553489, name: "Turade" },
      { id: 553356, name: "Turbhe" },
      { id: 553458, name: "Turmale" },
      { id: 553443, name: "Ulwe" },
      { id: 553400, name: "Umroli" },
      { id: 553401, name: "Usarli Bk." },
      { id: 553425, name: "Usarli Kh" },
      { id: 553459, name: "Vadavali" },
      { id: 553516, name: "Vadghar" },
      { id: 553437, name: "Vaghivali" },
      { id: 553402, name: "Vakadi" },
      { id: 553366, name: "Valap" },
      { id: 553376, name: "Vavanje" },
      { id: 553488, name: "Vaveghar" },
      { id: 553424, name: "Vichumbe" },
      { id: 553407, name: "Vihighar" },
      { id: 943059, name: "Waghachi Wadi" },
      { id: 553445, name: "Wahal" },
      { id: 553413, name: "Wajapur" },
      { id: 553411, name: "Waje" },
      { id: 909430, name: "Walavali" },
      { id: 553371, name: "Wangani Tarfe Taloje" },
      { id: 553420, name: "Wangani Tarfe Waje" },
      { id: 553430, name: "Wardoli" },
    ],
    4174: [
      { id: 943158, name: "Aasalpada" },
      { id: 943050, name: "Aasalwadi" },
      { id: 553677, name: "Adivali" },
      { id: 944239, name: "Akurle" },
      { id: 553579, name: "Ambherpada" },
      { id: 553599, name: "Ambivali T. Kothalkhalati" },
      { id: 553552, name: "Ambiwali Bk." },
      { id: 553628, name: "Ambot" },
      { id: 943159, name: "Anandwadi" },
      { id: 553594, name: "Anjap" },
      { id: 553592, name: "Antrat Tarfe Need" },
      { id: 553540, name: "Antrat Tarfe Waredi" },
      { id: 553524, name: "Ardhe" },
      { id: 553640, name: "Arvand" },
      { id: 553556, name: "Asal" },
      { id: 553526, name: "Ase" },
      { id: 553659, name: "Ashane" },
      { id: 553674, name: "Avalas" },
      { id: 553530, name: "Awasare" },
      { id: 553566, name: "Baliware" },
      { id: 553662, name: "Bambnoli" },
      { id: 553532, name: "Bandhiwali" },
      { id: 943157, name: "Bangarwadi" },
      { id: 553655, name: "Bardi" },
      { id: 553637, name: "Barne" },
      { id: 553519, name: "Bedisgaon" },
      { id: 553554, name: "Bekare" },
      { id: 553622, name: "Bendase" },
      { id: 553534, name: "Bhadwal" },
      { id: 943047, name: "Bhadwal Takachiwadi" },
      { id: 944419, name: "Bhaktachi Wadi" },
      { id: 553615, name: "Bhaliwadi" },
      { id: 553651, name: "Bhansoli" },
      { id: 553621, name: "Bhatgaon" },
      { id: 944280, name: "Bhisegaon" },
      { id: 553630, name: "Bhivpuri Camp" },
      { id: 553625, name: "Bhoirwadi" },
      { id: 553557, name: "Bhutiwali" },
      { id: 553691, name: "Bid Bk." },
      { id: 553531, name: "Birdole" },
      { id: 553544, name: "Bopele" },
      { id: 553562, name: "Borgaon" },
      { id: 553590, name: "Boriwali" },
      { id: 553546, name: "Borle" },
      { id: 553569, name: "Chafewadi" },
      { id: 553564, name: "Chai" },
      { id: 553618, name: "Chandai" },
      { id: 553568, name: "Chevane" },
      { id: 943183, name: "Chinchwadi" },
      { id: 553609, name: "Chinchwali" },
      { id: 553694, name: "Chochi" },
      { id: 944416, name: "Choravale" },
      { id: 553645, name: "Dahigaon" },
      { id: 944245, name: "Dahivali Tarfe Need" },
      { id: 553538, name: "Dahiwali Tarfe Waredi" },
      { id: 553533, name: "Damat" },
      { id: 553665, name: "Deulwadi" },
      { id: 553574, name: "Devpada" },
      { id: 553649, name: "Dhak" },
      { id: 553670, name: "Dhakate Vengaon" },
      { id: 553602, name: "Dhamni" },
      { id: 553543, name: "Dhamote" },
      { id: 553583, name: "Dhotre" },
      { id: 553654, name: "Diksal" },
      { id: 553635, name: "Done" },
      { id: 943161, name: "Dongarpada" },
      { id: 553650, name: "Eksal" },
      { id: 553653, name: "Ganegaon Chinchawali" },
      { id: 553657, name: "Garpoli" },
      { id: 553614, name: "Gaulwadi" },
      { id: 553646, name: "Gaurkamat" },
      { id: 944929, name: "Gaurkamath Adivasiwadi" },
      { id: 553591, name: "Gudhavan" },
      { id: 944243, name: "Gundage" },
      { id: 553666, name: "Haliwali" },
      { id: 553612, name: "Hedawali" },
      { id: 553631, name: "Humgaon" },
      { id: 553644, name: "Injiwali" },
      { id: 553638, name: "Jambhiwali" },
      { id: 553600, name: "Jambrung" },
      { id: 553547, name: "Jite" },
      { id: 553617, name: "Kadav" },
      { id: 553560, name: "Kalamb" },
      { id: 553608, name: "Kalamboli Tarf Waredi" },
      { id: 944415, name: "Kamatpada" },
      { id: 944240, name: "Karjat" },
      { id: 553595, name: "Kashele" },
      { id: 943044, name: "Kawathewadi" },
      { id: 553523, name: "Khadyachapada" },
      { id: 553597, name: "Khanand" },
      { id: 553678, name: "Khandape" },
      { id: 553577, name: "Khandas" },
      { id: 553684, name: "Kharwandi" },
      { id: 553585, name: "Kikavi" },
      { id: 553664, name: "Kirawali" },
      { id: 553545, name: "Kolhare" },
      { id: 553548, name: "Kolhiwali" },
      { id: 553693, name: "Kondhane" },
      { id: 553685, name: "Kondiwade" },
      { id: 553537, name: "Kondiwale" },
      { id: 553660, name: "Koshane" },
      { id: 553596, name: "Kothimbe" },
      { id: 553551, name: "Kumbhe" },
      { id: 553624, name: "Kundalaj" },
      { id: 553570, name: "Kurung" },
      { id: 553648, name: "Kushiwali" },
      { id: 553667, name: "Ladiwali" },
      { id: 553525, name: "Male" },
      { id: 553605, name: "Malegaon T. Kothal Khalati" },
      { id: 553536, name: "Malegaon Tarfe Waredi" },
      { id: 553535, name: "Mamdapur" },
      { id: 553613, name: "Mandawane" },
      { id: 553681, name: "Mangaon T. Wasare" },
      { id: 553553, name: "Mangaon Tarf Waredi" },
      { id: 944420, name: "Mangaon Thakurwadi" },
      { id: 553528, name: "Maniwali" },
      { id: 553571, name: "Mankiwali" },
      { id: 553586, name: "Margachiwadi" },
      { id: 553620, name: "Markewadi" },
      { id: 943041, name: "Mechkarwadi" },
      { id: 553593, name: "Mircholi" },
      { id: 553603, name: "Mograj" },
      { id: 553529, name: "Mohili Tarfe Waredi" },
      { id: 553687, name: "Mohili Tarfe Wasare" },
      { id: 553669, name: "Mothe Vengaon" },
      { id: 944282, name: "Mudre Budruk" },
      { id: 944281, name: "Mudre Khurd" },
      { id: 553692, name: "Mugape" },
      { id: 553679, name: "Mulgaon Tarfe Wasare" },
      { id: 943181, name: "Nagewadi" },
      { id: 553589, name: "Naldhe" },
      { id: 553567, name: "Nandgaon" },
      { id: 553671, name: "Nangurle" },
      { id: 943184, name: "Naralachiwadi" },
      { id: 553606, name: "Nasarapur" },
      { id: 943043, name: "Navsuchiwadi" },
      { id: 553695, name: "Neral" },
      { id: 553550, name: "Newali" },
      { id: 553688, name: "Newali Tarfe Vasare" },
      { id: 553521, name: "Nikhop" },
      { id: 553563, name: "Olman" },
      { id: 943046, name: "Pachkhadakwadi" },
      { id: 553689, name: "Palasdari" },
      { id: 553633, name: "Pali Tarfe Kothal Khalathi" },
      { id: 553558, name: "Pali Tarfe Waredi" },
      { id: 553668, name: "Parade" },
      { id: 553522, name: "Pashane" },
      { id: 553587, name: "Pathraj" },
      { id: 553601, name: "Peth" },
      { id: 943042, name: "Phondyachiwadi" },
      { id: 553604, name: "Pimpalpada" },
      { id: 553541, name: "Pimploli Bk." },
      { id: 553598, name: "Pinglas" },
      { id: 553572, name: "Pohi" },
      { id: 944418, name: "Pokharkarwadi" },
      { id: 553641, name: "Posari" },
      { id: 553573, name: "Poshir" },
      { id: 553634, name: "Potal" },
      { id: 944417, name: "Pulachiwadi" },
      { id: 553580, name: "Rajape" },
      { id: 553632, name: "Saidongar" },
      { id: 553559, name: "Salokh Tarf Waredi" },
      { id: 553636, name: "Salokh Tarfe Need" },
      { id: 944930, name: "Salokh Tarfe Nid Adivasiwadi" },
      { id: 553683, name: "Salpe" },
      { id: 553607, name: "Salvad" },
      { id: 553682, name: "Sandashi" },
      { id: 553686, name: "Sangavi" },
      { id: 553627, name: "Sapele" },
      { id: 553611, name: "Savale" },
      { id: 553639, name: "Savele" },
      { id: 553661, name: "Sawargaon" },
      { id: 553520, name: "Shelu" },
      { id: 553584, name: "Shilar" },
      { id: 943182, name: "Shilarwadi" },
      { id: 553582, name: "Shingdhol" },
      { id: 553675, name: "Shirshe" },
      { id: 553588, name: "Sugave" },
      { id: 553576, name: "Tadwadi" },
      { id: 553610, name: "Takave" },
      { id: 553690, name: "Talawali" },
      { id: 553542, name: "Talwade" },
      { id: 553626, name: "Tambas" },
      { id: 553676, name: "Tamnath" },
      { id: 553561, name: "Tatyachiwadi" },
      { id: 553581, name: "Tembhare" },
      { id: 553672, name: "Tighar" },
      { id: 553680, name: "Tiwane" },
      { id: 553642, name: "Tiware" },
      { id: 553578, name: "Tungi" },
      { id: 553652, name: "Ukrul" },
      { id: 553658, name: "Umroli" },
      { id: 553647, name: "Vadap" },
      { id: 943160, name: "Vadap Adivasiwadi" },
      { id: 553629, name: "Vaijanath" },
      { id: 553549, name: "Vakas" },
      { id: 553616, name: "Vanjarwadi" },
      { id: 553643, name: "Varai Tarfe Need" },
      { id: 553673, name: "Varne" },
      { id: 553619, name: "Wadawali" },
      { id: 553555, name: "Wadawali Tarf Waredi" },
      { id: 553663, name: "Wanjale" },
      { id: 553539, name: "Wanjarpada" },
      { id: 553527, name: "Warai Tarf Waredi" },
      { id: 553575, name: "Ware" },
      { id: 553656, name: "Wave" },
      { id: 553623, name: "Wavloli" },
      { id: 553565, name: "Zugarewadi" },
    ],
    4175: [
      { id: 553769, name: "Adoshi" },
      { id: 553782, name: "Ajivali" },
      { id: 945113, name: "Ajoshi" },
      { id: 553741, name: "Ambivali Tarfe Tungartan" },
      { id: 553817, name: "Ambivali Tarfe Wankhal" },
      { id: 944421, name: "Anandwadi" },
      { id: 553762, name: "Anjrun" },
      { id: 553781, name: "Apati" },
      { id: 553734, name: "Asare" },
      { id: 553726, name: "Asroti" },
      { id: 553768, name: "Atkargaon" },
      { id: 553755, name: "Beed Kh." },
      { id: 944289, name: "Bhanvaj" },
      { id: 553730, name: "Bhilvale" },
      { id: 553704, name: "Borgaon Bk." },
      { id: 553705, name: "Borgaon Kh." },
      { id: 553722, name: "Borivali" },
      { id: 553718, name: "Chambharli" },
      { id: 553816, name: "Chavani" },
      { id: 553806, name: "Chilthan" },
      { id: 944285, name: "Chinchavali Shekin" },
      { id: 553766, name: "Chinchvali Gohe" },
      { id: 553700, name: "Chowk Manivali" },
      { id: 553779, name: "Dahivali Tarfe Boreti" },
      { id: 944288, name: "Devalad" },
      { id: 553794, name: "Devnhave" },
      { id: 553774, name: "Dhamani" },
      { id: 942991, name: "Dharavi" },
      { id: 553735, name: "Dharni" },
      { id: 553765, name: "Dheku" },
      { id: 553760, name: "Dolavali" },
      { id: 553792, name: "Donvat" },
      { id: 553814, name: "Durshet" },
      { id: 942955, name: "Ganeshnagar" },
      { id: 553749, name: "Ghodivali" },
      { id: 553808, name: "Gohe" },
      { id: 553789, name: "Gorthan Bk." },
      { id: 553791, name: "Gorthan Kh." },
      { id: 553802, name: "Gothivali" },
      { id: 944308, name: "Hal Bk" },
      { id: 553763, name: "Hal Kh." },
      { id: 553711, name: "Hatanoli" },
      { id: 553767, name: "Honad" },
      { id: 553783, name: "Horale" },
      { id: 553740, name: "Isambe" },
      { id: 553757, name: "Jambarung" },
      { id: 553801, name: "Jambhivali Tarfe Chhattishi" },
      { id: 944286, name: "Jambhivali Tarfe Vankhal" },
      { id: 944915, name: "Jambrung Thakurwadi" },
      { id: 553721, name: "Kaire" },
      { id: 553731, name: "Kalote Mokashi" },
      { id: 553733, name: "Kalote Rayati" },
      { id: 553717, name: "Kambe" },
      { id: 553750, name: "Kandharoli Tarfe Boreti" },
      { id: 553728, name: "Kandharoli Tarfe Wankhal" },
      { id: 553809, name: "Karambeli" },
      { id: 553813, name: "Kargaon" },
      { id: 944283, name: "Katrang" },
      { id: 553753, name: "Kelavali" },
      { id: 553748, name: "Khalapur" },
      { id: 553811, name: "Khambewadi" },
      { id: 553804, name: "Khanav" },
      { id: 553807, name: "Kharivali" },
      { id: 553772, name: "Kharsundi" },
      { id: 553759, name: "Kharvai" },
      { id: 944332, name: "Khirkindiwadi" },
      { id: 944284, name: "Khopoli" },
      { id: 553725, name: "Kopari" },
      { id: 553773, name: "Kumbhivali" },
      { id: 944293, name: "Lavhej" },
      { id: 553698, name: "Lodhivali" },
      { id: 553737, name: "Lohop" },
      { id: 553771, name: "Madap" },
      { id: 553764, name: "Mahad" },
      { id: 553742, name: "Majgaon" },
      { id: 942971, name: "Maniknagar" },
      { id: 553761, name: "Mankivali" },
      { id: 944290, name: "Mil" },
      { id: 553710, name: "Morbe" },
      { id: 944291, name: "Mulgaon Bk" },
      { id: 944423, name: "Mutha" },
      { id: 553699, name: "Nadhal" },
      { id: 553744, name: "Nadode" },
      { id: 942956, name: "Nageshwar" },
      { id: 944422, name: "Nananagar" },
      { id: 553800, name: "Nandanpada" },
      { id: 553701, name: "Nanivali" },
      { id: 553798, name: "Narangi" },
      { id: 553751, name: "Navandhe" },
      { id: 942963, name: "Navin Posari" },
      { id: 553743, name: "Nigdoli" },
      { id: 553745, name: "Nimbode" },
      { id: 553776, name: "Niphan" },
      { id: 553702, name: "Padaghe" },
      { id: 553708, name: "Pali Bk." },
      { id: 553713, name: "Pali Kh." },
      { id: 553697, name: "Panashil" },
      { id: 553719, name: "Parade" },
      { id: 553784, name: "Parkhande" },
      { id: 553770, name: "Poud" },
      { id: 944292, name: "Rahatwade" },
      { id: 553787, name: "Ransai" },
      { id: 553819, name: "Rees" },
      { id: 942989, name: "Sainagar" },
      { id: 553778, name: "Sajgaon" },
      { id: 942954, name: "Samarthnagar" },
      { id: 553796, name: "Sangade" },
      { id: 553797, name: "Sangadewadi" },
      { id: 553714, name: "Sarang" },
      { id: 553777, name: "Sarsan" },
      { id: 553775, name: "Savaroli" },
      { id: 944307, name: "Shedavali" },
      { id: 553758, name: "Shengaon" },
      { id: 944306, name: "Shil" },
      { id: 944334, name: "Shindiwadi" },
      { id: 553747, name: "Shirvali Tarfe Boreti" },
      { id: 553788, name: "Shirvali Tarfe Chhattishi" },
      { id: 942961, name: "Shivgaon" },
      { id: 553706, name: "Sondewadi" },
      { id: 553799, name: "Swali" },
      { id: 944287, name: "Takai" },
      { id: 553786, name: "Talashi" },
      { id: 553739, name: "Talavali" },
      { id: 553696, name: "Talegaon" },
      { id: 553780, name: "Tambati" },
      { id: 553715, name: "Tembhari" },
      { id: 553795, name: "Thanenhave" },
      { id: 553803, name: "Tondali" },
      { id: 553815, name: "Tuksai" },
      { id: 553712, name: "Tupgaon" },
      { id: 553810, name: "Ujloli" },
      { id: 553812, name: "Umbare" },
      { id: 553756, name: "Umbarvira" },
      { id: 553805, name: "Usroli" },
      { id: 553793, name: "Vadval" },
      { id: 553709, name: "Vadvihir" },
      { id: 553746, name: "Vanave" },
      { id: 553724, name: "Vanivali" },
      { id: 553790, name: "Vanvathe" },
      { id: 553723, name: "Vashivali" },
      { id: 553720, name: "Vat" },
      { id: 553729, name: "Vavandal" },
      { id: 553707, name: "Vavarle" },
      { id: 553785, name: "Vavoshi" },
      { id: 553716, name: "Vayal" },
      { id: 944305, name: "Vihari" },
      { id: 553732, name: "Vinegaon" },
      { id: 942953, name: "Virgaon" },
      { id: 553738, name: "Wadgaon" },
      { id: 553752, name: "Wangani" },
      { id: 553754, name: "Wani" },
      { id: 553736, name: "Warad" },
      { id: 944295, name: "Warose Tarfe Vasrang" },
      { id: 553703, name: "Warose Tarfe Wankhal" },
      { id: 909445, name: "Wasambe" },
      { id: 944297, name: "Wasarang" },
      { id: 944333, name: "Zadaniwadi" },
    ],
    4176: [
      { id: 553929, name: "Adharne" },
      { id: 553938, name: "Aghai" },
      { id: 553909, name: "Ambeghar" },
      { id: 553889, name: "Ambivali" },
      { id: 553972, name: "Amtem" },
      { id: 553837, name: "Antore" },
      { id: 553911, name: "Ashte" },
      { id: 553983, name: "Atiwali" },
      { id: 553826, name: "Bahiramkotak" },
      { id: 553870, name: "Balawali" },
      { id: 553899, name: "Belvade Bk" },
      { id: 553898, name: "Belvade Kh" },
      { id: 553987, name: "Benase" },
      { id: 553825, name: "Benavale" },
      { id: 553851, name: "Beneghat" },
      { id: 553919, name: "Borgaon" },
      { id: 553846, name: "Bori" },
      { id: 942993, name: "Boricha Mal" },
      { id: 553845, name: "Borwe" },
      { id: 553832, name: "Borze" },
      { id: 944441, name: "Chaphegani" },
      { id: 553895, name: "Chinchghar" },
      { id: 553974, name: "Chole" },
      { id: 553989, name: "Dadar" },
      { id: 553897, name: "Davansar" },
      { id: 553873, name: "Davre" },
      { id: 944907, name: "Devali" },
      { id: 943053, name: "Devmal Thakurwadi" },
      { id: 553937, name: "Dhamni" },
      { id: 553966, name: "Dhaulpada" },
      { id: 944453, name: "Dhavaral" },
      { id: 553908, name: "Dhavate" },
      { id: 553838, name: "Dhondpada" },
      { id: 553829, name: "Div" },
      { id: 553852, name: "Dolvi" },
      { id: 553879, name: "Dolvi Dababa" },
      { id: 553864, name: "Dubej" },
      { id: 553868, name: "Durshet" },
      { id: 553859, name: "Dushmi" },
      { id: 553892, name: "Dutarfa Sapoli" },
      { id: 553924, name: "Gagode Bk" },
      { id: 553917, name: "Gagode Kh" },
      { id: 553975, name: "Gandhe" },
      { id: 553914, name: "Ghote" },
      { id: 944440, name: "Goulanwadi" },
      { id: 553882, name: "Govirle" },
      { id: 553890, name: "Hamrapur" },
      { id: 553874, name: "Hanumanpada" },
      { id: 553936, name: "Hetavane" },
      { id: 944452, name: "Indranagar" },
      { id: 553970, name: "Jambhoshi" },
      { id: 553982, name: "Jambhultep" },
      { id: 553884, name: "Jawali" },
      { id: 553949, name: "Jirne" },
      { id: 553865, name: "Jite" },
      { id: 553880, name: "Johe" },
      { id: 553855, name: "Jui Bk." },
      { id: 553957, name: "Jui Habbas" },
      { id: 553857, name: "Jui Kh" },
      { id: 553953, name: "Kalad" },
      { id: 553875, name: "Kalave" },
      { id: 553823, name: "Kaleshri" },
      { id: 553923, name: "Kamarli" },
      { id: 553905, name: "Kandale" },
      { id: 553903, name: "Kandlepada" },
      { id: 553831, name: "Kane" },
      { id: 553822, name: "Kanhoba" },
      { id: 553915, name: "Karambeli Chattishi" },
      { id: 553943, name: "Karav" },
      { id: 553979, name: "Karli" },
      { id: 553885, name: "Karodi" },
      { id: 553904, name: "Kashmire" },
      { id: 553960, name: "Kasu" },
      { id: 553965, name: "Kasurghuntwadi" },
      { id: 553861, name: "Kauli Simadevi" },
      { id: 553948, name: "Kelambi" },
      { id: 553878, name: "Khar Dutarfa Borli" },
      { id: 553862, name: "Khar Koshim" },
      { id: 553976, name: "Khar Ovali" },
      { id: 553860, name: "Khar Simadevi" },
      { id: 944336, name: "Kharbachiwadi (Jawali)" },
      { id: 553871, name: "Kharborli" },
      { id: 553959, name: "Kharburdi" },
      { id: 944326, name: "Kharchirbi" },
      { id: 553942, name: "Khardevali" },
      { id: 553955, name: "Khardhombi" },
      { id: 553946, name: "Kharghat" },
      { id: 553947, name: "Kharjambhela" },
      { id: 553973, name: "Kharkalai" },
      { id: 553941, name: "Kharkarawi" },
      { id: 553978, name: "Kharkoleti" },
      { id: 553945, name: "Kharmachela" },
      { id: 553854, name: "Kharnandai" },
      { id: 553866, name: "Kharoshi" },
      { id: 553858, name: "Kharpada" },
      { id: 553956, name: "Kharpale" },
      { id: 553893, name: "Kharsapoli" },
      { id: 553849, name: "Kolave" },
      { id: 553980, name: "Koleti" },
      { id: 553969, name: "Kondhavi" },
      { id: 553872, name: "Kopar" },
      { id: 553835, name: "Koproli" },
      { id: 553988, name: "Kuhire" },
      { id: 553928, name: "Kurmurli" },
      { id: 553952, name: "Kurnad" },
      { id: 553824, name: "Lakhola" },
      { id: 553950, name: "Mahalmirya Dongar" },
      { id: 942994, name: "Maldev" },
      { id: 553922, name: "Mangrul" },
      { id: 553843, name: "Masad Bedi" },
      { id: 553842, name: "Masad Bk" },
      { id: 553844, name: "Masad Kh" },
      { id: 942992, name: "Mayani Taldev" },
      { id: 553906, name: "Meleghar" },
      { id: 553958, name: "Mhaisbad" },
      { id: 944457, name: "Mohadiwadi" },
      { id: 553913, name: "Mohili Inam" },
      { id: 553912, name: "Mohili Khalsa" },
      { id: 553820, name: "Mothe Bhal" },
      { id: 553830, name: "Mothe Vadhav" },
      { id: 553954, name: "Mouje Pale" },
      { id: 553984, name: "Mundhani" },
      { id: 553887, name: "Mungoshi" },
      { id: 553894, name: "Nagadi Sapoli" },
      { id: 553935, name: "Nanegaon" },
      { id: 553827, name: "Narwel" },
      { id: 944454, name: "Navghar" },
      { id: 553869, name: "Navkhar" },
      { id: 553883, name: "Nidhavali" },
      { id: 944337, name: "Nifadwadi" },
      { id: 553964, name: "Nigade" },
      { id: 944455, name: "Nimbarwadi" },
      { id: 553867, name: "Niphad" },
      { id: 553834, name: "Odhangi" },
      { id: 553968, name: "Pabal" },
      { id: 553886, name: "Padale" },
      { id: 553951, name: "Panchgani" },
      { id: 553926, name: "Paned" },
      { id: 553963, name: "Patani Pandapur" },
      { id: 553836, name: "Patnoli" },
      { id: 553933, name: "Pen Gramin" },
      { id: 944456, name: "Phanaswadi" },
      { id: 553921, name: "Pimpalgaon" },
      { id: 553900, name: "Ramraj" },
      { id: 944458, name: "Rathichiwadi" },
      { id: 553863, name: "Rave" },
      { id: 553967, name: "Revoli" },
      { id: 553934, name: "Rode" },
      { id: 553961, name: "Salinde" },
      { id: 553920, name: "Sapoli Enam" },
      { id: 553847, name: "Sarebhag" },
      { id: 553918, name: "Sawarsai" },
      { id: 944459, name: "Shedashi Katkariwadi" },
      { id: 553931, name: "Shene" },
      { id: 553986, name: "Shetjui" },
      { id: 553985, name: "Shihu" },
      { id: 553848, name: "Shinganvat" },
      { id: 553840, name: "Shirki" },
      { id: 553841, name: "Shirkichawl" },
      { id: 553896, name: "Shitole" },
      { id: 553876, name: "Sonkhar" },
      { id: 553930, name: "Talavali" },
      { id: 553977, name: "Talekhar" },
      { id: 944906, name: "Tambadi" },
      { id: 553881, name: "Tambadshet" },
      { id: 553901, name: "Tarankhop" },
      { id: 553981, name: "Tarshet" },
      { id: 553940, name: "Tilore" },
      { id: 553856, name: "Turkhul" },
      { id: 553902, name: "Uchede" },
      { id: 553839, name: "Umbarde" },
      { id: 553877, name: "Urnilee" },
      { id: 553962, name: "Usar" },
      { id: 553907, name: "Vadgaon" },
      { id: 553888, name: "Valak" },
      { id: 943058, name: "Varvane Adiwasiwadi" },
      { id: 553821, name: "Vitthalwadi" },
      { id: 553828, name: "Wadhav" },
      { id: 553850, name: "Wadkhal" },
      { id: 553927, name: "Wakrul" },
      { id: 553971, name: "Warap" },
      { id: 553939, name: "Warawane" },
      { id: 553891, name: "Waredi" },
      { id: 553910, name: "Warsai" },
      { id: 553833, name: "Washi" },
      { id: 553916, name: "Washiwali" },
      { id: 553853, name: "Wave" },
      { id: 553932, name: "Wirani" },
      { id: 553990, name: "Zotirpada" },
    ],
    4177: [
      { id: 554186, name: "Agarkot" },
      { id: 554020, name: "Agarsure" },
      { id: 554146, name: "Akshi" },
      { id: 944236, name: "Alibag" },
      { id: 554082, name: "Ambeghar" },
      { id: 554203, name: "Ambepur" },
      { id: 554169, name: "Andoshi" },
      { id: 554009, name: "Awas" },
      { id: 554141, name: "Aweti" },
      { id: 942951, name: "Bagdanda" },
      { id: 554161, name: "Bagmala" },
      { id: 554037, name: "Bahiricha Pada" },
      { id: 554016, name: "Bahirole" },
      { id: 554153, name: "Bamangaon" },
      { id: 554073, name: "Bamanoli" },
      { id: 554021, name: "Bamansure" },
      { id: 554183, name: "Bapale" },
      { id: 554145, name: "Belkade" },
      { id: 554054, name: "Belkhar" },
      { id: 554181, name: "Beloshi" },
      { id: 554005, name: "Belpada" },
      { id: 554015, name: "Belvali" },
      { id: 554162, name: "Bhadane" },
      { id: 554051, name: "Bhaimala" },
      { id: 554108, name: "Bhakarwad" },
      { id: 554030, name: "Bhal" },
      { id: 554097, name: "Bhangar Dadaji" },
      { id: 554155, name: "Bherase" },
      { id: 554190, name: "Bhilji" },
      { id: 554049, name: "Bhisarai" },
      { id: 554196, name: "Bhonang" },
      { id: 944413, name: "Bhute" },
      { id: 554140, name: "Bidwagale" },
      { id: 553996, name: "Bodani" },
      { id: 554138, name: "Bopoli" },
      { id: 554189, name: "Borghar" },
      { id: 554024, name: "Boris" },
      { id: 943056, name: "Chandarwadi" },
      { id: 554061, name: "Chari" },
      { id: 554204, name: "Chendhare" },
      { id: 554119, name: "Chikhali" },
      { id: 554040, name: "Chinchawali" },
      { id: 554178, name: "Chinchoti" },
      { id: 942969, name: "Chondhi" },
      { id: 554177, name: "Choul" },
      { id: 554137, name: "Dalavi Kharoshi" },
      { id: 942950, name: "Dattapada" },
      { id: 554172, name: "Dawale" },
      { id: 554107, name: "Dehenkoni" },
      { id: 554174, name: "Deoghar" },
      { id: 554012, name: "Deotalai" },
      { id: 554179, name: "Deotalai Tarf Umate" },
      { id: 554149, name: "Dhavarpada" },
      { id: 554148, name: "Dhawar" },
      { id: 554092, name: "Dherand" },
      { id: 554007, name: "Dhokawade" },
      { id: 554104, name: "Dhuwadkhar" },
      { id: 554185, name: "Diviparangi" },
      { id: 554096, name: "Divlang" },
      { id: 554143, name: "Durgadarya" },
      { id: 943057, name: "Dyanwadi" },
      { id: 554131, name: "Fanasapur" },
      { id: 554004, name: "Fufadevi Pada" },
      { id: 554067, name: "Gan Tarf Parhur" },
      { id: 554078, name: "Gan Tarf Shrigaon" },
      { id: 554106, name: "Gavali Kotha" },
      { id: 554060, name: "Gavkhar" },
      { id: 554101, name: "Ghasawad" },
      { id: 554166, name: "Ghotawade" },
      { id: 554089, name: "Gondhalpada" },
      { id: 554056, name: "Gopachari" },
      { id: 554068, name: "Gotheghar" },
      { id: 554152, name: "Gothi" },
      { id: 554025, name: "Gunjis" },
      { id: 554033, name: "Hashiware" },
      { id: 554135, name: "Hemnagar" },
      { id: 945121, name: "Indrape" },
      { id: 554128, name: "Jalashi" },
      { id: 554014, name: "Jambhulpada" },
      { id: 554105, name: "Juibapuji" },
      { id: 554118, name: "Juigavali" },
      { id: 554116, name: "Kachali" },
      { id: 554077, name: "Kaloshi" },
      { id: 554114, name: "Kalwadkhar" },
      { id: 554052, name: "Kamarle" },
      { id: 942967, name: "Kamath" },
      { id: 554058, name: "Kandavira" },
      { id: 554013, name: "Kankeshwar" },
      { id: 554075, name: "Karle" },
      { id: 945122, name: "Katalpada" },
      { id: 554003, name: "Kawade" },
      { id: 554151, name: "Kawir" },
      { id: 554046, name: "Keakichamala" },
      { id: 554163, name: "Khanav" },
      { id: 554086, name: "Khandale" },
      { id: 553993, name: "Khanderi" },
      { id: 554044, name: "Khar Pedhambe" },
      { id: 554122, name: "Khatwira" },
      { id: 554062, name: "Khidki" },
      { id: 554057, name: "Khopanekhar" },
      { id: 554022, name: "Kihim" },
      { id: 553992, name: "Kolgaon" },
      { id: 554136, name: "Kolghar" },
      { id: 554063, name: "Kopar" },
      { id: 554130, name: "Kopari" },
      { id: 553995, name: "Koproli" },
      { id: 554199, name: "Kude" },
      { id: 554164, name: "Kune" },
      { id: 554134, name: "Kurdus" },
      { id: 554080, name: "Kurkundi Koltembhi" },
      { id: 554205, name: "Kurul" },
      { id: 554121, name: "Kusumbale" },
      { id: 554059, name: "Laxmiprasad" },
      { id: 554055, name: "Lebhi" },
      { id: 554053, name: "Lonakotha" },
      { id: 554072, name: "Lonare" },
      { id: 942990, name: "Longhar" },
      { id: 554182, name: "Mahajane" },
      { id: 554202, name: "Mahan" },
      { id: 554194, name: "Malade" },
      { id: 554167, name: "Malyan" },
      { id: 554071, name: "Man Tarf Zirad" },
      { id: 554041, name: "Mandavakhar" },
      { id: 554170, name: "Mandave Tarf Bamangaon" },
      { id: 553994, name: "Mandave Tarfe Zirad" },
      { id: 554036, name: "Mankule" },
      { id: 554017, name: "Mapgaon" },
      { id: 554115, name: "Medhekhar" },
      { id: 554006, name: "Mhatroli" },
      { id: 554000, name: "Milkatkhar" },
      { id: 554124, name: "Mondvira" },
      { id: 554188, name: "Morkhol" },
      { id: 554192, name: "Moronde" },
      { id: 554074, name: "Mule" },
      { id: 554026, name: "Munawali" },
      { id: 554018, name: "Mushet" },
      { id: 554159, name: "Nagaon" },
      { id: 554113, name: "Nagazari" },
      { id: 942976, name: "Nandaipada" },
      { id: 554038, name: "Narangi" },
      { id: 909448, name: "Narangikhar" },
      { id: 554198, name: "Navakhar Tarf Umate" },
      { id: 553991, name: "Navedar Kolgaon" },
      { id: 554147, name: "Navedarbeli" },
      { id: 554110, name: "Navenagar" },
      { id: 554094, name: "Navkhar Rayande" },
      { id: 554133, name: "Navkhar Tarf Shrigaon" },
      { id: 554087, name: "Nehuli" },
      { id: 554023, name: "Nevedar Navagaon" },
      { id: 554091, name: "Nigade" },
      { id: 554048, name: "Palambe" },
      { id: 945844, name: "Palav" },
      { id: 554158, name: "Palhe" },
      { id: 554069, name: "Parhur" },
      { id: 554070, name: "Parhurpada" },
      { id: 554084, name: "Pavele" },
      { id: 554176, name: "Pazar" },
      { id: 554045, name: "Pedhambe" },
      { id: 554095, name: "Pezari" },
      { id: 554187, name: "Phanaspur Tarf Umate" },
      { id: 554042, name: "Phopheri" },
      { id: 554117, name: "Pitakiri" },
      { id: 554109, name: "Poynad" },
      { id: 554201, name: "Rajewadi" },
      { id: 554035, name: "Ramkotha" },
      { id: 554193, name: "Ramraj" },
      { id: 554039, name: "Ranjankhar" },
      { id: 554001, name: "Ranjankhar Davali" },
      { id: 944414, name: "Ranjanpada" },
      { id: 554129, name: "Ravet" },
      { id: 554081, name: "Rayande" },
      { id: 554160, name: "Revdanda" },
      { id: 554002, name: "Rewas" },
      { id: 554139, name: "Ruishet Bhomoli" },
      { id: 554083, name: "Rule" },
      { id: 554076, name: "Sagaon" },
      { id: 554112, name: "Sagargad" },
      { id: 554150, name: "Sahan" },
      { id: 554142, name: "Sambari" },
      { id: 553999, name: "Saral" },
      { id: 554008, name: "Sasawane" },
      { id: 554047, name: "Satghar" },
      { id: 554019, name: "Satirje" },
      { id: 554100, name: "Shahabaj" },
      { id: 554093, name: "Shahapur" },
      { id: 909682, name: "Shivsangh" },
      { id: 554123, name: "Shrigaon" },
      { id: 554132, name: "Simadevi" },
      { id: 554027, name: "Sogaon" },
      { id: 554034, name: "Sonakothakhar" },
      { id: 554200, name: "Sudkoli" },
      { id: 554171, name: "Surai" },
      { id: 554010, name: "Surekhar" },
      { id: 554066, name: "Sutarpada" },
      { id: 554099, name: "Tadacha Kotha" },
      { id: 554126, name: "Tadwagale" },
      { id: 554195, name: "Tajpur" },
      { id: 554102, name: "Talanikhar" },
      { id: 554127, name: "Talashet" },
      { id: 554050, name: "Talavade" },
      { id: 554085, name: "Talavali Tarf Khandala" },
      { id: 554197, name: "Talavali Tarf Umate" },
      { id: 554098, name: "Talband" },
      { id: 944412, name: "Tekali" },
      { id: 554031, name: "Thal" },
      { id: 945843, name: "Theronda" },
      { id: 554028, name: "Tudal" },
      { id: 554191, name: "Umate" },
      { id: 554165, name: "Usar" },
      { id: 554090, name: "Vadgaon" },
      { id: 554154, name: "Vadhav Bk." },
      { id: 554157, name: "Vadhav Kh" },
      { id: 554111, name: "Vaghode" },
      { id: 554065, name: "Vagholi" },
      { id: 554032, name: "Vaijali" },
      { id: 554029, name: "Vaishet" },
      { id: 554173, name: "Vanwali" },
      { id: 554175, name: "Varande" },
      { id: 554144, name: "Varasoli" },
      { id: 554184, name: "Vaskhar" },
      { id: 554168, name: "Vave" },
      { id: 554088, name: "Veshvi" },
      { id: 553998, name: "Virtasaral" },
      { id: 554125, name: "Wadawali" },
      { id: 554064, name: "Wagholiwadi" },
      { id: 554043, name: "Waghran" },
      { id: 554120, name: "Waghwira" },
      { id: 554103, name: "Walawade" },
      { id: 554180, name: "Walawali" },
      { id: 554156, name: "Welhavali" },
      { id: 553997, name: "Yelwane" },
      { id: 554011, name: "Zirad" },
      { id: 945123, name: "Ziradpada" },
    ],
    4178: [
      { id: 554243, name: "Aadi" },
      { id: 554211, name: "Abitghar" },
      { id: 554240, name: "Adad" },
      { id: 554271, name: "Agardanda" },
      { id: 554222, name: "Amali" },
      { id: 554267, name: "Amboli" },
      { id: 554250, name: "Araoghar" },
      { id: 554216, name: "Barashiv" },
      { id: 554228, name: "Bhoighar" },
      { id: 554213, name: "Borli" },
      { id: 554210, name: "Cheher" },
      { id: 942957, name: "Chikani" },
      { id: 554231, name: "Chordhe" },
      { id: 554242, name: "Donde Tarfe Nandgaon" },
      { id: 554265, name: "Dongari" },
      { id: 554264, name: "Eakdara" },
      { id: 554272, name: "Haphijkhar" },
      { id: 943060, name: "Jamrutkhar" },
      { id: 554262, name: "Josranjan" },
      { id: 554221, name: "Kakalghar" },
      { id: 554235, name: "Karambeli" },
      { id: 554236, name: "Kashid" },
      { id: 554277, name: "Khamde" },
      { id: 554244, name: "Khardodkule" },
      { id: 554245, name: "Kharikwada" },
      { id: 945124, name: "Kharshet" },
      { id: 554263, name: "Khatibkhar" },
      { id: 554215, name: "Kolmandala" },
      { id: 554206, name: "Korlai" },
      { id: 554259, name: "Mahalor" },
      { id: 554220, name: "Mahalunge Bk." },
      { id: 554219, name: "Mahalunge Kh." },
      { id: 554218, name: "Mandala" },
      { id: 554251, name: "Mazgaon" },
      { id: 554278, name: "Mithagar" },
      { id: 554209, name: "Mithekhar" },
      { id: 554253, name: "More" },
      { id: 554255, name: "Murud" },
      { id: 554260, name: "Nagshet" },
      { id: 554273, name: "Nandale" },
      { id: 554246, name: "Nandgaon" },
      { id: 554208, name: "Nidi" },
      { id: 554229, name: "Pargan" },
      { id: 554266, name: "Rajpuri" },
      { id: 554258, name: "Saigaon" },
      { id: 554207, name: "Salav" },
      { id: 554252, name: "Sarane" },
      { id: 554237, name: "Sarve" },
      { id: 554226, name: "Satirde" },
      { id: 554232, name: "Savroli" },
      { id: 554276, name: "Sawali" },
      { id: 554261, name: "Shighre" },
      { id: 554224, name: "Shirgaon" },
      { id: 554238, name: "Supegaon" },
      { id: 554214, name: "Surai" },
      { id: 554230, name: "Tadgaon" },
      { id: 554212, name: "Talavali" },
      { id: 554234, name: "Tale" },
      { id: 554233, name: "Talekhar" },
      { id: 554256, name: "Telawade" },
      { id: 554217, name: "Tembhorde" },
      { id: 554269, name: "Tisle" },
      { id: 554275, name: "Tokekhar" },
      { id: 554268, name: "Undargaon" },
      { id: 554274, name: "Usadi" },
      { id: 554241, name: "Usroli" },
      { id: 554248, name: "Velaste" },
      { id: 554254, name: "Vihour" },
      { id: 554239, name: "Wadghar" },
      { id: 554225, name: "Walake" },
      { id: 554247, name: "Walwati" },
      { id: 554270, name: "Wande" },
      { id: 554227, name: "Wandeli" },
      { id: 554249, name: "Wave" },
      { id: 554257, name: "Wawdungi" },
      { id: 554223, name: "Yesade" },
    ],
    4179: [
      { id: 943037, name: "Aambiwali Adiwasiwadi" },
      { id: 554341, name: "Ainghar" },
      { id: 554379, name: "Ainwahal" },
      { id: 554399, name: "Ambewadi" },
      { id: 554395, name: "Ambivali" },
      { id: 554346, name: "Amdoshi" },
      { id: 554292, name: "Are Bk." },
      { id: 554291, name: "Are Kh." },
      { id: 554414, name: "Ashtami" },
      { id: 554386, name: "Bahe" },
      { id: 944486, name: "Bahershiv" },
      { id: 554378, name: "Balhe" },
      { id: 554344, name: "Balsai" },
      { id: 554312, name: "Belkhar" },
      { id: 554444, name: "Bhalagaon" },
      { id: 554287, name: "Bhatsai" },
      { id: 554348, name: "Bhise" },
      { id: 554447, name: "Bhuwaneshwar" },
      { id: 554308, name: "Birwadi" },
      { id: 554321, name: "Bobadghar" },
      { id: 554418, name: "Borghar" },
      { id: 554302, name: "Chandgaon" },
      { id: 554309, name: "Chanera" },
      { id: 944482, name: "Cherathi" },
      { id: 554336, name: "Chikani" },
      { id: 554369, name: "Chilhe" },
      { id: 554377, name: "Chinchawali Tarf Atone" },
      { id: 554405, name: "Chinchawali Tarf Diwali" },
      { id: 554280, name: "Dapoli" },
      { id: 554367, name: "Devakanhe" },
      { id: 554394, name: "Dhagadwadi" },
      { id: 554356, name: "Dhamansai" },
      { id: 554368, name: "Dhankanhe" },
      { id: 554448, name: "Dhatav" },
      { id: 554311, name: "Dhondkhar Tarf Birwadi" },
      { id: 554279, name: "Dhondkhar Tarf Umate" },
      { id: 554297, name: "Div" },
      { id: 554380, name: "Dolavahal" },
      { id: 554285, name: "Dongari" },
      { id: 942952, name: "Dongarwadi" },
      { id: 554397, name: "Durtoli" },
      { id: 944339, name: "Fugarewadi" },
      { id: 554391, name: "Gaulwadi" },
      { id: 943051, name: "Gaulwadi Adiwasiwadi" },
      { id: 554374, name: "Gherasurgad" },
      { id: 554430, name: "Ghosale" },
      { id: 554343, name: "Godasai" },
      { id: 554433, name: "Gopalwat" },
      { id: 554294, name: "Gophan" },
      { id: 554387, name: "Gove" },
      { id: 944481, name: "Goyandawadi" },
      { id: 554441, name: "Hal" },
      { id: 554340, name: "Hedawali" },
      { id: 554406, name: "Hetavane" },
      { id: 945126, name: "Jai Dhakoba Nivi Thakurwadi" },
      { id: 554408, name: "Jamgaon" },
      { id: 554333, name: "Kadsure" },
      { id: 944476, name: "Kalkaiwadi" },
      { id: 554392, name: "Kamath" },
      { id: 554376, name: "Kandale" },
      { id: 554442, name: "Kandane Bk." },
      { id: 554443, name: "Kandane Kh." },
      { id: 554342, name: "Kansai" },
      { id: 554432, name: "Kanti" },
      { id: 554296, name: "Karanjvira" },
      { id: 554420, name: "Karivane" },
      { id: 944474, name: "Katalawadi" },
      { id: 554429, name: "Kawalthe" },
      { id: 554431, name: "Kelghar" },
      { id: 554317, name: "Khairale" },
      { id: 554307, name: "Khaire Kh." },
      { id: 554445, name: "Khajani" },
      { id: 554372, name: "Khamb" },
      { id: 554323, name: "Khambere" },
      { id: 554320, name: "Khandar" },
      { id: 944480, name: "Kharabachi Wadi" },
      { id: 554360, name: "Kharapati" },
      { id: 554290, name: "Khargaon" },
      { id: 554411, name: "Khari" },
      { id: 554313, name: "Kharkhardi" },
      { id: 554316, name: "Khope" },
      { id: 554310, name: "Khutal" },
      { id: 554421, name: "Killa" },
      { id: 944477, name: "Killawadi" },
      { id: 554314, name: "Kokban" },
      { id: 554398, name: "Kolad" },
      { id: 944343, name: "Kolad Adiwasiwadi" },
      { id: 554329, name: "Kondgaon" },
      { id: 944479, name: "Krushnanagar" },
      { id: 554396, name: "Kudali" },
      { id: 554293, name: "Kumbhoshi" },
      { id: 554424, name: "Landhar" },
      { id: 554381, name: "Madhali Bk." },
      { id: 554353, name: "Madhali Kh." },
      { id: 943038, name: "Mahadevwadi" },
      { id: 554301, name: "Mahalunge" },
      { id: 554358, name: "Malsai" },
      { id: 554352, name: "Medha" },
      { id: 554325, name: "Mhasadi" },
      { id: 554434, name: "Muchane" },
      { id: 554437, name: "Mukte" },
      { id: 554383, name: "Muthavali Bk." },
      { id: 554362, name: "Muthavali Kh" },
      { id: 554371, name: "Nadawali" },
      { id: 554446, name: "Nagothane" },
      { id: 554300, name: "Nawakhar" },
      { id: 554390, name: "Neharunagar" },
      { id: 554299, name: "Nhave" },
      { id: 554351, name: "Nidi Tarf Ashtami" },
      { id: 554331, name: "Nidi Tarf Nagothane" },
      { id: 554416, name: "Nivi" },
      { id: 554361, name: "Padam" },
      { id: 554407, name: "Pahoor" },
      { id: 554328, name: "Palas" },
      { id: 554400, name: "Pale Bk." },
      { id: 554422, name: "Pale Kh." },
      { id: 554349, name: "Pale Tarf Ashtami" },
      { id: 554306, name: "Pangaloli" },
      { id: 554337, name: "Patansai" },
      { id: 554409, name: "Patharshet" },
      { id: 554326, name: "Pigonde" },
      { id: 944484, name: "Pimpalgaon" },
      { id: 554359, name: "Pingalsai" },
      { id: 554382, name: "Pugaon" },
      { id: 554388, name: "Pui" },
      { id: 944342, name: "Rajkhalati" },
      { id: 554347, name: "Revoli" },
      { id: 554413, name: "Roha" },
      { id: 554366, name: "Roth Bk." },
      { id: 554365, name: "Roth Kh." },
      { id: 554401, name: "Sambhe" },
      { id: 554282, name: "Sanegaon" },
      { id: 554363, name: "Sangade" },
      { id: 554318, name: "Sarsoli" },
      { id: 554295, name: "Shedsai" },
      { id: 554286, name: "Shenvai" },
      { id: 944341, name: "Shenvai Adiwasiwadi" },
      { id: 554327, name: "Shetpalas" },
      { id: 554315, name: "Shiloshi" },
      { id: 554384, name: "Shirawali" },
      { id: 554355, name: "Songaon" },
      { id: 554298, name: "Sonkhar" },
      { id: 554319, name: "Sudakoli" },
      { id: 554357, name: "Sukeli" },
      { id: 944338, name: "Sukhadarwadi" },
      { id: 554417, name: "Talaghar" },
      { id: 554303, name: "Talavade" },
      { id: 554370, name: "Talawali Tarf Ashtami" },
      { id: 554403, name: "Talawali Tarf Diwali" },
      { id: 554304, name: "Talawali Tarf Ghosale" },
      { id: 554428, name: "Tambadi" },
      { id: 554427, name: "Tambadiwadi" },
      { id: 554426, name: "Tamhanshet" },
      { id: 554339, name: "Tamsoli" },
      { id: 554410, name: "Tareghar" },
      { id: 554324, name: "Temghar" },
      { id: 554404, name: "Tise" },
      { id: 943052, name: "Titaviwadi" },
      { id: 554435, name: "Uchel" },
      { id: 554364, name: "Udadavane" },
      { id: 554305, name: "Usar" },
      { id: 554373, name: "Vaijnath" },
      { id: 554436, name: "Virjoli" },
      { id: 554375, name: "Vitthalwadi" },
      { id: 944340, name: "Waghali" },
      { id: 554438, name: "Wali" },
      { id: 554354, name: "Wandoli" },
      { id: 945125, name: "Wandoli Adivasiwadi" },
      { id: 554345, name: "Wangani" },
      { id: 554334, name: "Wani" },
      { id: 554402, name: "Warasgaon" },
      { id: 554412, name: "Warathi" },
      { id: 554350, name: "Waravade" },
      { id: 554335, name: "Waravatane" },
      { id: 554415, name: "Warse" },
      { id: 554330, name: "Wasgaon" },
      { id: 554419, name: "Washi" },
      { id: 554283, name: "Wavekhar" },
      { id: 554284, name: "Wavepotge" },
      { id: 554338, name: "Wazaroli" },
      { id: 554332, name: "Welshet" },
      { id: 554281, name: "Yashwantkhar" },
      { id: 554393, name: "Yeral" },
      { id: 554289, name: "Zolambe" },
      { id: 554288, name: "Zolambewadi" },
    ],
    4180: [
      { id: 554526, name: "Adulse" },
      { id: 554529, name: "Ambivali" },
      { id: 554509, name: "Ambole" },
      { id: 554465, name: "Amnori" },
      { id: 554519, name: "Apatwane" },
      { id: 554488, name: "Asare" },
      { id: 554543, name: "Atone" },
      { id: 554475, name: "Avandhe" },
      { id: 942964, name: "Bahirampada" },
      { id: 554504, name: "Balap" },
      { id: 554540, name: "Balhe" },
      { id: 554491, name: "Bhalgul" },
      { id: 554528, name: "Bharje" },
      { id: 944487, name: "Bhavshet" },
      { id: 554457, name: "Bheliv" },
      { id: 554485, name: "Bherav" },
      { id: 554493, name: "Bhilpada" },
      { id: 554506, name: "Burmali" },
      { id: 554468, name: "Chandargaon" },
      { id: 554501, name: "Chikhalgaon" },
      { id: 554494, name: "Chive" },
      { id: 554466, name: "Dahigaon" },
      { id: 554508, name: "Dapode" },
      { id: 554533, name: "Daryagaon" },
      { id: 554464, name: "Dhokshet" },
      { id: 554489, name: "Dhondivali" },
      { id: 554525, name: "Dhondse" },
      { id: 554539, name: "Dighewadi" },
      { id: 554456, name: "Falyan" },
      { id: 554510, name: "Gherasarasgad" },
      { id: 554524, name: "Gherasudhagad" },
      { id: 554453, name: "Ghotawade" },
      { id: 554541, name: "Gomashi" },
      { id: 554530, name: "Gondale" },
      { id: 554450, name: "Gondav" },
      { id: 554479, name: "Harneri" },
      { id: 554449, name: "Hatond" },
      { id: 554477, name: "Hedvali" },
      { id: 909687, name: "Jambulpada" },
      { id: 554481, name: "Kalamb" },
      { id: 554542, name: "Kalamboshi" },
      { id: 554490, name: "Kanhivali" },
      { id: 554476, name: "Kansal" },
      { id: 554498, name: "Karanjghar" },
      { id: 554461, name: "Karchunde" },
      { id: 554487, name: "Kasarwadi" },
      { id: 554472, name: "Kavele" },
      { id: 554535, name: "Khadsambale" },
      { id: 554467, name: "Khandpoli" },
      { id: 554522, name: "Khandsai" },
      { id: 554483, name: "Khavali" },
      { id: 554546, name: "Koshimbale" },
      { id: 554473, name: "Kumbharghar" },
      { id: 554502, name: "Kumbharshet" },
      { id: 554516, name: "Madhali" },
      { id: 554469, name: "Mahagaon" },
      { id: 554495, name: "Majare Jambhulpada" },
      { id: 554455, name: "Mangaon Bk" },
      { id: 554458, name: "Mangaon Kh" },
      { id: 554480, name: "Mulashi" },
      { id: 554523, name: "Nadsur" },
      { id: 554544, name: "Nagaon" },
      { id: 554545, name: "Nagshet" },
      { id: 554538, name: "Nandgaon" },
      { id: 554451, name: "Nanose" },
      { id: 554514, name: "Navghar" },
      { id: 554536, name: "Nenavali" },
      { id: 554452, name: "Nere" },
      { id: 554532, name: "Pachhapur" },
      { id: 554463, name: "Padghawali" },
      { id: 554471, name: "Padsare" },
      { id: 909688, name: "Pali" },
      { id: 554462, name: "Parali" },
      { id: 554460, name: "Pawasalawadi" },
      { id: 554486, name: "Pedali" },
      { id: 554499, name: "Pilosari" },
      { id: 554537, name: "Pimploli" },
      { id: 554534, name: "Potlaj Bk." },
      { id: 554531, name: "Potlaj Kh." },
      { id: 554527, name: "Pui" },
      { id: 554503, name: "Rabgaon" },
      { id: 554511, name: "Rasal" },
      { id: 943034, name: "Sharadnagar" },
      { id: 554515, name: "Shiloshi" },
      { id: 554521, name: "Siddheshwar Bk" },
      { id: 554518, name: "Siddheshwar Kh" },
      { id: 554470, name: "Tadgaon" },
      { id: 554492, name: "Tivare" },
      { id: 943036, name: "Torangaon" },
      { id: 554482, name: "Uddhar" },
      { id: 554500, name: "Unhere Bk" },
      { id: 554505, name: "Unhere Kh" },
      { id: 554512, name: "Usale" },
      { id: 554517, name: "Usar" },
      { id: 554459, name: "Vasunde" },
      { id: 554484, name: "Wafeghar" },
      { id: 554474, name: "Waghoshi" },
      { id: 943032, name: "Wakangaon" },
      { id: 554513, name: "Wandroshi" },
      { id: 554496, name: "Wave Tarf Haveli" },
      { id: 554454, name: "Wave Tarfe Asare" },
      { id: 554520, name: "Wavloli" },
      { id: 554497, name: "Widsai" },
      { id: 554507, name: "Zap" },
    ],
    4181: [
      { id: 943008, name: "Adarshnagar" },
      { id: 554670, name: "Adghar" },
      { id: 554705, name: "Alsunde" },
      { id: 554712, name: "Ambarle" },
      { id: 554635, name: "Amdoshi" },
      { id: 944488, name: "Bahirichiwadi" },
      { id: 554571, name: "Bamangaon" },
      { id: 554642, name: "Bamnoli" },
      { id: 554552, name: "Bedgaon" },
      { id: 554644, name: "Bhadav" },
      { id: 554555, name: "Bhagad" },
      { id: 554567, name: "Bhale" },
      { id: 554689, name: "Bhanadare" },
      { id: 554730, name: "Bhandavali" },
      { id: 554719, name: "Bhintad" },
      { id: 554608, name: "Bhuvan" },
      { id: 554565, name: "Bondshet" },
      { id: 554575, name: "Borawali" },
      { id: 554634, name: "Borghar Tarf Kharavali" },
      { id: 554657, name: "Borle" },
      { id: 554579, name: "Chach" },
      { id: 554701, name: "Chandore" },
      { id: 554598, name: "Channat" },
      { id: 554673, name: "Chapadi" },
      { id: 944331, name: "Chervali" },
      { id: 554697, name: "Chinchavali" },
      { id: 554682, name: "Dahivali Tarf Govele" },
      { id: 554681, name: "Dahivalikond" },
      { id: 554593, name: "Dakhane" },
      { id: 554666, name: "Degaon" },
      { id: 554728, name: "Devali" },
      { id: 944463, name: "Devalikond" },
      { id: 554680, name: "Dhaksheli" },
      { id: 554651, name: "Dhalghar" },
      { id: 554582, name: "Dhamani" },
      { id: 554663, name: "Dongroli" },
      { id: 944461, name: "Ekatanagar" },
      { id: 944462, name: "Eklavyanagar" },
      { id: 554732, name: "Falani" },
      { id: 554604, name: "Gangawali" },
      { id: 554669, name: "Garal" },
      { id: 554607, name: "Gharoshi" },
      { id: 554609, name: "Ghotval" },
      { id: 554734, name: "Goregaon" },
      { id: 554703, name: "Govele" },
      { id: 554702, name: "Govelekond" },
      { id: 554723, name: "Harkol" },
      { id: 554722, name: "Harkolkond" },
      { id: 942997, name: "Harnewadi" },
      { id: 554597, name: "Harwandi" },
      { id: 554647, name: "Hatkeli" },
      { id: 554645, name: "Hodgaon" },
      { id: 554721, name: "Hurdi" },
      { id: 554616, name: "Indapur" },
      { id: 943012, name: "Indiranagar" },
      { id: 554649, name: "Javali" },
      { id: 554566, name: "Javathe" },
      { id: 554559, name: "Jite" },
      { id: 554600, name: "Jor" },
      { id: 554720, name: "Kachale" },
      { id: 554572, name: "Kadape" },
      { id: 554602, name: "Kadapur" },
      { id: 554660, name: "Kakal" },
      { id: 554640, name: "Kalamje" },
      { id: 554592, name: "Kalvan" },
      { id: 554569, name: "Kandalgaon Bk." },
      { id: 554564, name: "Kandalgaon Kh." },
      { id: 554599, name: "Karambeli" },
      { id: 554622, name: "Kashene" },
      { id: 554588, name: "Kashimbale Tarf Nijampur" },
      { id: 943005, name: "Katkari Gaon Sangi" },
      { id: 554691, name: "Kavilvahal Bk." },
      { id: 554690, name: "Kavilvahal Kh." },
      { id: 554578, name: "Kelgan" },
      { id: 554693, name: "Khadkoli" },
      { id: 554643, name: "Khandad" },
      { id: 554714, name: "Khandpale" },
      { id: 554631, name: "Kharavali" },
      { id: 554603, name: "Kharbachi Wadi" },
      { id: 554594, name: "Khardi Bk." },
      { id: 554646, name: "Khardi Kh." },
      { id: 554624, name: "Kolhan" },
      { id: 554626, name: "Koshimbale Tarf Tale" },
      { id: 554585, name: "Koste Bk." },
      { id: 554584, name: "Koste Kh." },
      { id: 554568, name: "Kumbharte" },
      { id: 554577, name: "Kumbhe" },
      { id: 554678, name: "Kumshet" },
      { id: 554686, name: "Kurwade" },
      { id: 554706, name: "Kushede Tarf Govele" },
      { id: 554630, name: "Kushede Tarf Tale" },
      { id: 554716, name: "Lakhapale" },
      { id: 554709, name: "Lonere" },
      { id: 554668, name: "Lonshi" },
      { id: 554725, name: "Madhegaon" },
      { id: 554664, name: "Mahadpoli" },
      { id: 554613, name: "Makti" },
      { id: 944468, name: "Malaikond" },
      { id: 554726, name: "Malaikondvani" },
      { id: 554573, name: "Maluste" },
      { id: 554652, name: "Mangaon" },
      { id: 554639, name: "Mangawali" },
      { id: 554694, name: "Mangrul" },
      { id: 554677, name: "Manjarwane" },
      { id: 554580, name: "Manjurne" },
      { id: 554581, name: "Mashidwadi" },
      { id: 554718, name: "Moor" },
      { id: 554665, name: "Morba" },
      { id: 554676, name: "Mudre" },
      { id: 554648, name: "Mugavali" },
      { id: 554591, name: "Muthavali Tarf Nijampur" },
      { id: 554619, name: "Muthavali Tarf Tale" },
      { id: 554708, name: "Nagaon" },
      { id: 554617, name: "Nagroli" },
      { id: 554636, name: "Naitane" },
      { id: 554674, name: "Nalephodi" },
      { id: 554731, name: "Nandvi" },
      { id: 554641, name: "Nanore" },
      { id: 943156, name: "Narayangaon" },
      { id: 554724, name: "Navashi" },
      { id: 554695, name: "Nhave" },
      { id: 554586, name: "Nijampur" },
      { id: 554611, name: "Nilaj" },
      { id: 554654, name: "Nilghun" },
      { id: 554618, name: "Nivi" },
      { id: 554667, name: "Pachole" },
      { id: 554713, name: "Pahel" },
      { id: 554606, name: "Palasgaon Bk." },
      { id: 943014, name: "Palasgaon Budruk Adiwasiwadi" },
      { id: 554601, name: "Palasgaon Kh." },
      { id: 554704, name: "Palsap" },
      { id: 554587, name: "Panaspe" },
      { id: 554710, name: "Panhalghar Bk" },
      { id: 554711, name: "Panhalghar Kh" },
      { id: 554595, name: "Panose" },
      { id: 554589, name: "Pansai" },
      { id: 554551, name: "Patnus" },
      { id: 554633, name: "Pen Tarf Tale" },
      { id: 554614, name: "Potner" },
      { id: 554727, name: "Purar" },
      { id: 554655, name: "Rajiwali" },
      { id: 943009, name: "Ramnagar" },
      { id: 945135, name: "Ramnagar Tarfe Madhegaon" },
      { id: 554675, name: "Ranavadekond" },
      { id: 554610, name: "Ratwad" },
      { id: 554548, name: "Rawalje" },
      { id: 554688, name: "Repoli" },
      { id: 554653, name: "Rile" },
      { id: 554615, name: "Rudravali" },
      { id: 554662, name: "Sai" },
      { id: 554549, name: "Saje" },
      { id: 554576, name: "Sakhalewadi" },
      { id: 554628, name: "Sale" },
      { id: 554596, name: "Salve" },
      { id: 554553, name: "Sanaswadi" },
      { id: 554557, name: "Sangi" },
      { id: 554699, name: "Shilim" },
      { id: 554679, name: "Shirawali Tarf Govele" },
      { id: 554560, name: "Shirawali Tarf Nijampur" },
      { id: 554570, name: "Shirsad" },
      { id: 943013, name: "Shivnagar" },
      { id: 943007, name: "Somjainagar" },
      { id: 554638, name: "Surav Tarf Nijampur" },
      { id: 554637, name: "Surav Tarf Tala" },
      { id: 554656, name: "Surle" },
      { id: 943011, name: "Surlewadi" },
      { id: 554621, name: "Talashet" },
      { id: 554687, name: "Talegaon" },
      { id: 554605, name: "Tamhane Tarf Goregaon" },
      { id: 554683, name: "Tarne Tarf Govele" },
      { id: 554563, name: "Tasgaon" },
      { id: 942999, name: "Tasgaon Adiwasiwadi" },
      { id: 554715, name: "Tempale" },
      { id: 554561, name: "Tharmari" },
      { id: 554627, name: "Tilore" },
      { id: 554574, name: "Titave" },
      { id: 554729, name: "Tol Kh" },
      { id: 554620, name: "Umaroli Tarfe Diwali" },
      { id: 554629, name: "Umaroli Tarfe Kharawali" },
      { id: 554558, name: "Umbardi" },
      { id: 554672, name: "Unegaon" },
      { id: 554661, name: "Usar Bk." },
      { id: 554696, name: "Usarghar" },
      { id: 554733, name: "Utekhol" },
      { id: 554554, name: "Varchi Wadi" },
      { id: 554659, name: "Vihule" },
      { id: 554658, name: "Vihulekond" },
      { id: 554550, name: "Vile" },
      { id: 944471, name: "Vitthalnagar" },
      { id: 554698, name: "Wadawali" },
      { id: 554684, name: "Wadgaon" },
      { id: 554685, name: "Wadghar" },
      { id: 554700, name: "Wadghar Tarfe Goregaon" },
      { id: 554590, name: "Wadhawan" },
      { id: 554717, name: "Wadpale" },
      { id: 554692, name: "Waghose" },
      { id: 554707, name: "Waki Tarf Govale" },
      { id: 554583, name: "Waki Tarf Nijampur" },
      { id: 554625, name: "Warak" },
      { id: 943033, name: "Warak Adiwasiwadi" },
      { id: 554612, name: "Wave Diwali" },
      { id: 554671, name: "Wave Tarf Nijampur" },
      { id: 554623, name: "Wighavali" },
      { id: 554650, name: "Winchavali" },
      { id: 554556, name: "Yelwade" },
      { id: 554562, name: "Yerad" },
    ],
    4182: [
      { id: 554781, name: "Adnale" },
      { id: 554764, name: "Ambeli" },
      { id: 943189, name: "Anandwadi" },
      { id: 944344, name: "Bahulewadi" },
      { id: 554775, name: "Bamanghar" },
      { id: 554736, name: "Barpe" },
      { id: 554772, name: "Belghar" },
      { id: 554782, name: "Bhanang" },
      { id: 554760, name: "Borgharhaveli" },
      { id: 554788, name: "Borichamal" },
      { id: 554787, name: "Charai Bk." },
      { id: 554784, name: "Charai Kh." },
      { id: 554790, name: "Choravali" },
      { id: 554796, name: "Dahivali Tarf Tale" },
      { id: 554792, name: "Ganeshnagar" },
      { id: 554780, name: "Gaulwadi" },
      { id: 554751, name: "Girne" },
      { id: 943187, name: "Hanuman Nagar" },
      { id: 554778, name: "Kakadshet" },
      { id: 554777, name: "Kalamshet" },
      { id: 554779, name: "Kalsambade" },
      { id: 554794, name: "Kasekhol" },
      { id: 554773, name: "Khairat" },
      { id: 554757, name: "Khambavali" },
      { id: 554743, name: "Kista Ketke" },
      { id: 554747, name: "Kondthare" },
      { id: 554740, name: "Korkhanda" },
      { id: 554755, name: "Kude" },
      { id: 944424, name: "Kumbhale" },
      { id: 554737, name: "Mahagaon" },
      { id: 554735, name: "Mahure" },
      { id: 554791, name: "Majgaon" },
      { id: 554750, name: "Malathe" },
      { id: 554771, name: "Maluk" },
      { id: 554754, name: "Mandad" },
      { id: 554749, name: "Medhe" },
      { id: 554739, name: "Mhasadi" },
      { id: 554752, name: "Nanvali" },
      { id: 554745, name: "Nigudshet" },
      { id: 554776, name: "Pachghar" },
      { id: 554738, name: "Padhavan" },
      { id: 554789, name: "Panheli" },
      { id: 554746, name: "Phalshet Karnala" },
      { id: 554767, name: "Pitsai" },
      { id: 944425, name: "Pitsaikond" },
      { id: 554753, name: "Rahatad" },
      { id: 554763, name: "Ranechi Wadi" },
      { id: 554768, name: "Rowala" },
      { id: 943188, name: "Saidham" },
      { id: 554742, name: "Salshet" },
      { id: 554766, name: "Shenate" },
      { id: 554756, name: "Shenawali" },
      { id: 554761, name: "Sonsade" },
      { id: 554759, name: "Tala" },
      { id: 554785, name: "Talegaon Tarf Tale" },
      { id: 554774, name: "Tambadi" },
      { id: 554793, name: "Tamhane Tarf Tale" },
      { id: 554758, name: "Tarne Tarf Tale" },
      { id: 554748, name: "Tokarde" },
      { id: 554786, name: "Usar Kh." },
      { id: 554741, name: "Vinawali" },
      { id: 554783, name: "Vrindavan" },
      { id: 554765, name: "Wanaste" },
      { id: 554795, name: "Wanjloshi" },
      { id: 554770, name: "Waral" },
      { id: 554769, name: "Washihaveli" },
      { id: 554744, name: "Washimahagaon" },
      { id: 554762, name: "Wavehaveli" },
      { id: 554797, name: "Wavemandraj" },
    ],
    4183: [
      { id: 554804, name: "Aadgaon" },
      { id: 554851, name: "Aarathi" },
      { id: 554821, name: "Aasuf" },
      { id: 554870, name: "Bagmandale" },
      { id: 554841, name: "Bapavali" },
      { id: 554852, name: "Bapavan" },
      { id: 554820, name: "Bharadkhol" },
      { id: 554840, name: "Bhardoli" },
      { id: 554847, name: "Bhattichamal" },
      { id: 554812, name: "Bhave" },
      { id: 554845, name: "Bhoste" },
      { id: 554827, name: "Borle" },
      { id: 554876, name: "Borli Panchatan" },
      { id: 554834, name: "Chikhalap" },
      { id: 554869, name: "Danda" },
      { id: 554822, name: "Dandguri" },
      { id: 554868, name: "Devghar" },
      { id: 554828, name: "Devkhol" },
      { id: 554874, name: "Dharavali" },
      { id: 554800, name: "Dighi" },
      { id: 554814, name: "Diveagar" },
      { id: 554857, name: "Galsure" },
      { id: 554854, name: "Gani" },
      { id: 554862, name: "Gaulwadi" },
      { id: 554842, name: "Guladhe" },
      { id: 554806, name: "Harvit" },
      { id: 554833, name: "Hunarveli" },
      { id: 554844, name: "Jasavali" },
      { id: 554856, name: "Javele" },
      { id: 554865, name: "Kalinje" },
      { id: 554853, name: "Kandane" },
      { id: 554815, name: "Kapoli" },
      { id: 554875, name: "Karivane" },
      { id: 554802, name: "Karlas" },
      { id: 554819, name: "Karle" },
      { id: 554836, name: "Khargaon" },
      { id: 554811, name: "Kharshet" },
      { id: 554846, name: "Kherdi" },
      { id: 554818, name: "Khujare" },
      { id: 554872, name: "Kolmandale A" },
      { id: 554871, name: "Kolmandale B" },
      { id: 554816, name: "Kondhe Panchatan" },
      { id: 554855, name: "Kondhe Tarfe Shrivardhan" },
      { id: 554824, name: "Kondivali" },
      { id: 554803, name: "Kudgaon" },
      { id: 554807, name: "Kudki" },
      { id: 554805, name: "Kunbiwadi" },
      { id: 554866, name: "Kuravade" },
      { id: 554831, name: "Mamavali" },
      { id: 554799, name: "Maneri" },
      { id: 554867, name: "Maral" },
      { id: 554832, name: "Meghare" },
      { id: 554808, name: "Mul Velas" },
      { id: 554829, name: "Nagloli" },
      { id: 554798, name: "Nanavali" },
      { id: 554863, name: "Nigadi" },
      { id: 554873, name: "Nivale" },
      { id: 554843, name: "Pangloli" },
      { id: 554839, name: "Punir" },
      { id: 554848, name: "Ranavali" },
      { id: 554864, name: "Saigaon" },
      { id: 554858, name: "Sakhari" },
      { id: 554860, name: "Sakharone" },
      { id: 554801, name: "Sarve" },
      { id: 554823, name: "Shekhadi" },
      { id: 554835, name: "Shiravane" },
      { id: 554813, name: "Shiste" },
      { id: 554850, name: "Shrivardhan" },
      { id: 554810, name: "Vadavali" },
      { id: 554849, name: "Vadghar" },
      { id: 554859, name: "Vadshet" },
      { id: 554825, name: "Vakalghar" },
      { id: 554817, name: "Vanjale" },
      { id: 554861, name: "Vave Tarfe Shrivardhan" },
      { id: 554809, name: "Velas Agar" },
      { id: 554837, name: "Walvati" },
      { id: 554838, name: "Walvati Kh." },
      { id: 554826, name: "Wave Panchatan" },
    ],
    4184: [
      { id: 554959, name: "Adi Mahad Khadi" },
      { id: 554877, name: "Adi Thakur" },
      { id: 554903, name: "Agarwada" },
      { id: 554943, name: "Ambet" },
      { id: 554956, name: "Bandwadi" },
      { id: 554899, name: "Banoti" },
      { id: 554932, name: "Bhabat" },
      { id: 554919, name: "Bhekryacha Kond" },
      { id: 554890, name: "Chichonde" },
      { id: 554918, name: "Chikhalap" },
      { id: 554916, name: "Chirgaon" },
      { id: 554888, name: "Dagadghoom" },
      { id: 554920, name: "Dehen" },
      { id: 554893, name: "Deoghar" },
      { id: 554894, name: "Deoghar Kond" },
      { id: 554895, name: "Dhoraje" },
      { id: 554946, name: "Gadadav" },
      { id: 944917, name: "Gairone" },
      { id: 554901, name: "Ganeshnagar" },
      { id: 554940, name: "Gaulwadi" },
      { id: 554892, name: "Ghonse" },
      { id: 554914, name: "Ghum" },
      { id: 554881, name: "Gondghar" },
      { id: 554910, name: "Jambhul" },
      { id: 554880, name: "Kalsuri" },
      { id: 554886, name: "Kandalwada" },
      { id: 554926, name: "Kanghar" },
      { id: 554911, name: "Kelte" },
      { id: 554925, name: "Khamgaon" },
      { id: 554882, name: "Khanloshi" },
      { id: 554938, name: "Kharavate" },
      { id: 554897, name: "Khargaon Bk" },
      { id: 554907, name: "Khargaon Kh" },
      { id: 554898, name: "Kharsai" },
      { id: 554934, name: "Kokbal" },
      { id: 554958, name: "Kole" },
      { id: 554930, name: "Kolvat" },
      { id: 554955, name: "Konzari" },
      { id: 554941, name: "Krishnanagar" },
      { id: 554951, name: "Kudgaon" },
      { id: 554891, name: "Kudtudi" },
      { id: 554922, name: "Lep" },
      { id: 554950, name: "Lipni" },
      { id: 554948, name: "Mahammadkhanikhar" },
      { id: 554937, name: "Mandathane" },
      { id: 554949, name: "Maryamkhar" },
      { id: 554884, name: "Mendadi" },
      { id: 554885, name: "Mendadi Kond" },
      { id: 554960, name: "Mhasla" },
      { id: 554927, name: "Morvane" },
      { id: 554909, name: "Newarul" },
      { id: 554887, name: "Nigadi" },
      { id: 554889, name: "Pabhare" },
      { id: 554912, name: "Panave" },
      { id: 554936, name: "Pandare" },
      { id: 554952, name: "Pangaloli" },
      { id: 554929, name: "Pashti" },
      { id: 554902, name: "Pedhambe" },
      { id: 554947, name: "Phalasap" },
      { id: 554933, name: "Rativane" },
      { id: 554900, name: "Revali" },
      { id: 554878, name: "Rohinikond" },
      { id: 554913, name: "Rudravat" },
      { id: 554908, name: "Sakalap" },
      { id: 554905, name: "Salvinde" },
      { id: 554945, name: "Sanderi" },
      { id: 554954, name: "Sangawad" },
      { id: 554917, name: "Sarwar" },
      { id: 554915, name: "Sawar" },
      { id: 554924, name: "Songhar" },
      { id: 554896, name: "Surai" },
      { id: 554957, name: "Talavade" },
      { id: 554931, name: "Tamhane Karambe" },
      { id: 554942, name: "Tamhane Shirke" },
      { id: 554935, name: "Thakroli" },
      { id: 554906, name: "Tondsure" },
      { id: 554953, name: "Toradi" },
      { id: 554879, name: "Turumbadi" },
      { id: 554944, name: "Vicharewadi" },
      { id: 554923, name: "Waghav" },
      { id: 554921, name: "Wangani" },
      { id: 554883, name: "Waral" },
      { id: 554904, name: "Waravatne" },
      { id: 554928, name: "Warnat" },
      { id: 554939, name: "Wave" },
    ],
    4185: [
      { id: 554992, name: "Achaloli" },
      { id: 555112, name: "Ade" },
      { id: 555047, name: "Adhi" },
      { id: 555103, name: "Adiste" },
      { id: 555007, name: "Adrai" },
      { id: 555063, name: "Akale" },
      { id: 555129, name: "Ambavade" },
      { id: 555114, name: "Ambavali Bk." },
      { id: 555113, name: "Ambavali Kh." },
      { id: 555010, name: "Ambeshivthar" },
      { id: 554966, name: "Amdoshi" },
      { id: 555026, name: "Amshet" },
      { id: 555105, name: "Appar Tudil" },
      { id: 555042, name: "Asanpoi" },
      { id: 555024, name: "Barasgaon" },
      { id: 554967, name: "Bavale" },
      { id: 555099, name: "Bebalghar" },
      { id: 554998, name: "Bhalekar Kond" },
      { id: 555032, name: "Bhave" },
      { id: 555110, name: "Bheloshi" },
      { id: 555044, name: "Bhivghar" },
      { id: 555057, name: "Bhogaon" },
      { id: 555122, name: "Bhomjai" },
      { id: 555062, name: "Bhorao" },
      { id: 555116, name: "Bijghar" },
      { id: 555143, name: "Birwadi" },
      { id: 555043, name: "Borgaon" },
      { id: 555055, name: "Chambharkhind" },
      { id: 555079, name: "Chandhae Bk." },
      { id: 555078, name: "Chandhave Kh." },
      { id: 554983, name: "Chapgaon" },
      { id: 555101, name: "Chimbhave Heladvane Kond" },
      { id: 555100, name: "Chimbhave Mohalla" },
      { id: 555074, name: "Chochinde" },
      { id: 555073, name: "Chochinde Kond" },
      { id: 554987, name: "Dabhekar Kond" },
      { id: 555082, name: "Dabhol" },
      { id: 555069, name: "Dadali" },
      { id: 555019, name: "Dahiwad" },
      { id: 554971, name: "Dapoli" },
      { id: 555050, name: "Dasgaon" },
      { id: 555004, name: "Devghar" },
      { id: 555028, name: "Dhamane" },
      { id: 555048, name: "Dongroli" },
      { id: 942996, name: "Ganeshwadi" },
      { id: 555025, name: "Gavadi" },
      { id: 555131, name: "Gavhadi" },
      { id: 555128, name: "Ghavarekond" },
      { id: 554996, name: "Ghurupkond" },
      { id: 555084, name: "Gomendi" },
      { id: 554999, name: "Gondale" },
      { id: 555091, name: "Gothe Bk." },
      { id: 555090, name: "Gothe Kh." },
      { id: 555035, name: "Gothvali" },
      { id: 555029, name: "Jite" },
      { id: 555088, name: "Jui Bk." },
      { id: 944335, name: "Jui Budruk Mohalla" },
      { id: 554994, name: "Kachale" },
      { id: 554970, name: "Kadsari Lingana" },
      { id: 555031, name: "Kalij" },
      { id: 555056, name: "Kamble Tarf Birwadi" },
      { id: 555064, name: "Kamble Tarf Mahad" },
      { id: 555118, name: "Karanjadi" },
      { id: 909695, name: "Karanjkhol" },
      { id: 554961, name: "Karmar" },
      { id: 555011, name: "Kasabe Shivthar" },
      { id: 555039, name: "Katiwade" },
      { id: 555132, name: "Kawale Tarf Vinhere" },
      { id: 554962, name: "Kawale Tarfe Nate" },
      { id: 555070, name: "Kemburli" },
      { id: 555005, name: "Ketakicha Kond" },
      { id: 555041, name: "Khaire Tarf Birwadi" },
      { id: 555104, name: "Khaire Tarf Tudil" },
      { id: 554979, name: "Khardi" },
      { id: 555040, name: "Kharvali" },
      { id: 555111, name: "Khutil" },
      { id: 555075, name: "Kinjalghar" },
      { id: 554995, name: "Kinjaloli Bk" },
      { id: 554997, name: "Kinjaloli Kh." },
      { id: 555034, name: "Kiye" },
      { id: 555083, name: "Kokare Tarf Govele" },
      { id: 554991, name: "Kokare Tarf Nate" },
      { id: 555068, name: "Kol" },
      { id: 554988, name: "Kolose" },
      { id: 555066, name: "Kondiwate" },
      { id: 555124, name: "Kondmalusare" },
      { id: 554977, name: "Konzar" },
      { id: 555092, name: "Kosabi" },
      { id: 555077, name: "Kotheri" },
      { id: 554981, name: "Koturde" },
      { id: 555133, name: "Kumbharde" },
      { id: 555012, name: "Kumbheshivthar" },
      { id: 555089, name: "Kumble" },
      { id: 555115, name: "Kurle" },
      { id: 555059, name: "Kusgaon" },
      { id: 555000, name: "Ladavali" },
      { id: 555094, name: "Lower Tudil" },
      { id: 555054, name: "Mahad" },
      { id: 554985, name: "Mandle" },
      { id: 555002, name: "Mangharun" },
      { id: 555023, name: "Mazeri" },
      { id: 555052, name: "Mohopre" },
      { id: 555038, name: "Mohot" },
      { id: 555117, name: "Mumurshi" },
      { id: 555072, name: "Muthavali" },
      { id: 555142, name: "Nadgaon Tarf Birwadi" },
      { id: 555108, name: "Nadgaon Tarf Tudil" },
      { id: 555127, name: "Nagaon" },
      { id: 554982, name: "Nandgaon Bk" },
      { id: 554989, name: "Nandgaon Kh" },
      { id: 555109, name: "Narvan" },
      { id: 554990, name: "Nate" },
      { id: 555119, name: "Natondi" },
      { id: 554976, name: "Nerav" },
      { id: 555046, name: "Nigade" },
      { id: 554973, name: "Nijampur" },
      { id: 555087, name: "Owale" },
      { id: 554975, name: "Pachad" },
      { id: 555020, name: "Padavi" },
      { id: 555053, name: "Pale" },
      { id: 555003, name: "Panderi" },
      { id: 554969, name: "Pane" },
      { id: 555134, name: "Pangari" },
      { id: 555022, name: "Parmachi" },
      { id: 554986, name: "Parwadi" },
      { id: 555141, name: "Phalakewadi" },
      { id: 555123, name: "Pimpalkond" },
      { id: 555036, name: "Pimpalwadi" },
      { id: 554965, name: "Punade Tarf Nate" },
      { id: 554974, name: "Raigadwadi" },
      { id: 555065, name: "Rajewadi" },
      { id: 555120, name: "Rajiwali" },
      { id: 555013, name: "Ramdas Pathar" },
      { id: 555009, name: "Ranavadi Kh." },
      { id: 555093, name: "Ravdhal" },
      { id: 555136, name: "Ravtali" },
      { id: 555125, name: "Revtale" },
      { id: 555096, name: "Rohan" },
      { id: 555037, name: "Rupavali" },
      { id: 555060, name: "Sakadi" },
      { id: 554963, name: "Sandoshi" },
      { id: 555081, name: "Sape Tarf Govele" },
      { id: 555107, name: "Sape Tarf Tudil" },
      { id: 555071, name: "Sav" },
      { id: 555027, name: "Savane Wadi" },
      { id: 554964, name: "Savarat" },
      { id: 555058, name: "Shel" },
      { id: 555030, name: "Sheltoli" },
      { id: 942995, name: "Shendurmalai" },
      { id: 555008, name: "Shevate" },
      { id: 944916, name: "Shindekond" },
      { id: 555135, name: "Shingarkond" },
      { id: 555076, name: "Shirgaon" },
      { id: 555138, name: "Shirsavane" },
      { id: 555130, name: "Shirvali" },
      { id: 555018, name: "Solamkond" },
      { id: 555095, name: "Songhar" },
      { id: 555102, name: "Sutarkond" },
      { id: 555033, name: "Taliye" },
      { id: 554984, name: "Taloshi" },
      { id: 555140, name: "Tamhane" },
      { id: 555086, name: "Telange" },
      { id: 555098, name: "Telange Mohalla" },
      { id: 555061, name: "Temghar" },
      { id: 554993, name: "Tetghar" },
      { id: 555080, name: "Tol Bk." },
      { id: 555121, name: "Ugavatkond" },
      { id: 555126, name: "Underi" },
      { id: 555045, name: "Vadghar Kh." },
      { id: 554972, name: "Vagheri" },
      { id: 554978, name: "Valsure" },
      { id: 555137, name: "Vasap" },
      { id: 555049, name: "Veer" },
      { id: 555139, name: "Vinhere" },
      { id: 555067, name: "Wadwali" },
      { id: 555001, name: "Wagholi" },
      { id: 555051, name: "Wahoor" },
      { id: 555015, name: "Waki Bk" },
      { id: 555014, name: "Waki Kh" },
      { id: 555017, name: "Walan Bk" },
      { id: 555006, name: "Walan Kh" },
      { id: 555097, name: "Walang" },
      { id: 555106, name: "Wamane" },
      { id: 555021, name: "Warandh" },
      { id: 554980, name: "Warandoli" },
      { id: 554968, name: "Warangi" },
      { id: 555085, name: "Warathi" },
      { id: 555016, name: "Zolicha Kond" },
    ],
    4186: [
      { id: 555149, name: "Aagrekond" },
      { id: 555165, name: "Adavale Bk." },
      { id: 555157, name: "Adavale Kh." },
      { id: 555217, name: "Bhogaon Bk." },
      { id: 555216, name: "Bhogaon Kh." },
      { id: 555182, name: "Boraj" },
      { id: 555185, name: "Borawale" },
      { id: 555163, name: "Borghar" },
      { id: 555206, name: "Chambhargani Bk." },
      { id: 555196, name: "Chambhargani Kh" },
      { id: 555180, name: "Chandake" },
      { id: 555162, name: "Chandale" },
      { id: 555169, name: "Charai" },
      { id: 555166, name: "Chikhali" },
      { id: 555172, name: "Cholai" },
      { id: 555189, name: "Dabhil" },
      { id: 555186, name: "Deole" },
      { id: 555204, name: "Deopur" },
      { id: 555205, name: "Deopurwadi" },
      { id: 555201, name: "Dhamandivi" },
      { id: 555148, name: "Dharawali" },
      { id: 555178, name: "Dhawale" },
      { id: 555152, name: "Divil" },
      { id: 555222, name: "Fanaskond" },
      { id: 555203, name: "Foujdarwadi" },
      { id: 555202, name: "Ganjawane" },
      { id: 555184, name: "Ghagarkond" },
      { id: 555221, name: "Goldara" },
      { id: 555212, name: "Golegani" },
      { id: 555175, name: "Govele" },
      { id: 555190, name: "Haldule" },
      { id: 555151, name: "Haware" },
      { id: 555150, name: "Kalawali" },
      { id: 555161, name: "Kamathe" },
      { id: 555145, name: "Kangule" },
      { id: 944460, name: "Kapade" },
      { id: 555197, name: "Kapade Bk." },
      { id: 555195, name: "Kapade Kh." },
      { id: 555187, name: "Karanje" },
      { id: 555218, name: "Katali" },
      { id: 555170, name: "Katetali" },
      { id: 555192, name: "Keonale" },
      { id: 555200, name: "Khadapi" },
      { id: 555219, name: "Khadkawane" },
      { id: 555177, name: "Khandaj" },
      { id: 555179, name: "Khopad" },
      { id: 555209, name: "Kineshwar" },
      { id: 555215, name: "Kondhavi" },
      { id: 555227, name: "Kotwal Bk." },
      { id: 555225, name: "Kotwal Kh." },
      { id: 555210, name: "Kshetrapal" },
      { id: 555228, name: "Kudpan Bk." },
      { id: 555229, name: "Kudpan Kh." },
      { id: 555188, name: "Lahulase" },
      { id: 555154, name: "Lohare" },
      { id: 555223, name: "Mahalagur" },
      { id: 555198, name: "Mahalunge" },
      { id: 555144, name: "Matwan" },
      { id: 555199, name: "Morgiri" },
      { id: 555158, name: "Morsade" },
      { id: 555193, name: "Naneghol" },
      { id: 555164, name: "Nawale" },
      { id: 555207, name: "Niwe" },
      { id: 555224, name: "Ombali" },
      { id: 555213, name: "Paithan" },
      { id: 555220, name: "Palchil" },
      { id: 555214, name: "Pangaloli" },
      { id: 555153, name: "Parle" },
      { id: 555226, name: "Parsule" },
      { id: 555230, name: "Poladpur" },
      { id: 555183, name: "Ranawadi Bk." },
      { id: 555173, name: "Ranbajire" },
      { id: 555191, name: "Rankadsari" },
      { id: 555171, name: "Sadawali" },
      { id: 555159, name: "Sade" },
      { id: 555174, name: "Sakhar" },
      { id: 555176, name: "Salvikond" },
      { id: 555146, name: "Sawad" },
      { id: 555208, name: "Tamhane" },
      { id: 555155, name: "Turbhe Bk." },
      { id: 555167, name: "Turbhe Kh." },
      { id: 555156, name: "Turbhe Kond" },
      { id: 555211, name: "Tutawali" },
      { id: 555181, name: "Umarath" },
      { id: 555160, name: "Wadghar Bk." },
      { id: 555194, name: "Wakan" },
      { id: 555147, name: "Wave" },
      { id: 555168, name: "Wazarwadi" },
    ],
    4187: [
      { id: 555348, name: "Agar" },
      { id: 555257, name: "Ahinavewadi" },
      { id: 555281, name: "Ajanawale" },
      { id: 555294, name: "Alame" },
      { id: 555305, name: "Aldare" },
      { id: 555275, name: "Ale" },
      { id: 555272, name: "Alefata" },
      { id: 555237, name: "Alu" },
      { id: 555328, name: "Ambe" },
      { id: 555255, name: "Ambe Gavhan" },
      { id: 555313, name: "Amboli" },
      { id: 555347, name: "Amrapur" },
      { id: 555400, name: "Anandwadi" },
      { id: 555393, name: "Ane" },
      { id: 555318, name: "Aptale" },
      { id: 555361, name: "Arvi" },
      { id: 555409, name: "Aurangpur" },
      { id: 555349, name: "Badshaha Talao" },
      { id: 555246, name: "Bagadwadi" },
      { id: 944056, name: "Bagayat Budruk" },
      { id: 944055, name: "Bagayat Khurd" },
      { id: 555295, name: "Ballalwadi" },
      { id: 555399, name: "Bangarwadi" },
      { id: 555346, name: "Barav" },
      { id: 555358, name: "Basti" },
      { id: 555402, name: "Belhe" },
      { id: 555335, name: "Belsar" },
      { id: 555277, name: "Bhatkalwadi" },
      { id: 555325, name: "Bhivade Bk." },
      { id: 555326, name: "Bhivade Kh." },
      { id: 555240, name: "Bhoirwadi" },
      { id: 555378, name: "Bhorwadi" },
      { id: 555396, name: "Bori Bk." },
      { id: 555385, name: "Bori Kh." },
      { id: 555334, name: "Botarde" },
      { id: 555367, name: "Buchakewadi" },
      { id: 555278, name: "Chalakwadi" },
      { id: 555309, name: "Chawand" },
      { id: 555254, name: "Chilhewadi" },
      { id: 944053, name: "Chinchechiwadi" },
      { id: 555369, name: "Chincholi" },
      { id: 555339, name: "Datkhilwadi" },
      { id: 555283, name: "Devale" },
      { id: 555352, name: "Dhalewadi Tarf Haveli" },
      { id: 555323, name: "Dhalewadi Tarf Minher" },
      { id: 555355, name: "Dhamankhel" },
      { id: 555375, name: "Dhangarwadi" },
      { id: 555262, name: "Dholwad" },
      { id: 555252, name: "Dingore" },
      { id: 555263, name: "Dumbarwadi" },
      { id: 555267, name: "Gaymukhwadi" },
      { id: 555331, name: "Ghangaldare" },
      { id: 555280, name: "Ghatghar" },
      { id: 555293, name: "Godre" },
      { id: 555302, name: "Golegaon" },
      { id: 555401, name: "Gulunchwadi" },
      { id: 555398, name: "Gunjalwadi" },
      { id: 555362, name: "Gunjalwadi Arvi" },
      { id: 555292, name: "Hadsar" },
      { id: 555350, name: "Hapus Baug" },
      { id: 555303, name: "Hatban" },
      { id: 555327, name: "Hatvij" },
      { id: 555286, name: "Hirdi" },
      { id: 555374, name: "Hivare Bk" },
      { id: 555261, name: "Hivare Kh" },
      { id: 555341, name: "Hivare Tarf Minher" },
      { id: 555384, name: "Hivare Tarf Narayangaon" },
      { id: 555329, name: "Ingaloon" },
      { id: 555405, name: "Jadhav Wadi" },
      { id: 555287, name: "Jalwandi" },
      { id: 555268, name: "Jambhulpad" },
      { id: 555234, name: "Jambhulshi" },
      { id: 944054, name: "Junnar" },
      { id: 948014, name: "Kailasnagar" },
      { id: 947560, name: "Kailasnagar" },
      { id: 555338, name: "Kale" },
      { id: 555279, name: "Kalwadi" },
      { id: 555379, name: "Kandali" },
      { id: 555243, name: "Karanjale" },
      { id: 555366, name: "Katede" },
      { id: 555317, name: "Keli" },
      { id: 555308, name: "Kewadi" },
      { id: 555289, name: "Khadkumbe" },
      { id: 555285, name: "Khaire" },
      { id: 555306, name: "Khamgaon" },
      { id: 555264, name: "Khamundi" },
      { id: 555354, name: "Khanapur" },
      { id: 555320, name: "Khangaon" },
      { id: 555284, name: "Khatkale" },
      { id: 555370, name: "Khilarwadi" },
      { id: 555231, name: "Khireshwar" },
      { id: 555388, name: "Khodad" },
      { id: 555242, name: "Khubi" },
      { id: 555232, name: "Kolhewadi" },
      { id: 555274, name: "Kolwadi" },
      { id: 555404, name: "Kombarwadi" },
      { id: 555233, name: "Kopare" },
      { id: 943015, name: "Kotamwadi" },
      { id: 555301, name: "Kumshet" },
      { id: 555353, name: "Kuran" },
      { id: 555336, name: "Kusur" },
      { id: 555248, name: "Madh" },
      { id: 555298, name: "Malwadi" },
      { id: 555238, name: "Mandarne" },
      { id: 555235, name: "Mandave" },
      { id: 555410, name: "Mangrul" },
      { id: 555312, name: "Manikdoh" },
      { id: 555389, name: "Manjarwadi" },
      { id: 555315, name: "Mankeshwar" },
      { id: 555236, name: "Muthalne" },
      { id: 555381, name: "Nagadwadi" },
      { id: 555390, name: "Nalawane" },
      { id: 555382, name: "Narayangaon" },
      { id: 555269, name: "Navalewadi" },
      { id: 555297, name: "Netwad" },
      { id: 555364, name: "Nimdari" },
      { id: 555408, name: "Nimgaon Sawa" },
      { id: 555357, name: "Nimgaon Tarf Mahalunge" },
      { id: 555282, name: "Nimgiri" },
      { id: 555319, name: "Nirgude" },
      { id: 555259, name: "Otur" },
      { id: 555372, name: "Ozar" },
      { id: 555256, name: "Pachgharwadi" },
      { id: 555344, name: "Padali" },
      { id: 555271, name: "Padirwadi" },
      { id: 555250, name: "Pangari Tarf Madh" },
      { id: 555296, name: "Pangari Tarfe Otur" },
      { id: 555412, name: "Pargaon Tarf Ale" },
      { id: 555245, name: "Pargaon Tarf Madh" },
      { id: 555368, name: "Parunde" },
      { id: 555392, name: "Pemdara" },
      { id: 555288, name: "Phagul Gavhan" },
      { id: 555239, name: "Pimpalgaon Joga" },
      { id: 555304, name: "Pimpalgaon Siddhanath" },
      { id: 555360, name: "Pimpalgaon T Narayangaon" },
      { id: 555276, name: "Pimpalwandi" },
      { id: 555342, name: "Pimparwadi" },
      { id: 555413, name: "Pimpri Kawal" },
      { id: 555266, name: "Pimpri Pendhar" },
      { id: 555310, name: "Pur" },
      { id: 555307, name: "Rajur" },
      { id: 555395, name: "Rajuri" },
      { id: 555333, name: "Ralegan" },
      { id: 555407, name: "Ranmalawadi" },
      { id: 555258, name: "Rohkadi" },
      { id: 555406, name: "Sakori T Belhe" },
      { id: 555241, name: "Sanganore" },
      { id: 947385, name: "Santwadi" },
      { id: 555363, name: "Sawargaon" },
      { id: 555332, name: "Shinde" },
      { id: 555391, name: "Shindewadi" },
      { id: 555351, name: "Shiroli Bk" },
      { id: 555300, name: "Shiroli Kh" },
      { id: 555386, name: "Shiroli T Ale" },
      { id: 555311, name: "Shiroli Tarf Kukadneher" },
      { id: 555324, name: "Shivali" },
      { id: 555247, name: "Sitewadi" },
      { id: 555345, name: "Somatwadi" },
      { id: 555330, name: "Sonawale" },
      { id: 555343, name: "Sukalwedhe" },
      { id: 555387, name: "Sultanpur" },
      { id: 555321, name: "Surale" },
      { id: 555244, name: "Taleran" },
      { id: 555340, name: "Tambe" },
      { id: 555397, name: "Tambewadi" },
      { id: 555299, name: "Tejewadi" },
      { id: 555316, name: "Tejur" },
      { id: 555260, name: "Tikekarwadi" },
      { id: 555314, name: "Uchhil" },
      { id: 555253, name: "Udapur" },
      { id: 555265, name: "Umbraj" },
      { id: 555394, name: "Unchkhadakwadi" },
      { id: 555291, name: "Undekhadak" },
      { id: 555290, name: "Usran" },
      { id: 555365, name: "Vadaj" },
      { id: 555380, name: "Vadgaon Kandali" },
      { id: 555359, name: "Vadgaon Sahani" },
      { id: 555377, name: "Vaishakh Khede" },
      { id: 555373, name: "Vighnaharnagar" },
      { id: 912887, name: "Vithalawadi" },
      { id: 555270, name: "Wadgaon Anand" },
      { id: 555322, name: "Wanewadi" },
      { id: 555383, name: "Warulwadi" },
      { id: 555249, name: "Watkhale" },
      { id: 555403, name: "Yadavwadi" },
      { id: 555376, name: "Yedgaon" },
      { id: 555337, name: "Yenere" },
      { id: 555411, name: "Zapwadi" },
    ],
    4188: [
      { id: 555422, name: "Adivare" },
      { id: 555416, name: "Aghane" },
      { id: 555414, name: "Ahupe" },
      { id: 555428, name: "Amade" },
      { id: 555488, name: "Ambedara" },
      { id: 555437, name: "Ambegaon" },
      { id: 555466, name: "Amondi" },
      { id: 555464, name: "Apati" },
      { id: 555419, name: "Asane" },
      { id: 555539, name: "Awasari Bk." },
      { id: 555532, name: "Awasari Kh" },
      { id: 944051, name: "Babhulwadi" },
      { id: 555511, name: "Bhagadi" },
      { id: 555536, name: "Bharadi" },
      { id: 555523, name: "Bhawadi" },
      { id: 555533, name: "Bhorwadi" },
      { id: 555423, name: "Borghar" },
      { id: 555504, name: "Chandoli Bk." },
      { id: 555516, name: "Chandoli Kh." },
      { id: 555485, name: "Chas" },
      { id: 555456, name: "Chikhali" },
      { id: 555487, name: "Chinchodi" },
      { id: 555483, name: "Chincholi" },
      { id: 555546, name: "Devgaon" },
      { id: 555489, name: "Dhakale" },
      { id: 555551, name: "Dhamani" },
      { id: 555482, name: "Dhondmal Shindewadi" },
      { id: 555435, name: "Digad" },
      { id: 555440, name: "Dimbhe Bk." },
      { id: 555462, name: "Dimbhe Kh." },
      { id: 555417, name: "Don" },
      { id: 555515, name: "Eklahare" },
      { id: 555467, name: "Falakewadi" },
      { id: 555453, name: "Gadewadi" },
      { id: 555473, name: "Gangapur Bk." },
      { id: 555465, name: "Gangapur Kh." },
      { id: 555540, name: "Gavdewadi" },
      { id: 555490, name: "Gawarwadi" },
      { id: 555480, name: "Ghodegaon" },
      { id: 555468, name: "Girawali" },
      { id: 555461, name: "Gohe Bk." },
      { id: 555459, name: "Gohe Kh." },
      { id: 555508, name: "Jadhavwadi" },
      { id: 555443, name: "Jambhori" },
      { id: 555544, name: "Jarkarwadi" },
      { id: 555537, name: "Jawale" },
      { id: 555484, name: "Kadewadi" },
      { id: 555502, name: "Kalamb" },
      { id: 555442, name: "Kalambai" },
      { id: 555491, name: "Kalewadi Darekarwadi" },
      { id: 555475, name: "Kanase" },
      { id: 555525, name: "Karegaon" },
      { id: 555545, name: "Kathapur Bk." },
      { id: 555534, name: "Khadakamala" },
      { id: 555505, name: "Khadaki" },
      { id: 555550, name: "Khadakwadi" },
      { id: 555481, name: "Koldara Gonawadi" },
      { id: 555521, name: "Kolharwadi" },
      { id: 555441, name: "Koltavade" },
      { id: 555492, name: "Kolwadi Kotamdara" },
      { id: 555427, name: "Kondhare" },
      { id: 555448, name: "Kondhaval" },
      { id: 555520, name: "Kurwandi" },
      { id: 555433, name: "Kushire Bk." },
      { id: 555434, name: "Kushire Kh." },
      { id: 555547, name: "Lakhangaon" },
      { id: 555554, name: "Loni" },
      { id: 555503, name: "Louki" },
      { id: 555497, name: "Mahalunge Padawal" },
      { id: 555432, name: "Mahalunge Tarf Ambegaon" },
      { id: 555439, name: "Mahalunge Tarf Ghoda" },
      { id: 555421, name: "Malin" },
      { id: 555557, name: "Manchar" },
      { id: 555556, name: "Mandalewadi" },
      { id: 555460, name: "Mapoli" },
      { id: 555445, name: "Megholi" },
      { id: 555542, name: "Mengadewadi" },
      { id: 555420, name: "Menumbarwadi" },
      { id: 555517, name: "Mordewadi" },
      { id: 555509, name: "Nagapur" },
      { id: 555429, name: "Nanavade" },
      { id: 555501, name: "Nandur" },
      { id: 555444, name: "Nandurkichi Wadi" },
      { id: 555486, name: "Narodi" },
      { id: 555430, name: "Nhaved" },
      { id: 555449, name: "Nigdale" },
      { id: 555519, name: "Nighotwadi" },
      { id: 555538, name: "Nirgoodsar" },
      { id: 555549, name: "Pahaddara" },
      { id: 555425, name: "Panchale Bk." },
      { id: 555426, name: "Panchale Kh." },
      { id: 555543, name: "Pargaon Tarf Awasari Bk." },
      { id: 555535, name: "Pargaon Tarf Khed" },
      { id: 555431, name: "Patan" },
      { id: 555526, name: "Peth" },
      { id: 555477, name: "Phadalewadi Ugalewadi" },
      { id: 555454, name: "Phalode" },
      { id: 555438, name: "Phulawade" },
      { id: 555471, name: "Pimpalgaon Tarf Ghoda" },
      { id: 555529, name: "Pimpalgaon Tarf Mahalunge" },
      { id: 555415, name: "Pimpargane" },
      { id: 555451, name: "Pimpari" },
      { id: 555493, name: "Pinglewadi Landewadi" },
      { id: 555457, name: "Pokhari" },
      { id: 555472, name: "Pokharkarwadi" },
      { id: 555548, name: "Pondewadi" },
      { id: 555458, name: "Rajewadi" },
      { id: 555452, name: "Rajpur" },
      { id: 555469, name: "Ramwadi" },
      { id: 555507, name: "Ranjani" },
      { id: 555552, name: "Ranmala" },
      { id: 555447, name: "Sakeri" },
      { id: 555500, name: "Sakore" },
      { id: 555479, name: "Sal" },
      { id: 555446, name: "Savarli" },
      { id: 555524, name: "Shewalwadi" },
      { id: 555494, name: "Shewalwadi Landewadi" },
      { id: 555531, name: "Shindemala" },
      { id: 555512, name: "Shingave" },
      { id: 555476, name: "Shinoli" },
      { id: 555553, name: "Shirdale" },
      { id: 555527, name: "Shriramnagar" },
      { id: 555514, name: "Sultanpur" },
      { id: 555463, name: "Supedhar" },
      { id: 555499, name: "Takewadi" },
      { id: 555455, name: "Taleghar" },
      { id: 555478, name: "Talekarwadi" },
      { id: 555528, name: "Tambademala" },
      { id: 555541, name: "Tavharewadi" },
      { id: 555450, name: "Terungan" },
      { id: 555470, name: "Thakar Wadi" },
      { id: 555506, name: "Thorandale" },
      { id: 555522, name: "Thugaon" },
      { id: 555418, name: "Tirpad" },
      { id: 555436, name: "Vachape" },
      { id: 555513, name: "Vadgaon Kashimbeg" },
      { id: 555424, name: "Varasawane" },
      { id: 555530, name: "Vayalmala" },
      { id: 555498, name: "Vitthalwadi" },
      { id: 555555, name: "Wadgaon Pir" },
      { id: 555510, name: "Walati" },
      { id: 912833, name: "Walunjnagar" },
      { id: 555518, name: "Walunjwadi" },
    ],
    4189: [
      { id: 555649, name: "Alegaon Paga" },
      { id: 555643, name: "Ambale" },
      { id: 555576, name: "Amdabad" },
      { id: 555658, name: "Andhalgaon" },
      { id: 555631, name: "Apti" },
      { id: 555648, name: "Arangaon" },
      { id: 555670, name: "Babhulsar Bk." },
      { id: 555621, name: "Babhulsar Kh." },
      { id: 555622, name: "Bhambarde" },
      { id: 555618, name: "Burunjwadi" },
      { id: 555562, name: "Chandoh" },
      { id: 555640, name: "Chavhanwadi" },
      { id: 555655, name: "Chinchani" },
      { id: 555589, name: "Chincholi" },
      { id: 555644, name: "Dahiwadi" },
      { id: 555634, name: "Darekarwadi" },
      { id: 555591, name: "Dhamari" },
      { id: 555638, name: "Dhanore" },
      { id: 555615, name: "Dhok Sangavi" },
      { id: 555663, name: "Dhumalwadi" },
      { id: 555633, name: "Dingrajwadi" },
      { id: 555574, name: "Dongargan" },
      { id: 555570, name: "Echakewadi" },
      { id: 555669, name: "Faratwadi" },
      { id: 555671, name: "Ganegaon Dumala" },
      { id: 555617, name: "Ganegaon Khalsa" },
      { id: 555613, name: "Golegaon" },
      { id: 555656, name: "Gunat" },
      { id: 555599, name: "Hivare" },
      { id: 555665, name: "Inamgaon" },
      { id: 555560, name: "Jambut" },
      { id: 555601, name: "Jategaon Bk." },
      { id: 555602, name: "Jategaon Kh." },
      { id: 555587, name: "Kanhur Mesai" },
      { id: 555597, name: "Karandi" },
      { id: 555623, name: "Karanjavane" },
      { id: 555639, name: "Karde" },
      { id: 555614, name: "Karegaon" },
      { id: 555627, name: "Kasari" },
      { id: 555558, name: "Kathapur Kh." },
      { id: 555569, name: "Kawathe (Yamai)" },
      { id: 555594, name: "Kendur" },
      { id: 555586, name: "Khairenagar" },
      { id: 555590, name: "Khairewadi" },
      { id: 555619, name: "Khandale" },
      { id: 555651, name: "Kohakdewadi" },
      { id: 555661, name: "Kolgaon Dolas" },
      { id: 555625, name: "Kondhapuri" },
      { id: 555673, name: "Koregaon Bhima" },
      { id: 555660, name: "Kuruli" },
      { id: 555578, name: "Lakhewadi" },
      { id: 555577, name: "Malthan" },
      { id: 555566, name: "Malwadi" },
      { id: 555668, name: "Mandavgan Pharata" },
      { id: 555575, name: "Mhase Bk." },
      { id: 555579, name: "Midgulwadi" },
      { id: 555641, name: "Motewadi" },
      { id: 555598, name: "Mukhai" },
      { id: 555572, name: "Munjalwadi" },
      { id: 555659, name: "Nagargaon" },
      { id: 555650, name: "Nhavara" },
      { id: 555607, name: "Nimgaon Bhogi" },
      { id: 555568, name: "Nimgaon Dude" },
      { id: 555626, name: "Nimgaon Mhalungi" },
      { id: 555642, name: "Nimone" },
      { id: 555657, name: "Nirvi" },
      { id: 555583, name: "Pabal" },
      { id: 555645, name: "Parodi" },
      { id: 555563, name: "Phakate" },
      { id: 555629, name: "Pimpale Jagtap" },
      { id: 555600, name: "Pimpale Khalsa" },
      { id: 555664, name: "Pimpalsuti" },
      { id: 555616, name: "Pimpari Dumala" },
      { id: 555559, name: "Pimparkhed" },
      { id: 555652, name: "Rakshewadi" },
      { id: 555620, name: "Ranjangaon Ganpati" },
      { id: 555653, name: "Ranjangaon Sandas" },
      { id: 555624, name: "Rautwadi" },
      { id: 555573, name: "Ravadewadi" },
      { id: 555567, name: "Sabalewadi" },
      { id: 555667, name: "Sadalgaon" },
      { id: 555674, name: "Sanaswadi" },
      { id: 555571, name: "Savindane" },
      { id: 555561, name: "Sharadwadi" },
      { id: 555588, name: "Shastabad" },
      { id: 555628, name: "Shikrapur" },
      { id: 555654, name: "Shindodi" },
      { id: 555603, name: "Shingadwadi" },
      { id: 555662, name: "Shirasgaon Kata" },
      { id: 555609, name: "Shirur Gramin" },
      { id: 944087, name: "Shirur Na. Pa." },
      { id: 555646, name: "Shivtakrar Mahalungi" },
      { id: 555606, name: "Sone Sangavi" },
      { id: 555636, name: "Takali Bhima" },
      { id: 555565, name: "Takali Haji" },
      { id: 555635, name: "Talegaon Dhamdhere" },
      { id: 555672, name: "Tandali" },
      { id: 555647, name: "Uralgaon" },
      { id: 555637, name: "Vitthalwadi" },
      { id: 555666, name: "Wadgaon Rasai" },
      { id: 555632, name: "Wadhu Bk." },
      { id: 555564, name: "Wadner Kh." },
      { id: 555605, name: "Waghale" },
      { id: 555630, name: "Wajewadi" },
      { id: 555604, name: "Warude" },
    ],
    4190: [
      { id: 555731, name: "Adgaon" },
      { id: 555719, name: "Adhe" },
      { id: 555744, name: "Ahire" },
      { id: 555781, name: "Akharwadi" },
      { id: 555726, name: "Akhatuli" },
      { id: 555852, name: "Alandi" },
      { id: 555833, name: "Ambethan" },
      { id: 555722, name: "Ambhu" },
      { id: 555723, name: "Amboli" },
      { id: 555736, name: "Anavale" },
      { id: 555787, name: "Arudewadi" },
      { id: 555768, name: "Askhed Bk." },
      { id: 555750, name: "Askhed Kh." },
      { id: 555715, name: "Avadar" },
      { id: 555724, name: "Avandhe" },
      { id: 555681, name: "Awhat" },
      { id: 555782, name: "Bahirwadi" },
      { id: 555845, name: "Bahul" },
      { id: 555720, name: "Bhalavadi" },
      { id: 555823, name: "Bhamboli" },
      { id: 942949, name: "Bhimashankarwadi" },
      { id: 555676, name: "Bhivegaon" },
      { id: 555702, name: "Bhomale" },
      { id: 555675, name: "Bhorgiri" },
      { id: 555841, name: "Bhose" },
      { id: 555838, name: "Biradvadi" },
      { id: 555772, name: "Bursewadi" },
      { id: 555783, name: "Butewadi" },
      { id: 555862, name: "Chakan" },
      { id: 555761, name: "Chandoli" },
      { id: 555764, name: "Chandus" },
      { id: 555860, name: "Charholi Kh." },
      { id: 555778, name: "Chas" },
      { id: 555812, name: "Chaudharwadi" },
      { id: 555807, name: "Chichbaiwadi" },
      { id: 555711, name: "Chikhalgaon" },
      { id: 555850, name: "Chimbali" },
      { id: 555844, name: "Chinchoshi" },
      { id: 555684, name: "Darakwadi" },
      { id: 555820, name: "Davadi" },
      { id: 555695, name: "Dehane" },
      { id: 555737, name: "Deshamukhwadi" },
      { id: 555713, name: "Devoshi" },
      { id: 555770, name: "Dhamane" },
      { id: 555693, name: "Dhamangaon Bk." },
      { id: 555698, name: "Dhamangaon Kh." },
      { id: 555859, name: "Dhanore" },
      { id: 555795, name: "Dhorewadi" },
      { id: 555699, name: "Dhuoli" },
      { id: 555760, name: "Donde" },
      { id: 555694, name: "Ekalahare" },
      { id: 555733, name: "Gadad" },
      { id: 555813, name: "Gadakwadi" },
      { id: 555758, name: "Gargotwadi" },
      { id: 555706, name: "Ghotavadi" },
      { id: 555856, name: "Golegaon" },
      { id: 555834, name: "Gonavadi" },
      { id: 555691, name: "Goregaon" },
      { id: 555816, name: "Gosasi" },
      { id: 555808, name: "Gulani" },
      { id: 555771, name: "Gundalwadi" },
      { id: 555739, name: "Hedruj" },
      { id: 555799, name: "Holewadi" },
      { id: 555792, name: "Jaidwadi" },
      { id: 942979, name: "Jarewadi" },
      { id: 555805, name: "Jaulke Bk." },
      { id: 555809, name: "Jaulke Kh." },
      { id: 555839, name: "Kadachiwadi" },
      { id: 555774, name: "Kadadhe" },
      { id: 555759, name: "Kadus" },
      { id: 555685, name: "Kahu" },
      { id: 555786, name: "Kalechiwadi" },
      { id: 555692, name: "Kalmodi" },
      { id: 555804, name: "Kalus" },
      { id: 555777, name: "Kaman" },
      { id: 555815, name: "Kanhersar" },
      { id: 555775, name: "Kanhewadi Bk." },
      { id: 555729, name: "Kanhewadi Kh." },
      { id: 555830, name: "Kanhewadi Tarf Chakan" },
      { id: 555749, name: "Karanj Vihire" },
      { id: 555677, name: "Karkudi" },
      { id: 555741, name: "Kasari" },
      { id: 555851, name: "Kelgaon" },
      { id: 555794, name: "Khalchi Bhamburwadi" },
      { id: 555827, name: "Khalumbre" },
      { id: 555863, name: "Kharabwadi" },
      { id: 555727, name: "Kharawali" },
      { id: 555680, name: "Kharoshi" },
      { id: 555704, name: "Kharpud" },
      { id: 555818, name: "Kharpudi Bk." },
      { id: 555800, name: "Kharpudi Kh." },
      { id: 555765, name: "Kiwale" },
      { id: 555756, name: "Kohinde Bk." },
      { id: 555725, name: "Kohinde Kh." },
      { id: 555789, name: "Kohinkarwadi" },
      { id: 555734, name: "Koliye" },
      { id: 555766, name: "Koregaon Bk." },
      { id: 555821, name: "Koregaon Kh." },
      { id: 555854, name: "Koyali Tarf Chakan" },
      { id: 555686, name: "Koyali Tarf Wada" },
      { id: 555769, name: "Koye" },
      { id: 555708, name: "Kude Bk." },
      { id: 555709, name: "Kude Kh." },
      { id: 555767, name: "Kurkundi" },
      { id: 555848, name: "Kuruli" },
      { id: 555832, name: "Mahalunge" },
      { id: 555688, name: "Majgaon" },
      { id: 555678, name: "Mandoshi" },
      { id: 555798, name: "Manjarewadi" },
      { id: 555855, name: "Markal" },
      { id: 555865, name: "Medankarwadi" },
      { id: 555779, name: "Mirjewadi" },
      { id: 555776, name: "Mohakal" },
      { id: 555849, name: "Moi" },
      { id: 555705, name: "Moroshi" },
      { id: 555864, name: "Nanekarwadi" },
      { id: 555679, name: "Nayphad" },
      { id: 555831, name: "Nighoje" },
      { id: 555819, name: "Nimgaon" },
      { id: 555703, name: "Pabhe" },
      { id: 555790, name: "Pacharnewadi" },
      { id: 555785, name: "Padali" },
      { id: 555745, name: "Pait" },
      { id: 555738, name: "Palu" },
      { id: 555784, name: "Pangari" },
      { id: 555780, name: "Papalwadi" },
      { id: 555743, name: "Parale" },
      { id: 555707, name: "Parsul" },
      { id: 555857, name: "Pimpalgaon Tarf Chakan" },
      { id: 555843, name: "Pimpalgaon Tarf Khed" },
      { id: 555801, name: "Pimpri Bk." },
      { id: 555835, name: "Pimpri Kh." },
      { id: 555814, name: "Pur" },
      { id: 555861, name: "Rajgurunagar (Khed)" },
      { id: 555797, name: "Rakshewadi" },
      { id: 555840, name: "Rase" },
      { id: 555746, name: "Raundhalwadi" },
      { id: 555817, name: "Retavadi" },
      { id: 555836, name: "Rohakal" },
      { id: 555846, name: "Sabalewadi" },
      { id: 555753, name: "Saburdi" },
      { id: 555687, name: "Sakurdi" },
      { id: 555791, name: "Sandbhorwadi" },
      { id: 555829, name: "Sangurdi" },
      { id: 555803, name: "Santosh Nagar" },
      { id: 555788, name: "Satkarsthal" },
      { id: 555826, name: "Savardari" },
      { id: 555755, name: "Sayagaon" },
      { id: 555842, name: "Shelgaon" },
      { id: 555751, name: "Shelu" },
      { id: 555697, name: "Shendurli" },
      { id: 555825, name: "Shinde" },
      { id: 555700, name: "Shirgaon" },
      { id: 555763, name: "Shiroli" },
      { id: 555747, name: "Shive" },
      { id: 555847, name: "Siddhegavhan" },
      { id: 555858, name: "Solu" },
      { id: 555730, name: "Supe" },
      { id: 555690, name: "Surkundi" },
      { id: 555796, name: "Takalkarwadi" },
      { id: 555757, name: "Talavade" },
      { id: 555735, name: "Tekavadi" },
      { id: 555689, name: "Tifanwwadi" },
      { id: 555701, name: "Tokavade" },
      { id: 555740, name: "Torne Bk" },
      { id: 555717, name: "Torne Kh" },
      { id: 912915, name: "Tukaiwadi" },
      { id: 555853, name: "Vadgaon Ghenand" },
      { id: 555762, name: "Vadgaon Tarf Khed" },
      { id: 555822, name: "Varale" },
      { id: 555793, name: "Varchi Bhamburwadi" },
      { id: 555811, name: "Varude" },
      { id: 555728, name: "Velhavale" },
      { id: 555754, name: "Vetale" },
      { id: 555721, name: "Virham" },
      { id: 555683, name: "Wada" },
      { id: 555806, name: "Wafegaon" },
      { id: 555732, name: "Waghu" },
      { id: 555742, name: "Wahagaon" },
      { id: 555714, name: "Wajavane" },
      { id: 555810, name: "Wakalwadi" },
      { id: 555802, name: "Waki Bk" },
      { id: 555837, name: "Waki Kh." },
      { id: 555748, name: "Waki Tarf Wada" },
      { id: 555682, name: "Walad" },
      { id: 555716, name: "Wandre" },
      { id: 555696, name: "Wanjale" },
      { id: 555752, name: "Washere" },
      { id: 555824, name: "Wasuli" },
      { id: 555828, name: "Yelwadi" },
      { id: 555710, name: "Yenave Bk." },
      { id: 555712, name: "Yenave Kh." },
    ],
    4191: [
      { id: 556046, name: "Adhale Bk" },
      { id: 556045, name: "Adhale Kh." },
      { id: 556037, name: "Adhe" },
      { id: 555937, name: "Ahirvade" },
      { id: 556027, name: "Ajivali" },
      { id: 556029, name: "Akurdi" },
      { id: 555877, name: "Ambale" },
      { id: 555985, name: "Ambegaon" },
      { id: 556028, name: "Ambi" },
      { id: 555980, name: "Apati" },
      { id: 556003, name: "Ardav" },
      { id: 555982, name: "Atvan" },
      { id: 555975, name: "Aundhe Kh." },
      { id: 555974, name: "Aundholi" },
      { id: 555879, name: "Badhalawadi" },
      { id: 555996, name: "Baur" },
      { id: 556038, name: "Bebad Ohol" },
      { id: 555993, name: "Bedse" },
      { id: 555889, name: "Belaj" },
      { id: 556004, name: "Bhadawali" },
      { id: 555972, name: "Bhaje" },
      { id: 555951, name: "Bhajgaon" },
      { id: 555874, name: "Bhoyare" },
      { id: 944078, name: "Bhushi" },
      { id: 555969, name: "Boraj" },
      { id: 555903, name: "Borivali" },
      { id: 555897, name: "Brahman Wadi" },
      { id: 556007, name: "Brahmanoli" },
      { id: 555916, name: "Brahmanwadi" },
      { id: 555957, name: "Budhavadi" },
      { id: 556044, name: "Chandkhed" },
      { id: 556022, name: "Chavsar" },
      { id: 555936, name: "Chikhalse" },
      { id: 555964, name: "Dahivali" },
      { id: 555901, name: "Dahuli" },
      { id: 556043, name: "Darumbare" },
      { id: 555973, name: "Devale" },
      { id: 555945, name: "Devghar" },
      { id: 555977, name: "Dhalewadi" },
      { id: 556039, name: "Dhamane" },
      { id: 556017, name: "Dhangavhan" },
      { id: 556049, name: "Divad" },
      { id: 556047, name: "Done" },
      { id: 555949, name: "Dongargaon" },
      { id: 555976, name: "Dudhivare" },
      { id: 556032, name: "Gahunje" },
      { id: 555981, name: "Gevhande Apati" },
      { id: 556020, name: "Gevhande Khadak" },
      { id: 555913, name: "Ghonshet" },
      { id: 556040, name: "Godumbare" },
      { id: 555925, name: "Govitri" },
      { id: 555885, name: "Induri" },
      { id: 555871, name: "Inglun" },
      { id: 555880, name: "Jadhavwadi" },
      { id: 555882, name: "Jambavade" },
      { id: 555922, name: "Jambhavali" },
      { id: 555893, name: "Jambhul" },
      { id: 556026, name: "Jovan" },
      { id: 555914, name: "Kacharewadi" },
      { id: 555992, name: "Kadadhe" },
      { id: 556021, name: "Kadav" },
      { id: 555987, name: "Kale" },
      { id: 555875, name: "Kalhat" },
      { id: 555902, name: "Kambare Andar Mawal" },
      { id: 555928, name: "Kambare N.M." },
      { id: 555894, name: "Kanhe" },
      { id: 555944, name: "Karandoli" },
      { id: 555926, name: "Karanjgaon" },
      { id: 555966, name: "Karla" },
      { id: 555994, name: "Karunj" },
      { id: 555873, name: "Kashal" },
      { id: 555892, name: "Katavi" },
      { id: 556013, name: "Keware" },
      { id: 556054, name: "Khadakala" },
      { id: 555934, name: "Khamshet" },
      { id: 555899, name: "Khand" },
      { id: 944075, name: "Khandala" },
      { id: 555954, name: "Khandashi" },
      { id: 555872, name: "Kivale" },
      { id: 556010, name: "Kolechafesar" },
      { id: 555909, name: "Kondivade A.M." },
      { id: 555929, name: "Kondivade N.M" },
      { id: 556006, name: "Kothurne" },
      { id: 555940, name: "Kune N.M." },
      { id: 555870, name: "Kunewadi" },
      { id: 555948, name: "Kurvande" },
      { id: 555905, name: "Kusavali" },
      { id: 556055, name: "Kusegaon Bk" },
      { id: 555935, name: "Kusgaon Kh." },
      { id: 556052, name: "Kusgaon P.M." },
      { id: 555900, name: "Kusur" },
      { id: 555979, name: "Lohagad" },
      { id: 944074, name: "Lonavala" },
      { id: 555988, name: "Mahagaon" },
      { id: 556012, name: "Majgaon" },
      { id: 944079, name: "Malavali" },
      { id: 556016, name: "Malavandi Thule" },
      { id: 556001, name: "Malawali P.M." },
      { id: 555867, name: "Malegaon Bk." },
      { id: 555869, name: "Malegaon Kh." },
      { id: 555978, name: "Malewadi" },
      { id: 944080, name: "Malwadi" },
      { id: 555887, name: "Mangarul" },
      { id: 555908, name: "Mau" },
      { id: 555881, name: "Mindewadi" },
      { id: 555927, name: "Moramarwadi" },
      { id: 556023, name: "Morave" },
      { id: 555961, name: "Mundhavare" },
      { id: 555906, name: "Nagathali" },
      { id: 555933, name: "Nane" },
      { id: 944077, name: "Nangargaon" },
      { id: 555931, name: "Nanoli N.M." },
      { id: 555886, name: "Nanoli T. Chakan" },
      { id: 555878, name: "Navalakh Umbre" },
      { id: 555895, name: "Nayagaon" },
      { id: 555955, name: "Nesave" },
      { id: 555876, name: "Nigade" },
      { id: 556048, name: "Ovale" },
      { id: 555998, name: "Ozarde" },
      { id: 556051, name: "Pachane" },
      { id: 555917, name: "Pale Nane Mawal" },
      { id: 555983, name: "Pale Pawan Mawal" },
      { id: 555941, name: "Pangaloli" },
      { id: 556009, name: "Pansoli" },
      { id: 556035, name: "Parandvadi" },
      { id: 555932, name: "Paravadi" },
      { id: 555968, name: "Patan" },
      { id: 555960, name: "Pathargaon" },
      { id: 555910, name: "Pawalewadi" },
      { id: 555911, name: "Phalane" },
      { id: 555999, name: "Pimpal Khunte" },
      { id: 555970, name: "Pimpaloli" },
      { id: 555868, name: "Pimpri A.M" },
      { id: 555990, name: "Prabhachiwadi" },
      { id: 556050, name: "Pusane" },
      { id: 555890, name: "Rajpuri" },
      { id: 555920, name: "Rakaswadi" },
      { id: 555950, name: "Sadapur" },
      { id: 555997, name: "Sadavali" },
      { id: 555930, name: "Sai" },
      { id: 556041, name: "Salumbare" },
      { id: 556042, name: "Sangavade" },
      { id: 555891, name: "Sangavi" },
      { id: 555956, name: "Sangise" },
      { id: 555896, name: "Sate" },
      { id: 555866, name: "Sawale" },
      { id: 555989, name: "Sawantwadi" },
      { id: 555986, name: "Shevati" },
      { id: 555963, name: "Shilatane" },
      { id: 556024, name: "Shilimb" },
      { id: 555984, name: "Shindgaon" },
      { id: 555919, name: "Shirdhe" },
      { id: 555888, name: "Shire" },
      { id: 556033, name: "Shirgaon" },
      { id: 556005, name: "Shivali" },
      { id: 556000, name: "Shivane" },
      { id: 556034, name: "Somatane" },
      { id: 555923, name: "Somavadi" },
      { id: 555884, name: "Sudumbare" },
      { id: 555883, name: "Sudvadi" },
      { id: 555971, name: "Taje" },
      { id: 555912, name: "Takave Bk." },
      { id: 555962, name: "Takave Kh." },
      { id: 556031, name: "Talegaon Dabhade" },
      { id: 556014, name: "Thakursai" },
      { id: 555921, name: "Thoran" },
      { id: 556002, name: "Thugaon" },
      { id: 556019, name: "Tikona" },
      { id: 556011, name: "Tung" },
      { id: 944076, name: "Tungarli" },
      { id: 555938, name: "Udhewadi" },
      { id: 555918, name: "Ukasan" },
      { id: 556036, name: "Urse" },
      { id: 555952, name: "Vadavali" },
      { id: 555907, name: "Vadeshwar" },
      { id: 555959, name: "Vadivale" },
      { id: 556025, name: "Vagheshwar" },
      { id: 555958, name: "Valakh" },
      { id: 555924, name: "Valavanti" },
      { id: 944081, name: "Valvan" },
      { id: 556030, name: "Varale" },
      { id: 556015, name: "Varu" },
      { id: 555915, name: "Vaund" },
      { id: 555965, name: "Vehergaon" },
      { id: 555953, name: "Velhavali" },
      { id: 556053, name: "Wadagaon" },
      { id: 555904, name: "Wahangaon" },
      { id: 555946, name: "Waksai" },
      { id: 555947, name: "Warsoli" },
      { id: 555991, name: "Yelase" },
      { id: 556018, name: "Yelghol" },
    ],
    4192: [
      { id: 556074, name: "Adgaon" },
      { id: 556192, name: "Admal" },
      { id: 556145, name: "Akole" },
      { id: 944082, name: "Amalewadi" },
      { id: 556136, name: "Ambadwet" },
      { id: 556059, name: "Ambavane" },
      { id: 556163, name: "Ambegaon" },
      { id: 556155, name: "Andeshe" },
      { id: 556168, name: "Andgaon" },
      { id: 556090, name: "Andhale" },
      { id: 556141, name: "Asade" },
      { id: 556067, name: "Barpe Bk." },
      { id: 556124, name: "Bavadhan Bk" },
      { id: 944085, name: "Bavdhan Khurd" },
      { id: 556158, name: "Belawade" },
      { id: 556194, name: "Bembatmal" },
      { id: 556143, name: "Bhadas Bk." },
      { id: 556108, name: "Bhalgudi" },
      { id: 556071, name: "Bhambarde" },
      { id: 556135, name: "Bhare" },
      { id: 556101, name: "Bhegadewadi" },
      { id: 556179, name: "Bhode" },
      { id: 556185, name: "Bhoini" },
      { id: 556097, name: "Bhoirwadi" },
      { id: 556129, name: "Bhugaon" },
      { id: 556130, name: "Bhukum" },
      { id: 556162, name: "Botarwadi" },
      { id: 556133, name: "Chale" },
      { id: 556098, name: "Chande" },
      { id: 556063, name: "Chandivali" },
      { id: 556110, name: "Chikhalgaon" },
      { id: 556200, name: "Chikhali Bk." },
      { id: 556156, name: "Chinchwad" },
      { id: 556132, name: "Dakhane" },
      { id: 556137, name: "Darawali" },
      { id: 556186, name: "Dasave" },
      { id: 556081, name: "Dattawadi" },
      { id: 556173, name: "Davaje" },
      { id: 556056, name: "Devghar" },
      { id: 556197, name: "Dhadawali" },
      { id: 556182, name: "Dhamanohol" },
      { id: 556078, name: "Disali" },
      { id: 556115, name: "Dongargaon" },
      { id: 556072, name: "Ekole" },
      { id: 556189, name: "Gadale" },
      { id: 556089, name: "Gheravitangad" },
      { id: 556102, name: "Ghotavade" },
      { id: 556073, name: "Ghutake" },
      { id: 556095, name: "Godambewadi" },
      { id: 556112, name: "Hadashi" },
      { id: 556201, name: "Hinjavadi" },
      { id: 556116, name: "Hotale" },
      { id: 556147, name: "Hulavalewadi" },
      { id: 556121, name: "Jambe" },
      { id: 556079, name: "Jamgaon" },
      { id: 556175, name: "Jatede" },
      { id: 556104, name: "Jawal" },
      { id: 556152, name: "Kalamshet" },
      { id: 556138, name: "Karmoli" },
      { id: 556149, name: "Kasar Amboli" },
      { id: 556118, name: "Kasarsai" },
      { id: 556106, name: "Kashig" },
      { id: 556091, name: "Katar Khadak" },
      { id: 556172, name: "Katavadi" },
      { id: 556105, name: "Kemasewadi" },
      { id: 556092, name: "Khamboli" },
      { id: 556167, name: "Kharavade" },
      { id: 556157, name: "Khechare" },
      { id: 556140, name: "Khubawali" },
      { id: 556166, name: "Kolavade" },
      { id: 556062, name: "Kolawali" },
      { id: 556183, name: "Koloshi" },
      { id: 556113, name: "Kolwan" },
      { id: 556151, name: "Kondhawale" },
      { id: 556174, name: "Kondhur" },
      { id: 556131, name: "Kule" },
      { id: 556061, name: "Kumbheri" },
      { id: 556128, name: "Lavale" },
      { id: 556165, name: "Lavharde" },
      { id: 556122, name: "Mahalunge" },
      { id: 556060, name: "Majgaon" },
      { id: 556080, name: "Male" },
      { id: 556176, name: "Malegaon" },
      { id: 556096, name: "Man" },
      { id: 556154, name: "Mandede" },
      { id: 556159, name: "Maranewadi" },
      { id: 556125, name: "Marunji" },
      { id: 556100, name: "Materewadi" },
      { id: 556198, name: "Mose Kh." },
      { id: 556184, name: "Mugaon" },
      { id: 556134, name: "Mugavade" },
      { id: 556161, name: "Mukaiwadi" },
      { id: 556126, name: "Mulkhed" },
      { id: 556086, name: "Mulshi Kh." },
      { id: 556169, name: "Mutha" },
      { id: 556127, name: "Nande" },
      { id: 556109, name: "Nandgaon" },
      { id: 556069, name: "Nandivali" },
      { id: 556117, name: "Nanegaon" },
      { id: 556119, name: "Nere" },
      { id: 556085, name: "Nive" },
      { id: 556187, name: "Padalghar" },
      { id: 556103, name: "Padalgharwadi" },
      { id: 556193, name: "Palase" },
      { id: 556195, name: "Patharshet" },
      { id: 556148, name: "Paud" },
      { id: 556058, name: "Peth Shahapur" },
      { id: 556093, name: "Pimpaloli" },
      { id: 556075, name: "Pimpri" },
      { id: 556202, name: "Pirangut" },
      { id: 556064, name: "Pomgaon" },
      { id: 944155, name: "Punawale" },
      { id: 556146, name: "Ravade" },
      { id: 556094, name: "Rihe" },
      { id: 556199, name: "Saiv Kh" },
      { id: 556190, name: "Sakhari" },
      { id: 556065, name: "Saltar" },
      { id: 556077, name: "Sambhave" },
      { id: 556111, name: "Sathesai" },
      { id: 556139, name: "Savargaon" },
      { id: 556070, name: "Shedani" },
      { id: 556153, name: "Shere" },
      { id: 556144, name: "Shileshwar" },
      { id: 556068, name: "Shirvali" },
      { id: 556123, name: "Sus" },
      { id: 556066, name: "Tail Baila" },
      { id: 556088, name: "Tamhini Bk" },
      { id: 556082, name: "Tata Talav" },
      { id: 944083, name: "Tathawade" },
      { id: 556196, name: "Tav" },
      { id: 556181, name: "Temghar" },
      { id: 944084, name: "Thergaon" },
      { id: 556188, name: "Ugavali" },
      { id: 556160, name: "Uravade" },
      { id: 556083, name: "Vadgaon" },
      { id: 556076, name: "Valane" },
      { id: 556084, name: "Vandre" },
      { id: 556180, name: "Vede" },
      { id: 556057, name: "Visakhar" },
      { id: 556150, name: "Vitthalwadi" },
      { id: 556191, name: "Wadavali" },
      { id: 944086, name: "Wakad" },
      { id: 556114, name: "Walen" },
      { id: 556178, name: "Wanjale" },
      { id: 556087, name: "Warak" },
      { id: 556177, name: "Watunde" },
      { id: 556164, name: "Wegare" },
    ],
    4193: [
      { id: 556254, name: "Agalambe" },
      { id: 944088, name: "Akurdi" },
      { id: 556322, name: "Alandi Mhatobachi" },
      { id: 556274, name: "Ambee" },
      { id: 556242, name: "Ambegaon Bk." },
      { id: 556243, name: "Ambegaon Kh" },
      { id: 556280, name: "Arvi" },
      { id: 556305, name: "Ashtapur" },
      { id: 556295, name: "Autade Handewadi" },
      { id: 556282, name: "Awasare Nagar" },
      { id: 556224, name: "Awhalwadi" },
      { id: 556253, name: "Bahuli" },
      { id: 556221, name: "Bakori" },
      { id: 944113, name: "Balewadi" },
      { id: 944112, name: "Baner" },
      { id: 556270, name: "Bhagatwadi" },
      { id: 556223, name: "Bhawadi" },
      { id: 556309, name: "Bhawarapur" },
      { id: 556300, name: "Bhilarewadi" },
      { id: 944116, name: "Bhosari" },
      { id: 556229, name: "Biwari" },
      { id: 944114, name: "Bopkhel" },
      { id: 944115, name: "Borhadewadi" },
      { id: 556215, name: "Burkegaon" },
      { id: 944098, name: "Charholi Bk." },
      { id: 944101, name: "Chikhali" },
      { id: 944100, name: "Chincholi" },
      { id: 944099, name: "Chinchwad" },
      { id: 944102, name: "Chovisawadi" },
      { id: 944105, name: "Dapodi" },
      { id: 556326, name: "Dehu" },
      { id: 944107, name: "Dhanakawadi" },
      { id: 944108, name: "Dhanori" },
      { id: 556240, name: "Dhayari" },
      { id: 944106, name: "Dighi" },
      { id: 556214, name: "Dongargaon" },
      { id: 556257, name: "Donje" },
      { id: 944103, name: "Dudulgaon" },
      { id: 556211, name: "Fulgaon" },
      { id: 556292, name: "Fursungi" },
      { id: 556284, name: "Gaud Dara" },
      { id: 556219, name: "Gawdewadi" },
      { id: 556267, name: "Ghera Sinhagad" },
      { id: 556279, name: "Gogalwadi" },
      { id: 556256, name: "Gorhe Bk." },
      { id: 556258, name: "Gorhe Kh." },
      { id: 556296, name: "Gujar Nimbalkarwadi" },
      { id: 556233, name: "Hadapsar" },
      { id: 944130, name: "Hingane Kh." },
      { id: 556307, name: "Hingangaon" },
      { id: 556302, name: "Holkarwadi" },
      { id: 556273, name: "Jambhali" },
      { id: 556297, name: "Jambhulwadi" },
      { id: 556314, name: "Kadamwak Wasti" },
      { id: 944089, name: "Kalas" },
      { id: 556281, name: "Kalyan" },
      { id: 944090, name: "Katraj" },
      { id: 556225, name: "Kesnand" },
      { id: 556259, name: "Khadakwadi" },
      { id: 556246, name: "Khadakwasala" },
      { id: 556251, name: "Khadewadi" },
      { id: 556275, name: "Khamgaon Mawal" },
      { id: 556308, name: "Khamgaon Tek" },
      { id: 556264, name: "Khanapur" },
      { id: 944096, name: "Kharadi" },
      { id: 944097, name: "Khedshivapur" },
      { id: 944091, name: "Kinhai" },
      { id: 556239, name: "Kirkitwadi" },
      { id: 944092, name: "Kiwale" },
      { id: 556298, name: "Kolawadi" },
      { id: 556227, name: "Kolwadi" },
      { id: 556286, name: "Kondhanpur" },
      { id: 944094, name: "Kondhave Bk." },
      { id: 556236, name: "Kondhave Dhavade" },
      { id: 944093, name: "Kondhave Kh." },
      { id: 556247, name: "Kopare" },
      { id: 556310, name: "Koregaon Mul" },
      { id: 944095, name: "Kothrud" },
      { id: 556255, name: "Kudaje" },
      { id: 556316, name: "Kunjirwadi" },
      { id: 556231, name: "Lahagaon" },
      { id: 556315, name: "Loni Kalbhor" },
      { id: 556222, name: "Lonikand" },
      { id: 944117, name: "M. Karvenagar" },
      { id: 944118, name: "Mahamadwadi" },
      { id: 556203, name: "Malinagar" },
      { id: 556263, name: "Malkhed" },
      { id: 944119, name: "Mamurdi" },
      { id: 556261, name: "Mandvi Bk." },
      { id: 556260, name: "Mandvi Kh." },
      { id: 556265, name: "Manerwadi" },
      { id: 556299, name: "Mangadewadi" },
      { id: 556232, name: "Manjari Bk" },
      { id: 556209, name: "Manjari Kh." },
      { id: 556276, name: "Mogarwadi" },
      { id: 556252, name: "Mokarwadi" },
      { id: 556268, name: "Mordarwadi" },
      { id: 944120, name: "Moshi" },
      { id: 556218, name: "Murkutenagar" },
      { id: 556317, name: "Naigaon" },
      { id: 556237, name: "Nanded" },
      { id: 556277, name: "Nandoshi" },
      { id: 556241, name: "Narhe" },
      { id: 556303, name: "Nhavi Sandas" },
      { id: 944109, name: "Nigadi" },
      { id: 556207, name: "Nirgudi" },
      { id: 556230, name: "Pashan" },
      { id: 556213, name: "Perane" },
      { id: 556311, name: "Peth" },
      { id: 556206, name: "Pimpale Gurav" },
      { id: 944111, name: "Pimpale Nilakh" },
      { id: 556205, name: "Pimpale Saudagar" },
      { id: 556216, name: "Pimpri Sandas" },
      { id: 944110, name: "Pimpri Waghere" },
      { id: 556244, name: "Pisoli" },
      { id: 944121, name: "Rahatani" },
      { id: 556288, name: "Rahatwade" },
      { id: 944122, name: "Ravet" },
      { id: 556266, name: "Sambarewadi" },
      { id: 556278, name: "Sanas Nagar" },
      { id: 556262, name: "Sangarun" },
      { id: 944128, name: "Sangavi Haveli" },
      { id: 556304, name: "Sangavi Sandas" },
      { id: 556228, name: "Sashte" },
      { id: 556291, name: "Shewalwadi" },
      { id: 556306, name: "Shindewadi" },
      { id: 556325, name: "Shindwane" },
      { id: 556217, name: "Shiraswadi" },
      { id: 556238, name: "Shivane" },
      { id: 556312, name: "Shriprayagdham" },
      { id: 556272, name: "Sonapur" },
      { id: 556320, name: "Sortapwadi" },
      { id: 944129, name: "Sutarwadi" },
      { id: 944104, name: "Talawade" },
      { id: 556226, name: "Taleranwadi" },
      { id: 556283, name: "Tanaji Nagar" },
      { id: 556323, name: "Tarade" },
      { id: 556313, name: "Theur" },
      { id: 556269, name: "Thoptewadi" },
      { id: 556318, name: "Tilekarwadi" },
      { id: 556210, name: "Tulapur" },
      { id: 556245, name: "Undri" },
      { id: 556293, name: "Uruli Dewachi" },
      { id: 556319, name: "Uruli Kanchan" },
      { id: 556204, name: "Vitthal Nagar" },
      { id: 556301, name: "Wadachiwadi" },
      { id: 556220, name: "Wade Bolhai" },
      { id: 944124, name: "Wadgaon Bk." },
      { id: 944123, name: "Wadgaon Kh." },
      { id: 944125, name: "Wadgaon Sheri" },
      { id: 556208, name: "Wadgaon Shinde" },
      { id: 556212, name: "Wadhu Kh." },
      { id: 556294, name: "Wadki" },
      { id: 944126, name: "Wadmukhwadi" },
      { id: 556327, name: "Wagholi" },
      { id: 556324, name: "Walati" },
      { id: 556250, name: "Wanjalewadi" },
      { id: 944127, name: "Waraje" },
      { id: 556271, name: "Wardade" },
      { id: 556328, name: "Yewalewadi" },
    ],
    4194: [
      { id: 944058, name: "Aundh" },
      { id: 944060, name: "Bopodi" },
      { id: 944059, name: "Ghorpadi" },
      { id: 944061, name: "Mundhava" },
      { id: 944063, name: "Wanavdi" },
      { id: 944062, name: "Yerawada" },
    ],
    4195: [
      { id: 556406, name: "Alegaon" },
      { id: 556372, name: "Amoni Mal" },
      { id: 556387, name: "Betwadi" },
      { id: 556364, name: "Bhandgaon" },
      { id: 556362, name: "Bharatgoan" },
      { id: 556347, name: "Boratewasti" },
      { id: 556361, name: "Boriaindi" },
      { id: 556419, name: "Boribel" },
      { id: 556358, name: "Boribhadak" },
      { id: 556378, name: "Boripardhi" },
      { id: 556431, name: "Chincholi" },
      { id: 556339, name: "Dahitane" },
      { id: 556359, name: "Dalimb" },
      { id: 556377, name: "Dapodi" },
      { id: 556432, name: "Daund" },
      { id: 556343, name: "Delvadi" },
      { id: 556376, name: "Deshmukh Mala" },
      { id: 556382, name: "Deulgaon Gada" },
      { id: 556407, name: "Deulgaon Raje" },
      { id: 556337, name: "Devkarwadi" },
      { id: 944057, name: "Dhayagudewadi" },
      { id: 556381, name: "Dhumalicha Mala" },
      { id: 556420, name: "Gadewadi" },
      { id: 556368, name: "Galandwadi" },
      { id: 556371, name: "Ganesh Road" },
      { id: 556386, name: "Gar" },
      { id: 556402, name: "Girim" },
      { id: 556403, name: "Gopalwadi" },
      { id: 556374, name: "Handalwadi" },
      { id: 556384, name: "Hatwalan" },
      { id: 556411, name: "Hingani Berdi" },
      { id: 556394, name: "Hinganigada" },
      { id: 556356, name: "Jawje Buwachiwadi" },
      { id: 556398, name: "Jiregaon" },
      { id: 556413, name: "Kadamwasti" },
      { id: 556412, name: "Kalewadi" },
      { id: 556354, name: "Kamathwadi" },
      { id: 556385, name: "Kangaon" },
      { id: 556355, name: "Kasurdi" },
      { id: 556417, name: "Kauthadi" },
      { id: 556379, name: "Kedgaon" },
      { id: 556375, name: "Kedgaon Station" },
      { id: 556423, name: "Khadaki" },
      { id: 556349, name: "Khamgaon" },
      { id: 556429, name: "Khanvate" },
      { id: 556373, name: "Khopodi" },
      { id: 556366, name: "Khor" },
      { id: 556405, name: "Khorwadi" },
      { id: 556352, name: "Khutbav" },
      { id: 556334, name: "Koregaon Bhiwar" },
      { id: 556396, name: "Kurkumbh" },
      { id: 556393, name: "Kusegaon" },
      { id: 556404, name: "Lingali" },
      { id: 556424, name: "Lonarwadi" },
      { id: 556418, name: "Maladpatas" },
      { id: 556425, name: "Malthan" },
      { id: 556415, name: "Malwadi" },
      { id: 556414, name: "Masanarwadi" },
      { id: 556416, name: "Mergalwadi" },
      { id: 556338, name: "Mirwadi" },
      { id: 556422, name: "Nandadevi" },
      { id: 556348, name: "Nandur" },
      { id: 556370, name: "Nangaon" },
      { id: 556400, name: "Nanwij" },
      { id: 556388, name: "Navingar" },
      { id: 556427, name: "Naygaon" },
      { id: 556383, name: "Padvi" },
      { id: 556397, name: "Pandharewadi" },
      { id: 556332, name: "Panwali" },
      { id: 556369, name: "Pargaon" },
      { id: 556391, name: "Patas" },
      { id: 556330, name: "Patethan" },
      { id: 556380, name: "Patil Nimbalkar Vasti" },
      { id: 556409, name: "Pedgaon" },
      { id: 556336, name: "Pilanwadi" },
      { id: 556367, name: "Pimpalachiwadi" },
      { id: 556341, name: "Pimpalgaon" },
      { id: 556340, name: "Rahu" },
      { id: 556428, name: "Rajegaon" },
      { id: 556421, name: "Ravangaon" },
      { id: 556395, name: "Roti" },
      { id: 556357, name: "Sahajpur" },
      { id: 556410, name: "Shirapur" },
      { id: 556401, name: "Sonwadi" },
      { id: 556331, name: "Takali" },
      { id: 556350, name: "Tambewadi" },
      { id: 556360, name: "Tamhanwadi" },
      { id: 556335, name: "Telewadi" },
      { id: 556351, name: "Undawadi" },
      { id: 556333, name: "Vadgaonbande" },
      { id: 556365, name: "Vakhari" },
      { id: 556342, name: "Valki" },
      { id: 556390, name: "Varvand" },
      { id: 556399, name: "Vasunde" },
      { id: 556408, name: "Wadgaon Darekar" },
      { id: 556426, name: "Watluj" },
      { id: 556363, name: "Yawat" },
      { id: 556353, name: "Yawat Station" },
    ],
    4196: [
      { id: 556462, name: "Ambale" },
      { id: 556444, name: "Ambodi" },
      { id: 556433, name: "Askarwadi" },
      { id: 556507, name: "Bahirwadi" },
      { id: 556506, name: "Bandhalwadi" },
      { id: 556485, name: "Belsar" },
      { id: 556455, name: "Bhivadi" },
      { id: 556435, name: "Bhivari" },
      { id: 556476, name: "Bhosalewadi" },
      { id: 556436, name: "Bopgaon" },
      { id: 556498, name: "Borhalwadi" },
      { id: 556437, name: "Chambali" },
      { id: 556495, name: "Chivhewadi" },
      { id: 556525, name: "Daundaj" },
      { id: 556505, name: "Dawanewadi" },
      { id: 556494, name: "Devadi" },
      { id: 944065, name: "Devmala" },
      { id: 556484, name: "Dhalewadi" },
      { id: 556513, name: "Dhanakwadi" },
      { id: 556446, name: "Dive" },
      { id: 556489, name: "Ekhatpur" },
      { id: 556449, name: "Garade" },
      { id: 556508, name: "Gherapurandhar" },
      { id: 556535, name: "Gulunche" },
      { id: 556458, name: "Gurholi" },
      { id: 556504, name: "Hargude" },
      { id: 556517, name: "Harni" },
      { id: 556448, name: "Hivare" },
      { id: 556438, name: "Jadhavwadi" },
      { id: 556480, name: "Jawalarjun" },
      { id: 944064, name: "Jejuri" },
      { id: 556539, name: "Jeur" },
      { id: 556512, name: "Kaldari" },
      { id: 556440, name: "Kalewadi" },
      { id: 556534, name: "Karnalwadi" },
      { id: 556510, name: "Ketkawale" },
      { id: 556488, name: "Khalad" },
      { id: 556475, name: "Khanvadi" },
      { id: 556502, name: "Khengarewadi" },
      { id: 556454, name: "Kodit Bk." },
      { id: 556453, name: "Kodit Kh." },
      { id: 556526, name: "Kolvihire" },
      { id: 556477, name: "Kothale" },
      { id: 556473, name: "Kumbharvalan" },
      { id: 556511, name: "Kumbhoshi" },
      { id: 556515, name: "Mahur" },
      { id: 556465, name: "Malshiras" },
      { id: 556538, name: "Mandaki" },
      { id: 556514, name: "Mandhar" },
      { id: 556527, name: "Mawadi Kade Pathar" },
      { id: 556472, name: "Mawadi Supe" },
      { id: 556509, name: "Misalawadi" },
      { id: 556474, name: "Munjvadi" },
      { id: 556528, name: "Nawali" },
      { id: 556470, name: "Naygaon" },
      { id: 556482, name: "Nazare Kade Pathar" },
      { id: 556481, name: "Nazare Supe" },
      { id: 556486, name: "Nilunj" },
      { id: 556541, name: "Nira Shivtakrar" },
      { id: 556479, name: "Pandeshwar" },
      { id: 556500, name: "Pangare" },
      { id: 556496, name: "Panvadi" },
      { id: 556460, name: "Pargaon" },
      { id: 556516, name: "Parinche" },
      { id: 556434, name: "Patharwadi" },
      { id: 556447, name: "Pawarwadi" },
      { id: 556499, name: "Pimpale" },
      { id: 556540, name: "Pimpre Kh." },
      { id: 556478, name: "Pimpri" },
      { id: 556524, name: "Pingori" },
      { id: 556471, name: "Pisarve" },
      { id: 556467, name: "Pise" },
      { id: 556537, name: "Pisurti" },
      { id: 556457, name: "Pokhar" },
      { id: 556466, name: "Pondhe" },
      { id: 556456, name: "Pur" },
      { id: 556463, name: "Rajewadi" },
      { id: 556469, name: "Rajuri" },
      { id: 556529, name: "Rakh" },
      { id: 556483, name: "Ranamala" },
      { id: 556468, name: "Rise" },
      { id: 556492, name: "Sakurde" },
      { id: 944066, name: "Saswad" },
      { id: 556501, name: "Shindewadi" },
      { id: 556490, name: "Shivari" },
      { id: 556459, name: "Singapur" },
      { id: 556452, name: "Somurdi" },
      { id: 556441, name: "Sonori" },
      { id: 944067, name: "Stationnagar" },
      { id: 556497, name: "Supe Kh." },
      { id: 556491, name: "Takrarwadi" },
      { id: 556464, name: "Tekavadi" },
      { id: 556450, name: "Thapewadi" },
      { id: 556536, name: "Thopatewadi" },
      { id: 556520, name: "Tondal" },
      { id: 556443, name: "Udachiwadi" },
      { id: 556442, name: "Vanpuri" },
      { id: 556521, name: "Veer" },
      { id: 556461, name: "Waghapur" },
      { id: 556532, name: "Walhe" },
      { id: 556487, name: "Walunj" },
      { id: 556451, name: "Warvadi" },
      { id: 556439, name: "Zendewadi" },
    ],
    4197: [
      { id: 556656, name: "Adavali" },
      { id: 556661, name: "Ambavane" },
      { id: 556566, name: "Ambed" },
      { id: 556572, name: "Ambegaon Bk" },
      { id: 556552, name: "Ambegaon Kh." },
      { id: 556628, name: "Antroli" },
      { id: 556669, name: "Asani Damguda" },
      { id: 556670, name: "Asani Manjai" },
      { id: 556643, name: "Askavadi" },
      { id: 556548, name: "Balvad" },
      { id: 556611, name: "Barshicha Mal" },
      { id: 556655, name: "Bhaginghar" },
      { id: 556618, name: "Bhalvadi" },
      { id: 556600, name: "Bhatti Wagdra" },
      { id: 556609, name: "Bhordi" },
      { id: 556587, name: "Bopalghar" },
      { id: 556637, name: "Boravale" },
      { id: 556597, name: "Brahmanghar" },
      { id: 556582, name: "Chandar" },
      { id: 556588, name: "Chapet" },
      { id: 556601, name: "Charhat Wadi" },
      { id: 556547, name: "Chikhali Kh." },
      { id: 556659, name: "Chinchale Bk" },
      { id: 556660, name: "Chinchale Kh" },
      { id: 556653, name: "Chirmodi" },
      { id: 556650, name: "Dadvadi" },
      { id: 556595, name: "Dapode" },
      { id: 556542, name: "Dapsare" },
      { id: 556590, name: "Dhanep" },
      { id: 556570, name: "Dhindali" },
      { id: 556608, name: "Ekalgaon" },
      { id: 556602, name: "Gevhande" },
      { id: 556654, name: "Ghavar" },
      { id: 556584, name: "Ghisar" },
      { id: 556545, name: "Ghodkhal" },
      { id: 556575, name: "Ghodshet" },
      { id: 556580, name: "Ghol" },
      { id: 556551, name: "Gholapghar" },
      { id: 556573, name: "Givashi" },
      { id: 556544, name: "Gondekhal" },
      { id: 556625, name: "Gugulshi" },
      { id: 556671, name: "Gunjavane" },
      { id: 556606, name: "Harpud" },
      { id: 556593, name: "Hirpodi" },
      { id: 556603, name: "Jadhavwadi" },
      { id: 556568, name: "Kadave" },
      { id: 556550, name: "Kambegi" },
      { id: 556586, name: "Kanand" },
      { id: 556658, name: "Karanjavane" },
      { id: 556627, name: "Karnavadi" },
      { id: 556546, name: "Kasedi" },
      { id: 556640, name: "Katavadi" },
      { id: 556623, name: "Kelad" },
      { id: 556657, name: "Ketkavane" },
      { id: 556641, name: "Khambavadi" },
      { id: 556565, name: "Khamgaon" },
      { id: 556581, name: "Khanu" },
      { id: 556629, name: "Khariv" },
      { id: 556596, name: "Khodad" },
      { id: 556617, name: "Khopde Wadi" },
      { id: 556668, name: "Kodavadi" },
      { id: 556604, name: "Kolambi" },
      { id: 556634, name: "Kolavadi" },
      { id: 556563, name: "Kondgaon" },
      { id: 556592, name: "Kondhavale Bk" },
      { id: 556591, name: "Kondhavale Kh." },
      { id: 556645, name: "Kondhavali" },
      { id: 556549, name: "Koshimghar" },
      { id: 556558, name: "Kuran Bk" },
      { id: 556559, name: "Kuran Kh" },
      { id: 556543, name: "Kurtavadi" },
      { id: 556553, name: "Kurvadi" },
      { id: 556631, name: "Lashirgaon" },
      { id: 556647, name: "Lavhi Bk" },
      { id: 556651, name: "Lavhi Kh" },
      { id: 556621, name: "Majgaon" },
      { id: 556632, name: "Malavali" },
      { id: 556578, name: "Mangaon" },
      { id: 556639, name: "Mangdari" },
      { id: 556642, name: "Margasani" },
      { id: 556646, name: "Meravane" },
      { id: 556612, name: "Metpilaware" },
      { id: 556583, name: "Mohari" },
      { id: 556554, name: "Mose Bk" },
      { id: 556562, name: "Nigade Mose" },
      { id: 556638, name: "Nigde Bk." },
      { id: 556622, name: "Nigde Kh" },
      { id: 556585, name: "Nivi" },
      { id: 556561, name: "Osade" },
      { id: 556594, name: "Pabe" },
      { id: 556615, name: "Pal Bk." },
      { id: 556616, name: "Pal Kh." },
      { id: 556626, name: "Pangari" },
      { id: 556557, name: "Panshet" },
      { id: 556620, name: "Pasali" },
      { id: 556652, name: "Phanshi" },
      { id: 556649, name: "Pimpri" },
      { id: 556624, name: "Pishawi" },
      { id: 556577, name: "Pole" },
      { id: 556564, name: "Ranjane" },
      { id: 556560, name: "Ranvadi" },
      { id: 556567, name: "Rule" },
      { id: 556555, name: "Saiv Bk." },
      { id: 556644, name: "Sakhar" },
      { id: 556619, name: "Shenvad" },
      { id: 556574, name: "Shirkoli" },
      { id: 556607, name: "Singapur" },
      { id: 556662, name: "Sonde Hiroji" },
      { id: 556663, name: "Sonde Karla" },
      { id: 556665, name: "Sonde Mathana" },
      { id: 556664, name: "Sonde Sarpale" },
      { id: 556667, name: "Suravad" },
      { id: 556579, name: "Tekpole" },
      { id: 556576, name: "Thangaon" },
      { id: 556666, name: "Vadgaon (Zanje)" },
      { id: 556571, name: "Vadghar" },
      { id: 556614, name: "Vajeghar Bk." },
      { id: 556648, name: "Vajeghar Kh" },
      { id: 556630, name: "Vanjale" },
      { id: 556569, name: "Vanjalwadi" },
      { id: 556556, name: "Varasgaon" },
      { id: 556605, name: "Varoti Bk" },
      { id: 556610, name: "Varoti Kh." },
      { id: 556599, name: "Velhe Bk." },
      { id: 556598, name: "Velhe Bk. Ghera" },
      { id: 556613, name: "Velhe Kh." },
      { id: 556589, name: "Vihir" },
      { id: 556633, name: "Vinzar" },
      { id: 556636, name: "Wangani" },
      { id: 556635, name: "Wanganichi Wadi" },
    ],
    4198: [
      { id: 556866, name: "Aambade" },
      { id: 556810, name: "Abhepuri" },
      { id: 943024, name: "Adachi Wadi" },
      { id: 556733, name: "Alande" },
      { id: 556838, name: "Ambavade" },
      { id: 556828, name: "Ambeghar" },
      { id: 556836, name: "Angasule" },
      { id: 556799, name: "Apti" },
      { id: 556807, name: "Ashimpi" },
      { id: 556857, name: "Bajarwadi" },
      { id: 556861, name: "Balawadi" },
      { id: 556775, name: "Bare Bk." },
      { id: 556776, name: "Bare Kh." },
      { id: 556777, name: "Basarapur" },
      { id: 556853, name: "Bhabavadi" },
      { id: 556734, name: "Bhairavnathnagar" },
      { id: 556815, name: "Bhambatmal" },
      { id: 556729, name: "Bhambavade" },
      { id: 556743, name: "Bhandravali" },
      { id: 556788, name: "Bhanusdara" },
      { id: 556835, name: "Bhavekhal" },
      { id: 556703, name: "Bhilarewadi" },
      { id: 556780, name: "Bholavade" },
      { id: 556722, name: "Bhongvali" },
      { id: 944073, name: "Bhor" },
      { id: 556741, name: "Bhutonde" },
      { id: 556760, name: "Bope" },
      { id: 944072, name: "Bramhanghar Hi. Ma." },
      { id: 556738, name: "Bramhanghar Velwand Khore" },
      { id: 556759, name: "Chandavane" },
      { id: 556831, name: "Chikhalavade Kh." },
      { id: 944071, name: "Chikhalawade Bk." },
      { id: 556848, name: "Chikhalgaon" },
      { id: 556818, name: "Dapakeghar" },
      { id: 556690, name: "Degaon" },
      { id: 556765, name: "Dehen" },
      { id: 556742, name: "Dere" },
      { id: 556802, name: "Devghar" },
      { id: 556792, name: "Dhamunashi" },
      { id: 556820, name: "Dhanavali" },
      { id: 556716, name: "Dhangawadi" },
      { id: 556858, name: "Dhavadi" },
      { id: 943025, name: "Dhondewadi" },
      { id: 556704, name: "Didghar" },
      { id: 556713, name: "Divale" },
      { id: 556811, name: "Durgadi" },
      { id: 556782, name: "Gawadi" },
      { id: 556856, name: "Gokavadi" },
      { id: 556753, name: "Gorad Mhashivali" },
      { id: 556822, name: "Gudhe" },
      { id: 556739, name: "Guhini" },
      { id: 556725, name: "Gunand" },
      { id: 556712, name: "Harishchandri" },
      { id: 556757, name: "Harnas" },
      { id: 556702, name: "Hatave Bk." },
      { id: 556854, name: "Hatnoshi" },
      { id: 556701, name: "Hatve Kh." },
      { id: 556804, name: "Hirdoshi" },
      { id: 556735, name: "Ingavali" },
      { id: 556697, name: "Jambhali" },
      { id: 556767, name: "Jayatpad" },
      { id: 556754, name: "Jogawadi" },
      { id: 556747, name: "Kambare Bk." },
      { id: 556746, name: "Kambare Kh." },
      { id: 944069, name: "Kambare Khe. Ba." },
      { id: 556693, name: "Kamthadi" },
      { id: 556683, name: "Kanjale" },
      { id: 556714, name: "Kapurhol" },
      { id: 556748, name: "Karandi Bk." },
      { id: 556750, name: "Karandi Kh." },
      { id: 556691, name: "Karandi Khe Ba" },
      { id: 556832, name: "Karanje" },
      { id: 556796, name: "Karanjgaon" },
      { id: 556837, name: "Kari" },
      { id: 556840, name: "Karnavad" },
      { id: 556773, name: "Karnvadi" },
      { id: 556806, name: "Karungan" },
      { id: 556710, name: "Kasurdi (Gunjan Mawal)" },
      { id: 556675, name: "Kasurdi K.B" },
      { id: 556688, name: "Kelawade" },
      { id: 556731, name: "Kenjal" },
      { id: 556692, name: "Ketkavane (Nimme)" },
      { id: 556707, name: "Khadki" },
      { id: 556852, name: "Khanapur" },
      { id: 556678, name: "Khopi" },
      { id: 556740, name: "Khulshi" },
      { id: 556717, name: "Kikvi" },
      { id: 556781, name: "Kiwat" },
      { id: 556698, name: "Kolavadi" },
      { id: 944070, name: "Kolewadi" },
      { id: 556763, name: "Kondgaon" },
      { id: 556793, name: "Kondhari" },
      { id: 556846, name: "Korle" },
      { id: 556824, name: "Kudali Bk." },
      { id: 556823, name: "Kudali Kh." },
      { id: 556841, name: "Kudpanewadi" },
      { id: 556758, name: "Kumbale" },
      { id: 556789, name: "Kund" },
      { id: 556686, name: "Kurungvadi" },
      { id: 556745, name: "Kurunji" },
      { id: 556677, name: "Kusagaon" },
      { id: 556756, name: "Lavheri" },
      { id: 943016, name: "Madgudevadi" },
      { id: 556785, name: "Mahude Bk." },
      { id: 556787, name: "Mahude Kh." },
      { id: 556744, name: "Male" },
      { id: 556694, name: "Malegaon" },
      { id: 556813, name: "Mazeri" },
      { id: 556755, name: "Mazgaon" },
      { id: 556843, name: "Mhakoshi" },
      { id: 556774, name: "Mhalavadi" },
      { id: 556794, name: "Mhasar Bk." },
      { id: 556795, name: "Mhasar Kh." },
      { id: 556709, name: "Mohari Bk." },
      { id: 556711, name: "Mohari Kh." },
      { id: 556718, name: "Morwadi" },
      { id: 556764, name: "Nanavale" },
      { id: 556784, name: "Nand" },
      { id: 556800, name: "Nandgaon" },
      { id: 556768, name: "Nandghur" },
      { id: 556737, name: "Narhe" },
      { id: 556695, name: "Nasrapur" },
      { id: 556829, name: "Natambi" },
      { id: 556689, name: "Naygaon" },
      { id: 556839, name: "Nazre" },
      { id: 556860, name: "Nere" },
      { id: 556727, name: "Nhavi" },
      { id: 556705, name: "Nidhan" },
      { id: 556715, name: "Nigde" },
      { id: 556801, name: "Nigudghar" },
      { id: 556855, name: "Nilakanth" },
      { id: 556821, name: "Nivangan" },
      { id: 556862, name: "Pale" },
      { id: 556859, name: "Palsoshi" },
      { id: 556730, name: "Pande" },
      { id: 556766, name: "Pangari" },
      { id: 556833, name: "Panhaval" },
      { id: 556814, name: "Parhar Bk." },
      { id: 556819, name: "Parhar Kh." },
      { id: 556684, name: "Parwadi" },
      { id: 556771, name: "Pasure" },
      { id: 556723, name: "Penjalwadi" },
      { id: 556797, name: "Pisavare" },
      { id: 556825, name: "Pombardi" },
      { id: 556728, name: "Rajapur" },
      { id: 556770, name: "Rajghar" },
      { id: 556790, name: "Rajivadi" },
      { id: 556676, name: "Ranjhe" },
      { id: 556849, name: "Ravdi" },
      { id: 556817, name: "Rayari" },
      { id: 556816, name: "Salav" },
      { id: 556687, name: "Salavade" },
      { id: 556762, name: "Salungan" },
      { id: 556736, name: "Sangamner" },
      { id: 556778, name: "Sangvi (Hirdas Maval)" },
      { id: 556761, name: "Sangvi (Velavade Khore)" },
      { id: 556699, name: "Sangvi Bk." },
      { id: 556706, name: "Sangvi Kh." },
      { id: 556834, name: "Sangvi Tarf Bhor" },
      { id: 556720, name: "Sarole" },
      { id: 556672, name: "Sasewadi" },
      { id: 556721, name: "Savardare" },
      { id: 556791, name: "Shilimb" },
      { id: 556783, name: "Shind" },
      { id: 556673, name: "Shindewadi" },
      { id: 556809, name: "Shirgaon" },
      { id: 556812, name: "Shirvali (Hirdas Maval)" },
      { id: 556827, name: "Shirvali Tarf Bhor" },
      { id: 556679, name: "Shivare" },
      { id: 556845, name: "Shivnagari" },
      { id: 556685, name: "Sonavadi" },
      { id: 556752, name: "Tale Mhasavali" },
      { id: 556772, name: "Taljainagar" },
      { id: 556700, name: "Tambhad" },
      { id: 556724, name: "Taprewadi" },
      { id: 556732, name: "Telavadi" },
      { id: 556847, name: "Titeghar" },
      { id: 556808, name: "Umbarde" },
      { id: 556708, name: "Umbare" },
      { id: 556851, name: "Utroli" },
      { id: 556850, name: "Vadgaon Dal" },
      { id: 556749, name: "Vadhane" },
      { id: 556844, name: "Vadtumbi" },
      { id: 556751, name: "Vakambe" },
      { id: 556805, name: "Varavand" },
      { id: 556865, name: "Varodi Bk." },
      { id: 556864, name: "Varodi Daymukh" },
      { id: 556863, name: "Varodi Kh." },
      { id: 556682, name: "Varve Bk." },
      { id: 556680, name: "Varve Kh." },
      { id: 556798, name: "Vathar (Hirdas Maval)" },
      { id: 556726, name: "Vatharhinge" },
      { id: 556842, name: "Vaveghar" },
      { id: 556674, name: "Velu" },
      { id: 556769, name: "Velvand" },
      { id: 556826, name: "Venavadi" },
      { id: 556803, name: "Venupuri" },
      { id: 556696, name: "Virwadi" },
      { id: 556719, name: "Wagajwadi" },
      { id: 556779, name: "Yevali" },
    ],
    4199: [
      { id: 556876, name: "Ambi Bk" },
      { id: 556875, name: "Ambi Kh" },
      { id: 556912, name: "Anjangaon" },
      { id: 556883, name: "Baburdi" },
      { id: 556960, name: "Bajrangwadi" },
      { id: 556975, name: "Baramati" },
      { id: 556902, name: "Barhanpur" },
      { id: 556914, name: "Bhilarwadi" },
      { id: 556874, name: "Bhondvewadi" },
      { id: 556879, name: "Chandgude Wadi" },
      { id: 556924, name: "Chaudhar Wadi" },
      { id: 556927, name: "Chopadaj" },
      { id: 556868, name: "Dandwadi" },
      { id: 556885, name: "Deulgaon Rasal" },
      { id: 556935, name: "Deulwadi" },
      { id: 556915, name: "Dhakale" },
      { id: 556979, name: "Dhekalwadi" },
      { id: 556954, name: "Dhumalwadi" },
      { id: 556977, name: "Dorlewadi" },
      { id: 556938, name: "Gadadarwadi" },
      { id: 556892, name: "Gadikhel" },
      { id: 556982, name: "Ghadagewadi" },
      { id: 943022, name: "Gitewasti" },
      { id: 556898, name: "Gojubavi" },
      { id: 556974, name: "Gunwadi" },
      { id: 556932, name: "Hol" },
      { id: 556900, name: "Jainakwadi" },
      { id: 556918, name: "Jalakewadi" },
      { id: 556911, name: "Jalgaon Kade Pathar" },
      { id: 556886, name: "Jalgaon Supe" },
      { id: 556983, name: "Jalochi" },
      { id: 556893, name: "Jaradwadi" },
      { id: 556877, name: "Jogwadi" },
      { id: 556881, name: "Kalkhairewadi" },
      { id: 556963, name: "Kambleshwar" },
      { id: 556926, name: "Kanadwadi" },
      { id: 556971, name: "Kanheri" },
      { id: 556936, name: "Karanje" },
      { id: 556941, name: "Karanjepul" },
      { id: 556884, name: "Karhati" },
      { id: 556913, name: "Karhavagaj" },
      { id: 556895, name: "Karkhel" },
      { id: 556972, name: "Katewadi" },
      { id: 556899, name: "Katphal" },
      { id: 556916, name: "Khamagalwadi" },
      { id: 556966, name: "Khandaj" },
      { id: 556937, name: "Khandobachiwadi" },
      { id: 556880, name: "Khandukhairewadi" },
      { id: 556887, name: "Kharade Wadi" },
      { id: 556870, name: "Kololi" },
      { id: 556929, name: "Korhale Bk" },
      { id: 556946, name: "Korhale Kh" },
      { id: 556956, name: "Kurnewadi" },
      { id: 556873, name: "Kutwalwadi" },
      { id: 556961, name: "Late" },
      { id: 556908, name: "Loni Bhapkar" },
      { id: 556934, name: "Magarwadi" },
      { id: 556976, name: "Malad" },
      { id: 556949, name: "Malegaon Bk" },
      { id: 556948, name: "Malegaon Kh." },
      { id: 556931, name: "Malshikare Wadi" },
      { id: 944068, name: "Malwadi" },
      { id: 556959, name: "Malwadi Late" },
      { id: 556955, name: "Manappawasti" },
      { id: 556920, name: "Masalwadi" },
      { id: 556904, name: "Medad" },
      { id: 556981, name: "Mekhali" },
      { id: 943028, name: "Mhasobanagar" },
      { id: 556922, name: "Modhave" },
      { id: 556921, name: "Moralwadi" },
      { id: 556878, name: "Morgaon" },
      { id: 556917, name: "Mudhale" },
      { id: 556906, name: "Murti" },
      { id: 556944, name: "Murum" },
      { id: 556869, name: "Naroli" },
      { id: 556903, name: "Nepat Valan" },
      { id: 556891, name: "Nimbodi" },
      { id: 556939, name: "Nimbut" },
      { id: 556967, name: "Niravagaj" },
      { id: 556950, name: "Pahunewadi" },
      { id: 556919, name: "Palshiwadi" },
      { id: 556952, name: "Pandare" },
      { id: 556962, name: "Pandharwadi" },
      { id: 556871, name: "Pansarewadi" },
      { id: 556890, name: "Parwadi" },
      { id: 556953, name: "Pawaimal" },
      { id: 556973, name: "Pimpali" },
      { id: 556958, name: "Pingalevasti" },
      { id: 556970, name: "Rui" },
      { id: 556889, name: "Sabalewadi" },
      { id: 556945, name: "Sadobachiwadi" },
      { id: 556964, name: "Sangavi" },
      { id: 556933, name: "Sastewadi" },
      { id: 556969, name: "Sawal" },
      { id: 556901, name: "Sawantwadi" },
      { id: 556909, name: "Sayambachiwadi" },
      { id: 556882, name: "Sherewadi" },
      { id: 556965, name: "Shirawali" },
      { id: 556888, name: "Shirsuphal" },
      { id: 556957, name: "Sirshane" },
      { id: 556980, name: "Songaon" },
      { id: 556947, name: "Sonkaswadi" },
      { id: 556896, name: "Sonvadisupe" },
      { id: 556940, name: "Soratewadi" },
      { id: 556872, name: "Supa" },
      { id: 556905, name: "Tandulwadi" },
      { id: 556907, name: "Tardoli" },
      { id: 556930, name: "Thopatewadi" },
      { id: 556923, name: "Umbarwadi" },
      { id: 556897, name: "Undavadi Kade Pathar" },
      { id: 556894, name: "Undavadisupe" },
      { id: 556928, name: "Vadgaon Nimbalkar" },
      { id: 556867, name: "Vadhane" },
      { id: 556925, name: "Vaki" },
      { id: 556968, name: "Vanjarwadi" },
      { id: 556942, name: "Waghalwadi" },
      { id: 556943, name: "Wanewadi" },
      { id: 556951, name: "Yelewasti" },
      { id: 556978, name: "Zaragadwadi" },
    ],
    4200: [
      { id: 557072, name: "Agoti No.1" },
      { id: 557073, name: "Agoti No.2" },
      { id: 557080, name: "Ajoti" },
      { id: 556998, name: "Akole" },
      { id: 916475, name: "Anandnagar" },
      { id: 557048, name: "Anthurne" },
      { id: 557105, name: "Awasari" },
      { id: 557104, name: "Babhulgaon" },
      { id: 557010, name: "Balpudi" },
      { id: 557004, name: "Bandewadi" },
      { id: 556992, name: "Bandgarwadi" },
      { id: 557111, name: "Bawada" },
      { id: 557103, name: "Bedshinge" },
      { id: 557024, name: "Belawadi" },
      { id: 556999, name: "Bhadalwadi" },
      { id: 557109, name: "Bhandgaon" },
      { id: 557047, name: "Bharnewadi" },
      { id: 557106, name: "Bhat Nimgaon" },
      { id: 557007, name: "Bhawadi" },
      { id: 557018, name: "Bhawaninagar" },
      { id: 556988, name: "Bhigvan" },
      { id: 557112, name: "Bhodani" },
      { id: 557088, name: "Bijwadi" },
      { id: 557045, name: "Birgundwadi" },
      { id: 557070, name: "Boratwadi" },
      { id: 557016, name: "Bori" },
      { id: 557114, name: "Chakati" },
      { id: 557071, name: "Chandgaon" },
      { id: 557030, name: "Chavhanwadi" },
      { id: 557037, name: "Chikhali" },
      { id: 557000, name: "Dalaj No.1" },
      { id: 557001, name: "Dalaj No.2" },
      { id: 557002, name: "Dalaj No.3" },
      { id: 556990, name: "Dikasal" },
      { id: 557087, name: "Gagargaon" },
      { id: 557084, name: "Galand Wadi No.1" },
      { id: 557097, name: "Galand Wadi No.2" },
      { id: 557121, name: "Ganeshwadi" },
      { id: 557074, name: "Ganjewalan" },
      { id: 557053, name: "Ghorpadwadi" },
      { id: 557125, name: "Giravi" },
      { id: 557098, name: "Gokhali" },
      { id: 557120, name: "Gondi" },
      { id: 557042, name: "Gosaviwadi" },
      { id: 557062, name: "Gotondi" },
      { id: 557050, name: "Hagarewadi" },
      { id: 557026, name: "Hinganewadi" },
      { id: 557095, name: "Hingangaon" },
      { id: 944052, name: "Indapur" },
      { id: 557019, name: "Jachakvasti" },
      { id: 557066, name: "Jadhavwadi" },
      { id: 557035, name: "Jamb" },
      { id: 557021, name: "Jankshan" },
      { id: 557061, name: "Kacharwadi (N.K)" },
      { id: 557117, name: "Kacharwadi Bawada" },
      { id: 557049, name: "Kadbanwadi" },
      { id: 557056, name: "Kalamb" },
      { id: 557043, name: "Kalas" },
      { id: 557075, name: "Kalashi" },
      { id: 557003, name: "Kalewadi" },
      { id: 557076, name: "Kalthan No.1" },
      { id: 557086, name: "Kalthan No.2" },
      { id: 557093, name: "Kandalgaon" },
      { id: 557020, name: "Kardanwadi" },
      { id: 557011, name: "Karewadi" },
      { id: 557065, name: "Kati" },
      { id: 557059, name: "Kauthali" },
      { id: 557014, name: "Kazad" },
      { id: 557069, name: "Khorochi" },
      { id: 556991, name: "Kumbhargaon" },
      { id: 557036, name: "Kurawali" },
      { id: 557012, name: "Lakadi" },
      { id: 557113, name: "Lakhewadi" },
      { id: 556994, name: "Lamjewadi" },
      { id: 557022, name: "Lasurne" },
      { id: 557008, name: "Loni Deokar" },
      { id: 557119, name: "Lumewadi" },
      { id: 556986, name: "Madanwadi" },
      { id: 557006, name: "Malewadi(Palasdeo)" },
      { id: 557083, name: "Malwadi" },
      { id: 557032, name: "Mankarwadi" },
      { id: 557039, name: "Maradewadi" },
      { id: 556996, name: "Mhasobachiwadi" },
      { id: 557124, name: "Narsingpur" },
      { id: 557085, name: "Narutwadi" },
      { id: 557040, name: "Nhavi" },
      { id: 557015, name: "Nimbodi" },
      { id: 557063, name: "Nimgaon Ketki" },
      { id: 557057, name: "Nimsakhar" },
      { id: 556995, name: "Nirgude" },
      { id: 557116, name: "Nirnimgaon" },
      { id: 557058, name: "Nirwangi" },
      { id: 557126, name: "Ozare" },
      { id: 557078, name: "Padasthal" },
      { id: 557005, name: "Palasdeo" },
      { id: 557101, name: "Pandharwadi" },
      { id: 557028, name: "Paritwadi" },
      { id: 557023, name: "Pawarwadi" },
      { id: 557038, name: "Pilewadi" },
      { id: 556985, name: "Pimpale" },
      { id: 557122, name: "Pimpri Bk." },
      { id: 557082, name: "Pimpri Kh." },
      { id: 557115, name: "Pithewadi" },
      { id: 557051, name: "Pitkeshwar" },
      { id: 557091, name: "Pondkulwadi" },
      { id: 556993, name: "Pondwadi" },
      { id: 557089, name: "Rajwadi" },
      { id: 557055, name: "Ranmodwadi" },
      { id: 557067, name: "Reda" },
      { id: 557068, name: "Redani" },
      { id: 557041, name: "Rui" },
      { id: 557017, name: "Sansar" },
      { id: 557025, name: "Sapkalwadi" },
      { id: 557052, name: "Sarafwadi" },
      { id: 557118, name: "Sarati" },
      { id: 557096, name: "Sardewadi" },
      { id: 557092, name: "Shaha" },
      { id: 557046, name: "Shelgaon" },
      { id: 557107, name: "Shetphal Haveli" },
      { id: 556984, name: "Shetphalgadhe" },
      { id: 557013, name: "Shindewadi" },
      { id: 557077, name: "Shirsodi" },
      { id: 557054, name: "Sirsatwadi" },
      { id: 557081, name: "Sugaon" },
      { id: 557108, name: "Surwad" },
      { id: 556987, name: "Takrarwadi" },
      { id: 557123, name: "Tannu" },
      { id: 557099, name: "Tarangwadi" },
      { id: 557094, name: "Taratgaon" },
      { id: 557034, name: "Tawashi" },
      { id: 557029, name: "Thoratwadi" },
      { id: 557044, name: "Thoratwadi (Rui)" },
      { id: 557027, name: "Udhat" },
      { id: 557102, name: "Vadapuri" },
      { id: 557110, name: "Vakilwasti" },
      { id: 557090, name: "Vangali" },
      { id: 557064, name: "Varkute Kh." },
      { id: 556997, name: "Vaysewadi" },
      { id: 557060, name: "Vyahali" },
      { id: 911503, name: "Walchandnagar" },
      { id: 557009, name: "Warkute Bk." },
      { id: 557100, name: "Zagadewadi" },
    ],
    4201: [
      { id: 557293, name: "Aabitkhind" },
      { id: 557238, name: "Aagar" },
      { id: 557249, name: "Agastinagar" },
      { id: 557248, name: "Akole" },
      { id: 557253, name: "Ambad" },
      { id: 557140, name: "Ambevangan" },
      { id: 557282, name: "Ambhol" },
      { id: 557225, name: "Ambikanagar" },
      { id: 557190, name: "Ambit" },
      { id: 557252, name: "Aurangpur" },
      { id: 557134, name: "Babhulwandi" },
      { id: 557315, name: "Badgi" },
      { id: 557228, name: "Bahirwadi" },
      { id: 557180, name: "Balthan" },
      { id: 557182, name: "Baravwandi" },
      { id: 557127, name: "Bari" },
      { id: 557311, name: "Belapur" },
      { id: 557162, name: "Bhandardara" },
      { id: 557169, name: "Bhojadarawadi" },
      { id: 557284, name: "Bholewadi" },
      { id: 557200, name: "Bitaka" },
      { id: 557285, name: "Bori" },
      { id: 557309, name: "Bramhanwada" },
      { id: 557312, name: "Chaitanyapur" },
      { id: 557289, name: "Chand Suraj" },
      { id: 557198, name: "Chandgirwadi" },
      { id: 557307, name: "Chas" },
      { id: 557143, name: "Chichondi" },
      { id: 557256, name: "Chinchavane" },
      { id: 557167, name: "Chitalwedhe" },
      { id: 557211, name: "Dagadwadi" },
      { id: 557138, name: "Deogaon" },
      { id: 557216, name: "Deothan" },
      { id: 557267, name: "Dhagewadi" },
      { id: 557254, name: "Dhamangaon Awari" },
      { id: 557259, name: "Dhamangaon Pat" },
      { id: 557175, name: "Dhamanvan" },
      { id: 557224, name: "Dhokri" },
      { id: 557250, name: "Dhumalwadi" },
      { id: 557136, name: "Digambar" },
      { id: 943693, name: "Dodaknadi" },
      { id: 557219, name: "Dongargaon" },
      { id: 557133, name: "Dongarwadi" },
      { id: 557199, name: "Ekdare" },
      { id: 557300, name: "Esarthav" },
      { id: 557220, name: "Ganore" },
      { id: 557223, name: "Gardani" },
      { id: 557304, name: "Garwadi" },
      { id: 557148, name: "Ghatghar" },
      { id: 557206, name: "Ghodsarwadi" },
      { id: 557270, name: "Ghoti" },
      { id: 557303, name: "Godewadi" },
      { id: 557183, name: "Gondoshi" },
      { id: 557161, name: "Guhire" },
      { id: 557218, name: "Hivargaon" },
      { id: 557234, name: "Indori" },
      { id: 557316, name: "Jachakwadi" },
      { id: 557128, name: "Jahagirdarwadi" },
      { id: 557313, name: "Jambhale" },
      { id: 557171, name: "Jamgaon" },
      { id: 557201, name: "Jaynawadi" },
      { id: 557306, name: "Kalamb" },
      { id: 557243, name: "Kalas Bk." },
      { id: 557242, name: "Kalas Kh." },
      { id: 557314, name: "Kalewadi" },
      { id: 557305, name: "Karandi" },
      { id: 557159, name: "Katalapur" },
      { id: 557172, name: "Kauthewadi" },
      { id: 557302, name: "Keli Kotul" },
      { id: 557301, name: "Keli Otur" },
      { id: 557205, name: "Keli Rumhanwadi" },
      { id: 557166, name: "Kelungan" },
      { id: 557187, name: "Khadki Bk." },
      { id: 557186, name: "Khadki Kh." },
      { id: 557237, name: "Khanapur" },
      { id: 557299, name: "Khetewadi" },
      { id: 557212, name: "Khirvire" },
      { id: 557310, name: "Khuntewadi" },
      { id: 557154, name: "Kodni" },
      { id: 557279, name: "Kohane" },
      { id: 557157, name: "Kohondi" },
      { id: 944272, name: "Kokanvadi" },
      { id: 557177, name: "Koltembhe" },
      { id: 557214, name: "Kombhalne" },
      { id: 557275, name: "Kothale" },
      { id: 557268, name: "Kotul" },
      { id: 557241, name: "Kumbhefal" },
      { id: 557178, name: "Kumshet" },
      { id: 557139, name: "Ladgaon" },
      { id: 557287, name: "Lahit Bk." },
      { id: 557288, name: "Lahit Kh." },
      { id: 557273, name: "Lavhali Kotul" },
      { id: 557274, name: "Lavhali Otur" },
      { id: 557265, name: "Lingdev" },
      { id: 557283, name: "Mahadeowadi" },
      { id: 557158, name: "Malegaon" },
      { id: 557141, name: "Manhere" },
      { id: 557173, name: "Manik Ozar" },
      { id: 557245, name: "Manoharpur" },
      { id: 557290, name: "Manyale" },
      { id: 557181, name: "Maveshi" },
      { id: 557227, name: "Mehenduri" },
      { id: 557230, name: "Mhaladevi" },
      { id: 557195, name: "Mhalungi" },
      { id: 557260, name: "Mogras" },
      { id: 557298, name: "Morwadi" },
      { id: 557151, name: "Murshet" },
      { id: 557215, name: "Muthalane" },
      { id: 557163, name: "Mutkhel" },
      { id: 557292, name: "Nachanthav" },
      { id: 557209, name: "Nagawadi" },
      { id: 557251, name: "Navalewadi" },
      { id: 557231, name: "Nilwande" },
      { id: 557232, name: "Nimbral" },
      { id: 557170, name: "Nirgudwadi" },
      { id: 557132, name: "Pabhulwadi" },
      { id: 557194, name: "Pachapattawadi" },
      { id: 557191, name: "Pachnai" },
      { id: 557258, name: "Padalane" },
      { id: 557203, name: "Padoshi" },
      { id: 557269, name: "Paithan" },
      { id: 557294, name: "Palsunde" },
      { id: 557261, name: "Pangari" },
      { id: 557145, name: "Panjare" },
      { id: 557247, name: "Parakhatpur" },
      { id: 557196, name: "Pedhewadi" },
      { id: 557144, name: "Pendshet" },
      { id: 557295, name: "Phophasandi" },
      { id: 557202, name: "Pimpaldarawadi" },
      { id: 557308, name: "Pimpaldari" },
      { id: 557263, name: "Pimpalgaon Khand" },
      { id: 557135, name: "Pimpalgaon Nakvinda" },
      { id: 557221, name: "Pimpalgaon Nipani" },
      { id: 557137, name: "Pimparkane" },
      { id: 557271, name: "Pimpri" },
      { id: 557291, name: "Pisewadi" },
      { id: 557213, name: "Poparewadi" },
      { id: 557188, name: "Purushwadi" },
      { id: 557317, name: "Rajur" },
      { id: 557153, name: "Ranad Bk." },
      { id: 557160, name: "Ranad Kh." },
      { id: 557150, name: "Ratanwadi" },
      { id: 557239, name: "Rede" },
      { id: 557233, name: "Rumbhodi" },
      { id: 557184, name: "Sakirwadi" },
      { id: 557149, name: "Samrad" },
      { id: 557208, name: "Samsherpur" },
      { id: 557204, name: "Sangavi" },
      { id: 557165, name: "Sarowarwadi" },
      { id: 557297, name: "Satewadi" },
      { id: 557174, name: "Savarkute" },
      { id: 557207, name: "Sawargaon Pat" },
      { id: 557257, name: "Shelad" },
      { id: 557156, name: "Shelvihire" },
      { id: 557152, name: "Shendi" },
      { id: 557130, name: "Shenit" },
      { id: 557131, name: "Shenit Kh." },
      { id: 557229, name: "Sherankhel" },
      { id: 557266, name: "Sherewadi" },
      { id: 557262, name: "Shidawad" },
      { id: 557281, name: "Shilvandi" },
      { id: 557277, name: "Shinde" },
      { id: 557147, name: "Shinganwadi" },
      { id: 557176, name: "Shirpunje Bk." },
      { id: 557179, name: "Shirpunje Kh." },
      { id: 557189, name: "Shiswad" },
      { id: 557193, name: "Shivajinagar" },
      { id: 557280, name: "Somalwadi" },
      { id: 557246, name: "Sugaon Bk." },
      { id: 557240, name: "Sugaon Kh." },
      { id: 557244, name: "Sultanpur" },
      { id: 557210, name: "Tahakari" },
      { id: 557236, name: "Takali" },
      { id: 557276, name: "Tale" },
      { id: 557222, name: "Tambhol" },
      { id: 557164, name: "Terungan" },
      { id: 557264, name: "Thakarwadi" },
      { id: 557192, name: "Tirdhe" },
      { id: 557155, name: "Titavi" },
      { id: 557146, name: "Udadawane" },
      { id: 557296, name: "Umbarwadi" },
      { id: 557226, name: "Unchkhadak Bk." },
      { id: 557235, name: "Unchkhadak Kh." },
      { id: 557255, name: "Vashere" },
      { id: 557278, name: "Vihir" },
      { id: 557217, name: "Virgaon" },
      { id: 557168, name: "Vitha" },
      { id: 557272, name: "Wagdari" },
      { id: 557286, name: "Waghapur" },
      { id: 557142, name: "Waki" },
      { id: 557185, name: "Wanjul Shet" },
      { id: 557129, name: "Waranghushi" },
      { id: 943692, name: "Warkhadwadi" },
    ],
    4202: [
      { id: 557476, name: "Abhalwadi" },
      { id: 557327, name: "Ajampur" },
      { id: 557477, name: "Akalapur" },
      { id: 557432, name: "Ambhore" },
      { id: 557486, name: "Ambi Dumala" },
      { id: 557473, name: "Ambi Khalasa" },
      { id: 557328, name: "Arampur" },
      { id: 557374, name: "Ashwi Bk." },
      { id: 557383, name: "Ashwi Kh." },
      { id: 557362, name: "Aurangpur" },
      { id: 557366, name: "Balapur" },
      { id: 557437, name: "Bambalewadi" },
      { id: 557470, name: "Bhojadari" },
      { id: 557451, name: "Birewadi" },
      { id: 557472, name: "Borbanwadi" },
      { id: 557482, name: "Bota" },
      { id: 557412, name: "Chandanapuri" },
      { id: 557377, name: "Chanegaon" },
      { id: 557334, name: "Chikani" },
      { id: 557399, name: "Chikhali" },
      { id: 557365, name: "Chinchapur Bk." },
      { id: 557364, name: "Chinchapur Kh." },
      { id: 557322, name: "Chincholi Gurav" },
      { id: 943010, name: "Choudharwadi" },
      { id: 557376, name: "Dadh Kh." },
      { id: 557439, name: "Darewadi" },
      { id: 557423, name: "Devgaon" },
      { id: 557323, name: "Devkauthe" },
      { id: 557402, name: "Dhandarphal Bk" },
      { id: 557404, name: "Dhandarphal Kh" },
      { id: 557391, name: "Dholewadi" },
      { id: 557419, name: "Dhupe" },
      { id: 557434, name: "Digras" },
      { id: 557446, name: "Dolasane" },
      { id: 557413, name: "Gabhanawadi" },
      { id: 557479, name: "Ghargaon" },
      { id: 557488, name: "Ghulewadi" },
      { id: 557405, name: "Godasewadi" },
      { id: 557390, name: "Gunjalwadi" },
      { id: 557435, name: "Gunjalwadi Pathar" },
      { id: 557385, name: "Hangewadi" },
      { id: 557325, name: "Hasanabad" },
      { id: 557448, name: "Hiwargaon Pathar" },
      { id: 557426, name: "Hiwargaon Pawasa" },
      { id: 557428, name: "Jakhuri" },
      { id: 557454, name: "Jambut Bk." },
      { id: 557455, name: "Jambut Kh." },
      { id: 557460, name: "Jawale Baleshwar" },
      { id: 557387, name: "Jawale Kadlag" },
      { id: 557369, name: "Jorve" },
      { id: 557326, name: "Junegaon" },
      { id: 557329, name: "Kakadwadi" },
      { id: 557443, name: "Kanasewadi" },
      { id: 557371, name: "Kankapur" },
      { id: 557370, name: "Kanoli" },
      { id: 557332, name: "Karhe" },
      { id: 557436, name: "Karjule Pathar" },
      { id: 557346, name: "Karule" },
      { id: 557397, name: "Kasar Dumala" },
      { id: 557342, name: "Kasare" },
      { id: 557354, name: "Kaunchi" },
      { id: 557468, name: "Kauthe Bk." },
      { id: 557406, name: "Kauthe Dhandarphal" },
      { id: 557345, name: "Kauthe Kamaleshwar" },
      { id: 557445, name: "Kauthe Malkapur" },
      { id: 557461, name: "Kauthewadi" },
      { id: 557484, name: "Kelewadi" },
      { id: 557379, name: "Khali" },
      { id: 557444, name: "Khambe" },
      { id: 557474, name: "Khandarmalwadi" },
      { id: 942973, name: "Khanderaiwadi" },
      { id: 557396, name: "Khandgaon" },
      { id: 557462, name: "Khandgedara" },
      { id: 557392, name: "Khanjapur" },
      { id: 557422, name: "Kharadi" },
      { id: 557442, name: "Kharshinde" },
      { id: 557401, name: "Kokanewadi" },
      { id: 557355, name: "Kokangaon" },
      { id: 557359, name: "Kolhewadi" },
      { id: 557431, name: "Kolwade" },
      { id: 557440, name: "Kumbharwadi" },
      { id: 557480, name: "Kurakundi" },
      { id: 557347, name: "Kuran" },
      { id: 557481, name: "Kurkutwadi" },
      { id: 557467, name: "Kuthe Kh." },
      { id: 557343, name: "Lohare" },
      { id: 557458, name: "Mahalwadi" },
      { id: 557336, name: "Maladad" },
      { id: 557350, name: "Malegaon Haweli" },
      { id: 557466, name: "Malegaon Pathar" },
      { id: 557433, name: "Malunje" },
      { id: 557485, name: "Malwadi" },
      { id: 557353, name: "Manchi" },
      { id: 557453, name: "Mandave Bk." },
      { id: 557398, name: "Mangalapur" },
      { id: 557360, name: "Manoli" },
      { id: 557416, name: "Megalwadi" },
      { id: 557352, name: "Mendhwan" },
      { id: 557487, name: "Mhaswandi" },
      { id: 557344, name: "Mirpur" },
      { id: 557411, name: "Mirzapur" },
      { id: 942978, name: "Modhalwadi" },
      { id: 557475, name: "Nandur Khandarmal" },
      { id: 557410, name: "Nanduri Dumala" },
      { id: 557330, name: "Nannaj Dumala" },
      { id: 557349, name: "Nilawande" },
      { id: 557403, name: "Nimaj" },
      { id: 557358, name: "Nimbale" },
      { id: 557388, name: "Nimgaon Bhojapur" },
      { id: 557409, name: "Nimgaon Budruk" },
      { id: 557361, name: "Nimgaon Jali" },
      { id: 557408, name: "Nimgaon Kh." },
      { id: 557427, name: "Nimgaon Tembhi" },
      { id: 557319, name: "Nimon" },
      { id: 557372, name: "Ozar Bk." },
      { id: 557367, name: "Ozar Kh." },
      { id: 557318, name: "Palaskhede" },
      { id: 557381, name: "Panodi" },
      { id: 557321, name: "Paregaon Bk." },
      { id: 557338, name: "Paregaon Kh." },
      { id: 557415, name: "Pemgiri" },
      { id: 557471, name: "Pemrewadi" },
      { id: 557320, name: "Pimpale" },
      { id: 557456, name: "Pimpalgaon Depa" },
      { id: 557400, name: "Pimpalgaon Konzira" },
      { id: 557459, name: "Pimpalgaon Matha" },
      { id: 557429, name: "Pimparne" },
      { id: 557380, name: "Pimpri Lauki Ajampur" },
      { id: 557457, name: "Pokhari Baleshwar" },
      { id: 557348, name: "Pokhari Haweli" },
      { id: 557375, name: "Pratappur" },
      { id: 557368, name: "Rahimpur" },
      { id: 557389, name: "Rajapur" },
      { id: 557438, name: "Rankhambwadi" },
      { id: 557420, name: "Rayate" },
      { id: 557424, name: "Rayatwadi" },
      { id: 557363, name: "Sadatpur" },
      { id: 557449, name: "Sakur" },
      { id: 557357, name: "Samnapur" },
      { id: 944271, name: "Sangamner Budruk" },
      { id: 557394, name: "Sangamner Kh." },
      { id: 557407, name: "Sangvi" },
      { id: 557465, name: "Sarole Pathar" },
      { id: 557417, name: "Sawarchol" },
      { id: 557463, name: "Sawargaon Ghule" },
      { id: 557414, name: "Sawargaon Tal" },
      { id: 557333, name: "Saykhindi" },
      { id: 557384, name: "Shedgaon" },
      { id: 557478, name: "Shelkewadi" },
      { id: 557447, name: "Shendewadi" },
      { id: 557382, name: "Shibalapur" },
      { id: 557452, name: "Shindodi" },
      { id: 557430, name: "Shirapur" },
      { id: 557418, name: "Shirasgaon" },
      { id: 557351, name: "Shivapur" },
      { id: 557331, name: "Sonewadi" },
      { id: 557337, name: "Sonoshi" },
      { id: 557393, name: "Sukewadi" },
      { id: 557324, name: "Talegaon" },
      { id: 557339, name: "Tigaon" },
      { id: 557373, name: "Umbri" },
      { id: 557395, name: "Vaiduwadi" },
      { id: 557469, name: "Vankute" },
      { id: 557464, name: "Varudi Pathar" },
      { id: 557441, name: "Varwandi" },
      { id: 557335, name: "Velhale" },
      { id: 557386, name: "Wadgaon Landga" },
      { id: 557356, name: "Wadgaon Pan" },
      { id: 557340, name: "Wadzari Bk." },
      { id: 557341, name: "Wadzari Kh." },
      { id: 557421, name: "Waghapur" },
      { id: 557483, name: "Yelkhopwadi" },
      { id: 557378, name: "Zarekathi" },
      { id: 557425, name: "Zole" },
    ],
    4203: [
      { id: 557512, name: "Anchalgaon" },
      { id: 557563, name: "Anjanapur" },
      { id: 557530, name: "Apegaon" },
      { id: 557558, name: "Bahadarabad" },
      { id: 557559, name: "Bahadarpur" },
      { id: 557503, name: "Baktarpur" },
      { id: 557539, name: "Bhojade" },
      { id: 557516, name: "Bolaki" },
      { id: 557510, name: "Bramhangaon" },
      { id: 557550, name: "Chande Kasare" },
      { id: 557522, name: "Chandgavhan" },
      { id: 557502, name: "Chasnali" },
      { id: 557538, name: "Dahigaon Bolka" },
      { id: 557547, name: "Dauch Bk." },
      { id: 557548, name: "Dauch Kh." },
      { id: 557546, name: "Derde Chandwad" },
      { id: 557552, name: "Derde Korhale" },
      { id: 557490, name: "Dhamori" },
      { id: 557520, name: "Dharangaon" },
      { id: 557565, name: "Dhondewadi" },
      { id: 557543, name: "Dhotre" },
      { id: 557551, name: "Ghari" },
      { id: 557535, name: "Ghoyegaon" },
      { id: 557534, name: "Godhegaon" },
      { id: 557505, name: "Handewadi" },
      { id: 557509, name: "Hingani" },
      { id: 557560, name: "Javalke" },
      { id: 557549, name: "Jeur Kumbhari" },
      { id: 557523, name: "Jeur Patoda" },
      { id: 557568, name: "Kakadi" },
      { id: 557540, name: "Kanhegaon" },
      { id: 557514, name: "Karanji Bk." },
      { id: 557506, name: "Karwadi" },
      { id: 557531, name: "Kasali" },
      { id: 557517, name: "Khirdi Ganesh" },
      { id: 557544, name: "Khopadi" },
      { id: 557526, name: "Kokamthan" },
      { id: 557508, name: "Kolgaon Thadi" },
      { id: 557498, name: "Kolpewadi" },
      { id: 557524, name: "Kopargaon" },
      { id: 557496, name: "Kumbhari" },
      { id: 557537, name: "Louki" },
      { id: 557545, name: "Madhi Bk" },
      { id: 557553, name: "Madhi Kh." },
      { id: 557497, name: "Mahegaon Deshmukh" },
      { id: 557493, name: "Malegaon Thadi" },
      { id: 557567, name: "Malharwadi" },
      { id: 557566, name: "Manegaon" },
      { id: 557501, name: "Manjur" },
      { id: 557491, name: "Mayegaon Devi" },
      { id: 557489, name: "Morvis" },
      { id: 557521, name: "Murshatpur" },
      { id: 557511, name: "Nategaon" },
      { id: 557513, name: "Ogadi" },
      { id: 557533, name: "Padhegaon" },
      { id: 557554, name: "Pohegaon Bk." },
      { id: 557556, name: "Pohegaon Kh." },
      { id: 557564, name: "Ranjangaon Deshmukh" },
      { id: 557494, name: "Rawande" },
      { id: 557541, name: "Sade" },
      { id: 557492, name: "Sangvi Bhusar" },
      { id: 557525, name: "Sanvatsar" },
      { id: 557527, name: "Sawalgaon" },
      { id: 557507, name: "Shahajapur" },
      { id: 557557, name: "Shahapur" },
      { id: 557515, name: "Shinganapur" },
      { id: 557532, name: "Shirasgaon" },
      { id: 557495, name: "Sonari" },
      { id: 557562, name: "Soygaon" },
      { id: 557499, name: "Suregaon" },
      { id: 557519, name: "Takali" },
      { id: 557536, name: "Talegaon Male" },
      { id: 557528, name: "Tilwani" },
      { id: 557529, name: "Ukkadgaon" },
      { id: 557504, name: "Vadgaon" },
      { id: 557500, name: "Velapur" },
      { id: 557561, name: "Ves" },
      { id: 557542, name: "Wari" },
      { id: 557518, name: "Yesgaon" },
    ],
    4204: [
      { id: 557616, name: "Adgaon Bk." },
      { id: 557615, name: "Adgaon Kh." },
      { id: 557587, name: "Astagaon" },
      { id: 557604, name: "Babhaleshwar Bk." },
      { id: 557603, name: "Babhaleshwar Kh." },
      { id: 557612, name: "Bhagwatipur" },
      { id: 557622, name: "Chandrapur" },
      { id: 557601, name: "Chitali" },
      { id: 557590, name: "Cholkewadi" },
      { id: 557623, name: "Dadh Bk." },
      { id: 557582, name: "Dahigaon Korhale" },
      { id: 557602, name: "Dhangarwadi" },
      { id: 557570, name: "Dorhale" },
      { id: 557624, name: "Durgapur" },
      { id: 557588, name: "Ekrukhe" },
      { id: 557599, name: "Elamwadi" },
      { id: 557618, name: "Gogalgaon" },
      { id: 557625, name: "Hanumantgaon" },
      { id: 557621, name: "Hasanapur" },
      { id: 557600, name: "Jalgaon" },
      { id: 557577, name: "Kankuri" },
      { id: 557583, name: "Kelwad Bk." },
      { id: 557584, name: "Kelwad Kh." },
      { id: 557586, name: "Khadakewake" },
      { id: 557613, name: "Kolhar Bk." },
      { id: 557579, name: "Korhale" },
      { id: 557611, name: "Lohgaon" },
      { id: 557620, name: "Loni Bk." },
      { id: 557619, name: "Loni Kh." },
      { id: 557606, name: "Mamdapur" },
      { id: 557592, name: "Morwadi" },
      { id: 557608, name: "Nandur Bk." },
      { id: 557607, name: "Nandur Kh." },
      { id: 557580, name: "Nandurkhi Bk." },
      { id: 557578, name: "Nandurkhi Kh." },
      { id: 557596, name: "Nathu Patalachiwadi" },
      { id: 557575, name: "Nighoj" },
      { id: 557576, name: "Nimgaon Korhale" },
      { id: 557626, name: "Pathare Bk." },
      { id: 557574, name: "Pimpalwadi" },
      { id: 557614, name: "Pimpari Lokai" },
      { id: 557585, name: "Pimplas" },
      { id: 557617, name: "Pimpri Nirmal" },
      { id: 557595, name: "Puntamba" },
      { id: 944277, name: "Rahata" },
      { id: 557605, name: "Rajuri" },
      { id: 557597, name: "Rampurwadi" },
      { id: 557589, name: "Ranjangaon Kh." },
      { id: 557609, name: "Ranjankhol" },
      { id: 557594, name: "Rastapur" },
      { id: 557573, name: "Rui" },
      { id: 557581, name: "Sakuri" },
      { id: 944276, name: "Sambhajinagr" },
      { id: 557572, name: "Sawalivihir Bk." },
      { id: 557571, name: "Sawlivihir Khurd" },
      { id: 557593, name: "Shingave" },
      { id: 944275, name: "Shirdi" },
      { id: 557591, name: "Tarkaswadi" },
      { id: 557610, name: "Tisgaon" },
      { id: 557598, name: "Wakadi" },
      { id: 557569, name: "Walki" },
    ],
    4205: [
      { id: 557657, name: "Aenatpur" },
      { id: 557656, name: "Belapur Bk." },
      { id: 557654, name: "Belapur Kh." },
      { id: 557643, name: "Bhairavnathnagar" },
      { id: 557662, name: "Bhamathan" },
      { id: 557678, name: "Bherdapur" },
      { id: 557668, name: "Bhokar" },
      { id: 557644, name: "Bramhangaon Vetal" },
      { id: 557639, name: "Dattanagar" },
      { id: 557637, name: "Dighi" },
      { id: 557653, name: "Ekalahare" },
      { id: 557649, name: "Fatyabad" },
      { id: 557651, name: "Galnimb" },
      { id: 557664, name: "Ghumandeo" },
      { id: 557635, name: "Gondegaon" },
      { id: 557632, name: "Govardhanpur" },
      { id: 557681, name: "Gurjarwadi" },
      { id: 557641, name: "Haregaon" },
      { id: 557629, name: "Jafrabad" },
      { id: 557647, name: "Kadit Bk." },
      { id: 557646, name: "Kadit Kh." },
      { id: 557663, name: "Kamalpur" },
      { id: 557675, name: "Kanhegaon" },
      { id: 557673, name: "Karegaon" },
      { id: 557661, name: "Khanapur" },
      { id: 557638, name: "Khandala" },
      { id: 557682, name: "Khirdi" },
      { id: 557670, name: "Khokar" },
      { id: 557650, name: "Kuranpur" },
      { id: 557676, name: "Ladgaon" },
      { id: 557660, name: "Mahankalwadgaon" },
      { id: 557634, name: "Malewadi" },
      { id: 557677, name: "Malunje Bk." },
      { id: 557665, name: "Malwadgaon" },
      { id: 557648, name: "Mandve" },
      { id: 557672, name: "Matapur" },
      { id: 557627, name: "Matulthan" },
      { id: 557666, name: "Muthewadgaon" },
      { id: 557655, name: "Narsari" },
      { id: 557630, name: "Naur" },
      { id: 557628, name: "Naygaon" },
      { id: 557636, name: "Nimgaon Khairi" },
      { id: 557671, name: "Nipani Wadgaon" },
      { id: 557674, name: "Padhegaon" },
      { id: 557631, name: "Rampur" },
      { id: 557633, name: "Sarala" },
      { id: 557645, name: "Shirasgaon" },
      { id: 944273, name: "Shrirampur Gramin" },
      { id: 557669, name: "Takalibhan" },
      { id: 557652, name: "Ukkalgaon" },
      { id: 557659, name: "Umbargaon" },
      { id: 557640, name: "Undirgaon" },
      { id: 557667, name: "Wadala Mahadeo" },
      { id: 557658, name: "Waladgaon" },
      { id: 557679, name: "Wangi Budruk" },
      { id: 557680, name: "Wangi Kh" },
    ],
    4206: [
      { id: 557755, name: "Amalner" },
      { id: 557787, name: "Antarwali" },
      { id: 557735, name: "Babhulkhede" },
      { id: 557751, name: "Babhulwedhe" },
      { id: 557701, name: "Bahirwadi" },
      { id: 557696, name: "Bakupimpalgaon" },
      { id: 557769, name: "Barhanpur" },
      { id: 557766, name: "Belhekarwadi" },
      { id: 557685, name: "Belpandhari" },
      { id: 557699, name: "Belpimpalgaon" },
      { id: 557689, name: "Bhalgaon" },
      { id: 557782, name: "Bhanashiware" },
      { id: 557791, name: "Bhende Bk." },
      { id: 557785, name: "Bhende Kh." },
      { id: 557687, name: "Borgaon" },
      { id: 557807, name: "Chanda" },
      { id: 557789, name: "Chilekhanwadi" },
      { id: 557709, name: "Chinchban" },
      { id: 557802, name: "Dedgaon" },
      { id: 557798, name: "Deogaon" },
      { id: 557800, name: "Deosade" },
      { id: 557698, name: "Dhamori" },
      { id: 557747, name: "Dhangarwadi (Newasa)" },
      { id: 557772, name: "Dhangarwadi (Sonai)" },
      { id: 557734, name: "Dighi" },
      { id: 557804, name: "Fattepur" },
      { id: 557720, name: "Galnimb" },
      { id: 557761, name: "Ganeshwadi" },
      { id: 557737, name: "Georai" },
      { id: 557770, name: "Ghodegaon" },
      { id: 557683, name: "Ghogargaon" },
      { id: 557729, name: "Gidegaon" },
      { id: 557690, name: "Godhegaon" },
      { id: 557725, name: "Gogalgaon" },
      { id: 557746, name: "Gomalwadi" },
      { id: 557784, name: "Gondegaon" },
      { id: 557716, name: "Gonegaon" },
      { id: 557731, name: "Gopalpur" },
      { id: 557738, name: "Goyegavhan" },
      { id: 557750, name: "Handinimgaon" },
      { id: 557764, name: "Hingoni" },
      { id: 557717, name: "Imampur" },
      { id: 557684, name: "Jainpur" },
      { id: 557726, name: "Jalke Bk." },
      { id: 557727, name: "Jalke Kh." },
      { id: 557799, name: "Jeur Haibati" },
      { id: 557763, name: "Kangoni" },
      { id: 557756, name: "Karajgaon" },
      { id: 557796, name: "Karegaon" },
      { id: 557808, name: "Kautha" },
      { id: 557704, name: "Khadke" },
      { id: 557703, name: "Khalal Pimpri" },
      { id: 557732, name: "Khamgaon" },
      { id: 557762, name: "Kharwandi" },
      { id: 557759, name: "Khedle Parmanand" },
      { id: 557718, name: "Khedlekajali" },
      { id: 557783, name: "Khunegaon" },
      { id: 557715, name: "Khupti" },
      { id: 557790, name: "Kukana" },
      { id: 557760, name: "Landewadi" },
      { id: 557776, name: "Loharwadi" },
      { id: 557774, name: "Lohgaon" },
      { id: 557702, name: "Madki" },
      { id: 557811, name: "Mahalaxmihivare" },
      { id: 557810, name: "Maka" },
      { id: 557713, name: "Maktapur" },
      { id: 557724, name: "Malewadi Dumala" },
      { id: 557695, name: "Malewadi Khalsa" },
      { id: 557794, name: "Malichinchora" },
      { id: 557777, name: "Mandegavhan" },
      { id: 557719, name: "Manglapur" },
      { id: 557694, name: "Mhalapur" },
      { id: 557806, name: "Mhalaspimpalgaon" },
      { id: 557712, name: "Mhasale" },
      { id: 557779, name: "Morgavhan" },
      { id: 557773, name: "Moryachichonre" },
      { id: 557714, name: "Mukindpur" },
      { id: 557697, name: "Murme" },
      { id: 557793, name: "Nagapur" },
      { id: 557736, name: "Najik Chincholi" },
      { id: 557744, name: "Nandur Shikari" },
      { id: 557748, name: "Narayanwadi" },
      { id: 557705, name: "Nevasa Bk." },
      { id: 557710, name: "Nevasa Kh" },
      { id: 557745, name: "Nimbhari" },
      { id: 557752, name: "Nipani Nimgaon" },
      { id: 557707, name: "Pachegaon" },
      { id: 557809, name: "Pachunde" },
      { id: 557771, name: "Panaswadi" },
      { id: 557757, name: "Panegaon" },
      { id: 557740, name: "Patharwale" },
      { id: 557711, name: "Pichadgaon" },
      { id: 557739, name: "Pimpri Shahali" },
      { id: 557693, name: "Pravarasangam" },
      { id: 557708, name: "Punatgaon" },
      { id: 557780, name: "Rajegaon" },
      { id: 557723, name: "Ramdoh" },
      { id: 557797, name: "Ranjangaon" },
      { id: 557805, name: "Rastapur" },
      { id: 557728, name: "Salabatpur" },
      { id: 557803, name: "Shahapur" },
      { id: 557768, name: "Shinganapur" },
      { id: 557778, name: "Shingvetukai" },
      { id: 557730, name: "Shirasgaon" },
      { id: 557758, name: "Siregaon" },
      { id: 557765, name: "Sonai (Navin)" },
      { id: 557792, name: "Soundala" },
      { id: 557742, name: "Sukali Bk." },
      { id: 557743, name: "Sukali Kh" },
      { id: 557741, name: "Sultanpur" },
      { id: 557686, name: "Suregaon Gangapur" },
      { id: 557721, name: "Suregaon Turfe Dahigaon" },
      { id: 557753, name: "Tamaswadi" },
      { id: 557786, name: "Tarwadi" },
      { id: 557801, name: "Telkudgaon" },
      { id: 557692, name: "Toka" },
      { id: 557749, name: "Usthal Dumala" },
      { id: 557688, name: "Usthal Khalsa" },
      { id: 557795, name: "Wadala Bahiroba" },
      { id: 557788, name: "Wadule" },
      { id: 557733, name: "Wakadi" },
      { id: 557767, name: "Wanjarwadi" },
      { id: 557781, name: "Wanjoli" },
      { id: 557722, name: "Warkhed" },
      { id: 557691, name: "Washim" },
      { id: 557754, name: "Watapur" },
      { id: 557775, name: "Zapwadi" },
    ],
    4207: [
      { id: 557837, name: "Aawhane Bk." },
      { id: 557840, name: "Aawhane Kh." },
      { id: 557913, name: "Adhodi" },
      { id: 557824, name: "Akhatwade" },
      { id: 557884, name: "Akhegaon Titarfa" },
      { id: 557879, name: "Amarapur" },
      { id: 557917, name: "Antarwali Bk." },
      { id: 557855, name: "Antarwali Khurd Ne." },
      { id: 557916, name: "Antarwali Khurd She" },
      { id: 557814, name: "Antre" },
      { id: 557833, name: "Apegaon" },
      { id: 557910, name: "Badgavhan" },
      { id: 557818, name: "Baktarpur" },
      { id: 557905, name: "Balamtakali" },
      { id: 557838, name: "Barhanpur" },
      { id: 557902, name: "Belgaon" },
      { id: 557876, name: "Bhagur" },
      { id: 557820, name: "Bhatkudgaon" },
      { id: 557848, name: "Bhavinimgaon" },
      { id: 557819, name: "Bhaygaon" },
      { id: 557904, name: "Bodhegaon" },
      { id: 557859, name: "Bodkhe" },
      { id: 557898, name: "Chapadgaon" },
      { id: 557903, name: "Chedechandgaon" },
      { id: 557861, name: "Dadegaon" },
      { id: 557851, name: "Dahifal" },
      { id: 557842, name: "Dahigaon Ne." },
      { id: 557889, name: "Dahigaon She" },
      { id: 557843, name: "Deolane" },
      { id: 557817, name: "Deotakli" },
      { id: 557832, name: "Dhor Jalgaon Ne." },
      { id: 557849, name: "Dhorhingani" },
      { id: 557825, name: "Dhorjalgaon She." },
      { id: 557815, name: "Dhorsade" },
      { id: 557912, name: "Diwate" },
      { id: 557882, name: "Dongar Akhegaon" },
      { id: 557852, name: "Erandgaon" },
      { id: 557888, name: "Gadewadi" },
      { id: 557906, name: "Gaikwad Jalgaon" },
      { id: 557831, name: "Garadwadi" },
      { id: 557846, name: "Ghevri" },
      { id: 557856, name: "Ghotan" },
      { id: 557922, name: "Golegaon" },
      { id: 557871, name: "Hasnapur" },
      { id: 557894, name: "Hatgaon" },
      { id: 557816, name: "Hingangaon Ne" },
      { id: 557822, name: "Joharapur" },
      { id: 557893, name: "Kambi" },
      { id: 557854, name: "Karhetakali" },
      { id: 557850, name: "Karjat Kh." },
      { id: 557890, name: "Khadke" },
      { id: 557821, name: "Khamgaon" },
      { id: 557896, name: "Khampimpri" },
      { id: 557853, name: "Khanapur" },
      { id: 557881, name: "Kharadgaon" },
      { id: 557862, name: "Khuntefal" },
      { id: 557870, name: "Kolgaon" },
      { id: 557920, name: "Konoshi" },
      { id: 557887, name: "Kurudgaon" },
      { id: 557911, name: "Ladjalgaon" },
      { id: 557899, name: "Lakhamapuri" },
      { id: 557845, name: "Lakhefal" },
      { id: 557823, name: "Lolegaon" },
      { id: 557891, name: "Madke" },
      { id: 557812, name: "Majleshahar" },
      { id: 557834, name: "Malegaon" },
      { id: 557873, name: "Malegaon Ne." },
      { id: 557830, name: "Malkapur" },
      { id: 557869, name: "Mangrul Bk." },
      { id: 557868, name: "Mangrul Kh." },
      { id: 557892, name: "Mungi" },
      { id: 557909, name: "Murmi" },
      { id: 557883, name: "Murshatpur" },
      { id: 557921, name: "Nagalwadi" },
      { id: 557864, name: "Najik Babhulgaon" },
      { id: 557826, name: "Nandurvihire" },
      { id: 557827, name: "Nimbe" },
      { id: 557895, name: "Pingewadi" },
      { id: 557897, name: "Prabhuwadgaon" },
      { id: 557865, name: "Rakshi" },
      { id: 557919, name: "Ranegaon" },
      { id: 557841, name: "Ranzani" },
      { id: 557858, name: "Raotale" },
      { id: 557874, name: "Salwadgaon" },
      { id: 557835, name: "Samangaon" },
      { id: 944279, name: "Sevanagar" },
      { id: 557878, name: "Shahajapur" },
      { id: 557839, name: "Shahapur" },
      { id: 557813, name: "Shahar Takali" },
      { id: 557908, name: "Shekte Bk." },
      { id: 557923, name: "Shekte Kh." },
      { id: 557863, name: "Shevgaon" },
      { id: 557918, name: "Shingori" },
      { id: 557914, name: "Shobhanagar" },
      { id: 557866, name: "Sone Sangavi" },
      { id: 557900, name: "Sonvihir" },
      { id: 557907, name: "Sukali" },
      { id: 557915, name: "Sule Pimpalgaon" },
      { id: 557847, name: "Sultanpur Bk." },
      { id: 557877, name: "Sultanpur Kh." },
      { id: 557860, name: "Tajnapur" },
      { id: 557857, name: "Talani" },
      { id: 557872, name: "Thakur Nimgaon" },
      { id: 557901, name: "Thakur Pimpalgaon" },
      { id: 557886, name: "Thate" },
      { id: 557844, name: "Vijaypur" },
      { id: 557885, name: "Wadgaon" },
      { id: 557836, name: "Wadule Bk." },
      { id: 557829, name: "Wadule Kh." },
      { id: 557828, name: "Wagholi" },
      { id: 557867, name: "Warkhed" },
      { id: 557880, name: "Warur Bk." },
      { id: 557875, name: "Warur Kh." },
    ],
    4208: [
      { id: 557928, name: "Adgaon" },
      { id: 557984, name: "Agaskhand" },
      { id: 558029, name: "Akola" },
      { id: 557999, name: "Alhanwadi" },
      { id: 558045, name: "Ambikanagar" },
      { id: 558009, name: "Aurangpur" },
      { id: 558026, name: "Badewadi" },
      { id: 558041, name: "Bhalgaon" },
      { id: 558022, name: "Bharajwadi" },
      { id: 558023, name: "Bhawarwadi (Navin)" },
      { id: 558047, name: "Bhilwade" },
      { id: 557955, name: "Bhose" },
      { id: 558018, name: "Bhutetakali" },
      { id: 558027, name: "Bondarwadi" },
      { id: 558002, name: "Borsewadi" },
      { id: 557993, name: "Chekewadi" },
      { id: 557934, name: "Chichondi" },
      { id: 558050, name: "Chinchpur Ijade" },
      { id: 558054, name: "Chinchpur Pangul" },
      { id: 557965, name: "Chitali" },
      { id: 558000, name: "Chitalwadi" },
      { id: 558044, name: "Chumbhali" },
      { id: 557954, name: "Dagadwadi" },
      { id: 557994, name: "Damalwadi(Chichondi)" },
      { id: 557937, name: "Damalwadi(Manikdaundi)" },
      { id: 557973, name: "Dangewadi" },
      { id: 557947, name: "Devrai" },
      { id: 558030, name: "Dhaitadakwadi" },
      { id: 558057, name: "Dhakanwadi(Kharwandi)" },
      { id: 558038, name: "Dhakanwadi(Vadgaon)" },
      { id: 557979, name: "Dhamangaon" },
      { id: 557992, name: "Dhangarwadi" },
      { id: 557939, name: "Dharwadi" },
      { id: 557975, name: "Dhawalewadi" },
      { id: 557938, name: "Dongarwadi" },
      { id: 557983, name: "Dule Chandgaon" },
      { id: 558043, name: "Ekanathwadi" },
      { id: 557958, name: "Ghatshiras" },
      { id: 557998, name: "Ghumatwadi" },
      { id: 557936, name: "Gitewadi" },
      { id: 558034, name: "Hakewadi (Navin)" },
      { id: 944270, name: "Handalwadi" },
      { id: 557964, name: "Hanuman Takali" },
      { id: 557974, name: "Hatral" },
      { id: 558036, name: "Jambhali" },
      { id: 558004, name: "Jatdeole" },
      { id: 557961, name: "Jawakhede Dumala" },
      { id: 557962, name: "Jawakhede Khalsa" },
      { id: 558037, name: "Jawalwadi" },
      { id: 558013, name: "Jirewadi" },
      { id: 558056, name: "Jogewadi" },
      { id: 557950, name: "Joharwadi" },
      { id: 557932, name: "Kadgaon" },
      { id: 558010, name: "Kalas Pimpri" },
      { id: 557968, name: "Kalegaon Fakir" },
      { id: 558035, name: "Kalewadi (Navin)" },
      { id: 557929, name: "Kamat Shingave" },
      { id: 557959, name: "Karadwadi" },
      { id: 557956, name: "Karanji" },
      { id: 557986, name: "Karegaon" },
      { id: 558048, name: "Karodi" },
      { id: 558042, name: "Kasalwadi" },
      { id: 557976, name: "Kasar Pimpalgaon" },
      { id: 557960, name: "Kasarwadi" },
      { id: 557949, name: "Kaudgaon" },
      { id: 557991, name: "Kelwandi" },
      { id: 557951, name: "Khandgaon" },
      { id: 558025, name: "Kharwandi" },
      { id: 557981, name: "Kherde" },
      { id: 557935, name: "Kolhar" },
      { id: 558014, name: "Kolsangavi" },
      { id: 557963, name: "Kopare" },
      { id: 558008, name: "Koradgaon" },
      { id: 558051, name: "Kuttarwadi" },
      { id: 558001, name: "Landakwadi" },
      { id: 557952, name: "Lohasar" },
      { id: 557989, name: "Madhi" },
      { id: 557982, name: "Malegaon" },
      { id: 558039, name: "Malewadi" },
      { id: 557980, name: "Malibabhulgaon" },
      { id: 557941, name: "Mandave" },
      { id: 558053, name: "Manewadi" },
      { id: 557996, name: "Manik Daundi" },
      { id: 558024, name: "Midsangavi" },
      { id: 557926, name: "Miri" },
      { id: 557987, name: "Mohari" },
      { id: 558031, name: "Mohate" },
      { id: 557931, name: "Mohoj Bk." },
      { id: 558033, name: "Mohoj Dewadhe" },
      { id: 557930, name: "Mohoj Kh." },
      { id: 558040, name: "Munguswade" },
      { id: 558021, name: "Nandur Nimba Daitya" },
      { id: 557946, name: "Nimbodi" },
      { id: 558015, name: "Nipani Jalgaon" },
      { id: 557978, name: "Niwdunge" },
      { id: 557966, name: "Padali" },
      { id: 557970, name: "Pagori Pimpalgaon" },
      { id: 558028, name: "Palavewadi" },
      { id: 557943, name: "Parewadi" },
      { id: 944268, name: "Pathardi" },
      { id: 557997, name: "Pattryacha Tanda" },
      { id: 558052, name: "Pimpalgaon Tappa" },
      { id: 558019, name: "Pimpalgavhan" },
      { id: 557995, name: "Pirewadi" },
      { id: 557969, name: "Prabhupimpri" },
      { id: 557940, name: "Raghohivre" },
      { id: 557990, name: "Ranjani" },
      { id: 557927, name: "Renukaiwadi" },
      { id: 558032, name: "Rupnarwadi (Navin)" },
      { id: 557977, name: "Saidapur" },
      { id: 557967, name: "Sakegaon" },
      { id: 557971, name: "Sangavi Bk." },
      { id: 557972, name: "Sangavi Kh." },
      { id: 557957, name: "Satwad" },
      { id: 557925, name: "Shankarwadi" },
      { id: 558017, name: "Shekate" },
      { id: 558003, name: "Shindewadi" },
      { id: 557924, name: "Shingave Keshav" },
      { id: 557933, name: "Shiral" },
      { id: 557945, name: "Shirapur" },
      { id: 557988, name: "Shirasathwadi" },
      { id: 558007, name: "Somthane Bk." },
      { id: 557942, name: "Somthane Kh." },
      { id: 558006, name: "Somthane Nalwade" },
      { id: 558012, name: "Sonoshi" },
      { id: 558005, name: "Susare" },
      { id: 558046, name: "Takali Manur" },
      { id: 944269, name: "Tanpurvadi" },
      { id: 558049, name: "Teenkhadi" },
      { id: 557944, name: "Tisgaon" },
      { id: 558011, name: "Tondoli" },
      { id: 557948, name: "Tribhuwanwadi" },
      { id: 557953, name: "Vaijubabhulgaon" },
      { id: 558055, name: "Wadgaon" },
      { id: 557985, name: "Walunj" },
      { id: 558016, name: "Wasu" },
      { id: 558020, name: "Yeli" },
    ],
    4209: [
      { id: 558116, name: "Aathawad" },
      { id: 558077, name: "Aavhadwadi" },
      { id: 558090, name: "Agadgaon" },
      { id: 558137, name: "Akolner" },
      { id: 558159, name: "Ambilwadi" },
      { id: 558133, name: "Arangaon" },
      { id: 558141, name: "Baburdi Bend" },
      { id: 558134, name: "Baburdi Ghumat" },
      { id: 558080, name: "Bahirwadi" },
      { id: 558092, name: "Balewadi" },
      { id: 558097, name: "Bardari" },
      { id: 558109, name: "Bhatodi Pargaon" },
      { id: 944262, name: "Bhingar" },
      { id: 944259, name: "Bhistbag" },
      { id: 558138, name: "Bhorwadi" },
      { id: 558130, name: "Bhoyare Kh" },
      { id: 558127, name: "Bhoyare Pathar" },
      { id: 944261, name: "Bolhegaon" },
      { id: 913036, name: "Burhannagar" },
      { id: 944950, name: "Burudgaon" },
      { id: 944254, name: "Chahurana Budruk" },
      { id: 944255, name: "Chahurana Khurd" },
      { id: 558131, name: "Chas" },
      { id: 558115, name: "Chichondi Patil" },
      { id: 558150, name: "Dahigaon" },
      { id: 558169, name: "Darewadi" },
      { id: 558110, name: "Dashmi Gavhan" },
      { id: 558064, name: "Dehere" },
      { id: 558096, name: "Deogaon" },
      { id: 558144, name: "Deulgaon Siddhi" },
      { id: 558083, name: "Dhangarwadi" },
      { id: 558073, name: "Dongargan" },
      { id: 558058, name: "Ghanegaon" },
      { id: 558142, name: "Ghospuri" },
      { id: 558162, name: "Gundegaon" },
      { id: 558160, name: "Gunwadi" },
      { id: 558120, name: "Hamidpur" },
      { id: 558158, name: "Hatwalan" },
      { id: 558119, name: "Hingangaon" },
      { id: 558143, name: "Hivare Zare" },
      { id: 558125, name: "Hivrebajar" },
      { id: 558081, name: "Imampur" },
      { id: 558068, name: "Islak" },
      { id: 558063, name: "Ismalpur" },
      { id: 558136, name: "Jadhavwadi" },
      { id: 558123, name: "Jakhangaon" },
      { id: 558100, name: "Jamb" },
      { id: 558082, name: "Jeur" },
      { id: 558129, name: "Kamargaon" },
      { id: 558089, name: "Kapurwadi" },
      { id: 558067, name: "Karjunekhare" },
      { id: 558099, name: "Kaudgaon" },
      { id: 944263, name: "Kedgaon" },
      { id: 558140, name: "Khadaki" },
      { id: 558135, name: "Khandala" },
      { id: 558094, name: "Khandke" },
      { id: 558118, name: "Khatgaon Takli" },
      { id: 558074, name: "Khospuri" },
      { id: 558105, name: "Kolhewadi" },
      { id: 558061, name: "Kolpe Akhada" },
      { id: 558108, name: "Madad Gaon" },
      { id: 558076, name: "Majale-Chincholi" },
      { id: 944258, name: "Malivada" },
      { id: 558113, name: "Mandave" },
      { id: 558072, name: "Manjar Sumbha" },
      { id: 558157, name: "Math Pimpri" },
      { id: 558093, name: "Mathani" },
      { id: 558098, name: "Mehekari" },
      { id: 944257, name: "Morchud Nagar" },
      { id: 944264, name: "Nagapur" },
      { id: 944265, name: "Nagardeole" },
      { id: 944256, name: "Nalegaon" },
      { id: 558060, name: "Nandgaon" },
      { id: 558111, name: "Narayan Doho" },
      { id: 558166, name: "Navnagapur" },
      { id: 558121, name: "Nepti" },
      { id: 558069, name: "Nimblak" },
      { id: 558146, name: "Nimbodi" },
      { id: 558117, name: "Nimgaon Ghana" },
      { id: 558122, name: "Nimgaon Wagha" },
      { id: 558075, name: "Pangarmal" },
      { id: 558102, name: "Parewadi" },
      { id: 558101, name: "Pargaon Bhatodi" },
      { id: 558148, name: "Pargaon Maula" },
      { id: 558128, name: "Pimpalgaon Kauda" },
      { id: 558103, name: "Pimpalgaon Landga" },
      { id: 558084, name: "Pimpalgaon Malvi" },
      { id: 558086, name: "Pimpalgaon Ujjaini" },
      { id: 558126, name: "Pimpalgaon Wagha" },
      { id: 944266, name: "Pimprighumat" },
      { id: 558087, name: "Pokhardi" },
      { id: 558161, name: "Ralegan" },
      { id: 558091, name: "Ranjani" },
      { id: 558095, name: "Ratadgaon" },
      { id: 558156, name: "Rui Chhattishi" },
      { id: 558151, name: "Sakat Kh." },
      { id: 558114, name: "Sandave" },
      { id: 558106, name: "Sarola Baddhi" },
      { id: 558139, name: "Sarola Kasar" },
      { id: 558079, name: "Sasewadi" },
      { id: 944260, name: "Savedi" },
      { id: 558145, name: "Shahapur" },
      { id: 558085, name: "Shendi" },
      { id: 558062, name: "Shingawe" },
      { id: 558149, name: "Shiradhon" },
      { id: 558104, name: "Sonewadi (Chas)" },
      { id: 558132, name: "Sonewadi(Pi.La)" },
      { id: 558059, name: "Sujalpur" },
      { id: 558107, name: "Takali Kazi" },
      { id: 558124, name: "Takali Khatgaon" },
      { id: 558153, name: "Tandali Wadgaon" },
      { id: 558078, name: "Udarmal" },
      { id: 558112, name: "Ukkadgaon" },
      { id: 558070, name: "Vadgaongupta" },
      { id: 558066, name: "Vilad" },
      { id: 558154, name: "Wadgaon Tandali" },
      { id: 558071, name: "Wakodi" },
      { id: 558152, name: "Walki" },
      { id: 558147, name: "Walunj" },
      { id: 558088, name: "Warulwadi" },
      { id: 558155, name: "Watephal" },
    ],
    4210: [
      { id: 558214, name: "Aambi" },
      { id: 558213, name: "Amalner" },
      { id: 558238, name: "Aradgaon" },
      { id: 558258, name: "Babhulgaon" },
      { id: 558202, name: "Baragaon Nandur" },
      { id: 558217, name: "Bodhegaon" },
      { id: 558218, name: "Bramhangaon Bhand" },
      { id: 558251, name: "Bramhani" },
      { id: 558242, name: "Chandakapur" },
      { id: 558216, name: "Chandegaon" },
      { id: 558252, name: "Chedgaon" },
      { id: 558196, name: "Chikhalthan" },
      { id: 558198, name: "Chinchale" },
      { id: 558208, name: "Chincholi" },
      { id: 558182, name: "Chinchvihire" },
      { id: 558226, name: "Daradgaon Tafe Belapur" },
      { id: 558197, name: "Daradgaon Thadi" },
      { id: 558212, name: "Davangaon" },
      { id: 944274, name: "Deolalipravara" },
      { id: 558247, name: "Deswandi" },
      { id: 558261, name: "Dhamori Bk." },
      { id: 558262, name: "Dhamori Kh." },
      { id: 558170, name: "Dhanore" },
      { id: 558256, name: "Digras" },
      { id: 558193, name: "Gadadhe Akhada" },
      { id: 558194, name: "Gadakhwadi" },
      { id: 558181, name: "Ganegaon" },
      { id: 558209, name: "Gangapur" },
      { id: 558192, name: "Ghorpadwadi" },
      { id: 558180, name: "Guha" },
      { id: 558265, name: "Gunjale" },
      { id: 558200, name: "Jambhali" },
      { id: 558201, name: "Jambhulban" },
      { id: 558220, name: "Jatap" },
      { id: 558177, name: "Kanadgaon" },
      { id: 558183, name: "Kangar Bk." },
      { id: 558189, name: "Kangar Kh." },
      { id: 558219, name: "Karajgaon" },
      { id: 558264, name: "Katrad" },
      { id: 558244, name: "Kendal Bk." },
      { id: 558243, name: "Kendal Kh." },
      { id: 558215, name: "Kesapur" },
      { id: 558259, name: "Khadambe Bk." },
      { id: 558260, name: "Khadambe Kh." },
      { id: 558230, name: "Khudsargaon" },
      { id: 558187, name: "Kolewadi" },
      { id: 558207, name: "Kolhar Kh" },
      { id: 558246, name: "Kondhavad" },
      { id: 558233, name: "Kopare" },
      { id: 558254, name: "Kukkadwedhe" },
      { id: 558188, name: "Kuranwadi" },
      { id: 558221, name: "Lakh" },
      { id: 558228, name: "Mahalgaon" },
      { id: 558229, name: "Mahegaon" },
      { id: 558172, name: "Malewadi Dukrewadi" },
      { id: 558191, name: "Malharwadi" },
      { id: 558227, name: "Malunje Kh." },
      { id: 558236, name: "Manjari" },
      { id: 558239, name: "Manori" },
      { id: 558195, name: "Mhaisgaon" },
      { id: 558253, name: "Mokal Ohal" },
      { id: 558190, name: "Momin Akhada" },
      { id: 558224, name: "Morwadi" },
      { id: 558225, name: "Musalwadi" },
      { id: 558174, name: "Nimbhere" },
      { id: 558231, name: "Pathare Kh." },
      { id: 558210, name: "Pimpalgaon Fungi" },
      { id: 558249, name: "Pimpri Avaghad" },
      { id: 558241, name: "Pimprivalan" },
      { id: 558204, name: "Rahuri Budruk" },
      { id: 558203, name: "Rahuri Kh." },
      { id: 558206, name: "Rampur" },
      { id: 558255, name: "Sade" },
      { id: 558211, name: "Sankrapur" },
      { id: 558173, name: "Satral" },
      { id: 558232, name: "Shenwadgaon" },
      { id: 558245, name: "Shilegaon" },
      { id: 558171, name: "Songaon" },
      { id: 558185, name: "Taharabad" },
      { id: 558223, name: "Takalimiya" },
      { id: 558179, name: "Tambhere" },
      { id: 558248, name: "Tamnar Akhada" },
      { id: 558178, name: "Tandulner" },
      { id: 558237, name: "Tandulwadi" },
      { id: 558234, name: "Tilapur" },
      { id: 558222, name: "Trimbakpur" },
      { id: 558175, name: "Tulapur" },
      { id: 558250, name: "Umbre" },
      { id: 558184, name: "Vadner" },
      { id: 558240, name: "Valan" },
      { id: 558263, name: "Vambori" },
      { id: 558186, name: "Varshinde" },
      { id: 558176, name: "Wabalewadi" },
      { id: 558205, name: "Waghacha Akhada" },
      { id: 558235, name: "Wanjulpoi" },
      { id: 558257, name: "Warwandi" },
      { id: 558199, name: "Wawarath" },
    ],
    4211: [
      { id: 558297, name: "Akkalwadi" },
      { id: 558340, name: "Alkuti" },
      { id: 558379, name: "Apdhup" },
      { id: 558382, name: "Astagaon" },
      { id: 558330, name: "Babhulwade" },
      { id: 558386, name: "Baburdi" },
      { id: 558303, name: "Bahirobawadi" },
      { id: 558306, name: "Bhalawani" },
      { id: 558309, name: "Bhandgaon" },
      { id: 558280, name: "Bhangadewadi" },
      { id: 558294, name: "Bhondre" },
      { id: 558387, name: "Bhoyaregangarda" },
      { id: 558334, name: "Chincholi" },
      { id: 558344, name: "Chombhut" },
      { id: 558308, name: "Daithane Gunjal" },
      { id: 558329, name: "Darodi" },
      { id: 558272, name: "Deswade" },
      { id: 558348, name: "Devi Bhoyare" },
      { id: 558279, name: "Dhavalpuri" },
      { id: 558357, name: "Dhawanwadi" },
      { id: 558283, name: "Dhoki" },
      { id: 558281, name: "Dhotre Bk." },
      { id: 558282, name: "Dhotre Kh." },
      { id: 558365, name: "Diksal" },
      { id: 558266, name: "Dongarwadi" },
      { id: 558358, name: "Gadilgaon" },
      { id: 558278, name: "Gajadipur" },
      { id: 558351, name: "Ganjibhoyare" },
      { id: 558295, name: "Gargundi" },
      { id: 558328, name: "Garkhindi" },
      { id: 558323, name: "Gatewadi" },
      { id: 558376, name: "Ghanegaon" },
      { id: 558314, name: "Goregaon" },
      { id: 558359, name: "Gunore" },
      { id: 558361, name: "Hakigatpur" },
      { id: 558367, name: "Hanga" },
      { id: 558318, name: "Hatalkhindi" },
      { id: 558304, name: "Hivare Korda" },
      { id: 558332, name: "Jadhavwadi" },
      { id: 558311, name: "Jamgaon" },
      { id: 558377, name: "Jategaon" },
      { id: 558353, name: "Jawala" },
      { id: 558388, name: "Kadus" },
      { id: 558292, name: "Kakanewadi" },
      { id: 558391, name: "Kalamkarwadi" },
      { id: 558327, name: "Kalas" },
      { id: 558312, name: "Kalkup" },
      { id: 558300, name: "Kanhur Pathar" },
      { id: 558316, name: "Karandi" },
      { id: 558289, name: "Karegaon" },
      { id: 558286, name: "Karjule Harya" },
      { id: 558290, name: "Kasare" },
      { id: 558267, name: "Katalwedha" },
      { id: 558274, name: "Khadakwadi" },
      { id: 558315, name: "Kinhi" },
      { id: 558364, name: "Kohakadi" },
      { id: 558396, name: "Kurund" },
      { id: 558366, name: "Loni Haveli" },
      { id: 558336, name: "Loni Mawala" },
      { id: 558362, name: "Majampur" },
      { id: 558305, name: "Malkup" },
      { id: 558273, name: "Mandave Kh." },
      { id: 558395, name: "Mawalewadi" },
      { id: 558360, name: "Mhase Kh." },
      { id: 558341, name: "Mhaskewadi" },
      { id: 558375, name: "Mhasne" },
      { id: 558269, name: "Mhasobacha Zap" },
      { id: 558356, name: "Morwadi" },
      { id: 558373, name: "Mungashi" },
      { id: 558288, name: "Nandur Pathar" },
      { id: 558390, name: "Narayan Gavhan" },
      { id: 558355, name: "Nighoj" },
      { id: 558337, name: "Pabal" },
      { id: 558342, name: "Padali Aale" },
      { id: 558331, name: "Padali Darya" },
      { id: 558392, name: "Padali Ranjangaon" },
      { id: 558313, name: "Padali Tarfe Kanhoor" },
      { id: 558275, name: "Palashi" },
      { id: 558268, name: "Palaspur" },
      { id: 558389, name: "Palwe Bk." },
      { id: 558378, name: "Palwe Kh." },
      { id: 558322, name: "Panoli" },
      { id: 558320, name: "Parner" },
      { id: 558354, name: "Patharwadi" },
      { id: 558296, name: "Pimpalgaon Rotha" },
      { id: 558293, name: "Pimpalgaon Turk" },
      { id: 558326, name: "Pimpalner" },
      { id: 558384, name: "Pimpri Gawali" },
      { id: 558350, name: "Pimpri Jalsen" },
      { id: 558299, name: "Pimpri Pathar" },
      { id: 558270, name: "Pokhari" },
      { id: 558319, name: "Punewadi" },
      { id: 558324, name: "Ralegan Shindhi" },
      { id: 558363, name: "Ralegan Tharepal" },
      { id: 558338, name: "Randhe" },
      { id: 558383, name: "Ranjangaon Mashid" },
      { id: 558381, name: "Rayatale" },
      { id: 558343, name: "Renwadi" },
      { id: 558385, name: "Rui Chhatrapati" },
      { id: 558352, name: "Sangvi Surya" },
      { id: 558310, name: "Sarola Advai" },
      { id: 558287, name: "Sawargaon" },
      { id: 558368, name: "Shahjapur" },
      { id: 558339, name: "Sheri Kasare" },
      { id: 558333, name: "Sheri Koldara" },
      { id: 558345, name: "Shirapur" },
      { id: 558347, name: "Shirsule" },
      { id: 558321, name: "Siddheshwar Wadi" },
      { id: 558372, name: "Sultanpur" },
      { id: 558369, name: "Supa" },
      { id: 558291, name: "Takali Dhokeshwar" },
      { id: 558276, name: "Tas" },
      { id: 558302, name: "Tikhol" },
      { id: 558277, name: "Vankute" },
      { id: 558394, name: "Wadegavhan" },
      { id: 558307, name: "Wadgaon Amli" },
      { id: 558298, name: "Wadgaon Darya" },
      { id: 558349, name: "Wadgaon Gund" },
      { id: 558284, name: "Wadgaon Sawtal" },
      { id: 558346, name: "Wadner Bk." },
      { id: 558374, name: "Wadner Haveli" },
      { id: 558325, name: "Wadule" },
      { id: 558335, name: "Wadzire" },
      { id: 558371, name: "Waghunde Bk." },
      { id: 558370, name: "Waghunde Kh." },
      { id: 558380, name: "Walwane" },
      { id: 558271, name: "Waranwadi" },
      { id: 558285, name: "Wasunde" },
      { id: 558301, name: "Wesdare" },
      { id: 558317, name: "Wiroli" },
      { id: 558393, name: "Yadavwadi" },
    ],
    4212: [
      { id: 558464, name: "Adhalgaon" },
      { id: 558475, name: "Adharewadi" },
      { id: 558507, name: "Ajnuj" },
      { id: 558508, name: "Anandwadi" },
      { id: 558510, name: "Angare" },
      { id: 558409, name: "Arangaon Dumala" },
      { id: 558509, name: "Arvi" },
      { id: 558491, name: "Baburdi" },
      { id: 558447, name: "Bangarde" },
      { id: 558441, name: "Banpimpri" },
      { id: 558421, name: "Belwandi Bk." },
      { id: 558456, name: "Belwandi Kothar" },
      { id: 558451, name: "Bhangaon" },
      { id: 558434, name: "Bhapkarwadi" },
      { id: 558466, name: "Bhavadi" },
      { id: 558470, name: "Bhingan Dumala" },
      { id: 558471, name: "Bhingan Khalasa" },
      { id: 558482, name: "Bori" },
      { id: 558403, name: "Chambhurdi" },
      { id: 558472, name: "Chandgaon" },
      { id: 558443, name: "Chavarsangavi" },
      { id: 558479, name: "Chikalthanwadi" },
      { id: 558429, name: "Chikhali" },
      { id: 558484, name: "Chimbhale" },
      { id: 558476, name: "Chorachiwadi" },
      { id: 558498, name: "Chormalewadi" },
      { id: 558412, name: "Danewadi" },
      { id: 558399, name: "Deodaithan" },
      { id: 558458, name: "Deulgaon" },
      { id: 558410, name: "Dhawalgaon" },
      { id: 558496, name: "Dhokrai Mal" },
      { id: 558465, name: "Dokewadi" },
      { id: 558497, name: "Domalewadi" },
      { id: 558437, name: "Doraje" },
      { id: 558418, name: "Erandoli" },
      { id: 558504, name: "Gar" },
      { id: 558463, name: "Gavhanewadi (Adhalagon)" },
      { id: 558398, name: "Gavhanewadi (Hingni Dumala)" },
      { id: 558487, name: "Ghargaon" },
      { id: 558469, name: "Ghodegaon" },
      { id: 558445, name: "Ghogargaon" },
      { id: 558488, name: "Ghotawi" },
      { id: 558457, name: "Ghugalwadgaon" },
      { id: 558428, name: "Ghutewadi" },
      { id: 558483, name: "Hangewadi" },
      { id: 558397, name: "Hingani Dumala" },
      { id: 558468, name: "Hiradgaon" },
      { id: 558499, name: "Jangalewadi" },
      { id: 945180, name: "Joshivasti" },
      { id: 558439, name: "Kamathi" },
      { id: 558480, name: "Kansewadi" },
      { id: 558501, name: "Kasti" },
      { id: 558506, name: "Kauthe" },
      { id: 558449, name: "Khandgaon" },
      { id: 558420, name: "Kharatwadi" },
      { id: 558453, name: "Khetmaliswadi" },
      { id: 558467, name: "Kokangaon" },
      { id: 558435, name: "Kolgaon" },
      { id: 558408, name: "Kondegavhan" },
      { id: 558430, name: "Koregaon" },
      { id: 558402, name: "Koregavhan" },
      { id: 558461, name: "Kosegavhan" },
      { id: 558436, name: "Kothul" },
      { id: 558433, name: "Lagadwadi" },
      { id: 558500, name: "Limpangaon" },
      { id: 558489, name: "Loni Vyanknath" },
      { id: 558493, name: "Madhewadgaon" },
      { id: 558486, name: "Mahadeowadi (Loni Khalchi)" },
      { id: 558460, name: "Mahadeowadi (Takli Lonar Khalchi)" },
      { id: 558448, name: "Mahandulwadi" },
      { id: 558440, name: "Mandavgan" },
      { id: 558494, name: "Masalwadi" },
      { id: 558413, name: "Math" },
      { id: 558414, name: "Mengalwadi" },
      { id: 558423, name: "Mhase" },
      { id: 558492, name: "Mhatar Pimpri" },
      { id: 558478, name: "Mundhekarwadi" },
      { id: 558405, name: "Mungusgaon" },
      { id: 558407, name: "Nimbavi" },
      { id: 558503, name: "Nimgaon Khalu" },
      { id: 558432, name: "Pandharewadi" },
      { id: 558452, name: "Pargaon Sudrik" },
      { id: 558485, name: "Parwatwadi" },
      { id: 558481, name: "Pedgaon" },
      { id: 558419, name: "Pimpalgaon Pisa" },
      { id: 558416, name: "Pimpri Kolandar" },
      { id: 558426, name: "Pisore Bk." },
      { id: 558450, name: "Pisorekhand" },
      { id: 558422, name: "Poliswadi" },
      { id: 558411, name: "Rajapur" },
      { id: 558415, name: "Rayagavhan" },
      { id: 558446, name: "Ruikhel" },
      { id: 558502, name: "Sangavi Dumala" },
      { id: 558401, name: "Sarola Somwanshi" },
      { id: 558474, name: "Shedgaon" },
      { id: 558505, name: "Shipalkarwadi" },
      { id: 558490, name: "Shirasgaon Bodkha" },
      { id: 944267, name: "Shrigonda" },
      { id: 558427, name: "Suregaon" },
      { id: 558454, name: "Surodi" },
      { id: 558459, name: "Takali Lonar" },
      { id: 558473, name: "Takli Kadevalit" },
      { id: 558462, name: "Tandli Dumala" },
      { id: 558442, name: "Taradgavhan" },
      { id: 558444, name: "Thitesangavi" },
      { id: 558417, name: "Ukkadgaon" },
      { id: 558404, name: "Ukkhalgaon" },
      { id: 558455, name: "Vadali" },
      { id: 558438, name: "Vadghul" },
      { id: 558495, name: "Vangdari" },
      { id: 558477, name: "Velu" },
      { id: 558431, name: "Vethekarwadi" },
      { id: 558406, name: "Visapur" },
      { id: 558424, name: "Wadgaon Shindodi" },
      { id: 558400, name: "Yavati" },
      { id: 558425, name: "Yelapne" },
    ],
    4213: [
      { id: 558624, name: "Aakhoni" },
      { id: 558584, name: "Alsunde" },
      { id: 558582, name: "Ambijalgaon" },
      { id: 558554, name: "Anandwadi" },
      { id: 558628, name: "Autewadi" },
      { id: 558630, name: "Babhulgaon Dumala" },
      { id: 558535, name: "Babhulgaon Khalsa" },
      { id: 558569, name: "Bahirobawadi" },
      { id: 558579, name: "Bajrangwadi" },
      { id: 558602, name: "Baradgaon Dagadi" },
      { id: 558610, name: "Baradgaon Sudrik" },
      { id: 558568, name: "Bargewadi" },
      { id: 558521, name: "Belgaon" },
      { id: 558597, name: "Belwandi" },
      { id: 558606, name: "Benwadi" },
      { id: 558612, name: "Berdi" },
      { id: 558614, name: "Bhambore" },
      { id: 558574, name: "Bhandewadi" },
      { id: 558560, name: "Bhose" },
      { id: 558562, name: "Bitkewadi" },
      { id: 558561, name: "Chakhalewadi" },
      { id: 558525, name: "Chande Bk." },
      { id: 558529, name: "Chande Kh." },
      { id: 558558, name: "Chapadgaon" },
      { id: 558619, name: "Chilvadi" },
      { id: 558540, name: "Chincholi Kaldat" },
      { id: 558511, name: "Chincholi Ramjan" },
      { id: 558607, name: "Deshmukhwadi" },
      { id: 558611, name: "Deulwadi" },
      { id: 558593, name: "Dhalwadi" },
      { id: 558577, name: "Dhandewadi" },
      { id: 558559, name: "Dighi" },
      { id: 558534, name: "Diksal" },
      { id: 558588, name: "Dombalwadi" },
      { id: 558613, name: "Dudhodi" },
      { id: 558594, name: "Durgaon" },
      { id: 558615, name: "Ganeshwadi" },
      { id: 558514, name: "Ghumari" },
      { id: 558531, name: "Gondardi" },
      { id: 558545, name: "Goykarwadi" },
      { id: 558524, name: "Gurav Pimpri" },
      { id: 558552, name: "Handalwadi" },
      { id: 558601, name: "Hingangaon" },
      { id: 558618, name: "Holewadi" },
      { id: 558599, name: "Jalalpur" },
      { id: 558547, name: "Jalgaon" },
      { id: 558557, name: "Jalkewadi" },
      { id: 558570, name: "Jogeshwarwadi" },
      { id: 558620, name: "Kalewadi" },
      { id: 558608, name: "Kangudwadi" },
      { id: 558571, name: "Kaprewadi" },
      { id: 558631, name: "Karjat" },
      { id: 558616, name: "Karmanwadi" },
      { id: 558623, name: "Karpadi" },
      { id: 558527, name: "Kaudane" },
      { id: 558546, name: "Khandale" },
      { id: 558517, name: "Khandavi" },
      { id: 558581, name: "Khatgaon" },
      { id: 558626, name: "Khed" },
      { id: 558528, name: "Khurangewadi" },
      { id: 558520, name: "Kokangaon" },
      { id: 558576, name: "Kolvadi" },
      { id: 558518, name: "Kombhali" },
      { id: 558566, name: "Kopardi" },
      { id: 558578, name: "Koregaon" },
      { id: 558591, name: "Kuldharan" },
      { id: 558583, name: "Kumbhefal" },
      { id: 558580, name: "Loni Masadpur" },
      { id: 558538, name: "Mahi" },
      { id: 558563, name: "Malewadi" },
      { id: 558555, name: "Malthan" },
      { id: 558512, name: "Mandali" },
      { id: 558587, name: "Mhalangi" },
      { id: 558523, name: "Mirajgaon" },
      { id: 558526, name: "Mulewadi" },
      { id: 558533, name: "Nagalwadi" },
      { id: 558515, name: "Nagamthan" },
      { id: 558536, name: "Nagapur" },
      { id: 558544, name: "Nandgaon" },
      { id: 558551, name: "Nawsarwadi" },
      { id: 558575, name: "Netakewadi" },
      { id: 558585, name: "Nimbe" },
      { id: 558549, name: "Nimbodi" },
      { id: 558556, name: "Nimgaon Daku" },
      { id: 558513, name: "Nimgaon Gangarda" },
      { id: 558622, name: "Paritwadi" },
      { id: 558548, name: "Pategaon" },
      { id: 558553, name: "Patewadi" },
      { id: 558595, name: "Pimpalwadi" },
      { id: 558592, name: "Rakshaswadi Bk." },
      { id: 558590, name: "Rakshaswadi Kh." },
      { id: 558617, name: "Rashin" },
      { id: 558532, name: "Ratanjan" },
      { id: 558621, name: "Raukalewadi" },
      { id: 558519, name: "Ravalgaon" },
      { id: 558543, name: "Rehekuri" },
      { id: 558565, name: "Ruigavhan" },
      { id: 558586, name: "Shegud" },
      { id: 558627, name: "Shimpore" },
      { id: 558564, name: "Shinde" },
      { id: 558600, name: "Siddhatek" },
      { id: 558537, name: "Sitpur" },
      { id: 558603, name: "Sonalwadi" },
      { id: 558541, name: "Supe" },
      { id: 558589, name: "Supekarwadi" },
      { id: 558598, name: "Taju" },
      { id: 558539, name: "Takli Khandeshwari" },
      { id: 558596, name: "Talwadi" },
      { id: 558550, name: "Taradgaon" },
      { id: 558516, name: "Thergaon" },
      { id: 558605, name: "Therwadi" },
      { id: 558530, name: "Thetewadi" },
      { id: 558522, name: "Tikhi" },
      { id: 558604, name: "Torkadwadi" },
      { id: 558567, name: "Wadgaon Tanpura" },
      { id: 558542, name: "Walvad" },
      { id: 558625, name: "Waysewadi" },
      { id: 558609, name: "Yeswadi" },
    ],
    4214: [
      { id: 558671, name: "Aghi" },
      { id: 558687, name: "Anandwadi" },
      { id: 558697, name: "Apti" },
      { id: 558653, name: "Arangaon" },
      { id: 558690, name: "Balgavhan" },
      { id: 558685, name: "Bandhkhadak" },
      { id: 558645, name: "Batewadi" },
      { id: 558668, name: "Bavi" },
      { id: 558633, name: "Bhavarwadi" },
      { id: 558636, name: "Bhutvada" },
      { id: 558711, name: "Borle" },
      { id: 558712, name: "Chobhewadi" },
      { id: 558670, name: "Chondhi" },
      { id: 558647, name: "Chumbhali" },
      { id: 558686, name: "Daradwadi" },
      { id: 558708, name: "Daundachiwadi" },
      { id: 558678, name: "Deodaithan" },
      { id: 558679, name: "Dhamangaon" },
      { id: 558716, name: "Dhanegaon" },
      { id: 558662, name: "Dhanora" },
      { id: 558659, name: "Dhond Pargaon" },
      { id: 558638, name: "Dhotri" },
      { id: 558681, name: "Dighol" },
      { id: 558655, name: "Disalewadi" },
      { id: 558675, name: "Dolewadi" },
      { id: 558632, name: "Dongaon" },
      { id: 558661, name: "Fakrabad" },
      { id: 558698, name: "Ghodegaon" },
      { id: 558665, name: "Girwali" },
      { id: 558699, name: "Gurewadi" },
      { id: 558669, name: "Halgaon" },
      { id: 558666, name: "Hasnabad" },
      { id: 558683, name: "Jaibhaywadi" },
      { id: 558646, name: "Jamadarwadi" },
      { id: 558635, name: "Jambwadi" },
      { id: 558718, name: "Jamkhed" },
      { id: 558682, name: "Jategaon" },
      { id: 558714, name: "Jawala" },
      { id: 558709, name: "Jawalke" },
      { id: 558673, name: "Katewadi" },
      { id: 558664, name: "Kavadgaon" },
      { id: 558654, name: "Khamgaon" },
      { id: 558660, name: "Khandvi" },
      { id: 558695, name: "Kharda" },
      { id: 558658, name: "Khurdaithan" },
      { id: 558641, name: "Kolhewadi" },
      { id: 558649, name: "Kusadgaon" },
      { id: 558637, name: "Lehnewadi" },
      { id: 558689, name: "Loni" },
      { id: 558700, name: "Maharuli" },
      { id: 558680, name: "Malewadi" },
      { id: 558713, name: "Matewadi" },
      { id: 558639, name: "Moha" },
      { id: 558692, name: "Mohari" },
      { id: 558693, name: "Mungewadi" },
      { id: 558715, name: "Munjewadi" },
      { id: 558694, name: "Nagobawadi" },
      { id: 558677, name: "Nahuli" },
      { id: 558702, name: "Nannaj" },
      { id: 558676, name: "Naygaon" },
      { id: 558657, name: "Padali" },
      { id: 558691, name: "Pandharewadi" },
      { id: 558652, name: "Parewadi" },
      { id: 558651, name: "Patoda" },
      { id: 558688, name: "Pimpalgaon Alwa" },
      { id: 558704, name: "Pimpalgaon Unda" },
      { id: 558640, name: "Pimpalwadi" },
      { id: 558667, name: "Pimparkhed" },
      { id: 558710, name: "Potewadi" },
      { id: 558701, name: "Rajewadi" },
      { id: 558674, name: "Rajuri" },
      { id: 558634, name: "Ratnapur" },
      { id: 558642, name: "Sakat" },
      { id: 558650, name: "Sangvi" },
      { id: 558648, name: "Saradwadi" },
      { id: 558672, name: "Sarola" },
      { id: 558705, name: "Satephal" },
      { id: 558643, name: "Savargaon" },
      { id: 558644, name: "Shiur" },
      { id: 558717, name: "Sonegaon" },
      { id: 558707, name: "Taradgaon" },
      { id: 558684, name: "Telangashi" },
      { id: 558663, name: "Vanjarwadi(Dhanora)" },
      { id: 558706, name: "Vanjarwadi(Taradgaon)" },
      { id: 558703, name: "Wagha" },
      { id: 558696, name: "Waki" },
      { id: 558656, name: "Zikri" },
    ],
    4215: [
      { id: 558744, name: "Ambhora" },
      { id: 558833, name: "Anandwadi" },
      { id: 558886, name: "Andhalewadi" },
      { id: 558728, name: "Aranvihira" },
      { id: 558885, name: "Ashta" },
      { id: 558895, name: "Ashti" },
      { id: 558813, name: "Aurangpur" },
      { id: 558893, name: "Balewadi" },
      { id: 558731, name: "Bandkhel" },
      { id: 558786, name: "Bavi" },
      { id: 558795, name: "Beed Sangvi" },
      { id: 558857, name: "Belgaon" },
      { id: 558872, name: "Bhalvani" },
      { id: 558884, name: "Bhatodi" },
      { id: 558746, name: "Bhojewadi" },
      { id: 558791, name: "Bhorwadi" },
      { id: 558750, name: "Birangalwadi" },
      { id: 558807, name: "Blewadi" },
      { id: 558815, name: "Borodi" },
      { id: 558752, name: "Borudwadi" },
      { id: 558865, name: "Bramhagaon" },
      { id: 558851, name: "Chikhali" },
      { id: 558860, name: "Chinchala" },
      { id: 558730, name: "Chinchewadi" },
      { id: 558825, name: "Chincholi" },
      { id: 558882, name: "Chinchpur" },
      { id: 558770, name: "Dadegaon" },
      { id: 558854, name: "Daithna" },
      { id: 558733, name: "Daulawadgaon" },
      { id: 558739, name: "Deolali" },
      { id: 558858, name: "Desur" },
      { id: 558721, name: "Deulgaon Ghat" },
      { id: 558775, name: "Devi Nimgaon" },
      { id: 558888, name: "Devigavhan" },
      { id: 558779, name: "Dhamangaon" },
      { id: 558802, name: "Dhangarwadi (Doithan)" },
      { id: 558763, name: "Dhangarwadi (Pimpala)" },
      { id: 558824, name: "Dhanora" },
      { id: 558843, name: "Dhirdi" },
      { id: 558783, name: "Doithan" },
      { id: 558774, name: "Dongargan" },
      { id: 558844, name: "Fattewadgaon" },
      { id: 558736, name: "Gahukhel" },
      { id: 558794, name: "Ganagewadi" },
      { id: 558883, name: "Gandhanwadi" },
      { id: 558725, name: "Gangadevi" },
      { id: 558768, name: "Ghata Pimpri" },
      { id: 558820, name: "Ghongadewadi" },
      { id: 558874, name: "Hajipur" },
      { id: 558751, name: "Hakewadi" },
      { id: 558853, name: "Hanumantgaon" },
      { id: 558762, name: "Hatola" },
      { id: 558812, name: "Hatolan" },
      { id: 558856, name: "Hingni" },
      { id: 558747, name: "Hivara" },
      { id: 558848, name: "Imangaon" },
      { id: 558840, name: "Jalgaon" },
      { id: 558887, name: "Jamgaon" },
      { id: 558828, name: "Kada" },
      { id: 558845, name: "Kanadi Bk." },
      { id: 558822, name: "Kanadi Kh." },
      { id: 558784, name: "Kapsi" },
      { id: 558873, name: "Karanji" },
      { id: 558880, name: "Karhewadgaon" },
      { id: 558871, name: "Karhewadi" },
      { id: 558765, name: "Karkhel Bk." },
      { id: 558735, name: "Karkhel Kh." },
      { id: 558862, name: "Kasari" },
      { id: 558732, name: "Kel" },
      { id: 558842, name: "Kelsangvi" },
      { id: 558789, name: "Kerul" },
      { id: 558758, name: "Khadakwadi" },
      { id: 558894, name: "Khadkat" },
      { id: 558837, name: "Khakalwadi" },
      { id: 558761, name: "Khalatwadi" },
      { id: 558852, name: "Khanapur" },
      { id: 558810, name: "Kharadgavhan" },
      { id: 558780, name: "Khilad" },
      { id: 558798, name: "Khuntephal" },
      { id: 558809, name: "Khuntephal Pundi" },
      { id: 558792, name: "Kinhi" },
      { id: 558787, name: "Kohini" },
      { id: 558799, name: "Koyal" },
      { id: 558808, name: "Kumbhephal" },
      { id: 558729, name: "Lamantanda (Waghaluj)" },
      { id: 558777, name: "Latewadi" },
      { id: 558776, name: "Limbodi" },
      { id: 558797, name: "Loni" },
      { id: 558778, name: "Mahajanwadi" },
      { id: 558755, name: "Mahinda" },
      { id: 558839, name: "Mandva" },
      { id: 558850, name: "Mangrul" },
      { id: 558719, name: "Marathwadi" },
      { id: 558870, name: "Matawali" },
      { id: 558881, name: "Matkuli" },
      { id: 558741, name: "Mhasobachiwadi" },
      { id: 558756, name: "Morala" },
      { id: 558788, name: "Morewadi" },
      { id: 558876, name: "Murshadpur" },
      { id: 558759, name: "Nagtala" },
      { id: 558835, name: "Nanda" },
      { id: 558804, name: "Nandur" },
      { id: 558819, name: "Nimgaon Bodkha" },
      { id: 558836, name: "Nimgaon Chaubha" },
      { id: 558864, name: "Pandegavhan" },
      { id: 558875, name: "Pandhari" },
      { id: 558754, name: "Pangra" },
      { id: 558868, name: "Pangulgavhan" },
      { id: 558892, name: "Pargaon Jogeshwari" },
      { id: 558814, name: "Parodi" },
      { id: 558781, name: "Patan" },
      { id: 558760, name: "Patsara" },
      { id: 558821, name: "Pimpalgaon Dani" },
      { id: 558720, name: "Pimpalgaon Ghat" },
      { id: 558855, name: "Pimpalsutti" },
      { id: 558748, name: "Pimparkhed" },
      { id: 558801, name: "Pimpla" },
      { id: 558841, name: "Pimpri Ashti" },
      { id: 558769, name: "Pimpri Ghata" },
      { id: 558823, name: "Pimpri Ghumri" },
      { id: 558879, name: "Pokhari" },
      { id: 558817, name: "Pundi" },
      { id: 558861, name: "Raghapur" },
      { id: 558767, name: "Ralesangvi" },
      { id: 558834, name: "Rui Nalkol" },
      { id: 558849, name: "Ruti" },
      { id: 558826, name: "Sablekhed" },
      { id: 558796, name: "Sakat" },
      { id: 558743, name: "Salewadgaon" },
      { id: 558891, name: "Sangvi Ashti" },
      { id: 558782, name: "Sangvi Patan" },
      { id: 558832, name: "Saratewadgaon" },
      { id: 558723, name: "Sawargaon Ghat" },
      { id: 558722, name: "Shedala" },
      { id: 558859, name: "Shekapur" },
      { id: 558830, name: "Sheri Bk." },
      { id: 558829, name: "Sheri Kh." },
      { id: 558863, name: "Shindewadi" },
      { id: 558847, name: "Shiral" },
      { id: 558827, name: "Shirapur" },
      { id: 558816, name: "Solapurwadi" },
      { id: 558878, name: "Solewadi" },
      { id: 558745, name: "Suleman Deola" },
      { id: 558800, name: "Sumbhewadi" },
      { id: 558764, name: "Surudi" },
      { id: 558727, name: "Tagadkhel" },
      { id: 558831, name: "Takali Aamiya" },
      { id: 558890, name: "Takalsing" },
      { id: 558877, name: "Tavalwadi" },
      { id: 558811, name: "Thombal Sangvi" },
      { id: 558742, name: "Underkhel" },
      { id: 558805, name: "Waghluj" },
      { id: 558818, name: "Wahira" },
      { id: 558846, name: "Waki" },
      { id: 558889, name: "Walunj" },
      { id: 558766, name: "Wanjarwadi" },
      { id: 558869, name: "Wanvewadi (Marola)" },
      { id: 558757, name: "Wanvewadi (Matavali)" },
      { id: 558838, name: "Watanwadi" },
      { id: 558726, name: "Welturi" },
      { id: 558793, name: "Wetalwadi" },
    ],
    4216: [
      { id: 558905, name: "Amalner" },
      { id: 558912, name: "Antapur" },
      { id: 558979, name: "Bedarwadi" },
      { id: 558993, name: "Bensur" },
      { id: 558943, name: "Bhurewadi" },
      { id: 558995, name: "Bhyala" },
      { id: 558911, name: "Chikhali" },
      { id: 558902, name: "Chincholi" },
      { id: 558947, name: "Chumbli" },
      { id: 558965, name: "Daskhed" },
      { id: 558946, name: "Dhangar Jaulka" },
      { id: 558980, name: "Domri" },
      { id: 558921, name: "Dongerkinhi" },
      { id: 558934, name: "Gandalwadi" },
      { id: 558897, name: "Gandhanwadi" },
      { id: 558918, name: "Gayakwadwadi" },
      { id: 558920, name: "Gholewadi" },
      { id: 558919, name: "Jadhavwadi" },
      { id: 558994, name: "Jaulala" },
      { id: 558974, name: "Kakadhira" },
      { id: 558987, name: "Karanjwan" },
      { id: 558923, name: "Karegaon" },
      { id: 558973, name: "Khadakwadi" },
      { id: 558898, name: "Kotan" },
      { id: 558932, name: "Kusalamb" },
      { id: 558935, name: "Lambharwadi" },
      { id: 558952, name: "Mahasanghvi" },
      { id: 558969, name: "Mahindrawadi" },
      { id: 558967, name: "Manzari Ghat" },
      { id: 558936, name: "Muggaon" },
      { id: 558978, name: "Naigaon Mayur" },
      { id: 558925, name: "Nalwandi" },
      { id: 558977, name: "Nirgudi" },
      { id: 558910, name: "Nivdunga" },
      { id: 558968, name: "Pachangri" },
      { id: 559000, name: "Pachegaon" },
      { id: 558901, name: "Pandharwadi" },
      { id: 558963, name: "Pargaon Gumra" },
      { id: 558941, name: "Parner" },
      { id: 558953, name: "Patoda" },
      { id: 558972, name: "Pimpalgaon Dhas" },
      { id: 558906, name: "Pimpalwandi" },
      { id: 558976, name: "Pithi" },
      { id: 558989, name: "Rohatawadi" },
      { id: 558899, name: "Sablewadi" },
      { id: 558958, name: "Saundana" },
      { id: 558944, name: "Sautada" },
      { id: 558914, name: "Sawargaon Ghat" },
      { id: 558957, name: "Sawargaon Sone" },
      { id: 558959, name: "Sonegaon" },
      { id: 558933, name: "Suppa" },
      { id: 558971, name: "Tagarwadi" },
      { id: 558986, name: "Talepimpalgaon" },
      { id: 558949, name: "Tambarajuri" },
      { id: 558988, name: "Therla" },
      { id: 558975, name: "Ukhanda Pitti" },
      { id: 558948, name: "Umber Vihira" },
      { id: 558998, name: "Vaidhyakinhi" },
      { id: 558999, name: "Vaijala" },
      { id: 558983, name: "Wadzari" },
      { id: 558996, name: "Waghira" },
      { id: 558913, name: "Wahali" },
    ],
    4217: [
      { id: 559038, name: "Anandgaon" },
      { id: 559080, name: "Anandwadi" },
      { id: 559066, name: "Arvi" },
      { id: 559078, name: "Aurangpur" },
      { id: 559031, name: "Badewadi" },
      { id: 559090, name: "Baragwadi" },
      { id: 559032, name: "Bargajwadi" },
      { id: 559019, name: "Bawi" },
      { id: 559050, name: "Bhadakhel" },
      { id: 559093, name: "Bhankwadi" },
      { id: 559010, name: "Borgaon Chakla" },
      { id: 559018, name: "Bramhanath Yelamb" },
      { id: 559022, name: "Dahiwandi" },
      { id: 559082, name: "Dhangarwadi" },
      { id: 559067, name: "Dhokwad" },
      { id: 559064, name: "Gazipur" },
      { id: 559026, name: "Ghatshil Pargaon" },
      { id: 559001, name: "Ghogaspargaon" },
      { id: 559081, name: "Ghugewadi" },
      { id: 559042, name: "Gomalwada" },
      { id: 559060, name: "Hajipur" },
      { id: 559094, name: "Hatkarwadi" },
      { id: 559077, name: "Hiversinga" },
      { id: 559068, name: "Jamb" },
      { id: 559029, name: "Jathawad" },
      { id: 559056, name: "Jatnandur" },
      { id: 559062, name: "Kamleshwar Dhanora" },
      { id: 559037, name: "Kanhobachi Wadi" },
      { id: 559072, name: "Khalapuri" },
      { id: 559069, name: "Khamba" },
      { id: 559076, name: "Khokermoha" },
      { id: 559051, name: "Khopti" },
      { id: 559036, name: "Kolwadi" },
      { id: 559071, name: "Limba" },
      { id: 559033, name: "Loni" },
      { id: 559049, name: "Madmapuri" },
      { id: 559002, name: "Malegaon Chakla" },
      { id: 559092, name: "Malkachiwadi" },
      { id: 559024, name: "Mangewadi" },
      { id: 559028, name: "Manur" },
      { id: 559061, name: "Markadwadi" },
      { id: 559003, name: "Matori" },
      { id: 559016, name: "Nandewali" },
      { id: 559008, name: "Narayanwadi" },
      { id: 559015, name: "Nimgaon Mayamba" },
      { id: 559073, name: "Padali" },
      { id: 559058, name: "Pangri" },
      { id: 559059, name: "Phulsawngi" },
      { id: 559043, name: "Pimpalner" },
      { id: 559070, name: "Poundul." },
      { id: 559083, name: "Raimoha" },
      { id: 559040, name: "Rakshasbhuwan" },
      { id: 559014, name: "Ralesangavi" },
      { id: 559041, name: "Rupur" },
      { id: 559084, name: "Sangalwadi" },
      { id: 559012, name: "Sawargaon Chakla" },
      { id: 559079, name: "Shirapur Dhumal" },
      { id: 559063, name: "Shirapurgat" },
      { id: 559021, name: "Shirur (Kasar)" },
      { id: 559025, name: "Shripatwadi" },
      { id: 559006, name: "Shrungarwadi" },
      { id: 559075, name: "Tagadgaon" },
      { id: 559089, name: "Takalwadi" },
      { id: 559005, name: "Taradgavhan" },
      { id: 559065, name: "Taradgavhan (Aghav)" },
      { id: 559027, name: "Tembhurni" },
      { id: 559004, name: "Tintarwani" },
      { id: 559011, name: "Ukirda Chakla" },
      { id: 559088, name: "Vanjarwadi" },
      { id: 559009, name: "Varangalwadi" },
      { id: 559048, name: "Wadali" },
      { id: 559023, name: "Warni" },
      { id: 559087, name: "Yewalwadi" },
      { id: 559020, name: "Zapewadi" },
    ],
    4218: [
      { id: 559158, name: "Aantarwali Bu." },
      { id: 559280, name: "Adpimpri" },
      { id: 559125, name: "Agar Nandur" },
      { id: 559260, name: "Aher Vahegaon" },
      { id: 559223, name: "Amla" },
      { id: 943936, name: "Anandwadi" },
      { id: 559272, name: "Ankota" },
      { id: 559281, name: "Ardhapimpri" },
      { id: 559208, name: "Ardhmasla" },
      { id: 559206, name: "Aurangpur Jawalka" },
      { id: 559235, name: "Aurangpur Kukada" },
      { id: 559175, name: "Babultara" },
      { id: 559137, name: "Bagpimpalgaon" },
      { id: 559114, name: "Bangali Pimpla" },
      { id: 559259, name: "Barhanpur" },
      { id: 559135, name: "Belgaon" },
      { id: 559179, name: "Belgudwadi" },
      { id: 559255, name: "Bhadangwadi" },
      { id: 559132, name: "Bhatantarwali" },
      { id: 559188, name: "Bhatepuri" },
      { id: 559214, name: "Bhend Bk." },
      { id: 559213, name: "Bhend Kh." },
      { id: 559215, name: "Bhend Takli" },
      { id: 559152, name: "Bhogalgaon" },
      { id: 559131, name: "Bhojgaon" },
      { id: 559096, name: "Borgaon Bk." },
      { id: 559153, name: "Borgaon Thadi" },
      { id: 559105, name: "Bori Pimpalgaon" },
      { id: 559110, name: "Bramhgaon" },
      { id: 559282, name: "Chaklamba" },
      { id: 559165, name: "Chavhanwadi" },
      { id: 559238, name: "Chikhali" },
      { id: 559195, name: "Chopdyachiwadi" },
      { id: 559283, name: "Chorpuri" },
      { id: 559159, name: "Daithan" },
      { id: 559161, name: "Deoki" },
      { id: 559134, name: "Deopimpri" },
      { id: 559173, name: "Dhalegaon" },
      { id: 559225, name: "Dhanora" },
      { id: 559264, name: "Dharwanta" },
      { id: 559129, name: "Dhondrai" },
      { id: 559279, name: "Dhumegaon" },
      { id: 559224, name: "Digrass" },
      { id: 559269, name: "Dimakhwadi" },
      { id: 559164, name: "Doiphodwadi." },
      { id: 559245, name: "Gadhi" },
      { id: 559103, name: "Gaikwad Jalgaon" },
      { id: 559155, name: "Gangawadi (Raheri)" },
      { id: 559120, name: "Gangawadi (Rakshabhuwan)" },
      { id: 559143, name: "Gaundgaon" },
      { id: 559141, name: "Georai (Rural)" },
      { id: 559178, name: "Golegaon" },
      { id: 559128, name: "Gondi Kh." },
      { id: 559172, name: "Gopat Pimpalgaon" },
      { id: 559163, name: "Govindwadi (Chavhanwadi)" },
      { id: 559147, name: "Govindwadi (Gevrai)" },
      { id: 559100, name: "Gulaj" },
      { id: 559098, name: "Guntegaon" },
      { id: 559127, name: "Hingangaon" },
      { id: 559276, name: "Hirapur" },
      { id: 559285, name: "Hiwarwadi" },
      { id: 559233, name: "Irgaon" },
      { id: 559275, name: "Itkur" },
      { id: 559211, name: "Jalgaon Majra" },
      { id: 559192, name: "Jategaon" },
      { id: 559248, name: "Javaharwadi" },
      { id: 559291, name: "Kajala" },
      { id: 559209, name: "Kajalyachi Wadi" },
      { id: 559267, name: "Kalwadi" },
      { id: 559216, name: "Kambi Majara" },
      { id: 559148, name: "Katchincholi" },
      { id: 559167, name: "Kathoda" },
      { id: 559113, name: "Kaudgaon" },
      { id: 559184, name: "Kekat Pangri" },
      { id: 559262, name: "Khadki" },
      { id: 559108, name: "Khalegaon" },
      { id: 559123, name: "Khamgaon" },
      { id: 559205, name: "Khandvi" },
      { id: 559201, name: "Kherda Bk." },
      { id: 559200, name: "Kherdawadi" },
      { id: 559145, name: "Khopati" },
      { id: 559139, name: "Kingaon" },
      { id: 559133, name: "Kobadwadi" },
      { id: 559251, name: "Kolgaon" },
      { id: 559138, name: "Kolher" },
      { id: 559181, name: "Koltyachiwadi" },
      { id: 559234, name: "Kopra" },
      { id: 559261, name: "Kumbharwadi" },
      { id: 559111, name: "Kumbhe Jalgaon" },
      { id: 559199, name: "Lonala" },
      { id: 559273, name: "Loulatgaon" },
      { id: 559162, name: "Lukhamasla" },
      { id: 559256, name: "Madalmohi" },
      { id: 559286, name: "Mahandula" },
      { id: 559278, name: "Mahar Takli" },
      { id: 559101, name: "Malegaon Bk." },
      { id: 559102, name: "Malegaon Kh." },
      { id: 559220, name: "Malegaon Majra" },
      { id: 559202, name: "Malhivara" },
      { id: 559263, name: "Mankapur" },
      { id: 559240, name: "Manmodi" },
      { id: 559169, name: "Manubai Jawala" },
      { id: 559146, name: "Manyarwadi" },
      { id: 559197, name: "Marfala" },
      { id: 559107, name: "Marotichiwadi" },
      { id: 559106, name: "Mategaon" },
      { id: 559119, name: "Mhalas Pimpalgaon" },
      { id: 559150, name: "Mirgaon" },
      { id: 559246, name: "Mirkala" },
      { id: 559203, name: "Mudhapuri" },
      { id: 559247, name: "Mulukwadi" },
      { id: 559124, name: "Nagzari" },
      { id: 559219, name: "Nandalgaon" },
      { id: 559217, name: "Nandpur" },
      { id: 559207, name: "Nipani Jawalka" },
      { id: 559227, name: "Pachegaon" },
      { id: 559258, name: "Padalsingi" },
      { id: 559190, name: "Padulyachi Wadi" },
      { id: 559117, name: "Panchaleshwar" },
      { id: 559151, name: "Pandhari" },
      { id: 559142, name: "Pandharwadi" },
      { id: 559149, name: "Pangulgaon" },
      { id: 559099, name: "Patharwala Bk." },
      { id: 559097, name: "Patharwala Kh." },
      { id: 559109, name: "Paulachiwadi" },
      { id: 559231, name: "Pimpalgaon Kanada" },
      { id: 559157, name: "Poitanda" },
      { id: 559253, name: "Pokhari" },
      { id: 559154, name: "Raheri" },
      { id: 559166, name: "Rajapur" },
      { id: 559144, name: "Rajpimpri" },
      { id: 559118, name: "Rakshasabhuwan" },
      { id: 559221, name: "Rameshwar" },
      { id: 559170, name: "Rampuri" },
      { id: 559244, name: "Ranjani" },
      { id: 559204, name: "Ranmala" },
      { id: 559284, name: "Rasulabad" },
      { id: 559160, name: "Revki" },
      { id: 559182, name: "Rohithal" },
      { id: 559183, name: "Rokda" },
      { id: 559210, name: "Rui" },
      { id: 559290, name: "Saidapur" },
      { id: 559126, name: "Sangam Jalgaon" },
      { id: 559250, name: "Sathewadi" },
      { id: 559121, name: "Sawaleshwar" },
      { id: 559122, name: "Sawargaon Jahagir" },
      { id: 559254, name: "Sawargaon Pokhari" },
      { id: 559193, name: "Selu" },
      { id: 559249, name: "Shahajanpur (Nirjan)" },
      { id: 559271, name: "Shahajanpur Chakla" },
      { id: 559287, name: "Shekta" },
      { id: 559243, name: "Shindewadi" },
      { id: 559171, name: "Shripat Antarwala" },
      { id: 559274, name: "Simpegaon" },
      { id: 559239, name: "Sindkhed" },
      { id: 559218, name: "Sindphana Chincholi" },
      { id: 559187, name: "Sirala" },
      { id: 559189, name: "Sirasdevi" },
      { id: 559268, name: "Sirasmarg" },
      { id: 559136, name: "Sujanpur" },
      { id: 559212, name: "Sultanpur" },
      { id: 559176, name: "Surdi Bk." },
      { id: 559116, name: "Surlegaon" },
      { id: 559236, name: "Sushi" },
      { id: 559237, name: "Sushi Vadgaon" },
      { id: 559140, name: "Takadgaon" },
      { id: 559277, name: "Takalgaon" },
      { id: 559266, name: "Takalgavhan Tarf Georai" },
      { id: 559196, name: "Takalgavhan Tarf Talkhed" },
      { id: 559130, name: "Talanewadi" },
      { id: 559242, name: "Talewadi" },
      { id: 559226, name: "Talvat Borgaon" },
      { id: 559156, name: "Talwada" },
      { id: 559288, name: "Tandala" },
      { id: 559174, name: "Tape Nimgaon" },
      { id: 559270, name: "Tartewadi" },
      { id: 559180, name: "Thakar Adgaon" },
      { id: 559265, name: "Ukhadpimpri" },
      { id: 559104, name: "Umapur" },
      { id: 559241, name: "Vadgaon Dhok" },
      { id: 559222, name: "Vahegaon Amala" },
      { id: 559257, name: "Vanjarwadi" },
      { id: 559232, name: "Yerandgav" },
    ],
    4219: [
      { id: 559347, name: "Abegaon" },
      { id: 559350, name: "Adola" },
      { id: 559396, name: "Anandgaon" },
      { id: 559411, name: "Babhalgaon" },
      { id: 559305, name: "Barabhai Tanda" },
      { id: 559407, name: "Belura" },
      { id: 946327, name: "Bhagwan Nagar" },
      { id: 559342, name: "Bhatwadgaon" },
      { id: 559382, name: "Bramhagaon" },
      { id: 559329, name: "Chhatra Borgaon" },
      { id: 559369, name: "Chinchagavhan" },
      { id: 559414, name: "Chopanwadi" },
      { id: 559356, name: "Chottewadi" },
      { id: 559320, name: "Dawargaon Kh." },
      { id: 559336, name: "Depegaon" },
      { id: 559373, name: "Devkheda" },
      { id: 559406, name: "Devla Kh." },
      { id: 946332, name: "Devsing Tanda" },
      { id: 559345, name: "Dhanagarwadi (Paytalwadi)" },
      { id: 559378, name: "Dhorgaon" },
      { id: 559413, name: "Dindrud" },
      { id: 559323, name: "Dubba Majra" },
      { id: 559298, name: "Dubbathadi" },
      { id: 559404, name: "Ekburjiwadi" },
      { id: 559319, name: "Ekdara" },
      { id: 559351, name: "Gangamasla" },
      { id: 559296, name: "Gavhanthadi" },
      { id: 559376, name: "Ghalatwadi" },
      { id: 946334, name: "Godawari Tanda" },
      { id: 559338, name: "Govindpur" },
      { id: 559334, name: "Govindwadi" },
      { id: 559358, name: "Gunjthadi" },
      { id: 946330, name: "Hanuman Nagar Tanda" },
      { id: 559310, name: "Harki Nimgaon" },
      { id: 559297, name: "Hiwara Bk." },
      { id: 559324, name: "Irala Majara" },
      { id: 559314, name: "Jadid Jawala" },
      { id: 559402, name: "Jivanapur" },
      { id: 559299, name: "Kalegaon Thadi" },
      { id: 559295, name: "Kaudgaon Thadi" },
      { id: 559372, name: "Kedar Sangvi" },
      { id: 559343, name: "Kesapuri" },
      { id: 559383, name: "Khanapur" },
      { id: 559360, name: "Kharat Adgaon" },
      { id: 559368, name: "Khatgavhan" },
      { id: 559313, name: "Kherda Kh." },
      { id: 559335, name: "Kitty Adgaon" },
      { id: 559399, name: "Kothrul" },
      { id: 559385, name: "Lahamewadi" },
      { id: 559388, name: "Laul" },
      { id: 559398, name: "Longaon" },
      { id: 559339, name: "Lukhegaon" },
      { id: 559374, name: "Majalgaon (Rural)" },
      { id: 559346, name: "Malipargaon" },
      { id: 946328, name: "Maltanda" },
      { id: 559317, name: "Mangrul" },
      { id: 559330, name: "Manjrath" },
      { id: 559340, name: "Manur" },
      { id: 559365, name: "Mogara." },
      { id: 559352, name: "Mothiwadi" },
      { id: 946331, name: "Nagazari (Gaimukh)" },
      { id: 559353, name: "Nagdgaon" },
      { id: 559409, name: "Nakhalgaon" },
      { id: 559371, name: "Nandur" },
      { id: 559401, name: "Nathnagar Tanda" },
      { id: 559362, name: "Nipani Takli" },
      { id: 559391, name: "Nitrud" },
      { id: 559384, name: "Pathrud" },
      { id: 559375, name: "Pawarwadi" },
      { id: 559344, name: "Phulepimpalgaon" },
      { id: 559318, name: "Phulpimpalgaon" },
      { id: 559410, name: "Pimpalgaon Nakhale" },
      { id: 559367, name: "Pimpri Kh." },
      { id: 946355, name: "Pirunaik Tanda" },
      { id: 559381, name: "Punandgaon" },
      { id: 559322, name: "Pungani" },
      { id: 559326, name: "Purshotampuri" },
      { id: 946329, name: "Pushpanaik Tanda" },
      { id: 559304, name: "Rajegaon" },
      { id: 559389, name: "Rajewadi" },
      { id: 559315, name: "Rampimpalgaon" },
      { id: 946333, name: "Rekhanaik Tanda" },
      { id: 559379, name: "Renapuri" },
      { id: 559294, name: "Ridhori" },
      { id: 559354, name: "Roshanpuri" },
      { id: 559328, name: "Sadola" },
      { id: 559400, name: "Salegaon" },
      { id: 559337, name: "Sandas Chincholi" },
      { id: 559348, name: "Sarwar Pimpalgaon" },
      { id: 559316, name: "Sawargaon" },
      { id: 559333, name: "Shahajanpur" },
      { id: 559311, name: "Shahapur Majara" },
      { id: 559370, name: "Shelapuri" },
      { id: 559293, name: "Shelgaon Thadi" },
      { id: 559359, name: "Shimpetakali" },
      { id: 559386, name: "Shindewadi" },
      { id: 946356, name: "Shivajinagar Tanda" },
      { id: 559364, name: "Shukltirth Nimgaon" },
      { id: 559403, name: "Simri Pargaon" },
      { id: 559349, name: "Somthana" },
      { id: 559361, name: "Sonnathadi." },
      { id: 559331, name: "Sultanpur" },
      { id: 559300, name: "Surdi Najik" },
      { id: 559357, name: "Surumgaon" },
      { id: 559292, name: "Takarwan" },
      { id: 559390, name: "Talewadi" },
      { id: 559312, name: "Talkhed" },
      { id: 559321, name: "Telgaon Kh." },
      { id: 559405, name: "Umri Bk." },
      { id: 946357, name: "Vasantnagar Tanda" },
      { id: 559332, name: "Waghora" },
      { id: 559415, name: "Wangi Bk." },
      { id: 559307, name: "Warula" },
    ],
    4220: [
      { id: 559434, name: "Bahegavhan" },
      { id: 559458, name: "Bavi" },
      { id: 559441, name: "Chikhal Beed" },
      { id: 559451, name: "Chinchala" },
      { id: 559433, name: "Chinchoti" },
      { id: 559426, name: "Chinchwadgaon" },
      { id: 559438, name: "Chinchwan" },
      { id: 559423, name: "Dawargaon Bk." },
      { id: 559425, name: "Devdhi" },
      { id: 559444, name: "Devgaon" },
      { id: 559421, name: "Devla Bk." },
      { id: 559450, name: "Dhanora" },
      { id: 559461, name: "Dhorwadi" },
      { id: 559452, name: "Dukdegaon" },
      { id: 559427, name: "Harishchandrapimpri" },
      { id: 559457, name: "Hiwargavhan" },
      { id: 559443, name: "Kadi Wadgaon" },
      { id: 559431, name: "Kanhapur" },
      { id: 559417, name: "Kanhobachiwadi" },
      { id: 559424, name: "Kaudgaon Bk." },
      { id: 559449, name: "Kende Pimpri" },
      { id: 559420, name: "Khadki" },
      { id: 559442, name: "Khalwat Limgaon" },
      { id: 559439, name: "Kotharban" },
      { id: 559454, name: "Kuppa" },
      { id: 559430, name: "Laxmipur" },
      { id: 559459, name: "Lonwal" },
      { id: 559432, name: "Mamla" },
      { id: 559448, name: "Mategaon" },
      { id: 559456, name: "Morwad" },
      { id: 559446, name: "Pardi" },
      { id: 559440, name: "Pimpaltakka" },
      { id: 559428, name: "Pimparkhed" },
      { id: 559419, name: "Pimpla Rui" },
      { id: 559455, name: "Pusra" },
      { id: 559418, name: "Rui Pimpla" },
      { id: 559429, name: "Salimba" },
      { id: 559437, name: "Sonnakhota" },
      { id: 559453, name: "Tigaon" },
      { id: 559422, name: "Tokewadi" },
      { id: 559460, name: "Upli" },
      { id: 559435, name: "Wadvani" },
    ],
    4221: [
      { id: 559551, name: "Adgaon" },
      { id: 559605, name: "Aher Dhanora" },
      { id: 559545, name: "Aher Nimgaon" },
      { id: 559569, name: "Aher Wadgaon" },
      { id: 559517, name: "Aherchincholi" },
      { id: 559469, name: "Ambesawali" },
      { id: 559682, name: "Ambil Wadgaon" },
      { id: 559542, name: "Anandwadi" },
      { id: 559660, name: "Anandwadi (Ghat)" },
      { id: 559681, name: "Andhapuri Ghat" },
      { id: 559633, name: "Anjanwati" },
      { id: 559601, name: "Atharwan Pimpri" },
      { id: 559529, name: "Aurangpur" },
      { id: 559488, name: "Awalpur" },
      { id: 559629, name: "Babhalkhunta" },
      { id: 559620, name: "Babhalwadi" },
      { id: 559483, name: "Bahadarpur" },
      { id: 559547, name: "Bahirwadi" },
      { id: 559476, name: "Bakarwadi" },
      { id: 559680, name: "Balapur" },
      { id: 559534, name: "Barhanpur" },
      { id: 559644, name: "Bavi" },
      { id: 559566, name: "Bedukwadi" },
      { id: 943942, name: "Beed Taraf Balgujar" },
      { id: 943944, name: "Beed Taraf Bobade" },
      { id: 943941, name: "Beed Taraf Deshmukh" },
      { id: 943940, name: "Beed Taraf Giram" },
      { id: 943939, name: "Beed Taraf Mali" },
      { id: 943943, name: "Beed Taraf Pingale" },
      { id: 943938, name: "Beed Traf Khod" },
      { id: 559544, name: "Belapuri" },
      { id: 559582, name: "Belgaon" },
      { id: 559511, name: "Belkhandi (Pa)" },
      { id: 559494, name: "Belura" },
      { id: 559621, name: "Belwadi" },
      { id: 559509, name: "Bhalwani" },
      { id: 559661, name: "Bhandarwadi" },
      { id: 559530, name: "Bhatsangvi" },
      { id: 559614, name: "Bhavanwadi" },
      { id: 559464, name: "Bordevi" },
      { id: 559594, name: "Borkhed" },
      { id: 559632, name: "Borphadi" },
      { id: 559627, name: "Bramhagaon" },
      { id: 559679, name: "Chakurwadi" },
      { id: 559658, name: "Chandani" },
      { id: 559657, name: "Chandegaon" },
      { id: 559503, name: "Charahata" },
      { id: 559589, name: "Chaudaswadi" },
      { id: 559646, name: "Chausala" },
      { id: 559548, name: "Chavanwadi" },
      { id: 559602, name: "Chincholi Mali" },
      { id: 559603, name: "Dahiphal(Chincholi)" },
      { id: 559635, name: "Dahiwandi" },
      { id: 559515, name: "Deorayachiwadi" },
      { id: 559645, name: "Devi Babhulgaon" },
      { id: 559574, name: "Dhangarwadi" },
      { id: 559677, name: "Dhavjyachiwadi" },
      { id: 559477, name: "Dhekan Moha" },
      { id: 929102, name: "Dheknmoha Tanda" },
      { id: 559643, name: "Dhotra" },
      { id: 559670, name: "Doiphodwadi" },
      { id: 943937, name: "Fukewadi" },
      { id: 559619, name: "Ganganathwadi" },
      { id: 559600, name: "Ganpur" },
      { id: 559504, name: "Gaulwadi" },
      { id: 559578, name: "Gawari" },
      { id: 559639, name: "Ghargaon" },
      { id: 559472, name: "Ghatjawala" },
      { id: 559475, name: "Ghatsawli" },
      { id: 559537, name: "Ghosapuri" },
      { id: 559634, name: "Gogalwadi" },
      { id: 559640, name: "Golangri" },
      { id: 559559, name: "Gundha" },
      { id: 559558, name: "Gundhawadi" },
      { id: 559556, name: "Gunjala" },
      { id: 559653, name: "Hingane Bk." },
      { id: 559521, name: "Hingani (Haveli)" },
      { id: 559655, name: "Hingani Kh." },
      { id: 559481, name: "Hiwaraphadi" },
      { id: 559612, name: "Imampur" },
      { id: 559623, name: "It" },
      { id: 559507, name: "Jadhavawadi" },
      { id: 559667, name: "Jaitalwadi" },
      { id: 559630, name: "Jarud" },
      { id: 559656, name: "Jebapimpri" },
      { id: 559543, name: "Jirewadi" },
      { id: 559625, name: "Juj Gavhan" },
      { id: 559510, name: "Kadamwadi" },
      { id: 559499, name: "Kakadhira" },
      { id: 559478, name: "Kalegaon Haveli" },
      { id: 559665, name: "Kalsambar" },
      { id: 559524, name: "Kambi" },
      { id: 559523, name: "Kamkheda" },
      { id: 559641, name: "Kanadi" },
      { id: 559479, name: "Karalwadi" },
      { id: 559573, name: "Karchondi" },
      { id: 559662, name: "Karegavhan" },
      { id: 559576, name: "Karzani" },
      { id: 559608, name: "Kathoda" },
      { id: 559502, name: "Katwatwadi" },
      { id: 559466, name: "Kesapuri" },
      { id: 559490, name: "Ketura" },
      { id: 559637, name: "Khadkighat" },
      { id: 559518, name: "Khamgaon" },
      { id: 559581, name: "Khandala" },
      { id: 559599, name: "Khandepargaon" },
      { id: 559540, name: "Khapar Pangri" },
      { id: 559675, name: "Khardewadi" },
      { id: 559550, name: "Khudras" },
      { id: 559527, name: "Kinhipai" },
      { id: 559610, name: "Kolharwadi" },
      { id: 559575, name: "Kolwadi" },
      { id: 559549, name: "Kukkatgaon" },
      { id: 559683, name: "Kumbhari" },
      { id: 559538, name: "Kumsi" },
      { id: 559528, name: "Kurla" },
      { id: 559654, name: "Kutewadi" },
      { id: 912693, name: "Laxmiaai Tanda" },
      { id: 559592, name: "Limba Ganesh" },
      { id: 559497, name: "Limbarui" },
      { id: 559562, name: "Limbarui (Devi)" },
      { id: 559535, name: "Lolatgaon" },
      { id: 559555, name: "Loni (Shahajanpur)" },
      { id: 559647, name: "Lonighat" },
      { id: 559593, name: "Mahajanwadi" },
      { id: 559617, name: "Mahalas Jawala" },
      { id: 559473, name: "Mainda" },
      { id: 559526, name: "Malapuri" },
      { id: 559652, name: "Malewadi" },
      { id: 559571, name: "Mandav Jali" },
      { id: 559666, name: "Mandavkhel" },
      { id: 559650, name: "Manewadi" },
      { id: 559579, name: "Manjar Sumba" },
      { id: 559470, name: "Mankurwadi" },
      { id: 559471, name: "Manyarwadi" },
      { id: 559572, name: "Manzari Haveli" },
      { id: 559591, name: "Masewadi" },
      { id: 559628, name: "Mauj" },
      { id: 559631, name: "Maujwadi" },
      { id: 559506, name: "Mengdewadi" },
      { id: 559622, name: "Mhalasapur" },
      { id: 559587, name: "Morgaon" },
      { id: 559565, name: "Muggaon" },
      { id: 559586, name: "Mulukwadi" },
      { id: 559496, name: "Murshadpur (Rajuri)" },
      { id: 559686, name: "Murshadpur(Ghat)" },
      { id: 559615, name: "Nagpur Bk." },
      { id: 559616, name: "Nagpur Kh." },
      { id: 559513, name: "Nagzari" },
      { id: 559626, name: "Nalwandi" },
      { id: 559536, name: "Namalgaon" },
      { id: 559519, name: "Nandur (Haveli)" },
      { id: 559553, name: "Nathapur" },
      { id: 559463, name: "Nawabpur" },
      { id: 559671, name: "Neknoor" },
      { id: 559480, name: "Nirmalwadi" },
      { id: 559669, name: "Nivdungawadi" },
      { id: 559570, name: "Pali" },
      { id: 559659, name: "Palsingan" },
      { id: 559505, name: "Palwan" },
      { id: 559678, name: "Pandharyachiwadi" },
      { id: 559467, name: "Parbhani" },
      { id: 559485, name: "Pargaon Siras" },
      { id: 559520, name: "Pargaonjapti" },
      { id: 559564, name: "Pategaon" },
      { id: 559512, name: "Patoda (Bel)" },
      { id: 559525, name: "Pendgaon" },
      { id: 559563, name: "Pimpaladevi" },
      { id: 559618, name: "Pimpalgaon (Majara)" },
      { id: 559649, name: "Pimpalgaon Ghat" },
      { id: 559606, name: "Pimpalgaon Mochi" },
      { id: 559567, name: "Pimpalner" },
      { id: 559508, name: "Pimpalwadi" },
      { id: 559541, name: "Pimpargavhan" },
      { id: 559583, name: "Pimparnai" },
      { id: 559474, name: "Pokhari" },
      { id: 559585, name: "Pokhari Ghat." },
      { id: 559687, name: "Pothra" },
      { id: 559532, name: "Rajkapur" },
      { id: 559495, name: "Rajuri Bk.(Navgan)" },
      { id: 559604, name: "Rajuri Ghodka" },
      { id: 559531, name: "Rakshas Bhuwan" },
      { id: 559552, name: "Ramgaon" },
      { id: 559554, name: "Ranjegaon" },
      { id: 559577, name: "Ratnagiri" },
      { id: 559638, name: "Raulasgaon" },
      { id: 559489, name: "Rudrapur" },
      { id: 559651, name: "Ruigavhan" },
      { id: 559493, name: "Ruilimba" },
      { id: 559590, name: "Safepur" },
      { id: 559596, name: "Sakhare Borgaon" },
      { id: 559482, name: "Sakshalpimpri" },
      { id: 559611, name: "Samnapur" },
      { id: 559668, name: "Sanapwadi" },
      { id: 559561, name: "Sandarwan" },
      { id: 559580, name: "Sasewadi" },
      { id: 559685, name: "Satra" },
      { id: 559539, name: "Saundana" },
      { id: 559673, name: "Sawantwadi" },
      { id: 559684, name: "Sawargaon Ghat" },
      { id: 559486, name: "Shahabajpur" },
      { id: 559522, name: "Shahajanpur (Kamkheda)" },
      { id: 559492, name: "Shahajanpur (Limba)" },
      { id: 559560, name: "Shahajanpur (Loni)" },
      { id: 559546, name: "Shidode" },
      { id: 559607, name: "Shivni" },
      { id: 559584, name: "Somnathwadi" },
      { id: 559487, name: "Songaon" },
      { id: 559663, name: "Sonpethwadi" },
      { id: 559642, name: "Sultanpur" },
      { id: 559462, name: "Surdi (Thot)" },
      { id: 559514, name: "Suryachiwadi" },
      { id: 559465, name: "Tadsonna" },
      { id: 559498, name: "Talegaon" },
      { id: 559676, name: "Tandalyachiwadi" },
      { id: 559484, name: "Tandulwadi (Bhill)" },
      { id: 559516, name: "Tandulwadi (Haveli)" },
      { id: 559636, name: "Tandulwadi Ghat" },
      { id: 559500, name: "Tippatwadi" },
      { id: 559588, name: "Udandwadgaon" },
      { id: 559598, name: "Umrad (Khalsa)" },
      { id: 559491, name: "Umrad Jahagir" },
      { id: 559624, name: "Umri" },
      { id: 559672, name: "Vaitagwadi" },
      { id: 559557, name: "Wadgaon (Gundha)" },
      { id: 559664, name: "Wadgaon (Kalsambar)" },
      { id: 559648, name: "Wadhavana" },
      { id: 559609, name: "Waibatwadi" },
      { id: 559533, name: "Waknathpur" },
      { id: 559468, name: "Walipur" },
      { id: 559595, name: "Wangaon" },
      { id: 559613, name: "Wangi" },
      { id: 559501, name: "Wanjarwadi" },
      { id: 559568, name: "Warwati" },
      { id: 559597, name: "Wasanwadi" },
      { id: 559674, name: "Yelambghat" },
    ],
    4222: [
      { id: 559774, name: "Adas" },
      { id: 559784, name: "Anandgaon" },
      { id: 559728, name: "Andhalewadi" },
      { id: 559802, name: "Anegaon" },
      { id: 559742, name: "Arangaon" },
      { id: 559795, name: "Aurangpur" },
      { id: 559800, name: "Awasgaon" },
      { id: 559703, name: "Banegaon" },
      { id: 559751, name: "Bankaranja" },
      { id: 559799, name: "Bansarola" },
      { id: 559803, name: "Bawachi" },
      { id: 559694, name: "Belgaon" },
      { id: 559805, name: "Bhalgaon" },
      { id: 559753, name: "Bhatumba" },
      { id: 559714, name: "Bhopala" },
      { id: 559765, name: "Bobdewadi" },
      { id: 559711, name: "Borgaon Bk." },
      { id: 559796, name: "Borisawargaon" },
      { id: 559752, name: "Chandansawargaon" },
      { id: 559760, name: "Chincholi Mali" },
      { id: 559715, name: "Dahiphal Wadmauli" },
      { id: 559710, name: "Daithana" },
      { id: 559704, name: "Daradwadi" },
      { id: 559729, name: "Deogaon" },
      { id: 559779, name: "Depewadgaon" },
      { id: 559705, name: "Dhakanwadi" },
      { id: 559755, name: "Dhakephal" },
      { id: 559806, name: "Dhanegaon" },
      { id: 559746, name: "Dharmala" },
      { id: 559700, name: "Dhotra" },
      { id: 559762, name: "Doka" },
      { id: 559758, name: "Dongaon" },
      { id: 559692, name: "Ekurka" },
      { id: 559701, name: "Gadlewadi" },
      { id: 559726, name: "Gappewadi" },
      { id: 559717, name: "Gaurwadi" },
      { id: 559719, name: "Ghatewadi" },
      { id: 559786, name: "Gotegaon" },
      { id: 559763, name: "Hadgaon" },
      { id: 559697, name: "Hanumant Pimpri" },
      { id: 559778, name: "Hoal" },
      { id: 559809, name: "Isthal" },
      { id: 559743, name: "Jadhavjawala" },
      { id: 559750, name: "Janegaon" },
      { id: 559782, name: "Jawalban" },
      { id: 559721, name: "Jiwachiwadi" },
      { id: 559731, name: "Jola" },
      { id: 912929, name: "Kaij" },
      { id: 559773, name: "Kalamamba" },
      { id: 559695, name: "Kalegaon Ghat" },
      { id: 559798, name: "Kandibadan" },
      { id: 559756, name: "Kandimali" },
      { id: 559712, name: "Kaprewadi" },
      { id: 559747, name: "Kasari" },
      { id: 559725, name: "Kashidwadi" },
      { id: 559797, name: "Kaudgaon" },
      { id: 559775, name: "Kekanwadi" },
      { id: 559772, name: "Kekat Sarni" },
      { id: 559693, name: "Kelgaon" },
      { id: 559696, name: "Kewad" },
      { id: 559723, name: "Kolhewadi" },
      { id: 559718, name: "Kordewadi" },
      { id: 559740, name: "Koregaon" },
      { id: 559737, name: "Kothi" },
      { id: 559754, name: "Kumbephal" },
      { id: 559781, name: "Ladegaon" },
      { id: 559777, name: "Ladewadgaon" },
      { id: 559738, name: "Lahuri" },
      { id: 559789, name: "Lakha" },
      { id: 559767, name: "Malegaon" },
      { id: 559699, name: "Malewadi" },
      { id: 559790, name: "Mangwadgaon" },
      { id: 559741, name: "Massajog" },
      { id: 559787, name: "Motegaon" },
      { id: 559776, name: "Mulegaon" },
      { id: 559691, name: "Mundewadi" },
      { id: 559722, name: "Nagzari" },
      { id: 559807, name: "Naigaon" },
      { id: 559706, name: "Nandurghat" },
      { id: 559698, name: "Nanholi" },
      { id: 559690, name: "Narewadi" },
      { id: 559793, name: "Paithan" },
      { id: 559780, name: "Palaskheda" },
      { id: 559792, name: "Pathra" },
      { id: 559735, name: "Pimpalgawhan" },
      { id: 559716, name: "Pirachiwadi" },
      { id: 559749, name: "Pisegaon" },
      { id: 559707, name: "Pitthighat" },
      { id: 559709, name: "Rajegaon" },
      { id: 559702, name: "Rameshwarwadi" },
      { id: 559745, name: "Sabla" },
      { id: 559804, name: "Sadola" },
      { id: 559764, name: "Salegaon" },
      { id: 559734, name: "Sangvi (S)" },
      { id: 559733, name: "Sarni (Sangvi)" },
      { id: 559783, name: "Sarni Anandgaon" },
      { id: 559761, name: "Sarukwadi" },
      { id: 559732, name: "Sarul" },
      { id: 559730, name: "Sasura" },
      { id: 559788, name: "Satephal" },
      { id: 559808, name: "Saundana" },
      { id: 559794, name: "Sawleshwar" },
      { id: 559766, name: "Shelgaon Ganji" },
      { id: 559736, name: "Shindi" },
      { id: 559759, name: "Shirpura" },
      { id: 559708, name: "Shirurghat" },
      { id: 559769, name: "Sonesangvi" },
      { id: 559785, name: "Sonijawla" },
      { id: 559768, name: "Sukli" },
      { id: 559770, name: "Surdi" },
      { id: 559757, name: "Takli" },
      { id: 559748, name: "Tambwa" },
      { id: 559744, name: "Tarnali" },
      { id: 559720, name: "Tukuchiwadi" },
      { id: 559739, name: "Umri" },
      { id: 559771, name: "Undri" },
      { id: 559689, name: "Waghebabhalgaon" },
      { id: 559801, name: "Wakdi" },
      { id: 559713, name: "Warapgaon" },
      { id: 559727, name: "Wida" },
      { id: 559724, name: "Yewta" },
      { id: 559791, name: "Yusufwadgav" },
    ],
    4223: [
      { id: 559877, name: "Aadhingani" },
      { id: 559841, name: "Ambewadgaon" },
      { id: 559831, name: "Amla" },
      { id: 559853, name: "Anjandhav" },
      { id: 559856, name: "Aranwadi" },
      { id: 559869, name: "Asardhav" },
      { id: 559854, name: "Aswala" },
      { id: 559861, name: "Awargaon" },
      { id: 559844, name: "Bhogalwadi" },
      { id: 559814, name: "Bhopa" },
      { id: 559825, name: "Bodakha" },
      { id: 559812, name: "Chardari" },
      { id: 559817, name: "Chatgaon" },
      { id: 559822, name: "Chikhali" },
      { id: 559863, name: "Chinchpur" },
      { id: 559848, name: "Choramba" },
      { id: 559845, name: "Choundi" },
      { id: 559818, name: "Devdahiphal" },
      { id: 559821, name: "Devthana" },
      { id: 559858, name: "Dharur" },
      { id: 559839, name: "Dunakwad" },
      { id: 559819, name: "Fakir Jawala" },
      { id: 559864, name: "Ganjpur" },
      { id: 559842, name: "Gawandara" },
      { id: 559857, name: "Ghagarwada" },
      { id: 559855, name: "Gopalpur Lamantanda" },
      { id: 559860, name: "Hasanabad" },
      { id: 559828, name: "Hingani Bk" },
      { id: 559829, name: "Hingani Kh" },
      { id: 559846, name: "Jahagir Moha" },
      { id: 559820, name: "Jaitapur" },
      { id: 559851, name: "Jaybhaychi Wadi" },
      { id: 559827, name: "Kacharwadi" },
      { id: 559824, name: "Kandewadi" },
      { id: 559872, name: "Kannapur" },
      { id: 559826, name: "Kari" },
      { id: 559823, name: "Kasari" },
      { id: 559843, name: "Katewadi" },
      { id: 559838, name: "Khodas" },
      { id: 559866, name: "Kolpimpri" },
      { id: 559832, name: "Koyal" },
      { id: 559876, name: "Kundi" },
      { id: 559859, name: "Maindwadi" },
      { id: 559871, name: "Mhatargaon" },
      { id: 559833, name: "Mohkhed" },
      { id: 559870, name: "Moraphali" },
      { id: 559873, name: "Mungi" },
      { id: 559840, name: "Nagzari Gaimukh" },
      { id: 559830, name: "Nimla" },
      { id: 559810, name: "Pahadi Dahifal" },
      { id: 559811, name: "Pahadi Pargaon" },
      { id: 559865, name: "Pangri" },
      { id: 559850, name: "Pimparwada" },
      { id: 559852, name: "Repewadi" },
      { id: 559867, name: "Rui Dharur" },
      { id: 559816, name: "Sangam" },
      { id: 559836, name: "Shiganwadi" },
      { id: 559849, name: "Sonimoha" },
      { id: 559874, name: "Sukli" },
      { id: 559835, name: "Suranwadi" },
      { id: 559862, name: "Tandalwadi" },
      { id: 559813, name: "Telgaon" },
      { id: 559847, name: "Thetegavhan" },
      { id: 559868, name: "Umarewadi" },
      { id: 559837, name: "Wagholi" },
      { id: 559834, name: "Wharkatwadi" },
    ],
    4224: [
      { id: 559979, name: "Anandwadi" },
      { id: 559933, name: "Aswalamba" },
      { id: 559896, name: "Aurangapur" },
      { id: 559929, name: "Bahadurwadi" },
      { id: 559938, name: "Belamba" },
      { id: 559917, name: "Bhilegaon" },
      { id: 559956, name: "Bhopla" },
      { id: 559905, name: "Bodhegaon" },
      { id: 559881, name: "Borkhed" },
      { id: 559949, name: "Bramhawadi" },
      { id: 559968, name: "Chandapur" },
      { id: 559945, name: "Dabi" },
      { id: 559946, name: "Dabi Tanda" },
      { id: 559961, name: "Dagadwadi" },
      { id: 559976, name: "Daithana Ghat" },
      { id: 559936, name: "Daunapur" },
      { id: 559940, name: "Dautpur" },
      { id: 559957, name: "Devhada" },
      { id: 559981, name: "Dharmapuri" },
      { id: 559878, name: "Digras" },
      { id: 559973, name: "Doundwadi" },
      { id: 559906, name: "Gaddewadi" },
      { id: 559919, name: "Gopalpur" },
      { id: 559890, name: "Govardhan" },
      { id: 559982, name: "Guttewadi" },
      { id: 559977, name: "Halamb" },
      { id: 559893, name: "Hasanabad" },
      { id: 559974, name: "Helab" },
      { id: 559884, name: "Hiwara Govardhan" },
      { id: 559944, name: "Indapwadi" },
      { id: 559971, name: "Indiranagar" },
      { id: 559912, name: "Injegaon" },
      { id: 559948, name: "Jalalpur" },
      { id: 559883, name: "Jalgavhan" },
      { id: 559892, name: "Jaygaon" },
      { id: 559947, name: "Jirewadi" },
      { id: 559900, name: "Kanadi" },
      { id: 559955, name: "Kanherwadi" },
      { id: 559902, name: "Karewadi" },
      { id: 559963, name: "Kasarwadi" },
      { id: 559898, name: "Kaudgaon Ghoda" },
      { id: 559886, name: "Kaudgaon Huda" },
      { id: 559899, name: "Kaudgaon Sabla" },
      { id: 559925, name: "Kauthali" },
      { id: 559926, name: "Kauthali Tanda" },
      { id: 559904, name: "Kavalyachiwadi" },
      { id: 559875, name: "Khamgaon" },
      { id: 559975, name: "Khodwa Sawargaon" },
      { id: 559980, name: "Ladzari" },
      { id: 559970, name: "Lendwadi" },
      { id: 559927, name: "Limbuta" },
      { id: 559939, name: "Lonarwadi" },
      { id: 559959, name: "Loni" },
      { id: 559972, name: "Maindwadi" },
      { id: 560058, name: "Malewadi" },
      { id: 559920, name: "Malhivara" },
      { id: 559954, name: "Malkapur" },
      { id: 559916, name: "Malnathapur" },
      { id: 559885, name: "Mamdapur" },
      { id: 559966, name: "Mandava (Parli)" },
      { id: 559930, name: "Mandekhel" },
      { id: 559967, name: "Maralwadi" },
      { id: 559962, name: "Mirwat" },
      { id: 559903, name: "Moha" },
      { id: 559928, name: "Nagapur" },
      { id: 559978, name: "Nagdara" },
      { id: 559931, name: "Nagpimpri" },
      { id: 559969, name: "Nandagaul" },
      { id: 559964, name: "Nandnaj" },
      { id: 559911, name: "Nathra" },
      { id: 559894, name: "Padoli" },
      { id: 559924, name: "Pangri" },
      { id: 559923, name: "Parchundi" },
      { id: 559951, name: "Parli (Rural)" },
      { id: 559910, name: "Pimpalgaon(Gadhe)" },
      { id: 559889, name: "Pimpri Bk" },
      { id: 559879, name: "Pohner" },
      { id: 559909, name: "Rewali" },
      { id: 559914, name: "Safdarabad" },
      { id: 559941, name: "Sangam" },
      { id: 559965, name: "Saradgaon" },
      { id: 559907, name: "Sarfarajpur" },
      { id: 559915, name: "Selu" },
      { id: 559958, name: "Selu (Parali)" },
      { id: 559887, name: "Shrikrushnanagar" },
      { id: 559888, name: "Shriramnagar" },
      { id: 559901, name: "Sirsala" },
      { id: 559932, name: "Sonhivra" },
      { id: 559921, name: "Tadoli" },
      { id: 559897, name: "Takli Acharya" },
      { id: 559913, name: "Takli Deshmukh" },
      { id: 559937, name: "Talegaon (Parli)" },
      { id: 559895, name: "Tapovan" },
      { id: 559880, name: "Telasmukh" },
      { id: 559943, name: "Tokwadi" },
      { id: 559950, name: "Vaijwadi" },
      { id: 559952, name: "Vasantnagar" },
      { id: 559960, name: "Wadgaon (Dadahari)" },
      { id: 559922, name: "Wadkhel" },
      { id: 559942, name: "Wagbet" },
      { id: 559918, name: "Waghala (Parli)" },
      { id: 559908, name: "Waka" },
      { id: 559934, name: "Wantakli" },
      { id: 559935, name: "Wantakli Tanda" },
    ],
    4225: [
      { id: 560033, name: "Akola" },
      { id: 560022, name: "Ambajogai (Rural)" },
      { id: 560057, name: "Ambaltek" },
      { id: 560046, name: "Ambalwadi" },
      { id: 560006, name: "Anjanpur" },
      { id: 560004, name: "Apegaon" },
      { id: 560070, name: "Babhalgaon" },
      { id: 560073, name: "Bagzari" },
      { id: 560039, name: "Bardapur" },
      { id: 560051, name: "Bharaj" },
      { id: 560081, name: "Bhatanwadi" },
      { id: 559990, name: "Bhawthana" },
      { id: 560020, name: "Chanai" },
      { id: 560041, name: "Chandanwadi" },
      { id: 559988, name: "Chichkhandi" },
      { id: 560066, name: "Chopanwadi" },
      { id: 560064, name: "Chothewadi" },
      { id: 560084, name: "Dagadwadi." },
      { id: 560036, name: "Daithana (Radi)" },
      { id: 560078, name: "Daradwadi" },
      { id: 560055, name: "Dattapur" },
      { id: 560009, name: "Devla" },
      { id: 560032, name: "Dhanora Bk." },
      { id: 560003, name: "Dhanora Kh" },
      { id: 560083, name: "Dhaswadi" },
      { id: 559992, name: "Dhavadi" },
      { id: 559985, name: "Dighol Amba" },
      { id: 560019, name: "Dongar Pimpla" },
      { id: 560059, name: "Ghatnandur" },
      { id: 560063, name: "Gholapwadi" },
      { id: 560047, name: "Girwli (Apet)" },
      { id: 560048, name: "Girwli (Bawne)" },
      { id: 560050, name: "Gitta" },
      { id: 560060, name: "Hanumantwadi" },
      { id: 560042, name: "Hatola" },
      { id: 559997, name: "Hivara Kh." },
      { id: 560052, name: "Jawalgaon" },
      { id: 560079, name: "Jodwadi" },
      { id: 560024, name: "Jogaiwadi" },
      { id: 560080, name: "Katkarwadi" },
      { id: 559991, name: "Kendrewadi" },
      { id: 560075, name: "Khapartone" },
      { id: 559983, name: "Kodari" },
      { id: 559999, name: "Kolkanadi" },
      { id: 560005, name: "Kopra" },
      { id: 560086, name: "Krushnanagar" },
      { id: 560000, name: "Kumbephal" },
      { id: 560014, name: "Kuranwadi" },
      { id: 560074, name: "Kusalwadi" },
      { id: 560015, name: "Laman Tanda" },
      { id: 560040, name: "Limbgaon" },
      { id: 559994, name: "Lokhandi Sawargaon" },
      { id: 560023, name: "Magarwadi" },
      { id: 560002, name: "Makegaon" },
      { id: 560011, name: "Mamdapur (Parli)" },
      { id: 560007, name: "Mamdapur (Patoda)" },
      { id: 560012, name: "Mandva Pathan" },
      { id: 560021, name: "Morewadi" },
      { id: 560035, name: "Mudegaon" },
      { id: 560085, name: "Multan Tanda" },
      { id: 560061, name: "Murambi" },
      { id: 560077, name: "Murkutwadi" },
      { id: 560068, name: "Murti" },
      { id: 560001, name: "Nandadi" },
      { id: 560038, name: "Nandgaon" },
      { id: 560062, name: "Nawabwadi" },
      { id: 560072, name: "Nirpana" },
      { id: 560008, name: "Patoda (Mamdapur)" },
      { id: 560069, name: "Pattiwadgaon" },
      { id: 560049, name: "Pimpala Dhaiguda" },
      { id: 560043, name: "Pimpri" },
      { id: 560028, name: "Pokhari" },
      { id: 560053, name: "Pus" },
      { id: 560030, name: "Radi" },
      { id: 560031, name: "Radi Tanda" },
      { id: 559989, name: "Rajewadi" },
      { id: 560010, name: "Rakshaswadi" },
      { id: 560016, name: "Sakud" },
      { id: 560065, name: "Salunkwadi" },
      { id: 559984, name: "Sangaon" },
      { id: 560025, name: "Satephal" },
      { id: 560076, name: "Saundana" },
      { id: 560029, name: "Saygaon" },
      { id: 560027, name: "Selu Amba" },
      { id: 560018, name: "Shepwadi" },
      { id: 559995, name: "Shripatraiwadi" },
      { id: 560071, name: "Somanwadi" },
      { id: 559998, name: "Somnath Borgaon" },
      { id: 559987, name: "Sonwala" },
      { id: 560037, name: "Sugaon" },
      { id: 560034, name: "Tadola" },
      { id: 560044, name: "Talegaon Ghat" },
      { id: 560054, name: "Talni" },
      { id: 559986, name: "Tat Borgaon" },
      { id: 560056, name: "Telghana" },
      { id: 560082, name: "Ujani" },
      { id: 559993, name: "Umrai" },
      { id: 560026, name: "Waghala (Radi)" },
      { id: 560087, name: "Waghalwadi" },
      { id: 560067, name: "Wakdi" },
      { id: 560045, name: "Walewadi" },
      { id: 559996, name: "Warapgaon" },
      { id: 560017, name: "Warwati" },
      { id: 560013, name: "Yelda" },
    ],
    4226: [
      { id: 560146, name: "Akharwai" },
      { id: 560150, name: "Akoli" },
      { id: 560195, name: "Anandwadi" },
      { id: 560210, name: "Arvi" },
      { id: 560168, name: "Babhalgaon" },
      { id: 560187, name: "Bamni" },
      { id: 560163, name: "Baswantpur" },
      { id: 560196, name: "Bhadgaon" },
      { id: 560188, name: "Bhadi" },
      { id: 560189, name: "Bhatangali" },
      { id: 560191, name: "Bhatkheda" },
      { id: 560089, name: "Bhosa" },
      { id: 560106, name: "Bhoyara" },
      { id: 560139, name: "Bhuisamudraga" },
      { id: 560209, name: "Bindgihal" },
      { id: 560120, name: "Bodka" },
      { id: 560208, name: "Bokangaon" },
      { id: 560108, name: "Bopala" },
      { id: 560101, name: "Borgaon Bk." },
      { id: 560203, name: "Bori" },
      { id: 560158, name: "Borwati" },
      { id: 560179, name: "Chandeshwar" },
      { id: 560105, name: "Chata" },
      { id: 560186, name: "Chikalthana" },
      { id: 560145, name: "Chikhurda" },
      { id: 560130, name: "Chincholi Ballalnath" },
      { id: 560148, name: "Chincholi Rao" },
      { id: 560155, name: "Chincholi Raowadi" },
      { id: 560206, name: "Dagadwadi" },
      { id: 560103, name: "Dhakani" },
      { id: 560200, name: "Dhanegaon" },
      { id: 560152, name: "Dhanori" },
      { id: 560128, name: "Dhoki" },
      { id: 560126, name: "Dindegaon" },
      { id: 560104, name: "Ekurga" },
      { id: 560116, name: "Gadhawad" },
      { id: 560177, name: "Gangapur" },
      { id: 560122, name: "Ganjur" },
      { id: 560143, name: "Gategaon" },
      { id: 560131, name: "Gondegaon" },
      { id: 560097, name: "Gumphawadi" },
      { id: 560165, name: "Hanamantwadi" },
      { id: 560173, name: "Harangul Bk" },
      { id: 560161, name: "Harangul Kh." },
      { id: 560100, name: "Hisori" },
      { id: 560119, name: "Jawala Bk." },
      { id: 560137, name: "Jewali" },
      { id: 560109, name: "Kanadi Borgaon" },
      { id: 944213, name: "Kanheri" },
      { id: 560098, name: "Karkatta" },
      { id: 560133, name: "Karsa" },
      { id: 560127, name: "Kasar Jawala" },
      { id: 560164, name: "Kasargaon" },
      { id: 560185, name: "Kasarkheda" },
      { id: 560134, name: "Katgaon" },
      { id: 560181, name: "Katpur" },
      { id: 560180, name: "Kavha" },
      { id: 560172, name: "Khadgaon" },
      { id: 560099, name: "Khandala" },
      { id: 560176, name: "Khandapur" },
      { id: 560170, name: "Khopegaon" },
      { id: 560183, name: "Khulgapur" },
      { id: 560094, name: "Khuntephal" },
      { id: 560192, name: "Kolpa" },
      { id: 560166, name: "Latur (Rural)" },
      { id: 560197, name: "Mahamdapur" },
      { id: 560157, name: "Mahapur" },
      { id: 560167, name: "Maharanapratapnagar" },
      { id: 560184, name: "Malwati" },
      { id: 560142, name: "Manjari" },
      { id: 560117, name: "Masala" },
      { id: 560095, name: "Matephal" },
      { id: 560144, name: "Murud Akola" },
      { id: 560096, name: "Murud Bk." },
      { id: 560204, name: "Mushirabad" },
      { id: 560138, name: "Nagzari" },
      { id: 560159, name: "Nandgaon" },
      { id: 560091, name: "Nilkanth" },
      { id: 560102, name: "Niwali" },
      { id: 560175, name: "Pakharsangvi" },
      { id: 560178, name: "Peth" },
      { id: 560088, name: "Pimpalgaon Amba" },
      { id: 560118, name: "Pimpri Amba" },
      { id: 560160, name: "Raiwadi" },
      { id: 560132, name: "Ramegaon" },
      { id: 560125, name: "Rameshwar" },
      { id: 560198, name: "Ramzanpur" },
      { id: 560124, name: "Rui" },
      { id: 560156, name: "Sai" },
      { id: 560147, name: "Sakhara" },
      { id: 560207, name: "Salgara Bk." },
      { id: 560205, name: "Salgara Kh." },
      { id: 560141, name: "Samangaon" },
      { id: 560193, name: "Sarola" },
      { id: 560113, name: "Sarsa" },
      { id: 560151, name: "Sawargaon" },
      { id: 560201, name: "Selu Bk." },
      { id: 560111, name: "Sevadasnagar" },
      { id: 560093, name: "Shirala" },
      { id: 560154, name: "Shiur" },
      { id: 560202, name: "Shivani Kh." },
      { id: 560169, name: "Sikandarpur" },
      { id: 560182, name: "Sirsi" },
      { id: 560194, name: "Sonavati" },
      { id: 560123, name: "Tadaki" },
      { id: 560110, name: "Takalgaon" },
      { id: 560136, name: "Takali Bardapur" },
      { id: 560107, name: "Takali Shiradhon" },
      { id: 560112, name: "Tandulja" },
      { id: 560140, name: "Tandulwadi" },
      { id: 560199, name: "Umarga" },
      { id: 560153, name: "Uti Kh." },
      { id: 560090, name: "Wadiwagholi" },
      { id: 560092, name: "Wagholi" },
      { id: 560121, name: "Wakadi" },
      { id: 560114, name: "Wanjarkheda" },
      { id: 560162, name: "Warwanti" },
      { id: 560171, name: "Wasangaon" },
      { id: 560129, name: "Yeli" },
    ],
    4227: [
      { id: 560229, name: "Andalgaon" },
      { id: 560238, name: "Arajkheda" },
      { id: 560283, name: "Asrachiwadi" },
      { id: 560233, name: "Bawchi" },
      { id: 560253, name: "Bhandarwadi" },
      { id: 560215, name: "Bhokaramba" },
      { id: 560255, name: "Bitargaon" },
      { id: 560211, name: "Chadgaon" },
      { id: 560236, name: "Darjiborgaon" },
      { id: 560223, name: "Dawangaon" },
      { id: 560289, name: "Dhaweli" },
      { id: 560218, name: "Dighol Deshmukh" },
      { id: 560219, name: "Dighol Deshpande" },
      { id: 560276, name: "Divegaon" },
      { id: 560243, name: "Faradpur" },
      { id: 560239, name: "Garsuli" },
      { id: 560264, name: "Gavhan" },
      { id: 560259, name: "Ghansargaon" },
      { id: 560278, name: "Godhala" },
      { id: 560266, name: "Harwadi" },
      { id: 560237, name: "Indarthana" },
      { id: 560221, name: "Itti" },
      { id: 560267, name: "Jawalga" },
      { id: 560245, name: "Kamkheda" },
      { id: 560284, name: "Karepur" },
      { id: 560281, name: "Khalangri" },
      { id: 560222, name: "Khanapur" },
      { id: 560269, name: "Kharola" },
      { id: 560234, name: "Kolgaon" },
      { id: 560274, name: "Koshtgaon" },
      { id: 560224, name: "Kumbhari" },
      { id: 560275, name: "Lahanewadi" },
      { id: 560213, name: "Lakhamapur" },
      { id: 560277, name: "Makegaon" },
      { id: 560251, name: "Manusmarwadi" },
      { id: 560287, name: "Mohgaon (Talni)" },
      { id: 560212, name: "Morwad" },
      { id: 560216, name: "Motegaon" },
      { id: 560260, name: "Murdhav" },
      { id: 560249, name: "Muslewadi" },
      { id: 560225, name: "Nagapur" },
      { id: 560250, name: "Narvatwadi" },
      { id: 560232, name: "Niwada" },
      { id: 560214, name: "Palsi" },
      { id: 560247, name: "Pangaon" },
      { id: 560252, name: "Patharwadi" },
      { id: 560248, name: "Phawdewadi" },
      { id: 560227, name: "Pohregaon" },
      { id: 560270, name: "Ramwadi" },
      { id: 560262, name: "Renapur" },
      { id: 944216, name: "Renapur Ek" },
      { id: 560257, name: "Samsapur" },
      { id: 560230, name: "Sangvi" },
      { id: 560282, name: "Sarola" },
      { id: 560279, name: "Saygaon" },
      { id: 560288, name: "Sayyadpur Bk." },
      { id: 560268, name: "Shelu Kh." },
      { id: 560226, name: "Shera" },
      { id: 560231, name: "Sindhgaon" },
      { id: 560273, name: "Sukani" },
      { id: 560256, name: "Sumthana" },
      { id: 560254, name: "Takalgaon" },
      { id: 560286, name: "Talni" },
      { id: 560240, name: "Tattapur" },
      { id: 560280, name: "Vhati" },
      { id: 560241, name: "Wala" },
      { id: 560217, name: "Wangdari" },
      { id: 560285, name: "Yeshwantwadi" },
    ],
    4228: [
      { id: 944217, name: "Ahmadpur" },
      { id: 560390, name: "Ajani Kh" },
      { id: 560392, name: "Ambegaon" },
      { id: 560358, name: "Anandwadi" },
      { id: 560297, name: "Andhori." },
      { id: 560409, name: "Babaldara" },
      { id: 560382, name: "Belur" },
      { id: 560371, name: "Bhutekarwadi" },
      { id: 560393, name: "Bodka" },
      { id: 560330, name: "Borgaon Kh." },
      { id: 560367, name: "Brahmapuri" },
      { id: 560351, name: "Brahmawadi" },
      { id: 560298, name: "Chikhali" },
      { id: 560346, name: "Chilka" },
      { id: 560396, name: "Chobali" },
      { id: 560300, name: "Dagadwadi" },
      { id: 560290, name: "Devkara" },
      { id: 560327, name: "Dhalegaon" },
      { id: 560310, name: "Dhanora Bk." },
      { id: 560402, name: "Dhanora Kh." },
      { id: 560317, name: "Dhaswadi" },
      { id: 560385, name: "Fattepur" },
      { id: 560398, name: "Gadewadi" },
      { id: 560325, name: "Gangahipparga" },
      { id: 560369, name: "Gothala" },
      { id: 560343, name: "Gugdal" },
      { id: 560302, name: "Gunjoti" },
      { id: 909996, name: "Guttewadi" },
      { id: 560407, name: "Hadolti" },
      { id: 560342, name: "Hagdal" },
      { id: 560363, name: "Halni." },
      { id: 560406, name: "Hangarga" },
      { id: 560372, name: "Hasarni" },
      { id: 560291, name: "Hingangaon" },
      { id: 560379, name: "Hippalgaon" },
      { id: 560312, name: "Hipparga (Kopdev)" },
      { id: 560361, name: "Hipparga Kajal" },
      { id: 560373, name: "Jamb" },
      { id: 560376, name: "Jawalga" },
      { id: 560357, name: "Kalegaon" },
      { id: 560411, name: "Kaudgaon" },
      { id: 560305, name: "Kendrewadi" },
      { id: 560303, name: "Khanapur" },
      { id: 560318, name: "Khandali" },
      { id: 560399, name: "Kharabwadi" },
      { id: 560299, name: "Kingaon" },
      { id: 560404, name: "Kini Kadu" },
      { id: 560375, name: "Kokanga" },
      { id: 560293, name: "Kolwadi" },
      { id: 560304, name: "Kopra" },
      { id: 560410, name: "Kumtha (Bk)" },
      { id: 560360, name: "Lanji" },
      { id: 560328, name: "Lendegaon" },
      { id: 560383, name: "Lingdal" },
      { id: 560381, name: "Mahadeowadi" },
      { id: 560400, name: "Makani" },
      { id: 560364, name: "Malegaon Kh." },
      { id: 560378, name: "Mandni" },
      { id: 560353, name: "Mangdari" },
      { id: 560309, name: "Mankhed" },
      { id: 560349, name: "Marshiwani Tanda" },
      { id: 560344, name: "Mawalgaon" },
      { id: 560384, name: "Methi" },
      { id: 560355, name: "Mogha" },
      { id: 560301, name: "Mohgaon" },
      { id: 560292, name: "Molwan" },
      { id: 560397, name: "Morewadi" },
      { id: 560386, name: "Mulki" },
      { id: 560316, name: "Nagthana" },
      { id: 560319, name: "Nagzari" },
      { id: 560370, name: "Nandura Bk." },
      { id: 560366, name: "Nandura Kh." },
      { id: 560296, name: "Narwatwadi" },
      { id: 560331, name: "Par" },
      { id: 560314, name: "Parchanda" },
      { id: 560313, name: "Patoda" },
      { id: 560322, name: "Ralga" },
      { id: 560337, name: "Rudhda" },
      { id: 560323, name: "Rui" },
      { id: 560389, name: "Salgara" },
      { id: 560324, name: "Sangvi (Sunegaon)" },
      { id: 560311, name: "Satala" },
      { id: 560368, name: "Sawargaon Rokda" },
      { id: 560405, name: "Sawargaon Thot" },
      { id: 560394, name: "Sayyadpur (Kh)" },
      { id: 560347, name: "Senkud" },
      { id: 560335, name: "Shendri" },
      { id: 560348, name: "Shenni" },
      { id: 560391, name: "Shirur Tajband" },
      { id: 560412, name: "Shivankhed (Kh)" },
      { id: 560354, name: "Sindgi Bk." },
      { id: 560352, name: "Sindgi Kh." },
      { id: 560306, name: "Sonkhed" },
      { id: 560345, name: "Sora" },
      { id: 560334, name: "Sumthana" },
      { id: 560338, name: "Sunegaon (Sangvi)" },
      { id: 560336, name: "Sunegaon (Shendri)" },
      { id: 560315, name: "Takalgaon (Kamkhed)" },
      { id: 560333, name: "Takalgaon (Senkud)" },
      { id: 560365, name: "Talegaon" },
      { id: 560359, name: "Tambat Sangvi" },
      { id: 560388, name: "Telgaon" },
      { id: 560356, name: "Tembhurni" },
      { id: 560350, name: "Thodga" },
      { id: 560377, name: "Thorlewadi" },
      { id: 560403, name: "Tirth" },
      { id: 560362, name: "Ugilewadi" },
      { id: 560320, name: "Ujana" },
      { id: 560387, name: "Umarga Kort" },
      { id: 560401, name: "Umarga Yelladevi" },
      { id: 560374, name: "Unni" },
      { id: 560308, name: "Vhatala" },
      { id: 560307, name: "Vilegaon" },
      { id: 560321, name: "Wadarwadi" },
      { id: 560395, name: "Waigaon" },
      { id: 560329, name: "Wairagadh" },
      { id: 560380, name: "Walsangi" },
      { id: 560326, name: "Wanjarwadi" },
      { id: 560341, name: "Warwanti" },
      { id: 560295, name: "Yeldarwadi" },
      { id: 560332, name: "Yestar" },
    ],
    4229: [
      { id: 560448, name: "Atnoor" },
      { id: 560454, name: "Belsangvi" },
      { id: 560458, name: "Borgaon Kh." },
      { id: 560420, name: "Chera" },
      { id: 560447, name: "Chincholi" },
      { id: 560424, name: "Dhamangaon" },
      { id: 560445, name: "Dhondwadi (Ghonsi)" },
      { id: 560428, name: "Dhorsangvi" },
      { id: 560423, name: "Domgaon" },
      { id: 560442, name: "Dongargaon" },
      { id: 560459, name: "Ekurga Kh." },
      { id: 560449, name: "Gawhan" },
      { id: 560444, name: "Ghonsi" },
      { id: 560452, name: "Gutti" },
      { id: 560439, name: "Haladwadhavana" },
      { id: 560426, name: "Hawarga" },
      { id: 560416, name: "Hokarna" },
      { id: 560422, name: "Jagalpur Bk." },
      { id: 560431, name: "Jalkot" },
      { id: 560425, name: "Jirga" },
      { id: 560433, name: "Karanji" },
      { id: 560418, name: "Kekatsindagi" },
      { id: 560436, name: "Kolnoor" },
      { id: 560457, name: "Konali Dongar" },
      { id: 560430, name: "Kunki" },
      { id: 560434, name: "Lali Bk." },
      { id: 560455, name: "Lali Kh." },
      { id: 560438, name: "Malhipparga" },
      { id: 560456, name: "Mangrul" },
      { id: 560441, name: "Marsangvi" },
      { id: 560450, name: "Mewapur" },
      { id: 560432, name: "Patoda Bk." },
      { id: 560437, name: "Patoda Kh." },
      { id: 560440, name: "Rawankola" },
      { id: 560413, name: "Sheldara" },
      { id: 560435, name: "Sonwala" },
      { id: 560414, name: "Sorga" },
      { id: 560446, name: "Sulhali" },
      { id: 560443, name: "Tiruka" },
      { id: 560417, name: "Umardara" },
      { id: 560421, name: "Umarga Retu" },
      { id: 560429, name: "Viral" },
      { id: 560415, name: "Wadgaon" },
      { id: 560419, name: "Wanjarwada" },
      { id: 560427, name: "Yeldara" },
      { id: 560453, name: "Yeori" },
    ],
    4230: [
      { id: 560526, name: "Ajansonda Kh." },
      { id: 560508, name: "Algarwadi" },
      { id: 560520, name: "Ambulga" },
      { id: 560488, name: "Anandwadi" },
      { id: 560494, name: "Anjansoda Bk." },
      { id: 560518, name: "Ashta" },
      { id: 560527, name: "Atola" },
      { id: 560524, name: "Bansawargaon" },
      { id: 560536, name: "Basawnal" },
      { id: 560535, name: "Bawalgaon" },
      { id: 560466, name: "Belgaon" },
      { id: 560525, name: "Bhatsangvi" },
      { id: 560537, name: "Bolegaon Kh." },
      { id: 560504, name: "Borgaon Bk." },
      { id: 560512, name: "Bothi" },
      { id: 560471, name: "Bramhawadi" },
      { id: 560510, name: "Chakur" },
      { id: 560492, name: "Chapoli" },
      { id: 560476, name: "Dapkyal" },
      { id: 560540, name: "Devangra" },
      { id: 560541, name: "Devangrawadi" },
      { id: 560531, name: "Dongraj" },
      { id: 560481, name: "Ganjur" },
      { id: 560482, name: "Ganjurwadi" },
      { id: 560485, name: "Gharni" },
      { id: 560484, name: "Gharola" },
      { id: 560464, name: "Hadoli" },
      { id: 560473, name: "Hali Kh" },
      { id: 560486, name: "Hanmant Jawalga" },
      { id: 560509, name: "Hanmantwadi" },
      { id: 560497, name: "Hatkarwadi 1" },
      { id: 560521, name: "Hatkarwadi 2" },
      { id: 560487, name: "Hipalner" },
      { id: 560465, name: "Jadhala" },
      { id: 560479, name: "Jagalpur" },
      { id: 560470, name: "Janwal" },
      { id: 560534, name: "Kabansangvi" },
      { id: 560474, name: "Kadmuli" },
      { id: 560505, name: "Kalkoti" },
      { id: 560478, name: "Kawathali" },
      { id: 560462, name: "Kendrewadi" },
      { id: 560522, name: "Latur Road" },
      { id: 560539, name: "Limbalwadi" },
      { id: 560463, name: "Mahalangi" },
      { id: 560517, name: "Mahalangra" },
      { id: 560542, name: "Mahalangrawadi" },
      { id: 560529, name: "Mahandol" },
      { id: 560513, name: "Mandurki" },
      { id: 560506, name: "Mashanerwadi" },
      { id: 560519, name: "Mohadal" },
      { id: 560523, name: "Mohanal" },
      { id: 560544, name: "Murambi" },
      { id: 560496, name: "Nagadarwadi" },
      { id: 560528, name: "Nageshwadi" },
      { id: 560489, name: "Naigaon" },
      { id: 560538, name: "Nalegaon" },
      { id: 560483, name: "Nandgaon" },
      { id: 560502, name: "Rachannawadi" },
      { id: 560461, name: "Raiwadi" },
      { id: 560460, name: "Rajewadi" },
      { id: 560469, name: "Ramwadi" },
      { id: 560532, name: "Rohina" },
      { id: 560530, name: "Sandol" },
      { id: 560490, name: "Saranwadi" },
      { id: 560499, name: "Shelgaon" },
      { id: 560507, name: "Shirnal" },
      { id: 560477, name: "Shiwani Majra" },
      { id: 560480, name: "Shiwankheda Bk." },
      { id: 560543, name: "Sugaon" },
      { id: 560503, name: "Takalgaon (Shelgaon)" },
      { id: 560514, name: "Talghal" },
      { id: 560511, name: "Tirthwadi" },
      { id: 560515, name: "Tiwatghal" },
      { id: 560516, name: "Tiwghal" },
      { id: 560533, name: "Ujalamb" },
      { id: 560491, name: "Vhonali" },
      { id: 560498, name: "Wadgaon" },
      { id: 560475, name: "Wadwal Nagnath" },
      { id: 560472, name: "Wagholi" },
      { id: 560467, name: "Zari Bk" },
      { id: 560468, name: "Zari Kh." },
    ],
    4231: [
      { id: 560571, name: "Aari" },
      { id: 560584, name: "Ajani Bk." },
      { id: 560563, name: "Anandwadi" },
      { id: 560589, name: "Ankulga (Rani)" },
      { id: 560581, name: "Ankulga (Syed)" },
      { id: 560590, name: "Bakali" },
      { id: 560578, name: "Bevanal" },
      { id: 560579, name: "Bevanalwadi" },
      { id: 560582, name: "Bhingoli" },
      { id: 560591, name: "Bibral" },
      { id: 560550, name: "Bolegaon Bk." },
      { id: 560551, name: "Chabharga" },
      { id: 560555, name: "Daithana" },
      { id: 560548, name: "Dhamangaon" },
      { id: 560553, name: "Dighol" },
      { id: 560580, name: "Dongargaon (Bori)" },
      { id: 560575, name: "Fakranpur" },
      { id: 560569, name: "Ganeshwadi" },
      { id: 560587, name: "Ghugi (Sangvi)" },
      { id: 560574, name: "Halki" },
      { id: 560546, name: "Hippalgaon" },
      { id: 560592, name: "Hisamabad" },
      { id: 560585, name: "Honmal" },
      { id: 560564, name: "Jogal" },
      { id: 560583, name: "Kalamgaon" },
      { id: 560570, name: "Kambalga" },
      { id: 560557, name: "Kanegaon" },
      { id: 560549, name: "Karewadi" },
      { id: 560565, name: "Lakkadjawalga" },
      { id: 560561, name: "Nagewadi" },
      { id: 560560, name: "Pandharwadi" },
      { id: 560567, name: "Rapka" },
      { id: 560559, name: "Sakol" },
      { id: 560588, name: "Sangvi (Ghugi)" },
      { id: 560572, name: "Sarpharajpur" },
      { id: 560545, name: "Sawargaon" },
      { id: 560556, name: "Shend (Daithana)" },
      { id: 560562, name: "Shirur Anantpal" },
      { id: 560547, name: "Shivpur" },
      { id: 560554, name: "Sumthana" },
      { id: 560586, name: "Talegaon (De)" },
      { id: 560573, name: "Talegaon Bori" },
      { id: 560568, name: "Thergaon" },
      { id: 560558, name: "Tipral" },
      { id: 560566, name: "Turukwadi" },
      { id: 560577, name: "Umardara" },
      { id: 560576, name: "Wanjarkheda" },
      { id: 560552, name: "Yerol" },
    ],
    4232: [
      { id: 560620, name: "Almala" },
      { id: 560666, name: "Anandwadi" },
      { id: 560606, name: "Andhora" },
      { id: 560657, name: "Apchunda" },
      { id: 560694, name: "Ashiv" },
      { id: 560641, name: "Ausa" },
      { id: 560702, name: "Banegaon" },
      { id: 560602, name: "Barhanpur" },
      { id: 560680, name: "Belkund" },
      { id: 560603, name: "Bhada" },
      { id: 560654, name: "Bhangewadi" },
      { id: 560593, name: "Bheta" },
      { id: 560628, name: "Bhusani" },
      { id: 560618, name: "Birawali" },
      { id: 560604, name: "Borgaon" },
      { id: 560642, name: "Borphal" },
      { id: 560622, name: "Budhoda" },
      { id: 560659, name: "Chalburga" },
      { id: 560704, name: "Chincholi Jo" },
      { id: 560690, name: "Chincholi Kajale" },
      { id: 560681, name: "Chincholi Son" },
      { id: 560685, name: "Dapegaon" },
      { id: 560671, name: "Dautpur" },
      { id: 910000, name: "Devtala Vasantnagar" },
      { id: 560655, name: "Dewanga" },
      { id: 560627, name: "Dhanora" },
      { id: 560644, name: "Fattepur" },
      { id: 560672, name: "Gadhawewadi" },
      { id: 560716, name: "Ganjankheda" },
      { id: 560633, name: "Gondri" },
      { id: 560703, name: "Gotewadi" },
      { id: 560715, name: "Gubal" },
      { id: 560679, name: "Gulkheda" },
      { id: 560601, name: "Haldurg" },
      { id: 560701, name: "Haregaon" },
      { id: 560623, name: "Hasala" },
      { id: 560713, name: "Hasalgan" },
      { id: 560634, name: "Hasegaon" },
      { id: 560649, name: "Hasegaonwadi" },
      { id: 560676, name: "Hatkarwadi" },
      { id: 560688, name: "Hipparga" },
      { id: 560626, name: "Hipparsoga" },
      { id: 560631, name: "Holi" },
      { id: 560652, name: "Jainagar" },
      { id: 560625, name: "Jamalpur" },
      { id: 560673, name: "Jawalga Pomadevi" },
      { id: 560661, name: "Jawli" },
      { id: 560607, name: "Jayphal" },
      { id: 560596, name: "Kalmata" },
      { id: 561629, name: "Kamalpur" },
      { id: 560651, name: "Kanheri" },
      { id: 560645, name: "Karajgaon" },
      { id: 560708, name: "Karla" },
      { id: 560696, name: "Kawali" },
      { id: 560595, name: "Kawtha Kej" },
      { id: 560632, name: "Kawtha Latur" },
      { id: 560640, name: "Khanapur" },
      { id: 560664, name: "Kharosa" },
      { id: 560635, name: "Khuntegaon" },
      { id: 560639, name: "Khurdwadi" },
      { id: 560719, name: "Killari" },
      { id: 560721, name: "Killariwadi" },
      { id: 560662, name: "Kininawre" },
      { id: 560653, name: "Kinithot" },
      { id: 560611, name: "Korangala" },
      { id: 560707, name: "Kumtha" },
      { id: 560598, name: "Lakhangaon" },
      { id: 560675, name: "Lamjana" },
      { id: 560711, name: "Limbala Dau" },
      { id: 560650, name: "Lodga" },
      { id: 560698, name: "Lohta" },
      { id: 944215, name: "Mahadevwadi" },
      { id: 560699, name: "Malkondji" },
      { id: 560687, name: "Malumbra" },
      { id: 560722, name: "Mangrul" },
      { id: 944214, name: "Masalga Bu" },
      { id: 560686, name: "Masalga Kh." },
      { id: 560678, name: "Masurdi" },
      { id: 560697, name: "Matola" },
      { id: 560706, name: "Mogarga" },
      { id: 560660, name: "Mugalewadi" },
      { id: 560684, name: "Nagarsoga" },
      { id: 560594, name: "Naholi" },
      { id: 560712, name: "Nandurga" },
      { id: 560709, name: "Pardhewadi" },
      { id: 560643, name: "Pirmagajwadi" },
      { id: 560669, name: "Rajewadi" },
      { id: 560663, name: "Ramegaon" },
      { id: 560705, name: "Ramwadi" },
      { id: 560617, name: "Ringani" },
      { id: 560612, name: "Samdarga" },
      { id: 560700, name: "Sankral" },
      { id: 560714, name: "Sarni" },
      { id: 560648, name: "Sarola" },
      { id: 560599, name: "Satdharwadi" },
      { id: 560600, name: "Sattardharwadi Laman Tanda" },
      { id: 560636, name: "Selu" },
      { id: 560624, name: "Shindala Jahagir" },
      { id: 560615, name: "Shindala Lohara" },
      { id: 560613, name: "Shindalwadi" },
      { id: 560629, name: "Shivani Bk." },
      { id: 560667, name: "Shivani Lakh" },
      { id: 560608, name: "Shivli" },
      { id: 560710, name: "Sirsal" },
      { id: 560619, name: "Taka" },
      { id: 560717, name: "Talani" },
      { id: 560668, name: "Tambarwadi" },
      { id: 560674, name: "Tapsechincholi" },
      { id: 560689, name: "Tavshitad" },
      { id: 560630, name: "Tondoli" },
      { id: 560682, name: "Tungi Bk." },
      { id: 560683, name: "Tungi Kh." },
      { id: 560693, name: "Ujani" },
      { id: 560621, name: "Umbadga Bk." },
      { id: 560637, name: "Umbadga Kh." },
      { id: 560597, name: "Uti Bk." },
      { id: 560670, name: "Utka" },
      { id: 560605, name: "Wadji" },
      { id: 560658, name: "Wagholi" },
      { id: 560638, name: "Wangajewadi" },
      { id: 560695, name: "Wangji" },
      { id: 560614, name: "Wanwada" },
      { id: 560609, name: "Warwada" },
      { id: 560646, name: "Yakatpur" },
      { id: 560692, name: "Yekambi" },
      { id: 560691, name: "Yekambi Laman Tanda" },
      { id: 560677, name: "Yekambiwadi" },
      { id: 560718, name: "Yelavat" },
      { id: 560656, name: "Yeli" },
      { id: 560616, name: "Yelori" },
      { id: 560610, name: "Yeloriwadi" },
      { id: 560647, name: "Yerandi" },
    ],
    4233: [
      { id: 560787, name: "Ambewadi Ambulga Bk." },
      { id: 560741, name: "Ambewadi Masalga" },
      { id: 560839, name: "Ambulga (V)" },
      { id: 560792, name: "Ambulga Bk." },
      { id: 560742, name: "Ambulga Men" },
      { id: 560728, name: "Anandwadi" },
      { id: 560838, name: "Anandwadi (A.V.)" },
      { id: 560732, name: "Anandwadi (Gaur)" },
      { id: 560836, name: "Anandwadi (Ha.)" },
      { id: 560824, name: "Anandwadi (Je.)" },
      { id: 560745, name: "Anandwadi (S.K.)" },
      { id: 560788, name: "Anandwadi Ambulga Bk." },
      { id: 560767, name: "Ansarwada" },
      { id: 560878, name: "Aundha" },
      { id: 560812, name: "Aurad Shahajani" },
      { id: 944252, name: "Aurangpura" },
      { id: 560877, name: "Badur" },
      { id: 560832, name: "Bamni" },
      { id: 560845, name: "Barmachiwadi" },
      { id: 560780, name: "Baspur" },
      { id: 560802, name: "Bendga" },
      { id: 560846, name: "Bhutmugli" },
      { id: 560849, name: "Bolegaon Kh." },
      { id: 560816, name: "Borsuri" },
      { id: 560797, name: "Botkul" },
      { id: 560753, name: "Bujrugwadi" },
      { id: 560865, name: "Chandori" },
      { id: 560866, name: "Chandoriwadi" },
      { id: 560813, name: "Channachiwadi" },
      { id: 560795, name: "Chichondi" },
      { id: 560873, name: "Chilwantwadi" },
      { id: 560843, name: "Chincholi (Bhangar)" },
      { id: 560850, name: "Chincholi (S)" },
      { id: 560765, name: "Dadgi" },
      { id: 560729, name: "Dagadwadi" },
      { id: 560725, name: "Dangewadi" },
      { id: 560760, name: "Dapka" },
      { id: 560833, name: "Dhanora" },
      { id: 560723, name: "Dhobalewadi" },
      { id: 560858, name: "Dongargaon [Ha.]" },
      { id: 560773, name: "Dukrewadi" },
      { id: 560807, name: "Fattewadi" },
      { id: 560731, name: "Gaur" },
      { id: 560783, name: "Girakchal" },
      { id: 560776, name: "Govindnagarwadi" },
      { id: 560744, name: "Gunewadi" },
      { id: 560801, name: "Gunjarga" },
      { id: 560758, name: "Gurhal" },
      { id: 560751, name: "Hadga" },
      { id: 560837, name: "Hadoli" },
      { id: 560799, name: "Hagranga" },
      { id: 560847, name: "Haidarwadi" },
      { id: 560808, name: "Halgara" },
      { id: 560883, name: "Hallali" },
      { id: 560856, name: "Halsi (Hattarga)" },
      { id: 560810, name: "Halsi Tugaon" },
      { id: 560790, name: "Hanchnal" },
      { id: 560857, name: "Handral" },
      { id: 560793, name: "Hanmantwadi" },
      { id: 560840, name: "Hanmantwadi (Hadoli)" },
      { id: 560798, name: "Hanmantwadi Halgara" },
      { id: 560841, name: "Hanmantwadi [A.V.]" },
      { id: 560740, name: "Hanmantwadi [Mugaon]" },
      { id: 560851, name: "Harijawalga" },
      { id: 560854, name: "Hasori Bk." },
      { id: 560853, name: "Hasori Kh." },
      { id: 560860, name: "Hattarga [Halsi]" },
      { id: 560796, name: "Hosur" },
      { id: 560756, name: "Jajnur" },
      { id: 560803, name: "Jamga" },
      { id: 560726, name: "Jau" },
      { id: 945590, name: "Jauwadi" },
      { id: 560823, name: "Jewari" },
      { id: 560736, name: "Jyotwadi" },
      { id: 560778, name: "Kalandi" },
      { id: 560868, name: "Kalmugali" },
      { id: 560771, name: "Kamshetwadi" },
      { id: 560777, name: "Kanshetwadi" },
      { id: 560876, name: "Kasar Balkunda" },
      { id: 560861, name: "Kasarshirshi" },
      { id: 560785, name: "Katejawalga" },
      { id: 560786, name: "Kedarpur" },
      { id: 560754, name: "Kelgaon" },
      { id: 560779, name: "Khadak Umarga" },
      { id: 560829, name: "Kokalgaon" },
      { id: 560880, name: "Korali" },
      { id: 560805, name: "Koyachiwadi" },
      { id: 560759, name: "Lambota" },
      { id: 560842, name: "Limbala" },
      { id: 560724, name: "Macharatwadi" },
      { id: 560835, name: "Madansuri" },
      { id: 560770, name: "Makni" },
      { id: 560869, name: "Malegaon (Kalyani)" },
      { id: 560821, name: "Malegaon [Je]" },
      { id: 560775, name: "Malradwadi" },
      { id: 560884, name: "Mamdapur" },
      { id: 560818, name: "Mane Jawalga" },
      { id: 560772, name: "Mangalwedwadi" },
      { id: 560763, name: "Mannathpur" },
      { id: 560735, name: "Masalga" },
      { id: 560769, name: "Masobachiwadi" },
      { id: 560882, name: "Mirganhali" },
      { id: 560761, name: "Mubarakpur" },
      { id: 560827, name: "Mudgad [Ekoji]" },
      { id: 560737, name: "Mugaon" },
      { id: 560826, name: "Nadi Hattarga" },
      { id: 560791, name: "Nadiwadi" },
      { id: 560727, name: "Nanand" },
      { id: 560881, name: "Nelwad" },
      { id: 560762, name: "Nilanga Rural" },
      { id: 560848, name: "Nilkanthwadi" },
      { id: 560774, name: "Nitur" },
      { id: 560764, name: "Palapur" },
      { id: 560730, name: "Panchincholi" },
      { id: 944253, name: "Peth Mahbubganj" },
      { id: 560831, name: "Pimpalwadi [Je]" },
      { id: 560875, name: "Pirupatelwadi" },
      { id: 560794, name: "Pirwadi" },
      { id: 560806, name: "Rajewadi" },
      { id: 560859, name: "Ramling Mudgad" },
      { id: 560830, name: "Ramtirth" },
      { id: 560752, name: "Rathoda" },
      { id: 560852, name: "Sabitwadi" },
      { id: 560804, name: "Sangareddiwadi" },
      { id: 560825, name: "Sangvi [Je]" },
      { id: 560872, name: "Sardarwadi" },
      { id: 560828, name: "Sarwadi" },
      { id: 560757, name: "Sawangira" },
      { id: 560814, name: "Sawari" },
      { id: 560747, name: "Shedol" },
      { id: 560819, name: "Shelgi" },
      { id: 560738, name: "Shend" },
      { id: 560879, name: "Shiradhon" },
      { id: 560782, name: "Shirol" },
      { id: 560789, name: "Shiur" },
      { id: 560743, name: "Shivani (Ko)" },
      { id: 560766, name: "Sindhkhed" },
      { id: 560749, name: "Sindijawalga" },
      { id: 560822, name: "Singnal" },
      { id: 560800, name: "Sirasi Hangarga" },
      { id: 560734, name: "Sonesangvi" },
      { id: 560815, name: "Sonkhed" },
      { id: 560820, name: "Tadmugli" },
      { id: 560811, name: "Tagarkheda" },
      { id: 560739, name: "Tajpur" },
      { id: 560867, name: "Takli" },
      { id: 560768, name: "Talikhed" },
      { id: 560871, name: "Tambala" },
      { id: 560870, name: "Tambalwadi" },
      { id: 560809, name: "Tambarwadi" },
      { id: 560733, name: "Tupdi" },
      { id: 560750, name: "Umarga [Hadga]" },
      { id: 560863, name: "Usturi" },
      { id: 560748, name: "Wadgaon" },
      { id: 560746, name: "Wadi (Shedol)" },
      { id: 560855, name: "Wadi Hasori" },
      { id: 560862, name: "Wadikasar Shirshi" },
      { id: 560864, name: "Waksa" },
      { id: 560784, name: "Walsangvi" },
      { id: 560781, name: "Wanjarwada" },
      { id: 560834, name: "Yelamwadi" },
      { id: 560844, name: "Yelnur" },
      { id: 560755, name: "Zari" },
    ],
    4234: [
      { id: 560920, name: "Achwala" },
      { id: 560925, name: "Ajani" },
      { id: 560909, name: "Ambanagar" },
      { id: 560930, name: "Ambegaon" },
      { id: 560910, name: "Anandwadi" },
      { id: 560902, name: "Anantwadi" },
      { id: 560938, name: "Batanpur" },
      { id: 560914, name: "Bhopani" },
      { id: 560932, name: "Bolegaon" },
      { id: 560903, name: "Bombali Bk." },
      { id: 560906, name: "Bombli Kh" },
      { id: 560928, name: "Borol" },
      { id: 560891, name: "Chawanhipparga" },
      { id: 560894, name: "Darewadi" },
      { id: 560908, name: "Dawanhipparga" },
      { id: 560922, name: "Deoni Bk." },
      { id: 560929, name: "Devani Kh" },
      { id: 560904, name: "Dhanegaon" },
      { id: 560886, name: "Dharmapuri" },
      { id: 560936, name: "Gaundgaon" },
      { id: 560887, name: "Gurdhal (Her)" },
      { id: 560934, name: "Gurnal" },
      { id: 560923, name: "Hanchanal" },
      { id: 560901, name: "Helamb" },
      { id: 560900, name: "Hisamnagar" },
      { id: 560916, name: "Honali" },
      { id: 560933, name: "Indral" },
      { id: 560896, name: "Ismailwadi" },
      { id: 560898, name: "Jawalga" },
      { id: 560918, name: "Kamalwadi" },
      { id: 560888, name: "Kamaroddinpur" },
      { id: 560893, name: "Kawathala" },
      { id: 560912, name: "Konali (N)" },
      { id: 560937, name: "Lasona" },
      { id: 560907, name: "Mahadevwadi" },
      { id: 560885, name: "Mamdapur" },
      { id: 560913, name: "Manki" },
      { id: 560911, name: "Nagral" },
      { id: 560890, name: "Nagtirthawadi" },
      { id: 560919, name: "Neknal" },
      { id: 560924, name: "Sangam" },
      { id: 560915, name: "Sawargaon" },
      { id: 560892, name: "Sayyadpur" },
      { id: 560927, name: "Shivajinagar Tanda" },
      { id: 560935, name: "Sindhikamth" },
      { id: 560905, name: "Takali (Walandi)" },
      { id: 560889, name: "Talegaon (Bhogeshwar)" },
      { id: 560921, name: "Vilegaon" },
      { id: 560931, name: "Wadmurambi" },
      { id: 560926, name: "Wagadari [Walandi]" },
      { id: 560895, name: "Walandi" },
    ],
    4235: [
      { id: 560961, name: "Adolwadi" },
      { id: 560944, name: "Anapwadi" },
      { id: 560941, name: "Arasnal" },
      { id: 561008, name: "Avalkonda" },
      { id: 561030, name: "Bamni" },
      { id: 561021, name: "Banshelki" },
      { id: 561033, name: "Belsakarga" },
      { id: 560996, name: "Bhakaskheda" },
      { id: 560985, name: "Borgaon Bk." },
      { id: 561011, name: "Bortaltanda" },
      { id: 560990, name: "Chandegaon" },
      { id: 561002, name: "Chighali" },
      { id: 560955, name: "Chimachiwadi" },
      { id: 560978, name: "Choundi" },
      { id: 560964, name: "Dangewadi" },
      { id: 560968, name: "Davul" },
      { id: 561000, name: "Dawangaon" },
      { id: 560977, name: "Deulwadi" },
      { id: 561003, name: "Dewarjan" },
      { id: 560984, name: "Dhadaknal" },
      { id: 561034, name: "Dhondi Hipparga" },
      { id: 560939, name: "Dhotarwadi" },
      { id: 560991, name: "Digras" },
      { id: 560971, name: "Dongarshelki" },
      { id: 560966, name: "Ekurka Road" },
      { id: 560995, name: "Gangapur" },
      { id: 560973, name: "Gudsur" },
      { id: 561025, name: "Gurdhal (Udgir)" },
      { id: 560998, name: "Haibatpur" },
      { id: 561006, name: "Haknakwadi" },
      { id: 560957, name: "Halli" },
      { id: 560960, name: "Handarguli" },
      { id: 560947, name: "Hangarga Kudar" },
      { id: 561004, name: "Hanmantwadi" },
      { id: 560951, name: "Her" },
      { id: 560969, name: "Hipparga (Davul)" },
      { id: 560945, name: "Honi Hipparga" },
      { id: 560948, name: "Ismalpur" },
      { id: 561023, name: "Jaknal" },
      { id: 561027, name: "Janapur" },
      { id: 560970, name: "Kallur" },
      { id: 560953, name: "Karadkhel" },
      { id: 561001, name: "Karkheli" },
      { id: 561005, name: "Karwandi" },
      { id: 560982, name: "Kasral" },
      { id: 561018, name: "Kaulkhed" },
      { id: 560967, name: "Kherda Kh." },
      { id: 560942, name: "Kini Yalladevi" },
      { id: 560979, name: "Kodali" },
      { id: 560946, name: "Kshetraphal" },
      { id: 560940, name: "Kumdal Her" },
      { id: 560988, name: "Kumdal Udgir" },
      { id: 560950, name: "Kumtha Kh." },
      { id: 560987, name: "Limbgaon" },
      { id: 560997, name: "Lohara" },
      { id: 561014, name: "Loni" },
      { id: 561020, name: "Madlapur" },
      { id: 560994, name: "Mahadevwadi" },
      { id: 561019, name: "Malewadi" },
      { id: 561015, name: "Malkapur" },
      { id: 560989, name: "Mallapur" },
      { id: 560980, name: "Manjari" },
      { id: 561017, name: "Maroti Tanda" },
      { id: 561029, name: "Mogha" },
      { id: 560956, name: "Mortalwadi" },
      { id: 560976, name: "Muttalgaon" },
      { id: 561010, name: "Nagalgaon" },
      { id: 560975, name: "Nalgir" },
      { id: 560972, name: "Nawandi" },
      { id: 561022, name: "Netragaon" },
      { id: 561037, name: "Nideban" },
      { id: 561007, name: "Pimpri" },
      { id: 561036, name: "Rawangaon" },
      { id: 560958, name: "Rudrawadi" },
      { id: 560992, name: "Satala Bk" },
      { id: 560993, name: "Shambhu Umarga" },
      { id: 560999, name: "Shekapur" },
      { id: 561024, name: "Shelhal" },
      { id: 561026, name: "Shirol" },
      { id: 561009, name: "Somla And Kashiram Tanda" },
      { id: 561013, name: "Somnathpur" },
      { id: 560963, name: "Sukani" },
      { id: 560981, name: "Sumthana" },
      { id: 561035, name: "Tadlapur" },
      { id: 560983, name: "Takali (Udgir)" },
      { id: 561016, name: "Tiwatgyal" },
      { id: 561032, name: "Togari" },
      { id: 560949, name: "Tondar" },
      { id: 561028, name: "Tondchir" },
      { id: 561012, name: "Udgir1 (Westside)" },
      { id: 945591, name: "Udgir2 (Eastside)" },
      { id: 560943, name: "Umarga Manna" },
      { id: 560965, name: "Wadhawana Bk." },
      { id: 560962, name: "Wadhawana Kh." },
      { id: 560986, name: "Wagdari" },
      { id: 560954, name: "Waigaon" },
      { id: 560959, name: "Wanjarwadi" },
      { id: 561031, name: "Yenki" },
    ],
    4236: [
      { id: 561126, name: "Ainapurwadi" },
      { id: 561064, name: "Aleshwar" },
      { id: 561069, name: "Anala" },
      { id: 561115, name: "Andhora" },
      { id: 561114, name: "Andhori" },
      { id: 561129, name: "Arangaon" },
      { id: 561125, name: "Asu" },
      { id: 561097, name: "Awar Pimpri" },
      { id: 561085, name: "Bawachi" },
      { id: 561133, name: "Bhandgaon" },
      { id: 561075, name: "Bhoinja" },
      { id: 561089, name: "Bhotra" },
      { id: 561083, name: "Bodakha" },
      { id: 561123, name: "Brahmagaon" },
      { id: 561057, name: "Chinchpur Bk." },
      { id: 561038, name: "Chinchpur Kh." },
      { id: 561084, name: "Dahitana" },
      { id: 561040, name: "Deogaon Bk." },
      { id: 561094, name: "Deogaon Kh." },
      { id: 561061, name: "Deulgaon" },
      { id: 561095, name: "Dhagpimpri" },
      { id: 561055, name: "Dhotri" },
      { id: 561077, name: "Domgaon" },
      { id: 561066, name: "Donja" },
      { id: 561086, name: "Dudhi" },
      { id: 561116, name: "Gharagaon" },
      { id: 561041, name: "Gosaviwadi" },
      { id: 561063, name: "Gosaviwadi (Donja)" },
      { id: 561120, name: "Hingangaon Bk." },
      { id: 561059, name: "Hingangaon Kh." },
      { id: 561068, name: "Ingoda" },
      { id: 561060, name: "Jagdalwadi" },
      { id: 561039, name: "Jakate Wadi" },
      { id: 561110, name: "Jake Pimpri" },
      { id: 561079, name: "Jamgaon" },
      { id: 561118, name: "Jawala (N.)" },
      { id: 561070, name: "Kandari" },
      { id: 561117, name: "Kangalgaon" },
      { id: 561099, name: "Kapilapuri" },
      { id: 561098, name: "Karanja" },
      { id: 561071, name: "Karla" },
      { id: 561062, name: "Katewadi" },
      { id: 561091, name: "Katrabad" },
      { id: 561073, name: "Kaundgaon" },
      { id: 561080, name: "Khanapur" },
      { id: 561042, name: "Khandeshwar Wadi" },
      { id: 561082, name: "Khasapuri" },
      { id: 561093, name: "Khasgaon" },
      { id: 561054, name: "Kokarwadi" },
      { id: 561052, name: "Kukkadgaon" },
      { id: 561076, name: "Kumbheja" },
      { id: 561109, name: "Kumbhephal" },
      { id: 561128, name: "Lakhi" },
      { id: 561101, name: "Lohara" },
      { id: 561103, name: "Loni" },
      { id: 561053, name: "Malkapur" },
      { id: 561072, name: "Mugaon" },
      { id: 561104, name: "Nalgaon" },
      { id: 561111, name: "Pachpimpla" },
      { id: 561044, name: "Pandharewadi" },
      { id: 561088, name: "Paranda" },
      { id: 561067, name: "Parewadi" },
      { id: 561122, name: "Pimpalwadi" },
      { id: 561081, name: "Pimparkhed" },
      { id: 561108, name: "Pistamwadi" },
      { id: 561090, name: "Pithapuri" },
      { id: 561113, name: "Rajuri" },
      { id: 561051, name: "Ratnapur" },
      { id: 561106, name: "Rohkal" },
      { id: 561078, name: "Rosa" },
      { id: 561087, name: "Rui" },
      { id: 561107, name: "Sakat Bk." },
      { id: 561127, name: "Sakat Kh." },
      { id: 561124, name: "Saranwadi" },
      { id: 561132, name: "Sawadarwadi" },
      { id: 561046, name: "Shelgaon" },
      { id: 561102, name: "Shirala" },
      { id: 561119, name: "Sirsao" },
      { id: 561074, name: "Sonari" },
      { id: 561092, name: "Songiri" },
      { id: 561112, name: "Takali" },
      { id: 561043, name: "Takmodwadi" },
      { id: 561056, name: "Tandul Wadi" },
      { id: 561050, name: "Undegaon" },
      { id: 561130, name: "Wadi Rajuri" },
      { id: 561096, name: "Wadner" },
      { id: 561121, name: "Wakadi" },
      { id: 561105, name: "Wanewadi" },
      { id: 561100, name: "Wangegavhan" },
      { id: 561058, name: "Watephal" },
      { id: 561131, name: "Yenegaon" },
    ],
    4237: [
      { id: 561168, name: "Aliyabadwadi" },
      { id: 561166, name: "Ambi" },
      { id: 561165, name: "Anandwadi" },
      { id: 561138, name: "Andrud" },
      { id: 561227, name: "Anjan Soda" },
      { id: 561169, name: "Antargaon" },
      { id: 561160, name: "Antarwali" },
      { id: 561224, name: "Arsoli" },
      { id: 561174, name: "Ashta" },
      { id: 561176, name: "Ashtewadi" },
      { id: 561152, name: "Bagalwadi (Dimakhwadi)" },
      { id: 561212, name: "Barhanpur" },
      { id: 561184, name: "Bavi" },
      { id: 561154, name: "Bedarwadi" },
      { id: 561202, name: "Belgaon" },
      { id: 561205, name: "Bhawanwadi (Bavi)" },
      { id: 561189, name: "Bhawanwadi (Sukata)" },
      { id: 561214, name: "Bhogalgaon" },
      { id: 561218, name: "Bhongiri" },
      { id: 561219, name: "Bhum(Rural)" },
      { id: 561164, name: "Birobachiwadi" },
      { id: 561228, name: "Chandwad" },
      { id: 561217, name: "Chincholi" },
      { id: 561198, name: "Chinchpur (D)" },
      { id: 561194, name: "Chumbli" },
      { id: 561163, name: "Dandegaon" },
      { id: 561182, name: "Deolali" },
      { id: 561178, name: "Devangra" },
      { id: 561222, name: "Dindori" },
      { id: 561140, name: "Dokewadi" },
      { id: 561147, name: "Dudhodi" },
      { id: 561206, name: "Dukkarwadi" },
      { id: 561199, name: "Ganegaon" },
      { id: 561229, name: "Ghatnandur" },
      { id: 561144, name: "Giralgaon" },
      { id: 910015, name: "Girwali" },
      { id: 561175, name: "Golegaon" },
      { id: 561195, name: "Gormala" },
      { id: 561220, name: "Handongri" },
      { id: 561167, name: "Hangewadi" },
      { id: 561221, name: "Hiwara" },
      { id: 561190, name: "Hiwarda" },
      { id: 561171, name: "Ida" },
      { id: 561141, name: "Ieet" },
      { id: 561157, name: "Irachiwadi" },
      { id: 561156, name: "Jamb" },
      { id: 561155, name: "Jayavantnagar" },
      { id: 561162, name: "Jejla" },
      { id: 561143, name: "Jotibachiwadi" },
      { id: 561172, name: "Kanadi" },
      { id: 561213, name: "Kasari" },
      { id: 561188, name: "Krishnapur" },
      { id: 561136, name: "Lanjeshwar" },
      { id: 561137, name: "Malewadi" },
      { id: 561181, name: "Mankeshwar" },
      { id: 561158, name: "Matrewadi" },
      { id: 561149, name: "Nagewadi" },
      { id: 561159, name: "Nali" },
      { id: 561145, name: "Naliwadgaon" },
      { id: 561151, name: "Nannajwadi (N.V.)" },
      { id: 561215, name: "Nawalgaon" },
      { id: 561135, name: "Nipani" },
      { id: 561203, name: "Padoli" },
      { id: 561142, name: "Pakhrud" },
      { id: 561139, name: "Pandharewadi" },
      { id: 561185, name: "Panhalwadi" },
      { id: 561153, name: "Pathrud" },
      { id: 561191, name: "Patsangvi" },
      { id: 561170, name: "Pida" },
      { id: 561201, name: "Pimpalgaon" },
      { id: 561183, name: "Ralesangvi" },
      { id: 561210, name: "Rameshwar" },
      { id: 561207, name: "Ramkund" },
      { id: 561197, name: "Rosamba" },
      { id: 561196, name: "Sadesangvi" },
      { id: 561200, name: "Samangaon" },
      { id: 561146, name: "Sawargaon (Devangra)" },
      { id: 561177, name: "Sawargaon (Patrud)" },
      { id: 561179, name: "Shekhapur" },
      { id: 561209, name: "Songiri" },
      { id: 561226, name: "Sonnewadi" },
      { id: 561204, name: "Sukta" },
      { id: 561134, name: "Tambewadi" },
      { id: 561161, name: "Tintraj" },
      { id: 561211, name: "Ulup" },
      { id: 561148, name: "Umachiwadi" },
      { id: 561150, name: "Wadachiwadi" },
      { id: 561208, name: "Wakwad" },
      { id: 561192, name: "Walha" },
      { id: 561193, name: "Walwad" },
      { id: 561180, name: "Wangi Bk." },
      { id: 561173, name: "Wangi Kh." },
      { id: 561223, name: "Wanjarwadi" },
      { id: 561216, name: "Warewadgaon" },
      { id: 561187, name: "Warud" },
    ],
    4238: [
      { id: 561273, name: "Bavi" },
      { id: 561278, name: "Bori" },
      { id: 561236, name: "Brahmagaon" },
      { id: 561241, name: "Dahiphal" },
      { id: 561271, name: "Dasmegaon" },
      { id: 561253, name: "Dongrewadi" },
      { id: 561250, name: "Fakarabad" },
      { id: 561243, name: "Ghatpimpari" },
      { id: 561255, name: "Ghodki" },
      { id: 561270, name: "Gojwada" },
      { id: 561266, name: "Golegaon" },
      { id: 561237, name: "Hatola" },
      { id: 561269, name: "Indapur" },
      { id: 561267, name: "Isrup" },
      { id: 561244, name: "Izora" },
      { id: 561230, name: "Jankapur" },
      { id: 561248, name: "Jawalka" },
      { id: 561232, name: "Jeba" },
      { id: 561282, name: "Kadaknathwadi" },
      { id: 561264, name: "Kanheri" },
      { id: 561259, name: "Kawadewadi" },
      { id: 561263, name: "Kelewadi" },
      { id: 561276, name: "Khamkarwadi" },
      { id: 561268, name: "Khanapur" },
      { id: 561234, name: "Lakhangaon" },
      { id: 561239, name: "Lonkhas" },
      { id: 561260, name: "Mahaldarpuri" },
      { id: 561274, name: "Mandva" },
      { id: 561283, name: "Masobachiwadi" },
      { id: 561279, name: "Nandgaon" },
      { id: 561233, name: "Pangri" },
      { id: 561249, name: "Para" },
      { id: 561265, name: "Pardi" },
      { id: 561231, name: "Pargaon" },
      { id: 561240, name: "Pimpalgaon (Kamleshwari)" },
      { id: 561251, name: "Pimpalgaon(K)" },
      { id: 561256, name: "Pimpalgaon(L)" },
      { id: 561235, name: "Pimpalwadi" },
      { id: 561238, name: "Rui" },
      { id: 561246, name: "Saramkondi" },
      { id: 561254, name: "Sarol (Mandva)" },
      { id: 561258, name: "Sarola" },
      { id: 561277, name: "Satvaiwadi" },
      { id: 561252, name: "Selu" },
      { id: 561242, name: "Shelgaon" },
      { id: 561247, name: "Shendi" },
      { id: 561275, name: "Sonarwadi" },
      { id: 561257, name: "Sonegaon" },
      { id: 561261, name: "Tandulwadi" },
      { id: 561281, name: "Terkheda" },
      { id: 561280, name: "Wadji" },
      { id: 561262, name: "Washi" },
      { id: 561245, name: "Yashwandi" },
      { id: 561272, name: "Zinnar" },
    ],
    4239: [
      { id: 561288, name: "Adhala" },
      { id: 561289, name: "Adsulwadi" },
      { id: 561313, name: "Andora" },
      { id: 561295, name: "Athardi" },
      { id: 561320, name: "Awad Shirpura" },
      { id: 561345, name: "Babhalgaon" },
      { id: 561287, name: "Bahula" },
      { id: 561377, name: "Bangarwadi" },
      { id: 561354, name: "Baramachiwadi" },
      { id: 561372, name: "Baratewadi" },
      { id: 561298, name: "Bhatsangvi" },
      { id: 561305, name: "Bhatshirapura" },
      { id: 561290, name: "Bhogaji" },
      { id: 561358, name: "Bhosa" },
      { id: 561314, name: "Borda" },
      { id: 561284, name: "Borgaon" },
      { id: 945079, name: "Borgaon (Keij)" },
      { id: 561340, name: "Borgaon Bk." },
      { id: 561330, name: "Borgaon Kh." },
      { id: 561336, name: "Borwanti" },
      { id: 561373, name: "Chorakhali" },
      { id: 561318, name: "Dabha" },
      { id: 561346, name: "Dahiphal" },
      { id: 561338, name: "Deodhanora" },
      { id: 561350, name: "Deolali" },
      { id: 561344, name: "Dhorala" },
      { id: 561307, name: "Diksal" },
      { id: 561376, name: "Dudhalwadi" },
      { id: 561335, name: "Ekurka" },
      { id: 561291, name: "Gambhirwadi" },
      { id: 561357, name: "Gaur" },
      { id: 561341, name: "Gaurgaon" },
      { id: 561325, name: "Ghargaon" },
      { id: 561349, name: "Govindpur" },
      { id: 561362, name: "Haladgaon" },
      { id: 561334, name: "Hasegaon (Shirdhon)" },
      { id: 561309, name: "Hasegaon Kej" },
      { id: 561299, name: "Hawargaon" },
      { id: 561303, name: "Hingangaon" },
      { id: 561292, name: "Itkur" },
      { id: 561327, name: "Jaiphal" },
      { id: 561337, name: "Jawala Khurd" },
      { id: 943986, name: "Kalamb" },
      { id: 561311, name: "Kanherwadi" },
      { id: 561304, name: "Karanjkalla" },
      { id: 561300, name: "Khadki" },
      { id: 561352, name: "Khamaswadi" },
      { id: 561316, name: "Kherda" },
      { id: 561297, name: "Khondala" },
      { id: 561317, name: "Kothala" },
      { id: 561293, name: "Kothalwadi" },
      { id: 561323, name: "Lasra" },
      { id: 561301, name: "Lohata(West)" },
      { id: 561374, name: "Malkapur" },
      { id: 561351, name: "Malkaranja" },
      { id: 561348, name: "Mangrul" },
      { id: 561312, name: "Massa (Kh)" },
      { id: 561347, name: "Moha" },
      { id: 561339, name: "Nagulgaon" },
      { id: 561353, name: "Nagzarwadi" },
      { id: 561331, name: "Naigaon" },
      { id: 561333, name: "Nipani" },
      { id: 561332, name: "Padoli" },
      { id: 561368, name: "Pangaon" },
      { id: 561367, name: "Partapur" },
      { id: 561294, name: "Pathardi" },
      { id: 561306, name: "Pimpalgaon Dola" },
      { id: 943987, name: "Pimpalgaon Tonga" },
      { id: 561329, name: "Pimpari (Sh)" },
      { id: 561328, name: "Raigavhan" },
      { id: 561324, name: "Ranjani" },
      { id: 561286, name: "Ratnapur" },
      { id: 561369, name: "Sanjitpur" },
      { id: 561370, name: "Sapnai" },
      { id: 561361, name: "Satephal" },
      { id: 561296, name: "Satra" },
      { id: 561363, name: "Saundana (Dhoki)" },
      { id: 561321, name: "Saundana Amba" },
      { id: 943988, name: "Sawargaon Kale" },
      { id: 561359, name: "Shelgaon Divani" },
      { id: 561365, name: "Shelgaon(Jagir)" },
      { id: 561315, name: "Shelka Dhanora" },
      { id: 561355, name: "Shingoli" },
      { id: 561319, name: "Shiradhon" },
      { id: 561326, name: "Tadgaon" },
      { id: 561308, name: "Tandulwadi" },
      { id: 561285, name: "Umara" },
      { id: 561371, name: "Uplai" },
      { id: 561342, name: "Wadgaon (Shirdhon)" },
      { id: 561366, name: "Wadgaon(Jagir)" },
      { id: 561356, name: "Wagholi" },
      { id: 561322, name: "Wakdi Istal" },
      { id: 561310, name: "Wakdi Kej" },
      { id: 561360, name: "Wanewadi" },
      { id: 561343, name: "Wathawada" },
      { id: 561364, name: "Yerandgaon" },
      { id: 561375, name: "Yermala" },
    ],
    4240: [
      { id: 561451, name: "Alni" },
      { id: 561463, name: "Ambehol" },
      { id: 561455, name: "Ambejawalga" },
      { id: 561487, name: "Ambewadi" },
      { id: 561489, name: "Ansurda" },
      { id: 561402, name: "Arni" },
      { id: 561448, name: "Balpeerwadi" },
      { id: 561498, name: "Bamani" },
      { id: 561483, name: "Baramgaon Bk." },
      { id: 561497, name: "Baramgaon Kh." },
      { id: 561425, name: "Bavi Dhoki" },
      { id: 561478, name: "Bavi(Osmanabad)" },
      { id: 561470, name: "Begada" },
      { id: 561491, name: "Bembli" },
      { id: 561450, name: "Bhadachiwadi" },
      { id: 561454, name: "Bhanasgaon" },
      { id: 561422, name: "Bhandari" },
      { id: 561439, name: "Bhandarwadi" },
      { id: 561399, name: "Bhikar Sarola" },
      { id: 561485, name: "Borgaon Raje" },
      { id: 561416, name: "Borkheda" },
      { id: 561392, name: "Bukanwadi" },
      { id: 561484, name: "Chikhali" },
      { id: 561466, name: "Chilvadi" },
      { id: 561437, name: "Dakwadi" },
      { id: 561446, name: "Darphal" },
      { id: 561445, name: "Dautpur" },
      { id: 561481, name: "Deolali" },
      { id: 561457, name: "Dharashiv" },
      { id: 561479, name: "Dharur" },
      { id: 561389, name: "Dhoki" },
      { id: 561420, name: "Dhutta" },
      { id: 561382, name: "Dudhagaon" },
      { id: 561430, name: "Gad Deodari" },
      { id: 561472, name: "Gaosud" },
      { id: 561490, name: "Gaundgaon" },
      { id: 561456, name: "Ghatangri" },
      { id: 561395, name: "Ghogarewadi" },
      { id: 561413, name: "Ghuggi" },
      { id: 561502, name: "Gogaon" },
      { id: 561378, name: "Gopalwadi" },
      { id: 561393, name: "Gorewadi" },
      { id: 561390, name: "Govardhanwadi" },
      { id: 561436, name: "Hinglajwadi" },
      { id: 561444, name: "Irla" },
      { id: 561398, name: "Jagji" },
      { id: 561431, name: "Jahagirdarwadi" },
      { id: 561383, name: "Jawale Dumala" },
      { id: 561462, name: "Junoni" },
      { id: 561443, name: "Kajala" },
      { id: 561423, name: "Kakaspur" },
      { id: 561410, name: "Kamegaon" },
      { id: 561418, name: "Kanagara" },
      { id: 561503, name: "Karajkheda" },
      { id: 562051, name: "Kari" },
      { id: 561381, name: "Kasbetadwale" },
      { id: 561461, name: "Kaudgaon (Bavi)" },
      { id: 910044, name: "Kaudgaon(Ambi)" },
      { id: 561477, name: "Kawaldara Tanda" },
      { id: 561391, name: "Kawalewadi" },
      { id: 561493, name: "Keshegaon" },
      { id: 561476, name: "Khamaswadi" },
      { id: 561385, name: "Khamgaon" },
      { id: 561460, name: "Khanapur" },
      { id: 561387, name: "Khed" },
      { id: 561429, name: "Kini" },
      { id: 561394, name: "Kolegaon" },
      { id: 561440, name: "Kolewadi" },
      { id: 561379, name: "Kombadwadi" },
      { id: 561404, name: "Kond" },
      { id: 561452, name: "Kumalwadi" },
      { id: 561412, name: "Lasona" },
      { id: 561496, name: "Mahadevwadi" },
      { id: 561486, name: "Mahalingi" },
      { id: 561482, name: "Medsinga" },
      { id: 561414, name: "Mendha" },
      { id: 561400, name: "Mohtarwadi" },
      { id: 561427, name: "Mulewadi" },
      { id: 561421, name: "Nandurga" },
      { id: 561447, name: "Narsinhwadi" },
      { id: 561405, name: "Nitali" },
      { id: 561415, name: "Padoli" },
      { id: 561474, name: "Palaswadi" },
      { id: 561396, name: "Palsap" },
      { id: 561417, name: "Panchgavhan" },
      { id: 561500, name: "Patoda" },
      { id: 561435, name: "Pawarwadi" },
      { id: 561468, name: "Pimpri" },
      { id: 561469, name: "Pohner" },
      { id: 561409, name: "Rajuri" },
      { id: 561438, name: "Ramwadi" },
      { id: 561424, name: "Rui Dhoki" },
      { id: 561488, name: "Ruibhar" },
      { id: 561458, name: "Sakanewadi" },
      { id: 561403, name: "Samba" },
      { id: 561411, name: "Samudrawani" },
      { id: 561408, name: "Sangvi" },
      { id: 561459, name: "Sanja" },
      { id: 561449, name: "Sarola Bk." },
      { id: 561480, name: "Shekapur" },
      { id: 561432, name: "Shingoli" },
      { id: 561453, name: "Sonegaon" },
      { id: 561467, name: "Surdi" },
      { id: 561419, name: "Takali Bembali" },
      { id: 561407, name: "Takali Dhoki" },
      { id: 561499, name: "Takwiki" },
      { id: 561397, name: "Tawarajkheda" },
      { id: 561428, name: "Ter" },
      { id: 561504, name: "Toramba" },
      { id: 561426, name: "Tugaon" },
      { id: 561495, name: "Umaregavhan" },
      { id: 561433, name: "Upala Ma." },
      { id: 561475, name: "Uttami Kayapur" },
      { id: 561492, name: "Vitthalwadi" },
      { id: 561501, name: "Wadala" },
      { id: 561473, name: "Wadgaon" },
      { id: 561494, name: "Wadibamani" },
      { id: 561442, name: "Wagholi" },
      { id: 561380, name: "Wakharwadi" },
      { id: 561464, name: "Walgud" },
      { id: 561441, name: "Wanewadi" },
      { id: 561434, name: "Waruda" },
      { id: 561471, name: "Warwanti" },
      { id: 561384, name: "Yedsi" },
      { id: 561406, name: "Yeoti" },
      { id: 561465, name: "Zaregaon" },
    ],
    4241: [
      { id: 561592, name: "Aliyabad" },
      { id: 561532, name: "Amrutwadi" },
      { id: 561590, name: "Andur" },
      { id: 561527, name: "Apsinga" },
      { id: 561566, name: "Arali Bk." },
      { id: 561564, name: "Arali Kh." },
      { id: 561577, name: "Arbali" },
      { id: 561604, name: "Babhalgaon" },
      { id: 561544, name: "Barul" },
      { id: 561565, name: "Baswantwadi" },
      { id: 561557, name: "Bhatambri" },
      { id: 561549, name: "Bijanwadi" },
      { id: 561627, name: "Bolegaon" },
      { id: 561623, name: "Borgaon" },
      { id: 561529, name: "Bori" },
      { id: 561546, name: "Bornadwadi" },
      { id: 561553, name: "Bornadwadi (Nal)" },
      { id: 561585, name: "Chikundra" },
      { id: 561563, name: "Chincholi" },
      { id: 561588, name: "Chivari" },
      { id: 561621, name: "Dahitna" },
      { id: 561508, name: "Dahiwadi" },
      { id: 561572, name: "Deokurli" },
      { id: 561551, name: "Deosinga (Tul)" },
      { id: 561619, name: "Devsinga Nal" },
      { id: 561560, name: "Dhanegaon" },
      { id: 561598, name: "Dhangarwadi" },
      { id: 561530, name: "Dhekri" },
      { id: 561579, name: "Dhotri" },
      { id: 561575, name: "Dindegaon" },
      { id: 561597, name: "Fulwadi" },
      { id: 561521, name: "Ganjewadi" },
      { id: 561518, name: "Gawalewadi" },
      { id: 561554, name: "Ghandora" },
      { id: 561512, name: "Gondhalwadi" },
      { id: 561616, name: "Gujnur" },
      { id: 561620, name: "Gulhalli" },
      { id: 561587, name: "Haglur" },
      { id: 561547, name: "Hangarga" },
      { id: 561614, name: "Hangarga (Nal)" },
      { id: 561576, name: "Hippargatad" },
      { id: 561545, name: "Honala" },
      { id: 561608, name: "Horti" },
      { id: 561613, name: "Indiranagar" },
      { id: 561603, name: "Itkal" },
      { id: 561612, name: "Jalkot" },
      { id: 561611, name: "Jalkotwadi" },
      { id: 561543, name: "Jawalga Mesai" },
      { id: 561511, name: "Kadamwadi" },
      { id: 561538, name: "Kakramba" },
      { id: 561536, name: "Kakrambawadi" },
      { id: 561568, name: "Kalegaon" },
      { id: 561528, name: "Kamtha" },
      { id: 561541, name: "Karla" },
      { id: 561562, name: "Kasai" },
      { id: 561578, name: "Katgaon" },
      { id: 561507, name: "Kati" },
      { id: 561526, name: "Katri" },
      { id: 561517, name: "Kemwadi" },
      { id: 561600, name: "Kerur" },
      { id: 561606, name: "Keshegaon" },
      { id: 561580, name: "Khadki" },
      { id: 561602, name: "Khanapur" },
      { id: 561540, name: "Khandala" },
      { id: 561596, name: "Khudawadi" },
      { id: 561505, name: "Khuttewadi" },
      { id: 561584, name: "Kilaj" },
      { id: 561571, name: "Korewadi" },
      { id: 561561, name: "Kumbhari" },
      { id: 561626, name: "Kunsali" },
      { id: 561615, name: "Lohagaon" },
      { id: 561513, name: "Malumbra" },
      { id: 561586, name: "Manewadi" },
      { id: 561559, name: "Mangrul" },
      { id: 561509, name: "Masala Kh." },
      { id: 561535, name: "Morda" },
      { id: 561610, name: "Murta" },
      { id: 561591, name: "Naldurg" },
      { id: 561622, name: "Nandgaon" },
      { id: 561569, name: "Nanduri" },
      { id: 561618, name: "Nilegaon" },
      { id: 561514, name: "Pangardarwadi" },
      { id: 561524, name: "Pimpala Bk." },
      { id: 561523, name: "Pimpala Kh." },
      { id: 561556, name: "Raikhel" },
      { id: 561593, name: "Ramtirth" },
      { id: 561582, name: "Salgara Divti" },
      { id: 561624, name: "Salgara Tatar" },
      { id: 561515, name: "Sangvi Kati" },
      { id: 561510, name: "Sangvi Mardi" },
      { id: 561605, name: "Sarati" },
      { id: 561558, name: "Sardewadi" },
      { id: 561555, name: "Sarola" },
      { id: 561516, name: "Sawargaon" },
      { id: 561617, name: "Shahapur" },
      { id: 561531, name: "Shiradhon" },
      { id: 561599, name: "Shirgapur" },
      { id: 561583, name: "Shivkarwadi" },
      { id: 561533, name: "Sindfal" },
      { id: 561625, name: "Sindgaon" },
      { id: 561522, name: "Suratgaon" },
      { id: 561537, name: "Tadwala" },
      { id: 561525, name: "Tamalwadi" },
      { id: 561601, name: "Telarnagar" },
      { id: 561550, name: "Tirth Bk." },
      { id: 561548, name: "Tirth Kh." },
      { id: 561534, name: "Tuljapur" },
      { id: 561589, name: "Umarga" },
      { id: 561552, name: "Wadgaon Deo" },
      { id: 561519, name: "Wadgaon Kati" },
      { id: 561539, name: "Wadgaon Lakh" },
      { id: 561595, name: "Wagdari" },
      { id: 561542, name: "Wanegaon" },
      { id: 561506, name: "Wanewadi" },
      { id: 561570, name: "Yamgarwadi" },
      { id: 561594, name: "Yedola" },
      { id: 561567, name: "Yewati" },
    ],
    4242: [
      { id: 561674, name: "Achaler" },
      { id: 561628, name: "Arni" },
      { id: 561673, name: "Ashta Kasar" },
      { id: 561657, name: "Belwadi" },
      { id: 561635, name: "Bendkal" },
      { id: 561631, name: "Bhatagali" },
      { id: 561670, name: "Bhosga" },
      { id: 561652, name: "Chincholi Kate" },
      { id: 561645, name: "Chincholi Rebe" },
      { id: 926834, name: "Dakshin Jewali" },
      { id: 561671, name: "Dastapur" },
      { id: 561654, name: "Dhanuri" },
      { id: 561647, name: "Ekondi Lohara" },
      { id: 561660, name: "Harali" },
      { id: 561665, name: "Hipparga Sayyad" },
      { id: 561638, name: "Hippargarava" },
      { id: 561648, name: "Holi" },
      { id: 561669, name: "Jewali" },
      { id: 561630, name: "Kanegaon" },
      { id: 561653, name: "Karanjgaon" },
      { id: 561664, name: "Karwanji" },
      { id: 561632, name: "Kasti Bk." },
      { id: 561634, name: "Kasti Kh." },
      { id: 561642, name: "Khed" },
      { id: 561672, name: "Kolnur Pandari" },
      { id: 561663, name: "Kondjigad" },
      { id: 561640, name: "Lohara Bk." },
      { id: 561641, name: "Lohara Kh." },
      { id: 561643, name: "Makani" },
      { id: 561659, name: "Malegaon" },
      { id: 561636, name: "Mardi" },
      { id: 561656, name: "Mogha Bk." },
      { id: 561655, name: "Mogha Kh" },
      { id: 561649, name: "Murshadpur" },
      { id: 561639, name: "Nagral" },
      { id: 561633, name: "Nagur" },
      { id: 561668, name: "Phanepur" },
      { id: 561646, name: "Rajegaon" },
      { id: 561662, name: "Salegaon" },
      { id: 561644, name: "Sastur" },
      { id: 943989, name: "Shivkarwadi" },
      { id: 561651, name: "Tawshigad" },
      { id: 561661, name: "Toramba" },
      { id: 561650, name: "Udatpur" },
      { id: 561637, name: "Undargaon" },
      { id: 561666, name: "Vilaspur Pandhari" },
      { id: 561667, name: "Wadgaon" },
      { id: 561658, name: "Wadgaonwadi" },
    ],
    4243: [
      { id: 561760, name: "Acharya Tanda" },
      { id: 561769, name: "Alur" },
      { id: 561759, name: "Ambarnagar" },
      { id: 561749, name: "Anantpur Beradwadi" },
      { id: 561710, name: "Ashta Jahangir" },
      { id: 561737, name: "Aurad" },
      { id: 561688, name: "Babalsur" },
      { id: 561726, name: "Balsur" },
      { id: 561767, name: "Belamb" },
      { id: 561717, name: "Bendga" },
      { id: 561680, name: "Bhagatwadi" },
      { id: 561715, name: "Bhikar Sangvi" },
      { id: 561748, name: "Bhusni" },
      { id: 561677, name: "Bori" },
      { id: 561718, name: "Chandkal" },
      { id: 561711, name: "Chinchkota" },
      { id: 561735, name: "Chincholi Bhuyar" },
      { id: 561742, name: "Chincholi Jahagir" },
      { id: 561681, name: "Chirewadi" },
      { id: 561709, name: "Dabka" },
      { id: 561724, name: "Dalimb" },
      { id: 561751, name: "Dawal Malikwadi" },
      { id: 561703, name: "Dhaktiwadi" },
      { id: 561720, name: "Dhanora Dagad" },
      { id: 561722, name: "Diggi" },
      { id: 561697, name: "Dudhanal" },
      { id: 561739, name: "Ekundi Jahagir" },
      { id: 561741, name: "Ekundiwadi" },
      { id: 561728, name: "Ekurga" },
      { id: 561729, name: "Ekurgawadi" },
      { id: 561762, name: "Fulsingnagar" },
      { id: 561761, name: "Ganeshnagar" },
      { id: 561693, name: "Gugalgaon" },
      { id: 561738, name: "Gunjoti" },
      { id: 561744, name: "Gunjotiwadi" },
      { id: 561713, name: "Gurwadi" },
      { id: 561698, name: "Handral" },
      { id: 561705, name: "Hippargarao" },
      { id: 561758, name: "Ingole Tanda" },
      { id: 561702, name: "Jagadalwadi" },
      { id: 561732, name: "Jakekur" },
      { id: 561736, name: "Jakekurwadi" },
      { id: 561692, name: "Jawalga Bet" },
      { id: 561695, name: "Kadamapur" },
      { id: 561687, name: "Kaddora" },
      { id: 561747, name: "Kader" },
      { id: 561685, name: "Kaldeo Nimbala" },
      { id: 561686, name: "Kalnimbala" },
      { id: 561764, name: "Kanthekur" },
      { id: 561700, name: "Karali" },
      { id: 561746, name: "Kasgi" },
      { id: 561745, name: "Kasgiwadi" },
      { id: 561734, name: "Katewadi" },
      { id: 561675, name: "Kawatha" },
      { id: 561768, name: "Kesarjawalga" },
      { id: 561679, name: "Kolewadi" },
      { id: 561706, name: "Kolsur (Gunjoti)" },
      { id: 561707, name: "Kolsur (Kalyani)" },
      { id: 561723, name: "Koral" },
      { id: 561731, name: "Koregaon" },
      { id: 561730, name: "Koregaonwadi" },
      { id: 561766, name: "Kothali" },
      { id: 561696, name: "Kunhali" },
      { id: 561691, name: "Madaj" },
      { id: 561753, name: "Mahalingraiwadi" },
      { id: 561712, name: "Malgi" },
      { id: 561719, name: "Malgiwadi" },
      { id: 561721, name: "Manegopal" },
      { id: 561676, name: "Matola" },
      { id: 561699, name: "Mulaj" },
      { id: 561765, name: "Murli" },
      { id: 561757, name: "Murum (Rural)" },
      { id: 561716, name: "Nagral" },
      { id: 561678, name: "Nai Chakur" },
      { id: 561763, name: "Naiknagar Mu" },
      { id: 561756, name: "Naiknagar Su" },
      { id: 561682, name: "Narangwadi" },
      { id: 561740, name: "Omarga (Rural)" },
      { id: 561743, name: "Palasgaon" },
      { id: 561714, name: "Paraskheda" },
      { id: 561683, name: "Pethsangvi" },
      { id: 561725, name: "Rampur" },
      { id: 561684, name: "Samudral" },
      { id: 561689, name: "Sawalsur" },
      { id: 561755, name: "Sundarwadi" },
      { id: 561750, name: "Supatgaon" },
      { id: 561701, name: "Talmod" },
      { id: 561704, name: "Thorliwadi" },
      { id: 561694, name: "Trikoli" },
      { id: 561754, name: "Tugaon" },
      { id: 561708, name: "Turori" },
      { id: 561770, name: "Varnalwadi" },
      { id: 561727, name: "Vhantal" },
      { id: 561690, name: "Wagdari" },
      { id: 561733, name: "Yeli" },
      { id: 561752, name: "Yenegur" },
    ],
    4244: [
      { id: 561812, name: "Aljapur" },
      { id: 561852, name: "Alsunde" },
      { id: 561808, name: "Anjandoh" },
      { id: 561844, name: "Arjunnagar" },
      { id: 561849, name: "Awati" },
      { id: 561816, name: "Balewadi" },
      { id: 561781, name: "Bhagatwadi" },
      { id: 561880, name: "Bhalavni" },
      { id: 561840, name: "Bhalewadi" },
      { id: 561773, name: "Bhilarwadi" },
      { id: 561878, name: "Bhivarwadi" },
      { id: 561828, name: "Bhose" },
      { id: 561817, name: "Bitargaon (Shrigonde)" },
      { id: 561890, name: "Bitargaon (Wangi)" },
      { id: 561825, name: "Borgaon" },
      { id: 561869, name: "Chikhalthan" },
      { id: 561870, name: "Dahigaon" },
      { id: 561777, name: "Delwadi" },
      { id: 561835, name: "Deolali" },
      { id: 561833, name: "Dhaykhindi" },
      { id: 561889, name: "Dhokari" },
      { id: 561838, name: "Dilmeshwar" },
      { id: 561776, name: "Divegavhan" },
      { id: 561848, name: "Gaundare" },
      { id: 561774, name: "Gharatwadi" },
      { id: 561815, name: "Ghargaon" },
      { id: 561882, name: "Ghoti" },
      { id: 561793, name: "Gorewadi" },
      { id: 561789, name: "Goyegaon" },
      { id: 561780, name: "Gulmarwadi" },
      { id: 561856, name: "Gulsadi" },
      { id: 561779, name: "Hingani" },
      { id: 561845, name: "Hisare" },
      { id: 561843, name: "Hivare" },
      { id: 561827, name: "Hiwarwadi" },
      { id: 561794, name: "Hulgewadi" },
      { id: 561810, name: "Jategaon" },
      { id: 561866, name: "Jeur" },
      { id: 561863, name: "Jeurwadi" },
      { id: 561782, name: "Jinnti" },
      { id: 561818, name: "Kamone" },
      { id: 561891, name: "Kandar" },
      { id: 561839, name: "Karanje" },
      { id: 561831, name: "Karmala (Rural)" },
      { id: 561783, name: "Katraj" },
      { id: 561887, name: "Kavitgaon" },
      { id: 561772, name: "Kawalwadi" },
      { id: 561862, name: "Kedgaon" },
      { id: 561885, name: "Kem" },
      { id: 561788, name: "Kettur" },
      { id: 561836, name: "Khadakewadi" },
      { id: 561811, name: "Khadaki" },
      { id: 561826, name: "Khambewadi" },
      { id: 561786, name: "Khatgaon" },
      { id: 561842, name: "Kolgaon" },
      { id: 561784, name: "Kondhar Chincholi" },
      { id: 561864, name: "Kondhej" },
      { id: 561795, name: "Korti" },
      { id: 561868, name: "Kugaon" },
      { id: 561775, name: "Kumbhargaon" },
      { id: 561860, name: "Kumbhej" },
      { id: 561796, name: "Kuskarwadi" },
      { id: 561872, name: "Lavhe" },
      { id: 561800, name: "Limbewadi" },
      { id: 561881, name: "Malwadi" },
      { id: 561821, name: "Mangi" },
      { id: 561805, name: "Manjargaon" },
      { id: 561841, name: "Mirghavan" },
      { id: 561797, name: "Morwad" },
      { id: 561853, name: "Nerle" },
      { id: 561823, name: "Nilaj" },
      { id: 561873, name: "Nimbhore" },
      { id: 561847, name: "Nimgaon (H)" },
      { id: 561814, name: "Padali" },
      { id: 561834, name: "Pande" },
      { id: 561879, name: "Pangare" },
      { id: 561778, name: "Parewadi" },
      { id: 561884, name: "Pathurdi" },
      { id: 561846, name: "Phisare" },
      { id: 561829, name: "Pimpalwadi" },
      { id: 561787, name: "Pomalwadi" },
      { id: 561803, name: "Pondhvadi" },
      { id: 561861, name: "Pophalaj" },
      { id: 561824, name: "Potegaon" },
      { id: 561822, name: "Pothare" },
      { id: 561809, name: "Punwar" },
      { id: 561804, name: "Rajuri" },
      { id: 561771, name: "Ramwadi" },
      { id: 561799, name: "Ravgaon" },
      { id: 561807, name: "Ritewadi" },
      { id: 561830, name: "Roshewadi" },
      { id: 561851, name: "Sade" },
      { id: 561850, name: "Salse" },
      { id: 561888, name: "Sangvi" },
      { id: 561859, name: "Sarapdoh" },
      { id: 561892, name: "Satoli" },
      { id: 561792, name: "Savadi" },
      { id: 561857, name: "Shelgaon (K)" },
      { id: 561871, name: "Shelgaon (Wangi)" },
      { id: 561867, name: "Shetphal" },
      { id: 561832, name: "Shirdevichamal" },
      { id: 561791, name: "Sogaon" },
      { id: 561858, name: "Sounde" },
      { id: 561785, name: "Takali (Rashin)" },
      { id: 561813, name: "Taratgaon" },
      { id: 561854, name: "Umrad" },
      { id: 561806, name: "Undargaon" },
      { id: 561886, name: "Vadshivane" },
      { id: 561798, name: "Vanjarwadi" },
      { id: 561801, name: "Veet" },
      { id: 561802, name: "Vihal" },
      { id: 561837, name: "Wadachiwadi" },
      { id: 561819, name: "Wadgaon (N)" },
      { id: 561820, name: "Wadgaon Kh." },
      { id: 561893, name: "Wangi" },
      { id: 561874, name: "Wangi - 1" },
      { id: 561875, name: "Wangi - 2" },
      { id: 561876, name: "Wangi - 3" },
      { id: 561877, name: "Wangi - 4" },
      { id: 561865, name: "Warkatne" },
      { id: 561883, name: "Warkute" },
      { id: 561790, name: "Washimbe" },
      { id: 561855, name: "Zare" },
    ],
    4245: [
      { id: 561936, name: "Adhegaon" },
      { id: 561970, name: "Ahergaon" },
      { id: 561951, name: "Akole Bk" },
      { id: 561932, name: "Akole Kh" },
      { id: 561909, name: "Akulgaon" },
      { id: 561969, name: "Akumbhe" },
      { id: 561937, name: "Alegaon Bk" },
      { id: 561939, name: "Alegaon Kh" },
      { id: 561921, name: "Ambad" },
      { id: 561991, name: "Anjangaon (Khe)" },
      { id: 561993, name: "Anjangaon Umate" },
      { id: 561958, name: "Aran" },
      { id: 561918, name: "Badalewadi" },
      { id: 561961, name: "Bairagwadi" },
      { id: 561907, name: "Barloni" },
      { id: 561976, name: "Bavi" },
      { id: 561953, name: "Bembale" },
      { id: 561973, name: "Bhend" },
      { id: 561900, name: "Bhogewadi" },
      { id: 561925, name: "Bhosare" },
      { id: 561964, name: "Bhuinje" },
      { id: 561977, name: "Bhutashte" },
      { id: 561898, name: "Bitergaon" },
      { id: 562009, name: "Budrukwadi" },
      { id: 561942, name: "Chandaj" },
      { id: 561999, name: "Chavhanwadi (Tembhurni)" },
      { id: 944185, name: "Chavhanwadi Darfal" },
      { id: 561910, name: "Chinchgaon" },
      { id: 561978, name: "Chincholi" },
      { id: 561903, name: "Chobhepimpari" },
      { id: 561916, name: "Dahiwali" },
      { id: 561996, name: "Darfal" },
      { id: 562008, name: "Dhanore" },
      { id: 561901, name: "Dhavalas" },
      { id: 561931, name: "Footjawalgaon" },
      { id: 561940, name: "Gar Akole" },
      { id: 561905, name: "Gavalewadi" },
      { id: 561924, name: "Ghatane" },
      { id: 561954, name: "Ghoti" },
      { id: 562006, name: "Hatkarwadi" },
      { id: 561972, name: "Hole Kh." },
      { id: 561959, name: "Jadhavwadi (Ma.)" },
      { id: 561982, name: "Jadhavwadi (Mo.)" },
      { id: 561902, name: "Jakhale" },
      { id: 561995, name: "Jamgaon" },
      { id: 561917, name: "Kanhergaon" },
      { id: 562007, name: "Kapsewadi" },
      { id: 561906, name: "Kavhe" },
      { id: 561998, name: "Kewad" },
      { id: 562004, name: "Khairao" },
      { id: 562001, name: "Khairewadi" },
      { id: 562003, name: "Kumbhej" },
      { id: 561923, name: "Kurdu" },
      { id: 944184, name: "Kurduwadi" },
      { id: 561908, name: "Lahu" },
      { id: 561967, name: "Laul" },
      { id: 562002, name: "Londhewadi" },
      { id: 561894, name: "Loni" },
      { id: 561988, name: "Madha" },
      { id: 561904, name: "Mahadeowadi" },
      { id: 561987, name: "Mahatpur" },
      { id: 561947, name: "Malegaon" },
      { id: 562005, name: "Manegaon" },
      { id: 561911, name: "Mhaisgaon" },
      { id: 561952, name: "Mitkalwadi" },
      { id: 561960, name: "Modnimb" },
      { id: 561895, name: "Mungashi" },
      { id: 561896, name: "Nadi" },
      { id: 561944, name: "Nagorli" },
      { id: 561986, name: "Nimgaon (Madha)" },
      { id: 561919, name: "Nimgaon [Tembhurni]" },
      { id: 562010, name: "Pachphulwadi" },
      { id: 561974, name: "Padasali" },
      { id: 561965, name: "Palwan" },
      { id: 561912, name: "Papnas" },
      { id: 561955, name: "Parite" },
      { id: 561956, name: "Paritewadi" },
      { id: 561922, name: "Pimpalkhunte" },
      { id: 561962, name: "Pimpalner" },
      { id: 561992, name: "Rahulnagar" },
      { id: 561984, name: "Randivewadi" },
      { id: 561935, name: "Ranzani" },
      { id: 561913, name: "Ridhore" },
      { id: 561899, name: "Ropale Kavhe" },
      { id: 561979, name: "Ropale Kh." },
      { id: 561938, name: "Rui" },
      { id: 561929, name: "Sapatne (Bhose)" },
      { id: 561963, name: "Sapatne Tembhurni" },
      { id: 561920, name: "Shedshinge" },
      { id: 561946, name: "Shevare" },
      { id: 561928, name: "Shindewadi" },
      { id: 561897, name: "Shingewadi" },
      { id: 561966, name: "Shiral Madha" },
      { id: 561933, name: "Shiral Tembhurni" },
      { id: 561975, name: "Solankarwadi" },
      { id: 561930, name: "Surli" },
      { id: 561926, name: "Tadavale" },
      { id: 561941, name: "Takali Tembhurni" },
      { id: 561949, name: "Tambave" },
      { id: 561914, name: "Tandulwadi" },
      { id: 561945, name: "Tembhurni" },
      { id: 561957, name: "Tulshi" },
      { id: 561968, name: "Ujani Madha" },
      { id: 561934, name: "Ujani Tembhurni" },
      { id: 561997, name: "Undargaon" },
      { id: 561981, name: "Upalai Bk." },
      { id: 561989, name: "Upalai Kh." },
      { id: 561915, name: "Upalawate" },
      { id: 561950, name: "Venegaon" },
      { id: 561990, name: "Vithalwadi" },
      { id: 561927, name: "Wadachiwadi (A. U.)" },
      { id: 561994, name: "Wadachiwadi (T.M.)" },
      { id: 561980, name: "Wadachiwadi (U. Bu.)" },
      { id: 561943, name: "Wadoli" },
      { id: 561985, name: "Wadshinge" },
      { id: 562000, name: "Wakav" },
      { id: 561971, name: "Warawade" },
      { id: 561983, name: "Wetalwadi" },
    ],
    4246: [
      { id: 562019, name: "Agalgaon" },
      { id: 562085, name: "Alipur" },
      { id: 562147, name: "Aljapur" },
      { id: 562142, name: "Ambabaiwadi" },
      { id: 562141, name: "Ambegaon" },
      { id: 562066, name: "Arangaon" },
      { id: 562030, name: "Babhulgaon" },
      { id: 562070, name: "Balewadi" },
      { id: 562083, name: "Barshi" },
      { id: 562073, name: "Bavi" },
      { id: 562020, name: "Belgaon" },
      { id: 562140, name: "Bhalgaon" },
      { id: 562145, name: "Bhandegaon" },
      { id: 562014, name: "Bhansale" },
      { id: 562113, name: "Bhatambare" },
      { id: 562091, name: "Bhoinje" },
      { id: 562029, name: "Bhoyare" },
      { id: 562115, name: "Borgaon (Zadi)" },
      { id: 562031, name: "Borgaon [Kh]" },
      { id: 562032, name: "Chare" },
      { id: 562059, name: "Chikharde" },
      { id: 562134, name: "Chinchkhopan" },
      { id: 562048, name: "Chincholi" },
      { id: 562013, name: "Chumb" },
      { id: 562072, name: "Dadshinge" },
      { id: 562109, name: "Dahitane" },
      { id: 562024, name: "Devgaon" },
      { id: 562016, name: "Dhamangaon (A)" },
      { id: 562131, name: "Dhamangaon (Du.)" },
      { id: 562039, name: "Dhanore" },
      { id: 562049, name: "Dhembarewadi" },
      { id: 562106, name: "Dhorale" },
      { id: 562052, name: "Dhotre" },
      { id: 562026, name: "Gadegaon" },
      { id: 562081, name: "Gatachiwadi" },
      { id: 562137, name: "Gaudgaon" },
      { id: 562098, name: "Ghanegaon" },
      { id: 562044, name: "Ghari" },
      { id: 562050, name: "Gholvewadi" },
      { id: 562055, name: "Gormale" },
      { id: 562093, name: "Gulpoli" },
      { id: 562119, name: "Halduge" },
      { id: 562133, name: "Hattij" },
      { id: 562116, name: "Hingani (Pangaon)" },
      { id: 562132, name: "Hingani (Ratanjan)" },
      { id: 562065, name: "Indapur" },
      { id: 562101, name: "Irle" },
      { id: 562100, name: "Irlewadi" },
      { id: 562045, name: "Jahanpur" },
      { id: 562042, name: "Jamgaon (Agalgaon)" },
      { id: 562112, name: "Jamgaon (P)" },
      { id: 562143, name: "Jawalgaon" },
      { id: 562144, name: "Jotibachiwadi" },
      { id: 562015, name: "Kalambawadi (A)" },
      { id: 562076, name: "Kalambwadi (P)" },
      { id: 562096, name: "Kalegaon" },
      { id: 562025, name: "Kandalgaon" },
      { id: 562064, name: "Kapasi" },
      { id: 562149, name: "Kasari" },
      { id: 562084, name: "Kasarwadi" },
      { id: 562017, name: "Kategaon" },
      { id: 562071, name: "Kavhe" },
      { id: 562022, name: "Khadkalgaon" },
      { id: 562011, name: "Khadkoni" },
      { id: 562057, name: "Khamgaon" },
      { id: 562086, name: "Khandavi" },
      { id: 562012, name: "Koregaon" },
      { id: 562078, name: "Korfale" },
      { id: 562040, name: "Kuslamb" },
      { id: 562125, name: "Ladole" },
      { id: 562079, name: "Lakshyachiwadi" },
      { id: 562074, name: "Mahagaon" },
      { id: 562135, name: "Malegaon" },
      { id: 562111, name: "Malegaon" },
      { id: 562103, name: "Malwandi" },
      { id: 562054, name: "Mamdapur" },
      { id: 562021, name: "Mandegaon" },
      { id: 562099, name: "Manegaon" },
      { id: 562146, name: "Mirzanpur" },
      { id: 562126, name: "Mungashi (R)" },
      { id: 562108, name: "Mungashi (Va)" },
      { id: 562080, name: "Nagobachiwadi" },
      { id: 562118, name: "Nandani" },
      { id: 562060, name: "Nari (Bhandewadi)" },
      { id: 562061, name: "Nariwadi" },
      { id: 562123, name: "Nimbalak" },
      { id: 562047, name: "Pandhari" },
      { id: 562077, name: "Pangaon" },
      { id: 562046, name: "Pangri" },
      { id: 562038, name: "Pathari" },
      { id: 562082, name: "Phaphalwadi" },
      { id: 562023, name: "Pimpalgaon (Dhas)" },
      { id: 562075, name: "Pimpalgaon (Pangaon)" },
      { id: 562053, name: "Pimpalgaon (Pangri)" },
      { id: 562034, name: "Pimpalwadi" },
      { id: 562117, name: "Pimpari (Pangaon)" },
      { id: 562063, name: "Pimpri (Ratanjan)" },
      { id: 562043, name: "Puri" },
      { id: 562129, name: "Raleras" },
      { id: 562094, name: "Rastapur" },
      { id: 562127, name: "Ratanjan" },
      { id: 562139, name: "Raulgaon" },
      { id: 562136, name: "Rui" },
      { id: 562097, name: "Sakat" },
      { id: 562138, name: "Sangamner" },
      { id: 562128, name: "Sarjapur" },
      { id: 562148, name: "Sarole" },
      { id: 562110, name: "Sasure" },
      { id: 562069, name: "Saundare" },
      { id: 562062, name: "Sawargaon" },
      { id: 562068, name: "Shelgaon (Ma.)" },
      { id: 562130, name: "Shelgaon (R)" },
      { id: 562027, name: "Shelgaon (Vhale)" },
      { id: 562089, name: "Shendri" },
      { id: 562037, name: "Shirale" },
      { id: 562092, name: "Shripat Pimpri" },
      { id: 562102, name: "Surdi" },
      { id: 562028, name: "Tadsoudne" },
      { id: 562107, name: "Tadwale (Ma)" },
      { id: 562114, name: "Tambewadi" },
      { id: 562058, name: "Tandulwadi" },
      { id: 562067, name: "Tawadi" },
      { id: 562104, name: "Turk-Pimpri" },
      { id: 562035, name: "Ukadgaon" },
      { id: 562018, name: "Umbarge" },
      { id: 562095, name: "Undegaon" },
      { id: 562088, name: "Upalai (Thonge)" },
      { id: 562120, name: "Upale (Du.)" },
      { id: 562124, name: "Vairag" },
      { id: 562036, name: "Waghachiwadi" },
      { id: 562033, name: "Walwad" },
      { id: 562041, name: "Wanewadi" },
      { id: 562090, name: "Wangarwadi" },
      { id: 562105, name: "Yawali" },
      { id: 562056, name: "Yelamb" },
      { id: 562121, name: "Zadi" },
      { id: 562122, name: "Zaregaon" },
    ],
    4247: [
      { id: 562168, name: "Akolekati" },
      { id: 944174, name: "Bale" },
      { id: 562173, name: "Banegaon" },
      { id: 944172, name: "Basaveshwarnagar" },
      { id: 562185, name: "Belati" },
      { id: 562150, name: "Bhagaiwadi" },
      { id: 562188, name: "Bhatewadi" },
      { id: 562172, name: "Bhogaon" },
      { id: 944166, name: "Dahitane" },
      { id: 562169, name: "Darfal (Bibi)" },
      { id: 562154, name: "Darphal (Gawadi)" },
      { id: 944167, name: "Degaon" },
      { id: 562187, name: "Dongaon" },
      { id: 562174, name: "Ekrukh" },
      { id: 562171, name: "Gulwanchi" },
      { id: 562175, name: "Haglur" },
      { id: 562181, name: "Hiraj" },
      { id: 562164, name: "Honsal" },
      { id: 562157, name: "Ichgaon" },
      { id: 562153, name: "Kalman" },
      { id: 562170, name: "Karamba" },
      { id: 944161, name: "Kasabe Solapur" },
      { id: 562186, name: "Kawathe" },
      { id: 944164, name: "Kegaon" },
      { id: 562178, name: "Khed" },
      { id: 562177, name: "Kondi" },
      { id: 562151, name: "Kouthali" },
      { id: 944163, name: "Kumathe" },
      { id: 944175, name: "Majarewadi" },
      { id: 562167, name: "Mardi" },
      { id: 562189, name: "Nandur" },
      { id: 562161, name: "Nannaj" },
      { id: 562162, name: "Narotewadi" },
      { id: 944169, name: "Neharu Nagar" },
      { id: 562156, name: "Padsali" },
      { id: 562179, name: "Pakani" },
      { id: 562183, name: "Pathari" },
      { id: 944170, name: "Pratapnagar" },
      { id: 562165, name: "Raleras" },
      { id: 562159, name: "Ranmasle" },
      { id: 562152, name: "Sakharewadi" },
      { id: 944179, name: "Salgarwadi" },
      { id: 562190, name: "Samshapur" },
      { id: 562163, name: "Sevalalnager" },
      { id: 944177, name: "Shelagi" },
      { id: 944176, name: "Shivajinagar" },
      { id: 562180, name: "Shivani" },
      { id: 944180, name: "Soregaon" },
      { id: 562176, name: "Tale Hipparge" },
      { id: 562166, name: "Taratgaon" },
      { id: 562184, name: "Telgaon" },
      { id: 562182, name: "Tirhe" },
      { id: 562158, name: "Wadala" },
      { id: 562155, name: "Wangi" },
    ],
    4248: [
      { id: 562259, name: "Adhegaon" },
      { id: 562208, name: "Angar" },
      { id: 562267, name: "Ankoli" },
      { id: 562290, name: "Arbali" },
      { id: 562288, name: "Ardhanari" },
      { id: 562247, name: "Arjunsond" },
      { id: 562243, name: "Ashte" },
      { id: 562198, name: "Ashti" },
      { id: 562268, name: "Aundhi" },
      { id: 562197, name: "Bairagwadi" },
      { id: 562225, name: "Bhairowadi" },
      { id: 562242, name: "Bhambewadi" },
      { id: 562237, name: "Bhoire" },
      { id: 562233, name: "Bitle" },
      { id: 562223, name: "Bople" },
      { id: 562202, name: "Chikhali" },
      { id: 562245, name: "Chincholikati" },
      { id: 562270, name: "Dadapur" },
      { id: 562228, name: "Degaon (Vakuj)" },
      { id: 562194, name: "Devadi" },
      { id: 562214, name: "Dhaingade Wadi" },
      { id: 562249, name: "Dhokbabhulgaon" },
      { id: 562235, name: "Diksal" },
      { id: 562232, name: "Ekurke" },
      { id: 562222, name: "Galandawadi" },
      { id: 562218, name: "Ghatne" },
      { id: 562289, name: "Ghodeshwar" },
      { id: 562229, name: "Ghorpadi" },
      { id: 562252, name: "Gotewadi" },
      { id: 562286, name: "Haralwadi" },
      { id: 562238, name: "Hingani(Nipani)" },
      { id: 562201, name: "Hivare" },
      { id: 562283, name: "Ichgaon" },
      { id: 562293, name: "Jamgaon Bk" },
      { id: 562294, name: "Jamgaon Kh" },
      { id: 562278, name: "Kamti Bk" },
      { id: 562276, name: "Kamti Kh" },
      { id: 562263, name: "Katewadi" },
      { id: 562199, name: "Khandali" },
      { id: 562209, name: "Khandobachiwadi" },
      { id: 562213, name: "Kharkatne" },
      { id: 562216, name: "Khavani" },
      { id: 562239, name: "Khuneshwar" },
      { id: 562221, name: "Kolegaon" },
      { id: 562207, name: "Kombadwadi" },
      { id: 562205, name: "Konheri" },
      { id: 562285, name: "Korwali" },
      { id: 562281, name: "Kothale" },
      { id: 562211, name: "Kuranwadi (Angar)" },
      { id: 562196, name: "Kuranwadi (Ashti)" },
      { id: 562264, name: "Kurul" },
      { id: 562277, name: "Lamantanda" },
      { id: 562244, name: "Lamboti" },
      { id: 562212, name: "Malikpeth" },
      { id: 562226, name: "Mangaoli" },
      { id: 562236, name: "Maslechaudhari" },
      { id: 562291, name: "Miri" },
      { id: 562219, name: "Mohol" },
      { id: 562240, name: "Morvanchi" },
      { id: 562253, name: "Mundhewadi" },
      { id: 562250, name: "Najikpimpari" },
      { id: 562210, name: "Nalbandwadi" },
      { id: 562254, name: "Nandgaon" },
      { id: 562234, name: "Narkhed" },
      { id: 562203, name: "Papari" },
      { id: 562269, name: "Parmeshwar-Pimpri" },
      { id: 562231, name: "Paslewadi" },
      { id: 562258, name: "Patkul" },
      { id: 562230, name: "Pawarwadi" },
      { id: 562273, name: "Peertakali" },
      { id: 562257, name: "Penur" },
      { id: 562217, name: "Pokharapur" },
      { id: 562255, name: "Pophali" },
      { id: 562248, name: "Ramhingani" },
      { id: 562206, name: "Sarole" },
      { id: 562262, name: "Saundane" },
      { id: 562246, name: "Sawaleshwar" },
      { id: 562251, name: "Sayyadwarwade" },
      { id: 562265, name: "Shejbabhulgaon" },
      { id: 562192, name: "Shetphal" },
      { id: 562274, name: "Shingoli" },
      { id: 562272, name: "Shirapur (Mohol)" },
      { id: 562241, name: "Shirapur (Solapur)" },
      { id: 562191, name: "Sidhdewadi" },
      { id: 562280, name: "Sohale" },
      { id: 562261, name: "Takali (Sikandar)" },
      { id: 562260, name: "Tamboli" },
      { id: 562275, name: "Taratgaon" },
      { id: 562195, name: "Telangwadi" },
      { id: 562200, name: "Wadachiwadi" },
      { id: 562282, name: "Wadadegaon" },
      { id: 562220, name: "Wadwal" },
      { id: 562193, name: "Wafale" },
      { id: 562279, name: "Wagholi" },
      { id: 562284, name: "Wagholiwadi" },
      { id: 562227, name: "Waluj" },
      { id: 562266, name: "Warkute" },
      { id: 562292, name: "Watwate" },
      { id: 562271, name: "Wirawade Bk" },
      { id: 562256, name: "Wirwade Kh" },
      { id: 562215, name: "Yawali" },
      { id: 562224, name: "Yellamwadi" },
      { id: 562287, name: "Yenaki" },
      { id: 562204, name: "Yevati" },
    ],
    4249: [
      { id: 562358, name: "Adhiv" },
      { id: 562362, name: "Ajansond" },
      { id: 562386, name: "Ambe" },
      { id: 562393, name: "Ambechincholi" },
      { id: 562368, name: "Anawali" },
      { id: 562304, name: "Avhe" },
      { id: 562355, name: "Babhulgaon" },
      { id: 562300, name: "Badalkot" },
      { id: 562311, name: "Bardi" },
      { id: 562335, name: "Bhalawani" },
      { id: 562331, name: "Bhandi Shegaon" },
      { id: 562359, name: "Bhatumbare" },
      { id: 562315, name: "Bhose" },
      { id: 562352, name: "Bohali" },
      { id: 562384, name: "Chale" },
      { id: 562323, name: "Chilaiwadi" },
      { id: 946149, name: "Chinchani" },
      { id: 562328, name: "Chincholi Bhose" },
      { id: 562373, name: "Chinchumbe" },
      { id: 562361, name: "Degaon" },
      { id: 562318, name: "Devade" },
      { id: 562332, name: "Dhondewadi" },
      { id: 562374, name: "Eklaspur" },
      { id: 562382, name: "Fulchincholi" },
      { id: 562351, name: "Gadegaon" },
      { id: 562340, name: "Gardi" },
      { id: 562367, name: "Gopalpur" },
      { id: 562326, name: "Gursale" },
      { id: 562321, name: "Hole Bk" },
      { id: 562347, name: "Isbavi" },
      { id: 562364, name: "Ishwar Wathar" },
      { id: 562313, name: "Jadhavwadi" },
      { id: 562336, name: "Jainwadi" },
      { id: 562298, name: "Jaloli" },
      { id: 562295, name: "Kanhapuri" },
      { id: 562310, name: "Karkamb" },
      { id: 562296, name: "Karole" },
      { id: 562375, name: "Kasegaon" },
      { id: 562344, name: "Kauthali" },
      { id: 562333, name: "Keskarwadi" },
      { id: 562312, name: "Kharatwadi" },
      { id: 562376, name: "Khardi" },
      { id: 562383, name: "Kharsoli" },
      { id: 562330, name: "Khed Bhalawani" },
      { id: 562319, name: "Khed Bhose" },
      { id: 562385, name: "Kondharki" },
      { id: 562350, name: "Korty" },
      { id: 562341, name: "Lonarwadi" },
      { id: 562380, name: "Magarwadi" },
      { id: 562324, name: "Mendhapur" },
      { id: 562366, name: "Mundhewadi" },
      { id: 562392, name: "Nali" },
      { id: 562303, name: "Nandore" },
      { id: 562357, name: "Narayan Chincholi" },
      { id: 562301, name: "Nematwadi" },
      { id: 562396, name: "Nepatgaon" },
      { id: 562395, name: "Ozewadi" },
      { id: 562339, name: "Palshi" },
      { id: 562314, name: "Pandharewadi" },
      { id: 944182, name: "Pandharpur" },
      { id: 562306, name: "Patvardhan Kuroli" },
      { id: 562302, name: "Pehe" },
      { id: 562308, name: "Pirachi Kuroli" },
      { id: 562387, name: "Pohargaon" },
      { id: 562389, name: "Puluj" },
      { id: 562390, name: "Pulujwadi" },
      { id: 562369, name: "Ranzani" },
      { id: 562354, name: "Ropale" },
      { id: 562299, name: "Sangavi" },
      { id: 562394, name: "Sarkoli" },
      { id: 562391, name: "Shankargaon" },
      { id: 562360, name: "Shegaon Dumala" },
      { id: 562329, name: "Shelve" },
      { id: 562334, name: "Shendgewadi" },
      { id: 562377, name: "Shetphal(Tapkiri)" },
      { id: 562317, name: "Shevate" },
      { id: 562345, name: "Shirdhon" },
      { id: 562371, name: "Shirgaon" },
      { id: 562372, name: "Siddhewadi" },
      { id: 562343, name: "Sonke" },
      { id: 562337, name: "Supli" },
      { id: 562365, name: "Suste" },
      { id: 562349, name: "Takli" },
      { id: 562378, name: "Tanali" },
      { id: 562381, name: "Tarapur" },
      { id: 562305, name: "Taratgaon (Bhose)" },
      { id: 562370, name: "Taratgaon Kasegaon" },
      { id: 562379, name: "Tavashi" },
      { id: 562342, name: "Tisangi" },
      { id: 562356, name: "Tungat" },
      { id: 562297, name: "Umbare" },
      { id: 562353, name: "Umbargaon" },
      { id: 562338, name: "Upari" },
      { id: 562388, name: "Vite" },
      { id: 562309, name: "Wadi Kuroli" },
      { id: 562346, name: "Wakhari" },
    ],
    4250: [
      { id: 562512, name: "Akluj" },
      { id: 562458, name: "Anandnagar" },
      { id: 562471, name: "Babhulgaon" },
      { id: 562508, name: "Bacheri" },
      { id: 562460, name: "Bagewadi" },
      { id: 562405, name: "Bangarde" },
      { id: 562435, name: "Bhamb" },
      { id: 562431, name: "Bhamburdi" },
      { id: 562467, name: "Bijvadi" },
      { id: 562496, name: "Bondale" },
      { id: 562480, name: "Borgaon" },
      { id: 562454, name: "Chakore" },
      { id: 562499, name: "Chandapuri" },
      { id: 562462, name: "Chaundeshwarwadi" },
      { id: 562408, name: "Dahigaon" },
      { id: 562497, name: "Dasur" },
      { id: 562486, name: "Dattanagar (Khandali)" },
      { id: 562398, name: "Deshmukhwadi" },
      { id: 562494, name: "Dhanore" },
      { id: 562410, name: "Dharmpuri" },
      { id: 562399, name: "Dombalwadi" },
      { id: 562444, name: "Dombalwadi (Khudus)" },
      { id: 562403, name: "Ekshiv" },
      { id: 562419, name: "Fadtari" },
      { id: 562506, name: "Falawani" },
      { id: 562413, name: "Fondshiras" },
      { id: 562469, name: "Ganeshgaon" },
      { id: 562452, name: "Garwad" },
      { id: 945358, name: "Ghulenagar" },
      { id: 562434, name: "Giravi" },
      { id: 562461, name: "Girzani" },
      { id: 562447, name: "Goradwadi" },
      { id: 562409, name: "Gursale" },
      { id: 562448, name: "Islampur" },
      { id: 562432, name: "Jadhavwadi" },
      { id: 562450, name: "Jalbhavi" },
      { id: 562484, name: "Jambud" },
      { id: 562438, name: "Kacharewadi" },
      { id: 562415, name: "Kadamwadi" },
      { id: 562404, name: "Kalamboli" },
      { id: 562507, name: "Kalamwadi" },
      { id: 562433, name: "Kanher" },
      { id: 562411, name: "Karunde" },
      { id: 562485, name: "Khalawe" },
      { id: 562487, name: "Khandali" },
      { id: 562443, name: "Khudus" },
      { id: 562510, name: "Kolegaon" },
      { id: 562456, name: "Kondabavi" },
      { id: 562478, name: "Kondharpatta" },
      { id: 562418, name: "Kothale" },
      { id: 562401, name: "Kurbavi" },
      { id: 562500, name: "Kusmod" },
      { id: 562474, name: "Lawang" },
      { id: 562423, name: "Lonand" },
      { id: 562422, name: "Londhe Mohitewadi" },
      { id: 562453, name: "Magarwadi (Garwad)" },
      { id: 562475, name: "Mahalung" },
      { id: 562464, name: "Malewadi (A)" },
      { id: 562481, name: "Malewadi (Borgaon))" },
      { id: 562465, name: "Malinagar" },
      { id: 562482, name: "Malkhambi" },
      { id: 562492, name: "Maloli" },
      { id: 562439, name: "Malshiras" },
      { id: 562449, name: "Mandaki" },
      { id: 562427, name: "Mandave" },
      { id: 562416, name: "Markadwadi" },
      { id: 562425, name: "Medad" },
      { id: 562476, name: "Mire" },
      { id: 562412, name: "Morochi" },
      { id: 562414, name: "Motewadi (Fondshiras)" },
      { id: 562446, name: "Motewadi (Malshiras)" },
      { id: 562511, name: "Natepute" },
      { id: 562479, name: "Neware" },
      { id: 562491, name: "Nimgaon" },
      { id: 562421, name: "Nitavewadi (Fadtari)" },
      { id: 562406, name: "Palasmandal" },
      { id: 562440, name: "Paniv" },
      { id: 562498, name: "Pathanwasti" },
      { id: 562503, name: "Piliv" },
      { id: 562417, name: "Pimpari" },
      { id: 562407, name: "Pirale" },
      { id: 562490, name: "Pisewadi" },
      { id: 562455, name: "Pratapnagar (Chakore)" },
      { id: 562429, name: "Purandawade" },
      { id: 562436, name: "Rede" },
      { id: 562428, name: "Sadashivnagar" },
      { id: 562504, name: "Salmukhwadi" },
      { id: 562470, name: "Sangam" },
      { id: 562466, name: "Savatgavhan" },
      { id: 562493, name: "Shendechinch" },
      { id: 562397, name: "Shindewadi" },
      { id: 562509, name: "Shingorni" },
      { id: 562420, name: "Shiwarvasti (Fadtari)" },
      { id: 562502, name: "Sulewadi" },
      { id: 562468, name: "Tambave" },
      { id: 562402, name: "Tambewadi" },
      { id: 562426, name: "Tamsidwadi" },
      { id: 562505, name: "Tandulwadi" },
      { id: 562451, name: "Tarangfal" },
      { id: 562437, name: "Tirwandi" },
      { id: 562495, name: "Tondale" },
      { id: 562488, name: "Ughadewadi" },
      { id: 562477, name: "Umbare (Velapur)" },
      { id: 562424, name: "Umbare Dahigaon" },
      { id: 562489, name: "Velapur" },
      { id: 562442, name: "Vijaywadi" },
      { id: 562483, name: "Vithalwadi" },
      { id: 562463, name: "Vizori" },
      { id: 562472, name: "Wafegaon" },
      { id: 562473, name: "Wagholi" },
      { id: 562459, name: "Yashawantnagar" },
      { id: 562430, name: "Yeliv" },
      { id: 562445, name: "Zanjewadi" },
      { id: 562501, name: "Zinjevasti" },
    ],
    4251: [
      { id: 562524, name: "Achakadani" },
      { id: 562606, name: "Aglavewadi" },
      { id: 562559, name: "Ajanale" },
      { id: 562587, name: "Akola" },
      { id: 562601, name: "Alegaon" },
      { id: 562564, name: "Ankadhal" },
      { id: 562529, name: "Bagalwadi" },
      { id: 562562, name: "Balvadi" },
      { id: 562543, name: "Bamani" },
      { id: 562571, name: "Bandgarwadi" },
      { id: 562607, name: "Bhopasewadi" },
      { id: 562574, name: "Buddhehal" },
      { id: 562551, name: "Buralewadi" },
      { id: 562605, name: "Burange Wadi" },
      { id: 562518, name: "Chikmahud" },
      { id: 562560, name: "Chinake" },
      { id: 562548, name: "Chincholi" },
      { id: 562572, name: "Chopadi" },
      { id: 562545, name: "Devale" },
      { id: 562539, name: "Devkatewadi" },
      { id: 562538, name: "Dhayati" },
      { id: 562613, name: "Diksal" },
      { id: 562598, name: "Dongargaon" },
      { id: 562547, name: "Ekhatapur" },
      { id: 562600, name: "Galavewadi" },
      { id: 562610, name: "Gavadewadi" },
      { id: 562531, name: "Gaygavhan" },
      { id: 562609, name: "Gheradi" },
      { id: 562555, name: "Godasewadi" },
      { id: 562576, name: "Goudwadi" },
      { id: 562581, name: "Gunappawadi" },
      { id: 562614, name: "Habisewadi" },
      { id: 562535, name: "Haldahivadi" },
      { id: 562611, name: "Hangirage" },
      { id: 562591, name: "Hanmantgaon" },
      { id: 562596, name: "Hatid" },
      { id: 562597, name: "Hatkar Mangewadi" },
      { id: 562514, name: "Itaki" },
      { id: 562604, name: "Javala" },
      { id: 562580, name: "Jujarpur" },
      { id: 562526, name: "Juni Lotewadi" },
      { id: 562579, name: "Junoni" },
      { id: 562588, name: "Kadlas" },
      { id: 562582, name: "Kalubaluwadi" },
      { id: 562556, name: "Kamalapur" },
      { id: 562577, name: "Karadwadi" },
      { id: 562519, name: "Karandewadi" },
      { id: 562575, name: "Karandewadi (Utanwadi)" },
      { id: 562567, name: "Karandewadi Budhdehal" },
      { id: 562515, name: "Katfal" },
      { id: 562525, name: "Khavaspur" },
      { id: 562532, name: "Khilarwadi" },
      { id: 562586, name: "Kidebisari" },
      { id: 562578, name: "Kola" },
      { id: 562584, name: "Kombadwadi" },
      { id: 562523, name: "Laxminagar (D.Wadi)" },
      { id: 562558, name: "Ligadewadi" },
      { id: 562590, name: "Lonavire" },
      { id: 562527, name: "Lotewadi" },
      { id: 562520, name: "Mahim" },
      { id: 562521, name: "Mahud Bk." },
      { id: 562592, name: "Manegaon" },
      { id: 562542, name: "Manjari" },
      { id: 562552, name: "Medashingi" },
      { id: 562537, name: "Metakarwadi" },
      { id: 562541, name: "Methvade" },
      { id: 562593, name: "Misalwadi" },
      { id: 562594, name: "Nalvadewadi" },
      { id: 562615, name: "Narale" },
      { id: 562533, name: "Naralewadi" },
      { id: 562563, name: "Nazare" },
      { id: 562589, name: "Nijampur" },
      { id: 562585, name: "Pachegaon Bk." },
      { id: 562595, name: "Pachegaon Kh." },
      { id: 562612, name: "Pare" },
      { id: 562550, name: "Rajapur" },
      { id: 562566, name: "Rajuri" },
      { id: 562540, name: "Sangewadi" },
      { id: 944187, name: "Sangola" },
      { id: 945187, name: "Sangola 1" },
      { id: 562568, name: "Saragarwadi" },
      { id: 562544, name: "Save" },
      { id: 562536, name: "Shirbavi" },
      { id: 562546, name: "Shivane" },
      { id: 562573, name: "Somewadi" },
      { id: 562530, name: "Sonalwadi" },
      { id: 562599, name: "Sonand" },
      { id: 562608, name: "Tarangewadi" },
      { id: 562583, name: "Tippehali" },
      { id: 562570, name: "Udanwadi" },
      { id: 562554, name: "Vasud" },
      { id: 562561, name: "Vazare" },
      { id: 562549, name: "Wadegaon" },
      { id: 562603, name: "Waki Gherdi" },
      { id: 562534, name: "Waki Shivane" },
      { id: 562602, name: "Wani Chinchale" },
      { id: 562565, name: "Watambare" },
      { id: 562557, name: "Yelmar Mangewadi" },
      { id: 562569, name: "Zapachiwadi" },
    ],
    4252: [
      { id: 562623, name: "Akole" },
      { id: 562655, name: "Andhalgaon" },
      { id: 562647, name: "Arali" },
      { id: 562694, name: "Asabewadi" },
      { id: 562629, name: "Bathan" },
      { id: 562688, name: "Bavachi" },
      { id: 562645, name: "Bhalewadi" },
      { id: 562652, name: "Bhalwani" },
      { id: 562671, name: "Bhose" },
      { id: 562635, name: "Borale" },
      { id: 562630, name: "Bramhapuri" },
      { id: 562675, name: "Chikhalgi" },
      { id: 562622, name: "Degaon" },
      { id: 562626, name: "Dharamgaon" },
      { id: 562621, name: "Dhavalas" },
      { id: 562650, name: "Diksal" },
      { id: 562646, name: "Donaj" },
      { id: 562640, name: "Dongargaon" },
      { id: 562641, name: "Fatewadi" },
      { id: 562656, name: "Ganeshwadi" },
      { id: 562619, name: "Gharniki" },
      { id: 562661, name: "Gonewadi" },
      { id: 562617, name: "Gunjegaon" },
      { id: 562664, name: "Hajapur" },
      { id: 562642, name: "Hivargaon" },
      { id: 562685, name: "Huljanti" },
      { id: 562673, name: "Hunnur" },
      { id: 562665, name: "Jalihal" },
      { id: 562689, name: "Jangalgi" },
      { id: 562653, name: "Jitti" },
      { id: 562662, name: "Junoni" },
      { id: 562639, name: "Kacharewadi" },
      { id: 562682, name: "Kagasht" },
      { id: 562684, name: "Karjal" },
      { id: 562683, name: "Katral" },
      { id: 562666, name: "Khadaki" },
      { id: 562654, name: "Khave" },
      { id: 562643, name: "Khomnal" },
      { id: 562658, name: "Khupsangi" },
      { id: 562681, name: "Lamantanda" },
      { id: 562696, name: "Lavangi" },
      { id: 562625, name: "Laxami Dahiwadi" },
      { id: 562659, name: "Lendave Chichale" },
      { id: 562679, name: "Lonar" },
      { id: 562631, name: "Machanur" },
      { id: 562677, name: "Mahamadabad (Hunnar)" },
      { id: 562616, name: "Mahamadabad (Shetfal)" },
      { id: 562686, name: "Malewadi" },
      { id: 562620, name: "Mallewadi" },
      { id: 562672, name: "Manewadi" },
      { id: 562638, name: "Mangalvedha" },
      { id: 562618, name: "Marapur" },
      { id: 562649, name: "Maravade" },
      { id: 562676, name: "Maroli" },
      { id: 562663, name: "Metkarwadi" },
      { id: 562627, name: "Mudhavi" },
      { id: 562637, name: "Mundhewadi" },
      { id: 562667, name: "Nandeshwar" },
      { id: 562648, name: "Nandur" },
      { id: 562669, name: "Nimboni" },
      { id: 562680, name: "Padolkarwadi" },
      { id: 562657, name: "Patkhal" },
      { id: 562687, name: "Pout" },
      { id: 562670, name: "Radde" },
      { id: 562636, name: "Rahatewadi" },
      { id: 562678, name: "Revewadi" },
      { id: 562695, name: "Salagar Bk." },
      { id: 562690, name: "Salagar Kh." },
      { id: 912927, name: "Sant Chokhamela Nagar" },
      { id: 912928, name: "Sant Damaji Nagar" },
      { id: 562624, name: "Shelewadi" },
      { id: 562660, name: "Shirashi" },
      { id: 562674, name: "Shirnandgi" },
      { id: 562693, name: "Shivangi" },
      { id: 562668, name: "Siddhankeri" },
      { id: 562634, name: "Sidhdapur" },
      { id: 562692, name: "Soddi" },
      { id: 562644, name: "Talsangi" },
      { id: 562632, name: "Tamdardi" },
      { id: 562633, name: "Tandor" },
      { id: 562628, name: "Uchethan" },
      { id: 562651, name: "Yedrav" },
      { id: 562691, name: "Yelagi" },
    ],
    4253: [
      { id: 562703, name: "(Baxi)Hipparge" },
      { id: 562727, name: "Achegaon" },
      { id: 562741, name: "Aherwadi" },
      { id: 562770, name: "Akole Mandrup" },
      { id: 562730, name: "Alegaon" },
      { id: 562775, name: "Antroli" },
      { id: 562728, name: "Auj Aherwadi" },
      { id: 562761, name: "Auj Mandrup" },
      { id: 562755, name: "Aurad" },
      { id: 562787, name: "Balgi" },
      { id: 562765, name: "Bandalgi" },
      { id: 562745, name: "Bankalgi" },
      { id: 562764, name: "Barur" },
      { id: 562756, name: "Basav Nagar" },
      { id: 562780, name: "Bhandar Kavathe" },
      { id: 562754, name: "Birnal" },
      { id: 562766, name: "Bolkavathe" },
      { id: 562707, name: "Boramani" },
      { id: 562746, name: "Borul" },
      { id: 562737, name: "Chandrahal" },
      { id: 562763, name: "Chinchpur" },
      { id: 562712, name: "Darganhalli" },
      { id: 562714, name: "Dhotri" },
      { id: 562722, name: "Dindur" },
      { id: 562706, name: "Doddi" },
      { id: 562697, name: "Gangewadi" },
      { id: 562773, name: "Gavadewadi" },
      { id: 562736, name: "Ghodatanda" },
      { id: 945403, name: "Godutai Parulekarnagar" },
      { id: 562769, name: "Gunjegaon" },
      { id: 562719, name: "Gurdehalli" },
      { id: 562725, name: "Hanamgaon" },
      { id: 562767, name: "Hattarsang" },
      { id: 562735, name: "Hattur" },
      { id: 562740, name: "Hipale" },
      { id: 562753, name: "Honmurgi" },
      { id: 562733, name: "Hotgi" },
      { id: 562739, name: "Hotgi Station" },
      { id: 562748, name: "Ingalgi" },
      { id: 562747, name: "Kanbas" },
      { id: 562774, name: "Kandalgaon" },
      { id: 562717, name: "Kardehalli" },
      { id: 562760, name: "Karkal" },
      { id: 562698, name: "Kasegaon" },
      { id: 562778, name: "Khanapur" },
      { id: 562768, name: "Kudal" },
      { id: 562716, name: "Kumbhari" },
      { id: 562758, name: "Kurghot" },
      { id: 562777, name: "Kusur" },
      { id: 562785, name: "Lavangi" },
      { id: 562721, name: "Limbi Chincholi" },
      { id: 562738, name: "Madre" },
      { id: 562759, name: "Malkavathe" },
      { id: 562751, name: "Mandrup" },
      { id: 562771, name: "Mangoli" },
      { id: 562705, name: "Mulegaon" },
      { id: 562704, name: "Mulegaon Tanda" },
      { id: 562711, name: "Musti" },
      { id: 562757, name: "Nandani" },
      { id: 562784, name: "Nimbargi" },
      { id: 562732, name: "Phatatewadi" },
      { id: 562708, name: "Pinjarwadi" },
      { id: 562743, name: "Rajur" },
      { id: 562720, name: "Rampur" },
      { id: 562786, name: "Sadepur" },
      { id: 562710, name: "Sangdari" },
      { id: 562744, name: "Sanjwad" },
      { id: 562734, name: "Savatkhed" },
      { id: 562782, name: "Shankar Nagar" },
      { id: 562726, name: "Shingadgaon" },
      { id: 562713, name: "Shirpanhalli" },
      { id: 562749, name: "Shirval" },
      { id: 562742, name: "Sindkhed" },
      { id: 562762, name: "Takali" },
      { id: 562709, name: "Tandulwadi" },
      { id: 562779, name: "Telgaon Mandrup" },
      { id: 562729, name: "Tillehal" },
      { id: 562723, name: "Tirth" },
      { id: 562718, name: "Togarali" },
      { id: 562699, name: "Ule" },
      { id: 562700, name: "Ulewadi" },
      { id: 562750, name: "Vadakbal" },
      { id: 562776, name: "Vadapur" },
      { id: 562724, name: "Valsang" },
      { id: 562781, name: "Vinchur" },
      { id: 562715, name: "Wadgaon" },
      { id: 562701, name: "Wadji" },
      { id: 562772, name: "Wangi" },
      { id: 562702, name: "Waralegaon" },
      { id: 562783, name: "Yelegaon" },
      { id: 562731, name: "Yetnal" },
    ],
    4254: [
      { id: 562860, name: "Akatnal" },
      { id: 562839, name: "Akkalkot (Rural)" },
      { id: 562804, name: "Alage" },
      { id: 562918, name: "Andewadi (Jahangir )" },
      { id: 562825, name: "Andewadi Bk" },
      { id: 562821, name: "Andewadi Kh" },
      { id: 562800, name: "Ankalage" },
      { id: 562849, name: "Arali" },
      { id: 562922, name: "Babalad" },
      { id: 562877, name: "Badole Bk" },
      { id: 562878, name: "Badole Kh" },
      { id: 562884, name: "Banajgol" },
      { id: 562862, name: "Barhanpur" },
      { id: 562848, name: "Basalegaon" },
      { id: 562866, name: "Basavgir" },
      { id: 562864, name: "Bavkarwadi" },
      { id: 562887, name: "Bhosage" },
      { id: 562871, name: "Bhurikavathe" },
      { id: 562907, name: "Binjger" },
      { id: 562851, name: "Boregaon" },
      { id: 562875, name: "Borgaon" },
      { id: 562914, name: "Boroti Bk" },
      { id: 562919, name: "Boroti Kh." },
      { id: 562833, name: "Byagehalli" },
      { id: 562829, name: "Chapalgaonwadi" },
      { id: 562863, name: "Chappalgaon" },
      { id: 562885, name: "Chikkeahalli" },
      { id: 562917, name: "Chincholi (M)" },
      { id: 562788, name: "Chincholi (Najik)" },
      { id: 562858, name: "Chungi" },
      { id: 562835, name: "Dahitane" },
      { id: 562830, name: "Dahitanewadi" },
      { id: 562850, name: "Darshanal" },
      { id: 562822, name: "Devikavathe" },
      { id: 562802, name: "Dharsang" },
      { id: 562809, name: "Dodyal" },
      { id: 562861, name: "Dombar-Jawalge" },
      { id: 562924, name: "Dudhani (Rural)" },
      { id: 562898, name: "Galoragi" },
      { id: 946161, name: "Gandhinagar Solse Lamantanda" },
      { id: 562813, name: "Gaudgaon Bk." },
      { id: 562869, name: "Gholasgaon" },
      { id: 562820, name: "Ghungaregaon" },
      { id: 562873, name: "Gogaon" },
      { id: 562892, name: "Goudgaon Kh." },
      { id: 562805, name: "Guddewadi" },
      { id: 562816, name: "Guravwadi" },
      { id: 562904, name: "Haidre" },
      { id: 562806, name: "Halchincholi" },
      { id: 562828, name: "Halhalli (Akkalkot)" },
      { id: 562906, name: "Halhalli (Maidargi)" },
      { id: 562812, name: "Handral" },
      { id: 562807, name: "Hanjagi" },
      { id: 562859, name: "Hannur" },
      { id: 562834, name: "Hasapur" },
      { id: 562890, name: "Hattikanbas" },
      { id: 562824, name: "Hilli" },
      { id: 562843, name: "Hingani" },
      { id: 562909, name: "Ibrahimpur" },
      { id: 562894, name: "Itage" },
      { id: 562811, name: "Jainapur" },
      { id: 562899, name: "Jakapur" },
      { id: 562808, name: "Jeur" },
      { id: 562810, name: "Jeurwadi" },
      { id: 562814, name: "Kadabgaon" },
      { id: 562855, name: "Kajikanbas" },
      { id: 562913, name: "Kalappawadi" },
      { id: 562844, name: "Kalegaon" },
      { id: 562818, name: "Kalhipparage" },
      { id: 562801, name: "Kalkarjal" },
      { id: 562897, name: "Kanthehalli" },
      { id: 562790, name: "Karajagi" },
      { id: 562831, name: "Karjal" },
      { id: 562793, name: "Kegaon Bk" },
      { id: 562792, name: "Kegaon Kh." },
      { id: 562872, name: "Khairat" },
      { id: 562799, name: "Khanapur" },
      { id: 562857, name: "Kini" },
      { id: 562856, name: "Kiniwadi" },
      { id: 562870, name: "Kirnalli" },
      { id: 562842, name: "Kolibet" },
      { id: 562832, name: "Konhali" },
      { id: 562795, name: "Korsegaon" },
      { id: 562823, name: "Kudal" },
      { id: 562794, name: "Kumthe" },
      { id: 562865, name: "Kurnur" },
      { id: 562900, name: "Maindargi (Rural)" },
      { id: 562845, name: "Mamdabad" },
      { id: 562791, name: "Mangrul" },
      { id: 562827, name: "Marathwadi" },
      { id: 562847, name: "Matanhalli" },
      { id: 562798, name: "Mhaisalage" },
      { id: 562896, name: "Mirajgi" },
      { id: 562868, name: "Motyal" },
      { id: 562910, name: "Mugali" },
      { id: 562796, name: "Mundhewadi" },
      { id: 562846, name: "Naganhalli" },
      { id: 562826, name: "Nagansur" },
      { id: 562908, name: "Nagore" },
      { id: 562853, name: "Nanhegaon" },
      { id: 562817, name: "Navindgi" },
      { id: 562891, name: "Nimgaon" },
      { id: 562876, name: "Palapur" },
      { id: 562852, name: "Pitapur" },
      { id: 562893, name: "Rampur" },
      { id: 562902, name: "Ramtirth" },
      { id: 562916, name: "Ruddewadi" },
      { id: 562883, name: "Sadalapur" },
      { id: 562881, name: "Safale" },
      { id: 562886, name: "Salgar" },
      { id: 562840, name: "Samarthnagar." },
      { id: 562837, name: "Sangavi Bk" },
      { id: 562838, name: "Sangavi Kh" },
      { id: 562911, name: "Sangogi (B)" },
      { id: 562889, name: "Sangogi Aland" },
      { id: 562905, name: "Satan Dudhani" },
      { id: 562815, name: "Sevalalnagar" },
      { id: 562819, name: "Shawal" },
      { id: 562803, name: "Shegaon" },
      { id: 562882, name: "Shirasi" },
      { id: 562880, name: "Shirwal" },
      { id: 562879, name: "Shirwalwadi" },
      { id: 562867, name: "Sindkhed" },
      { id: 562927, name: "Sinnur" },
      { id: 562789, name: "Sulerjawalage" },
      { id: 562854, name: "Sultanpur" },
      { id: 562797, name: "Tadwal" },
      { id: 562912, name: "Talewad" },
      { id: 562903, name: "Tolnur" },
      { id: 562888, name: "Torani" },
      { id: 562901, name: "Udagi" },
      { id: 562895, name: "Umarge" },
      { id: 562841, name: "Vasantrao Naiknagar" },
      { id: 562874, name: "Wagdari" },
    ],
    4255: [
      { id: 562989, name: "Achali" },
      { id: 562979, name: "Adhal" },
      { id: 563017, name: "Ahir" },
      { id: 563035, name: "Akalpe" },
      { id: 562963, name: "Ambral" },
      { id: 562998, name: "Amshi" },
      { id: 563031, name: "Araw" },
      { id: 562930, name: "Avakali" },
      { id: 563005, name: "Awalan" },
      { id: 562955, name: "Bhekavali" },
      { id: 562965, name: "Bhilar" },
      { id: 562957, name: "Bhose" },
      { id: 562943, name: "Birmani" },
      { id: 562945, name: "Birwadi" },
      { id: 563029, name: "Chakdev" },
      { id: 562950, name: "Chaturbet" },
      { id: 562975, name: "Chikhali" },
      { id: 562983, name: "Dabhe Mohan" },
      { id: 562984, name: "Dabhedabhekar" },
      { id: 562960, name: "Dandeghar" },
      { id: 562971, name: "Danvali" },
      { id: 562932, name: "Dare" },
      { id: 563034, name: "Dere Tarfe Tamb" },
      { id: 562953, name: "Devali" },
      { id: 562990, name: "Devasare" },
      { id: 563019, name: "Dhangarwadi" },
      { id: 562980, name: "Dhardev" },
      { id: 563021, name: "Dhawali" },
      { id: 563024, name: "Dodani" },
      { id: 562949, name: "Dudhgaon" },
      { id: 562940, name: "Dudhoshi" },
      { id: 563018, name: "Gadhavali" },
      { id: 563004, name: "Gavadhoshi" },
      { id: 562977, name: "Ghavari" },
      { id: 562951, name: "Ghonaspur" },
      { id: 562961, name: "Godavali" },
      { id: 563008, name: "Gogave" },
      { id: 562948, name: "Goroshi" },
      { id: 562956, name: "Gureghar" },
      { id: 563003, name: "Harchandi" },
      { id: 562938, name: "Haroshi" },
      { id: 562947, name: "Hatlot" },
      { id: 562933, name: "Jaoli" },
      { id: 562954, name: "Kalamgaon" },
      { id: 562986, name: "Kalamgaon Kalamkar" },
      { id: 563022, name: "Kandat" },
      { id: 562946, name: "Kasrud" },
      { id: 562972, name: "Kaswand" },
      { id: 563002, name: "Khambil Chorge" },
      { id: 562999, name: "Khambil Pokale" },
      { id: 562995, name: "Kharoshi" },
      { id: 562962, name: "Khingar" },
      { id: 562994, name: "Kotroshi" },
      { id: 562928, name: "Kshetra Mahabaleshwar" },
      { id: 562934, name: "Kumbharoshi" },
      { id: 562942, name: "Kumthe" },
      { id: 563000, name: "Kuroshi" },
      { id: 563001, name: "Lakhwad" },
      { id: 563032, name: "Lamaj" },
      { id: 562970, name: "Machutar" },
      { id: 562991, name: "Majarewadi" },
      { id: 944602, name: "Malkampeth" },
      { id: 562968, name: "Malusar" },
      { id: 562967, name: "Manghar" },
      { id: 562939, name: "Met Taliye" },
      { id: 562931, name: "Metgutad" },
      { id: 563037, name: "Mhalunge" },
      { id: 562973, name: "Moleshwar" },
      { id: 563036, name: "Morni" },
      { id: 562929, name: "Nakinda" },
      { id: 562969, name: "Navali" },
      { id: 563033, name: "Nivali" },
      { id: 563012, name: "Pali T. Ategaon" },
      { id: 912846, name: "Panchgani" },
      { id: 562958, name: "Pangari" },
      { id: 562941, name: "Parpar" },
      { id: 562936, name: "Parsond" },
      { id: 562976, name: "Parut" },
      { id: 563027, name: "Parwat T. Wagawale" },
      { id: 562937, name: "Petpar" },
      { id: 563038, name: "Pimpri T. Tamb" },
      { id: 562964, name: "Rajpuri" },
      { id: 563011, name: "Rameghar" },
      { id: 562935, name: "Ran Adva Gaund" },
      { id: 562996, name: "Renoshi" },
      { id: 562997, name: "Rule" },
      { id: 563025, name: "Saloshi" },
      { id: 563030, name: "Shindi" },
      { id: 562966, name: "Shindola" },
      { id: 562944, name: "Shiravali" },
      { id: 562985, name: "Shirnar" },
      { id: 562993, name: "Sonat" },
      { id: 562992, name: "Soundari" },
      { id: 562959, name: "Taighat" },
      { id: 562982, name: "Taldev" },
      { id: 563016, name: "Tapola" },
      { id: 562974, name: "Tekavali" },
      { id: 563026, name: "Uchat" },
      { id: 563020, name: "Umbari" },
      { id: 563028, name: "Valawan" },
      { id: 563015, name: "Vanavli T. Ategaon" },
      { id: 563014, name: "Vanavli Tarf Solasi" },
      { id: 563010, name: "Varsoli Dev" },
      { id: 563009, name: "Varsoli Koli" },
      { id: 563006, name: "Velapur" },
      { id: 563007, name: "Vengale" },
      { id: 562981, name: "Vivar" },
      { id: 563013, name: "Walne" },
      { id: 562978, name: "Yerandal" },
      { id: 562987, name: "Yerne Bk" },
      { id: 562988, name: "Yerne Kh" },
      { id: 563023, name: "Zadani" },
      { id: 562952, name: "Zanzwad" },
    ],
    4256: [
      { id: 563048, name: "Abhepuri" },
      { id: 563109, name: "Akoshi" },
      { id: 563042, name: "Ambedarawadi" },
      { id: 563135, name: "Amrutwadi" },
      { id: 563142, name: "Anavadi" },
      { id: 563126, name: "Anpatwadi" },
      { id: 563062, name: "Asagaon" },
      { id: 563134, name: "Asale" },
      { id: 563051, name: "Asare" },
      { id: 563100, name: "Balakavadi" },
      { id: 563077, name: "Baleghar" },
      { id: 563127, name: "Bavdhan" },
      { id: 563152, name: "Belamachi" },
      { id: 563060, name: "Bhivadi" },
      { id: 946118, name: "Bhivadi Punarvasit" },
      { id: 563070, name: "Bhogaon" },
      { id: 563144, name: "Bhuinj" },
      { id: 563088, name: "Bopardi" },
      { id: 563141, name: "Bopegaon" },
      { id: 563105, name: "Borgaon Bk." },
      { id: 563106, name: "Borgaon Kh." },
      { id: 563114, name: "Boriv" },
      { id: 563079, name: "Chandak" },
      { id: 563157, name: "Chandvadi" },
      { id: 563121, name: "Chikhali" },
      { id: 563154, name: "Chindhawali" },
      { id: 563103, name: "Dahyat" },
      { id: 563125, name: "Darewadi" },
      { id: 563120, name: "Dasvadi" },
      { id: 563148, name: "Degaon" },
      { id: 563068, name: "Dhavadi" },
      { id: 563107, name: "Dhavali" },
      { id: 563064, name: "Dhom" },
      { id: 563043, name: "Duichivadi" },
      { id: 563116, name: "Ekasar" },
      { id: 563047, name: "Gadhavewadi" },
      { id: 563040, name: "Gherakelanja" },
      { id: 563097, name: "Golegaon" },
      { id: 563098, name: "Golewadi" },
      { id: 563061, name: "Gove" },
      { id: 563161, name: "Govedigar" },
      { id: 563080, name: "Gulumb" },
      { id: 563067, name: "Gundewadi" },
      { id: 563159, name: "Jamb" },
      { id: 563039, name: "Jambhali" },
      { id: 563129, name: "Jambhulane" },
      { id: 563096, name: "Jor" },
      { id: 563132, name: "Kadegaon" },
      { id: 563138, name: "Kalambhe" },
      { id: 563162, name: "Kalangwadi" },
      { id: 563124, name: "Kanur" },
      { id: 563095, name: "Kawathe" },
      { id: 563085, name: "Kenjal" },
      { id: 563156, name: "Khadaki" },
      { id: 563151, name: "Khalachi Belmachi" },
      { id: 563093, name: "Khanapur" },
      { id: 563054, name: "Khavali" },
      { id: 563163, name: "Kholvadi" },
      { id: 563153, name: "Kikali" },
      { id: 563057, name: "Kironde" },
      { id: 563046, name: "Kochalewadi" },
      { id: 563058, name: "Kondhavale" },
      { id: 563108, name: "Kondhavali Bk" },
      { id: 563110, name: "Kondhavali Kh" },
      { id: 563118, name: "Kusgaon" },
      { id: 563150, name: "Logadwadi" },
      { id: 563089, name: "Lohare" },
      { id: 563111, name: "Malatpur" },
      { id: 563131, name: "Malusurewadi" },
      { id: 563045, name: "Mandhardeo" },
      { id: 563149, name: "Maparwadi Wakanvadi" },
      { id: 563071, name: "Menavali" },
      { id: 563082, name: "Mohodekarwadi" },
      { id: 563112, name: "Mugaon" },
      { id: 563086, name: "Mungasewadi" },
      { id: 563123, name: "Nagewadi" },
      { id: 563101, name: "Nandgane" },
      { id: 563113, name: "Nhalewadi" },
      { id: 563160, name: "Nikamwadi" },
      { id: 563041, name: "Oholi" },
      { id: 563140, name: "Ozarde" },
      { id: 563050, name: "Pachputewadi" },
      { id: 563052, name: "Panas" },
      { id: 563136, name: "Panchwad" },
      { id: 563094, name: "Pande" },
      { id: 563066, name: "Pandewadi" },
      { id: 563128, name: "Pandharechiwadi" },
      { id: 563104, name: "Paratavadi" },
      { id: 563090, name: "Parkhandi" },
      { id: 563117, name: "Pasarni" },
      { id: 563069, name: "Pirachiwadi" },
      { id: 946120, name: "Punarvasit Dhom" },
      { id: 563164, name: "Rautwadi" },
      { id: 563053, name: "Renawale" },
      { id: 563087, name: "Satalewadi" },
      { id: 563072, name: "Shelarwadi" },
      { id: 563091, name: "Shendurjane" },
      { id: 563143, name: "Shirgaon" },
      { id: 563073, name: "Sidhdanathwadi" },
      { id: 563165, name: "Songirwadi" },
      { id: 563092, name: "Sultanpur" },
      { id: 563084, name: "Surur" },
      { id: 563137, name: "Udatare" },
      { id: 563099, name: "Ulumb" },
      { id: 563055, name: "Vadoli" },
      { id: 563083, name: "Vahagaon" },
      { id: 563102, name: "Vaigaon" },
      { id: 563065, name: "Varkhadwadi" },
      { id: 563059, name: "Vasole" },
      { id: 563063, name: "Velang" },
      { id: 563081, name: "Vele" },
      { id: 563139, name: "Virmade" },
      { id: 563119, name: "Vithalwadi" },
      { id: 563115, name: "Vyahali" },
      { id: 563133, name: "Vyahali Punervasan" },
      { id: 563130, name: "Vyajawadi" },
      { id: 563049, name: "Wadachiwadi" },
      { id: 563122, name: "Wadkarwadi" },
      { id: 563075, name: "Wai (Rural)" },
      { id: 563056, name: "Washivali" },
      { id: 563044, name: "Yeruli" },
    ],
    4257: [
      { id: 563223, name: "Ahire" },
      { id: 563204, name: "Ajnuj" },
      { id: 563205, name: "Ambarwadi" },
      { id: 563214, name: "Andori" },
      { id: 563206, name: "Asawali" },
      { id: 563182, name: "Atit" },
      { id: 563213, name: "Balu Patlachiwadi" },
      { id: 563198, name: "Bavda" },
      { id: 563211, name: "Bavkalwadi" },
      { id: 563196, name: "Bhadavade" },
      { id: 563216, name: "Bhade" },
      { id: 563166, name: "Bhatghar" },
      { id: 563193, name: "Bholi" },
      { id: 563227, name: "Bori" },
      { id: 946124, name: "Dapakeghar (Punarv)" },
      { id: 946122, name: "Devghar (Punarvasit)" },
      { id: 563176, name: "Dhangarwadi" },
      { id: 563224, name: "Dhawadwadi" },
      { id: 563188, name: "Ghadgewadi" },
      { id: 563226, name: "Ghatdare" },
      { id: 946117, name: "Golegaon (Punarvasit)" },
      { id: 563170, name: "Guthalwadi" },
      { id: 563225, name: "Harali" },
      { id: 563203, name: "Haripur" },
      { id: 563168, name: "Hartali" },
      { id: 563185, name: "Javale" },
      { id: 563183, name: "Kanhavadi" },
      { id: 563207, name: "Kanheri" },
      { id: 563219, name: "Karadwadi" },
      { id: 563184, name: "Karnavadi" },
      { id: 563186, name: "Kavathe" },
      { id: 563199, name: "Kesurdi" },
      { id: 563201, name: "Khandala" },
      { id: 563221, name: "Khed Bk." },
      { id: 563231, name: "Koparde" },
      { id: 563190, name: "Limbachiwadi" },
      { id: 563187, name: "Lohom" },
      { id: 563232, name: "Lonand" },
      { id: 563192, name: "Loni" },
      { id: 563194, name: "Manecolony" },
      { id: 563220, name: "Mariachiwadi" },
      { id: 563202, name: "Mhavashi" },
      { id: 563181, name: "Mirje" },
      { id: 563178, name: "Moh Tarf Shirwal" },
      { id: 563217, name: "Morve" },
      { id: 563179, name: "Naigaon" },
      { id: 563230, name: "Nimbodi" },
      { id: 563229, name: "Padali" },
      { id: 563212, name: "Padegaon" },
      { id: 563174, name: "Palashi" },
      { id: 563200, name: "Pargaon" },
      { id: 563210, name: "Pimpare Bk." },
      { id: 563177, name: "Pisalwadi" },
      { id: 563167, name: "Rajewadi" },
      { id: 563209, name: "Rui" },
      { id: 946123, name: "Salav (Punarvasit)" },
      { id: 563175, name: "Sangvi" },
      { id: 563215, name: "Shedgewadi" },
      { id: 563195, name: "Shekhmirwadi" },
      { id: 563172, name: "Shindewadi" },
      { id: 563173, name: "Shirwal" },
      { id: 563197, name: "Shivajinagar" },
      { id: 563222, name: "Sukhed" },
      { id: 563191, name: "Tondal" },
      { id: 563180, name: "Vadgaon" },
      { id: 563169, name: "Wadwadi" },
      { id: 563218, name: "Waghoshi" },
      { id: 563208, name: "Wathar Bk." },
      { id: 563171, name: "Wing" },
      { id: 563228, name: "Yelewadi" },
      { id: 563189, name: "Zagalwadi" },
    ],
    4258: [
      { id: 563356, name: "Adarki Bk." },
      { id: 563357, name: "Adarki Kh." },
      { id: 563275, name: "Alagudewadi" },
      { id: 563355, name: "Aljapur" },
      { id: 563317, name: "Andrud" },
      { id: 563245, name: "Aradgaon" },
      { id: 563297, name: "Asu" },
      { id: 563312, name: "Barad" },
      { id: 563323, name: "Bhadali Bk." },
      { id: 563324, name: "Bhadali Kh." },
      { id: 944595, name: "Bhavaninagar Rajuri" },
      { id: 563268, name: "Bhilkatti" },
      { id: 563354, name: "Bibi" },
      { id: 563339, name: "Bodkewadi" },
      { id: 563246, name: "Chambharwadi" },
      { id: 563273, name: "Chaudharwadi" },
      { id: 563240, name: "Chavhanwadi" },
      { id: 563328, name: "Dalvadi" },
      { id: 912870, name: "Daryachiwadi" },
      { id: 944591, name: "Dattanagar Kuravali Bk." },
      { id: 563331, name: "Dhaval" },
      { id: 563296, name: "Dhavalewadi (Asu)" },
      { id: 563270, name: "Dhavalewadi (Ni)" },
      { id: 563276, name: "Dhuldev" },
      { id: 563341, name: "Dhumalwadi" },
      { id: 563260, name: "Dombalwadi" },
      { id: 563325, name: "Dudhebavi" },
      { id: 563267, name: "Fadatarwadi" },
      { id: 563277, name: "Farandwadi" },
      { id: 563263, name: "Ghadgemala" },
      { id: 563345, name: "Ghadgewadi" },
      { id: 563340, name: "Girvi" },
      { id: 563295, name: "Gokhali" },
      { id: 945357, name: "Golegaon Punarvasit" },
      { id: 946121, name: "Golewadi Punarvasit" },
      { id: 563302, name: "Gunware" },
      { id: 563299, name: "Hanmantwadi" },
      { id: 563343, name: "Hingangaon" },
      { id: 563254, name: "Hol" },
      { id: 944625, name: "Jadhavnagar" },
      { id: 563279, name: "Jadhavwadi" },
      { id: 563301, name: "Jadhavwadi (Asu )" },
      { id: 563318, name: "Jaoli" },
      { id: 563255, name: "Jinti" },
      { id: 945356, name: "Jor Punarvasit" },
      { id: 563261, name: "Kalaj" },
      { id: 563281, name: "Kambleshwar" },
      { id: 563239, name: "Kapadgaon" },
      { id: 563344, name: "Kapashi" },
      { id: 563271, name: "Kashiwadi" },
      { id: 563346, name: "Khadaki" },
      { id: 563253, name: "Khamgaon" },
      { id: 563258, name: "Kharadewadi" },
      { id: 563294, name: "Khatkewasti" },
      { id: 563265, name: "Khunte" },
      { id: 944588, name: "Kolaki" },
      { id: 563248, name: "Koparde" },
      { id: 563238, name: "Koregaon" },
      { id: 563353, name: "Korhale" },
      { id: 563310, name: "Kurvali Bk." },
      { id: 563320, name: "Kurvali Kh." },
      { id: 563235, name: "Kusur" },
      { id: 563236, name: "Malewadi" },
      { id: 563350, name: "Malvadi" },
      { id: 563327, name: "Mandavkhadak" },
      { id: 563335, name: "Manewadi" },
      { id: 563307, name: "Mathachiwadi" },
      { id: 946094, name: "Mazeri (Punarvasit)" },
      { id: 563316, name: "Mirdhe" },
      { id: 563234, name: "Mirewadi" },
      { id: 563329, name: "Mirewadi (Da)" },
      { id: 563347, name: "Mirgaon" },
      { id: 563264, name: "Mulikwadi" },
      { id: 563303, name: "Munjwadi" },
      { id: 563252, name: "Murum" },
      { id: 563315, name: "Naik Bombawadi" },
      { id: 563262, name: "Nandal" },
      { id: 563305, name: "Nimbalak" },
      { id: 563269, name: "Nimbhore" },
      { id: 563326, name: "Nirugudi" },
      { id: 563233, name: "Padegaon" },
      { id: 946090, name: "Parhar Bu. (Punarv)" },
      { id: 946089, name: "Parhar Khurd (Punarv)" },
      { id: 563300, name: "Pawarwadi" },
      { id: 944593, name: "Phaltan" },
      { id: 563256, name: "Pimpalwadi" },
      { id: 563287, name: "Pimparad" },
      { id: 563333, name: "Pirachiwadi" },
      { id: 563285, name: "Rajale" },
      { id: 563308, name: "Rajuri" },
      { id: 563251, name: "Ravadi Bk." },
      { id: 563250, name: "Ravadi Kh." },
      { id: 563249, name: "Salpe" },
      { id: 563283, name: "Sangavi" },
      { id: 563292, name: "Sarade" },
      { id: 563322, name: "Saskal" },
      { id: 563274, name: "Sastewadi" },
      { id: 563243, name: "Saswad" },
      { id: 563293, name: "Sathe" },
      { id: 944623, name: "Savantwadi" },
      { id: 563332, name: "Sherechiwadi (Dhaval)" },
      { id: 563342, name: "Sherechiwadi (Hin))" },
      { id: 563314, name: "Shereshindewadi" },
      { id: 563237, name: "Shindemal" },
      { id: 563298, name: "Shindenagar" },
      { id: 563266, name: "Shindewadi" },
      { id: 563282, name: "Somanthali" },
      { id: 563284, name: "Songaon" },
      { id: 563289, name: "Sonwadi Bk." },
      { id: 563291, name: "Sonwadi Kh." },
      { id: 563257, name: "Survadi" },
      { id: 563259, name: "Tadavale" },
      { id: 563286, name: "Takalwade" },
      { id: 563247, name: "Tambave" },
      { id: 563241, name: "Taradgaon" },
      { id: 563336, name: "Tardaf" },
      { id: 563334, name: "Tathavada" },
      { id: 563319, name: "Tavadi" },
      { id: 563244, name: "Thakubaichiwadi" },
      { id: 563278, name: "Thakurki" },
      { id: 563304, name: "Tirakwadi" },
      { id: 946116, name: "Ulumb (Punarv)" },
      { id: 563338, name: "Upalave" },
      { id: 563290, name: "Vadale" },
      { id: 563351, name: "Vadgaon" },
      { id: 563272, name: "Vadjal" },
      { id: 944599, name: "Vajegaon Nimbalak" },
      { id: 563337, name: "Veloshi" },
      { id: 563288, name: "Vidani" },
      { id: 563321, name: "Vinchurni" },
      { id: 563242, name: "Vitthalwadi" },
      { id: 563352, name: "Waghoshi" },
      { id: 563349, name: "Wakhari" },
      { id: 563348, name: "Wathar (Nimbalkar)" },
      { id: 563330, name: "Zadakbaichiwadi" },
      { id: 563280, name: "Zirapwadi" },
    ],
    4259: [
      { id: 563442, name: "Agaswadi" },
      { id: 563376, name: "Andhali" },
      { id: 563383, name: "Anubhulewadi" },
      { id: 563457, name: "Bangarwadi" },
      { id: 563403, name: "Bhalavadi" },
      { id: 563373, name: "Bhandavali" },
      { id: 563409, name: "Bhatki" },
      { id: 563394, name: "Bidal" },
      { id: 563387, name: "Bijavadi" },
      { id: 563391, name: "Birobanagar" },
      { id: 563378, name: "Bodake" },
      { id: 563368, name: "Bothe" },
      { id: 563448, name: "Chillarwadi" },
      { id: 563395, name: "Dahivadi" },
      { id: 563385, name: "Danavalewadi" },
      { id: 563398, name: "Dangirewadi (Mohi)" },
      { id: 563399, name: "Dangirewadi (Thadale)" },
      { id: 563453, name: "Devapur" },
      { id: 563438, name: "Dhakani" },
      { id: 563435, name: "Dhamani" },
      { id: 563450, name: "Dhuldev" },
      { id: 563437, name: "Didwaghwadi (Divad)" },
      { id: 563436, name: "Divad" },
      { id: 563415, name: "Divadi (Mahimangad)" },
      { id: 563430, name: "Dorgewadi (Naravane)" },
      { id: 563365, name: "Gadewadi" },
      { id: 563456, name: "Gangoti" },
      { id: 563361, name: "Garadachiwadi" },
      { id: 563439, name: "Gatewadi" },
      { id: 563384, name: "Gherewadi" },
      { id: 563421, name: "Gondavale Bk." },
      { id: 563428, name: "Gondavale Kh." },
      { id: 563408, name: "Hawaldarwadi" },
      { id: 563451, name: "Hingani" },
      { id: 563405, name: "Injabav" },
      { id: 563389, name: "Jadhavwadi" },
      { id: 563446, name: "Jambhulani" },
      { id: 563425, name: "Jashi" },
      { id: 944603, name: "Kalaskarwadi" },
      { id: 563461, name: "Kalchondi" },
      { id: 563431, name: "Kalewadi" },
      { id: 563449, name: "Karkhel" },
      { id: 944604, name: "Kasarwadi" },
      { id: 563410, name: "Khadaki" },
      { id: 563363, name: "Khandyachiwadi" },
      { id: 563367, name: "Khokade" },
      { id: 563401, name: "Khutbav" },
      { id: 563429, name: "Kiraksal" },
      { id: 563413, name: "Kolewadi" },
      { id: 563441, name: "Kukudwad" },
      { id: 563366, name: "Kulakjai" },
      { id: 563458, name: "Kuranewadi" },
      { id: 563433, name: "Lodhavade" },
      { id: 563460, name: "Mahabaleshwar Wadi" },
      { id: 563416, name: "Mahimangad" },
      { id: 563372, name: "Malavadi" },
      { id: 944606, name: "Malwadi" },
      { id: 563427, name: "Mankarnawadi" },
      { id: 563402, name: "Mardi" },
      { id: 944000, name: "Masaiwadi" },
      { id: 944002, name: "Masalwadi" },
      { id: 944608, name: "Mhaswad" },
      { id: 563381, name: "Mogarale" },
      { id: 563400, name: "Mohi" },
      { id: 563432, name: "Naravane" },
      { id: 563382, name: "Pachvad" },
      { id: 563426, name: "Palashi" },
      { id: 563452, name: "Palsavade" },
      { id: 563445, name: "Panavan" },
      { id: 563414, name: "Pandharwadi (Mahimangad)" },
      { id: 563390, name: "Pangari" },
      { id: 563370, name: "Parkhandi" },
      { id: 563407, name: "Paryanti" },
      { id: 563434, name: "Pimpari" },
      { id: 563419, name: "Pingali Bk" },
      { id: 563420, name: "Pingali Kh." },
      { id: 563443, name: "Pukalewadi" },
      { id: 563455, name: "Pulkoti" },
      { id: 563386, name: "Rajavadi" },
      { id: 563424, name: "Ranand" },
      { id: 563404, name: "Ranjani" },
      { id: 563406, name: "Sambhukhed" },
      { id: 563375, name: "Satrewadi" },
      { id: 563462, name: "Shenwadi" },
      { id: 563422, name: "Shevari" },
      { id: 563379, name: "Shindi Bk." },
      { id: 563369, name: "Shindi Kh" },
      { id: 563396, name: "Shinganapur" },
      { id: 563374, name: "Shiravali" },
      { id: 563454, name: "Shirtav" },
      { id: 563360, name: "Shripanvan" },
      { id: 563423, name: "Sokasan" },
      { id: 563418, name: "Swarupkhanwadi" },
      { id: 563371, name: "Takewadi" },
      { id: 563397, name: "Thadale" },
      { id: 563380, name: "Tondale" },
      { id: 563364, name: "Ugalyachiwadi" },
      { id: 563417, name: "Ukirde" },
      { id: 563393, name: "Vadgaon" },
      { id: 563444, name: "Valai" },
      { id: 563459, name: "Varkute Malavadi" },
      { id: 563362, name: "Varugad" },
      { id: 563447, name: "Virali" },
      { id: 944001, name: "Virkarwadi" },
      { id: 563440, name: "Wadjal" },
      { id: 563412, name: "Waki" },
      { id: 563411, name: "Warkute Mhaswad" },
      { id: 563392, name: "Wawarhire" },
      { id: 563388, name: "Yelewadi" },
    ],
    4260: [
      { id: 563498, name: "Amalewadi" },
      { id: 563547, name: "Ambavade" },
      { id: 563509, name: "Ambheri" },
      { id: 563470, name: "Anpatwadi" },
      { id: 563579, name: "Anphale" },
      { id: 563527, name: "Aundh" },
      { id: 563556, name: "Banpuri" },
      { id: 563497, name: "Bhandewadi" },
      { id: 563511, name: "Bhosare" },
      { id: 563531, name: "Bhurakvadi" },
      { id: 563597, name: "Bhushangad" },
      { id: 563502, name: "Bitalewadi" },
      { id: 563549, name: "Bombale" },
      { id: 563476, name: "Budh" },
      { id: 563468, name: "Chinchani" },
      { id: 563574, name: "Chitali" },
      { id: 563603, name: "Chorade" },
      { id: 946125, name: "Dahivad (Punarvasit)" },
      { id: 563548, name: "Dalmodi" },
      { id: 563550, name: "Dambhewadi" },
      { id: 563507, name: "Darajai" },
      { id: 563506, name: "Daruj" },
      { id: 563561, name: "Datewadi" },
      { id: 563514, name: "Dhakatwadi" },
      { id: 563495, name: "Dharpudi" },
      { id: 563580, name: "Dhokalwadi" },
      { id: 563565, name: "Dhondewadi" },
      { id: 563466, name: "Diskal" },
      { id: 563558, name: "Enkul" },
      { id: 563484, name: "Fadtarwadi (Ner)" },
      { id: 563478, name: "Fadtarwadi Bk" },
      { id: 563499, name: "Gadewadi" },
      { id: 563525, name: "Ganeshwadi (Aundh)" },
      { id: 563542, name: "Ganeshwadi (Vaduj)" },
      { id: 563587, name: "Garalewadi" },
      { id: 563465, name: "Garavadi" },
      { id: 563583, name: "Garudi" },
      { id: 563588, name: "Girijashankarwadi" },
      { id: 563530, name: "Gopuj" },
      { id: 563601, name: "Goregaon (Nimsod)" },
      { id: 563564, name: "Goregaon (Vangi)" },
      { id: 563529, name: "Gosavyachiwadi" },
      { id: 563576, name: "Gundewadi" },
      { id: 563543, name: "Gursale" },
      { id: 563535, name: "Hingane" },
      { id: 563567, name: "Hivarwadi" },
      { id: 563596, name: "Holichagaon" },
      { id: 563505, name: "Husenpur" },
      { id: 563516, name: "Jaigaon" },
      { id: 563504, name: "Jakhangaon" },
      { id: 563503, name: "Jamb" },
      { id: 563522, name: "Kalambi" },
      { id: 563585, name: "Kaledhon" },
      { id: 563469, name: "Kalewadi" },
      { id: 563573, name: "Kamathi T. Parali" },
      { id: 563566, name: "Kanharwadi" },
      { id: 563578, name: "Kankatre" },
      { id: 563559, name: "Kansewadi" },
      { id: 563526, name: "Karandewadi" },
      { id: 563487, name: "Katalgewadi" },
      { id: 563552, name: "Katarkhatav" },
      { id: 563477, name: "Katewadi" },
      { id: 563493, name: "Katgun" },
      { id: 944135, name: "Katkarwadi Jaypur" },
      { id: 563517, name: "Khabalwadi" },
      { id: 563524, name: "Kharashinge" },
      { id: 563496, name: "Khatav" },
      { id: 563492, name: "Khatgun" },
      { id: 563560, name: "Khatval" },
      { id: 563510, name: "Kokarale" },
      { id: 563528, name: "Kumathe" },
      { id: 563594, name: "Ladegaon" },
      { id: 563473, name: "Lalgun" },
      { id: 563520, name: "Landewadi" },
      { id: 563591, name: "Laxminagar (Vanjarwadi)" },
      { id: 563512, name: "Loni" },
      { id: 563533, name: "Mandave" },
      { id: 563555, name: "Manetupewadi" },
      { id: 563463, name: "Manjarwadi" },
      { id: 563569, name: "Maradwak" },
      { id: 563577, name: "Mayani" },
      { id: 563605, name: "Mhasurne" },
      { id: 563464, name: "Mol" },
      { id: 563570, name: "Morale" },
      { id: 563584, name: "Mulikwadi" },
      { id: 563554, name: "Nadhaval" },
      { id: 563480, name: "Nagnathawadi" },
      { id: 563541, name: "Naikachiwadi" },
      { id: 563518, name: "Nandoshi" },
      { id: 563472, name: "Navalewadi" },
      { id: 563483, name: "Ner" },
      { id: 563488, name: "Nidhal" },
      { id: 563571, name: "Nimsod" },
      { id: 563582, name: "Pachwad" },
      { id: 563568, name: "Padal" },
      { id: 563557, name: "Palasgaon" },
      { id: 563545, name: "Palashi" },
      { id: 563467, name: "Pandharwadi" },
      { id: 563474, name: "Pangarkhel" },
      { id: 563602, name: "Pargaon" },
      { id: 563481, name: "Pawarwadi" },
      { id: 563532, name: "Pedgaon" },
      { id: 563563, name: "Pimpari" },
      { id: 946088, name: "Popalkarwadi" },
      { id: 563489, name: "Pusegaon" },
      { id: 563590, name: "Pusesawali" },
      { id: 563599, name: "Rahatani" },
      { id: 563589, name: "Rajache Kurle" },
      { id: 563475, name: "Rajapur" },
      { id: 563501, name: "Rameshwar" },
      { id: 563500, name: "Ramoshiwadi" },
      { id: 563486, name: "Ranshingwadi" },
      { id: 946087, name: "Revali (Punarvasit)" },
      { id: 563491, name: "Revalkarwadi" },
      { id: 563536, name: "Satewadi" },
      { id: 563575, name: "Shedagewadi" },
      { id: 563604, name: "Shenawadi" },
      { id: 563471, name: "Shindewadi" },
      { id: 563546, name: "Shirsawadi" },
      { id: 563539, name: "Sidhdeshvar Kuroli" },
      { id: 563508, name: "Sundarpur" },
      { id: 563562, name: "Suryachiwadi" },
      { id: 563534, name: "Tadavale" },
      { id: 563586, name: "Taraswadi" },
      { id: 563592, name: "Thoravewadi" },
      { id: 563519, name: "Trimali" },
      { id: 563540, name: "Umbarde" },
      { id: 563494, name: "Umbarmale" },
      { id: 563593, name: "Unchithane" },
      { id: 563600, name: "Vadgaon (J.S.)" },
      { id: 563521, name: "Vadi" },
      { id: 563513, name: "Vadkhal (Bechirak)" },
      { id: 563537, name: "Vaduj" },
      { id: 563595, name: "Vanzoli" },
      { id: 563482, name: "Vardhangad" },
      { id: 563515, name: "Varud" },
      { id: 563485, name: "Vetane" },
      { id: 563581, name: "Vikhale" },
      { id: 563490, name: "Visapur" },
      { id: 563544, name: "Wakalwadi" },
      { id: 563538, name: "Wakeshwar" },
      { id: 563553, name: "Yaralwadi" },
      { id: 563523, name: "Yeliv" },
      { id: 563551, name: "Yelmarwadi" },
    ],
    4261: [
      { id: 563671, name: "Aajhadpur Nhavi Khurd" },
      { id: 563662, name: "Ambawade S. Koregaon" },
      { id: 563642, name: "Ambawade S.Wagholi" },
      { id: 563721, name: "Ambheri" },
      { id: 563670, name: "Anbhulwadi" },
      { id: 563623, name: "Anpatwadi" },
      { id: 563720, name: "Apshinge" },
      { id: 563634, name: "Arabwadi" },
      { id: 563741, name: "Arvi" },
      { id: 563624, name: "Asangaon" },
      { id: 946127, name: "Asare" },
      { id: 563678, name: "Asgaon" },
      { id: 563633, name: "Banawadi" },
      { id: 563665, name: "Bargewadi ( Khed )" },
      { id: 563723, name: "Belewadi" },
      { id: 563654, name: "Bhadale" },
      { id: 563680, name: "Bhakarwadi" },
      { id: 563647, name: "Bhaktawadi" },
      { id: 563686, name: "Bhandarmachi" },
      { id: 563688, name: "Bhatamwadi" },
      { id: 563618, name: "Bhavenagar" },
      { id: 563648, name: "Bhimnagar" },
      { id: 563703, name: "Bhivadi" },
      { id: 563674, name: "Bhose" },
      { id: 563637, name: "Bichukale" },
      { id: 563677, name: "Bobadewadi" },
      { id: 563655, name: "Bodhewadi Bhadale" },
      { id: 563685, name: "Bodhewadi Chimangaon" },
      { id: 563728, name: "Borgaon" },
      { id: 946126, name: "Boriv" },
      { id: 563673, name: "Borjaiwadi" },
      { id: 563676, name: "Chadvadi" },
      { id: 563667, name: "Chanchali" },
      { id: 563613, name: "Chaudharwadi" },
      { id: 563612, name: "Chawaneshwar" },
      { id: 563651, name: "Chilewadi" },
      { id: 563684, name: "Chimangaon" },
      { id: 563626, name: "Dahigaon" },
      { id: 563649, name: "Dare T. Tamb" },
      { id: 563636, name: "Deur" },
      { id: 563713, name: "Dhamner" },
      { id: 563664, name: "Dhumalwadi" },
      { id: 563632, name: "Dudhanwadi" },
      { id: 563711, name: "Dughi" },
      { id: 563735, name: "Durgalwadi" },
      { id: 563689, name: "Ekambe" },
      { id: 563698, name: "Eksal" },
      { id: 563631, name: "Fadtarwadi" },
      { id: 946119, name: "Ghadagewadi" },
      { id: 563620, name: "Ghigewadi" },
      { id: 563708, name: "Godsewadi" },
      { id: 563707, name: "Gogavalewadi" },
      { id: 563696, name: "Golewadi" },
      { id: 563730, name: "Gujarwadi ( Takale )" },
      { id: 563639, name: "Gujarwadi Palashi" },
      { id: 563652, name: "Hasewadi" },
      { id: 563657, name: "Hivare" },
      { id: 563659, name: "Holewadi" },
      { id: 563630, name: "Jadhavwadi" },
      { id: 563616, name: "Jagtapwadi Sonke" },
      { id: 563719, name: "Jaigaon" },
      { id: 563726, name: "Jaipur" },
      { id: 563679, name: "Jalgaon" },
      { id: 563694, name: "Jamb Bk." },
      { id: 563658, name: "Jamb Kh." },
      { id: 563700, name: "Jarewadi" },
      { id: 563736, name: "Kaloshi ( Punarv )" },
      { id: 563718, name: "Kanherkhed" },
      { id: 563611, name: "Karanjkhop" },
      { id: 944134, name: "Kasabe Rahimatpur" },
      { id: 563717, name: "Katewadi" },
      { id: 563706, name: "Kathapur" },
      { id: 563656, name: "Kawadewadi" },
      { id: 563663, name: "Khadkhadwadi" },
      { id: 563635, name: "Khamakarwadi" },
      { id: 563666, name: "Khed" },
      { id: 563691, name: "Khirkhindi" },
      { id: 563661, name: "Kinhai" },
      { id: 563733, name: "Kiroli" },
      { id: 563646, name: "Kolavadi" },
      { id: 563742, name: "Kombadwadi" },
      { id: 563744, name: "Koregaon" },
      { id: 563681, name: "Kumathe" },
      { id: 563695, name: "Lhasurne" },
      { id: 563660, name: "Madanapurwadi" },
      { id: 563705, name: "Mangalapur" },
      { id: 563739, name: "Mohitewadi" },
      { id: 563609, name: "Morbend" },
      { id: 563701, name: "Mugaon" },
      { id: 563653, name: "Nagewadi" },
      { id: 563743, name: "Nagzari" },
      { id: 563738, name: "Nalavadewadi" },
      { id: 563638, name: "Nalavadewadi Bichukale" },
      { id: 563608, name: "Nandwal" },
      { id: 563607, name: "Naygaon" },
      { id: 563712, name: "Nigadi" },
      { id: 563650, name: "Padali Station" },
      { id: 563640, name: "Palashi" },
      { id: 563645, name: "Paratwadi" },
      { id: 563727, name: "Pawarwadi" },
      { id: 563617, name: "Pimpode Bk." },
      { id: 563641, name: "Pimpode Kh." },
      { id: 563725, name: "Pimpri" },
      { id: 563687, name: "Ramoshiwadi" },
      { id: 563610, name: "Randullabad" },
      { id: 563622, name: "Rautwadi" },
      { id: 563643, name: "Revdi" },
      { id: 563737, name: "Rikibadarwadi" },
      { id: 563669, name: "Rui" },
      { id: 563714, name: "Saigaon ( Dhamner )" },
      { id: 563682, name: "Sangavi" },
      { id: 563724, name: "Sap" },
      { id: 563614, name: "Sarkalwadi" },
      { id: 563715, name: "Sasurve" },
      { id: 563740, name: "Sathewadi" },
      { id: 563625, name: "Shahapur Aasangaon" },
      { id: 563690, name: "Shelti" },
      { id: 563668, name: "Shendurjane" },
      { id: 563709, name: "Shirambe" },
      { id: 563699, name: "Shirdhon" },
      { id: 563672, name: "Siddharthnagar" },
      { id: 563606, name: "Solashi" },
      { id: 563615, name: "Sonake" },
      { id: 563697, name: "Sultanwadi" },
      { id: 563731, name: "Surli" },
      { id: 563619, name: "Tadawale S. Wagholi" },
      { id: 563675, name: "Tadawale S.Koregaon" },
      { id: 563729, name: "Takale" },
      { id: 563628, name: "Taliye" },
      { id: 563644, name: "Tambi" },
      { id: 563704, name: "Tandulwadi" },
      { id: 563734, name: "Targaon." },
      { id: 563702, name: "Triputi" },
      { id: 563683, name: "Vadachiwadi" },
      { id: 563716, name: "Velang ( Kanher Khed )" },
      { id: 563710, name: "Velang ( Shirambe )" },
      { id: 563722, name: "Velu" },
      { id: 563629, name: "Vikhale" },
      { id: 563621, name: "Wagholi" },
      { id: 563692, name: "Wagjaiwadi" },
      { id: 563732, name: "Wathar Kiroli" },
      { id: 563627, name: "Wathar Station" },
    ],
    4262: [
      { id: 563749, name: "Agundewadi" },
      { id: 563755, name: "Akale" },
      { id: 563833, name: "Alawadi" },
      { id: 563873, name: "Ambale" },
      { id: 563869, name: "Ambavade Bk" },
      { id: 563876, name: "Ambavade Kh." },
      { id: 563927, name: "Ambewadi" },
      { id: 563823, name: "Anavale" },
      { id: 563922, name: "Angapur T Targaon" },
      { id: 563923, name: "Angapur Vandan" },
      { id: 563925, name: "Apashinge" },
      { id: 563780, name: "Arale" },
      { id: 563883, name: "Are T.Parali" },
      { id: 563828, name: "Argadwadi" },
      { id: 563776, name: "Arphal" },
      { id: 563887, name: "Asangaon" },
      { id: 563779, name: "Asgaon" },
      { id: 563825, name: "Ashte" },
      { id: 563813, name: "Atali" },
      { id: 563952, name: "Atit" },
      { id: 563848, name: "Banghar" },
      { id: 563782, name: "Basappachiwadi" },
      { id: 563896, name: "Bendwadi" },
      { id: 563945, name: "Bhairavgad" },
      { id: 563811, name: "Bhambavali" },
      { id: 563906, name: "Bharatgaon" },
      { id: 563905, name: "Bharatgaonwadi" },
      { id: 563902, name: "Bhatmarali" },
      { id: 563870, name: "Bhondavade" },
      { id: 563861, name: "Boposhi" },
      { id: 563907, name: "Borgaon" },
      { id: 563784, name: "Borkhal" },
      { id: 563854, name: "Borne" },
      { id: 563913, name: "Bramhanwadi" },
      { id: 563789, name: "Chahur" },
      { id: 563859, name: "Chalkewadi" },
      { id: 563860, name: "Chikhali" },
      { id: 563795, name: "Chinchaner S. Nimb" },
      { id: 563909, name: "Chinchaner Vandan" },
      { id: 563750, name: "Chinchani" },
      { id: 563752, name: "Chorgewadi" },
      { id: 563877, name: "Dabewadi" },
      { id: 563827, name: "Dahivad" },
      { id: 563807, name: "Dare Bk." },
      { id: 563810, name: "Dare Kh." },
      { id: 563884, name: "Dare T.Parali" },
      { id: 563800, name: "Degaon" },
      { id: 563934, name: "Deshmukh Nagar" },
      { id: 563899, name: "Dhanavadewadi" },
      { id: 563797, name: "Dhangarwadi" },
      { id: 563914, name: "Dhangarwadi (Nigadi)" },
      { id: 563834, name: "Dhavali" },
      { id: 563757, name: "Dhawadshi" },
      { id: 563930, name: "Dhondewadi" },
      { id: 563911, name: "Dhondewadi (Tasgaon)" },
      { id: 944612, name: "Dighavale" },
      { id: 563903, name: "Dolegaon" },
      { id: 563920, name: "Fadatarwadi" },
      { id: 563932, name: "Fatyapur" },
      { id: 563871, name: "Gajawadi" },
      { id: 563951, name: "Ganeshwadi" },
      { id: 563801, name: "Gavadi" },
      { id: 563816, name: "Ghatawan" },
      { id: 563958, name: "Godoli" },
      { id: 563751, name: "Gogavalewadi" },
      { id: 563910, name: "Gojegaon" },
      { id: 563770, name: "Gove" },
      { id: 563804, name: "Hamdabaj" },
      { id: 563916, name: "Jadhavwadi (Tasgaon)" },
      { id: 563908, name: "Jaitapur" },
      { id: 563878, name: "Jakatwadi" },
      { id: 563863, name: "Jambhe" },
      { id: 946096, name: "Jambhgaon (Punarvasit)" },
      { id: 564080, name: "Jawalwadi" },
      { id: 563918, name: "Jihe" },
      { id: 563748, name: "Jotibachiwadi" },
      { id: 563767, name: "Kalambe" },
      { id: 563868, name: "Kaloshi" },
      { id: 563846, name: "Kamathi T.Parali" },
      { id: 563746, name: "Kamathi T.Satara" },
      { id: 563931, name: "Kameri" },
      { id: 563754, name: "Kanher" },
      { id: 563885, name: "Karandi" },
      { id: 563799, name: "Karandwadi" },
      { id: 563866, name: "Karanje T.Parali" },
      { id: 563957, name: "Karanje Tarf Satara" },
      { id: 563864, name: "Karanjoshi" },
      { id: 563872, name: "Kari" },
      { id: 563812, name: "Kasani" },
      { id: 563844, name: "Kasarsthal" },
      { id: 563954, name: "Kashil" },
      { id: 563843, name: "Katavadi Bk" },
      { id: 563830, name: "Katavadi Kh" },
      { id: 563837, name: "Kelavali" },
      { id: 563851, name: "Khadgaon" },
      { id: 563771, name: "Khandobachi Wadi" },
      { id: 563794, name: "Khavali" },
      { id: 563956, name: "Khed" },
      { id: 563798, name: "Khindwadi" },
      { id: 563953, name: "Khodad" },
      { id: 563929, name: "Khojewadi" },
      { id: 563766, name: "Kidgaon" },
      { id: 563959, name: "Kodoli" },
      { id: 563806, name: "Kondave" },
      { id: 563761, name: "Kondvali" },
      { id: 563941, name: "Koparde" },
      { id: 563792, name: "Kshetra Mahuli" },
      { id: 563818, name: "Kudeghar" },
      { id: 563895, name: "Kumathe" },
      { id: 563817, name: "Kurulbaji" },
      { id: 563814, name: "Kurultijai" },
      { id: 563867, name: "Kurun" },
      { id: 563849, name: "Kus Bk." },
      { id: 563850, name: "Kus Kh." },
      { id: 563901, name: "Kusavade" },
      { id: 563759, name: "Kushi" },
      { id: 563939, name: "Landewadi" },
      { id: 563822, name: "Lavanghar" },
      { id: 563760, name: "Limb" },
      { id: 563936, name: "Limbachiwadi" },
      { id: 563829, name: "Lumanekhol" },
      { id: 563796, name: "Mahagaon" },
      { id: 563926, name: "Majgaon" },
      { id: 563773, name: "Malgaon" },
      { id: 563756, name: "Malyachi Wadi" },
      { id: 563944, name: "Mandave" },
      { id: 563769, name: "Mardhe" },
      { id: 563928, name: "Mattyapur" },
      { id: 563888, name: "Mhaparwadi" },
      { id: 563786, name: "Mhasave" },
      { id: 563824, name: "Mhaskarwadi" },
      { id: 563862, name: "Morewadi" },
      { id: 563890, name: "Mugdul Bhatachiwadi" },
      { id: 563917, name: "Mulikwadi" },
      { id: 563762, name: "Nagewadi" },
      { id: 563948, name: "Nagthane" },
      { id: 946093, name: "Nagthane 1(Ashte) ( Punarvasit)" },
      { id: 946130, name: "Nagthane 2 Jambhalewadi" },
      { id: 563935, name: "Nandgaon" },
      { id: 563835, name: "Navali" },
      { id: 563765, name: "Nele" },
      { id: 563774, name: "Nhalewadi" },
      { id: 563915, name: "Nigadi T.Satara" },
      { id: 563924, name: "Nigadi Vandan" },
      { id: 563838, name: "Nigudamal" },
      { id: 563946, name: "Ninam" },
      { id: 563938, name: "Nisarale" },
      { id: 563839, name: "Nitral" },
      { id: 563803, name: "Nune" },
      { id: 563947, name: "Padali" },
      { id: 563852, name: "Palsavade" },
      { id: 563853, name: "Pangare" },
      { id: 563764, name: "Panmalewadi" },
      { id: 563847, name: "Parali" },
      { id: 563745, name: "Parambewadi" },
      { id: 563897, name: "Parmale" },
      { id: 563832, name: "Pateghar" },
      { id: 563785, name: "Patkhal" },
      { id: 944614, name: "Pavangaon" },
      { id: 563820, name: "Petri" },
      { id: 563898, name: "Pilani" },
      { id: 563900, name: "Pilaniwadi" },
      { id: 563758, name: "Pimpalwadi" },
      { id: 563790, name: "Pirwadi" },
      { id: 563882, name: "Pogarwadi" },
      { id: 563826, name: "Punavadi" },
      { id: 563874, name: "Raighar" },
      { id: 563855, name: "Rajapuri" },
      { id: 563886, name: "Rakusalewadi" },
      { id: 563955, name: "Ramkrushna Nagar" },
      { id: 563781, name: "Renavale" },
      { id: 563845, name: "Revali" },
      { id: 563857, name: "Revande" },
      { id: 563831, name: "Rohot" },
      { id: 563768, name: "Sabalewadi" },
      { id: 563805, name: "Saidapur" },
      { id: 563772, name: "Salwan" },
      { id: 912862, name: "Samarthgaon" },
      { id: 912925, name: "Samarthnagar" },
      { id: 563809, name: "Sambarwadi" },
      { id: 912854, name: "Sambhaji Nagar" },
      { id: 563842, name: "Sandavali" },
      { id: 563802, name: "Sarkhal" },
      { id: 563950, name: "Saspade" },
      { id: 944616, name: "Satara" },
      { id: 563815, name: "Savali" },
      { id: 563942, name: "Sayali" },
      { id: 563821, name: "Sayali (Punarwasit)" },
      { id: 563879, name: "Shahapur" },
      { id: 563891, name: "Shelkewadi" },
      { id: 563893, name: "Shendre" },
      { id: 563889, name: "Sherewadi" },
      { id: 563865, name: "Shindewadi" },
      { id: 563777, name: "Shivthar" },
      { id: 563949, name: "Sonapur" },
      { id: 563875, name: "Sonavadi" },
      { id: 563892, name: "Sonegaon T Satara" },
      { id: 563793, name: "Songaon S.Nimb" },
      { id: 563840, name: "Takawali" },
      { id: 563912, name: "Tasgaon" },
      { id: 563858, name: "Thoseghar" },
      { id: 563933, name: "Titavewadi" },
      { id: 563943, name: "Tukaiwadi" },
      { id: 563880, name: "Upali" },
      { id: 563778, name: "Vaduth" },
      { id: 563904, name: "Valase" },
      { id: 563775, name: "Vangal" },
      { id: 563788, name: "Vanvaswadi" },
      { id: 563921, name: "Varne" },
      { id: 563763, name: "Varye" },
      { id: 563894, name: "Vechale" },
      { id: 563747, name: "Vele" },
      { id: 563940, name: "Venegaon" },
      { id: 563836, name: "Venekhol" },
      { id: 563919, name: "Vijay Nagar" },
      { id: 563819, name: "Wadgaon" },
      { id: 563787, name: "Wadhe" },
      { id: 563783, name: "Wasole" },
      { id: 563856, name: "Wavadare" },
      { id: 563808, name: "Yavateshwar" },
      { id: 563881, name: "Zarewadi" },
    ],
    4263: [
      { id: 564047, name: "Adoshi" },
      { id: 564081, name: "Agalavewadi" },
      { id: 564018, name: "Akhade" },
      { id: 564005, name: "Akhegani" },
      { id: 564100, name: "Alewadi" },
      { id: 563979, name: "Ambeghar T Medha" },
      { id: 564012, name: "Ambeghar T.Kudal" },
      { id: 564053, name: "Andhari" },
      { id: 564112, name: "Anewadi" },
      { id: 564039, name: "Apti" },
      { id: 564106, name: "Arde" },
      { id: 563978, name: "Asani" },
      { id: 563964, name: "Bahule" },
      { id: 564029, name: "Bamnoli T. Kudal" },
      { id: 564107, name: "Belawade" },
      { id: 563997, name: "Beloshi" },
      { id: 564016, name: "Bhaleghar" },
      { id: 563983, name: "Bhamghar" },
      { id: 564091, name: "Bhanang" },
      { id: 944137, name: "Bhavaninagar" },
      { id: 564034, name: "Bhivadi" },
      { id: 563981, name: "Bhogavali T. Medha" },
      { id: 564013, name: "Bhogavali T.Kudal" },
      { id: 563962, name: "Bhuteghar" },
      { id: 564082, name: "Bibhvi" },
      { id: 563961, name: "Bondarwadi" },
      { id: 563993, name: "Chorambe" },
      { id: 563975, name: "Dangreghar" },
      { id: 564002, name: "Dapawadi" },
      { id: 564102, name: "Dare Bk." },
      { id: 564118, name: "Dare Kh." },
      { id: 564067, name: "Deur" },
      { id: 564094, name: "Dhanakwadi" },
      { id: 564101, name: "Dhondewadi" },
      { id: 563985, name: "Divdev" },
      { id: 563986, name: "Divdevwadi" },
      { id: 564115, name: "Duduskarwadi" },
      { id: 564086, name: "Dund" },
      { id: 564038, name: "Furus" },
      { id: 563982, name: "Galdev" },
      { id: 564075, name: "Ganje" },
      { id: 563980, name: "Gavdi" },
      { id: 564000, name: "Ghoteghar" },
      { id: 563990, name: "Gondemal" },
      { id: 564014, name: "Hateghar" },
      { id: 564020, name: "Humgaon" },
      { id: 564025, name: "Indavali T. Kudal" },
      { id: 564021, name: "Jarewadi" },
      { id: 563937, name: "Jawalwadi" },
      { id: 564084, name: "Kaloshi" },
      { id: 564028, name: "Karandi T. Kudal" },
      { id: 564087, name: "Karandi T.Medha" },
      { id: 564104, name: "Karandoshi" },
      { id: 564073, name: "Karanje" },
      { id: 564059, name: "Kargaon" },
      { id: 564009, name: "Karhar" },
      { id: 564054, name: "Kas" },
      { id: 564045, name: "Kasbe Bamnoli" },
      { id: 563996, name: "Katavali" },
      { id: 564007, name: "Kavadi" },
      { id: 563969, name: "Kedambe" },
      { id: 563976, name: "Kelghar T Medha" },
      { id: 564041, name: "Kelghar T.Solshi" },
      { id: 564097, name: "Kenjal" },
      { id: 564096, name: "Kesakarwadi" },
      { id: 564003, name: "Kharshi Baramure" },
      { id: 564111, name: "Kharshi T. Kudal" },
      { id: 564057, name: "Khirkhandi" },
      { id: 564019, name: "Kolewadi" },
      { id: 564043, name: "Kolghar" },
      { id: 564031, name: "Kudal" },
      { id: 564090, name: "Kumbhargani" },
      { id: 563972, name: "Kuraloshi" },
      { id: 564049, name: "Kusapur" },
      { id: 564078, name: "Kusumbi" },
      { id: 564048, name: "Madoshi" },
      { id: 564120, name: "Mahamulkarwadi" },
      { id: 564109, name: "Mahigaon" },
      { id: 564001, name: "Mahu" },
      { id: 564050, name: "Majare Shembadi" },
      { id: 564088, name: "Malchoundi" },
      { id: 564063, name: "Maldev" },
      { id: 564085, name: "Maleshwar" },
      { id: 563987, name: "Mamurdi" },
      { id: 564040, name: "Manti" },
      { id: 564108, name: "Maradmure" },
      { id: 564026, name: "Marli" },
      { id: 564051, name: "Mauje Shembadi" },
      { id: 564121, name: "Medha" },
      { id: 564023, name: "Mhasve" },
      { id: 563988, name: "Mhate Bk" },
      { id: 563991, name: "Mhate Kh." },
      { id: 564052, name: "Mhavshi" },
      { id: 563992, name: "Mohat" },
      { id: 564098, name: "Morawale" },
      { id: 564116, name: "Morghar" },
      { id: 563965, name: "Mukavali" },
      { id: 564060, name: "Munawale" },
      { id: 563973, name: "Nandgane" },
      { id: 564117, name: "Narfdev" },
      { id: 944136, name: "Nevekarwadi" },
      { id: 564037, name: "Nipani" },
      { id: 564092, name: "Nizare" },
      { id: 563977, name: "Okhavadi" },
      { id: 564089, name: "Ozare" },
      { id: 564008, name: "Panas" },
      { id: 946091, name: "Panas (Punarv)" },
      { id: 564119, name: "Pawarwadi" },
      { id: 564055, name: "Phalani" },
      { id: 564004, name: "Pimpali" },
      { id: 564074, name: "Pimpri T. Medha" },
      { id: 564110, name: "Prabhuchiwadi" },
      { id: 563974, name: "Punavadi" },
      { id: 564010, name: "Ramwadi" },
      { id: 564027, name: "Rangeghar" },
      { id: 563999, name: "Ranjni" },
      { id: 564046, name: "Ravandi" },
      { id: 564113, name: "Raygaon" },
      { id: 564103, name: "Rendimura" },
      { id: 563971, name: "Rengadiwadi" },
      { id: 564083, name: "Ritkawali" },
      { id: 563994, name: "Ruighar" },
      { id: 564077, name: "Sahyadrinagar" },
      { id: 564017, name: "Sanapane" },
      { id: 564033, name: "Sangvi T. Kudal" },
      { id: 564076, name: "Sangvi T. Medha" },
      { id: 564032, name: "Sarjapur" },
      { id: 564022, name: "Sartale" },
      { id: 563984, name: "Savali" },
      { id: 564044, name: "Sawari" },
      { id: 564099, name: "Sayali" },
      { id: 564114, name: "Saygaon" },
      { id: 564015, name: "Sayghar" },
      { id: 564030, name: "Shete" },
      { id: 563995, name: "Shindewadi" },
      { id: 564024, name: "Somardi" },
      { id: 564105, name: "Songaon" },
      { id: 563968, name: "Taloshi" },
      { id: 564079, name: "Tambi T. Medha" },
      { id: 564042, name: "Tetli" },
      { id: 564061, name: "Umbarewadi" },
      { id: 563989, name: "Vaghdare" },
      { id: 564095, name: "Vagheshwar" },
      { id: 563998, name: "Vahagaon" },
      { id: 563963, name: "Vahite" },
      { id: 563967, name: "Valanjwadi" },
      { id: 564011, name: "Valuth" },
      { id: 563970, name: "Varoshi" },
      { id: 563966, name: "Vatambe" },
      { id: 564071, name: "Vele" },
      { id: 564006, name: "Vivar" },
      { id: 564056, name: "Waghali" },
      { id: 564036, name: "Waki" },
      { id: 564093, name: "Yekiv" },
    ],
    4264: [
      { id: 564345, name: "Aadev Kh." },
      { id: 564124, name: "Aaral (Aavsari)" },
      { id: 564308, name: "Abdarwadi" },
      { id: 564460, name: "Acharewadi" },
      { id: 564344, name: "Adadev" },
      { id: 564275, name: "Adul" },
      { id: 564213, name: "Ambale" },
      { id: 564397, name: "Ambavade Kh." },
      { id: 564249, name: "Ambavane" },
      { id: 564353, name: "Ambeghar Tarf Marli" },
      { id: 564355, name: "Ambrag" },
      { id: 564343, name: "Ambrule" },
      { id: 564322, name: "Asawalewadi" },
      { id: 564326, name: "Atoli" },
      { id: 564205, name: "Awarde" },
      { id: 564382, name: "Bacholi" },
      { id: 944571, name: "Bagalewadi" },
      { id: 564416, name: "Bagalwadi" },
      { id: 564329, name: "Bahe" },
      { id: 564319, name: "Bahule" },
      { id: 564144, name: "Baje" },
      { id: 564189, name: "Bamanewadi" },
      { id: 564435, name: "Bamanwadi" },
      { id: 564206, name: "Bambavade" },
      { id: 564228, name: "Bandhvat" },
      { id: 564171, name: "Banpethwadi" },
      { id: 564383, name: "Banpuri" },
      { id: 564342, name: "Belavade Kh." },
      { id: 564188, name: "Bhambe" },
      { id: 564463, name: "Bharewadi" },
      { id: 564232, name: "Bharsakhale" },
      { id: 564390, name: "Bhilarwadi" },
      { id: 564399, name: "Bhosgaon" },
      { id: 564204, name: "Bhudakewadi" },
      { id: 564265, name: "Bibi" },
      { id: 564301, name: "Bodakewadi" },
      { id: 564255, name: "Bondri" },
      { id: 564152, name: "Bopoli" },
      { id: 944585, name: "Borgewadi Kumbhargaon" },
      { id: 564295, name: "Chafal" },
      { id: 564177, name: "Chafer" },
      { id: 564236, name: "Chafoli" },
      { id: 564438, name: "Chalkewadi" },
      { id: 564281, name: "Chavanwadi" },
      { id: 944580, name: "Chavhanwadi Chafal" },
      { id: 564336, name: "Chawaliwadi" },
      { id: 564431, name: "Chikhalewadi" },
      { id: 564250, name: "Chiteghar" },
      { id: 564341, name: "Chopadi" },
      { id: 564363, name: "Chopdarwadi" },
      { id: 564366, name: "Chougalewadi (Kalgaon)" },
      { id: 564459, name: "Chougulewadi (Sangwad)" },
      { id: 564298, name: "Dadholi" },
      { id: 564445, name: "Dakewadi (Kalgaon )" },
      { id: 564446, name: "Dakewadi (Wazoli)" },
      { id: 564196, name: "Dangistewadi" },
      { id: 564192, name: "Daphalwadi" },
      { id: 564373, name: "Davari" },
      { id: 564297, name: "Dervan" },
      { id: 564141, name: "Deshmukhwadi" },
      { id: 564253, name: "Devghar Tarf Patan" },
      { id: 564241, name: "Dhadamwadi" },
      { id: 564372, name: "Dhajgaon" },
      { id: 564447, name: "Dhamani" },
      { id: 564215, name: "Dhangarwadi" },
      { id: 564348, name: "Dhavade" },
      { id: 564284, name: "Dhayati" },
      { id: 564398, name: "Dhebewadi" },
      { id: 564212, name: "Dhoroshi" },
      { id: 564132, name: "Dhuilwadi" },
      { id: 564127, name: "Dicholi" },
      { id: 564272, name: "Digewadi" },
      { id: 564349, name: "Dikshi" },
      { id: 564321, name: "Divashi Bk." },
      { id: 564237, name: "Divashi Kh" },
      { id: 564339, name: "Dongarobachiwadi" },
      { id: 564346, name: "Donglewadi" },
      { id: 564160, name: "Donichawada" },
      { id: 564230, name: "Dusale" },
      { id: 564202, name: "Dutalwadi" },
      { id: 564142, name: "Gadhavkhop" },
      { id: 944579, name: "Gadkhop" },
      { id: 564449, name: "Galmewadi" },
      { id: 564293, name: "Gamewadi" },
      { id: 564318, name: "Garawade" },
      { id: 944578, name: "Gavaliwada" },
      { id: 564362, name: "Gavhanwadi" },
      { id: 564133, name: "Gawdewadi" },
      { id: 564245, name: "Ghanav" },
      { id: 564247, name: "Ghanbi" },
      { id: 564199, name: "Ghatewadi" },
      { id: 564149, name: "Ghatmatha" },
      { id: 564258, name: "Gheradategad" },
      { id: 564222, name: "Ghot" },
      { id: 564412, name: "Ghotil" },
      { id: 564310, name: "Girewadi" },
      { id: 564131, name: "Gojegaon" },
      { id: 564147, name: "Gokul Tarf Helwak" },
      { id: 564354, name: "Gokul Tarf Patan" },
      { id: 564195, name: "Gorewadi" },
      { id: 564158, name: "Goshatwadi" },
      { id: 564185, name: "Gothane" },
      { id: 564179, name: "Govare" },
      { id: 564424, name: "Gudhe" },
      { id: 564172, name: "Gunjali" },
      { id: 564328, name: "Gureghar" },
      { id: 564273, name: "Harugdewadi" },
      { id: 564155, name: "Helwak" },
      { id: 564140, name: "Humbarli" },
      { id: 564351, name: "Humbarne" },
      { id: 564371, name: "Humbarwadi" },
      { id: 564411, name: "Jadhavwadi" },
      { id: 564294, name: "Jadhavwadi (Chafal)" },
      { id: 564256, name: "Jaichiwadi" },
      { id: 564286, name: "Jalagewadi" },
      { id: 564208, name: "Jalav" },
      { id: 564315, name: "Jamadadwadi" },
      { id: 564210, name: "Jambhekarwadi" },
      { id: 564432, name: "Jambhulwadi" },
      { id: 564217, name: "Jangalwadi" },
      { id: 564391, name: "Janugdewadi" },
      { id: 564325, name: "Jarewadi" },
      { id: 564403, name: "Jinti" },
      { id: 564238, name: "Jungati" },
      { id: 564168, name: "Jyotibachiwadi" },
      { id: 564201, name: "Kadave Bk." },
      { id: 564200, name: "Kadave Kh" },
      { id: 564417, name: "Kadhane" },
      { id: 564178, name: "Kadoli" },
      { id: 564352, name: "Kahir" },
      { id: 564207, name: "Kalambe" },
      { id: 564453, name: "Kalgaon" },
      { id: 564359, name: "Kalkewadi" },
      { id: 564170, name: "Kaloli" },
      { id: 564139, name: "Kamargaon" },
      { id: 564395, name: "Karale" },
      { id: 564456, name: "Karapewadi (Kalgaon)" },
      { id: 564161, name: "Karate" },
      { id: 564422, name: "Karpewadi" },
      { id: 564257, name: "Karvat" },
      { id: 564413, name: "Kasani" },
      { id: 564216, name: "Katewadi" },
      { id: 564125, name: "Kathi" },
      { id: 564262, name: "Katvadi" },
      { id: 564260, name: "Kavadewadi" },
      { id: 564337, name: "Kavarwadi" },
      { id: 564280, name: "Keloli" },
      { id: 564150, name: "Kemase" },
      { id: 564263, name: "Ker" },
      { id: 564240, name: "Keral" },
      { id: 564419, name: "Khale" },
      { id: 564289, name: "Kharadwadi" },
      { id: 564246, name: "Khivashi" },
      { id: 564290, name: "Khonoli" },
      { id: 564332, name: "Killemorgiri" },
      { id: 564134, name: "Kisrule" },
      { id: 564291, name: "Kocharewadi" },
      { id: 564350, name: "Kodal" },
      { id: 564330, name: "Kokisare" },
      { id: 564461, name: "Kolagewadi" },
      { id: 564183, name: "Kolane" },
      { id: 564402, name: "Kolekarwadi" },
      { id: 564157, name: "Kondhavale" },
      { id: 564203, name: "Konjavade" },
      { id: 564324, name: "Korivale" },
      { id: 564252, name: "Kotawadewadi" },
      { id: 564427, name: "Kumbhargaon" },
      { id: 564122, name: "Kusavade" },
      { id: 564187, name: "Kushi" },
      { id: 564357, name: "Kusrund" },
      { id: 564441, name: "Kuthare" },
      { id: 564174, name: "Lendhori" },
      { id: 564458, name: "Loharwadi" },
      { id: 564454, name: "Lotalewadi" },
      { id: 564271, name: "Lugadewadi" },
      { id: 564381, name: "Mahind" },
      { id: 564296, name: "Majgaon" },
      { id: 564182, name: "Mala" },
      { id: 564392, name: "Maldan" },
      { id: 564307, name: "Malharpeth" },
      { id: 564197, name: "Maloshi" },
      { id: 564387, name: "Mandrulkole" },
      { id: 564388, name: "Mandrulkole Kh." },
      { id: 564235, name: "Mandure" },
      { id: 564175, name: "Maneri" },
      { id: 564421, name: "Manewadi" },
      { id: 564386, name: "Manyachiwadi (Kumbhargaon)" },
      { id: 564428, name: "Manyachiwadi (Maldan)" },
      { id: 564369, name: "Marali" },
      { id: 564409, name: "Marathwadi" },
      { id: 944586, name: "Marathwadi Divashi Khurd" },
      { id: 564209, name: "Marloshi" },
      { id: 564320, name: "Marul Haveli" },
      { id: 564162, name: "Marul Tarf Patan" },
      { id: 564450, name: "Maskarwadi" },
      { id: 564451, name: "Maskarwadi No. 1" },
      { id: 944572, name: "Maskarwadi No. 2" },
      { id: 944587, name: "Matekarwadi Kumbhargaon" },
      { id: 564287, name: "Mathanewadi" },
      { id: 564400, name: "Matrewadi" },
      { id: 564313, name: "Maundrul Haveli" },
      { id: 564410, name: "Mendh" },
      { id: 564156, name: "Mendheghar" },
      { id: 564242, name: "Mendhoshi" },
      { id: 564234, name: "Mharwand" },
      { id: 564268, name: "Mhavashi" },
      { id: 564138, name: "Mirgaon" },
      { id: 564406, name: "Modakwadi" },
      { id: 564426, name: "Morewadi (Kuthare)" },
      { id: 564333, name: "Morgiri" },
      { id: 564338, name: "Mulgaon" },
      { id: 564194, name: "Murud" },
      { id: 564464, name: "Mutalwadi" },
      { id: 564277, name: "Nade" },
      { id: 564274, name: "Nadoli" },
      { id: 564137, name: "Nahibe Ambeghar" },
      { id: 564288, name: "Nanegaon Bk." },
      { id: 564285, name: "Nanegaon Kh." },
      { id: 564145, name: "Nanel" },
      { id: 564314, name: "Naralwadi" },
      { id: 564356, name: "Natoshi" },
      { id: 564184, name: "Nav" },
      { id: 564311, name: "Navadi" },
      { id: 564305, name: "Navasarwadi" },
      { id: 564135, name: "Nawaja" },
      { id: 564153, name: "Nechal" },
      { id: 564335, name: "Nerale" },
      { id: 564407, name: "Nigade" },
      { id: 564309, name: "Nisare" },
      { id: 564191, name: "Nivade" },
      { id: 564233, name: "Nivakane" },
      { id: 564414, name: "Nivi" },
      { id: 564219, name: "Nune" },
      { id: 564229, name: "Pabhalwadi" },
      { id: 564327, name: "Pachgani" },
      { id: 564425, name: "Pachupatewadi" },
      { id: 564198, name: "Padekarwadi" },
      { id: 564283, name: "Padloshi" },
      { id: 564442, name: "Pagewadi" },
      { id: 564376, name: "Palashi" },
      { id: 564218, name: "Pandharwadi" },
      { id: 944582, name: "Pandharwadi Nade" },
      { id: 564374, name: "Paneri" },
      { id: 564367, name: "Paparde Bk" },
      { id: 564368, name: "Paparde Kh." },
      { id: 564465, name: "Patan" },
      { id: 564181, name: "Patharpunj" },
      { id: 564231, name: "Pathavade" },
      { id: 564440, name: "Pawarwadi" },
      { id: 564334, name: "Pethshivapur" },
      { id: 944583, name: "Pimpalgaon" },
      { id: 564264, name: "Pimpaloshi" },
      { id: 944584, name: "Potekarwadi" },
      { id: 564130, name: "Punvali" },
      { id: 564220, name: "Rahude" },
      { id: 564462, name: "Ramishtewadi" },
      { id: 564146, name: "Rasati" },
      { id: 564401, name: "Retharekarwadi" },
      { id: 564186, name: "Risawad" },
      { id: 564396, name: "Ruvale" },
      { id: 564389, name: "Sabalewadi" },
      { id: 564279, name: "Sadawaghapur" },
      { id: 564420, name: "Saikade" },
      { id: 564251, name: "Sakhari" },
      { id: 564377, name: "Salave" },
      { id: 564266, name: "Saltewadi" },
      { id: 564393, name: "Sanbur" },
      { id: 564365, name: "Sangwad" },
      { id: 564405, name: "Satar" },
      { id: 564190, name: "Sawarghar" },
      { id: 564303, name: "Shedgewadi" },
      { id: 944577, name: "Shendevadi" },
      { id: 564430, name: "Shibewadi (Kumbhargaon)" },
      { id: 564415, name: "Shidrukwadi" },
      { id: 564360, name: "Shindewadi" },
      { id: 564299, name: "Shinganwadi" },
      { id: 564164, name: "Shiral" },
      { id: 564384, name: "Shitapwadi" },
      { id: 564154, name: "Shivandeshwar" },
      { id: 564364, name: "Siddheshwar Nagar" },
      { id: 564316, name: "Sonaichiwadi" },
      { id: 564370, name: "Sonavade" },
      { id: 564276, name: "Subhashnagar" },
      { id: 564361, name: "Sulewadi" },
      { id: 564443, name: "Supugadewadi" },
      { id: 564267, name: "Surul" },
      { id: 564385, name: "Sutarwadi" },
      { id: 564176, name: "Taliye" },
      { id: 564375, name: "Tamine" },
      { id: 564169, name: "Tamkade" },
      { id: 564254, name: "Tamkane" },
      { id: 564214, name: "Tarale" },
      { id: 564423, name: "Taygadewadi" },
      { id: 564323, name: "Telewadi" },
      { id: 944581, name: "Tetamewadi" },
      { id: 564151, name: "Thankal" },
      { id: 564300, name: "Thomase" },
      { id: 564259, name: "Tolewadi" },
      { id: 564193, name: "Tondoshi" },
      { id: 564148, name: "Torane" },
      { id: 564340, name: "Tripudi" },
      { id: 564418, name: "Tupewadi" },
      { id: 564394, name: "Udhavane" },
      { id: 564408, name: "Umarkanchan" },
      { id: 564302, name: "Urul" },
      { id: 564347, name: "Vadi Kotawade" },
      { id: 564434, name: "Vaichalwadi" },
      { id: 564143, name: "Vajegaon" },
      { id: 564163, name: "Vajegaon (Marul Patan)" },
      { id: 564227, name: "Vajroshi" },
      { id: 564123, name: "Van" },
      { id: 564159, name: "Vanzole" },
      { id: 564429, name: "Varekarwadi" },
      { id: 564248, name: "Vatole" },
      { id: 564221, name: "Vekhandwadi" },
      { id: 564312, name: "Vetalwadi" },
      { id: 564304, name: "Vihe" },
      { id: 564282, name: "Virewadi" },
      { id: 564180, name: "Waghane" },
      { id: 564292, name: "Waghjaewadi" },
      { id: 564444, name: "Wazoli" },
      { id: 564452, name: "Yelewadi" },
      { id: 564167, name: "Yerad" },
      { id: 564306, name: "Yeradwadi" },
      { id: 564270, name: "Yerphale" },
      { id: 564129, name: "Zadoli" },
      { id: 564173, name: "Zakade" },
    ],
    4265: [
      { id: 564570, name: "Abachiwadi" },
      { id: 564633, name: "Akaichiwadi" },
      { id: 564583, name: "Ambavade" },
      { id: 564526, name: "Andharwadi" },
      { id: 564584, name: "Ane" },
      { id: 564502, name: "Antvadi" },
      { id: 564579, name: "Arewadi" },
      { id: 564647, name: "Atake" },
      { id: 564551, name: "Babarmachi" },
      { id: 564596, name: "Bamanwadi" },
      { id: 944132, name: "Banavadi" },
      { id: 564609, name: "Bandekarwadi" },
      { id: 564489, name: "Banugadewadi" },
      { id: 564664, name: "Belavade Bk" },
      { id: 564566, name: "Beldare" },
      { id: 564532, name: "Belvade Haveli" },
      { id: 564487, name: "Belwadi" },
      { id: 564468, name: "Bhagatwadi" },
      { id: 946115, name: "Bhambe (Punarvasit)" },
      { id: 564624, name: "Bharewadi" },
      { id: 564524, name: "Bhavanwadi" },
      { id: 564565, name: "Bholewadi" },
      { id: 564516, name: "Bhosalewadi" },
      { id: 564623, name: "Bhurbhushi" },
      { id: 564480, name: "Bhuyachiwadi" },
      { id: 564634, name: "Botrewadi" },
      { id: 564535, name: "British Shirwade" },
      { id: 564588, name: "Chachegaon" },
      { id: 564655, name: "Chapnemali" },
      { id: 564529, name: "Charegaon" },
      { id: 564654, name: "Chaugulemala" },
      { id: 564498, name: "Chikhali" },
      { id: 564486, name: "Chinchani" },
      { id: 564473, name: "Chorajwadi" },
      { id: 564474, name: "Chore" },
      { id: 564630, name: "Chormarwadi" },
      { id: 564470, name: "Daphalwadi" },
      { id: 564582, name: "Delewadi" },
      { id: 564521, name: "Dhanakwadi" },
      { id: 564471, name: "Dhavarwadi" },
      { id: 564640, name: "Dhondewadi" },
      { id: 564673, name: "Dushere" },
      { id: 564491, name: "Gaikwadwadi" },
      { id: 564580, name: "Gamewadi" },
      { id: 564626, name: "Ganeshwadi" },
      { id: 564621, name: "Gharalwadi" },
      { id: 564600, name: "Gharewadi" },
      { id: 564614, name: "Ghogaon" },
      { id: 564499, name: "Gholapwadi" },
      { id: 564556, name: "Ghonashi" },
      { id: 564666, name: "Goleshwar" },
      { id: 564679, name: "Gondi" },
      { id: 564671, name: "Gopalnagar" },
      { id: 564492, name: "Gosavewadi" },
      { id: 564563, name: "Gote" },
      { id: 564625, name: "Gotewadi" },
      { id: 564562, name: "Govare" },
      { id: 564683, name: "Hajarmachi" },
      { id: 564622, name: "Hanamantwadi" },
      { id: 564494, name: "Hanbarwadi" },
      { id: 564522, name: "Hanumanwadi" },
      { id: 564466, name: "Harpalwadi" },
      { id: 564607, name: "Havelwadi" },
      { id: 564488, name: "Helgaon" },
      { id: 564483, name: "Hingnole" },
      { id: 564481, name: "Indoli" },
      { id: 564648, name: "Jadhavmala" },
      { id: 564641, name: "Jakhinwadi" },
      { id: 564636, name: "Jinti" },
      { id: 564652, name: "Jujarwadi" },
      { id: 564680, name: "Julewadi" },
      { id: 564518, name: "June Kavathe" },
      { id: 564495, name: "Kacharewadi" },
      { id: 564525, name: "Kalantrewadi" },
      { id: 564651, name: "Kale" },
      { id: 564645, name: "Kaletake" },
      { id: 564485, name: "Kalgaon" },
      { id: 564661, name: "Kalvade" },
      { id: 564542, name: "Kamathi" },
      { id: 564508, name: "Kambirwadi" },
      { id: 564667, name: "Kapil" },
      { id: 564685, name: "Karad" },
      { id: 946095, name: "Karanjoshi (Punarvasit)" },
      { id: 564544, name: "Karavadi" },
      { id: 564670, name: "Karve" },
      { id: 564665, name: "Kasarshirambe" },
      { id: 564571, name: "Kese" },
      { id: 564527, name: "Khalkarwadi" },
      { id: 564496, name: "Kharade" },
      { id: 564500, name: "Khodjaiwadi" },
      { id: 564557, name: "Khodshi" },
      { id: 564682, name: "Khubi" },
      { id: 564586, name: "Kirpe" },
      { id: 564501, name: "Kival" },
      { id: 564669, name: "Kodoli" },
      { id: 564591, name: "Kole" },
      { id: 564592, name: "Kolewadi" },
      { id: 564509, name: "Konegaon" },
      { id: 564546, name: "Koparde Haveli" },
      { id: 564554, name: "Koregaon" },
      { id: 564482, name: "Koriwale" },
      { id: 564517, name: "Korti" },
      { id: 564642, name: "Koyanavasahat" },
      { id: 564594, name: "Kusur" },
      { id: 564606, name: "Latakewadi" },
      { id: 564628, name: "Loharwadi" },
      { id: 564635, name: "Maharugadewadi" },
      { id: 944133, name: "Malakapur" },
      { id: 564662, name: "Malkhed" },
      { id: 564507, name: "Malwadi" },
      { id: 564515, name: "Mangwadi (Umbraj)" },
      { id: 564659, name: "Manu" },
      { id: 564469, name: "Marali" },
      { id: 564472, name: "Maskarwadi" },
      { id: 564505, name: "Masur" },
      { id: 564631, name: "Matekarwadi" },
      { id: 564539, name: "Meravewadi" },
      { id: 564615, name: "Mhasoli" },
      { id: 564567, name: "Mhopre" },
      { id: 564646, name: "Munawale" },
      { id: 564560, name: "Mundhe" },
      { id: 564536, name: "Nadashi" },
      { id: 564638, name: "Nandgaon" },
      { id: 564643, name: "Nandlapur" },
      { id: 946092, name: "Nanegaon (Punarvasit)" },
      { id: 564644, name: "Narayanwadi" },
      { id: 564601, name: "Navin Gavthan Gharewadi" },
      { id: 564519, name: "Navin Kavathe" },
      { id: 564663, name: "Navin Malkhed" },
      { id: 564639, name: "Navin Nandgaon" },
      { id: 564493, name: "Nigadi" },
      { id: 564656, name: "Ond" },
      { id: 564637, name: "Ondoshi" },
      { id: 564541, name: "Pachund" },
      { id: 564604, name: "Pachupatewadi" },
      { id: 564668, name: "Pachwadwasti" },
      { id: 564490, name: "Padali Helgaon" },
      { id: 564572, name: "Padalikese" },
      { id: 564467, name: "Pal" },
      { id: 564545, name: "Parle" },
      { id: 944131, name: "Paschim Umbraj" },
      { id: 564573, name: "Pashchimsupane" },
      { id: 564581, name: "Patharwadi" },
      { id: 564658, name: "Patilmala" },
      { id: 564598, name: "Pawarwadi" },
      { id: 564660, name: "Pawarwadi (Nandgaon)" },
      { id: 564479, name: "Perale" },
      { id: 564510, name: "Pimpari" },
      { id: 564590, name: "Potale" },
      { id: 564550, name: "Rajmachi" },
      { id: 564681, name: "Rethare Bk." },
      { id: 564649, name: "Rethare Kh." },
      { id: 564503, name: "Risvad" },
      { id: 564484, name: "Sabalwadi" },
      { id: 564684, name: "Saidapur" },
      { id: 564578, name: "Sajur" },
      { id: 564475, name: "Sakharwadi" },
      { id: 564575, name: "Sakurdi" },
      { id: 564612, name: "Salshirambe" },
      { id: 564653, name: "Sanjaynagar" },
      { id: 564675, name: "Sanjaynagar (Shere)" },
      { id: 564608, name: "Savade" },
      { id: 946061, name: "Savarghar (Punarvasit)" },
      { id: 564552, name: "Sayapur" },
      { id: 564511, name: "Shahapur" },
      { id: 564540, name: "Shamgaon" },
      { id: 564616, name: "Shelakewadi (Mhasoli)" },
      { id: 564619, name: "Shelakewadi (Yevati)" },
      { id: 564677, name: "Shenoli" },
      { id: 564678, name: "Shenolistalion" },
      { id: 564674, name: "Shere" },
      { id: 564617, name: "Shevalwadi (Mhasoli)" },
      { id: 564611, name: "Shevalwadi (Undale)" },
      { id: 564632, name: "Shevalwadi (Yenape)" },
      { id: 564620, name: "Shewalewadi (Yevati)" },
      { id: 564593, name: "Shindewadi" },
      { id: 564602, name: "Shindewadi (Kolewadi)" },
      { id: 564599, name: "Shinganwadi" },
      { id: 564534, name: "Shiravade" },
      { id: 564477, name: "Shirgaon" },
      { id: 564528, name: "Shitalwadi" },
      { id: 564523, name: "Shiwade" },
      { id: 564574, name: "Supane" },
      { id: 564543, name: "Surli" },
      { id: 564533, name: "Talbid" },
      { id: 564613, name: "Talgaon" },
      { id: 564576, name: "Tambave" },
      { id: 564595, name: "Tarukh" },
      { id: 564531, name: "Tasavade" },
      { id: 564553, name: "Tembhu" },
      { id: 564676, name: "Thorathmala (Ond)" },
      { id: 564657, name: "Thoratmala" },
      { id: 564603, name: "Tulsan" },
      { id: 564513, name: "Umbraj" },
      { id: 564610, name: "Undale" },
      { id: 564577, name: "Uttar Tambave" },
      { id: 564476, name: "Vadgaon Umbraj" },
      { id: 564520, name: "Vadoli Bhikeshwar" },
      { id: 564537, name: "Vadoli Nileshwar" },
      { id: 564538, name: "Vagheri" },
      { id: 564555, name: "Vahagaon" },
      { id: 564597, name: "Vanarwadi" },
      { id: 564558, name: "Vanavasmachi" },
      { id: 564561, name: "Vanvasmachi (Sadashivgad)" },
      { id: 564530, name: "Varade" },
      { id: 564564, name: "Varunji" },
      { id: 564569, name: "Vasantgad" },
      { id: 564568, name: "Vastisakurdi" },
      { id: 564650, name: "Vathar" },
      { id: 564559, name: "Vijaynagar" },
      { id: 564589, name: "Ving" },
      { id: 564548, name: "Virvade" },
      { id: 564605, name: "Vithobachiwadi" },
      { id: 564672, name: "Wadgaon Haveli" },
      { id: 564504, name: "Wagheshwar" },
      { id: 564497, name: "Wanyachiwadi" },
      { id: 564478, name: "Wazewadi" },
      { id: 564547, name: "Yadavawadi (Masur)" },
      { id: 564506, name: "Yadavawadi(Uttar Koparde)" },
      { id: 564512, name: "Yashwantnagar" },
      { id: 564627, name: "Yelgaon" },
      { id: 564585, name: "Yenake" },
      { id: 564629, name: "Yenape" },
      { id: 564587, name: "Yeravale" },
      { id: 564618, name: "Yevati" },
    ],
    4266: [
      { id: 564702, name: "Adkhal" },
      { id: 564695, name: "Adkhalvan" },
      { id: 564712, name: "Ambadawe" },
      { id: 564737, name: "Ambavali" },
      { id: 564686, name: "Ambavane Bk." },
      { id: 564750, name: "Ambavane Kh." },
      { id: 564707, name: "Asawale" },
      { id: 564724, name: "Atale" },
      { id: 564706, name: "Bahiravali" },
      { id: 564768, name: "Bamanghar" },
      { id: 564744, name: "Bankot" },
      { id: 564714, name: "Bhamghar" },
      { id: 564770, name: "Bhingaloli" },
      { id: 564794, name: "Bholavali" },
      { id: 564762, name: "Borghar" },
      { id: 564716, name: "Borkhat" },
      { id: 564700, name: "Buri" },
      { id: 564730, name: "Chinchaghar" },
      { id: 564696, name: "Chinchali" },
      { id: 564789, name: "Dabhat" },
      { id: 564766, name: "Dahagaon" },
      { id: 564751, name: "Dahimbe" },
      { id: 564687, name: "Dandnagari" },
      { id: 564755, name: "Dattanagar" },
      { id: 564720, name: "Devhare" },
      { id: 564718, name: "Dhamani" },
      { id: 564703, name: "Dhangar" },
      { id: 564772, name: "Dhutroli" },
      { id: 564767, name: "Dudhere" },
      { id: 564729, name: "Gawalwadi" },
      { id: 564765, name: "Gharadi" },
      { id: 564747, name: "Ghosale" },
      { id: 564710, name: "Ghumari" },
      { id: 564715, name: "Gothe" },
      { id: 564699, name: "Govele" },
      { id: 564793, name: "Gowal" },
      { id: 564733, name: "Gudeghar" },
      { id: 564694, name: "Islampur" },
      { id: 564754, name: "Jambulnagar" },
      { id: 564732, name: "Jawale" },
      { id: 564787, name: "Kadawan" },
      { id: 564719, name: "Kalkavane" },
      { id: 564740, name: "Kante" },
      { id: 564769, name: "Kelwat" },
      { id: 564741, name: "Kengwal" },
      { id: 564727, name: "Keril" },
      { id: 564709, name: "Kinjalghar" },
      { id: 564688, name: "Kondgaon" },
      { id: 564723, name: "Konhavali" },
      { id: 564759, name: "Konzar" },
      { id: 564728, name: "Kuduk Bk." },
      { id: 564781, name: "Kuduk Kh." },
      { id: 564774, name: "Kumbale" },
      { id: 564698, name: "Kumbharli" },
      { id: 564791, name: "Latawan" },
      { id: 564692, name: "Lokran" },
      { id: 564761, name: "Mahu" },
      { id: 564760, name: "Mandangad" },
      { id: 564693, name: "Mhapral" },
      { id: 564792, name: "Muradpur" },
      { id: 564745, name: "Narayannagar" },
      { id: 564763, name: "Nargoli" },
      { id: 564726, name: "Nayane" },
      { id: 564711, name: "Nigadi" },
      { id: 564748, name: "Pacharal" },
      { id: 564691, name: "Padwe" },
      { id: 564756, name: "Palawani" },
      { id: 564758, name: "Pale" },
      { id: 564773, name: "Palghar" },
      { id: 564705, name: "Panderi" },
      { id: 564731, name: "Panhali Bk." },
      { id: 564697, name: "Panhali Kh." },
      { id: 564771, name: "Pat" },
      { id: 564689, name: "Pewe" },
      { id: 564788, name: "Pimpalgaon" },
      { id: 564775, name: "Pimpaloli" },
      { id: 564739, name: "Ranavali" },
      { id: 564783, name: "Sade" },
      { id: 564738, name: "Sakhari" },
      { id: 564713, name: "Sawari" },
      { id: 564764, name: "Shedawai" },
      { id: 564778, name: "Shenale" },
      { id: 564725, name: "Sheware" },
      { id: 564708, name: "Shigvan" },
      { id: 564736, name: "Shipole" },
      { id: 564735, name: "Shipole Bandar" },
      { id: 564777, name: "Shirgaon" },
      { id: 564780, name: "Soweli" },
      { id: 564701, name: "Surle" },
      { id: 564704, name: "Takavali" },
      { id: 564776, name: "Takede" },
      { id: 564785, name: "Taleghar" },
      { id: 564721, name: "Tamhane" },
      { id: 564782, name: "Terdi" },
      { id: 564784, name: "Tide" },
      { id: 564752, name: "Tondali" },
      { id: 564757, name: "Tulshi" },
      { id: 564690, name: "Umbershet" },
      { id: 564734, name: "Umroli" },
      { id: 564749, name: "Unhavare" },
      { id: 564722, name: "Vadavali" },
      { id: 564779, name: "Vakavali" },
      { id: 564743, name: "Valmikinagar" },
      { id: 564786, name: "Valote" },
      { id: 564746, name: "Velas" },
      { id: 564753, name: "Veral Tarf Natu" },
      { id: 564717, name: "Veral Tarfe Vesavi" },
      { id: 564742, name: "Vesavi" },
      { id: 564790, name: "Vinhe" },
    ],
    4267: [
      { id: 564807, name: "Ade" },
      { id: 564830, name: "Adkhal" },
      { id: 564917, name: "Agarvayangani" },
      { id: 564908, name: "Aghari" },
      { id: 564805, name: "Ambavali Bk." },
      { id: 564876, name: "Ambavali Kh." },
      { id: 564819, name: "Anjarla" },
      { id: 564941, name: "Apti" },
      { id: 564953, name: "Asond" },
      { id: 564883, name: "Asud" },
      { id: 564803, name: "Atgaon" },
      { id: 564849, name: "Awashi" },
      { id: 564824, name: "Bandhativare" },
      { id: 564965, name: "Bhadavale" },
      { id: 564845, name: "Bhangar" },
      { id: 564851, name: "Bhatghar" },
      { id: 564922, name: "Bhati" },
      { id: 564835, name: "Bhomadi" },
      { id: 564931, name: "Bhopan" },
      { id: 564880, name: "Bondivali" },
      { id: 564942, name: "Borghar" },
      { id: 564911, name: "Borivali" },
      { id: 564817, name: "Borthal" },
      { id: 564887, name: "Brahmanwadi" },
      { id: 564893, name: "Burondi" },
      { id: 943167, name: "Camp Dapoli" },
      { id: 564897, name: "Chandikanagar" },
      { id: 564814, name: "Chandivane" },
      { id: 564886, name: "Chandranagar" },
      { id: 564906, name: "Chikhalgaon" },
      { id: 564862, name: "Chinchali" },
      { id: 564928, name: "Dabhil" },
      { id: 564970, name: "Dabhol" },
      { id: 564823, name: "Dalkhan" },
      { id: 564963, name: "Damame" },
      { id: 564959, name: "Degaon" },
      { id: 564815, name: "Dehen" },
      { id: 564920, name: "Derde" },
      { id: 564892, name: "Devke" },
      { id: 564843, name: "Dhankoli" },
      { id: 564834, name: "Douli" },
      { id: 564854, name: "Dr.Iqubalnagar" },
      { id: 564910, name: "Dumdeo" },
      { id: 564847, name: "Ganpatipule" },
      { id: 564951, name: "Gaontale" },
      { id: 564888, name: "Gavhe" },
      { id: 564914, name: "Gavrai" },
      { id: 564968, name: "Gimhavane" },
      { id: 564934, name: "Gudaghe" },
      { id: 564829, name: "Harne" },
      { id: 564865, name: "Hatip" },
      { id: 564811, name: "Ilane" },
      { id: 564946, name: "Inampangari" },
      { id: 564969, name: "Jalgaon" },
      { id: 564860, name: "Jamge" },
      { id: 943168, name: "Jogele" },
      { id: 564827, name: "Juikar Mohalla" },
      { id: 564839, name: "Kadivali" },
      { id: 564832, name: "Kalambat" },
      { id: 564838, name: "Kalanagar" },
      { id: 564916, name: "Kalki" },
      { id: 564837, name: "Kangavai" },
      { id: 564891, name: "Karajgaon" },
      { id: 564958, name: "Karanjali" },
      { id: 564881, name: "Karanjani" },
      { id: 564885, name: "Karde" },
      { id: 564961, name: "Katran" },
      { id: 564798, name: "Kawadoli" },
      { id: 564795, name: "Kelashi" },
      { id: 564926, name: "Kelil" },
      { id: 564800, name: "Kharavate" },
      { id: 564879, name: "Kherdi" },
      { id: 564900, name: "Kinhal" },
      { id: 564949, name: "Kolbandre" },
      { id: 564907, name: "Kolthare" },
      { id: 564956, name: "Kondhe" },
      { id: 564826, name: "Kongle" },
      { id: 564844, name: "Kudavale" },
      { id: 564940, name: "Kumbhave" },
      { id: 564889, name: "Ladghar" },
      { id: 564810, name: "Lonvadi" },
      { id: 564868, name: "Mahalunge" },
      { id: 564896, name: "Mahamaynagar" },
      { id: 564912, name: "Male" },
      { id: 564806, name: "Malvi" },
      { id: 564799, name: "Mandivali" },
      { id: 564913, name: "Mathegujar" },
      { id: 564846, name: "Matwan" },
      { id: 564882, name: "Mauje Dapoli" },
      { id: 564850, name: "Mugij" },
      { id: 564820, name: "Murdi" },
      { id: 564884, name: "Murud" },
      { id: 564905, name: "Nante" },
      { id: 564936, name: "Nargoli" },
      { id: 564921, name: "Navase" },
      { id: 564937, name: "Navashi" },
      { id: 564867, name: "Nawanagar" },
      { id: 564899, name: "Nigade" },
      { id: 564901, name: "Olgaon" },
      { id: 564924, name: "Onanvase" },
      { id: 564923, name: "Oni" },
      { id: 564869, name: "Pachavali" },
      { id: 564808, name: "Padale" },
      { id: 564871, name: "Palgad" },
      { id: 564909, name: "Panchanadi" },
      { id: 564932, name: "Panderi" },
      { id: 564828, name: "Pandhari" },
      { id: 564929, name: "Pangari Tarf Haveli" },
      { id: 564915, name: "Panhalekazi" },
      { id: 564960, name: "Pavnal" },
      { id: 564955, name: "Phansu" },
      { id: 564967, name: "Pharare" },
      { id: 564836, name: "Pichadoli" },
      { id: 564873, name: "Pisai" },
      { id: 564957, name: "Pophalwane" },
      { id: 564822, name: "Rajapur" },
      { id: 564797, name: "Rawtoli" },
      { id: 564841, name: "Rewali" },
      { id: 564802, name: "Rowale" },
      { id: 564952, name: "Rukhi" },
      { id: 564903, name: "Sadavali" },
      { id: 564944, name: "Sadave" },
      { id: 564930, name: "Sahilnagar" },
      { id: 564945, name: "Sakhaloli" },
      { id: 564842, name: "Sakurde" },
      { id: 564875, name: "Saldure" },
      { id: 564861, name: "Samsher Ali Nagar" },
      { id: 564874, name: "Sarang" },
      { id: 564821, name: "Satamba" },
      { id: 564925, name: "Satere Tarf Haveli" },
      { id: 564859, name: "Satere Tarf Natu" },
      { id: 564927, name: "Shiravane" },
      { id: 564943, name: "Shirde" },
      { id: 564864, name: "Shirkhal" },
      { id: 564853, name: "Shirsadi" },
      { id: 564855, name: "Shirseshwar" },
      { id: 564938, name: "Shirshinge" },
      { id: 564856, name: "Shirsoli" },
      { id: 564895, name: "Shitalnagar" },
      { id: 564948, name: "Shivajinagar (Aade)" },
      { id: 564878, name: "Shivajinagar (Gimhavane)" },
      { id: 564809, name: "Shivajinagar (Sakhaloli)" },
      { id: 564950, name: "Shiwnari" },
      { id: 564870, name: "Sondeghar" },
      { id: 564852, name: "Soveli" },
      { id: 564816, name: "Sukondi" },
      { id: 564818, name: "Tadachakond" },
      { id: 564825, name: "Tadil" },
      { id: 564935, name: "Talsure" },
      { id: 564890, name: "Tamastirth" },
      { id: 564964, name: "Tamond" },
      { id: 564848, name: "Tangar" },
      { id: 564894, name: "Teleshwarnagar" },
      { id: 564904, name: "Terevayangani" },
      { id: 564947, name: "Tetavali" },
      { id: 564813, name: "Turavade" },
      { id: 564933, name: "Umbarghar" },
      { id: 564902, name: "Umbarle" },
      { id: 564796, name: "Umbarshet" },
      { id: 564962, name: "Unhavare" },
      { id: 564954, name: "Urphi" },
      { id: 564919, name: "Usgaon" },
      { id: 564804, name: "Utambar" },
      { id: 564866, name: "Vadavli" },
      { id: 564877, name: "Vanand" },
      { id: 564872, name: "Vanoshi Tarf Natu" },
      { id: 564918, name: "Vanoshi Tarf Panchanadi" },
      { id: 564840, name: "Velvi" },
      { id: 564833, name: "Virsai" },
      { id: 564857, name: "Visapur" },
      { id: 564858, name: "Visharantinagar" },
      { id: 564831, name: "Waghave" },
      { id: 564812, name: "Waghivane" },
      { id: 564939, name: "Wakavali" },
      { id: 564898, name: "Walane" },
      { id: 564801, name: "Wanzloli" },
      { id: 564966, name: "Wavghar" },
    ],
    4268: [
      { id: 565035, name: "Ainavali" },
      { id: 565061, name: "Ainavare" },
      { id: 564980, name: "Aini" },
      { id: 565083, name: "Alsure" },
      { id: 565084, name: "Alsure Kh." },
      { id: 565151, name: "Ambadas" },
      { id: 565057, name: "Ambavali" },
      { id: 564973, name: "Ambaye" },
      { id: 565102, name: "Anaspure" },
      { id: 565121, name: "Anjani" },
      { id: 565019, name: "Apede" },
      { id: 565126, name: "Asagani" },
      { id: 565127, name: "Asagani Mohalla" },
      { id: 565118, name: "Ashti" },
      { id: 565119, name: "Ashti Budruk" },
      { id: 565120, name: "Ashti Mohalla" },
      { id: 565046, name: "Astan" },
      { id: 565128, name: "Avashi" },
      { id: 565109, name: "Bahiravali" },
      { id: 565031, name: "Bharana Naka" },
      { id: 565030, name: "Bharane" },
      { id: 565154, name: "Bhelsai" },
      { id: 565081, name: "Bhoste" },
      { id: 565076, name: "Bhoste Bk." },
      { id: 565080, name: "Bhoste Mohalla" },
      { id: 565067, name: "Bijghar" },
      { id: 565039, name: "Biramani" },
      { id: 565114, name: "Boraj" },
      { id: 565015, name: "Borghar" },
      { id: 564985, name: "Chakale" },
      { id: 565177, name: "Chandewadi" },
      { id: 565047, name: "Chatav" },
      { id: 565014, name: "Chinchavali" },
      { id: 564986, name: "Chinchghar" },
      { id: 565029, name: "Chinchwadi" },
      { id: 565149, name: "Chirani" },
      { id: 565150, name: "Chirani Varchiwadi" },
      { id: 565164, name: "Choravane" },
      { id: 565165, name: "Choravane Utekarwadi" },
      { id: 565108, name: "Chougale Mohalla" },
      { id: 565124, name: "Dabhil" },
      { id: 565009, name: "Dahivali" },
      { id: 565071, name: "Dayal" },
      { id: 565052, name: "Devghar" },
      { id: 564993, name: "Devsade" },
      { id: 565129, name: "Dhakarwadi" },
      { id: 564995, name: "Dhakti Suseri" },
      { id: 565160, name: "Dhamanand" },
      { id: 565146, name: "Dhamandevi" },
      { id: 564976, name: "Dhamani" },
      { id: 565045, name: "Dhavade" },
      { id: 565002, name: "Divan Khavati" },
      { id: 565073, name: "Diwalewadi" },
      { id: 564989, name: "Falsonda" },
      { id: 564990, name: "Furus" },
      { id: 564988, name: "Furus Amshet" },
      { id: 564992, name: "Furus Gaonthan" },
      { id: 945109, name: "Ganwal" },
      { id: 565142, name: "Ghanekhunt" },
      { id: 565049, name: "Ghera Rasalgad" },
      { id: 565022, name: "Ghera Sumargad" },
      { id: 564975, name: "Gherapalgad" },
      { id: 565008, name: "Ghogare" },
      { id: 565131, name: "Gunade" },
      { id: 565062, name: "Hedali" },
      { id: 565106, name: "Hodkhad" },
      { id: 565105, name: "Hodkhad Kh." },
      { id: 565054, name: "Humbari" },
      { id: 565023, name: "Jaitapur" },
      { id: 564974, name: "Jamage" },
      { id: 565065, name: "Jambhulgaon" },
      { id: 565077, name: "Jambhurde" },
      { id: 565184, name: "Javli Gaonthan" },
      { id: 565174, name: "Kadavali" },
      { id: 565173, name: "Kajvewadi" },
      { id: 565016, name: "Kalambani Bk." },
      { id: 565038, name: "Kalambani Kh." },
      { id: 565040, name: "Kandoshi" },
      { id: 565097, name: "Karjee" },
      { id: 565098, name: "Karjee Amshet" },
      { id: 565095, name: "Karjee Bk." },
      { id: 565028, name: "Kartel" },
      { id: 565004, name: "Kasaba Natu" },
      { id: 565157, name: "Kasai" },
      { id: 565000, name: "Kashedi" },
      { id: 565158, name: "Kavale" },
      { id: 565172, name: "Kelane" },
      { id: 565053, name: "Khalachi Humbari" },
      { id: 565075, name: "Khari" },
      { id: 565003, name: "Khavati" },
      { id: 943163, name: "Khed" },
      { id: 564997, name: "Khed (Bhadgaon)" },
      { id: 565137, name: "Khopi" },
      { id: 565136, name: "Khopi Tambadwadi" },
      { id: 565041, name: "Kinjale Tarf Khed" },
      { id: 565007, name: "Kinjale Tarf Natu" },
      { id: 565110, name: "Kondivali" },
      { id: 565111, name: "Kondivali Kh." },
      { id: 564972, name: "Kondwadi" },
      { id: 565086, name: "Koregaon" },
      { id: 565087, name: "Koregaon Kh." },
      { id: 565141, name: "Kotwali" },
      { id: 565034, name: "Kudoshi" },
      { id: 565066, name: "Kulvandi" },
      { id: 565068, name: "Kumbhad" },
      { id: 565176, name: "Kumbhavali" },
      { id: 565185, name: "Kuraval Gaothan" },
      { id: 565180, name: "Kuraval Javali" },
      { id: 565179, name: "Kuraval Khed" },
      { id: 565125, name: "Lavel" },
      { id: 565148, name: "Lote" },
      { id: 565058, name: "Mahalunge" },
      { id: 565020, name: "Mandave" },
      { id: 565064, name: "Mani" },
      { id: 565122, name: "Mete" },
      { id: 565132, name: "Mirle" },
      { id: 565051, name: "Mohane" },
      { id: 565079, name: "Morvande" },
      { id: 565078, name: "Morvande Kh." },
      { id: 565099, name: "Mulgaon" },
      { id: 565092, name: "Mumbake" },
      { id: 564983, name: "Murde" },
      { id: 565178, name: "Musad" },
      { id: 565074, name: "Nandgaon" },
      { id: 565072, name: "Nandgaon Mohalla" },
      { id: 565044, name: "Nandivali" },
      { id: 565060, name: "Nawanagar" },
      { id: 565115, name: "Nigade" },
      { id: 565025, name: "Nilavane" },
      { id: 565085, name: "Nilik" },
      { id: 565163, name: "Nive" },
      { id: 565001, name: "Pakharwadi" },
      { id: 565104, name: "Panhalaje" },
      { id: 565103, name: "Panhalaje Kh." },
      { id: 565169, name: "Posare Bk." },
      { id: 565168, name: "Posare Kh." },
      { id: 564978, name: "Poyanar" },
      { id: 564977, name: "Poyanar Kh." },
      { id: 564984, name: "Prabhuwadi" },
      { id: 565013, name: "Pure Bk." },
      { id: 565012, name: "Pure Kh." },
      { id: 565094, name: "Rajvel" },
      { id: 565167, name: "Sakhar" },
      { id: 564987, name: "Sakharoli" },
      { id: 564979, name: "Sakharoli Kh." },
      { id: 565055, name: "Sanaghar" },
      { id: 565090, name: "Sanglat" },
      { id: 565088, name: "Sanglat Boudhwadi" },
      { id: 565089, name: "Sanglat Marathwadi" },
      { id: 565091, name: "Sanglot Mohalla" },
      { id: 565166, name: "Sapirli" },
      { id: 565123, name: "Satvingaon" },
      { id: 565100, name: "Savanas" },
      { id: 565101, name: "Savanas Kh." },
      { id: 565063, name: "Saveni" },
      { id: 565134, name: "Sheldi" },
      { id: 565070, name: "Sheraval" },
      { id: 565069, name: "Sheraval Kh." },
      { id: 565011, name: "Shingri" },
      { id: 565026, name: "Shiravali" },
      { id: 565139, name: "Shirgaon" },
      { id: 565140, name: "Shirgaon Kh." },
      { id: 565093, name: "Shirshi" },
      { id: 565112, name: "Shiv Bk." },
      { id: 565116, name: "Shiv Kh." },
      { id: 565113, name: "Shiv Mohalla" },
      { id: 564971, name: "Shivtar" },
      { id: 565050, name: "Sondye" },
      { id: 565144, name: "Songaon" },
      { id: 564991, name: "Sukdar" },
      { id: 565033, name: "Sukivali" },
      { id: 564994, name: "Suseri" },
      { id: 565096, name: "Talaghar" },
      { id: 565024, name: "Tale" },
      { id: 565161, name: "Talvat Javali" },
      { id: 565162, name: "Talvat Khed" },
      { id: 565159, name: "Talvat Pal" },
      { id: 565059, name: "Tisangi" },
      { id: 564982, name: "Tise" },
      { id: 564981, name: "Tise Kh." },
      { id: 564998, name: "Tulashi Bk." },
      { id: 564999, name: "Tulashi Kh." },
      { id: 565107, name: "Tumbad" },
      { id: 565018, name: "Udhale Bk." },
      { id: 565017, name: "Udhale Kh." },
      { id: 565027, name: "Valanjawadi" },
      { id: 565056, name: "Varavali" },
      { id: 565032, name: "Veral" },
      { id: 564996, name: "Vetalwadi" },
      { id: 565042, name: "Vihali" },
      { id: 565082, name: "Virachiwadi" },
      { id: 565037, name: "Wadgaon Bk." },
      { id: 565036, name: "Wadgaon Kh." },
      { id: 565010, name: "Wadi Beldar" },
      { id: 565048, name: "Wadi Bid" },
      { id: 565021, name: "Wadi Jaitapur" },
      { id: 565043, name: "Wadi Malde" },
      { id: 565182, name: "Wave Tarf Khed" },
      { id: 565006, name: "Wave Tarf Natu" },
      { id: 565175, name: "Zagdewadi" },
    ],
    4269: [
      { id: 565259, name: "Adare" },
      { id: 565298, name: "Agarwadi" },
      { id: 565329, name: "Agave" },
      { id: 565235, name: "Akale" },
      { id: 565269, name: "Akuskhannagar" },
      { id: 565265, name: "Alore" },
      { id: 565333, name: "Ambatkhol" },
      { id: 565289, name: "Ambere Bk." },
      { id: 565309, name: "Ambitgaon" },
      { id: 565261, name: "Anari" },
      { id: 565332, name: "Asurde" },
      { id: 565187, name: "Bamnoli" },
      { id: 565216, name: "Bhile" },
      { id: 565197, name: "Bhom" },
      { id: 565212, name: "Bivali" },
      { id: 565192, name: "Borgaon" },
      { id: 565229, name: "Chinchghari" },
      { id: 943166, name: "Chiplun" },
      { id: 565191, name: "Chiveli" },
      { id: 565242, name: "Dadar" },
      { id: 565283, name: "Dahivali Bk." },
      { id: 565284, name: "Dahivali Kh." },
      { id: 565246, name: "Dalvatne" },
      { id: 565336, name: "Dervan" },
      { id: 565335, name: "Dervan Kh." },
      { id: 565287, name: "Devkherki" },
      { id: 565317, name: "Devpat" },
      { id: 565310, name: "Dhakmoli" },
      { id: 565228, name: "Dhamanvane" },
      { id: 565215, name: "Dhameli Kond" },
      { id: 565306, name: "Dhokravali" },
      { id: 565190, name: "Donavali" },
      { id: 565297, name: "Dugave" },
      { id: 565345, name: "Durgwadi" },
      { id: 565344, name: "Durgwadi Kh." },
      { id: 565244, name: "Gane" },
      { id: 565250, name: "Ganeshpur" },
      { id: 565189, name: "Gangrai" },
      { id: 565300, name: "Ghavalwadi" },
      { id: 565193, name: "Gondhale" },
      { id: 565225, name: "Govalkot" },
      { id: 943165, name: "Gudhe Budruk" },
      { id: 565299, name: "Gudhe Khurd" },
      { id: 565304, name: "Gulavane" },
      { id: 565334, name: "Hadkani" },
      { id: 565199, name: "Hanumangaon" },
      { id: 565206, name: "Jodhagaon" },
      { id: 565241, name: "Kadwad" },
      { id: 565223, name: "Kalambaste" },
      { id: 565301, name: "Kalambat" },
      { id: 565279, name: "Kalavande" },
      { id: 565243, name: "Kalkavane" },
      { id: 565290, name: "Kalmundi" },
      { id: 565217, name: "Kaluste Budruk" },
      { id: 943164, name: "Kaluste Khurd" },
      { id: 565278, name: "Kamathe" },
      { id: 565282, name: "Kamathe Kh." },
      { id: 565253, name: "Kanhe" },
      { id: 565195, name: "Kapare" },
      { id: 565277, name: "Kapsal" },
      { id: 565213, name: "Karambavane" },
      { id: 565328, name: "Kasarwadi" },
      { id: 565313, name: "Katalwadi" },
      { id: 565198, name: "Katroli" },
      { id: 565201, name: "Kaundhar Tamhane" },
      { id: 565302, name: "Kere" },
      { id: 565214, name: "Ketki" },
      { id: 565247, name: "Khadpoli" },
      { id: 565230, name: "Khandat" },
      { id: 565311, name: "Khandotri" },
      { id: 565281, name: "Kharavate" },
      { id: 565351, name: "Kherdi" },
      { id: 565323, name: "Khershet" },
      { id: 565196, name: "Khopad" },
      { id: 565322, name: "Kokare" },
      { id: 565266, name: "Kolkewadi" },
      { id: 565270, name: "Kondfansavane" },
      { id: 565226, name: "Kondhe" },
      { id: 565324, name: "Kondmala" },
      { id: 565338, name: "Kosabi" },
      { id: 565327, name: "Kudap" },
      { id: 565267, name: "Kumbharli" },
      { id: 565205, name: "Kumbharwadi" },
      { id: 565341, name: "Kushivade" },
      { id: 565350, name: "Kutare" },
      { id: 565188, name: "Lonari Chivali Bandar" },
      { id: 565200, name: "Majare Kaundhar" },
      { id: 565348, name: "Majaregoval" },
      { id: 565219, name: "Majarekashi" },
      { id: 565211, name: "Maldoli" },
      { id: 565275, name: "Malghar" },
      { id: 565255, name: "Mandavkhari" },
      { id: 565330, name: "Mandki" },
      { id: 565331, name: "Mandki Kh." },
      { id: 565346, name: "Manjutri" },
      { id: 565202, name: "Margtamhane" },
      { id: 565203, name: "Margtamhane Kh." },
      { id: 565227, name: "Mirjoli" },
      { id: 565293, name: "Mirvane" },
      { id: 565234, name: "Moravane" },
      { id: 565233, name: "Moravane Bk." },
      { id: 565249, name: "Mouje Owali" },
      { id: 565263, name: "Mundhe Tarf Chiplun" },
      { id: 565337, name: "Mundhe Tarf Savarda" },
      { id: 565312, name: "Murtavade" },
      { id: 565264, name: "Nagave" },
      { id: 565339, name: "Nandgaon" },
      { id: 565340, name: "Nandgaon Kh." },
      { id: 565251, name: "Nandivase" },
      { id: 565295, name: "Naradkherki" },
      { id: 565321, name: "Nayashi" },
      { id: 565232, name: "Nirbade" },
      { id: 565210, name: "Nirvhal" },
      { id: 565308, name: "Nivali" },
      { id: 565286, name: "Omali" },
      { id: 565280, name: "Pachad" },
      { id: 565231, name: "Pali" },
      { id: 565307, name: "Palvan" },
      { id: 565288, name: "Pathardi" },
      { id: 565347, name: "Pathe" },
      { id: 565285, name: "Pawarwadi" },
      { id: 565248, name: "Pedhambe" },
      { id: 565220, name: "Pedhe" },
      { id: 565221, name: "Pedhe Parshuram" },
      { id: 565343, name: "Phurus" },
      { id: 565315, name: "Pilavali Tarf Savarda" },
      { id: 565303, name: "Pilawali Tarf Velamb" },
      { id: 565254, name: "Pimpli Bk." },
      { id: 565252, name: "Pimpli Kh." },
      { id: 565272, name: "Pophali" },
      { id: 565271, name: "Pophali Bk." },
      { id: 565194, name: "Posare" },
      { id: 565240, name: "Radhanagar" },
      { id: 565208, name: "Rampur" },
      { id: 565209, name: "Raulgaon" },
      { id: 565276, name: "Rehele Bhagadi" },
      { id: 565237, name: "Riktoli" },
      { id: 565326, name: "Savarde" },
      { id: 565325, name: "Savarde Kh." },
      { id: 565273, name: "Shiral" },
      { id: 565268, name: "Shirgaon" },
      { id: 565294, name: "Shirvali" },
      { id: 565239, name: "Swayamdev" },
      { id: 565349, name: "Talavade" },
      { id: 565207, name: "Talegaon" },
      { id: 565262, name: "Talsar" },
      { id: 565296, name: "Tamhanmala" },
      { id: 565292, name: "Tanali" },
      { id: 565256, name: "Terav" },
      { id: 565258, name: "Terav Bk." },
      { id: 565238, name: "Tivadi" },
      { id: 565236, name: "Tiware" },
      { id: 565314, name: "Tondali" },
      { id: 565305, name: "Turambav" },
      { id: 565291, name: "Ubhale" },
      { id: 565224, name: "Uktad" },
      { id: 565204, name: "Umroli" },
      { id: 565319, name: "Vahal" },
      { id: 565274, name: "Vaijee" },
      { id: 565318, name: "Vareli" },
      { id: 565316, name: "Veer" },
      { id: 565260, name: "Vehele" },
      { id: 565257, name: "Vetkond" },
      { id: 565320, name: "Waderu" },
      { id: 565186, name: "Waghivare" },
      { id: 565222, name: "Walope" },
      { id: 565245, name: "Walvati" },
      { id: 565342, name: "Yegaon" },
    ],
    4270: [
      { id: 565449, name: "Abloli" },
      { id: 565412, name: "Adoor" },
      { id: 565464, name: "Ambere Kh." },
      { id: 565473, name: "Anjanwel" },
      { id: 565373, name: "Are" },
      { id: 565395, name: "Asgoli" },
      { id: 565462, name: "Asore" },
      { id: 565453, name: "Aware" },
      { id: 565460, name: "Bandarwadi" },
      { id: 565408, name: "Barbhai" },
      { id: 565470, name: "Bhatgaon" },
      { id: 565471, name: "Bhatgaon Dhakka" },
      { id: 565472, name: "Bhatgaon Tisang" },
      { id: 565399, name: "Chikhali" },
      { id: 565440, name: "Chindrawale" },
      { id: 565386, name: "Daphalewadi" },
      { id: 565400, name: "Deoghar" },
      { id: 565354, name: "Dhopave" },
      { id: 565441, name: "Dodavali" },
      { id: 565418, name: "Ghadewadi Tarfe Velamb" },
      { id: 565360, name: "Gharatwadi Tarf Veldur" },
      { id: 565391, name: "Gimavi" },
      { id: 565450, name: "Gonabarewadi" },
      { id: 565407, name: "Gonavali" },
      { id: 565379, name: "Guhagar" },
      { id: 565435, name: "Hedavi" },
      { id: 565455, name: "Jambhali Kh." },
      { id: 565454, name: "Jambhari" },
      { id: 565428, name: "Jamsut" },
      { id: 565392, name: "Janavale" },
      { id: 565469, name: "Kajurlee" },
      { id: 565442, name: "Karde" },
      { id: 565383, name: "Karul" },
      { id: 565388, name: "Katakiri" },
      { id: 565456, name: "Katale" },
      { id: 565365, name: "Katalwadi Tarf Anjanwel" },
      { id: 565402, name: "Kaundhar Kalsur" },
      { id: 565426, name: "Kawankarwadi" },
      { id: 565368, name: "Khamshet" },
      { id: 565370, name: "Kharyachakond" },
      { id: 565446, name: "Khodade" },
      { id: 565419, name: "Kiravalewadi" },
      { id: 565380, name: "Kirtanwadi Tarf Guhagar" },
      { id: 565468, name: "Kolavali" },
      { id: 565356, name: "Koliwadi Chalkewadi Tarfe Dhopave" },
      { id: 565411, name: "Kond Karul" },
      { id: 565394, name: "Kondwadi Tarf Patpanhale" },
      { id: 565427, name: "Kotluk" },
      { id: 565463, name: "Kudli" },
      { id: 565367, name: "Kumbharwadi Tarf Palpene" },
      { id: 565421, name: "Kutgiri" },
      { id: 565414, name: "Madhal" },
      { id: 565403, name: "Malan" },
      { id: 565398, name: "Mandavkarwadi" },
      { id: 565409, name: "Maruti Mandir" },
      { id: 565447, name: "Masu" },
      { id: 565448, name: "Masue Bk." },
      { id: 565452, name: "Matalwadi" },
      { id: 565358, name: "Mohallawadi Mhaskarwadi Tarfe Sakhari Trishul" },
      { id: 565461, name: "Mohitewadi" },
      { id: 565389, name: "Mundhar" },
      { id: 565390, name: "Mundhar Kh." },
      { id: 565438, name: "Muslondi" },
      { id: 565410, name: "Nagazari" },
      { id: 565437, name: "Naravan" },
      { id: 565353, name: "Navanagar" },
      { id: 565371, name: "Nigundal" },
      { id: 565451, name: "Nivatewadi" },
      { id: 565405, name: "Nivoshi" },
      { id: 565424, name: "Pabhare" },
      { id: 565423, name: "Pabhare Kh." },
      { id: 565465, name: "Pacheriagar" },
      { id: 565467, name: "Pacherisada" },
      { id: 565459, name: "Padave" },
      { id: 565420, name: "Pali" },
      { id: 565361, name: "Palkot Sakhari Trishul" },
      { id: 565376, name: "Palpene" },
      { id: 565404, name: "Palshet" },
      { id: 565381, name: "Pangari Tarf Haveli" },
      { id: 565416, name: "Pangari Tarf Welamb" },
      { id: 565384, name: "Parchuri" },
      { id: 565385, name: "Parchuri Kh." },
      { id: 565362, name: "Pardalewadi" },
      { id: 565393, name: "Pat Panhale" },
      { id: 565422, name: "Pati" },
      { id: 565352, name: "Peth Anjanwel" },
      { id: 565363, name: "Peve" },
      { id: 565378, name: "Pimpalwat" },
      { id: 565430, name: "Pimpar Kh." },
      { id: 565429, name: "Pimper" },
      { id: 565406, name: "Pomendi" },
      { id: 565401, name: "Ramanewadi Tarfe Koundhar Kalsur" },
      { id: 565374, name: "Ranavi" },
      { id: 565443, name: "Rohile" },
      { id: 565366, name: "Sakhari Bk." },
      { id: 565364, name: "Sakhari Kh." },
      { id: 565357, name: "Sakhari Trishul" },
      { id: 565433, name: "Sakhariagar" },
      { id: 565444, name: "Sheer" },
      { id: 565445, name: "Sheer Bk." },
      { id: 565425, name: "Shigawanwadi" },
      { id: 565466, name: "Shivane" },
      { id: 565397, name: "Shringartali" },
      { id: 565415, name: "Sural" },
      { id: 565369, name: "Talavali" },
      { id: 565372, name: "Talyachiwadi Tarf Palpene" },
      { id: 565458, name: "Tavasal" },
      { id: 565457, name: "Tavasal Khurd" },
      { id: 565355, name: "Tetale" },
      { id: 565434, name: "Umarath" },
      { id: 565436, name: "Umarath Kh." },
      { id: 565387, name: "Vadad" },
      { id: 565439, name: "Vaghambe" },
      { id: 565377, name: "Varachapath Tarf Guhagar" },
      { id: 565396, name: "Varweli" },
      { id: 565417, name: "Velamb" },
      { id: 565432, name: "Velaneshwar" },
      { id: 565359, name: "Veldur" },
      { id: 565382, name: "Visapur" },
      { id: 565431, name: "Wadadai" },
      { id: 565375, name: "Waki" },
      { id: 565413, name: "Zombadi" },
    ],
    4271: [
      { id: 565584, name: "Adi" },
      { id: 565536, name: "Agarnaral" },
      { id: 565546, name: "Agave T. Fungus" },
      { id: 565567, name: "Ambekarwadi" },
      { id: 565595, name: "Ambeshet" },
      { id: 565523, name: "Are" },
      { id: 565629, name: "Bagpatole" },
      { id: 565611, name: "Bajarpeth" },
      { id: 565530, name: "Basani" },
      { id: 565508, name: "Bhagavatinagar" },
      { id: 565505, name: "Bhandarpule" },
      { id: 565501, name: "Bhandarwada Malgud" },
      { id: 565512, name: "Bhandarwada Varvade" },
      { id: 565667, name: "Bhandarwadi" },
      { id: 565640, name: "Bhatye" },
      { id: 565563, name: "Bhaveadom" },
      { id: 565561, name: "Bhoke" },
      { id: 565531, name: "Bolewadi" },
      { id: 565540, name: "Bondye" },
      { id: 565542, name: "Chafe" },
      { id: 565488, name: "Chaferi" },
      { id: 565626, name: "Chanderai" },
      { id: 565638, name: "Chandor" },
      { id: 565610, name: "Charveli" },
      { id: 565541, name: "Chave" },
      { id: 565538, name: "Chikhalwadi" },
      { id: 565597, name: "Chinchkhari" },
      { id: 565621, name: "Chindravali" },
      { id: 565668, name: "Dabhilambere" },
      { id: 565564, name: "Dandeadom" },
      { id: 565570, name: "Dangewadi" },
      { id: 565537, name: "Dewood" },
      { id: 565515, name: "Dhamanse" },
      { id: 565560, name: "Dhanawadewadi" },
      { id: 565522, name: "Dhokambale" },
      { id: 565647, name: "Dhopatwadi" },
      { id: 565669, name: "Dorle" },
      { id: 565632, name: "Dugave" },
      { id: 565495, name: "Gadnaral" },
      { id: 565507, name: "Ganapatipule" },
      { id: 565650, name: "Ganeshgule" },
      { id: 565666, name: "Gaonkhadi" },
      { id: 565663, name: "Gavade Ambere" },
      { id: 565576, name: "Ghavaliwadi" },
      { id: 565646, name: "Golap" },
      { id: 565634, name: "Harchiri" },
      { id: 565630, name: "Hatis" },
      { id: 565571, name: "Hatkhamba" },
      { id: 565627, name: "Ibrahimpattan" },
      { id: 565474, name: "Jaigad" },
      { id: 565582, name: "Jakimirya" },
      { id: 565487, name: "Jamatwadi" },
      { id: 565486, name: "Jambhari" },
      { id: 565517, name: "Jambharun" },
      { id: 565659, name: "Jambhulaad" },
      { id: 565641, name: "Junafansop" },
      { id: 565596, name: "Juve" },
      { id: 565480, name: "Kachare" },
      { id: 565553, name: "Kajarekond" },
      { id: 565513, name: "Kajirbhati" },
      { id: 565533, name: "Kalbadevi" },
      { id: 565502, name: "Kalzondi" },
      { id: 565490, name: "Kamblelavgan" },
      { id: 565616, name: "Kapadgaon" },
      { id: 565559, name: "Kapilvastu" },
      { id: 565558, name: "Karabudekond" },
      { id: 565557, name: "Karbude" },
      { id: 565672, name: "Karle Mu. Aat" },
      { id: 565573, name: "Karwanchiwadi" },
      { id: 565481, name: "Kasari" },
      { id: 565534, name: "Kasarveli" },
      { id: 565605, name: "Kasheli" },
      { id: 565643, name: "Kasop" },
      { id: 565578, name: "Kelye" },
      { id: 565519, name: "Kerle Myu. Baher" },
      { id: 565543, name: "Khalgaon" },
      { id: 565614, name: "Khanu" },
      { id: 565518, name: "Kharavate" },
      { id: 565498, name: "Kharviwada Jambhari" },
      { id: 565485, name: "Kharviwada Varvade" },
      { id: 565587, name: "Khedshi" },
      { id: 943169, name: "Killeratnagiri" },
      { id: 565600, name: "Kolambe" },
      { id: 565496, name: "Kolisare" },
      { id: 565565, name: "Kond" },
      { id: 565606, name: "Kondgaon" },
      { id: 565628, name: "Kondkhandkar" },
      { id: 565625, name: "Kondvi" },
      { id: 565521, name: "Kotavade" },
      { id: 565609, name: "Kotharewadi" },
      { id: 565602, name: "Kotharwadi" },
      { id: 565556, name: "Kumbharwada" },
      { id: 565476, name: "Kunbiwadi" },
      { id: 565655, name: "Kurdhe" },
      { id: 565633, name: "Kurtade" },
      { id: 565673, name: "Kuwarbav" },
      { id: 565555, name: "Lajul Gonbarewadi" },
      { id: 565549, name: "Machivalewadi" },
      { id: 565589, name: "Madhaliwadi" },
      { id: 565528, name: "Madhaliwadi Fanasvale" },
      { id: 565585, name: "Majgaon" },
      { id: 565503, name: "Malgund" },
      { id: 565615, name: "Marathawadi Malgund" },
      { id: 565603, name: "Marathewadi" },
      { id: 565483, name: "Marathwada" },
      { id: 565504, name: "Marathwadi" },
      { id: 565500, name: "Marathwadi Saitavade" },
      { id: 565657, name: "Mavlunge" },
      { id: 565548, name: "Mayangadewadi" },
      { id: 565532, name: "Mayekarwadi" },
      { id: 565660, name: "Mervi" },
      { id: 565580, name: "Mhamurwadi" },
      { id: 565492, name: "Miravane" },
      { id: 565590, name: "Mirjole" },
      { id: 565592, name: "Mirya" },
      { id: 565554, name: "Mulgaon" },
      { id: 945119, name: "Musalimwadi Golap" },
      { id: 565648, name: "Musalmanwadi" },
      { id: 565591, name: "Musalmanwadi Karle" },
      { id: 565594, name: "Musalmanwadi Shirgaon" },
      { id: 565665, name: "Muslimwadi" },
      { id: 945117, name: "Nachane Mu Baher" },
      { id: 565671, name: "Nachane Mu. Ata" },
      { id: 565608, name: "Nagalewadi" },
      { id: 565652, name: "Nakhare" },
      { id: 565651, name: "Nalewathar" },
      { id: 565477, name: "Nandivade" },
      { id: 565624, name: "Nanij" },
      { id: 565516, name: "Narme" },
      { id: 565544, name: "Narsinge" },
      { id: 565658, name: "Natunde" },
      { id: 565598, name: "Navasomeshwar" },
      { id: 565635, name: "Navet" },
      { id: 565514, name: "Nevare" },
      { id: 565637, name: "Nirool" },
      { id: 565569, name: "Nivali" },
      { id: 565509, name: "Nivendi" },
      { id: 565511, name: "Ori" },
      { id: 565588, name: "Padavewadi" },
      { id: 565623, name: "Pali" },
      { id: 565491, name: "Panhali" },
      { id: 565574, name: "Panval" },
      { id: 565622, name: "Patharat" },
      { id: 565649, name: "Pavas" },
      { id: 565662, name: "Pethpurnagad" },
      { id: 943170, name: "Pethshivapur" },
      { id: 565566, name: "Phanasavale" },
      { id: 565642, name: "Phansop" },
      { id: 565529, name: "Pirdavane" },
      { id: 565577, name: "Pomendi Bk." },
      { id: 565617, name: "Pomendi Kh." },
      { id: 565661, name: "Purnagad" },
      { id: 565506, name: "Rahatagar" },
      { id: 945118, name: "Rahataghar Ratnagiri" },
      { id: 565539, name: "Rai" },
      { id: 565645, name: "Ranpar" },
      { id: 565550, name: "Ranpat" },
      { id: 565568, name: "Ravnangwadi" },
      { id: 565497, name: "Ril" },
      { id: 565524, name: "Sadye" },
      { id: 565484, name: "Saitavade" },
      { id: 565475, name: "Sakharmohalla" },
      { id: 565535, name: "Sakhartar" },
      { id: 565478, name: "Sandelavagan" },
      { id: 565479, name: "Sandkhol" },
      { id: 565613, name: "Sarfarewadi" },
      { id: 565612, name: "Sathare" },
      { id: 565482, name: "Satkondi" },
      { id: 565579, name: "Sheel" },
      { id: 565583, name: "Shirgaon" },
      { id: 565664, name: "Shivarambere" },
      { id: 565599, name: "Someshwar" },
      { id: 565510, name: "Talekarwadi" },
      { id: 565639, name: "Taliwadi" },
      { id: 565547, name: "Tarwal" },
      { id: 565572, name: "Tarwewadi" },
      { id: 565618, name: "Tembhye" },
      { id: 565656, name: "Thikanbehere" },
      { id: 565653, name: "Thikanchandradev" },
      { id: 565586, name: "Thikandatye" },
      { id: 565654, name: "Thikansoman" },
      { id: 565636, name: "Thikwadi" },
      { id: 565604, name: "Thombarewadi" },
      { id: 565619, name: "Tike" },
      { id: 565593, name: "Tiwandewadi" },
      { id: 565631, name: "Tonade" },
      { id: 565551, name: "Ukshi" },
      { id: 565620, name: "Umare" },
      { id: 565520, name: "Umbarwadi" },
      { id: 565489, name: "Undi" },
      { id: 565494, name: "Vaidyalavagan" },
      { id: 565607, name: "Valke" },
      { id: 565499, name: "Varavade" },
      { id: 565552, name: "Vedarewadi" },
      { id: 565601, name: "Velvand" },
      { id: 565526, name: "Vetoshi" },
      { id: 565527, name: "Vetoshi Khalchiwadi" },
      { id: 565562, name: "Vetoshi Madhliwadi" },
      { id: 565545, name: "Vilaye" },
      { id: 565525, name: "Wadajun" },
      { id: 565581, name: "Wadamirya" },
      { id: 565493, name: "Watad" },
      { id: 565644, name: "Wayangani" },
      { id: 565670, name: "Zadgaon Mu. Aat" },
      { id: 945116, name: "Zadgaon Mu. Baher" },
      { id: 565575, name: "Zarewadi" },
    ],
    4272: [
      { id: 565809, name: "Agarewadi" },
      { id: 565679, name: "Ambav" },
      { id: 565790, name: "Ambavali" },
      { id: 565763, name: "Ambed Budruk" },
      { id: 565714, name: "Ambed Khurd" },
      { id: 565687, name: "Ambet" },
      { id: 565718, name: "Anderi" },
      { id: 565831, name: "Angavali" },
      { id: 565716, name: "Antravali" },
      { id: 565677, name: "Aravali" },
      { id: 565684, name: "Asave" },
      { id: 565732, name: "Asurde" },
      { id: 565828, name: "Bamnoli" },
      { id: 565823, name: "Belari Bk." },
      { id: 565822, name: "Belari Kh." },
      { id: 565819, name: "Belariwadi" },
      { id: 565854, name: "Bhadakamba" },
      { id: 565738, name: "Bhimnagar" },
      { id: 565734, name: "Bhirkond" },
      { id: 565818, name: "Bhorpavane" },
      { id: 565869, name: "Bhovade" },
      { id: 565841, name: "Bondye" },
      { id: 565775, name: "Borsut" },
      { id: 565680, name: "Burambad" },
      { id: 565806, name: "Chandivane" },
      { id: 565860, name: "Chaphavali" },
      { id: 565706, name: "Chikhali" },
      { id: 565861, name: "Chorvane" },
      { id: 565866, name: "Dabhole Bk." },
      { id: 565865, name: "Dabhole Kh." },
      { id: 565846, name: "Dakhin" },
      { id: 565756, name: "Davkhol" },
      { id: 565759, name: "Den" },
      { id: 565870, name: "Devade" },
      { id: 565859, name: "Devale" },
      { id: 565773, name: "Devale Ghera Prachitgad" },
      { id: 565813, name: "Devghar" },
      { id: 565872, name: "Devrukh" },
      { id: 565712, name: "Dhamani" },
      { id: 565803, name: "Dhamapur Tarf Devrukh" },
      { id: 565689, name: "Dhamapur Tarf Sangameshwar" },
      { id: 565745, name: "Dingni" },
      { id: 565753, name: "Dingni Kuran" },
      { id: 565802, name: "Fansat" },
      { id: 565863, name: "Ghativale" },
      { id: 565864, name: "Ghativale Kh." },
      { id: 565805, name: "Ghodavali" },
      { id: 565711, name: "Golavali" },
      { id: 565826, name: "Gothane" },
      { id: 565704, name: "Harekarwadi" },
      { id: 565824, name: "Harpude" },
      { id: 565833, name: "Hativ" },
      { id: 565717, name: "Hedali" },
      { id: 565731, name: "Jambhulwadi" },
      { id: 565858, name: "Jangalwadi" },
      { id: 565703, name: "Kadvai" },
      { id: 565739, name: "Kalambaste" },
      { id: 565675, name: "Kalambushi" },
      { id: 565766, name: "Kanalkond" },
      { id: 565848, name: "Kankadi" },
      { id: 565768, name: "Kante" },
      { id: 565835, name: "Karambele Tarf Devale" },
      { id: 565777, name: "Karambele Tarf Sangameshwar" },
      { id: 565827, name: "Karandewadi" },
      { id: 565862, name: "Karanjari" },
      { id: 565724, name: "Karbhatle" },
      { id: 565691, name: "Karjuve" },
      { id: 565811, name: "Karli" },
      { id: 565840, name: "Kasar Kolvan" },
      { id: 565729, name: "Kasba Sangameshwar" },
      { id: 565681, name: "Kase" },
      { id: 565785, name: "Katavali" },
      { id: 565720, name: "Katurdi Kond" },
      { id: 565843, name: "Khadi Kolvan" },
      { id: 565772, name: "Kinjale" },
      { id: 943173, name: "Kinjale Punarvasan" },
      { id: 565868, name: "Kirbet" },
      { id: 565798, name: "Kirdadi" },
      { id: 565815, name: "Kirduve" },
      { id: 565761, name: "Kolambe" },
      { id: 565730, name: "Kond Ambed" },
      { id: 565735, name: "Kond Asurde" },
      { id: 565700, name: "Kond Bhairav" },
      { id: 565799, name: "Kond Bhujbalrao" },
      { id: 565800, name: "Kond Kadamrao" },
      { id: 565786, name: "Kond Ozare" },
      { id: 565850, name: "Kondgaon" },
      { id: 565676, name: "Kondivare" },
      { id: 565814, name: "Kondran" },
      { id: 565725, name: "Kondumare" },
      { id: 565755, name: "Kondye" },
      { id: 565781, name: "Kosumb" },
      { id: 565695, name: "Kuchambe" },
      { id: 565793, name: "Kudavali" },
      { id: 565774, name: "Kule" },
      { id: 565694, name: "Kumbhar Khani Bk." },
      { id: 565713, name: "Kumbharkhani Kh." },
      { id: 565821, name: "Kundi" },
      { id: 565751, name: "Kurdhunda" },
      { id: 565752, name: "Kurdhunda Kh." },
      { id: 565698, name: "Kutgiri" },
      { id: 565750, name: "Lovale" },
      { id: 565748, name: "Mabhale" },
      { id: 565686, name: "Makhajan" },
      { id: 565727, name: "Maladewadi" },
      { id: 565764, name: "Manaskond" },
      { id: 565743, name: "Manjare" },
      { id: 565829, name: "Maral" },
      { id: 565707, name: "Masarang" },
      { id: 565792, name: "Math Dhamapur" },
      { id: 565688, name: "Mavalange" },
      { id: 565857, name: "Medhe Tarf Devale" },
      { id: 565742, name: "Medhe Tarf Phungus" },
      { id: 565847, name: "Meghi" },
      { id: 565837, name: "Morde" },
      { id: 565770, name: "Muchari" },
      { id: 565834, name: "Muradpur" },
      { id: 565678, name: "Murdav" },
      { id: 565853, name: "Murshi" },
      { id: 565804, name: "Musalmanwadi" },
      { id: 565791, name: "Nandlaj" },
      { id: 565683, name: "Narduve" },
      { id: 565749, name: "Navdi" },
      { id: 565816, name: "Nawale Wadi" },
      { id: 565722, name: "Nayari" },
      { id: 565747, name: "Nidhalewadi" },
      { id: 565825, name: "Nigudwadi" },
      { id: 565845, name: "Ninave" },
      { id: 565719, name: "Nivali" },
      { id: 565842, name: "Nivdhe" },
      { id: 565810, name: "Nive Bk." },
      { id: 565832, name: "Nive Kh." },
      { id: 565746, name: "Ozar Khol" },
      { id: 565844, name: "Ozare Bk." },
      { id: 565787, name: "Ozare Kh." },
      { id: 565699, name: "Pachambe" },
      { id: 565807, name: "Pangri" },
      { id: 565760, name: "Parchuri" },
      { id: 565795, name: "Parsharamwadi" },
      { id: 565796, name: "Patgaon" },
      { id: 565690, name: "Pedhambe" },
      { id: 565855, name: "Pethwadi" },
      { id: 565784, name: "Phansavale" },
      { id: 565715, name: "Phansavane" },
      { id: 565754, name: "Phungus" },
      { id: 565744, name: "Pirandavane" },
      { id: 565758, name: "Pochari" },
      { id: 565797, name: "Pur" },
      { id: 565856, name: "Purye Tarf Devale" },
      { id: 565682, name: "Purye Tarf Savarde" },
      { id: 565696, name: "Rajivali" },
      { id: 565710, name: "Rajwadi" },
      { id: 565736, name: "Rampeth" },
      { id: 565702, name: "Rangav" },
      { id: 565697, name: "Ratambi" },
      { id: 565794, name: "Sadavali" },
      { id: 565733, name: "Sakhalkond" },
      { id: 565851, name: "Sakharpa" },
      { id: 565852, name: "Sakharpa Kh." },
      { id: 565801, name: "Sangave" },
      { id: 565685, name: "Sarand" },
      { id: 565783, name: "Sayale" },
      { id: 565709, name: "Shembavane" },
      { id: 565701, name: "Shenavade" },
      { id: 565692, name: "Shinde Amberi" },
      { id: 565674, name: "Shirambe" },
      { id: 565778, name: "Shivane" },
      { id: 943174, name: "Shivdhamapur" },
      { id: 565721, name: "Shringapur" },
      { id: 565830, name: "Sonarwadi" },
      { id: 565776, name: "Sonavade" },
      { id: 565762, name: "Songiri" },
      { id: 565788, name: "Talavade Tarf Devrukh" },
      { id: 565767, name: "Tale" },
      { id: 565708, name: "Tambedi" },
      { id: 565780, name: "Tamhane" },
      { id: 565779, name: "Tamhane Kh." },
      { id: 565820, name: "Tamnale" },
      { id: 565769, name: "Terye" },
      { id: 565723, name: "Tivare Ghera Prachitgad" },
      { id: 565867, name: "Tivare Tarf Devale" },
      { id: 565808, name: "Tulsani" },
      { id: 565705, name: "Tural" },
      { id: 565789, name: "Ujgaon" },
      { id: 565726, name: "Umare" },
      { id: 565757, name: "Upale" },
      { id: 565838, name: "Vanzole" },
      { id: 565839, name: "Vanzole Bk." },
      { id: 565836, name: "Vanzole Kh." },
      { id: 565817, name: "Vayangane" },
      { id: 565782, name: "Vighravali" },
      { id: 565693, name: "Vikas Nagar" },
      { id: 565728, name: "Wadathikanat" },
      { id: 565737, name: "Wadavesarad" },
      { id: 565871, name: "Wadi Adhishti" },
      { id: 565765, name: "Wandri" },
      { id: 565812, name: "Washi Tarf Deorukh" },
      { id: 565771, name: "Washi Tarf Sangameshwar" },
    ],
    4273: [
      { id: 565970, name: "Adavali" },
      { id: 565902, name: "Agargaon" },
      { id: 565920, name: "Agargaon (Lanja)" },
      { id: 565892, name: "Agave" },
      { id: 565940, name: "Anandgaon" },
      { id: 565877, name: "Anjanari" },
      { id: 565988, name: "Argaon" },
      { id: 565911, name: "Asage" },
      { id: 565879, name: "Asode" },
      { id: 565968, name: "Baing" },
      { id: 565975, name: "Bankhor" },
      { id: 565944, name: "Bapere" },
      { id: 565959, name: "Beni Bk." },
      { id: 565917, name: "Beni Kh." },
      { id: 565949, name: "Bhade" },
      { id: 565978, name: "Bhambed" },
      { id: 565962, name: "Borivale" },
      { id: 565956, name: "Borthade" },
      { id: 565896, name: "Buddhawadi Tarf Devdhe" },
      { id: 565971, name: "Budhawadi Tarf Salpe" },
      { id: 565928, name: "Budhawadi Tarfe Vervali Bk." },
      { id: 565881, name: "Chafet" },
      { id: 565966, name: "Chinchurti" },
      { id: 565963, name: "Daphalewadi" },
      { id: 565895, name: "Devdhe" },
      { id: 565919, name: "Dhundare" },
      { id: 565931, name: "Dolasgaon" },
      { id: 565874, name: "Gangarkarwadigaon" },
      { id: 565889, name: "Gautamgaon" },
      { id: 565899, name: "Gavane" },
      { id: 565884, name: "Ghadashigaon" },
      { id: 565952, name: "Golavashi" },
      { id: 565925, name: "Gondesakhal" },
      { id: 565914, name: "Govil" },
      { id: 565915, name: "Guravwadi" },
      { id: 565960, name: "Harche" },
      { id: 565979, name: "Hardkhale" },
      { id: 565912, name: "Hasol" },
      { id: 565953, name: "Indavati" },
      { id: 565946, name: "Isavali" },
      { id: 565937, name: "Javade" },
      { id: 565891, name: "Joshigaon" },
      { id: 565882, name: "Kadugaon" },
      { id: 565907, name: "Kangavali" },
      { id: 565905, name: "Kante" },
      { id: 565936, name: "Katalgaon" },
      { id: 565926, name: "Kelambe" },
      { id: 565972, name: "Kelvali" },
      { id: 565947, name: "Khanavali" },
      { id: 565938, name: "Khavadi" },
      { id: 565918, name: "Kheravse" },
      { id: 565990, name: "Khorgaon" },
      { id: 565976, name: "Khorninko" },
      { id: 565964, name: "Kochari" },
      { id: 565906, name: "Koldhe" },
      { id: 565913, name: "Kolhewadi" },
      { id: 565992, name: "Kondage" },
      { id: 565989, name: "Kondgaon" },
      { id: 565924, name: "Kondye" },
      { id: 565930, name: "Korle" },
      { id: 565901, name: "Kot" },
      { id: 565980, name: "Kudewadi" },
      { id: 565900, name: "Kumbhargaon" },
      { id: 565987, name: "Kunane" },
      { id: 565994, name: "Kurang" },
      { id: 565909, name: "Kurchumb" },
      { id: 565888, name: "Kurne" },
      { id: 565942, name: "Kuve" },
      { id: 565995, name: "Lanja" },
      { id: 565948, name: "Lavgan" },
      { id: 565965, name: "Machal" },
      { id: 565922, name: "Majal" },
      { id: 565897, name: "Manche" },
      { id: 565878, name: "Math" },
      { id: 565983, name: "Mogargaon" },
      { id: 565929, name: "Musalmanwadi" },
      { id: 565885, name: "Muslimgaon" },
      { id: 565973, name: "Name" },
      { id: 565876, name: "Nandivali" },
      { id: 565943, name: "Nioshi" },
      { id: 565873, name: "Nivasar" },
      { id: 565935, name: "Padvan" },
      { id: 565883, name: "Padyar" },
      { id: 565974, name: "Palu" },
      { id: 565941, name: "Panhale" },
      { id: 565950, name: "Panore" },
      { id: 565961, name: "Panore Tarf Harche" },
      { id: 565887, name: "Pateregaon" },
      { id: 565991, name: "Patilgaon" },
      { id: 565977, name: "Prabhanvalli" },
      { id: 565890, name: "Punas" },
      { id: 565939, name: "Puragaon" },
      { id: 565898, name: "Ramane" },
      { id: 565923, name: "Rambadegaon" },
      { id: 565932, name: "Ramgaon" },
      { id: 565945, name: "Ravari" },
      { id: 565993, name: "Ringane" },
      { id: 565951, name: "Roon" },
      { id: 565957, name: "Sadvali" },
      { id: 565967, name: "Salpe" },
      { id: 565958, name: "Satavali" },
      { id: 565969, name: "Shiposhi" },
      { id: 565875, name: "Shirambavali" },
      { id: 565985, name: "Shiravali" },
      { id: 565908, name: "Talavade" },
      { id: 565893, name: "Upale" },
      { id: 565954, name: "Vangule" },
      { id: 565986, name: "Varachi Shiravali" },
      { id: 565886, name: "Veral" },
      { id: 565933, name: "Veravli Bk." },
      { id: 565934, name: "Vervali Kh." },
      { id: 565880, name: "Vesurle" },
      { id: 565982, name: "Vilavade" },
      { id: 565894, name: "Virgaon" },
      { id: 565927, name: "Vivali" },
      { id: 565916, name: "Wadgaon" },
      { id: 565903, name: "Wadilimbu" },
      { id: 565981, name: "Waghangaon" },
      { id: 565904, name: "Waghrat" },
      { id: 565955, name: "Waked" },
      { id: 565984, name: "Whel" },
      { id: 565910, name: "Yeravande" },
      { id: 565921, name: "Zapade" },
    ],
    4274: [
      { id: 566194, name: "Adavali" },
      { id: 566130, name: "Agarewadi" },
      { id: 566042, name: "Agarwadi" },
      { id: 566233, name: "Ajivali" },
      { id: 566012, name: "Ambelkarwadi" },
      { id: 566027, name: "Ambolgad" },
      { id: 566038, name: "Anantwadi" },
      { id: 566094, name: "Angale" },
      { id: 566063, name: "Ansure" },
      { id: 565997, name: "Avalichiwadi" },
      { id: 566152, name: "Bag Abdul Kadir" },
      { id: 566149, name: "Bag Kazi Husen" },
      { id: 566216, name: "Bagavewadi" },
      { id: 566039, name: "Bajarwadi" },
      { id: 566193, name: "Bajarwadi (Pachal)" },
      { id: 566050, name: "Bakale" },
      { id: 566029, name: "Bandhawadi" },
      { id: 566118, name: "Bandiwade" },
      { id: 566139, name: "Barsu" },
      { id: 566000, name: "Benagiwadi" },
      { id: 566020, name: "Bhabalewadi" },
      { id: 566003, name: "Bhalavali" },
      { id: 566048, name: "Bhandar Sakhari" },
      { id: 566025, name: "Bharadin" },
      { id: 566125, name: "Bhoo" },
      { id: 566080, name: "Burbe" },
      { id: 566034, name: "Burbewadi" },
      { id: 566072, name: "Chauke" },
      { id: 566056, name: "Chavhanwadi" },
      { id: 566037, name: "Chavhatawadi" },
      { id: 566123, name: "Chikhale" },
      { id: 566221, name: "Chikhalewadi" },
      { id: 566186, name: "Chikhalgaon" },
      { id: 566178, name: "Chipatewadi" },
      { id: 566163, name: "Chuna Kolwan" },
      { id: 566041, name: "Dale" },
      { id: 566065, name: "Dandewadi" },
      { id: 566127, name: "Dasur" },
      { id: 566023, name: "Dasurewadi" },
      { id: 566088, name: "Dattawadi" },
      { id: 566032, name: "Deulwadi" },
      { id: 566036, name: "Devache Gothane" },
      { id: 566121, name: "Devi Hasol" },
      { id: 566208, name: "Dhamanpe" },
      { id: 566022, name: "Dhaulvali" },
      { id: 566140, name: "Dhopeshwar" },
      { id: 566087, name: "Dongar" },
      { id: 566092, name: "Doniwade" },
      { id: 566214, name: "Ganganwadi" },
      { id: 566105, name: "Gaonkarwadi" },
      { id: 566129, name: "Ghumewadi" },
      { id: 566173, name: "Gorulewadi" },
      { id: 566189, name: "Gothane Doniwade" },
      { id: 566069, name: "Gothivare" },
      { id: 566155, name: "Goval" },
      { id: 566115, name: "Gunjavane" },
      { id: 566213, name: "Guravwadi" },
      { id: 566207, name: "Haral" },
      { id: 566141, name: "Hardi" },
      { id: 566103, name: "Hasol Tarf Saundal" },
      { id: 566231, name: "Hatade" },
      { id: 566190, name: "Hatankarwadi" },
      { id: 566091, name: "Hativale" },
      { id: 566043, name: "Holi" },
      { id: 566062, name: "Hurshe" },
      { id: 566084, name: "Ingalwadi" },
      { id: 566046, name: "Jaitapur" },
      { id: 566081, name: "Jambhari" },
      { id: 566196, name: "Jambhavali" },
      { id: 566218, name: "Jambhulwadi" },
      { id: 566054, name: "Janashi" },
      { id: 566232, name: "Jawalethar" },
      { id: 566101, name: "Juvathi" },
      { id: 566040, name: "Juve Jaitapur" },
      { id: 566224, name: "Kajirda" },
      { id: 566008, name: "Kalakawadi" },
      { id: 566175, name: "Kalasavali" },
      { id: 566153, name: "Kaneri" },
      { id: 566146, name: "Kaneriwadi" },
      { id: 566203, name: "Karak" },
      { id: 566204, name: "Karavali" },
      { id: 566055, name: "Karel" },
      { id: 566068, name: "Karivane" },
      { id: 566100, name: "Karshingewadi" },
      { id: 566174, name: "Kasarwadi" },
      { id: 566006, name: "Kasheli" },
      { id: 566082, name: "Katali" },
      { id: 566079, name: "Katradevi" },
      { id: 566134, name: "Kelavade" },
      { id: 566109, name: "Kelavali" },
      { id: 566031, name: "Keravale" },
      { id: 945103, name: "Khachiwadi (Goval)" },
      { id: 566126, name: "Khadakvali" },
      { id: 566077, name: "Khajantad Nanar" },
      { id: 566011, name: "Khalcha Bhandarwada" },
      { id: 566102, name: "Khalchiwadi (Kondye Tarfe Saundal)" },
      { id: 945106, name: "Khalchiwadi (Pendkhale)" },
      { id: 566135, name: "Kharavate" },
      { id: 566124, name: "Khingini" },
      { id: 566142, name: "Kodavali" },
      { id: 566227, name: "Kolamb" },
      { id: 566172, name: "Kolwankhadi" },
      { id: 566167, name: "Kond Tiware" },
      { id: 566122, name: "Konddasur" },
      { id: 566148, name: "Kondhye Tarf Rajapur" },
      { id: 566180, name: "Kondivale" },
      { id: 565998, name: "Kondsar Bk." },
      { id: 565999, name: "Kondsar Kh." },
      { id: 566106, name: "Kondvashiwadi" },
      { id: 566187, name: "Kondwadi" },
      { id: 566112, name: "Kondye Tarf Saundal" },
      { id: 566128, name: "Kotapur" },
      { id: 566074, name: "Kumbhavade" },
      { id: 566133, name: "Kunbiwadi" },
      { id: 566047, name: "Kuveshi" },
      { id: 566051, name: "Madban" },
      { id: 566136, name: "Madhaliwadi (Kodavali)" },
      { id: 566113, name: "Madheliwadi (Kondye Tarfe Saudal)" },
      { id: 566099, name: "Mahalunge" },
      { id: 566002, name: "Majre Juve" },
      { id: 566195, name: "Malewadi" },
      { id: 566143, name: "Mandavkarwadi" },
      { id: 566165, name: "Mandrul" },
      { id: 566183, name: "Manjarewadi" },
      { id: 566108, name: "Math Kh." },
      { id: 566228, name: "Miland" },
      { id: 566057, name: "Mirgulewadi" },
      { id: 566064, name: "Mithgavane" },
      { id: 566222, name: "Moor" },
      { id: 566107, name: "Moroshi" },
      { id: 566110, name: "Mosam" },
      { id: 566089, name: "Musalmanwadi (Dongar)" },
      { id: 566184, name: "Musalmanwadi (Saundal)" },
      { id: 945108, name: "Musalmanwadi (Tulaswade)" },
      { id: 566070, name: "Nanar" },
      { id: 566026, name: "Nate" },
      { id: 566007, name: "Navedar" },
      { id: 566188, name: "Nerakewadi" },
      { id: 566104, name: "Nikharewadi" },
      { id: 566061, name: "Niveli" },
      { id: 566162, name: "Nivkholwadi" },
      { id: 566181, name: "Oni" },
      { id: 566217, name: "Oshiwale" },
      { id: 566170, name: "Ozar" },
      { id: 566210, name: "Pachal" },
      { id: 566059, name: "Padave" },
      { id: 566229, name: "Pahiliwadi" },
      { id: 566182, name: "Pajavewadi" },
      { id: 566159, name: "Palasamkarwadi" },
      { id: 566071, name: "Palekarwadi" },
      { id: 566098, name: "Pangari Bk." },
      { id: 566202, name: "Pangari Kh." },
      { id: 566150, name: "Panhale Tarf Rajapur" },
      { id: 566114, name: "Panhale Tarf Saundal" },
      { id: 566192, name: "Paratvali" },
      { id: 566199, name: "Parule" },
      { id: 566137, name: "Patharde" },
      { id: 566205, name: "Patkarwadi" },
      { id: 566177, name: "Pendkhale" },
      { id: 945105, name: "Pethwadi" },
      { id: 566095, name: "Phupere" },
      { id: 566010, name: "Pishedwadi" },
      { id: 566024, name: "Pokalewadi" },
      { id: 566119, name: "Prindrawan" },
      { id: 566209, name: "Raipatan" },
      { id: 943171, name: "Rajapur" },
      { id: 566018, name: "Rajawadi" },
      { id: 566225, name: "Ranewadi" },
      { id: 566033, name: "Rautwadi" },
      { id: 566169, name: "Sabalewadi" },
      { id: 566067, name: "Sagave" },
      { id: 945107, name: "Sagave Khurd" },
      { id: 566060, name: "Sakhar" },
      { id: 566030, name: "Sakhari Nate" },
      { id: 566097, name: "Sasale" },
      { id: 566185, name: "Saundal" },
      { id: 566230, name: "Savadav" },
      { id: 566179, name: "Shedekarwadi" },
      { id: 566154, name: "Shedhe" },
      { id: 566145, name: "Sheel" },
      { id: 566116, name: "Shejavali" },
      { id: 566093, name: "Shembavane" },
      { id: 566220, name: "Shendyewadi" },
      { id: 566085, name: "Shengalwadi" },
      { id: 566066, name: "Shirse" },
      { id: 566176, name: "Shivane Bk." },
      { id: 566157, name: "Shivane Kh." },
      { id: 566035, name: "Sogamwadi" },
      { id: 566021, name: "Solgaon" },
      { id: 566198, name: "Solivade" },
      { id: 566096, name: "Solye" },
      { id: 566164, name: "Sutarwadi" },
      { id: 566215, name: "Takkewadi" },
      { id: 566111, name: "Talgaon" },
      { id: 566212, name: "Talvade" },
      { id: 566219, name: "Tamhane" },
      { id: 566073, name: "Taral" },
      { id: 566144, name: "Taralwadi" },
      { id: 566131, name: "Terwan" },
      { id: 566191, name: "Thikankond" },
      { id: 566132, name: "Thoraliwadi" },
      { id: 566058, name: "Thukrulwadi" },
      { id: 566053, name: "Tivarambi" },
      { id: 566168, name: "Tiware" },
      { id: 566197, name: "Tulsavade" },
      { id: 566044, name: "Tulsundewadi Holi" },
      { id: 566045, name: "Tulsundewadi Kuveshi" },
      { id: 566147, name: "Unhale" },
      { id: 566120, name: "Upale" },
      { id: 566117, name: "Valye" },
      { id: 566151, name: "Varachiwadi Goval" },
      { id: 565996, name: "Varachiwadi Kasheli" },
      { id: 566001, name: "Varchi Guravwadi" },
      { id: 566226, name: "Varchiwadi (Moor)" },
      { id: 566052, name: "Varilwadi" },
      { id: 566090, name: "Vikhare Gothane" },
      { id: 566086, name: "Vilye" },
      { id: 945104, name: "Wada Kombe" },
      { id: 566013, name: "Wada Mogare" },
      { id: 566019, name: "Wada Paneri" },
      { id: 566004, name: "Wada Rundhe" },
      { id: 566014, name: "Wadabharade" },
      { id: 566083, name: "Wadachivari" },
      { id: 566160, name: "Wadad Hasol" },
      { id: 566078, name: "Wadapalye" },
      { id: 566005, name: "Wadapeth" },
      { id: 566017, name: "Wadativare" },
      { id: 566161, name: "Wadavali" },
      { id: 566016, name: "Wadavetye" },
      { id: 566015, name: "Wadi Kh" },
      { id: 566049, name: "Waghran" },
      { id: 566223, name: "Walwad" },
      { id: 566166, name: "Watul" },
      { id: 566028, name: "Yashavantgad" },
      { id: 566171, name: "Yelawan" },
      { id: 566201, name: "Yeradav" },
      { id: 566200, name: "Zarye" },
    ],
    4275: [
      { id: 566331, name: "Aadbandar" },
      { id: 566307, name: "Aare" },
      { id: 566323, name: "Bagamala" },
      { id: 566289, name: "Bagatalavade" },
      { id: 566237, name: "Bandegaon" },
      { id: 566271, name: "Baparde" },
      { id: 566278, name: "Burambavade" },
      { id: 566303, name: "Chafed" },
      { id: 566298, name: "Chandoshi" },
      { id: 566253, name: "Chinchwad" },
      { id: 566313, name: "Dabhole" },
      { id: 566324, name: "Dahibaon" },
      { id: 566311, name: "Devgad" },
      { id: 566264, name: "Dhalavali" },
      { id: 566296, name: "Dhoptewadi" },
      { id: 566317, name: "Elaye" },
      { id: 566290, name: "Gadhitamhane" },
      { id: 566283, name: "Gavane" },
      { id: 566236, name: "Girye" },
      { id: 566276, name: "Goval" },
      { id: 566294, name: "Hadpid" },
      { id: 566328, name: "Hindale" },
      { id: 566246, name: "Hurshi" },
      { id: 566312, name: "Jamsande" },
      { id: 566272, name: "Juveshwar" },
      { id: 566247, name: "Kalambai" },
      { id: 566285, name: "Kalvi" },
      { id: 566243, name: "Kasaba Waghotan" },
      { id: 566321, name: "Katvan" },
      { id: 566320, name: "Katwaneshwar" },
      { id: 566310, name: "Khudi" },
      { id: 566299, name: "Kinjawade" },
      { id: 566265, name: "Korle" },
      { id: 566309, name: "Kotkamte" },
      { id: 566266, name: "Kunkawan" },
      { id: 566319, name: "Kunkeshwar" },
      { id: 566304, name: "Kuvale" },
      { id: 566315, name: "Lingdal" },
      { id: 566281, name: "Mahalunge" },
      { id: 566250, name: "Malegaon" },
      { id: 566262, name: "Malpewadi" },
      { id: 566261, name: "Manche" },
      { id: 566326, name: "Mithbaon" },
      { id: 566318, name: "Mithmumbari" },
      { id: 566238, name: "Mohulgaon" },
      { id: 566252, name: "Mond" },
      { id: 566251, name: "Mondpar" },
      { id: 566327, name: "Morve" },
      { id: 566244, name: "Mouje Waghotan" },
      { id: 566330, name: "Munage" },
      { id: 566259, name: "Mutat" },
      { id: 566282, name: "Nad" },
      { id: 566249, name: "Nadan" },
      { id: 566325, name: "Naringre" },
      { id: 566295, name: "Nimatwadi" },
      { id: 566293, name: "Ombal" },
      { id: 566245, name: "Padel" },
      { id: 566257, name: "Padvane" },
      { id: 566260, name: "Palekarwadi" },
      { id: 566269, name: "Patgaon" },
      { id: 566316, name: "Patthar" },
      { id: 566274, name: "Pavnai" },
      { id: 566270, name: "Pendhari" },
      { id: 566256, name: "Phanase" },
      { id: 566268, name: "Phanasgaon" },
      { id: 566263, name: "Pombhurle" },
      { id: 566329, name: "Poyare" },
      { id: 566248, name: "Pural" },
      { id: 566291, name: "Rahateshwar" },
      { id: 566235, name: "Rameshwar" },
      { id: 566306, name: "Rembavali" },
      { id: 566302, name: "Salashi" },
      { id: 566305, name: "Sandve" },
      { id: 566242, name: "Saundale" },
      { id: 566308, name: "Sherighera Kamte" },
      { id: 566292, name: "Shevare" },
      { id: 566284, name: "Shiravali" },
      { id: 566301, name: "Shirgaon" },
      { id: 566275, name: "Somlewadi" },
      { id: 566287, name: "Talavade" },
      { id: 566288, name: "Talebajar" },
      { id: 566322, name: "Tambaldeg" },
      { id: 566286, name: "Tembavali" },
      { id: 566239, name: "Thakurwadi" },
      { id: 566240, name: "Tirlot" },
      { id: 566300, name: "Torsole" },
      { id: 566267, name: "Undil" },
      { id: 566297, name: "Valivande" },
      { id: 566234, name: "Vijaydurg" },
      { id: 566254, name: "Virwadi" },
      { id: 566277, name: "Vitthaladevi" },
      { id: 566255, name: "Wada" },
      { id: 566241, name: "Wadaker Poi" },
      { id: 566258, name: "Wadatar" },
      { id: 566280, name: "Waghivare" },
      { id: 566273, name: "Wanivade" },
      { id: 566314, name: "Wareri" },
      { id: 566279, name: "Welgive" },
    ],
    4276: [
      { id: 566386, name: "Achirne" },
      { id: 566342, name: "Ainari" },
      { id: 566336, name: "Akhavane" },
      { id: 566383, name: "Arule" },
      { id: 566365, name: "Bandhawadi" },
      { id: 566371, name: "Bhattiwadi" },
      { id: 566340, name: "Bhom" },
      { id: 566355, name: "Bhuibawada" },
      { id: 566348, name: "Bhusarwadi" },
      { id: 566370, name: "Bhuyadewadi" },
      { id: 566360, name: "Digashi" },
      { id: 566387, name: "Gadmath" },
      { id: 566388, name: "Ghanegadwadi" },
      { id: 566343, name: "Het" },
      { id: 566335, name: "Jambhavade" },
      { id: 566373, name: "Jamdarwadi" },
      { id: 566372, name: "Karul" },
      { id: 566378, name: "Khambale" },
      { id: 566366, name: "Khambalwadi" },
      { id: 566376, name: "Kokisare" },
      { id: 566349, name: "Kolape" },
      { id: 566357, name: "Kumbhari" },
      { id: 566351, name: "Kumbharwadi" },
      { id: 566369, name: "Kumbhavade" },
      { id: 566389, name: "Kurli" },
      { id: 566352, name: "Kusur" },
      { id: 566390, name: "Lore" },
      { id: 566353, name: "Madhaliwadi" },
      { id: 566338, name: "Mandavkarwadi" },
      { id: 566344, name: "Mangavali" },
      { id: 566350, name: "Mehbubnagar" },
      { id: 566379, name: "Mohitewadi" },
      { id: 566341, name: "Mounde" },
      { id: 566363, name: "Nadhavade" },
      { id: 566339, name: "Nagapwadi" },
      { id: 566346, name: "Nanivade" },
      { id: 566361, name: "Napane" },
      { id: 566367, name: "Narkarwadi" },
      { id: 566381, name: "Navale" },
      { id: 566332, name: "Nerle" },
      { id: 566385, name: "Nimarule" },
      { id: 566334, name: "Palandewadi" },
      { id: 566358, name: "Pimpalwadi" },
      { id: 566356, name: "Ringewadi" },
      { id: 566384, name: "Sadure" },
      { id: 566380, name: "Sangulwadi" },
      { id: 566364, name: "Sardarwadi" },
      { id: 566382, name: "Shirale" },
      { id: 566362, name: "Sonali" },
      { id: 566377, name: "Tembwadi" },
      { id: 566354, name: "Tiravade Tarf Kharepatan" },
      { id: 566333, name: "Tiravade Tarf Soundal" },
      { id: 566347, name: "Tithavali" },
      { id: 566359, name: "Umbarde" },
      { id: 566337, name: "Upale" },
      { id: 566375, name: "Vabhave" },
      { id: 566374, name: "Vayamboshi" },
      { id: 566345, name: "Vengasar" },
      { id: 566368, name: "Yedgaon" },
    ],
    4277: [
      { id: 566412, name: "Anandnagar" },
      { id: 566418, name: "Asalade" },
      { id: 566455, name: "Ashiye" },
      { id: 566405, name: "Audumbarnagar" },
      { id: 566415, name: "Avaleshwar" },
      { id: 566420, name: "Aynal" },
      { id: 566392, name: "Bandargaon" },
      { id: 566423, name: "Bavshi" },
      { id: 566442, name: "Belne Khurd" },
      { id: 566398, name: "Berle" },
      { id: 566492, name: "Bhairavgaon" },
      { id: 566449, name: "Bharni" },
      { id: 566476, name: "Bhiravande" },
      { id: 566451, name: "Bidwadi" },
      { id: 566467, name: "Bordave" },
      { id: 566434, name: "Bramhanagari Phonda" },
      { id: 566397, name: "Chinchwali" },
      { id: 566416, name: "Dabgaon" },
      { id: 566436, name: "Damare" },
      { id: 566486, name: "Dariste" },
      { id: 566407, name: "Darum" },
      { id: 566409, name: "Dhareshwar" },
      { id: 566489, name: "Digavale" },
      { id: 566474, name: "Gandhinagar" },
      { id: 566431, name: "Gangeshwar" },
      { id: 566432, name: "Ghonsari" },
      { id: 566459, name: "Halwal" },
      { id: 566478, name: "Harkul Budruk" },
      { id: 566446, name: "Harkul Khurd" },
      { id: 566450, name: "Humbarane" },
      { id: 566443, name: "Humbrath" },
      { id: 566494, name: "Jambhalgaon (Nardave Najik)" },
      { id: 566408, name: "Jambhulgaon" },
      { id: 566448, name: "Janavali" },
      { id: 566395, name: "Kajirde" },
      { id: 566496, name: "Kalmath" },
      { id: 566469, name: "Kalsuli" },
      { id: 942983, name: "Kankavli" },
      { id: 566445, name: "Karanje" },
      { id: 566440, name: "Karul" },
      { id: 566410, name: "Kasarde" },
      { id: 566465, name: "Kasavan" },
      { id: 566456, name: "Kasral" },
      { id: 566396, name: "Kharepatan" },
      { id: 566419, name: "Koloshi" },
      { id: 566439, name: "Kondye" },
      { id: 566488, name: "Kumbhavade" },
      { id: 566400, name: "Kurangavne" },
      { id: 566428, name: "Lingeshwar" },
      { id: 566463, name: "Lingeshwar Nagar" },
      { id: 566429, name: "Lore" },
      { id: 566424, name: "Main" },
      { id: 566427, name: "Mathkurd" },
      { id: 566401, name: "Nadgive" },
      { id: 566447, name: "Nagave" },
      { id: 566414, name: "Nagsawantwadi" },
      { id: 566422, name: "Nandgaon" },
      { id: 566491, name: "Nardave" },
      { id: 566487, name: "Natal" },
      { id: 566482, name: "Navanagar" },
      { id: 945112, name: "Navin Kurli (Lore)" },
      { id: 566430, name: "Navin Kurli (Phonda)" },
      { id: 566480, name: "Nehru Nagar" },
      { id: 566466, name: "Osargaon" },
      { id: 566421, name: "Otav" },
      { id: 566413, name: "Ozaram" },
      { id: 566468, name: "Phanasnagar" },
      { id: 566433, name: "Phondaghat" },
      { id: 566462, name: "Pimpaleshwar Nagar" },
      { id: 566493, name: "Pimpalgaon" },
      { id: 566452, name: "Pisekamate" },
      { id: 566426, name: "Piyali" },
      { id: 566471, name: "Rajnagar" },
      { id: 566475, name: "Rameshwarnagar" },
      { id: 566490, name: "Ranjangaon" },
      { id: 566444, name: "Sakedi" },
      { id: 566404, name: "Saliste" },
      { id: 566484, name: "Sambhajinagar" },
      { id: 566394, name: "Sambhajinagar (Kharepatan Najik)" },
      { id: 566477, name: "Sangave" },
      { id: 566457, name: "Satral" },
      { id: 566425, name: "Savdav" },
      { id: 566479, name: "Shastrinagar" },
      { id: 566399, name: "Sherpe" },
      { id: 566403, name: "Shidavne" },
      { id: 566460, name: "Shiraval" },
      { id: 566483, name: "Shivajinagar" },
      { id: 566393, name: "Shivajipeth" },
      { id: 566485, name: "Shivdav" },
      { id: 566473, name: "Shrinagar" },
      { id: 566481, name: "Subhash Nagar" },
      { id: 566464, name: "Talavade" },
      { id: 566406, name: "Talere" },
      { id: 566453, name: "Tarandale" },
      { id: 566441, name: "Tiware" },
      { id: 566417, name: "Tondavali" },
      { id: 566461, name: "Ulhasnagar" },
      { id: 566470, name: "Upanagar" },
      { id: 566472, name: "Uttamnagar" },
      { id: 566411, name: "Uttar Dakshin Gavthan" },
      { id: 566454, name: "Varavade" },
      { id: 566391, name: "Vayangani" },
      { id: 566458, name: "Wagade" },
      { id: 566435, name: "Wagheri" },
      { id: 566402, name: "Wargaon" },
      { id: 566495, name: "Yevteshwargaon" },
    ],
    4278: [
      { id: 566588, name: "Aambdos" },
      { id: 566503, name: "Achare" },
      { id: 566543, name: "Advali" },
      { id: 566547, name: "Amavane" },
      { id: 566602, name: "Amberi" },
      { id: 566593, name: "Anandvhal" },
      { id: 566581, name: "Anganewadi" },
      { id: 566499, name: "Aparadhwadi" },
      { id: 566545, name: "Asagani" },
      { id: 566548, name: "Asarondi" },
      { id: 566532, name: "Bagadwadi" },
      { id: 566540, name: "Bagavewadi" },
      { id: 566629, name: "Bagwadi" },
      { id: 566564, name: "Bandiwade Bk." },
      { id: 566566, name: "Bandiwade Kh." },
      { id: 942985, name: "Belachiwadi" },
      { id: 942986, name: "Bele Budruk" },
      { id: 566513, name: "Bhagawantgad" },
      { id: 566621, name: "Bhandarwada" },
      { id: 566508, name: "Bhatwadi (Chindar)" },
      { id: 566544, name: "Bhatwadi (Shrawan)" },
      { id: 566585, name: "Bhogalewadi" },
      { id: 566587, name: "Bilvas" },
      { id: 566530, name: "Budhavale" },
      { id: 566606, name: "Chafekhol" },
      { id: 566584, name: "Chander" },
      { id: 566594, name: "Chauke" },
      { id: 566500, name: "Chindar" },
      { id: 566552, name: "Chunavare" },
      { id: 566562, name: "Dangmode" },
      { id: 566574, name: "Deulwada" },
      { id: 566605, name: "Devbag" },
      { id: 566600, name: "Devli" },
      { id: 566595, name: "Dhamapur" },
      { id: 566578, name: "Dikval" },
      { id: 566497, name: "Dongrewadi" },
      { id: 566519, name: "Gaonkarwada" },
      { id: 566504, name: "Gaudwadi" },
      { id: 566537, name: "Gavaliwadi" },
      { id: 566533, name: "Gavathan" },
      { id: 566509, name: "Gavathanwadi" },
      { id: 566542, name: "Ghadiwadi" },
      { id: 566590, name: "Ghumade" },
      { id: 566577, name: "Golwan" },
      { id: 566535, name: "Gothane" },
      { id: 566615, name: "Guramnagari" },
      { id: 566516, name: "Hadi" },
      { id: 566557, name: "Hedul" },
      { id: 566507, name: "Hirlewadi" },
      { id: 566553, name: "Hiwale" },
      { id: 566505, name: "Jamdul" },
      { id: 566518, name: "Juva Pankhol" },
      { id: 566599, name: "Kalethar" },
      { id: 566631, name: "Kalse" },
      { id: 566520, name: "Kandalgaon" },
      { id: 566596, name: "Karlachavhal" },
      { id: 566614, name: "Katta" },
      { id: 566591, name: "Katvad" },
      { id: 566572, name: "Kava" },
      { id: 566623, name: "Khand" },
      { id: 566583, name: "Khanjanwadi" },
      { id: 566625, name: "Kharare" },
      { id: 566575, name: "Khervand" },
      { id: 566556, name: "Khotale" },
      { id: 566546, name: "Kirlos" },
      { id: 566560, name: "Koil" },
      { id: 566527, name: "Kolamb" },
      { id: 942984, name: "Kothewada" },
      { id: 566531, name: "Kudopi" },
      { id: 566579, name: "Kumame" },
      { id: 566592, name: "Kumbharmath." },
      { id: 566501, name: "Kumbharwadi" },
      { id: 566616, name: "Kunkavale" },
      { id: 566613, name: "Kusarave" },
      { id: 566582, name: "Magvane" },
      { id: 566523, name: "Mahan" },
      { id: 566603, name: "Mala" },
      { id: 566551, name: "Malandi" },
      { id: 566563, name: "Malawadi" },
      { id: 566586, name: "Malgaon" },
      { id: 566627, name: "Malkewadi" },
      { id: 566561, name: "Malond" },
      { id: 943039, name: "Malvan" },
      { id: 566571, name: "Marde" },
      { id: 566570, name: "Margtad" },
      { id: 566567, name: "Masade" },
      { id: 566573, name: "Masure" },
      { id: 566529, name: "Math Bk." },
      { id: 566612, name: "Mhavlunge" },
      { id: 566619, name: "Mogarne" },
      { id: 566617, name: "Nagzar" },
      { id: 566608, name: "Nandos" },
      { id: 566589, name: "Nandrukh" },
      { id: 566524, name: "Nhive" },
      { id: 566528, name: "Nirom" },
      { id: 566554, name: "Ovaliye" },
      { id: 566522, name: "Ozar" },
      { id: 566538, name: "Palasamb" },
      { id: 566559, name: "Palayewadi" },
      { id: 566541, name: "Palikadilwadi" },
      { id: 566510, name: "Palkarwadi" },
      { id: 566630, name: "Parabwada" },
      { id: 566628, name: "Parad" },
      { id: 566498, name: "Parwadi" },
      { id: 566624, name: "Pedave" },
      { id: 566626, name: "Pendur" },
      { id: 566506, name: "Pirawadi" },
      { id: 566555, name: "Poip" },
      { id: 566550, name: "Rathivade" },
      { id: 566525, name: "Revandi" },
      { id: 566512, name: "Sadewadi" },
      { id: 566618, name: "Salel" },
      { id: 566526, name: "Sarjekot" },
      { id: 566565, name: "Sayyad Juva" },
      { id: 566521, name: "Shemad Ranewadi" },
      { id: 566549, name: "Shirvande" },
      { id: 566536, name: "Shrawan" },
      { id: 566620, name: "Sonarwada" },
      { id: 566610, name: "Sukalwad" },
      { id: 566611, name: "Talgaon" },
      { id: 566598, name: "Tarkarli" },
      { id: 566607, name: "Tembwadi" },
      { id: 566511, name: "Terai" },
      { id: 566609, name: "Tiravde" },
      { id: 566515, name: "Tondavali" },
      { id: 566539, name: "Trimbak" },
      { id: 566502, name: "Varachiwadi" },
      { id: 566576, name: "Wadachapat" },
      { id: 566580, name: "Wadi Dangmode" },
      { id: 566601, name: "Waghavane" },
      { id: 566558, name: "Waingavade" },
      { id: 566604, name: "Wak" },
      { id: 566622, name: "Warad" },
      { id: 566514, name: "Wayangani" },
      { id: 566597, name: "Wayari" },
      { id: 566569, name: "Weral" },
    ],
    4279: [
      { id: 566666, name: "Adari" },
      { id: 566657, name: "Adeli" },
      { id: 566676, name: "Ansur" },
      { id: 566699, name: "Arawali" },
      { id: 566693, name: "Asoli" },
      { id: 566703, name: "Bagayat" },
      { id: 566700, name: "Bandh" },
      { id: 566658, name: "Bhandarwada" },
      { id: 566665, name: "Bhendamala" },
      { id: 566638, name: "Bhogave" },
      { id: 566710, name: "Bombadojichiwadi" },
      { id: 566632, name: "Chipi" },
      { id: 566655, name: "Dabholi" },
      { id: 566661, name: "Devsu" },
      { id: 566707, name: "Gandhinagar" },
      { id: 566636, name: "Gavan" },
      { id: 566714, name: "Gavatale" },
      { id: 566679, name: "Girapwadi" },
      { id: 566681, name: "Hodawada" },
      { id: 566708, name: "Huda" },
      { id: 566690, name: "Josoli" },
      { id: 566648, name: "Kalavi" },
      { id: 566659, name: "Kamalevir" },
      { id: 566672, name: "Kambaliwadi" },
      { id: 566713, name: "Kanyal" },
      { id: 566634, name: "Karli" },
      { id: 566647, name: "Kelus" },
      { id: 566705, name: "Khalchiker" },
      { id: 566645, name: "Khalchiwadi" },
      { id: 566651, name: "Khanoli" },
      { id: 566684, name: "Khatarwadi" },
      { id: 566646, name: "Khavane" },
      { id: 566639, name: "Kochare" },
      { id: 566674, name: "Kurlewadi" },
      { id: 566644, name: "Malai" },
      { id: 566663, name: "Math" },
      { id: 566687, name: "Matond" },
      { id: 566641, name: "Mayana" },
      { id: 566642, name: "Medha" },
      { id: 566643, name: "Mhapan" },
      { id: 566709, name: "Mhartale" },
      { id: 566677, name: "Mochemad" },
      { id: 566678, name: "Muth" },
      { id: 566667, name: "Namas" },
      { id: 566668, name: "Navabag" },
      { id: 566692, name: "Nhaichiad" },
      { id: 566686, name: "Pal" },
      { id: 566653, name: "Palkarwadi" },
      { id: 566685, name: "Paltad" },
      { id: 566702, name: "Parabgaon" },
      { id: 566664, name: "Parabwada" },
      { id: 566683, name: "Parabwadi" },
      { id: 566633, name: "Parule" },
      { id: 566688, name: "Pendur" },
      { id: 566662, name: "Pimpalgaon" },
      { id: 566635, name: "Ravadas" },
      { id: 566712, name: "Redi" },
      { id: 566697, name: "Sagartirtha" },
      { id: 566695, name: "Sakhailekhol" },
      { id: 566656, name: "Sataye" },
      { id: 566689, name: "Satvayangani" },
      { id: 566637, name: "Shelapi" },
      { id: 566701, name: "Shiroda" },
      { id: 566640, name: "Shriramwadi" },
      { id: 566671, name: "Siddharthwadi" },
      { id: 566694, name: "Sonsure" },
      { id: 566682, name: "Subhashwadi" },
      { id: 566711, name: "Sukhalbhat" },
      { id: 566673, name: "Sukhatanbag" },
      { id: 566649, name: "Talekarwadi" },
      { id: 566696, name: "Tank" },
      { id: 566698, name: "Temb" },
      { id: 566680, name: "Tulas" },
      { id: 566669, name: "Ubhadanda" },
      { id: 566691, name: "Vadakhol" },
      { id: 566670, name: "Vagheshwar" },
      { id: 566660, name: "Vajrat" },
      { id: 566675, name: "Varachemad" },
      { id: 566706, name: "Varachiker" },
      { id: 566652, name: "Varchiaad" },
      { id: 566704, name: "Velagar" },
      { id: 943040, name: "Vengurla" },
      { id: 566654, name: "Vetore" },
      { id: 566650, name: "Wayangani" },
    ],
    4280: [
      { id: 566810, name: "Akeri" },
      { id: 566796, name: "Ambadpal" },
      { id: 566770, name: "Amberi" },
      { id: 566718, name: "Ambrad" },
      { id: 566725, name: "Anav" },
      { id: 566830, name: "Andurle" },
      { id: 566763, name: "Anjivade" },
      { id: 566745, name: "Avalegaon" },
      { id: 566728, name: "Bambarde Tarf Kalsuli" },
      { id: 566807, name: "Bambarde Tarf Mangaon" },
      { id: 566788, name: "Bambuli" },
      { id: 566787, name: "Bav" },
      { id: 566795, name: "Belnadi" },
      { id: 566774, name: "Bengaon" },
      { id: 566739, name: "Bhadgaon Bk." },
      { id: 566738, name: "Bhadgaon Kh." },
      { id: 566736, name: "Bharani" },
      { id: 566786, name: "Bhattgaon" },
      { id: 566737, name: "Bhutvad" },
      { id: 566806, name: "Bibavane" },
      { id: 566791, name: "Borbhat" },
      { id: 566761, name: "Chafeli" },
      { id: 566819, name: "Chendawan" },
      { id: 566805, name: "Deulwadi" },
      { id: 566785, name: "Dholkarwadi" },
      { id: 566748, name: "Digas" },
      { id: 566732, name: "Durganagar" },
      { id: 566821, name: "Gandhigram" },
      { id: 566831, name: "Gandhinagar" },
      { id: 566824, name: "Gaondhad" },
      { id: 566729, name: "Gavalgaon" },
      { id: 566715, name: "Gavrai" },
      { id: 566734, name: "Ghadigaon" },
      { id: 566781, name: "Ghatakarnagar" },
      { id: 566771, name: "Ghavanale" },
      { id: 566735, name: "Ghotage" },
      { id: 566751, name: "Girgaon" },
      { id: 566804, name: "Gondhalpur" },
      { id: 566836, name: "Gondhayale" },
      { id: 566758, name: "Gothos" },
      { id: 566835, name: "Goveri" },
      { id: 566801, name: "Gudhipur" },
      { id: 566752, name: "Hirlok" },
      { id: 566829, name: "Humarmala" },
      { id: 566809, name: "Humras" },
      { id: 566784, name: "Jambharmala" },
      { id: 566731, name: "Jambhavade" },
      { id: 566742, name: "Kadawal" },
      { id: 566777, name: "Kaleli" },
      { id: 566825, name: "Kandargaon" },
      { id: 566775, name: "Kanduli" },
      { id: 566749, name: "Karivane" },
      { id: 566717, name: "Kasal" },
      { id: 566782, name: "Kattagaon" },
      { id: 566820, name: "Kavathi" },
      { id: 566814, name: "Kavilgaon" },
      { id: 566790, name: "Kavilkate" },
      { id: 566760, name: "Keravade Karyad Narur" },
      { id: 566799, name: "Keravade Tarf Mangaon" },
      { id: 566756, name: "Khocharewadi" },
      { id: 566755, name: "Khutvalwadi" },
      { id: 566750, name: "Kinlos" },
      { id: 566839, name: "Kudal" },
      { id: 566721, name: "Kunde" },
      { id: 566730, name: "Kupavade" },
      { id: 566720, name: "Kusabe" },
      { id: 566744, name: "Kusagaon" },
      { id: 566816, name: "Kutgaon" },
      { id: 566828, name: "Madgaon" },
      { id: 566800, name: "Mandkuli" },
      { id: 566779, name: "Mangaon" },
      { id: 566827, name: "Mankadevi" },
      { id: 566793, name: "Mitkyachiwadi" },
      { id: 566776, name: "More" },
      { id: 566823, name: "Mudyacha Kond" },
      { id: 566797, name: "Mulade" },
      { id: 566833, name: "Munagi" },
      { id: 566822, name: "Naiknagar" },
      { id: 566813, name: "Naikwadi" },
      { id: 566780, name: "Namasgaon" },
      { id: 566772, name: "Namaspur" },
      { id: 566773, name: "Naneli" },
      { id: 566754, name: "Narur Karyad Narur" },
      { id: 566789, name: "Neharunagar" },
      { id: 566762, name: "Nerur Karyad Narur" },
      { id: 566817, name: "Nerur Tarf Haveli" },
      { id: 566759, name: "Nileli" },
      { id: 566740, name: "Nirukhe" },
      { id: 566757, name: "Nivaje" },
      { id: 566723, name: "Oras Bk." },
      { id: 566724, name: "Oras Kh." },
      { id: 566716, name: "Padave" },
      { id: 566727, name: "Pandur" },
      { id: 566743, name: "Pangrad" },
      { id: 566832, name: "Pat" },
      { id: 566792, name: "Pawashi" },
      { id: 566803, name: "Pinguli" },
      { id: 566719, name: "Pokharan" },
      { id: 566768, name: "Pulas" },
      { id: 566722, name: "Ranbambuli" },
      { id: 566834, name: "Raygaon" },
      { id: 566747, name: "Rumadgaon" },
      { id: 566826, name: "Saigaon" },
      { id: 566766, name: "Sakirde" },
      { id: 566783, name: "Salgaon" },
      { id: 566794, name: "Sangirde" },
      { id: 566812, name: "Sarambal" },
      { id: 566764, name: "Shivapur" },
      { id: 566811, name: "Sonavade Tarf Haveli" },
      { id: 566733, name: "Sonavade Tarf Kalsuli" },
      { id: 566815, name: "Talegaon" },
      { id: 566778, name: "Taligaon" },
      { id: 566802, name: "Tembdhurinagar" },
      { id: 566746, name: "Tembgaon" },
      { id: 566837, name: "Tendoli" },
      { id: 566753, name: "Tulsuli Karyad Narur" },
      { id: 566798, name: "Tulsuli Tarf Mangaon" },
      { id: 566767, name: "Upavade" },
      { id: 566726, name: "Vadihumarmala" },
      { id: 566838, name: "Wadivarvade" },
      { id: 566769, name: "Wados" },
      { id: 566818, name: "Walawal" },
      { id: 566741, name: "Warde" },
      { id: 566765, name: "Wasoli" },
      { id: 566808, name: "Zarap" },
    ],
    4281: [
      { id: 566879, name: "Ajgaon" },
      { id: 566844, name: "Ambegaon" },
      { id: 566855, name: "Amboli" },
      { id: 566889, name: "Aronda" },
      { id: 566883, name: "Aros" },
      { id: 566898, name: "Asniye" },
      { id: 566872, name: "Bada" },
      { id: 566923, name: "Banda" },
      { id: 566861, name: "Bavlat" },
      { id: 942988, name: "Bhairavwadi" },
      { id: 566899, name: "Bhalawal" },
      { id: 566888, name: "Bhatpavani" },
      { id: 566841, name: "Bhom" },
      { id: 945128, name: "Bhom Myu. Hadd" },
      { id: 566847, name: "Brahmanpat" },
      { id: 566846, name: "Charathe" },
      { id: 945129, name: "Charathe Myu. Hadd" },
      { id: 566871, name: "Chaukul" },
      { id: 566894, name: "Dabhil" },
      { id: 566882, name: "Dandeli" },
      { id: 566865, name: "Danoli" },
      { id: 566906, name: "Degave" },
      { id: 566863, name: "Devsu" },
      { id: 566880, name: "Dhakore" },
      { id: 566910, name: "Dingne" },
      { id: 566911, name: "Dongarpal" },
      { id: 566867, name: "Fansavade" },
      { id: 566913, name: "Galel" },
      { id: 566854, name: "Gele" },
      { id: 945133, name: "Gharap" },
      { id: 566885, name: "Gulduve" },
      { id: 566902, name: "Insuli" },
      { id: 566857, name: "Kalambist" },
      { id: 566860, name: "Kariwade" },
      { id: 566917, name: "Kas" },
      { id: 566921, name: "Kavthani" },
      { id: 566868, name: "Kegad" },
      { id: 566866, name: "Kesari" },
      { id: 566890, name: "Kinale" },
      { id: 566842, name: "Kolgaon" },
      { id: 945131, name: "Kolgaon Myu. Hadd" },
      { id: 566897, name: "Konas" },
      { id: 566881, name: "Kondure" },
      { id: 566903, name: "Kshetrapal" },
      { id: 566849, name: "Kumbharli" },
      { id: 566873, name: "Kumbharwada" },
      { id: 566843, name: "Kunkeri" },
      { id: 566859, name: "Madkhol" },
      { id: 566916, name: "Madure" },
      { id: 566922, name: "Majgaon" },
      { id: 945130, name: "Majgaon Myu. Hadd" },
      { id: 566878, name: "Malewad" },
      { id: 566848, name: "Malgaon" },
      { id: 566870, name: "Masure" },
      { id: 566887, name: "Nanos" },
      { id: 566840, name: "Nemale" },
      { id: 566869, name: "Nene" },
      { id: 566912, name: "Netarde" },
      { id: 566877, name: "Nhaveli" },
      { id: 566905, name: "Nigude" },
      { id: 566875, name: "Niravade" },
      { id: 566845, name: "Nirukhe" },
      { id: 566892, name: "Otavane" },
      { id: 566858, name: "Ovaliye" },
      { id: 566915, name: "Padlos" },
      { id: 566909, name: "Padve" },
      { id: 566908, name: "Padve Majgaon" },
      { id: 566864, name: "Parpoli" },
      { id: 566904, name: "Ronapal" },
      { id: 566851, name: "Sangeli" },
      { id: 566893, name: "Sarmale" },
      { id: 566919, name: "Satarda" },
      { id: 566920, name: "Sateli Tarf Satarda" },
      { id: 566918, name: "Satose" },
      { id: 566862, name: "Satuli" },
      { id: 566891, name: "Savarjuva" },
      { id: 942987, name: "Sawantwadi" },
      { id: 566852, name: "Sawarwad" },
      { id: 566914, name: "Sherle" },
      { id: 566853, name: "Shirshinge" },
      { id: 566876, name: "Sonurli" },
      { id: 566874, name: "Talavade" },
      { id: 566884, name: "Talawane" },
      { id: 566907, name: "Tamboli" },
      { id: 566886, name: "Tiroda" },
      { id: 945132, name: "Udeli" },
      { id: 566856, name: "Verle" },
      { id: 566850, name: "Vetye" },
      { id: 566900, name: "Vilavade" },
      { id: 566901, name: "Wafoli" },
    ],
    4282: [
      { id: 566931, name: "Adali" },
      { id: 566981, name: "Ambadgaon" },
      { id: 566945, name: "Ambeli" },
      { id: 566966, name: "Awade" },
      { id: 566983, name: "Ayee" },
      { id: 566959, name: "Aynode" },
      { id: 566948, name: "Bambarde" },
      { id: 566954, name: "Bhekurli" },
      { id: 566936, name: "Bhikekonal" },
      { id: 566971, name: "Bodade" },
      { id: 566969, name: "Bodan" },
      { id: 566949, name: "Ghatiwade" },
      { id: 566956, name: "Ghotage" },
      { id: 566958, name: "Ghotagewadi" },
      { id: 566979, name: "Girode" },
      { id: 566950, name: "Hewale" },
      { id: 566937, name: "Kalane" },
      { id: 566944, name: "Kasai" },
      { id: 566962, name: "Kendre Bk." },
      { id: 566961, name: "Kendre Kh." },
      { id: 566955, name: "Ker" },
      { id: 945111, name: "Khadpade" },
      { id: 566968, name: "Khanyale" },
      { id: 566976, name: "Khokral" },
      { id: 566928, name: "Kolzar" },
      { id: 566965, name: "Konal" },
      { id: 566941, name: "Kudase" },
      { id: 566942, name: "Kudase Kh." },
      { id: 945110, name: "Kumbhavade" },
      { id: 566934, name: "Kumbral" },
      { id: 566943, name: "Maneri" },
      { id: 566977, name: "Mangeli" },
      { id: 566982, name: "Matane" },
      { id: 566930, name: "Morgaon" },
      { id: 566953, name: "Morle" },
      { id: 566963, name: "Pal" },
      { id: 566952, name: "Palye" },
      { id: 566940, name: "Panturli" },
      { id: 566957, name: "Parme" },
      { id: 566964, name: "Patye" },
      { id: 566933, name: "Phondye" },
      { id: 566925, name: "Phukeri" },
      { id: 566975, name: "Pikule" },
      { id: 566960, name: "Sargave" },
      { id: 566939, name: "Sasoli Kh." },
      { id: 566938, name: "Sateli" },
      { id: 566967, name: "Sateli Bhedshi" },
      { id: 566970, name: "Shirange" },
      { id: 566935, name: "Shirwal" },
      { id: 566951, name: "Sonawal" },
      { id: 566984, name: "Talekhol" },
      { id: 566929, name: "Talkat" },
      { id: 566947, name: "Terwan" },
      { id: 566946, name: "Terwanmedhe" },
      { id: 566932, name: "Ugade" },
      { id: 566978, name: "Usap" },
      { id: 566980, name: "Vazare" },
      { id: 566985, name: "Virdi" },
      { id: 566972, name: "Zare" },
      { id: 566973, name: "Zare - 1" },
      { id: 566974, name: "Zare-2" },
      { id: 566927, name: "Zolambe" },
    ],
    4283: [
      { id: 567037, name: "Ainwadi" },
      { id: 567076, name: "Akurle" },
      { id: 567020, name: "Altur" },
      { id: 567026, name: "Amba" },
      { id: 567066, name: "Ambarde" },
      { id: 566994, name: "Amboli" },
      { id: 567075, name: "Ameni" },
      { id: 567119, name: "Anuskura" },
      { id: 567065, name: "Arul" },
      { id: 567089, name: "Bahirewadi" },
      { id: 567090, name: "Bajagewadi" },
      { id: 567101, name: "Bambavade" },
      { id: 567120, name: "Barki" },
      { id: 567098, name: "Bhadale" },
      { id: 567012, name: "Bhedasgaon" },
      { id: 567017, name: "Bhendavade" },
      { id: 567115, name: "Burambal" },
      { id: 567027, name: "Chalanwadi" },
      { id: 566986, name: "Chandel" },
      { id: 567023, name: "Chandoli" },
      { id: 567054, name: "Chanwad" },
      { id: 567097, name: "Charan" },
      { id: 566987, name: "Dhakale" },
      { id: 567038, name: "Dhanagarwadi" },
      { id: 567102, name: "Donoli" },
      { id: 566989, name: "Durgewadi" },
      { id: 567050, name: "Gadewadi" },
      { id: 567041, name: "Gajapur" },
      { id: 567074, name: "Gavadi" },
      { id: 567042, name: "Gelavade" },
      { id: 567030, name: "Gholasvade" },
      { id: 567111, name: "Ghungur" },
      { id: 567071, name: "Girgaon" },
      { id: 567091, name: "Gogave" },
      { id: 567016, name: "Golivane" },
      { id: 567007, name: "Gondoli" },
      { id: 567013, name: "Harugadewadi" },
      { id: 567029, name: "Humbavali" },
      { id: 567129, name: "Ijoli" },
      { id: 567003, name: "Jambur" },
      { id: 567031, name: "Jawali" },
      { id: 567045, name: "Kadave" },
      { id: 566998, name: "Kandavan" },
      { id: 567116, name: "Kante" },
      { id: 567079, name: "Kapashi" },
      { id: 567122, name: "Karanjfen" },
      { id: 567088, name: "Karanjoshi" },
      { id: 566991, name: "Karde" },
      { id: 567033, name: "Karungale" },
      { id: 567036, name: "Kasarde" },
      { id: 567127, name: "Katlewadi" },
      { id: 567024, name: "Kerle" },
      { id: 567000, name: "Khede" },
      { id: 567108, name: "Khotwadi" },
      { id: 567103, name: "Khutalwadi" },
      { id: 567061, name: "Kode" },
      { id: 567063, name: "Kolgaon" },
      { id: 567053, name: "Koparde" },
      { id: 567009, name: "Kotoli" },
      { id: 567118, name: "Kumbhavde" },
      { id: 567046, name: "Lalewadi" },
      { id: 567021, name: "Lolane" },
      { id: 944759, name: "Malakapur" },
      { id: 567126, name: "Malapude" },
      { id: 567006, name: "Malewadi" },
      { id: 566999, name: "Malgaon" },
      { id: 567059, name: "Man" },
      { id: 567077, name: "Mangaon" },
      { id: 567072, name: "Manjare." },
      { id: 567028, name: "Manoli" },
      { id: 567121, name: "Marale" },
      { id: 567069, name: "Mhalasvade" },
      { id: 567085, name: "Molavade" },
      { id: 567117, name: "Mosum" },
      { id: 567057, name: "Mutkalwadi" },
      { id: 567124, name: "Nandari" },
      { id: 567125, name: "Nandgaon" },
      { id: 567011, name: "Nerle" },
      { id: 567034, name: "Nile" },
      { id: 567014, name: "Nivale" },
      { id: 567130, name: "Pal" },
      { id: 567004, name: "Palasavade" },
      { id: 567068, name: "Panundre" },
      { id: 567048, name: "Parale" },
      { id: 567018, name: "Paraleninai" },
      { id: 567112, name: "Parali" },
      { id: 567043, name: "Parivane" },
      { id: 567110, name: "Parkhandale" },
      { id: 567082, name: "Patane" },
      { id: 567060, name: "Patawade" },
      { id: 567123, name: "Pendakhale" },
      { id: 567049, name: "Perid" },
      { id: 567107, name: "Pishavi" },
      { id: 567019, name: "Pusarle" },
      { id: 567008, name: "Rethare" },
      { id: 567096, name: "Saidapur" },
      { id: 567106, name: "Salashi" },
      { id: 567086, name: "Sambu" },
      { id: 567094, name: "Sarud" },
      { id: 567087, name: "Sasegaon" },
      { id: 567109, name: "Savarde Bk." },
      { id: 567084, name: "Savarde Kh." },
      { id: 567128, name: "Savardi" },
      { id: 567052, name: "Savate" },
      { id: 567083, name: "Save" },
      { id: 567073, name: "Shembavane" },
      { id: 567081, name: "Shimpe" },
      { id: 567067, name: "Shirale Tarf Malkapur" },
      { id: 566997, name: "Shirale Tarf Warun" },
      { id: 567051, name: "Shirgaon" },
      { id: 567099, name: "Shittur Tarf Malkapur" },
      { id: 566996, name: "Shittur Tarf Warun" },
      { id: 567078, name: "Shivare" },
      { id: 566988, name: "Sonarli" },
      { id: 567100, name: "Sonavade" },
      { id: 567001, name: "Sondoli" },
      { id: 567113, name: "Sonurle" },
      { id: 567104, name: "Supatre" },
      { id: 567025, name: "Talavade" },
      { id: 566993, name: "Tambave" },
      { id: 566992, name: "Tanali" },
      { id: 567062, name: "Tekoli" },
      { id: 567092, name: "Thamakewadi" },
      { id: 567002, name: "Thavade" },
      { id: 567095, name: "Thergaon" },
      { id: 567010, name: "Turukwadi" },
      { id: 567056, name: "Uchat" },
      { id: 567015, name: "Udgiri" },
      { id: 566995, name: "Ukhalu" },
      { id: 567064, name: "Ukoli" },
      { id: 567035, name: "Valur" },
      { id: 567005, name: "Virale" },
      { id: 567040, name: "Vishalgad" },
      { id: 567080, name: "Wadgaon" },
      { id: 566990, name: "Wadi Hudumb" },
      { id: 567093, name: "Wadicharan" },
      { id: 567022, name: "Wakoli" },
      { id: 567105, name: "Warewadi" },
      { id: 567044, name: "Warlegaon" },
      { id: 567032, name: "Warul" },
      { id: 567055, name: "Yelane" },
      { id: 567047, name: "Yelur" },
      { id: 567114, name: "Yelvadi" },
      { id: 567070, name: "Yelvan Jugai" },
    ],
    4284: [
      { id: 567248, name: "Akurde" },
      { id: 567189, name: "Alave" },
      { id: 567138, name: "Amatewadi" },
      { id: 567256, name: "Ambarde" },
      { id: 567163, name: "Ambavade" },
      { id: 567161, name: "Apati" },
      { id: 567137, name: "Arale" },
      { id: 567240, name: "Asagaon" },
      { id: 567167, name: "Asurle" },
      { id: 567238, name: "Atkirwadi" },
      { id: 567146, name: "Avali" },
      { id: 567155, name: "Badewadi" },
      { id: 567135, name: "Bahirewadi" },
      { id: 567199, name: "Bajarbhongaon" },
      { id: 567156, name: "Bandiwade" },
      { id: 944744, name: "Bhacharwadi" },
      { id: 567154, name: "Bongewadi" },
      { id: 567153, name: "Boriwade" },
      { id: 567148, name: "Borpadale" },
      { id: 567178, name: "Chavhanwadi" },
      { id: 567170, name: "Danewadi" },
      { id: 567168, name: "Darewadi" },
      { id: 567176, name: "Desaiwadi" },
      { id: 567147, name: "Devale" },
      { id: 567211, name: "Devthane" },
      { id: 567166, name: "Dhabdhabewadi" },
      { id: 567188, name: "Digavade" },
      { id: 567244, name: "Gharapan" },
      { id: 567179, name: "Ghotawade" },
      { id: 567171, name: "Giroli" },
      { id: 567253, name: "Gogave" },
      { id: 567191, name: "Goliwade" },
      { id: 567224, name: "Gothane" },
      { id: 567246, name: "Gothe" },
      { id: 567165, name: "Gude" },
      { id: 567257, name: "Harpavade" },
      { id: 567157, name: "Injole" },
      { id: 567143, name: "Jakhale" },
      { id: 567145, name: "Japhale" },
      { id: 567151, name: "Jeur" },
      { id: 567210, name: "K.Thane" },
      { id: 567133, name: "Kakhe" },
      { id: 567236, name: "Kale" },
      { id: 567226, name: "Kaljawade" },
      { id: 567182, name: "Kaneri" },
      { id: 567180, name: "Karanjphen" },
      { id: 567177, name: "Kasaba Borgaon" },
      { id: 567132, name: "Kasaba Satave" },
      { id: 567212, name: "Katebhogaon" },
      { id: 567216, name: "Kaurwadi" },
      { id: 567144, name: "Kekhale" },
      { id: 567237, name: "Kherivade" },
      { id: 567228, name: "Khotwadi" },
      { id: 567217, name: "Kisrul" },
      { id: 567252, name: "Kodavade" },
      { id: 567134, name: "Kodoli" },
      { id: 567223, name: "Kolik" },
      { id: 567184, name: "Kololi" },
      { id: 567185, name: "Kotoli" },
      { id: 567204, name: "Kumbharwadi" },
      { id: 567173, name: "Kushire Tarfe Thane" },
      { id: 567209, name: "Mahadikwadi" },
      { id: 567230, name: "Majagaon" },
      { id: 944745, name: "Majgaon Paiki Malwadi" },
      { id: 944746, name: "Majgaon Paiki Shindewadi" },
      { id: 567205, name: "Majnal" },
      { id: 567141, name: "Male" },
      { id: 567242, name: "Malharpeth" },
      { id: 567186, name: "Malwadi" },
      { id: 567190, name: "Manewadi" },
      { id: 567220, name: "Manwad" },
      { id: 567235, name: "Marali" },
      { id: 567239, name: "Menganewadi" },
      { id: 567208, name: "Mhalunge Tarf Borgaon" },
      { id: 567159, name: "Mhalunge Tarf Thane" },
      { id: 567149, name: "Mitharwadi" },
      { id: 567136, name: "Mohare" },
      { id: 946154, name: "Morewadi" },
      { id: 567215, name: "Motaiwadi" },
      { id: 567218, name: "Mugadewadi" },
      { id: 567181, name: "Nanundre" },
      { id: 567150, name: "Navali" },
      { id: 567162, name: "Nebapur" },
      { id: 567194, name: "Nikamwadi" },
      { id: 567258, name: "Nivachiwadi" },
      { id: 567174, name: "Nivade" },
      { id: 567232, name: "Padal" },
      { id: 567222, name: "Padasali" },
      { id: 567152, name: "Paijarwadi" },
      { id: 567160, name: "Panhala" },
      { id: 567259, name: "Panore" },
      { id: 567254, name: "Panutre" },
      { id: 567245, name: "Parakhandale" },
      { id: 567197, name: "Patpanhala" },
      { id: 567164, name: "Pimple T.Satave" },
      { id: 567192, name: "Pimple T.Thane" },
      { id: 567219, name: "Pisatri" },
      { id: 567172, name: "Pohale T.Alate" },
      { id: 567200, name: "Pohale T.Borgaon" },
      { id: 567227, name: "Pohalwadi" },
      { id: 567142, name: "Pokhale" },
      { id: 567225, name: "Pombre" },
      { id: 567198, name: "Porle T.Borgaon" },
      { id: 567196, name: "Porle T.Thane" },
      { id: 567206, name: "Punal" },
      { id: 567207, name: "Pushire T.Borgaon" },
      { id: 567169, name: "Rakshi" },
      { id: 567201, name: "Salwadi" },
      { id: 567234, name: "Satarde" },
      { id: 567241, name: "Savarde Tarf Asandoli" },
      { id: 567131, name: "Sawarde T.Satave" },
      { id: 567140, name: "Shahapur" },
      { id: 567251, name: "Sule" },
      { id: 567213, name: "Talewadi" },
      { id: 567247, name: "Tandulwadi" },
      { id: 567183, name: "Telave" },
      { id: 567187, name: "Tirpan" },
      { id: 567175, name: "Undri" },
      { id: 567195, name: "Utre" },
      { id: 567202, name: "Valoli" },
      { id: 567158, name: "Vekhandwadi" },
      { id: 567255, name: "Vetawade" },
      { id: 567260, name: "Wadi Ratnagiri" },
      { id: 567193, name: "Waghave" },
      { id: 567249, name: "Waghurde" },
      { id: 567214, name: "Walavekarwadi" },
      { id: 567203, name: "Warnul" },
      { id: 567221, name: "Washi" },
      { id: 567233, name: "Yavluj" },
    ],
    4285: [
      { id: 567290, name: "Alte" },
      { id: 567272, name: "Ambap" },
      { id: 567273, name: "Ambapwadi" },
      { id: 567303, name: "Atigre" },
      { id: 567270, name: "Bhadole" },
      { id: 567279, name: "Bhendavade" },
      { id: 567292, name: "Birdevwadi" },
      { id: 567313, name: "Chandur" },
      { id: 567263, name: "Chavare" },
      { id: 567302, name: "Chokak" },
      { id: 912834, name: "Durgewadai" },
      { id: 567264, name: "Ghunaki" },
      { id: 567297, name: "Halondi" },
      { id: 567291, name: "Hatkanangale" },
      { id: 567299, name: "Herle" },
      { id: 567286, name: "Hingangaon" },
      { id: 567321, name: "Hupari" },
      { id: 944761, name: "Ichalkaranji" },
      { id: 567309, name: "Ingali" },
      { id: 567316, name: "Jangamwadi" },
      { id: 567320, name: "Kabnur" },
      { id: 567285, name: "Kapurwadi" },
      { id: 567271, name: "Kasaba Vadgaon" },
      { id: 567274, name: "Kasarwadi" },
      { id: 567280, name: "Khochi" },
      { id: 567312, name: "Khotwadi" },
      { id: 567265, name: "Kini" },
      { id: 567319, name: "Korochi" },
      { id: 567287, name: "Kumbhoj" },
      { id: 567278, name: "Latavade" },
      { id: 567293, name: "Laxmiwadi" },
      { id: 567289, name: "Majale" },
      { id: 567300, name: "Male" },
      { id: 567305, name: "Mangaon" },
      { id: 567304, name: "Mangaonwadi" },
      { id: 567269, name: "Manpadle" },
      { id: 567298, name: "Mauje Vadgaon" },
      { id: 567284, name: "Minche" },
      { id: 567301, name: "Mudshingi" },
      { id: 567296, name: "Nagaon" },
      { id: 567282, name: "Narande" },
      { id: 567288, name: "Nej" },
      { id: 567268, name: "Padali" },
      { id: 567262, name: "Pargaon" },
      { id: 567310, name: "Pattan Kodoli" },
      { id: 567315, name: "Rangoli" },
      { id: 567317, name: "Rendal" },
      { id: 567308, name: "Rui" },
      { id: 567294, name: "Rukadi" },
      { id: 567306, name: "Sajani" },
      { id: 567276, name: "Sambhapur" },
      { id: 567283, name: "Savarde" },
      { id: 944762, name: "Shahapur" },
      { id: 567295, name: "Shiroli" },
      { id: 567314, name: "Talandage" },
      { id: 567267, name: "Talsande" },
      { id: 567311, name: "Tardal" },
      { id: 567277, name: "Tasgaon" },
      { id: 567307, name: "Tilwani" },
      { id: 567275, name: "Top" },
      { id: 567281, name: "Vathar Tarf Udgaon" },
      { id: 567266, name: "Vathar Tarf Vadgaon" },
      { id: 567318, name: "Yalgud" },
    ],
    4286: [
      { id: 567349, name: "Abdul Lat" },
      { id: 567331, name: "Agar" },
      { id: 567358, name: "Akiwat" },
      { id: 567367, name: "Alas" },
      { id: 567332, name: "Arjunwad" },
      { id: 567360, name: "Aurwad" },
      { id: 567357, name: "Bastwad" },
      { id: 567366, name: "Bubnal" },
      { id: 567329, name: "Chinchwad" },
      { id: 567340, name: "Chipri" },
      { id: 567323, name: "Danoli" },
      { id: 944760, name: "Danwad" },
      { id: 567375, name: "Dattawad" },
      { id: 567345, name: "Dharangutti" },
      { id: 567364, name: "Ganeshwadi" },
      { id: 567361, name: "Gaurwad" },
      { id: 567333, name: "Ghalwad" },
      { id: 567368, name: "Ghosarwad" },
      { id: 567343, name: "Haroli" },
      { id: 567336, name: "Hasur" },
      { id: 567353, name: "Herwad" },
      { id: 567325, name: "Jainapur" },
      { id: 567342, name: "Jambhali" },
      { id: 567327, name: "Jaysingpur" },
      { id: 567337, name: "Kanwad" },
      { id: 567362, name: "Kavatheguland" },
      { id: 567322, name: "Kavathesar" },
      { id: 567372, name: "Khidrapur" },
      { id: 567341, name: "Kondigre" },
      { id: 567324, name: "Kothali" },
      { id: 567355, name: "Kurundwad" },
      { id: 567335, name: "Kutwad" },
      { id: 567352, name: "Latwadi" },
      { id: 567356, name: "Majarewadi" },
      { id: 567344, name: "Nandani" },
      { id: 567339, name: "Nimshirgaon" },
      { id: 567359, name: "Nrusinhwadi" },
      { id: 567371, name: "Rajapur" },
      { id: 912598, name: "Sambhajipur" },
      { id: 567363, name: "Shedshal" },
      { id: 567350, name: "Shiradwad" },
      { id: 567334, name: "Shirati" },
      { id: 567348, name: "Shirdhon" },
      { id: 567330, name: "Shirol" },
      { id: 567351, name: "Shivnakwadi" },
      { id: 567370, name: "Takali" },
      { id: 567369, name: "Takaliwadi" },
      { id: 567347, name: "Takawade" },
      { id: 567338, name: "Tamdalge" },
      { id: 567354, name: "Terwad" },
      { id: 567328, name: "Udagaon" },
      { id: 567326, name: "Umalwad" },
      { id: 567346, name: "Yadrav" },
    ],
    4287: [
      { id: 567379, name: "Adur" },
      { id: 567476, name: "Amashi" },
      { id: 567408, name: "Ambewadi" },
      { id: 567480, name: "Ardewadi" },
      { id: 567459, name: "Are" },
      { id: 567463, name: "Bachani" },
      { id: 567475, name: "Bahireshwar." },
      { id: 567388, name: "Balinge" },
      { id: 567448, name: "Bele" },
      { id: 567377, name: "Bhamate" },
      { id: 567467, name: "Bhatanwadi" },
      { id: 567404, name: "Bhuye" },
      { id: 567399, name: "Bhuyewadi" },
      { id: 567482, name: "Bololi" },
      { id: 567491, name: "Chafodi" },
      { id: 567407, name: "Chikhali" },
      { id: 567410, name: "Chinchawad" },
      { id: 567376, name: "Chinchawade Tarf Kale" },
      { id: 567434, name: "Chuye" },
      { id: 944741, name: "Daryache Wadgaon" },
      { id: 567443, name: "Dewale" },
      { id: 567460, name: "Dhangarwadi" },
      { id: 567456, name: "Dhondewadi" },
      { id: 567428, name: "Dindanerli" },
      { id: 567390, name: "Donawade" },
      { id: 567490, name: "Donwadi" },
      { id: 567481, name: "Durgulwadi" },
      { id: 567461, name: "Gadegoundwadi" },
      { id: 567455, name: "Ganeshwadi" },
      { id: 567489, name: "Garjan" },
      { id: 567494, name: "Ghanawade" },
      { id: 567495, name: "Ghungurwadi" },
      { id: 567424, name: "Girgaon" },
      { id: 567502, name: "Gokul Shirgaon" },
      { id: 567444, name: "Haladi" },
      { id: 567415, name: "Halasawade" },
      { id: 567427, name: "Hanbarwadi" },
      { id: 567384, name: "Hanmantwadi" },
      { id: 567426, name: "Hasur Dumala" },
      { id: 567485, name: "Hirawade Dumala" },
      { id: 567465, name: "Hirawade Khalasa" },
      { id: 567432, name: "Ispurli" },
      { id: 944739, name: "Jadhavwadi" },
      { id: 567442, name: "Jaital" },
      { id: 567403, name: "Jatharwadi" },
      { id: 567504, name: "Kalambe T Thane" },
      { id: 567378, name: "Kalambe Tarf Kale" },
      { id: 567470, name: "Kanchanwadi" },
      { id: 567417, name: "Kandalgaon" },
      { id: 567440, name: "Kandgaon" },
      { id: 567421, name: "Kaneri" },
      { id: 567420, name: "Kaneriwadi" },
      { id: 567462, name: "Karbharwadi" },
      { id: 567492, name: "Kasaba Arale" },
      { id: 944737, name: "Kasaba Bavada" },
      { id: 567454, name: "Kasaba Beed" },
      { id: 944734, name: "Kasaba Karvir" },
      { id: 567435, name: "Kavane" },
      { id: 567483, name: "Kekatwadi" },
      { id: 567397, name: "Kerali" },
      { id: 567394, name: "Kerli" },
      { id: 567473, name: "Khatangale" },
      { id: 567430, name: "Khebavade" },
      { id: 567381, name: "Khupire" },
      { id: 567452, name: "Koge" },
      { id: 567422, name: "Kogil Bk." },
      { id: 567423, name: "Kogil Khurd" },
      { id: 567380, name: "Koparde" },
      { id: 567446, name: "Kothali" },
      { id: 567392, name: "Kuditre" },
      { id: 567445, name: "Kurdu" },
      { id: 567447, name: "Kurukali" },
      { id: 567400, name: "Madale" },
      { id: 567453, name: "Mahe" },
      { id: 567488, name: "Mandare" },
      { id: 567496, name: "Manjarwadi" },
      { id: 567471, name: "Mhalasvade" },
      { id: 567450, name: "Mhalunge" },
      { id: 567474, name: "Mharul" },
      { id: 567501, name: "Morewadi" },
      { id: 567411, name: "Mudashingi" },
      { id: 567387, name: "Nagadewadi" },
      { id: 567431, name: "Nagaon" },
      { id: 567429, name: "Nandgaon" },
      { id: 567441, name: "Nandwal" },
      { id: 567418, name: "Nerli" },
      { id: 921519, name: "New Wadade" },
      { id: 567398, name: "Nigave Dumala" },
      { id: 567436, name: "Nigave Khalsa" },
      { id: 567395, name: "Nitawade" },
      { id: 567500, name: "Pachgaon" },
      { id: 567383, name: "Padali Bk." },
      { id: 567389, name: "Padali Kh." },
      { id: 567393, name: "Padvalwadi" },
      { id: 567451, name: "Parite" },
      { id: 567478, name: "Pasarde" },
      { id: 567469, name: "Patekarwadi" },
      { id: 567406, name: "Rajaputwadi" },
      { id: 567386, name: "Sabalewadi" },
      { id: 567401, name: "Sadale" },
      { id: 567486, name: "Sadoli Dumala" },
      { id: 567464, name: "Sadoli Khalsa" },
      { id: 567414, name: "Sangawadewadi" },
      { id: 567472, name: "Sangrul" },
      { id: 567413, name: "Sangwade" },
      { id: 567416, name: "Sarnobatwadi" },
      { id: 567487, name: "Savarde Dumala" },
      { id: 567458, name: "Savarwadi" },
      { id: 567439, name: "Shelakewadi" },
      { id: 567382, name: "Shindewadi" },
      { id: 567385, name: "Shinganapur" },
      { id: 567457, name: "Shipekarwadi" },
      { id: 567484, name: "Shiroli Dumala" },
      { id: 567402, name: "Shiye" },
      { id: 567468, name: "Sonali" },
      { id: 567503, name: "Tamgaon" },
      { id: 944740, name: "Tembalaiwadi" },
      { id: 567493, name: "Teraswadi" },
      { id: 567499, name: "Uchgaon" },
      { id: 567497, name: "Ujalaiwadi" },
      { id: 567479, name: "Upawade" },
      { id: 567433, name: "Vadakshivale" },
      { id: 567405, name: "Vadanage" },
      { id: 567391, name: "Vakare" },
      { id: 567396, name: "Varanage" },
      { id: 567412, name: "Vasagade" },
      { id: 567419, name: "Vikaswadi" },
      { id: 567425, name: "Waddwadi" },
      { id: 567437, name: "Wadipeer" },
      { id: 567477, name: "Waghobachiwadi" },
      { id: 567409, name: "Walivade" },
      { id: 567438, name: "Washi" },
      { id: 567449, name: "Yevati" },
    ],
    4288: [
      { id: 567529, name: "Anadur" },
      { id: 567527, name: "Asalaj" },
      { id: 567509, name: "Asandoli" },
      { id: 567520, name: "Balewadi" },
      { id: 567541, name: "Baveli" },
      { id: 567543, name: "Borbet" },
      { id: 567530, name: "Dhundavade" },
      { id: 567546, name: "Gagan Bavda" },
      { id: 567542, name: "Garivade" },
      { id: 567539, name: "Jargi" },
      { id: 567540, name: "Kadave" },
      { id: 567545, name: "Katali" },
      { id: 567517, name: "Khadule" },
      { id: 567532, name: "Kherivade" },
      { id: 567528, name: "Khokurle" },
      { id: 567515, name: "Kirave" },
      { id: 567505, name: "Kode Bk" },
      { id: 567506, name: "Kode Kh." },
      { id: 567544, name: "Lakhamapur" },
      { id: 567518, name: "Longhe" },
      { id: 567525, name: "Mandukali" },
      { id: 567523, name: "Mandur" },
      { id: 567510, name: "Margewadi" },
      { id: 567514, name: "Mhalunge" },
      { id: 567516, name: "Mutakeshwar" },
      { id: 567548, name: "Narveli" },
      { id: 567512, name: "Nivade" },
      { id: 567534, name: "Palsambe" },
      { id: 567538, name: "Pargaonkarwadi" },
      { id: 567524, name: "Patilwadi" },
      { id: 567537, name: "Saitavade." },
      { id: 567513, name: "Sakhari" },
      { id: 567521, name: "Salwan" },
      { id: 567536, name: "Sangashi" },
      { id: 567533, name: "Sheloshi" },
      { id: 567508, name: "Shenavade" },
      { id: 567507, name: "Taliye Bk." },
      { id: 567549, name: "Taliye Kh." },
      { id: 567519, name: "Tisangi" },
      { id: 567535, name: "Vesaraf" },
      { id: 567511, name: "Vesarde" },
      { id: 567522, name: "Vetawade" },
    ],
    4289: [
      { id: 567644, name: "Adoli" },
      { id: 567663, name: "Aini" },
      { id: 567597, name: "Akanur" },
      { id: 567577, name: "Amjaiwharwade" },
      { id: 567619, name: "Anaje" },
      { id: 567560, name: "Aptal" },
      { id: 567586, name: "Arjunwada" },
      { id: 944750, name: "Asangaon" },
      { id: 567661, name: "Ategaon" },
      { id: 567603, name: "Avali Bk." },
      { id: 567618, name: "Avali Kh." },
      { id: 944755, name: "Bambarde" },
      { id: 567631, name: "Banachiwadi" },
      { id: 567589, name: "Baradwadi" },
      { id: 567574, name: "Baragewadi" },
      { id: 944756, name: "Bhandane" },
      { id: 567575, name: "Bhopalwadi" },
      { id: 567653, name: "Bujawade" },
      { id: 567562, name: "Burambali" },
      { id: 567598, name: "Chafodi T.Tarale" },
      { id: 567641, name: "Chafodi Tarf Ainghol" },
      { id: 567590, name: "Chakreshwarwadi" },
      { id: 567566, name: "Chande" },
      { id: 567583, name: "Chandekarwadi" },
      { id: 567587, name: "Chandre" },
      { id: 567660, name: "Dhamanwadi" },
      { id: 567563, name: "Dhamod" },
      { id: 567656, name: "Dhengewadi" },
      { id: 944769, name: "Digas" },
      { id: 567645, name: "Dubalewadi" },
      { id: 567612, name: "Durgmanwadi" },
      { id: 944766, name: "Ejivade" },
      { id: 567637, name: "Farale" },
      { id: 944767, name: "Fejivade Paiki Potkharab" },
      { id: 567550, name: "Gavashi" },
      { id: 567642, name: "Gawathanwadi" },
      { id: 567572, name: "Ghotawade" },
      { id: 567604, name: "Ghudewadi" },
      { id: 567555, name: "Gotewadi" },
      { id: 567621, name: "Gudal" },
      { id: 567622, name: "Gudalwadi" },
      { id: 912907, name: "Hasane" },
      { id: 567654, name: "Helewadi" },
      { id: 944768, name: "June Karanje" },
      { id: 567617, name: "Kalankwadi" },
      { id: 567605, name: "Kambalwadi" },
      { id: 944751, name: "Kambarde" },
      { id: 567609, name: "Kandalgaon" },
      { id: 567616, name: "Kanthewadi" },
      { id: 567595, name: "Kapileshwar" },
      { id: 567624, name: "Karanjphen" },
      { id: 912908, name: "Karivade" },
      { id: 567623, name: "Kasaba Tarale" },
      { id: 567584, name: "Kasabawalwe" },
      { id: 567658, name: "Kasarputale" },
      { id: 567573, name: "Kaulav" },
      { id: 567559, name: "Keloshi Bk." },
      { id: 567561, name: "Keloshi Kh." },
      { id: 567557, name: "Khamkarwadi" },
      { id: 567620, name: "Khindi Wharawade" },
      { id: 567567, name: "Kodawade" },
      { id: 567558, name: "Konoli Tarf Asandoli" },
      { id: 944752, name: "Konoli Tarfe Einghol" },
      { id: 567565, name: "Kote" },
      { id: 567625, name: "Kudutri" },
      { id: 567613, name: "Kukudwadi" },
      { id: 567614, name: "Kumbharwadi" },
      { id: 567580, name: "Kurhadwadi" },
      { id: 567564, name: "Ladwadi" },
      { id: 567638, name: "Lingachiwadi" },
      { id: 567581, name: "Majagaon" },
      { id: 567592, name: "Majare Kasarwada" },
      { id: 567652, name: "Mallewadi" },
      { id: 567594, name: "Malve" },
      { id: 567610, name: "Manbet" },
      { id: 567556, name: "Manewadi" },
      { id: 567648, name: "Mangewadi" },
      { id: 567596, name: "Mangoli" },
      { id: 567659, name: "Mauje Kasarwada" },
      { id: 567552, name: "Mhasurli" },
      { id: 567651, name: "Mogharde" },
      { id: 567569, name: "Mohade" },
      { id: 567602, name: "Musalwadi" },
      { id: 944753, name: "Nanivale" },
      { id: 567647, name: "Nartawade" },
      { id: 567634, name: "New Karanje" },
      { id: 944754, name: "Nidankhan" },
      { id: 567633, name: "Olavan" },
      { id: 567629, name: "Padali" },
      { id: 944770, name: "Padali Paiki Potkharab" },
      { id: 567611, name: "Padasali" },
      { id: 567553, name: "Pal Bk." },
      { id: 567554, name: "Pal Kh." },
      { id: 567585, name: "Palkarwadi" },
      { id: 567655, name: "Pandewadi" },
      { id: 567662, name: "Panori" },
      { id: 567636, name: "Patpanhala" },
      { id: 567632, name: "Phejiwade" },
      { id: 567578, name: "Pimpalwadi" },
      { id: 567627, name: "Piral" },
      { id: 567599, name: "Pungoan" },
      { id: 567630, name: "Radhanagari" },
      { id: 567608, name: "Rai" },
      { id: 567639, name: "Rajapur" },
      { id: 567635, name: "Ramanwadi" },
      { id: 567571, name: "Rashiwade Bk." },
      { id: 567600, name: "Rashiwade Kh." },
      { id: 567646, name: "Sarvade" },
      { id: 567640, name: "Savarde" },
      { id: 567657, name: "Savarde Patankar" },
      { id: 567628, name: "Savardhan" },
      { id: 567551, name: "Sawatwadi" },
      { id: 944758, name: "Shelap" },
      { id: 567582, name: "Shelewadi" },
      { id: 567601, name: "Shirgaon" },
      { id: 567576, name: "Sirase" },
      { id: 567650, name: "Solankur" },
      { id: 567626, name: "Sonyachi Shiroli" },
      { id: 567649, name: "Sulambi" },
      { id: 567588, name: "Talashi" },
      { id: 567607, name: "Talgaon" },
      { id: 567615, name: "Tarale Kh." },
      { id: 567606, name: "Tarasambale" },
      { id: 567579, name: "Thikpurli" },
      { id: 567591, name: "Titawe" },
      { id: 567593, name: "Turambe" },
      { id: 944765, name: "Vadade" },
      { id: 944757, name: "Vaki" },
      { id: 567643, name: "Wadachiwadi" },
      { id: 567568, name: "Waghawade" },
      { id: 567570, name: "Yelvade" },
    ],
    4290: [
      { id: 567734, name: "Alabad" },
      { id: 567691, name: "Anur" },
      { id: 567724, name: "Arjuni" },
      { id: 567720, name: "Arjunwada" },
      { id: 567708, name: "Avachitwadi" },
      { id: 567679, name: "Bachani" },
      { id: 567737, name: "Baleghol" },
      { id: 567736, name: "Balikre" },
      { id: 567677, name: "Bamani" },
      { id: 567696, name: "Banage" },
      { id: 567713, name: "Bastavade" },
      { id: 567682, name: "Belawale Bk." },
      { id: 567681, name: "Belawale Kh." },
      { id: 567746, name: "Belewadi Kalamma" },
      { id: 567733, name: "Belewadi Masa" },
      { id: 567718, name: "Benikre" },
      { id: 567704, name: "Bhadagaon" },
      { id: 567700, name: "Bidri" },
      { id: 567743, name: "Bolavi" },
      { id: 567732, name: "Bolaviwadi" },
      { id: 567699, name: "Boravade" },
      { id: 567693, name: "Chaundal" },
      { id: 567715, name: "Chikhali" },
      { id: 567707, name: "Chimagaon" },
      { id: 567706, name: "Daulatwadi" },
      { id: 567672, name: "Ekondi" },
      { id: 567722, name: "Galgale" },
      { id: 567689, name: "Gorambe" },
      { id: 567719, name: "Haladi" },
      { id: 567729, name: "Haldavade" },
      { id: 567716, name: "Hamidwada" },
      { id: 567744, name: "Hasur Bk." },
      { id: 567742, name: "Hasur Kh." },
      { id: 567726, name: "Jainyal" },
      { id: 944742, name: "Kagal" },
      { id: 567735, name: "Kapashi" },
      { id: 567730, name: "Karanjivane" },
      { id: 567721, name: "Kardyal" },
      { id: 567671, name: "Karnoor" },
      { id: 567666, name: "Kasaba Sangaon" },
      { id: 567741, name: "Kasari" },
      { id: 567714, name: "Kaulage" },
      { id: 567680, name: "Kembali" },
      { id: 567688, name: "Kenavade" },
      { id: 567723, name: "Khadakewada" },
      { id: 567703, name: "Kurni" },
      { id: 567711, name: "Kurukali" },
      { id: 567725, name: "Lingnoor Kapshi" },
      { id: 567670, name: "Lingnur Dumala" },
      { id: 567747, name: "Madyal" },
      { id: 567694, name: "Malage Bk." },
      { id: 567695, name: "Malage Kh." },
      { id: 567745, name: "Mangnoor" },
      { id: 567669, name: "Mauje Sangaon" },
      { id: 567717, name: "Metage" },
      { id: 567690, name: "Mhakave" },
      { id: 567727, name: "Mugali" },
      { id: 944743, name: "Muragud" },
      { id: 567728, name: "Nandyal" },
      { id: 567702, name: "Nidhori" },
      { id: 567698, name: "Pharakatewadi" },
      { id: 567692, name: "Pimpalgaon Bk." },
      { id: 567665, name: "Pimpalgaon Kh." },
      { id: 567685, name: "Pirachiwadi" },
      { id: 567667, name: "Randivewadi" },
      { id: 567683, name: "Sake" },
      { id: 567686, name: "Savarde Bk." },
      { id: 567687, name: "Savarde Kh." },
      { id: 567675, name: "Shankarwadi" },
      { id: 567676, name: "Shendur" },
      { id: 567705, name: "Shindewadi" },
      { id: 567673, name: "Siddhanerli" },
      { id: 567712, name: "Sonage" },
      { id: 567701, name: "Sonali" },
      { id: 567668, name: "Sulkud" },
      { id: 567710, name: "Surupali" },
      { id: 567739, name: "Tamanakwada" },
      { id: 567731, name: "Thanewadi" },
      { id: 567697, name: "Undarwadi" },
      { id: 567740, name: "Vadgaon" },
      { id: 567684, name: "Valave Kh." },
      { id: 567674, name: "Vandoor" },
      { id: 567678, name: "Vhanali" },
      { id: 567664, name: "Vhannur" },
      { id: 567709, name: "Yamage" },
    ],
    4291: [
      { id: 567748, name: "Admapur" },
      { id: 567802, name: "Akurde" },
      { id: 567772, name: "Ambavane" },
      { id: 567846, name: "Anaf Bk." },
      { id: 567850, name: "Anaf Kh." },
      { id: 567852, name: "Antivade" },
      { id: 567848, name: "Anturli" },
      { id: 567793, name: "Aralgundi" },
      { id: 567784, name: "Bamne" },
      { id: 567781, name: "Barve" },
      { id: 567764, name: "Basarewadi" },
      { id: 567792, name: "Bediv" },
      { id: 567791, name: "Begvade" },
      { id: 567761, name: "Bhativade" },
      { id: 567779, name: "Bhendvade" },
      { id: 567813, name: "Bidri" },
      { id: 567847, name: "Chandamwadi" },
      { id: 567863, name: "Chikkewadi" },
      { id: 567854, name: "Chivale" },
      { id: 567766, name: "Darwad" },
      { id: 567845, name: "Dasewadi" },
      { id: 567853, name: "Dele" },
      { id: 567838, name: "Deulwadi" },
      { id: 567801, name: "Devakewadi" },
      { id: 567839, name: "Devarde" },
      { id: 567786, name: "Dindewadi" },
      { id: 567819, name: "Donvade" },
      { id: 567767, name: "Gangapur" },
      { id: 567775, name: "Gargoti" },
      { id: 567800, name: "Girgaon" },
      { id: 567864, name: "Hanamante" },
      { id: 567773, name: "Hanbarwadi" },
      { id: 567799, name: "Hedvade" },
      { id: 567780, name: "Helewadi" },
      { id: 944747, name: "K Patgaon" },
      { id: 567832, name: "Kadgaon" },
      { id: 567771, name: "Kalnakwadi" },
      { id: 567814, name: "Karadwadi" },
      { id: 567837, name: "Karambali" },
      { id: 567840, name: "Karivade" },
      { id: 567774, name: "Khanapur" },
      { id: 567755, name: "Khaparewadi" },
      { id: 567817, name: "Khedge" },
      { id: 567797, name: "Kolavan" },
      { id: 567844, name: "Kondoshi" },
      { id: 567753, name: "Konvade" },
      { id: 567752, name: "Koor" },
      { id: 567836, name: "Kudtarwadi" },
      { id: 567816, name: "Kumbharwadi" },
      { id: 567760, name: "Lotewadi" },
      { id: 567769, name: "Madilge Bk." },
      { id: 567770, name: "Madilge Kh." },
      { id: 567812, name: "Madur" },
      { id: 567796, name: "Maharwadi" },
      { id: 567826, name: "Mamdapur" },
      { id: 567788, name: "Manavle" },
      { id: 567856, name: "Mani" },
      { id: 567860, name: "Manope" },
      { id: 567855, name: "Mathagaon" },
      { id: 567828, name: "Megholi" },
      { id: 567842, name: "Mhasarang" },
      { id: 567795, name: "Mhasave" },
      { id: 567758, name: "Minache Bk" },
      { id: 567762, name: "Minache Kh." },
      { id: 567794, name: "Morewadi" },
      { id: 567749, name: "Mudal" },
      { id: 567787, name: "Murukte" },
      { id: 567754, name: "Nadhavade" },
      { id: 567782, name: "Naganwadi" },
      { id: 567830, name: "Nandoli" },
      { id: 567777, name: "Nangargaon" },
      { id: 567829, name: "Navale" },
      { id: 567759, name: "Navaraswadi" },
      { id: 567821, name: "Nhavyachiwadi" },
      { id: 567765, name: "Nilpan" },
      { id: 567811, name: "Nishnap" },
      { id: 567820, name: "Nitvade" },
      { id: 567815, name: "Pacharde" },
      { id: 567763, name: "Pachavade" },
      { id: 567824, name: "Padkhambe" },
      { id: 567778, name: "Pal" },
      { id: 567798, name: "Palewadi" },
      { id: 567768, name: "Palshivane" },
      { id: 567851, name: "Palyachahuda" },
      { id: 567757, name: "Pandivare" },
      { id: 567783, name: "Pangire" },
      { id: 567810, name: "Pardewadi" },
      { id: 944748, name: "Peth Shivapur" },
      { id: 567803, name: "Phanaswadi" },
      { id: 567809, name: "Phaye" },
      { id: 567785, name: "Pimpalgaon" },
      { id: 567806, name: "Pushpanagar" },
      { id: 946962, name: "Ranewadi" },
      { id: 567804, name: "Salpewadi" },
      { id: 567822, name: "Sheloli" },
      { id: 567808, name: "Shengaon" },
      { id: 567776, name: "Shindewadi" },
      { id: 567857, name: "Shivdav Bk." },
      { id: 567859, name: "Shivdav Kh." },
      { id: 945846, name: "Siddhanandnagar" },
      { id: 567807, name: "Sonarwadi" },
      { id: 567827, name: "Sonurli" },
      { id: 944749, name: "Sukyachiwadi" },
      { id: 567849, name: "Tambale" },
      { id: 567862, name: "Tambyachiwadi" },
      { id: 567756, name: "Tikkewadi" },
      { id: 567831, name: "Tiravade" },
      { id: 567843, name: "Ukirbhatale" },
      { id: 567823, name: "Varapewadi" },
      { id: 567833, name: "Vasnoli" },
      { id: 567825, name: "Vengrul" },
      { id: 567841, name: "Vesarde" },
      { id: 567751, name: "Vhangutti" },
      { id: 567858, name: "Vinjole" },
      { id: 567750, name: "Waghapur" },
      { id: 567818, name: "Yerandpe" },
    ],
    4292: [
      { id: 567964, name: "Ajra" },
      { id: 567922, name: "Alyachiwadi" },
      { id: 567925, name: "Ambade" },
      { id: 567876, name: "Ardal" },
      { id: 567920, name: "Awandi" },
      { id: 567888, name: "Bachi" },
      { id: 567866, name: "Bahirewadi" },
      { id: 567870, name: "Belewadi Hubbalagi" },
      { id: 567885, name: "Bhadawan" },
      { id: 567884, name: "Bhadawanwadi" },
      { id: 567963, name: "Bhavewadi" },
      { id: 567949, name: "Bolakewadi" },
      { id: 567950, name: "Burude" },
      { id: 567961, name: "Chafavade" },
      { id: 567900, name: "Chandewadi" },
      { id: 567869, name: "Chavhanwadi" },
      { id: 567872, name: "Chimane" },
      { id: 567962, name: "Chitale" },
      { id: 567909, name: "Dabheel" },
      { id: 567911, name: "Dardewadi" },
      { id: 567907, name: "Deokandgaon" },
      { id: 567915, name: "Deulwadi" },
      { id: 567905, name: "Dewarde" },
      { id: 567865, name: "Dhamane" },
      { id: 567917, name: "Erandol" },
      { id: 567929, name: "Gajargaon" },
      { id: 567921, name: "Gavase" },
      { id: 567898, name: "Hajgoli Bk." },
      { id: 567899, name: "Hajgoli Kh." },
      { id: 567877, name: "Halewadi" },
      { id: 567912, name: "Haloli" },
      { id: 567939, name: "Handewadi" },
      { id: 567891, name: "Harapwade" },
      { id: 567930, name: "Harur" },
      { id: 567948, name: "Hattiwade" },
      { id: 567947, name: "Honewadi" },
      { id: 567873, name: "Honyali" },
      { id: 567916, name: "Ite" },
      { id: 567882, name: "Jadhewadi" },
      { id: 567960, name: "Jeur" },
      { id: 567931, name: "Kanoli" },
      { id: 567874, name: "Karpewadi Dumala" },
      { id: 567914, name: "Karpewadi Khalsa" },
      { id: 567957, name: "Kasar Kandgaon" },
      { id: 567954, name: "Kerakbol" },
      { id: 567958, name: "Khanapur" },
      { id: 567897, name: "Khede" },
      { id: 567883, name: "Khoratwadi" },
      { id: 567943, name: "Kine" },
      { id: 567926, name: "Kitvade" },
      { id: 567940, name: "Kolindre" },
      { id: 567890, name: "Koriwade" },
      { id: 567932, name: "Kowade" },
      { id: 567893, name: "Kurkunde" },
      { id: 567938, name: "Lakudwadi" },
      { id: 567919, name: "Latagaon" },
      { id: 567886, name: "Madilage" },
      { id: 567879, name: "Mahagond" },
      { id: 567878, name: "Mahagondwadi" },
      { id: 567934, name: "Maligre" },
      { id: 567881, name: "Masewadi" },
      { id: 567913, name: "Masoli" },
      { id: 567906, name: "Medhewadi" },
      { id: 567946, name: "Mendholi" },
      { id: 567953, name: "Morewadi" },
      { id: 567867, name: "Mumewadi" },
      { id: 567896, name: "Munguswadi" },
      { id: 567956, name: "Murude" },
      { id: 567928, name: "Ningudage" },
      { id: 567895, name: "Parewadi" },
      { id: 567923, name: "Parpoli" },
      { id: 567933, name: "Pedrewadi" },
      { id: 567875, name: "Pendharwadi" },
      { id: 567892, name: "Pernoli" },
      { id: 567903, name: "Pethewadi" },
      { id: 567959, name: "Polgaon" },
      { id: 567941, name: "Poshratwadi" },
      { id: 567942, name: "Redewadi" },
      { id: 567894, name: "Salgaon" },
      { id: 567936, name: "Sarambalwadi" },
      { id: 567927, name: "Saroli" },
      { id: 567918, name: "Satewadi" },
      { id: 567902, name: "Sawarwadi" },
      { id: 567910, name: "Shelap" },
      { id: 567944, name: "Shirsangi" },
      { id: 567951, name: "Shrungarwadi" },
      { id: 567889, name: "Sohale" },
      { id: 567937, name: "Sule" },
      { id: 567924, name: "Suleran" },
      { id: 567901, name: "Sulgaon" },
      { id: 567955, name: "Uchangi" },
      { id: 567868, name: "Uttur" },
      { id: 567880, name: "Vadakshiwale" },
      { id: 567887, name: "Vazare" },
      { id: 567904, name: "Velawatti" },
      { id: 567908, name: "Vinayakwadi" },
      { id: 567952, name: "Watangi" },
      { id: 567945, name: "Yamekond" },
      { id: 567871, name: "Zulapewadi" },
    ],
    4293: [
      { id: 567976, name: "Ainapur" },
      { id: 567991, name: "Aralgundi" },
      { id: 568050, name: "Arjunwadi" },
      { id: 567973, name: "Atyal" },
      { id: 567983, name: "Aurnal" },
      { id: 946128, name: "Badyachiwadi" },
      { id: 568000, name: "Basarge Bk" },
      { id: 568004, name: "Basarge Kh" },
      { id: 568035, name: "Batkanangale" },
      { id: 567967, name: "Beknal" },
      { id: 567974, name: "Belgundi" },
      { id: 568018, name: "Bhadgaon" },
      { id: 568038, name: "Bidrewadi" },
      { id: 568014, name: "Bugadi Katti" },
      { id: 568002, name: "Chandankud" },
      { id: 567997, name: "Channekuppi" },
      { id: 568007, name: "Chinchewadi" },
      { id: 568045, name: "Donewadi" },
      { id: 568029, name: "Dugunwadi" },
      { id: 567984, name: "Dundage" },
      { id: 567968, name: "Gadhinglaj" },
      { id: 567969, name: "Gijavane" },
      { id: 568016, name: "Gudalkop" },
      { id: 568044, name: "Hadlge" },
      { id: 568003, name: "Halkarni" },
      { id: 567980, name: "Hanimnal" },
      { id: 568006, name: "Hanmantwadi" },
      { id: 568020, name: "Harli Bk." },
      { id: 568021, name: "Harli Kh." },
      { id: 567981, name: "Hasurchampu" },
      { id: 568024, name: "Hasursasgiri" },
      { id: 568023, name: "Hasurwadi" },
      { id: 568037, name: "Hebbal Jaldyal" },
      { id: 567986, name: "Hebbal Kasaba Nool" },
      { id: 568041, name: "Helewadi" },
      { id: 568025, name: "Hidadugi" },
      { id: 567978, name: "Hirlage" },
      { id: 567989, name: "Hitni" },
      { id: 568019, name: "Hunginhal" },
      { id: 568001, name: "Idarguchhi" },
      { id: 567975, name: "Inchanal" },
      { id: 567965, name: "Jakhewadi" },
      { id: 568030, name: "Jambhulwadi" },
      { id: 567985, name: "Jarali" },
      { id: 568026, name: "Kadal" },
      { id: 567992, name: "Kadalge" },
      { id: 567966, name: "Kadgaon" },
      { id: 568056, name: "Kalamwadi" },
      { id: 568017, name: "Kalavi Katti" },
      { id: 568051, name: "Kanadewadi" },
      { id: 567971, name: "Karambali" },
      { id: 567994, name: "Kasaba Nool" },
      { id: 567977, name: "Kaulge" },
      { id: 567998, name: "Khamale Hatti" },
      { id: 567993, name: "Khandal" },
      { id: 568055, name: "Kumari" },
      { id: 568012, name: "Kumbalhal" },
      { id: 568036, name: "Linganur T. Nesari" },
      { id: 567970, name: "Lingnoor K. Nool" },
      { id: 567982, name: "Madyal Kasaba Nul" },
      { id: 568032, name: "Mahagaon" },
      { id: 568048, name: "Maladewadi" },
      { id: 568034, name: "Manganur Tarf Sawatwadi" },
      { id: 568010, name: "Manwad" },
      { id: 568031, name: "Masewadi" },
      { id: 567995, name: "Mugali" },
      { id: 568028, name: "Mungurwadi" },
      { id: 567988, name: "Mutnal" },
      { id: 568011, name: "Nandanwad" },
      { id: 567990, name: "Nangnur" },
      { id: 568009, name: "Narewadi" },
      { id: 568008, name: "Naukud" },
      { id: 568042, name: "Nesari" },
      { id: 567987, name: "Nilji" },
      { id: 568054, name: "Sambare" },
      { id: 568053, name: "Saroli" },
      { id: 568046, name: "Sawatwadi Tarf Nesari" },
      { id: 567979, name: "Shendri" },
      { id: 567996, name: "Shindewadi" },
      { id: 567972, name: "Shippur Tarf Ajara" },
      { id: 568040, name: "Shippur Tarf Nesari" },
      { id: 568047, name: "Talewadi" },
      { id: 567999, name: "Tanavadi" },
      { id: 568043, name: "Tarewadi" },
      { id: 568052, name: "Tavarewadi" },
      { id: 568027, name: "Teginhal" },
      { id: 568013, name: "Terani" },
      { id: 568049, name: "Tikkewadi" },
      { id: 568015, name: "Tupurwadi" },
      { id: 568033, name: "Umbarwadi" },
      { id: 946129, name: "Vadarage" },
      { id: 568039, name: "Waghrali" },
      { id: 568022, name: "Wairagwadi" },
      { id: 568057, name: "Yamehatti" },
      { id: 568005, name: "Yenechavandi" },
    ],
    4294: [
      { id: 568075, name: "Adkur" },
      { id: 568183, name: "Adure" },
      { id: 568064, name: "Alabadevi" },
      { id: 568191, name: "Ambewadi" },
      { id: 568074, name: "Amroli" },
      { id: 568095, name: "Asagaon" },
      { id: 568101, name: "Asagoli" },
      { id: 568114, name: "Bagilage" },
      { id: 568125, name: "Basarge" },
      { id: 568109, name: "Belebhat" },
      { id: 568091, name: "Bhogoli" },
      { id: 568085, name: "Bijur" },
      { id: 568068, name: "Bonjurdi" },
      { id: 568059, name: "Bujhavade" },
      { id: 568157, name: "Bukkihal" },
      { id: 568092, name: "Chandgad" },
      { id: 568137, name: "Channehatti" },
      { id: 568132, name: "Chinchane" },
      { id: 568096, name: "Churnicha Wada" },
      { id: 568110, name: "Date" },
      { id: 568169, name: "Devarwadi" },
      { id: 568058, name: "Dhamapur" },
      { id: 568174, name: "Dhekoli" },
      { id: 568175, name: "Dhekoliwadi" },
      { id: 568155, name: "Dholagarwadi" },
      { id: 568128, name: "Dhumadewadi" },
      { id: 568138, name: "Dindalkop" },
      { id: 568141, name: "Dundage" },
      { id: 568081, name: "Fatakwadi" },
      { id: 568106, name: "Gandharvagad" },
      { id: 568070, name: "Ganuchiwadi" },
      { id: 568126, name: "Gaulwadi" },
      { id: 568060, name: "Gavase" },
      { id: 568145, name: "Ghullewadi" },
      { id: 568204, name: "Gudavale Khalsa" },
      { id: 568112, name: "Gudewadi" },
      { id: 568214, name: "Gulamb" },
      { id: 568177, name: "Hajagoli" },
      { id: 568188, name: "Halkarni" },
      { id: 568187, name: "Hallarwadi" },
      { id: 568097, name: "Hambire" },
      { id: 568196, name: "Here" },
      { id: 568080, name: "Hindagaon" },
      { id: 568150, name: "Hosur" },
      { id: 568147, name: "Hundalewadi" },
      { id: 568061, name: "Ibrahimpur" },
      { id: 568098, name: "Inam Kolindre" },
      { id: 568083, name: "Inam Mhalunge" },
      { id: 568079, name: "Inam Savarde" },
      { id: 568201, name: "Isapur" },
      { id: 568144, name: "Jakkanhatti" },
      { id: 568200, name: "Jambare" },
      { id: 568189, name: "Jangamhatti" },
      { id: 568113, name: "Jattewadi" },
      { id: 568210, name: "Jelugade" },
      { id: 568069, name: "Jogewadi" },
      { id: 568153, name: "Kadalge Bk." },
      { id: 568154, name: "Kadalge Kh." },
      { id: 568151, name: "Kagani" },
      { id: 568082, name: "Kajirne" },
      { id: 568212, name: "Kalasgade" },
      { id: 568190, name: "Kaliwade" },
      { id: 568148, name: "Kalkundri" },
      { id: 568133, name: "Kamewadi" },
      { id: 568078, name: "Kanadi" },
      { id: 568086, name: "Kanur Bk." },
      { id: 568088, name: "Kanur Kh." },
      { id: 568186, name: "Karanjgaon" },
      { id: 568156, name: "Karekundi" },
      { id: 568158, name: "Kaulage" },
      { id: 568100, name: "Kenchewadi" },
      { id: 568102, name: "Kervade" },
      { id: 568194, name: "Khalsa Kolindre" },
      { id: 568180, name: "Khalsa Mhalunge" },
      { id: 568195, name: "Khalsa Savarde" },
      { id: 568205, name: "Khamdale" },
      { id: 568146, name: "Kini" },
      { id: 568211, name: "Kitvade" },
      { id: 568149, name: "Kitwad" },
      { id: 568213, name: "Kodali" },
      { id: 568182, name: "Kokare" },
      { id: 568181, name: "Kolik" },
      { id: 568108, name: "Konewadi" },
      { id: 568105, name: "Koraj" },
      { id: 568142, name: "Kowad" },
      { id: 568140, name: "Kudnoor" },
      { id: 568084, name: "Kurni" },
      { id: 568107, name: "Kurtanwadi" },
      { id: 568118, name: "Lakikatte" },
      { id: 568117, name: "Lakurwadi" },
      { id: 568173, name: "Madavale" },
      { id: 568159, name: "Mahipalgad" },
      { id: 568163, name: "Majare Karve" },
      { id: 568094, name: "Majareshirgaon" },
      { id: 568067, name: "Malagewadi" },
      { id: 568119, name: "Malatwadi" },
      { id: 568179, name: "Malaviwadi" },
      { id: 568116, name: "Malgad" },
      { id: 568161, name: "Mandedurg" },
      { id: 568122, name: "Mangaon" },
      { id: 568120, name: "Mhalewadi" },
      { id: 568202, name: "Mirvel" },
      { id: 568066, name: "Morewadi" },
      { id: 568206, name: "Motanwadi" },
      { id: 568162, name: "Mouje Karve" },
      { id: 568093, name: "Mouje Shirgaon" },
      { id: 568071, name: "Mugali" },
      { id: 568164, name: "Murkutewadi" },
      { id: 568104, name: "Naganwadi" },
      { id: 568152, name: "Nagardale" },
      { id: 568197, name: "Nagave" },
      { id: 568185, name: "Nandavade" },
      { id: 568130, name: "Narewadi" },
      { id: 568198, name: "Nhaveli" },
      { id: 568143, name: "Nittur" },
      { id: 568207, name: "Parle" },
      { id: 568209, name: "Patane" },
      { id: 568090, name: "Pilani" },
      { id: 568073, name: "Porewadi" },
      { id: 568077, name: "Powachiwadi" },
      { id: 568087, name: "Pundra" },
      { id: 568208, name: "Raidewadi" },
      { id: 568136, name: "Rajgoli Bk." },
      { id: 568135, name: "Rajgoli Kh." },
      { id: 568115, name: "Rampur" },
      { id: 568089, name: "Sadegudwale" },
      { id: 568176, name: "Saroli" },
      { id: 568099, name: "Satawane" },
      { id: 568063, name: "Sattewadi" },
      { id: 568192, name: "Shevale" },
      { id: 568171, name: "Shinoli Bk." },
      { id: 568170, name: "Shinoli Kh." },
      { id: 568193, name: "Shippur" },
      { id: 568062, name: "Shiroli" },
      { id: 568121, name: "Shivange" },
      { id: 568072, name: "Sonarwadi" },
      { id: 568184, name: "Sulaye" },
      { id: 568160, name: "Sundi" },
      { id: 568168, name: "Supe" },
      { id: 568172, name: "Surute" },
      { id: 568167, name: "Tadashinhal" },
      { id: 568139, name: "Talguli" },
      { id: 568129, name: "Tambulwadi" },
      { id: 568127, name: "Tavarewadi" },
      { id: 568131, name: "Teurwadi" },
      { id: 568178, name: "Tudiye" },
      { id: 568165, name: "Turkewadi" },
      { id: 568199, name: "Umgaon" },
      { id: 568076, name: "Utsali" },
      { id: 568166, name: "Vaitakwadi" },
      { id: 568103, name: "Valakoli" },
      { id: 568111, name: "Vargaon" },
      { id: 568065, name: "Vinjhane" },
      { id: 568203, name: "Waghotre" },
      { id: 568134, name: "Yartanhatti" },
    ],
    4295: [
      { id: 944850, name: "Aaloli" },
      { id: 568278, name: "Ambewadi" },
      { id: 944853, name: "Ambole" },
      { id: 568283, name: "Antri Bk" },
      { id: 568285, name: "Antri Kh" },
      { id: 568219, name: "Arala" },
      { id: 568262, name: "Aswalewadi" },
      { id: 568281, name: "Aundhi" },
      { id: 568270, name: "Bambavade" },
      { id: 568291, name: "Beldarwadi" },
      { id: 568257, name: "Belewadi" },
      { id: 568221, name: "Beradewadi" },
      { id: 568272, name: "Bhairavwadi" },
      { id: 568222, name: "Bhashtewadi" },
      { id: 568300, name: "Bhatshirgaon" },
      { id: 568290, name: "Bhatwadi" },
      { id: 944854, name: "Bhogiv" },
      { id: 568255, name: "Bilashi" },
      { id: 568289, name: "Biur" },
      { id: 944864, name: "Chandoli Bu." },
      { id: 944857, name: "Chandoli Khu." },
      { id: 568235, name: "Charan" },
      { id: 568306, name: "Chikhali" },
      { id: 568298, name: "Chikhalwadi" },
      { id: 568228, name: "Chinchewadi" },
      { id: 568249, name: "Chincholi" },
      { id: 944852, name: "Devhare" },
      { id: 568311, name: "Devwadi" },
      { id: 568265, name: "Dhamavade" },
      { id: 568252, name: "Dhaswadi" },
      { id: 568303, name: "Dholewadi" },
      { id: 568308, name: "Fakirwadi" },
      { id: 568244, name: "Gavalewadi" },
      { id: 944861, name: "Gave" },
      { id: 568267, name: "Ghagarewadi" },
      { id: 568266, name: "Girajawade" },
      { id: 568223, name: "Gudhe" },
      { id: 568245, name: "Hattegaon" },
      { id: 568299, name: "Ingrul" },
      { id: 568297, name: "Jambhalewadi" },
      { id: 944859, name: "Javali" },
      { id: 568227, name: "Kadamwadi" },
      { id: 568232, name: "Kalundre" },
      { id: 568307, name: "Kande" },
      { id: 568302, name: "Kandur" },
      { id: 944855, name: "Kanholi" },
      { id: 568296, name: "Kapari" },
      { id: 568280, name: "Karamale" },
      { id: 568230, name: "Karungali" },
      { id: 568229, name: "Kharale" },
      { id: 568293, name: "Khed" },
      { id: 568246, name: "Khirawade" },
      { id: 568247, name: "Khujgaon" },
      { id: 568216, name: "Khundalapur" },
      { id: 568226, name: "Kinarewadi" },
      { id: 568250, name: "Kokarud" },
      { id: 568264, name: "Kondaiwadi" },
      { id: 568253, name: "Kusaiwadi" },
      { id: 568233, name: "Kusalewadi" },
      { id: 568309, name: "Ladewadi" },
      { id: 944862, name: "Lotiv" },
      { id: 568251, name: "Malewadi" },
      { id: 568217, name: "Manadur" },
      { id: 568276, name: "Mandalgaon" },
      { id: 568224, name: "Manewadi" },
      { id: 568310, name: "Mangle" },
      { id: 568256, name: "Mangrul" },
      { id: 568284, name: "Mankarwadi" },
      { id: 568231, name: "Marathewadi" },
      { id: 568242, name: "Meni" },
      { id: 568236, name: "Mohare" },
      { id: 568248, name: "Morewadi" },
      { id: 944851, name: "Nandoli" },
      { id: 568237, name: "Nathavade" },
      { id: 568305, name: "Natoli" },
      { id: 568279, name: "Nigadi" },
      { id: 944856, name: "Nivale" },
      { id: 568225, name: "Pachgani" },
      { id: 568269, name: "Pachumbri" },
      { id: 568282, name: "Padalewadi" },
      { id: 568287, name: "Padali" },
      { id: 568268, name: "Panumbre Tarf Shirala" },
      { id: 568234, name: "Panumbre Tarf Warun" },
      { id: 568263, name: "Pavalewadi" },
      { id: 944848, name: "Pentlod" },
      { id: 568259, name: "Phufire" },
      { id: 568261, name: "Punavat" },
      { id: 568241, name: "Ranjanwadi" },
      { id: 568292, name: "Red" },
      { id: 568258, name: "Rile" },
      { id: 944858, name: "Rundiv" },
      { id: 568304, name: "Sagaon" },
      { id: 568240, name: "Sawantwadi" },
      { id: 568254, name: "Shindewadi" },
      { id: 568295, name: "Shirala" },
      { id: 568260, name: "Shirale Kh." },
      { id: 568274, name: "Shirashi" },
      { id: 568239, name: "Shirsatwadi" },
      { id: 568294, name: "Shivani" },
      { id: 568273, name: "Shivarwadi" },
      { id: 944849, name: "Sidhdeshvar" },
      { id: 568218, name: "Sonavade" },
      { id: 568286, name: "Tadavale" },
      { id: 944863, name: "Takale" },
      { id: 568271, name: "Takave" },
      { id: 568288, name: "Upavale" },
      { id: 944860, name: "Vetti" },
      { id: 568301, name: "Wadibhagai" },
      { id: 568275, name: "Wakurde Bk" },
      { id: 568277, name: "Wakurde Kh" },
      { id: 568243, name: "Yelapur" },
      { id: 568220, name: "Yeslewadi" },
      { id: 568215, name: "Zolambi" },
    ],
    4296: [
      { id: 568389, name: "Ahirwadi" },
      { id: 568365, name: "Aitavade Bk" },
      { id: 568373, name: "Aitavade Kh" },
      { id: 944636, name: "Ashta" },
      { id: 944640, name: "Ashta Dkshin" },
      { id: 568400, name: "Bagani" },
      { id: 568383, name: "Bahadurwadi" },
      { id: 568334, name: "Bahe" },
      { id: 568339, name: "Banewadi" },
      { id: 568392, name: "Bavchi" },
      { id: 568326, name: "Beradmachi" },
      { id: 568396, name: "Bhadkambe" },
      { id: 568381, name: "Bharatwadi" },
      { id: 568318, name: "Bhatwadi" },
      { id: 568324, name: "Bhavaninagar" },
      { id: 568330, name: "Bichud" },
      { id: 568343, name: "Borgaon" },
      { id: 568369, name: "Chikurde" },
      { id: 568370, name: "Devarde" },
      { id: 568361, name: "Dhagewadi" },
      { id: 568395, name: "Dhavali" },
      { id: 568313, name: "Dhotrewadi" },
      { id: 568367, name: "Dongarwadi" },
      { id: 568332, name: "Dudhari" },
      { id: 568402, name: "Falakewadi (Chandawadi)" },
      { id: 568338, name: "Farnewadi(Borgaon)" },
      { id: 568390, name: "Gatadwadi" },
      { id: 568340, name: "Gaundwadi" },
      { id: 568391, name: "Gotkhindi" },
      { id: 568336, name: "Hubalwadi" },
      { id: 944633, name: "Islampur" },
      { id: 568374, name: "Itakare" },
      { id: 568362, name: "Jakraiwadi" },
      { id: 568354, name: "Jambhulwadi" },
      { id: 568385, name: "June Khed" },
      { id: 568401, name: "Kakachiwadi" },
      { id: 568319, name: "Kalamwadi" },
      { id: 568357, name: "Kameri" },
      { id: 568382, name: "Kanegaon" },
      { id: 568347, name: "Kapuskhed" },
      { id: 568406, name: "Karandwadi" },
      { id: 568371, name: "Karanjvade" },
      { id: 568360, name: "Karve" },
      { id: 568312, name: "Kasegaon" },
      { id: 568320, name: "Kedargaon" },
      { id: 568335, name: "Kharatwadi" },
      { id: 568322, name: "Kille Machhindra Gad" },
      { id: 568327, name: "Kole" },
      { id: 568397, name: "Koregaon" },
      { id: 568407, name: "Krishnanagar" },
      { id: 568379, name: "Kundalwadi" },
      { id: 568372, name: "Kurlap" },
      { id: 568364, name: "Ladegaon" },
      { id: 568323, name: "Lavanmachi" },
      { id: 568346, name: "Mahadevwadi" },
      { id: 568376, name: "Malewadi" },
      { id: 568345, name: "Manikwadi" },
      { id: 568359, name: "Maralnathpur" },
      { id: 568405, name: "Mardawadi" },
      { id: 568342, name: "Masuchiwadi" },
      { id: 568404, name: "Mirajwadi" },
      { id: 568394, name: "Nagaon" },
      { id: 568328, name: "Narsihapur" },
      { id: 568384, name: "Nave Khed" },
      { id: 568349, name: "Naykalwadi" },
      { id: 568321, name: "Nerle" },
      { id: 568350, name: "Ozarde" },
      { id: 568388, name: "Padavalwadi" },
      { id: 568348, name: "Peth" },
      { id: 568398, name: "Pharnewadi(Shigaon)" },
      { id: 568393, name: "Pokharni" },
      { id: 568353, name: "Rethare Dharan" },
      { id: 568331, name: "Rethare Harnaksha" },
      { id: 568403, name: "Rozawadi" },
      { id: 568337, name: "Sakharale" },
      { id: 568341, name: "Satapewadi" },
      { id: 568366, name: "Shekharwadi" },
      { id: 568316, name: "Shene" },
      { id: 568399, name: "Shigaon" },
      { id: 568329, name: "Shirate" },
      { id: 568386, name: "Shirgaon" },
      { id: 568358, name: "Shivpuri" },
      { id: 568352, name: "Surul" },
      { id: 568333, name: "Takari" },
      { id: 568314, name: "Tambave" },
      { id: 568380, name: "Tandulwadi" },
      { id: 568368, name: "Thanapude" },
      { id: 568344, name: "Tujarpur" },
      { id: 944631, name: "Urun" },
      { id: 944630, name: "Urun Dakshin" },
      { id: 568363, name: "Vashi" },
      { id: 568356, name: "Vitthalwadi" },
      { id: 568355, name: "Waghwadi" },
      { id: 568387, name: "Walwa" },
      { id: 568317, name: "Wategaon" },
      { id: 568325, name: "Yede Machchhindra" },
      { id: 568375, name: "Yede Nipani" },
      { id: 568378, name: "Yelur" },
      { id: 568315, name: "Yewalewadi" },
    ],
    4297: [
      { id: 568422, name: "Amanapur" },
      { id: 568425, name: "Andhali" },
      { id: 568431, name: "Ankalkhop" },
      { id: 568424, name: "Anugdewadi" },
      { id: 568427, name: "Bambavade" },
      { id: 568437, name: "Bhilavadi" },
      { id: 568440, name: "Bramhanal" },
      { id: 568420, name: "Burli" },
      { id: 568433, name: "Burungwadi" },
      { id: 568438, name: "Chopadewadi" },
      { id: 568409, name: "Dahyari" },
      { id: 568432, name: "Dhangaon" },
      { id: 568411, name: "Dudhondi" },
      { id: 568410, name: "Ghogaon" },
      { id: 568434, name: "Hajarwadi" },
      { id: 568435, name: "Khandobachiwadi" },
      { id: 568441, name: "Khatav" },
      { id: 568413, name: "Kundal" },
      { id: 568436, name: "Malwadi" },
      { id: 568426, name: "Morale (Rajapur)" },
      { id: 568419, name: "Nagarale" },
      { id: 568428, name: "Nagthane" },
      { id: 568415, name: "Palus" },
      { id: 568417, name: "Punadi Tarf Walava" },
      { id: 568418, name: "Pundiwadi" },
      { id: 568430, name: "Radewadi" },
      { id: 568421, name: "Ramanandnagar" },
      { id: 568414, name: "Sandagewadi" },
      { id: 568416, name: "Savantpur" },
      { id: 568412, name: "Shere Dudhondi" },
      { id: 568439, name: "Sukhwadi" },
      { id: 568429, name: "Suryagaon" },
      { id: 568408, name: "Tupari" },
      { id: 568442, name: "Vasgade" },
      { id: 568423, name: "Viththalwadi" },
    ],
    4298: [
      { id: 943999, name: "Adarshnagar" },
      { id: 568450, name: "Ambak" },
      { id: 568483, name: "Ambegaon" },
      { id: 568480, name: "Amrapur" },
      { id: 568489, name: "Apshinge" },
      { id: 568447, name: "Asad" },
      { id: 568477, name: "Belavade" },
      { id: 568465, name: "Bhikawadi Khu" },
      { id: 568456, name: "Bombalewadi" },
      { id: 568479, name: "Chikhali" },
      { id: 568448, name: "Chinchani Wangi" },
      { id: 568452, name: "Devrashtre" },
      { id: 568460, name: "Dhanewadi" },
      { id: 943998, name: "Ghotil" },
      { id: 568494, name: "Hanmant Vadiye" },
      { id: 568458, name: "Hingangaon Bk" },
      { id: 568492, name: "Hingangaon Kh" },
      { id: 568486, name: "Kadegaon" },
      { id: 568487, name: "Kadepur" },
      { id: 568463, name: "Kanharwadi" },
      { id: 568474, name: "Karandewadi" },
      { id: 943996, name: "Kekatainagar" },
      { id: 568488, name: "Khambale Aundh" },
      { id: 568467, name: "Kherade Vita" },
      { id: 568461, name: "Kherade Wangi" },
      { id: 568491, name: "Kotawade" },
      { id: 568466, name: "Kotij" },
      { id: 568455, name: "Kumbhargaon" },
      { id: 943997, name: "Mendh Wasahat" },
      { id: 568451, name: "Mo. Vadgaon" },
      { id: 568490, name: "Nerli" },
      { id: 568482, name: "Nevari" },
      { id: 568484, name: "Nimsod" },
      { id: 568446, name: "Padali" },
      { id: 568454, name: "Ramapur" },
      { id: 568457, name: "Raygaon" },
      { id: 568476, name: "Renusewadi" },
      { id: 568469, name: "Saspade" },
      { id: 568472, name: "Shalgaon" },
      { id: 568498, name: "Shelakbav" },
      { id: 568444, name: "Shirasgaon" },
      { id: 568453, name: "Shirgaon" },
      { id: 568485, name: "Shivajinagar (Nhavi)" },
      { id: 568496, name: "Shivani" },
      { id: 568478, name: "Soholi" },
      { id: 568445, name: "Sonkire" },
      { id: 568443, name: "Sonsal" },
      { id: 568493, name: "Tadasar" },
      { id: 568468, name: "Tondoli" },
      { id: 568481, name: "Tupewadi Khe." },
      { id: 568464, name: "Tupewadi Ye." },
      { id: 943995, name: "Umarkanchan" },
      { id: 568470, name: "Upale Mayani" },
      { id: 568459, name: "Upale Wangi" },
      { id: 912826, name: "Vajegaon" },
      { id: 568475, name: "Vihapur" },
      { id: 568497, name: "Wadiyeraybag" },
      { id: 568449, name: "Wangi" },
      { id: 568473, name: "Wangrethare" },
      { id: 568471, name: "Yede" },
      { id: 568462, name: "Yetgaon" },
      { id: 568495, name: "Yewalewadi" },
    ],
    4299: [
      { id: 568546, name: "Ainwadi" },
      { id: 568534, name: "Alsand" },
      { id: 568541, name: "Balvadi (Kha)" },
      { id: 568537, name: "Balvadi Bhalvani" },
      { id: 568512, name: "Bamani" },
      { id: 568564, name: "Banurgad" },
      { id: 568543, name: "Benapur" },
      { id: 568557, name: "Bhadakewadi" },
      { id: 568517, name: "Bhagyanagar" },
      { id: 568531, name: "Bhalwani" },
      { id: 568526, name: "Bhambarde" },
      { id: 568516, name: "Bhendvade" },
      { id: 568513, name: "Bhikawadi Bk." },
      { id: 568523, name: "Bhood" },
      { id: 568501, name: "Chikhalhol" },
      { id: 568510, name: "Chinchani (Mangrul)" },
      { id: 568514, name: "Devikhindi" },
      { id: 568522, name: "Devnagar" },
      { id: 568529, name: "Dhawaleshwar" },
      { id: 568558, name: "Dhondewadi" },
      { id: 568547, name: "Dhondgewadi" },
      { id: 568505, name: "Gardi" },
      { id: 568508, name: "Ghadgewadi" },
      { id: 568504, name: "Ghanwad" },
      { id: 568549, name: "Ghoti Bk" },
      { id: 568550, name: "Ghoti Kh" },
      { id: 568544, name: "Gorewadi" },
      { id: 568503, name: "Hingangade" },
      { id: 568560, name: "Hivare" },
      { id: 568536, name: "Jadhavnagar" },
      { id: 568540, name: "Jadhavwadi" },
      { id: 568545, name: "Jakhinwadi" },
      { id: 568524, name: "Jondhalkhindi" },
      { id: 568532, name: "Kalambi" },
      { id: 568535, name: "Kamlapur" },
      { id: 568559, name: "Karanje" },
      { id: 568506, name: "Karve" },
      { id: 568533, name: "Khambale Bhalvani" },
      { id: 568552, name: "Khanapur" },
      { id: 568507, name: "Kurli" },
      { id: 568562, name: "Kusbavade" },
      { id: 568521, name: "Lengre" },
      { id: 568525, name: "Madhalmuthi" },
      { id: 568499, name: "Mahuli" },
      { id: 568511, name: "Mangrul" },
      { id: 568542, name: "Menganwadi" },
      { id: 568555, name: "Mohi" },
      { id: 568502, name: "Nagewadi" },
      { id: 568561, name: "Palashi" },
      { id: 568530, name: "Panchlingnagar" },
      { id: 568509, name: "Pare" },
      { id: 568551, name: "Posewadi" },
      { id: 568554, name: "Ramnagar" },
      { id: 568528, name: "Renavi" },
      { id: 568548, name: "Rewangaon" },
      { id: 568518, name: "Salshinge" },
      { id: 568519, name: "Sangole" },
      { id: 568556, name: "Shendgewadi" },
      { id: 568553, name: "Sultangade" },
      { id: 568563, name: "Tadachiwadi" },
      { id: 568538, name: "Tandalgaon" },
      { id: 568520, name: "Valuj" },
      { id: 568527, name: "Vasumbe" },
      { id: 568515, name: "Vejegaon" },
      { id: 944209, name: "Vita" },
      { id: 943992, name: "Vita Purv" },
      { id: 568500, name: "Walkhad" },
      { id: 568539, name: "Wazar" },
    ],
    4300: [
      { id: 568620, name: "Aoutewadi" },
      { id: 568588, name: "Atpadi" },
      { id: 568576, name: "Awalai" },
      { id: 568613, name: "Balewadi" },
      { id: 568591, name: "Banpuri" },
      { id: 568589, name: "Bhingewadi" },
      { id: 568585, name: "Bombewadi" },
      { id: 568611, name: "Chinchale" },
      { id: 568582, name: "Deshmukhwadi" },
      { id: 568619, name: "Dhavadwadi" },
      { id: 568570, name: "Dighanchi" },
      { id: 568577, name: "Galavewadi" },
      { id: 568609, name: "Ghanand" },
      { id: 568605, name: "Gharniki" },
      { id: 568617, name: "Gomewadi" },
      { id: 568598, name: "Gulewadi" },
      { id: 568623, name: "Hivtad" },
      { id: 568606, name: "Jambhulani" },
      { id: 568616, name: "Kalewadi" },
      { id: 568608, name: "Kamth" },
      { id: 568618, name: "Kankatrewadi" },
      { id: 568614, name: "Kargani" },
      { id: 568574, name: "Kauthuli" },
      { id: 568586, name: "Khanjodwadi" },
      { id: 568612, name: "Kharsundi" },
      { id: 568600, name: "Kurundwadi" },
      { id: 568595, name: "Lengrewadi" },
      { id: 568566, name: "Lingiware" },
      { id: 568594, name: "Madgule" },
      { id: 568615, name: "Malewadi" },
      { id: 568622, name: "Manewadi" },
      { id: 568580, name: "Maptemala" },
      { id: 568593, name: "Masalwadi" },
      { id: 568590, name: "Mitki" },
      { id: 568607, name: "Mudhewadi" },
      { id: 568621, name: "Nelkaranji" },
      { id: 568578, name: "Nimbawade" },
      { id: 568571, name: "Palaskhel" },
      { id: 568568, name: "Pandharewadi" },
      { id: 568602, name: "Parekarwadi" },
      { id: 568597, name: "Patrewadi" },
      { id: 568604, name: "Pimpari Bk." },
      { id: 568583, name: "Pimpri Kh" },
      { id: 568572, name: "Pisewadi" },
      { id: 568567, name: "Pujarwadi" },
      { id: 568581, name: "Pujarwadi (Dighanchi)" },
      { id: 568565, name: "Rajewadi" },
      { id: 568575, name: "Sherewadi" },
      { id: 568596, name: "Shetphale" },
      { id: 568592, name: "Tadawale" },
      { id: 568624, name: "Talewadi" },
      { id: 568569, name: "Umbargaon" },
      { id: 568599, name: "Vibhutwadi" },
      { id: 568573, name: "Vitthlapur" },
      { id: 568579, name: "Wakshewadi" },
      { id: 568610, name: "Walwan" },
      { id: 568587, name: "Yamaji Patalachi Wadi" },
      { id: 568601, name: "Zare" },
    ],
    4301: [
      { id: 568631, name: "Alate" },
      { id: 568660, name: "Anjani" },
      { id: 568680, name: "Arwade" },
      { id: 568663, name: "Balgavade" },
      { id: 568662, name: "Bastawade" },
      { id: 568687, name: "Bendri" },
      { id: 568682, name: "Bhairvawadi" },
      { id: 568650, name: "Biranwadi" },
      { id: 568677, name: "Borgaon" },
      { id: 568630, name: "Chikhal Gothan" },
      { id: 568683, name: "Chinchani" },
      { id: 568654, name: "Dahiwadi" },
      { id: 568678, name: "Dhavali" },
      { id: 568636, name: "Dhondewadi" },
      { id: 568676, name: "Dhulgaon" },
      { id: 568656, name: "Dogarsoni" },
      { id: 568664, name: "Dorli" },
      { id: 568649, name: "Gaurgaon" },
      { id: 568671, name: "Gavhan" },
      { id: 568648, name: "Gotewadi" },
      { id: 568633, name: "Hatnoli" },
      { id: 568644, name: "Hatnoor" },
      { id: 568653, name: "Jarandi" },
      { id: 568628, name: "Julewadi" },
      { id: 568639, name: "Kapurgaon" },
      { id: 568667, name: "Kaulage" },
      { id: 568689, name: "Kavathe Ekand" },
      { id: 568634, name: "Khalsa Dhamani" },
      { id: 568665, name: "Khujagaon" },
      { id: 568675, name: "Kumathe" },
      { id: 568632, name: "Limb" },
      { id: 568638, name: "Limbgaon" },
      { id: 568668, name: "Lodhe" },
      { id: 568657, name: "Lokarewadi" },
      { id: 568672, name: "Manerajuri" },
      { id: 568643, name: "Manjarde" },
      { id: 568691, name: "Matkunki" },
      { id: 568642, name: "Morale Ped" },
      { id: 568692, name: "Nagaon Kavathe" },
      { id: 568686, name: "Nagaon Nimani" },
      { id: 568659, name: "Nagewadi" },
      { id: 568637, name: "Narsingpur" },
      { id: 568684, name: "Nehru Nagar" },
      { id: 568685, name: "Nimani" },
      { id: 568629, name: "Nimblak" },
      { id: 568635, name: "Padali" },
      { id: 568645, name: "Panmalewadi" },
      { id: 568641, name: "Ped" },
      { id: 568681, name: "Punadi (Tasgaon)" },
      { id: 568625, name: "Rajapur" },
      { id: 568661, name: "Savalaj" },
      { id: 568669, name: "Savarde" },
      { id: 568688, name: "Shirgaon Kavathe" },
      { id: 568655, name: "Sidhdewadi" },
      { id: 568646, name: "Sirgaon Visapur" },
      { id: 943636, name: "Tasgaon" },
      { id: 568626, name: "Turachi" },
      { id: 568674, name: "Upalavi" },
      { id: 568670, name: "Vajrachaunde" },
      { id: 568679, name: "Vanjarwadi" },
      { id: 568640, name: "Vijay Nagar" },
      { id: 568647, name: "Visapur" },
      { id: 568658, name: "Wadgaon" },
      { id: 568666, name: "Waghapur" },
      { id: 568651, name: "Waifale" },
      { id: 568690, name: "Wasumbe" },
      { id: 568652, name: "Yamgarwadi" },
      { id: 568627, name: "Yelavi" },
      { id: 568673, name: "Yogewadi" },
    ],
    4302: [
      { id: 568704, name: "Ankali" },
      { id: 568754, name: "Arag" },
      { id: 568745, name: "Bamani" },
      { id: 568712, name: "Bamnoli" },
      { id: 568752, name: "Bedag" },
      { id: 568734, name: "Belanki" },
      { id: 568718, name: "Bhose" },
      { id: 568709, name: "Bisur" },
      { id: 568744, name: "Bolwad" },
      { id: 568758, name: "Budhagaon" },
      { id: 568736, name: "Chabukswarwadi" },
      { id: 568748, name: "Dhavali" },
      { id: 568732, name: "Dongarwadi" },
      { id: 568697, name: "Dudhgaon" },
      { id: 568741, name: "Erandoli" },
      { id: 568729, name: "Gundewadi" },
      { id: 568703, name: "Haripur" },
      { id: 568705, name: "Inam Dhamani" },
      { id: 568737, name: "Janaraowadi" },
      { id: 568733, name: "Kadamwadi" },
      { id: 568713, name: "Kakadwadi" },
      { id: 568726, name: "Kalambi" },
      { id: 568723, name: "Kanadwadi" },
      { id: 568715, name: "Kanchanpur" },
      { id: 568710, name: "Karnal" },
      { id: 568717, name: "Karoli (M)" },
      { id: 568695, name: "Kasabe Digraj" },
      { id: 568707, name: "Kavaji Khotwadi" },
      { id: 568722, name: "Kavalapur" },
      { id: 568701, name: "Kavathe Piran" },
      { id: 568730, name: "Khanderajuri" },
      { id: 568757, name: "Khatav" },
      { id: 944194, name: "Kupavad 2" },
      { id: 944814, name: "Kupwad" },
      { id: 568753, name: "Laxmiwadi" },
      { id: 568756, name: "Lingnur" },
      { id: 568759, name: "Madhavnagar" },
      { id: 568742, name: "Malewadi" },
      { id: 568728, name: "Malgaon" },
      { id: 568700, name: "Malwadi" },
      { id: 568720, name: "Manmodi" },
      { id: 568750, name: "Mhaishal (S)" },
      { id: 944815, name: "Miraj" },
      { id: 943994, name: "Miraj Shivajinagar" },
      { id: 943993, name: "Miraj Vakharbhag" },
      { id: 568699, name: "Mola Kumbhoj" },
      { id: 568694, name: "Mouje Digraj" },
      { id: 568706, name: "Nandre" },
      { id: 568751, name: "Narwad" },
      { id: 568746, name: "Nilaji" },
      { id: 568711, name: "Padmale" },
      { id: 568719, name: "Patgaon" },
      { id: 568731, name: "Payappachiwadi" },
      { id: 568721, name: "Rasulwadi" },
      { id: 568735, name: "Salgare" },
      { id: 568714, name: "Sambarwadi" },
      { id: 568702, name: "Samdoli" },
      { id: 943638, name: "Sangaliwadi" },
      { id: 944817, name: "Sangli" },
      { id: 943990, name: "Sanjaynagar" },
      { id: 568738, name: "Santoshwadi" },
      { id: 568724, name: "Savali" },
      { id: 568698, name: "Savalwadi" },
      { id: 568696, name: "Sheri Kavathe" },
      { id: 568755, name: "Shindewadi" },
      { id: 568739, name: "Shipur" },
      { id: 568727, name: "Siddhewadi" },
      { id: 568716, name: "Soni" },
      { id: 568743, name: "Takali" },
      { id: 568725, name: "Tanang" },
      { id: 568693, name: "Tung" },
      { id: 568747, name: "Vaddi" },
      { id: 943637, name: "Vanleswadi" },
      { id: 568749, name: "Vijay Nagar" },
      { id: 943991, name: "Vishrambag" },
      { id: 568740, name: "Vyankuchiwadi" },
      { id: 568708, name: "Wajegaon" },
    ],
    4303: [
      { id: 568780, name: "Agalgaon" },
      { id: 568797, name: "Agran Dhulagaon" },
      { id: 568806, name: "Alkud (M)" },
      { id: 568788, name: "Alkud [S]" },
      { id: 568774, name: "Arewadi" },
      { id: 568815, name: "Banewadi" },
      { id: 568787, name: "Bassappachiwadi" },
      { id: 568805, name: "Borgaon" },
      { id: 568769, name: "Chorochi" },
      { id: 568771, name: "Chudekhindi" },
      { id: 568813, name: "Deshing" },
      { id: 568784, name: "Dhalewadi" },
      { id: 568772, name: "Dhalgaon" },
      { id: 568768, name: "Dholewadi" },
      { id: 568767, name: "Dudhebhavi" },
      { id: 568777, name: "Garjewadi" },
      { id: 568760, name: "Ghatnandre" },
      { id: 568765, name: "Ghorpadi" },
      { id: 568807, name: "Haroli" },
      { id: 568809, name: "Hingangaon" },
      { id: 568785, name: "Irali" },
      { id: 568793, name: "Jadhavwadi" },
      { id: 568781, name: "Jakhapur" },
      { id: 568770, name: "Jambhulwadi" },
      { id: 568802, name: "Jayagavhan" },
      { id: 568773, name: "Kadamwadi" },
      { id: 568800, name: "Karalhatti" },
      { id: 568810, name: "Karoli (T)" },
      { id: 568794, name: "Kavathe Mahankal" },
      { id: 568775, name: "Kerewadi" },
      { id: 568814, name: "Kharshing" },
      { id: 568799, name: "Kokale" },
      { id: 568819, name: "Kongnoli" },
      { id: 568782, name: "Kuchi" },
      { id: 568816, name: "Kuktoli" },
      { id: 568778, name: "Kundlapur" },
      { id: 568792, name: "Landagewadi" },
      { id: 568783, name: "Langarpeth" },
      { id: 568801, name: "Lonarwadi" },
      { id: 568803, name: "Malangaon" },
      { id: 568811, name: "Mhaishal (M)" },
      { id: 568786, name: "Moghamwadi" },
      { id: 568808, name: "Morgaon" },
      { id: 568763, name: "Nagaj" },
      { id: 568789, name: "Nangole" },
      { id: 568764, name: "Nimaj" },
      { id: 568796, name: "Pimpalwadi" },
      { id: 568817, name: "Rampurwadi" },
      { id: 568798, name: "Ranjani" },
      { id: 568762, name: "Raywadi" },
      { id: 568818, name: "Sarati" },
      { id: 568779, name: "Shelkewadi" },
      { id: 568812, name: "Shindewadi (Hi)" },
      { id: 568766, name: "Shindewadi Gho" },
      { id: 568804, name: "Shirdhon" },
      { id: 568790, name: "Thabadewadi" },
      { id: 568761, name: "Tisangi" },
      { id: 568795, name: "Vithurayachi Wadi" },
      { id: 568776, name: "Wagholi" },
      { id: 568791, name: "Zurewadi" },
    ],
    4304: [
      { id: 568856, name: "Achkanhalli" },
      { id: 568898, name: "Akkalawadi" },
      { id: 568927, name: "Amrutwadi" },
      { id: 568894, name: "Ankalagi" },
      { id: 568830, name: "Ankale" },
      { id: 568850, name: "Antral" },
      { id: 568876, name: "Asangi Jat" },
      { id: 568924, name: "Asangi Turk" },
      { id: 568844, name: "Avandi" },
      { id: 568847, name: "Bagalwadi" },
      { id: 568827, name: "Bagewadi" },
      { id: 568831, name: "Baj" },
      { id: 568891, name: "Balgaon" },
      { id: 568857, name: "Banali" },
      { id: 568942, name: "Basargi" },
      { id: 568892, name: "Belundagi" },
      { id: 568832, name: "Belunkhi" },
      { id: 568821, name: "Bevanur" },
      { id: 568905, name: "Bhivargi" },
      { id: 568938, name: "Bilur" },
      { id: 568826, name: "Birnal" },
      { id: 568896, name: "Borgi Bk" },
      { id: 568897, name: "Borgi Kh" },
      { id: 568836, name: "Dafalapur" },
      { id: 568918, name: "Daribadachi" },
      { id: 568882, name: "Darikonur" },
      { id: 568930, name: "Devnal" },
      { id: 568824, name: "Dhavadwadi" },
      { id: 568925, name: "Dhulkarwadi" },
      { id: 568829, name: "Dorli" },
      { id: 568842, name: "Ekundi" },
      { id: 568868, name: "Gholeshwar" },
      { id: 568900, name: "Girgaon" },
      { id: 568903, name: "Gondhalewadi" },
      { id: 568875, name: "Guddapur" },
      { id: 568941, name: "Gugwad" },
      { id: 568902, name: "Gulgunjnal" },
      { id: 568822, name: "Gulvanchi" },
      { id: 568890, name: "Halli" },
      { id: 568828, name: "Hivare" },
      { id: 568862, name: "Jadarbobalad" },
      { id: 568907, name: "Jalihal Bk" },
      { id: 568920, name: "Jalihal Khurd" },
      { id: 568926, name: "Jat" },
      { id: 568840, name: "Jirgyal" },
      { id: 568923, name: "Kaganari" },
      { id: 568833, name: "Kanthi" },
      { id: 568895, name: "Karajagi" },
      { id: 568869, name: "Karajanagi" },
      { id: 568913, name: "Karewadi (Ko. Bo.)" },
      { id: 944819, name: "Karewadi Tikondi" },
      { id: 568848, name: "Kaslingwadi" },
      { id: 568853, name: "Khairao" },
      { id: 568835, name: "Khalati" },
      { id: 568916, name: "Khandnal" },
      { id: 568939, name: "Khilarwadi" },
      { id: 568937, name: "Khojanwadi" },
      { id: 568870, name: "Kolgiri" },
      { id: 944820, name: "Konabagi" },
      { id: 568909, name: "Kontebobalad" },
      { id: 568859, name: "Kosari" },
      { id: 568837, name: "Kudnur" },
      { id: 568893, name: "Kulalwadi" },
      { id: 568825, name: "Kumbhari" },
      { id: 568866, name: "Kunikonur" },
      { id: 568864, name: "Lakdewadi" },
      { id: 568884, name: "Lamantanda D.B" },
      { id: 944825, name: "Lamantanda Utagi" },
      { id: 568901, name: "Lavanga" },
      { id: 568843, name: "Lohagaon" },
      { id: 568872, name: "Madgyal" },
      { id: 568871, name: "Maithal" },
      { id: 568929, name: "Mallal" },
      { id: 568899, name: "Manik Nal" },
      { id: 944642, name: "Mendhigiri" },
      { id: 568839, name: "Mirawad" },
      { id: 568849, name: "Mokashawadi" },
      { id: 568906, name: "Morbagi" },
      { id: 944821, name: "Motewadi Asangi" },
      { id: 944822, name: "Motewadi Ko Bo" },
      { id: 568936, name: "Muchandi" },
      { id: 568820, name: "Navalwadi" },
      { id: 568885, name: "Nigadi Bk" },
      { id: 568855, name: "Nigadi Kh" },
      { id: 568921, name: "Pandharewadi" },
      { id: 568915, name: "Pandozari" },
      { id: 568914, name: "Paradhevasti" },
      { id: 568823, name: "Pratapur" },
      { id: 568928, name: "Rampur" },
      { id: 568935, name: "Ravalgundwadi" },
      { id: 568860, name: "Revnal" },
      { id: 944823, name: "Salekiri" },
      { id: 568933, name: "Salmalgewadi" },
      { id: 568867, name: "Sanamadi" },
      { id: 568904, name: "Sankh" },
      { id: 568881, name: "Shedyal" },
      { id: 568858, name: "Shegaon" },
      { id: 568841, name: "Shelakewadi" },
      { id: 568838, name: "Shinganapur" },
      { id: 568919, name: "Siddhanath" },
      { id: 568944, name: "Sindur" },
      { id: 568845, name: "Singanhalli" },
      { id: 568888, name: "Sonalagi" },
      { id: 568863, name: "Sonyal" },
      { id: 568878, name: "Soradi" },
      { id: 568889, name: "Suslad" },
      { id: 568912, name: "Tikondi" },
      { id: 568877, name: "Tilyal" },
      { id: 568861, name: "Tippehalli" },
      { id: 568854, name: "Tonewadi" },
      { id: 568886, name: "Umadi" },
      { id: 568943, name: "Umarani" },
      { id: 568934, name: "Untwadi" },
      { id: 568883, name: "Utagi" },
      { id: 568940, name: "Vajrawad" },
      { id: 568874, name: "Vhaspeth" },
      { id: 568887, name: "Vithalwadi" },
      { id: 568851, name: "Waifal" },
      { id: 568846, name: "Walekhindi" },
      { id: 568879, name: "Walsang" },
      { id: 568834, name: "Washan" },
      { id: 568852, name: "Yelavi" },
      { id: 568932, name: "Yeldari" },
    ],
    7179: [
      { id: 943423, name: "Ambivali" },
      { id: 943421, name: "Andheri" },
      { id: 943395, name: "Bandivali" },
      { id: 943429, name: "Bandra" },
      { id: 943432, name: "Bapnala" },
      { id: 943435, name: "Brahmanwada" },
      { id: 943433, name: "Chakala" },
      { id: 943424, name: "Danda" },
      { id: 943419, name: "Gundavali" },
      { id: 943426, name: "Ismaliya" },
      { id: 943393, name: "Juhu" },
      { id: 943418, name: "Kolekalyan" },
      { id: 943428, name: "Kondivita" },
      { id: 943431, name: "Madh" },
      { id: 943427, name: "Majas" },
      { id: 943415, name: "Marol" },
      { id: 943434, name: "Mogra" },
      { id: 943425, name: "Mulgaon" },
      { id: 943414, name: "Oshiwara" },
      { id: 943437, name: "Parighakhar" },
      { id: 943436, name: "Parjapur" },
      { id: 943416, name: "Sahar" },
      { id: 943422, name: "Varsova" },
      { id: 943430, name: "Vileparle" },
      { id: 943417, name: "Vyarvali" },
    ],
    7180: [
      { id: 943565, name: "Anik" },
      { id: 943564, name: "Asalfhe" },
      { id: 943581, name: "Bhandup" },
      { id: 943580, name: "Borla" },
      { id: 943571, name: "Chandivali" },
      { id: 943572, name: "Chembur" },
      { id: 943576, name: "Devnar" },
      { id: 943570, name: "Ghatkopar" },
      { id: 943592, name: "Hariyali" },
      { id: 943566, name: "Kanjur" },
      { id: 943567, name: "Kirol" },
      { id: 943569, name: "Kopari" },
      { id: 943568, name: "Kurla" },
      { id: 943585, name: "Mahul" },
      { id: 943583, name: "Manbudruk" },
      { id: 943588, name: "Mandale" },
      { id: 943582, name: "Mankhurd" },
      { id: 943584, name: "Maravali" },
      { id: 943587, name: "Mohili" },
      { id: 943586, name: "Mulund" },
      { id: 943577, name: "Nahur" },
      { id: 943579, name: "Paspoli" },
      { id: 943578, name: "Powai" },
      { id: 943591, name: "Saki" },
      { id: 943573, name: "Tirandaj" },
      { id: 943575, name: "Tungva" },
      { id: 943574, name: "Turbhe" },
      { id: 943589, name: "Vadhavali" },
      { id: 943590, name: "Vikroli" },
    ],
    7181: [
      { id: 943442, name: "Aarey" },
      { id: 943441, name: "Akse" },
      { id: 943438, name: "Akurli" },
      { id: 943552, name: "Borivali" },
      { id: 943543, name: "Charkop" },
      { id: 943544, name: "Chinchavali" },
      { id: 943545, name: "Dahisar" },
      { id: 943546, name: "Darvali" },
      { id: 943547, name: "Dindoshi" },
      { id: 943443, name: "Eksar" },
      { id: 943549, name: "Eksar Pahadi" },
      { id: 943550, name: "Erangal" },
      { id: 943541, name: "Gorai" },
      { id: 943542, name: "Goregaon" },
      { id: 943540, name: "Gundgaon" },
      { id: 943537, name: "Kandivali" },
      { id: 943536, name: "Kanheri" },
      { id: 943539, name: "Klerabad" },
      { id: 943538, name: "Kurar" },
      { id: 943555, name: "Magathane" },
      { id: 943558, name: "Malad" },
      { id: 943557, name: "Malvani" },
      { id: 943559, name: "Mandpeshwar" },
      { id: 943553, name: "Manori" },
      { id: 943554, name: "Maroshi" },
      { id: 943556, name: "Marve" },
      { id: 943548, name: "Pahadi Goregaon" },
      { id: 943551, name: "Poisar" },
      { id: 943563, name: "Sai" },
      { id: 943562, name: "Shimpvali" },
      { id: 943561, name: "Vadhavan" },
      { id: 943560, name: "Valanai" },
    ],
  }
}
